webpackJsonp(["1"],{

/***/ "./node_modules/@babel/runtime-corejs2/core-js/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/core-js/library/fn/object/assign.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs2/core-js/object/create.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/core-js/library/fn/object/create.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs2/core-js/object/define-property.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/core-js/library/fn/object/define-property.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs2/core-js/object/entries.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/core-js/library/fn/object/entries.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs2/core-js/object/get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/core-js/library/fn/object/get-own-property-descriptor.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs2/core-js/object/keys.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/core-js/library/fn/object/keys.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs2/core-js/object/values.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/core-js/library/fn/object/values.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs2/core-js/parse-int.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/core-js/library/fn/parse-int.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs2/helpers/assertThisInitialized.js":
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs2/helpers/extends.js":
/***/ (function(module, exports, __webpack_require__) {

var _Object$assign = __webpack_require__("./node_modules/@babel/runtime-corejs2/core-js/object/assign.js");

function _extends() {
  module.exports = _extends = _Object$assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs2/helpers/inheritsLoose.js":
/***/ (function(module, exports, __webpack_require__) {

var _Object$create = __webpack_require__("./node_modules/@babel/runtime-corejs2/core-js/object/create.js");

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = _Object$create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs2/helpers/interopRequireDefault.js":
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard.js":
/***/ (function(module, exports, __webpack_require__) {

var _Object$getOwnPropertyDescriptor = __webpack_require__("./node_modules/@babel/runtime-corejs2/core-js/object/get-own-property-descriptor.js");

var _Object$defineProperty = __webpack_require__("./node_modules/@babel/runtime-corejs2/core-js/object/define-property.js");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = _Object$defineProperty && _Object$getOwnPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            _Object$defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

module.exports = _interopRequireWildcard;

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs2/helpers/objectWithoutPropertiesLoose.js":
/***/ (function(module, exports, __webpack_require__) {

var _Object$keys = __webpack_require__("./node_modules/@babel/runtime-corejs2/core-js/object/keys.js");

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};

  var sourceKeys = _Object$keys(source);

  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js":
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),

/***/ "./node_modules/@humblebee/styled-components-breakpoint/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMedia = exports.getMediaShorthands = exports.getMixin = exports.mediaRules = exports.getNextMedia = exports.getSmallestMedia = exports.mediaTemplate = exports.ruleTemplate = exports.mediaWidthRule = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n      ', '{\n        ', '\n      }\n    '], ['\n      ', '{\n        ', '\n      }\n    ']);

var _styledComponents = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// Breakpoint


// Flow-types
var mediaWidthRule = exports.mediaWidthRule = function mediaWidthRule(rule) {
  return ({ up: 'min', down: 'max' }[rule] || 'min') + '-width';
};

var ruleTemplate = exports.ruleTemplate = function ruleTemplate(rule, width) {
  return '(' + rule + ': ' + width + 'px)';
};
var mediaTemplate = exports.mediaTemplate = function mediaTemplate(rules) {
  return '@media only screen and ' + rules;
};

var getSmallestMedia = exports.getSmallestMedia = function getSmallestMedia(breakpoints) {
  var keys = Object.keys(breakpoints);

  return Number(keys.reduce(function (acc, key) {
    if (acc) {
      return acc > breakpoints[key] ? breakpoints[key] : acc;
    }
    return breakpoints[key];
  }, undefined));
};

var getNextMedia = exports.getNextMedia = function getNextMedia(breakpoints, width) {
  var keys = Object.keys(breakpoints);

  var nextBreakpoint = Number(keys.reduce(function (acc, key) {
    var current = breakpoints[key];
    if (acc && width - current <= 0) {
      return width - acc > Math.abs(width - current) || width - acc === 0 ? current : acc;
    }
    return getSmallestMedia(breakpoints);
  }, undefined));

  if (nextBreakpoint === width) {
    throw new Error('The breakpoint of value ' + nextBreakpoint + ' is the heighst there is, did you mean to use "[media].up"?');
  }
  return nextBreakpoint;
};

var mediaRules = exports.mediaRules = function mediaRules(breakpoints, widthKey, rule, boundKey) {
  var width = breakpoints[widthKey];
  var bound = breakpoints[boundKey];
  var baseWidthRule = mediaWidthRule(rule);
  var boudWidthRule = void 0;

  var baseRule = ruleTemplate(baseWidthRule, width);
  var boundRule = void 0;

  if (bound && width) {
    // Get correct rule based on width relative to bound
    baseWidthRule = mediaWidthRule(bound <= width ? 'down' : 'up');
    boudWidthRule = mediaWidthRule(bound <= width ? 'up' : 'down');

    baseRule = ruleTemplate(mediaWidthRule(bound <= width ? 'down' : 'up'), width);
    boundRule = ruleTemplate(boudWidthRule, bound);
    return [].concat([baseRule], bound ? [boundRule] : []).join(' and ');
  }

  if (!bound && rule === 'only') {
    // Get correct rule based on width relative to bound
    boudWidthRule = mediaWidthRule(bound <= width ? 'up' : 'down');
    boundRule = ruleTemplate(boudWidthRule, getNextMedia(breakpoints, width));
  }

  return [].concat([baseRule], boundRule ? [boundRule] : []).join(' and ');
};

var getMixin = exports.getMixin = function getMixin(breakpoints, key) {
  var rule = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'up';
  return function (bound) {
    return function () {
      return (0, _styledComponents.css)(_templateObject, mediaTemplate(mediaRules(breakpoints, key, rule, bound)), _styledComponents.css.apply(undefined, arguments));
    };
  };
};

var getMediaShorthands = exports.getMediaShorthands = function getMediaShorthands(breakpoints, rule) {
  return Object.keys(breakpoints).reduce(function (acc, key) {
    return _extends({}, acc, _defineProperty({}, key, getMixin(breakpoints, key, rule)()));
  }, {});
};

var getMedia = exports.getMedia = function getMedia(breakpoints) {
  var mediasUp = getMediaShorthands(breakpoints, 'up');
  var list = Object.keys(breakpoints);

  return _extends({}, mediasUp, {
    up: function up(widthKey) {
      return getMixin(breakpoints, widthKey, 'up')();
    },
    down: function down(widthKey) {
      return getMixin(breakpoints, widthKey, 'down')();
    },
    only: function only(widthKey, boundKey) {
      return getMixin(breakpoints, widthKey, 'only')(boundKey);
    },
    list: list
  });
};

exports.default = getMedia;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/@ngard/tiny-get/index.js":
/***/ (function(module, exports) {

function get(e,t,r){try{if(t in e)return e[t];var s=e;return t.replace(/\[\s*(['"])((?!\1).)*\1\s*\]|^\s*(\w+)\s*(?=\.|\[|$)|\.\s*(\w*)\s*(?=\.|\[|$)|\[\s*(-?\d+)\s*\]/g,function(e,t,r,n,o,u){s=s[r||n||o||u]}),void 0==s?r:s}catch(e){return r}}Object.defineProperty(exports,"__esModule",{value:!0}),exports.get=get;

/***/ }),

/***/ "./node_modules/animejs/anime.min.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 2017 Julian Garnier
 Released under the MIT license
*/
var $jscomp={scope:{}};$jscomp.defineProperty="function"==typeof Object.defineProperties?Object.defineProperty:function(e,r,p){if(p.get||p.set)throw new TypeError("ES3 does not support getters and setters.");e!=Array.prototype&&e!=Object.prototype&&(e[r]=p.value)};$jscomp.getGlobal=function(e){return"undefined"!=typeof window&&window===e?e:"undefined"!=typeof global&&null!=global?global:e};$jscomp.global=$jscomp.getGlobal(this);$jscomp.SYMBOL_PREFIX="jscomp_symbol_";
$jscomp.initSymbol=function(){$jscomp.initSymbol=function(){};$jscomp.global.Symbol||($jscomp.global.Symbol=$jscomp.Symbol)};$jscomp.symbolCounter_=0;$jscomp.Symbol=function(e){return $jscomp.SYMBOL_PREFIX+(e||"")+$jscomp.symbolCounter_++};
$jscomp.initSymbolIterator=function(){$jscomp.initSymbol();var e=$jscomp.global.Symbol.iterator;e||(e=$jscomp.global.Symbol.iterator=$jscomp.global.Symbol("iterator"));"function"!=typeof Array.prototype[e]&&$jscomp.defineProperty(Array.prototype,e,{configurable:!0,writable:!0,value:function(){return $jscomp.arrayIterator(this)}});$jscomp.initSymbolIterator=function(){}};$jscomp.arrayIterator=function(e){var r=0;return $jscomp.iteratorPrototype(function(){return r<e.length?{done:!1,value:e[r++]}:{done:!0}})};
$jscomp.iteratorPrototype=function(e){$jscomp.initSymbolIterator();e={next:e};e[$jscomp.global.Symbol.iterator]=function(){return this};return e};$jscomp.array=$jscomp.array||{};$jscomp.iteratorFromArray=function(e,r){$jscomp.initSymbolIterator();e instanceof String&&(e+="");var p=0,m={next:function(){if(p<e.length){var u=p++;return{value:r(u,e[u]),done:!1}}m.next=function(){return{done:!0,value:void 0}};return m.next()}};m[Symbol.iterator]=function(){return m};return m};
$jscomp.polyfill=function(e,r,p,m){if(r){p=$jscomp.global;e=e.split(".");for(m=0;m<e.length-1;m++){var u=e[m];u in p||(p[u]={});p=p[u]}e=e[e.length-1];m=p[e];r=r(m);r!=m&&null!=r&&$jscomp.defineProperty(p,e,{configurable:!0,writable:!0,value:r})}};$jscomp.polyfill("Array.prototype.keys",function(e){return e?e:function(){return $jscomp.iteratorFromArray(this,function(e){return e})}},"es6-impl","es3");var $jscomp$this=this;
(function(e,r){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (r),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"===typeof module&&module.exports?module.exports=r():e.anime=r()})(this,function(){function e(a){if(!h.col(a))try{return document.querySelectorAll(a)}catch(c){}}function r(a,c){for(var d=a.length,b=2<=arguments.length?arguments[1]:void 0,f=[],n=0;n<d;n++)if(n in a){var k=a[n];c.call(b,k,n,a)&&f.push(k)}return f}function p(a){return a.reduce(function(a,d){return a.concat(h.arr(d)?p(d):d)},[])}function m(a){if(h.arr(a))return a;
h.str(a)&&(a=e(a)||a);return a instanceof NodeList||a instanceof HTMLCollection?[].slice.call(a):[a]}function u(a,c){return a.some(function(a){return a===c})}function C(a){var c={},d;for(d in a)c[d]=a[d];return c}function D(a,c){var d=C(a),b;for(b in a)d[b]=c.hasOwnProperty(b)?c[b]:a[b];return d}function z(a,c){var d=C(a),b;for(b in c)d[b]=h.und(a[b])?c[b]:a[b];return d}function T(a){a=a.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i,function(a,c,d,k){return c+c+d+d+k+k});var c=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(a);
a=parseInt(c[1],16);var d=parseInt(c[2],16),c=parseInt(c[3],16);return"rgba("+a+","+d+","+c+",1)"}function U(a){function c(a,c,b){0>b&&(b+=1);1<b&&--b;return b<1/6?a+6*(c-a)*b:.5>b?c:b<2/3?a+(c-a)*(2/3-b)*6:a}var d=/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(a)||/hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(a);a=parseInt(d[1])/360;var b=parseInt(d[2])/100,f=parseInt(d[3])/100,d=d[4]||1;if(0==b)f=b=a=f;else{var n=.5>f?f*(1+b):f+b-f*b,k=2*f-n,f=c(k,n,a+1/3),b=c(k,n,a);a=c(k,n,a-1/3)}return"rgba("+
255*f+","+255*b+","+255*a+","+d+")"}function y(a){if(a=/([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(a))return a[2]}function V(a){if(-1<a.indexOf("translate")||"perspective"===a)return"px";if(-1<a.indexOf("rotate")||-1<a.indexOf("skew"))return"deg"}function I(a,c){return h.fnc(a)?a(c.target,c.id,c.total):a}function E(a,c){if(c in a.style)return getComputedStyle(a).getPropertyValue(c.replace(/([a-z])([A-Z])/g,"$1-$2").toLowerCase())||"0"}function J(a,c){if(h.dom(a)&&
u(W,c))return"transform";if(h.dom(a)&&(a.getAttribute(c)||h.svg(a)&&a[c]))return"attribute";if(h.dom(a)&&"transform"!==c&&E(a,c))return"css";if(null!=a[c])return"object"}function X(a,c){var d=V(c),d=-1<c.indexOf("scale")?1:0+d;a=a.style.transform;if(!a)return d;for(var b=[],f=[],n=[],k=/(\w+)\((.+?)\)/g;b=k.exec(a);)f.push(b[1]),n.push(b[2]);a=r(n,function(a,b){return f[b]===c});return a.length?a[0]:d}function K(a,c){switch(J(a,c)){case "transform":return X(a,c);case "css":return E(a,c);case "attribute":return a.getAttribute(c)}return a[c]||
0}function L(a,c){var d=/^(\*=|\+=|-=)/.exec(a);if(!d)return a;var b=y(a)||0;c=parseFloat(c);a=parseFloat(a.replace(d[0],""));switch(d[0][0]){case "+":return c+a+b;case "-":return c-a+b;case "*":return c*a+b}}function F(a,c){return Math.sqrt(Math.pow(c.x-a.x,2)+Math.pow(c.y-a.y,2))}function M(a){a=a.points;for(var c=0,d,b=0;b<a.numberOfItems;b++){var f=a.getItem(b);0<b&&(c+=F(d,f));d=f}return c}function N(a){if(a.getTotalLength)return a.getTotalLength();switch(a.tagName.toLowerCase()){case "circle":return 2*
Math.PI*a.getAttribute("r");case "rect":return 2*a.getAttribute("width")+2*a.getAttribute("height");case "line":return F({x:a.getAttribute("x1"),y:a.getAttribute("y1")},{x:a.getAttribute("x2"),y:a.getAttribute("y2")});case "polyline":return M(a);case "polygon":var c=a.points;return M(a)+F(c.getItem(c.numberOfItems-1),c.getItem(0))}}function Y(a,c){function d(b){b=void 0===b?0:b;return a.el.getPointAtLength(1<=c+b?c+b:0)}var b=d(),f=d(-1),n=d(1);switch(a.property){case "x":return b.x;case "y":return b.y;
case "angle":return 180*Math.atan2(n.y-f.y,n.x-f.x)/Math.PI}}function O(a,c){var d=/-?\d*\.?\d+/g,b;b=h.pth(a)?a.totalLength:a;if(h.col(b))if(h.rgb(b)){var f=/rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(b);b=f?"rgba("+f[1]+",1)":b}else b=h.hex(b)?T(b):h.hsl(b)?U(b):void 0;else f=(f=y(b))?b.substr(0,b.length-f.length):b,b=c&&!/\s/g.test(b)?f+c:f;b+="";return{original:b,numbers:b.match(d)?b.match(d).map(Number):[0],strings:h.str(a)||c?b.split(d):[]}}function P(a){a=a?p(h.arr(a)?a.map(m):m(a)):[];return r(a,
function(a,d,b){return b.indexOf(a)===d})}function Z(a){var c=P(a);return c.map(function(a,b){return{target:a,id:b,total:c.length}})}function aa(a,c){var d=C(c);if(h.arr(a)){var b=a.length;2!==b||h.obj(a[0])?h.fnc(c.duration)||(d.duration=c.duration/b):a={value:a}}return m(a).map(function(a,b){b=b?0:c.delay;a=h.obj(a)&&!h.pth(a)?a:{value:a};h.und(a.delay)&&(a.delay=b);return a}).map(function(a){return z(a,d)})}function ba(a,c){var d={},b;for(b in a){var f=I(a[b],c);h.arr(f)&&(f=f.map(function(a){return I(a,
c)}),1===f.length&&(f=f[0]));d[b]=f}d.duration=parseFloat(d.duration);d.delay=parseFloat(d.delay);return d}function ca(a){return h.arr(a)?A.apply(this,a):Q[a]}function da(a,c){var d;return a.tweens.map(function(b){b=ba(b,c);var f=b.value,e=K(c.target,a.name),k=d?d.to.original:e,k=h.arr(f)?f[0]:k,w=L(h.arr(f)?f[1]:f,k),e=y(w)||y(k)||y(e);b.from=O(k,e);b.to=O(w,e);b.start=d?d.end:a.offset;b.end=b.start+b.delay+b.duration;b.easing=ca(b.easing);b.elasticity=(1E3-Math.min(Math.max(b.elasticity,1),999))/
1E3;b.isPath=h.pth(f);b.isColor=h.col(b.from.original);b.isColor&&(b.round=1);return d=b})}function ea(a,c){return r(p(a.map(function(a){return c.map(function(b){var c=J(a.target,b.name);if(c){var d=da(b,a);b={type:c,property:b.name,animatable:a,tweens:d,duration:d[d.length-1].end,delay:d[0].delay}}else b=void 0;return b})})),function(a){return!h.und(a)})}function R(a,c,d,b){var f="delay"===a;return c.length?(f?Math.min:Math.max).apply(Math,c.map(function(b){return b[a]})):f?b.delay:d.offset+b.delay+
b.duration}function fa(a){var c=D(ga,a),d=D(S,a),b=Z(a.targets),f=[],e=z(c,d),k;for(k in a)e.hasOwnProperty(k)||"targets"===k||f.push({name:k,offset:e.offset,tweens:aa(a[k],d)});a=ea(b,f);return z(c,{children:[],animatables:b,animations:a,duration:R("duration",a,c,d),delay:R("delay",a,c,d)})}function q(a){function c(){return window.Promise&&new Promise(function(a){return p=a})}function d(a){return g.reversed?g.duration-a:a}function b(a){for(var b=0,c={},d=g.animations,f=d.length;b<f;){var e=d[b],
k=e.animatable,h=e.tweens,n=h.length-1,l=h[n];n&&(l=r(h,function(b){return a<b.end})[0]||l);for(var h=Math.min(Math.max(a-l.start-l.delay,0),l.duration)/l.duration,w=isNaN(h)?1:l.easing(h,l.elasticity),h=l.to.strings,p=l.round,n=[],m=void 0,m=l.to.numbers.length,t=0;t<m;t++){var x=void 0,x=l.to.numbers[t],q=l.from.numbers[t],x=l.isPath?Y(l.value,w*x):q+w*(x-q);p&&(l.isColor&&2<t||(x=Math.round(x*p)/p));n.push(x)}if(l=h.length)for(m=h[0],w=0;w<l;w++)p=h[w+1],t=n[w],isNaN(t)||(m=p?m+(t+p):m+(t+" "));
else m=n[0];ha[e.type](k.target,e.property,m,c,k.id);e.currentValue=m;b++}if(b=Object.keys(c).length)for(d=0;d<b;d++)H||(H=E(document.body,"transform")?"transform":"-webkit-transform"),g.animatables[d].target.style[H]=c[d].join(" ");g.currentTime=a;g.progress=a/g.duration*100}function f(a){if(g[a])g[a](g)}function e(){g.remaining&&!0!==g.remaining&&g.remaining--}function k(a){var k=g.duration,n=g.offset,w=n+g.delay,r=g.currentTime,x=g.reversed,q=d(a);if(g.children.length){var u=g.children,v=u.length;
if(q>=g.currentTime)for(var G=0;G<v;G++)u[G].seek(q);else for(;v--;)u[v].seek(q)}if(q>=w||!k)g.began||(g.began=!0,f("begin")),f("run");if(q>n&&q<k)b(q);else if(q<=n&&0!==r&&(b(0),x&&e()),q>=k&&r!==k||!k)b(k),x||e();f("update");a>=k&&(g.remaining?(t=h,"alternate"===g.direction&&(g.reversed=!g.reversed)):(g.pause(),g.completed||(g.completed=!0,f("complete"),"Promise"in window&&(p(),m=c()))),l=0)}a=void 0===a?{}:a;var h,t,l=0,p=null,m=c(),g=fa(a);g.reset=function(){var a=g.direction,c=g.loop;g.currentTime=
0;g.progress=0;g.paused=!0;g.began=!1;g.completed=!1;g.reversed="reverse"===a;g.remaining="alternate"===a&&1===c?2:c;b(0);for(a=g.children.length;a--;)g.children[a].reset()};g.tick=function(a){h=a;t||(t=h);k((l+h-t)*q.speed)};g.seek=function(a){k(d(a))};g.pause=function(){var a=v.indexOf(g);-1<a&&v.splice(a,1);g.paused=!0};g.play=function(){g.paused&&(g.paused=!1,t=0,l=d(g.currentTime),v.push(g),B||ia())};g.reverse=function(){g.reversed=!g.reversed;t=0;l=d(g.currentTime)};g.restart=function(){g.pause();
g.reset();g.play()};g.finished=m;g.reset();g.autoplay&&g.play();return g}var ga={update:void 0,begin:void 0,run:void 0,complete:void 0,loop:1,direction:"normal",autoplay:!0,offset:0},S={duration:1E3,delay:0,easing:"easeOutElastic",elasticity:500,round:0},W="translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY perspective".split(" "),H,h={arr:function(a){return Array.isArray(a)},obj:function(a){return-1<Object.prototype.toString.call(a).indexOf("Object")},
pth:function(a){return h.obj(a)&&a.hasOwnProperty("totalLength")},svg:function(a){return a instanceof SVGElement},dom:function(a){return a.nodeType||h.svg(a)},str:function(a){return"string"===typeof a},fnc:function(a){return"function"===typeof a},und:function(a){return"undefined"===typeof a},hex:function(a){return/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a)},rgb:function(a){return/^rgb/.test(a)},hsl:function(a){return/^hsl/.test(a)},col:function(a){return h.hex(a)||h.rgb(a)||h.hsl(a)}},A=function(){function a(a,
d,b){return(((1-3*b+3*d)*a+(3*b-6*d))*a+3*d)*a}return function(c,d,b,f){if(0<=c&&1>=c&&0<=b&&1>=b){var e=new Float32Array(11);if(c!==d||b!==f)for(var k=0;11>k;++k)e[k]=a(.1*k,c,b);return function(k){if(c===d&&b===f)return k;if(0===k)return 0;if(1===k)return 1;for(var h=0,l=1;10!==l&&e[l]<=k;++l)h+=.1;--l;var l=h+(k-e[l])/(e[l+1]-e[l])*.1,n=3*(1-3*b+3*c)*l*l+2*(3*b-6*c)*l+3*c;if(.001<=n){for(h=0;4>h;++h){n=3*(1-3*b+3*c)*l*l+2*(3*b-6*c)*l+3*c;if(0===n)break;var m=a(l,c,b)-k,l=l-m/n}k=l}else if(0===
n)k=l;else{var l=h,h=h+.1,g=0;do m=l+(h-l)/2,n=a(m,c,b)-k,0<n?h=m:l=m;while(1e-7<Math.abs(n)&&10>++g);k=m}return a(k,d,f)}}}}(),Q=function(){function a(a,b){return 0===a||1===a?a:-Math.pow(2,10*(a-1))*Math.sin(2*(a-1-b/(2*Math.PI)*Math.asin(1))*Math.PI/b)}var c="Quad Cubic Quart Quint Sine Expo Circ Back Elastic".split(" "),d={In:[[.55,.085,.68,.53],[.55,.055,.675,.19],[.895,.03,.685,.22],[.755,.05,.855,.06],[.47,0,.745,.715],[.95,.05,.795,.035],[.6,.04,.98,.335],[.6,-.28,.735,.045],a],Out:[[.25,
.46,.45,.94],[.215,.61,.355,1],[.165,.84,.44,1],[.23,1,.32,1],[.39,.575,.565,1],[.19,1,.22,1],[.075,.82,.165,1],[.175,.885,.32,1.275],function(b,c){return 1-a(1-b,c)}],InOut:[[.455,.03,.515,.955],[.645,.045,.355,1],[.77,0,.175,1],[.86,0,.07,1],[.445,.05,.55,.95],[1,0,0,1],[.785,.135,.15,.86],[.68,-.55,.265,1.55],function(b,c){return.5>b?a(2*b,c)/2:1-a(-2*b+2,c)/2}]},b={linear:A(.25,.25,.75,.75)},f={},e;for(e in d)f.type=e,d[f.type].forEach(function(a){return function(d,f){b["ease"+a.type+c[f]]=h.fnc(d)?
d:A.apply($jscomp$this,d)}}(f)),f={type:f.type};return b}(),ha={css:function(a,c,d){return a.style[c]=d},attribute:function(a,c,d){return a.setAttribute(c,d)},object:function(a,c,d){return a[c]=d},transform:function(a,c,d,b,f){b[f]||(b[f]=[]);b[f].push(c+"("+d+")")}},v=[],B=0,ia=function(){function a(){B=requestAnimationFrame(c)}function c(c){var b=v.length;if(b){for(var d=0;d<b;)v[d]&&v[d].tick(c),d++;a()}else cancelAnimationFrame(B),B=0}return a}();q.version="2.2.0";q.speed=1;q.running=v;q.remove=
function(a){a=P(a);for(var c=v.length;c--;)for(var d=v[c],b=d.animations,f=b.length;f--;)u(a,b[f].animatable.target)&&(b.splice(f,1),b.length||d.pause())};q.getValue=K;q.path=function(a,c){var d=h.str(a)?e(a)[0]:a,b=c||100;return function(a){return{el:d,property:a,totalLength:N(d)*(b/100)}}};q.setDashoffset=function(a){var c=N(a);a.setAttribute("stroke-dasharray",c);return c};q.bezier=A;q.easings=Q;q.timeline=function(a){var c=q(a);c.pause();c.duration=0;c.add=function(d){c.children.forEach(function(a){a.began=
!0;a.completed=!0});m(d).forEach(function(b){var d=z(b,D(S,a||{}));d.targets=d.targets||a.targets;b=c.duration;var e=d.offset;d.autoplay=!1;d.direction=c.direction;d.offset=h.und(e)?b:L(e,b);c.began=!0;c.completed=!0;c.seek(d.offset);d=q(d);d.began=!0;d.completed=!0;d.duration>b&&(c.duration=d.duration);c.children.push(d)});c.seek(0);c.reset();c.autoplay&&c.restart();return c};return c};q.random=function(a,c){return Math.floor(Math.random()*(c-a+1))+a};return q});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/react-scripts/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/array.dedup/build/src/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var dedup = function dedup(array) {
    if (!array || !array.filter) {
        return array;
    }
    return array.filter(function (item, pos, arr) {
        return arr.indexOf(item) === pos;
    });
};

exports.default = dedup;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/assert/assert.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var objectAssign = __webpack_require__("./node_modules/object-assign/index.js");

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:
// NB: The URL to the CommonJS spec is kept just for tradition.
//     node-assert has evolved a lot since then, both in API and behavior.

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = __webpack_require__("./node_modules/util/util.js");
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

// Expose a strict only variant of assert
function strict(value, message) {
  if (!value) fail(value, true, message, '==', strict);
}
assert.strict = objectAssign(strict, assert, {
  equal: assert.strictEqual,
  deepEqual: assert.deepStrictEqual,
  notEqual: assert.notStrictEqual,
  notDeepEqual: assert.notDeepStrictEqual
});
assert.strict.strict = assert.strict;

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/react-scripts/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/axios/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/axios/lib/axios.js");

/***/ }),

/***/ "./node_modules/axios/lib/adapters/xhr.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
var settle = __webpack_require__("./node_modules/axios/lib/core/settle.js");
var buildURL = __webpack_require__("./node_modules/axios/lib/helpers/buildURL.js");
var buildFullPath = __webpack_require__("./node_modules/axios/lib/core/buildFullPath.js");
var parseHeaders = __webpack_require__("./node_modules/axios/lib/helpers/parseHeaders.js");
var isURLSameOrigin = __webpack_require__("./node_modules/axios/lib/helpers/isURLSameOrigin.js");
var createError = __webpack_require__("./node_modules/axios/lib/core/createError.js");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__("./node_modules/axios/lib/helpers/cookies.js");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "./node_modules/axios/lib/axios.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
var bind = __webpack_require__("./node_modules/axios/lib/helpers/bind.js");
var Axios = __webpack_require__("./node_modules/axios/lib/core/Axios.js");
var mergeConfig = __webpack_require__("./node_modules/axios/lib/core/mergeConfig.js");
var defaults = __webpack_require__("./node_modules/axios/lib/defaults.js");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("./node_modules/axios/lib/cancel/Cancel.js");
axios.CancelToken = __webpack_require__("./node_modules/axios/lib/cancel/CancelToken.js");
axios.isCancel = __webpack_require__("./node_modules/axios/lib/cancel/isCancel.js");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("./node_modules/axios/lib/helpers/spread.js");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "./node_modules/axios/lib/cancel/Cancel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "./node_modules/axios/lib/cancel/CancelToken.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("./node_modules/axios/lib/cancel/Cancel.js");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "./node_modules/axios/lib/cancel/isCancel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "./node_modules/axios/lib/core/Axios.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
var buildURL = __webpack_require__("./node_modules/axios/lib/helpers/buildURL.js");
var InterceptorManager = __webpack_require__("./node_modules/axios/lib/core/InterceptorManager.js");
var dispatchRequest = __webpack_require__("./node_modules/axios/lib/core/dispatchRequest.js");
var mergeConfig = __webpack_require__("./node_modules/axios/lib/core/mergeConfig.js");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "./node_modules/axios/lib/core/InterceptorManager.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "./node_modules/axios/lib/core/buildFullPath.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__("./node_modules/axios/lib/helpers/isAbsoluteURL.js");
var combineURLs = __webpack_require__("./node_modules/axios/lib/helpers/combineURLs.js");

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ "./node_modules/axios/lib/core/createError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("./node_modules/axios/lib/core/enhanceError.js");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "./node_modules/axios/lib/core/dispatchRequest.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
var transformData = __webpack_require__("./node_modules/axios/lib/core/transformData.js");
var isCancel = __webpack_require__("./node_modules/axios/lib/cancel/isCancel.js");
var defaults = __webpack_require__("./node_modules/axios/lib/defaults.js");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "./node_modules/axios/lib/core/enhanceError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),

/***/ "./node_modules/axios/lib/core/mergeConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),

/***/ "./node_modules/axios/lib/core/settle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("./node_modules/axios/lib/core/createError.js");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "./node_modules/axios/lib/core/transformData.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "./node_modules/axios/lib/defaults.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
var normalizeHeaderName = __webpack_require__("./node_modules/axios/lib/helpers/normalizeHeaderName.js");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("./node_modules/axios/lib/adapters/xhr.js");
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__("./node_modules/axios/lib/adapters/xhr.js");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/axios/lib/helpers/bind.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "./node_modules/axios/lib/helpers/buildURL.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "./node_modules/axios/lib/helpers/combineURLs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "./node_modules/axios/lib/helpers/cookies.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ "./node_modules/axios/lib/helpers/isAbsoluteURL.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "./node_modules/axios/lib/helpers/isURLSameOrigin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ "./node_modules/axios/lib/helpers/normalizeHeaderName.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "./node_modules/axios/lib/helpers/parseHeaders.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "./node_modules/axios/lib/helpers/spread.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "./node_modules/axios/lib/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("./node_modules/axios/lib/helpers/bind.js");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "./node_modules/babel-runtime/core-js/json/stringify.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/json/stringify.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/assign.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/create.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/create.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/define-property.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/define-property.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/get-prototype-of.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/keys.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/keys.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/set-prototype-of.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/symbol.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/symbol/index.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/symbol/iterator.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/symbol/iterator.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/classCallCheck.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/createClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/extends.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/inherits.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/set-prototype-of.js");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__("./node_modules/babel-runtime/core-js/object/create.js");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/typeof.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__("./node_modules/babel-runtime/core-js/symbol/iterator.js");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__("./node_modules/babel-runtime/core-js/symbol.js");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/regenerator-runtime/runtime-module.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__("./node_modules/babel-runtime/node_modules/regenerator-runtime/runtime.js");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/regenerator-runtime/runtime.js":
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),

/***/ "./node_modules/babel-runtime/regenerator/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/babel-runtime/node_modules/regenerator-runtime/runtime-module.js");


/***/ }),

/***/ "./node_modules/base64-js/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ "./node_modules/buffer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__("./node_modules/base64-js/index.js")
var ieee754 = __webpack_require__("./node_modules/ieee754/index.js")
var isArray = __webpack_require__("./node_modules/isarray/index.js")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/react-scripts/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/class-lib/build/src/getClassReg.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getSafeReg = __webpack_require__("./node_modules/get-safe-reg/build/es/src/index.js");

var _getSafeReg2 = _interopRequireDefault(_getSafeReg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getRegString = function getRegString(name) {
  return '(?:^|\\s+)' + (0, _getSafeReg2.default)(name) + '(?:\\s+|$)';
};

var cache = (0, _getSafeReg.cacheReg)({})(getRegString);

exports.default = function (name) {
  return cache(name);
};

module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/class-lib/build/src/hasClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getClassReg = __webpack_require__("./node_modules/class-lib/build/src/getClassReg.js");

var _getClassReg2 = _interopRequireDefault(_getClassReg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasClass = function hasClass(classes, name) {
    return (0, _getClassReg2.default)(name).test(classes);
};

exports.default = hasClass;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/class-lib/build/src/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mixClass = __webpack_require__("./node_modules/class-lib/build/src/mixClass.js");

Object.defineProperty(exports, 'mixClass', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_mixClass).default;
  }
});

var _hasClass = __webpack_require__("./node_modules/class-lib/build/src/hasClass.js");

Object.defineProperty(exports, 'hasClass', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_hasClass).default;
  }
});

var _removeClass = __webpack_require__("./node_modules/class-lib/build/src/removeClass.js");

Object.defineProperty(exports, 'removeClass', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_removeClass).default;
  }
});

var _toggleClass = __webpack_require__("./node_modules/class-lib/build/src/toggleClass.js");

Object.defineProperty(exports, 'toggleClass', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_toggleClass).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./node_modules/class-lib/build/src/mixClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _array = __webpack_require__("./node_modules/array.dedup/build/src/index.js");

var _array2 = _interopRequireDefault(_array);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isArray = Array.isArray;
var keys = Object.keys;

var mixClass = function mixClass() {
    var classes = [];
    var args = arguments;
    keys(args).forEach(function (key) {
        var arg = args[key];
        if (!arg) {
            return;
        }
        var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);
        if (argType === 'string' || argType === 'number') {
            classes.push(arg);
        } else if (isArray(arg)) {
            classes.push(mixClass.apply(null, arg));
        } else if (argType === 'object') {
            keys(arg).forEach(function (k) {
                if (arg[k]) {
                    classes.push(k);
                }
            });
        }
    });
    var cookClasses = [];
    classes.forEach(function (c) {
        return cookClasses = cookClasses.concat(c.split(' '));
    });
    return (0, _array2.default)(cookClasses).join(' ');
};

exports.default = mixClass;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/class-lib/build/src/removeClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getClassReg = __webpack_require__("./node_modules/class-lib/build/src/getClassReg.js");

var _getClassReg2 = _interopRequireDefault(_getClassReg);

var _hasClass = __webpack_require__("./node_modules/class-lib/build/src/hasClass.js");

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var removeClass = function removeClass(classes, name) {
    if (classes && (0, _hasClass2.default)(classes, name)) {
        classes = classes.replace((0, _getClassReg2.default)(name), ' ').replace(/(^\s+)|\s+$/g, '');
        if ((0, _hasClass2.default)(classes, name)) {
            // in case of multiple adjacent
            classes = removeClass(classes, name);
        }
    }
    return classes;
};

exports.default = removeClass;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/class-lib/build/src/toggleClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _hasClass = __webpack_require__("./node_modules/class-lib/build/src/hasClass.js");

var _hasClass2 = _interopRequireDefault(_hasClass);

var _removeClass = __webpack_require__("./node_modules/class-lib/build/src/removeClass.js");

var _removeClass2 = _interopRequireDefault(_removeClass);

var _mixClass = __webpack_require__("./node_modules/class-lib/build/src/mixClass.js");

var _mixClass2 = _interopRequireDefault(_mixClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toggleClass = function toggleClass(classes, name) {
    if ((0, _hasClass2.default)(classes, name)) {
        classes = (0, _removeClass2.default)(classes, name);
    } else {
        classes = (0, _mixClass2.default)(classes, name);
    }
    return classes;
};

/***/ }),

/***/ "./node_modules/classnames/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ "./node_modules/core-js/library/fn/json/stringify.js":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.assign.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.assign;


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/create.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.create.js");
var $Object = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/define-property.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.define-property.js");
var $Object = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/entries.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es7.object.entries.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.entries;


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.get-own-property-descriptor.js");
var $Object = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.get-prototype-of.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.getPrototypeOf;


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/keys.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.keys.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.keys;


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.set-prototype-of.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.setPrototypeOf;


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/values.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es7.object.values.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.values;


/***/ }),

/***/ "./node_modules/core-js/library/fn/parse-int.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.parse-int.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").parseInt;


/***/ }),

/***/ "./node_modules/core-js/library/fn/symbol/index.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.symbol.js");
__webpack_require__("./node_modules/core-js/library/modules/es6.object.to-string.js");
__webpack_require__("./node_modules/core-js/library/modules/es7.symbol.async-iterator.js");
__webpack_require__("./node_modules/core-js/library/modules/es7.symbol.observable.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Symbol;


/***/ }),

/***/ "./node_modules/core-js/library/fn/symbol/iterator.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.string.iterator.js");
__webpack_require__("./node_modules/core-js/library/modules/web.dom.iterable.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_wks-ext.js").f('iterator');


/***/ }),

/***/ "./node_modules/core-js/library/modules/_a-function.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_add-to-unscopables.js":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "./node_modules/core-js/library/modules/_an-object.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_array-includes.js":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
var toLength = __webpack_require__("./node_modules/core-js/library/modules/_to-length.js");
var toAbsoluteIndex = __webpack_require__("./node_modules/core-js/library/modules/_to-absolute-index.js");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_cof.js":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_core.js":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "./node_modules/core-js/library/modules/_ctx.js":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("./node_modules/core-js/library/modules/_a-function.js");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_defined.js":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_descriptors.js":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/_dom-create.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
var document = __webpack_require__("./node_modules/core-js/library/modules/_global.js").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_enum-bug-keys.js":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "./node_modules/core-js/library/modules/_enum-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");
var gOPS = __webpack_require__("./node_modules/core-js/library/modules/_object-gops.js");
var pIE = __webpack_require__("./node_modules/core-js/library/modules/_object-pie.js");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_export.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
var hide = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");
var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_fails.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_global.js":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "./node_modules/core-js/library/modules/_has.js":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_hide.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
var createDesc = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_html.js":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("./node_modules/core-js/library/modules/_global.js").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_ie8-dom-define.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") && !__webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
  return Object.defineProperty(__webpack_require__("./node_modules/core-js/library/modules/_dom-create.js")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("./node_modules/core-js/library/modules/_cof.js");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_is-array.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("./node_modules/core-js/library/modules/_cof.js");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_is-object.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iter-create.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("./node_modules/core-js/library/modules/_object-create.js");
var descriptor = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");
var setToStringTag = __webpack_require__("./node_modules/core-js/library/modules/_set-to-string-tag.js");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("./node_modules/core-js/library/modules/_hide.js")(IteratorPrototype, __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iter-define.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("./node_modules/core-js/library/modules/_library.js");
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var redefine = __webpack_require__("./node_modules/core-js/library/modules/_redefine.js");
var hide = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");
var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
var $iterCreate = __webpack_require__("./node_modules/core-js/library/modules/_iter-create.js");
var setToStringTag = __webpack_require__("./node_modules/core-js/library/modules/_set-to-string-tag.js");
var getPrototypeOf = __webpack_require__("./node_modules/core-js/library/modules/_object-gpo.js");
var ITERATOR = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iter-step.js":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iterators.js":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_library.js":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_meta.js":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("./node_modules/core-js/library/modules/_uid.js")('meta');
var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
var setDesc = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-assign.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js");
var getKeys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");
var gOPS = __webpack_require__("./node_modules/core-js/library/modules/_object-gops.js");
var pIE = __webpack_require__("./node_modules/core-js/library/modules/_object-pie.js");
var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
var IObject = __webpack_require__("./node_modules/core-js/library/modules/_iobject.js");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-create.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var dPs = __webpack_require__("./node_modules/core-js/library/modules/_object-dps.js");
var enumBugKeys = __webpack_require__("./node_modules/core-js/library/modules/_enum-bug-keys.js");
var IE_PROTO = __webpack_require__("./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("./node_modules/core-js/library/modules/_dom-create.js")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("./node_modules/core-js/library/modules/_html.js").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-dp.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var IE8_DOM_DEFINE = __webpack_require__("./node_modules/core-js/library/modules/_ie8-dom-define.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/library/modules/_to-primitive.js");
var dP = Object.defineProperty;

exports.f = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-dps.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var getKeys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");

module.exports = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-gopd.js":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("./node_modules/core-js/library/modules/_object-pie.js");
var createDesc = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");
var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/library/modules/_to-primitive.js");
var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
var IE8_DOM_DEFINE = __webpack_require__("./node_modules/core-js/library/modules/_ie8-dom-define.js");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-gopn-ext.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
var gOPN = __webpack_require__("./node_modules/core-js/library/modules/_object-gopn.js").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-gopn.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys-internal.js");
var hiddenKeys = __webpack_require__("./node_modules/core-js/library/modules/_enum-bug-keys.js").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-gops.js":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-gpo.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
var IE_PROTO = __webpack_require__("./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-keys-internal.js":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
var arrayIndexOf = __webpack_require__("./node_modules/core-js/library/modules/_array-includes.js")(false);
var IE_PROTO = __webpack_require__("./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys-internal.js");
var enumBugKeys = __webpack_require__("./node_modules/core-js/library/modules/_enum-bug-keys.js");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-pie.js":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-sap.js":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
var fails = __webpack_require__("./node_modules/core-js/library/modules/_fails.js");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-to-array.js":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js");
var getKeys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");
var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
var isEnum = __webpack_require__("./node_modules/core-js/library/modules/_object-pie.js").f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_parse-int.js":
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__("./node_modules/core-js/library/modules/_global.js").parseInt;
var $trim = __webpack_require__("./node_modules/core-js/library/modules/_string-trim.js").trim;
var ws = __webpack_require__("./node_modules/core-js/library/modules/_string-ws.js");
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_property-desc.js":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_redefine.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");


/***/ }),

/***/ "./node_modules/core-js/library/modules/_set-proto.js":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js")(Function.call, __webpack_require__("./node_modules/core-js/library/modules/_object-gopd.js").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_set-to-string-tag.js":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f;
var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
var TAG = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_shared-key.js":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("./node_modules/core-js/library/modules/_shared.js")('keys');
var uid = __webpack_require__("./node_modules/core-js/library/modules/_uid.js");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_shared.js":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("./node_modules/core-js/library/modules/_library.js") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/_string-at.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("./node_modules/core-js/library/modules/_to-integer.js");
var defined = __webpack_require__("./node_modules/core-js/library/modules/_defined.js");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_string-trim.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var defined = __webpack_require__("./node_modules/core-js/library/modules/_defined.js");
var fails = __webpack_require__("./node_modules/core-js/library/modules/_fails.js");
var spaces = __webpack_require__("./node_modules/core-js/library/modules/_string-ws.js");
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_string-ws.js":
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-absolute-index.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("./node_modules/core-js/library/modules/_to-integer.js");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-integer.js":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("./node_modules/core-js/library/modules/_iobject.js");
var defined = __webpack_require__("./node_modules/core-js/library/modules/_defined.js");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-length.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("./node_modules/core-js/library/modules/_to-integer.js");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-object.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("./node_modules/core-js/library/modules/_defined.js");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_uid.js":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_wks-define.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
var LIBRARY = __webpack_require__("./node_modules/core-js/library/modules/_library.js");
var wksExt = __webpack_require__("./node_modules/core-js/library/modules/_wks-ext.js");
var defineProperty = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_wks-ext.js":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("./node_modules/core-js/library/modules/_wks.js");


/***/ }),

/***/ "./node_modules/core-js/library/modules/_wks.js":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("./node_modules/core-js/library/modules/_shared.js")('wks');
var uid = __webpack_require__("./node_modules/core-js/library/modules/_uid.js");
var Symbol = __webpack_require__("./node_modules/core-js/library/modules/_global.js").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.array.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("./node_modules/core-js/library/modules/_add-to-unscopables.js");
var step = __webpack_require__("./node_modules/core-js/library/modules/_iter-step.js");
var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_iter-define.js")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.assign.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("./node_modules/core-js/library/modules/_object-assign.js") });


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.create.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__("./node_modules/core-js/library/modules/_object-create.js") });


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.define-property.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("./node_modules/core-js/library/modules/_descriptors.js"), 'Object', { defineProperty: __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f });


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
var $getOwnPropertyDescriptor = __webpack_require__("./node_modules/core-js/library/modules/_object-gopd.js").f;

__webpack_require__("./node_modules/core-js/library/modules/_object-sap.js")('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
var $getPrototypeOf = __webpack_require__("./node_modules/core-js/library/modules/_object-gpo.js");

__webpack_require__("./node_modules/core-js/library/modules/_object-sap.js")('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
var $keys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");

__webpack_require__("./node_modules/core-js/library/modules/_object-sap.js")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("./node_modules/core-js/library/modules/_set-proto.js").set });


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.to-string.js":
/***/ (function(module, exports) {



/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.parse-int.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var $parseInt = __webpack_require__("./node_modules/core-js/library/modules/_parse-int.js");
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.string.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("./node_modules/core-js/library/modules/_string-at.js")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("./node_modules/core-js/library/modules/_iter-define.js")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.symbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
var DESCRIPTORS = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js");
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var redefine = __webpack_require__("./node_modules/core-js/library/modules/_redefine.js");
var META = __webpack_require__("./node_modules/core-js/library/modules/_meta.js").KEY;
var $fails = __webpack_require__("./node_modules/core-js/library/modules/_fails.js");
var shared = __webpack_require__("./node_modules/core-js/library/modules/_shared.js");
var setToStringTag = __webpack_require__("./node_modules/core-js/library/modules/_set-to-string-tag.js");
var uid = __webpack_require__("./node_modules/core-js/library/modules/_uid.js");
var wks = __webpack_require__("./node_modules/core-js/library/modules/_wks.js");
var wksExt = __webpack_require__("./node_modules/core-js/library/modules/_wks-ext.js");
var wksDefine = __webpack_require__("./node_modules/core-js/library/modules/_wks-define.js");
var enumKeys = __webpack_require__("./node_modules/core-js/library/modules/_enum-keys.js");
var isArray = __webpack_require__("./node_modules/core-js/library/modules/_is-array.js");
var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/library/modules/_to-primitive.js");
var createDesc = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");
var _create = __webpack_require__("./node_modules/core-js/library/modules/_object-create.js");
var gOPNExt = __webpack_require__("./node_modules/core-js/library/modules/_object-gopn-ext.js");
var $GOPD = __webpack_require__("./node_modules/core-js/library/modules/_object-gopd.js");
var $GOPS = __webpack_require__("./node_modules/core-js/library/modules/_object-gops.js");
var $DP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
var $keys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("./node_modules/core-js/library/modules/_object-gopn.js").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("./node_modules/core-js/library/modules/_object-pie.js").f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("./node_modules/core-js/library/modules/_library.js")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("./node_modules/core-js/library/modules/_hide.js")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "./node_modules/core-js/library/modules/es7.object.entries.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var $entries = __webpack_require__("./node_modules/core-js/library/modules/_object-to-array.js")(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/es7.object.values.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var $values = __webpack_require__("./node_modules/core-js/library/modules/_object-to-array.js")(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/es7.symbol.async-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/_wks-define.js")('asyncIterator');


/***/ }),

/***/ "./node_modules/core-js/library/modules/es7.symbol.observable.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/_wks-define.js")('observable');


/***/ }),

/***/ "./node_modules/core-js/library/modules/web.dom.iterable.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.array.iterator.js");
var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var hide = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");
var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
var TO_STRING_TAG = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "./node_modules/core-util-is/lib/util.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "./node_modules/create-react-class/factory.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("./node_modules/object-assign/index.js");

var emptyObject = __webpack_require__("./node_modules/create-react-class/node_modules/fbjs/lib/emptyObject.js");
var _invariant = __webpack_require__("./node_modules/create-react-class/node_modules/fbjs/lib/invariant.js");

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),

/***/ "./node_modules/create-react-class/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__("./node_modules/react/index.js");
var factory = __webpack_require__("./node_modules/create-react-class/factory.js");

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),

/***/ "./node_modules/create-react-class/node_modules/fbjs/lib/emptyObject.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),

/***/ "./node_modules/create-react-class/node_modules/fbjs/lib/invariant.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ "./node_modules/css/lib/parse/index.js":
/***/ (function(module, exports) {

// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var commentre = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g

module.exports = function(css, options){
  options = options || {};

  /**
   * Positional.
   */

  var lineno = 1;
  var column = 1;

  /**
   * Update lineno and column based on `str`.
   */

  function updatePosition(str) {
    var lines = str.match(/\n/g);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf('\n');
    column = ~i ? str.length - i : column + str.length;
  }

  /**
   * Mark position and patch `node.position`.
   */

  function position() {
    var start = { line: lineno, column: column };
    return function(node){
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }

  /**
   * Store position information for a node
   */

  function Position(start) {
    this.start = start;
    this.end = { line: lineno, column: column };
    this.source = options.source;
  }

  /**
   * Non-enumerable source string
   */

  Position.prototype.content = css;

  /**
   * Error `msg`.
   */

  var errorsList = [];

  function error(msg) {
    var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = css;

    if (options.silent) {
      errorsList.push(err);
    } else {
      throw err;
    }
  }

  /**
   * Parse stylesheet.
   */

  function stylesheet() {
    var rulesList = rules();

    return {
      type: 'stylesheet',
      stylesheet: {
        source: options.source,
        rules: rulesList,
        parsingErrors: errorsList
      }
    };
  }

  /**
   * Opening brace.
   */

  function open() {
    return match(/^{\s*/);
  }

  /**
   * Closing brace.
   */

  function close() {
    return match(/^}/);
  }

  /**
   * Parse ruleset.
   */

  function rules() {
    var node;
    var rules = [];
    whitespace();
    comments(rules);
    while (css.length && css.charAt(0) != '}' && (node = atrule() || rule())) {
      if (node !== false) {
        rules.push(node);
        comments(rules);
      }
    }
    return rules;
  }

  /**
   * Match `re` and return captures.
   */

  function match(re) {
    var m = re.exec(css);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    css = css.slice(str.length);
    return m;
  }

  /**
   * Parse whitespace.
   */

  function whitespace() {
    match(/^\s*/);
  }

  /**
   * Parse comments;
   */

  function comments(rules) {
    var c;
    rules = rules || [];
    while (c = comment()) {
      if (c !== false) {
        rules.push(c);
      }
    }
    return rules;
  }

  /**
   * Parse comment.
   */

  function comment() {
    var pos = position();
    if ('/' != css.charAt(0) || '*' != css.charAt(1)) return;

    var i = 2;
    while ("" != css.charAt(i) && ('*' != css.charAt(i) || '/' != css.charAt(i + 1))) ++i;
    i += 2;

    if ("" === css.charAt(i-1)) {
      return error('End of comment missing');
    }

    var str = css.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    css = css.slice(i);
    column += 2;

    return pos({
      type: 'comment',
      comment: str
    });
  }

  /**
   * Parse selector.
   */

  function selector() {
    var m = match(/^([^{]+)/);
    if (!m) return;
    /* @fix Remove all comments from selectors
     * http://ostermiller.org/findcomment.html */
    return trim(m[0])
      .replace(/\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*\/+/g, '')
      .replace(/"(?:\\"|[^"])*"|'(?:\\'|[^'])*'/g, function(m) {
        return m.replace(/,/g, '\u200C');
      })
      .split(/\s*(?![^(]*\)),\s*/)
      .map(function(s) {
        return s.replace(/\u200C/g, ',');
      });
  }

  /**
   * Parse declaration.
   */

  function declaration() {
    var pos = position();

    // prop
    var prop = match(/^(\*?[-#\/\*\\\w]+(\[[0-9a-z_-]+\])?)\s*/);
    if (!prop) return;
    prop = trim(prop[0]);

    // :
    if (!match(/^:\s*/)) return error("property missing ':'");

    // val
    var val = match(/^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^\)]*?\)|[^};])+)/);

    var ret = pos({
      type: 'declaration',
      property: prop.replace(commentre, ''),
      value: val ? trim(val[0]).replace(commentre, '') : ''
    });

    // ;
    match(/^[;\s]*/);

    return ret;
  }

  /**
   * Parse declarations.
   */

  function declarations() {
    var decls = [];

    if (!open()) return error("missing '{'");
    comments(decls);

    // declarations
    var decl;
    while (decl = declaration()) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }

    if (!close()) return error("missing '}'");
    return decls;
  }

  /**
   * Parse keyframe.
   */

  function keyframe() {
    var m;
    var vals = [];
    var pos = position();

    while (m = match(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/)) {
      vals.push(m[1]);
      match(/^,\s*/);
    }

    if (!vals.length) return;

    return pos({
      type: 'keyframe',
      values: vals,
      declarations: declarations()
    });
  }

  /**
   * Parse keyframes.
   */

  function atkeyframes() {
    var pos = position();
    var m = match(/^@([-\w]+)?keyframes\s*/);

    if (!m) return;
    var vendor = m[1];

    // identifier
    var m = match(/^([-\w]+)\s*/);
    if (!m) return error("@keyframes missing name");
    var name = m[1];

    if (!open()) return error("@keyframes missing '{'");

    var frame;
    var frames = comments();
    while (frame = keyframe()) {
      frames.push(frame);
      frames = frames.concat(comments());
    }

    if (!close()) return error("@keyframes missing '}'");

    return pos({
      type: 'keyframes',
      name: name,
      vendor: vendor,
      keyframes: frames
    });
  }

  /**
   * Parse supports.
   */

  function atsupports() {
    var pos = position();
    var m = match(/^@supports *([^{]+)/);

    if (!m) return;
    var supports = trim(m[1]);

    if (!open()) return error("@supports missing '{'");

    var style = comments().concat(rules());

    if (!close()) return error("@supports missing '}'");

    return pos({
      type: 'supports',
      supports: supports,
      rules: style
    });
  }

  /**
   * Parse host.
   */

  function athost() {
    var pos = position();
    var m = match(/^@host\s*/);

    if (!m) return;

    if (!open()) return error("@host missing '{'");

    var style = comments().concat(rules());

    if (!close()) return error("@host missing '}'");

    return pos({
      type: 'host',
      rules: style
    });
  }

  /**
   * Parse media.
   */

  function atmedia() {
    var pos = position();
    var m = match(/^@media *([^{]+)/);

    if (!m) return;
    var media = trim(m[1]);

    if (!open()) return error("@media missing '{'");

    var style = comments().concat(rules());

    if (!close()) return error("@media missing '}'");

    return pos({
      type: 'media',
      media: media,
      rules: style
    });
  }


  /**
   * Parse custom-media.
   */

  function atcustommedia() {
    var pos = position();
    var m = match(/^@custom-media\s+(--[^\s]+)\s*([^{;]+);/);
    if (!m) return;

    return pos({
      type: 'custom-media',
      name: trim(m[1]),
      media: trim(m[2])
    });
  }

  /**
   * Parse paged media.
   */

  function atpage() {
    var pos = position();
    var m = match(/^@page */);
    if (!m) return;

    var sel = selector() || [];

    if (!open()) return error("@page missing '{'");
    var decls = comments();

    // declarations
    var decl;
    while (decl = declaration()) {
      decls.push(decl);
      decls = decls.concat(comments());
    }

    if (!close()) return error("@page missing '}'");

    return pos({
      type: 'page',
      selectors: sel,
      declarations: decls
    });
  }

  /**
   * Parse document.
   */

  function atdocument() {
    var pos = position();
    var m = match(/^@([-\w]+)?document *([^{]+)/);
    if (!m) return;

    var vendor = trim(m[1]);
    var doc = trim(m[2]);

    if (!open()) return error("@document missing '{'");

    var style = comments().concat(rules());

    if (!close()) return error("@document missing '}'");

    return pos({
      type: 'document',
      document: doc,
      vendor: vendor,
      rules: style
    });
  }

  /**
   * Parse font-face.
   */

  function atfontface() {
    var pos = position();
    var m = match(/^@font-face\s*/);
    if (!m) return;

    if (!open()) return error("@font-face missing '{'");
    var decls = comments();

    // declarations
    var decl;
    while (decl = declaration()) {
      decls.push(decl);
      decls = decls.concat(comments());
    }

    if (!close()) return error("@font-face missing '}'");

    return pos({
      type: 'font-face',
      declarations: decls
    });
  }

  /**
   * Parse import
   */

  var atimport = _compileAtrule('import');

  /**
   * Parse charset
   */

  var atcharset = _compileAtrule('charset');

  /**
   * Parse namespace
   */

  var atnamespace = _compileAtrule('namespace');

  /**
   * Parse non-block at-rules
   */


  function _compileAtrule(name) {
    var re = new RegExp('^@' + name + '\\s*([^;]+);');
    return function() {
      var pos = position();
      var m = match(re);
      if (!m) return;
      var ret = { type: name };
      ret[name] = m[1].trim();
      return pos(ret);
    }
  }

  /**
   * Parse at rule.
   */

  function atrule() {
    if (css[0] != '@') return;

    return atkeyframes()
      || atmedia()
      || atcustommedia()
      || atsupports()
      || atimport()
      || atcharset()
      || atnamespace()
      || atdocument()
      || atpage()
      || athost()
      || atfontface();
  }

  /**
   * Parse rule.
   */

  function rule() {
    var pos = position();
    var sel = selector();

    if (!sel) return error('selector missing');
    comments();

    return pos({
      type: 'rule',
      selectors: sel,
      declarations: declarations()
    });
  }

  return addParent(stylesheet());
};

/**
 * Trim `str`.
 */

function trim(str) {
  return str ? str.replace(/^\s+|\s+$/g, '') : '';
}

/**
 * Adds non-enumerable parent node reference to each node.
 */

function addParent(obj, parent) {
  var isNode = obj && typeof obj.type === 'string';
  var childParent = isNode ? obj : parent;

  for (var k in obj) {
    var value = obj[k];
    if (Array.isArray(value)) {
      value.forEach(function(v) { addParent(v, childParent); });
    } else if (value && typeof value === 'object') {
      addParent(value, childParent);
    }
  }

  if (isNode) {
    Object.defineProperty(obj, 'parent', {
      configurable: true,
      writable: true,
      enumerable: false,
      value: parent || null
    });
  }

  return obj;
}


/***/ }),

/***/ "./node_modules/design-system-utils/build/es.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pxTo */
/* unused harmony export toPx */
/* unused harmony export parseUnit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ngard_tiny_get__ = __webpack_require__("./node_modules/@ngard/tiny-get/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ngard_tiny_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ngard_tiny_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dset__ = __webpack_require__("./node_modules/dset/dist/dset.es.js");
var i=function(t,r,i){return void 0===r&&(r=16),void 0===i&&(i="rem"),""+parseFloat(t)/r+i},e=function(t,r){return void 0===r&&(r=16),parseFloat(t)*r+"px"},o=function(t){return t.trim().match(/[\d.\-+]*\s*(.*)/)[1]||""},s=function(t){return"design-system-utils: Values missing at: "+t+" within your design tokens config"},n=function(t,r,i){return"design-system-utils: There is a missing value at this key: "+t+"."+(void 0===i?r:r+"."+i)},p=function(t,r){this.opts=Object.assign({},{fontSizeUnit:void 0},r),this.ds=t};p.prototype.get=function(r,i){return void 0===i&&(i=this.ds),Object(__WEBPACK_IMPORTED_MODULE_0__ngard_tiny_get__["get"])(i,r,void 0)},p.prototype.set=function(t,i){return Object(__WEBPACK_IMPORTED_MODULE_1_dset__["a" /* default */])(this.ds,t,i)},p.prototype.fontSize=function(t){var r;this.parentCheck("type.sizes"),"string"==typeof this.ds.type.baseFontSize&&(r=parseFloat(this.ds.type.baseFontSize));var s=this.get(t,this.ds.type.sizes);if(void 0===s)throw new Error(n("type.sizes",t));if(o(s)===this.opts.fontSizeUnit)return s;switch(this.opts.fontSizeUnit){case"rem":return i(s,r,"rem");case"em":return i(s,r,"em");case"px":return e(s,r);default:return s}},p.prototype.fs=function(t){return this.fontSize(t)},p.prototype.spacing=function(t){this.parentCheck("spacing.scale");var r=this.get(""+t,this.ds.spacing.scale);if(void 0===r)throw new Error(n("spacing.scale",t));return"string"==typeof r?r:r+"px"},p.prototype.space=function(t){return this.spacing(t)},p.prototype.color=function(t,r){void 0===r&&(r="base");var i="colors.colorPalette";if(void 0===this.get("colors",this.ds)&&void 0===this.get(i,this.ds))throw new Error(s(i));var e=t.split(".").length>1?this.get(t,this.ds.colors.colorPalette):this.ds.colors.colorPalette[t][r];if(void 0===e)throw new Error(n(i,t,r));return e},p.prototype.brand=function(t){this.parentCheck("colors.brand");var r=this.get(t,this.ds.colors.brand);if(void 0===r)throw new Error(n("colors.brand",t));return r},p.prototype.bp=function(t){if(void 0===this.get("breakpoints",this.ds))throw new Error(s("breakpoints"));var r=this.get(t,this.ds.breakpoints);if(void 0===r)throw new Error(n("breakpoints",t));return r},p.prototype.z=function(t){if(void 0===this.get("zIndex",this.ds))throw new Error(s("zIndex"));var r=this.get(t,this.ds.zIndex);if(void 0===r)throw new Error(n("zIndex",t));return r},p.prototype.multiply=function(t,r){return("string"==typeof t?parseFloat(this.get(t)):t)*r},p.prototype.parentCheck=function(t){var r=t.split(".");if(void 0===this.get(r[0],this.ds)&&void 0===this.get(t,this.ds))throw new Error(s(t))};/* harmony default export */ __webpack_exports__["a"] = (p);
//# sourceMappingURL=es.js.map


/***/ }),

/***/ "./node_modules/dom-helpers/style/getComputedStyle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.default = _getComputedStyle;

var _camelizeStyle = _interopRequireDefault(__webpack_require__("./node_modules/dom-helpers/util/camelizeStyle.js"));

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;
  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;
      prop = (0, _camelizeStyle.default)(prop);
      if (prop == 'float') prop = 'styleFloat';
      var current = node.currentStyle[prop] || null;
      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

        if (rsLeft) runStyle.left = node.currentStyle.left;
        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px'; // Revert the changed values

        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}

module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/dom-helpers/style/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.default = style;

var _camelizeStyle = _interopRequireDefault(__webpack_require__("./node_modules/dom-helpers/util/camelizeStyle.js"));

var _hyphenateStyle = _interopRequireDefault(__webpack_require__("./node_modules/dom-helpers/util/hyphenateStyle.js"));

var _getComputedStyle2 = _interopRequireDefault(__webpack_require__("./node_modules/dom-helpers/style/getComputedStyle.js"));

var _removeStyle = _interopRequireDefault(__webpack_require__("./node_modules/dom-helpers/style/removeStyle.js"));

var _properties = __webpack_require__("./node_modules/dom-helpers/transition/properties.js");

var _isTransform = _interopRequireDefault(__webpack_require__("./node_modules/dom-helpers/transition/isTransform.js"));

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (!value && value !== 0) {
      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
    } else if ((0, _isTransform.default)(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += _properties.transform + ": " + transforms + ";";
  }

  node.style.cssText += ';' + css;
}

module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/dom-helpers/style/removeStyle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/dom-helpers/transition/isTransform.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/dom-helpers/transition/properties.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__("./node_modules/dom-helpers/util/inDOM.js"));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),

/***/ "./node_modules/dom-helpers/util/camelize.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/dom-helpers/util/camelizeStyle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.default = camelizeStyleName;

var _camelize = _interopRequireDefault(__webpack_require__("./node_modules/dom-helpers/util/camelize.js"));

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */
var msPattern = /^-ms-/;

function camelizeStyleName(string) {
  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
}

module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/dom-helpers/util/hyphenate.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/dom-helpers/util/hyphenateStyle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.default = hyphenateStyleName;

var _hyphenate = _interopRequireDefault(__webpack_require__("./node_modules/dom-helpers/util/hyphenate.js"));

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;

function hyphenateStyleName(string) {
  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
}

module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/dom-helpers/util/inDOM.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/dset/dist/dset.es.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (obj, keys, val) {
	keys.split && (keys=keys.split('.'));
	var i=0, l=keys.length, t=obj, x;
	for (; i < l; ++i) {
		x = t[keys[i]];
		t = t[keys[i]] = (i === l - 1 ? val : (x != null ? x : (!!~keys[i+1].indexOf('.') || !(+keys[i+1] > -1)) ? {} : []));
	}
});


/***/ }),

/***/ "./node_modules/easing-lib/easeInOutCubic.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var easeInOutCubic = function easeInOutCubic(t, b, c, d) {
    if ((t /= d / 2) < 1) {
        return c / 2 * t * t * t + b;
    }
    return c / 2 * ((t -= 2) * t * t + 2) + b;
};

exports.default = easeInOutCubic;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/enquire.js/src/MediaQuery.js":
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__("./node_modules/enquire.js/src/QueryHandler.js");
var each = __webpack_require__("./node_modules/enquire.js/src/Util.js").each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),

/***/ "./node_modules/enquire.js/src/MediaQueryDispatch.js":
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__("./node_modules/enquire.js/src/MediaQuery.js");
var Util = __webpack_require__("./node_modules/enquire.js/src/Util.js");
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),

/***/ "./node_modules/enquire.js/src/QueryHandler.js":
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),

/***/ "./node_modules/enquire.js/src/Util.js":
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),

/***/ "./node_modules/enquire.js/src/index.js":
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__("./node_modules/enquire.js/src/MediaQueryDispatch.js");
module.exports = new MediaQueryDispatch();


/***/ }),

/***/ "./node_modules/events/events.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}


/***/ }),

/***/ "./node_modules/fbjs/lib/invariant.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var validateFormat =  false ? function (format) {} : function (format) {
  if (format === undefined) {
    throw new Error('invariant(...): Second argument must be a string.');
  }
};
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments to provide
 * information about what broke and what you were expecting.
 *
 * The invariant message will be stripped in production, but the invariant will
 * remain to ensure logic does not differ in production.
 */

function invariant(condition, format) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  validateFormat(format);

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return String(args[argIndex++]);
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // Skip invariant's own stack frame.

    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ "./node_modules/get-object-value/build/es/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getDefault */
/* unused harmony export toJS */
/* unused harmony export toMap */
/* unused harmony export initMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_typeof__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/typeof.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_constant__ = __webpack_require__("./node_modules/reshow-constant/build/es/index.js");


var isArray = Array.isArray;

var getWebpack4Default = function getWebpack4Default(o) {
  return get(o, [__WEBPACK_IMPORTED_MODULE_1_reshow_constant__["a" /* DEFAULT */], __WEBPACK_IMPORTED_MODULE_1_reshow_constant__["a" /* DEFAULT */]], function () {
    return get(o, [__WEBPACK_IMPORTED_MODULE_1_reshow_constant__["a" /* DEFAULT */]], function () {
      return o;
    });
  });
};

var toJS = function toJS(v) {
  return v && v.toJS ? v.toJS() : v;
};

var toMap = function toMap(a) {
  return get(toJS(a), null, {});
};

var initMap = function initMap(o) {
  return function (k, v) {
    return o[k] || (o[k] = getDefaultValue(v));
  };
};

var getDefaultValue = function getDefaultValue(v) {
  return __WEBPACK_IMPORTED_MODULE_1_reshow_constant__["b" /* FUNCTION */] === Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_typeof__["a" /* default */])(v) ? v() : v;
};

var get = function get(o, path, defaultValue) {
  if (null === o || __WEBPACK_IMPORTED_MODULE_1_reshow_constant__["e" /* UNDEFINED */] === Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_typeof__["a" /* default */])(o)) {
    return getDefaultValue(defaultValue);
  }

  var current = toJS(o);

  if (!isArray(path)) {
    return current;
  }

  path.every(function (a) {
    if (null !== current[a] && __WEBPACK_IMPORTED_MODULE_1_reshow_constant__["e" /* UNDEFINED */] !== Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_typeof__["a" /* default */])(current[a])) {
      current = current[a];
      return true;
    } else {
      current = getDefaultValue(defaultValue);
      return false;
    }
  });
  return current;
};

/* harmony default export */ __webpack_exports__["a"] = (get);


/***/ }),

/***/ "./node_modules/get-safe-reg/build/es/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cacheReg", function() { return cacheReg; });
var esc = /[|\\{}()[\]^$+*?.]/g;
var getSafeReg = function getSafeReg(name) {
    return name.replace(esc, '\\$&');
};
var cacheReg = function cacheReg(cache) {
    return function (regString) {
        return function (name) {
            if (!cache[name]) {
                cache[name] = new RegExp(regString(name));
            }
            return cache[name];
        };
    };
};
/* harmony default export */ __webpack_exports__["default"] = (getSafeReg);


/***/ }),

/***/ "./node_modules/get-scroll-info/build/es/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getScrollNode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_typeof__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/typeof.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_win_doc__ = __webpack_require__("./node_modules/win-doc/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reshow_constant__ = __webpack_require__("./node_modules/reshow-constant/build/es/index.js");



var lastScrollStore = {};
var oDoc;
var oWin;
var isWebkit;
var docEl;
var domCount = 0;

var initDoc = function initDoc() {
  oDoc = Object(__WEBPACK_IMPORTED_MODULE_1_win_doc__["a" /* doc */])();
  oWin = Object(__WEBPACK_IMPORTED_MODULE_1_win_doc__["b" /* win */])();
  isWebkit = __WEBPACK_IMPORTED_MODULE_2_reshow_constant__["e" /* UNDEFINED */] !== Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_typeof__["a" /* default */])(oDoc.webkitIsFullScreen);
  docEl = oDoc.documentElement;
};

var getScrollNode = function getScrollNode(el) {
  if (!oDoc) {
    initDoc();
  }

  if (!el && oDoc) {
    if (oDoc.scrollingElement) {
      el = oDoc.scrollingElement;
    } else if (isWebkit) {
      el = oDoc.body;
    } else {
      el = docEl;
    }
  }

  if (!el.id) {
    el.id = 'scroll-info-' + domCount;
    domCount++;
  }

  return el;
};

var getScrollInfo = function getScrollInfo(el, margin) {
  el = getScrollNode(el);

  if (!margin) {
    margin = 50;
  }

  var w;
  var h;
  var nodeName = (el.nodeName || '').toLowerCase();
  var isRoot = 'body' === nodeName || 'html' === nodeName;

  if (isRoot) {
    w = Math.max(docEl.clientWidth || 0, oWin.innerWidth || 0);
    h = Math.max(docEl.clientHeight || 0, oWin.innerHeight || 0);
  } else {
    w = el.clientWidth;
    h = el.clientHeight;
  }

  var scrollLeft = el.scrollLeft;
  var scrollHeight = el.scrollHeight;
  var scrollTop = el.scrollTop;
  var scrollWidth = el.scrollWidth;
  var scrollBottom = scrollTop + h;
  var scrollRight = scrollLeft + w;
  var elId = el.id;
  var lastScroll = lastScrollStore[elId];
  var info = {
    atTop: scrollTop < margin,
    atRight: scrollRight > scrollWidth - margin,
    atBottom: scrollBottom > scrollHeight - margin,
    atLeft: scrollLeft < margin,
    isScrollDown: lastScroll && scrollTop > lastScroll.top,
    isScrollLeft: lastScroll && scrollLeft < lastScroll.left,
    isScrollRight: lastScroll && scrollLeft > lastScroll.left,
    isScrollUp: lastScroll && scrollTop < lastScroll.top,
    scrollWidth: scrollWidth,
    scrollHeight: scrollHeight,
    scrollNodeWidth: w,
    scrollNodeHeight: h,
    top: scrollTop,
    right: scrollRight,
    bottom: scrollBottom,
    left: scrollLeft
  };
  lastScrollStore[elId] = info;
  return info;
};

/* harmony default export */ __webpack_exports__["a"] = (getScrollInfo);


/***/ }),

/***/ "./node_modules/get-style/build/src/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getStyle = function getStyle(el, styleKey) {
    if ('undefined' === typeof document) {
        return;
    }
    var doc = document;
    var styleValue = '';
    if (el.currentStyle) {
        styleValue = el.currentStyle[styleKey];
    } else if (doc.defaultView && doc.defaultView.getComputedStyle) {
        styleValue = doc.defaultView.getComputedStyle(el, null).getPropertyValue(styleKey);
    }
    if (styleValue && styleValue.toLowerCase) {
        return styleValue.toLowerCase();
    } else {
        return styleValue;
    }
};

exports.default = getStyle;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/get-window-offset/build/es/src/alignUI.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getoffset__ = __webpack_require__("./node_modules/getoffset/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_get_scroll_info__ = __webpack_require__("./node_modules/get-scroll-info/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_get_object_value__ = __webpack_require__("./node_modules/get-object-value/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getAfterMove__ = __webpack_require__("./node_modules/get-window-offset/build/es/src/getAfterMove.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getWindowOffset__ = __webpack_require__("./node_modules/get-window-offset/build/es/src/getWindowOffset.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__alignWith__ = __webpack_require__("./node_modules/get-window-offset/build/es/src/alignWith.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isFullOnScreen__ = __webpack_require__("./node_modules/get-window-offset/build/es/src/isFullOnScreen.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isSetOverflow__ = __webpack_require__("./node_modules/get-window-offset/build/es/src/isSetOverflow.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isFixed__ = __webpack_require__("./node_modules/get-window-offset/build/es/src/isFixed.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__positions__ = __webpack_require__("./node_modules/get-window-offset/build/es/src/positions.js");











var getAlignWithLoc = function getAlignWithLoc(toLoc) {
  var loc;

  switch (toLoc) {
    case __WEBPACK_IMPORTED_MODULE_9__positions__["a" /* default */].TL:
      loc = __WEBPACK_IMPORTED_MODULE_9__positions__["a" /* default */].TR;
      break;

    case __WEBPACK_IMPORTED_MODULE_9__positions__["a" /* default */].TR:
      loc = __WEBPACK_IMPORTED_MODULE_9__positions__["a" /* default */].TL;
      break;

    case __WEBPACK_IMPORTED_MODULE_9__positions__["a" /* default */].BL:
      loc = __WEBPACK_IMPORTED_MODULE_9__positions__["a" /* default */].BR;
      break;

    case __WEBPACK_IMPORTED_MODULE_9__positions__["a" /* default */].BR:
      loc = __WEBPACK_IMPORTED_MODULE_9__positions__["a" /* default */].BL;
      break;

    default:
      loc = toLoc;
      break;
  }

  return loc;
};

var fixFixedNode = function fixFixedNode(scrollInfo) {
  return function (move) {
    return [move[0] + scrollInfo.left, move[1] + scrollInfo.top];
  };
};

var fixScrollNode = function fixScrollNode(scrollInfo) {
  return function (move) {
    return [move[0] - scrollInfo.left, move[1] - scrollInfo.top];
  };
};

var alignUI = function alignUI(targetEl, floatEl, alignParams, winInfo) {
  var _get = Object(__WEBPACK_IMPORTED_MODULE_2_get_object_value__["a" /* default */])(alignParams, null, {}),
      toLoc = _get.toLoc,
      disableAutoLoc = _get.disableAutoLoc;

  if (!targetEl) {
    console.error('targetEl was empty');
    console.trace();
    return false;
  }

  var targetInfo;
  var locs = [];

  if (toLoc) {
    locs.push(toLoc);
  }

  if (!disableAutoLoc) {
    winInfo = winInfo || Object(__WEBPACK_IMPORTED_MODULE_4__getWindowOffset__["a" /* default */])(targetEl);

    if (!winInfo) {
      console.error('get windows offset failed');
    } else {
      locs = locs.concat(winInfo.locs);
    }
  }

  if (!locs.length) {
    console.error('Not set any locs', toLoc);
    return;
  }

  if (!targetInfo) {
    if (winInfo) {
      targetInfo = winInfo.domInfo;
    } else {
      var targetFixedNode = Object(__WEBPACK_IMPORTED_MODULE_8__isFixed__["a" /* default */])(targetEl);
      targetInfo = Object(__WEBPACK_IMPORTED_MODULE_0_getoffset__["a" /* default */])(targetEl, targetFixedNode);
      targetInfo.scrollNode = Object(__WEBPACK_IMPORTED_MODULE_7__isSetOverflow__["a" /* default */])(targetEl);
      targetInfo.fixedNode = targetFixedNode;
    }
  }

  var floatInfo = Object(__WEBPACK_IMPORTED_MODULE_0_getoffset__["a" /* default */])(floatEl);
  var adjustMove;
  var scrollNode = targetInfo.scrollNode;
  var fixedNode = targetInfo.fixedNode;

  if (fixedNode) {
    if (fixedNode.contains(floatEl)) {
      adjustMove = fixFixedNode(Object(__WEBPACK_IMPORTED_MODULE_1_get_scroll_info__["a" /* default */])(fixedNode));
    } else {
      if (winInfo) {
        adjustMove = fixFixedNode(winInfo.scrollInfo);
      } else {
        adjustMove = fixFixedNode(Object(__WEBPACK_IMPORTED_MODULE_1_get_scroll_info__["a" /* default */])());
      }
    }
  } else if (scrollNode) {
    adjustMove = fixScrollNode(Object(__WEBPACK_IMPORTED_MODULE_1_get_scroll_info__["a" /* default */])(scrollNode));
  }

  var loc;
  var move;
  locs.some(function (locItem) {
    toLoc = locItem;
    loc = getAlignWithLoc(toLoc);
    move = Object(__WEBPACK_IMPORTED_MODULE_5__alignWith__["a" /* default */])(targetInfo, floatInfo, loc);

    if (adjustMove) {
      move = adjustMove(move);
    }

    if (!winInfo) {
      return true;
    } else {
      var movePos = Object(__WEBPACK_IMPORTED_MODULE_3__getAfterMove__["a" /* default */])(floatInfo, move);
      var bFullOnScreen = Object(__WEBPACK_IMPORTED_MODULE_6__isFullOnScreen__["a" /* default */])(movePos, winInfo.scrollInfo);

      if (bFullOnScreen) {
        return true;
      } else {
        return false;
      }
    }
  });
  var result = {
    loc: loc,
    toLoc: toLoc,
    move: move
  }; //console.log(result);

  return result;
};

/* unused harmony default export */ var _unused_webpack_default_export = (alignUI);

/***/ }),

/***/ "./node_modules/get-window-offset/build/es/src/alignWith.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAlignTargetXY__ = __webpack_require__("./node_modules/get-window-offset/build/es/src/getAlignTargetXY.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__positions__ = __webpack_require__("./node_modules/get-window-offset/build/es/src/positions.js");



var alignWith = function alignWith(targetInfo, floatElInfo, loc) {
  var xy = Object(__WEBPACK_IMPORTED_MODULE_0__getAlignTargetXY__["a" /* default */])(targetInfo, loc);
  var width = floatElInfo.right - floatElInfo.left;
  var height = floatElInfo.bottom - floatElInfo.top;
  var moveXY;

  switch (loc) {
    case __WEBPACK_IMPORTED_MODULE_1__positions__["a" /* default */].TL:
      moveXY = [xy[0], xy[1] - height];
      break;

    case __WEBPACK_IMPORTED_MODULE_1__positions__["a" /* default */].TC:
      moveXY = [xy[0] - Math.floor(width / 2), xy[1] - height];
      break;

    case __WEBPACK_IMPORTED_MODULE_1__positions__["a" /* default */].TR:
      moveXY = [xy[0] - width, xy[1] - height];
      break;

    case __WEBPACK_IMPORTED_MODULE_1__positions__["a" /* default */].RT:
      moveXY = [xy[0], xy[1]];
      break;

    case __WEBPACK_IMPORTED_MODULE_1__positions__["a" /* default */].RC:
      moveXY = [xy[0], xy[1] - Math.floor(height / 2)];
      break;

    case __WEBPACK_IMPORTED_MODULE_1__positions__["a" /* default */].RB:
      moveXY = [xy[0], xy[1] - height];
      break;

    case __WEBPACK_IMPORTED_MODULE_1__positions__["a" /* default */].BL:
      moveXY = [xy[0], xy[1]];
      break;

    case __WEBPACK_IMPORTED_MODULE_1__positions__["a" /* default */].BC:
      moveXY = [xy[0] - Math.floor(width / 2), xy[1]];
      break;

    case __WEBPACK_IMPORTED_MODULE_1__positions__["a" /* default */].BR:
      moveXY = [xy[0] - width, xy[1]];
      break;

    case __WEBPACK_IMPORTED_MODULE_1__positions__["a" /* default */].LT:
      moveXY = [xy[0] - width, xy[1]];
      break;

    case __WEBPACK_IMPORTED_MODULE_1__positions__["a" /* default */].LC:
      moveXY = [xy[0] - width, xy[1] - Math.floor(height / 2)];
      break;

    case __WEBPACK_IMPORTED_MODULE_1__positions__["a" /* default */].LB:
      moveXY = [xy[0] - width, xy[1] - height];
      break;

    case __WEBPACK_IMPORTED_MODULE_1__positions__["a" /* default */].CC:
      moveXY = [xy[0] - Math.floor(width / 2), xy[1] - Math.floor(height / 2)];
      break;

    default:
      console.error('Not support align type.');
      break;
  }

  return moveXY;
};

/* harmony default export */ __webpack_exports__["a"] = (alignWith);

/***/ }),

/***/ "./node_modules/get-window-offset/build/es/src/getAfterMove.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getAfterMove = function getAfterMove(domInfo, moveXY) {
  var width = domInfo.right - domInfo.left;
  var height = domInfo.bottom - domInfo.top;
  var info = {
    top: moveXY[1],
    right: moveXY[0] + width,
    bottom: moveXY[1] + height,
    left: moveXY[0]
  };
  return info;
};

/* harmony default export */ __webpack_exports__["a"] = (getAfterMove);

/***/ }),

/***/ "./node_modules/get-window-offset/build/es/src/getAlignTargetXY.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__positions__ = __webpack_require__("./node_modules/get-window-offset/build/es/src/positions.js");


var getAlignTargetXY = function getAlignTargetXY(domInfo, loc) {
  var xy;
  var width = domInfo.right - domInfo.left;
  var height = domInfo.bottom - domInfo.top;

  switch (loc) {
    case __WEBPACK_IMPORTED_MODULE_0__positions__["a" /* default */].LT:
    case __WEBPACK_IMPORTED_MODULE_0__positions__["a" /* default */].TL:
      xy = [domInfo.left, domInfo.top];
      break;

    case __WEBPACK_IMPORTED_MODULE_0__positions__["a" /* default */].TC:
      xy = [domInfo.left + Math.floor(width / 2), domInfo.top];
      break;

    case __WEBPACK_IMPORTED_MODULE_0__positions__["a" /* default */].RT:
    case __WEBPACK_IMPORTED_MODULE_0__positions__["a" /* default */].TR:
      xy = [domInfo.right, domInfo.top];
      break;

    case __WEBPACK_IMPORTED_MODULE_0__positions__["a" /* default */].LT:
    case __WEBPACK_IMPORTED_MODULE_0__positions__["a" /* default */].BL:
      xy = [domInfo.left, domInfo.bottom];
      break;

    case __WEBPACK_IMPORTED_MODULE_0__positions__["a" /* default */].BC:
      xy = [domInfo.left + Math.floor(width / 2), domInfo.bottom];
      break;

    case __WEBPACK_IMPORTED_MODULE_0__positions__["a" /* default */].RB:
    case __WEBPACK_IMPORTED_MODULE_0__positions__["a" /* default */].BR:
      xy = [domInfo.right, domInfo.bottom];
      break;

    case __WEBPACK_IMPORTED_MODULE_0__positions__["a" /* default */].RC:
      xy = [domInfo.right, domInfo.top + Math.floor(height / 2)];
      break;

    case __WEBPACK_IMPORTED_MODULE_0__positions__["a" /* default */].LC:
      xy = [domInfo.left, domInfo.top + Math.floor(height / 2)];
      break;

    case __WEBPACK_IMPORTED_MODULE_0__positions__["a" /* default */].CC:
      xy = [domInfo.left + Math.floor(width / 2), domInfo.top + Math.floor(height / 2)];
      break;

    default:
      console.error('Not support align type. [' + loc + ']');
      break;
  }

  return xy;
};

/* harmony default export */ __webpack_exports__["a"] = (getAlignTargetXY);

/***/ }),

/***/ "./node_modules/get-window-offset/build/es/src/getPositionString.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_get_object_value__ = __webpack_require__("./node_modules/get-object-value/build/es/src/index.js");

var position = {
  tl: 'top left',
  tc: 'top center',
  tr: 'top right',
  rt: 'right center',
  rc: 'right center',
  rb: 'right center',
  bl: 'bottom left',
  bc: 'bottom center',
  br: 'bottom right',
  lt: 'left center',
  lc: 'left center',
  lb: 'left center'
};

var getPositionString = function getPositionString(loc) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_get_object_value__["a" /* default */])(position, [loc]);
};

/* unused harmony default export */ var _unused_webpack_default_export = (getPositionString);

/***/ }),

/***/ "./node_modules/get-window-offset/build/es/src/getWindowOffset.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_objectSpread__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectSpread.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_defineProperty__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/defineProperty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_get_scroll_info__ = __webpack_require__("./node_modules/get-scroll-info/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_getoffset__ = __webpack_require__("./node_modules/getoffset/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isOnScreen__ = __webpack_require__("./node_modules/get-window-offset/build/es/src/isOnScreen.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isFixed__ = __webpack_require__("./node_modules/get-window-offset/build/es/src/isFixed.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isSetOverflow__ = __webpack_require__("./node_modules/get-window-offset/build/es/src/isSetOverflow.js");








var calWindowOffset = function calWindowOffset(domInfo, scrollInfo) {
  var _distanceFlip;

  var distance = {};
  distance.top = domInfo.top - scrollInfo.top;
  distance.right = scrollInfo.right - domInfo.right;
  distance.bottom = scrollInfo.bottom - domInfo.bottom;
  distance.left = domInfo.left - scrollInfo.left;
  var distanceFlip = (_distanceFlip = {}, Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_defineProperty__["a" /* default */])(_distanceFlip, distance.top, 't'), Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_defineProperty__["a" /* default */])(_distanceFlip, distance.right, 'r'), Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_defineProperty__["a" /* default */])(_distanceFlip, distance.bottom, 'b'), Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_defineProperty__["a" /* default */])(_distanceFlip, distance.left, 'l'), _distanceFlip);
  var maxDistance = Math.max(distance.top, distance.right, distance.bottom, distance.left);
  var firstKey = distanceFlip[maxDistance];
  var secondKey;
  var locs = [firstKey + 'c'];

  if (firstKey === 't' || firstKey === 'b') {
    var _distanceFlip2;

    distanceFlip = (_distanceFlip2 = {}, Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_defineProperty__["a" /* default */])(_distanceFlip2, distance.right, 'r'), Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_defineProperty__["a" /* default */])(_distanceFlip2, distance.left, 'l'), _distanceFlip2);
    secondKey = distanceFlip[Math.max(distance.left, distance.right)];
  } else {
    var _distanceFlip3;

    distanceFlip = (_distanceFlip3 = {}, Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_defineProperty__["a" /* default */])(_distanceFlip3, distance.top, 't'), Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_defineProperty__["a" /* default */])(_distanceFlip3, distance.bottom, 'b'), _distanceFlip3);
    secondKey = firstKey;
    firstKey = distanceFlip[Math.max(distance.top, distance.bottom)];
  }

  locs.push(firstKey + secondKey);
  locs.push(secondKey + firstKey);
  var tb = firstKey;
  var lr = secondKey;
  return {
    locs: locs,
    tb: tb,
    lr: lr
  };
};

var getWindowOffset = function getWindowOffset(dom) {
  if (!dom) {
    console.error('getWindowOffset not assign dom');
    console.trace();
    return false;
  }

  var fixedNode = Object(__WEBPACK_IMPORTED_MODULE_5__isFixed__["a" /* default */])(dom);
  var scrollNode = Object(__WEBPACK_IMPORTED_MODULE_6__isSetOverflow__["a" /* default */])(dom);
  var scrollInfo = Object(__WEBPACK_IMPORTED_MODULE_2_get_scroll_info__["a" /* default */])();

  var cookScrollInfo = Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_objectSpread__["a" /* default */])({}, scrollInfo);

  if (fixedNode) {
    var fixedScrollInfo = Object(__WEBPACK_IMPORTED_MODULE_2_get_scroll_info__["a" /* default */])(fixedNode);
    cookScrollInfo.top = fixedScrollInfo.top;
    cookScrollInfo.right = scrollInfo.scrollNodeWidth;
    cookScrollInfo.bottom = scrollInfo.scrollNodeHeight;
    cookScrollInfo.left = fixedScrollInfo.left;
  } else if (scrollNode) {
    var scrollNodeScrollInfo = Object(__WEBPACK_IMPORTED_MODULE_2_get_scroll_info__["a" /* default */])(scrollNode);
    cookScrollInfo.top += scrollNodeScrollInfo.top;
    cookScrollInfo.right += scrollNodeScrollInfo.left;
    cookScrollInfo.bottom += scrollNodeScrollInfo.top;
    cookScrollInfo.left += scrollNodeScrollInfo.left;
  }

  var domInfo = Object(__WEBPACK_IMPORTED_MODULE_4__isOnScreen__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3_getoffset__["a" /* default */])(dom, fixedNode), cookScrollInfo);
  domInfo.fixedNode = fixedNode;
  domInfo.scrollNode = scrollNode;

  if (!domInfo.isOnScreen) {
    console.warn('Dom is not in screen', {
      dom: dom,
      domInfo: domInfo,
      scrollInfo: scrollInfo,
      cookScrollInfo: cookScrollInfo
    });
    return false;
  }

  var result = Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_objectSpread__["a" /* default */])({
    domInfo: domInfo,
    scrollInfo: scrollInfo
  }, calWindowOffset(domInfo, cookScrollInfo));

  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (getWindowOffset);

/***/ }),

/***/ "./node_modules/get-window-offset/build/es/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindowOffset__ = __webpack_require__("./node_modules/get-window-offset/build/es/src/getWindowOffset.js");
/* unused harmony reexport default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alignUI__ = __webpack_require__("./node_modules/get-window-offset/build/es/src/alignUI.js");
/* unused harmony reexport alignUI */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getPositionString__ = __webpack_require__("./node_modules/get-window-offset/build/es/src/getPositionString.js");
/* unused harmony reexport getPositionString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isOnScreen__ = __webpack_require__("./node_modules/get-window-offset/build/es/src/isOnScreen.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__isOnScreen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isFixed__ = __webpack_require__("./node_modules/get-window-offset/build/es/src/isFixed.js");
/* unused harmony reexport isFixed */







/***/ }),

/***/ "./node_modules/get-window-offset/build/es/src/isFixed.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_get_style__ = __webpack_require__("./node_modules/get-style/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_get_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_get_style__);


var isFixed = function isFixed(node) {
  if (!document.body.contains(node)) {
    console.warn(['Dom not exists in body', node]);
    return false;
  }

  var thisParent = node;

  while (thisParent.nodeName != 'BODY') {
    var position = __WEBPACK_IMPORTED_MODULE_0_get_style___default()(thisParent, 'position');

    if ('fixed' === position) {
      return thisParent;
    }

    thisParent = thisParent.parentNode;
  }

  return false;
};

/* harmony default export */ __webpack_exports__["a"] = (isFixed);

/***/ }),

/***/ "./node_modules/get-window-offset/build/es/src/isFullOnScreen.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isFullOnScreen = function isFullOnScreen(domInfo, scrollInfo) {
  var bool = domInfo.top > scrollInfo.top && domInfo.right < scrollInfo.right && domInfo.bottom < scrollInfo.bottom && domInfo.left > scrollInfo.left;
  return bool;
};

/* harmony default export */ __webpack_exports__["a"] = (isFullOnScreen);

/***/ }),

/***/ "./node_modules/get-window-offset/build/es/src/isOnScreen.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isOnScreen = function isOnScreen(domInfo, scrollInfo) {
  var margin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  domInfo.atTop = domInfo.bottom <= scrollInfo.top + margin;
  domInfo.atRight = domInfo.left >= scrollInfo.right - margin;
  domInfo.atBottom = domInfo.top >= scrollInfo.bottom - margin;
  domInfo.atLeft = domInfo.right <= scrollInfo.left + margin;
  domInfo.isOnScreen = !(domInfo.atTop || domInfo.atRight || domInfo.atBottom || domInfo.atLeft);
  return domInfo;
};

/* harmony default export */ __webpack_exports__["a"] = (isOnScreen);

/***/ }),

/***/ "./node_modules/get-window-offset/build/es/src/isSetOverflow.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_get_style__ = __webpack_require__("./node_modules/get-style/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_get_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_get_style__);


var isSetOverflow = function isSetOverflow(node) {
  if (!document.body.contains(node)) {
    console.warn(['Dom not exists in body', node]);
    return false;
  }

  var thisParent = node;

  while (thisParent.nodeName != 'BODY') {
    var overflowX = __WEBPACK_IMPORTED_MODULE_0_get_style___default()(thisParent, 'overflow-x');
    var overflowY = __WEBPACK_IMPORTED_MODULE_0_get_style___default()(thisParent, 'overflow-y');

    if ('visible' !== overflowY || 'visible' !== overflowX) {
      return thisParent;
    }

    thisParent = thisParent.parentNode;
  }

  return false;
};

/* harmony default export */ __webpack_exports__["a"] = (isSetOverflow);

/***/ }),

/***/ "./node_modules/get-window-offset/build/es/src/positions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var positions = {
  TL: 'tl',
  TC: 'tc',
  TR: 'tr',
  RT: 'rt',
  RC: 'rc',
  RB: 'rb',
  BL: 'bl',
  BC: 'bc',
  BR: 'br',
  LT: 'lt',
  LC: 'lc',
  LB: 'lb',
  CC: 'cc'
};
/* harmony default export */ __webpack_exports__["a"] = (positions);

/***/ }),

/***/ "./node_modules/getoffset/build/es/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mouse */
/* unused harmony export toSvgXY */
/* unused harmony export getSvgMatrixXY */
/* unused harmony export unifyTouch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_typeof__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/typeof.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_get_scroll_info__ = __webpack_require__("./node_modules/get-scroll-info/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_get_object_value__ = __webpack_require__("./node_modules/get-object-value/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reshow_constant__ = __webpack_require__("./node_modules/reshow-constant/build/es/index.js");





var unifyTouch = function unifyTouch(e) {
  return e && e.changedTouches ? Object(__WEBPACK_IMPORTED_MODULE_2_get_object_value__["a" /* default */])(e, ['changedTouches', 0]) : e;
};

var mouse = function mouse(e, dom, scrollNode) {
  if (!dom) {
    dom = e.currentTarget || e.target;
  }

  e = unifyTouch(e);
  var x = e.clientX;
  var y = e.clientY;
  var svgXY = toSvgXY(dom)(x, y);

  if (false !== svgXY) {
    var svgX = svgXY.x,
        svgY = svgXY.y;
    return [svgX, svgY];
  } else {
    var domXY = getOffset(dom, scrollNode);
    return [x - domXY.left - dom.clientLeft, y - domXY.top - dom.clientTop];
  }
};

var toSvgXY = function toSvgXY(dom, zoom) {
  return function (x, y) {
    var svg = dom.ownerSVGElement || dom;

    if (svg.createSVGPoint) {
      var point = svg.createSVGPoint();
      point.x = x;
      point.y = y;
      point = point.matrixTransform(dom.getScreenCTM().inverse());
      return getZoomXY(zoom)(point.x, point.y);
    } else {
      return false;
    }
  };
};

var getSvgMatrixXY = function getSvgMatrixXY(dom, zoom) {
  return function (x, y) {
    var svg = dom.ownerSVGElement || dom;

    if (svg.getScreenCTM) {
      var _dom$getScreenCTM = dom.getScreenCTM(),
          a = _dom$getScreenCTM.a,
          b = _dom$getScreenCTM.b,
          c = _dom$getScreenCTM.c,
          d = _dom$getScreenCTM.d,
          e = _dom$getScreenCTM.e,
          f = _dom$getScreenCTM.f;

      var _svg$getBoundingClien = svg.getBoundingClientRect(),
          left = _svg$getBoundingClien.left,
          top = _svg$getBoundingClien.top;

      var svgX = a * x + c * y + e - left;
      var svgY = b * x + d * y + f - top;
      return getZoomXY(zoom)(svgX, svgY);
    }
  };
};

var getZoomXY = function getZoomXY(zoom) {
  return function (x, y) {
    if (!zoom) {
      return {
        x: x,
        y: y
      };
    }

    var zoomK = Object(__WEBPACK_IMPORTED_MODULE_2_get_object_value__["a" /* default */])(zoom, ['k'], 1);
    var zoomX = Object(__WEBPACK_IMPORTED_MODULE_2_get_object_value__["a" /* default */])(zoom, ['x'], 0);
    var zoomY = Object(__WEBPACK_IMPORTED_MODULE_2_get_object_value__["a" /* default */])(zoom, ['y'], 0);
    var zx = (x - zoomX) / zoomK;
    var zy = (y - zoomY) / zoomK;
    return {
      x: zx,
      y: zy
    };
  };
};

var getRectWithElOffset = function getRectWithElOffset(dom) {
  var top = 0;
  var left = 0;
  var el = dom;

  do {
    var offsetTop = el.offsetTop || 0;
    var offsetLeft = el.offsetLeft || 0;

    if ('BODY' === el.nodeName) {
      top += offsetTop;
      left += offsetLeft;
    } else {
      top += offsetTop - el.scrollTop;
      left += offsetLeft - el.scrollLeft;
    }

    el = el.offsetParent;
  } while (el);

  return {
    top: top,
    left: left
  };
};

var getOffset = function getOffset(dom, scrollNode) {
  var top = 0;
  var left = 0;
  var w;
  var h;
  var scrollInfo = 0 === scrollNode ? {
    top: 0,
    left: 0
  } : Object(__WEBPACK_IMPORTED_MODULE_1_get_scroll_info__["a" /* default */])(scrollNode);

  if (__WEBPACK_IMPORTED_MODULE_3_reshow_constant__["e" /* UNDEFINED */] !== (typeof SVGElement === "undefined" ? "undefined" : Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_typeof__["a" /* default */])(SVGElement)) && dom instanceof SVGElement) {
    var rect = dom.getBoundingClientRect();
    top = rect.top + scrollInfo.top;
    left = rect.left + scrollInfo.left;
    w = rect.width;
    h = rect.height;
  } else {
    w = dom.offsetWidth;
    h = dom.offsetHeight;

    if (dom.getBoundingClientRect) {
      var _rect = dom.getBoundingClientRect();

      top = parseInt(_rect.top + scrollInfo.top, 10);
      left = parseInt(_rect.left + scrollInfo.left, 10);
    } else {
      var rectOffset = getRectWithElOffset(dom);
      top = rectOffset.top;
      left = rectOffset.left;
    }
  }

  var result = {
    w: w,
    h: h,
    width: w,
    height: h,
    top: top,
    right: left + w,
    bottom: top + h,
    left: left
  };
  return result;
};


/* harmony default export */ __webpack_exports__["a"] = (getOffset);

/***/ }),

/***/ "./node_modules/hedron/dist/hedron.js":
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? factory(exports, __webpack_require__("./node_modules/react/index.js"), __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js")) :
	typeof define === 'function' && define.amd ? define(['exports', 'react', 'styled-components'], factory) :
	(factory((global.hedron = global.hedron || {}),global.React,global.styled));
}(this, (function (exports,React,styled) { 'use strict';

var React__default = 'default' in React ? React['default'] : React;
var styled__default = 'default' in styled ? styled['default'] : styled;

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction$1 = function emptyFunction$1() {};

emptyFunction$1.thatReturns = makeEmptyFunction;
emptyFunction$1.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction$1.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction$1.thatReturnsNull = makeEmptyFunction(null);
emptyFunction$1.thatReturnsThis = function () {
  return this;
};
emptyFunction$1.thatReturnsArgument = function (arg) {
  return arg;
};

var emptyFunction_1 = emptyFunction$1;

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

{
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant$1(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var invariant_1 = invariant$1;

var emptyFunction$2 = emptyFunction_1;

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning$1 = emptyFunction$2;

{
  (function () {
    var printWarning = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning$1 = function warning$1(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning.apply(undefined, [format].concat(args));
      }
    };
  })();
}

var warning_1 = warning$1;

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

var ReactPropTypesSecret$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;

{
  var invariant$2 = invariant_1;
  var warning$2 = warning_1;
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant$2(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        warning$2(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning$2(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

var checkPropTypes_1 = checkPropTypes$1;

var emptyFunction = emptyFunction_1;
var invariant = invariant_1;
var warning = warning_1;

var ReactPropTypesSecret = ReactPropTypesSecret_1;
var checkPropTypes = checkPropTypes_1;

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if ("development" !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.');
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.');
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var index = createCommonjsModule(function (module) {
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

{
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
}
});

// Divvy is a function for dividing up a grid.
// divvy(12, 6) returns: (100 / 12) * 6
// This can then be used by the grid system.
// i.e. width: ${divvy(12, 4)};
var divvy = function () {
  var divisions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;
  var span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  return 100 / divisions * span;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



var set = function set(object, property, value, receiver) {
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent !== null) {
      set(parent, property, value, receiver);
    }
  } else if ("value" in desc && desc.writable) {
    desc.value = value;
  } else {
    var setter = desc.set;

    if (setter !== undefined) {
      setter.call(receiver, value);
    }
  }

  return value;
};





var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var _templateObject$3 = taggedTemplateLiteral(['\n  @media (min-width: ', 'px) {\n    ', '\n  }'], ['\n  @media (min-width: ', 'px) {\n    ', '\n  }']);

var defaultBreakpoints = {
  sm: 500,
  md: 768,
  lg: 1100
};

var query = function query(size) {
  var breakpoints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultBreakpoints;
  return function () {
    return styled.css(_templateObject$3, breakpoints[size] || defaultBreakpoints[size], styled.css.apply(undefined, arguments));
  };
};

var media = Object.keys(defaultBreakpoints).reduce(function (acc, label) {
  var accumulator = acc;
  accumulator[label] = function (breakpoints) {
    return query(label, breakpoints);
  };
  return accumulator;
}, {});

var _templateObject$4 = taggedTemplateLiteral(['', ''], ['', '']);

var breakpoint = function breakpoint(name, getStyle) {
  return function (props) {
    return media[name] ? media[name](props.breakpoints)(_templateObject$4, function (props) {
      return getStyle(props, name);
    }) : getStyle(props, name);
  };
};

/* globals ReactClass */
// This is an undocumented utility that is subject to change.
// Please do not use this externally. Eventually I will likely
// expose it once it's been cleaned and made reusable.
//
// The passOn function applies a specific set of properties
// to the children components. It will only apply the props
// to a component type that exists in the ofTypes array.
var passOn = function (children, ofTypes) {
  var process = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (r) {
    return r;
  };

  var response = React__default.Children.map(children,
  // Check to see if the child's component type is whitelisted,
  // and then process it.
  function (child) {
    return React__default.isValidElement(child) && ofTypes.indexOf(child.type) !== -1 ? React__default.cloneElement(child, process(child)) : child;
  });
  return response;
};



var index$1 = Object.freeze({
	divvy: divvy,
	media: media,
	defaultBreakpoints: defaultBreakpoints,
	breakpoint: breakpoint,
	passOn: passOn
});

/* globals ReactClass */
var breakpointsShape = index.shape({
  sm: index.number,
  md: index.number,
  lg: index.number
});

var BreakpointProvider = function (_Component) {
  inherits(BreakpointProvider, _Component);

  function BreakpointProvider() {
    classCallCheck(this, BreakpointProvider);
    return possibleConstructorReturn(this, (BreakpointProvider.__proto__ || Object.getPrototypeOf(BreakpointProvider)).apply(this, arguments));
  }

  createClass(BreakpointProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _props$breakpoints = this.props.breakpoints,
          propsBreakpoints = _props$breakpoints === undefined ? {} : _props$breakpoints;
      var _context$breakpoints = this.context.breakpoints,
          contextBreakpoints = _context$breakpoints === undefined ? {} : _context$breakpoints;


      return {
        breakpoints: _extends({}, defaultBreakpoints, contextBreakpoints, propsBreakpoints)
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return React.Children.only(this.props.children);
    }
  }]);
  return BreakpointProvider;
}(React.Component);

BreakpointProvider.propTypes = {
  children: index.node,
  breakpoints: breakpointsShape
};
BreakpointProvider.contextTypes = {
  breakpoints: breakpointsShape
};
BreakpointProvider.childContextTypes = {
  breakpoints: breakpointsShape
};
var withBreakpoints = function withBreakpoints(WrappedComponent
// eslint-disable-next-line react/no-multi-comp
) {
  var _class, _temp;

  return _temp = _class = function (_Component2) {
    inherits(Breakpoints, _Component2);

    function Breakpoints() {
      classCallCheck(this, Breakpoints);
      return possibleConstructorReturn(this, (Breakpoints.__proto__ || Object.getPrototypeOf(Breakpoints)).apply(this, arguments));
    }

    createClass(Breakpoints, [{
      key: 'render',
      value: function render() {
        var breakpoints = this.context.breakpoints;


        return React__default.createElement(WrappedComponent, _extends({}, this.props, { breakpoints: breakpoints }));
      } // eslint-disable-line  react/prefer-stateless-function

    }]);
    return Breakpoints;
  }(React.Component), _class.contextTypes = {
    breakpoints: breakpointsShape
  }, _temp;
};

var _templateObject$2 = taggedTemplateLiteral(['\n  ', '\n  ', '\n  ', '\n  ', '\n'], ['\n  ', '\n  ', '\n  ', '\n  ', '\n']);

/* eslint-disable no-unused-vars */
function HiddenContainer(props) {
  var children = props.children,
      debug = props.debug,
      xs = props.xs,
      sm = props.sm,
      md = props.md,
      lg = props.lg,
      breakpoints = props.breakpoints,
      rest = objectWithoutProperties(props, ['children', 'debug', 'xs', 'sm', 'md', 'lg', 'breakpoints']);

  var newChildren = passOn(children, [Row, Column$1], function (child) {
    return {
      debug: typeof child.props.debug === 'undefined' ? debug : child.props.debug
    };
  });
  return React__default.createElement(
    'div',
    rest,
    newChildren
  );
}

HiddenContainer.propTypes = {
  children: __webpack_require__("./node_modules/prop-types/index.js").node,
  debug: __webpack_require__("./node_modules/prop-types/index.js").bool,
  xs: __webpack_require__("./node_modules/prop-types/index.js").bool,
  sm: __webpack_require__("./node_modules/prop-types/index.js").bool,
  md: __webpack_require__("./node_modules/prop-types/index.js").bool,
  lg: __webpack_require__("./node_modules/prop-types/index.js").bool,
  breakpoints: __webpack_require__("./node_modules/prop-types/index.js").object
};
var compute$1 = function compute$1(name) {
  return breakpoint(name, function (props, name) {
    return 'display:' + (props[name] ? 'none' : 'inherit') + ';';
  });
};

var Hidden = styled__default(HiddenContainer)(_templateObject$2, compute$1('xs'), compute$1('sm'), compute$1('md'), compute$1('lg'));

var Hidden$1 = withBreakpoints(Hidden);

var _templateObject$1 = taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n'], ['\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n']);

/* eslint-disable no-unused-vars */
function RowContainer(props) {
  var children = props.children,
      tagName = props.tagName,
      debug = props.debug,
      divisions = props.divisions,
      theme = props.theme,
      alignContent = props.alignContent,
      alignItems = props.alignItems,
      alignSelf = props.alignSelf,
      justifyContent = props.justifyContent,
      order = props.order,
      rest = objectWithoutProperties(props, ['children', 'tagName', 'debug', 'divisions', 'theme', 'alignContent', 'alignItems', 'alignSelf', 'justifyContent', 'order']);

  var newChildren = passOn(children, [Column$1, Hidden$1], function (child) {
    return {
      debug: typeof child.props.debug === 'undefined' ? debug : child.props.debug,
      divisions: divisions
    };
  });
  return React__default.createElement(tagName || 'section', rest, newChildren);
}

RowContainer.propTypes = {
  children: __webpack_require__("./node_modules/prop-types/index.js").node,
  className: __webpack_require__("./node_modules/prop-types/index.js").string,
  debug: __webpack_require__("./node_modules/prop-types/index.js").bool,
  tagName: __webpack_require__("./node_modules/prop-types/index.js").string,
  theme: __webpack_require__("./node_modules/prop-types/index.js").object,
  divisions: __webpack_require__("./node_modules/prop-types/index.js").number,
  alignContent: __webpack_require__("./node_modules/prop-types/index.js").string,
  alignItems: __webpack_require__("./node_modules/prop-types/index.js").string,
  alignSelf: __webpack_require__("./node_modules/prop-types/index.js").string,
  justifyContent: __webpack_require__("./node_modules/prop-types/index.js").string,
  order: __webpack_require__("./node_modules/prop-types/index.js").string
};
RowContainer.defaultProps = {
  divisions: 12
};

var ifDefined = function ifDefined(prop) {
  var css$$1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prop;
  return function (props) {
    return props[prop] ? css$$1 + ': ' + props[prop] : '';
  };
};

var Row = styled__default(RowContainer)(_templateObject$1, ifDefined('alignContent', 'align-content'), ifDefined('alignItems', 'align-items'), ifDefined('alignSelf', 'align-self'), ifDefined('justifyContent', 'justify-content'), ifDefined('order'));

var _templateObject = taggedTemplateLiteral(['\n  display: block;\n  ', '\n  box-sizing: border-box;\n  padding: ', ';\n  width: 100%;\n  ', '\n  ', '\n  ', '\n  ', '\n'], ['\n  display: block;\n  ', '\n  box-sizing: border-box;\n  padding: ', ';\n  width: 100%;\n  ', '\n  ', '\n  ', '\n  ', '\n']);

/* eslint-disable no-unused-vars */
function ColumnContainer(props) {
  var children = props.children,
      tagName = props.tagName,
      debug = props.debug,
      divisions = props.divisions,
      fluid = props.fluid,
      xs = props.xs,
      sm = props.sm,
      md = props.md,
      lg = props.lg,
      theme = props.theme,
      xsShift = props.xsShift,
      smShift = props.smShift,
      mdShift = props.mdShift,
      lgShift = props.lgShift,
      breakpoints = props.breakpoints,
      rest = objectWithoutProperties(props, ['children', 'tagName', 'debug', 'divisions', 'fluid', 'xs', 'sm', 'md', 'lg', 'theme', 'xsShift', 'smShift', 'mdShift', 'lgShift', 'breakpoints']);

  var newChildren = passOn(children, [Row], function (child) {
    return {
      debug: typeof child.props.debug === 'undefined' ? debug : child.props.debug
    };
  });
  return React__default.createElement(tagName || 'div', rest, newChildren);
}

ColumnContainer.propTypes = {
  children: __webpack_require__("./node_modules/prop-types/index.js").node,
  className: __webpack_require__("./node_modules/prop-types/index.js").string,
  tagName: __webpack_require__("./node_modules/prop-types/index.js").string,
  theme: __webpack_require__("./node_modules/prop-types/index.js").object,
  debug: __webpack_require__("./node_modules/prop-types/index.js").bool,
  divisions: __webpack_require__("./node_modules/prop-types/index.js").number,
  fluid: __webpack_require__("./node_modules/prop-types/index.js").bool,
  xs: __webpack_require__("./node_modules/prop-types/index.js").number,
  sm: __webpack_require__("./node_modules/prop-types/index.js").number,
  md: __webpack_require__("./node_modules/prop-types/index.js").number,
  lg: __webpack_require__("./node_modules/prop-types/index.js").number,
  xsShift: __webpack_require__("./node_modules/prop-types/index.js").number,
  smShift: __webpack_require__("./node_modules/prop-types/index.js").number,
  mdShift: __webpack_require__("./node_modules/prop-types/index.js").number,
  lgShift: __webpack_require__("./node_modules/prop-types/index.js").number,
  breakpoints: __webpack_require__("./node_modules/prop-types/index.js").object
};
ColumnContainer.defaultProps = {
  divisions: 12
};

var compute = function compute(name) {
  return breakpoint(name, function (props, name) {
    return function (divisions, size, shift) {
      return '\n      ' + (size ? 'width: ' + divvy(divisions, size) + '%;' : '') + '\n      ' + (shift ? 'margin-left: ' + divvy(divisions, shift) + '%;' : '') + '\n    ';
    }(props.divisions, props[name], props[name + 'Shift']);
  });
};

var Column = styled__default(ColumnContainer)(_templateObject, function (props) {
  return props.debug ? 'background-color: rgba(50, 50, 255, .1);\n       outline: 1px solid #fff;' : '';
}, function (props) {
  return props.fluid ? '0' : '20px';
}, compute('xs'), compute('sm'), compute('md'), compute('lg'));

var Column$1 = withBreakpoints(Column);

var _templateObject$5 = taggedTemplateLiteral(['\n  ', '\n'], ['\n  ', '\n']);

/* eslint-disable no-unused-vars */
function PageContainer(props) {
  var children = props.children,
      tagName = props.tagName,
      debug = props.debug,
      fluid = props.fluid,
      rest = objectWithoutProperties(props, ['children', 'tagName', 'debug', 'fluid']);

  var newChildren = passOn(children, [Row, Hidden$1], function (child) {
    return {
      debug: typeof child.props.debug === 'undefined' ? debug : child.props.debug
    };
  });
  return React__default.createElement(tagName || 'div', rest, newChildren);
}

PageContainer.propTypes = {
  children: __webpack_require__("./node_modules/prop-types/index.js").node,
  className: __webpack_require__("./node_modules/prop-types/index.js").string,
  tagName: __webpack_require__("./node_modules/prop-types/index.js").string,
  debug: __webpack_require__("./node_modules/prop-types/index.js").bool,
  fluid: __webpack_require__("./node_modules/prop-types/index.js").bool,
  width: __webpack_require__("./node_modules/prop-types/index.js").string
};
var Page = styled__default(PageContainer)(_templateObject$5, function (props) {
  return props.fluid ? 'width: 100%;' : '\n      margin: 0 auto;\n      max-width: 100%;\n      ' + (props.width ? 'width: ' + props.width + ';' : 'width: 960px;') + '\n    ';
});

exports.Column = Column$1;
exports.Page = Page;
exports.Row = Row;
exports.Hidden = Hidden$1;
exports.BreakpointProvider = BreakpointProvider;
exports.withBreakpoints = withBreakpoints;
exports.utils = index$1;

Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),

/***/ "./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__("./node_modules/react-is/index.js");
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ "./node_modules/html-dom-parser/lib/domparser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module dependencies.
 */
var utilities = __webpack_require__("./node_modules/html-dom-parser/lib/utilities.js");
var detectIE = utilities.isIE;

/**
 * Constants.
 */
var HTML_TAG_NAME = 'html';
var BODY_TAG_NAME = 'body';
var HEAD_TAG_NAME = 'head';
var FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>
var HEAD_REGEX = /<\/head>/i;
var BODY_REGEX = /<\/body>/i;
// http://www.w3.org/TR/html/syntax.html#void-elements
var VOID_ELEMENTS_REGEX = /<(area|base|br|col|embed|hr|img|input|keygen|link|menuitem|meta|param|source|track|wbr)(.*?)\/?>/gi;

// browser support
var isIE = detectIE();
var isIE9 = detectIE(9);

/**
 * DOMParser (performance: slow).
 *
 * https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
 */
var parseFromString;
if (typeof window.DOMParser === 'function') {
    var domParser = new window.DOMParser();
    // IE9 does not support 'text/html' MIME type
    // https://msdn.microsoft.com/en-us/library/ff975278(v=vs.85).aspx
    var MIME_TYPE = isIE9 ? 'text/xml' : 'text/html';

    /**
     * Creates an HTML document using `DOMParser.parseFromString`.
     *
     * @param  {String} html      - The HTML string.
     * @param  {String} [tagName] - The element to render the HTML (with 'body' as fallback).
     * @return {HTMLDocument}
     */
    parseFromString = function domStringParser(html, tagName) {
        if (tagName) {
            html = ['<', tagName, '>', html, '</', tagName, '>'].join('');
        }
        // because IE9 only supports MIME type 'text/xml', void elements need to be self-closed
        if (isIE9) {
            html = html.replace(VOID_ELEMENTS_REGEX, '<$1$2$3/>');
        }
        return domParser.parseFromString(html, MIME_TYPE);
    };
}

/**
 * DOMImplementation (performance: fair).
 *
 * https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
 */
var parseFromDocument;
if (typeof document.implementation === 'object') {
    // title parameter is required in IE
    // https://msdn.microsoft.com/en-us/library/ff975457(v=vs.85).aspx
    var doc = document.implementation.createHTMLDocument(isIE ? 'HTML_DOM_PARSER_TITLE' : undefined);

    /**
     * Use HTML document created by `document.implementation.createHTMLDocument`.
     *
     * @param  {String} html      - The HTML string.
     * @param  {String} [tagName] - The element to render the HTML (with 'body' as fallback).
     * @return {HTMLDocument}
     */
    parseFromDocument = function createHTMLDocument(html, tagName) {
        if (tagName) {
            doc.documentElement.getElementsByTagName(tagName)[0].innerHTML = html;
            return doc;
        }

        try {
            doc.documentElement.innerHTML = html;
            return doc;
        // fallback when certain elements in `documentElement` are read-only (IE9)
        } catch (err) {
            if (parseFromString) return parseFromString(html);
        }
    };
}

/**
 * Template (performance: fast).
 *
 * https://developer.mozilla.org/docs/Web/HTML/Element/template
 */
var parseFromTemplate;
var template = document.createElement('template');
if (template.content) {

    /**
     * Uses a template element (content fragment) to parse HTML.
     *
     * @param  {String} html - The HTML string.
     * @return {NodeList}
     */
    parseFromTemplate = function templateParser(html) {
        template.innerHTML = html;
        return template.content.childNodes;
    };
}

/** Fallback document parser. */
var parseWithFallback = parseFromDocument || parseFromString;

/**
 * Parses HTML string to DOM nodes.
 *
 * @param  {String} html      - The HTML string.
 * @param  {String} [tagName] - The tag name.
 * @return {NodeList|Array}
 */
module.exports = function domparser(html) {
    // try to match first tag
    var tagName;
    var match = html.match(FIRST_TAG_REGEX);
    if (match && match[1]) {
        tagName = match[1].toLowerCase();
    }

    var doc;
    var element;
    var elements;

    switch (tagName) {
        case HTML_TAG_NAME:
            if (parseFromString) {
                doc = parseFromString(html);

                // the created document may come with filler head/body elements,
                // so ake sure to remove them if they don't actually exist
                if (!HEAD_REGEX.test(html)) {
                    element = doc.getElementsByTagName(HEAD_TAG_NAME)[0];
                    if (element) element.parentNode.removeChild(element);
                }
                if (!BODY_REGEX.test(html)) {
                    element = doc.getElementsByTagName(BODY_TAG_NAME)[0];
                    if (element) element.parentNode.removeChild(element);
                }

                return doc.getElementsByTagName(HTML_TAG_NAME);
            }
            break;

        case HEAD_TAG_NAME:
            if (parseWithFallback) {
                elements = parseWithFallback(html).getElementsByTagName(HEAD_TAG_NAME);

                // account for possibility of sibling
                if (BODY_REGEX.test(html)) {
                    return elements[0].parentNode.childNodes;
                }
                return elements;
            }
            break;

        case BODY_TAG_NAME:
            if (parseWithFallback) {
                elements = parseWithFallback(html).getElementsByTagName(BODY_TAG_NAME);

                // account for possibility of sibling (return both body and head)
                if (HEAD_REGEX.test(html)) {
                    return elements[0].parentNode.childNodes;
                }
                return elements;
            }
            break;

        // low-level tag or text
        default:
            if (parseFromTemplate) return parseFromTemplate(html);
            if (parseWithFallback) {
                return parseWithFallback(html, BODY_TAG_NAME).getElementsByTagName(BODY_TAG_NAME)[0].childNodes;
            }
            break;
    }

    return [];
};


/***/ }),

/***/ "./node_modules/html-dom-parser/lib/html-to-dom-client.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module dependencies.
 */
var domparser = __webpack_require__("./node_modules/html-dom-parser/lib/domparser.js");
var utilities = __webpack_require__("./node_modules/html-dom-parser/lib/utilities.js");
var formatDOM = utilities.formatDOM;
var isIE9 = utilities.isIE(9);

/**
 * Constants.
 */
var DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>

/**
 * Parses HTML and reformats DOM nodes output.
 *
 * @param  {String} html - The HTML string.
 * @return {Array}       - The formatted DOM nodes.
 */
module.exports = function parseDOM(html) {
    if (typeof html !== 'string') {
        throw new TypeError('First argument must be a string.');
    }
    if (!html) return [];

    // match directive
    var match = html.match(DIRECTIVE_REGEX);
    var directive;
    if (match && match[1]) {
        directive = match[1];

        // remove directive in IE9 because DOMParser uses
        // MIME type 'text/xml' instead of 'text/html'
        if (isIE9) {
            html = html.replace(match[0], '');
        }
    }

    return formatDOM(domparser(html), null, directive);
};


/***/ }),

/***/ "./node_modules/html-dom-parser/lib/utilities.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Format DOM attributes to an associative array.
 *
 * @param  {NamedNodeMap} - The list of attributes.
 * @return {Object}       - The object of attributes.
 */
function formatAttributes(attributes) {
    var result = {};
    var attribute;

    // NamedNodeMap is array-like
    for (var i = 0, len = attributes.length; i < len; i++) {
        attribute = attributes[i];
        result[attribute.name] = attribute.value;
    }

    return result;
}

/**
 * Format the browser DOM nodes to mimic the output of `htmlparser2.parseDOM()`.
 *
 * @param  {NodeList} nodes        - The DOM nodes.
 * @param  {Object}   [parentObj]  - The formatted parent node.
 * @param  {String}   [directive]  - The directive.
 * @return {Object}                - The formatted DOM object.
 */
function formatDOM(nodes, parentObj, directive) {
    parentObj = parentObj || null;

    var result = [];
    var node;
    var prevNode;
    var nodeObj;

    // NodeList is array-like
    for (var i = 0, len = nodes.length; i < len; i++) {
        node = nodes[i];
        // reset
        nodeObj = {
            next: null,
            prev: result[i - 1] || null,
            parent: parentObj
        };

        // set the next node for the previous node (if applicable)
        prevNode = result[i - 1];
        if (prevNode) {
            prevNode.next = nodeObj;
        }

        // set the node name if it's not "#text" or "#comment"
        // e.g., "div"
        if (node.nodeName.indexOf('#') !== 0) {
            nodeObj.name = node.nodeName.toLowerCase();

            // also, nodes of type "tag" have "attribs"
            nodeObj.attribs = {}; // default
            if (node.attributes && node.attributes.length) {
                nodeObj.attribs = formatAttributes(node.attributes);
            }
        }

        // set the node type
        // e.g., "tag"
        switch (node.nodeType) {
            // 1 = element
            case 1:
                if (nodeObj.name === 'script' || nodeObj.name === 'style') {
                    nodeObj.type = nodeObj.name;
                } else {
                    nodeObj.type = 'tag';
                }
                // recursively format the children
                nodeObj.children = formatDOM(node.childNodes, nodeObj);
                break;
                // 2 = attribute
                // 3 = text
            case 3:
                nodeObj.type = 'text';
                nodeObj.data = node.nodeValue;
                break;
                // 8 = comment
            case 8:
                nodeObj.type = 'comment';
                nodeObj.data = node.nodeValue;
                break;
            default:
                break;
        }

        result.push(nodeObj);
    }

    if (directive) {
        result.unshift({
            name: directive.substring(0, directive.indexOf(' ')).toLowerCase(),
            data: directive,
            type: 'directive',
            next: result[0] ? result[0] : null,
            prev: null,
            parent: parentObj
        });

        if (result[1]) {
            result[1].prev = result[0];
        }
    }

    return result;
}

/**
 * Detect IE with or without version.
 *
 * @param  {Number} [version] - The IE version to detect.
 * @return {Boolean}          - Whether IE or the version has been detected.
 */
function isIE(version) {
    if (version) {
        return document.documentMode === version;
    }
    return /(MSIE |Trident\/|Edge\/)/.test(navigator.userAgent);
}

/**
 * Export utilities.
 */
module.exports = {
    formatAttributes: formatAttributes,
    formatDOM: formatDOM,
    isIE: isIE
};


/***/ }),

/***/ "./node_modules/html-react-parser/index.js":
/***/ (function(module, exports, __webpack_require__) {

var domToReact = __webpack_require__("./node_modules/html-react-parser/lib/dom-to-react.js");
var htmlToDOM = __webpack_require__("./node_modules/html-dom-parser/lib/html-to-dom-client.js");

// decode HTML entities by default for `htmlparser2`
var domParserOptions = { decodeEntities: true, lowerCaseAttributeNames: false };

/**
 * Convert HTML string to React elements.
 *
 * @param  {String}   html              - The HTML string.
 * @param  {Object}   [options]         - The additional options.
 * @param  {Function} [options.replace] - The replace method.
 * @return {ReactElement|Array}
 */
function HTMLReactParser(html, options) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string');
  }
  return domToReact(htmlToDOM(html, domParserOptions), options);
}

/**
 * Export HTML to React parser.
 */
module.exports = HTMLReactParser;


/***/ }),

/***/ "./node_modules/html-react-parser/lib/attributes-to-props.js":
/***/ (function(module, exports, __webpack_require__) {

var DOMProperty = __webpack_require__("./node_modules/react-dom-core/lib/DOMProperty.js");
var propertyConfig = __webpack_require__("./node_modules/html-react-parser/lib/property-config.js");
var styleToObject = __webpack_require__("./node_modules/style-to-object/index.js");
var utilities = __webpack_require__("./node_modules/html-react-parser/lib/utilities.js");

var config = propertyConfig.config;
var isCustomAttribute = propertyConfig.HTMLDOMPropertyConfig.isCustomAttribute;
DOMProperty.injection.injectDOMPropertyConfig(
  propertyConfig.HTMLDOMPropertyConfig
);

/**
 * Makes attributes compatible with React props.
 *
 * @param  {Object} attributes - The attributes.
 * @return {Object}            - The props.
 */
function attributesToProps(attributes) {
  attributes = attributes || {};
  var props = {};
  var propertyName;
  var propertyValue;
  var reactProperty;

  for (propertyName in attributes) {
    propertyValue = attributes[propertyName];

    // custom attributes (`data-` and `aria-`)
    if (isCustomAttribute(propertyName)) {
      props[propertyName] = propertyValue;
      continue;
    }

    // make HTML DOM attribute/property consistent with React attribute/property
    reactProperty = config.html[propertyName.toLowerCase()];
    if (reactProperty) {
      if (
        DOMProperty.properties.hasOwnProperty(reactProperty) &&
        DOMProperty.properties[reactProperty].hasBooleanValue
      ) {
        props[reactProperty] = true;
      } else {
        props[reactProperty] = propertyValue;
      }
      continue;
    }

    // make SVG DOM attribute/property consistent with React attribute/property
    reactProperty = config.svg[propertyName];
    if (reactProperty) {
      props[reactProperty] = propertyValue;
    }
  }

  // convert inline style to object
  if (attributes.style != null) {
    props.style = cssToJs(attributes.style);
  }
  return props;
}

/**
 * Converts CSS style string to JS style object.
 *
 * @param  {String} style - The CSS style.
 * @return {Object}       - The JS style object.
 */
function cssToJs(style) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string.');
  }
  var styleObj = {};

  styleToObject(style, function(propName, propValue) {
    // Check if it's not a comment node
    if (propName && propValue) {
      styleObj[utilities.camelCase(propName)] = propValue;
    }
  });
  return styleObj;
}

module.exports = attributesToProps;


/***/ }),

/***/ "./node_modules/html-react-parser/lib/dom-to-react.js":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("./node_modules/react/index.js");
var attributesToProps = __webpack_require__("./node_modules/html-react-parser/lib/attributes-to-props.js");

/**
 * Converts DOM nodes to React elements.
 *
 * @param  {Array}    nodes             - The DOM nodes.
 * @param  {Object}   [options]         - The additional options.
 * @param  {Function} [options.replace] - The replace method.
 * @return {ReactElement|Array}
 */
function domToReact(nodes, options) {
  options = options || {};
  var result = [];
  var node;
  var isReplacePresent = typeof options.replace === 'function';
  var replacement;
  var props;
  var children;

  for (var i = 0, len = nodes.length; i < len; i++) {
    node = nodes[i];

    // replace with custom React element (if applicable)
    if (isReplacePresent) {
      replacement = options.replace(node);

      if (React.isValidElement(replacement)) {
        // specify a "key" prop if element has siblings
        // https://fb.me/react-warning-keys
        if (len > 1) {
          replacement = React.cloneElement(replacement, { key: i });
        }
        result.push(replacement);
        continue;
      }
    }

    if (node.type === 'text') {
      result.push(node.data);
      continue;
    }

    // update values
    props = attributesToProps(node.attribs);
    children = null;

    // node type for <script> is "script"
    // node type for <style> is "style"
    if (node.type === 'script' || node.type === 'style') {
      // prevent text in <script> or <style> from being escaped
      // https://facebook.github.io/react/tips/dangerously-set-inner-html.html
      if (node.children[0]) {
        props.dangerouslySetInnerHTML = {
          __html: node.children[0].data
        };
      }
    } else if (node.type === 'tag') {
      // setting textarea value in children is an antipattern in React
      // https://reactjs.org/docs/forms.html#the-textarea-tag
      if (node.name === 'textarea' && node.children[0]) {
        props.defaultValue = node.children[0].data;

        // continue recursion of creating React elements (if applicable)
      } else if (node.children && node.children.length) {
        children = domToReact(node.children, options);
      }

      // skip all other cases (e.g., comment)
    } else {
      continue;
    }

    // specify a "key" prop if element has siblings
    // https://fb.me/react-warning-keys
    if (len > 1) {
      props.key = i;
    }

    result.push(React.createElement(node.name, props, children));
  }

  return result.length === 1 ? result[0] : result;
}

module.exports = domToReact;


/***/ }),

/***/ "./node_modules/html-react-parser/lib/property-config.js":
/***/ (function(module, exports, __webpack_require__) {

var HTMLDOMPropertyConfig = __webpack_require__("./node_modules/react-dom-core/lib/HTMLDOMPropertyConfig.js");
var SVGDOMPropertyConfig = __webpack_require__("./node_modules/react-dom-core/lib/SVGDOMPropertyConfig.js");
var utilities = __webpack_require__("./node_modules/html-react-parser/lib/utilities.js");

var config = {
  html: {},
  svg: {}
};

var propertyName;

/**
 * HTML DOM property config.
 *
 * https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
 */

// first map out the HTML attribute names
// e.g., { className: 'class' } => { 'class': 'className' }
config.html = utilities.invertObject(HTMLDOMPropertyConfig.DOMAttributeNames);

// then map out the rest of the HTML properties
// e.g., { readOnly: 0 } => { readonly: 'readOnly' }
for (propertyName in HTMLDOMPropertyConfig.Properties) {
  // lowercase to make matching property names easier
  config.html[propertyName.toLowerCase()] = propertyName;
}

/**
 * SVG DOM property config.
 *
 * https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/SVGDOMPropertyConfig.js
 */

// first map out the SVG attribute names
// e.g., { fontSize: 'font-size' } => { 'font-size': 'fontSize' }
config.svg = utilities.invertObject(SVGDOMPropertyConfig.DOMAttributeNames);

// then map out the rest of the SVG properties
// e.g., { fillRule: 0 } => { fillRule: 'fillRule' }
for (propertyName in SVGDOMPropertyConfig.Properties) {
  // do not lowercase as some svg properties are camel cased
  config.html[propertyName] = propertyName;
}

module.exports = {
  config: config,
  HTMLDOMPropertyConfig: HTMLDOMPropertyConfig,
  SVGDOMPropertyConfig: SVGDOMPropertyConfig
};


/***/ }),

/***/ "./node_modules/html-react-parser/lib/utilities.js":
/***/ (function(module, exports) {

var hyphenPatternRegex = /-([a-z])/g;

/**
 * Converts a string to camelCase.
 *
 * @param  {String} string - The string.
 * @return {String}
 */
function camelCase(string) {
  if (typeof string !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  // no hyphen found
  if (string.indexOf('-') === -1) {
    return string;
  }

  // convert to camelCase
  return string
    .toLowerCase()
    .replace(hyphenPatternRegex, function(_, character) {
      return character.toUpperCase();
    });
}

/**
 * Swap key with value in an object.
 *
 * @param  {Object}   obj        - The object.
 * @param  {Function} [override] - The override method.
 * @return {Object}              - The inverted object.
 */
function invertObject(obj, override) {
  if (!obj || typeof obj !== 'object') {
    throw new TypeError('First argument must be an object');
  }

  var key;
  var value;
  var isOverridePresent = typeof override === 'function';
  var overrides = {};
  var result = {};

  for (key in obj) {
    value = obj[key];

    if (isOverridePresent) {
      overrides = override(key, value);
      if (overrides && overrides.length === 2) {
        result[overrides[0]] = overrides[1];
        continue;
      }
    }

    if (typeof value === 'string') {
      result[value] = key;
    }
  }

  return result;
}

module.exports = {
  camelCase: camelCase,
  invertObject: invertObject
};


/***/ }),

/***/ "./node_modules/hyphenate-style-name/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ __webpack_exports__["a"] = (hyphenateStyleName);


/***/ }),

/***/ "./node_modules/ieee754/index.js":
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "./node_modules/immutable/dist/immutable.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.Immutable = factory());
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step !== 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      if (o !== o || o === Infinity) {
        return 0;
      }
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
      return emptyMap().withMutations(function(map ) {
        for (var i = 0; i < keyValues.length; i += 2) {
          if (i + 1 >= keyValues.length) {
            throw new Error('Missing value for key: ' + keyValues[i]);
          }
          map.set(keyValues[i], keyValues[i + 1]);
        }
      });
    };

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      if (end === Infinity) {
        end = originalSize;
      } else {
        end = end | 0;
      }
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      if (this._map && !this._map.has(k)) {
        var defaultVal = this._defaultValues[k];
        if (v === defaultVal) {
          return this;
        }
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findEntry: function(predicate, context, notSetValue) {
      var found = notSetValue;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    findLastEntry: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },

    findLastKey: function(predicate, context) {
      return this.toKeyedSeq().reverse().findKey(predicate, context);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    lastKeyOf: function(searchValue) {
      return this.toKeyedSeq().reverse().keyOf(searchValue);
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.lastKeyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var entry = this.findLastEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    keySeq: function() {
      return Range(0, this.size);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;
  SetIterable.prototype.contains = SetIterable.prototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),

/***/ "./node_modules/inherits/inherits_browser.js":
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),

/***/ "./node_modules/is-buffer/index.js":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),

/***/ "./node_modules/isarray/index.js":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "./node_modules/json2mq/index.js":
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__("./node_modules/string-convert/camel2hyphen.js");

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),

/***/ "./node_modules/jsonp/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var debug = __webpack_require__("./node_modules/jsonp/node_modules/debug/src/browser.js")('jsonp');

/**
 * Module exports.
 */

module.exports = jsonp;

/**
 * Callback index.
 */

var count = 0;

/**
 * Noop function.
 */

function noop(){}

/**
 * JSONP handler
 *
 * Options:
 *  - param {String} qs parameter (`callback`)
 *  - prefix {String} qs parameter (`__jp`)
 *  - name {String} qs parameter (`prefix` + incr)
 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
 *
 * @param {String} url
 * @param {Object|Function} optional options / callback
 * @param {Function} optional callback
 */

function jsonp(url, opts, fn){
  if ('function' == typeof opts) {
    fn = opts;
    opts = {};
  }
  if (!opts) opts = {};

  var prefix = opts.prefix || '__jp';

  // use the callback name that was passed if one was provided.
  // otherwise generate a unique name by incrementing our counter.
  var id = opts.name || (prefix + (count++));

  var param = opts.param || 'callback';
  var timeout = null != opts.timeout ? opts.timeout : 60000;
  var enc = encodeURIComponent;
  var target = document.getElementsByTagName('script')[0] || document.head;
  var script;
  var timer;


  if (timeout) {
    timer = setTimeout(function(){
      cleanup();
      if (fn) fn(new Error('Timeout'));
    }, timeout);
  }

  function cleanup(){
    if (script.parentNode) script.parentNode.removeChild(script);
    window[id] = noop;
    if (timer) clearTimeout(timer);
  }

  function cancel(){
    if (window[id]) {
      cleanup();
    }
  }

  window[id] = function(data){
    debug('jsonp got', data);
    cleanup();
    if (fn) fn(null, data);
  };

  // add qs component
  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
  url = url.replace('?&', '?');

  debug('jsonp req "%s"', url);

  // create script
  script = document.createElement('script');
  script.src = url;
  target.parentNode.insertBefore(script, target);

  return cancel;
}


/***/ }),

/***/ "./node_modules/jsonp/node_modules/debug/src/browser.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__("./node_modules/jsonp/node_modules/debug/src/debug.js");
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_CONTACT_FORM_MAIL_TO":"https://prod-11.westeurope.logic.azure.com:443/workflows/469daeb9e0814284944a6823e010e5a8/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=LDw4OCmhrzknYryf6NZR0l3HUvOO4sOrJ4KrLNKgQF4","REACT_APP_CONTACT_FORM_SUPPORT_MAIL_TO":"https://prod-16.westeurope.logic.azure.com:443/workflows/07509f2760d64838bdf665f7d4c46e93/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=RU0-XCUoC4Qpr8vUzhRzGqBG6tSvXSkO9nkxjqaxCPI","REACT_APP_DEBUG":"false","REACT_APP_GEOLOCATION_API":"https://ipinfo.io/json?token=ea4d0cf5569d7d","REACT_APP_NEWSLETTER":"https://zonifero-new-www-dev-linux-fap.azurewebsites.net/api/getResponse","REACT_APP_PIPEDRIVE":"https://thg-d-www-pipedrive-fap.azurewebsites.net/api/postnote?code=Ils3YzEnC4e_eucIqh-bmAFyZfiILKHctzHGfhApQ46-AzFun4AhSA%3D%3D","REACT_APP_PROXY_BASE_URL":"https://tender-cms-api.azurewebsites.net","REACT_APP_RECAPTCHA_SECRET_KEY":"6Ld2rL0kAAAAAMu9_rMrS0HMhPpbzlO9L11OpDSS","REACT_APP_RECAPTCHA_SITE_KEY":"6Ld2rL0kAAAAAPMldKss1yYJmpWfSil0UPlBBlqh","REACT_APP_SEARCH_CONSOLE_CODE":"vLvp2xQcuyTV0NJMTAfXrgRLTIvTQg3LC-PmKOg7rHo","REACT_APP_SECURITY_APP":"https://swh-p-spambotprot-fap.azurewebsites.net/api/SpamBotProtection","REACT_APP_TAG_MANAGER_ID":"GTM-KB24WRL"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/jsonp/node_modules/debug/src/debug.js":
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__("./node_modules/jsonp/node_modules/ms/index.js");

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ "./node_modules/jsonp/node_modules/ms/index.js":
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/client/delivery-client.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var query_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/index.js");
var sdk_info_generated_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/sdk-info.generated.js");
var services_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/services/index.js");
var parser_adapter_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/parser/parser-adapter.js");
var DeliveryClient = /** @class */ (function () {
    /**
    * Delivery client used to fetch data from Kentico Cloud
    * @constructor
    * @param {IDeliveryClientConfig} config - The client configuration
    */
    function DeliveryClient(config) {
        this.config = config;
        if (!config) {
            throw Error("Please provide Delivery client configuration");
        }
        this.queryService = new services_1.QueryService(config, new services_1.DeliveryHttpService(), parser_adapter_1.getParserAdapter(), {
            host: sdk_info_generated_1.sdkInfo.host,
            name: sdk_info_generated_1.sdkInfo.name,
            version: sdk_info_generated_1.sdkInfo.version
        });
    }
    /**
    * Gets query for multiple types
    */
    DeliveryClient.prototype.types = function () {
        return new query_1.MultipleTypeQuery(this.config, this.queryService);
    };
    /**
    * Gets query for single type
    * @param {string} typeCodename - Codename of the type to fetch
    */
    DeliveryClient.prototype.type = function (typeCodename) {
        return new query_1.SingleTypeQuery(this.config, this.queryService, typeCodename);
    };
    /**
    * Gets query for multiple items
    */
    DeliveryClient.prototype.items = function () {
        return new query_1.MultipleItemQuery(this.config, this.queryService);
    };
    /**
    * Gets query for single item
    * @param {string} codename - Codename of item to fetch
    */
    DeliveryClient.prototype.item = function (codename) {
        return new query_1.SingleItemQuery(this.config, this.queryService, codename);
    };
    /**
    * Gets query for single taxonomy
    * @param {string} codename - Codename of taxonomy to fetch
    */
    DeliveryClient.prototype.taxonomy = function (codename) {
        return new query_1.TaxonomyQuery(this.config, this.queryService, codename);
    };
    /**
    * Gets query for multiple taxonomies
    */
    DeliveryClient.prototype.taxonomies = function () {
        return new query_1.TaxonomiesQuery(this.config, this.queryService);
    };
    /**
     * Gets query for an element within a type
     * @param {string} typeCodename - Codename of the type
     * @param {string} elementCodename - Codename of the element
     */
    DeliveryClient.prototype.element = function (typeCodename, elementCodename) {
        return new query_1.ElementQuery(this.config, this.queryService, typeCodename, elementCodename);
    };
    return DeliveryClient;
}());
exports.DeliveryClient = DeliveryClient;
//# sourceMappingURL=delivery-client.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/client/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/client/delivery-client.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/fields/field-decorators.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
__webpack_require__("./node_modules/reflect-metadata/Reflect.js");
var FieldDecorators;
(function (FieldDecorators) {
    var codenameMetadataKey = Symbol('codename');
    var generateKey = function (name) {
        return codenameMetadataKey.toString() + ":" + name;
    };
    /**
     * Get the metadata entry saved by the decorator
     * @param target - object instance
     * @param fieldName - field name (code name from Kentico Cloud)
     */
    function getPropertyName(target, fieldName) {
        return Reflect.getMetadata(generateKey(fieldName), target);
    }
    FieldDecorators.getPropertyName = getPropertyName;
    /**
     * Decorator - reates metadata entry for the @target - Value is the property name.
     * This will then be retrieved in the FieldMap service when resolving the field name
     * @param value - field code name
     */
    function codename(value) {
        return function (target, propertyKey) {
            Reflect.defineMetadata(generateKey(value), propertyKey, target);
        };
    }
    FieldDecorators.codename = codename;
})(FieldDecorators = exports.FieldDecorators || (exports.FieldDecorators = {}));
//# sourceMappingURL=field-decorators.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/fields/field-models.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var FieldModels;
(function (FieldModels) {
    var AssetModel = /** @class */ (function () {
        /**
        * Represents Kentico Cloud's asset
        * @constructor
        * @param {string} name - Name of the asset
        * @param {string} type - Type of the asset
        * @param {number} size - Size of the asset
        * @param {string} description - Description of the asset
        * @param {string} url - Url of the asset
        */
        function AssetModel(name, type, size, description, url) {
            this.name = name;
            this.type = type;
            this.size = size;
            this.description = description;
            this.url = url;
        }
        return AssetModel;
    }());
    FieldModels.AssetModel = AssetModel;
    var MultipleChoiceOption = /** @class */ (function () {
        /**
        * Represents Kentico Cloud's multiple choice option
        * @constructor
        * @param {string} name - Name of the option
        * @param {string} codename - Codename of the option
        */
        function MultipleChoiceOption(name, codename) {
            this.name = name;
            this.codename = codename;
        }
        return MultipleChoiceOption;
    }());
    FieldModels.MultipleChoiceOption = MultipleChoiceOption;
    var TaxonomyTerm = /** @class */ (function () {
        /**
       * Represents taxonomy term
       * @constructor
       * @param {string} name - Name of the taxonomy option
       * @param {string} codename - Codename of the option
       */
        function TaxonomyTerm(name, codename) {
            this.name = name;
            this.codename = codename;
        }
        return TaxonomyTerm;
    }());
    FieldModels.TaxonomyTerm = TaxonomyTerm;
})(FieldModels = exports.FieldModels || (exports.FieldModels = {}));
//# sourceMappingURL=field-models.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/fields/field-type.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
/**
* Represents codename of Kentico Cloud field types
*/
var FieldType;
(function (FieldType) {
    FieldType["Text"] = "text";
    FieldType["Number"] = "number";
    FieldType["ModularContent"] = "modular_content";
    FieldType["Asset"] = "asset";
    FieldType["DateTime"] = "date_time";
    FieldType["RichText"] = "rich_text";
    FieldType["MultipleChoice"] = "multiple_choice";
    FieldType["UrlSlug"] = "url_slug";
    FieldType["Taxonomy"] = "taxonomy";
})(FieldType = exports.FieldType || (exports.FieldType = {}));
//# sourceMappingURL=field-type.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/fields/field-types.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var field_models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/fields/field-models.js");
var field_type_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/fields/field-type.js");
var Fields;
(function (Fields) {
    var TextField = /** @class */ (function () {
        /**
        * Represents text field of Kentico Cloud item
        * @constructor
        * @param {string} name - Name of the field
        * @param {string} value - Value of the field
        */
        function TextField(name, value) {
            this.name = name;
            this.value = value;
            /**
            * Type of the field
            */
            this.type = field_type_1.FieldType.Text;
            this.text = this.value;
        }
        return TextField;
    }());
    Fields.TextField = TextField;
    var MultipleChoiceField = /** @class */ (function () {
        /**
        * Represents multiple choice field of Kentico Cloud item
        * @constructor
        * @param {string} name - Name of the field
        * @param {string} value - Value of the field
        */
        function MultipleChoiceField(name, value) {
            var _this = this;
            this.name = name;
            this.value = value;
            /**
            * Multiple choice options
            */
            this.options = [];
            /**
            * Type of the field
            */
            this.type = field_type_1.FieldType.MultipleChoice;
            if (this.value && Array.isArray(this.value)) {
                this.value.forEach(function (option) {
                    var optionTemp = option;
                    _this.options.push(new field_models_1.FieldModels.MultipleChoiceOption(optionTemp.name, optionTemp.codename));
                });
            }
        }
        return MultipleChoiceField;
    }());
    Fields.MultipleChoiceField = MultipleChoiceField;
    var DateTimeField = /** @class */ (function () {
        /**
        * Represents date time field of Kentico Cloud item
        * @constructor
        * @param {string} name - Name of the field
        * @param {string} value - Value of the field
        */
        function DateTimeField(name, value) {
            this.name = name;
            this.value = value;
            /**
            * Type of the field
            */
            this.type = field_type_1.FieldType.DateTime;
            this.datetime = new Date(value);
        }
        return DateTimeField;
    }());
    Fields.DateTimeField = DateTimeField;
    var RichTextField = /** @class */ (function () {
        /**
        * Represents rich text field of Kentico Cloud item
        * @constructor
        * @param {string} name - Name of the field
        * @param {string} value - Value of the field
        * @param {() => string} resolveHtml - Function that resolves HTML
        * @param {Link[]} links - Links for this rich text field
        */
        function RichTextField(name, value, data) {
            this.name = name;
            this.value = value;
            /**
            * Type of the field
            */
            this.type = field_type_1.FieldType.RichText;
            /**
             * Links
             */
            this.links = [];
            Object.assign(this, data);
        }
        RichTextField.prototype.getHtml = function () {
            // check if html was already resolved
            if (this.resolvedHtml) {
                return this.resolvedHtml;
            }
            this.resolvedHtml = this.resolveHtml();
            return this.resolvedHtml;
        };
        return RichTextField;
    }());
    Fields.RichTextField = RichTextField;
    var NumberField = /** @class */ (function () {
        /**
        * Represents number field of Kentico Cloud item
        * @constructor
        * @param {string} name - Name of the field
        * @param {string} value - Value of the field
        */
        function NumberField(name, value) {
            this.name = name;
            this.value = value;
            /**
            * Type of the field
            */
            this.type = field_type_1.FieldType.Number;
            this.number = value;
        }
        return NumberField;
    }());
    Fields.NumberField = NumberField;
    var AssetsField = /** @class */ (function () {
        /**
        * Represents asset field of Kentico Cloud item
        * @constructor
        * @param {string} name - Name of the field
        * @param {any} value - Value of the field
        */
        function AssetsField(name, value) {
            var _this = this;
            this.name = name;
            this.value = value;
            /**
            * Type of the field
            */
            this.type = field_type_1.FieldType.Asset;
            /**
            * List of assets used in this field
            */
            this.assets = [];
            if (!value) {
                throw Error("Cannot bind assets field because no value was provided");
            }
            if (!Array.isArray(value)) {
                throw Error("Cannot bind assets because the provided value is not an array");
            }
            this.value.forEach(function (asset) {
                _this.assets.push(new field_models_1.FieldModels.AssetModel(asset.name, asset.type, asset.size, asset.description, asset.url));
            });
        }
        return AssetsField;
    }());
    Fields.AssetsField = AssetsField;
    var UrlSlugField = /** @class */ (function () {
        /**
        * Represents URL slug field of Kentico Cloud item
        * @constructor
        * @param {string} name - Name of the field
        * @param {string} value - Value of the field
        * @param {() => string | undefined} resolveUrl - Function to get url of the link
        */
        function UrlSlugField(name, value, data) {
            this.name = name;
            this.value = value;
            /**
            * Type of the field
            */
            this.type = field_type_1.FieldType.UrlSlug;
            Object.assign(this, data);
        }
        UrlSlugField.prototype.getUrl = function () {
            if (this.resolvedUrl) {
                return this.resolvedUrl;
            }
            this.resolvedUrl = this.resolveUrl();
            return this.resolvedUrl;
        };
        return UrlSlugField;
    }());
    Fields.UrlSlugField = UrlSlugField;
    var TaxonomyField = /** @class */ (function () {
        /**
        * Represents number field of Kentico Cloud item
        * @constructor
        * @param {string} name - Name of the field
        * @param {string} value - Value of the field
        * @param {string | undefined} taxonomyGroup - Codename of the taxonomy group
        */
        function TaxonomyField(name, value, taxonomyGroup) {
            var _this = this;
            this.name = name;
            this.value = value;
            this.taxonomyGroup = taxonomyGroup;
            /**
            * Type of the field
            */
            this.type = field_type_1.FieldType.Taxonomy;
            /**
            * List of assigned taxonomy terms
            */
            this.taxonomyTerms = [];
            if (!value) {
                throw Error("Cannot map taxonomy field because no value was provided");
            }
            if (!Array.isArray(value)) {
                throw Error("Cannot get taxonomy field because the provided value is not an array");
            }
            var taxonomyList = value;
            taxonomyList.forEach(function (term) {
                _this.taxonomyTerms.push(new field_models_1.FieldModels.TaxonomyTerm(term.name, term.codename));
            });
        }
        return TaxonomyField;
    }());
    Fields.TaxonomyField = TaxonomyField;
})(Fields = exports.Fields || (exports.Fields = {}));
//# sourceMappingURL=field-types.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/fields/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/fields/field-decorators.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/fields/field-models.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/fields/field-type.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/fields/field-types.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
/* client */
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/client/index.js"));
// sdk info */
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/sdk-info.generated.js"));
/* fields */
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/fields/index.js"));
/* parser */
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/parser/index.js"));
/* resolvers */
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/resolvers/index.js"));
/* services */
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/services/index.js"));
/* mappers */
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/mappers/index.js"));
/* queries */
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/index.js"));
/* models */
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/index.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/client/delivery-client.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var query_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/index.js");
var sdk_info_generated_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/sdk-info.generated.js");
var services_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/services/index.js");
var parser_adapter_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/parser/parser-adapter.js");
var DeliveryClient = /** @class */ (function () {
    /**
    * Delivery client used to fetch data from Kentico Cloud
    * @constructor
    * @param {IDeliveryClientConfig} config - The client configuration
    */
    function DeliveryClient(config) {
        this.config = config;
        if (!config) {
            throw Error("Please provide Delivery client configuration");
        }
        this.queryService = new services_1.QueryService(config, new services_1.DeliveryHttpService(), parser_adapter_1.getParserAdapter(), {
            host: sdk_info_generated_1.sdkInfo.host,
            name: sdk_info_generated_1.sdkInfo.name,
            version: sdk_info_generated_1.sdkInfo.version
        });
    }
    /**
    * Gets query for multiple types
    */
    DeliveryClient.prototype.types = function () {
        return new query_1.MultipleTypeQuery(this.config, this.queryService);
    };
    /**
    * Gets query for single type
    * @param {string} typeCodename - Codename of the type to fetch
    */
    DeliveryClient.prototype.type = function (typeCodename) {
        return new query_1.SingleTypeQuery(this.config, this.queryService, typeCodename);
    };
    /**
    * Gets query for multiple items
    */
    DeliveryClient.prototype.items = function () {
        return new query_1.MultipleItemQuery(this.config, this.queryService);
    };
    /**
    * Gets query for single item
    * @param {string} codename - Codename of item to fetch
    */
    DeliveryClient.prototype.item = function (codename) {
        return new query_1.SingleItemQuery(this.config, this.queryService, codename);
    };
    /**
    * Gets query for single taxonomy
    * @param {string} codename - Codename of taxonomy to fetch
    */
    DeliveryClient.prototype.taxonomy = function (codename) {
        return new query_1.TaxonomyQuery(this.config, this.queryService, codename);
    };
    /**
    * Gets query for multiple taxonomies
    */
    DeliveryClient.prototype.taxonomies = function () {
        return new query_1.TaxonomiesQuery(this.config, this.queryService);
    };
    /**
     * Gets query for an element within a type
     * @param {string} typeCodename - Codename of the type
     * @param {string} elementCodename - Codename of the element
     */
    DeliveryClient.prototype.element = function (typeCodename, elementCodename) {
        return new query_1.ElementQuery(this.config, this.queryService, typeCodename, elementCodename);
    };
    return DeliveryClient;
}());
exports.DeliveryClient = DeliveryClient;
//# sourceMappingURL=delivery-client.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/client/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/client/delivery-client.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/fields/field-decorators.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
__webpack_require__("./node_modules/reflect-metadata/Reflect.js");
var FieldDecorators;
(function (FieldDecorators) {
    var codenameMetadataKey = Symbol('codename');
    var generateKey = function (name) {
        return codenameMetadataKey.toString() + ":" + name;
    };
    /**
     * Get the metadata entry saved by the decorator
     * @param target - object instance
     * @param fieldName - field name (code name from Kentico Cloud)
     */
    function getPropertyName(target, fieldName) {
        return Reflect.getMetadata(generateKey(fieldName), target);
    }
    FieldDecorators.getPropertyName = getPropertyName;
    /**
     * Decorator - reates metadata entry for the @target - Value is the property name.
     * This will then be retrieved in the FieldMap service when resolving the field name
     * @param value - field code name
     */
    function codename(value) {
        return function (target, propertyKey) {
            Reflect.defineMetadata(generateKey(value), propertyKey, target);
        };
    }
    FieldDecorators.codename = codename;
})(FieldDecorators = exports.FieldDecorators || (exports.FieldDecorators = {}));
//# sourceMappingURL=field-decorators.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/fields/field-models.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var FieldModels;
(function (FieldModels) {
    var AssetModel = /** @class */ (function () {
        /**
        * Represents Kentico Cloud's asset
        * @constructor
        * @param {string} name - Name of the asset
        * @param {string} type - Type of the asset
        * @param {number} size - Size of the asset
        * @param {string} description - Description of the asset
        * @param {string} url - Url of the asset
        */
        function AssetModel(name, type, size, description, url) {
            this.name = name;
            this.type = type;
            this.size = size;
            this.description = description;
            this.url = url;
        }
        return AssetModel;
    }());
    FieldModels.AssetModel = AssetModel;
    var MultipleChoiceOption = /** @class */ (function () {
        /**
        * Represents Kentico Cloud's multiple choice option
        * @constructor
        * @param {string} name - Name of the option
        * @param {string} codename - Codename of the option
        */
        function MultipleChoiceOption(name, codename) {
            this.name = name;
            this.codename = codename;
        }
        return MultipleChoiceOption;
    }());
    FieldModels.MultipleChoiceOption = MultipleChoiceOption;
    var TaxonomyTerm = /** @class */ (function () {
        /**
       * Represents taxonomy term
       * @constructor
       * @param {string} name - Name of the taxonomy option
       * @param {string} codename - Codename of the option
       */
        function TaxonomyTerm(name, codename) {
            this.name = name;
            this.codename = codename;
        }
        return TaxonomyTerm;
    }());
    FieldModels.TaxonomyTerm = TaxonomyTerm;
})(FieldModels = exports.FieldModels || (exports.FieldModels = {}));
//# sourceMappingURL=field-models.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/fields/field-type.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
/**
* Represents codename of Kentico Cloud field types
*/
var FieldType;
(function (FieldType) {
    FieldType["Text"] = "text";
    FieldType["Number"] = "number";
    FieldType["ModularContent"] = "modular_content";
    FieldType["Asset"] = "asset";
    FieldType["DateTime"] = "date_time";
    FieldType["RichText"] = "rich_text";
    FieldType["MultipleChoice"] = "multiple_choice";
    FieldType["UrlSlug"] = "url_slug";
    FieldType["Taxonomy"] = "taxonomy";
})(FieldType = exports.FieldType || (exports.FieldType = {}));
//# sourceMappingURL=field-type.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/fields/field-types.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var field_models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/fields/field-models.js");
var field_type_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/fields/field-type.js");
var Fields;
(function (Fields) {
    var TextField = /** @class */ (function () {
        /**
        * Represents text field of Kentico Cloud item
        * @constructor
        * @param {string} name - Name of the field
        * @param {string} value - Value of the field
        */
        function TextField(name, value) {
            this.name = name;
            this.value = value;
            /**
            * Type of the field
            */
            this.type = field_type_1.FieldType.Text;
            this.text = this.value;
        }
        return TextField;
    }());
    Fields.TextField = TextField;
    var MultipleChoiceField = /** @class */ (function () {
        /**
        * Represents multiple choice field of Kentico Cloud item
        * @constructor
        * @param {string} name - Name of the field
        * @param {string} value - Value of the field
        */
        function MultipleChoiceField(name, value) {
            var _this = this;
            this.name = name;
            this.value = value;
            /**
            * Multiple choice options
            */
            this.options = [];
            /**
            * Type of the field
            */
            this.type = field_type_1.FieldType.MultipleChoice;
            if (this.value && Array.isArray(this.value)) {
                this.value.forEach(function (option) {
                    var optionTemp = option;
                    _this.options.push(new field_models_1.FieldModels.MultipleChoiceOption(optionTemp.name, optionTemp.codename));
                });
            }
        }
        return MultipleChoiceField;
    }());
    Fields.MultipleChoiceField = MultipleChoiceField;
    var DateTimeField = /** @class */ (function () {
        /**
        * Represents date time field of Kentico Cloud item
        * @constructor
        * @param {string} name - Name of the field
        * @param {string} value - Value of the field
        */
        function DateTimeField(name, value) {
            this.name = name;
            this.value = value;
            /**
            * Type of the field
            */
            this.type = field_type_1.FieldType.DateTime;
            this.datetime = new Date(value);
        }
        return DateTimeField;
    }());
    Fields.DateTimeField = DateTimeField;
    var RichTextField = /** @class */ (function () {
        /**
        * Represents rich text field of Kentico Cloud item
        * @constructor
        * @param {string} name - Name of the field
        * @param {string} value - Value of the field
        * @param {() => string} resolveHtml - Function that resolves HTML
        * @param {Link[]} links - Links for this rich text field
        */
        function RichTextField(name, value, data) {
            this.name = name;
            this.value = value;
            /**
            * Type of the field
            */
            this.type = field_type_1.FieldType.RichText;
            /**
             * Links
             */
            this.links = [];
            Object.assign(this, data);
        }
        RichTextField.prototype.getHtml = function () {
            // check if html was already resolved
            if (this.resolvedHtml) {
                return this.resolvedHtml;
            }
            this.resolvedHtml = this.resolveHtml();
            return this.resolvedHtml;
        };
        return RichTextField;
    }());
    Fields.RichTextField = RichTextField;
    var NumberField = /** @class */ (function () {
        /**
        * Represents number field of Kentico Cloud item
        * @constructor
        * @param {string} name - Name of the field
        * @param {string} value - Value of the field
        */
        function NumberField(name, value) {
            this.name = name;
            this.value = value;
            /**
            * Type of the field
            */
            this.type = field_type_1.FieldType.Number;
            this.number = value;
        }
        return NumberField;
    }());
    Fields.NumberField = NumberField;
    var AssetsField = /** @class */ (function () {
        /**
        * Represents asset field of Kentico Cloud item
        * @constructor
        * @param {string} name - Name of the field
        * @param {any} value - Value of the field
        */
        function AssetsField(name, value) {
            var _this = this;
            this.name = name;
            this.value = value;
            /**
            * Type of the field
            */
            this.type = field_type_1.FieldType.Asset;
            /**
            * List of assets used in this field
            */
            this.assets = [];
            if (!value) {
                throw Error("Cannot bind assets field because no value was provided");
            }
            if (!Array.isArray(value)) {
                throw Error("Cannot bind assets because the provided value is not an array");
            }
            this.value.forEach(function (asset) {
                _this.assets.push(new field_models_1.FieldModels.AssetModel(asset.name, asset.type, asset.size, asset.description, asset.url));
            });
        }
        return AssetsField;
    }());
    Fields.AssetsField = AssetsField;
    var UrlSlugField = /** @class */ (function () {
        /**
        * Represents URL slug field of Kentico Cloud item
        * @constructor
        * @param {string} name - Name of the field
        * @param {string} value - Value of the field
        * @param {() => string | undefined} resolveUrl - Function to get url of the link
        */
        function UrlSlugField(name, value, data) {
            this.name = name;
            this.value = value;
            /**
            * Type of the field
            */
            this.type = field_type_1.FieldType.UrlSlug;
            Object.assign(this, data);
        }
        UrlSlugField.prototype.getUrl = function () {
            if (this.resolvedUrl) {
                return this.resolvedUrl;
            }
            this.resolvedUrl = this.resolveUrl();
            return this.resolvedUrl;
        };
        return UrlSlugField;
    }());
    Fields.UrlSlugField = UrlSlugField;
    var TaxonomyField = /** @class */ (function () {
        /**
        * Represents number field of Kentico Cloud item
        * @constructor
        * @param {string} name - Name of the field
        * @param {string} value - Value of the field
        * @param {string | undefined} taxonomyGroup - Codename of the taxonomy group
        */
        function TaxonomyField(name, value, taxonomyGroup) {
            var _this = this;
            this.name = name;
            this.value = value;
            this.taxonomyGroup = taxonomyGroup;
            /**
            * Type of the field
            */
            this.type = field_type_1.FieldType.Taxonomy;
            /**
            * List of assigned taxonomy terms
            */
            this.taxonomyTerms = [];
            if (!value) {
                throw Error("Cannot map taxonomy field because no value was provided");
            }
            if (!Array.isArray(value)) {
                throw Error("Cannot get taxonomy field because the provided value is not an array");
            }
            var taxonomyList = value;
            taxonomyList.forEach(function (term) {
                _this.taxonomyTerms.push(new field_models_1.FieldModels.TaxonomyTerm(term.name, term.codename));
            });
        }
        return TaxonomyField;
    }());
    Fields.TaxonomyField = TaxonomyField;
})(Fields = exports.Fields || (exports.Fields = {}));
//# sourceMappingURL=field-types.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/fields/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/fields/field-decorators.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/fields/field-models.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/fields/field-type.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/fields/field-types.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/images/image-url-builder.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/index.js");
var image_models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/images/image.models.js");
var ImageUrlBuilder = /** @class */ (function () {
    function ImageUrlBuilder(
    /** Image url */
    imageUrl) {
        this.imageUrl = imageUrl;
        this.queryParams = [];
    }
    /**
     * The dpr transformation is used to serve correctly sized images for devices that expose a device pixel ratio.
     * @param dpr A required DPR value.
     */
    ImageUrlBuilder.prototype.withDpr = function (dpr) {
        this.queryParams.push(new models_1.Parameters.QueryParameter('dpr', dpr.toString()));
        return this;
    };
    /**
     * Applies the crop transformation that removes pixels from an image outside the specified rectangle.
     * @param x Rectangle offset on the X-axis.
     * @param y Rectangle offset on the Y-axis.
     * @param width Rectangle width.
     * @param height Rectangle height.
     */
    ImageUrlBuilder.prototype.withRectangleCrop = function (x, y, width, height) {
        this.queryParams.push(new models_1.Parameters.QueryParameter('rect', [x, y, width, height].join(',')));
        return this;
    };
    /**
     * Applies the crop transformation centered on the specified point.
     * @param x Focal point X coordinate.
     * @param y Focal point Y coordinate.
     * @param z Zoom of the transformation.
     */
    ImageUrlBuilder.prototype.withFocalPointCrop = function (x, y, z) {
        this.withFitMode(image_models_1.ImageFitModeEnum.Crop);
        this.queryParams.push(new models_1.Parameters.QueryParameter('crop', 'focalpoint'));
        this.queryParams.push(new models_1.Parameters.QueryParameter('fp-x', x.toString()));
        this.queryParams.push(new models_1.Parameters.QueryParameter('fp-y', y.toString()));
        this.queryParams.push(new models_1.Parameters.QueryParameter('fp-z', z.toString()));
        return this;
    };
    /**
     * Enables WebP image support.
     * @param compression Specifies the lossy or lossless compression.
     */
    ImageUrlBuilder.prototype.withAutomaticFormat = function (backupFormat) {
        this.queryParams.push(new models_1.Parameters.QueryParameter('auto', image_models_1.ImageFormatEnum.Webp));
        if (backupFormat) {
            this.withFormat(backupFormat);
        }
        return this;
    };
    /**
     * The fit transformation controls how the output image is fit to its target dimensions after resizing.
     * @param fitMode Specifies the mode for the transformation.
     */
    ImageUrlBuilder.prototype.withFitMode = function (fitMode) {
        this.queryParams.push(new models_1.Parameters.QueryParameter('fit', fitMode));
        return this;
    };
    /**
     * Specifies the compression mode for the WebP image transformations.
     * @param compression Specifies the lossy or lossless compression.
     */
    ImageUrlBuilder.prototype.withCompression = function (compression) {
        this.queryParams.push(new models_1.Parameters.QueryParameter('lossless', compression === image_models_1.ImageCompressionEnum.Lossless ? 'true' : 'false'));
        return this;
    };
    /**
     * Applies the quality parameter that enables control over the compression level for lossy file-formatted images.
     * @param quality The required quality of the image.
     */
    ImageUrlBuilder.prototype.withQuality = function (quality) {
        this.queryParams.push(new models_1.Parameters.QueryParameter('q', quality.toString()));
        return this;
    };
    /**
     * The format transformation enables the source image to be converted (a.k.a., "transcoded") from
     * one encoded format to another. This is very useful when the source image has been saved in a sub-optimal
     * file format that hinders performance.
     * @param format Target image file type.
     */
    ImageUrlBuilder.prototype.withFormat = function (format) {
        this.queryParams.push(new models_1.Parameters.QueryParameter('fm', format));
        return this;
    };
    /**
     * The height transformation enables dynamic height resizing based on pixels and percent values.
     * @param height A required image height.
     */
    ImageUrlBuilder.prototype.withHeight = function (height) {
        this.queryParams.push(new models_1.Parameters.QueryParameter('h', height.toString()));
        return this;
    };
    /**
     * The width transformation enables dynamic width resizing based on pixels and percent values.
     * @param width A required image width.
     */
    ImageUrlBuilder.prototype.withWidth = function (width) {
        this.queryParams.push(new models_1.Parameters.QueryParameter('w', width.toString()));
        return this;
    };
    /**
     * Gets params applied to image
     */
    ImageUrlBuilder.prototype.getParams = function () {
        return this.queryParams;
    };
    /**
     * Gets query string part of the image URL
     */
    ImageUrlBuilder.prototype.getQueryString = function () {
        var query = '';
        this.queryParams.forEach(function (filter) {
            if (query.indexOf('?') > -1) {
                query = query + '&' + filter.getParam() + '=' + filter.getParamValue();
            }
            else {
                query = query + '?' + filter.getParam() + '=' + filter.getParamValue();
            }
        });
        return query;
    };
    /**
     * Gets full transformed url to image with parameters
     */
    ImageUrlBuilder.prototype.getUrl = function () {
        return this.imageUrl + this.getQueryString();
    };
    return ImageUrlBuilder;
}());
exports.ImageUrlBuilder = ImageUrlBuilder;
//# sourceMappingURL=image-url-builder.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/images/image.models.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var ImageFitModeEnum;
(function (ImageFitModeEnum) {
    ImageFitModeEnum["Clip"] = "clip";
    ImageFitModeEnum["Scale"] = "scale";
    ImageFitModeEnum["Crop"] = "crop";
})(ImageFitModeEnum = exports.ImageFitModeEnum || (exports.ImageFitModeEnum = {}));
var ImageFormatEnum;
(function (ImageFormatEnum) {
    ImageFormatEnum["Gif"] = "gif";
    ImageFormatEnum["Png"] = "png";
    ImageFormatEnum["Png8"] = "png8";
    ImageFormatEnum["Jpg"] = "jpg";
    ImageFormatEnum["Pjpg"] = "pjpg";
    ImageFormatEnum["Webp"] = "webp";
})(ImageFormatEnum = exports.ImageFormatEnum || (exports.ImageFormatEnum = {}));
var ImageCompressionEnum;
(function (ImageCompressionEnum) {
    /**
     * Allows the original data to be perfectly reconstructed from the compressed data.
     */
    ImageCompressionEnum[ImageCompressionEnum["Lossless"] = 0] = "Lossless";
    /**
     * Irreversible compression where partial data are discarded.
     */
    ImageCompressionEnum[ImageCompressionEnum["Lossy"] = 1] = "Lossy";
})(ImageCompressionEnum = exports.ImageCompressionEnum || (exports.ImageCompressionEnum = {}));
//# sourceMappingURL=image.models.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/images/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/images/image-url-builder.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/images/image.models.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
/* client */
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/client/index.js"));
// sdk info */
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/sdk-info.generated.js"));
/* fields */
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/fields/index.js"));
/* parser */
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/parser/index.js"));
/* resolvers */
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/resolvers/index.js"));
/* services */
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/services/index.js"));
/* mappers */
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/mappers/index.js"));
/* queries */
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/index.js"));
/* models */
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/index.js"));
/* images */
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/images/index.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/mappers/element.mapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/index.js");
var ElementMapper = /** @class */ (function () {
    function ElementMapper() {
    }
    ElementMapper.prototype.mapElement = function (response) {
        if (!response) {
            throw Error("Invalid response for mapping element");
        }
        return new models_1.Element({
            codename: response.codename,
            name: response.name,
            type: response.type,
            options: response.options ? response.options : [],
            taxonomyGroup: response.taxonomy_group
        });
    };
    return ElementMapper;
}());
exports.ElementMapper = ElementMapper;
//# sourceMappingURL=element.mapper.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/mappers/field.mapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var fields_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/fields/index.js");
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/index.js");
var resolvers_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/resolvers/index.js");
var FieldMapper = /** @class */ (function () {
    function FieldMapper(config, richTextHtmlParser) {
        this.config = config;
        this.richTextHtmlParser = richTextHtmlParser;
        this.defaultModularContentWrapperTag = 'p';
        this.defaultModularContentWrapperClasses = ['kc-modular-item-wrapper'];
    }
    /**
     * Maps all fields in given content item and returns strongly typed content item based on the resolver specified
     * in DeliveryClientConfig
     * @param item Item to map (raw response from Kentico Cloud)
     * @param modularContent Modular content sent along with item
     * @param queryConfig Query configuration
     */
    FieldMapper.prototype.mapFields = function (item, modularContent, queryConfig, processedItems) {
        var _this = this;
        if (!item) {
            throw Error("Cannot map fields because item is not defined");
        }
        if (!item.system) {
            throw Error("Cannot map item because it does not contain system attributes. This is an essential field and every item should have one.");
        }
        if (!item.elements) {
            throw Error("Cannot map elements of item with codename '" + item.system.codename + "'");
        }
        if (!processedItems) {
            throw Error("ProcessedItems need to be initialized");
        }
        if (!Array.isArray(processedItems)) {
            throw Error("ProcessedItems need to be an array of 'IContentItems'");
        }
        var properties = Object.getOwnPropertyNames(item.elements);
        var itemTyped;
        // check if resolver for this type is available
        if (this.config.typeResolvers && resolvers_1.stronglyTypedResolver.hasTypeResolver(item.system.type, this.config.typeResolvers)) {
            itemTyped = resolvers_1.stronglyTypedResolver.createTypedObj(item.system.type, item, this.config.typeResolvers);
        }
        else {
            itemTyped = resolvers_1.stronglyTypedResolver.createContentItem(item);
        }
        // add/taken item to processed items to avoid infinite recursion
        var processedItem = processedItems.find(function (m) { return m.system.codename === item.system.codename; });
        if (!processedItem) {
            processedItems.push(itemTyped);
        }
        properties.forEach(function (fieldName) {
            var field = item.elements[fieldName];
            var propertyName;
            // resolve field to a custom model property
            if (itemTyped.propertyResolver) {
                propertyName = itemTyped.propertyResolver(fieldName);
            }
            // if property hasn't been resolved, try with decorator
            if (!propertyName) {
                propertyName = fields_1.FieldDecorators.getPropertyName(itemTyped, fieldName);
            }
            // if property name is null/empty, use elements codename
            if (!propertyName) {
                propertyName = fieldName;
            }
            itemTyped[propertyName] = _this.mapField(field, modularContent, itemTyped, queryConfig, processedItems);
        });
        return itemTyped;
    };
    FieldMapper.prototype.mapField = function (field, modularContent, item, queryConfig, processedItems) {
        var fieldType = field.type.toLowerCase();
        if (fieldType === fields_1.FieldType.ModularContent.toString()) {
            return this.mapModularField(field, modularContent, queryConfig, processedItems);
        }
        else if (fieldType === fields_1.FieldType.Text.toLowerCase()) {
            return this.mapTextField(field);
        }
        else if (fieldType === fields_1.FieldType.Asset.toLowerCase()) {
            return this.mapAssetsField(field);
        }
        else if (fieldType === fields_1.FieldType.Number.toLowerCase()) {
            return this.mapNumberField(field);
        }
        else if (fieldType === fields_1.FieldType.MultipleChoice.toLowerCase()) {
            return this.mapMultipleChoiceField(field);
        }
        else if (fieldType === fields_1.FieldType.DateTime.toLowerCase()) {
            return this.mapDateTimeField(field);
        }
        else if (fieldType === fields_1.FieldType.RichText.toLowerCase()) {
            return this.mapRichTextField(field, modularContent, queryConfig, processedItems);
        }
        else if (fieldType === fields_1.FieldType.UrlSlug.toLowerCase()) {
            return this.mapUrlSlugField(field, item, queryConfig);
        }
        else if (fieldType === fields_1.FieldType.Taxonomy.toLowerCase()) {
            return this.mapTaxonomyField(field);
        }
        var error = "Unsupported field type '" + field.type + "'";
        throw Error(error);
    };
    FieldMapper.prototype.mapRichTextField = function (field, modularContent, queryConfig, processedItems) {
        var _this = this;
        // get all modular content items nested in rich text
        var modularItems = [];
        if (field.modular_content) {
            if (Array.isArray(field.modular_content)) {
                field.modular_content.forEach(function (codename) {
                    // get modular item and check if it exists (it might not be included in response due to 'Depth' parameter)
                    var modularContentItem = modularContent[codename];
                    if (!modularContentItem) {
                        throw Error("Modular content item with codename '" + codename + "' is not present in Delivery response.\n                        This modular item was requested by '" + field.name + "' field.\n                        Error can usually be solved by increasing 'Depth' parameter of your query.");
                    }
                    var modularItem = _this.mapFields(modularContent[codename], modularContent, queryConfig, processedItems);
                    if (modularItem != null) {
                        modularItems.push(modularItem);
                    }
                });
            }
        }
        // extract and map links
        var links = this.mapRichTextLinks(field.links);
        return new fields_1.Fields.RichTextField(field.name, field.value, {
            links: links,
            resolveHtml: function () { return resolvers_1.richTextResolver.resolveHtml(field.value, {
                enableAdvancedLogging: _this.config.enableAdvancedLogging ? _this.config.enableAdvancedLogging : false,
                typeResolvers: _this.config.typeResolvers ? _this.config.typeResolvers : [],
                richTextHtmlParser: _this.richTextHtmlParser,
                modularItems: modularItems,
                links: links,
                queryConfig: queryConfig,
                modularContentWrapperTag: _this.config.modularContentResolver && _this.config.modularContentResolver.modularContentWrapperTag
                    ? _this.config.modularContentResolver.modularContentWrapperTag
                    : _this.defaultModularContentWrapperTag,
                modularContentWrapperClasses: _this.config.modularContentResolver && _this.config.modularContentResolver.modularContentWrapperClasses
                    ? _this.config.modularContentResolver.modularContentWrapperClasses
                    : _this.defaultModularContentWrapperClasses
            }); }
        });
    };
    FieldMapper.prototype.mapDateTimeField = function (field) {
        return new fields_1.Fields.DateTimeField(field.name, field.value);
    };
    FieldMapper.prototype.mapMultipleChoiceField = function (field) {
        return new fields_1.Fields.MultipleChoiceField(field.name, field.value);
    };
    FieldMapper.prototype.mapNumberField = function (field) {
        return new fields_1.Fields.NumberField(field.name, field.value);
    };
    FieldMapper.prototype.mapTextField = function (field) {
        return new fields_1.Fields.TextField(field.name, field.value);
    };
    FieldMapper.prototype.mapAssetsField = function (field) {
        return new fields_1.Fields.AssetsField(field.name, field.value);
    };
    FieldMapper.prototype.mapTaxonomyField = function (field) {
        return new fields_1.Fields.TaxonomyField(field.name, field.value, field.taxonomy_group);
    };
    FieldMapper.prototype.mapUrlSlugField = function (field, item, queryConfig) {
        var _this = this;
        var linkResolver = this.getLinkResolverForUrlSlugField(item, queryConfig);
        return new fields_1.Fields.UrlSlugField(field.name, field.value, {
            resolveUrl: function () { return resolvers_1.urlSlugResolver.resolveUrl({
                fieldName: field.name,
                type: field.type,
                fieldValue: field.value,
                item: item,
                enableAdvancedLogging: _this.config.enableAdvancedLogging ? _this.config.enableAdvancedLogging : false,
                linkResolver: linkResolver
            }); }
        });
    };
    FieldMapper.prototype.mapModularField = function (field, modularContent, queryConfig, processedItems) {
        var _this = this;
        if (!field) {
            if (this.config.enableAdvancedLogging) {
                console.warn("Cannot map modular content field because field does not exist");
            }
            return null;
        }
        if (!field.value) {
            if (this.config.enableAdvancedLogging) {
                console.warn("Cannot map modular content of '" + field.name + "' because its value does not exist");
            }
            return null;
        }
        // modular content is always returned in an array
        var modularContentItems = [];
        var fieldModularContent = field.value;
        fieldModularContent.forEach(function (modularItemCodename) {
            var modularItem = modularContent[modularItemCodename];
            if (!modularItem) {
                if (_this.config.enableAdvancedLogging) {
                    console.warn("Cannot map '" + field.name + "' modular content item. Make sure you use 'DepthParameter' in case your modular content is nested.");
                }
            }
            // try to map only if the modular item was present in response
            if (modularItem) {
                // add/taken item to processed items to avoid infinite recursion
                var processedItem = processedItems.find(function (m) { return m.system.codename === modularItem.system.codename; });
                if (processedItem) {
                    modularContentItems.push(processedItem);
                }
                else {
                    var newModularItem = _this.mapFields(modularItem, modularContent, queryConfig, processedItems);
                    modularContentItems.push(newModularItem);
                    processedItem = newModularItem;
                }
            }
        });
        return modularContentItems;
    };
    FieldMapper.prototype.getLinkResolverForUrlSlugField = function (item, queryConfig) {
        // link resolver defined by the query config (= by calling method) has priority over type's global link resolver
        var linkResolver = undefined;
        if (queryConfig.linkResolver) {
            linkResolver = queryConfig.linkResolver;
        }
        else {
            linkResolver = item.linkResolver;
        }
        return linkResolver;
    };
    FieldMapper.prototype.mapRichTextLinks = function (linksJson) {
        var links = [];
        for (var _i = 0, _a = Object.keys(linksJson); _i < _a.length; _i++) {
            var linkItemId = _a[_i];
            var linkRaw = linksJson[linkItemId];
            links.push(new models_1.Link({
                codename: linkRaw.codename,
                itemId: linkItemId,
                urlSlug: linkRaw.url_slug,
                type: linkRaw.type
            }));
        }
        return links;
    };
    return FieldMapper;
}());
exports.FieldMapper = FieldMapper;
//# sourceMappingURL=field.mapper.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/mappers/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/mappers/element.mapper.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/mappers/field.mapper.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/mappers/item.mapper.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/mappers/response.mapper.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/mappers/taxonomy.mapper.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/mappers/type.mapper.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/mappers/item.mapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var mappers_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/mappers/index.js");
var ItemMapper = /** @class */ (function () {
    function ItemMapper(config, richTextHtmlParser) {
        this.config = config;
        this.richTextHtmlParser = richTextHtmlParser;
        this.fieldMapper = new mappers_1.FieldMapper(config, richTextHtmlParser);
    }
    /**
     * Maps single item to its proper strongly typed model from the given Cloud response
     * @param response Cloud response used to map the item
     * @param queryConfig Query configuration
     */
    ItemMapper.prototype.mapSingleItem = function (response, queryConfig) {
        return this.mapItem(response.item, response.modular_content, queryConfig);
    };
    /**
    * Maps multiple items to their strongly typed model from the given Cloud response
    * @param response Cloud response used to map the item
    * @param queryConfig Query configuration
    */
    ItemMapper.prototype.mapMultipleItems = function (response, queryConfig) {
        var that = this;
        return response.items.map(function (item) {
            return that.mapItem(item, response.modular_content, queryConfig);
        });
    };
    ItemMapper.prototype.mapItem = function (item, modularContent, queryConfig) {
        if (item == null) {
            throw Error("Could not map item because its undefined");
        }
        return this.fieldMapper.mapFields(item, modularContent, queryConfig, []);
    };
    return ItemMapper;
}());
exports.ItemMapper = ItemMapper;
//# sourceMappingURL=item.mapper.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/mappers/response.mapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/index.js");
var element_mapper_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/mappers/element.mapper.js");
var item_mapper_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/mappers/item.mapper.js");
var taxonomy_mapper_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/mappers/taxonomy.mapper.js");
var type_mapper_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/mappers/type.mapper.js");
var ResponseMapper = /** @class */ (function () {
    function ResponseMapper(config, richTextHtmlParser) {
        this.config = config;
        this.richTextHtmlParser = richTextHtmlParser;
        this.typeMapper = new type_mapper_1.TypeMapper();
        this.itemMapper = new item_mapper_1.ItemMapper(config, richTextHtmlParser);
        this.taxonomyMapper = new taxonomy_mapper_1.TaxonomyMapper();
        this.elementMapper = new element_mapper_1.ElementMapper();
    }
    /**
     * Gets response for getting a single type
     * @param response Response data
     */
    ResponseMapper.prototype.mapSingleTypeResponse = function (response) {
        var cloudResponse = response.data;
        // map type
        var type = this.typeMapper.mapSingleType(cloudResponse);
        return new models_1.TypeResponses.DeliveryTypeResponse(type, this.mapResponseDebug(response));
    };
    /**
     * Gets resposne for getting multiple types
     * @param response Response data
     * @param options Options
     */
    ResponseMapper.prototype.mapMultipleTypeResponse = function (response) {
        var cloudResponse = response.data;
        // map types
        var types = this.typeMapper.mapMultipleTypes(cloudResponse);
        // pagination
        var pagination = new models_1.Pagination({
            skip: cloudResponse.pagination.skip,
            count: cloudResponse.pagination.count,
            limit: cloudResponse.pagination.limit,
            next_page: cloudResponse.pagination.next_page
        });
        return new models_1.TypeResponses.DeliveryTypeListingResponse(types, pagination, this.mapResponseDebug(response));
    };
    /**
     * Gets response for getting single item
     * @param response Response data
     * @param queryConfig Query configuration
     */
    ResponseMapper.prototype.mapSingleResponse = function (response, queryConfig) {
        var cloudResponse = response.data;
        // map item
        var item = this.itemMapper.mapSingleItem(cloudResponse, queryConfig);
        return new models_1.ItemResponses.DeliveryItemResponse(item, this.mapResponseDebug(response));
    };
    /**
     * Gets response for getting multiple items
     * @param response Response data
     * @param queryConfig Query configuration
     */
    ResponseMapper.prototype.mapMultipleResponse = function (response, queryConfig) {
        var cloudResponse = response.data;
        // map items
        var items = this.itemMapper.mapMultipleItems(cloudResponse, queryConfig);
        // pagination
        var pagination = new models_1.Pagination({
            skip: cloudResponse.pagination.skip,
            count: cloudResponse.pagination.count,
            limit: cloudResponse.pagination.limit,
            next_page: cloudResponse.pagination.next_page
        });
        return new models_1.ItemResponses.DeliveryItemListingResponse(items, pagination, this.mapResponseDebug(response));
    };
    /**
     * Gets response for getting single taxonomy item
     * @param response Response data
     */
    ResponseMapper.prototype.mapTaxonomyResponse = function (response) {
        var cloudResponse = response.data;
        // map taxonomy
        var taxonomy = this.taxonomyMapper.mapTaxonomy(cloudResponse.system, cloudResponse.terms);
        return new models_1.TaxonomyResponses.TaxonomyResponse(taxonomy, this.mapResponseDebug(response));
    };
    /**
     * Gets response for getting multiples taxonomies
     * @param response Response data
     */
    ResponseMapper.prototype.mapTaxonomiesResponse = function (response) {
        var cloudResponse = response.data;
        // map taxonomies
        var taxonomies = this.taxonomyMapper.mapTaxonomies(cloudResponse.taxonomies);
        // pagination
        var pagination = new models_1.Pagination({
            skip: cloudResponse.pagination.skip,
            count: cloudResponse.pagination.count,
            limit: cloudResponse.pagination.limit,
            next_page: cloudResponse.pagination.next_page
        });
        return new models_1.TaxonomyResponses.TaxonomiesResponse(taxonomies, pagination, this.mapResponseDebug(response));
    };
    /**
    * Gets response for getting single content type element
    * @param response Response data
    */
    ResponseMapper.prototype.mapElementResponse = function (response) {
        var cloudResponse = response.data;
        // map element
        var element = this.elementMapper.mapElement(cloudResponse);
        return new models_1.ElementResponses.ElementResponse(element, this.mapResponseDebug(response));
    };
    ResponseMapper.prototype.mapResponseDebug = function (response) {
        if (!response) {
            throw Error("Cannot map 'debug' model from the response");
        }
        return {
            response: response.response
        };
    };
    return ResponseMapper;
}());
exports.ResponseMapper = ResponseMapper;
//# sourceMappingURL=response.mapper.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/mappers/taxonomy.mapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/index.js");
var TaxonomyMapper = /** @class */ (function () {
    function TaxonomyMapper() {
    }
    TaxonomyMapper.prototype.mapTaxonomy = function (taxonomySystem, taxonomyTerms) {
        if (!taxonomySystem) {
            throw Error("Cannot map taxonomy due to missing 'system' property");
        }
        if (!taxonomyTerms) {
            throw Error("Cannot map taxonomy due to missing 'terms' property");
        }
        if (!Array.isArray(taxonomyTerms)) {
            throw Error("Cannot map terms because no terms array was provided");
        }
        var mappedSystemAttributes = new models_1.TaxonomySystemAttributes({
            name: taxonomySystem.name,
            codename: taxonomySystem.codename,
            id: taxonomySystem.id,
            lastModified: taxonomySystem.last_modified
        });
        var mappedTerms = this.mapTaxonomyTerms(taxonomyTerms);
        return new models_1.TaxonomyGroup(mappedSystemAttributes, mappedTerms);
    };
    TaxonomyMapper.prototype.mapTaxonomies = function (taxonomies) {
        var _this = this;
        if (!taxonomies) {
            throw Error("Cannot map taxonomy due to missing 'taxonomies' property");
        }
        if (!Array.isArray(taxonomies)) {
            throw Error("Cannot map taxonomies because the 'taxonomies' property is not an array ");
        }
        var mappedTaxonomies = [];
        taxonomies.forEach(function (taxonomy) {
            mappedTaxonomies.push(_this.mapTaxonomy(taxonomy.system, taxonomy.terms));
        });
        return mappedTaxonomies;
    };
    /**
     * Recursively map array of taxonomy terms
     * @param termsArray Terms array to map
     */
    TaxonomyMapper.prototype.mapTaxonomyTerms = function (termsArray) {
        var _this = this;
        if (termsArray.length === 0) {
            return [];
        }
        var mappedTermsArray = [];
        termsArray.forEach(function (terms) {
            var mappedTerms = new models_1.TaxonomyTerms({
                codename: terms.codename,
                name: terms.name,
                terms: _this.mapTaxonomyTerms(terms.terms)
            });
            mappedTermsArray.push(mappedTerms);
        });
        return mappedTermsArray;
    };
    return TaxonomyMapper;
}());
exports.TaxonomyMapper = TaxonomyMapper;
//# sourceMappingURL=taxonomy.mapper.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/mappers/type.mapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/index.js");
var TypeMapper = /** @class */ (function () {
    function TypeMapper() {
    }
    TypeMapper.prototype.mapSingleType = function (response) {
        return this.mapType(response);
    };
    TypeMapper.prototype.mapMultipleTypes = function (response) {
        var that = this;
        return response.types.map(function (type) {
            return that.mapType(type);
        });
    };
    TypeMapper.prototype.mapType = function (type) {
        if (!type) {
            throw Error("Cannot map type");
        }
        if (!type.elements) {
            throw Error("Cannot map type elements");
        }
        var typeSystem = new models_1.ContentTypeSystemAttributes({
            codename: type.system.codename,
            id: type.system.id,
            name: type.system.name,
            lastModified: type.system.last_modified
        });
        var elements = [];
        var elementNames = Object.getOwnPropertyNames(type.elements);
        elementNames.forEach(function (elementName) {
            var typeElement = type.elements[elementName];
            if (!typeElement) {
                throw Error("Cannot find element '" + elementName + "' on type '" + type + "'");
            }
            // use json property as a codename of the type element
            var elementCodename = elementName;
            // extra properties for certain field types
            var taxonomyGroup = typeElement.taxonomy_group;
            var options = [];
            // some elements can contain options
            var rawOptions = typeElement.options;
            if (rawOptions) {
                if (!Array.isArray(rawOptions)) {
                    throw Error("Content type 'options' property has to be an array");
                }
                rawOptions.forEach(function (rawOption) {
                    options.push(new models_1.ElementOption(rawOption.name, rawOption.codename));
                });
            }
            elements.push(new models_1.Element({
                codename: elementCodename,
                taxonomyGroup: taxonomyGroup,
                options: options,
                name: typeElement.name,
                type: typeElement.type
            }));
        });
        return new models_1.ContentType({
            system: typeSystem,
            elements: elements
        });
    };
    return TypeMapper;
}());
exports.TypeMapper = TypeMapper;
//# sourceMappingURL=type.mapper.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/common/cloud-error.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var DeliveryCloudError = /** @class */ (function () {
    function DeliveryCloudError(data) {
        Object.assign(this, data);
    }
    return DeliveryCloudError;
}());
exports.DeliveryCloudError = DeliveryCloudError;
//# sourceMappingURL=cloud-error.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/common/filters.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var Filters;
(function (Filters) {
    var valueSeparator = ',';
    var defaultValue = '';
    var TypeFilter = /** @class */ (function () {
        function TypeFilter(type) {
            this.type = type;
        }
        TypeFilter.prototype.getParam = function () {
            if (Array.isArray(this.type)) {
                // multiple types
                return 'system.type[in]';
            }
            // single type
            return 'system.type';
        };
        TypeFilter.prototype.getParamValue = function () {
            if (!this.type) {
                return defaultValue;
            }
            if (Array.isArray(this.type)) {
                var value = '';
                // use [in] filter
                for (var i = 0; i < this.type.length; i++) {
                    value = value + this.type[i].toString();
                    if (i !== this.type.length - 1) {
                        // append separator if its not last item
                        value = value + valueSeparator;
                    }
                }
                return value;
            }
            // single type was given
            return this.type.toString();
        };
        return TypeFilter;
    }());
    Filters.TypeFilter = TypeFilter;
    var EqualsFilter = /** @class */ (function () {
        function EqualsFilter(field, value) {
            this.field = field;
            this.value = value;
            if (!this.field) {
                throw Error("Field specified in 'EqualsFilter' is undefined ");
            }
        }
        EqualsFilter.prototype.getParam = function () {
            return this.field.trim();
        };
        EqualsFilter.prototype.getParamValue = function () {
            if (!this.value) {
                return defaultValue;
            }
            return this.value;
        };
        return EqualsFilter;
    }());
    Filters.EqualsFilter = EqualsFilter;
    var AllFilter = /** @class */ (function () {
        function AllFilter(field, values) {
            this.field = field;
            this.values = values;
            if (!this.field) {
                throw Error("Field specified in 'AllFilter' is undefined ");
            }
        }
        AllFilter.prototype.getParam = function () {
            return this.field.trim() + "[all]";
        };
        AllFilter.prototype.getParamValue = function () {
            if (!this.values || !Array.isArray(this.values)) {
                return defaultValue;
            }
            return this.values.map(function (m) { return m.trim(); }).join(',');
        };
        return AllFilter;
    }());
    Filters.AllFilter = AllFilter;
    var AnyFilter = /** @class */ (function () {
        function AnyFilter(field, values) {
            this.field = field;
            this.values = values;
            if (!this.field) {
                throw Error("Field specified in 'AnyFilter' is undefined ");
            }
        }
        AnyFilter.prototype.getParam = function () {
            return this.field.trim() + "[any]";
        };
        AnyFilter.prototype.getParamValue = function () {
            if (!this.values || !Array.isArray(this.values)) {
                return defaultValue;
            }
            return this.values.map(function (m) { return m.trim(); }).join(',');
        };
        return AnyFilter;
    }());
    Filters.AnyFilter = AnyFilter;
    var ContainsFilter = /** @class */ (function () {
        function ContainsFilter(field, values) {
            this.field = field;
            this.values = values;
            if (!this.field) {
                throw Error("Field specified in 'ContainsFilter' is undefined ");
            }
        }
        ContainsFilter.prototype.getParam = function () {
            return this.field.trim() + "[contains]";
        };
        ContainsFilter.prototype.getParamValue = function () {
            if (!this.values || !Array.isArray(this.values)) {
                return defaultValue;
            }
            return this.values.map(function (m) { return m.trim(); }).join(',');
        };
        return ContainsFilter;
    }());
    Filters.ContainsFilter = ContainsFilter;
    var GreaterThanFilter = /** @class */ (function () {
        function GreaterThanFilter(field, value) {
            this.field = field;
            this.value = value;
            if (!this.field) {
                throw Error("Field specified in 'GreaterThanFilter' is undefined ");
            }
        }
        GreaterThanFilter.prototype.getParam = function () {
            return this.field.trim() + "[gt]";
        };
        GreaterThanFilter.prototype.getParamValue = function () {
            if (!this.value) {
                return defaultValue;
            }
            return this.value;
        };
        return GreaterThanFilter;
    }());
    Filters.GreaterThanFilter = GreaterThanFilter;
    var GreaterThanOrEqualFilter = /** @class */ (function () {
        function GreaterThanOrEqualFilter(field, value) {
            this.field = field;
            this.value = value;
            if (!this.field) {
                throw Error("Field specified in 'GreaterThanOrEqualFilter' is undefined ");
            }
        }
        GreaterThanOrEqualFilter.prototype.getParam = function () {
            return this.field.trim() + "[gte]";
        };
        GreaterThanOrEqualFilter.prototype.getParamValue = function () {
            if (!this.value) {
                return defaultValue;
            }
            return this.value;
        };
        return GreaterThanOrEqualFilter;
    }());
    Filters.GreaterThanOrEqualFilter = GreaterThanOrEqualFilter;
    var Infilter = /** @class */ (function () {
        function Infilter(field, values) {
            this.field = field;
            this.values = values;
            if (!this.field) {
                throw Error("Field specified in 'Infilter' is undefined");
            }
        }
        Infilter.prototype.getParam = function () {
            return this.field.trim() + "[in]";
        };
        Infilter.prototype.getParamValue = function () {
            if (!this.values || !Array.isArray(this.values)) {
                return defaultValue;
            }
            return this.values.map(function (m) {
                return m.trim();
            }).join(',');
        };
        return Infilter;
    }());
    Filters.Infilter = Infilter;
    var LessThanFilter = /** @class */ (function () {
        function LessThanFilter(field, value) {
            this.field = field;
            this.value = value;
            if (!this.field) {
                throw Error("Field specified in 'LessThanFilter' is undefined ");
            }
        }
        LessThanFilter.prototype.getParam = function () {
            return this.field.trim() + "[lt]";
        };
        LessThanFilter.prototype.getParamValue = function () {
            if (!this.value) {
                return defaultValue;
            }
            return this.value;
        };
        return LessThanFilter;
    }());
    Filters.LessThanFilter = LessThanFilter;
    var LessThanOrEqualFilter = /** @class */ (function () {
        function LessThanOrEqualFilter(field, value) {
            this.field = field;
            this.value = value;
            if (!this.field) {
                throw Error("Field specified in 'LessThanOrEqualFilter' is undefined ");
            }
        }
        LessThanOrEqualFilter.prototype.getParam = function () {
            return this.field.trim() + "[lte]";
        };
        LessThanOrEqualFilter.prototype.getParamValue = function () {
            if (!this.value) {
                return defaultValue;
            }
            return this.value;
        };
        return LessThanOrEqualFilter;
    }());
    Filters.LessThanOrEqualFilter = LessThanOrEqualFilter;
    var RangeFilter = /** @class */ (function () {
        function RangeFilter(field, lowerValue, higherValue) {
            this.field = field;
            this.lowerValue = lowerValue;
            this.higherValue = higherValue;
            if (!this.field) {
                throw Error("Field specified in 'RangeFilter' is undefined ");
            }
            if (lowerValue > higherValue) {
                throw Error("'lowerValue' cannot be higher then 'higherValue' in 'RangeFilter'");
            }
        }
        RangeFilter.prototype.getParam = function () {
            return this.field.trim() + "[range]";
        };
        RangeFilter.prototype.getParamValue = function () {
            var lowerVal = defaultValue;
            var higherVal = defaultValue;
            if (this.lowerValue) {
                lowerVal = this.lowerValue.toString();
            }
            if (this.higherValue) {
                higherVal = this.higherValue.toString();
            }
            return lowerVal + "," + higherVal;
        };
        return RangeFilter;
    }());
    Filters.RangeFilter = RangeFilter;
})(Filters = exports.Filters || (exports.Filters = {}));
//# sourceMappingURL=filters.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/common/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/common/cloud-error.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/common/filters.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/common/pagination.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/common/parameters.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/common/sort-order.enum.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/common/pagination.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var Pagination = /** @class */ (function () {
    function Pagination(data) {
        Object.assign(this, data);
    }
    return Pagination;
}());
exports.Pagination = Pagination;
//# sourceMappingURL=pagination.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/common/parameters.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var sort_order_enum_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/common/sort-order.enum.js");
var Parameters;
(function (Parameters) {
    var defaultValue = '';
    var QueryParameter = /** @class */ (function () {
        /**
        * Custom parameter
        * @constructor
        * @param {string} name - Name of the parameter
        * @param {string} value - Value of the parameter
        */
        function QueryParameter(name, value) {
            this.name = name;
            this.value = value;
            if (!name) {
                throw Error("Name of the custom parameter is not specified");
            }
        }
        QueryParameter.prototype.getParam = function () {
            return this.name;
        };
        QueryParameter.prototype.getParamValue = function () {
            return this.value;
        };
        return QueryParameter;
    }());
    Parameters.QueryParameter = QueryParameter;
    var ElementsParameter = /** @class */ (function () {
        /**
        * Sets elements (projection) so that only certain elements from a content item are returned
        * @constructor
        * @param {string[]} elementCodenames - Array of element codenames to include in response.
        */
        function ElementsParameter(elementCodenames) {
            this.elementCodenames = elementCodenames;
        }
        ElementsParameter.prototype.getParam = function () {
            return 'elements';
        };
        ElementsParameter.prototype.getParamValue = function () {
            if (!this.elementCodenames) {
                return defaultValue;
            }
            return this.elementCodenames.map(function (m) {
                if (!m) {
                    throw Error("Codename of 'ElementsParameter' cannot be null or empty");
                }
                return m.trim();
            }).join(',');
        };
        return ElementsParameter;
    }());
    Parameters.ElementsParameter = ElementsParameter;
    var LimitParameter = /** @class */ (function () {
        /**
        * Limits the number of items that are returned from response
        * @constructor
        * @param {number} limit - Number of elements that will be returned
        */
        function LimitParameter(limit) {
            this.limit = limit;
            if (limit <= 0) {
                throw Error("'LimitParameter' must specify a positive integer");
            }
        }
        LimitParameter.prototype.getParam = function () {
            return 'limit';
        };
        LimitParameter.prototype.getParamValue = function () {
            return this.limit.toString();
        };
        return LimitParameter;
    }());
    Parameters.LimitParameter = LimitParameter;
    var SkipParameter = /** @class */ (function () {
        /**
        * Configures response to skip certain number of items
        * @constructor
        * @param {number} skip - Number of content items that will be skipped
        */
        function SkipParameter(skip) {
            this.skip = skip;
            if (skip < 0) {
                throw Error("'SkipParameter' must specify a positive integer number or zero.\"");
            }
        }
        SkipParameter.prototype.getParam = function () {
            return 'skip';
        };
        SkipParameter.prototype.getParamValue = function () {
            return this.skip.toString();
        };
        return SkipParameter;
    }());
    Parameters.SkipParameter = SkipParameter;
    var OrderParameter = /** @class */ (function () {
        /**
        * Sorts the response based on given field.
        * @constructor
        * @param {string} field - Field that will be used for sorting (can be both elements.<fieldname> or system.<fieldname>)
        * @param {SortOrder} sortOrder - Order type (desc/asc). Defaults to 'asc' if SortOrder is null or invalid.
        */
        function OrderParameter(field, sortOrder) {
            this.field = field;
            this.sortOrder = sortOrder;
            if (!field) {
                throw Error("Field specified in 'OrderParameter' is null or empty");
            }
        }
        OrderParameter.prototype.getParam = function () {
            return 'order';
        };
        OrderParameter.prototype.getParamValue = function () {
            var order;
            if (this.sortOrder === sort_order_enum_1.SortOrder.desc) {
                order = 'desc';
            }
            else {
                order = 'asc';
            }
            return this.field.trim() + "[" + order + "]";
        };
        return OrderParameter;
    }());
    Parameters.OrderParameter = OrderParameter;
    var DepthParameter = /** @class */ (function () {
        /**
        * Configures the depth of the response. Content items might reference modular content items using the Modular content element.
        * Recursively, these modular content items can reference another modular content items.
        * By default, only one level of modular content is returned.
        * @constructor
        * @param {number} depth - Depth fo the response
        */
        function DepthParameter(depth) {
            this.depth = depth;
            if (depth < 0) {
                throw Error("'DepthParameter' must specify a positive integer or zero");
            }
        }
        DepthParameter.prototype.getParam = function () {
            return 'depth';
        };
        DepthParameter.prototype.getParamValue = function () {
            return this.depth.toString();
        };
        return DepthParameter;
    }());
    Parameters.DepthParameter = DepthParameter;
    var LanguageParameter = /** @class */ (function () {
        /**
        * Specifies language version to fetch
        * @constructor
        * @param {string} languageCodename - Codename of the language
        */
        function LanguageParameter(languageCodename) {
            this.languageCodename = languageCodename;
            if (!languageCodename) {
                throw Error("'LanguageParameter' must specify codename of the language");
            }
        }
        LanguageParameter.prototype.getParam = function () {
            return 'language';
        };
        LanguageParameter.prototype.getParamValue = function () {
            return this.languageCodename.trim().toString();
        };
        return LanguageParameter;
    }());
    Parameters.LanguageParameter = LanguageParameter;
})(Parameters = exports.Parameters || (exports.Parameters = {}));
//# sourceMappingURL=parameters.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/common/sort-order.enum.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var SortOrder;
(function (SortOrder) {
    SortOrder[SortOrder["asc"] = 0] = "asc";
    SortOrder[SortOrder["desc"] = 1] = "desc";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
//# sourceMappingURL=sort-order.enum.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/element/element-option.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var ElementOption = /** @class */ (function () {
    function ElementOption(
    /**
     * Name of the option
     */
    name, 
    /**
     * Value of the option
     */
    codename) {
        this.name = name;
        this.codename = codename;
    }
    return ElementOption;
}());
exports.ElementOption = ElementOption;
//# sourceMappingURL=element-option.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/element/element.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var Element = /** @class */ (function () {
    function Element(data) {
        /**
         * Array of options if the field has some
         */
        this.options = [];
        Object.assign(this, data);
    }
    return Element;
}());
exports.Element = Element;
//# sourceMappingURL=element.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/element/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/element/element-option.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/element/element.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/element/responses.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/element/responses.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var ElementResponses;
(function (ElementResponses) {
    var ElementResponse = /** @class */ (function () {
        /**
        * Response containing content type element
        *
        * @constructor
        * @param {Element} element - Content type element
        * @param {ICloudResponseDebug} debug - Debug information from the response
        */
        function ElementResponse(element, debug) {
            this.element = element;
            this.debug = debug;
        }
        return ElementResponse;
    }());
    ElementResponses.ElementResponse = ElementResponse;
})(ElementResponses = exports.ElementResponses || (exports.ElementResponses = {}));
//# sourceMappingURL=responses.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/common/index.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/element/index.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/item/index.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/taxonomy/index.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/type/index.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/item/content-item-system-attributes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var ContentItemSystemAttributes = /** @class */ (function () {
    function ContentItemSystemAttributes(data) {
        Object.assign(this, data);
    }
    return ContentItemSystemAttributes;
}());
exports.ContentItemSystemAttributes = ContentItemSystemAttributes;
//# sourceMappingURL=content-item-system-attributes.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/item/content-item.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var ContentItem = /** @class */ (function () {
    /**
    * Base class representing content item type. All content type models need to extend this class.
    * @constructor
    * @param {(fieldName: string) => string} propertyResolver - Callback used to bind fields returned from Kentico Cloud to a model property. Common usage is to bind e.g. 'FirstName' field from Kentico Cloud response to 'firstName' field in model
    * @param {(link: Link) => string} linkResolver - Callback used to resolve links or URL slug fields
    * @param {(contentItem: ContentItem) => string} richTextResolver - Callback used to resolve modular content in rich text fields to HTML
    */
    function ContentItem(data) {
        this.data = data;
        if (data) {
            Object.assign(this, data);
        }
    }
    return ContentItem;
}());
exports.ContentItem = ContentItem;
//# sourceMappingURL=content-item.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/item/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/item/content-item-system-attributes.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/item/content-item.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/item/link.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/item/responses.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/item/type-resolver.class.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/item/link.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var Link = /** @class */ (function () {
    function Link(data) {
        Object.assign(this, data);
    }
    return Link;
}());
exports.Link = Link;
//# sourceMappingURL=link.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/item/responses.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var ItemResponses;
(function (ItemResponses) {
    var DeliveryItemListingResponse = /** @class */ (function () {
        /**
        * Response containing multiple item
        * @constructor
        * @param {TItem[]} items - Collection of content items
        * @param {Pagination} pagination - Pagination object
        * @param {ICloudResponseDebug} debug - Debug information from the request
        */
        function DeliveryItemListingResponse(items, pagination, debug) {
            this.items = items;
            this.pagination = pagination;
            this.debug = debug;
            this.initIsEmpty();
            this.initFirstAndLastItem();
        }
        DeliveryItemListingResponse.prototype.initIsEmpty = function () {
            if (!this.items) {
                this.isEmpty = true;
            }
            else {
                this.isEmpty = this.items.length <= 0;
            }
        };
        DeliveryItemListingResponse.prototype.initFirstAndLastItem = function () {
            if (!this.items) {
                return;
            }
            if (this.items.length < 1) {
                return;
            }
            this.firstItem = this.items[0];
            this.lastItem = this.items[this.items.length - 1];
        };
        return DeliveryItemListingResponse;
    }());
    ItemResponses.DeliveryItemListingResponse = DeliveryItemListingResponse;
    var DeliveryItemResponse = /** @class */ (function () {
        /**
        * Response containing single item
        * @constructor
        * @param {TItem} item - Returned item
        * @param {ICloudResponseDebug} debug - Debug information from the request
        */
        function DeliveryItemResponse(item, debug) {
            this.item = item;
            this.debug = debug;
            this.initIsEmpty();
        }
        DeliveryItemResponse.prototype.initIsEmpty = function () {
            if (!this.item) {
                this.isEmpty = true;
            }
            else {
                this.isEmpty = false;
            }
        };
        return DeliveryItemResponse;
    }());
    ItemResponses.DeliveryItemResponse = DeliveryItemResponse;
})(ItemResponses = exports.ItemResponses || (exports.ItemResponses = {}));
//# sourceMappingURL=responses.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/item/type-resolver.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var TypeResolver = /** @class */ (function () {
    /**
    * Resolver used to create empty instance of object representing your content item.
    * For example if you create a class 'Character' which corresponds to 'character' code name of Kentico Cloud type, you
    * need to use TypeResolver like: 'new TypeResolver("code_example", () => new CodeExample())'
    * @constructor
    * @param {string} type - Codename of the content item defined in your Kentico Cloud content types
    * @param {() => ContentItem} resolve - Calbacked used to returs empty instance of proper item class
    */
    function TypeResolver(type, resolve) {
        this.type = type;
        this.resolve = resolve;
    }
    return TypeResolver;
}());
exports.TypeResolver = TypeResolver;
//# sourceMappingURL=type-resolver.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/taxonomy/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/taxonomy/responses.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/taxonomy/taxonomy-group.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/taxonomy/taxonomy-system-attributes.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/taxonomy/taxonomy-terms.class.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/taxonomy/responses.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var TaxonomyResponses;
(function (TaxonomyResponses) {
    var TaxonomyResponse = /** @class */ (function () {
        function TaxonomyResponse(
        /**
         * Taxonomy group
         */
        taxonomy, 
        /**
         * Debug information
         */
        debug) {
            this.taxonomy = taxonomy;
            this.debug = debug;
        }
        return TaxonomyResponse;
    }());
    TaxonomyResponses.TaxonomyResponse = TaxonomyResponse;
    var TaxonomiesResponse = /** @class */ (function () {
        function TaxonomiesResponse(
        /**
         * Taxonomies
         */
        taxonomies, 
        /**
         * Pagination
         */
        pagination, 
        /**
         * Debug information
         */
        debug) {
            this.taxonomies = taxonomies;
            this.pagination = pagination;
            this.debug = debug;
        }
        return TaxonomiesResponse;
    }());
    TaxonomyResponses.TaxonomiesResponse = TaxonomiesResponse;
})(TaxonomyResponses = exports.TaxonomyResponses || (exports.TaxonomyResponses = {}));
//# sourceMappingURL=responses.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/taxonomy/taxonomy-group.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var TaxonomyGroup = /** @class */ (function () {
    function TaxonomyGroup(system, terms) {
        this.system = system;
        this.terms = terms;
    }
    return TaxonomyGroup;
}());
exports.TaxonomyGroup = TaxonomyGroup;
//# sourceMappingURL=taxonomy-group.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/taxonomy/taxonomy-system-attributes.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var TaxonomySystemAttributes = /** @class */ (function () {
    function TaxonomySystemAttributes(data) {
        Object.assign(this, data);
    }
    return TaxonomySystemAttributes;
}());
exports.TaxonomySystemAttributes = TaxonomySystemAttributes;
//# sourceMappingURL=taxonomy-system-attributes.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/taxonomy/taxonomy-terms.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var TaxonomyTerms = /** @class */ (function () {
    function TaxonomyTerms(data) {
        Object.assign(this, data);
    }
    return TaxonomyTerms;
}());
exports.TaxonomyTerms = TaxonomyTerms;
//# sourceMappingURL=taxonomy-terms.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/type/content-type-system-attributes.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var ContentTypeSystemAttributes = /** @class */ (function () {
    function ContentTypeSystemAttributes(data) {
        Object.assign(this, data);
    }
    return ContentTypeSystemAttributes;
}());
exports.ContentTypeSystemAttributes = ContentTypeSystemAttributes;
//# sourceMappingURL=content-type-system-attributes.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/type/content-type.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var ContentType = /** @class */ (function () {
    function ContentType(data) {
        Object.assign(this, data);
    }
    return ContentType;
}());
exports.ContentType = ContentType;
//# sourceMappingURL=content-type.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/type/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/type/content-type-system-attributes.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/type/content-type.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/type/responses.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/models/type/responses.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var TypeResponses;
(function (TypeResponses) {
    var DeliveryTypeListingResponse = /** @class */ (function () {
        /**
        * Response containing multiple types
        * @constructor
        * @param {IContentType[]} types - Content types
        * @param {Pagination} pagination - Pagination object
        */
        function DeliveryTypeListingResponse(types, pagination, debug) {
            this.types = types;
            this.pagination = pagination;
            this.debug = debug;
        }
        return DeliveryTypeListingResponse;
    }());
    TypeResponses.DeliveryTypeListingResponse = DeliveryTypeListingResponse;
    var DeliveryTypeResponse = /** @class */ (function () {
        /**
        * Response containing single type
        * @constructor
        * @param {IContentType} type - Content type
        */
        function DeliveryTypeResponse(type, debug) {
            this.type = type;
            this.debug = debug;
        }
        return DeliveryTypeResponse;
    }());
    TypeResponses.DeliveryTypeResponse = DeliveryTypeResponse;
})(TypeResponses = exports.TypeResponses || (exports.TypeResponses = {}));
//# sourceMappingURL=responses.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/parser/adapters/browser-rich-text.parser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var BrowserRichTextParser = /** @class */ (function () {
    function BrowserRichTextParser() {
        this.modularContentWrapperElem = 'div';
        this.modularContent = {
            type: 'application/kenticocloud',
            dataType: 'data-type',
            dataCodename: 'data-codename'
        };
        this.link = {
            nodeName: 'a',
            dataItemId: 'data-item-id'
        };
    }
    BrowserRichTextParser.prototype.resolveRichTextField = function (html, replacement, config) {
        try {
            var doc = this.createWrapperElement(html);
            // get all modular content items
            var result = this.processRichTextField(doc.children, replacement, config, {
                links: [],
                modularContentItems: []
            });
            return {
                links: result.links,
                modularContentItems: result.modularContentItems,
                resolvedHtml: doc.innerHTML
            };
        }
        catch (error) {
            throw Error('Parsing HTML failed:' + error);
        }
    };
    BrowserRichTextParser.prototype.createWrapperElement = function (html) {
        var element = document.createElement(this.modularContentWrapperElem);
        element.innerHTML = html;
        return element;
    };
    BrowserRichTextParser.prototype.processRichTextField = function (htmlCollection, replacement, config, result) {
        if (!htmlCollection || htmlCollection.length === 0) {
            // there are no more nodes
        }
        else {
            // extract objects
            for (var i = 0; i < htmlCollection.length; i++) {
                var element = htmlCollection[i];
                var typeAttribute = element.attributes ? element.attributes.getNamedItem('type') : undefined;
                if (element.attributes && typeAttribute && typeAttribute.value && typeAttribute.value.toLowerCase() === this.modularContent.type.toLowerCase()) {
                    // node is modular content object
                    var dataCodenameAttribute = element.attributes.getNamedItem(this.modularContent.dataCodename);
                    var dataTypeAttribute = element.attributes.getNamedItem(this.modularContent.dataType);
                    var modularItem = {
                        dataCodename: dataCodenameAttribute ? dataCodenameAttribute.value : '',
                        dataType: dataTypeAttribute ? dataTypeAttribute.value : ''
                    };
                    // add to result
                    result.modularContentItems.push(modularItem);
                    // replace html
                    var parentElement = element.parentElement;
                    if (!parentElement) {
                        console.warn("Could not replace modular content '" + modularItem.dataCodename + "' of '" + modularItem.dataType + "' because parent node is null. Please report this error if you are seeing this.");
                    }
                    else {
                        // create new element
                        var newElem = document.createElement(config.modularContentWrapperTag);
                        newElem.innerHTML = replacement.getModularContentHtml(modularItem.dataCodename);
                        // add classes
                        newElem.className = config.modularContentWrapperClasses.map(function (m) { return m; }).join(' ');
                        // remove original object element
                        parentElement.replaceChild(newElem, element);
                    }
                }
                if (element.nodeName.toLowerCase() === this.link.nodeName.toLowerCase()) {
                    var dataItemIdAttribute = element.attributes.getNamedItem(this.link.dataItemId);
                    if (dataItemIdAttribute) {
                        var link = {
                            dataItemId: dataItemIdAttribute ? dataItemIdAttribute.value : ''
                        };
                        // add to result
                        result.links.push(link);
                        var resolvedUrl = replacement.getLinkUrl(link.dataItemId);
                        // add url to link
                        var hrefAttribute = element.attributes.getNamedItem('href');
                        if (!hrefAttribute) {
                            // href attribute is missing
                            if (config.enableAdvancedLogging) {
                                console.warn("Cannot set url '" + resolvedUrl + "' because 'href' attribute is not present in the <a> tag. Please report this issue if you are seeing this.");
                            }
                        }
                        else {
                            hrefAttribute.value = resolvedUrl;
                        }
                    }
                }
                // recursively process child nodes
                if (element.children && element.children.length > 0) {
                    this.processRichTextField(element.children, replacement, config, result);
                }
            }
        }
        return result;
    };
    return BrowserRichTextParser;
}());
exports.BrowserRichTextParser = BrowserRichTextParser;
//# sourceMappingURL=browser-rich-text.parser.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/parser/adapters/node-rich-text.parser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var parse5 = __webpack_require__("./node_modules/parse5/lib/index.js");
var NodeRichTextParser = /** @class */ (function () {
    function NodeRichTextParser() {
        this.modularContentWrapperElem = 'div';
        this.modularContent = {
            type: 'application/kenticocloud',
            dataType: 'data-type',
            dataCodename: 'data-codename'
        };
        this.link = {
            nodeName: 'a',
            dataItemId: 'data-item-id'
        };
    }
    NodeRichTextParser.prototype.resolveRichTextField = function (html, replacement, config) {
        try {
            // create document
            var documentFragment = parse5.parseFragment(html);
            // get all modular content items
            var result = this.processRichTextField(this.getChildNodes(documentFragment), replacement, config, {
                links: [],
                modularContentItems: []
            });
            var resolvedHtml = parse5.serialize(documentFragment);
            return {
                links: result.links,
                modularContentItems: result.modularContentItems,
                resolvedHtml: resolvedHtml
            };
        }
        catch (error) {
            throw Error('Parsing HTML failed:' + error);
        }
    };
    NodeRichTextParser.prototype.processRichTextField = function (elements, replacement, config, result) {
        var _this = this;
        if (!elements || elements.length === 0) {
            // there are no more elements
        }
        else {
            elements.forEach(function (element) {
                if (element.attrs) {
                    // process modular content
                    _this.processModularContent(element, replacement, config, result);
                    // process link
                    _this.processLink(element, replacement, config, result);
                }
                if (element.childNodes) {
                    // recursively process all childs
                    _this.processRichTextField(_this.getChildNodes(element), replacement, config, result);
                }
            });
        }
        return result;
    };
    NodeRichTextParser.prototype.processLink = function (element, replacement, config, result) {
        var _this = this;
        var attributes = element.attrs;
        if (element.nodeName !== this.link.nodeName) {
            // node is not a link
            return;
        }
        // get all links which have item it attribute, ignore all other links (they can be regular links in rich text)
        var dataItemIdAttribute = attributes.find(function (m) { return m.name === _this.link.dataItemId; });
        if (!dataItemIdAttribute) {
            // its either a regular link or the attribute is not defined
            return;
        }
        // get id of content item
        var itemId = dataItemIdAttribute.value;
        var link = {
            dataItemId: dataItemIdAttribute ? dataItemIdAttribute.value : ''
        };
        // add to result
        result.links.push(link);
        var resolvedUrl = replacement.getLinkUrl(link.dataItemId);
        // assign url to 'href' attribute of the link
        var hrefAttribute = attributes.find(function (m) { return m.name === 'href'; });
        if (!hrefAttribute) {
            // href attribute is missing
            if (config.enableAdvancedLogging) {
                console.warn("Cannot set url '" + resolvedUrl + "' because 'href' attribute is not present in the link element");
            }
            return;
        }
        hrefAttribute.value = resolvedUrl;
    };
    NodeRichTextParser.prototype.processModularContent = function (element, replacement, config, result) {
        var _this = this;
        var attributes = element.attrs;
        var dataTypeAttribute = attributes.find(function (m) { return m.value === _this.modularContent.type; });
        if (!dataTypeAttribute) {
            // node is not of modular content type
            return;
        }
        // get codename of the modular content
        var dataCodenameAttribute = attributes.find(function (m) { return m.name === _this.modularContent.dataCodename; });
        if (dataCodenameAttribute == null) {
            throw Error("The '" + this.modularContent.dataCodename + "' attribute is missing and therefore modular content item cannot be retrieved");
        }
        var itemCodename = dataCodenameAttribute.value;
        var modularItem = {
            dataCodename: dataCodenameAttribute ? dataCodenameAttribute.value : '',
            dataType: dataTypeAttribute ? dataTypeAttribute.value : ''
        };
        // add to result
        result.modularContentItems.push(modularItem);
        // get html
        var resultHtml = replacement.getModularContentHtml(itemCodename);
        // replace 'object' tag name
        element.tagName = config.modularContentWrapperTag;
        // add classes
        element.attrs.push({
            name: 'class',
            value: config.modularContentWrapperClasses.map(function (m) { return m; }).join(' ')
        });
        // get serialized set of nodes from HTML
        var serializedChildNodes = parse5.parseFragment(resultHtml);
        // add child nodes
        element.childNodes = serializedChildNodes.childNodes;
    };
    NodeRichTextParser.prototype.getChildNodes = function (documentFragment) {
        return documentFragment.childNodes;
    };
    return NodeRichTextParser;
}());
exports.NodeRichTextParser = NodeRichTextParser;
//# sourceMappingURL=node-rich-text.parser.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/parser/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/parser/parser-adapter.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/parser/parser-adapter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {
exports.__esModule = true;
function getParserAdapter() {
    var parser;
    // Only Node.JS has a process variable that is of [[Class]] process
    if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
        // For node use
        var adapter = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/parser/adapters/node-rich-text.parser.js");
        // instantiate class
        parser = new adapter.NodeRichTextParser();
    }
    else if (typeof XMLHttpRequest !== 'undefined') {
        // For browsers use
        var adapter = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/parser/adapters/browser-rich-text.parser.js");
        // instantiate class
        parser = new adapter.BrowserRichTextParser();
    }
    if (!parser) {
        throw Error("Invalid or unsupported parser adapter");
    }
    return parser;
}
exports.getParserAdapter = getParserAdapter;
//# sourceMappingURL=parser-adapter.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/query/common/base-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/index.js");
var BaseQuery = /** @class */ (function () {
    function BaseQuery(config, queryService) {
        this.config = config;
        this.queryService = queryService;
        this.parameters = [];
    }
    /**
     * Adds parameter to query
     * @param name Name of parameter
     * @param value Value of parameter
     */
    BaseQuery.prototype.withParameter = function (name, value) {
        this.parameters.push(new models_1.Parameters.QueryParameter(name, value));
        return this;
    };
    /**
    * Gets headers used by this query
    */
    BaseQuery.prototype.getHeaders = function () {
        return this.queryService.getHeaders(this._queryConfig);
    };
    BaseQuery.prototype.withUrl = function (url) {
        this.customUrl = url;
        return this;
    };
    BaseQuery.prototype.getParameters = function () {
        return this.parameters;
    };
    BaseQuery.prototype.getPromise = function () {
        return this.getObservable().toPromise();
    };
    BaseQuery.prototype.resolveUrlInternal = function (action) {
        // use custom URL if user specified it
        if (this.customUrl) {
            return this.customUrl;
        }
        // use original url
        return this.queryService.getUrl(action, this._queryConfig, this.getParameters());
    };
    return BaseQuery;
}());
exports.BaseQuery = BaseQuery;
//# sourceMappingURL=base-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/query/element/base-element-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var base_query_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/common/base-query.class.js");
var BaseElementQuery = /** @class */ (function (_super) {
    __extends(BaseElementQuery, _super);
    function BaseElementQuery(config, queryService) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        _this._queryConfig = {};
        return _this;
    }
    /**
     * Use to configure query
     * @param queryConfig Query configuration
     */
    BaseElementQuery.prototype.queryConfig = function (queryConfig) {
        this._queryConfig = queryConfig;
        return this;
    };
    /**
     * Gets headers used by this query
     */
    BaseElementQuery.prototype.getHeaders = function () {
        return this.queryService.getHeaders(this._queryConfig);
    };
    BaseElementQuery.prototype.getElementQueryUrl = function (typeCodename, elementCodename) {
        var action = '/types/' + typeCodename + '/elements/' + elementCodename;
        return _super.prototype.resolveUrlInternal.call(this, action);
    };
    BaseElementQuery.prototype.runElementQuery = function (typeCodename, elementCodename) {
        return this.queryService.getElement(this.getElementQueryUrl(typeCodename, elementCodename), this._queryConfig);
    };
    return BaseElementQuery;
}(base_query_class_1.BaseQuery));
exports.BaseElementQuery = BaseElementQuery;
//# sourceMappingURL=base-element-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/query/element/element-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var base_element_query_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/element/base-element-query.class.js");
var ElementQuery = /** @class */ (function (_super) {
    __extends(ElementQuery, _super);
    function ElementQuery(config, queryService, typeCodename, elementCodename) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        _this.typeCodename = typeCodename;
        _this.elementCodename = elementCodename;
        if (!typeCodename) {
            throw Error("Codename of the type has to be provided");
        }
        if (!elementCodename) {
            throw Error("Codename of the element has to be provided");
        }
        return _this;
    }
    /**
    * Gets the runnable Observable
    */
    ElementQuery.prototype.getObservable = function () {
        return _super.prototype.runElementQuery.call(this, this.typeCodename, this.elementCodename);
    };
    /**
    * Gets 'Url' representation of query
    */
    ElementQuery.prototype.getUrl = function () {
        return _super.prototype.getElementQueryUrl.call(this, this.typeCodename, this.elementCodename);
    };
    return ElementQuery;
}(base_element_query_class_1.BaseElementQuery));
exports.ElementQuery = ElementQuery;
//# sourceMappingURL=element-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/query/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/common/base-query.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/element/base-element-query.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/element/element-query.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/item/base-item-query.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/item/multiple-item-query.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/item/single-item-query.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/taxonomy/base-taxonomy-query.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/taxonomy/taxonomies-query.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/taxonomy/taxonomy-query.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/type/base-type-query.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/type/multiple-type-query.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/type/single-type-query.class.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/query/item/base-item-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/index.js");
var base_query_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/common/base-query.class.js");
var BaseItemQuery = /** @class */ (function (_super) {
    __extends(BaseItemQuery, _super);
    function BaseItemQuery(config, queryService) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        _this._queryConfig = {};
        return _this;
    }
    /**
     * Used to configure query
     * @param queryConfig Query configuration
     */
    BaseItemQuery.prototype.queryConfig = function (queryConfig) {
        this._queryConfig = queryConfig;
        return this;
    };
    /**
     * Language codename
     * @param languageCodename Codename of the language
     */
    BaseItemQuery.prototype.languageParameter = function (languageCodename) {
        this.parameters.push(new models_1.Parameters.LanguageParameter(languageCodename));
        return this;
    };
    /**
     * Used to limit the number of elements returned by query.
     * @param elementCodenames Array of element codenames to fetch
     */
    BaseItemQuery.prototype.elementsParameter = function (elementCodenames) {
        this.parameters.push(new models_1.Parameters.ElementsParameter(elementCodenames));
        return this;
    };
    /**
     * Indicates how deep nested modular content items are resolved.
     * @param depth Depth of the query (> 0)
     */
    BaseItemQuery.prototype.depthParameter = function (depth) {
        this.parameters.push(new models_1.Parameters.DepthParameter(depth));
        return this;
    };
    BaseItemQuery.prototype.getMultipleItemsQueryUrl = function () {
        var action = '/items';
        // add default language is necessry
        this.processDefaultLanguageParameter();
        return _super.prototype.resolveUrlInternal.call(this, action);
    };
    BaseItemQuery.prototype.getSingleItemQueryUrl = function (codename) {
        var action = '/items/' + codename;
        // add default language is necessry
        this.processDefaultLanguageParameter();
        return _super.prototype.resolveUrlInternal.call(this, action);
    };
    BaseItemQuery.prototype.runMultipleItemsQuery = function () {
        var url = this.getMultipleItemsQueryUrl();
        return this.queryService.getMultipleItems(url, this._queryConfig);
    };
    BaseItemQuery.prototype.runSingleItemQuery = function (codename) {
        var url = this.getSingleItemQueryUrl(codename);
        return this.queryService.getSingleItem(url, this._queryConfig);
    };
    BaseItemQuery.prototype.processDefaultLanguageParameter = function () {
        // add default language if none is specified && default language is specified globally
        if (this.config.defaultLanguage) {
            var languageParameter = this.getParameters().find(function (m) { return m.getParam() === 'language'; });
            if (!languageParameter) {
                // language parameter was not specified in query, use globally defined language
                this.parameters.push(new models_1.Parameters.LanguageParameter(this.config.defaultLanguage));
            }
        }
    };
    return BaseItemQuery;
}(base_query_class_1.BaseQuery));
exports.BaseItemQuery = BaseItemQuery;
//# sourceMappingURL=base-item-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/query/item/multiple-item-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/index.js");
var base_item_query_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/item/base-item-query.class.js");
var MultipleItemQuery = /** @class */ (function (_super) {
    __extends(MultipleItemQuery, _super);
    function MultipleItemQuery(config, queryService) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        return _this;
    }
    /**
     * Gets only item of given type
     * @param type Codename of type to get
     */
    MultipleItemQuery.prototype.type = function (type) {
        this.parameters.push(new models_1.Filters.TypeFilter(type));
        return this;
    };
    /**
     * Gets items of given types (logical or)
     * I.e. get items of either 'Actor' or 'Movie' type
     * @param types Types to get
     */
    MultipleItemQuery.prototype.types = function (types) {
        this.parameters.push(new models_1.Filters.TypeFilter(types));
        return this;
    };
    // filters
    /**
     * Equals filter condition
     * @param field Element to filter. Example: 'elements.movie'
     * @param value Value to match. Example: 'Kingsman'
     */
    MultipleItemQuery.prototype.equalsFilter = function (field, value) {
        this.parameters.push(new models_1.Filters.EqualsFilter(field, value));
        return this;
    };
    /**
     * All filter
     * @param field Element to filter.
     * @param values Values
     */
    MultipleItemQuery.prototype.allFilter = function (field, values) {
        this.parameters.push(new models_1.Filters.AllFilter(field, values));
        return this;
    };
    /**
     * Any filter
     * @param field Element to filter.
     * @param values Values
     */
    MultipleItemQuery.prototype.anyFilter = function (field, values) {
        this.parameters.push(new models_1.Filters.AnyFilter(field, values));
        return this;
    };
    /**
     * Contains filter
     * @param field Element to filter.
     * @param values Values
     */
    MultipleItemQuery.prototype.containsFilter = function (field, values) {
        this.parameters.push(new models_1.Filters.ContainsFilter(field, values));
        return this;
    };
    /**
     * Greater then filter
     * @param field Element to filter.
     * @param value Value
     */
    MultipleItemQuery.prototype.greaterThanFilter = function (field, value) {
        this.parameters.push(new models_1.Filters.GreaterThanFilter(field, value));
        return this;
    };
    /**
     * Greater then or equals filter
     * @param field Element to filter.
     * @param value Value
     */
    MultipleItemQuery.prototype.greaterThanOrEqualFilter = function (field, value) {
        this.parameters.push(new models_1.Filters.GreaterThanOrEqualFilter(field, value));
        return this;
    };
    /**
     * In filter
     * @param field Element to filter.
     * @param values Values
     */
    MultipleItemQuery.prototype.inFilter = function (field, values) {
        this.parameters.push(new models_1.Filters.Infilter(field, values));
        return this;
    };
    /**
     * Less then filter
     * @param field Element to filter.
     * @param value Value
     */
    MultipleItemQuery.prototype.lessThanFilter = function (field, value) {
        this.parameters.push(new models_1.Filters.LessThanFilter(field, value));
        return this;
    };
    /**
     * @param field Element to filter.
     * @param value Value
     */
    MultipleItemQuery.prototype.lessThanOrEqualFilter = function (field, value) {
        this.parameters.push(new models_1.Filters.LessThanOrEqualFilter(field, value));
        return this;
    };
    /**
     * @param field Element to filter.
     * @param lowerValue Lower value of range (e.g. 2)
     * @param higherValue Higher value of range (e.g. 10)
     */
    MultipleItemQuery.prototype.rangeFilter = function (field, lowerValue, higherValue) {
        this.parameters.push(new models_1.Filters.RangeFilter(field, lowerValue, higherValue));
        return this;
    };
    /**
     * Limits the number of items returned by query
     * @param limit Number of items to load
     */
    MultipleItemQuery.prototype.limitParameter = function (limit) {
        this.parameters.push(new models_1.Parameters.LimitParameter(limit));
        return this;
    };
    /**
     * Orders query based on given field and sort order
     * @param field Element by which to order
     * @param sortOrder Asc/Desc order type
     */
    MultipleItemQuery.prototype.orderParameter = function (field, sortOrder) {
        this.parameters.push(new models_1.Parameters.OrderParameter(field, sortOrder));
        return this;
    };
    /**
     * Skips the selected number of items
     * @param skip Number of items to skip
     */
    MultipleItemQuery.prototype.skipParameter = function (skip) {
        this.parameters.push(new models_1.Parameters.SkipParameter(skip));
        return this;
    };
    /**
     * Gets the runnable Observable
     */
    MultipleItemQuery.prototype.getObservable = function () {
        return _super.prototype.runMultipleItemsQuery.call(this);
    };
    /**
     * Gets 'Url' representation of query
     */
    MultipleItemQuery.prototype.getUrl = function () {
        return _super.prototype.getMultipleItemsQueryUrl.call(this);
    };
    return MultipleItemQuery;
}(base_item_query_class_1.BaseItemQuery));
exports.MultipleItemQuery = MultipleItemQuery;
//# sourceMappingURL=multiple-item-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/query/item/single-item-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var base_item_query_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/item/base-item-query.class.js");
var SingleItemQuery = /** @class */ (function (_super) {
    __extends(SingleItemQuery, _super);
    function SingleItemQuery(config, queryService, codename) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        _this.codename = codename;
        if (!codename) {
            throw Error("'codename' has to be configured for 'SingleItemQuery' query");
        }
        return _this;
    }
    /**
    * Gets the runnable Observable
    */
    SingleItemQuery.prototype.getObservable = function () {
        return _super.prototype.runSingleItemQuery.call(this, this.codename);
    };
    /**
    * Gets 'Url' representation of query
    */
    SingleItemQuery.prototype.getUrl = function () {
        return _super.prototype.getSingleItemQueryUrl.call(this, this.codename);
    };
    return SingleItemQuery;
}(base_item_query_class_1.BaseItemQuery));
exports.SingleItemQuery = SingleItemQuery;
//# sourceMappingURL=single-item-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/query/taxonomy/base-taxonomy-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var base_query_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/common/base-query.class.js");
var BaseTaxonomyQuery = /** @class */ (function (_super) {
    __extends(BaseTaxonomyQuery, _super);
    function BaseTaxonomyQuery(config, queryService) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        /**
         * Taxonomies endpoint URL action
         */
        _this.taxonomiesEndpoint = 'taxonomies';
        /**
         * Query configuration
         */
        _this._queryConfig = {};
        return _this;
    }
    /**
     * Used to configure query
     * @param queryConfig Query configuration
     */
    BaseTaxonomyQuery.prototype.queryConfig = function (queryConfig) {
        this._queryConfig = queryConfig;
        return this;
    };
    /**
     * Gets headers used by this query
     */
    BaseTaxonomyQuery.prototype.getHeaders = function () {
        return this.queryService.getHeaders(this._queryConfig);
    };
    BaseTaxonomyQuery.prototype.getTaxonomyQueryUrl = function (taxonomyCodename) {
        var action = '/' + this.taxonomiesEndpoint + '/' + taxonomyCodename;
        return _super.prototype.resolveUrlInternal.call(this, action);
    };
    BaseTaxonomyQuery.prototype.getTaxonomiesQueryUrl = function () {
        var action = '/' + this.taxonomiesEndpoint;
        return _super.prototype.resolveUrlInternal.call(this, action);
    };
    BaseTaxonomyQuery.prototype.runTaxonomyQuery = function (codename) {
        return this.queryService.getTaxonomy(this.getTaxonomyQueryUrl(codename), this._queryConfig);
    };
    BaseTaxonomyQuery.prototype.runTaxonomiesQuery = function () {
        return this.queryService.getTaxonomies(this.getTaxonomiesQueryUrl(), this._queryConfig);
    };
    return BaseTaxonomyQuery;
}(base_query_class_1.BaseQuery));
exports.BaseTaxonomyQuery = BaseTaxonomyQuery;
//# sourceMappingURL=base-taxonomy-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/query/taxonomy/taxonomies-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/index.js");
var base_taxonomy_query_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/taxonomy/base-taxonomy-query.class.js");
var TaxonomiesQuery = /** @class */ (function (_super) {
    __extends(TaxonomiesQuery, _super);
    function TaxonomiesQuery(config, queryService) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        return _this;
    }
    /**
    * Limits the number of taxonomies returned by query
    * @param limit Number of taxonomies to load
    */
    TaxonomiesQuery.prototype.limitParameter = function (limit) {
        this.parameters.push(new models_1.Parameters.LimitParameter(limit));
        return this;
    };
    /**
    * Skips the selected number of taxonomies
    * @param skip Number of taxonomies to skip
    */
    TaxonomiesQuery.prototype.skipParameter = function (skip) {
        this.parameters.push(new models_1.Parameters.SkipParameter(skip));
        return this;
    };
    /**
    * Gets the runnable Observable
    */
    TaxonomiesQuery.prototype.getObservable = function () {
        return _super.prototype.runTaxonomiesQuery.call(this);
    };
    // debug
    /**
    * Gets 'Url' representation of query
    */
    TaxonomiesQuery.prototype.getUrl = function () {
        return _super.prototype.getTaxonomiesQueryUrl.call(this);
    };
    return TaxonomiesQuery;
}(base_taxonomy_query_class_1.BaseTaxonomyQuery));
exports.TaxonomiesQuery = TaxonomiesQuery;
//# sourceMappingURL=taxonomies-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/query/taxonomy/taxonomy-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var base_taxonomy_query_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/taxonomy/base-taxonomy-query.class.js");
var TaxonomyQuery = /** @class */ (function (_super) {
    __extends(TaxonomyQuery, _super);
    function TaxonomyQuery(config, queryService, taxonomyCodename) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        _this.taxonomyCodename = taxonomyCodename;
        if (!taxonomyCodename) {
            throw Error("Cannot create taxonomy query without codename of the taxonomy");
        }
        return _this;
    }
    /**
    * Gets the runnable Observable
    */
    TaxonomyQuery.prototype.getObservable = function () {
        return _super.prototype.runTaxonomyQuery.call(this, this.taxonomyCodename);
    };
    /**
    * Gets 'Url' representation of query
    */
    TaxonomyQuery.prototype.getUrl = function () {
        return _super.prototype.getTaxonomyQueryUrl.call(this, this.taxonomyCodename);
    };
    return TaxonomyQuery;
}(base_taxonomy_query_class_1.BaseTaxonomyQuery));
exports.TaxonomyQuery = TaxonomyQuery;
//# sourceMappingURL=taxonomy-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/query/type/base-type-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var base_query_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/common/base-query.class.js");
var BaseTypeQuery = /** @class */ (function (_super) {
    __extends(BaseTypeQuery, _super);
    function BaseTypeQuery(config, queryService) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        _this.parameters = [];
        _this._queryConfig = {};
        return _this;
    }
    /**
     * Used to configure query
     * @param queryConfig Query configuration
     */
    BaseTypeQuery.prototype.queryConfig = function (queryConfig) {
        this._queryConfig = queryConfig;
        return this;
    };
    /**
     * Gets headers used by this query
     */
    BaseTypeQuery.prototype.getHeaders = function () {
        return this.queryService.getHeaders(this._queryConfig);
    };
    BaseTypeQuery.prototype.getSingleTypeQueryUrl = function (codename) {
        var action = '/types/' + codename;
        return _super.prototype.resolveUrlInternal.call(this, action);
    };
    BaseTypeQuery.prototype.getMultipleTypesQueryUrl = function () {
        var action = '/types';
        return _super.prototype.resolveUrlInternal.call(this, action);
    };
    BaseTypeQuery.prototype.runMultipleTypesQuery = function () {
        return this.queryService.getMultipleTypes(this.getMultipleTypesQueryUrl(), this._queryConfig);
    };
    BaseTypeQuery.prototype.runSingleTypeQuery = function (codename) {
        return this.queryService.getSingleType(this.getSingleTypeQueryUrl(codename), this._queryConfig);
    };
    return BaseTypeQuery;
}(base_query_class_1.BaseQuery));
exports.BaseTypeQuery = BaseTypeQuery;
//# sourceMappingURL=base-type-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/query/type/multiple-type-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/index.js");
var base_type_query_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/type/base-type-query.class.js");
var MultipleTypeQuery = /** @class */ (function (_super) {
    __extends(MultipleTypeQuery, _super);
    function MultipleTypeQuery(config, queryService) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        return _this;
    }
    /**
    * Limits the number of types returned by query
    * @param limit Number of types to load
    */
    MultipleTypeQuery.prototype.limitParameter = function (limit) {
        this.parameters.push(new models_1.Parameters.LimitParameter(limit));
        return this;
    };
    /**
     * Skips the selected number of types
     * @param skip Number of types to skip
     */
    MultipleTypeQuery.prototype.skipParameter = function (skip) {
        this.parameters.push(new models_1.Parameters.SkipParameter(skip));
        return this;
    };
    /**
    * Gets the runnable Observable
    */
    MultipleTypeQuery.prototype.getObservable = function () {
        return _super.prototype.runMultipleTypesQuery.call(this);
    };
    /**
    * Gets 'Url' representation of query
    */
    MultipleTypeQuery.prototype.getUrl = function () {
        return _super.prototype.getMultipleTypesQueryUrl.call(this);
    };
    return MultipleTypeQuery;
}(base_type_query_class_1.BaseTypeQuery));
exports.MultipleTypeQuery = MultipleTypeQuery;
//# sourceMappingURL=multiple-type-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/query/type/single-type-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var base_type_query_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/query/type/base-type-query.class.js");
var SingleTypeQuery = /** @class */ (function (_super) {
    __extends(SingleTypeQuery, _super);
    function SingleTypeQuery(config, queryService, typeCodename) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        _this.typeCodename = typeCodename;
        if (!typeCodename) {
            throw Error("Cannot create type query without the codename of the type");
        }
        return _this;
    }
    /**
    * Gets the runnable Observable
    */
    SingleTypeQuery.prototype.getObservable = function () {
        return _super.prototype.runSingleTypeQuery.call(this, this.typeCodename);
    };
    /**
    * Gets 'Url' representation of query
    */
    SingleTypeQuery.prototype.getUrl = function () {
        return _super.prototype.getSingleTypeQueryUrl.call(this, this.typeCodename);
    };
    return SingleTypeQuery;
}(base_type_query_class_1.BaseTypeQuery));
exports.SingleTypeQuery = SingleTypeQuery;
//# sourceMappingURL=single-type-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/resolvers/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/resolvers/strongly-type.resolver.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/resolvers/rich-text.resolver.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/resolvers/url-slug.resolver.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/resolvers/rich-text.resolver.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var strongly_type_resolver_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/resolvers/strongly-type.resolver.js");
var RichTextResolver = /** @class */ (function () {
    function RichTextResolver() {
        /**
        * Type identifying nested modular content in Rich text fields
        */
        this.modularContentobjectType = 'application/kenticocloud';
        /**
         * This tag wil be used instead of 'object'
         */
        this.modularContentTagWrapper = 'div';
        /**
         * Attribute used to identify modular item based on its codename
         */
        this.modularContentCodenameAttributeName = 'data-codename';
        /**
         * Tag identifying links
         */
        this.linkTag = 'a';
        /**
         * Attributes that identifies if of the content item referenced in links
         */
        this.linkContentItemIdAttributeName = 'data-item-id';
    }
    /**
     * Resolves modular content inside the Rich text field.
     * Rich text resolved needs to be configured either on the model or query level
     */
    RichTextResolver.prototype.resolveHtml = function (html, data) {
        var _this = this;
        // prepare config
        var config = {
            enableAdvancedLogging: data.enableAdvancedLogging,
            queryConfig: data.queryConfig,
            modularContentWrapperTag: data.modularContentWrapperTag,
            modularContentWrapperClasses: data.modularContentWrapperClasses
        };
        var result = data.richTextHtmlParser.resolveRichTextField(html, {
            getLinkUrl: function (itemId) { return _this.getLinkUrl({
                config: config,
                links: data.links,
                itemId: itemId,
                typeResolvers: data.typeResolvers
            }); },
            getModularContentHtml: function (itemCodename) { return _this.getHtmlOfModularContent({
                itemCodename: itemCodename,
                config: config,
                modularItems: data.modularItems
            }); }
        }, {
            enableAdvancedLogging: data.enableAdvancedLogging,
            queryConfig: data.queryConfig,
            modularContentWrapperTag: data.modularContentWrapperTag,
            modularContentWrapperClasses: data.modularContentWrapperClasses
        });
        return result.resolvedHtml;
    };
    RichTextResolver.prototype.getHtmlOfModularContent = function (data) {
        // get modular content item
        var modularContentItem = data.modularItems.find(function (m) { return m.system.codename === data.itemCodename; });
        // check if modular content really exists
        if (!modularContentItem) {
            throw Error("Cannot resolve modular content in 'RichTextField' for '" + data.itemCodename + "' content item");
        }
        // create new replacement object
        // get html to replace object using Rich text resolver function
        var resolver = undefined;
        if (data.config.queryConfig.richTextResolver) {
            // use resolved defined by query if available
            resolver = data.config.queryConfig.richTextResolver;
        }
        else {
            // use default resolver defined in models
            if (modularContentItem.richTextResolver) {
                resolver = modularContentItem.richTextResolver;
            }
        }
        // check resolver
        if (!resolver) {
            if (data.config.enableAdvancedLogging) {
                console.warn("Cannot resolve modular content of '" + modularContentItem.system.type + "' type in 'RichTextField' because no rich text resolved was configured");
                return '';
            }
            return '';
        }
        return resolver(modularContentItem);
    };
    RichTextResolver.prototype.getLinkUrl = function (data) {
        // find link with the id of content item
        var link = data.links.find(function (m) { return m.itemId === data.itemId; });
        if (!link) {
            if (data.config.enableAdvancedLogging) {
                console.warn("Cannot resolve URL for item '" + data.itemId + "' because no link with this id was found");
            }
            return '';
        }
        // try to resolve link using the resolver passed through the query config
        var queryLinkResolver = data.config.queryConfig.linkResolver;
        var url;
        if (queryLinkResolver) {
            // try to resolve url using the query config
            url = queryLinkResolver(link);
        }
        if (!url) {
            // url was not resolved, try to find global resolver for this particular type
            var emptyTypedItem = strongly_type_resolver_1.stronglyTypedResolver.createEmptyTypedObj(link.type, data.typeResolvers);
            if (!emptyTypedItem) {
                if (data.config.enableAdvancedLogging) {
                    console.warn("Cannot resolve link for link of '" + link.type + "' type with id '" + link.itemId + "' and url slug '" + link.urlSlug + "'");
                }
            }
            else {
                var globalLinkResolver = emptyTypedItem.linkResolver;
                if (globalLinkResolver) {
                    url = globalLinkResolver(link);
                }
            }
        }
        // url still wasn't resolved
        if (!url) {
            if (data.config.enableAdvancedLogging) {
                console.warn("Url for content type '" + link.type + "' with id '" + link.itemId + "' resolved to null/undefined");
            }
            return '';
        }
        return url;
    };
    return RichTextResolver;
}());
exports.RichTextResolver = RichTextResolver;
exports.richTextResolver = new RichTextResolver();
//# sourceMappingURL=rich-text.resolver.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/resolvers/strongly-type.resolver.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var content_item_system_attributes_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/item/content-item-system-attributes.js");
var content_item_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/item/content-item.class.js");
var StronglyTypedResolver = /** @class */ (function () {
    function StronglyTypedResolver() {
    }
    /**
     * Indicates if given type has a type resolver
     * @param type Type
     * @param resolvers Type resolvers
     */
    StronglyTypedResolver.prototype.hasTypeResolver = function (type, resolvers) {
        return !(!resolvers.find(function (m) { return m.type === type; }));
    };
    /**
     * Creates non generic ContentItem used when content type does not have a strongly typed model
     */
    StronglyTypedResolver.prototype.createContentItem = function (item) {
        var contentItem = new content_item_class_1.ContentItem();
        // use typed 'system' property
        contentItem.system = new content_item_system_attributes_1.ContentItemSystemAttributes({
            name: item.system.name,
            codename: item.system.codename,
            id: item.system.id,
            lastModified: item.system.last_modified,
            language: item.system.language,
            type: item.system.type,
            sitemapLocations: item.system.sitemap_locations
        });
        return contentItem;
    };
    /**
     * Takes given type name and creates a strongly typed model based specified in client configuration
     * @param type Type of the content item
     * @param item Typed content item
     * @param resolvers Type resolvers
     */
    StronglyTypedResolver.prototype.createTypedObj = function (type, item, typeResolvers) {
        var typedItem = this.createEmptyTypedObj(type, typeResolvers);
        if (!typedItem) {
            throw Error("Cannot find resolver for type '" + type + "'. This error means that no class was registered as TypeResolver");
        }
        // use typed 'system' property
        typedItem.system = new content_item_system_attributes_1.ContentItemSystemAttributes({
            name: item.system.name,
            codename: item.system.codename,
            id: item.system.id,
            lastModified: item.system.last_modified,
            language: item.system.language,
            type: item.system.type,
            sitemapLocations: item.system.sitemap_locations
        });
        return typedItem;
    };
    /**
     * Creates empty typed object of given type
     * @param type Type of the content item
     * @param resolvers Type resolvers
     */
    StronglyTypedResolver.prototype.createEmptyTypedObj = function (type, resolvers) {
        if (!type) {
            throw Error('Cannot resolve type because no type name was provided');
        }
        var typeResolver = resolvers.find(function (m) { return m.type === type; });
        if (!typeResolver) {
            return undefined;
        }
        return typeResolver.resolve();
    };
    return StronglyTypedResolver;
}());
exports.StronglyTypedResolver = StronglyTypedResolver;
exports.stronglyTypedResolver = new StronglyTypedResolver();
//# sourceMappingURL=strongly-type.resolver.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/resolvers/url-slug.resolver.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/index.js");
var UrlSlugResolver = /** @class */ (function () {
    function UrlSlugResolver() {
    }
    UrlSlugResolver.prototype.resolveUrl = function (data) {
        if (!data.linkResolver) {
            if (data.enableAdvancedLogging) {
                console.warn("You have to implement 'linkResolver' in your Model class or your query in order to get url of this item");
            }
            return undefined;
        }
        if (!data.item) {
            if (data.enableAdvancedLogging) {
                console.warn("Cannot resolve link for field '" + data.fieldName + "' because no item was provided to URL slug field (item may be missing from response)");
            }
            return undefined;
        }
        var url = data.linkResolver(new models_1.Link({
            urlSlug: data.fieldValue,
            type: data.type,
            codename: data.item.system.codename,
            itemId: data.item.system.id
        }));
        if (!url) {
            if (data.enableAdvancedLogging) {
                console.warn("'linkResolver' is configured, but url resolved for '" + data.item.system.codename + "' item of '" + data.item.system.type + "' type inside '" + data.fieldName + "' field resolved to an undefined url.");
            }
            return undefined;
        }
        return url;
    };
    return UrlSlugResolver;
}());
exports.UrlSlugResolver = UrlSlugResolver;
exports.urlSlugResolver = new UrlSlugResolver();
//# sourceMappingURL=url-slug.resolver.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/sdk-info.generated.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
exports.sdkInfo = {
    host: 'npmjs.com',
    version: '4.1.0',
    name: 'kentico-cloud-delivery'
};
//# sourceMappingURL=sdk-info.generated.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/services/http/delivery-http-service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var axios_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/index.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/_esm5/index.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/_esm5/operators/index.js");
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/models/index.js");
var KCErrorNames = {
    errorCode: 'error_code',
    message: 'message',
    requestId: 'request_id',
    specificCode: 'specific_code'
};
var DeliveryHttpService = /** @class */ (function () {
    function DeliveryHttpService() {
    }
    DeliveryHttpService.prototype.get = function (url, headers) {
        return rxjs_1.from(axios_1["default"].get(url, {
            headers: this.getHeadersJson(headers)
        })).pipe(operators_1.map(function (response) {
            return {
                data: response.data,
                response: response
            };
        }), operators_1.catchError(function (error) {
            // Handling errors: https://github.com/axios/axios#handling-errors
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                var cloudError = void 0;
                var data = error.response.data;
                if (data[KCErrorNames.requestId]) {
                    cloudError = new models_1.DeliveryCloudError({
                        requestId: data[KCErrorNames.requestId],
                        message: data[KCErrorNames.message] ? data[KCErrorNames.message] : '',
                        errorCode: data[KCErrorNames.errorCode] ? data[KCErrorNames.errorCode] : 0,
                        specificCode: data[KCErrorNames.specificCode] ? data[KCErrorNames.specificCode] : 0
                    });
                }
                return rxjs_1.throwError({
                    message: error.message,
                    originalError: error,
                    cloudError: cloudError
                });
            }
            else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                return rxjs_1.throwError({
                    message: error.message,
                    originalError: error
                });
            }
            // Something happened in setting up the request that triggered an Error
            return rxjs_1.throwError({
                message: error.message,
                originalError: error
            });
        }));
    };
    DeliveryHttpService.prototype.getHeadersJson = function (headers) {
        var headerJson = {
            'Content-Type': 'application/json'
        };
        if (!headers) {
            return headerJson;
        }
        headers.forEach(function (header) {
            headerJson[header.header] = header.value;
        });
        return headerJson;
    };
    return DeliveryHttpService;
}());
exports.DeliveryHttpService = DeliveryHttpService;
//# sourceMappingURL=delivery-http-service.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/services/http/delivery-retry-strategy.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var rxjs_1 = __webpack_require__("./node_modules/rxjs/_esm5/index.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/_esm5/operators/index.js");
var DeliveryRetryStrategy = /** @class */ (function () {
    function DeliveryRetryStrategy() {
        var _this = this;
        this.strategy = function (options) { return function (attempts) {
            return attempts.pipe(operators_1.mergeMap(function (error, i) {
                var retryAttempt = i + 1;
                // if maximum number of retries have been met
                // or response is a status code we don't wish to retry, throw error
                if (retryAttempt > options.maxRetryAttempts ||
                    options.excludedStatusCodes.find(function (e) { return e === error.status; })) {
                    return rxjs_1.throwError(error);
                }
                // calculate retry time
                var retryTimeout = _this.getRetryTimeout(retryAttempt);
                // debug log attempt
                _this.debugLogAttempt(retryAttempt, retryTimeout);
                return rxjs_1.timer(retryTimeout);
            }));
        }; };
    }
    /**
    * Calculates retry attempt timeout in ms
    * @param attempt Index of the attempt to calculate increasing delay when retrying
    */
    DeliveryRetryStrategy.prototype.getRetryTimeout = function (attempt) {
        return Math.pow(2, attempt) * 100;
    };
    /**
     * Logs attempt in console.
     * This function is also used for testing in jasmine spy
     * @param attempt Index of attempt
     */
    DeliveryRetryStrategy.prototype.debugLogAttempt = function (attempt, retryTimeout) {
        console.warn("Attempt " + attempt + ": retrying in " + retryTimeout + "ms");
    };
    return DeliveryRetryStrategy;
}());
exports.DeliveryRetryStrategy = DeliveryRetryStrategy;
exports.deliveryRetryStrategy = new DeliveryRetryStrategy();
//# sourceMappingURL=delivery-retry-strategy.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/services/http/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/services/http/delivery-retry-strategy.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/services/http/delivery-http-service.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/services/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/services/query.service.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/services/http/index.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/lib/services/query.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var rxjs_1 = __webpack_require__("./node_modules/rxjs/_esm5/index.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/_esm5/operators/index.js");
var mappers_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/mappers/index.js");
var delivery_retry_strategy_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/services/http/delivery-retry-strategy.js");
var QueryService = /** @class */ (function () {
    function QueryService(
    /**
     * Delivery client configuration
     */
    config, 
    /**
     * Http service for fetching data
     */
    httpService, 
    /**
    * Used for manipulating with rich text HTML (required for Node / Browser support)
    */
    richTextHtmlParser, 
    /**
    * Information about the SDK
    * This can contain information from both this & Node SDK for internal logging with 'SDKID' header
    */
    sdkInfo) {
        this.config = config;
        this.httpService = httpService;
        this.richTextHtmlParser = richTextHtmlParser;
        this.sdkInfo = sdkInfo;
        /**
         * Default number of retry attempts when user did not set any
         */
        this.defaultRetryAttempts = 3;
        /**
         * Excluded status code from retry functionality
         */
        this.retryExcludedStatuses = [404, 401];
        /**
         * Header name for SDK usage
         */
        this.sdkVersionHeader = 'X-KC-SDKID';
        /**
        * Default base Url to Kentico Delivery API
        */
        this.defaultBaseDeliveryApiUrl = 'https://deliver.kenticocloud.com';
        /**
        * Default preview url to Kentico Delivery API
        */
        this.defaultPreviewDeliveryApiUrl = 'https://preview-deliver.kenticocloud.com';
        /**
         * Name of the header used when 'wait for loading new content' feature is used
         */
        this.waitForLoadingNewContentHeader = 'X-KC-Wait-For-Loading-New-Content';
        if (!config) {
            throw Error("Invalid configuration has been provided");
        }
        this.responseMapper = new mappers_1.ResponseMapper(config, richTextHtmlParser);
    }
    /**
     * Gets url based on the action, query configuration and options (parameters)
     * @param action Action (= url part) that will be hit
     * @param queryConfig Query configuration
     * @param options Query options
     */
    QueryService.prototype.getUrl = function (action, queryConfig, options) {
        return this.addOptionsToUrl(this.getBaseUrl(queryConfig) + action, options);
    };
    /**
     * Gets single item from given url
     * @param url Url used to get single item
     * @param queryConfig Query configuration
     */
    QueryService.prototype.getSingleItem = function (url, queryConfig) {
        var _this = this;
        return this.getResponse(url, queryConfig)
            .pipe(operators_1.map(function (response) {
            return _this.responseMapper.mapSingleResponse(response, queryConfig);
        }), operators_1.catchError(function (err) {
            return rxjs_1.throwError(_this.handleError(err));
        }));
    };
    /**
    * Gets multiple items from given url
    * @param url Url used to get multiple items
    * @param queryConfig Query configuration
    */
    QueryService.prototype.getMultipleItems = function (url, queryConfig) {
        var _this = this;
        return this.getResponse(url, queryConfig)
            .pipe(operators_1.map(function (response) {
            return _this.responseMapper.mapMultipleResponse(response, queryConfig);
        }), operators_1.catchError(function (err) {
            return rxjs_1.throwError(_this.handleError(err));
        }));
    };
    /**
     * Gets single content type from given url
     * @param url Url used to get single type
     * @param queryConfig Query configuration
     */
    QueryService.prototype.getSingleType = function (url, queryConfig) {
        var _this = this;
        return this.getResponse(url, queryConfig)
            .pipe(operators_1.map(function (response) {
            return _this.responseMapper.mapSingleTypeResponse(response);
        }), operators_1.catchError(function (err) {
            return rxjs_1.throwError(_this.handleError(err));
        }));
    };
    /**
     * Gets multiple content types from given url
     * @param url Url used to get multiple types
     * @param queryConfig Query configuration
     */
    QueryService.prototype.getMultipleTypes = function (url, queryConfig) {
        var _this = this;
        return this.getResponse(url, queryConfig)
            .pipe(operators_1.map(function (response) {
            return _this.responseMapper.mapMultipleTypeResponse(response);
        }), operators_1.catchError(function (err) {
            return rxjs_1.throwError(_this.handleError(err));
        }));
    };
    /**
     * Gets single taxonomy from given url
     * @param url Url used to get single taxonomy
     * @param queryConfig Query configuration
     */
    QueryService.prototype.getTaxonomy = function (url, queryConfig) {
        var _this = this;
        return this.getResponse(url, queryConfig)
            .pipe(operators_1.map(function (response) {
            return _this.responseMapper.mapTaxonomyResponse(response);
        }), operators_1.catchError(function (err) {
            return rxjs_1.throwError(_this.handleError(err));
        }));
    };
    /**
    * Gets multiple taxonomies from given url
    * @param url Url used to get multiple taxonomies
    * @param queryConfig Query configuration
    */
    QueryService.prototype.getTaxonomies = function (url, queryConfig) {
        var _this = this;
        return this.getResponse(url, queryConfig)
            .pipe(operators_1.map(function (response) {
            return _this.responseMapper.mapTaxonomiesResponse(response);
        }), operators_1.catchError(function (err) {
            return rxjs_1.throwError(_this.handleError(err));
        }));
    };
    /**
    * Gets single content type element from given url
    * @param url Url used to get single content type element
    * @param queryConfig Query configuration
    */
    QueryService.prototype.getElement = function (url, queryConfig) {
        var _this = this;
        return this.getResponse(url, queryConfig)
            .pipe(operators_1.map(function (response) {
            return _this.responseMapper.mapElementResponse(response);
        }), operators_1.catchError(function (err) {
            return rxjs_1.throwError(_this.handleError(err));
        }));
    };
    /**
     * Gets proper set of headers for given request.
     * @param queryConfig Query configuration
     * @param customHeaders Custom headers
     */
    QueryService.prototype.getHeaders = function (queryConfig) {
        var headers = [];
        if (queryConfig.customHeaders) {
            headers = headers.concat(queryConfig.customHeaders);
        }
        // add SDK Id header for monitoring SDK usage
        headers.push(this.getSdkIdHeader());
        if (this.isPreviewModeEnabled(queryConfig) && this.isSecuredModeEnabled(queryConfig)) {
            throw Error("Preview & secured modes cannot be used at the same time.");
        }
        // add preview header is required
        if (this.isPreviewModeEnabled(queryConfig)) {
            headers.push(this.getAuthorizationHeader(this.config.previewApiKey));
        }
        // add secured mode header is required
        if (this.isSecuredModeEnabled(queryConfig)) {
            headers.push(this.getAuthorizationHeader(this.config.securedApiKey));
        }
        // add 'X-KC-Wait-For-Loading-New-Content' header if required
        if (queryConfig.waitForLoadingNewContent) {
            headers.push({
                header: this.waitForLoadingNewContentHeader,
                value: 'true'
            });
        }
        return headers;
    };
    /**
    * Http get response
    * @param url Url of request
    * @param queryConfig Query configuration
    */
    QueryService.prototype.getResponse = function (url, queryConfig) {
        var _this = this;
        return this.httpService.get(url, this.getHeaders(queryConfig))
            .pipe(operators_1.map(function (response) {
            return response;
        }), operators_1.retryWhen(delivery_retry_strategy_1.deliveryRetryStrategy.strategy({
            maxRetryAttempts: this.getRetryAttempts(),
            excludedStatusCodes: this.retryExcludedStatuses
        })), operators_1.catchError(function (err) {
            return rxjs_1.throwError(_this.handleError(err));
        }));
    };
    /**
     * Gets number of retry attempts used by queries
     */
    QueryService.prototype.getRetryAttempts = function () {
        // get the attempts
        var attempts;
        if (this.config.retryAttempts || this.config.retryAttempts === 0) {
            // use custom defined number of attempts
            attempts = this.config.retryAttempts;
        }
        else {
            // use default attempts
            attempts = this.defaultRetryAttempts;
        }
        return attempts;
    };
    /**
     * Handles given error
     * @param error Error to be handled
     */
    QueryService.prototype.handleError = function (error) {
        if (this.config.enableAdvancedLogging) {
            console.error(error);
        }
        if (error.cloudError) {
            return error.cloudError;
        }
        return error;
    };
    /**
     * Indicates if current query should use preview mode
     * @param queryConfig Query configuration
     */
    QueryService.prototype.isPreviewModeEnabled = function (queryConfig) {
        if (queryConfig.usePreviewMode != null) {
            return queryConfig.usePreviewMode;
        }
        return this.config.enablePreviewMode === true;
    };
    /**
    * Indicates if current query should use secured mode
    * @param queryConfig Query configuration
    */
    QueryService.prototype.isSecuredModeEnabled = function (queryConfig) {
        if (queryConfig.useSecuredMode != null) {
            return queryConfig.useSecuredMode;
        }
        return this.config.enableSecuredMode === true;
    };
    /**
     * Gets preview or standard URL based on client and query configuration
     * @param queryConfig Query configuration
     */
    QueryService.prototype.getDeliveryUrl = function (queryConfig) {
        if (this.isPreviewModeEnabled(queryConfig)) {
            if (!this.config.previewApiKey) {
                throw Error("You have to configure 'previewApiKey' to use 'preview' mode");
            }
            // use custom base / preview url if its configured
            if (this.config.basePreviewUrl) {
                return this.config.basePreviewUrl;
            }
            // use default preview url
            return this.defaultPreviewDeliveryApiUrl;
        }
        // use custom base / preview url if its configured
        if (this.config.baseUrl) {
            return this.config.baseUrl;
        }
        return this.defaultBaseDeliveryApiUrl;
    };
    /**
     * Gets base URL of the request including the project Id
     * @param queryConfig Query configuration
     */
    QueryService.prototype.getBaseUrl = function (queryConfig) {
        return this.getDeliveryUrl(queryConfig) + '/' + this.config.projectId;
    };
    /**
     * Adds query parameters to given url
     * @param url Url to which options will be added
     * @param options Query parameters to add
     */
    QueryService.prototype.addOptionsToUrl = function (url, options) {
        if (options) {
            options.forEach(function (filter) {
                if (url.indexOf('?') > -1) {
                    url = url + '&' + filter.getParam() + '=' + filter.getParamValue();
                }
                else {
                    url = url + '?' + filter.getParam() + '=' + filter.getParamValue();
                }
            });
        }
        return url;
    };
    /**
     * Gets authorization header. This is used for 'preview' functionality
     */
    QueryService.prototype.getAuthorizationHeader = function (key) {
        if (!key) {
            throw Error("Cannot get authorization header because key is undefined");
        }
        // authorization header required for preview mode
        return {
            header: 'authorization',
            value: "bearer " + key
        };
    };
    /**
     * Header identifying SDK type & version for internal purposes of Kentico
     */
    QueryService.prototype.getSdkIdHeader = function () {
        return {
            header: this.sdkVersionHeader,
            value: this.sdkInfo.host + ";" + this.sdkInfo.name + ";" + this.sdkInfo.version
        };
    };
    return QueryService;
}());
exports.QueryService = QueryService;
//# sourceMappingURL=query.service.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/mappers/element.mapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/index.js");
var ElementMapper = /** @class */ (function () {
    function ElementMapper() {
    }
    ElementMapper.prototype.mapElement = function (response) {
        if (!response) {
            throw Error("Invalid response for mapping element");
        }
        return new models_1.Element({
            codename: response.codename,
            name: response.name,
            type: response.type,
            options: response.options,
            taxonomyGroup: response.taxonomy_group
        });
    };
    return ElementMapper;
}());
exports.ElementMapper = ElementMapper;
//# sourceMappingURL=element.mapper.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/mappers/field.mapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var fields_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/fields/index.js");
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/index.js");
var resolvers_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/resolvers/index.js");
var FieldMapper = /** @class */ (function () {
    function FieldMapper(config, richTextHtmlParser) {
        this.config = config;
        this.richTextHtmlParser = richTextHtmlParser;
        this.defaultModularContentWrapperTag = 'p';
        this.defaultModularContentWrapperClasses = ['kc-modular-item-wrapper'];
    }
    /**
     * Maps all fields in given content item and returns strongly typed content item based on the resolver specified
     * in DeliveryClientConfig
     * @param item Item to map (raw response from Kentico Cloud)
     * @param modularContent Modular content sent along with item
     * @param queryConfig Query configuration
     */
    FieldMapper.prototype.mapFields = function (item, modularContent, queryConfig, processedItems) {
        var _this = this;
        if (!item) {
            throw Error("Cannot map fields because item is not defined");
        }
        if (!item.system) {
            throw Error("Cannot map item because it does not contain system attributes. This is an essential field and every item should have one.");
        }
        if (!item.elements) {
            throw Error("Cannot map elements of item with codename '" + item.system.codename + "'");
        }
        if (!processedItems) {
            throw Error("ProcessedItems need to be initialized");
        }
        if (!Array.isArray(processedItems)) {
            throw Error("ProcessedItems need to be an array of 'IContentItems'");
        }
        var properties = Object.getOwnPropertyNames(item.elements);
        var itemTyped;
        // check if resolver for this type is available
        if (this.config.typeResolvers && resolvers_1.stronglyTypedResolver.hasTypeResolver(item.system.type, this.config.typeResolvers)) {
            itemTyped = resolvers_1.stronglyTypedResolver.createTypedObj(item.system.type, item, this.config.typeResolvers);
        }
        else {
            itemTyped = resolvers_1.stronglyTypedResolver.createContentItem(item);
        }
        // add/taken item to processed items to avoid infinite recursion
        var processedItem = processedItems.find(function (m) { return m.system.codename === item.system.codename; });
        if (!processedItem) {
            processedItems.push(itemTyped);
        }
        properties.forEach(function (fieldName) {
            var field = item.elements[fieldName];
            var propertyName;
            // resolve field to a custom model property
            if (itemTyped.propertyResolver) {
                propertyName = itemTyped.propertyResolver(fieldName);
            }
            // if property hasn't been resolved, try with decorator
            if (!propertyName) {
                propertyName = fields_1.FieldDecorators.getPropertyName(itemTyped, fieldName);
            }
            // if property name is null/empty, use elements codename
            if (!propertyName) {
                propertyName = fieldName;
            }
            itemTyped[propertyName] = _this.mapField(field, modularContent, itemTyped, queryConfig, processedItems);
        });
        return itemTyped;
    };
    FieldMapper.prototype.mapField = function (field, modularContent, item, queryConfig, processedItems) {
        var fieldType = field.type.toLowerCase();
        if (fieldType === fields_1.FieldType.ModularContent.toString()) {
            return this.mapModularField(field, modularContent, queryConfig, processedItems);
        }
        else if (fieldType === fields_1.FieldType.Text.toLowerCase()) {
            return this.mapTextField(field);
        }
        else if (fieldType === fields_1.FieldType.Asset.toLowerCase()) {
            return this.mapAssetsField(field);
        }
        else if (fieldType === fields_1.FieldType.Number.toLowerCase()) {
            return this.mapNumberField(field);
        }
        else if (fieldType === fields_1.FieldType.MultipleChoice.toLowerCase()) {
            return this.mapMultipleChoiceField(field);
        }
        else if (fieldType === fields_1.FieldType.DateTime.toLowerCase()) {
            return this.mapDateTimeField(field);
        }
        else if (fieldType === fields_1.FieldType.RichText.toLowerCase()) {
            return this.mapRichTextField(field, modularContent, queryConfig, processedItems);
        }
        else if (fieldType === fields_1.FieldType.UrlSlug.toLowerCase()) {
            return this.mapUrlSlugField(field, item, queryConfig);
        }
        else if (fieldType === fields_1.FieldType.Taxonomy.toLowerCase()) {
            return this.mapTaxonomyField(field);
        }
        var error = "Unsupported field type '" + field.type + "'";
        throw Error(error);
    };
    FieldMapper.prototype.mapRichTextField = function (field, modularContent, queryConfig, processedItems) {
        var _this = this;
        // get all modular content items nested in rich text
        var modularItems = [];
        if (field.modular_content) {
            if (Array.isArray(field.modular_content)) {
                field.modular_content.forEach(function (codename) {
                    // get modular item and check if it exists (it might not be included in response due to 'Depth' parameter)
                    var modularContentItem = modularContent[codename];
                    if (!modularContentItem) {
                        throw Error("Modular content item with codename '" + codename + "' is not present in Delivery response.\n                        This modular item was requested by '" + field.name + "' field.\n                        Error can usually be solved by increasing 'Depth' parameter of your query.");
                    }
                    var modularItem = _this.mapFields(modularContent[codename], modularContent, queryConfig, processedItems);
                    if (modularItem != null) {
                        modularItems.push(modularItem);
                    }
                });
            }
        }
        // extract and map links
        var links = this.mapRichTextLinks(field.links);
        return new fields_1.Fields.RichTextField(field.name, field.value, {
            links: links,
            resolveHtml: function () { return resolvers_1.richTextResolver.resolveHtml(field.value, {
                enableAdvancedLogging: _this.config.enableAdvancedLogging ? _this.config.enableAdvancedLogging : false,
                typeResolvers: _this.config.typeResolvers ? _this.config.typeResolvers : [],
                richTextHtmlParser: _this.richTextHtmlParser,
                modularItems: modularItems,
                links: links,
                queryConfig: queryConfig,
                modularContentWrapperTag: _this.config.modularContentResolver && _this.config.modularContentResolver.modularContentWrapperTag
                    ? _this.config.modularContentResolver.modularContentWrapperTag
                    : _this.defaultModularContentWrapperTag,
                modularContentWrapperClasses: _this.config.modularContentResolver && _this.config.modularContentResolver.modularContentWrapperClasses
                    ? _this.config.modularContentResolver.modularContentWrapperClasses
                    : _this.defaultModularContentWrapperClasses
            }); }
        });
    };
    FieldMapper.prototype.mapDateTimeField = function (field) {
        return new fields_1.Fields.DateTimeField(field.name, field.value);
    };
    FieldMapper.prototype.mapMultipleChoiceField = function (field) {
        return new fields_1.Fields.MultipleChoiceField(field.name, field.value);
    };
    FieldMapper.prototype.mapNumberField = function (field) {
        return new fields_1.Fields.NumberField(field.name, field.value);
    };
    FieldMapper.prototype.mapTextField = function (field) {
        return new fields_1.Fields.TextField(field.name, field.value);
    };
    FieldMapper.prototype.mapAssetsField = function (field) {
        return new fields_1.Fields.AssetsField(field.name, field.value);
    };
    FieldMapper.prototype.mapTaxonomyField = function (field) {
        return new fields_1.Fields.TaxonomyField(field.name, field.value, field.taxonomy_group);
    };
    FieldMapper.prototype.mapUrlSlugField = function (field, item, queryConfig) {
        var _this = this;
        var linkResolver = this.getLinkResolverForUrlSlugField(item, queryConfig);
        return new fields_1.Fields.UrlSlugField(field.name, field.value, {
            resolveUrl: function () { return resolvers_1.urlSlugResolver.resolveUrl({
                fieldName: field.name,
                type: field.type,
                fieldValue: field.value,
                item: item,
                enableAdvancedLogging: _this.config.enableAdvancedLogging ? _this.config.enableAdvancedLogging : false,
                linkResolver: linkResolver
            }); }
        });
    };
    FieldMapper.prototype.mapModularField = function (field, modularContent, queryConfig, processedItems) {
        var _this = this;
        if (!field) {
            if (this.config.enableAdvancedLogging) {
                console.warn("Cannot map modular content field because field does not exist");
            }
            return null;
        }
        if (!field.value) {
            if (this.config.enableAdvancedLogging) {
                console.warn("Cannot map modular content of '" + field.name + "' because its value does not exist");
            }
            return null;
        }
        // modular content is always returned in an array
        var modularContentItems = [];
        var fieldModularContent = field.value;
        fieldModularContent.forEach(function (modularItemCodename) {
            var modularItem = modularContent[modularItemCodename];
            if (!modularItem) {
                if (_this.config.enableAdvancedLogging) {
                    console.warn("Cannot map '" + field.name + "' modular content item. Make sure you use 'DepthParameter' in case your modular content is nested.");
                }
            }
            // try to map only if the modular item was present in response
            if (modularItem) {
                // add/taken item to processed items to avoid infinite recursion
                var processedItem = processedItems.find(function (m) { return m.system.codename === modularItem.system.codename; });
                if (processedItem) {
                    modularContentItems.push(processedItem);
                }
                else {
                    var newModularItem = _this.mapFields(modularItem, modularContent, queryConfig, processedItems);
                    modularContentItems.push(newModularItem);
                    processedItem = newModularItem;
                }
            }
        });
        return modularContentItems;
    };
    FieldMapper.prototype.getLinkResolverForUrlSlugField = function (item, queryConfig) {
        // link resolver defined by the query config (= by calling method) has priority over type's global link resolver
        var linkResolver = undefined;
        if (queryConfig.linkResolver) {
            linkResolver = queryConfig.linkResolver;
        }
        else {
            linkResolver = item.linkResolver;
        }
        return linkResolver;
    };
    FieldMapper.prototype.mapRichTextLinks = function (linksJson) {
        var links = [];
        for (var _i = 0, _a = Object.keys(linksJson); _i < _a.length; _i++) {
            var linkItemId = _a[_i];
            var linkRaw = linksJson[linkItemId];
            links.push(new models_1.Link({
                codename: linkRaw.codename,
                itemId: linkItemId,
                urlSlug: linkRaw.url_slug,
                type: linkRaw.type
            }));
        }
        return links;
    };
    return FieldMapper;
}());
exports.FieldMapper = FieldMapper;
//# sourceMappingURL=field.mapper.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/mappers/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/mappers/element.mapper.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/mappers/field.mapper.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/mappers/item.mapper.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/mappers/response.mapper.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/mappers/taxonomy.mapper.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/mappers/type.mapper.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/mappers/item.mapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var mappers_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/mappers/index.js");
var ItemMapper = /** @class */ (function () {
    function ItemMapper(config, richTextHtmlParser) {
        this.config = config;
        this.richTextHtmlParser = richTextHtmlParser;
        this.fieldMapper = new mappers_1.FieldMapper(config, richTextHtmlParser);
    }
    /**
     * Maps single item to its proper strongly typed model from the given Cloud response
     * @param response Cloud response used to map the item
     * @param queryConfig Query configuration
     */
    ItemMapper.prototype.mapSingleItem = function (response, queryConfig) {
        return this.mapItem(response.item, response.modular_content, queryConfig);
    };
    /**
    * Maps multiple items to their strongly typed model from the given Cloud response
    * @param response Cloud response used to map the item
    * @param queryConfig Query configuration
    */
    ItemMapper.prototype.mapMultipleItems = function (response, queryConfig) {
        var that = this;
        return response.items.map(function (item) {
            return that.mapItem(item, response.modular_content, queryConfig);
        });
    };
    ItemMapper.prototype.mapItem = function (item, modularContent, queryConfig) {
        if (item == null) {
            throw Error("Could not map item because its undefined");
        }
        return this.fieldMapper.mapFields(item, modularContent, queryConfig, []);
    };
    return ItemMapper;
}());
exports.ItemMapper = ItemMapper;
//# sourceMappingURL=item.mapper.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/mappers/response.mapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/index.js");
var element_mapper_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/mappers/element.mapper.js");
var item_mapper_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/mappers/item.mapper.js");
var taxonomy_mapper_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/mappers/taxonomy.mapper.js");
var type_mapper_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/mappers/type.mapper.js");
var ResponseMapper = /** @class */ (function () {
    function ResponseMapper(config, richTextHtmlParser) {
        this.config = config;
        this.richTextHtmlParser = richTextHtmlParser;
        this.typeMapper = new type_mapper_1.TypeMapper();
        this.itemMapper = new item_mapper_1.ItemMapper(config, richTextHtmlParser);
        this.taxonomyMapper = new taxonomy_mapper_1.TaxonomyMapper();
        this.elementMapper = new element_mapper_1.ElementMapper();
    }
    /**
     * Gets response for getting a single type
     * @param response Response data
     */
    ResponseMapper.prototype.mapSingleTypeResponse = function (response) {
        var cloudResponse = response.data;
        // map type
        var type = this.typeMapper.mapSingleType(cloudResponse);
        return new models_1.TypeResponses.DeliveryTypeResponse(type, this.mapResponseDebug(response));
    };
    /**
     * Gets resposne for getting multiple types
     * @param response Response data
     * @param options Options
     */
    ResponseMapper.prototype.mapMultipleTypeResponse = function (response) {
        var cloudResponse = response.data;
        // map types
        var types = this.typeMapper.mapMultipleTypes(cloudResponse);
        // pagination
        var pagination = new models_1.Pagination({
            skip: cloudResponse.pagination.skip,
            count: cloudResponse.pagination.count,
            limit: cloudResponse.pagination.limit,
            next_page: cloudResponse.pagination.next_page
        });
        return new models_1.TypeResponses.DeliveryTypeListingResponse(types, pagination, this.mapResponseDebug(response));
    };
    /**
     * Gets response for getting single item
     * @param response Response data
     * @param queryConfig Query configuration
     */
    ResponseMapper.prototype.mapSingleResponse = function (response, queryConfig) {
        var cloudResponse = response.data;
        // map item
        var item = this.itemMapper.mapSingleItem(cloudResponse, queryConfig);
        return new models_1.ItemResponses.DeliveryItemResponse(item, this.mapResponseDebug(response));
    };
    /**
     * Gets response for getting multiple items
     * @param response Response data
     * @param queryConfig Query configuration
     */
    ResponseMapper.prototype.mapMultipleResponse = function (response, queryConfig) {
        var cloudResponse = response.data;
        // map items
        var items = this.itemMapper.mapMultipleItems(cloudResponse, queryConfig);
        // pagination
        var pagination = new models_1.Pagination({
            skip: cloudResponse.pagination.skip,
            count: cloudResponse.pagination.count,
            limit: cloudResponse.pagination.limit,
            next_page: cloudResponse.pagination.next_page
        });
        return new models_1.ItemResponses.DeliveryItemListingResponse(items, pagination, this.mapResponseDebug(response));
    };
    /**
     * Gets response for getting single taxonomy item
     * @param response Response data
     */
    ResponseMapper.prototype.mapTaxonomyResponse = function (response) {
        var cloudResponse = response.data;
        // map taxonomy
        var taxonomy = this.taxonomyMapper.mapTaxonomy(cloudResponse.system, cloudResponse.terms);
        return new models_1.TaxonomyResponses.TaxonomyResponse(taxonomy, this.mapResponseDebug(response));
    };
    /**
     * Gets response for getting multiples taxonomies
     * @param response Response data
     */
    ResponseMapper.prototype.mapTaxonomiesResponse = function (response) {
        var cloudResponse = response.data;
        // map taxonomies
        var taxonomies = this.taxonomyMapper.mapTaxonomies(cloudResponse.taxonomies);
        // pagination
        var pagination = new models_1.Pagination({
            skip: cloudResponse.pagination.skip,
            count: cloudResponse.pagination.count,
            limit: cloudResponse.pagination.limit,
            next_page: cloudResponse.pagination.next_page
        });
        return new models_1.TaxonomyResponses.TaxonomiesResponse(taxonomies, pagination, this.mapResponseDebug(response));
    };
    /**
    * Gets response for getting single content type element
    * @param response Response data
    */
    ResponseMapper.prototype.mapElementResponse = function (response) {
        var cloudResponse = response.data;
        // map element
        var element = this.elementMapper.mapElement(cloudResponse);
        return new models_1.ElementResponses.ElementResponse(element, this.mapResponseDebug(response));
    };
    ResponseMapper.prototype.mapResponseDebug = function (response) {
        if (!response) {
            throw Error("Cannot map 'debug' model from the response");
        }
        return {
            response: response.response
        };
    };
    return ResponseMapper;
}());
exports.ResponseMapper = ResponseMapper;
//# sourceMappingURL=response.mapper.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/mappers/taxonomy.mapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/index.js");
var TaxonomyMapper = /** @class */ (function () {
    function TaxonomyMapper() {
    }
    TaxonomyMapper.prototype.mapTaxonomy = function (taxonomySystem, taxonomyTerms) {
        if (!taxonomySystem) {
            throw Error("Cannot map taxonomy due to missing 'system' property");
        }
        if (!taxonomyTerms) {
            throw Error("Cannot map taxonomy due to missing 'terms' property");
        }
        if (!Array.isArray(taxonomyTerms)) {
            throw Error("Cannot map terms because no terms array was provided");
        }
        var mappedSystemAttributes = new models_1.TaxonomySystemAttributes({
            name: taxonomySystem.name,
            codename: taxonomySystem.codename,
            id: taxonomySystem.id,
            lastModified: taxonomySystem.last_modified
        });
        var mappedTerms = this.mapTaxonomyTerms(taxonomyTerms);
        return new models_1.TaxonomyGroup(mappedSystemAttributes, mappedTerms);
    };
    TaxonomyMapper.prototype.mapTaxonomies = function (taxonomies) {
        var _this = this;
        if (!taxonomies) {
            throw Error("Cannot map taxonomy due to missing 'taxonomies' property");
        }
        if (!Array.isArray(taxonomies)) {
            throw Error("Cannot map taxonomies because the 'taxonomies' property is not an array ");
        }
        var mappedTaxonomies = [];
        taxonomies.forEach(function (taxonomy) {
            mappedTaxonomies.push(_this.mapTaxonomy(taxonomy.system, taxonomy.terms));
        });
        return mappedTaxonomies;
    };
    /**
     * Recursively map array of taxonomy terms
     * @param termsArray Terms array to map
     */
    TaxonomyMapper.prototype.mapTaxonomyTerms = function (termsArray) {
        var _this = this;
        if (termsArray.length === 0) {
            return [];
        }
        var mappedTermsArray = [];
        termsArray.forEach(function (terms) {
            var mappedTerms = new models_1.TaxonomyTerms({
                codename: terms.codename,
                name: terms.name,
                terms: _this.mapTaxonomyTerms(terms.terms)
            });
            mappedTermsArray.push(mappedTerms);
        });
        return mappedTermsArray;
    };
    return TaxonomyMapper;
}());
exports.TaxonomyMapper = TaxonomyMapper;
//# sourceMappingURL=taxonomy.mapper.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/mappers/type.mapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/index.js");
var TypeMapper = /** @class */ (function () {
    function TypeMapper() {
    }
    TypeMapper.prototype.mapSingleType = function (response) {
        return this.mapType(response);
    };
    TypeMapper.prototype.mapMultipleTypes = function (response) {
        var that = this;
        return response.types.map(function (type) {
            return that.mapType(type);
        });
    };
    TypeMapper.prototype.mapType = function (type) {
        if (!type) {
            throw Error("Cannot map type");
        }
        if (!type.elements) {
            throw Error("Cannot map type elements");
        }
        var typeSystem = new models_1.ContentTypeSystemAttributes({
            codename: type.system.codename,
            id: type.system.id,
            name: type.system.name,
            lastModified: type.system.last_modified
        });
        var elements = [];
        var elementNames = Object.getOwnPropertyNames(type.elements);
        elementNames.forEach(function (elementName) {
            var typeElement = type.elements[elementName];
            if (!typeElement) {
                throw Error("Cannot find element '" + elementName + "' on type '" + type + "'");
            }
            // use json property as a codename of the type element
            var elementCodename = elementName;
            // extra properties for certain field types
            var taxonomyGroup = typeElement.taxonomy_group;
            var options = [];
            // some elements can contain options
            var rawOptions = typeElement.options;
            if (rawOptions) {
                if (!Array.isArray(rawOptions)) {
                    throw Error("Content type 'options' property has to be an array");
                }
                rawOptions.forEach(function (rawOption) {
                    options.push(new models_1.ElementOption(rawOption.name, rawOption.codename));
                });
            }
            elements.push(new models_1.Element({
                codename: elementCodename,
                taxonomyGroup: taxonomyGroup,
                options: options,
                name: typeElement.name,
                type: typeElement.type
            }));
        });
        return new models_1.ContentType({
            system: typeSystem,
            elements: elements
        });
    };
    return TypeMapper;
}());
exports.TypeMapper = TypeMapper;
//# sourceMappingURL=type.mapper.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/common/cloud-error.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var DeliveryCloudError = /** @class */ (function () {
    function DeliveryCloudError(data) {
        Object.assign(this, data);
    }
    return DeliveryCloudError;
}());
exports.DeliveryCloudError = DeliveryCloudError;
//# sourceMappingURL=cloud-error.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/common/filters.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var Filters;
(function (Filters) {
    var valueSeparator = ',';
    var defaultValue = '';
    var TypeFilter = /** @class */ (function () {
        function TypeFilter(type) {
            this.type = type;
        }
        TypeFilter.prototype.getParam = function () {
            if (Array.isArray(this.type)) {
                // multiple types
                return 'system.type[in]';
            }
            // single type
            return 'system.type';
        };
        TypeFilter.prototype.getParamValue = function () {
            if (!this.type) {
                return defaultValue;
            }
            if (Array.isArray(this.type)) {
                var value = '';
                // use [in] filter
                for (var i = 0; i < this.type.length; i++) {
                    value = value + this.type[i].toString();
                    if (i !== this.type.length - 1) {
                        // append separator if its not last item
                        value = value + valueSeparator;
                    }
                }
                return value;
            }
            // single type was given
            return this.type.toString();
        };
        return TypeFilter;
    }());
    Filters.TypeFilter = TypeFilter;
    var EqualsFilter = /** @class */ (function () {
        function EqualsFilter(field, value) {
            this.field = field;
            this.value = value;
            if (!this.field) {
                throw Error("Field specified in 'EqualsFilter' is undefined ");
            }
        }
        EqualsFilter.prototype.getParam = function () {
            return this.field.trim();
        };
        EqualsFilter.prototype.getParamValue = function () {
            if (!this.value) {
                return defaultValue;
            }
            return this.value;
        };
        return EqualsFilter;
    }());
    Filters.EqualsFilter = EqualsFilter;
    var AllFilter = /** @class */ (function () {
        function AllFilter(field, values) {
            this.field = field;
            this.values = values;
            if (!this.field) {
                throw Error("Field specified in 'AllFilter' is undefined ");
            }
        }
        AllFilter.prototype.getParam = function () {
            return this.field.trim() + "[all]";
        };
        AllFilter.prototype.getParamValue = function () {
            if (!this.values || !Array.isArray(this.values)) {
                return defaultValue;
            }
            return this.values.map(function (m) { return m.trim(); }).join(',');
        };
        return AllFilter;
    }());
    Filters.AllFilter = AllFilter;
    var AnyFilter = /** @class */ (function () {
        function AnyFilter(field, values) {
            this.field = field;
            this.values = values;
            if (!this.field) {
                throw Error("Field specified in 'AnyFilter' is undefined ");
            }
        }
        AnyFilter.prototype.getParam = function () {
            return this.field.trim() + "[any]";
        };
        AnyFilter.prototype.getParamValue = function () {
            if (!this.values || !Array.isArray(this.values)) {
                return defaultValue;
            }
            return this.values.map(function (m) { return m.trim(); }).join(',');
        };
        return AnyFilter;
    }());
    Filters.AnyFilter = AnyFilter;
    var ContainsFilter = /** @class */ (function () {
        function ContainsFilter(field, values) {
            this.field = field;
            this.values = values;
            if (!this.field) {
                throw Error("Field specified in 'ContainsFilter' is undefined ");
            }
        }
        ContainsFilter.prototype.getParam = function () {
            return this.field.trim() + "[contains]";
        };
        ContainsFilter.prototype.getParamValue = function () {
            if (!this.values || !Array.isArray(this.values)) {
                return defaultValue;
            }
            return this.values.map(function (m) { return m.trim(); }).join(',');
        };
        return ContainsFilter;
    }());
    Filters.ContainsFilter = ContainsFilter;
    var GreaterThanFilter = /** @class */ (function () {
        function GreaterThanFilter(field, value) {
            this.field = field;
            this.value = value;
            if (!this.field) {
                throw Error("Field specified in 'GreaterThanFilter' is undefined ");
            }
        }
        GreaterThanFilter.prototype.getParam = function () {
            return this.field.trim() + "[gt]";
        };
        GreaterThanFilter.prototype.getParamValue = function () {
            if (!this.value) {
                return defaultValue;
            }
            return this.value;
        };
        return GreaterThanFilter;
    }());
    Filters.GreaterThanFilter = GreaterThanFilter;
    var GreaterThanOrEqualFilter = /** @class */ (function () {
        function GreaterThanOrEqualFilter(field, value) {
            this.field = field;
            this.value = value;
            if (!this.field) {
                throw Error("Field specified in 'GreaterThanOrEqualFilter' is undefined ");
            }
        }
        GreaterThanOrEqualFilter.prototype.getParam = function () {
            return this.field.trim() + "[gte]";
        };
        GreaterThanOrEqualFilter.prototype.getParamValue = function () {
            if (!this.value) {
                return defaultValue;
            }
            return this.value;
        };
        return GreaterThanOrEqualFilter;
    }());
    Filters.GreaterThanOrEqualFilter = GreaterThanOrEqualFilter;
    var Infilter = /** @class */ (function () {
        function Infilter(field, values) {
            this.field = field;
            this.values = values;
            if (!this.field) {
                throw Error("Field specified in 'Infilter' is undefined");
            }
        }
        Infilter.prototype.getParam = function () {
            return this.field.trim() + "[in]";
        };
        Infilter.prototype.getParamValue = function () {
            if (!this.values || !Array.isArray(this.values)) {
                return defaultValue;
            }
            return this.values.map(function (m) {
                return m.trim();
            }).join(',');
        };
        return Infilter;
    }());
    Filters.Infilter = Infilter;
    var LessThanFilter = /** @class */ (function () {
        function LessThanFilter(field, value) {
            this.field = field;
            this.value = value;
            if (!this.field) {
                throw Error("Field specified in 'LessThanFilter' is undefined ");
            }
        }
        LessThanFilter.prototype.getParam = function () {
            return this.field.trim() + "[lt]";
        };
        LessThanFilter.prototype.getParamValue = function () {
            if (!this.value) {
                return defaultValue;
            }
            return this.value;
        };
        return LessThanFilter;
    }());
    Filters.LessThanFilter = LessThanFilter;
    var LessThanOrEqualFilter = /** @class */ (function () {
        function LessThanOrEqualFilter(field, value) {
            this.field = field;
            this.value = value;
            if (!this.field) {
                throw Error("Field specified in 'LessThanOrEqualFilter' is undefined ");
            }
        }
        LessThanOrEqualFilter.prototype.getParam = function () {
            return this.field.trim() + "[lte]";
        };
        LessThanOrEqualFilter.prototype.getParamValue = function () {
            if (!this.value) {
                return defaultValue;
            }
            return this.value;
        };
        return LessThanOrEqualFilter;
    }());
    Filters.LessThanOrEqualFilter = LessThanOrEqualFilter;
    var RangeFilter = /** @class */ (function () {
        function RangeFilter(field, lowerValue, higherValue) {
            this.field = field;
            this.lowerValue = lowerValue;
            this.higherValue = higherValue;
            if (!this.field) {
                throw Error("Field specified in 'RangeFilter' is undefined ");
            }
            if (lowerValue > higherValue) {
                throw Error("'lowerValue' cannot be higher then 'higherValue' in 'RangeFilter'");
            }
        }
        RangeFilter.prototype.getParam = function () {
            return this.field.trim() + "[range]";
        };
        RangeFilter.prototype.getParamValue = function () {
            var lowerVal = defaultValue;
            var higherVal = defaultValue;
            if (this.lowerValue) {
                lowerVal = this.lowerValue.toString();
            }
            if (this.higherValue) {
                higherVal = this.higherValue.toString();
            }
            return lowerVal + "," + higherVal;
        };
        return RangeFilter;
    }());
    Filters.RangeFilter = RangeFilter;
})(Filters = exports.Filters || (exports.Filters = {}));
//# sourceMappingURL=filters.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/common/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/common/cloud-error.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/common/filters.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/common/pagination.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/common/parameters.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/common/sort-order.enum.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/common/pagination.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var Pagination = /** @class */ (function () {
    function Pagination(data) {
        Object.assign(this, data);
    }
    return Pagination;
}());
exports.Pagination = Pagination;
//# sourceMappingURL=pagination.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/common/parameters.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var sort_order_enum_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/common/sort-order.enum.js");
var Parameters;
(function (Parameters) {
    var defaultValue = '';
    var CustomParameter = /** @class */ (function () {
        /**
        * Custom parameter
        * @constructor
        * @param {string} name - Name of the parameter
        * @param {string} value - Value of the parameter
        */
        function CustomParameter(name, value) {
            this.name = name;
            this.value = value;
            if (!name) {
                throw Error("Name of the custom parameter is not specified");
            }
        }
        CustomParameter.prototype.getParam = function () {
            return this.name;
        };
        CustomParameter.prototype.getParamValue = function () {
            return this.value;
        };
        return CustomParameter;
    }());
    Parameters.CustomParameter = CustomParameter;
    var ElementsParameter = /** @class */ (function () {
        /**
        * Sets elements (projection) so that only certain elements from a content item are returned
        * @constructor
        * @param {string[]} elementCodenames - Array of element codenames to include in response.
        */
        function ElementsParameter(elementCodenames) {
            this.elementCodenames = elementCodenames;
        }
        ElementsParameter.prototype.getParam = function () {
            return 'elements';
        };
        ElementsParameter.prototype.getParamValue = function () {
            if (!this.elementCodenames) {
                return defaultValue;
            }
            return this.elementCodenames.map(function (m) {
                if (!m) {
                    throw Error("Codename of 'ElementsParameter' cannot be null or empty");
                }
                return m.trim();
            }).join(',');
        };
        return ElementsParameter;
    }());
    Parameters.ElementsParameter = ElementsParameter;
    var LimitParameter = /** @class */ (function () {
        /**
        * Limits the number of items that are returned from response
        * @constructor
        * @param {number} limit - Number of elements that will be returned
        */
        function LimitParameter(limit) {
            this.limit = limit;
            if (limit <= 0) {
                throw Error("'LimitParameter' must specify a positive integer");
            }
        }
        LimitParameter.prototype.getParam = function () {
            return 'limit';
        };
        LimitParameter.prototype.getParamValue = function () {
            return this.limit.toString();
        };
        return LimitParameter;
    }());
    Parameters.LimitParameter = LimitParameter;
    var SkipParameter = /** @class */ (function () {
        /**
        * Configures response to skip certain number of items
        * @constructor
        * @param {number} skip - Number of content items that will be skipped
        */
        function SkipParameter(skip) {
            this.skip = skip;
            if (skip < 0) {
                throw Error("'SkipParameter' must specify a positive integer number or zero.\"");
            }
        }
        SkipParameter.prototype.getParam = function () {
            return 'skip';
        };
        SkipParameter.prototype.getParamValue = function () {
            return this.skip.toString();
        };
        return SkipParameter;
    }());
    Parameters.SkipParameter = SkipParameter;
    var OrderParameter = /** @class */ (function () {
        /**
        * Sorts the response based on given field.
        * @constructor
        * @param {string} field - Field that will be used for sorting (can be both elements.<fieldname> or system.<fieldname>)
        * @param {SortOrder} sortOrder - Order type (desc/asc). Defaults to 'asc' if SortOrder is null or invalid.
        */
        function OrderParameter(field, sortOrder) {
            this.field = field;
            this.sortOrder = sortOrder;
            if (!field) {
                throw Error("Field specified in 'OrderParameter' is null or empty");
            }
        }
        OrderParameter.prototype.getParam = function () {
            return 'order';
        };
        OrderParameter.prototype.getParamValue = function () {
            var order;
            if (this.sortOrder === sort_order_enum_1.SortOrder.desc) {
                order = 'desc';
            }
            else {
                order = 'asc';
            }
            return this.field.trim() + "[" + order + "]";
        };
        return OrderParameter;
    }());
    Parameters.OrderParameter = OrderParameter;
    var DepthParameter = /** @class */ (function () {
        /**
        * Configures the depth of the response. Content items might reference modular content items using the Modular content element.
        * Recursively, these modular content items can reference another modular content items.
        * By default, only one level of modular content is returned.
        * @constructor
        * @param {number} depth - Depth fo the response
        */
        function DepthParameter(depth) {
            this.depth = depth;
            if (depth < 0) {
                throw Error("'DepthParameter' must specify a positive integer or zero");
            }
        }
        DepthParameter.prototype.getParam = function () {
            return 'depth';
        };
        DepthParameter.prototype.getParamValue = function () {
            return this.depth.toString();
        };
        return DepthParameter;
    }());
    Parameters.DepthParameter = DepthParameter;
    var LanguageParameter = /** @class */ (function () {
        /**
        * Specifies language version to fetch
        * @constructor
        * @param {string} languageCodename - Codename of the language
        */
        function LanguageParameter(languageCodename) {
            this.languageCodename = languageCodename;
            if (!languageCodename) {
                throw Error("'LanguageParameter' must specify codename of the language");
            }
        }
        LanguageParameter.prototype.getParam = function () {
            return 'language';
        };
        LanguageParameter.prototype.getParamValue = function () {
            return this.languageCodename.trim().toString();
        };
        return LanguageParameter;
    }());
    Parameters.LanguageParameter = LanguageParameter;
})(Parameters = exports.Parameters || (exports.Parameters = {}));
//# sourceMappingURL=parameters.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/common/sort-order.enum.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var SortOrder;
(function (SortOrder) {
    SortOrder[SortOrder["asc"] = 0] = "asc";
    SortOrder[SortOrder["desc"] = 1] = "desc";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
//# sourceMappingURL=sort-order.enum.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/element/element-option.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var ElementOption = /** @class */ (function () {
    function ElementOption(
    /**
     * Name of the option
     */
    name, 
    /**
     * Value of the option
     */
    codename) {
        this.name = name;
        this.codename = codename;
    }
    return ElementOption;
}());
exports.ElementOption = ElementOption;
//# sourceMappingURL=element-option.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/element/element.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var Element = /** @class */ (function () {
    function Element(data) {
        Object.assign(this, data);
    }
    return Element;
}());
exports.Element = Element;
//# sourceMappingURL=element.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/element/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/element/element-option.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/element/element.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/element/responses.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/element/responses.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var ElementResponses;
(function (ElementResponses) {
    var ElementResponse = /** @class */ (function () {
        /**
        * Response containing content type element
        *
        * @constructor
        * @param {Element} element - Content type element
        * @param {ICloudResponseDebug} debug - Debug information from the response
        */
        function ElementResponse(element, debug) {
            this.element = element;
            this.debug = debug;
        }
        return ElementResponse;
    }());
    ElementResponses.ElementResponse = ElementResponse;
})(ElementResponses = exports.ElementResponses || (exports.ElementResponses = {}));
//# sourceMappingURL=responses.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/common/index.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/element/index.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/item/index.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/taxonomy/index.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/type/index.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/item/content-item-system-attributes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var ContentItemSystemAttributes = /** @class */ (function () {
    function ContentItemSystemAttributes(data) {
        Object.assign(this, data);
    }
    return ContentItemSystemAttributes;
}());
exports.ContentItemSystemAttributes = ContentItemSystemAttributes;
//# sourceMappingURL=content-item-system-attributes.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/item/content-item.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var ContentItem = /** @class */ (function () {
    /**
    * Base class representing content item type. All content type models need to extend this class.
    * @constructor
    * @param {(fieldName: string) => string} propertyResolver - Callback used to bind fields returned from Kentico Cloud to a model property. Common usage is to bind e.g. 'FirstName' field from Kentico Cloud response to 'firstName' field in model
    * @param {(link: Link) => string} linkResolver - Callback used to resolve links or URL slug fields
    * @param {(contentItem: ContentItem) => string} richTextResolver - Callback used to resolve modular content in rich text fields to HTML
    */
    function ContentItem(data) {
        this.data = data;
        if (data) {
            Object.assign(this, data);
        }
    }
    return ContentItem;
}());
exports.ContentItem = ContentItem;
//# sourceMappingURL=content-item.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/item/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/item/content-item-system-attributes.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/item/content-item.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/item/link.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/item/responses.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/item/type-resolver.class.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/item/link.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var Link = /** @class */ (function () {
    function Link(data) {
        Object.assign(this, data);
    }
    return Link;
}());
exports.Link = Link;
//# sourceMappingURL=link.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/item/responses.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var ItemResponses;
(function (ItemResponses) {
    var DeliveryItemListingResponse = /** @class */ (function () {
        /**
        * Response containing multiple item
        * @constructor
        * @param {TItem[]} items - Collection of content items
        * @param {Pagination} pagination - Pagination object
        * @param {ICloudResponseDebug} debug - Debug information from the request
        */
        function DeliveryItemListingResponse(items, pagination, debug) {
            this.items = items;
            this.pagination = pagination;
            this.debug = debug;
            this.initIsEmpty();
            this.initFirstAndLastItem();
        }
        DeliveryItemListingResponse.prototype.initIsEmpty = function () {
            if (!this.items) {
                this.isEmpty = true;
            }
            else {
                this.isEmpty = this.items.length <= 0;
            }
        };
        DeliveryItemListingResponse.prototype.initFirstAndLastItem = function () {
            if (!this.items) {
                return;
            }
            if (this.items.length < 1) {
                return;
            }
            this.firstItem = this.items[0];
            this.lastItem = this.items[this.items.length - 1];
        };
        return DeliveryItemListingResponse;
    }());
    ItemResponses.DeliveryItemListingResponse = DeliveryItemListingResponse;
    var DeliveryItemResponse = /** @class */ (function () {
        /**
        * Response containing single item
        * @constructor
        * @param {TItem} item - Returned item
        * @param {ICloudResponseDebug} debug - Debug information from the request
        */
        function DeliveryItemResponse(item, debug) {
            this.item = item;
            this.debug = debug;
            this.initIsEmpty();
        }
        DeliveryItemResponse.prototype.initIsEmpty = function () {
            if (!this.item) {
                this.isEmpty = true;
            }
            else {
                this.isEmpty = false;
            }
        };
        return DeliveryItemResponse;
    }());
    ItemResponses.DeliveryItemResponse = DeliveryItemResponse;
})(ItemResponses = exports.ItemResponses || (exports.ItemResponses = {}));
//# sourceMappingURL=responses.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/item/type-resolver.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var TypeResolver = /** @class */ (function () {
    /**
    * Resolver used to create empty instance of object representing your content item.
    * For example if you create a class 'Character' which corresponds to 'character' code name of Kentico Cloud type, you
    * need to use TypeResolver like: 'new TypeResolver("code_example", () => new CodeExample())'
    * @constructor
    * @param {string} type - Codename of the content item defined in your Kentico Cloud content types
    * @param {() => ContentItem} resolve - Calbacked used to returs empty instance of proper item class
    */
    function TypeResolver(type, resolve) {
        this.type = type;
        this.resolve = resolve;
    }
    return TypeResolver;
}());
exports.TypeResolver = TypeResolver;
//# sourceMappingURL=type-resolver.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/taxonomy/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/taxonomy/responses.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/taxonomy/taxonomy-group.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/taxonomy/taxonomy-system-attributes.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/taxonomy/taxonomy-terms.class.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/taxonomy/responses.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var TaxonomyResponses;
(function (TaxonomyResponses) {
    var TaxonomyResponse = /** @class */ (function () {
        function TaxonomyResponse(
        /**
         * Taxonomy group
         */
        taxonomy, 
        /**
         * Debug information
         */
        debug) {
            this.taxonomy = taxonomy;
            this.debug = debug;
        }
        return TaxonomyResponse;
    }());
    TaxonomyResponses.TaxonomyResponse = TaxonomyResponse;
    var TaxonomiesResponse = /** @class */ (function () {
        function TaxonomiesResponse(
        /**
         * Taxonomies
         */
        taxonomies, 
        /**
         * Pagination
         */
        pagination, 
        /**
         * Debug information
         */
        debug) {
            this.taxonomies = taxonomies;
            this.pagination = pagination;
            this.debug = debug;
        }
        return TaxonomiesResponse;
    }());
    TaxonomyResponses.TaxonomiesResponse = TaxonomiesResponse;
})(TaxonomyResponses = exports.TaxonomyResponses || (exports.TaxonomyResponses = {}));
//# sourceMappingURL=responses.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/taxonomy/taxonomy-group.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var TaxonomyGroup = /** @class */ (function () {
    function TaxonomyGroup(system, terms) {
        this.system = system;
        this.terms = terms;
    }
    return TaxonomyGroup;
}());
exports.TaxonomyGroup = TaxonomyGroup;
//# sourceMappingURL=taxonomy-group.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/taxonomy/taxonomy-system-attributes.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var TaxonomySystemAttributes = /** @class */ (function () {
    function TaxonomySystemAttributes(data) {
        Object.assign(this, data);
    }
    return TaxonomySystemAttributes;
}());
exports.TaxonomySystemAttributes = TaxonomySystemAttributes;
//# sourceMappingURL=taxonomy-system-attributes.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/taxonomy/taxonomy-terms.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var TaxonomyTerms = /** @class */ (function () {
    function TaxonomyTerms(data) {
        Object.assign(this, data);
    }
    return TaxonomyTerms;
}());
exports.TaxonomyTerms = TaxonomyTerms;
//# sourceMappingURL=taxonomy-terms.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/type/content-type-system-attributes.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var ContentTypeSystemAttributes = /** @class */ (function () {
    function ContentTypeSystemAttributes(data) {
        Object.assign(this, data);
    }
    return ContentTypeSystemAttributes;
}());
exports.ContentTypeSystemAttributes = ContentTypeSystemAttributes;
//# sourceMappingURL=content-type-system-attributes.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/type/content-type.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var ContentType = /** @class */ (function () {
    function ContentType(data) {
        Object.assign(this, data);
    }
    return ContentType;
}());
exports.ContentType = ContentType;
//# sourceMappingURL=content-type.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/type/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/type/content-type-system-attributes.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/type/content-type.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/type/responses.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/models/type/responses.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var TypeResponses;
(function (TypeResponses) {
    var DeliveryTypeListingResponse = /** @class */ (function () {
        /**
        * Response containing multiple types
        * @constructor
        * @param {IContentType[]} types - Content types
        * @param {Pagination} pagination - Pagination object
        */
        function DeliveryTypeListingResponse(types, pagination, debug) {
            this.types = types;
            this.pagination = pagination;
            this.debug = debug;
        }
        return DeliveryTypeListingResponse;
    }());
    TypeResponses.DeliveryTypeListingResponse = DeliveryTypeListingResponse;
    var DeliveryTypeResponse = /** @class */ (function () {
        /**
        * Response containing single type
        * @constructor
        * @param {IContentType} type - Content type
        */
        function DeliveryTypeResponse(type, debug) {
            this.type = type;
            this.debug = debug;
        }
        return DeliveryTypeResponse;
    }());
    TypeResponses.DeliveryTypeResponse = DeliveryTypeResponse;
})(TypeResponses = exports.TypeResponses || (exports.TypeResponses = {}));
//# sourceMappingURL=responses.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/parser/adapters/browser-rich-text.parser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var BrowserRichTextParser = /** @class */ (function () {
    function BrowserRichTextParser() {
        this.modularContentWrapperElem = 'div';
        this.modularContent = {
            type: 'application/kenticocloud',
            dataType: 'data-type',
            dataCodename: 'data-codename'
        };
        this.link = {
            nodeName: 'a',
            dataItemId: 'data-item-id'
        };
    }
    BrowserRichTextParser.prototype.resolveRichTextField = function (html, replacement, config) {
        try {
            var doc = this.createWrapperElement(html);
            // get all modular content items
            var result = this.processRichTextField(doc.children, replacement, config, {
                links: [],
                modularContentItems: []
            });
            return {
                links: result.links,
                modularContentItems: result.modularContentItems,
                resolvedHtml: doc.innerHTML
            };
        }
        catch (error) {
            throw Error('Parsing HTML failed:' + error);
        }
    };
    BrowserRichTextParser.prototype.createWrapperElement = function (html) {
        var element = document.createElement(this.modularContentWrapperElem);
        element.innerHTML = html;
        return element;
    };
    BrowserRichTextParser.prototype.processRichTextField = function (htmlCollection, replacement, config, result) {
        if (!htmlCollection || htmlCollection.length === 0) {
            // there are no more nodes
        }
        else {
            // extract objects
            for (var i = 0; i < htmlCollection.length; i++) {
                var element = htmlCollection[i];
                var typeAttribute = element.attributes ? element.attributes.getNamedItem('type') : undefined;
                if (element.attributes && typeAttribute && typeAttribute.value && typeAttribute.value.toLowerCase() === this.modularContent.type.toLowerCase()) {
                    // node is modular content object
                    var dataCodenameAttribute = element.attributes.getNamedItem(this.modularContent.dataCodename);
                    var dataTypeAttribute = element.attributes.getNamedItem(this.modularContent.dataType);
                    var modularItem = {
                        dataCodename: dataCodenameAttribute ? dataCodenameAttribute.value : '',
                        dataType: dataTypeAttribute ? dataTypeAttribute.value : ''
                    };
                    // add to result
                    result.modularContentItems.push(modularItem);
                    // replace html
                    var parentElement = element.parentElement;
                    if (!parentElement) {
                        console.warn("Could not replace modular content '" + modularItem.dataCodename + "' of '" + modularItem.dataType + "' because parent node is null. Please report this error if you are seeing this.");
                    }
                    else {
                        // create new element
                        var newElem = document.createElement(config.modularContentWrapperTag);
                        newElem.innerHTML = replacement.getModularContentHtml(modularItem.dataCodename);
                        // add classes
                        newElem.className = config.modularContentWrapperClasses.map(function (m) { return m; }).join(' ');
                        // remove original object element
                        parentElement.replaceChild(newElem, element);
                    }
                }
                if (element.nodeName.toLowerCase() === this.link.nodeName.toLowerCase()) {
                    var dataItemIdAttribute = element.attributes.getNamedItem(this.link.dataItemId);
                    if (dataItemIdAttribute) {
                        var link = {
                            dataItemId: dataItemIdAttribute ? dataItemIdAttribute.value : ''
                        };
                        // add to result
                        result.links.push(link);
                        var resolvedUrl = replacement.getLinkUrl(link.dataItemId);
                        // add url to link
                        var hrefAttribute = element.attributes.getNamedItem('href');
                        if (!hrefAttribute) {
                            // href attribute is missing
                            if (config.enableAdvancedLogging) {
                                console.warn("Cannot set url '" + resolvedUrl + "' because 'href' attribute is not present in the <a> tag. Please report this issue if you are seeing this.");
                            }
                        }
                        else {
                            hrefAttribute.value = resolvedUrl;
                        }
                    }
                }
                // recursively process child nodes
                if (element.children && element.children.length > 0) {
                    this.processRichTextField(element.children, replacement, config, result);
                }
            }
        }
        return result;
    };
    return BrowserRichTextParser;
}());
exports.BrowserRichTextParser = BrowserRichTextParser;
//# sourceMappingURL=browser-rich-text.parser.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/parser/adapters/node-rich-text.parser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var parse5 = __webpack_require__("./node_modules/parse5/lib/index.js");
var NodeRichTextParser = /** @class */ (function () {
    function NodeRichTextParser() {
        this.modularContentWrapperElem = 'div';
        this.modularContent = {
            type: 'application/kenticocloud',
            dataType: 'data-type',
            dataCodename: 'data-codename'
        };
        this.link = {
            nodeName: 'a',
            dataItemId: 'data-item-id'
        };
    }
    NodeRichTextParser.prototype.resolveRichTextField = function (html, replacement, config) {
        try {
            // create document
            var documentFragment = parse5.parseFragment(html);
            // get all modular content items
            var result = this.processRichTextField(this.getChildNodes(documentFragment), replacement, config, {
                links: [],
                modularContentItems: []
            });
            var resolvedHtml = parse5.serialize(documentFragment);
            return {
                links: result.links,
                modularContentItems: result.modularContentItems,
                resolvedHtml: resolvedHtml
            };
        }
        catch (error) {
            throw Error('Parsing HTML failed:' + error);
        }
    };
    NodeRichTextParser.prototype.processRichTextField = function (elements, replacement, config, result) {
        var _this = this;
        if (!elements || elements.length === 0) {
            // there are no more elements
        }
        else {
            elements.forEach(function (element) {
                if (element.attrs) {
                    // process modular content
                    _this.processModularContent(element, replacement, config, result);
                    // process link
                    _this.processLink(element, replacement, config, result);
                }
                if (element.childNodes) {
                    // recursively process all childs
                    _this.processRichTextField(_this.getChildNodes(element), replacement, config, result);
                }
            });
        }
        return result;
    };
    NodeRichTextParser.prototype.processLink = function (element, replacement, config, result) {
        var _this = this;
        var attributes = element.attrs;
        if (element.nodeName !== this.link.nodeName) {
            // node is not a link
            return;
        }
        // get all links which have item it attribute, ignore all other links (they can be regular links in rich text)
        var dataItemIdAttribute = attributes.find(function (m) { return m.name === _this.link.dataItemId; });
        if (!dataItemIdAttribute) {
            // its either a regular link or the attribute is not defined
            return;
        }
        // get id of content item
        var itemId = dataItemIdAttribute.value;
        var link = {
            dataItemId: dataItemIdAttribute ? dataItemIdAttribute.value : ''
        };
        // add to result
        result.links.push(link);
        var resolvedUrl = replacement.getLinkUrl(link.dataItemId);
        // assign url to 'href' attribute of the link
        var hrefAttribute = attributes.find(function (m) { return m.name === 'href'; });
        if (!hrefAttribute) {
            // href attribute is missing
            if (config.enableAdvancedLogging) {
                console.warn("Cannot set url '" + resolvedUrl + "' because 'href' attribute is not present in the link element");
            }
            return;
        }
        hrefAttribute.value = resolvedUrl;
    };
    NodeRichTextParser.prototype.processModularContent = function (element, replacement, config, result) {
        var _this = this;
        var attributes = element.attrs;
        var dataTypeAttribute = attributes.find(function (m) { return m.value === _this.modularContent.type; });
        if (!dataTypeAttribute) {
            // node is not of modular content type
            return;
        }
        // get codename of the modular content
        var dataCodenameAttribute = attributes.find(function (m) { return m.name === _this.modularContent.dataCodename; });
        if (dataCodenameAttribute == null) {
            throw Error("The '" + this.modularContent.dataCodename + "' attribute is missing and therefore modular content item cannot be retrieved");
        }
        var itemCodename = dataCodenameAttribute.value;
        var modularItem = {
            dataCodename: dataCodenameAttribute ? dataCodenameAttribute.value : '',
            dataType: dataTypeAttribute ? dataTypeAttribute.value : ''
        };
        // add to result
        result.modularContentItems.push(modularItem);
        // get html
        var resultHtml = replacement.getModularContentHtml(itemCodename);
        // replace 'object' tag name
        element.tagName = config.modularContentWrapperTag;
        // add classes
        element.attrs.push({
            name: 'class',
            value: config.modularContentWrapperClasses.map(function (m) { return m; }).join(' ')
        });
        // get serialized set of nodes from HTML
        var serializedChildNodes = parse5.parseFragment(resultHtml);
        // add child nodes
        element.childNodes = serializedChildNodes.childNodes;
    };
    NodeRichTextParser.prototype.getChildNodes = function (documentFragment) {
        return documentFragment.childNodes;
    };
    return NodeRichTextParser;
}());
exports.NodeRichTextParser = NodeRichTextParser;
//# sourceMappingURL=node-rich-text.parser.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/parser/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/parser/parser-adapter.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/parser/parser-adapter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {
exports.__esModule = true;
function getParserAdapter() {
    var parser;
    // Only Node.JS has a process variable that is of [[Class]] process
    if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
        // For node use
        var adapter = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/parser/adapters/node-rich-text.parser.js");
        // instantiate class
        parser = new adapter.NodeRichTextParser();
    }
    else if (typeof XMLHttpRequest !== 'undefined') {
        // For browsers use
        var adapter = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/parser/adapters/browser-rich-text.parser.js");
        // instantiate class
        parser = new adapter.BrowserRichTextParser();
    }
    if (!parser) {
        throw Error("Invalid or unsupported parser adapter");
    }
    return parser;
}
exports.getParserAdapter = getParserAdapter;
//# sourceMappingURL=parser-adapter.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/query/common/base-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/index.js");
var BaseQuery = /** @class */ (function () {
    function BaseQuery(config, queryService) {
        this.config = config;
        this.queryService = queryService;
        this.parameters = [];
    }
    BaseQuery.prototype.customParameter = function (name, value) {
        this.parameters.push(new models_1.Parameters.CustomParameter(name, value));
        return this;
    };
    BaseQuery.prototype.withUrl = function (url) {
        this.customUrl = url;
        return this;
    };
    BaseQuery.prototype.getParameters = function () {
        return this.parameters;
    };
    BaseQuery.prototype.getPromise = function () {
        return this.getObservable().toPromise();
    };
    BaseQuery.prototype.resolveUrlInternal = function (action) {
        // use custom URL if user specified it
        if (this.customUrl) {
            return this.customUrl;
        }
        // use original url
        return this.queryService.getUrl(action, this._queryConfig, this.getParameters());
    };
    return BaseQuery;
}());
exports.BaseQuery = BaseQuery;
//# sourceMappingURL=base-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/query/element/base-element-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var base_query_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/common/base-query.class.js");
var BaseElementQuery = /** @class */ (function (_super) {
    __extends(BaseElementQuery, _super);
    function BaseElementQuery(config, queryService) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        _this._queryConfig = {};
        return _this;
    }
    /**
     * Use to configure query
     * @param queryConfig Query configuration
     */
    BaseElementQuery.prototype.queryConfig = function (queryConfig) {
        this._queryConfig = queryConfig;
        return this;
    };
    /**
     * Gets headers used by this query
     */
    BaseElementQuery.prototype.getHeaders = function () {
        return this.queryService.getHeaders(this._queryConfig);
    };
    BaseElementQuery.prototype.getElementQueryUrl = function (typeCodename, elementCodename) {
        var action = '/types/' + typeCodename + '/elements/' + elementCodename;
        return _super.prototype.resolveUrlInternal.call(this, action);
    };
    BaseElementQuery.prototype.runElementQuery = function (typeCodename, elementCodename) {
        return this.queryService.getElement(this.getElementQueryUrl(typeCodename, elementCodename), this._queryConfig);
    };
    return BaseElementQuery;
}(base_query_class_1.BaseQuery));
exports.BaseElementQuery = BaseElementQuery;
//# sourceMappingURL=base-element-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/query/element/element-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var base_element_query_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/element/base-element-query.class.js");
var ElementQuery = /** @class */ (function (_super) {
    __extends(ElementQuery, _super);
    function ElementQuery(config, queryService, typeCodename, elementCodename) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        _this.typeCodename = typeCodename;
        _this.elementCodename = elementCodename;
        if (!typeCodename) {
            throw Error("Codename of the type has to be provided");
        }
        if (!elementCodename) {
            throw Error("Codename of the element has to be provided");
        }
        return _this;
    }
    /**
    * Gets the runnable Observable
    */
    ElementQuery.prototype.getObservable = function () {
        return _super.prototype.runElementQuery.call(this, this.typeCodename, this.elementCodename);
    };
    /**
    * Gets 'Url' representation of query
    */
    ElementQuery.prototype.getUrl = function () {
        return _super.prototype.getElementQueryUrl.call(this, this.typeCodename, this.elementCodename);
    };
    return ElementQuery;
}(base_element_query_class_1.BaseElementQuery));
exports.ElementQuery = ElementQuery;
//# sourceMappingURL=element-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/query/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/common/base-query.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/element/base-element-query.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/element/element-query.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/item/base-item-query.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/item/multiple-item-query.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/item/single-item-query.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/taxonomy/base-taxonomy-query.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/taxonomy/taxonomies-query.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/taxonomy/taxonomy-query.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/type/base-type-query.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/type/multiple-type-query.class.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/type/single-type-query.class.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/query/item/base-item-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/index.js");
var base_query_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/common/base-query.class.js");
var BaseItemQuery = /** @class */ (function (_super) {
    __extends(BaseItemQuery, _super);
    function BaseItemQuery(config, queryService) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        _this._queryConfig = {};
        return _this;
    }
    /**
     * Used to configure query
     * @param queryConfig Query configuration
     */
    BaseItemQuery.prototype.queryConfig = function (queryConfig) {
        this._queryConfig = queryConfig;
        return this;
    };
    /**
    * Gets headers used by this query
    */
    BaseItemQuery.prototype.getHeaders = function () {
        return this.queryService.getHeaders(this._queryConfig);
    };
    // shared parameters
    /**
     * Language codename
     * @param languageCodename Codename of the language
     */
    BaseItemQuery.prototype.languageParameter = function (languageCodename) {
        this.parameters.push(new models_1.Parameters.LanguageParameter(languageCodename));
        return this;
    };
    /**
     * Used to limit the number of elements returned by query.
     * @param elementCodenames Array of element codenames to fetch
     */
    BaseItemQuery.prototype.elementsParameter = function (elementCodenames) {
        this.parameters.push(new models_1.Parameters.ElementsParameter(elementCodenames));
        return this;
    };
    /**
     * Indicates how deep nested modular content items are resolved.
     * @param depth Depth of the query (> 0)
     */
    BaseItemQuery.prototype.depthParameter = function (depth) {
        this.parameters.push(new models_1.Parameters.DepthParameter(depth));
        return this;
    };
    BaseItemQuery.prototype.getMultipleItemsQueryUrl = function () {
        var action = '/items';
        // add default language is necessry
        this.processDefaultLanguageParameter();
        return _super.prototype.resolveUrlInternal.call(this, action);
    };
    BaseItemQuery.prototype.getSingleItemQueryUrl = function (codename) {
        var action = '/items/' + codename;
        // add default language is necessry
        this.processDefaultLanguageParameter();
        return _super.prototype.resolveUrlInternal.call(this, action);
    };
    BaseItemQuery.prototype.runMultipleItemsQuery = function () {
        var url = this.getMultipleItemsQueryUrl();
        return this.queryService.getMultipleItems(url, this._queryConfig);
    };
    BaseItemQuery.prototype.runSingleItemQuery = function (codename) {
        var url = this.getSingleItemQueryUrl(codename);
        return this.queryService.getSingleItem(url, this._queryConfig);
    };
    BaseItemQuery.prototype.processDefaultLanguageParameter = function () {
        // add default language if none is specified && default language is specified globally
        if (this.config.defaultLanguage) {
            var languageParameter = this.getParameters().find(function (m) { return m.getParam() === 'language'; });
            if (!languageParameter) {
                // language parameter was not specified in query, use globally defined language
                this.parameters.push(new models_1.Parameters.LanguageParameter(this.config.defaultLanguage));
            }
        }
    };
    return BaseItemQuery;
}(base_query_class_1.BaseQuery));
exports.BaseItemQuery = BaseItemQuery;
//# sourceMappingURL=base-item-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/query/item/multiple-item-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/index.js");
var base_item_query_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/item/base-item-query.class.js");
var MultipleItemQuery = /** @class */ (function (_super) {
    __extends(MultipleItemQuery, _super);
    function MultipleItemQuery(config, queryService) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        return _this;
    }
    /**
     * Gets only item of given type
     * @param type Codename of type to get
     */
    MultipleItemQuery.prototype.type = function (type) {
        this.parameters.push(new models_1.Filters.TypeFilter(type));
        return this;
    };
    /**
     * Gets items of given types (logical or)
     * I.e. get items of either 'Actor' or 'Movie' type
     * @param types Types to get
     */
    MultipleItemQuery.prototype.types = function (types) {
        this.parameters.push(new models_1.Filters.TypeFilter(types));
        return this;
    };
    // filters
    /**
     * Equals filter condition
     * @param field Element to filter. Example: 'elements.movie'
     * @param value Value to match. Example: 'Kingsman'
     */
    MultipleItemQuery.prototype.equalsFilter = function (field, value) {
        this.parameters.push(new models_1.Filters.EqualsFilter(field, value));
        return this;
    };
    /**
     * All filter
     * @param field Element to filter.
     * @param values Values
     */
    MultipleItemQuery.prototype.allFilter = function (field, values) {
        this.parameters.push(new models_1.Filters.AllFilter(field, values));
        return this;
    };
    /**
     * Any filter
     * @param field Element to filter.
     * @param values Values
     */
    MultipleItemQuery.prototype.anyFilter = function (field, values) {
        this.parameters.push(new models_1.Filters.AnyFilter(field, values));
        return this;
    };
    /**
     * Contains filter
     * @param field Element to filter.
     * @param values Values
     */
    MultipleItemQuery.prototype.containsFilter = function (field, values) {
        this.parameters.push(new models_1.Filters.ContainsFilter(field, values));
        return this;
    };
    /**
     * Greater then filter
     * @param field Element to filter.
     * @param value Value
     */
    MultipleItemQuery.prototype.greaterThanFilter = function (field, value) {
        this.parameters.push(new models_1.Filters.GreaterThanFilter(field, value));
        return this;
    };
    /**
     * Greater then or equals filter
     * @param field Element to filter.
     * @param value Value
     */
    MultipleItemQuery.prototype.greaterThanOrEqualFilter = function (field, value) {
        this.parameters.push(new models_1.Filters.GreaterThanOrEqualFilter(field, value));
        return this;
    };
    /**
     * In filter
     * @param field Element to filter.
     * @param values Values
     */
    MultipleItemQuery.prototype.inFilter = function (field, values) {
        this.parameters.push(new models_1.Filters.Infilter(field, values));
        return this;
    };
    /**
     * Less then filter
     * @param field Element to filter.
     * @param value Value
     */
    MultipleItemQuery.prototype.lessThanFilter = function (field, value) {
        this.parameters.push(new models_1.Filters.LessThanFilter(field, value));
        return this;
    };
    /**
     * @param field Element to filter.
     * @param value Value
     */
    MultipleItemQuery.prototype.lessThanOrEqualFilter = function (field, value) {
        this.parameters.push(new models_1.Filters.LessThanOrEqualFilter(field, value));
        return this;
    };
    /**
     * @param field Element to filter.
     * @param lowerValue Lower value of range (e.g. 2)
     * @param higherValue Higher value of range (e.g. 10)
     */
    MultipleItemQuery.prototype.rangeFilter = function (field, lowerValue, higherValue) {
        this.parameters.push(new models_1.Filters.RangeFilter(field, lowerValue, higherValue));
        return this;
    };
    /**
     * Limits the number of items returned by query
     * @param limit Number of items to load
     */
    MultipleItemQuery.prototype.limitParameter = function (limit) {
        this.parameters.push(new models_1.Parameters.LimitParameter(limit));
        return this;
    };
    /**
     * Orders query based on given field and sort order
     * @param field Element by which to order
     * @param sortOrder Asc/Desc order type
     */
    MultipleItemQuery.prototype.orderParameter = function (field, sortOrder) {
        this.parameters.push(new models_1.Parameters.OrderParameter(field, sortOrder));
        return this;
    };
    /**
     * Skips the selected number of items
     * @param skip Number of items to skip
     */
    MultipleItemQuery.prototype.skipParameter = function (skip) {
        this.parameters.push(new models_1.Parameters.SkipParameter(skip));
        return this;
    };
    /**
     * Gets the runnable Observable
     */
    MultipleItemQuery.prototype.getObservable = function () {
        return _super.prototype.runMultipleItemsQuery.call(this);
    };
    /**
     * Gets 'Url' representation of query
     */
    MultipleItemQuery.prototype.getUrl = function () {
        return _super.prototype.getMultipleItemsQueryUrl.call(this);
    };
    return MultipleItemQuery;
}(base_item_query_class_1.BaseItemQuery));
exports.MultipleItemQuery = MultipleItemQuery;
//# sourceMappingURL=multiple-item-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/query/item/single-item-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var base_item_query_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/item/base-item-query.class.js");
var SingleItemQuery = /** @class */ (function (_super) {
    __extends(SingleItemQuery, _super);
    function SingleItemQuery(config, queryService, codename) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        _this.codename = codename;
        if (!codename) {
            throw Error("'codename' has to be configured for 'SingleItemQuery' query");
        }
        return _this;
    }
    /**
    * Gets the runnable Observable
    */
    SingleItemQuery.prototype.getObservable = function () {
        return _super.prototype.runSingleItemQuery.call(this, this.codename);
    };
    /**
    * Gets 'Url' representation of query
    */
    SingleItemQuery.prototype.getUrl = function () {
        return _super.prototype.getSingleItemQueryUrl.call(this, this.codename);
    };
    return SingleItemQuery;
}(base_item_query_class_1.BaseItemQuery));
exports.SingleItemQuery = SingleItemQuery;
//# sourceMappingURL=single-item-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/query/taxonomy/base-taxonomy-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var base_query_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/common/base-query.class.js");
var BaseTaxonomyQuery = /** @class */ (function (_super) {
    __extends(BaseTaxonomyQuery, _super);
    function BaseTaxonomyQuery(config, queryService) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        /**
         * Taxonomies endpoint URL action
         */
        _this.taxonomiesEndpoint = 'taxonomies';
        /**
         * Query configuration
         */
        _this._queryConfig = {};
        return _this;
    }
    /**
     * Used to configure query
     * @param queryConfig Query configuration
     */
    BaseTaxonomyQuery.prototype.queryConfig = function (queryConfig) {
        this._queryConfig = queryConfig;
        return this;
    };
    /**
     * Gets headers used by this query
     */
    BaseTaxonomyQuery.prototype.getHeaders = function () {
        return this.queryService.getHeaders(this._queryConfig);
    };
    BaseTaxonomyQuery.prototype.getTaxonomyQueryUrl = function (taxonomyCodename) {
        var action = '/' + this.taxonomiesEndpoint + '/' + taxonomyCodename;
        return _super.prototype.resolveUrlInternal.call(this, action);
    };
    BaseTaxonomyQuery.prototype.getTaxonomiesQueryUrl = function () {
        var action = '/' + this.taxonomiesEndpoint;
        return _super.prototype.resolveUrlInternal.call(this, action);
    };
    BaseTaxonomyQuery.prototype.runTaxonomyQuery = function (codename) {
        return this.queryService.getTaxonomy(this.getTaxonomyQueryUrl(codename), this._queryConfig);
    };
    BaseTaxonomyQuery.prototype.runTaxonomiesQuery = function () {
        return this.queryService.getTaxonomies(this.getTaxonomiesQueryUrl(), this._queryConfig);
    };
    return BaseTaxonomyQuery;
}(base_query_class_1.BaseQuery));
exports.BaseTaxonomyQuery = BaseTaxonomyQuery;
//# sourceMappingURL=base-taxonomy-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/query/taxonomy/taxonomies-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/index.js");
var base_taxonomy_query_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/taxonomy/base-taxonomy-query.class.js");
var TaxonomiesQuery = /** @class */ (function (_super) {
    __extends(TaxonomiesQuery, _super);
    function TaxonomiesQuery(config, queryService) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        return _this;
    }
    /**
    * Limits the number of taxonomies returned by query
    * @param limit Number of taxonomies to load
    */
    TaxonomiesQuery.prototype.limitParameter = function (limit) {
        this.parameters.push(new models_1.Parameters.LimitParameter(limit));
        return this;
    };
    /**
    * Skips the selected number of taxonomies
    * @param skip Number of taxonomies to skip
    */
    TaxonomiesQuery.prototype.skipParameter = function (skip) {
        this.parameters.push(new models_1.Parameters.SkipParameter(skip));
        return this;
    };
    /**
    * Gets the runnable Observable
    */
    TaxonomiesQuery.prototype.getObservable = function () {
        return _super.prototype.runTaxonomiesQuery.call(this);
    };
    // debug
    /**
    * Gets 'Url' representation of query
    */
    TaxonomiesQuery.prototype.getUrl = function () {
        return _super.prototype.getTaxonomiesQueryUrl.call(this);
    };
    return TaxonomiesQuery;
}(base_taxonomy_query_class_1.BaseTaxonomyQuery));
exports.TaxonomiesQuery = TaxonomiesQuery;
//# sourceMappingURL=taxonomies-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/query/taxonomy/taxonomy-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var base_taxonomy_query_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/taxonomy/base-taxonomy-query.class.js");
var TaxonomyQuery = /** @class */ (function (_super) {
    __extends(TaxonomyQuery, _super);
    function TaxonomyQuery(config, queryService, taxonomyCodename) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        _this.taxonomyCodename = taxonomyCodename;
        if (!taxonomyCodename) {
            throw Error("Cannot create taxonomy query without codename of the taxonomy");
        }
        return _this;
    }
    /**
    * Gets the runnable Observable
    */
    TaxonomyQuery.prototype.getObservable = function () {
        return _super.prototype.runTaxonomyQuery.call(this, this.taxonomyCodename);
    };
    /**
    * Gets 'Url' representation of query
    */
    TaxonomyQuery.prototype.getUrl = function () {
        return _super.prototype.getTaxonomyQueryUrl.call(this, this.taxonomyCodename);
    };
    return TaxonomyQuery;
}(base_taxonomy_query_class_1.BaseTaxonomyQuery));
exports.TaxonomyQuery = TaxonomyQuery;
//# sourceMappingURL=taxonomy-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/query/type/base-type-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var base_query_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/common/base-query.class.js");
var BaseTypeQuery = /** @class */ (function (_super) {
    __extends(BaseTypeQuery, _super);
    function BaseTypeQuery(config, queryService) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        _this.parameters = [];
        _this._queryConfig = {};
        return _this;
    }
    /**
     * Used to configure query
     * @param queryConfig Query configuration
     */
    BaseTypeQuery.prototype.queryConfig = function (queryConfig) {
        this._queryConfig = queryConfig;
        return this;
    };
    /**
     * Gets headers used by this query
     */
    BaseTypeQuery.prototype.getHeaders = function () {
        return this.queryService.getHeaders(this._queryConfig);
    };
    BaseTypeQuery.prototype.getSingleTypeQueryUrl = function (codename) {
        var action = '/types/' + codename;
        return _super.prototype.resolveUrlInternal.call(this, action);
    };
    BaseTypeQuery.prototype.getMultipleTypesQueryUrl = function () {
        var action = '/types';
        return _super.prototype.resolveUrlInternal.call(this, action);
    };
    BaseTypeQuery.prototype.runMultipleTypesQuery = function () {
        return this.queryService.getMultipleTypes(this.getMultipleTypesQueryUrl(), this._queryConfig);
    };
    BaseTypeQuery.prototype.runSingleTypeQuery = function (codename) {
        return this.queryService.getSingleType(this.getSingleTypeQueryUrl(codename), this._queryConfig);
    };
    return BaseTypeQuery;
}(base_query_class_1.BaseQuery));
exports.BaseTypeQuery = BaseTypeQuery;
//# sourceMappingURL=base-type-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/query/type/multiple-type-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/index.js");
var base_type_query_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/type/base-type-query.class.js");
var MultipleTypeQuery = /** @class */ (function (_super) {
    __extends(MultipleTypeQuery, _super);
    function MultipleTypeQuery(config, queryService) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        return _this;
    }
    /**
    * Limits the number of types returned by query
    * @param limit Number of types to load
    */
    MultipleTypeQuery.prototype.limitParameter = function (limit) {
        this.parameters.push(new models_1.Parameters.LimitParameter(limit));
        return this;
    };
    /**
     * Skips the selected number of types
     * @param skip Number of types to skip
     */
    MultipleTypeQuery.prototype.skipParameter = function (skip) {
        this.parameters.push(new models_1.Parameters.SkipParameter(skip));
        return this;
    };
    /**
    * Gets the runnable Observable
    */
    MultipleTypeQuery.prototype.getObservable = function () {
        return _super.prototype.runMultipleTypesQuery.call(this);
    };
    /**
    * Gets 'Url' representation of query
    */
    MultipleTypeQuery.prototype.getUrl = function () {
        return _super.prototype.getMultipleTypesQueryUrl.call(this);
    };
    return MultipleTypeQuery;
}(base_type_query_class_1.BaseTypeQuery));
exports.MultipleTypeQuery = MultipleTypeQuery;
//# sourceMappingURL=multiple-type-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/query/type/single-type-query.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var base_type_query_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/query/type/base-type-query.class.js");
var SingleTypeQuery = /** @class */ (function (_super) {
    __extends(SingleTypeQuery, _super);
    function SingleTypeQuery(config, queryService, typeCodename) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        _this.typeCodename = typeCodename;
        if (!typeCodename) {
            throw Error("Cannot create type query without the codename of the type");
        }
        return _this;
    }
    /**
    * Gets the runnable Observable
    */
    SingleTypeQuery.prototype.getObservable = function () {
        return _super.prototype.runSingleTypeQuery.call(this, this.typeCodename);
    };
    /**
    * Gets 'Url' representation of query
    */
    SingleTypeQuery.prototype.getUrl = function () {
        return _super.prototype.getSingleTypeQueryUrl.call(this, this.typeCodename);
    };
    return SingleTypeQuery;
}(base_type_query_class_1.BaseTypeQuery));
exports.SingleTypeQuery = SingleTypeQuery;
//# sourceMappingURL=single-type-query.class.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/resolvers/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/resolvers/strongly-type.resolver.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/resolvers/rich-text.resolver.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/resolvers/url-slug.resolver.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/resolvers/rich-text.resolver.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var strongly_type_resolver_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/resolvers/strongly-type.resolver.js");
var RichTextResolver = /** @class */ (function () {
    function RichTextResolver() {
        /**
        * Type identifying nested modular content in Rich text fields
        */
        this.modularContentobjectType = 'application/kenticocloud';
        /**
         * This tag wil be used instead of 'object'
         */
        this.modularContentTagWrapper = 'div';
        /**
         * Attribute used to identify modular item based on its codename
         */
        this.modularContentCodenameAttributeName = 'data-codename';
        /**
         * Tag identifying links
         */
        this.linkTag = 'a';
        /**
         * Attributes that identifies if of the content item referenced in links
         */
        this.linkContentItemIdAttributeName = 'data-item-id';
    }
    /**
     * Resolves modular content inside the Rich text field.
     * Rich text resolved needs to be configured either on the model or query level
     */
    RichTextResolver.prototype.resolveHtml = function (html, data) {
        var _this = this;
        // prepare config
        var config = {
            enableAdvancedLogging: data.enableAdvancedLogging,
            queryConfig: data.queryConfig,
            modularContentWrapperTag: data.modularContentWrapperTag,
            modularContentWrapperClasses: data.modularContentWrapperClasses
        };
        var result = data.richTextHtmlParser.resolveRichTextField(html, {
            getLinkUrl: function (itemId) { return _this.getLinkUrl({
                config: config,
                links: data.links,
                itemId: itemId,
                typeResolvers: data.typeResolvers
            }); },
            getModularContentHtml: function (itemCodename) { return _this.getHtmlOfModularContent({
                itemCodename: itemCodename,
                config: config,
                modularItems: data.modularItems
            }); }
        }, {
            enableAdvancedLogging: data.enableAdvancedLogging,
            queryConfig: data.queryConfig,
            modularContentWrapperTag: data.modularContentWrapperTag,
            modularContentWrapperClasses: data.modularContentWrapperClasses
        });
        return result.resolvedHtml;
    };
    RichTextResolver.prototype.getHtmlOfModularContent = function (data) {
        // get modular content item
        var modularContentItem = data.modularItems.find(function (m) { return m.system.codename === data.itemCodename; });
        // check if modular content really exists
        if (!modularContentItem) {
            throw Error("Cannot resolve modular content in 'RichTextField' for '" + data.itemCodename + "' content item");
        }
        // create new replacement object
        // get html to replace object using Rich text resolver function
        var resolver = undefined;
        if (data.config.queryConfig.richTextResolver) {
            // use resolved defined by query if available
            resolver = data.config.queryConfig.richTextResolver;
        }
        else {
            // use default resolver defined in models
            if (modularContentItem.richTextResolver) {
                resolver = modularContentItem.richTextResolver;
            }
        }
        // check resolver
        if (!resolver) {
            if (data.config.enableAdvancedLogging) {
                console.warn("Cannot resolve modular content of '" + modularContentItem.system.type + "' type in 'RichTextField' because no rich text resolved was configured");
                return '';
            }
            return '';
        }
        return resolver(modularContentItem);
    };
    RichTextResolver.prototype.getLinkUrl = function (data) {
        // find link with the id of content item
        var link = data.links.find(function (m) { return m.itemId === data.itemId; });
        if (!link) {
            if (data.config.enableAdvancedLogging) {
                console.warn("Cannot resolve URL for item '" + data.itemId + "' because no link with this id was found");
            }
            return '';
        }
        // try to resolve link using the resolver passed through the query config
        var queryLinkResolver = data.config.queryConfig.linkResolver;
        var url;
        if (queryLinkResolver) {
            // try to resolve url using the query config
            url = queryLinkResolver(link);
        }
        if (!url) {
            // url was not resolved, try to find global resolver for this particular type
            var emptyTypedItem = strongly_type_resolver_1.stronglyTypedResolver.createEmptyTypedObj(link.type, data.typeResolvers);
            if (!emptyTypedItem) {
                if (data.config.enableAdvancedLogging) {
                    console.warn("Cannot resolve link for link of '" + link.type + "' type with id '" + link.itemId + "' and url slug '" + link.urlSlug + "'");
                }
            }
            else {
                var globalLinkResolver = emptyTypedItem.linkResolver;
                if (globalLinkResolver) {
                    url = globalLinkResolver(link);
                }
            }
        }
        // url still wasn't resolved
        if (!url) {
            if (data.config.enableAdvancedLogging) {
                console.warn("Url for content type '" + link.type + "' with id '" + link.itemId + "' resolved to null/undefined");
            }
            return '';
        }
        return url;
    };
    return RichTextResolver;
}());
exports.RichTextResolver = RichTextResolver;
exports.richTextResolver = new RichTextResolver();
//# sourceMappingURL=rich-text.resolver.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/resolvers/strongly-type.resolver.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var content_item_system_attributes_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/item/content-item-system-attributes.js");
var content_item_class_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/item/content-item.class.js");
var StronglyTypedResolver = /** @class */ (function () {
    function StronglyTypedResolver() {
    }
    /**
     * Indicates if given type has a type resolver
     * @param type Type
     * @param resolvers Type resolvers
     */
    StronglyTypedResolver.prototype.hasTypeResolver = function (type, resolvers) {
        return !(!resolvers.find(function (m) { return m.type === type; }));
    };
    /**
     * Creates non generic ContentItem used when content type does not have a strongly typed model
     */
    StronglyTypedResolver.prototype.createContentItem = function (item) {
        var contentItem = new content_item_class_1.ContentItem();
        // use typed 'system' property
        contentItem.system = new content_item_system_attributes_1.ContentItemSystemAttributes({
            name: item.system.name,
            codename: item.system.codename,
            id: item.system.id,
            lastModified: item.system.last_modified,
            language: item.system.language,
            type: item.system.type,
            sitemapLocations: item.system.sitemap_locations
        });
        return contentItem;
    };
    /**
     * Takes given type name and creates a strongly typed model based specified in client configuration
     * @param type Type of the content item
     * @param item Typed content item
     * @param resolvers Type resolvers
     */
    StronglyTypedResolver.prototype.createTypedObj = function (type, item, typeResolvers) {
        var typedItem = this.createEmptyTypedObj(type, typeResolvers);
        if (!typedItem) {
            throw Error("Cannot find resolver for type '" + type + "'. This error means that no class was registered as TypeResolver");
        }
        // use typed 'system' property
        typedItem.system = new content_item_system_attributes_1.ContentItemSystemAttributes({
            name: item.system.name,
            codename: item.system.codename,
            id: item.system.id,
            lastModified: item.system.last_modified,
            language: item.system.language,
            type: item.system.type,
            sitemapLocations: item.system.sitemap_locations
        });
        return typedItem;
    };
    /**
     * Creates empty typed object of given type
     * @param type Type of the content item
     * @param resolvers Type resolvers
     */
    StronglyTypedResolver.prototype.createEmptyTypedObj = function (type, resolvers) {
        if (!type) {
            throw Error('Cannot resolve type because no type name was provided');
        }
        var typeResolver = resolvers.find(function (m) { return m.type === type; });
        if (!typeResolver) {
            return undefined;
        }
        return typeResolver.resolve();
    };
    return StronglyTypedResolver;
}());
exports.StronglyTypedResolver = StronglyTypedResolver;
exports.stronglyTypedResolver = new StronglyTypedResolver();
//# sourceMappingURL=strongly-type.resolver.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/resolvers/url-slug.resolver.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/index.js");
var UrlSlugResolver = /** @class */ (function () {
    function UrlSlugResolver() {
    }
    UrlSlugResolver.prototype.resolveUrl = function (data) {
        if (!data.linkResolver) {
            if (data.enableAdvancedLogging) {
                console.warn("You have to implement 'linkResolver' in your Model class or your query in order to get url of this item");
            }
            return undefined;
        }
        if (!data.item) {
            if (data.enableAdvancedLogging) {
                console.warn("Cannot resolve link for field '" + data.fieldName + "' because no item was provided to URL slug field (item may be missing from response)");
            }
            return undefined;
        }
        var url = data.linkResolver(new models_1.Link({
            urlSlug: data.fieldValue,
            type: data.type,
            codename: data.item.system.codename,
            itemId: data.item.system.id
        }));
        if (!url) {
            if (data.enableAdvancedLogging) {
                console.warn("'linkResolver' is configured, but url resolved for '" + data.item.system.codename + "' item of '" + data.item.system.type + "' type inside '" + data.fieldName + "' field resolved to an undefined url.");
            }
            return undefined;
        }
        return url;
    };
    return UrlSlugResolver;
}());
exports.UrlSlugResolver = UrlSlugResolver;
exports.urlSlugResolver = new UrlSlugResolver();
//# sourceMappingURL=url-slug.resolver.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/sdk-info.generated.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
exports.sdkInfo = {
    host: 'npmjs.com',
    version: '4.0.1',
    name: 'kentico-cloud-delivery'
};
//# sourceMappingURL=sdk-info.generated.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/services/http/delivery-http-service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var axios_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/index.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/_esm5/index.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/_esm5/operators/index.js");
var models_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/models/index.js");
var KCErrorNames = {
    errorCode: 'error_code',
    message: 'message',
    requestId: 'request_id',
    specificCode: 'specific_code'
};
var DeliveryHttpService = /** @class */ (function () {
    function DeliveryHttpService() {
    }
    DeliveryHttpService.prototype.get = function (url, headers) {
        return rxjs_1.from(axios_1["default"].get(url, {
            headers: this.getHeadersJson(headers)
        })).pipe(operators_1.map(function (response) {
            return {
                data: response.data,
                response: response
            };
        }), operators_1.catchError(function (error) {
            // Handling errors: https://github.com/axios/axios#handling-errors
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                var cloudError = void 0;
                var data = error.response.data;
                if (data[KCErrorNames.requestId]) {
                    cloudError = new models_1.DeliveryCloudError({
                        requestId: data[KCErrorNames.requestId],
                        message: data[KCErrorNames.message] ? data[KCErrorNames.message] : '',
                        errorCode: data[KCErrorNames.errorCode] ? data[KCErrorNames.errorCode] : 0,
                        specificCode: data[KCErrorNames.specificCode] ? data[KCErrorNames.specificCode] : 0
                    });
                }
                return rxjs_1.throwError({
                    message: error.message,
                    originalError: error,
                    cloudError: cloudError
                });
            }
            else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                return rxjs_1.throwError({
                    message: error.message,
                    originalError: error
                });
            }
            // Something happened in setting up the request that triggered an Error
            return rxjs_1.throwError({
                message: error.message,
                originalError: error
            });
        }));
    };
    DeliveryHttpService.prototype.getHeadersJson = function (headers) {
        var headerJson = {
            'Content-Type': 'application/json'
        };
        if (!headers) {
            return headerJson;
        }
        headers.forEach(function (header) {
            headerJson[header.header] = header.value;
        });
        return headerJson;
    };
    return DeliveryHttpService;
}());
exports.DeliveryHttpService = DeliveryHttpService;
//# sourceMappingURL=delivery-http-service.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/services/http/delivery-retry-strategy.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var rxjs_1 = __webpack_require__("./node_modules/rxjs/_esm5/index.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/_esm5/operators/index.js");
var DeliveryRetryStrategy = /** @class */ (function () {
    function DeliveryRetryStrategy() {
        var _this = this;
        this.strategy = function (options) { return function (attempts) {
            return attempts.pipe(operators_1.mergeMap(function (error, i) {
                var retryAttempt = i + 1;
                // if maximum number of retries have been met
                // or response is a status code we don't wish to retry, throw error
                if (retryAttempt > options.maxRetryAttempts ||
                    options.excludedStatusCodes.find(function (e) { return e === error.status; })) {
                    return rxjs_1.throwError(error);
                }
                // calculate retry time
                var retryTimeout = _this.getRetryTimeout(retryAttempt);
                // debug log attempt
                _this.debugLogAttempt(retryAttempt, retryTimeout);
                return rxjs_1.timer(retryTimeout);
            }));
        }; };
    }
    /**
    * Calculates retry attempt timeout in ms
    * @param attempt Index of the attempt to calculate increasing delay when retrying
    */
    DeliveryRetryStrategy.prototype.getRetryTimeout = function (attempt) {
        return Math.pow(2, attempt) * 100;
    };
    /**
     * Logs attempt in console.
     * This function is also used for testing in jasmine spy
     * @param attempt Index of attempt
     */
    DeliveryRetryStrategy.prototype.debugLogAttempt = function (attempt, retryTimeout) {
        console.warn("Attempt " + attempt + ": retrying in " + retryTimeout + "ms");
    };
    return DeliveryRetryStrategy;
}());
exports.DeliveryRetryStrategy = DeliveryRetryStrategy;
exports.deliveryRetryStrategy = new DeliveryRetryStrategy();
//# sourceMappingURL=delivery-retry-strategy.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/services/http/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/services/http/delivery-retry-strategy.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/services/http/delivery-http-service.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/services/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/services/query.service.js"));
__export(__webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/services/http/index.js"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/_commonjs/services/query.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var rxjs_1 = __webpack_require__("./node_modules/rxjs/_esm5/index.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/_esm5/operators/index.js");
var mappers_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/mappers/index.js");
var delivery_retry_strategy_1 = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/services/http/delivery-retry-strategy.js");
var QueryService = /** @class */ (function () {
    function QueryService(
    /**
     * Delivery client configuration
     */
    config, 
    /**
     * Http service for fetching data
     */
    httpService, 
    /**
    * Used for manipulating with rich text HTML (required for Node / Browser support)
    */
    richTextHtmlParser, 
    /**
    * Information about the SDK
    * This can contain information from both this & Node SDK for internal logging with 'SDKID' header
    */
    sdkInfo) {
        this.config = config;
        this.httpService = httpService;
        this.richTextHtmlParser = richTextHtmlParser;
        this.sdkInfo = sdkInfo;
        /**
         * Default number of retry attempts when user did not set any
         */
        this.defaultRetryAttempts = 3;
        /**
         * Excluded status code from retry functionality
         */
        this.retryExcludedStatuses = [404, 401];
        /**
         * Header name for SDK usage
         */
        this.sdkVersionHeader = 'X-KC-SDKID';
        /**
        * Default base Url to Kentico Delivery API
        */
        this.defaultBaseDeliveryApiUrl = 'https://deliver.kenticocloud.com';
        /**
        * Default preview url to Kentico Delivery API
        */
        this.defaultPreviewDeliveryApiUrl = 'https://preview-deliver.kenticocloud.com';
        /**
         * Name of the header used when 'wait for loading new content' feature is used
         */
        this.waitForLoadingNewContentHeader = 'X-KC-Wait-For-Loading-New-Content';
        if (!config) {
            throw Error("Invalid configuration has been provided");
        }
        this.responseMapper = new mappers_1.ResponseMapper(config, richTextHtmlParser);
    }
    /**
     * Gets url based on the action, query configuration and options (parameters)
     * @param action Action (= url part) that will be hit
     * @param queryConfig Query configuration
     * @param options Query options
     */
    QueryService.prototype.getUrl = function (action, queryConfig, options) {
        return this.addOptionsToUrl(this.getBaseUrl(queryConfig) + action, options);
    };
    /**
     * Gets single item from given url
     * @param url Url used to get single item
     * @param queryConfig Query configuration
     */
    QueryService.prototype.getSingleItem = function (url, queryConfig) {
        var _this = this;
        return this.getResponse(url, queryConfig)
            .pipe(operators_1.map(function (response) {
            return _this.responseMapper.mapSingleResponse(response, queryConfig);
        }), operators_1.catchError(function (err) {
            return rxjs_1.throwError(_this.handleError(err));
        }));
    };
    /**
    * Gets multiple items from given url
    * @param url Url used to get multiple items
    * @param queryConfig Query configuration
    */
    QueryService.prototype.getMultipleItems = function (url, queryConfig) {
        var _this = this;
        return this.getResponse(url, queryConfig)
            .pipe(operators_1.map(function (response) {
            return _this.responseMapper.mapMultipleResponse(response, queryConfig);
        }), operators_1.catchError(function (err) {
            return rxjs_1.throwError(_this.handleError(err));
        }));
    };
    /**
     * Gets single content type from given url
     * @param url Url used to get single type
     * @param queryConfig Query configuration
     */
    QueryService.prototype.getSingleType = function (url, queryConfig) {
        var _this = this;
        return this.getResponse(url, queryConfig)
            .pipe(operators_1.map(function (response) {
            return _this.responseMapper.mapSingleTypeResponse(response);
        }), operators_1.catchError(function (err) {
            return rxjs_1.throwError(_this.handleError(err));
        }));
    };
    /**
     * Gets multiple content types from given url
     * @param url Url used to get multiple types
     * @param queryConfig Query configuration
     */
    QueryService.prototype.getMultipleTypes = function (url, queryConfig) {
        var _this = this;
        return this.getResponse(url, queryConfig)
            .pipe(operators_1.map(function (response) {
            return _this.responseMapper.mapMultipleTypeResponse(response);
        }), operators_1.catchError(function (err) {
            return rxjs_1.throwError(_this.handleError(err));
        }));
    };
    /**
     * Gets single taxonomy from given url
     * @param url Url used to get single taxonomy
     * @param queryConfig Query configuration
     */
    QueryService.prototype.getTaxonomy = function (url, queryConfig) {
        var _this = this;
        return this.getResponse(url, queryConfig)
            .pipe(operators_1.map(function (response) {
            return _this.responseMapper.mapTaxonomyResponse(response);
        }), operators_1.catchError(function (err) {
            return rxjs_1.throwError(_this.handleError(err));
        }));
    };
    /**
    * Gets multiple taxonomies from given url
    * @param url Url used to get multiple taxonomies
    * @param queryConfig Query configuration
    */
    QueryService.prototype.getTaxonomies = function (url, queryConfig) {
        var _this = this;
        return this.getResponse(url, queryConfig)
            .pipe(operators_1.map(function (response) {
            return _this.responseMapper.mapTaxonomiesResponse(response);
        }), operators_1.catchError(function (err) {
            return rxjs_1.throwError(_this.handleError(err));
        }));
    };
    /**
    * Gets single content type element from given url
    * @param url Url used to get single content type element
    * @param queryConfig Query configuration
    */
    QueryService.prototype.getElement = function (url, queryConfig) {
        var _this = this;
        return this.getResponse(url, queryConfig)
            .pipe(operators_1.map(function (response) {
            return _this.responseMapper.mapElementResponse(response);
        }), operators_1.catchError(function (err) {
            return rxjs_1.throwError(_this.handleError(err));
        }));
    };
    /**
     * Gets proper set of headers for given request.
     * @param queryConfig Query configuration
     */
    QueryService.prototype.getHeaders = function (queryConfig) {
        var headers = [];
        // add SDK Id header for monitoring SDK usage
        headers.push(this.getSdkIdHeader());
        if (this.isPreviewModeEnabled(queryConfig) && this.isSecuredModeEnabled(queryConfig)) {
            throw Error("Preview & secured modes cannot be used at the same time.");
        }
        // add preview header is required
        if (this.isPreviewModeEnabled(queryConfig)) {
            headers.push(this.getAuthorizationHeader(this.config.previewApiKey));
        }
        // add secured mode header is required
        if (this.isSecuredModeEnabled(queryConfig)) {
            headers.push(this.getAuthorizationHeader(this.config.securedApiKey));
        }
        // add 'X-KC-Wait-For-Loading-New-Content' header if required
        if (queryConfig.waitForLoadingNewContent) {
            headers.push({
                header: this.waitForLoadingNewContentHeader,
                value: 'true'
            });
        }
        return headers;
    };
    /**
    * Http get response
    * @param url Url of request
    * @param queryConfig Query configuration
    */
    QueryService.prototype.getResponse = function (url, queryConfig) {
        var _this = this;
        return this.httpService.get(url, this.getHeaders(queryConfig))
            .pipe(operators_1.map(function (response) {
            return response;
        }), operators_1.retryWhen(delivery_retry_strategy_1.deliveryRetryStrategy.strategy({
            maxRetryAttempts: this.getRetryAttempts(),
            excludedStatusCodes: this.retryExcludedStatuses
        })), operators_1.catchError(function (err) {
            return rxjs_1.throwError(_this.handleError(err));
        }));
    };
    /**
     * Gets number of retry attempts used by queries
     */
    QueryService.prototype.getRetryAttempts = function () {
        // get the attempts
        var attempts;
        if (this.config.retryAttempts || this.config.retryAttempts === 0) {
            // use custom defined number of attempts
            attempts = this.config.retryAttempts;
        }
        else {
            // use default attempts
            attempts = this.defaultRetryAttempts;
        }
        return attempts;
    };
    /**
     * Handles given error
     * @param error Error to be handled
     */
    QueryService.prototype.handleError = function (error) {
        if (this.config.enableAdvancedLogging) {
            console.error(error);
        }
        if (error.cloudError) {
            return error.cloudError;
        }
        return error;
    };
    /**
     * Indicates if current query should use preview mode
     * @param queryConfig Query configuration
     */
    QueryService.prototype.isPreviewModeEnabled = function (queryConfig) {
        if (queryConfig.usePreviewMode != null) {
            return queryConfig.usePreviewMode;
        }
        return this.config.enablePreviewMode === true;
    };
    /**
    * Indicates if current query should use secured mode
    * @param queryConfig Query configuration
    */
    QueryService.prototype.isSecuredModeEnabled = function (queryConfig) {
        if (queryConfig.useSecuredMode != null) {
            return queryConfig.useSecuredMode;
        }
        return this.config.enableSecuredMode === true;
    };
    /**
     * Gets preview or standard URL based on client and query configuration
     * @param queryConfig Query configuration
     */
    QueryService.prototype.getDeliveryUrl = function (queryConfig) {
        if (this.isPreviewModeEnabled(queryConfig)) {
            if (!this.config.previewApiKey) {
                throw Error("You have to configure 'previewApiKey' to use 'preview' mode");
            }
            // use custom base / preview url if its configured
            if (this.config.basePreviewUrl) {
                return this.config.basePreviewUrl;
            }
            // use default preview url
            return this.defaultPreviewDeliveryApiUrl;
        }
        // use custom base / preview url if its configured
        if (this.config.baseUrl) {
            return this.config.baseUrl;
        }
        return this.defaultBaseDeliveryApiUrl;
    };
    /**
     * Gets base URL of the request including the project Id
     * @param queryConfig Query configuration
     */
    QueryService.prototype.getBaseUrl = function (queryConfig) {
        return this.getDeliveryUrl(queryConfig) + '/' + this.config.projectId;
    };
    /**
     * Adds query parameters to given url
     * @param url Url to which options will be added
     * @param options Query parameters to add
     */
    QueryService.prototype.addOptionsToUrl = function (url, options) {
        if (options) {
            options.forEach(function (filter) {
                if (url.indexOf('?') > -1) {
                    url = url + '&' + filter.getParam() + '=' + filter.getParamValue();
                }
                else {
                    url = url + '?' + filter.getParam() + '=' + filter.getParamValue();
                }
            });
        }
        return url;
    };
    /**
     * Gets authorization header. This is used for 'preview' functionality
     */
    QueryService.prototype.getAuthorizationHeader = function (key) {
        if (!key) {
            throw Error("Cannot get authorization header because key is undefined");
        }
        // authorization header required for preview mode
        return {
            header: 'authorization',
            value: "bearer " + key
        };
    };
    /**
     * Header identifying SDK type & version for internal purposes of Kentico
     */
    QueryService.prototype.getSdkIdHeader = function () {
        return {
            header: this.sdkVersionHeader,
            value: this.sdkInfo.host + ";" + this.sdkInfo.name + ";" + this.sdkInfo.version
        };
    };
    return QueryService;
}());
exports.QueryService = QueryService;
//# sourceMappingURL=query.service.js.map

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/axios.js");

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/adapters/xhr.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/utils.js");
var settle = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/core/settle.js");
var buildURL = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/helpers/buildURL.js");
var parseHeaders = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/helpers/parseHeaders.js");
var isURLSameOrigin = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/helpers/isURLSameOrigin.js");
var createError = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/core/createError.js");
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/helpers/btoa.js");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/helpers/cookies.js");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/axios.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/utils.js");
var bind = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/helpers/bind.js");
var Axios = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/core/Axios.js");
var defaults = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/defaults.js");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/cancel/Cancel.js");
axios.CancelToken = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/cancel/CancelToken.js");
axios.isCancel = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/cancel/isCancel.js");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/helpers/spread.js");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/cancel/Cancel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/cancel/CancelToken.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/cancel/Cancel.js");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/cancel/isCancel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/core/Axios.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/defaults.js");
var utils = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/utils.js");
var InterceptorManager = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/core/InterceptorManager.js");
var dispatchRequest = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/core/dispatchRequest.js");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/core/InterceptorManager.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/utils.js");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/core/createError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/core/enhanceError.js");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/core/dispatchRequest.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/utils.js");
var transformData = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/core/transformData.js");
var isCancel = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/cancel/isCancel.js");
var defaults = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/defaults.js");
var isAbsoluteURL = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/helpers/isAbsoluteURL.js");
var combineURLs = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/helpers/combineURLs.js");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/core/enhanceError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/core/settle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/core/createError.js");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/core/transformData.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/utils.js");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/defaults.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/utils.js");
var normalizeHeaderName = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/helpers/normalizeHeaderName.js");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/adapters/xhr.js");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/adapters/xhr.js");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/helpers/bind.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/helpers/btoa.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/helpers/buildURL.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/utils.js");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/helpers/combineURLs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/helpers/cookies.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/helpers/isAbsoluteURL.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/helpers/isURLSameOrigin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/helpers/normalizeHeaderName.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/utils.js");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/helpers/parseHeaders.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/utils.js");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/helpers/spread.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "./node_modules/kentico-cloud-delivery/node_modules/axios/lib/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("./node_modules/kentico-cloud-delivery/node_modules/axios/lib/helpers/bind.js");
var isBuffer = __webpack_require__("./node_modules/is-buffer/index.js");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "./node_modules/lodash.debounce/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/react-scripts/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/lodash/chunk.js":
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__("./node_modules/lodash/_baseSlice.js"),
    isIterateeCall = __webpack_require__("./node_modules/lodash/_isIterateeCall.js"),
    toInteger = __webpack_require__("./node_modules/lodash/toInteger.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

module.exports = chunk;


/***/ }),

/***/ "./node_modules/lodash/isNil.js":
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),

/***/ "./node_modules/moment/moment.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/react-scripts/node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/organism-react-scroll-nav/build/es/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stores_scrollStore__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/src/stores/scrollStore.js");
/* unused harmony reexport scrollStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stores_fastScrollStore__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/src/stores/fastScrollStore.js");
/* unused harmony reexport fastScrollStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_organisms_ScrollSpy__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/ui/organisms/ScrollSpy.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__ui_organisms_ScrollSpy__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_organisms_ScrollReceiver__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/ui/organisms/ScrollReceiver.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__ui_organisms_ScrollReceiver__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_organisms_ScrollInfo__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/ui/organisms/ScrollInfo.js");
/* unused harmony reexport ScrollInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_organisms_SmoothScrollLink__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/ui/organisms/SmoothScrollLink.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__ui_organisms_SmoothScrollLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scrollDispatcher__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/src/scrollDispatcher.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__scrollDispatcher__["b"]; });
// Stores



// UI





// Dispatch


/***/ }),

/***/ "./node_modules/organism-react-scroll-nav/build/es/src/scrollDispatcher.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scrollDispatch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_flux__ = __webpack_require__("./node_modules/reshow-flux/build/es/index.js");




var instance = new __WEBPACK_IMPORTED_MODULE_0_reshow_flux__["a" /* Dispatcher */]();
/* harmony default export */ __webpack_exports__["a"] = (instance);

var scrollDispatch = instance.dispatch.bind(instance);

/***/ }),

/***/ "./node_modules/organism-react-scroll-nav/build/es/src/stores/fastScrollStore.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scrollDispatcher__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/src/scrollDispatcher.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scrollStore__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/src/stores/scrollStore.js");


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var fastScrollStore = function (_scrollStore) {
  _inherits(fastScrollStore, _scrollStore);

  function fastScrollStore() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, fastScrollStore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = fastScrollStore.__proto__ || Object.getPrototypeOf(fastScrollStore)).call.apply(_ref, [this].concat(args))), _this), _this.storeName = 'fastScroll', _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(fastScrollStore, [{
    key: 'runScrollMonitor',
    value: function runScrollMonitor() {
      this.triggerScroll();
    }
  }]);

  return fastScrollStore;
}(__WEBPACK_IMPORTED_MODULE_1__scrollStore__["b" /* scrollStore */]);

/* harmony default export */ __webpack_exports__["a"] = (new fastScrollStore(__WEBPACK_IMPORTED_MODULE_0__scrollDispatcher__["a" /* default */]));

/***/ }),

/***/ "./node_modules/organism-react-scroll-nav/build/es/src/stores/scrollStore.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scrollStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("./node_modules/immutable/dist/immutable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_flux__ = __webpack_require__("./node_modules/reshow-flux/build/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_get_scroll_info__ = __webpack_require__("./node_modules/get-scroll-info/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_get_window_offset__ = __webpack_require__("./node_modules/get-window-offset/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_getoffset__ = __webpack_require__("./node_modules/getoffset/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_get_object_value__ = __webpack_require__("./node_modules/get-object-value/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scrollDispatcher__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/src/scrollDispatcher.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__testForPassiveScroll__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/src/testForPassiveScroll.js");


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var incNum = 0;

var scrollStore = function (_ReduceStore) {
    _inherits(scrollStore, _ReduceStore);

    function scrollStore() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, scrollStore);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = scrollStore.__proto__ || Object.getPrototypeOf(scrollStore)).call.apply(_ref, [this].concat(args))), _this), _this.storeName = 'delayScroll', _this.isInitEvent = false, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(scrollStore, [{
        key: 'getInitialState',
        value: function getInitialState() {
            this.spys = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])();
            this.margins = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])();
            this.scrollMonitor = this.runScrollMonitor.bind(this);
            return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
                scrollDelay: 50,
                scrollMargin: 0
            });
        }
    }, {
        key: 'initEvent',
        value: function initEvent() {
            if ('undefined' !== typeof window) {
                var self = this;
                var win = window;
                if (win.addEventListener) {
                    var supportsPassive = Object(__WEBPACK_IMPORTED_MODULE_7__testForPassiveScroll__["a" /* default */])();
                    win.addEventListener('scroll', self.scrollMonitor, supportsPassive ? { passive: true } : false);
                    win.addEventListener('resize', self.scrollMonitor);
                } else {
                    win.attachEvent('onscroll', self.scrollMonitor);
                    win.attachEvent('resize', self.scrollMonitor);
                }
                setTimeout(function () {
                    self.scrollMonitor();
                    //for lazy content 
                    setTimeout(function () {
                        return self.scrollMonitor();
                    }, 777);
                });

                self.isInitEvent = true;
            }
        }
    }, {
        key: 'removeEvent',
        value: function removeEvent() {
            var self = this;
            var win = window;
            win.removeEventListener('scroll', self.scrollMonitor);
            win.removeEventListener('resize', self.scrollMonitor);
            self.isInitEvent = false;
        }
    }, {
        key: 'runScrollMonitor',
        value: function runScrollMonitor() {
            clearTimeout(this._scrollTimeout);
            var self = this;
            var delay = self.getState().get('scrollDelay');
            self._scrollTimeout = setTimeout(function () {
                return self.triggerScroll.call(self);
            }, delay);
        }
    }, {
        key: 'triggerScroll',
        value: function triggerScroll() {
            var defaultMargin = this.getState().get('scrollMargin');
            var actives = { mdefault: null };
            var offsetCache = {};
            var arrMonitorScroll = [];
            var scroll = Object(__WEBPACK_IMPORTED_MODULE_2_get_scroll_info__["a" /* default */])();
            var scrollTop = scroll.top + defaultMargin;
            var margin = void 0;
            this.spys.forEach(function (node) {
                var nodeEl = node.getOffsetEl();

                var _get = Object(__WEBPACK_IMPORTED_MODULE_5_get_object_value__["a" /* default */])(node, ['props'], {}),
                    monitorScroll = _get.monitorScroll,
                    scrollMargin = _get.scrollMargin;

                var pos = Object(__WEBPACK_IMPORTED_MODULE_4_getoffset__["a" /* default */])(nodeEl);
                if (monitorScroll) {
                    if (scrollTop >= pos.top && scrollTop < pos.bottom) {
                        actives.mdefault = node.id;
                    }
                    arrMonitorScroll.push(node);
                }
                margin = scrollMargin ? scrollMargin : defaultMargin;
                pos = Object(__WEBPACK_IMPORTED_MODULE_3_get_window_offset__["a" /* isOnScreen */])(pos, scroll, margin);
                offsetCache[node.id] = pos;
            });
            this.margins.forEach(function (margin) {
                scrollTop = scroll.top + margin;
                actives['m' + margin] = null;
                arrMonitorScroll.every(function (node) {
                    var pos = offsetCache[node.id];
                    if (scrollTop >= pos.top && scrollTop < pos.bottom) {
                        actives['m' + margin] = node.id;
                        return false;
                    }
                    return true;
                });
            });
            this.margins = this.margins.clear();
            Object(__WEBPACK_IMPORTED_MODULE_6__scrollDispatcher__["b" /* scrollDispatch */])(_extends({}, actives, {
                nodes: offsetCache,
                scroll: scroll,
                storeName: this.storeName
            }));
        }
    }, {
        key: 'getNode',
        value: function getNode(id) {
            var item = false;
            this.spys.some(function (node) {
                if (id === node.id) {
                    item = node;
                }
                return item;
            });
            return item;
        }
    }, {
        key: 'getOffset',
        value: function getOffset(id, callName) {
            var nodes = this.getMap('nodes');
            return nodes[id];
        }
    }, {
        key: 'hasAttach',
        value: function hasAttach(node) {
            return this.spys.has(node);
        }
    }, {
        key: 'attach',
        value: function attach(node) {
            if (!node.id) {
                if (node.props.id) {
                    node.id = node.props.id;
                } else {
                    node.id = 'spy-' + incNum;
                    incNum++;
                }
            }
            this.spys = this.spys.add(node);
            if (!this.isInitEvent) {
                this.initEvent();
            }
            return node.id;
        }
    }, {
        key: 'detach',
        value: function detach(node) {
            this.spys = this.spys.remove(node);
            if (!this.spys.size) {
                this.removeEvent();
            }
        }
    }, {
        key: 'addMargin',
        value: function addMargin(num) {
            this.margins = this.margins.add(num);
        }
    }, {
        key: 'deleteMargin',
        value: function deleteMargin(num) {
            this.margins = this.margins.remove(num);
        }
    }, {
        key: 'reduce',
        value: function reduce(state, action) {
            var storeName = Object(__WEBPACK_IMPORTED_MODULE_5_get_object_value__["a" /* default */])(action, ['storeName']);
            if (storeName === this.storeName) {
                return state.merge(action);
            } else {
                return state;
            }
        }
    }]);

    return scrollStore;
}(__WEBPACK_IMPORTED_MODULE_1_reshow_flux__["b" /* ReduceStore */]);

/* harmony default export */ __webpack_exports__["a"] = (new scrollStore(__WEBPACK_IMPORTED_MODULE_6__scrollDispatcher__["a" /* default */]));


/***/ }),

/***/ "./node_modules/organism-react-scroll-nav/build/es/src/testForPassiveScroll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var testForPassiveScroll = function testForPassiveScroll() {
    var win = window;
    var supportsPassiveOption = false;
    try {
        var opts = Object.defineProperty({}, 'passive', {
            get: function get() {
                supportsPassiveOption = true;
            }
        });
        win.addEventListener('test', null, opts);
        win.removeEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
};

/* harmony default export */ __webpack_exports__["a"] = (testForPassiveScroll);

/***/ }),

/***/ "./node_modules/organism-react-scroll-nav/build/es/ui/organisms/ScrollInfo.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__organisms_ScrollSpy__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/ui/organisms/ScrollSpy.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__organisms_ScrollReceiver__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/ui/organisms/ScrollReceiver.js");
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var ScrollInfo = function ScrollInfo(_ref) {
    var children = _ref.children,
        others = _objectWithoutProperties(_ref, ['children']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__organisms_ScrollSpy__["a" /* default */],
        others,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__organisms_ScrollReceiver__["a" /* default */],
            null,
            children
        )
    );
};

/* unused harmony default export */ var _unused_webpack_default_export = (ScrollInfo);

/***/ }),

/***/ "./node_modules/organism-react-scroll-nav/build/es/ui/organisms/ScrollReceiver.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_flux__ = __webpack_require__("./node_modules/reshow-flux/build/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_atomic_molecule__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_stores_scrollStore__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/src/stores/scrollStore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_stores_fastScrollStore__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/src/stores/fastScrollStore.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ScrollReceiver = function (_PureComponent) {
   _inherits(ScrollReceiver, _PureComponent);

   function ScrollReceiver() {
      _classCallCheck(this, ScrollReceiver);

      return _possibleConstructorReturn(this, (ScrollReceiver.__proto__ || Object.getPrototypeOf(ScrollReceiver)).apply(this, arguments));
   }

   _createClass(ScrollReceiver, [{
      key: 'render',
      value: function render() {
         var _props = this.props,
             atom = _props.atom,
             container = _props.container,
             scrollMargin = _props.scrollMargin,
             targetId = _props.targetId,
             isScrollReceiver = _props.isScrollReceiver,
             noDelay = _props.noDelay,
             children = _props.children,
             resetProps = _objectWithoutProperties(_props, ['atom', 'container', 'scrollMargin', 'targetId', 'isScrollReceiver', 'noDelay', 'children']);

         if (!Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(container)) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
               __WEBPACK_IMPORTED_MODULE_2_react_atomic_molecule__["a" /* SemanticUI */],
               resetProps,
               children
            );
         }
         var targetInfo = _extends({}, this.state, {
            targetId: targetId
         });
         var thisChildren = children;
         if (!thisChildren) {
            thisChildren = container.props.children;
         }
         return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(container, _extends({}, resetProps, {
            targetInfo: targetInfo
         }), thisChildren);
      }
   }], [{
      key: 'getStores',
      value: function getStores(props) {
         return props.noDelay ? [__WEBPACK_IMPORTED_MODULE_4__src_stores_fastScrollStore__["a" /* default */]] : [__WEBPACK_IMPORTED_MODULE_3__src_stores_scrollStore__["a" /* default */]];
      }
   }, {
      key: 'calculateState',
      value: function calculateState(prevState, props) {
         var noDelay = props.noDelay,
             targetId = props.targetId,
             scrollMargin = props.scrollMargin;

         var store = noDelay ? __WEBPACK_IMPORTED_MODULE_4__src_stores_fastScrollStore__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_3__src_stores_scrollStore__["a" /* default */];
         var state = store.getState();
         var isShown = prevState && prevState.isShown || false;
         var pos = store.getOffset(targetId, store.storeName) || {};
         var scrollInfo = store.getMap('scroll');
         var scrollTop = scrollInfo.top;
         if (pos.isOnScreen) {
            isShown = true;
         }
         var active = 'undefined' !== typeof targetId && targetId === state.get('m' + scrollMargin);
         if (!isNaN(scrollMargin)) {
            store.addMargin(scrollMargin);
         }
         return _extends({}, pos, {
            active: active,
            scrollTop: scrollTop,
            scrollInfo: scrollInfo,
            isShown: isShown
         });
      }
   }]);

   return ScrollReceiver;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

ScrollReceiver.defaultProps = {
   scrollMargin: 'default',
   isScrollReceiver: true,
   noDelay: false
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_reshow_flux__["c" /* connect */])(ScrollReceiver, { withProps: true }));

/***/ }),

/***/ "./node_modules/organism-react-scroll-nav/build/es/ui/organisms/ScrollSpy.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_get_object_value__ = __webpack_require__("./node_modules/get-object-value/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_atomic_molecule__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_stores_scrollStore__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/src/stores/scrollStore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_stores_fastScrollStore__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/src/stores/fastScrollStore.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var _ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_atomic_molecule__["a" /* SemanticUI */], null);

var ScrollSpy = function (_PureComponent) {
    _inherits(ScrollSpy, _PureComponent);

    function ScrollSpy() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ScrollSpy);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScrollSpy.__proto__ || Object.getPrototypeOf(ScrollSpy)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ScrollSpy, [{
        key: 'getOffsetEl',
        value: function getOffsetEl() {
            if (this.el) {
                return this.el;
            } else {
                console.warn('Please use SemanticUI. props.container -> import {SemanticUI} from "react-atomic-molecule"');
            }
        }
    }, {
        key: 'useStore',
        value: function useStore() {
            var noDelay = this.props.noDelay;

            return noDelay ? __WEBPACK_IMPORTED_MODULE_4__src_stores_fastScrollStore__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_3__src_stores_scrollStore__["a" /* default */];
        }
    }, {
        key: 'attach',
        value: function attach() {
            if (this.useStore().hasAttach(this)) {
                return this.state.id;
            }
            var id = this.useStore().attach(this);
            this.setState({ id: id });
            return id;
        }
    }, {
        key: 'detach',
        value: function detach() {
            return this.useStore().detach(this);
        }
    }, {
        key: 'isScrollReceiver',
        value: function isScrollReceiver(el) {
            if (Object(__WEBPACK_IMPORTED_MODULE_1_get_object_value__["a" /* default */])(el, ['props', 'isScrollReceiver'])) {
                return true;
            }
            return false;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.attach();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.detach();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            /**
             * monitorScroll use in store, in component just for reset props.
             */
            var _props = this.props,
                className = _props.className,
                monitorScroll = _props.monitorScroll,
                children = _props.children,
                container = _props.container,
                noDelay = _props.noDelay,
                others = _objectWithoutProperties(_props, ['className', 'monitorScroll', 'children', 'container', 'noDelay']);

            var isScrollReceiver = this.isScrollReceiver(children);
            var targetId = this.state.id;
            var classes = Object(__WEBPACK_IMPORTED_MODULE_2_react_atomic_molecule__["b" /* mixClass */])(className, 'spy-tar-' + targetId);
            var cookChildren = void 0;
            var thisContainer = void 0;
            var thisProps = void 0;
            if (isScrollReceiver) {
                thisContainer = children;
                thisProps = _extends({}, others, children.props, {
                    className: classes,
                    targetId: targetId,
                    container: container,
                    noDelay: noDelay
                });
            } else {
                thisProps = _extends({
                    children: children,
                    className: classes
                }, others);
                if (container) {
                    thisContainer = container;
                } else {
                    thisContainer = _ref2;
                }
            }
            thisProps = _extends({}, thisProps, {
                refCb: function refCb(el) {
                    return _this2.el = el;
                }
            });
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(thisContainer, thisProps);
        }
    }]);

    return ScrollSpy;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

ScrollSpy.defaultProps = {
    monitorScroll: true,
    noDelay: false
};


/* harmony default export */ __webpack_exports__["a"] = (ScrollSpy);

/***/ }),

/***/ "./node_modules/organism-react-scroll-nav/build/es/ui/organisms/SmoothScrollLink.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_smooth_scroll_to__ = __webpack_require__("./node_modules/smooth-scroll-to/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_getoffset__ = __webpack_require__("./node_modules/getoffset/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_index__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_stores_scrollStore__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/src/stores/scrollStore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_stores_fastScrollStore__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/src/stores/fastScrollStore.js");


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var scollTimer = null;
var resetTimer = function resetTimer() {
    if (scollTimer) {
        clearTimeout(scollTimer);
        scollTimer = false;
    }
};

var SmoothScrollLink = function (_PureComponent) {
    _inherits(SmoothScrollLink, _PureComponent);

    function SmoothScrollLink() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SmoothScrollLink);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SmoothScrollLink.__proto__ || Object.getPrototypeOf(SmoothScrollLink)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            scrollRefElement: null
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SmoothScrollLink, [{
        key: 'useStore',
        value: function useStore() {
            var noDelay = this.props.noDelay;

            return noDelay ? __WEBPACK_IMPORTED_MODULE_5__src_stores_fastScrollStore__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_4__src_stores_scrollStore__["a" /* default */];
        }
    }, {
        key: 'getMargin',
        value: function getMargin(props, ref) {
            var scrollRefLoc = props.scrollRefLoc;

            var margin = 0;
            if (ref) {
                var offset = Object(__WEBPACK_IMPORTED_MODULE_2_getoffset__["a" /* default */])(ref);
                margin = offset[scrollRefLoc];
            }
            if (!isNaN(props.scrollMargin)) {
                margin += props.scrollMargin;
            }
            return margin;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var dom = document.getElementById(this.props.scrollRefId);
            if (dom) {
                this.setState({
                    scrollRefElement: dom
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            resetTimer();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var store = this.useStore();
            var props = this.props;

            var targetId = props.targetId,
                scrollRefLoc = props.scrollRefLoc,
                scrollMargin = props.scrollMargin,
                scrollRefId = props.scrollRefId,
                style = props.style,
                preventDefault = props.preventDefault,
                others = _objectWithoutProperties(props, ['targetId', 'scrollRefLoc', 'scrollMargin', 'scrollRefId', 'style', 'preventDefault']);

            var scrollRefElement = this.state.scrollRefElement;

            var margin = this.getMargin(props, scrollRefElement);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_index__["a" /* ScrollReceiver */], _extends({
                atom: 'a',
                targetId: targetId
            }, others, {
                scrollMargin: margin,
                style: _extends({}, Styles.link, style),
                onClick: function onClick(e) {
                    resetTimer();
                    var offset = store.getOffset(targetId);
                    if (offset) {
                        margin = _this2.getMargin(props, scrollRefElement);
                        scollTimer = true;
                        Object(__WEBPACK_IMPORTED_MODULE_1_smooth_scroll_to__["a" /* default */])(offset.top - margin, null, null, function () {
                            if (true !== scollTimer) {
                                return;
                            }
                            scollTimer = setTimeout(function () {
                                offset = store.getOffset(targetId);
                                margin = _this2.getMargin(props, scrollRefElement);
                                Object(__WEBPACK_IMPORTED_MODULE_1_smooth_scroll_to__["a" /* default */])(offset.top - margin, 100);
                            }, 500);
                        });
                        if (preventDefault) {
                            e.preventDefault();
                        }
                    }
                }
            }));
        }
    }]);

    return SmoothScrollLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

SmoothScrollLink.defaultProps = {
    scrollRefId: '',
    scrollRefLoc: 'bottom',
    preventDefault: true,
    noDelay: false
};


/* harmony default export */ __webpack_exports__["a"] = (SmoothScrollLink);

var Styles = {
    link: {
        cursor: 'pointer'
    }
};

/***/ }),

/***/ "./node_modules/parse5/lib/common/doctype.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DOCUMENT_MODE = __webpack_require__("./node_modules/parse5/lib/common/html.js").DOCUMENT_MODE;

//Const
var VALID_DOCTYPE_NAME = 'html',
    QUIRKS_MODE_SYSTEM_ID = 'http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd',
    QUIRKS_MODE_PUBLIC_ID_PREFIXES = [
        '+//silmaril//dtd html pro v0r11 19970101//en',
        '-//advasoft ltd//dtd html 3.0 aswedit + extensions//en',
        '-//as//dtd html 3.0 aswedit + extensions//en',
        '-//ietf//dtd html 2.0 level 1//en',
        '-//ietf//dtd html 2.0 level 2//en',
        '-//ietf//dtd html 2.0 strict level 1//en',
        '-//ietf//dtd html 2.0 strict level 2//en',
        '-//ietf//dtd html 2.0 strict//en',
        '-//ietf//dtd html 2.0//en',
        '-//ietf//dtd html 2.1e//en',
        '-//ietf//dtd html 3.0//en',
        '-//ietf//dtd html 3.0//en//',
        '-//ietf//dtd html 3.2 final//en',
        '-//ietf//dtd html 3.2//en',
        '-//ietf//dtd html 3//en',
        '-//ietf//dtd html level 0//en',
        '-//ietf//dtd html level 0//en//2.0',
        '-//ietf//dtd html level 1//en',
        '-//ietf//dtd html level 1//en//2.0',
        '-//ietf//dtd html level 2//en',
        '-//ietf//dtd html level 2//en//2.0',
        '-//ietf//dtd html level 3//en',
        '-//ietf//dtd html level 3//en//3.0',
        '-//ietf//dtd html strict level 0//en',
        '-//ietf//dtd html strict level 0//en//2.0',
        '-//ietf//dtd html strict level 1//en',
        '-//ietf//dtd html strict level 1//en//2.0',
        '-//ietf//dtd html strict level 2//en',
        '-//ietf//dtd html strict level 2//en//2.0',
        '-//ietf//dtd html strict level 3//en',
        '-//ietf//dtd html strict level 3//en//3.0',
        '-//ietf//dtd html strict//en',
        '-//ietf//dtd html strict//en//2.0',
        '-//ietf//dtd html strict//en//3.0',
        '-//ietf//dtd html//en',
        '-//ietf//dtd html//en//2.0',
        '-//ietf//dtd html//en//3.0',
        '-//metrius//dtd metrius presentational//en',
        '-//microsoft//dtd internet explorer 2.0 html strict//en',
        '-//microsoft//dtd internet explorer 2.0 html//en',
        '-//microsoft//dtd internet explorer 2.0 tables//en',
        '-//microsoft//dtd internet explorer 3.0 html strict//en',
        '-//microsoft//dtd internet explorer 3.0 html//en',
        '-//microsoft//dtd internet explorer 3.0 tables//en',
        '-//netscape comm. corp.//dtd html//en',
        '-//netscape comm. corp.//dtd strict html//en',
        '-//o\'reilly and associates//dtd html 2.0//en',
        '-//o\'reilly and associates//dtd html extended 1.0//en',
        '-//spyglass//dtd html 2.0 extended//en',
        '-//sq//dtd html 2.0 hotmetal + extensions//en',
        '-//sun microsystems corp.//dtd hotjava html//en',
        '-//sun microsystems corp.//dtd hotjava strict html//en',
        '-//w3c//dtd html 3 1995-03-24//en',
        '-//w3c//dtd html 3.2 draft//en',
        '-//w3c//dtd html 3.2 final//en',
        '-//w3c//dtd html 3.2//en',
        '-//w3c//dtd html 3.2s draft//en',
        '-//w3c//dtd html 4.0 frameset//en',
        '-//w3c//dtd html 4.0 transitional//en',
        '-//w3c//dtd html experimental 19960712//en',
        '-//w3c//dtd html experimental 970421//en',
        '-//w3c//dtd w3 html//en',
        '-//w3o//dtd w3 html 3.0//en',
        '-//w3o//dtd w3 html 3.0//en//',
        '-//webtechs//dtd mozilla html 2.0//en',
        '-//webtechs//dtd mozilla html//en'
    ],
    QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES = QUIRKS_MODE_PUBLIC_ID_PREFIXES.concat([
        '-//w3c//dtd html 4.01 frameset//',
        '-//w3c//dtd html 4.01 transitional//'
    ]),
    QUIRKS_MODE_PUBLIC_IDS = [
        '-//w3o//dtd w3 html strict 3.0//en//',
        '-/w3c/dtd html 4.0 transitional/en',
        'html'
    ],
    LIMITED_QUIRKS_PUBLIC_ID_PREFIXES = [
        '-//W3C//DTD XHTML 1.0 Frameset//',
        '-//W3C//DTD XHTML 1.0 Transitional//'
    ],
    LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES = LIMITED_QUIRKS_PUBLIC_ID_PREFIXES.concat([
        '-//W3C//DTD HTML 4.01 Frameset//',
        '-//W3C//DTD HTML 4.01 Transitional//'
    ]);


//Utils
function enquoteDoctypeId(id) {
    var quote = id.indexOf('"') !== -1 ? '\'' : '"';

    return quote + id + quote;
}

function hasPrefix(publicId, prefixes) {
    for (var i = 0; i < prefixes.length; i++) {
        if (publicId.indexOf(prefixes[i]) === 0)
            return true;
    }

    return false;
}


//API
exports.getDocumentMode = function (name, publicId, systemId) {
    if (name !== VALID_DOCTYPE_NAME)
        return DOCUMENT_MODE.QUIRKS;

    if (systemId && systemId.toLowerCase() === QUIRKS_MODE_SYSTEM_ID)
        return DOCUMENT_MODE.QUIRKS;

    if (publicId !== null) {
        publicId = publicId.toLowerCase();

        if (QUIRKS_MODE_PUBLIC_IDS.indexOf(publicId) > -1)
            return DOCUMENT_MODE.QUIRKS;

        var prefixes = systemId === null ? QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES : QUIRKS_MODE_PUBLIC_ID_PREFIXES;

        if (hasPrefix(publicId, prefixes))
            return DOCUMENT_MODE.QUIRKS;

        prefixes = systemId === null ? LIMITED_QUIRKS_PUBLIC_ID_PREFIXES : LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES;

        if (hasPrefix(publicId, prefixes))
            return DOCUMENT_MODE.LIMITED_QUIRKS;
    }

    return DOCUMENT_MODE.NO_QUIRKS;
};

exports.serializeContent = function (name, publicId, systemId) {
    var str = '!DOCTYPE ';

    if (name)
        str += name;

    if (publicId !== null)
        str += ' PUBLIC ' + enquoteDoctypeId(publicId);

    else if (systemId !== null)
        str += ' SYSTEM';

    if (systemId !== null)
        str += ' ' + enquoteDoctypeId(systemId);

    return str;
};


/***/ }),

/***/ "./node_modules/parse5/lib/common/foreign_content.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Tokenizer = __webpack_require__("./node_modules/parse5/lib/tokenizer/index.js"),
    HTML = __webpack_require__("./node_modules/parse5/lib/common/html.js");

//Aliases
var $ = HTML.TAG_NAMES,
    NS = HTML.NAMESPACES,
    ATTRS = HTML.ATTRS;


//MIME types
var MIME_TYPES = {
    TEXT_HTML: 'text/html',
    APPLICATION_XML: 'application/xhtml+xml'
};

//Attributes
var DEFINITION_URL_ATTR = 'definitionurl',
    ADJUSTED_DEFINITION_URL_ATTR = 'definitionURL',
    SVG_ATTRS_ADJUSTMENT_MAP = {
        'attributename': 'attributeName',
        'attributetype': 'attributeType',
        'basefrequency': 'baseFrequency',
        'baseprofile': 'baseProfile',
        'calcmode': 'calcMode',
        'clippathunits': 'clipPathUnits',
        'diffuseconstant': 'diffuseConstant',
        'edgemode': 'edgeMode',
        'filterunits': 'filterUnits',
        'glyphref': 'glyphRef',
        'gradienttransform': 'gradientTransform',
        'gradientunits': 'gradientUnits',
        'kernelmatrix': 'kernelMatrix',
        'kernelunitlength': 'kernelUnitLength',
        'keypoints': 'keyPoints',
        'keysplines': 'keySplines',
        'keytimes': 'keyTimes',
        'lengthadjust': 'lengthAdjust',
        'limitingconeangle': 'limitingConeAngle',
        'markerheight': 'markerHeight',
        'markerunits': 'markerUnits',
        'markerwidth': 'markerWidth',
        'maskcontentunits': 'maskContentUnits',
        'maskunits': 'maskUnits',
        'numoctaves': 'numOctaves',
        'pathlength': 'pathLength',
        'patterncontentunits': 'patternContentUnits',
        'patterntransform': 'patternTransform',
        'patternunits': 'patternUnits',
        'pointsatx': 'pointsAtX',
        'pointsaty': 'pointsAtY',
        'pointsatz': 'pointsAtZ',
        'preservealpha': 'preserveAlpha',
        'preserveaspectratio': 'preserveAspectRatio',
        'primitiveunits': 'primitiveUnits',
        'refx': 'refX',
        'refy': 'refY',
        'repeatcount': 'repeatCount',
        'repeatdur': 'repeatDur',
        'requiredextensions': 'requiredExtensions',
        'requiredfeatures': 'requiredFeatures',
        'specularconstant': 'specularConstant',
        'specularexponent': 'specularExponent',
        'spreadmethod': 'spreadMethod',
        'startoffset': 'startOffset',
        'stddeviation': 'stdDeviation',
        'stitchtiles': 'stitchTiles',
        'surfacescale': 'surfaceScale',
        'systemlanguage': 'systemLanguage',
        'tablevalues': 'tableValues',
        'targetx': 'targetX',
        'targety': 'targetY',
        'textlength': 'textLength',
        'viewbox': 'viewBox',
        'viewtarget': 'viewTarget',
        'xchannelselector': 'xChannelSelector',
        'ychannelselector': 'yChannelSelector',
        'zoomandpan': 'zoomAndPan'
    },
    XML_ATTRS_ADJUSTMENT_MAP = {
        'xlink:actuate': {prefix: 'xlink', name: 'actuate', namespace: NS.XLINK},
        'xlink:arcrole': {prefix: 'xlink', name: 'arcrole', namespace: NS.XLINK},
        'xlink:href': {prefix: 'xlink', name: 'href', namespace: NS.XLINK},
        'xlink:role': {prefix: 'xlink', name: 'role', namespace: NS.XLINK},
        'xlink:show': {prefix: 'xlink', name: 'show', namespace: NS.XLINK},
        'xlink:title': {prefix: 'xlink', name: 'title', namespace: NS.XLINK},
        'xlink:type': {prefix: 'xlink', name: 'type', namespace: NS.XLINK},
        'xml:base': {prefix: 'xml', name: 'base', namespace: NS.XML},
        'xml:lang': {prefix: 'xml', name: 'lang', namespace: NS.XML},
        'xml:space': {prefix: 'xml', name: 'space', namespace: NS.XML},
        'xmlns': {prefix: '', name: 'xmlns', namespace: NS.XMLNS},
        'xmlns:xlink': {prefix: 'xmlns', name: 'xlink', namespace: NS.XMLNS}

    };

//SVG tag names adjustment map
var SVG_TAG_NAMES_ADJUSTMENT_MAP = exports.SVG_TAG_NAMES_ADJUSTMENT_MAP = {
    'altglyph': 'altGlyph',
    'altglyphdef': 'altGlyphDef',
    'altglyphitem': 'altGlyphItem',
    'animatecolor': 'animateColor',
    'animatemotion': 'animateMotion',
    'animatetransform': 'animateTransform',
    'clippath': 'clipPath',
    'feblend': 'feBlend',
    'fecolormatrix': 'feColorMatrix',
    'fecomponenttransfer': 'feComponentTransfer',
    'fecomposite': 'feComposite',
    'feconvolvematrix': 'feConvolveMatrix',
    'fediffuselighting': 'feDiffuseLighting',
    'fedisplacementmap': 'feDisplacementMap',
    'fedistantlight': 'feDistantLight',
    'feflood': 'feFlood',
    'fefunca': 'feFuncA',
    'fefuncb': 'feFuncB',
    'fefuncg': 'feFuncG',
    'fefuncr': 'feFuncR',
    'fegaussianblur': 'feGaussianBlur',
    'feimage': 'feImage',
    'femerge': 'feMerge',
    'femergenode': 'feMergeNode',
    'femorphology': 'feMorphology',
    'feoffset': 'feOffset',
    'fepointlight': 'fePointLight',
    'fespecularlighting': 'feSpecularLighting',
    'fespotlight': 'feSpotLight',
    'fetile': 'feTile',
    'feturbulence': 'feTurbulence',
    'foreignobject': 'foreignObject',
    'glyphref': 'glyphRef',
    'lineargradient': 'linearGradient',
    'radialgradient': 'radialGradient',
    'textpath': 'textPath'
};

//Tags that causes exit from foreign content
var EXITS_FOREIGN_CONTENT = Object.create(null);

EXITS_FOREIGN_CONTENT[$.B] = true;
EXITS_FOREIGN_CONTENT[$.BIG] = true;
EXITS_FOREIGN_CONTENT[$.BLOCKQUOTE] = true;
EXITS_FOREIGN_CONTENT[$.BODY] = true;
EXITS_FOREIGN_CONTENT[$.BR] = true;
EXITS_FOREIGN_CONTENT[$.CENTER] = true;
EXITS_FOREIGN_CONTENT[$.CODE] = true;
EXITS_FOREIGN_CONTENT[$.DD] = true;
EXITS_FOREIGN_CONTENT[$.DIV] = true;
EXITS_FOREIGN_CONTENT[$.DL] = true;
EXITS_FOREIGN_CONTENT[$.DT] = true;
EXITS_FOREIGN_CONTENT[$.EM] = true;
EXITS_FOREIGN_CONTENT[$.EMBED] = true;
EXITS_FOREIGN_CONTENT[$.H1] = true;
EXITS_FOREIGN_CONTENT[$.H2] = true;
EXITS_FOREIGN_CONTENT[$.H3] = true;
EXITS_FOREIGN_CONTENT[$.H4] = true;
EXITS_FOREIGN_CONTENT[$.H5] = true;
EXITS_FOREIGN_CONTENT[$.H6] = true;
EXITS_FOREIGN_CONTENT[$.HEAD] = true;
EXITS_FOREIGN_CONTENT[$.HR] = true;
EXITS_FOREIGN_CONTENT[$.I] = true;
EXITS_FOREIGN_CONTENT[$.IMG] = true;
EXITS_FOREIGN_CONTENT[$.LI] = true;
EXITS_FOREIGN_CONTENT[$.LISTING] = true;
EXITS_FOREIGN_CONTENT[$.MENU] = true;
EXITS_FOREIGN_CONTENT[$.META] = true;
EXITS_FOREIGN_CONTENT[$.NOBR] = true;
EXITS_FOREIGN_CONTENT[$.OL] = true;
EXITS_FOREIGN_CONTENT[$.P] = true;
EXITS_FOREIGN_CONTENT[$.PRE] = true;
EXITS_FOREIGN_CONTENT[$.RUBY] = true;
EXITS_FOREIGN_CONTENT[$.S] = true;
EXITS_FOREIGN_CONTENT[$.SMALL] = true;
EXITS_FOREIGN_CONTENT[$.SPAN] = true;
EXITS_FOREIGN_CONTENT[$.STRONG] = true;
EXITS_FOREIGN_CONTENT[$.STRIKE] = true;
EXITS_FOREIGN_CONTENT[$.SUB] = true;
EXITS_FOREIGN_CONTENT[$.SUP] = true;
EXITS_FOREIGN_CONTENT[$.TABLE] = true;
EXITS_FOREIGN_CONTENT[$.TT] = true;
EXITS_FOREIGN_CONTENT[$.U] = true;
EXITS_FOREIGN_CONTENT[$.UL] = true;
EXITS_FOREIGN_CONTENT[$.VAR] = true;

//Check exit from foreign content
exports.causesExit = function (startTagToken) {
    var tn = startTagToken.tagName;
    var isFontWithAttrs = tn === $.FONT && (Tokenizer.getTokenAttr(startTagToken, ATTRS.COLOR) !== null ||
                                            Tokenizer.getTokenAttr(startTagToken, ATTRS.SIZE) !== null ||
                                            Tokenizer.getTokenAttr(startTagToken, ATTRS.FACE) !== null);

    return isFontWithAttrs ? true : EXITS_FOREIGN_CONTENT[tn];
};

//Token adjustments
exports.adjustTokenMathMLAttrs = function (token) {
    for (var i = 0; i < token.attrs.length; i++) {
        if (token.attrs[i].name === DEFINITION_URL_ATTR) {
            token.attrs[i].name = ADJUSTED_DEFINITION_URL_ATTR;
            break;
        }
    }
};

exports.adjustTokenSVGAttrs = function (token) {
    for (var i = 0; i < token.attrs.length; i++) {
        var adjustedAttrName = SVG_ATTRS_ADJUSTMENT_MAP[token.attrs[i].name];

        if (adjustedAttrName)
            token.attrs[i].name = adjustedAttrName;
    }
};

exports.adjustTokenXMLAttrs = function (token) {
    for (var i = 0; i < token.attrs.length; i++) {
        var adjustedAttrEntry = XML_ATTRS_ADJUSTMENT_MAP[token.attrs[i].name];

        if (adjustedAttrEntry) {
            token.attrs[i].prefix = adjustedAttrEntry.prefix;
            token.attrs[i].name = adjustedAttrEntry.name;
            token.attrs[i].namespace = adjustedAttrEntry.namespace;
        }
    }
};

exports.adjustTokenSVGTagName = function (token) {
    var adjustedTagName = SVG_TAG_NAMES_ADJUSTMENT_MAP[token.tagName];

    if (adjustedTagName)
        token.tagName = adjustedTagName;
};

//Integration points
function isMathMLTextIntegrationPoint(tn, ns) {
    return ns === NS.MATHML && (tn === $.MI || tn === $.MO || tn === $.MN || tn === $.MS || tn === $.MTEXT);
}

function isHtmlIntegrationPoint(tn, ns, attrs) {
    if (ns === NS.MATHML && tn === $.ANNOTATION_XML) {
        for (var i = 0; i < attrs.length; i++) {
            if (attrs[i].name === ATTRS.ENCODING) {
                var value = attrs[i].value.toLowerCase();

                return value === MIME_TYPES.TEXT_HTML || value === MIME_TYPES.APPLICATION_XML;
            }
        }
    }

    return ns === NS.SVG && (tn === $.FOREIGN_OBJECT || tn === $.DESC || tn === $.TITLE);
}

exports.isIntegrationPoint = function (tn, ns, attrs, foreignNS) {
    if ((!foreignNS || foreignNS === NS.HTML) && isHtmlIntegrationPoint(tn, ns, attrs))
        return true;

    if ((!foreignNS || foreignNS === NS.MATHML) && isMathMLTextIntegrationPoint(tn, ns))
        return true;

    return false;
};


/***/ }),

/***/ "./node_modules/parse5/lib/common/html.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var NS = exports.NAMESPACES = {
    HTML: 'http://www.w3.org/1999/xhtml',
    MATHML: 'http://www.w3.org/1998/Math/MathML',
    SVG: 'http://www.w3.org/2000/svg',
    XLINK: 'http://www.w3.org/1999/xlink',
    XML: 'http://www.w3.org/XML/1998/namespace',
    XMLNS: 'http://www.w3.org/2000/xmlns/'
};

exports.ATTRS = {
    TYPE: 'type',
    ACTION: 'action',
    ENCODING: 'encoding',
    PROMPT: 'prompt',
    NAME: 'name',
    COLOR: 'color',
    FACE: 'face',
    SIZE: 'size'
};

exports.DOCUMENT_MODE = {
    NO_QUIRKS: 'no-quirks',
    QUIRKS: 'quirks',
    LIMITED_QUIRKS: 'limited-quirks'
};

var $ = exports.TAG_NAMES = {
    A: 'a',
    ADDRESS: 'address',
    ANNOTATION_XML: 'annotation-xml',
    APPLET: 'applet',
    AREA: 'area',
    ARTICLE: 'article',
    ASIDE: 'aside',

    B: 'b',
    BASE: 'base',
    BASEFONT: 'basefont',
    BGSOUND: 'bgsound',
    BIG: 'big',
    BLOCKQUOTE: 'blockquote',
    BODY: 'body',
    BR: 'br',
    BUTTON: 'button',

    CAPTION: 'caption',
    CENTER: 'center',
    CODE: 'code',
    COL: 'col',
    COLGROUP: 'colgroup',

    DD: 'dd',
    DESC: 'desc',
    DETAILS: 'details',
    DIALOG: 'dialog',
    DIR: 'dir',
    DIV: 'div',
    DL: 'dl',
    DT: 'dt',

    EM: 'em',
    EMBED: 'embed',

    FIELDSET: 'fieldset',
    FIGCAPTION: 'figcaption',
    FIGURE: 'figure',
    FONT: 'font',
    FOOTER: 'footer',
    FOREIGN_OBJECT: 'foreignObject',
    FORM: 'form',
    FRAME: 'frame',
    FRAMESET: 'frameset',

    H1: 'h1',
    H2: 'h2',
    H3: 'h3',
    H4: 'h4',
    H5: 'h5',
    H6: 'h6',
    HEAD: 'head',
    HEADER: 'header',
    HGROUP: 'hgroup',
    HR: 'hr',
    HTML: 'html',

    I: 'i',
    IMG: 'img',
    IMAGE: 'image',
    INPUT: 'input',
    IFRAME: 'iframe',

    KEYGEN: 'keygen',

    LABEL: 'label',
    LI: 'li',
    LINK: 'link',
    LISTING: 'listing',

    MAIN: 'main',
    MALIGNMARK: 'malignmark',
    MARQUEE: 'marquee',
    MATH: 'math',
    MENU: 'menu',
    MENUITEM: 'menuitem',
    META: 'meta',
    MGLYPH: 'mglyph',
    MI: 'mi',
    MO: 'mo',
    MN: 'mn',
    MS: 'ms',
    MTEXT: 'mtext',

    NAV: 'nav',
    NOBR: 'nobr',
    NOFRAMES: 'noframes',
    NOEMBED: 'noembed',
    NOSCRIPT: 'noscript',

    OBJECT: 'object',
    OL: 'ol',
    OPTGROUP: 'optgroup',
    OPTION: 'option',

    P: 'p',
    PARAM: 'param',
    PLAINTEXT: 'plaintext',
    PRE: 'pre',

    RB: 'rb',
    RP: 'rp',
    RT: 'rt',
    RTC: 'rtc',
    RUBY: 'ruby',

    S: 's',
    SCRIPT: 'script',
    SECTION: 'section',
    SELECT: 'select',
    SOURCE: 'source',
    SMALL: 'small',
    SPAN: 'span',
    STRIKE: 'strike',
    STRONG: 'strong',
    STYLE: 'style',
    SUB: 'sub',
    SUMMARY: 'summary',
    SUP: 'sup',

    TABLE: 'table',
    TBODY: 'tbody',
    TEMPLATE: 'template',
    TEXTAREA: 'textarea',
    TFOOT: 'tfoot',
    TD: 'td',
    TH: 'th',
    THEAD: 'thead',
    TITLE: 'title',
    TR: 'tr',
    TRACK: 'track',
    TT: 'tt',

    U: 'u',
    UL: 'ul',

    SVG: 'svg',

    VAR: 'var',

    WBR: 'wbr',

    XMP: 'xmp'
};

var SPECIAL_ELEMENTS = exports.SPECIAL_ELEMENTS = Object.create(null);

SPECIAL_ELEMENTS[NS.HTML] = Object.create(null);
SPECIAL_ELEMENTS[NS.HTML][$.ADDRESS] = true;
SPECIAL_ELEMENTS[NS.HTML][$.APPLET] = true;
SPECIAL_ELEMENTS[NS.HTML][$.AREA] = true;
SPECIAL_ELEMENTS[NS.HTML][$.ARTICLE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.ASIDE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BASE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BASEFONT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BGSOUND] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BLOCKQUOTE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BODY] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BR] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BUTTON] = true;
SPECIAL_ELEMENTS[NS.HTML][$.CAPTION] = true;
SPECIAL_ELEMENTS[NS.HTML][$.CENTER] = true;
SPECIAL_ELEMENTS[NS.HTML][$.COL] = true;
SPECIAL_ELEMENTS[NS.HTML][$.COLGROUP] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DD] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DETAILS] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DIR] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DIV] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DL] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.EMBED] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FIELDSET] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FIGCAPTION] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FIGURE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FOOTER] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FORM] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FRAME] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FRAMESET] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H1] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H2] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H3] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H4] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H5] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H6] = true;
SPECIAL_ELEMENTS[NS.HTML][$.HEAD] = true;
SPECIAL_ELEMENTS[NS.HTML][$.HEADER] = true;
SPECIAL_ELEMENTS[NS.HTML][$.HGROUP] = true;
SPECIAL_ELEMENTS[NS.HTML][$.HR] = true;
SPECIAL_ELEMENTS[NS.HTML][$.HTML] = true;
SPECIAL_ELEMENTS[NS.HTML][$.IFRAME] = true;
SPECIAL_ELEMENTS[NS.HTML][$.IMG] = true;
SPECIAL_ELEMENTS[NS.HTML][$.INPUT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.LI] = true;
SPECIAL_ELEMENTS[NS.HTML][$.LINK] = true;
SPECIAL_ELEMENTS[NS.HTML][$.LISTING] = true;
SPECIAL_ELEMENTS[NS.HTML][$.MAIN] = true;
SPECIAL_ELEMENTS[NS.HTML][$.MARQUEE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.MENU] = true;
SPECIAL_ELEMENTS[NS.HTML][$.META] = true;
SPECIAL_ELEMENTS[NS.HTML][$.NAV] = true;
SPECIAL_ELEMENTS[NS.HTML][$.NOEMBED] = true;
SPECIAL_ELEMENTS[NS.HTML][$.NOFRAMES] = true;
SPECIAL_ELEMENTS[NS.HTML][$.NOSCRIPT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.OBJECT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.OL] = true;
SPECIAL_ELEMENTS[NS.HTML][$.P] = true;
SPECIAL_ELEMENTS[NS.HTML][$.PARAM] = true;
SPECIAL_ELEMENTS[NS.HTML][$.PLAINTEXT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.PRE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.SCRIPT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.SECTION] = true;
SPECIAL_ELEMENTS[NS.HTML][$.SELECT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.SOURCE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.STYLE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.SUMMARY] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TABLE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TBODY] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TD] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TEMPLATE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TEXTAREA] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TFOOT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TH] = true;
SPECIAL_ELEMENTS[NS.HTML][$.THEAD] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TITLE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TR] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TRACK] = true;
SPECIAL_ELEMENTS[NS.HTML][$.UL] = true;
SPECIAL_ELEMENTS[NS.HTML][$.WBR] = true;
SPECIAL_ELEMENTS[NS.HTML][$.XMP] = true;

SPECIAL_ELEMENTS[NS.MATHML] = Object.create(null);
SPECIAL_ELEMENTS[NS.MATHML][$.MI] = true;
SPECIAL_ELEMENTS[NS.MATHML][$.MO] = true;
SPECIAL_ELEMENTS[NS.MATHML][$.MN] = true;
SPECIAL_ELEMENTS[NS.MATHML][$.MS] = true;
SPECIAL_ELEMENTS[NS.MATHML][$.MTEXT] = true;
SPECIAL_ELEMENTS[NS.MATHML][$.ANNOTATION_XML] = true;

SPECIAL_ELEMENTS[NS.SVG] = Object.create(null);
SPECIAL_ELEMENTS[NS.SVG][$.TITLE] = true;
SPECIAL_ELEMENTS[NS.SVG][$.FOREIGN_OBJECT] = true;
SPECIAL_ELEMENTS[NS.SVG][$.DESC] = true;


/***/ }),

/***/ "./node_modules/parse5/lib/common/unicode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.REPLACEMENT_CHARACTER = '\uFFFD';

exports.CODE_POINTS = {
    EOF: -1,
    NULL: 0x00,
    TABULATION: 0x09,
    CARRIAGE_RETURN: 0x0D,
    LINE_FEED: 0x0A,
    FORM_FEED: 0x0C,
    SPACE: 0x20,
    EXCLAMATION_MARK: 0x21,
    QUOTATION_MARK: 0x22,
    NUMBER_SIGN: 0x23,
    AMPERSAND: 0x26,
    APOSTROPHE: 0x27,
    HYPHEN_MINUS: 0x2D,
    SOLIDUS: 0x2F,
    DIGIT_0: 0x30,
    DIGIT_9: 0x39,
    SEMICOLON: 0x3B,
    LESS_THAN_SIGN: 0x3C,
    EQUALS_SIGN: 0x3D,
    GREATER_THAN_SIGN: 0x3E,
    QUESTION_MARK: 0x3F,
    LATIN_CAPITAL_A: 0x41,
    LATIN_CAPITAL_F: 0x46,
    LATIN_CAPITAL_X: 0x58,
    LATIN_CAPITAL_Z: 0x5A,
    GRAVE_ACCENT: 0x60,
    LATIN_SMALL_A: 0x61,
    LATIN_SMALL_F: 0x66,
    LATIN_SMALL_X: 0x78,
    LATIN_SMALL_Z: 0x7A,
    REPLACEMENT_CHARACTER: 0xFFFD
};

exports.CODE_POINT_SEQUENCES = {
    DASH_DASH_STRING: [0x2D, 0x2D], //--
    DOCTYPE_STRING: [0x44, 0x4F, 0x43, 0x54, 0x59, 0x50, 0x45], //DOCTYPE
    CDATA_START_STRING: [0x5B, 0x43, 0x44, 0x41, 0x54, 0x41, 0x5B], //[CDATA[
    CDATA_END_STRING: [0x5D, 0x5D, 0x3E], //]]>
    SCRIPT_STRING: [0x73, 0x63, 0x72, 0x69, 0x70, 0x74], //script
    PUBLIC_STRING: [0x50, 0x55, 0x42, 0x4C, 0x49, 0x43], //PUBLIC
    SYSTEM_STRING: [0x53, 0x59, 0x53, 0x54, 0x45, 0x4D] //SYSTEM
};


/***/ }),

/***/ "./node_modules/parse5/lib/extensions/location_info/open_element_stack_mixin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Mixin = __webpack_require__("./node_modules/parse5/lib/utils/mixin.js"),
    inherits = __webpack_require__("./node_modules/util/util.js").inherits;

var LocationInfoOpenElementStackMixin = module.exports = function (stack, options) {
    Mixin.call(this, stack);

    this.onItemPop = options.onItemPop;
};

inherits(LocationInfoOpenElementStackMixin, Mixin);

LocationInfoOpenElementStackMixin.prototype._getOverriddenMethods = function (mxn, orig) {
    return {
        pop: function () {
            mxn.onItemPop(this.current);
            orig.pop.call(this);
        },

        popAllUpToHtmlElement: function () {
            for (var i = this.stackTop; i > 0; i--)
                mxn.onItemPop(this.items[i]);

            orig.popAllUpToHtmlElement.call(this);
        },

        remove: function (element) {
            mxn.onItemPop(this.current);
            orig.remove.call(this, element);
        }
    };
};



/***/ }),

/***/ "./node_modules/parse5/lib/extensions/location_info/parser_mixin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Mixin = __webpack_require__("./node_modules/parse5/lib/utils/mixin.js"),
    Tokenizer = __webpack_require__("./node_modules/parse5/lib/tokenizer/index.js"),
    LocationInfoTokenizerMixin = __webpack_require__("./node_modules/parse5/lib/extensions/location_info/tokenizer_mixin.js"),
    PositionTrackingPreprocessorMixin = __webpack_require__("./node_modules/parse5/lib/extensions/position_tracking/preprocessor_mixin.js"),
    LocationInfoOpenElementStackMixin = __webpack_require__("./node_modules/parse5/lib/extensions/location_info/open_element_stack_mixin.js"),
    HTML = __webpack_require__("./node_modules/parse5/lib/common/html.js"),
    inherits = __webpack_require__("./node_modules/util/util.js").inherits;


//Aliases
var $ = HTML.TAG_NAMES;

var LocationInfoParserMixin = module.exports = function (parser) {
    Mixin.call(this, parser);

    this.parser = parser;
    this.posTracker = null;
    this.lastStartTagToken = null;
    this.lastFosterParentingLocation = null;
    this.currentToken = null;
};

inherits(LocationInfoParserMixin, Mixin);


LocationInfoParserMixin.prototype._setStartLocation = function (element) {
    if (this.lastStartTagToken) {
        element.__location = Object.create(this.lastStartTagToken.location);
        element.__location.startTag = this.lastStartTagToken.location;
    }
    else
        element.__location = null;
};

LocationInfoParserMixin.prototype._setEndLocation = function (element, closingToken) {
    var loc = element.__location;

    if (loc) {
        if (closingToken.location) {
            var ctLoc = closingToken.location,
                tn = this.parser.treeAdapter.getTagName(element);

            // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
            // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
            var isClosingEndTag = closingToken.type === Tokenizer.END_TAG_TOKEN && tn === closingToken.tagName;

            if (isClosingEndTag) {
                loc.endTag = Object.create(ctLoc);
                loc.endOffset = ctLoc.endOffset;
            }

            else
                loc.endOffset = ctLoc.startOffset;
        }

        else if (closingToken.type === Tokenizer.EOF_TOKEN)
            loc.endOffset = this.posTracker.offset;
    }
};

LocationInfoParserMixin.prototype._getOverriddenMethods = function (mxn, orig) {
    return {
        _bootstrap: function (document, fragmentContext) {
            orig._bootstrap.call(this, document, fragmentContext);

            mxn.lastStartTagToken = null;
            mxn.lastFosterParentingLocation = null;
            mxn.currentToken = null;
            mxn.posTracker = new PositionTrackingPreprocessorMixin(this.tokenizer.preprocessor);

            new LocationInfoTokenizerMixin(this.tokenizer);

            new LocationInfoOpenElementStackMixin(this.openElements, {
                onItemPop: function (element) {
                    mxn._setEndLocation(element, mxn.currentToken);
                }
            });
        },

        _runParsingLoop: function (scriptHandler) {
            orig._runParsingLoop.call(this, scriptHandler);

            // NOTE: generate location info for elements
            // that remains on open element stack
            for (var i = this.openElements.stackTop; i >= 0; i--)
                mxn._setEndLocation(this.openElements.items[i], mxn.currentToken);
        },


        //Token processing
        _processTokenInForeignContent: function (token) {
            mxn.currentToken = token;
            orig._processTokenInForeignContent.call(this, token);
        },

        _processToken: function (token) {
            mxn.currentToken = token;
            orig._processToken.call(this, token);

            //NOTE: <body> and <html> are never popped from the stack, so we need to updated
            //their end location explicitly.
            var requireExplicitUpdate = token.type === Tokenizer.END_TAG_TOKEN &&
                                        (token.tagName === $.HTML ||
                                         token.tagName === $.BODY && this.openElements.hasInScope($.BODY));

            if (requireExplicitUpdate) {
                for (var i = this.openElements.stackTop; i >= 0; i--) {
                    var element = this.openElements.items[i];

                    if (this.treeAdapter.getTagName(element) === token.tagName) {
                        mxn._setEndLocation(element, token);
                        break;
                    }
                }
            }
        },


        //Doctype
        _setDocumentType: function (token) {
            orig._setDocumentType.call(this, token);

            var documentChildren = this.treeAdapter.getChildNodes(this.document),
                cnLength = documentChildren.length;

            for (var i = 0; i < cnLength; i++) {
                var node = documentChildren[i];

                if (this.treeAdapter.isDocumentTypeNode(node)) {
                    node.__location = token.location;
                    break;
                }
            }
        },


        //Elements
        _attachElementToTree: function (element) {
            //NOTE: _attachElementToTree is called from _appendElement, _insertElement and _insertTemplate methods.
            //So we will use token location stored in this methods for the element.
            mxn._setStartLocation(element);
            mxn.lastStartTagToken = null;
            orig._attachElementToTree.call(this, element);
        },

        _appendElement: function (token, namespaceURI) {
            mxn.lastStartTagToken = token;
            orig._appendElement.call(this, token, namespaceURI);
        },

        _insertElement: function (token, namespaceURI) {
            mxn.lastStartTagToken = token;
            orig._insertElement.call(this, token, namespaceURI);
        },

        _insertTemplate: function (token) {
            mxn.lastStartTagToken = token;
            orig._insertTemplate.call(this, token);

            var tmplContent = this.treeAdapter.getTemplateContent(this.openElements.current);

            tmplContent.__location = null;
        },

        _insertFakeRootElement: function () {
            orig._insertFakeRootElement.call(this);
            this.openElements.current.__location = null;
        },

        //Comments
        _appendCommentNode: function (token, parent) {
            orig._appendCommentNode.call(this, token, parent);

            var children = this.treeAdapter.getChildNodes(parent),
                commentNode = children[children.length - 1];

            commentNode.__location = token.location;
        },

        //Text
        _findFosterParentingLocation: function () {
            //NOTE: store last foster parenting location, so we will be able to find inserted text
            //in case of foster parenting
            mxn.lastFosterParentingLocation = orig._findFosterParentingLocation.call(this);

            return mxn.lastFosterParentingLocation;
        },

        _insertCharacters: function (token) {
            orig._insertCharacters.call(this, token);

            var hasFosterParent = this._shouldFosterParentOnInsertion(),
                parent = hasFosterParent && mxn.lastFosterParentingLocation.parent ||
                         this.openElements.currentTmplContent ||
                         this.openElements.current,
                siblings = this.treeAdapter.getChildNodes(parent),
                textNodeIdx = hasFosterParent && mxn.lastFosterParentingLocation.beforeElement ?
                siblings.indexOf(mxn.lastFosterParentingLocation.beforeElement) - 1 :
                siblings.length - 1,
                textNode = siblings[textNodeIdx];

            //NOTE: if we have location assigned by another token, then just update end position
            if (textNode.__location)
                textNode.__location.endOffset = token.location.endOffset;

            else
                textNode.__location = token.location;
        }
    };
};



/***/ }),

/***/ "./node_modules/parse5/lib/extensions/location_info/tokenizer_mixin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Mixin = __webpack_require__("./node_modules/parse5/lib/utils/mixin.js"),
    Tokenizer = __webpack_require__("./node_modules/parse5/lib/tokenizer/index.js"),
    PositionTrackingPreprocessorMixin = __webpack_require__("./node_modules/parse5/lib/extensions/position_tracking/preprocessor_mixin.js"),
    inherits = __webpack_require__("./node_modules/util/util.js").inherits;

var LocationInfoTokenizerMixin = module.exports = function (tokenizer) {
    Mixin.call(this, tokenizer);

    this.tokenizer = tokenizer;
    this.posTracker = new PositionTrackingPreprocessorMixin(tokenizer.preprocessor);
    this.currentAttrLocation = null;
    this.currentTokenLocation = null;
};

inherits(LocationInfoTokenizerMixin, Mixin);

LocationInfoTokenizerMixin.prototype._getCurrentLocation = function () {
    return {
        line: this.posTracker.line,
        col: this.posTracker.col,
        startOffset: this.posTracker.offset,
        endOffset: -1
    };
};

LocationInfoTokenizerMixin.prototype._attachCurrentAttrLocationInfo = function () {
    this.currentAttrLocation.endOffset = this.posTracker.offset;

    var currentToken = this.tokenizer.currentToken,
        currentAttr = this.tokenizer.currentAttr;

    if (!currentToken.location.attrs)
        currentToken.location.attrs = Object.create(null);

    currentToken.location.attrs[currentAttr.name] = this.currentAttrLocation;
};

LocationInfoTokenizerMixin.prototype._getOverriddenMethods = function (mxn, orig) {
    var methods = {
        _createStartTagToken: function () {
            orig._createStartTagToken.call(this);
            this.currentToken.location = mxn.currentTokenLocation;
        },

        _createEndTagToken: function () {
            orig._createEndTagToken.call(this);
            this.currentToken.location = mxn.currentTokenLocation;
        },

        _createCommentToken: function () {
            orig._createCommentToken.call(this);
            this.currentToken.location = mxn.currentTokenLocation;
        },

        _createDoctypeToken: function (initialName) {
            orig._createDoctypeToken.call(this, initialName);
            this.currentToken.location = mxn.currentTokenLocation;
        },

        _createCharacterToken: function (type, ch) {
            orig._createCharacterToken.call(this, type, ch);
            this.currentCharacterToken.location = mxn.currentTokenLocation;
        },

        _createAttr: function (attrNameFirstCh) {
            orig._createAttr.call(this, attrNameFirstCh);
            mxn.currentAttrLocation = mxn._getCurrentLocation();
        },

        _leaveAttrName: function (toState) {
            orig._leaveAttrName.call(this, toState);
            mxn._attachCurrentAttrLocationInfo();
        },

        _leaveAttrValue: function (toState) {
            orig._leaveAttrValue.call(this, toState);
            mxn._attachCurrentAttrLocationInfo();
        },

        _emitCurrentToken: function () {
            //NOTE: if we have pending character token make it's end location equal to the
            //current token's start location.
            if (this.currentCharacterToken)
                this.currentCharacterToken.location.endOffset = this.currentToken.location.startOffset;

            this.currentToken.location.endOffset = mxn.posTracker.offset + 1;
            orig._emitCurrentToken.call(this);
        },

        _emitCurrentCharacterToken: function () {
            //NOTE: if we have character token and it's location wasn't set in the _emitCurrentToken(),
            //then set it's location at the current preprocessor position.
            //We don't need to increment preprocessor position, since character token
            //emission is always forced by the start of the next character token here.
            //So, we already have advanced position.
            if (this.currentCharacterToken && this.currentCharacterToken.location.endOffset === -1)
                this.currentCharacterToken.location.endOffset = mxn.posTracker.offset;

            orig._emitCurrentCharacterToken.call(this);
        }
    };

    //NOTE: patch initial states for each mode to obtain token start position
    Object.keys(Tokenizer.MODE).forEach(function (modeName) {
        var state = Tokenizer.MODE[modeName];

        methods[state] = function (cp) {
            mxn.currentTokenLocation = mxn._getCurrentLocation();
            orig[state].call(this, cp);
        };
    });

    return methods;
};



/***/ }),

/***/ "./node_modules/parse5/lib/extensions/position_tracking/preprocessor_mixin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Mixin = __webpack_require__("./node_modules/parse5/lib/utils/mixin.js"),
    inherits = __webpack_require__("./node_modules/util/util.js").inherits,
    UNICODE = __webpack_require__("./node_modules/parse5/lib/common/unicode.js");

//Aliases
var $ = UNICODE.CODE_POINTS;

var PositionTrackingPreprocessorMixin = module.exports = function (preprocessor) {
    // NOTE: avoid installing tracker twice
    if (!preprocessor.__locTracker) {
        preprocessor.__locTracker = this;

        Mixin.call(this, preprocessor);

        this.preprocessor = preprocessor;
        this.isEol = false;
        this.lineStartPos = 0;
        this.droppedBufferSize = 0;

        this.col = -1;
        this.line = 1;
    }

    return preprocessor.__locTracker;
};

inherits(PositionTrackingPreprocessorMixin, Mixin);

Object.defineProperty(PositionTrackingPreprocessorMixin.prototype, 'offset', {
    get: function () {
        return this.droppedBufferSize + this.preprocessor.pos;
    }
});

PositionTrackingPreprocessorMixin.prototype._getOverriddenMethods = function (mxn, orig) {
    return {
        advance: function () {
            var cp = orig.advance.call(this);

            //NOTE: LF should be in the last column of the line
            if (mxn.isEol) {
                mxn.isEol = false;
                mxn.line++;
                mxn.lineStartPos = mxn.offset;
            }

            if (cp === $.LINE_FEED)
                mxn.isEol = true;

            mxn.col = mxn.offset - mxn.lineStartPos + 1;

            return cp;
        },

        retreat: function () {
            orig.retreat.call(this);
            mxn.isEol = false;

            mxn.col = mxn.offset - mxn.lineStartPos + 1;
        },

        dropParsedChunk: function () {
            var prevPos = this.pos;

            orig.dropParsedChunk.call(this);

            mxn.droppedBufferSize += prevPos - this.pos;
        }
    };
};


/***/ }),

/***/ "./node_modules/parse5/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Parser = __webpack_require__("./node_modules/parse5/lib/parser/index.js"),
    Serializer = __webpack_require__("./node_modules/parse5/lib/serializer/index.js");


// Shorthands
exports.parse = function parse(html, options) {
    var parser = new Parser(options);

    return parser.parse(html);
};

exports.parseFragment = function parseFragment(fragmentContext, html, options) {
    if (typeof fragmentContext === 'string') {
        options = html;
        html = fragmentContext;
        fragmentContext = null;
    }

    var parser = new Parser(options);

    return parser.parseFragment(html, fragmentContext);
};

exports.serialize = function (node, options) {
    var serializer = new Serializer(node, options);

    return serializer.serialize();
};


// Tree adapters
exports.treeAdapters = {
    default: __webpack_require__("./node_modules/parse5/lib/tree_adapters/default.js"),
    htmlparser2: __webpack_require__("./node_modules/parse5/lib/tree_adapters/htmlparser2.js")
};


// Streaming
exports.ParserStream = __webpack_require__("./node_modules/parse5/lib/parser/parser_stream.js");
exports.PlainTextConversionStream = __webpack_require__("./node_modules/parse5/lib/parser/plain_text_conversion_stream.js");
exports.SerializerStream = __webpack_require__("./node_modules/parse5/lib/serializer/serializer_stream.js");
exports.SAXParser = __webpack_require__("./node_modules/parse5/lib/sax/index.js");


/***/ }),

/***/ "./node_modules/parse5/lib/parser/formatting_element_list.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//Const
var NOAH_ARK_CAPACITY = 3;

//List of formatting elements
var FormattingElementList = module.exports = function (treeAdapter) {
    this.length = 0;
    this.entries = [];
    this.treeAdapter = treeAdapter;
    this.bookmark = null;
};

//Entry types
FormattingElementList.MARKER_ENTRY = 'MARKER_ENTRY';
FormattingElementList.ELEMENT_ENTRY = 'ELEMENT_ENTRY';

//Noah Ark's condition
//OPTIMIZATION: at first we try to find possible candidates for exclusion using
//lightweight heuristics without thorough attributes check.
FormattingElementList.prototype._getNoahArkConditionCandidates = function (newElement) {
    var candidates = [];

    if (this.length >= NOAH_ARK_CAPACITY) {
        var neAttrsLength = this.treeAdapter.getAttrList(newElement).length,
            neTagName = this.treeAdapter.getTagName(newElement),
            neNamespaceURI = this.treeAdapter.getNamespaceURI(newElement);

        for (var i = this.length - 1; i >= 0; i--) {
            var entry = this.entries[i];

            if (entry.type === FormattingElementList.MARKER_ENTRY)
                break;

            var element = entry.element,
                elementAttrs = this.treeAdapter.getAttrList(element),
                isCandidate = this.treeAdapter.getTagName(element) === neTagName &&
                              this.treeAdapter.getNamespaceURI(element) === neNamespaceURI &&
                              elementAttrs.length === neAttrsLength;

            if (isCandidate)
                candidates.push({idx: i, attrs: elementAttrs});
        }
    }

    return candidates.length < NOAH_ARK_CAPACITY ? [] : candidates;
};

FormattingElementList.prototype._ensureNoahArkCondition = function (newElement) {
    var candidates = this._getNoahArkConditionCandidates(newElement),
        cLength = candidates.length;

    if (cLength) {
        var neAttrs = this.treeAdapter.getAttrList(newElement),
            neAttrsLength = neAttrs.length,
            neAttrsMap = Object.create(null);

        //NOTE: build attrs map for the new element so we can perform fast lookups
        for (var i = 0; i < neAttrsLength; i++) {
            var neAttr = neAttrs[i];

            neAttrsMap[neAttr.name] = neAttr.value;
        }

        for (i = 0; i < neAttrsLength; i++) {
            for (var j = 0; j < cLength; j++) {
                var cAttr = candidates[j].attrs[i];

                if (neAttrsMap[cAttr.name] !== cAttr.value) {
                    candidates.splice(j, 1);
                    cLength--;
                }

                if (candidates.length < NOAH_ARK_CAPACITY)
                    return;
            }
        }

        //NOTE: remove bottommost candidates until Noah's Ark condition will not be met
        for (i = cLength - 1; i >= NOAH_ARK_CAPACITY - 1; i--) {
            this.entries.splice(candidates[i].idx, 1);
            this.length--;
        }
    }
};

//Mutations
FormattingElementList.prototype.insertMarker = function () {
    this.entries.push({type: FormattingElementList.MARKER_ENTRY});
    this.length++;
};

FormattingElementList.prototype.pushElement = function (element, token) {
    this._ensureNoahArkCondition(element);

    this.entries.push({
        type: FormattingElementList.ELEMENT_ENTRY,
        element: element,
        token: token
    });

    this.length++;
};

FormattingElementList.prototype.insertElementAfterBookmark = function (element, token) {
    var bookmarkIdx = this.length - 1;

    for (; bookmarkIdx >= 0; bookmarkIdx--) {
        if (this.entries[bookmarkIdx] === this.bookmark)
            break;
    }

    this.entries.splice(bookmarkIdx + 1, 0, {
        type: FormattingElementList.ELEMENT_ENTRY,
        element: element,
        token: token
    });

    this.length++;
};

FormattingElementList.prototype.removeEntry = function (entry) {
    for (var i = this.length - 1; i >= 0; i--) {
        if (this.entries[i] === entry) {
            this.entries.splice(i, 1);
            this.length--;
            break;
        }
    }
};

FormattingElementList.prototype.clearToLastMarker = function () {
    while (this.length) {
        var entry = this.entries.pop();

        this.length--;

        if (entry.type === FormattingElementList.MARKER_ENTRY)
            break;
    }
};

//Search
FormattingElementList.prototype.getElementEntryInScopeWithTagName = function (tagName) {
    for (var i = this.length - 1; i >= 0; i--) {
        var entry = this.entries[i];

        if (entry.type === FormattingElementList.MARKER_ENTRY)
            return null;

        if (this.treeAdapter.getTagName(entry.element) === tagName)
            return entry;
    }

    return null;
};

FormattingElementList.prototype.getElementEntry = function (element) {
    for (var i = this.length - 1; i >= 0; i--) {
        var entry = this.entries[i];

        if (entry.type === FormattingElementList.ELEMENT_ENTRY && entry.element === element)
            return entry;
    }

    return null;
};


/***/ }),

/***/ "./node_modules/parse5/lib/parser/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Tokenizer = __webpack_require__("./node_modules/parse5/lib/tokenizer/index.js"),
    OpenElementStack = __webpack_require__("./node_modules/parse5/lib/parser/open_element_stack.js"),
    FormattingElementList = __webpack_require__("./node_modules/parse5/lib/parser/formatting_element_list.js"),
    LocationInfoParserMixin = __webpack_require__("./node_modules/parse5/lib/extensions/location_info/parser_mixin.js"),
    defaultTreeAdapter = __webpack_require__("./node_modules/parse5/lib/tree_adapters/default.js"),
    mergeOptions = __webpack_require__("./node_modules/parse5/lib/utils/merge_options.js"),
    doctype = __webpack_require__("./node_modules/parse5/lib/common/doctype.js"),
    foreignContent = __webpack_require__("./node_modules/parse5/lib/common/foreign_content.js"),
    UNICODE = __webpack_require__("./node_modules/parse5/lib/common/unicode.js"),
    HTML = __webpack_require__("./node_modules/parse5/lib/common/html.js");

//Aliases
var $ = HTML.TAG_NAMES,
    NS = HTML.NAMESPACES,
    ATTRS = HTML.ATTRS;

var DEFAULT_OPTIONS = {
    locationInfo: false,
    treeAdapter: defaultTreeAdapter
};

//Misc constants
var HIDDEN_INPUT_TYPE = 'hidden';

//Adoption agency loops iteration count
var AA_OUTER_LOOP_ITER = 8,
    AA_INNER_LOOP_ITER = 3;

//Insertion modes
var INITIAL_MODE = 'INITIAL_MODE',
    BEFORE_HTML_MODE = 'BEFORE_HTML_MODE',
    BEFORE_HEAD_MODE = 'BEFORE_HEAD_MODE',
    IN_HEAD_MODE = 'IN_HEAD_MODE',
    AFTER_HEAD_MODE = 'AFTER_HEAD_MODE',
    IN_BODY_MODE = 'IN_BODY_MODE',
    TEXT_MODE = 'TEXT_MODE',
    IN_TABLE_MODE = 'IN_TABLE_MODE',
    IN_TABLE_TEXT_MODE = 'IN_TABLE_TEXT_MODE',
    IN_CAPTION_MODE = 'IN_CAPTION_MODE',
    IN_COLUMN_GROUP_MODE = 'IN_COLUMN_GROUP_MODE',
    IN_TABLE_BODY_MODE = 'IN_TABLE_BODY_MODE',
    IN_ROW_MODE = 'IN_ROW_MODE',
    IN_CELL_MODE = 'IN_CELL_MODE',
    IN_SELECT_MODE = 'IN_SELECT_MODE',
    IN_SELECT_IN_TABLE_MODE = 'IN_SELECT_IN_TABLE_MODE',
    IN_TEMPLATE_MODE = 'IN_TEMPLATE_MODE',
    AFTER_BODY_MODE = 'AFTER_BODY_MODE',
    IN_FRAMESET_MODE = 'IN_FRAMESET_MODE',
    AFTER_FRAMESET_MODE = 'AFTER_FRAMESET_MODE',
    AFTER_AFTER_BODY_MODE = 'AFTER_AFTER_BODY_MODE',
    AFTER_AFTER_FRAMESET_MODE = 'AFTER_AFTER_FRAMESET_MODE';

//Insertion mode reset map
var INSERTION_MODE_RESET_MAP = Object.create(null);

INSERTION_MODE_RESET_MAP[$.TR] = IN_ROW_MODE;
INSERTION_MODE_RESET_MAP[$.TBODY] =
INSERTION_MODE_RESET_MAP[$.THEAD] =
INSERTION_MODE_RESET_MAP[$.TFOOT] = IN_TABLE_BODY_MODE;
INSERTION_MODE_RESET_MAP[$.CAPTION] = IN_CAPTION_MODE;
INSERTION_MODE_RESET_MAP[$.COLGROUP] = IN_COLUMN_GROUP_MODE;
INSERTION_MODE_RESET_MAP[$.TABLE] = IN_TABLE_MODE;
INSERTION_MODE_RESET_MAP[$.BODY] = IN_BODY_MODE;
INSERTION_MODE_RESET_MAP[$.FRAMESET] = IN_FRAMESET_MODE;

//Template insertion mode switch map
var TEMPLATE_INSERTION_MODE_SWITCH_MAP = Object.create(null);

TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.CAPTION] =
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.COLGROUP] =
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TBODY] =
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TFOOT] =
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.THEAD] = IN_TABLE_MODE;
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.COL] = IN_COLUMN_GROUP_MODE;
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TR] = IN_TABLE_BODY_MODE;
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TD] =
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TH] = IN_ROW_MODE;

//Token handlers map for insertion modes
var _ = Object.create(null);

_[INITIAL_MODE] = Object.create(null);
_[INITIAL_MODE][Tokenizer.CHARACTER_TOKEN] =
_[INITIAL_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenInInitialMode;
_[INITIAL_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = ignoreToken;
_[INITIAL_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[INITIAL_MODE][Tokenizer.DOCTYPE_TOKEN] = doctypeInInitialMode;
_[INITIAL_MODE][Tokenizer.START_TAG_TOKEN] =
_[INITIAL_MODE][Tokenizer.END_TAG_TOKEN] =
_[INITIAL_MODE][Tokenizer.EOF_TOKEN] = tokenInInitialMode;

_[BEFORE_HTML_MODE] = Object.create(null);
_[BEFORE_HTML_MODE][Tokenizer.CHARACTER_TOKEN] =
_[BEFORE_HTML_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenBeforeHtml;
_[BEFORE_HTML_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = ignoreToken;
_[BEFORE_HTML_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[BEFORE_HTML_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[BEFORE_HTML_MODE][Tokenizer.START_TAG_TOKEN] = startTagBeforeHtml;
_[BEFORE_HTML_MODE][Tokenizer.END_TAG_TOKEN] = endTagBeforeHtml;
_[BEFORE_HTML_MODE][Tokenizer.EOF_TOKEN] = tokenBeforeHtml;

_[BEFORE_HEAD_MODE] = Object.create(null);
_[BEFORE_HEAD_MODE][Tokenizer.CHARACTER_TOKEN] =
_[BEFORE_HEAD_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenBeforeHead;
_[BEFORE_HEAD_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = ignoreToken;
_[BEFORE_HEAD_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[BEFORE_HEAD_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[BEFORE_HEAD_MODE][Tokenizer.START_TAG_TOKEN] = startTagBeforeHead;
_[BEFORE_HEAD_MODE][Tokenizer.END_TAG_TOKEN] = endTagBeforeHead;
_[BEFORE_HEAD_MODE][Tokenizer.EOF_TOKEN] = tokenBeforeHead;

_[IN_HEAD_MODE] = Object.create(null);
_[IN_HEAD_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_HEAD_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenInHead;
_[IN_HEAD_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[IN_HEAD_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_HEAD_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_HEAD_MODE][Tokenizer.START_TAG_TOKEN] = startTagInHead;
_[IN_HEAD_MODE][Tokenizer.END_TAG_TOKEN] = endTagInHead;
_[IN_HEAD_MODE][Tokenizer.EOF_TOKEN] = tokenInHead;

_[AFTER_HEAD_MODE] = Object.create(null);
_[AFTER_HEAD_MODE][Tokenizer.CHARACTER_TOKEN] =
_[AFTER_HEAD_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenAfterHead;
_[AFTER_HEAD_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[AFTER_HEAD_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[AFTER_HEAD_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[AFTER_HEAD_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterHead;
_[AFTER_HEAD_MODE][Tokenizer.END_TAG_TOKEN] = endTagAfterHead;
_[AFTER_HEAD_MODE][Tokenizer.EOF_TOKEN] = tokenAfterHead;

_[IN_BODY_MODE] = Object.create(null);
_[IN_BODY_MODE][Tokenizer.CHARACTER_TOKEN] = characterInBody;
_[IN_BODY_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_BODY_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[IN_BODY_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_BODY_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_BODY_MODE][Tokenizer.START_TAG_TOKEN] = startTagInBody;
_[IN_BODY_MODE][Tokenizer.END_TAG_TOKEN] = endTagInBody;
_[IN_BODY_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[TEXT_MODE] = Object.create(null);
_[TEXT_MODE][Tokenizer.CHARACTER_TOKEN] =
_[TEXT_MODE][Tokenizer.NULL_CHARACTER_TOKEN] =
_[TEXT_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[TEXT_MODE][Tokenizer.COMMENT_TOKEN] =
_[TEXT_MODE][Tokenizer.DOCTYPE_TOKEN] =
_[TEXT_MODE][Tokenizer.START_TAG_TOKEN] = ignoreToken;
_[TEXT_MODE][Tokenizer.END_TAG_TOKEN] = endTagInText;
_[TEXT_MODE][Tokenizer.EOF_TOKEN] = eofInText;

_[IN_TABLE_MODE] = Object.create(null);
_[IN_TABLE_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_TABLE_MODE][Tokenizer.NULL_CHARACTER_TOKEN] =
_[IN_TABLE_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = characterInTable;
_[IN_TABLE_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_TABLE_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_TABLE_MODE][Tokenizer.START_TAG_TOKEN] = startTagInTable;
_[IN_TABLE_MODE][Tokenizer.END_TAG_TOKEN] = endTagInTable;
_[IN_TABLE_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_TABLE_TEXT_MODE] = Object.create(null);
_[IN_TABLE_TEXT_MODE][Tokenizer.CHARACTER_TOKEN] = characterInTableText;
_[IN_TABLE_TEXT_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_TABLE_TEXT_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInTableText;
_[IN_TABLE_TEXT_MODE][Tokenizer.COMMENT_TOKEN] =
_[IN_TABLE_TEXT_MODE][Tokenizer.DOCTYPE_TOKEN] =
_[IN_TABLE_TEXT_MODE][Tokenizer.START_TAG_TOKEN] =
_[IN_TABLE_TEXT_MODE][Tokenizer.END_TAG_TOKEN] =
_[IN_TABLE_TEXT_MODE][Tokenizer.EOF_TOKEN] = tokenInTableText;

_[IN_CAPTION_MODE] = Object.create(null);
_[IN_CAPTION_MODE][Tokenizer.CHARACTER_TOKEN] = characterInBody;
_[IN_CAPTION_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_CAPTION_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[IN_CAPTION_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_CAPTION_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_CAPTION_MODE][Tokenizer.START_TAG_TOKEN] = startTagInCaption;
_[IN_CAPTION_MODE][Tokenizer.END_TAG_TOKEN] = endTagInCaption;
_[IN_CAPTION_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_COLUMN_GROUP_MODE] = Object.create(null);
_[IN_COLUMN_GROUP_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_COLUMN_GROUP_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenInColumnGroup;
_[IN_COLUMN_GROUP_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[IN_COLUMN_GROUP_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_COLUMN_GROUP_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_COLUMN_GROUP_MODE][Tokenizer.START_TAG_TOKEN] = startTagInColumnGroup;
_[IN_COLUMN_GROUP_MODE][Tokenizer.END_TAG_TOKEN] = endTagInColumnGroup;
_[IN_COLUMN_GROUP_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_TABLE_BODY_MODE] = Object.create(null);
_[IN_TABLE_BODY_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_TABLE_BODY_MODE][Tokenizer.NULL_CHARACTER_TOKEN] =
_[IN_TABLE_BODY_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = characterInTable;
_[IN_TABLE_BODY_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_TABLE_BODY_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_TABLE_BODY_MODE][Tokenizer.START_TAG_TOKEN] = startTagInTableBody;
_[IN_TABLE_BODY_MODE][Tokenizer.END_TAG_TOKEN] = endTagInTableBody;
_[IN_TABLE_BODY_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_ROW_MODE] = Object.create(null);
_[IN_ROW_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_ROW_MODE][Tokenizer.NULL_CHARACTER_TOKEN] =
_[IN_ROW_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = characterInTable;
_[IN_ROW_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_ROW_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_ROW_MODE][Tokenizer.START_TAG_TOKEN] = startTagInRow;
_[IN_ROW_MODE][Tokenizer.END_TAG_TOKEN] = endTagInRow;
_[IN_ROW_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_CELL_MODE] = Object.create(null);
_[IN_CELL_MODE][Tokenizer.CHARACTER_TOKEN] = characterInBody;
_[IN_CELL_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_CELL_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[IN_CELL_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_CELL_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_CELL_MODE][Tokenizer.START_TAG_TOKEN] = startTagInCell;
_[IN_CELL_MODE][Tokenizer.END_TAG_TOKEN] = endTagInCell;
_[IN_CELL_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_SELECT_MODE] = Object.create(null);
_[IN_SELECT_MODE][Tokenizer.CHARACTER_TOKEN] = insertCharacters;
_[IN_SELECT_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_SELECT_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[IN_SELECT_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_SELECT_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_SELECT_MODE][Tokenizer.START_TAG_TOKEN] = startTagInSelect;
_[IN_SELECT_MODE][Tokenizer.END_TAG_TOKEN] = endTagInSelect;
_[IN_SELECT_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_SELECT_IN_TABLE_MODE] = Object.create(null);
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.CHARACTER_TOKEN] = insertCharacters;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.START_TAG_TOKEN] = startTagInSelectInTable;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.END_TAG_TOKEN] = endTagInSelectInTable;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_TEMPLATE_MODE] = Object.create(null);
_[IN_TEMPLATE_MODE][Tokenizer.CHARACTER_TOKEN] = characterInBody;
_[IN_TEMPLATE_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_TEMPLATE_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[IN_TEMPLATE_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_TEMPLATE_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_TEMPLATE_MODE][Tokenizer.START_TAG_TOKEN] = startTagInTemplate;
_[IN_TEMPLATE_MODE][Tokenizer.END_TAG_TOKEN] = endTagInTemplate;
_[IN_TEMPLATE_MODE][Tokenizer.EOF_TOKEN] = eofInTemplate;

_[AFTER_BODY_MODE] = Object.create(null);
_[AFTER_BODY_MODE][Tokenizer.CHARACTER_TOKEN] =
_[AFTER_BODY_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenAfterBody;
_[AFTER_BODY_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[AFTER_BODY_MODE][Tokenizer.COMMENT_TOKEN] = appendCommentToRootHtmlElement;
_[AFTER_BODY_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[AFTER_BODY_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterBody;
_[AFTER_BODY_MODE][Tokenizer.END_TAG_TOKEN] = endTagAfterBody;
_[AFTER_BODY_MODE][Tokenizer.EOF_TOKEN] = stopParsing;

_[IN_FRAMESET_MODE] = Object.create(null);
_[IN_FRAMESET_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_FRAMESET_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_FRAMESET_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[IN_FRAMESET_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_FRAMESET_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_FRAMESET_MODE][Tokenizer.START_TAG_TOKEN] = startTagInFrameset;
_[IN_FRAMESET_MODE][Tokenizer.END_TAG_TOKEN] = endTagInFrameset;
_[IN_FRAMESET_MODE][Tokenizer.EOF_TOKEN] = stopParsing;

_[AFTER_FRAMESET_MODE] = Object.create(null);
_[AFTER_FRAMESET_MODE][Tokenizer.CHARACTER_TOKEN] =
_[AFTER_FRAMESET_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[AFTER_FRAMESET_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[AFTER_FRAMESET_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[AFTER_FRAMESET_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[AFTER_FRAMESET_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterFrameset;
_[AFTER_FRAMESET_MODE][Tokenizer.END_TAG_TOKEN] = endTagAfterFrameset;
_[AFTER_FRAMESET_MODE][Tokenizer.EOF_TOKEN] = stopParsing;

_[AFTER_AFTER_BODY_MODE] = Object.create(null);
_[AFTER_AFTER_BODY_MODE][Tokenizer.CHARACTER_TOKEN] = tokenAfterAfterBody;
_[AFTER_AFTER_BODY_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenAfterAfterBody;
_[AFTER_AFTER_BODY_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[AFTER_AFTER_BODY_MODE][Tokenizer.COMMENT_TOKEN] = appendCommentToDocument;
_[AFTER_AFTER_BODY_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[AFTER_AFTER_BODY_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterAfterBody;
_[AFTER_AFTER_BODY_MODE][Tokenizer.END_TAG_TOKEN] = tokenAfterAfterBody;
_[AFTER_AFTER_BODY_MODE][Tokenizer.EOF_TOKEN] = stopParsing;

_[AFTER_AFTER_FRAMESET_MODE] = Object.create(null);
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.CHARACTER_TOKEN] =
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.COMMENT_TOKEN] = appendCommentToDocument;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterAfterFrameset;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.END_TAG_TOKEN] = ignoreToken;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.EOF_TOKEN] = stopParsing;


//Parser
var Parser = module.exports = function (options) {
    this.options = mergeOptions(DEFAULT_OPTIONS, options);

    this.treeAdapter = this.options.treeAdapter;
    this.pendingScript = null;

    if (this.options.locationInfo)
        new LocationInfoParserMixin(this);
};

// API
Parser.prototype.parse = function (html) {
    var document = this.treeAdapter.createDocument();

    this._bootstrap(document, null);
    this.tokenizer.write(html, true);
    this._runParsingLoop(null);

    return document;
};

Parser.prototype.parseFragment = function (html, fragmentContext) {
    //NOTE: use <template> element as a fragment context if context element was not provided,
    //so we will parse in "forgiving" manner
    if (!fragmentContext)
        fragmentContext = this.treeAdapter.createElement($.TEMPLATE, NS.HTML, []);

    //NOTE: create fake element which will be used as 'document' for fragment parsing.
    //This is important for jsdom there 'document' can't be recreated, therefore
    //fragment parsing causes messing of the main `document`.
    var documentMock = this.treeAdapter.createElement('documentmock', NS.HTML, []);

    this._bootstrap(documentMock, fragmentContext);

    if (this.treeAdapter.getTagName(fragmentContext) === $.TEMPLATE)
        this._pushTmplInsertionMode(IN_TEMPLATE_MODE);

    this._initTokenizerForFragmentParsing();
    this._insertFakeRootElement();
    this._resetInsertionMode();
    this._findFormInFragmentContext();
    this.tokenizer.write(html, true);
    this._runParsingLoop(null);

    var rootElement = this.treeAdapter.getFirstChild(documentMock),
        fragment = this.treeAdapter.createDocumentFragment();

    this._adoptNodes(rootElement, fragment);

    return fragment;
};

//Bootstrap parser
Parser.prototype._bootstrap = function (document, fragmentContext) {
    this.tokenizer = new Tokenizer(this.options);

    this.stopped = false;

    this.insertionMode = INITIAL_MODE;
    this.originalInsertionMode = '';

    this.document = document;
    this.fragmentContext = fragmentContext;

    this.headElement = null;
    this.formElement = null;

    this.openElements = new OpenElementStack(this.document, this.treeAdapter);
    this.activeFormattingElements = new FormattingElementList(this.treeAdapter);

    this.tmplInsertionModeStack = [];
    this.tmplInsertionModeStackTop = -1;
    this.currentTmplInsertionMode = null;

    this.pendingCharacterTokens = [];
    this.hasNonWhitespacePendingCharacterToken = false;

    this.framesetOk = true;
    this.skipNextNewLine = false;
    this.fosterParentingEnabled = false;
};

//Parsing loop
Parser.prototype._runParsingLoop  = function (scriptHandler) {
    while (!this.stopped) {
        this._setupTokenizerCDATAMode();

        var token = this.tokenizer.getNextToken();

        if (token.type === Tokenizer.HIBERNATION_TOKEN)
            break;

        if (this.skipNextNewLine) {
            this.skipNextNewLine = false;

            if (token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN && token.chars[0] === '\n') {
                if (token.chars.length === 1)
                    continue;

                token.chars = token.chars.substr(1);
            }
        }

        this._processInputToken(token);

        if (scriptHandler && this.pendingScript)
            break;
    }
};

Parser.prototype.runParsingLoopForCurrentChunk = function (writeCallback, scriptHandler) {
    this._runParsingLoop(scriptHandler);

    if (scriptHandler && this.pendingScript) {
        var script = this.pendingScript;

        this.pendingScript = null;

        scriptHandler(script);

        return;
    }

    if (writeCallback)
        writeCallback();
};

//Text parsing
Parser.prototype._setupTokenizerCDATAMode = function () {
    var current = this._getAdjustedCurrentElement();

    this.tokenizer.allowCDATA = current && current !== this.document &&
                                this.treeAdapter.getNamespaceURI(current) !== NS.HTML && !this._isIntegrationPoint(current);
};

Parser.prototype._switchToTextParsing = function (currentToken, nextTokenizerState) {
    this._insertElement(currentToken, NS.HTML);
    this.tokenizer.state = nextTokenizerState;
    this.originalInsertionMode = this.insertionMode;
    this.insertionMode = TEXT_MODE;
};

Parser.prototype.switchToPlaintextParsing = function () {
    this.insertionMode = TEXT_MODE;
    this.originalInsertionMode = IN_BODY_MODE;
    this.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
};

//Fragment parsing
Parser.prototype._getAdjustedCurrentElement = function () {
    return this.openElements.stackTop === 0 && this.fragmentContext ?
        this.fragmentContext :
        this.openElements.current;
};

Parser.prototype._findFormInFragmentContext = function () {
    var node = this.fragmentContext;

    do {
        if (this.treeAdapter.getTagName(node) === $.FORM) {
            this.formElement = node;
            break;
        }

        node = this.treeAdapter.getParentNode(node);
    } while (node);
};

Parser.prototype._initTokenizerForFragmentParsing = function () {
    if (this.treeAdapter.getNamespaceURI(this.fragmentContext) === NS.HTML) {
        var tn = this.treeAdapter.getTagName(this.fragmentContext);

        if (tn === $.TITLE || tn === $.TEXTAREA)
            this.tokenizer.state = Tokenizer.MODE.RCDATA;

        else if (tn === $.STYLE || tn === $.XMP || tn === $.IFRAME ||
                 tn === $.NOEMBED || tn === $.NOFRAMES || tn === $.NOSCRIPT)
            this.tokenizer.state = Tokenizer.MODE.RAWTEXT;

        else if (tn === $.SCRIPT)
            this.tokenizer.state = Tokenizer.MODE.SCRIPT_DATA;

        else if (tn === $.PLAINTEXT)
            this.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
    }
};

//Tree mutation
Parser.prototype._setDocumentType = function (token) {
    this.treeAdapter.setDocumentType(this.document, token.name, token.publicId, token.systemId);
};

Parser.prototype._attachElementToTree = function (element) {
    if (this._shouldFosterParentOnInsertion())
        this._fosterParentElement(element);

    else {
        var parent = this.openElements.currentTmplContent || this.openElements.current;

        this.treeAdapter.appendChild(parent, element);
    }
};

Parser.prototype._appendElement = function (token, namespaceURI) {
    var element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);

    this._attachElementToTree(element);
};

Parser.prototype._insertElement = function (token, namespaceURI) {
    var element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);

    this._attachElementToTree(element);
    this.openElements.push(element);
};

Parser.prototype._insertFakeElement = function (tagName) {
    var element = this.treeAdapter.createElement(tagName, NS.HTML, []);

    this._attachElementToTree(element);
    this.openElements.push(element);
};

Parser.prototype._insertTemplate = function (token) {
    var tmpl = this.treeAdapter.createElement(token.tagName, NS.HTML, token.attrs),
        content = this.treeAdapter.createDocumentFragment();

    this.treeAdapter.setTemplateContent(tmpl, content);
    this._attachElementToTree(tmpl);
    this.openElements.push(tmpl);
};

Parser.prototype._insertFakeRootElement = function () {
    var element = this.treeAdapter.createElement($.HTML, NS.HTML, []);

    this.treeAdapter.appendChild(this.openElements.current, element);
    this.openElements.push(element);
};

Parser.prototype._appendCommentNode = function (token, parent) {
    var commentNode = this.treeAdapter.createCommentNode(token.data);

    this.treeAdapter.appendChild(parent, commentNode);
};

Parser.prototype._insertCharacters = function (token) {
    if (this._shouldFosterParentOnInsertion())
        this._fosterParentText(token.chars);

    else {
        var parent = this.openElements.currentTmplContent || this.openElements.current;

        this.treeAdapter.insertText(parent, token.chars);
    }
};

Parser.prototype._adoptNodes = function (donor, recipient) {
    while (true) {
        var child = this.treeAdapter.getFirstChild(donor);

        if (!child)
            break;

        this.treeAdapter.detachNode(child);
        this.treeAdapter.appendChild(recipient, child);
    }
};

//Token processing
Parser.prototype._shouldProcessTokenInForeignContent = function (token) {
    var current = this._getAdjustedCurrentElement();

    if (!current || current === this.document)
        return false;

    var ns = this.treeAdapter.getNamespaceURI(current);

    if (ns === NS.HTML)
        return false;

    if (this.treeAdapter.getTagName(current) === $.ANNOTATION_XML && ns === NS.MATHML &&
        token.type === Tokenizer.START_TAG_TOKEN && token.tagName === $.SVG)
        return false;

    var isCharacterToken = token.type === Tokenizer.CHARACTER_TOKEN ||
                           token.type === Tokenizer.NULL_CHARACTER_TOKEN ||
                           token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN,
        isMathMLTextStartTag = token.type === Tokenizer.START_TAG_TOKEN &&
                               token.tagName !== $.MGLYPH &&
                               token.tagName !== $.MALIGNMARK;

    if ((isMathMLTextStartTag || isCharacterToken) && this._isIntegrationPoint(current, NS.MATHML))
        return false;

    if ((token.type === Tokenizer.START_TAG_TOKEN || isCharacterToken) && this._isIntegrationPoint(current, NS.HTML))
        return false;

    return token.type !== Tokenizer.EOF_TOKEN;
};

Parser.prototype._processToken = function (token) {
    _[this.insertionMode][token.type](this, token);
};

Parser.prototype._processTokenInBodyMode = function (token) {
    _[IN_BODY_MODE][token.type](this, token);
};

Parser.prototype._processTokenInForeignContent = function (token) {
    if (token.type === Tokenizer.CHARACTER_TOKEN)
        characterInForeignContent(this, token);

    else if (token.type === Tokenizer.NULL_CHARACTER_TOKEN)
        nullCharacterInForeignContent(this, token);

    else if (token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN)
        insertCharacters(this, token);

    else if (token.type === Tokenizer.COMMENT_TOKEN)
        appendComment(this, token);

    else if (token.type === Tokenizer.START_TAG_TOKEN)
        startTagInForeignContent(this, token);

    else if (token.type === Tokenizer.END_TAG_TOKEN)
        endTagInForeignContent(this, token);
};

Parser.prototype._processInputToken = function (token) {
    if (this._shouldProcessTokenInForeignContent(token))
        this._processTokenInForeignContent(token);

    else
        this._processToken(token);
};

//Integration points
Parser.prototype._isIntegrationPoint = function (element, foreignNS) {
    var tn = this.treeAdapter.getTagName(element),
        ns = this.treeAdapter.getNamespaceURI(element),
        attrs = this.treeAdapter.getAttrList(element);

    return foreignContent.isIntegrationPoint(tn, ns, attrs, foreignNS);
};

//Active formatting elements reconstruction
Parser.prototype._reconstructActiveFormattingElements = function () {
    var listLength = this.activeFormattingElements.length;

    if (listLength) {
        var unopenIdx = listLength,
            entry = null;

        do {
            unopenIdx--;
            entry = this.activeFormattingElements.entries[unopenIdx];

            if (entry.type === FormattingElementList.MARKER_ENTRY || this.openElements.contains(entry.element)) {
                unopenIdx++;
                break;
            }
        } while (unopenIdx > 0);

        for (var i = unopenIdx; i < listLength; i++) {
            entry = this.activeFormattingElements.entries[i];
            this._insertElement(entry.token, this.treeAdapter.getNamespaceURI(entry.element));
            entry.element = this.openElements.current;
        }
    }
};

//Close elements
Parser.prototype._closeTableCell = function () {
    this.openElements.generateImpliedEndTags();
    this.openElements.popUntilTableCellPopped();
    this.activeFormattingElements.clearToLastMarker();
    this.insertionMode = IN_ROW_MODE;
};

Parser.prototype._closePElement = function () {
    this.openElements.generateImpliedEndTagsWithExclusion($.P);
    this.openElements.popUntilTagNamePopped($.P);
};

//Insertion modes
Parser.prototype._resetInsertionMode = function () {
    for (var i = this.openElements.stackTop, last = false; i >= 0; i--) {
        var element = this.openElements.items[i];

        if (i === 0) {
            last = true;

            if (this.fragmentContext)
                element = this.fragmentContext;
        }

        var tn = this.treeAdapter.getTagName(element),
            newInsertionMode = INSERTION_MODE_RESET_MAP[tn];

        if (newInsertionMode) {
            this.insertionMode = newInsertionMode;
            break;
        }

        else if (!last && (tn === $.TD || tn === $.TH)) {
            this.insertionMode = IN_CELL_MODE;
            break;
        }

        else if (!last && tn === $.HEAD) {
            this.insertionMode = IN_HEAD_MODE;
            break;
        }

        else if (tn === $.SELECT) {
            this._resetInsertionModeForSelect(i);
            break;
        }

        else if (tn === $.TEMPLATE) {
            this.insertionMode = this.currentTmplInsertionMode;
            break;
        }

        else if (tn === $.HTML) {
            this.insertionMode = this.headElement ? AFTER_HEAD_MODE : BEFORE_HEAD_MODE;
            break;
        }

        else if (last) {
            this.insertionMode = IN_BODY_MODE;
            break;
        }
    }
};

Parser.prototype._resetInsertionModeForSelect = function (selectIdx) {
    if (selectIdx > 0) {
        for (var i = selectIdx - 1; i > 0; i--) {
            var ancestor = this.openElements.items[i],
                tn = this.treeAdapter.getTagName(ancestor);

            if (tn === $.TEMPLATE)
                break;

            else if (tn === $.TABLE) {
                this.insertionMode = IN_SELECT_IN_TABLE_MODE;
                return;
            }
        }
    }

    this.insertionMode = IN_SELECT_MODE;
};

Parser.prototype._pushTmplInsertionMode = function (mode) {
    this.tmplInsertionModeStack.push(mode);
    this.tmplInsertionModeStackTop++;
    this.currentTmplInsertionMode = mode;
};

Parser.prototype._popTmplInsertionMode = function () {
    this.tmplInsertionModeStack.pop();
    this.tmplInsertionModeStackTop--;
    this.currentTmplInsertionMode = this.tmplInsertionModeStack[this.tmplInsertionModeStackTop];
};

//Foster parenting
Parser.prototype._isElementCausesFosterParenting = function (element) {
    var tn = this.treeAdapter.getTagName(element);

    return tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR;
};

Parser.prototype._shouldFosterParentOnInsertion = function () {
    return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.current);
};

Parser.prototype._findFosterParentingLocation = function () {
    var location = {
        parent: null,
        beforeElement: null
    };

    for (var i = this.openElements.stackTop; i >= 0; i--) {
        var openElement = this.openElements.items[i],
            tn = this.treeAdapter.getTagName(openElement),
            ns = this.treeAdapter.getNamespaceURI(openElement);

        if (tn === $.TEMPLATE && ns === NS.HTML) {
            location.parent = this.treeAdapter.getTemplateContent(openElement);
            break;
        }

        else if (tn === $.TABLE) {
            location.parent = this.treeAdapter.getParentNode(openElement);

            if (location.parent)
                location.beforeElement = openElement;
            else
                location.parent = this.openElements.items[i - 1];

            break;
        }
    }

    if (!location.parent)
        location.parent = this.openElements.items[0];

    return location;
};

Parser.prototype._fosterParentElement = function (element) {
    var location = this._findFosterParentingLocation();

    if (location.beforeElement)
        this.treeAdapter.insertBefore(location.parent, element, location.beforeElement);
    else
        this.treeAdapter.appendChild(location.parent, element);
};

Parser.prototype._fosterParentText = function (chars) {
    var location = this._findFosterParentingLocation();

    if (location.beforeElement)
        this.treeAdapter.insertTextBefore(location.parent, chars, location.beforeElement);
    else
        this.treeAdapter.insertText(location.parent, chars);
};

//Special elements
Parser.prototype._isSpecialElement = function (element) {
    var tn = this.treeAdapter.getTagName(element),
        ns = this.treeAdapter.getNamespaceURI(element);

    return HTML.SPECIAL_ELEMENTS[ns][tn];
};

//Adoption agency algorithm
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tree-construction.html#adoptionAgency)
//------------------------------------------------------------------

//Steps 5-8 of the algorithm
function aaObtainFormattingElementEntry(p, token) {
    var formattingElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName(token.tagName);

    if (formattingElementEntry) {
        if (!p.openElements.contains(formattingElementEntry.element)) {
            p.activeFormattingElements.removeEntry(formattingElementEntry);
            formattingElementEntry = null;
        }

        else if (!p.openElements.hasInScope(token.tagName))
            formattingElementEntry = null;
    }

    else
        genericEndTagInBody(p, token);

    return formattingElementEntry;
}

//Steps 9 and 10 of the algorithm
function aaObtainFurthestBlock(p, formattingElementEntry) {
    var furthestBlock = null;

    for (var i = p.openElements.stackTop; i >= 0; i--) {
        var element = p.openElements.items[i];

        if (element === formattingElementEntry.element)
            break;

        if (p._isSpecialElement(element))
            furthestBlock = element;
    }

    if (!furthestBlock) {
        p.openElements.popUntilElementPopped(formattingElementEntry.element);
        p.activeFormattingElements.removeEntry(formattingElementEntry);
    }

    return furthestBlock;
}

//Step 13 of the algorithm
function aaInnerLoop(p, furthestBlock, formattingElement) {
    var lastElement = furthestBlock,
        nextElement = p.openElements.getCommonAncestor(furthestBlock);

    for (var i = 0, element = nextElement; element !== formattingElement; i++, element = nextElement) {
        //NOTE: store next element for the next loop iteration (it may be deleted from the stack by step 9.5)
        nextElement = p.openElements.getCommonAncestor(element);

        var elementEntry = p.activeFormattingElements.getElementEntry(element),
            counterOverflow = elementEntry && i >= AA_INNER_LOOP_ITER,
            shouldRemoveFromOpenElements = !elementEntry || counterOverflow;

        if (shouldRemoveFromOpenElements) {
            if (counterOverflow)
                p.activeFormattingElements.removeEntry(elementEntry);

            p.openElements.remove(element);
        }

        else {
            element = aaRecreateElementFromEntry(p, elementEntry);

            if (lastElement === furthestBlock)
                p.activeFormattingElements.bookmark = elementEntry;

            p.treeAdapter.detachNode(lastElement);
            p.treeAdapter.appendChild(element, lastElement);
            lastElement = element;
        }
    }

    return lastElement;
}

//Step 13.7 of the algorithm
function aaRecreateElementFromEntry(p, elementEntry) {
    var ns = p.treeAdapter.getNamespaceURI(elementEntry.element),
        newElement = p.treeAdapter.createElement(elementEntry.token.tagName, ns, elementEntry.token.attrs);

    p.openElements.replace(elementEntry.element, newElement);
    elementEntry.element = newElement;

    return newElement;
}

//Step 14 of the algorithm
function aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement) {
    if (p._isElementCausesFosterParenting(commonAncestor))
        p._fosterParentElement(lastElement);

    else {
        var tn = p.treeAdapter.getTagName(commonAncestor),
            ns = p.treeAdapter.getNamespaceURI(commonAncestor);

        if (tn === $.TEMPLATE && ns === NS.HTML)
            commonAncestor = p.treeAdapter.getTemplateContent(commonAncestor);

        p.treeAdapter.appendChild(commonAncestor, lastElement);
    }
}

//Steps 15-19 of the algorithm
function aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry) {
    var ns = p.treeAdapter.getNamespaceURI(formattingElementEntry.element),
        token = formattingElementEntry.token,
        newElement = p.treeAdapter.createElement(token.tagName, ns, token.attrs);

    p._adoptNodes(furthestBlock, newElement);
    p.treeAdapter.appendChild(furthestBlock, newElement);

    p.activeFormattingElements.insertElementAfterBookmark(newElement, formattingElementEntry.token);
    p.activeFormattingElements.removeEntry(formattingElementEntry);

    p.openElements.remove(formattingElementEntry.element);
    p.openElements.insertAfter(furthestBlock, newElement);
}

//Algorithm entry point
function callAdoptionAgency(p, token) {
    var formattingElementEntry;

    for (var i = 0; i < AA_OUTER_LOOP_ITER; i++) {
        formattingElementEntry = aaObtainFormattingElementEntry(p, token, formattingElementEntry);

        if (!formattingElementEntry)
            break;

        var furthestBlock = aaObtainFurthestBlock(p, formattingElementEntry);

        if (!furthestBlock)
            break;

        p.activeFormattingElements.bookmark = formattingElementEntry;

        var lastElement = aaInnerLoop(p, furthestBlock, formattingElementEntry.element),
            commonAncestor = p.openElements.getCommonAncestor(formattingElementEntry.element);

        p.treeAdapter.detachNode(lastElement);
        aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement);
        aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry);
    }
}


//Generic token handlers
//------------------------------------------------------------------
function ignoreToken() {
    //NOTE: do nothing =)
}

function appendComment(p, token) {
    p._appendCommentNode(token, p.openElements.currentTmplContent || p.openElements.current);
}

function appendCommentToRootHtmlElement(p, token) {
    p._appendCommentNode(token, p.openElements.items[0]);
}

function appendCommentToDocument(p, token) {
    p._appendCommentNode(token, p.document);
}

function insertCharacters(p, token) {
    p._insertCharacters(token);
}

function stopParsing(p) {
    p.stopped = true;
}

//12.2.5.4.1 The "initial" insertion mode
//------------------------------------------------------------------
function doctypeInInitialMode(p, token) {
    p._setDocumentType(token);

    var mode = token.forceQuirks ?
        HTML.DOCUMENT_MODE.QUIRKS :
        doctype.getDocumentMode(token.name, token.publicId, token.systemId);

    p.treeAdapter.setDocumentMode(p.document, mode);

    p.insertionMode = BEFORE_HTML_MODE;
}

function tokenInInitialMode(p, token) {
    p.treeAdapter.setDocumentMode(p.document, HTML.DOCUMENT_MODE.QUIRKS);
    p.insertionMode = BEFORE_HTML_MODE;
    p._processToken(token);
}


//12.2.5.4.2 The "before html" insertion mode
//------------------------------------------------------------------
function startTagBeforeHtml(p, token) {
    if (token.tagName === $.HTML) {
        p._insertElement(token, NS.HTML);
        p.insertionMode = BEFORE_HEAD_MODE;
    }

    else
        tokenBeforeHtml(p, token);
}

function endTagBeforeHtml(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML || tn === $.HEAD || tn === $.BODY || tn === $.BR)
        tokenBeforeHtml(p, token);
}

function tokenBeforeHtml(p, token) {
    p._insertFakeRootElement();
    p.insertionMode = BEFORE_HEAD_MODE;
    p._processToken(token);
}


//12.2.5.4.3 The "before head" insertion mode
//------------------------------------------------------------------
function startTagBeforeHead(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.HEAD) {
        p._insertElement(token, NS.HTML);
        p.headElement = p.openElements.current;
        p.insertionMode = IN_HEAD_MODE;
    }

    else
        tokenBeforeHead(p, token);
}

function endTagBeforeHead(p, token) {
    var tn = token.tagName;

    if (tn === $.HEAD || tn === $.BODY || tn === $.HTML || tn === $.BR)
        tokenBeforeHead(p, token);
}

function tokenBeforeHead(p, token) {
    p._insertFakeElement($.HEAD);
    p.headElement = p.openElements.current;
    p.insertionMode = IN_HEAD_MODE;
    p._processToken(token);
}


//12.2.5.4.4 The "in head" insertion mode
//------------------------------------------------------------------
function startTagInHead(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META)
        p._appendElement(token, NS.HTML);

    else if (tn === $.TITLE)
        p._switchToTextParsing(token, Tokenizer.MODE.RCDATA);

    //NOTE: here we assume that we always act as an interactive user agent with enabled scripting, so we parse
    //<noscript> as a rawtext.
    else if (tn === $.NOSCRIPT || tn === $.NOFRAMES || tn === $.STYLE)
        p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);

    else if (tn === $.SCRIPT)
        p._switchToTextParsing(token, Tokenizer.MODE.SCRIPT_DATA);

    else if (tn === $.TEMPLATE) {
        p._insertTemplate(token, NS.HTML);
        p.activeFormattingElements.insertMarker();
        p.framesetOk = false;
        p.insertionMode = IN_TEMPLATE_MODE;
        p._pushTmplInsertionMode(IN_TEMPLATE_MODE);
    }

    else if (tn !== $.HEAD)
        tokenInHead(p, token);
}

function endTagInHead(p, token) {
    var tn = token.tagName;

    if (tn === $.HEAD) {
        p.openElements.pop();
        p.insertionMode = AFTER_HEAD_MODE;
    }

    else if (tn === $.BODY || tn === $.BR || tn === $.HTML)
        tokenInHead(p, token);

    else if (tn === $.TEMPLATE && p.openElements.tmplCount > 0) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped($.TEMPLATE);
        p.activeFormattingElements.clearToLastMarker();
        p._popTmplInsertionMode();
        p._resetInsertionMode();
    }
}

function tokenInHead(p, token) {
    p.openElements.pop();
    p.insertionMode = AFTER_HEAD_MODE;
    p._processToken(token);
}


//12.2.5.4.6 The "after head" insertion mode
//------------------------------------------------------------------
function startTagAfterHead(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.BODY) {
        p._insertElement(token, NS.HTML);
        p.framesetOk = false;
        p.insertionMode = IN_BODY_MODE;
    }

    else if (tn === $.FRAMESET) {
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_FRAMESET_MODE;
    }

    else if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META ||
             tn === $.NOFRAMES || tn === $.SCRIPT || tn === $.STYLE || tn === $.TEMPLATE || tn === $.TITLE) {
        p.openElements.push(p.headElement);
        startTagInHead(p, token);
        p.openElements.remove(p.headElement);
    }

    else if (tn !== $.HEAD)
        tokenAfterHead(p, token);
}

function endTagAfterHead(p, token) {
    var tn = token.tagName;

    if (tn === $.BODY || tn === $.HTML || tn === $.BR)
        tokenAfterHead(p, token);

    else if (tn === $.TEMPLATE)
        endTagInHead(p, token);
}

function tokenAfterHead(p, token) {
    p._insertFakeElement($.BODY);
    p.insertionMode = IN_BODY_MODE;
    p._processToken(token);
}


//12.2.5.4.7 The "in body" insertion mode
//------------------------------------------------------------------
function whitespaceCharacterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
}

function characterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
    p.framesetOk = false;
}

function htmlStartTagInBody(p, token) {
    if (p.openElements.tmplCount === 0)
        p.treeAdapter.adoptAttributes(p.openElements.items[0], token.attrs);
}

function bodyStartTagInBody(p, token) {
    var bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();

    if (bodyElement && p.openElements.tmplCount === 0) {
        p.framesetOk = false;
        p.treeAdapter.adoptAttributes(bodyElement, token.attrs);
    }
}

function framesetStartTagInBody(p, token) {
    var bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();

    if (p.framesetOk && bodyElement) {
        p.treeAdapter.detachNode(bodyElement);
        p.openElements.popAllUpToHtmlElement();
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_FRAMESET_MODE;
    }
}

function addressStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._insertElement(token, NS.HTML);
}

function numberedHeaderStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    var tn = p.openElements.currentTagName;

    if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6)
        p.openElements.pop();

    p._insertElement(token, NS.HTML);
}

function preStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._insertElement(token, NS.HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of pre blocks are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.framesetOk = false;
}

function formStartTagInBody(p, token) {
    var inTemplate = p.openElements.tmplCount > 0;

    if (!p.formElement || inTemplate) {
        if (p.openElements.hasInButtonScope($.P))
            p._closePElement();

        p._insertElement(token, NS.HTML);

        if (!inTemplate)
            p.formElement = p.openElements.current;
    }
}

function listItemStartTagInBody(p, token) {
    p.framesetOk = false;

    var tn = token.tagName;

    for (var i = p.openElements.stackTop; i >= 0; i--) {
        var element = p.openElements.items[i],
            elementTn = p.treeAdapter.getTagName(element),
            closeTn = null;

        if (tn === $.LI && elementTn === $.LI)
            closeTn = $.LI;

        else if ((tn === $.DD || tn === $.DT) && (elementTn === $.DD || elementTn === $.DT))
            closeTn = elementTn;

        if (closeTn) {
            p.openElements.generateImpliedEndTagsWithExclusion(closeTn);
            p.openElements.popUntilTagNamePopped(closeTn);
            break;
        }

        if (elementTn !== $.ADDRESS && elementTn !== $.DIV && elementTn !== $.P && p._isSpecialElement(element))
            break;
    }

    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._insertElement(token, NS.HTML);
}

function plaintextStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._insertElement(token, NS.HTML);
    p.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
}

function buttonStartTagInBody(p, token) {
    if (p.openElements.hasInScope($.BUTTON)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped($.BUTTON);
    }

    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.framesetOk = false;
}

function aStartTagInBody(p, token) {
    var activeElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName($.A);

    if (activeElementEntry) {
        callAdoptionAgency(p, token);
        p.openElements.remove(activeElementEntry.element);
        p.activeFormattingElements.removeEntry(activeElementEntry);
    }

    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}

function bStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}

function nobrStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();

    if (p.openElements.hasInScope($.NOBR)) {
        callAdoptionAgency(p, token);
        p._reconstructActiveFormattingElements();
    }

    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}

function appletStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.insertMarker();
    p.framesetOk = false;
}

function tableStartTagInBody(p, token) {
    if (p.treeAdapter.getDocumentMode(p.document) !== HTML.DOCUMENT_MODE.QUIRKS && p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._insertElement(token, NS.HTML);
    p.framesetOk = false;
    p.insertionMode = IN_TABLE_MODE;
}

function areaStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, NS.HTML);
    p.framesetOk = false;
}

function inputStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, NS.HTML);

    var inputType = Tokenizer.getTokenAttr(token, ATTRS.TYPE);

    if (!inputType || inputType.toLowerCase() !== HIDDEN_INPUT_TYPE)
        p.framesetOk = false;

}

function paramStartTagInBody(p, token) {
    p._appendElement(token, NS.HTML);
}

function hrStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    if (p.openElements.currentTagName === $.MENUITEM)
        p.openElements.pop();

    p._appendElement(token, NS.HTML);
    p.framesetOk = false;
}

function imageStartTagInBody(p, token) {
    token.tagName = $.IMG;
    areaStartTagInBody(p, token);
}

function textareaStartTagInBody(p, token) {
    p._insertElement(token, NS.HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of textarea elements are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.tokenizer.state = Tokenizer.MODE.RCDATA;
    p.originalInsertionMode = p.insertionMode;
    p.framesetOk = false;
    p.insertionMode = TEXT_MODE;
}

function xmpStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._reconstructActiveFormattingElements();
    p.framesetOk = false;
    p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
}

function iframeStartTagInBody(p, token) {
    p.framesetOk = false;
    p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
}

//NOTE: here we assume that we always act as an user agent with enabled plugins, so we parse
//<noembed> as a rawtext.
function noembedStartTagInBody(p, token) {
    p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
}

function selectStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.framesetOk = false;

    if (p.insertionMode === IN_TABLE_MODE ||
        p.insertionMode === IN_CAPTION_MODE ||
        p.insertionMode === IN_TABLE_BODY_MODE ||
        p.insertionMode === IN_ROW_MODE ||
        p.insertionMode === IN_CELL_MODE)

        p.insertionMode = IN_SELECT_IN_TABLE_MODE;

    else
        p.insertionMode = IN_SELECT_MODE;
}

function optgroupStartTagInBody(p, token) {
    if (p.openElements.currentTagName === $.OPTION)
        p.openElements.pop();

    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
}

function rbStartTagInBody(p, token) {
    if (p.openElements.hasInScope($.RUBY))
        p.openElements.generateImpliedEndTags();

    p._insertElement(token, NS.HTML);
}

function rtStartTagInBody(p, token) {
    if (p.openElements.hasInScope($.RUBY))
        p.openElements.generateImpliedEndTagsWithExclusion($.RTC);

    p._insertElement(token, NS.HTML);
}

function menuitemStartTagInBody(p, token) {
    if (p.openElements.currentTagName === $.MENUITEM)
        p.openElements.pop();

    // TODO needs clarification, see https://github.com/whatwg/html/pull/907/files#r73505877
    p._reconstructActiveFormattingElements();

    p._insertElement(token, NS.HTML);
}

function menuStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    if (p.openElements.currentTagName === $.MENUITEM)
        p.openElements.pop();

    p._insertElement(token, NS.HTML);
}

function mathStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();

    foreignContent.adjustTokenMathMLAttrs(token);
    foreignContent.adjustTokenXMLAttrs(token);

    if (token.selfClosing)
        p._appendElement(token, NS.MATHML);
    else
        p._insertElement(token, NS.MATHML);
}

function svgStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();

    foreignContent.adjustTokenSVGAttrs(token);
    foreignContent.adjustTokenXMLAttrs(token);

    if (token.selfClosing)
        p._appendElement(token, NS.SVG);
    else
        p._insertElement(token, NS.SVG);
}

function genericStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
}

//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function startTagInBody(p, token) {
    var tn = token.tagName;

    switch (tn.length) {
        case 1:
            if (tn === $.I || tn === $.S || tn === $.B || tn === $.U)
                bStartTagInBody(p, token);

            else if (tn === $.P)
                addressStartTagInBody(p, token);

            else if (tn === $.A)
                aStartTagInBody(p, token);

            else
                genericStartTagInBody(p, token);

            break;

        case 2:
            if (tn === $.DL || tn === $.OL || tn === $.UL)
                addressStartTagInBody(p, token);

            else if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6)
                numberedHeaderStartTagInBody(p, token);

            else if (tn === $.LI || tn === $.DD || tn === $.DT)
                listItemStartTagInBody(p, token);

            else if (tn === $.EM || tn === $.TT)
                bStartTagInBody(p, token);

            else if (tn === $.BR)
                areaStartTagInBody(p, token);

            else if (tn === $.HR)
                hrStartTagInBody(p, token);

            else if (tn === $.RB)
                rbStartTagInBody(p, token);

            else if (tn === $.RT || tn === $.RP)
                rtStartTagInBody(p, token);

            else if (tn !== $.TH && tn !== $.TD && tn !== $.TR)
                genericStartTagInBody(p, token);

            break;

        case 3:
            if (tn === $.DIV || tn === $.DIR || tn === $.NAV)
                addressStartTagInBody(p, token);

            else if (tn === $.PRE)
                preStartTagInBody(p, token);

            else if (tn === $.BIG)
                bStartTagInBody(p, token);

            else if (tn === $.IMG || tn === $.WBR)
                areaStartTagInBody(p, token);

            else if (tn === $.XMP)
                xmpStartTagInBody(p, token);

            else if (tn === $.SVG)
                svgStartTagInBody(p, token);

            else if (tn === $.RTC)
                rbStartTagInBody(p, token);

            else if (tn !== $.COL)
                genericStartTagInBody(p, token);

            break;

        case 4:
            if (tn === $.HTML)
                htmlStartTagInBody(p, token);

            else if (tn === $.BASE || tn === $.LINK || tn === $.META)
                startTagInHead(p, token);

            else if (tn === $.BODY)
                bodyStartTagInBody(p, token);

            else if (tn === $.MAIN)
                addressStartTagInBody(p, token);

            else if (tn === $.FORM)
                formStartTagInBody(p, token);

            else if (tn === $.CODE || tn === $.FONT)
                bStartTagInBody(p, token);

            else if (tn === $.NOBR)
                nobrStartTagInBody(p, token);

            else if (tn === $.AREA)
                areaStartTagInBody(p, token);

            else if (tn === $.MATH)
                mathStartTagInBody(p, token);

            else if (tn === $.MENU)
                menuStartTagInBody(p, token);

            else if (tn !== $.HEAD)
                genericStartTagInBody(p, token);

            break;

        case 5:
            if (tn === $.STYLE || tn === $.TITLE)
                startTagInHead(p, token);

            else if (tn === $.ASIDE)
                addressStartTagInBody(p, token);

            else if (tn === $.SMALL)
                bStartTagInBody(p, token);

            else if (tn === $.TABLE)
                tableStartTagInBody(p, token);

            else if (tn === $.EMBED)
                areaStartTagInBody(p, token);

            else if (tn === $.INPUT)
                inputStartTagInBody(p, token);

            else if (tn === $.PARAM || tn === $.TRACK)
                paramStartTagInBody(p, token);

            else if (tn === $.IMAGE)
                imageStartTagInBody(p, token);

            else if (tn !== $.FRAME && tn !== $.TBODY && tn !== $.TFOOT && tn !== $.THEAD)
                genericStartTagInBody(p, token);

            break;

        case 6:
            if (tn === $.SCRIPT)
                startTagInHead(p, token);

            else if (tn === $.CENTER || tn === $.FIGURE || tn === $.FOOTER || tn === $.HEADER || tn === $.HGROUP)
                addressStartTagInBody(p, token);

            else if (tn === $.BUTTON)
                buttonStartTagInBody(p, token);

            else if (tn === $.STRIKE || tn === $.STRONG)
                bStartTagInBody(p, token);

            else if (tn === $.APPLET || tn === $.OBJECT)
                appletStartTagInBody(p, token);

            else if (tn === $.KEYGEN)
                areaStartTagInBody(p, token);

            else if (tn === $.SOURCE)
                paramStartTagInBody(p, token);

            else if (tn === $.IFRAME)
                iframeStartTagInBody(p, token);

            else if (tn === $.SELECT)
                selectStartTagInBody(p, token);

            else if (tn === $.OPTION)
                optgroupStartTagInBody(p, token);

            else
                genericStartTagInBody(p, token);

            break;

        case 7:
            if (tn === $.BGSOUND)
                startTagInHead(p, token);

            else if (tn === $.DETAILS || tn === $.ADDRESS || tn === $.ARTICLE || tn === $.SECTION || tn === $.SUMMARY)
                addressStartTagInBody(p, token);

            else if (tn === $.LISTING)
                preStartTagInBody(p, token);

            else if (tn === $.MARQUEE)
                appletStartTagInBody(p, token);

            else if (tn === $.NOEMBED)
                noembedStartTagInBody(p, token);

            else if (tn !== $.CAPTION)
                genericStartTagInBody(p, token);

            break;

        case 8:
            if (tn === $.BASEFONT)
                startTagInHead(p, token);

            else if (tn === $.MENUITEM)
                menuitemStartTagInBody(p, token);

            else if (tn === $.FRAMESET)
                framesetStartTagInBody(p, token);

            else if (tn === $.FIELDSET)
                addressStartTagInBody(p, token);

            else if (tn === $.TEXTAREA)
                textareaStartTagInBody(p, token);

            else if (tn === $.TEMPLATE)
                startTagInHead(p, token);

            else if (tn === $.NOSCRIPT)
                noembedStartTagInBody(p, token);

            else if (tn === $.OPTGROUP)
                optgroupStartTagInBody(p, token);

            else if (tn !== $.COLGROUP)
                genericStartTagInBody(p, token);

            break;

        case 9:
            if (tn === $.PLAINTEXT)
                plaintextStartTagInBody(p, token);

            else
                genericStartTagInBody(p, token);

            break;

        case 10:
            if (tn === $.BLOCKQUOTE || tn === $.FIGCAPTION)
                addressStartTagInBody(p, token);

            else
                genericStartTagInBody(p, token);

            break;

        default:
            genericStartTagInBody(p, token);
    }
}

function bodyEndTagInBody(p) {
    if (p.openElements.hasInScope($.BODY))
        p.insertionMode = AFTER_BODY_MODE;
}

function htmlEndTagInBody(p, token) {
    if (p.openElements.hasInScope($.BODY)) {
        p.insertionMode = AFTER_BODY_MODE;
        p._processToken(token);
    }
}

function addressEndTagInBody(p, token) {
    var tn = token.tagName;

    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
    }
}

function formEndTagInBody(p) {
    var inTemplate = p.openElements.tmplCount > 0,
        formElement = p.formElement;

    if (!inTemplate)
        p.formElement = null;

    if ((formElement || inTemplate) && p.openElements.hasInScope($.FORM)) {
        p.openElements.generateImpliedEndTags();

        if (inTemplate)
            p.openElements.popUntilTagNamePopped($.FORM);

        else
            p.openElements.remove(formElement);
    }
}

function pEndTagInBody(p) {
    if (!p.openElements.hasInButtonScope($.P))
        p._insertFakeElement($.P);

    p._closePElement();
}

function liEndTagInBody(p) {
    if (p.openElements.hasInListItemScope($.LI)) {
        p.openElements.generateImpliedEndTagsWithExclusion($.LI);
        p.openElements.popUntilTagNamePopped($.LI);
    }
}

function ddEndTagInBody(p, token) {
    var tn = token.tagName;

    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTagsWithExclusion(tn);
        p.openElements.popUntilTagNamePopped(tn);
    }
}

function numberedHeaderEndTagInBody(p) {
    if (p.openElements.hasNumberedHeaderInScope()) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilNumberedHeaderPopped();
    }
}

function appletEndTagInBody(p, token) {
    var tn = token.tagName;

    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
        p.activeFormattingElements.clearToLastMarker();
    }
}

function brEndTagInBody(p) {
    p._reconstructActiveFormattingElements();
    p._insertFakeElement($.BR);
    p.openElements.pop();
    p.framesetOk = false;
}

function genericEndTagInBody(p, token) {
    var tn = token.tagName;

    for (var i = p.openElements.stackTop; i > 0; i--) {
        var element = p.openElements.items[i];

        if (p.treeAdapter.getTagName(element) === tn) {
            p.openElements.generateImpliedEndTagsWithExclusion(tn);
            p.openElements.popUntilElementPopped(element);
            break;
        }

        if (p._isSpecialElement(element))
            break;
    }
}

//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function endTagInBody(p, token) {
    var tn = token.tagName;

    switch (tn.length) {
        case 1:
            if (tn === $.A || tn === $.B || tn === $.I || tn === $.S || tn === $.U)
                callAdoptionAgency(p, token);

            else if (tn === $.P)
                pEndTagInBody(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 2:
            if (tn === $.DL || tn === $.UL || tn === $.OL)
                addressEndTagInBody(p, token);

            else if (tn === $.LI)
                liEndTagInBody(p, token);

            else if (tn === $.DD || tn === $.DT)
                ddEndTagInBody(p, token);

            else if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6)
                numberedHeaderEndTagInBody(p, token);

            else if (tn === $.BR)
                brEndTagInBody(p, token);

            else if (tn === $.EM || tn === $.TT)
                callAdoptionAgency(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 3:
            if (tn === $.BIG)
                callAdoptionAgency(p, token);

            else if (tn === $.DIR || tn === $.DIV || tn === $.NAV)
                addressEndTagInBody(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 4:
            if (tn === $.BODY)
                bodyEndTagInBody(p, token);

            else if (tn === $.HTML)
                htmlEndTagInBody(p, token);

            else if (tn === $.FORM)
                formEndTagInBody(p, token);

            else if (tn === $.CODE || tn === $.FONT || tn === $.NOBR)
                callAdoptionAgency(p, token);

            else if (tn === $.MAIN || tn === $.MENU)
                addressEndTagInBody(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 5:
            if (tn === $.ASIDE)
                addressEndTagInBody(p, token);

            else if (tn === $.SMALL)
                callAdoptionAgency(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 6:
            if (tn === $.CENTER || tn === $.FIGURE || tn === $.FOOTER || tn === $.HEADER || tn === $.HGROUP)
                addressEndTagInBody(p, token);

            else if (tn === $.APPLET || tn === $.OBJECT)
                appletEndTagInBody(p, token);

            else if (tn === $.STRIKE || tn === $.STRONG)
                callAdoptionAgency(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 7:
            if (tn === $.ADDRESS || tn === $.ARTICLE || tn === $.DETAILS || tn === $.SECTION || tn === $.SUMMARY)
                addressEndTagInBody(p, token);

            else if (tn === $.MARQUEE)
                appletEndTagInBody(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 8:
            if (tn === $.FIELDSET)
                addressEndTagInBody(p, token);

            else if (tn === $.TEMPLATE)
                endTagInHead(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 10:
            if (tn === $.BLOCKQUOTE || tn === $.FIGCAPTION)
                addressEndTagInBody(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        default :
            genericEndTagInBody(p, token);
    }
}

function eofInBody(p, token) {
    if (p.tmplInsertionModeStackTop > -1)
        eofInTemplate(p, token);

    else
        p.stopped = true;
}

//12.2.5.4.8 The "text" insertion mode
//------------------------------------------------------------------
function endTagInText(p, token) {
    if (token.tagName === $.SCRIPT)
        p.pendingScript = p.openElements.current;

    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
}


function eofInText(p, token) {
    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
    p._processToken(token);
}


//12.2.5.4.9 The "in table" insertion mode
//------------------------------------------------------------------
function characterInTable(p, token) {
    var curTn = p.openElements.currentTagName;

    if (curTn === $.TABLE || curTn === $.TBODY || curTn === $.TFOOT || curTn === $.THEAD || curTn === $.TR) {
        p.pendingCharacterTokens = [];
        p.hasNonWhitespacePendingCharacterToken = false;
        p.originalInsertionMode = p.insertionMode;
        p.insertionMode = IN_TABLE_TEXT_MODE;
        p._processToken(token);
    }

    else
        tokenInTable(p, token);
}

function captionStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p.activeFormattingElements.insertMarker();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_CAPTION_MODE;
}

function colgroupStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_COLUMN_GROUP_MODE;
}

function colStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement($.COLGROUP);
    p.insertionMode = IN_COLUMN_GROUP_MODE;
    p._processToken(token);
}

function tbodyStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_TABLE_BODY_MODE;
}

function tdStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement($.TBODY);
    p.insertionMode = IN_TABLE_BODY_MODE;
    p._processToken(token);
}

function tableStartTagInTable(p, token) {
    if (p.openElements.hasInTableScope($.TABLE)) {
        p.openElements.popUntilTagNamePopped($.TABLE);
        p._resetInsertionMode();
        p._processToken(token);
    }
}

function inputStartTagInTable(p, token) {
    var inputType = Tokenizer.getTokenAttr(token, ATTRS.TYPE);

    if (inputType && inputType.toLowerCase() === HIDDEN_INPUT_TYPE)
        p._appendElement(token, NS.HTML);

    else
        tokenInTable(p, token);
}

function formStartTagInTable(p, token) {
    if (!p.formElement && p.openElements.tmplCount === 0) {
        p._insertElement(token, NS.HTML);
        p.formElement = p.openElements.current;
        p.openElements.pop();
    }
}

function startTagInTable(p, token) {
    var tn = token.tagName;

    switch (tn.length) {
        case 2:
            if (tn === $.TD || tn === $.TH || tn === $.TR)
                tdStartTagInTable(p, token);

            else
                tokenInTable(p, token);

            break;

        case 3:
            if (tn === $.COL)
                colStartTagInTable(p, token);

            else
                tokenInTable(p, token);

            break;

        case 4:
            if (tn === $.FORM)
                formStartTagInTable(p, token);

            else
                tokenInTable(p, token);

            break;

        case 5:
            if (tn === $.TABLE)
                tableStartTagInTable(p, token);

            else if (tn === $.STYLE)
                startTagInHead(p, token);

            else if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD)
                tbodyStartTagInTable(p, token);

            else if (tn === $.INPUT)
                inputStartTagInTable(p, token);

            else
                tokenInTable(p, token);

            break;

        case 6:
            if (tn === $.SCRIPT)
                startTagInHead(p, token);

            else
                tokenInTable(p, token);

            break;

        case 7:
            if (tn === $.CAPTION)
                captionStartTagInTable(p, token);

            else
                tokenInTable(p, token);

            break;

        case 8:
            if (tn === $.COLGROUP)
                colgroupStartTagInTable(p, token);

            else if (tn === $.TEMPLATE)
                startTagInHead(p, token);

            else
                tokenInTable(p, token);

            break;

        default:
            tokenInTable(p, token);
    }

}

function endTagInTable(p, token) {
    var tn = token.tagName;

    if (tn === $.TABLE) {
        if (p.openElements.hasInTableScope($.TABLE)) {
            p.openElements.popUntilTagNamePopped($.TABLE);
            p._resetInsertionMode();
        }
    }

    else if (tn === $.TEMPLATE)
        endTagInHead(p, token);

    else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML &&
             tn !== $.TBODY && tn !== $.TD && tn !== $.TFOOT && tn !== $.TH && tn !== $.THEAD && tn !== $.TR)
        tokenInTable(p, token);
}

function tokenInTable(p, token) {
    var savedFosterParentingState = p.fosterParentingEnabled;

    p.fosterParentingEnabled = true;
    p._processTokenInBodyMode(token);
    p.fosterParentingEnabled = savedFosterParentingState;
}


//12.2.5.4.10 The "in table text" insertion mode
//------------------------------------------------------------------
function whitespaceCharacterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
}

function characterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
    p.hasNonWhitespacePendingCharacterToken = true;
}

function tokenInTableText(p, token) {
    var i = 0;

    if (p.hasNonWhitespacePendingCharacterToken) {
        for (; i < p.pendingCharacterTokens.length; i++)
            tokenInTable(p, p.pendingCharacterTokens[i]);
    }

    else {
        for (; i < p.pendingCharacterTokens.length; i++)
            p._insertCharacters(p.pendingCharacterTokens[i]);
    }

    p.insertionMode = p.originalInsertionMode;
    p._processToken(token);
}


//12.2.5.4.11 The "in caption" insertion mode
//------------------------------------------------------------------
function startTagInCaption(p, token) {
    var tn = token.tagName;

    if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY ||
        tn === $.TD || tn === $.TFOOT || tn === $.TH || tn === $.THEAD || tn === $.TR) {
        if (p.openElements.hasInTableScope($.CAPTION)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped($.CAPTION);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = IN_TABLE_MODE;
            p._processToken(token);
        }
    }

    else
        startTagInBody(p, token);
}

function endTagInCaption(p, token) {
    var tn = token.tagName;

    if (tn === $.CAPTION || tn === $.TABLE) {
        if (p.openElements.hasInTableScope($.CAPTION)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped($.CAPTION);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = IN_TABLE_MODE;

            if (tn === $.TABLE)
                p._processToken(token);
        }
    }

    else if (tn !== $.BODY && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML && tn !== $.TBODY &&
             tn !== $.TD && tn !== $.TFOOT && tn !== $.TH && tn !== $.THEAD && tn !== $.TR)
        endTagInBody(p, token);
}


//12.2.5.4.12 The "in column group" insertion mode
//------------------------------------------------------------------
function startTagInColumnGroup(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.COL)
        p._appendElement(token, NS.HTML);

    else if (tn === $.TEMPLATE)
        startTagInHead(p, token);

    else
        tokenInColumnGroup(p, token);
}

function endTagInColumnGroup(p, token) {
    var tn = token.tagName;

    if (tn === $.COLGROUP) {
        if (p.openElements.currentTagName === $.COLGROUP) {
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
        }
    }

    else if (tn === $.TEMPLATE)
        endTagInHead(p, token);

    else if (tn !== $.COL)
        tokenInColumnGroup(p, token);
}

function tokenInColumnGroup(p, token) {
    if (p.openElements.currentTagName === $.COLGROUP) {
        p.openElements.pop();
        p.insertionMode = IN_TABLE_MODE;
        p._processToken(token);
    }
}

//12.2.5.4.13 The "in table body" insertion mode
//------------------------------------------------------------------
function startTagInTableBody(p, token) {
    var tn = token.tagName;

    if (tn === $.TR) {
        p.openElements.clearBackToTableBodyContext();
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_ROW_MODE;
    }

    else if (tn === $.TH || tn === $.TD) {
        p.openElements.clearBackToTableBodyContext();
        p._insertFakeElement($.TR);
        p.insertionMode = IN_ROW_MODE;
        p._processToken(token);
    }

    else if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP ||
             tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {

        if (p.openElements.hasTableBodyContextInTableScope()) {
            p.openElements.clearBackToTableBodyContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
            p._processToken(token);
        }
    }

    else
        startTagInTable(p, token);
}

function endTagInTableBody(p, token) {
    var tn = token.tagName;

    if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.clearBackToTableBodyContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
        }
    }

    else if (tn === $.TABLE) {
        if (p.openElements.hasTableBodyContextInTableScope()) {
            p.openElements.clearBackToTableBodyContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
            p._processToken(token);
        }
    }

    else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP ||
             tn !== $.HTML && tn !== $.TD && tn !== $.TH && tn !== $.TR)
        endTagInTable(p, token);
}

//12.2.5.4.14 The "in row" insertion mode
//------------------------------------------------------------------
function startTagInRow(p, token) {
    var tn = token.tagName;

    if (tn === $.TH || tn === $.TD) {
        p.openElements.clearBackToTableRowContext();
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_CELL_MODE;
        p.activeFormattingElements.insertMarker();
    }

    else if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY ||
             tn === $.TFOOT || tn === $.THEAD || tn === $.TR) {
        if (p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
            p._processToken(token);
        }
    }

    else
        startTagInTable(p, token);
}

function endTagInRow(p, token) {
    var tn = token.tagName;

    if (tn === $.TR) {
        if (p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
        }
    }

    else if (tn === $.TABLE) {
        if (p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
            p._processToken(token);
        }
    }

    else if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
        if (p.openElements.hasInTableScope(tn) || p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
            p._processToken(token);
        }
    }

    else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP ||
             tn !== $.HTML && tn !== $.TD && tn !== $.TH)
        endTagInTable(p, token);
}


//12.2.5.4.15 The "in cell" insertion mode
//------------------------------------------------------------------
function startTagInCell(p, token) {
    var tn = token.tagName;

    if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY ||
        tn === $.TD || tn === $.TFOOT || tn === $.TH || tn === $.THEAD || tn === $.TR) {

        if (p.openElements.hasInTableScope($.TD) || p.openElements.hasInTableScope($.TH)) {
            p._closeTableCell();
            p._processToken(token);
        }
    }

    else
        startTagInBody(p, token);
}

function endTagInCell(p, token) {
    var tn = token.tagName;

    if (tn === $.TD || tn === $.TH) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped(tn);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = IN_ROW_MODE;
        }
    }

    else if (tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR) {
        if (p.openElements.hasInTableScope(tn)) {
            p._closeTableCell();
            p._processToken(token);
        }
    }

    else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML)
        endTagInBody(p, token);
}

//12.2.5.4.16 The "in select" insertion mode
//------------------------------------------------------------------
function startTagInSelect(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.OPTION) {
        if (p.openElements.currentTagName === $.OPTION)
            p.openElements.pop();

        p._insertElement(token, NS.HTML);
    }

    else if (tn === $.OPTGROUP) {
        if (p.openElements.currentTagName === $.OPTION)
            p.openElements.pop();

        if (p.openElements.currentTagName === $.OPTGROUP)
            p.openElements.pop();

        p._insertElement(token, NS.HTML);
    }

    else if (tn === $.INPUT || tn === $.KEYGEN || tn === $.TEXTAREA || tn === $.SELECT) {
        if (p.openElements.hasInSelectScope($.SELECT)) {
            p.openElements.popUntilTagNamePopped($.SELECT);
            p._resetInsertionMode();

            if (tn !== $.SELECT)
                p._processToken(token);
        }
    }

    else if (tn === $.SCRIPT || tn === $.TEMPLATE)
        startTagInHead(p, token);
}

function endTagInSelect(p, token) {
    var tn = token.tagName;

    if (tn === $.OPTGROUP) {
        var prevOpenElement = p.openElements.items[p.openElements.stackTop - 1],
            prevOpenElementTn = prevOpenElement && p.treeAdapter.getTagName(prevOpenElement);

        if (p.openElements.currentTagName === $.OPTION && prevOpenElementTn === $.OPTGROUP)
            p.openElements.pop();

        if (p.openElements.currentTagName === $.OPTGROUP)
            p.openElements.pop();
    }

    else if (tn === $.OPTION) {
        if (p.openElements.currentTagName === $.OPTION)
            p.openElements.pop();
    }

    else if (tn === $.SELECT && p.openElements.hasInSelectScope($.SELECT)) {
        p.openElements.popUntilTagNamePopped($.SELECT);
        p._resetInsertionMode();
    }

    else if (tn === $.TEMPLATE)
        endTagInHead(p, token);
}

//12.2.5.4.17 The "in select in table" insertion mode
//------------------------------------------------------------------
function startTagInSelectInTable(p, token) {
    var tn = token.tagName;

    if (tn === $.CAPTION || tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT ||
        tn === $.THEAD || tn === $.TR || tn === $.TD || tn === $.TH) {
        p.openElements.popUntilTagNamePopped($.SELECT);
        p._resetInsertionMode();
        p._processToken(token);
    }

    else
        startTagInSelect(p, token);
}

function endTagInSelectInTable(p, token) {
    var tn = token.tagName;

    if (tn === $.CAPTION || tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT ||
        tn === $.THEAD || tn === $.TR || tn === $.TD || tn === $.TH) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.popUntilTagNamePopped($.SELECT);
            p._resetInsertionMode();
            p._processToken(token);
        }
    }

    else
        endTagInSelect(p, token);
}

//12.2.5.4.18 The "in template" insertion mode
//------------------------------------------------------------------
function startTagInTemplate(p, token) {
    var tn = token.tagName;

    if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META ||
        tn === $.NOFRAMES || tn === $.SCRIPT || tn === $.STYLE || tn === $.TEMPLATE || tn === $.TITLE)
        startTagInHead(p, token);

    else {
        var newInsertionMode = TEMPLATE_INSERTION_MODE_SWITCH_MAP[tn] || IN_BODY_MODE;

        p._popTmplInsertionMode();
        p._pushTmplInsertionMode(newInsertionMode);
        p.insertionMode = newInsertionMode;
        p._processToken(token);
    }
}

function endTagInTemplate(p, token) {
    if (token.tagName === $.TEMPLATE)
        endTagInHead(p, token);
}

function eofInTemplate(p, token) {
    if (p.openElements.tmplCount > 0) {
        p.openElements.popUntilTagNamePopped($.TEMPLATE);
        p.activeFormattingElements.clearToLastMarker();
        p._popTmplInsertionMode();
        p._resetInsertionMode();
        p._processToken(token);
    }

    else
        p.stopped = true;
}


//12.2.5.4.19 The "after body" insertion mode
//------------------------------------------------------------------
function startTagAfterBody(p, token) {
    if (token.tagName === $.HTML)
        startTagInBody(p, token);

    else
        tokenAfterBody(p, token);
}

function endTagAfterBody(p, token) {
    if (token.tagName === $.HTML) {
        if (!p.fragmentContext)
            p.insertionMode = AFTER_AFTER_BODY_MODE;
    }

    else
        tokenAfterBody(p, token);
}

function tokenAfterBody(p, token) {
    p.insertionMode = IN_BODY_MODE;
    p._processToken(token);
}

//12.2.5.4.20 The "in frameset" insertion mode
//------------------------------------------------------------------
function startTagInFrameset(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.FRAMESET)
        p._insertElement(token, NS.HTML);

    else if (tn === $.FRAME)
        p._appendElement(token, NS.HTML);

    else if (tn === $.NOFRAMES)
        startTagInHead(p, token);
}

function endTagInFrameset(p, token) {
    if (token.tagName === $.FRAMESET && !p.openElements.isRootHtmlElementCurrent()) {
        p.openElements.pop();

        if (!p.fragmentContext && p.openElements.currentTagName !== $.FRAMESET)
            p.insertionMode = AFTER_FRAMESET_MODE;
    }
}

//12.2.5.4.21 The "after frameset" insertion mode
//------------------------------------------------------------------
function startTagAfterFrameset(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.NOFRAMES)
        startTagInHead(p, token);
}

function endTagAfterFrameset(p, token) {
    if (token.tagName === $.HTML)
        p.insertionMode = AFTER_AFTER_FRAMESET_MODE;
}

//12.2.5.4.22 The "after after body" insertion mode
//------------------------------------------------------------------
function startTagAfterAfterBody(p, token) {
    if (token.tagName === $.HTML)
        startTagInBody(p, token);

    else
        tokenAfterAfterBody(p, token);
}

function tokenAfterAfterBody(p, token) {
    p.insertionMode = IN_BODY_MODE;
    p._processToken(token);
}

//12.2.5.4.23 The "after after frameset" insertion mode
//------------------------------------------------------------------
function startTagAfterAfterFrameset(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.NOFRAMES)
        startTagInHead(p, token);
}


//12.2.5.5 The rules for parsing tokens in foreign content
//------------------------------------------------------------------
function nullCharacterInForeignContent(p, token) {
    token.chars = UNICODE.REPLACEMENT_CHARACTER;
    p._insertCharacters(token);
}

function characterInForeignContent(p, token) {
    p._insertCharacters(token);
    p.framesetOk = false;
}

function startTagInForeignContent(p, token) {
    if (foreignContent.causesExit(token) && !p.fragmentContext) {
        while (p.treeAdapter.getNamespaceURI(p.openElements.current) !== NS.HTML && !p._isIntegrationPoint(p.openElements.current))
            p.openElements.pop();

        p._processToken(token);
    }

    else {
        var current = p._getAdjustedCurrentElement(),
            currentNs = p.treeAdapter.getNamespaceURI(current);

        if (currentNs === NS.MATHML)
            foreignContent.adjustTokenMathMLAttrs(token);

        else if (currentNs === NS.SVG) {
            foreignContent.adjustTokenSVGTagName(token);
            foreignContent.adjustTokenSVGAttrs(token);
        }

        foreignContent.adjustTokenXMLAttrs(token);

        if (token.selfClosing)
            p._appendElement(token, currentNs);
        else
            p._insertElement(token, currentNs);
    }
}

function endTagInForeignContent(p, token) {
    for (var i = p.openElements.stackTop; i > 0; i--) {
        var element = p.openElements.items[i];

        if (p.treeAdapter.getNamespaceURI(element) === NS.HTML) {
            p._processToken(token);
            break;
        }

        if (p.treeAdapter.getTagName(element).toLowerCase() === token.tagName) {
            p.openElements.popUntilElementPopped(element);
            break;
        }
    }
}


/***/ }),

/***/ "./node_modules/parse5/lib/parser/open_element_stack.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var HTML = __webpack_require__("./node_modules/parse5/lib/common/html.js");

//Aliases
var $ = HTML.TAG_NAMES,
    NS = HTML.NAMESPACES;

//Element utils

//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function isImpliedEndTagRequired(tn) {
    switch (tn.length) {
        case 1:
            return tn === $.P;

        case 2:
            return tn === $.RB || tn === $.RP || tn === $.RT || tn === $.DD || tn === $.DT || tn === $.LI;

        case 3:
            return tn === $.RTC;

        case 6:
            return tn === $.OPTION;

        case 8:
            return tn === $.OPTGROUP || tn === $.MENUITEM;
    }

    return false;
}

function isScopingElement(tn, ns) {
    switch (tn.length) {
        case 2:
            if (tn === $.TD || tn === $.TH)
                return ns === NS.HTML;

            else if (tn === $.MI || tn === $.MO || tn === $.MN || tn === $.MS)
                return ns === NS.MATHML;

            break;

        case 4:
            if (tn === $.HTML)
                return ns === NS.HTML;

            else if (tn === $.DESC)
                return ns === NS.SVG;

            break;

        case 5:
            if (tn === $.TABLE)
                return ns === NS.HTML;

            else if (tn === $.MTEXT)
                return ns === NS.MATHML;

            else if (tn === $.TITLE)
                return ns === NS.SVG;

            break;

        case 6:
            return (tn === $.APPLET || tn === $.OBJECT) && ns === NS.HTML;

        case 7:
            return (tn === $.CAPTION || tn === $.MARQUEE) && ns === NS.HTML;

        case 8:
            return tn === $.TEMPLATE && ns === NS.HTML;

        case 13:
            return tn === $.FOREIGN_OBJECT && ns === NS.SVG;

        case 14:
            return tn === $.ANNOTATION_XML && ns === NS.MATHML;
    }

    return false;
}

//Stack of open elements
var OpenElementStack = module.exports = function (document, treeAdapter) {
    this.stackTop = -1;
    this.items = [];
    this.current = document;
    this.currentTagName = null;
    this.currentTmplContent = null;
    this.tmplCount = 0;
    this.treeAdapter = treeAdapter;
};

//Index of element
OpenElementStack.prototype._indexOf = function (element) {
    var idx = -1;

    for (var i = this.stackTop; i >= 0; i--) {
        if (this.items[i] === element) {
            idx = i;
            break;
        }
    }
    return idx;
};

//Update current element
OpenElementStack.prototype._isInTemplate = function () {
    return this.currentTagName === $.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === NS.HTML;
};

OpenElementStack.prototype._updateCurrentElement = function () {
    this.current = this.items[this.stackTop];
    this.currentTagName = this.current && this.treeAdapter.getTagName(this.current);

    this.currentTmplContent = this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : null;
};

//Mutations
OpenElementStack.prototype.push = function (element) {
    this.items[++this.stackTop] = element;
    this._updateCurrentElement();

    if (this._isInTemplate())
        this.tmplCount++;

};

OpenElementStack.prototype.pop = function () {
    this.stackTop--;

    if (this.tmplCount > 0 && this._isInTemplate())
        this.tmplCount--;

    this._updateCurrentElement();
};

OpenElementStack.prototype.replace = function (oldElement, newElement) {
    var idx = this._indexOf(oldElement);

    this.items[idx] = newElement;

    if (idx === this.stackTop)
        this._updateCurrentElement();
};

OpenElementStack.prototype.insertAfter = function (referenceElement, newElement) {
    var insertionIdx = this._indexOf(referenceElement) + 1;

    this.items.splice(insertionIdx, 0, newElement);

    if (insertionIdx === ++this.stackTop)
        this._updateCurrentElement();
};

OpenElementStack.prototype.popUntilTagNamePopped = function (tagName) {
    while (this.stackTop > -1) {
        var tn = this.currentTagName,
            ns = this.treeAdapter.getNamespaceURI(this.current);

        this.pop();

        if (tn === tagName && ns === NS.HTML)
            break;
    }
};

OpenElementStack.prototype.popUntilElementPopped = function (element) {
    while (this.stackTop > -1) {
        var poppedElement = this.current;

        this.pop();

        if (poppedElement === element)
            break;
    }
};

OpenElementStack.prototype.popUntilNumberedHeaderPopped = function () {
    while (this.stackTop > -1) {
        var tn = this.currentTagName,
            ns = this.treeAdapter.getNamespaceURI(this.current);

        this.pop();

        if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6 && ns === NS.HTML)
            break;
    }
};

OpenElementStack.prototype.popUntilTableCellPopped = function () {
    while (this.stackTop > -1) {
        var tn = this.currentTagName,
            ns = this.treeAdapter.getNamespaceURI(this.current);

        this.pop();

        if (tn === $.TD || tn === $.TH && ns === NS.HTML)
            break;
    }
};

OpenElementStack.prototype.popAllUpToHtmlElement = function () {
    //NOTE: here we assume that root <html> element is always first in the open element stack, so
    //we perform this fast stack clean up.
    this.stackTop = 0;
    this._updateCurrentElement();
};

OpenElementStack.prototype.clearBackToTableContext = function () {
    while (this.currentTagName !== $.TABLE &&
           this.currentTagName !== $.TEMPLATE &&
           this.currentTagName !== $.HTML ||
           this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML)
        this.pop();
};

OpenElementStack.prototype.clearBackToTableBodyContext = function () {
    while (this.currentTagName !== $.TBODY &&
           this.currentTagName !== $.TFOOT &&
           this.currentTagName !== $.THEAD &&
           this.currentTagName !== $.TEMPLATE &&
           this.currentTagName !== $.HTML ||
           this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML)
        this.pop();
};

OpenElementStack.prototype.clearBackToTableRowContext = function () {
    while (this.currentTagName !== $.TR &&
           this.currentTagName !== $.TEMPLATE &&
           this.currentTagName !== $.HTML ||
           this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML)
        this.pop();
};

OpenElementStack.prototype.remove = function (element) {
    for (var i = this.stackTop; i >= 0; i--) {
        if (this.items[i] === element) {
            this.items.splice(i, 1);
            this.stackTop--;
            this._updateCurrentElement();
            break;
        }
    }
};

//Search
OpenElementStack.prototype.tryPeekProperlyNestedBodyElement = function () {
    //Properly nested <body> element (should be second element in stack).
    var element = this.items[1];

    return element && this.treeAdapter.getTagName(element) === $.BODY ? element : null;
};

OpenElementStack.prototype.contains = function (element) {
    return this._indexOf(element) > -1;
};

OpenElementStack.prototype.getCommonAncestor = function (element) {
    var elementIdx = this._indexOf(element);

    return --elementIdx >= 0 ? this.items[elementIdx] : null;
};

OpenElementStack.prototype.isRootHtmlElementCurrent = function () {
    return this.stackTop === 0 && this.currentTagName === $.HTML;
};

//Element in scope
OpenElementStack.prototype.hasInScope = function (tagName) {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (tn === tagName && ns === NS.HTML)
            return true;

        if (isScopingElement(tn, ns))
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasNumberedHeaderInScope = function () {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if ((tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6) && ns === NS.HTML)
            return true;

        if (isScopingElement(tn, ns))
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasInListItemScope = function (tagName) {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (tn === tagName && ns === NS.HTML)
            return true;

        if ((tn === $.UL || tn === $.OL) && ns === NS.HTML || isScopingElement(tn, ns))
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasInButtonScope = function (tagName) {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (tn === tagName && ns === NS.HTML)
            return true;

        if (tn === $.BUTTON && ns === NS.HTML || isScopingElement(tn, ns))
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasInTableScope = function (tagName) {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (ns !== NS.HTML)
            continue;

        if (tn === tagName)
            return true;

        if (tn === $.TABLE || tn === $.TEMPLATE || tn === $.HTML)
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasTableBodyContextInTableScope = function () {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (ns !== NS.HTML)
            continue;

        if (tn === $.TBODY || tn === $.THEAD || tn === $.TFOOT)
            return true;

        if (tn === $.TABLE || tn === $.HTML)
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasInSelectScope = function (tagName) {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (ns !== NS.HTML)
            continue;

        if (tn === tagName)
            return true;

        if (tn !== $.OPTION && tn !== $.OPTGROUP)
            return false;
    }

    return true;
};

//Implied end tags
OpenElementStack.prototype.generateImpliedEndTags = function () {
    while (isImpliedEndTagRequired(this.currentTagName))
        this.pop();
};

OpenElementStack.prototype.generateImpliedEndTagsWithExclusion = function (exclusionTagName) {
    while (isImpliedEndTagRequired(this.currentTagName) && this.currentTagName !== exclusionTagName)
        this.pop();
};


/***/ }),

/***/ "./node_modules/parse5/lib/parser/parser_stream.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var WritableStream = __webpack_require__("./node_modules/stream-browserify/index.js").Writable,
    inherits = __webpack_require__("./node_modules/util/util.js").inherits,
    Parser = __webpack_require__("./node_modules/parse5/lib/parser/index.js");

var ParserStream = module.exports = function (options) {
    WritableStream.call(this);

    this.parser = new Parser(options);

    this.lastChunkWritten = false;
    this.writeCallback = null;
    this.pausedByScript = false;

    this.document = this.parser.treeAdapter.createDocument();

    this.pendingHtmlInsertions = [];

    this._resume = this._resume.bind(this);
    this._documentWrite = this._documentWrite.bind(this);
    this._scriptHandler = this._scriptHandler.bind(this);

    this.parser._bootstrap(this.document, null);
};

inherits(ParserStream, WritableStream);

//WritableStream implementation
ParserStream.prototype._write = function (chunk, encoding, callback) {
    this.writeCallback = callback;
    this.parser.tokenizer.write(chunk.toString('utf8'), this.lastChunkWritten);
    this._runParsingLoop();
};

ParserStream.prototype.end = function (chunk, encoding, callback) {
    this.lastChunkWritten = true;
    WritableStream.prototype.end.call(this, chunk || '', encoding, callback);
};

//Scriptable parser implementation
ParserStream.prototype._runParsingLoop = function () {
    this.parser.runParsingLoopForCurrentChunk(this.writeCallback, this._scriptHandler);
};

ParserStream.prototype._resume = function () {
    if (!this.pausedByScript)
        throw new Error('Parser was already resumed');

    while (this.pendingHtmlInsertions.length) {
        var html = this.pendingHtmlInsertions.pop();

        this.parser.tokenizer.insertHtmlAtCurrentPos(html);
    }

    this.pausedByScript = false;

    //NOTE: keep parsing if we don't wait for the next input chunk
    if (this.parser.tokenizer.active)
        this._runParsingLoop();
};

ParserStream.prototype._documentWrite = function (html) {
    if (!this.parser.stopped)
        this.pendingHtmlInsertions.push(html);
};

ParserStream.prototype._scriptHandler = function (scriptElement) {
    if (this.listeners('script').length) {
        this.pausedByScript = true;
        this.emit('script', scriptElement, this._documentWrite, this._resume);
    }
    else
        this._runParsingLoop();
};



/***/ }),

/***/ "./node_modules/parse5/lib/parser/plain_text_conversion_stream.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ParserStream = __webpack_require__("./node_modules/parse5/lib/parser/parser_stream.js"),
    inherits = __webpack_require__("./node_modules/util/util.js").inherits,
    $ = __webpack_require__("./node_modules/parse5/lib/common/html.js").TAG_NAMES;

var PlainTextConversionStream = module.exports = function (options) {
    ParserStream.call(this, options);

    // NOTE: see https://html.spec.whatwg.org/#read-text
    this.parser._insertFakeElement($.HTML);
    this.parser._insertFakeElement($.HEAD);
    this.parser.openElements.pop();
    this.parser._insertFakeElement($.BODY);
    this.parser._insertFakeElement($.PRE);
    this.parser.treeAdapter.insertText(this.parser.openElements.current, '\n');
    this.parser.switchToPlaintextParsing();
};

inherits(PlainTextConversionStream, ParserStream);


/***/ }),

/***/ "./node_modules/parse5/lib/sax/dev_null_stream.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var WritableStream = __webpack_require__("./node_modules/stream-browserify/index.js").Writable,
    util = __webpack_require__("./node_modules/util/util.js");

var DevNullStream = module.exports = function () {
    WritableStream.call(this);
};

util.inherits(DevNullStream, WritableStream);

DevNullStream.prototype._write = function (chunk, encoding, cb) {
    cb();
};


/***/ }),

/***/ "./node_modules/parse5/lib/sax/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var TransformStream = __webpack_require__("./node_modules/stream-browserify/index.js").Transform,
    DevNullStream = __webpack_require__("./node_modules/parse5/lib/sax/dev_null_stream.js"),
    inherits = __webpack_require__("./node_modules/util/util.js").inherits,
    Tokenizer = __webpack_require__("./node_modules/parse5/lib/tokenizer/index.js"),
    LocationInfoTokenizerMixin = __webpack_require__("./node_modules/parse5/lib/extensions/location_info/tokenizer_mixin.js"),
    ParserFeedbackSimulator = __webpack_require__("./node_modules/parse5/lib/sax/parser_feedback_simulator.js"),
    mergeOptions = __webpack_require__("./node_modules/parse5/lib/utils/merge_options.js");

var DEFAULT_OPTIONS = {
    locationInfo: false
};

var SAXParser = module.exports = function (options) {
    TransformStream.call(this);

    this.options = mergeOptions(DEFAULT_OPTIONS, options);

    this.tokenizer = new Tokenizer(options);

    if (this.options.locationInfo)
        new LocationInfoTokenizerMixin(this.tokenizer);

    this.parserFeedbackSimulator = new ParserFeedbackSimulator(this.tokenizer);

    this.pendingText = null;
    this.currentTokenLocation = void 0;

    this.lastChunkWritten = false;
    this.stopped = false;

    // NOTE: always pipe stream to the /dev/null stream to avoid
    // `highWaterMark` hit even if we don't have consumers.
    // (see: https://github.com/inikulin/parse5/issues/97#issuecomment-171940774)
    this.pipe(new DevNullStream());
};

inherits(SAXParser, TransformStream);

//TransformStream implementation
SAXParser.prototype._transform = function (chunk, encoding, callback) {
    if (!this.stopped) {
        this.tokenizer.write(chunk.toString('utf8'), this.lastChunkWritten);
        this._runParsingLoop();
    }

    this.push(chunk);

    callback();
};

SAXParser.prototype._flush = function (callback) {
    callback();
};

SAXParser.prototype.end = function (chunk, encoding, callback) {
    this.lastChunkWritten = true;
    TransformStream.prototype.end.call(this, chunk, encoding, callback);
};

SAXParser.prototype.stop = function () {
    this.stopped = true;
};

//Internals
SAXParser.prototype._runParsingLoop = function () {
    do {
        var token = this.parserFeedbackSimulator.getNextToken();

        if (token.type === Tokenizer.HIBERNATION_TOKEN)
            break;

        if (token.type === Tokenizer.CHARACTER_TOKEN ||
            token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN ||
            token.type === Tokenizer.NULL_CHARACTER_TOKEN) {

            if (this.options.locationInfo) {
                if (this.pendingText === null)
                    this.currentTokenLocation = token.location;

                else
                    this.currentTokenLocation.endOffset = token.location.endOffset;
            }

            this.pendingText = (this.pendingText || '') + token.chars;
        }

        else {
            this._emitPendingText();
            this._handleToken(token);
        }
    } while (!this.stopped && token.type !== Tokenizer.EOF_TOKEN);
};

SAXParser.prototype._handleToken = function (token) {
    if (this.options.locationInfo)
        this.currentTokenLocation = token.location;

    if (token.type === Tokenizer.START_TAG_TOKEN)
        this.emit('startTag', token.tagName, token.attrs, token.selfClosing, this.currentTokenLocation);

    else if (token.type === Tokenizer.END_TAG_TOKEN)
        this.emit('endTag', token.tagName, this.currentTokenLocation);

    else if (token.type === Tokenizer.COMMENT_TOKEN)
        this.emit('comment', token.data, this.currentTokenLocation);

    else if (token.type === Tokenizer.DOCTYPE_TOKEN)
        this.emit('doctype', token.name, token.publicId, token.systemId, this.currentTokenLocation);
};

SAXParser.prototype._emitPendingText = function () {
    if (this.pendingText !== null) {
        this.emit('text', this.pendingText, this.currentTokenLocation);
        this.pendingText = null;
    }
};


/***/ }),

/***/ "./node_modules/parse5/lib/sax/parser_feedback_simulator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Tokenizer = __webpack_require__("./node_modules/parse5/lib/tokenizer/index.js"),
    foreignContent = __webpack_require__("./node_modules/parse5/lib/common/foreign_content.js"),
    UNICODE = __webpack_require__("./node_modules/parse5/lib/common/unicode.js"),
    HTML = __webpack_require__("./node_modules/parse5/lib/common/html.js");


//Aliases
var $ = HTML.TAG_NAMES,
    NS = HTML.NAMESPACES;


//ParserFeedbackSimulator
//Simulates adjustment of the Tokenizer which performed by standard parser during tree construction.
var ParserFeedbackSimulator = module.exports = function (tokenizer) {
    this.tokenizer = tokenizer;

    this.namespaceStack = [];
    this.namespaceStackTop = -1;
    this._enterNamespace(NS.HTML);
};

ParserFeedbackSimulator.prototype.getNextToken = function () {
    var token = this.tokenizer.getNextToken();

    if (token.type === Tokenizer.START_TAG_TOKEN)
        this._handleStartTagToken(token);

    else if (token.type === Tokenizer.END_TAG_TOKEN)
        this._handleEndTagToken(token);

    else if (token.type === Tokenizer.NULL_CHARACTER_TOKEN && this.inForeignContent) {
        token.type = Tokenizer.CHARACTER_TOKEN;
        token.chars = UNICODE.REPLACEMENT_CHARACTER;
    }

    else if (this.skipNextNewLine) {
        if (token.type !== Tokenizer.HIBERNATION_TOKEN)
            this.skipNextNewLine = false;

        if (token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN && token.chars[0] === '\n') {
            if (token.chars.length === 1)
                return this.getNextToken();

            token.chars = token.chars.substr(1);
        }
    }

    return token;
};

//Namespace stack mutations
ParserFeedbackSimulator.prototype._enterNamespace = function (namespace) {
    this.namespaceStackTop++;
    this.namespaceStack.push(namespace);

    this.inForeignContent = namespace !== NS.HTML;
    this.currentNamespace = namespace;
    this.tokenizer.allowCDATA = this.inForeignContent;
};

ParserFeedbackSimulator.prototype._leaveCurrentNamespace = function () {
    this.namespaceStackTop--;
    this.namespaceStack.pop();

    this.currentNamespace = this.namespaceStack[this.namespaceStackTop];
    this.inForeignContent = this.currentNamespace !== NS.HTML;
    this.tokenizer.allowCDATA = this.inForeignContent;
};

//Token handlers
ParserFeedbackSimulator.prototype._ensureTokenizerMode = function (tn) {
    if (tn === $.TEXTAREA || tn === $.TITLE)
        this.tokenizer.state = Tokenizer.MODE.RCDATA;

    else if (tn === $.PLAINTEXT)
        this.tokenizer.state = Tokenizer.MODE.PLAINTEXT;

    else if (tn === $.SCRIPT)
        this.tokenizer.state = Tokenizer.MODE.SCRIPT_DATA;

    else if (tn === $.STYLE || tn === $.IFRAME || tn === $.XMP ||
             tn === $.NOEMBED || tn === $.NOFRAMES || tn === $.NOSCRIPT)
        this.tokenizer.state = Tokenizer.MODE.RAWTEXT;
};

ParserFeedbackSimulator.prototype._handleStartTagToken = function (token) {
    var tn = token.tagName;

    if (tn === $.SVG)
        this._enterNamespace(NS.SVG);

    else if (tn === $.MATH)
        this._enterNamespace(NS.MATHML);

    if (this.inForeignContent) {
        if (foreignContent.causesExit(token)) {
            this._leaveCurrentNamespace();
            return;
        }

        var currentNs = this.currentNamespace;

        if (currentNs === NS.MATHML)
            foreignContent.adjustTokenMathMLAttrs(token);

        else if (currentNs === NS.SVG) {
            foreignContent.adjustTokenSVGTagName(token);
            foreignContent.adjustTokenSVGAttrs(token);
        }

        foreignContent.adjustTokenXMLAttrs(token);

        tn = token.tagName;

        if (!token.selfClosing && foreignContent.isIntegrationPoint(tn, currentNs, token.attrs))
            this._enterNamespace(NS.HTML);
    }

    else {
        if (tn === $.PRE || tn === $.TEXTAREA || tn === $.LISTING)
            this.skipNextNewLine = true;

        else if (tn === $.IMAGE)
            token.tagName = $.IMG;

        this._ensureTokenizerMode(tn);
    }
};

ParserFeedbackSimulator.prototype._handleEndTagToken = function (token) {
    var tn = token.tagName;

    if (!this.inForeignContent) {
        var previousNs = this.namespaceStack[this.namespaceStackTop - 1];

        if (previousNs === NS.SVG && foreignContent.SVG_TAG_NAMES_ADJUSTMENT_MAP[tn])
            tn = foreignContent.SVG_TAG_NAMES_ADJUSTMENT_MAP[tn];

        //NOTE: check for exit from integration point
        if (foreignContent.isIntegrationPoint(tn, previousNs, token.attrs))
            this._leaveCurrentNamespace();
    }

    else if (tn === $.SVG && this.currentNamespace === NS.SVG ||
             tn === $.MATH && this.currentNamespace === NS.MATHML)
        this._leaveCurrentNamespace();

    // NOTE: adjust end tag name as well for consistency
    if (this.currentNamespace === NS.SVG)
        foreignContent.adjustTokenSVGTagName(token);
};


/***/ }),

/***/ "./node_modules/parse5/lib/serializer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaultTreeAdapter = __webpack_require__("./node_modules/parse5/lib/tree_adapters/default.js"),
    mergeOptions = __webpack_require__("./node_modules/parse5/lib/utils/merge_options.js"),
    doctype = __webpack_require__("./node_modules/parse5/lib/common/doctype.js"),
    HTML = __webpack_require__("./node_modules/parse5/lib/common/html.js");

//Aliases
var $ = HTML.TAG_NAMES,
    NS = HTML.NAMESPACES;

//Default serializer options
var DEFAULT_OPTIONS = {
    treeAdapter: defaultTreeAdapter
};

//Escaping regexes
var AMP_REGEX = /&/g,
    NBSP_REGEX = /\u00a0/g,
    DOUBLE_QUOTE_REGEX = /"/g,
    LT_REGEX = /</g,
    GT_REGEX = />/g;

//Serializer
var Serializer = module.exports = function (node, options) {
    this.options = mergeOptions(DEFAULT_OPTIONS, options);
    this.treeAdapter = this.options.treeAdapter;

    this.html = '';
    this.startNode = node;
};

// NOTE: exported as static method for the testing purposes
Serializer.escapeString = function (str, attrMode) {
    str = str
        .replace(AMP_REGEX, '&amp;')
        .replace(NBSP_REGEX, '&nbsp;');

    if (attrMode)
        str = str.replace(DOUBLE_QUOTE_REGEX, '&quot;');

    else {
        str = str
            .replace(LT_REGEX, '&lt;')
            .replace(GT_REGEX, '&gt;');
    }

    return str;
};


//API
Serializer.prototype.serialize = function () {
    this._serializeChildNodes(this.startNode);

    return this.html;
};


//Internals
Serializer.prototype._serializeChildNodes = function (parentNode) {
    var childNodes = this.treeAdapter.getChildNodes(parentNode);

    if (childNodes) {
        for (var i = 0, cnLength = childNodes.length; i < cnLength; i++) {
            var currentNode = childNodes[i];

            if (this.treeAdapter.isElementNode(currentNode))
                this._serializeElement(currentNode);

            else if (this.treeAdapter.isTextNode(currentNode))
                this._serializeTextNode(currentNode);

            else if (this.treeAdapter.isCommentNode(currentNode))
                this._serializeCommentNode(currentNode);

            else if (this.treeAdapter.isDocumentTypeNode(currentNode))
                this._serializeDocumentTypeNode(currentNode);
        }
    }
};

Serializer.prototype._serializeElement = function (node) {
    var tn = this.treeAdapter.getTagName(node),
        ns = this.treeAdapter.getNamespaceURI(node);

    this.html += '<' + tn;
    this._serializeAttributes(node);
    this.html += '>';

    if (tn !== $.AREA && tn !== $.BASE && tn !== $.BASEFONT && tn !== $.BGSOUND && tn !== $.BR && tn !== $.BR &&
        tn !== $.COL && tn !== $.EMBED && tn !== $.FRAME && tn !== $.HR && tn !== $.IMG && tn !== $.INPUT &&
        tn !== $.KEYGEN && tn !== $.LINK && tn !== $.MENUITEM && tn !== $.META && tn !== $.PARAM && tn !== $.SOURCE &&
        tn !== $.TRACK && tn !== $.WBR) {

        var childNodesHolder = tn === $.TEMPLATE && ns === NS.HTML ?
            this.treeAdapter.getTemplateContent(node) :
            node;

        this._serializeChildNodes(childNodesHolder);
        this.html += '</' + tn + '>';
    }
};

Serializer.prototype._serializeAttributes = function (node) {
    var attrs = this.treeAdapter.getAttrList(node);

    for (var i = 0, attrsLength = attrs.length; i < attrsLength; i++) {
        var attr = attrs[i],
            value = Serializer.escapeString(attr.value, true);

        this.html += ' ';

        if (!attr.namespace)
            this.html += attr.name;

        else if (attr.namespace === NS.XML)
            this.html += 'xml:' + attr.name;

        else if (attr.namespace === NS.XMLNS) {
            if (attr.name !== 'xmlns')
                this.html += 'xmlns:';

            this.html += attr.name;
        }

        else if (attr.namespace === NS.XLINK)
            this.html += 'xlink:' + attr.name;

        else
            this.html += attr.namespace + ':' + attr.name;

        this.html += '="' + value + '"';
    }
};

Serializer.prototype._serializeTextNode = function (node) {
    var content = this.treeAdapter.getTextNodeContent(node),
        parent = this.treeAdapter.getParentNode(node),
        parentTn = void 0;

    if (parent && this.treeAdapter.isElementNode(parent))
        parentTn = this.treeAdapter.getTagName(parent);

    if (parentTn === $.STYLE || parentTn === $.SCRIPT || parentTn === $.XMP || parentTn === $.IFRAME ||
        parentTn === $.NOEMBED || parentTn === $.NOFRAMES || parentTn === $.PLAINTEXT || parentTn === $.NOSCRIPT)

        this.html += content;

    else
        this.html += Serializer.escapeString(content, false);
};

Serializer.prototype._serializeCommentNode = function (node) {
    this.html += '<!--' + this.treeAdapter.getCommentNodeContent(node) + '-->';
};

Serializer.prototype._serializeDocumentTypeNode = function (node) {
    var name = this.treeAdapter.getDocumentTypeNodeName(node);

    this.html += '<' + doctype.serializeContent(name, null, null) + '>';
};


/***/ }),

/***/ "./node_modules/parse5/lib/serializer/serializer_stream.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ReadableStream = __webpack_require__("./node_modules/stream-browserify/index.js").Readable,
    inherits = __webpack_require__("./node_modules/util/util.js").inherits,
    Serializer = __webpack_require__("./node_modules/parse5/lib/serializer/index.js");

var SerializerStream = module.exports = function (node, options) {
    ReadableStream.call(this);

    this.serializer = new Serializer(node, options);

    Object.defineProperty(this.serializer, 'html', {
        //NOTE: To make `+=` concat operator work properly we define
        //getter which always returns empty string
        get: function () {
            return '';
        },
        set: this.push.bind(this)
    });
};

inherits(SerializerStream, ReadableStream);

//Readable stream implementation
SerializerStream.prototype._read = function () {
    this.serializer.serialize();
    this.push(null);
};


/***/ }),

/***/ "./node_modules/parse5/lib/tokenizer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Preprocessor = __webpack_require__("./node_modules/parse5/lib/tokenizer/preprocessor.js"),
    UNICODE = __webpack_require__("./node_modules/parse5/lib/common/unicode.js"),
    neTree = __webpack_require__("./node_modules/parse5/lib/tokenizer/named_entity_data.js");

//Aliases
var $ = UNICODE.CODE_POINTS,
    $$ = UNICODE.CODE_POINT_SEQUENCES;

//Replacement code points for numeric entities
var NUMERIC_ENTITY_REPLACEMENTS = {
    0x00: 0xFFFD, 0x0D: 0x000D, 0x80: 0x20AC, 0x81: 0x0081, 0x82: 0x201A, 0x83: 0x0192, 0x84: 0x201E,
    0x85: 0x2026, 0x86: 0x2020, 0x87: 0x2021, 0x88: 0x02C6, 0x89: 0x2030, 0x8A: 0x0160, 0x8B: 0x2039,
    0x8C: 0x0152, 0x8D: 0x008D, 0x8E: 0x017D, 0x8F: 0x008F, 0x90: 0x0090, 0x91: 0x2018, 0x92: 0x2019,
    0x93: 0x201C, 0x94: 0x201D, 0x95: 0x2022, 0x96: 0x2013, 0x97: 0x2014, 0x98: 0x02DC, 0x99: 0x2122,
    0x9A: 0x0161, 0x9B: 0x203A, 0x9C: 0x0153, 0x9D: 0x009D, 0x9E: 0x017E, 0x9F: 0x0178
};

// Named entity tree flags
var HAS_DATA_FLAG = 1 << 0;
var DATA_DUPLET_FLAG = 1 << 1;
var HAS_BRANCHES_FLAG = 1 << 2;
var MAX_BRANCH_MARKER_VALUE = HAS_DATA_FLAG | DATA_DUPLET_FLAG | HAS_BRANCHES_FLAG;


//States
var DATA_STATE = 'DATA_STATE',
    CHARACTER_REFERENCE_IN_DATA_STATE = 'CHARACTER_REFERENCE_IN_DATA_STATE',
    RCDATA_STATE = 'RCDATA_STATE',
    CHARACTER_REFERENCE_IN_RCDATA_STATE = 'CHARACTER_REFERENCE_IN_RCDATA_STATE',
    RAWTEXT_STATE = 'RAWTEXT_STATE',
    SCRIPT_DATA_STATE = 'SCRIPT_DATA_STATE',
    PLAINTEXT_STATE = 'PLAINTEXT_STATE',
    TAG_OPEN_STATE = 'TAG_OPEN_STATE',
    END_TAG_OPEN_STATE = 'END_TAG_OPEN_STATE',
    TAG_NAME_STATE = 'TAG_NAME_STATE',
    RCDATA_LESS_THAN_SIGN_STATE = 'RCDATA_LESS_THAN_SIGN_STATE',
    RCDATA_END_TAG_OPEN_STATE = 'RCDATA_END_TAG_OPEN_STATE',
    RCDATA_END_TAG_NAME_STATE = 'RCDATA_END_TAG_NAME_STATE',
    RAWTEXT_LESS_THAN_SIGN_STATE = 'RAWTEXT_LESS_THAN_SIGN_STATE',
    RAWTEXT_END_TAG_OPEN_STATE = 'RAWTEXT_END_TAG_OPEN_STATE',
    RAWTEXT_END_TAG_NAME_STATE = 'RAWTEXT_END_TAG_NAME_STATE',
    SCRIPT_DATA_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_LESS_THAN_SIGN_STATE',
    SCRIPT_DATA_END_TAG_OPEN_STATE = 'SCRIPT_DATA_END_TAG_OPEN_STATE',
    SCRIPT_DATA_END_TAG_NAME_STATE = 'SCRIPT_DATA_END_TAG_NAME_STATE',
    SCRIPT_DATA_ESCAPE_START_STATE = 'SCRIPT_DATA_ESCAPE_START_STATE',
    SCRIPT_DATA_ESCAPE_START_DASH_STATE = 'SCRIPT_DATA_ESCAPE_START_DASH_STATE',
    SCRIPT_DATA_ESCAPED_STATE = 'SCRIPT_DATA_ESCAPED_STATE',
    SCRIPT_DATA_ESCAPED_DASH_STATE = 'SCRIPT_DATA_ESCAPED_DASH_STATE',
    SCRIPT_DATA_ESCAPED_DASH_DASH_STATE = 'SCRIPT_DATA_ESCAPED_DASH_DASH_STATE',
    SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE',
    SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE = 'SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE',
    SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE = 'SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPED_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE',
    BEFORE_ATTRIBUTE_NAME_STATE = 'BEFORE_ATTRIBUTE_NAME_STATE',
    ATTRIBUTE_NAME_STATE = 'ATTRIBUTE_NAME_STATE',
    AFTER_ATTRIBUTE_NAME_STATE = 'AFTER_ATTRIBUTE_NAME_STATE',
    BEFORE_ATTRIBUTE_VALUE_STATE = 'BEFORE_ATTRIBUTE_VALUE_STATE',
    ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE = 'ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE',
    ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE = 'ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE',
    ATTRIBUTE_VALUE_UNQUOTED_STATE = 'ATTRIBUTE_VALUE_UNQUOTED_STATE',
    CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE = 'CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE',
    AFTER_ATTRIBUTE_VALUE_QUOTED_STATE = 'AFTER_ATTRIBUTE_VALUE_QUOTED_STATE',
    SELF_CLOSING_START_TAG_STATE = 'SELF_CLOSING_START_TAG_STATE',
    BOGUS_COMMENT_STATE = 'BOGUS_COMMENT_STATE',
    BOGUS_COMMENT_STATE_CONTINUATION = 'BOGUS_COMMENT_STATE_CONTINUATION',
    MARKUP_DECLARATION_OPEN_STATE = 'MARKUP_DECLARATION_OPEN_STATE',
    COMMENT_START_STATE = 'COMMENT_START_STATE',
    COMMENT_START_DASH_STATE = 'COMMENT_START_DASH_STATE',
    COMMENT_STATE = 'COMMENT_STATE',
    COMMENT_END_DASH_STATE = 'COMMENT_END_DASH_STATE',
    COMMENT_END_STATE = 'COMMENT_END_STATE',
    COMMENT_END_BANG_STATE = 'COMMENT_END_BANG_STATE',
    DOCTYPE_STATE = 'DOCTYPE_STATE',
    DOCTYPE_NAME_STATE = 'DOCTYPE_NAME_STATE',
    AFTER_DOCTYPE_NAME_STATE = 'AFTER_DOCTYPE_NAME_STATE',
    BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE = 'BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE',
    DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE = 'DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE',
    DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE = 'DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE',
    BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE = 'BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE',
    BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE = 'BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE',
    DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE = 'DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE',
    DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE = 'DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE',
    AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE = 'AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE',
    BOGUS_DOCTYPE_STATE = 'BOGUS_DOCTYPE_STATE',
    CDATA_SECTION_STATE = 'CDATA_SECTION_STATE';

//Utils

//OPTIMIZATION: these utility functions should not be moved out of this module. V8 Crankshaft will not inline
//this functions if they will be situated in another module due to context switch.
//Always perform inlining check before modifying this functions ('node --trace-inlining').
function isWhitespace(cp) {
    return cp === $.SPACE || cp === $.LINE_FEED || cp === $.TABULATION || cp === $.FORM_FEED;
}

function isAsciiDigit(cp) {
    return cp >= $.DIGIT_0 && cp <= $.DIGIT_9;
}

function isAsciiUpper(cp) {
    return cp >= $.LATIN_CAPITAL_A && cp <= $.LATIN_CAPITAL_Z;
}

function isAsciiLower(cp) {
    return cp >= $.LATIN_SMALL_A && cp <= $.LATIN_SMALL_Z;
}

function isAsciiLetter(cp) {
    return isAsciiLower(cp) || isAsciiUpper(cp);
}

function isAsciiAlphaNumeric(cp) {
    return isAsciiLetter(cp) || isAsciiDigit(cp);
}

function isDigit(cp, isHex) {
    return isAsciiDigit(cp) || isHex && (cp >= $.LATIN_CAPITAL_A && cp <= $.LATIN_CAPITAL_F ||
                                         cp >= $.LATIN_SMALL_A && cp <= $.LATIN_SMALL_F);
}

function isReservedCodePoint(cp) {
    return cp >= 0xD800 && cp <= 0xDFFF || cp > 0x10FFFF;
}

function toAsciiLowerCodePoint(cp) {
    return cp + 0x0020;
}

//NOTE: String.fromCharCode() function can handle only characters from BMP subset.
//So, we need to workaround this manually.
//(see: https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/String/fromCharCode#Getting_it_to_work_with_higher_values)
function toChar(cp) {
    if (cp <= 0xFFFF)
        return String.fromCharCode(cp);

    cp -= 0x10000;
    return String.fromCharCode(cp >>> 10 & 0x3FF | 0xD800) + String.fromCharCode(0xDC00 | cp & 0x3FF);
}

function toAsciiLowerChar(cp) {
    return String.fromCharCode(toAsciiLowerCodePoint(cp));
}

function findNamedEntityTreeBranch(nodeIx, cp) {
    var branchCount = neTree[++nodeIx],
        lo = ++nodeIx,
        hi = lo + branchCount - 1;

    while (lo <= hi) {
        var mid = lo + hi >>> 1,
            midCp = neTree[mid];

        if (midCp < cp)
            lo = mid + 1;

        else if (midCp > cp)
            hi = mid - 1;

        else
            return neTree[mid + branchCount];
    }

    return -1;
}


//Tokenizer
var Tokenizer = module.exports = function () {
    this.preprocessor = new Preprocessor();

    this.tokenQueue = [];

    this.allowCDATA = false;

    this.state = DATA_STATE;
    this.returnState = '';

    this.tempBuff = [];
    this.additionalAllowedCp = void 0;
    this.lastStartTagName = '';

    this.consumedAfterSnapshot = -1;
    this.active = false;

    this.currentCharacterToken = null;
    this.currentToken = null;
    this.currentAttr = null;
};

//Token types
Tokenizer.CHARACTER_TOKEN = 'CHARACTER_TOKEN';
Tokenizer.NULL_CHARACTER_TOKEN = 'NULL_CHARACTER_TOKEN';
Tokenizer.WHITESPACE_CHARACTER_TOKEN = 'WHITESPACE_CHARACTER_TOKEN';
Tokenizer.START_TAG_TOKEN = 'START_TAG_TOKEN';
Tokenizer.END_TAG_TOKEN = 'END_TAG_TOKEN';
Tokenizer.COMMENT_TOKEN = 'COMMENT_TOKEN';
Tokenizer.DOCTYPE_TOKEN = 'DOCTYPE_TOKEN';
Tokenizer.EOF_TOKEN = 'EOF_TOKEN';
Tokenizer.HIBERNATION_TOKEN = 'HIBERNATION_TOKEN';

//Tokenizer initial states for different modes
Tokenizer.MODE = {
    DATA: DATA_STATE,
    RCDATA: RCDATA_STATE,
    RAWTEXT: RAWTEXT_STATE,
    SCRIPT_DATA: SCRIPT_DATA_STATE,
    PLAINTEXT: PLAINTEXT_STATE
};

//Static
Tokenizer.getTokenAttr = function (token, attrName) {
    for (var i = token.attrs.length - 1; i >= 0; i--) {
        if (token.attrs[i].name === attrName)
            return token.attrs[i].value;
    }

    return null;
};

//API
Tokenizer.prototype.getNextToken = function () {
    while (!this.tokenQueue.length && this.active) {
        this._hibernationSnapshot();

        var cp = this._consume();

        if (!this._ensureHibernation())
            this[this.state](cp);
    }

    return this.tokenQueue.shift();
};

Tokenizer.prototype.write = function (chunk, isLastChunk) {
    this.active = true;
    this.preprocessor.write(chunk, isLastChunk);
};

Tokenizer.prototype.insertHtmlAtCurrentPos = function (chunk) {
    this.active = true;
    this.preprocessor.insertHtmlAtCurrentPos(chunk);
};

//Hibernation
Tokenizer.prototype._hibernationSnapshot = function () {
    this.consumedAfterSnapshot = 0;
};

Tokenizer.prototype._ensureHibernation = function () {
    if (this.preprocessor.endOfChunkHit) {
        for (; this.consumedAfterSnapshot > 0; this.consumedAfterSnapshot--)
            this.preprocessor.retreat();

        this.active = false;
        this.tokenQueue.push({type: Tokenizer.HIBERNATION_TOKEN});

        return true;
    }

    return false;
};


//Consumption
Tokenizer.prototype._consume = function () {
    this.consumedAfterSnapshot++;
    return this.preprocessor.advance();
};

Tokenizer.prototype._unconsume = function () {
    this.consumedAfterSnapshot--;
    this.preprocessor.retreat();
};

Tokenizer.prototype._unconsumeSeveral = function (count) {
    while (count--)
        this._unconsume();
};

Tokenizer.prototype._reconsumeInState = function (state) {
    this.state = state;
    this._unconsume();
};

Tokenizer.prototype._consumeSubsequentIfMatch = function (pattern, startCp, caseSensitive) {
    var consumedCount = 0,
        isMatch = true,
        patternLength = pattern.length,
        patternPos = 0,
        cp = startCp,
        patternCp = void 0;

    for (; patternPos < patternLength; patternPos++) {
        if (patternPos > 0) {
            cp = this._consume();
            consumedCount++;
        }

        if (cp === $.EOF) {
            isMatch = false;
            break;
        }

        patternCp = pattern[patternPos];

        if (cp !== patternCp && (caseSensitive || cp !== toAsciiLowerCodePoint(patternCp))) {
            isMatch = false;
            break;
        }
    }

    if (!isMatch)
        this._unconsumeSeveral(consumedCount);

    return isMatch;
};

//Lookahead
Tokenizer.prototype._lookahead = function () {
    var cp = this._consume();

    this._unconsume();

    return cp;
};

//Temp buffer
Tokenizer.prototype.isTempBufferEqualToScriptString = function () {
    if (this.tempBuff.length !== $$.SCRIPT_STRING.length)
        return false;

    for (var i = 0; i < this.tempBuff.length; i++) {
        if (this.tempBuff[i] !== $$.SCRIPT_STRING[i])
            return false;
    }

    return true;
};

//Token creation
Tokenizer.prototype._createStartTagToken = function () {
    this.currentToken = {
        type: Tokenizer.START_TAG_TOKEN,
        tagName: '',
        selfClosing: false,
        attrs: []
    };
};

Tokenizer.prototype._createEndTagToken = function () {
    this.currentToken = {
        type: Tokenizer.END_TAG_TOKEN,
        tagName: '',
        attrs: []
    };
};

Tokenizer.prototype._createCommentToken = function () {
    this.currentToken = {
        type: Tokenizer.COMMENT_TOKEN,
        data: ''
    };
};

Tokenizer.prototype._createDoctypeToken = function (initialName) {
    this.currentToken = {
        type: Tokenizer.DOCTYPE_TOKEN,
        name: initialName,
        forceQuirks: false,
        publicId: null,
        systemId: null
    };
};

Tokenizer.prototype._createCharacterToken = function (type, ch) {
    this.currentCharacterToken = {
        type: type,
        chars: ch
    };
};

//Tag attributes
Tokenizer.prototype._createAttr = function (attrNameFirstCh) {
    this.currentAttr = {
        name: attrNameFirstCh,
        value: ''
    };
};

Tokenizer.prototype._isDuplicateAttr = function () {
    return Tokenizer.getTokenAttr(this.currentToken, this.currentAttr.name) !== null;
};

Tokenizer.prototype._leaveAttrName = function (toState) {
    this.state = toState;

    if (!this._isDuplicateAttr())
        this.currentToken.attrs.push(this.currentAttr);
};

Tokenizer.prototype._leaveAttrValue = function (toState) {
    this.state = toState;
};

//Appropriate end tag token
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tokenization.html#appropriate-end-tag-token)
Tokenizer.prototype._isAppropriateEndTagToken = function () {
    return this.lastStartTagName === this.currentToken.tagName;
};

//Token emission
Tokenizer.prototype._emitCurrentToken = function () {
    this._emitCurrentCharacterToken();

    //NOTE: store emited start tag's tagName to determine is the following end tag token is appropriate.
    if (this.currentToken.type === Tokenizer.START_TAG_TOKEN)
        this.lastStartTagName = this.currentToken.tagName;

    this.tokenQueue.push(this.currentToken);
    this.currentToken = null;
};

Tokenizer.prototype._emitCurrentCharacterToken = function () {
    if (this.currentCharacterToken) {
        this.tokenQueue.push(this.currentCharacterToken);
        this.currentCharacterToken = null;
    }
};

Tokenizer.prototype._emitEOFToken = function () {
    this._emitCurrentCharacterToken();
    this.tokenQueue.push({type: Tokenizer.EOF_TOKEN});
};

//Characters emission

//OPTIMIZATION: specification uses only one type of character tokens (one token per character).
//This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
//If we have a sequence of characters that belong to the same group, parser can process it
//as a single solid character token.
//So, there are 3 types of character tokens in parse5:
//1)NULL_CHARACTER_TOKEN - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
//2)WHITESPACE_CHARACTER_TOKEN - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
//3)CHARACTER_TOKEN - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
Tokenizer.prototype._appendCharToCurrentCharacterToken = function (type, ch) {
    if (this.currentCharacterToken && this.currentCharacterToken.type !== type)
        this._emitCurrentCharacterToken();

    if (this.currentCharacterToken)
        this.currentCharacterToken.chars += ch;

    else
        this._createCharacterToken(type, ch);
};

Tokenizer.prototype._emitCodePoint = function (cp) {
    var type = Tokenizer.CHARACTER_TOKEN;

    if (isWhitespace(cp))
        type = Tokenizer.WHITESPACE_CHARACTER_TOKEN;

    else if (cp === $.NULL)
        type = Tokenizer.NULL_CHARACTER_TOKEN;

    this._appendCharToCurrentCharacterToken(type, toChar(cp));
};

Tokenizer.prototype._emitSeveralCodePoints = function (codePoints) {
    for (var i = 0; i < codePoints.length; i++)
        this._emitCodePoint(codePoints[i]);
};

//NOTE: used then we emit character explicitly. This is always a non-whitespace and a non-null character.
//So we can avoid additional checks here.
Tokenizer.prototype._emitChar = function (ch) {
    this._appendCharToCurrentCharacterToken(Tokenizer.CHARACTER_TOKEN, ch);
};

//Character reference tokenization
Tokenizer.prototype._consumeNumericEntity = function (isHex) {
    var digits = '',
        nextCp = void 0;

    do {
        digits += toChar(this._consume());
        nextCp = this._lookahead();
    } while (nextCp !== $.EOF && isDigit(nextCp, isHex));

    if (this._lookahead() === $.SEMICOLON)
        this._consume();

    var referencedCp = parseInt(digits, isHex ? 16 : 10),
        replacement = NUMERIC_ENTITY_REPLACEMENTS[referencedCp];

    if (replacement)
        return replacement;

    if (isReservedCodePoint(referencedCp))
        return $.REPLACEMENT_CHARACTER;

    return referencedCp;
};

// NOTE: for the details on this algorithm see
// https://github.com/inikulin/parse5/tree/master/scripts/generate_named_entity_data/README.md
Tokenizer.prototype._consumeNamedEntity = function (inAttr) {
    var referencedCodePoints = null,
        referenceSize = 0,
        cp = null,
        consumedCount = 0,
        semicolonTerminated = false;

    for (var i = 0; i > -1;) {
        var current = neTree[i],
            inNode = current < MAX_BRANCH_MARKER_VALUE,
            nodeWithData = inNode && current & HAS_DATA_FLAG;

        if (nodeWithData) {
            referencedCodePoints = current & DATA_DUPLET_FLAG ? [neTree[++i], neTree[++i]] : [neTree[++i]];
            referenceSize = consumedCount;

            if (cp === $.SEMICOLON) {
                semicolonTerminated = true;
                break;
            }
        }

        cp = this._consume();
        consumedCount++;

        if (cp === $.EOF)
            break;

        if (inNode)
            i = current & HAS_BRANCHES_FLAG ? findNamedEntityTreeBranch(i, cp) : -1;

        else
            i = cp === current ? ++i : -1;
    }


    if (referencedCodePoints) {
        if (!semicolonTerminated) {
            //NOTE: unconsume excess (e.g. 'it' in '&notit')
            this._unconsumeSeveral(consumedCount - referenceSize);

            //NOTE: If the character reference is being consumed as part of an attribute and the next character
            //is either a U+003D EQUALS SIGN character (=) or an alphanumeric ASCII character, then, for historical
            //reasons, all the characters that were matched after the U+0026 AMPERSAND character (&) must be
            //unconsumed, and nothing is returned.
            //However, if this next character is in fact a U+003D EQUALS SIGN character (=), then this is a
            //parse error, because some legacy user agents will misinterpret the markup in those cases.
            //(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tokenization.html#tokenizing-character-references)
            if (inAttr) {
                var nextCp = this._lookahead();

                if (nextCp === $.EQUALS_SIGN || isAsciiAlphaNumeric(nextCp)) {
                    this._unconsumeSeveral(referenceSize);
                    return null;
                }
            }
        }

        return referencedCodePoints;
    }

    this._unconsumeSeveral(consumedCount);

    return null;
};

Tokenizer.prototype._consumeCharacterReference = function (startCp, inAttr) {
    if (isWhitespace(startCp) || startCp === $.GREATER_THAN_SIGN ||
        startCp === $.AMPERSAND || startCp === this.additionalAllowedCp || startCp === $.EOF) {
        //NOTE: not a character reference. No characters are consumed, and nothing is returned.
        this._unconsume();
        return null;
    }

    if (startCp === $.NUMBER_SIGN) {
        //NOTE: we have a numeric entity candidate, now we should determine if it's hex or decimal
        var isHex = false,
            nextCp = this._lookahead();

        if (nextCp === $.LATIN_SMALL_X || nextCp === $.LATIN_CAPITAL_X) {
            this._consume();
            isHex = true;
        }

        nextCp = this._lookahead();

        //NOTE: if we have at least one digit this is a numeric entity for sure, so we consume it
        if (nextCp !== $.EOF && isDigit(nextCp, isHex))
            return [this._consumeNumericEntity(isHex)];

        //NOTE: otherwise this is a bogus number entity and a parse error. Unconsume the number sign
        //and the 'x'-character if appropriate.
        this._unconsumeSeveral(isHex ? 2 : 1);
        return null;
    }

    this._unconsume();

    return this._consumeNamedEntity(inAttr);
};

//State machine
var _ = Tokenizer.prototype;

//12.2.4.1 Data state
//------------------------------------------------------------------
_[DATA_STATE] = function dataState(cp) {
    this.preprocessor.dropParsedChunk();

    if (cp === $.AMPERSAND)
        this.state = CHARACTER_REFERENCE_IN_DATA_STATE;

    else if (cp === $.LESS_THAN_SIGN)
        this.state = TAG_OPEN_STATE;

    else if (cp === $.NULL)
        this._emitCodePoint(cp);

    else if (cp === $.EOF)
        this._emitEOFToken();

    else
        this._emitCodePoint(cp);
};


//12.2.4.2 Character reference in data state
//------------------------------------------------------------------
_[CHARACTER_REFERENCE_IN_DATA_STATE] = function characterReferenceInDataState(cp) {
    this.additionalAllowedCp = void 0;

    var referencedCodePoints = this._consumeCharacterReference(cp, false);

    if (!this._ensureHibernation()) {
        if (referencedCodePoints)
            this._emitSeveralCodePoints(referencedCodePoints);

        else
            this._emitChar('&');

        this.state = DATA_STATE;
    }
};


//12.2.4.3 RCDATA state
//------------------------------------------------------------------
_[RCDATA_STATE] = function rcdataState(cp) {
    this.preprocessor.dropParsedChunk();

    if (cp === $.AMPERSAND)
        this.state = CHARACTER_REFERENCE_IN_RCDATA_STATE;

    else if (cp === $.LESS_THAN_SIGN)
        this.state = RCDATA_LESS_THAN_SIGN_STATE;

    else if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._emitEOFToken();

    else
        this._emitCodePoint(cp);
};


//12.2.4.4 Character reference in RCDATA state
//------------------------------------------------------------------
_[CHARACTER_REFERENCE_IN_RCDATA_STATE] = function characterReferenceInRcdataState(cp) {
    this.additionalAllowedCp = void 0;

    var referencedCodePoints = this._consumeCharacterReference(cp, false);

    if (!this._ensureHibernation()) {
        if (referencedCodePoints)
            this._emitSeveralCodePoints(referencedCodePoints);

        else
            this._emitChar('&');

        this.state = RCDATA_STATE;
    }
};


//12.2.4.5 RAWTEXT state
//------------------------------------------------------------------
_[RAWTEXT_STATE] = function rawtextState(cp) {
    this.preprocessor.dropParsedChunk();

    if (cp === $.LESS_THAN_SIGN)
        this.state = RAWTEXT_LESS_THAN_SIGN_STATE;

    else if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._emitEOFToken();

    else
        this._emitCodePoint(cp);
};


//12.2.4.6 Script data state
//------------------------------------------------------------------
_[SCRIPT_DATA_STATE] = function scriptDataState(cp) {
    this.preprocessor.dropParsedChunk();

    if (cp === $.LESS_THAN_SIGN)
        this.state = SCRIPT_DATA_LESS_THAN_SIGN_STATE;

    else if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._emitEOFToken();

    else
        this._emitCodePoint(cp);
};


//12.2.4.7 PLAINTEXT state
//------------------------------------------------------------------
_[PLAINTEXT_STATE] = function plaintextState(cp) {
    this.preprocessor.dropParsedChunk();

    if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._emitEOFToken();

    else
        this._emitCodePoint(cp);
};


//12.2.4.8 Tag open state
//------------------------------------------------------------------
_[TAG_OPEN_STATE] = function tagOpenState(cp) {
    if (cp === $.EXCLAMATION_MARK)
        this.state = MARKUP_DECLARATION_OPEN_STATE;

    else if (cp === $.SOLIDUS)
        this.state = END_TAG_OPEN_STATE;

    else if (isAsciiLetter(cp)) {
        this._createStartTagToken();
        this._reconsumeInState(TAG_NAME_STATE);
    }

    else if (cp === $.QUESTION_MARK)
        this._reconsumeInState(BOGUS_COMMENT_STATE);

    else {
        this._emitChar('<');
        this._reconsumeInState(DATA_STATE);
    }
};


//12.2.4.9 End tag open state
//------------------------------------------------------------------
_[END_TAG_OPEN_STATE] = function endTagOpenState(cp) {
    if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(TAG_NAME_STATE);
    }

    else if (cp === $.GREATER_THAN_SIGN)
        this.state = DATA_STATE;

    else if (cp === $.EOF) {
        this._reconsumeInState(DATA_STATE);
        this._emitChar('<');
        this._emitChar('/');
    }

    else
        this._reconsumeInState(BOGUS_COMMENT_STATE);
};


//12.2.4.10 Tag name state
//------------------------------------------------------------------
_[TAG_NAME_STATE] = function tagNameState(cp) {
    if (isWhitespace(cp))
        this.state = BEFORE_ATTRIBUTE_NAME_STATE;

    else if (cp === $.SOLIDUS)
        this.state = SELF_CLOSING_START_TAG_STATE;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (isAsciiUpper(cp))
        this.currentToken.tagName += toAsciiLowerChar(cp);

    else if (cp === $.NULL)
        this.currentToken.tagName += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this.currentToken.tagName += toChar(cp);
};


//12.2.4.11 RCDATA less-than sign state
//------------------------------------------------------------------
_[RCDATA_LESS_THAN_SIGN_STATE] = function rcdataLessThanSignState(cp) {
    if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = RCDATA_END_TAG_OPEN_STATE;
    }

    else {
        this._emitChar('<');
        this._reconsumeInState(RCDATA_STATE);
    }
};


//12.2.4.12 RCDATA end tag open state
//------------------------------------------------------------------
_[RCDATA_END_TAG_OPEN_STATE] = function rcdataEndTagOpenState(cp) {
    if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(RCDATA_END_TAG_NAME_STATE);
    }

    else {
        this._emitChar('<');
        this._emitChar('/');
        this._reconsumeInState(RCDATA_STATE);
    }
};


//12.2.4.13 RCDATA end tag name state
//------------------------------------------------------------------
_[RCDATA_END_TAG_NAME_STATE] = function rcdataEndTagNameState(cp) {
    if (isAsciiUpper(cp)) {
        this.currentToken.tagName += toAsciiLowerChar(cp);
        this.tempBuff.push(cp);
    }

    else if (isAsciiLower(cp)) {
        this.currentToken.tagName += toChar(cp);
        this.tempBuff.push(cp);
    }

    else {
        if (this._isAppropriateEndTagToken()) {
            if (isWhitespace(cp)) {
                this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                return;
            }

            if (cp === $.SOLIDUS) {
                this.state = SELF_CLOSING_START_TAG_STATE;
                return;
            }

            if (cp === $.GREATER_THAN_SIGN) {
                this.state = DATA_STATE;
                this._emitCurrentToken();
                return;
            }
        }

        this._emitChar('<');
        this._emitChar('/');
        this._emitSeveralCodePoints(this.tempBuff);
        this._reconsumeInState(RCDATA_STATE);
    }
};


//12.2.4.14 RAWTEXT less-than sign state
//------------------------------------------------------------------
_[RAWTEXT_LESS_THAN_SIGN_STATE] = function rawtextLessThanSignState(cp) {
    if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = RAWTEXT_END_TAG_OPEN_STATE;
    }

    else {
        this._emitChar('<');
        this._reconsumeInState(RAWTEXT_STATE);
    }
};


//12.2.4.15 RAWTEXT end tag open state
//------------------------------------------------------------------
_[RAWTEXT_END_TAG_OPEN_STATE] = function rawtextEndTagOpenState(cp) {
    if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(RAWTEXT_END_TAG_NAME_STATE);
    }

    else {
        this._emitChar('<');
        this._emitChar('/');
        this._reconsumeInState(RAWTEXT_STATE);
    }
};


//12.2.4.16 RAWTEXT end tag name state
//------------------------------------------------------------------
_[RAWTEXT_END_TAG_NAME_STATE] = function rawtextEndTagNameState(cp) {
    if (isAsciiUpper(cp)) {
        this.currentToken.tagName += toAsciiLowerChar(cp);
        this.tempBuff.push(cp);
    }

    else if (isAsciiLower(cp)) {
        this.currentToken.tagName += toChar(cp);
        this.tempBuff.push(cp);
    }

    else {
        if (this._isAppropriateEndTagToken()) {
            if (isWhitespace(cp)) {
                this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                return;
            }

            if (cp === $.SOLIDUS) {
                this.state = SELF_CLOSING_START_TAG_STATE;
                return;
            }

            if (cp === $.GREATER_THAN_SIGN) {
                this._emitCurrentToken();
                this.state = DATA_STATE;
                return;
            }
        }

        this._emitChar('<');
        this._emitChar('/');
        this._emitSeveralCodePoints(this.tempBuff);
        this._reconsumeInState(RAWTEXT_STATE);
    }
};


//12.2.4.17 Script data less-than sign state
//------------------------------------------------------------------
_[SCRIPT_DATA_LESS_THAN_SIGN_STATE] = function scriptDataLessThanSignState(cp) {
    if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = SCRIPT_DATA_END_TAG_OPEN_STATE;
    }

    else if (cp === $.EXCLAMATION_MARK) {
        this.state = SCRIPT_DATA_ESCAPE_START_STATE;
        this._emitChar('<');
        this._emitChar('!');
    }

    else {
        this._emitChar('<');
        this._reconsumeInState(SCRIPT_DATA_STATE);
    }
};


//12.2.4.18 Script data end tag open state
//------------------------------------------------------------------
_[SCRIPT_DATA_END_TAG_OPEN_STATE] = function scriptDataEndTagOpenState(cp) {
    if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(SCRIPT_DATA_END_TAG_NAME_STATE);
    }

    else {
        this._emitChar('<');
        this._emitChar('/');
        this._reconsumeInState(SCRIPT_DATA_STATE);
    }
};


//12.2.4.19 Script data end tag name state
//------------------------------------------------------------------
_[SCRIPT_DATA_END_TAG_NAME_STATE] = function scriptDataEndTagNameState(cp) {
    if (isAsciiUpper(cp)) {
        this.currentToken.tagName += toAsciiLowerChar(cp);
        this.tempBuff.push(cp);
    }

    else if (isAsciiLower(cp)) {
        this.currentToken.tagName += toChar(cp);
        this.tempBuff.push(cp);
    }

    else {
        if (this._isAppropriateEndTagToken()) {
            if (isWhitespace(cp)) {
                this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                return;
            }

            else if (cp === $.SOLIDUS) {
                this.state = SELF_CLOSING_START_TAG_STATE;
                return;
            }

            else if (cp === $.GREATER_THAN_SIGN) {
                this._emitCurrentToken();
                this.state = DATA_STATE;
                return;
            }
        }

        this._emitChar('<');
        this._emitChar('/');
        this._emitSeveralCodePoints(this.tempBuff);
        this._reconsumeInState(SCRIPT_DATA_STATE);
    }
};


//12.2.4.20 Script data escape start state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPE_START_STATE] = function scriptDataEscapeStartState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_ESCAPE_START_DASH_STATE;
        this._emitChar('-');
    }

    else
        this._reconsumeInState(SCRIPT_DATA_STATE);
};


//12.2.4.21 Script data escape start dash state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPE_START_DASH_STATE] = function scriptDataEscapeStartDashState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_ESCAPED_DASH_DASH_STATE;
        this._emitChar('-');
    }

    else
        this._reconsumeInState(SCRIPT_DATA_STATE);
};


//12.2.4.22 Script data escaped state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_STATE] = function scriptDataEscapedState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_ESCAPED_DASH_STATE;
        this._emitChar('-');
    }

    else if (cp === $.LESS_THAN_SIGN)
        this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;

    else if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this._emitCodePoint(cp);
};


//12.2.4.23 Script data escaped dash state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_DASH_STATE] = function scriptDataEscapedDashState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_ESCAPED_DASH_DASH_STATE;
        this._emitChar('-');
    }

    else if (cp === $.LESS_THAN_SIGN)
        this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;

    else if (cp === $.NULL) {
        this.state = SCRIPT_DATA_ESCAPED_STATE;
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else {
        this.state = SCRIPT_DATA_ESCAPED_STATE;
        this._emitCodePoint(cp);
    }
};


//12.2.4.24 Script data escaped dash dash state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_DASH_DASH_STATE] = function scriptDataEscapedDashDashState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this._emitChar('-');

    else if (cp === $.LESS_THAN_SIGN)
        this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = SCRIPT_DATA_STATE;
        this._emitChar('>');
    }

    else if (cp === $.NULL) {
        this.state = SCRIPT_DATA_ESCAPED_STATE;
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else {
        this.state = SCRIPT_DATA_ESCAPED_STATE;
        this._emitCodePoint(cp);
    }
};


//12.2.4.25 Script data escaped less-than sign state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE] = function scriptDataEscapedLessThanSignState(cp) {
    if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE;
    }

    else if (isAsciiLetter(cp)) {
        this.tempBuff = [];
        this._emitChar('<');
        this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE);
    }

    else {
        this._emitChar('<');
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
    }
};


//12.2.4.26 Script data escaped end tag open state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE] = function scriptDataEscapedEndTagOpenState(cp) {
    if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE);
    }

    else {
        this._emitChar('<');
        this._emitChar('/');
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
    }
};


//12.2.4.27 Script data escaped end tag name state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE] = function scriptDataEscapedEndTagNameState(cp) {
    if (isAsciiUpper(cp)) {
        this.currentToken.tagName += toAsciiLowerChar(cp);
        this.tempBuff.push(cp);
    }

    else if (isAsciiLower(cp)) {
        this.currentToken.tagName += toChar(cp);
        this.tempBuff.push(cp);
    }

    else {
        if (this._isAppropriateEndTagToken()) {
            if (isWhitespace(cp)) {
                this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                return;
            }

            if (cp === $.SOLIDUS) {
                this.state = SELF_CLOSING_START_TAG_STATE;
                return;
            }

            if (cp === $.GREATER_THAN_SIGN) {
                this._emitCurrentToken();
                this.state = DATA_STATE;
                return;
            }
        }

        this._emitChar('<');
        this._emitChar('/');
        this._emitSeveralCodePoints(this.tempBuff);
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
    }
};


//12.2.4.28 Script data double escape start state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE] = function scriptDataDoubleEscapeStartState(cp) {
    if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN) {
        this.state = this.isTempBufferEqualToScriptString() ? SCRIPT_DATA_DOUBLE_ESCAPED_STATE : SCRIPT_DATA_ESCAPED_STATE;
        this._emitCodePoint(cp);
    }

    else if (isAsciiUpper(cp)) {
        this.tempBuff.push(toAsciiLowerCodePoint(cp));
        this._emitCodePoint(cp);
    }

    else if (isAsciiLower(cp)) {
        this.tempBuff.push(cp);
        this._emitCodePoint(cp);
    }

    else
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
};


//12.2.4.29 Script data double escaped state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPED_STATE] = function scriptDataDoubleEscapedState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE;
        this._emitChar('-');
    }

    else if (cp === $.LESS_THAN_SIGN) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
        this._emitChar('<');
    }

    else if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this._emitCodePoint(cp);
};


//12.2.4.30 Script data double escaped dash state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE] = function scriptDataDoubleEscapedDashState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE;
        this._emitChar('-');
    }

    else if (cp === $.LESS_THAN_SIGN) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
        this._emitChar('<');
    }

    else if (cp === $.NULL) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
        this._emitCodePoint(cp);
    }
};


//12.2.4.31 Script data double escaped dash dash state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE] = function scriptDataDoubleEscapedDashDashState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this._emitChar('-');

    else if (cp === $.LESS_THAN_SIGN) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
        this._emitChar('<');
    }

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = SCRIPT_DATA_STATE;
        this._emitChar('>');
    }

    else if (cp === $.NULL) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
        this._emitCodePoint(cp);
    }
};


//12.2.4.32 Script data double escaped less-than sign state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE] = function scriptDataDoubleEscapedLessThanSignState(cp) {
    if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE;
        this._emitChar('/');
    }

    else
        this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPED_STATE);
};


//12.2.4.33 Script data double escape end state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE] = function scriptDataDoubleEscapeEndState(cp) {
    if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN) {
        this.state = this.isTempBufferEqualToScriptString() ? SCRIPT_DATA_ESCAPED_STATE : SCRIPT_DATA_DOUBLE_ESCAPED_STATE;

        this._emitCodePoint(cp);
    }

    else if (isAsciiUpper(cp)) {
        this.tempBuff.push(toAsciiLowerCodePoint(cp));
        this._emitCodePoint(cp);
    }

    else if (isAsciiLower(cp)) {
        this.tempBuff.push(cp);
        this._emitCodePoint(cp);
    }

    else
        this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPED_STATE);
};


//12.2.4.34 Before attribute name state
//------------------------------------------------------------------
_[BEFORE_ATTRIBUTE_NAME_STATE] = function beforeAttributeNameState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN || cp === $.EOF)
        this._reconsumeInState(AFTER_ATTRIBUTE_NAME_STATE);

    else if (cp === $.EQUALS_SIGN) {
        this._createAttr('=');
        this.state = ATTRIBUTE_NAME_STATE;
    }

    else {
        this._createAttr('');
        this._reconsumeInState(ATTRIBUTE_NAME_STATE);
    }
};


//12.2.4.35 Attribute name state
//------------------------------------------------------------------
_[ATTRIBUTE_NAME_STATE] = function attributeNameState(cp) {
    if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN || cp === $.EOF) {
        this._leaveAttrName(AFTER_ATTRIBUTE_NAME_STATE);
        this._unconsume();
    }

    else if (cp === $.EQUALS_SIGN)
        this._leaveAttrName(BEFORE_ATTRIBUTE_VALUE_STATE);

    else if (isAsciiUpper(cp))
        this.currentAttr.name += toAsciiLowerChar(cp);

    else if (cp === $.QUOTATION_MARK || cp === $.APOSTROPHE || cp === $.LESS_THAN_SIGN)
        this.currentAttr.name += toChar(cp);

    else if (cp === $.NULL)
        this.currentAttr.name += UNICODE.REPLACEMENT_CHARACTER;

    else
        this.currentAttr.name += toChar(cp);
};


//12.2.4.36 After attribute name state
//------------------------------------------------------------------
_[AFTER_ATTRIBUTE_NAME_STATE] = function afterAttributeNameState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.SOLIDUS)
        this.state = SELF_CLOSING_START_TAG_STATE;

    else if (cp === $.EQUALS_SIGN)
        this.state = BEFORE_ATTRIBUTE_VALUE_STATE;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else {
        this._createAttr('');
        this._reconsumeInState(ATTRIBUTE_NAME_STATE);
    }
};


//12.2.4.37 Before attribute value state
//------------------------------------------------------------------
_[BEFORE_ATTRIBUTE_VALUE_STATE] = function beforeAttributeValueState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.QUOTATION_MARK)
        this.state = ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE;

    else if (cp === $.APOSTROPHE)
        this.state = ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE;

    else
        this._reconsumeInState(ATTRIBUTE_VALUE_UNQUOTED_STATE);
};


//12.2.4.38 Attribute value (double-quoted) state
//------------------------------------------------------------------
_[ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE] = function attributeValueDoubleQuotedState(cp) {
    if (cp === $.QUOTATION_MARK)
        this.state = AFTER_ATTRIBUTE_VALUE_QUOTED_STATE;

    else if (cp === $.AMPERSAND) {
        this.additionalAllowedCp = $.QUOTATION_MARK;
        this.returnState = this.state;
        this.state = CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE;
    }

    else if (cp === $.NULL)
        this.currentAttr.value += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this.currentAttr.value += toChar(cp);
};


//12.2.4.39 Attribute value (single-quoted) state
//------------------------------------------------------------------
_[ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE] = function attributeValueSingleQuotedState(cp) {
    if (cp === $.APOSTROPHE)
        this.state = AFTER_ATTRIBUTE_VALUE_QUOTED_STATE;

    else if (cp === $.AMPERSAND) {
        this.additionalAllowedCp = $.APOSTROPHE;
        this.returnState = this.state;
        this.state = CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE;
    }

    else if (cp === $.NULL)
        this.currentAttr.value += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this.currentAttr.value += toChar(cp);
};


//12.2.4.40 Attribute value (unquoted) state
//------------------------------------------------------------------
_[ATTRIBUTE_VALUE_UNQUOTED_STATE] = function attributeValueUnquotedState(cp) {
    if (isWhitespace(cp))
        this._leaveAttrValue(BEFORE_ATTRIBUTE_NAME_STATE);

    else if (cp === $.AMPERSAND) {
        this.additionalAllowedCp = $.GREATER_THAN_SIGN;
        this.returnState = this.state;
        this.state = CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE;
    }

    else if (cp === $.GREATER_THAN_SIGN) {
        this._leaveAttrValue(DATA_STATE);
        this._emitCurrentToken();
    }

    else if (cp === $.NULL)
        this.currentAttr.value += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.QUOTATION_MARK || cp === $.APOSTROPHE || cp === $.LESS_THAN_SIGN ||
             cp === $.EQUALS_SIGN || cp === $.GRAVE_ACCENT)
        this.currentAttr.value += toChar(cp);

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this.currentAttr.value += toChar(cp);
};


//12.2.4.41 Character reference in attribute value state
//------------------------------------------------------------------
_[CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE] = function characterReferenceInAttributeValueState(cp) {
    var referencedCodePoints = this._consumeCharacterReference(cp, true);

    if (!this._ensureHibernation()) {
        if (referencedCodePoints) {
            for (var i = 0; i < referencedCodePoints.length; i++)
                this.currentAttr.value += toChar(referencedCodePoints[i]);
        }
        else
            this.currentAttr.value += '&';

        this.state = this.returnState;
    }
};


//12.2.4.42 After attribute value (quoted) state
//------------------------------------------------------------------
_[AFTER_ATTRIBUTE_VALUE_QUOTED_STATE] = function afterAttributeValueQuotedState(cp) {
    if (isWhitespace(cp))
        this._leaveAttrValue(BEFORE_ATTRIBUTE_NAME_STATE);

    else if (cp === $.SOLIDUS)
        this._leaveAttrValue(SELF_CLOSING_START_TAG_STATE);

    else if (cp === $.GREATER_THAN_SIGN) {
        this._leaveAttrValue(DATA_STATE);
        this._emitCurrentToken();
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this._reconsumeInState(BEFORE_ATTRIBUTE_NAME_STATE);
};


//12.2.4.43 Self-closing start tag state
//------------------------------------------------------------------
_[SELF_CLOSING_START_TAG_STATE] = function selfClosingStartTagState(cp) {
    if (cp === $.GREATER_THAN_SIGN) {
        this.currentToken.selfClosing = true;
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this._reconsumeInState(BEFORE_ATTRIBUTE_NAME_STATE);
};


//12.2.4.44 Bogus comment state
//------------------------------------------------------------------
_[BOGUS_COMMENT_STATE] = function bogusCommentState() {
    this._createCommentToken();
    this._reconsumeInState(BOGUS_COMMENT_STATE_CONTINUATION);
};

//HACK: to support streaming and make BOGUS_COMMENT_STATE reentrant we've
//introduced BOGUS_COMMENT_STATE_CONTINUATION state which will not produce
//comment token on each call.
_[BOGUS_COMMENT_STATE_CONTINUATION] = function bogusCommentStateContinuation(cp) {
    while (true) {
        if (cp === $.GREATER_THAN_SIGN) {
            this.state = DATA_STATE;
            break;
        }

        else if (cp === $.EOF) {
            this._reconsumeInState(DATA_STATE);
            break;
        }

        else {
            this.currentToken.data += cp === $.NULL ? UNICODE.REPLACEMENT_CHARACTER : toChar(cp);

            this._hibernationSnapshot();
            cp = this._consume();

            if (this._ensureHibernation())
                return;
        }
    }

    this._emitCurrentToken();
};

//12.2.4.45 Markup declaration open state
//------------------------------------------------------------------
_[MARKUP_DECLARATION_OPEN_STATE] = function markupDeclarationOpenState(cp) {
    var dashDashMatch = this._consumeSubsequentIfMatch($$.DASH_DASH_STRING, cp, true),
        doctypeMatch = !dashDashMatch && this._consumeSubsequentIfMatch($$.DOCTYPE_STRING, cp, false),
        cdataMatch = !dashDashMatch && !doctypeMatch &&
                     this.allowCDATA &&
                     this._consumeSubsequentIfMatch($$.CDATA_START_STRING, cp, true);

    if (!this._ensureHibernation()) {
        if (dashDashMatch) {
            this._createCommentToken();
            this.state = COMMENT_START_STATE;
        }

        else if (doctypeMatch)
            this.state = DOCTYPE_STATE;

        else if (cdataMatch)
            this.state = CDATA_SECTION_STATE;

        else
            this._reconsumeInState(BOGUS_COMMENT_STATE);
    }
};


//12.2.4.46 Comment start state
//------------------------------------------------------------------
_[COMMENT_START_STATE] = function commentStartState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this.state = COMMENT_START_DASH_STATE;

    else if (cp === $.NULL) {
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
        this.state = COMMENT_STATE;
    }

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else {
        this.currentToken.data += toChar(cp);
        this.state = COMMENT_STATE;
    }
};


//12.2.4.47 Comment start dash state
//------------------------------------------------------------------
_[COMMENT_START_DASH_STATE] = function commentStartDashState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this.state = COMMENT_END_STATE;

    else if (cp === $.NULL) {
        this.currentToken.data += '-';
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
        this.state = COMMENT_STATE;
    }

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else {
        this.currentToken.data += '-';
        this.currentToken.data += toChar(cp);
        this.state = COMMENT_STATE;
    }
};


//12.2.4.48 Comment state
//------------------------------------------------------------------
_[COMMENT_STATE] = function commentState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this.state = COMMENT_END_DASH_STATE;

    else if (cp === $.NULL)
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.currentToken.data += toChar(cp);
};


//12.2.4.49 Comment end dash state
//------------------------------------------------------------------
_[COMMENT_END_DASH_STATE] = function commentEndDashState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this.state = COMMENT_END_STATE;

    else if (cp === $.NULL) {
        this.currentToken.data += '-';
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
        this.state = COMMENT_STATE;
    }

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else {
        this.currentToken.data += '-';
        this.currentToken.data += toChar(cp);
        this.state = COMMENT_STATE;
    }
};


//12.2.4.50 Comment end state
//------------------------------------------------------------------
_[COMMENT_END_STATE] = function commentEndState(cp) {
    if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.EXCLAMATION_MARK)
        this.state = COMMENT_END_BANG_STATE;

    else if (cp === $.HYPHEN_MINUS)
        this.currentToken.data += '-';

    else if (cp === $.NULL) {
        this.currentToken.data += '--';
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
        this.state = COMMENT_STATE;
    }

    else if (cp === $.EOF) {
        this._reconsumeInState(DATA_STATE);
        this._emitCurrentToken();
    }

    else {
        this.currentToken.data += '--';
        this.currentToken.data += toChar(cp);
        this.state = COMMENT_STATE;
    }
};


//12.2.4.51 Comment end bang state
//------------------------------------------------------------------
_[COMMENT_END_BANG_STATE] = function commentEndBangState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.currentToken.data += '--!';
        this.state = COMMENT_END_DASH_STATE;
    }

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.NULL) {
        this.currentToken.data += '--!';
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
        this.state = COMMENT_STATE;
    }

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else {
        this.currentToken.data += '--!';
        this.currentToken.data += toChar(cp);
        this.state = COMMENT_STATE;
    }
};


//12.2.4.52 DOCTYPE state
//------------------------------------------------------------------
_[DOCTYPE_STATE] = function doctypeState(cp) {
    if (isWhitespace(cp))
        return;

    else if (cp === $.GREATER_THAN_SIGN) {
        this._createDoctypeToken(null);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.EOF) {
        this._createDoctypeToken(null);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }
    else {
        this._createDoctypeToken('');
        this._reconsumeInState(DOCTYPE_NAME_STATE);
    }
};


//12.2.4.54 DOCTYPE name state
//------------------------------------------------------------------
_[DOCTYPE_NAME_STATE] = function doctypeNameState(cp) {
    if (isWhitespace(cp) || cp === $.GREATER_THAN_SIGN || cp === $.EOF)
        this._reconsumeInState(AFTER_DOCTYPE_NAME_STATE);

    else if (isAsciiUpper(cp))
        this.currentToken.name += toAsciiLowerChar(cp);

    else if (cp === $.NULL)
        this.currentToken.name += UNICODE.REPLACEMENT_CHARACTER;

    else
        this.currentToken.name += toChar(cp);
};


//12.2.4.55 After DOCTYPE name state
//------------------------------------------------------------------
_[AFTER_DOCTYPE_NAME_STATE] = function afterDoctypeNameState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else {
        var publicMatch = this._consumeSubsequentIfMatch($$.PUBLIC_STRING, cp, false),
            systemMatch = !publicMatch && this._consumeSubsequentIfMatch($$.SYSTEM_STRING, cp, false);

        if (!this._ensureHibernation()) {
            if (publicMatch)
                this.state = BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE;

            else if (systemMatch)
                this.state = BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE;

            else {
                this.currentToken.forceQuirks = true;
                this.state = BOGUS_DOCTYPE_STATE;
            }
        }
    }
};


//12.2.4.57 Before DOCTYPE public identifier state
//------------------------------------------------------------------
_[BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE] = function beforeDoctypePublicIdentifierState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.QUOTATION_MARK) {
        this.currentToken.publicId = '';
        this.state = DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE;
    }

    else if (cp === $.APOSTROPHE) {
        this.currentToken.publicId = '';
        this.state = DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE;
    }

    else {
        this.currentToken.forceQuirks = true;
        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
    }
};


//12.2.4.58 DOCTYPE public identifier (double-quoted) state
//------------------------------------------------------------------
_[DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE] = function doctypePublicIdentifierDoubleQuotedState(cp) {
    if (cp === $.QUOTATION_MARK)
        this.state = BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE;

    else if (cp === $.NULL)
        this.currentToken.publicId += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.EOF) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.currentToken.publicId += toChar(cp);
};


//12.2.4.59 DOCTYPE public identifier (single-quoted) state
//------------------------------------------------------------------
_[DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE] = function doctypePublicIdentifierSingleQuotedState(cp) {
    if (cp === $.APOSTROPHE)
        this.state = BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE;

    else if (cp === $.NULL)
        this.currentToken.publicId += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.EOF) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.currentToken.publicId += toChar(cp);
};


//12.2.4.61 Between DOCTYPE public and system identifiers state
//------------------------------------------------------------------
_[BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE] = function betweenDoctypePublicAndSystemIdentifiersState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.GREATER_THAN_SIGN) {
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.QUOTATION_MARK) {
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
    }


    else if (cp === $.APOSTROPHE) {
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
    }

    else {
        this.currentToken.forceQuirks = true;
        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
    }
};


//12.2.4.63 Before DOCTYPE system identifier state
//------------------------------------------------------------------
_[BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE] = function beforeDoctypeSystemIdentifierState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.QUOTATION_MARK) {
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
    }

    else if (cp === $.APOSTROPHE) {
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
    }

    else {
        this.currentToken.forceQuirks = true;
        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
    }
};


//12.2.4.64 DOCTYPE system identifier (double-quoted) state
//------------------------------------------------------------------
_[DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE] = function doctypeSystemIdentifierDoubleQuotedState(cp) {
    if (cp === $.QUOTATION_MARK)
        this.state = AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.NULL)
        this.currentToken.systemId += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.currentToken.systemId += toChar(cp);
};


//12.2.4.65 DOCTYPE system identifier (single-quoted) state
//------------------------------------------------------------------
_[DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE] = function doctypeSystemIdentifierSingleQuotedState(cp) {
    if (cp === $.APOSTROPHE)
        this.state = AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.NULL)
        this.currentToken.systemId += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.currentToken.systemId += toChar(cp);
};


//12.2.4.66 After DOCTYPE system identifier state
//------------------------------------------------------------------
_[AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE] = function afterDoctypeSystemIdentifierState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.GREATER_THAN_SIGN) {
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.EOF) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.state = BOGUS_DOCTYPE_STATE;
};


//12.2.4.67 Bogus DOCTYPE state
//------------------------------------------------------------------
_[BOGUS_DOCTYPE_STATE] = function bogusDoctypeState(cp) {
    if (cp === $.GREATER_THAN_SIGN) {
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }
};


//12.2.4.68 CDATA section state
//------------------------------------------------------------------
_[CDATA_SECTION_STATE] = function cdataSectionState(cp) {
    while (true) {
        if (cp === $.EOF) {
            this._reconsumeInState(DATA_STATE);
            break;
        }

        else {
            var cdataEndMatch = this._consumeSubsequentIfMatch($$.CDATA_END_STRING, cp, true);

            if (this._ensureHibernation())
                break;

            if (cdataEndMatch) {
                this.state = DATA_STATE;
                break;
            }

            this._emitCodePoint(cp);

            this._hibernationSnapshot();
            cp = this._consume();

            if (this._ensureHibernation())
                break;
        }
    }
};


/***/ }),

/***/ "./node_modules/parse5/lib/tokenizer/named_entity_data.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//NOTE: this file contains auto-generated array mapped radix tree that is used for the named entity references consumption
//(details: https://github.com/inikulin/parse5/tree/master/scripts/generate_named_entity_data/README.md)
module.exports = new Uint16Array([4,52,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,106,303,412,810,1432,1701,1796,1987,2114,2360,2420,2484,3170,3251,4140,4393,4575,4610,5106,5512,5728,6117,6274,6315,6345,6427,6516,7002,7910,8733,9323,9870,10170,10631,10893,11318,11386,11467,12773,13092,14474,14922,15448,15542,16419,17666,18166,18611,19004,19095,19298,19397,4,16,69,77,97,98,99,102,103,108,109,110,111,112,114,115,116,117,140,150,158,169,176,194,199,210,216,222,226,242,256,266,283,294,108,105,103,5,198,1,59,148,1,198,80,5,38,1,59,156,1,38,99,117,116,101,5,193,1,59,167,1,193,114,101,118,101,59,1,258,4,2,105,121,182,191,114,99,5,194,1,59,189,1,194,59,1,1040,114,59,3,55349,56580,114,97,118,101,5,192,1,59,208,1,192,112,104,97,59,1,913,97,99,114,59,1,256,100,59,1,10835,4,2,103,112,232,237,111,110,59,1,260,102,59,3,55349,56632,112,108,121,70,117,110,99,116,105,111,110,59,1,8289,105,110,103,5,197,1,59,264,1,197,4,2,99,115,272,277,114,59,3,55349,56476,105,103,110,59,1,8788,105,108,100,101,5,195,1,59,292,1,195,109,108,5,196,1,59,301,1,196,4,8,97,99,101,102,111,114,115,117,321,350,354,383,388,394,400,405,4,2,99,114,327,336,107,115,108,97,115,104,59,1,8726,4,2,118,119,342,345,59,1,10983,101,100,59,1,8966,121,59,1,1041,4,3,99,114,116,362,369,379,97,117,115,101,59,1,8757,110,111,117,108,108,105,115,59,1,8492,97,59,1,914,114,59,3,55349,56581,112,102,59,3,55349,56633,101,118,101,59,1,728,99,114,59,1,8492,109,112,101,113,59,1,8782,4,14,72,79,97,99,100,101,102,104,105,108,111,114,115,117,442,447,456,504,542,547,569,573,577,616,678,784,790,796,99,121,59,1,1063,80,89,5,169,1,59,454,1,169,4,3,99,112,121,464,470,497,117,116,101,59,1,262,4,2,59,105,476,478,1,8914,116,97,108,68,105,102,102,101,114,101,110,116,105,97,108,68,59,1,8517,108,101,121,115,59,1,8493,4,4,97,101,105,111,514,520,530,535,114,111,110,59,1,268,100,105,108,5,199,1,59,528,1,199,114,99,59,1,264,110,105,110,116,59,1,8752,111,116,59,1,266,4,2,100,110,553,560,105,108,108,97,59,1,184,116,101,114,68,111,116,59,1,183,114,59,1,8493,105,59,1,935,114,99,108,101,4,4,68,77,80,84,591,596,603,609,111,116,59,1,8857,105,110,117,115,59,1,8854,108,117,115,59,1,8853,105,109,101,115,59,1,8855,111,4,2,99,115,623,646,107,119,105,115,101,67,111,110,116,111,117,114,73,110,116,101,103,114,97,108,59,1,8754,101,67,117,114,108,121,4,2,68,81,658,671,111,117,98,108,101,81,117,111,116,101,59,1,8221,117,111,116,101,59,1,8217,4,4,108,110,112,117,688,701,736,753,111,110,4,2,59,101,696,698,1,8759,59,1,10868,4,3,103,105,116,709,717,722,114,117,101,110,116,59,1,8801,110,116,59,1,8751,111,117,114,73,110,116,101,103,114,97,108,59,1,8750,4,2,102,114,742,745,59,1,8450,111,100,117,99,116,59,1,8720,110,116,101,114,67,108,111,99,107,119,105,115,101,67,111,110,116,111,117,114,73,110,116,101,103,114,97,108,59,1,8755,111,115,115,59,1,10799,99,114,59,3,55349,56478,112,4,2,59,67,803,805,1,8915,97,112,59,1,8781,4,11,68,74,83,90,97,99,101,102,105,111,115,834,850,855,860,865,888,903,916,921,1011,1415,4,2,59,111,840,842,1,8517,116,114,97,104,100,59,1,10513,99,121,59,1,1026,99,121,59,1,1029,99,121,59,1,1039,4,3,103,114,115,873,879,883,103,101,114,59,1,8225,114,59,1,8609,104,118,59,1,10980,4,2,97,121,894,900,114,111,110,59,1,270,59,1,1044,108,4,2,59,116,910,912,1,8711,97,59,1,916,114,59,3,55349,56583,4,2,97,102,927,998,4,2,99,109,933,992,114,105,116,105,99,97,108,4,4,65,68,71,84,950,957,978,985,99,117,116,101,59,1,180,111,4,2,116,117,964,967,59,1,729,98,108,101,65,99,117,116,101,59,1,733,114,97,118,101,59,1,96,105,108,100,101,59,1,732,111,110,100,59,1,8900,102,101,114,101,110,116,105,97,108,68,59,1,8518,4,4,112,116,117,119,1021,1026,1048,1249,102,59,3,55349,56635,4,3,59,68,69,1034,1036,1041,1,168,111,116,59,1,8412,113,117,97,108,59,1,8784,98,108,101,4,6,67,68,76,82,85,86,1065,1082,1101,1189,1211,1236,111,110,116,111,117,114,73,110,116,101,103,114,97,108,59,1,8751,111,4,2,116,119,1089,1092,59,1,168,110,65,114,114,111,119,59,1,8659,4,2,101,111,1107,1141,102,116,4,3,65,82,84,1117,1124,1136,114,114,111,119,59,1,8656,105,103,104,116,65,114,114,111,119,59,1,8660,101,101,59,1,10980,110,103,4,2,76,82,1149,1177,101,102,116,4,2,65,82,1158,1165,114,114,111,119,59,1,10232,105,103,104,116,65,114,114,111,119,59,1,10234,105,103,104,116,65,114,114,111,119,59,1,10233,105,103,104,116,4,2,65,84,1199,1206,114,114,111,119,59,1,8658,101,101,59,1,8872,112,4,2,65,68,1218,1225,114,114,111,119,59,1,8657,111,119,110,65,114,114,111,119,59,1,8661,101,114,116,105,99,97,108,66,97,114,59,1,8741,110,4,6,65,66,76,82,84,97,1264,1292,1299,1352,1391,1408,114,114,111,119,4,3,59,66,85,1276,1278,1283,1,8595,97,114,59,1,10515,112,65,114,114,111,119,59,1,8693,114,101,118,101,59,1,785,101,102,116,4,3,82,84,86,1310,1323,1334,105,103,104,116,86,101,99,116,111,114,59,1,10576,101,101,86,101,99,116,111,114,59,1,10590,101,99,116,111,114,4,2,59,66,1345,1347,1,8637,97,114,59,1,10582,105,103,104,116,4,2,84,86,1362,1373,101,101,86,101,99,116,111,114,59,1,10591,101,99,116,111,114,4,2,59,66,1384,1386,1,8641,97,114,59,1,10583,101,101,4,2,59,65,1399,1401,1,8868,114,114,111,119,59,1,8615,114,114,111,119,59,1,8659,4,2,99,116,1421,1426,114,59,3,55349,56479,114,111,107,59,1,272,4,16,78,84,97,99,100,102,103,108,109,111,112,113,115,116,117,120,1466,1470,1478,1489,1515,1520,1525,1536,1544,1593,1609,1617,1650,1664,1668,1677,71,59,1,330,72,5,208,1,59,1476,1,208,99,117,116,101,5,201,1,59,1487,1,201,4,3,97,105,121,1497,1503,1512,114,111,110,59,1,282,114,99,5,202,1,59,1510,1,202,59,1,1069,111,116,59,1,278,114,59,3,55349,56584,114,97,118,101,5,200,1,59,1534,1,200,101,109,101,110,116,59,1,8712,4,2,97,112,1550,1555,99,114,59,1,274,116,121,4,2,83,86,1563,1576,109,97,108,108,83,113,117,97,114,101,59,1,9723,101,114,121,83,109,97,108,108,83,113,117,97,114,101,59,1,9643,4,2,103,112,1599,1604,111,110,59,1,280,102,59,3,55349,56636,115,105,108,111,110,59,1,917,117,4,2,97,105,1624,1640,108,4,2,59,84,1631,1633,1,10869,105,108,100,101,59,1,8770,108,105,98,114,105,117,109,59,1,8652,4,2,99,105,1656,1660,114,59,1,8496,109,59,1,10867,97,59,1,919,109,108,5,203,1,59,1675,1,203,4,2,105,112,1683,1689,115,116,115,59,1,8707,111,110,101,110,116,105,97,108,69,59,1,8519,4,5,99,102,105,111,115,1713,1717,1722,1762,1791,121,59,1,1060,114,59,3,55349,56585,108,108,101,100,4,2,83,86,1732,1745,109,97,108,108,83,113,117,97,114,101,59,1,9724,101,114,121,83,109,97,108,108,83,113,117,97,114,101,59,1,9642,4,3,112,114,117,1770,1775,1781,102,59,3,55349,56637,65,108,108,59,1,8704,114,105,101,114,116,114,102,59,1,8497,99,114,59,1,8497,4,12,74,84,97,98,99,100,102,103,111,114,115,116,1822,1827,1834,1848,1855,1877,1882,1887,1890,1896,1978,1984,99,121,59,1,1027,5,62,1,59,1832,1,62,109,109,97,4,2,59,100,1843,1845,1,915,59,1,988,114,101,118,101,59,1,286,4,3,101,105,121,1863,1869,1874,100,105,108,59,1,290,114,99,59,1,284,59,1,1043,111,116,59,1,288,114,59,3,55349,56586,59,1,8921,112,102,59,3,55349,56638,101,97,116,101,114,4,6,69,70,71,76,83,84,1915,1933,1944,1953,1959,1971,113,117,97,108,4,2,59,76,1925,1927,1,8805,101,115,115,59,1,8923,117,108,108,69,113,117,97,108,59,1,8807,114,101,97,116,101,114,59,1,10914,101,115,115,59,1,8823,108,97,110,116,69,113,117,97,108,59,1,10878,105,108,100,101,59,1,8819,99,114,59,3,55349,56482,59,1,8811,4,8,65,97,99,102,105,111,115,117,2005,2012,2026,2032,2036,2049,2073,2089,82,68,99,121,59,1,1066,4,2,99,116,2018,2023,101,107,59,1,711,59,1,94,105,114,99,59,1,292,114,59,1,8460,108,98,101,114,116,83,112,97,99,101,59,1,8459,4,2,112,114,2055,2059,102,59,1,8461,105,122,111,110,116,97,108,76,105,110,101,59,1,9472,4,2,99,116,2079,2083,114,59,1,8459,114,111,107,59,1,294,109,112,4,2,68,69,2097,2107,111,119,110,72,117,109,112,59,1,8782,113,117,97,108,59,1,8783,4,14,69,74,79,97,99,100,102,103,109,110,111,115,116,117,2144,2149,2155,2160,2171,2189,2194,2198,2209,2245,2307,2329,2334,2341,99,121,59,1,1045,108,105,103,59,1,306,99,121,59,1,1025,99,117,116,101,5,205,1,59,2169,1,205,4,2,105,121,2177,2186,114,99,5,206,1,59,2184,1,206,59,1,1048,111,116,59,1,304,114,59,1,8465,114,97,118,101,5,204,1,59,2207,1,204,4,3,59,97,112,2217,2219,2238,1,8465,4,2,99,103,2225,2229,114,59,1,298,105,110,97,114,121,73,59,1,8520,108,105,101,115,59,1,8658,4,2,116,118,2251,2281,4,2,59,101,2257,2259,1,8748,4,2,103,114,2265,2271,114,97,108,59,1,8747,115,101,99,116,105,111,110,59,1,8898,105,115,105,98,108,101,4,2,67,84,2293,2300,111,109,109,97,59,1,8291,105,109,101,115,59,1,8290,4,3,103,112,116,2315,2320,2325,111,110,59,1,302,102,59,3,55349,56640,97,59,1,921,99,114,59,1,8464,105,108,100,101,59,1,296,4,2,107,109,2347,2352,99,121,59,1,1030,108,5,207,1,59,2358,1,207,4,5,99,102,111,115,117,2372,2386,2391,2397,2414,4,2,105,121,2378,2383,114,99,59,1,308,59,1,1049,114,59,3,55349,56589,112,102,59,3,55349,56641,4,2,99,101,2403,2408,114,59,3,55349,56485,114,99,121,59,1,1032,107,99,121,59,1,1028,4,7,72,74,97,99,102,111,115,2436,2441,2446,2452,2467,2472,2478,99,121,59,1,1061,99,121,59,1,1036,112,112,97,59,1,922,4,2,101,121,2458,2464,100,105,108,59,1,310,59,1,1050,114,59,3,55349,56590,112,102,59,3,55349,56642,99,114,59,3,55349,56486,4,11,74,84,97,99,101,102,108,109,111,115,116,2508,2513,2520,2562,2585,2981,2986,3004,3011,3146,3167,99,121,59,1,1033,5,60,1,59,2518,1,60,4,5,99,109,110,112,114,2532,2538,2544,2548,2558,117,116,101,59,1,313,98,100,97,59,1,923,103,59,1,10218,108,97,99,101,116,114,102,59,1,8466,114,59,1,8606,4,3,97,101,121,2570,2576,2582,114,111,110,59,1,317,100,105,108,59,1,315,59,1,1051,4,2,102,115,2591,2907,116,4,10,65,67,68,70,82,84,85,86,97,114,2614,2663,2672,2728,2735,2760,2820,2870,2888,2895,4,2,110,114,2620,2633,103,108,101,66,114,97,99,107,101,116,59,1,10216,114,111,119,4,3,59,66,82,2644,2646,2651,1,8592,97,114,59,1,8676,105,103,104,116,65,114,114,111,119,59,1,8646,101,105,108,105,110,103,59,1,8968,111,4,2,117,119,2679,2692,98,108,101,66,114,97,99,107,101,116,59,1,10214,110,4,2,84,86,2699,2710,101,101,86,101,99,116,111,114,59,1,10593,101,99,116,111,114,4,2,59,66,2721,2723,1,8643,97,114,59,1,10585,108,111,111,114,59,1,8970,105,103,104,116,4,2,65,86,2745,2752,114,114,111,119,59,1,8596,101,99,116,111,114,59,1,10574,4,2,101,114,2766,2792,101,4,3,59,65,86,2775,2777,2784,1,8867,114,114,111,119,59,1,8612,101,99,116,111,114,59,1,10586,105,97,110,103,108,101,4,3,59,66,69,2806,2808,2813,1,8882,97,114,59,1,10703,113,117,97,108,59,1,8884,112,4,3,68,84,86,2829,2841,2852,111,119,110,86,101,99,116,111,114,59,1,10577,101,101,86,101,99,116,111,114,59,1,10592,101,99,116,111,114,4,2,59,66,2863,2865,1,8639,97,114,59,1,10584,101,99,116,111,114,4,2,59,66,2881,2883,1,8636,97,114,59,1,10578,114,114,111,119,59,1,8656,105,103,104,116,97,114,114,111,119,59,1,8660,115,4,6,69,70,71,76,83,84,2922,2936,2947,2956,2962,2974,113,117,97,108,71,114,101,97,116,101,114,59,1,8922,117,108,108,69,113,117,97,108,59,1,8806,114,101,97,116,101,114,59,1,8822,101,115,115,59,1,10913,108,97,110,116,69,113,117,97,108,59,1,10877,105,108,100,101,59,1,8818,114,59,3,55349,56591,4,2,59,101,2992,2994,1,8920,102,116,97,114,114,111,119,59,1,8666,105,100,111,116,59,1,319,4,3,110,112,119,3019,3110,3115,103,4,4,76,82,108,114,3030,3058,3070,3098,101,102,116,4,2,65,82,3039,3046,114,114,111,119,59,1,10229,105,103,104,116,65,114,114,111,119,59,1,10231,105,103,104,116,65,114,114,111,119,59,1,10230,101,102,116,4,2,97,114,3079,3086,114,114,111,119,59,1,10232,105,103,104,116,97,114,114,111,119,59,1,10234,105,103,104,116,97,114,114,111,119,59,1,10233,102,59,3,55349,56643,101,114,4,2,76,82,3123,3134,101,102,116,65,114,114,111,119,59,1,8601,105,103,104,116,65,114,114,111,119,59,1,8600,4,3,99,104,116,3154,3158,3161,114,59,1,8466,59,1,8624,114,111,107,59,1,321,59,1,8810,4,8,97,99,101,102,105,111,115,117,3188,3192,3196,3222,3227,3237,3243,3248,112,59,1,10501,121,59,1,1052,4,2,100,108,3202,3213,105,117,109,83,112,97,99,101,59,1,8287,108,105,110,116,114,102,59,1,8499,114,59,3,55349,56592,110,117,115,80,108,117,115,59,1,8723,112,102,59,3,55349,56644,99,114,59,1,8499,59,1,924,4,9,74,97,99,101,102,111,115,116,117,3271,3276,3283,3306,3422,3427,4120,4126,4137,99,121,59,1,1034,99,117,116,101,59,1,323,4,3,97,101,121,3291,3297,3303,114,111,110,59,1,327,100,105,108,59,1,325,59,1,1053,4,3,103,115,119,3314,3380,3415,97,116,105,118,101,4,3,77,84,86,3327,3340,3365,101,100,105,117,109,83,112,97,99,101,59,1,8203,104,105,4,2,99,110,3348,3357,107,83,112,97,99,101,59,1,8203,83,112,97,99,101,59,1,8203,101,114,121,84,104,105,110,83,112,97,99,101,59,1,8203,116,101,100,4,2,71,76,3389,3405,114,101,97,116,101,114,71,114,101,97,116,101,114,59,1,8811,101,115,115,76,101,115,115,59,1,8810,76,105,110,101,59,1,10,114,59,3,55349,56593,4,4,66,110,112,116,3437,3444,3460,3464,114,101,97,107,59,1,8288,66,114,101,97,107,105,110,103,83,112,97,99,101,59,1,160,102,59,1,8469,4,13,59,67,68,69,71,72,76,78,80,82,83,84,86,3492,3494,3517,3536,3578,3657,3685,3784,3823,3860,3915,4066,4107,1,10988,4,2,111,117,3500,3510,110,103,114,117,101,110,116,59,1,8802,112,67,97,112,59,1,8813,111,117,98,108,101,86,101,114,116,105,99,97,108,66,97,114,59,1,8742,4,3,108,113,120,3544,3552,3571,101,109,101,110,116,59,1,8713,117,97,108,4,2,59,84,3561,3563,1,8800,105,108,100,101,59,3,8770,824,105,115,116,115,59,1,8708,114,101,97,116,101,114,4,7,59,69,70,71,76,83,84,3600,3602,3609,3621,3631,3637,3650,1,8815,113,117,97,108,59,1,8817,117,108,108,69,113,117,97,108,59,3,8807,824,114,101,97,116,101,114,59,3,8811,824,101,115,115,59,1,8825,108,97,110,116,69,113,117,97,108,59,3,10878,824,105,108,100,101,59,1,8821,117,109,112,4,2,68,69,3666,3677,111,119,110,72,117,109,112,59,3,8782,824,113,117,97,108,59,3,8783,824,101,4,2,102,115,3692,3724,116,84,114,105,97,110,103,108,101,4,3,59,66,69,3709,3711,3717,1,8938,97,114,59,3,10703,824,113,117,97,108,59,1,8940,115,4,6,59,69,71,76,83,84,3739,3741,3748,3757,3764,3777,1,8814,113,117,97,108,59,1,8816,114,101,97,116,101,114,59,1,8824,101,115,115,59,3,8810,824,108,97,110,116,69,113,117,97,108,59,3,10877,824,105,108,100,101,59,1,8820,101,115,116,101,100,4,2,71,76,3795,3812,114,101,97,116,101,114,71,114,101,97,116,101,114,59,3,10914,824,101,115,115,76,101,115,115,59,3,10913,824,114,101,99,101,100,101,115,4,3,59,69,83,3838,3840,3848,1,8832,113,117,97,108,59,3,10927,824,108,97,110,116,69,113,117,97,108,59,1,8928,4,2,101,105,3866,3881,118,101,114,115,101,69,108,101,109,101,110,116,59,1,8716,103,104,116,84,114,105,97,110,103,108,101,4,3,59,66,69,3900,3902,3908,1,8939,97,114,59,3,10704,824,113,117,97,108,59,1,8941,4,2,113,117,3921,3973,117,97,114,101,83,117,4,2,98,112,3933,3952,115,101,116,4,2,59,69,3942,3945,3,8847,824,113,117,97,108,59,1,8930,101,114,115,101,116,4,2,59,69,3963,3966,3,8848,824,113,117,97,108,59,1,8931,4,3,98,99,112,3981,4000,4045,115,101,116,4,2,59,69,3990,3993,3,8834,8402,113,117,97,108,59,1,8840,99,101,101,100,115,4,4,59,69,83,84,4015,4017,4025,4037,1,8833,113,117,97,108,59,3,10928,824,108,97,110,116,69,113,117,97,108,59,1,8929,105,108,100,101,59,3,8831,824,101,114,115,101,116,4,2,59,69,4056,4059,3,8835,8402,113,117,97,108,59,1,8841,105,108,100,101,4,4,59,69,70,84,4080,4082,4089,4100,1,8769,113,117,97,108,59,1,8772,117,108,108,69,113,117,97,108,59,1,8775,105,108,100,101,59,1,8777,101,114,116,105,99,97,108,66,97,114,59,1,8740,99,114,59,3,55349,56489,105,108,100,101,5,209,1,59,4135,1,209,59,1,925,4,14,69,97,99,100,102,103,109,111,112,114,115,116,117,118,4170,4176,4187,4205,4212,4217,4228,4253,4259,4292,4295,4316,4337,4346,108,105,103,59,1,338,99,117,116,101,5,211,1,59,4185,1,211,4,2,105,121,4193,4202,114,99,5,212,1,59,4200,1,212,59,1,1054,98,108,97,99,59,1,336,114,59,3,55349,56594,114,97,118,101,5,210,1,59,4226,1,210,4,3,97,101,105,4236,4241,4246,99,114,59,1,332,103,97,59,1,937,99,114,111,110,59,1,927,112,102,59,3,55349,56646,101,110,67,117,114,108,121,4,2,68,81,4272,4285,111,117,98,108,101,81,117,111,116,101,59,1,8220,117,111,116,101,59,1,8216,59,1,10836,4,2,99,108,4301,4306,114,59,3,55349,56490,97,115,104,5,216,1,59,4314,1,216,105,4,2,108,109,4323,4332,100,101,5,213,1,59,4330,1,213,101,115,59,1,10807,109,108,5,214,1,59,4344,1,214,101,114,4,2,66,80,4354,4380,4,2,97,114,4360,4364,114,59,1,8254,97,99,4,2,101,107,4372,4375,59,1,9182,101,116,59,1,9140,97,114,101,110,116,104,101,115,105,115,59,1,9180,4,9,97,99,102,104,105,108,111,114,115,4413,4422,4426,4431,4435,4438,4448,4471,4561,114,116,105,97,108,68,59,1,8706,121,59,1,1055,114,59,3,55349,56595,105,59,1,934,59,1,928,117,115,77,105,110,117,115,59,1,177,4,2,105,112,4454,4467,110,99,97,114,101,112,108,97,110,101,59,1,8460,102,59,1,8473,4,4,59,101,105,111,4481,4483,4526,4531,1,10939,99,101,100,101,115,4,4,59,69,83,84,4498,4500,4507,4519,1,8826,113,117,97,108,59,1,10927,108,97,110,116,69,113,117,97,108,59,1,8828,105,108,100,101,59,1,8830,109,101,59,1,8243,4,2,100,112,4537,4543,117,99,116,59,1,8719,111,114,116,105,111,110,4,2,59,97,4555,4557,1,8759,108,59,1,8733,4,2,99,105,4567,4572,114,59,3,55349,56491,59,1,936,4,4,85,102,111,115,4585,4594,4599,4604,79,84,5,34,1,59,4592,1,34,114,59,3,55349,56596,112,102,59,1,8474,99,114,59,3,55349,56492,4,12,66,69,97,99,101,102,104,105,111,114,115,117,4636,4642,4650,4681,4704,4763,4767,4771,5047,5069,5081,5094,97,114,114,59,1,10512,71,5,174,1,59,4648,1,174,4,3,99,110,114,4658,4664,4668,117,116,101,59,1,340,103,59,1,10219,114,4,2,59,116,4675,4677,1,8608,108,59,1,10518,4,3,97,101,121,4689,4695,4701,114,111,110,59,1,344,100,105,108,59,1,342,59,1,1056,4,2,59,118,4710,4712,1,8476,101,114,115,101,4,2,69,85,4722,4748,4,2,108,113,4728,4736,101,109,101,110,116,59,1,8715,117,105,108,105,98,114,105,117,109,59,1,8651,112,69,113,117,105,108,105,98,114,105,117,109,59,1,10607,114,59,1,8476,111,59,1,929,103,104,116,4,8,65,67,68,70,84,85,86,97,4792,4840,4849,4905,4912,4972,5022,5040,4,2,110,114,4798,4811,103,108,101,66,114,97,99,107,101,116,59,1,10217,114,111,119,4,3,59,66,76,4822,4824,4829,1,8594,97,114,59,1,8677,101,102,116,65,114,114,111,119,59,1,8644,101,105,108,105,110,103,59,1,8969,111,4,2,117,119,4856,4869,98,108,101,66,114,97,99,107,101,116,59,1,10215,110,4,2,84,86,4876,4887,101,101,86,101,99,116,111,114,59,1,10589,101,99,116,111,114,4,2,59,66,4898,4900,1,8642,97,114,59,1,10581,108,111,111,114,59,1,8971,4,2,101,114,4918,4944,101,4,3,59,65,86,4927,4929,4936,1,8866,114,114,111,119,59,1,8614,101,99,116,111,114,59,1,10587,105,97,110,103,108,101,4,3,59,66,69,4958,4960,4965,1,8883,97,114,59,1,10704,113,117,97,108,59,1,8885,112,4,3,68,84,86,4981,4993,5004,111,119,110,86,101,99,116,111,114,59,1,10575,101,101,86,101,99,116,111,114,59,1,10588,101,99,116,111,114,4,2,59,66,5015,5017,1,8638,97,114,59,1,10580,101,99,116,111,114,4,2,59,66,5033,5035,1,8640,97,114,59,1,10579,114,114,111,119,59,1,8658,4,2,112,117,5053,5057,102,59,1,8477,110,100,73,109,112,108,105,101,115,59,1,10608,105,103,104,116,97,114,114,111,119,59,1,8667,4,2,99,104,5087,5091,114,59,1,8475,59,1,8625,108,101,68,101,108,97,121,101,100,59,1,10740,4,13,72,79,97,99,102,104,105,109,111,113,115,116,117,5134,5150,5157,5164,5198,5203,5259,5265,5277,5283,5374,5380,5385,4,2,67,99,5140,5146,72,99,121,59,1,1065,121,59,1,1064,70,84,99,121,59,1,1068,99,117,116,101,59,1,346,4,5,59,97,101,105,121,5176,5178,5184,5190,5195,1,10940,114,111,110,59,1,352,100,105,108,59,1,350,114,99,59,1,348,59,1,1057,114,59,3,55349,56598,111,114,116,4,4,68,76,82,85,5216,5227,5238,5250,111,119,110,65,114,114,111,119,59,1,8595,101,102,116,65,114,114,111,119,59,1,8592,105,103,104,116,65,114,114,111,119,59,1,8594,112,65,114,114,111,119,59,1,8593,103,109,97,59,1,931,97,108,108,67,105,114,99,108,101,59,1,8728,112,102,59,3,55349,56650,4,2,114,117,5289,5293,116,59,1,8730,97,114,101,4,4,59,73,83,85,5306,5308,5322,5367,1,9633,110,116,101,114,115,101,99,116,105,111,110,59,1,8851,117,4,2,98,112,5329,5347,115,101,116,4,2,59,69,5338,5340,1,8847,113,117,97,108,59,1,8849,101,114,115,101,116,4,2,59,69,5358,5360,1,8848,113,117,97,108,59,1,8850,110,105,111,110,59,1,8852,99,114,59,3,55349,56494,97,114,59,1,8902,4,4,98,99,109,112,5395,5420,5475,5478,4,2,59,115,5401,5403,1,8912,101,116,4,2,59,69,5411,5413,1,8912,113,117,97,108,59,1,8838,4,2,99,104,5426,5468,101,101,100,115,4,4,59,69,83,84,5440,5442,5449,5461,1,8827,113,117,97,108,59,1,10928,108,97,110,116,69,113,117,97,108,59,1,8829,105,108,100,101,59,1,8831,84,104,97,116,59,1,8715,59,1,8721,4,3,59,101,115,5486,5488,5507,1,8913,114,115,101,116,4,2,59,69,5498,5500,1,8835,113,117,97,108,59,1,8839,101,116,59,1,8913,4,11,72,82,83,97,99,102,104,105,111,114,115,5536,5546,5552,5567,5579,5602,5607,5655,5695,5701,5711,79,82,78,5,222,1,59,5544,1,222,65,68,69,59,1,8482,4,2,72,99,5558,5563,99,121,59,1,1035,121,59,1,1062,4,2,98,117,5573,5576,59,1,9,59,1,932,4,3,97,101,121,5587,5593,5599,114,111,110,59,1,356,100,105,108,59,1,354,59,1,1058,114,59,3,55349,56599,4,2,101,105,5613,5631,4,2,114,116,5619,5627,101,102,111,114,101,59,1,8756,97,59,1,920,4,2,99,110,5637,5647,107,83,112,97,99,101,59,3,8287,8202,83,112,97,99,101,59,1,8201,108,100,101,4,4,59,69,70,84,5668,5670,5677,5688,1,8764,113,117,97,108,59,1,8771,117,108,108,69,113,117,97,108,59,1,8773,105,108,100,101,59,1,8776,112,102,59,3,55349,56651,105,112,108,101,68,111,116,59,1,8411,4,2,99,116,5717,5722,114,59,3,55349,56495,114,111,107,59,1,358,4,14,97,98,99,100,102,103,109,110,111,112,114,115,116,117,5758,5789,5805,5823,5830,5835,5846,5852,5921,5937,6089,6095,6101,6108,4,2,99,114,5764,5774,117,116,101,5,218,1,59,5772,1,218,114,4,2,59,111,5781,5783,1,8607,99,105,114,59,1,10569,114,4,2,99,101,5796,5800,121,59,1,1038,118,101,59,1,364,4,2,105,121,5811,5820,114,99,5,219,1,59,5818,1,219,59,1,1059,98,108,97,99,59,1,368,114,59,3,55349,56600,114,97,118,101,5,217,1,59,5844,1,217,97,99,114,59,1,362,4,2,100,105,5858,5905,101,114,4,2,66,80,5866,5892,4,2,97,114,5872,5876,114,59,1,95,97,99,4,2,101,107,5884,5887,59,1,9183,101,116,59,1,9141,97,114,101,110,116,104,101,115,105,115,59,1,9181,111,110,4,2,59,80,5913,5915,1,8899,108,117,115,59,1,8846,4,2,103,112,5927,5932,111,110,59,1,370,102,59,3,55349,56652,4,8,65,68,69,84,97,100,112,115,5955,5985,5996,6009,6026,6033,6044,6075,114,114,111,119,4,3,59,66,68,5967,5969,5974,1,8593,97,114,59,1,10514,111,119,110,65,114,114,111,119,59,1,8645,111,119,110,65,114,114,111,119,59,1,8597,113,117,105,108,105,98,114,105,117,109,59,1,10606,101,101,4,2,59,65,6017,6019,1,8869,114,114,111,119,59,1,8613,114,114,111,119,59,1,8657,111,119,110,97,114,114,111,119,59,1,8661,101,114,4,2,76,82,6052,6063,101,102,116,65,114,114,111,119,59,1,8598,105,103,104,116,65,114,114,111,119,59,1,8599,105,4,2,59,108,6082,6084,1,978,111,110,59,1,933,105,110,103,59,1,366,99,114,59,3,55349,56496,105,108,100,101,59,1,360,109,108,5,220,1,59,6115,1,220,4,9,68,98,99,100,101,102,111,115,118,6137,6143,6148,6152,6166,6250,6255,6261,6267,97,115,104,59,1,8875,97,114,59,1,10987,121,59,1,1042,97,115,104,4,2,59,108,6161,6163,1,8873,59,1,10982,4,2,101,114,6172,6175,59,1,8897,4,3,98,116,121,6183,6188,6238,97,114,59,1,8214,4,2,59,105,6194,6196,1,8214,99,97,108,4,4,66,76,83,84,6209,6214,6220,6231,97,114,59,1,8739,105,110,101,59,1,124,101,112,97,114,97,116,111,114,59,1,10072,105,108,100,101,59,1,8768,84,104,105,110,83,112,97,99,101,59,1,8202,114,59,3,55349,56601,112,102,59,3,55349,56653,99,114,59,3,55349,56497,100,97,115,104,59,1,8874,4,5,99,101,102,111,115,6286,6292,6298,6303,6309,105,114,99,59,1,372,100,103,101,59,1,8896,114,59,3,55349,56602,112,102,59,3,55349,56654,99,114,59,3,55349,56498,4,4,102,105,111,115,6325,6330,6333,6339,114,59,3,55349,56603,59,1,926,112,102,59,3,55349,56655,99,114,59,3,55349,56499,4,9,65,73,85,97,99,102,111,115,117,6365,6370,6375,6380,6391,6405,6410,6416,6422,99,121,59,1,1071,99,121,59,1,1031,99,121,59,1,1070,99,117,116,101,5,221,1,59,6389,1,221,4,2,105,121,6397,6402,114,99,59,1,374,59,1,1067,114,59,3,55349,56604,112,102,59,3,55349,56656,99,114,59,3,55349,56500,109,108,59,1,376,4,8,72,97,99,100,101,102,111,115,6445,6450,6457,6472,6477,6501,6505,6510,99,121,59,1,1046,99,117,116,101,59,1,377,4,2,97,121,6463,6469,114,111,110,59,1,381,59,1,1047,111,116,59,1,379,4,2,114,116,6483,6497,111,87,105,100,116,104,83,112,97,99,101,59,1,8203,97,59,1,918,114,59,1,8488,112,102,59,1,8484,99,114,59,3,55349,56501,4,16,97,98,99,101,102,103,108,109,110,111,112,114,115,116,117,119,6550,6561,6568,6612,6622,6634,6645,6672,6699,6854,6870,6923,6933,6963,6974,6983,99,117,116,101,5,225,1,59,6559,1,225,114,101,118,101,59,1,259,4,6,59,69,100,105,117,121,6582,6584,6588,6591,6600,6609,1,8766,59,3,8766,819,59,1,8767,114,99,5,226,1,59,6598,1,226,116,101,5,180,1,59,6607,1,180,59,1,1072,108,105,103,5,230,1,59,6620,1,230,4,2,59,114,6628,6630,1,8289,59,3,55349,56606,114,97,118,101,5,224,1,59,6643,1,224,4,2,101,112,6651,6667,4,2,102,112,6657,6663,115,121,109,59,1,8501,104,59,1,8501,104,97,59,1,945,4,2,97,112,6678,6692,4,2,99,108,6684,6688,114,59,1,257,103,59,1,10815,5,38,1,59,6697,1,38,4,2,100,103,6705,6737,4,5,59,97,100,115,118,6717,6719,6724,6727,6734,1,8743,110,100,59,1,10837,59,1,10844,108,111,112,101,59,1,10840,59,1,10842,4,7,59,101,108,109,114,115,122,6753,6755,6758,6762,6814,6835,6848,1,8736,59,1,10660,101,59,1,8736,115,100,4,2,59,97,6770,6772,1,8737,4,8,97,98,99,100,101,102,103,104,6790,6793,6796,6799,6802,6805,6808,6811,59,1,10664,59,1,10665,59,1,10666,59,1,10667,59,1,10668,59,1,10669,59,1,10670,59,1,10671,116,4,2,59,118,6821,6823,1,8735,98,4,2,59,100,6830,6832,1,8894,59,1,10653,4,2,112,116,6841,6845,104,59,1,8738,59,1,197,97,114,114,59,1,9084,4,2,103,112,6860,6865,111,110,59,1,261,102,59,3,55349,56658,4,7,59,69,97,101,105,111,112,6886,6888,6891,6897,6900,6904,6908,1,8776,59,1,10864,99,105,114,59,1,10863,59,1,8778,100,59,1,8779,115,59,1,39,114,111,120,4,2,59,101,6917,6919,1,8776,113,59,1,8778,105,110,103,5,229,1,59,6931,1,229,4,3,99,116,121,6941,6946,6949,114,59,3,55349,56502,59,1,42,109,112,4,2,59,101,6957,6959,1,8776,113,59,1,8781,105,108,100,101,5,227,1,59,6972,1,227,109,108,5,228,1,59,6981,1,228,4,2,99,105,6989,6997,111,110,105,110,116,59,1,8755,110,116,59,1,10769,4,16,78,97,98,99,100,101,102,105,107,108,110,111,112,114,115,117,7036,7041,7119,7135,7149,7155,7219,7224,7347,7354,7463,7489,7786,7793,7814,7866,111,116,59,1,10989,4,2,99,114,7047,7094,107,4,4,99,101,112,115,7058,7064,7073,7080,111,110,103,59,1,8780,112,115,105,108,111,110,59,1,1014,114,105,109,101,59,1,8245,105,109,4,2,59,101,7088,7090,1,8765,113,59,1,8909,4,2,118,119,7100,7105,101,101,59,1,8893,101,100,4,2,59,103,7113,7115,1,8965,101,59,1,8965,114,107,4,2,59,116,7127,7129,1,9141,98,114,107,59,1,9142,4,2,111,121,7141,7146,110,103,59,1,8780,59,1,1073,113,117,111,59,1,8222,4,5,99,109,112,114,116,7167,7181,7188,7193,7199,97,117,115,4,2,59,101,7176,7178,1,8757,59,1,8757,112,116,121,118,59,1,10672,115,105,59,1,1014,110,111,117,59,1,8492,4,3,97,104,119,7207,7210,7213,59,1,946,59,1,8502,101,101,110,59,1,8812,114,59,3,55349,56607,103,4,7,99,111,115,116,117,118,119,7241,7262,7288,7305,7328,7335,7340,4,3,97,105,117,7249,7253,7258,112,59,1,8898,114,99,59,1,9711,112,59,1,8899,4,3,100,112,116,7270,7275,7281,111,116,59,1,10752,108,117,115,59,1,10753,105,109,101,115,59,1,10754,4,2,113,116,7294,7300,99,117,112,59,1,10758,97,114,59,1,9733,114,105,97,110,103,108,101,4,2,100,117,7318,7324,111,119,110,59,1,9661,112,59,1,9651,112,108,117,115,59,1,10756,101,101,59,1,8897,101,100,103,101,59,1,8896,97,114,111,119,59,1,10509,4,3,97,107,111,7362,7436,7458,4,2,99,110,7368,7432,107,4,3,108,115,116,7377,7386,7394,111,122,101,110,103,101,59,1,10731,113,117,97,114,101,59,1,9642,114,105,97,110,103,108,101,4,4,59,100,108,114,7411,7413,7419,7425,1,9652,111,119,110,59,1,9662,101,102,116,59,1,9666,105,103,104,116,59,1,9656,107,59,1,9251,4,2,49,51,7442,7454,4,2,50,52,7448,7451,59,1,9618,59,1,9617,52,59,1,9619,99,107,59,1,9608,4,2,101,111,7469,7485,4,2,59,113,7475,7478,3,61,8421,117,105,118,59,3,8801,8421,116,59,1,8976,4,4,112,116,119,120,7499,7504,7517,7523,102,59,3,55349,56659,4,2,59,116,7510,7512,1,8869,111,109,59,1,8869,116,105,101,59,1,8904,4,12,68,72,85,86,98,100,104,109,112,116,117,118,7549,7571,7597,7619,7655,7660,7682,7708,7715,7721,7728,7750,4,4,76,82,108,114,7559,7562,7565,7568,59,1,9559,59,1,9556,59,1,9558,59,1,9555,4,5,59,68,85,100,117,7583,7585,7588,7591,7594,1,9552,59,1,9574,59,1,9577,59,1,9572,59,1,9575,4,4,76,82,108,114,7607,7610,7613,7616,59,1,9565,59,1,9562,59,1,9564,59,1,9561,4,7,59,72,76,82,104,108,114,7635,7637,7640,7643,7646,7649,7652,1,9553,59,1,9580,59,1,9571,59,1,9568,59,1,9579,59,1,9570,59,1,9567,111,120,59,1,10697,4,4,76,82,108,114,7670,7673,7676,7679,59,1,9557,59,1,9554,59,1,9488,59,1,9484,4,5,59,68,85,100,117,7694,7696,7699,7702,7705,1,9472,59,1,9573,59,1,9576,59,1,9516,59,1,9524,105,110,117,115,59,1,8863,108,117,115,59,1,8862,105,109,101,115,59,1,8864,4,4,76,82,108,114,7738,7741,7744,7747,59,1,9563,59,1,9560,59,1,9496,59,1,9492,4,7,59,72,76,82,104,108,114,7766,7768,7771,7774,7777,7780,7783,1,9474,59,1,9578,59,1,9569,59,1,9566,59,1,9532,59,1,9508,59,1,9500,114,105,109,101,59,1,8245,4,2,101,118,7799,7804,118,101,59,1,728,98,97,114,5,166,1,59,7812,1,166,4,4,99,101,105,111,7824,7829,7834,7846,114,59,3,55349,56503,109,105,59,1,8271,109,4,2,59,101,7841,7843,1,8765,59,1,8909,108,4,3,59,98,104,7855,7857,7860,1,92,59,1,10693,115,117,98,59,1,10184,4,2,108,109,7872,7885,108,4,2,59,101,7879,7881,1,8226,116,59,1,8226,112,4,3,59,69,101,7894,7896,7899,1,8782,59,1,10926,4,2,59,113,7905,7907,1,8783,59,1,8783,4,15,97,99,100,101,102,104,105,108,111,114,115,116,117,119,121,7942,8021,8075,8080,8121,8126,8157,8279,8295,8430,8446,8485,8491,8707,8726,4,3,99,112,114,7950,7956,8007,117,116,101,59,1,263,4,6,59,97,98,99,100,115,7970,7972,7977,7984,7998,8003,1,8745,110,100,59,1,10820,114,99,117,112,59,1,10825,4,2,97,117,7990,7994,112,59,1,10827,112,59,1,10823,111,116,59,1,10816,59,3,8745,65024,4,2,101,111,8013,8017,116,59,1,8257,110,59,1,711,4,4,97,101,105,117,8031,8046,8056,8061,4,2,112,114,8037,8041,115,59,1,10829,111,110,59,1,269,100,105,108,5,231,1,59,8054,1,231,114,99,59,1,265,112,115,4,2,59,115,8069,8071,1,10828,109,59,1,10832,111,116,59,1,267,4,3,100,109,110,8088,8097,8104,105,108,5,184,1,59,8095,1,184,112,116,121,118,59,1,10674,116,5,162,2,59,101,8112,8114,1,162,114,100,111,116,59,1,183,114,59,3,55349,56608,4,3,99,101,105,8134,8138,8154,121,59,1,1095,99,107,4,2,59,109,8146,8148,1,10003,97,114,107,59,1,10003,59,1,967,114,4,7,59,69,99,101,102,109,115,8174,8176,8179,8258,8261,8268,8273,1,9675,59,1,10691,4,3,59,101,108,8187,8189,8193,1,710,113,59,1,8791,101,4,2,97,100,8200,8223,114,114,111,119,4,2,108,114,8210,8216,101,102,116,59,1,8634,105,103,104,116,59,1,8635,4,5,82,83,97,99,100,8235,8238,8241,8246,8252,59,1,174,59,1,9416,115,116,59,1,8859,105,114,99,59,1,8858,97,115,104,59,1,8861,59,1,8791,110,105,110,116,59,1,10768,105,100,59,1,10991,99,105,114,59,1,10690,117,98,115,4,2,59,117,8288,8290,1,9827,105,116,59,1,9827,4,4,108,109,110,112,8305,8326,8376,8400,111,110,4,2,59,101,8313,8315,1,58,4,2,59,113,8321,8323,1,8788,59,1,8788,4,2,109,112,8332,8344,97,4,2,59,116,8339,8341,1,44,59,1,64,4,3,59,102,108,8352,8354,8358,1,8705,110,59,1,8728,101,4,2,109,120,8365,8371,101,110,116,59,1,8705,101,115,59,1,8450,4,2,103,105,8382,8395,4,2,59,100,8388,8390,1,8773,111,116,59,1,10861,110,116,59,1,8750,4,3,102,114,121,8408,8412,8417,59,3,55349,56660,111,100,59,1,8720,5,169,2,59,115,8424,8426,1,169,114,59,1,8471,4,2,97,111,8436,8441,114,114,59,1,8629,115,115,59,1,10007,4,2,99,117,8452,8457,114,59,3,55349,56504,4,2,98,112,8463,8474,4,2,59,101,8469,8471,1,10959,59,1,10961,4,2,59,101,8480,8482,1,10960,59,1,10962,100,111,116,59,1,8943,4,7,100,101,108,112,114,118,119,8507,8522,8536,8550,8600,8697,8702,97,114,114,4,2,108,114,8516,8519,59,1,10552,59,1,10549,4,2,112,115,8528,8532,114,59,1,8926,99,59,1,8927,97,114,114,4,2,59,112,8545,8547,1,8630,59,1,10557,4,6,59,98,99,100,111,115,8564,8566,8573,8587,8592,8596,1,8746,114,99,97,112,59,1,10824,4,2,97,117,8579,8583,112,59,1,10822,112,59,1,10826,111,116,59,1,8845,114,59,1,10821,59,3,8746,65024,4,4,97,108,114,118,8610,8623,8663,8672,114,114,4,2,59,109,8618,8620,1,8631,59,1,10556,121,4,3,101,118,119,8632,8651,8656,113,4,2,112,115,8639,8645,114,101,99,59,1,8926,117,99,99,59,1,8927,101,101,59,1,8910,101,100,103,101,59,1,8911,101,110,5,164,1,59,8670,1,164,101,97,114,114,111,119,4,2,108,114,8684,8690,101,102,116,59,1,8630,105,103,104,116,59,1,8631,101,101,59,1,8910,101,100,59,1,8911,4,2,99,105,8713,8721,111,110,105,110,116,59,1,8754,110,116,59,1,8753,108,99,116,121,59,1,9005,4,19,65,72,97,98,99,100,101,102,104,105,106,108,111,114,115,116,117,119,122,8773,8778,8783,8821,8839,8854,8887,8914,8930,8944,9036,9041,9058,9197,9227,9258,9281,9297,9305,114,114,59,1,8659,97,114,59,1,10597,4,4,103,108,114,115,8793,8799,8805,8809,103,101,114,59,1,8224,101,116,104,59,1,8504,114,59,1,8595,104,4,2,59,118,8816,8818,1,8208,59,1,8867,4,2,107,108,8827,8834,97,114,111,119,59,1,10511,97,99,59,1,733,4,2,97,121,8845,8851,114,111,110,59,1,271,59,1,1076,4,3,59,97,111,8862,8864,8880,1,8518,4,2,103,114,8870,8876,103,101,114,59,1,8225,114,59,1,8650,116,115,101,113,59,1,10871,4,3,103,108,109,8895,8902,8907,5,176,1,59,8900,1,176,116,97,59,1,948,112,116,121,118,59,1,10673,4,2,105,114,8920,8926,115,104,116,59,1,10623,59,3,55349,56609,97,114,4,2,108,114,8938,8941,59,1,8643,59,1,8642,4,5,97,101,103,115,118,8956,8986,8989,8996,9001,109,4,3,59,111,115,8965,8967,8983,1,8900,110,100,4,2,59,115,8975,8977,1,8900,117,105,116,59,1,9830,59,1,9830,59,1,168,97,109,109,97,59,1,989,105,110,59,1,8946,4,3,59,105,111,9009,9011,9031,1,247,100,101,5,247,2,59,111,9020,9022,1,247,110,116,105,109,101,115,59,1,8903,110,120,59,1,8903,99,121,59,1,1106,99,4,2,111,114,9048,9053,114,110,59,1,8990,111,112,59,1,8973,4,5,108,112,116,117,119,9070,9076,9081,9130,9144,108,97,114,59,1,36,102,59,3,55349,56661,4,5,59,101,109,112,115,9093,9095,9109,9116,9122,1,729,113,4,2,59,100,9102,9104,1,8784,111,116,59,1,8785,105,110,117,115,59,1,8760,108,117,115,59,1,8724,113,117,97,114,101,59,1,8865,98,108,101,98,97,114,119,101,100,103,101,59,1,8966,110,4,3,97,100,104,9153,9160,9172,114,114,111,119,59,1,8595,111,119,110,97,114,114,111,119,115,59,1,8650,97,114,112,111,111,110,4,2,108,114,9184,9190,101,102,116,59,1,8643,105,103,104,116,59,1,8642,4,2,98,99,9203,9211,107,97,114,111,119,59,1,10512,4,2,111,114,9217,9222,114,110,59,1,8991,111,112,59,1,8972,4,3,99,111,116,9235,9248,9252,4,2,114,121,9241,9245,59,3,55349,56505,59,1,1109,108,59,1,10742,114,111,107,59,1,273,4,2,100,114,9264,9269,111,116,59,1,8945,105,4,2,59,102,9276,9278,1,9663,59,1,9662,4,2,97,104,9287,9292,114,114,59,1,8693,97,114,59,1,10607,97,110,103,108,101,59,1,10662,4,2,99,105,9311,9315,121,59,1,1119,103,114,97,114,114,59,1,10239,4,18,68,97,99,100,101,102,103,108,109,110,111,112,113,114,115,116,117,120,9361,9376,9398,9439,9444,9447,9462,9495,9531,9585,9598,9614,9659,9755,9771,9792,9808,9826,4,2,68,111,9367,9372,111,116,59,1,10871,116,59,1,8785,4,2,99,115,9382,9392,117,116,101,5,233,1,59,9390,1,233,116,101,114,59,1,10862,4,4,97,105,111,121,9408,9414,9430,9436,114,111,110,59,1,283,114,4,2,59,99,9421,9423,1,8790,5,234,1,59,9428,1,234,108,111,110,59,1,8789,59,1,1101,111,116,59,1,279,59,1,8519,4,2,68,114,9453,9458,111,116,59,1,8786,59,3,55349,56610,4,3,59,114,115,9470,9472,9482,1,10906,97,118,101,5,232,1,59,9480,1,232,4,2,59,100,9488,9490,1,10902,111,116,59,1,10904,4,4,59,105,108,115,9505,9507,9515,9518,1,10905,110,116,101,114,115,59,1,9191,59,1,8467,4,2,59,100,9524,9526,1,10901,111,116,59,1,10903,4,3,97,112,115,9539,9544,9564,99,114,59,1,275,116,121,4,3,59,115,118,9554,9556,9561,1,8709,101,116,59,1,8709,59,1,8709,112,4,2,49,59,9571,9583,4,2,51,52,9577,9580,59,1,8196,59,1,8197,1,8195,4,2,103,115,9591,9594,59,1,331,112,59,1,8194,4,2,103,112,9604,9609,111,110,59,1,281,102,59,3,55349,56662,4,3,97,108,115,9622,9635,9640,114,4,2,59,115,9629,9631,1,8917,108,59,1,10723,117,115,59,1,10865,105,4,3,59,108,118,9649,9651,9656,1,949,111,110,59,1,949,59,1,1013,4,4,99,115,117,118,9669,9686,9716,9747,4,2,105,111,9675,9680,114,99,59,1,8790,108,111,110,59,1,8789,4,2,105,108,9692,9696,109,59,1,8770,97,110,116,4,2,103,108,9705,9710,116,114,59,1,10902,101,115,115,59,1,10901,4,3,97,101,105,9724,9729,9734,108,115,59,1,61,115,116,59,1,8799,118,4,2,59,68,9741,9743,1,8801,68,59,1,10872,112,97,114,115,108,59,1,10725,4,2,68,97,9761,9766,111,116,59,1,8787,114,114,59,1,10609,4,3,99,100,105,9779,9783,9788,114,59,1,8495,111,116,59,1,8784,109,59,1,8770,4,2,97,104,9798,9801,59,1,951,5,240,1,59,9806,1,240,4,2,109,114,9814,9822,108,5,235,1,59,9820,1,235,111,59,1,8364,4,3,99,105,112,9834,9838,9843,108,59,1,33,115,116,59,1,8707,4,2,101,111,9849,9859,99,116,97,116,105,111,110,59,1,8496,110,101,110,116,105,97,108,101,59,1,8519,4,12,97,99,101,102,105,106,108,110,111,112,114,115,9896,9910,9914,9921,9954,9960,9967,9989,9994,10027,10036,10164,108,108,105,110,103,100,111,116,115,101,113,59,1,8786,121,59,1,1092,109,97,108,101,59,1,9792,4,3,105,108,114,9929,9935,9950,108,105,103,59,1,64259,4,2,105,108,9941,9945,103,59,1,64256,105,103,59,1,64260,59,3,55349,56611,108,105,103,59,1,64257,108,105,103,59,3,102,106,4,3,97,108,116,9975,9979,9984,116,59,1,9837,105,103,59,1,64258,110,115,59,1,9649,111,102,59,1,402,4,2,112,114,10000,10005,102,59,3,55349,56663,4,2,97,107,10011,10016,108,108,59,1,8704,4,2,59,118,10022,10024,1,8916,59,1,10969,97,114,116,105,110,116,59,1,10765,4,2,97,111,10042,10159,4,2,99,115,10048,10155,4,6,49,50,51,52,53,55,10062,10102,10114,10135,10139,10151,4,6,50,51,52,53,54,56,10076,10083,10086,10093,10096,10099,5,189,1,59,10081,1,189,59,1,8531,5,188,1,59,10091,1,188,59,1,8533,59,1,8537,59,1,8539,4,2,51,53,10108,10111,59,1,8532,59,1,8534,4,3,52,53,56,10122,10129,10132,5,190,1,59,10127,1,190,59,1,8535,59,1,8540,53,59,1,8536,4,2,54,56,10145,10148,59,1,8538,59,1,8541,56,59,1,8542,108,59,1,8260,119,110,59,1,8994,99,114,59,3,55349,56507,4,17,69,97,98,99,100,101,102,103,105,106,108,110,111,114,115,116,118,10206,10217,10247,10254,10268,10273,10358,10363,10374,10380,10385,10406,10458,10464,10470,10497,10610,4,2,59,108,10212,10214,1,8807,59,1,10892,4,3,99,109,112,10225,10231,10244,117,116,101,59,1,501,109,97,4,2,59,100,10239,10241,1,947,59,1,989,59,1,10886,114,101,118,101,59,1,287,4,2,105,121,10260,10265,114,99,59,1,285,59,1,1075,111,116,59,1,289,4,4,59,108,113,115,10283,10285,10288,10308,1,8805,59,1,8923,4,3,59,113,115,10296,10298,10301,1,8805,59,1,8807,108,97,110,116,59,1,10878,4,4,59,99,100,108,10318,10320,10324,10345,1,10878,99,59,1,10921,111,116,4,2,59,111,10332,10334,1,10880,4,2,59,108,10340,10342,1,10882,59,1,10884,4,2,59,101,10351,10354,3,8923,65024,115,59,1,10900,114,59,3,55349,56612,4,2,59,103,10369,10371,1,8811,59,1,8921,109,101,108,59,1,8503,99,121,59,1,1107,4,4,59,69,97,106,10395,10397,10400,10403,1,8823,59,1,10898,59,1,10917,59,1,10916,4,4,69,97,101,115,10416,10419,10434,10453,59,1,8809,112,4,2,59,112,10426,10428,1,10890,114,111,120,59,1,10890,4,2,59,113,10440,10442,1,10888,4,2,59,113,10448,10450,1,10888,59,1,8809,105,109,59,1,8935,112,102,59,3,55349,56664,97,118,101,59,1,96,4,2,99,105,10476,10480,114,59,1,8458,109,4,3,59,101,108,10489,10491,10494,1,8819,59,1,10894,59,1,10896,5,62,6,59,99,100,108,113,114,10512,10514,10527,10532,10538,10545,1,62,4,2,99,105,10520,10523,59,1,10919,114,59,1,10874,111,116,59,1,8919,80,97,114,59,1,10645,117,101,115,116,59,1,10876,4,5,97,100,101,108,115,10557,10574,10579,10599,10605,4,2,112,114,10563,10570,112,114,111,120,59,1,10886,114,59,1,10616,111,116,59,1,8919,113,4,2,108,113,10586,10592,101,115,115,59,1,8923,108,101,115,115,59,1,10892,101,115,115,59,1,8823,105,109,59,1,8819,4,2,101,110,10616,10626,114,116,110,101,113,113,59,3,8809,65024,69,59,3,8809,65024,4,10,65,97,98,99,101,102,107,111,115,121,10653,10658,10713,10718,10724,10760,10765,10786,10850,10875,114,114,59,1,8660,4,4,105,108,109,114,10668,10674,10678,10684,114,115,112,59,1,8202,102,59,1,189,105,108,116,59,1,8459,4,2,100,114,10690,10695,99,121,59,1,1098,4,3,59,99,119,10703,10705,10710,1,8596,105,114,59,1,10568,59,1,8621,97,114,59,1,8463,105,114,99,59,1,293,4,3,97,108,114,10732,10748,10754,114,116,115,4,2,59,117,10741,10743,1,9829,105,116,59,1,9829,108,105,112,59,1,8230,99,111,110,59,1,8889,114,59,3,55349,56613,115,4,2,101,119,10772,10779,97,114,111,119,59,1,10533,97,114,111,119,59,1,10534,4,5,97,109,111,112,114,10798,10803,10809,10839,10844,114,114,59,1,8703,116,104,116,59,1,8763,107,4,2,108,114,10816,10827,101,102,116,97,114,114,111,119,59,1,8617,105,103,104,116,97,114,114,111,119,59,1,8618,102,59,3,55349,56665,98,97,114,59,1,8213,4,3,99,108,116,10858,10863,10869,114,59,3,55349,56509,97,115,104,59,1,8463,114,111,107,59,1,295,4,2,98,112,10881,10887,117,108,108,59,1,8259,104,101,110,59,1,8208,4,15,97,99,101,102,103,105,106,109,110,111,112,113,115,116,117,10925,10936,10958,10977,10990,11001,11039,11045,11101,11192,11220,11226,11237,11285,11299,99,117,116,101,5,237,1,59,10934,1,237,4,3,59,105,121,10944,10946,10955,1,8291,114,99,5,238,1,59,10953,1,238,59,1,1080,4,2,99,120,10964,10968,121,59,1,1077,99,108,5,161,1,59,10975,1,161,4,2,102,114,10983,10986,59,1,8660,59,3,55349,56614,114,97,118,101,5,236,1,59,10999,1,236,4,4,59,105,110,111,11011,11013,11028,11034,1,8520,4,2,105,110,11019,11024,110,116,59,1,10764,116,59,1,8749,102,105,110,59,1,10716,116,97,59,1,8489,108,105,103,59,1,307,4,3,97,111,112,11053,11092,11096,4,3,99,103,116,11061,11065,11088,114,59,1,299,4,3,101,108,112,11073,11076,11082,59,1,8465,105,110,101,59,1,8464,97,114,116,59,1,8465,104,59,1,305,102,59,1,8887,101,100,59,1,437,4,5,59,99,102,111,116,11113,11115,11121,11136,11142,1,8712,97,114,101,59,1,8453,105,110,4,2,59,116,11129,11131,1,8734,105,101,59,1,10717,100,111,116,59,1,305,4,5,59,99,101,108,112,11154,11156,11161,11179,11186,1,8747,97,108,59,1,8890,4,2,103,114,11167,11173,101,114,115,59,1,8484,99,97,108,59,1,8890,97,114,104,107,59,1,10775,114,111,100,59,1,10812,4,4,99,103,112,116,11202,11206,11211,11216,121,59,1,1105,111,110,59,1,303,102,59,3,55349,56666,97,59,1,953,114,111,100,59,1,10812,117,101,115,116,5,191,1,59,11235,1,191,4,2,99,105,11243,11248,114,59,3,55349,56510,110,4,5,59,69,100,115,118,11261,11263,11266,11271,11282,1,8712,59,1,8953,111,116,59,1,8949,4,2,59,118,11277,11279,1,8948,59,1,8947,59,1,8712,4,2,59,105,11291,11293,1,8290,108,100,101,59,1,297,4,2,107,109,11305,11310,99,121,59,1,1110,108,5,239,1,59,11316,1,239,4,6,99,102,109,111,115,117,11332,11346,11351,11357,11363,11380,4,2,105,121,11338,11343,114,99,59,1,309,59,1,1081,114,59,3,55349,56615,97,116,104,59,1,567,112,102,59,3,55349,56667,4,2,99,101,11369,11374,114,59,3,55349,56511,114,99,121,59,1,1112,107,99,121,59,1,1108,4,8,97,99,102,103,104,106,111,115,11404,11418,11433,11438,11445,11450,11455,11461,112,112,97,4,2,59,118,11413,11415,1,954,59,1,1008,4,2,101,121,11424,11430,100,105,108,59,1,311,59,1,1082,114,59,3,55349,56616,114,101,101,110,59,1,312,99,121,59,1,1093,99,121,59,1,1116,112,102,59,3,55349,56668,99,114,59,3,55349,56512,4,23,65,66,69,72,97,98,99,100,101,102,103,104,106,108,109,110,111,112,114,115,116,117,118,11515,11538,11544,11555,11560,11721,11780,11818,11868,12136,12160,12171,12203,12208,12246,12275,12327,12509,12523,12569,12641,12732,12752,4,3,97,114,116,11523,11528,11532,114,114,59,1,8666,114,59,1,8656,97,105,108,59,1,10523,97,114,114,59,1,10510,4,2,59,103,11550,11552,1,8806,59,1,10891,97,114,59,1,10594,4,9,99,101,103,109,110,112,113,114,116,11580,11586,11594,11600,11606,11624,11627,11636,11694,117,116,101,59,1,314,109,112,116,121,118,59,1,10676,114,97,110,59,1,8466,98,100,97,59,1,955,103,4,3,59,100,108,11615,11617,11620,1,10216,59,1,10641,101,59,1,10216,59,1,10885,117,111,5,171,1,59,11634,1,171,114,4,8,59,98,102,104,108,112,115,116,11655,11657,11669,11673,11677,11681,11685,11690,1,8592,4,2,59,102,11663,11665,1,8676,115,59,1,10527,115,59,1,10525,107,59,1,8617,112,59,1,8619,108,59,1,10553,105,109,59,1,10611,108,59,1,8610,4,3,59,97,101,11702,11704,11709,1,10923,105,108,59,1,10521,4,2,59,115,11715,11717,1,10925,59,3,10925,65024,4,3,97,98,114,11729,11734,11739,114,114,59,1,10508,114,107,59,1,10098,4,2,97,107,11745,11758,99,4,2,101,107,11752,11755,59,1,123,59,1,91,4,2,101,115,11764,11767,59,1,10635,108,4,2,100,117,11774,11777,59,1,10639,59,1,10637,4,4,97,101,117,121,11790,11796,11811,11815,114,111,110,59,1,318,4,2,100,105,11802,11807,105,108,59,1,316,108,59,1,8968,98,59,1,123,59,1,1083,4,4,99,113,114,115,11828,11832,11845,11864,97,59,1,10550,117,111,4,2,59,114,11840,11842,1,8220,59,1,8222,4,2,100,117,11851,11857,104,97,114,59,1,10599,115,104,97,114,59,1,10571,104,59,1,8626,4,5,59,102,103,113,115,11880,11882,12008,12011,12031,1,8804,116,4,5,97,104,108,114,116,11895,11913,11935,11947,11996,114,114,111,119,4,2,59,116,11905,11907,1,8592,97,105,108,59,1,8610,97,114,112,111,111,110,4,2,100,117,11925,11931,111,119,110,59,1,8637,112,59,1,8636,101,102,116,97,114,114,111,119,115,59,1,8647,105,103,104,116,4,3,97,104,115,11959,11974,11984,114,114,111,119,4,2,59,115,11969,11971,1,8596,59,1,8646,97,114,112,111,111,110,115,59,1,8651,113,117,105,103,97,114,114,111,119,59,1,8621,104,114,101,101,116,105,109,101,115,59,1,8907,59,1,8922,4,3,59,113,115,12019,12021,12024,1,8804,59,1,8806,108,97,110,116,59,1,10877,4,5,59,99,100,103,115,12043,12045,12049,12070,12083,1,10877,99,59,1,10920,111,116,4,2,59,111,12057,12059,1,10879,4,2,59,114,12065,12067,1,10881,59,1,10883,4,2,59,101,12076,12079,3,8922,65024,115,59,1,10899,4,5,97,100,101,103,115,12095,12103,12108,12126,12131,112,112,114,111,120,59,1,10885,111,116,59,1,8918,113,4,2,103,113,12115,12120,116,114,59,1,8922,103,116,114,59,1,10891,116,114,59,1,8822,105,109,59,1,8818,4,3,105,108,114,12144,12150,12156,115,104,116,59,1,10620,111,111,114,59,1,8970,59,3,55349,56617,4,2,59,69,12166,12168,1,8822,59,1,10897,4,2,97,98,12177,12198,114,4,2,100,117,12184,12187,59,1,8637,4,2,59,108,12193,12195,1,8636,59,1,10602,108,107,59,1,9604,99,121,59,1,1113,4,5,59,97,99,104,116,12220,12222,12227,12235,12241,1,8810,114,114,59,1,8647,111,114,110,101,114,59,1,8990,97,114,100,59,1,10603,114,105,59,1,9722,4,2,105,111,12252,12258,100,111,116,59,1,320,117,115,116,4,2,59,97,12267,12269,1,9136,99,104,101,59,1,9136,4,4,69,97,101,115,12285,12288,12303,12322,59,1,8808,112,4,2,59,112,12295,12297,1,10889,114,111,120,59,1,10889,4,2,59,113,12309,12311,1,10887,4,2,59,113,12317,12319,1,10887,59,1,8808,105,109,59,1,8934,4,8,97,98,110,111,112,116,119,122,12345,12359,12364,12421,12446,12467,12474,12490,4,2,110,114,12351,12355,103,59,1,10220,114,59,1,8701,114,107,59,1,10214,103,4,3,108,109,114,12373,12401,12409,101,102,116,4,2,97,114,12382,12389,114,114,111,119,59,1,10229,105,103,104,116,97,114,114,111,119,59,1,10231,97,112,115,116,111,59,1,10236,105,103,104,116,97,114,114,111,119,59,1,10230,112,97,114,114,111,119,4,2,108,114,12433,12439,101,102,116,59,1,8619,105,103,104,116,59,1,8620,4,3,97,102,108,12454,12458,12462,114,59,1,10629,59,3,55349,56669,117,115,59,1,10797,105,109,101,115,59,1,10804,4,2,97,98,12480,12485,115,116,59,1,8727,97,114,59,1,95,4,3,59,101,102,12498,12500,12506,1,9674,110,103,101,59,1,9674,59,1,10731,97,114,4,2,59,108,12517,12519,1,40,116,59,1,10643,4,5,97,99,104,109,116,12535,12540,12548,12561,12564,114,114,59,1,8646,111,114,110,101,114,59,1,8991,97,114,4,2,59,100,12556,12558,1,8651,59,1,10605,59,1,8206,114,105,59,1,8895,4,6,97,99,104,105,113,116,12583,12589,12594,12597,12614,12635,113,117,111,59,1,8249,114,59,3,55349,56513,59,1,8624,109,4,3,59,101,103,12606,12608,12611,1,8818,59,1,10893,59,1,10895,4,2,98,117,12620,12623,59,1,91,111,4,2,59,114,12630,12632,1,8216,59,1,8218,114,111,107,59,1,322,5,60,8,59,99,100,104,105,108,113,114,12660,12662,12675,12680,12686,12692,12698,12705,1,60,4,2,99,105,12668,12671,59,1,10918,114,59,1,10873,111,116,59,1,8918,114,101,101,59,1,8907,109,101,115,59,1,8905,97,114,114,59,1,10614,117,101,115,116,59,1,10875,4,2,80,105,12711,12716,97,114,59,1,10646,4,3,59,101,102,12724,12726,12729,1,9667,59,1,8884,59,1,9666,114,4,2,100,117,12739,12746,115,104,97,114,59,1,10570,104,97,114,59,1,10598,4,2,101,110,12758,12768,114,116,110,101,113,113,59,3,8808,65024,69,59,3,8808,65024,4,14,68,97,99,100,101,102,104,105,108,110,111,112,115,117,12803,12809,12893,12908,12914,12928,12933,12937,13011,13025,13032,13049,13052,13069,68,111,116,59,1,8762,4,4,99,108,112,114,12819,12827,12849,12887,114,5,175,1,59,12825,1,175,4,2,101,116,12833,12836,59,1,9794,4,2,59,101,12842,12844,1,10016,115,101,59,1,10016,4,2,59,115,12855,12857,1,8614,116,111,4,4,59,100,108,117,12869,12871,12877,12883,1,8614,111,119,110,59,1,8615,101,102,116,59,1,8612,112,59,1,8613,107,101,114,59,1,9646,4,2,111,121,12899,12905,109,109,97,59,1,10793,59,1,1084,97,115,104,59,1,8212,97,115,117,114,101,100,97,110,103,108,101,59,1,8737,114,59,3,55349,56618,111,59,1,8487,4,3,99,100,110,12945,12954,12985,114,111,5,181,1,59,12952,1,181,4,4,59,97,99,100,12964,12966,12971,12976,1,8739,115,116,59,1,42,105,114,59,1,10992,111,116,5,183,1,59,12983,1,183,117,115,4,3,59,98,100,12995,12997,13000,1,8722,59,1,8863,4,2,59,117,13006,13008,1,8760,59,1,10794,4,2,99,100,13017,13021,112,59,1,10971,114,59,1,8230,112,108,117,115,59,1,8723,4,2,100,112,13038,13044,101,108,115,59,1,8871,102,59,3,55349,56670,59,1,8723,4,2,99,116,13058,13063,114,59,3,55349,56514,112,111,115,59,1,8766,4,3,59,108,109,13077,13079,13087,1,956,116,105,109,97,112,59,1,8888,97,112,59,1,8888,4,24,71,76,82,86,97,98,99,100,101,102,103,104,105,106,108,109,111,112,114,115,116,117,118,119,13142,13165,13217,13229,13247,13330,13359,13414,13420,13508,13513,13579,13602,13626,13631,13762,13767,13855,13936,13995,14214,14285,14312,14432,4,2,103,116,13148,13152,59,3,8921,824,4,2,59,118,13158,13161,3,8811,8402,59,3,8811,824,4,3,101,108,116,13173,13200,13204,102,116,4,2,97,114,13181,13188,114,114,111,119,59,1,8653,105,103,104,116,97,114,114,111,119,59,1,8654,59,3,8920,824,4,2,59,118,13210,13213,3,8810,8402,59,3,8810,824,105,103,104,116,97,114,114,111,119,59,1,8655,4,2,68,100,13235,13241,97,115,104,59,1,8879,97,115,104,59,1,8878,4,5,98,99,110,112,116,13259,13264,13270,13275,13308,108,97,59,1,8711,117,116,101,59,1,324,103,59,3,8736,8402,4,5,59,69,105,111,112,13287,13289,13293,13298,13302,1,8777,59,3,10864,824,100,59,3,8779,824,115,59,1,329,114,111,120,59,1,8777,117,114,4,2,59,97,13316,13318,1,9838,108,4,2,59,115,13325,13327,1,9838,59,1,8469,4,2,115,117,13336,13344,112,5,160,1,59,13342,1,160,109,112,4,2,59,101,13352,13355,3,8782,824,59,3,8783,824,4,5,97,101,111,117,121,13371,13385,13391,13407,13411,4,2,112,114,13377,13380,59,1,10819,111,110,59,1,328,100,105,108,59,1,326,110,103,4,2,59,100,13399,13401,1,8775,111,116,59,3,10861,824,112,59,1,10818,59,1,1085,97,115,104,59,1,8211,4,7,59,65,97,100,113,115,120,13436,13438,13443,13466,13472,13478,13494,1,8800,114,114,59,1,8663,114,4,2,104,114,13450,13454,107,59,1,10532,4,2,59,111,13460,13462,1,8599,119,59,1,8599,111,116,59,3,8784,824,117,105,118,59,1,8802,4,2,101,105,13484,13489,97,114,59,1,10536,109,59,3,8770,824,105,115,116,4,2,59,115,13503,13505,1,8708,59,1,8708,114,59,3,55349,56619,4,4,69,101,115,116,13523,13527,13563,13568,59,3,8807,824,4,3,59,113,115,13535,13537,13559,1,8817,4,3,59,113,115,13545,13547,13551,1,8817,59,3,8807,824,108,97,110,116,59,3,10878,824,59,3,10878,824,105,109,59,1,8821,4,2,59,114,13574,13576,1,8815,59,1,8815,4,3,65,97,112,13587,13592,13597,114,114,59,1,8654,114,114,59,1,8622,97,114,59,1,10994,4,3,59,115,118,13610,13612,13623,1,8715,4,2,59,100,13618,13620,1,8956,59,1,8954,59,1,8715,99,121,59,1,1114,4,7,65,69,97,100,101,115,116,13647,13652,13656,13661,13665,13737,13742,114,114,59,1,8653,59,3,8806,824,114,114,59,1,8602,114,59,1,8229,4,4,59,102,113,115,13675,13677,13703,13725,1,8816,116,4,2,97,114,13684,13691,114,114,111,119,59,1,8602,105,103,104,116,97,114,114,111,119,59,1,8622,4,3,59,113,115,13711,13713,13717,1,8816,59,3,8806,824,108,97,110,116,59,3,10877,824,4,2,59,115,13731,13734,3,10877,824,59,1,8814,105,109,59,1,8820,4,2,59,114,13748,13750,1,8814,105,4,2,59,101,13757,13759,1,8938,59,1,8940,105,100,59,1,8740,4,2,112,116,13773,13778,102,59,3,55349,56671,5,172,3,59,105,110,13787,13789,13829,1,172,110,4,4,59,69,100,118,13800,13802,13806,13812,1,8713,59,3,8953,824,111,116,59,3,8949,824,4,3,97,98,99,13820,13823,13826,59,1,8713,59,1,8951,59,1,8950,105,4,2,59,118,13836,13838,1,8716,4,3,97,98,99,13846,13849,13852,59,1,8716,59,1,8958,59,1,8957,4,3,97,111,114,13863,13892,13899,114,4,4,59,97,115,116,13874,13876,13883,13888,1,8742,108,108,101,108,59,1,8742,108,59,3,11005,8421,59,3,8706,824,108,105,110,116,59,1,10772,4,3,59,99,101,13907,13909,13914,1,8832,117,101,59,1,8928,4,2,59,99,13920,13923,3,10927,824,4,2,59,101,13929,13931,1,8832,113,59,3,10927,824,4,4,65,97,105,116,13946,13951,13971,13982,114,114,59,1,8655,114,114,4,3,59,99,119,13961,13963,13967,1,8603,59,3,10547,824,59,3,8605,824,103,104,116,97,114,114,111,119,59,1,8603,114,105,4,2,59,101,13990,13992,1,8939,59,1,8941,4,7,99,104,105,109,112,113,117,14011,14036,14060,14080,14085,14090,14106,4,4,59,99,101,114,14021,14023,14028,14032,1,8833,117,101,59,1,8929,59,3,10928,824,59,3,55349,56515,111,114,116,4,2,109,112,14045,14050,105,100,59,1,8740,97,114,97,108,108,101,108,59,1,8742,109,4,2,59,101,14067,14069,1,8769,4,2,59,113,14075,14077,1,8772,59,1,8772,105,100,59,1,8740,97,114,59,1,8742,115,117,4,2,98,112,14098,14102,101,59,1,8930,101,59,1,8931,4,3,98,99,112,14114,14157,14171,4,4,59,69,101,115,14124,14126,14130,14133,1,8836,59,3,10949,824,59,1,8840,101,116,4,2,59,101,14141,14144,3,8834,8402,113,4,2,59,113,14151,14153,1,8840,59,3,10949,824,99,4,2,59,101,14164,14166,1,8833,113,59,3,10928,824,4,4,59,69,101,115,14181,14183,14187,14190,1,8837,59,3,10950,824,59,1,8841,101,116,4,2,59,101,14198,14201,3,8835,8402,113,4,2,59,113,14208,14210,1,8841,59,3,10950,824,4,4,103,105,108,114,14224,14228,14238,14242,108,59,1,8825,108,100,101,5,241,1,59,14236,1,241,103,59,1,8824,105,97,110,103,108,101,4,2,108,114,14254,14269,101,102,116,4,2,59,101,14263,14265,1,8938,113,59,1,8940,105,103,104,116,4,2,59,101,14279,14281,1,8939,113,59,1,8941,4,2,59,109,14291,14293,1,957,4,3,59,101,115,14301,14303,14308,1,35,114,111,59,1,8470,112,59,1,8199,4,9,68,72,97,100,103,105,108,114,115,14332,14338,14344,14349,14355,14369,14376,14408,14426,97,115,104,59,1,8877,97,114,114,59,1,10500,112,59,3,8781,8402,97,115,104,59,1,8876,4,2,101,116,14361,14365,59,3,8805,8402,59,3,62,8402,110,102,105,110,59,1,10718,4,3,65,101,116,14384,14389,14393,114,114,59,1,10498,59,3,8804,8402,4,2,59,114,14399,14402,3,60,8402,105,101,59,3,8884,8402,4,2,65,116,14414,14419,114,114,59,1,10499,114,105,101,59,3,8885,8402,105,109,59,3,8764,8402,4,3,65,97,110,14440,14445,14468,114,114,59,1,8662,114,4,2,104,114,14452,14456,107,59,1,10531,4,2,59,111,14462,14464,1,8598,119,59,1,8598,101,97,114,59,1,10535,4,18,83,97,99,100,101,102,103,104,105,108,109,111,112,114,115,116,117,118,14512,14515,14535,14560,14597,14603,14618,14643,14657,14662,14701,14741,14747,14769,14851,14877,14907,14916,59,1,9416,4,2,99,115,14521,14531,117,116,101,5,243,1,59,14529,1,243,116,59,1,8859,4,2,105,121,14541,14557,114,4,2,59,99,14548,14550,1,8858,5,244,1,59,14555,1,244,59,1,1086,4,5,97,98,105,111,115,14572,14577,14583,14587,14591,115,104,59,1,8861,108,97,99,59,1,337,118,59,1,10808,116,59,1,8857,111,108,100,59,1,10684,108,105,103,59,1,339,4,2,99,114,14609,14614,105,114,59,1,10687,59,3,55349,56620,4,3,111,114,116,14626,14630,14640,110,59,1,731,97,118,101,5,242,1,59,14638,1,242,59,1,10689,4,2,98,109,14649,14654,97,114,59,1,10677,59,1,937,110,116,59,1,8750,4,4,97,99,105,116,14672,14677,14693,14698,114,114,59,1,8634,4,2,105,114,14683,14687,114,59,1,10686,111,115,115,59,1,10683,110,101,59,1,8254,59,1,10688,4,3,97,101,105,14709,14714,14719,99,114,59,1,333,103,97,59,1,969,4,3,99,100,110,14727,14733,14736,114,111,110,59,1,959,59,1,10678,117,115,59,1,8854,112,102,59,3,55349,56672,4,3,97,101,108,14755,14759,14764,114,59,1,10679,114,112,59,1,10681,117,115,59,1,8853,4,7,59,97,100,105,111,115,118,14785,14787,14792,14831,14837,14841,14848,1,8744,114,114,59,1,8635,4,4,59,101,102,109,14802,14804,14817,14824,1,10845,114,4,2,59,111,14811,14813,1,8500,102,59,1,8500,5,170,1,59,14822,1,170,5,186,1,59,14829,1,186,103,111,102,59,1,8886,114,59,1,10838,108,111,112,101,59,1,10839,59,1,10843,4,3,99,108,111,14859,14863,14873,114,59,1,8500,97,115,104,5,248,1,59,14871,1,248,108,59,1,8856,105,4,2,108,109,14884,14893,100,101,5,245,1,59,14891,1,245,101,115,4,2,59,97,14901,14903,1,8855,115,59,1,10806,109,108,5,246,1,59,14914,1,246,98,97,114,59,1,9021,4,12,97,99,101,102,104,105,108,109,111,114,115,117,14948,14992,14996,15033,15038,15068,15090,15189,15192,15222,15427,15441,114,4,4,59,97,115,116,14959,14961,14976,14989,1,8741,5,182,2,59,108,14968,14970,1,182,108,101,108,59,1,8741,4,2,105,108,14982,14986,109,59,1,10995,59,1,11005,59,1,8706,121,59,1,1087,114,4,5,99,105,109,112,116,15009,15014,15019,15024,15027,110,116,59,1,37,111,100,59,1,46,105,108,59,1,8240,59,1,8869,101,110,107,59,1,8241,114,59,3,55349,56621,4,3,105,109,111,15046,15057,15063,4,2,59,118,15052,15054,1,966,59,1,981,109,97,116,59,1,8499,110,101,59,1,9742,4,3,59,116,118,15076,15078,15087,1,960,99,104,102,111,114,107,59,1,8916,59,1,982,4,2,97,117,15096,15119,110,4,2,99,107,15103,15115,107,4,2,59,104,15110,15112,1,8463,59,1,8462,118,59,1,8463,115,4,9,59,97,98,99,100,101,109,115,116,15140,15142,15148,15151,15156,15168,15171,15179,15184,1,43,99,105,114,59,1,10787,59,1,8862,105,114,59,1,10786,4,2,111,117,15162,15165,59,1,8724,59,1,10789,59,1,10866,110,5,177,1,59,15177,1,177,105,109,59,1,10790,119,111,59,1,10791,59,1,177,4,3,105,112,117,15200,15208,15213,110,116,105,110,116,59,1,10773,102,59,3,55349,56673,110,100,5,163,1,59,15220,1,163,4,10,59,69,97,99,101,105,110,111,115,117,15244,15246,15249,15253,15258,15334,15347,15367,15416,15421,1,8826,59,1,10931,112,59,1,10935,117,101,59,1,8828,4,2,59,99,15264,15266,1,10927,4,6,59,97,99,101,110,115,15280,15282,15290,15299,15303,15329,1,8826,112,112,114,111,120,59,1,10935,117,114,108,121,101,113,59,1,8828,113,59,1,10927,4,3,97,101,115,15311,15319,15324,112,112,114,111,120,59,1,10937,113,113,59,1,10933,105,109,59,1,8936,105,109,59,1,8830,109,101,4,2,59,115,15342,15344,1,8242,59,1,8473,4,3,69,97,115,15355,15358,15362,59,1,10933,112,59,1,10937,105,109,59,1,8936,4,3,100,102,112,15375,15378,15404,59,1,8719,4,3,97,108,115,15386,15392,15398,108,97,114,59,1,9006,105,110,101,59,1,8978,117,114,102,59,1,8979,4,2,59,116,15410,15412,1,8733,111,59,1,8733,105,109,59,1,8830,114,101,108,59,1,8880,4,2,99,105,15433,15438,114,59,3,55349,56517,59,1,968,110,99,115,112,59,1,8200,4,6,102,105,111,112,115,117,15462,15467,15472,15478,15485,15491,114,59,3,55349,56622,110,116,59,1,10764,112,102,59,3,55349,56674,114,105,109,101,59,1,8279,99,114,59,3,55349,56518,4,3,97,101,111,15499,15520,15534,116,4,2,101,105,15506,15515,114,110,105,111,110,115,59,1,8461,110,116,59,1,10774,115,116,4,2,59,101,15528,15530,1,63,113,59,1,8799,116,5,34,1,59,15540,1,34,4,21,65,66,72,97,98,99,100,101,102,104,105,108,109,110,111,112,114,115,116,117,120,15586,15609,15615,15620,15796,15855,15893,15931,15977,16001,16039,16183,16204,16222,16228,16285,16312,16318,16363,16408,16416,4,3,97,114,116,15594,15599,15603,114,114,59,1,8667,114,59,1,8658,97,105,108,59,1,10524,97,114,114,59,1,10511,97,114,59,1,10596,4,7,99,100,101,110,113,114,116,15636,15651,15656,15664,15687,15696,15770,4,2,101,117,15642,15646,59,3,8765,817,116,101,59,1,341,105,99,59,1,8730,109,112,116,121,118,59,1,10675,103,4,4,59,100,101,108,15675,15677,15680,15683,1,10217,59,1,10642,59,1,10661,101,59,1,10217,117,111,5,187,1,59,15694,1,187,114,4,11,59,97,98,99,102,104,108,112,115,116,119,15721,15723,15727,15739,15742,15746,15750,15754,15758,15763,15767,1,8594,112,59,1,10613,4,2,59,102,15733,15735,1,8677,115,59,1,10528,59,1,10547,115,59,1,10526,107,59,1,8618,112,59,1,8620,108,59,1,10565,105,109,59,1,10612,108,59,1,8611,59,1,8605,4,2,97,105,15776,15781,105,108,59,1,10522,111,4,2,59,110,15788,15790,1,8758,97,108,115,59,1,8474,4,3,97,98,114,15804,15809,15814,114,114,59,1,10509,114,107,59,1,10099,4,2,97,107,15820,15833,99,4,2,101,107,15827,15830,59,1,125,59,1,93,4,2,101,115,15839,15842,59,1,10636,108,4,2,100,117,15849,15852,59,1,10638,59,1,10640,4,4,97,101,117,121,15865,15871,15886,15890,114,111,110,59,1,345,4,2,100,105,15877,15882,105,108,59,1,343,108,59,1,8969,98,59,1,125,59,1,1088,4,4,99,108,113,115,15903,15907,15914,15927,97,59,1,10551,100,104,97,114,59,1,10601,117,111,4,2,59,114,15922,15924,1,8221,59,1,8221,104,59,1,8627,4,3,97,99,103,15939,15966,15970,108,4,4,59,105,112,115,15950,15952,15957,15963,1,8476,110,101,59,1,8475,97,114,116,59,1,8476,59,1,8477,116,59,1,9645,5,174,1,59,15975,1,174,4,3,105,108,114,15985,15991,15997,115,104,116,59,1,10621,111,111,114,59,1,8971,59,3,55349,56623,4,2,97,111,16007,16028,114,4,2,100,117,16014,16017,59,1,8641,4,2,59,108,16023,16025,1,8640,59,1,10604,4,2,59,118,16034,16036,1,961,59,1,1009,4,3,103,110,115,16047,16167,16171,104,116,4,6,97,104,108,114,115,116,16063,16081,16103,16130,16143,16155,114,114,111,119,4,2,59,116,16073,16075,1,8594,97,105,108,59,1,8611,97,114,112,111,111,110,4,2,100,117,16093,16099,111,119,110,59,1,8641,112,59,1,8640,101,102,116,4,2,97,104,16112,16120,114,114,111,119,115,59,1,8644,97,114,112,111,111,110,115,59,1,8652,105,103,104,116,97,114,114,111,119,115,59,1,8649,113,117,105,103,97,114,114,111,119,59,1,8605,104,114,101,101,116,105,109,101,115,59,1,8908,103,59,1,730,105,110,103,100,111,116,115,101,113,59,1,8787,4,3,97,104,109,16191,16196,16201,114,114,59,1,8644,97,114,59,1,8652,59,1,8207,111,117,115,116,4,2,59,97,16214,16216,1,9137,99,104,101,59,1,9137,109,105,100,59,1,10990,4,4,97,98,112,116,16238,16252,16257,16278,4,2,110,114,16244,16248,103,59,1,10221,114,59,1,8702,114,107,59,1,10215,4,3,97,102,108,16265,16269,16273,114,59,1,10630,59,3,55349,56675,117,115,59,1,10798,105,109,101,115,59,1,10805,4,2,97,112,16291,16304,114,4,2,59,103,16298,16300,1,41,116,59,1,10644,111,108,105,110,116,59,1,10770,97,114,114,59,1,8649,4,4,97,99,104,113,16328,16334,16339,16342,113,117,111,59,1,8250,114,59,3,55349,56519,59,1,8625,4,2,98,117,16348,16351,59,1,93,111,4,2,59,114,16358,16360,1,8217,59,1,8217,4,3,104,105,114,16371,16377,16383,114,101,101,59,1,8908,109,101,115,59,1,8906,105,4,4,59,101,102,108,16394,16396,16399,16402,1,9657,59,1,8885,59,1,9656,116,114,105,59,1,10702,108,117,104,97,114,59,1,10600,59,1,8478,4,19,97,98,99,100,101,102,104,105,108,109,111,112,113,114,115,116,117,119,122,16459,16466,16472,16572,16590,16672,16687,16746,16844,16850,16924,16963,16988,17115,17121,17154,17206,17614,17656,99,117,116,101,59,1,347,113,117,111,59,1,8218,4,10,59,69,97,99,101,105,110,112,115,121,16494,16496,16499,16513,16518,16531,16536,16556,16564,16569,1,8827,59,1,10932,4,2,112,114,16505,16508,59,1,10936,111,110,59,1,353,117,101,59,1,8829,4,2,59,100,16524,16526,1,10928,105,108,59,1,351,114,99,59,1,349,4,3,69,97,115,16544,16547,16551,59,1,10934,112,59,1,10938,105,109,59,1,8937,111,108,105,110,116,59,1,10771,105,109,59,1,8831,59,1,1089,111,116,4,3,59,98,101,16582,16584,16587,1,8901,59,1,8865,59,1,10854,4,7,65,97,99,109,115,116,120,16606,16611,16634,16642,16646,16652,16668,114,114,59,1,8664,114,4,2,104,114,16618,16622,107,59,1,10533,4,2,59,111,16628,16630,1,8600,119,59,1,8600,116,5,167,1,59,16640,1,167,105,59,1,59,119,97,114,59,1,10537,109,4,2,105,110,16659,16665,110,117,115,59,1,8726,59,1,8726,116,59,1,10038,114,4,2,59,111,16679,16682,3,55349,56624,119,110,59,1,8994,4,4,97,99,111,121,16697,16702,16716,16739,114,112,59,1,9839,4,2,104,121,16708,16713,99,121,59,1,1097,59,1,1096,114,116,4,2,109,112,16724,16729,105,100,59,1,8739,97,114,97,108,108,101,108,59,1,8741,5,173,1,59,16744,1,173,4,2,103,109,16752,16770,109,97,4,3,59,102,118,16762,16764,16767,1,963,59,1,962,59,1,962,4,8,59,100,101,103,108,110,112,114,16788,16790,16795,16806,16817,16828,16832,16838,1,8764,111,116,59,1,10858,4,2,59,113,16801,16803,1,8771,59,1,8771,4,2,59,69,16812,16814,1,10910,59,1,10912,4,2,59,69,16823,16825,1,10909,59,1,10911,101,59,1,8774,108,117,115,59,1,10788,97,114,114,59,1,10610,97,114,114,59,1,8592,4,4,97,101,105,116,16860,16883,16891,16904,4,2,108,115,16866,16878,108,115,101,116,109,105,110,117,115,59,1,8726,104,112,59,1,10803,112,97,114,115,108,59,1,10724,4,2,100,108,16897,16900,59,1,8739,101,59,1,8995,4,2,59,101,16910,16912,1,10922,4,2,59,115,16918,16920,1,10924,59,3,10924,65024,4,3,102,108,112,16932,16938,16958,116,99,121,59,1,1100,4,2,59,98,16944,16946,1,47,4,2,59,97,16952,16954,1,10692,114,59,1,9023,102,59,3,55349,56676,97,4,2,100,114,16970,16985,101,115,4,2,59,117,16978,16980,1,9824,105,116,59,1,9824,59,1,8741,4,3,99,115,117,16996,17028,17089,4,2,97,117,17002,17015,112,4,2,59,115,17009,17011,1,8851,59,3,8851,65024,112,4,2,59,115,17022,17024,1,8852,59,3,8852,65024,117,4,2,98,112,17035,17062,4,3,59,101,115,17043,17045,17048,1,8847,59,1,8849,101,116,4,2,59,101,17056,17058,1,8847,113,59,1,8849,4,3,59,101,115,17070,17072,17075,1,8848,59,1,8850,101,116,4,2,59,101,17083,17085,1,8848,113,59,1,8850,4,3,59,97,102,17097,17099,17112,1,9633,114,4,2,101,102,17106,17109,59,1,9633,59,1,9642,59,1,9642,97,114,114,59,1,8594,4,4,99,101,109,116,17131,17136,17142,17148,114,59,3,55349,56520,116,109,110,59,1,8726,105,108,101,59,1,8995,97,114,102,59,1,8902,4,2,97,114,17160,17172,114,4,2,59,102,17167,17169,1,9734,59,1,9733,4,2,97,110,17178,17202,105,103,104,116,4,2,101,112,17188,17197,112,115,105,108,111,110,59,1,1013,104,105,59,1,981,115,59,1,175,4,5,98,99,109,110,112,17218,17351,17420,17423,17427,4,9,59,69,100,101,109,110,112,114,115,17238,17240,17243,17248,17261,17267,17279,17285,17291,1,8834,59,1,10949,111,116,59,1,10941,4,2,59,100,17254,17256,1,8838,111,116,59,1,10947,117,108,116,59,1,10945,4,2,69,101,17273,17276,59,1,10955,59,1,8842,108,117,115,59,1,10943,97,114,114,59,1,10617,4,3,101,105,117,17299,17335,17339,116,4,3,59,101,110,17308,17310,17322,1,8834,113,4,2,59,113,17317,17319,1,8838,59,1,10949,101,113,4,2,59,113,17330,17332,1,8842,59,1,10955,109,59,1,10951,4,2,98,112,17345,17348,59,1,10965,59,1,10963,99,4,6,59,97,99,101,110,115,17366,17368,17376,17385,17389,17415,1,8827,112,112,114,111,120,59,1,10936,117,114,108,121,101,113,59,1,8829,113,59,1,10928,4,3,97,101,115,17397,17405,17410,112,112,114,111,120,59,1,10938,113,113,59,1,10934,105,109,59,1,8937,105,109,59,1,8831,59,1,8721,103,59,1,9834,4,13,49,50,51,59,69,100,101,104,108,109,110,112,115,17455,17462,17469,17476,17478,17481,17496,17509,17524,17530,17536,17548,17554,5,185,1,59,17460,1,185,5,178,1,59,17467,1,178,5,179,1,59,17474,1,179,1,8835,59,1,10950,4,2,111,115,17487,17491,116,59,1,10942,117,98,59,1,10968,4,2,59,100,17502,17504,1,8839,111,116,59,1,10948,115,4,2,111,117,17516,17520,108,59,1,10185,98,59,1,10967,97,114,114,59,1,10619,117,108,116,59,1,10946,4,2,69,101,17542,17545,59,1,10956,59,1,8843,108,117,115,59,1,10944,4,3,101,105,117,17562,17598,17602,116,4,3,59,101,110,17571,17573,17585,1,8835,113,4,2,59,113,17580,17582,1,8839,59,1,10950,101,113,4,2,59,113,17593,17595,1,8843,59,1,10956,109,59,1,10952,4,2,98,112,17608,17611,59,1,10964,59,1,10966,4,3,65,97,110,17622,17627,17650,114,114,59,1,8665,114,4,2,104,114,17634,17638,107,59,1,10534,4,2,59,111,17644,17646,1,8601,119,59,1,8601,119,97,114,59,1,10538,108,105,103,5,223,1,59,17664,1,223,4,13,97,98,99,100,101,102,104,105,111,112,114,115,119,17694,17709,17714,17737,17742,17749,17754,17860,17905,17957,17964,18090,18122,4,2,114,117,17700,17706,103,101,116,59,1,8982,59,1,964,114,107,59,1,9140,4,3,97,101,121,17722,17728,17734,114,111,110,59,1,357,100,105,108,59,1,355,59,1,1090,111,116,59,1,8411,108,114,101,99,59,1,8981,114,59,3,55349,56625,4,4,101,105,107,111,17764,17805,17836,17851,4,2,114,116,17770,17786,101,4,2,52,102,17777,17780,59,1,8756,111,114,101,59,1,8756,97,4,3,59,115,118,17795,17797,17802,1,952,121,109,59,1,977,59,1,977,4,2,99,110,17811,17831,107,4,2,97,115,17818,17826,112,112,114,111,120,59,1,8776,105,109,59,1,8764,115,112,59,1,8201,4,2,97,115,17842,17846,112,59,1,8776,105,109,59,1,8764,114,110,5,254,1,59,17858,1,254,4,3,108,109,110,17868,17873,17901,100,101,59,1,732,101,115,5,215,3,59,98,100,17884,17886,17898,1,215,4,2,59,97,17892,17894,1,8864,114,59,1,10801,59,1,10800,116,59,1,8749,4,3,101,112,115,17913,17917,17953,97,59,1,10536,4,4,59,98,99,102,17927,17929,17934,17939,1,8868,111,116,59,1,9014,105,114,59,1,10993,4,2,59,111,17945,17948,3,55349,56677,114,107,59,1,10970,97,59,1,10537,114,105,109,101,59,1,8244,4,3,97,105,112,17972,17977,18082,100,101,59,1,8482,4,7,97,100,101,109,112,115,116,17993,18051,18056,18059,18066,18072,18076,110,103,108,101,4,5,59,100,108,113,114,18009,18011,18017,18032,18035,1,9653,111,119,110,59,1,9663,101,102,116,4,2,59,101,18026,18028,1,9667,113,59,1,8884,59,1,8796,105,103,104,116,4,2,59,101,18045,18047,1,9657,113,59,1,8885,111,116,59,1,9708,59,1,8796,105,110,117,115,59,1,10810,108,117,115,59,1,10809,98,59,1,10701,105,109,101,59,1,10811,101,122,105,117,109,59,1,9186,4,3,99,104,116,18098,18111,18116,4,2,114,121,18104,18108,59,3,55349,56521,59,1,1094,99,121,59,1,1115,114,111,107,59,1,359,4,2,105,111,18128,18133,120,116,59,1,8812,104,101,97,100,4,2,108,114,18143,18154,101,102,116,97,114,114,111,119,59,1,8606,105,103,104,116,97,114,114,111,119,59,1,8608,4,18,65,72,97,98,99,100,102,103,104,108,109,111,112,114,115,116,117,119,18204,18209,18214,18234,18250,18268,18292,18308,18319,18343,18379,18397,18413,18504,18547,18553,18584,18603,114,114,59,1,8657,97,114,59,1,10595,4,2,99,114,18220,18230,117,116,101,5,250,1,59,18228,1,250,114,59,1,8593,114,4,2,99,101,18241,18245,121,59,1,1118,118,101,59,1,365,4,2,105,121,18256,18265,114,99,5,251,1,59,18263,1,251,59,1,1091,4,3,97,98,104,18276,18281,18287,114,114,59,1,8645,108,97,99,59,1,369,97,114,59,1,10606,4,2,105,114,18298,18304,115,104,116,59,1,10622,59,3,55349,56626,114,97,118,101,5,249,1,59,18317,1,249,4,2,97,98,18325,18338,114,4,2,108,114,18332,18335,59,1,8639,59,1,8638,108,107,59,1,9600,4,2,99,116,18349,18374,4,2,111,114,18355,18369,114,110,4,2,59,101,18363,18365,1,8988,114,59,1,8988,111,112,59,1,8975,114,105,59,1,9720,4,2,97,108,18385,18390,99,114,59,1,363,5,168,1,59,18395,1,168,4,2,103,112,18403,18408,111,110,59,1,371,102,59,3,55349,56678,4,6,97,100,104,108,115,117,18427,18434,18445,18470,18475,18494,114,114,111,119,59,1,8593,111,119,110,97,114,114,111,119,59,1,8597,97,114,112,111,111,110,4,2,108,114,18457,18463,101,102,116,59,1,8639,105,103,104,116,59,1,8638,117,115,59,1,8846,105,4,3,59,104,108,18484,18486,18489,1,965,59,1,978,111,110,59,1,965,112,97,114,114,111,119,115,59,1,8648,4,3,99,105,116,18512,18537,18542,4,2,111,114,18518,18532,114,110,4,2,59,101,18526,18528,1,8989,114,59,1,8989,111,112,59,1,8974,110,103,59,1,367,114,105,59,1,9721,99,114,59,3,55349,56522,4,3,100,105,114,18561,18566,18572,111,116,59,1,8944,108,100,101,59,1,361,105,4,2,59,102,18579,18581,1,9653,59,1,9652,4,2,97,109,18590,18595,114,114,59,1,8648,108,5,252,1,59,18601,1,252,97,110,103,108,101,59,1,10663,4,15,65,66,68,97,99,100,101,102,108,110,111,112,114,115,122,18643,18648,18661,18667,18847,18851,18857,18904,18909,18915,18931,18937,18943,18949,18996,114,114,59,1,8661,97,114,4,2,59,118,18656,18658,1,10984,59,1,10985,97,115,104,59,1,8872,4,2,110,114,18673,18679,103,114,116,59,1,10652,4,7,101,107,110,112,114,115,116,18695,18704,18711,18720,18742,18754,18810,112,115,105,108,111,110,59,1,1013,97,112,112,97,59,1,1008,111,116,104,105,110,103,59,1,8709,4,3,104,105,114,18728,18732,18735,105,59,1,981,59,1,982,111,112,116,111,59,1,8733,4,2,59,104,18748,18750,1,8597,111,59,1,1009,4,2,105,117,18760,18766,103,109,97,59,1,962,4,2,98,112,18772,18791,115,101,116,110,101,113,4,2,59,113,18784,18787,3,8842,65024,59,3,10955,65024,115,101,116,110,101,113,4,2,59,113,18803,18806,3,8843,65024,59,3,10956,65024,4,2,104,114,18816,18822,101,116,97,59,1,977,105,97,110,103,108,101,4,2,108,114,18834,18840,101,102,116,59,1,8882,105,103,104,116,59,1,8883,121,59,1,1074,97,115,104,59,1,8866,4,3,101,108,114,18865,18884,18890,4,3,59,98,101,18873,18875,18880,1,8744,97,114,59,1,8891,113,59,1,8794,108,105,112,59,1,8942,4,2,98,116,18896,18901,97,114,59,1,124,59,1,124,114,59,3,55349,56627,116,114,105,59,1,8882,115,117,4,2,98,112,18923,18927,59,3,8834,8402,59,3,8835,8402,112,102,59,3,55349,56679,114,111,112,59,1,8733,116,114,105,59,1,8883,4,2,99,117,18955,18960,114,59,3,55349,56523,4,2,98,112,18966,18981,110,4,2,69,101,18973,18977,59,3,10955,65024,59,3,8842,65024,110,4,2,69,101,18988,18992,59,3,10956,65024,59,3,8843,65024,105,103,122,97,103,59,1,10650,4,7,99,101,102,111,112,114,115,19020,19026,19061,19066,19072,19075,19089,105,114,99,59,1,373,4,2,100,105,19032,19055,4,2,98,103,19038,19043,97,114,59,1,10847,101,4,2,59,113,19050,19052,1,8743,59,1,8793,101,114,112,59,1,8472,114,59,3,55349,56628,112,102,59,3,55349,56680,59,1,8472,4,2,59,101,19081,19083,1,8768,97,116,104,59,1,8768,99,114,59,3,55349,56524,4,14,99,100,102,104,105,108,109,110,111,114,115,117,118,119,19125,19146,19152,19157,19173,19176,19192,19197,19202,19236,19252,19269,19286,19291,4,3,97,105,117,19133,19137,19142,112,59,1,8898,114,99,59,1,9711,112,59,1,8899,116,114,105,59,1,9661,114,59,3,55349,56629,4,2,65,97,19163,19168,114,114,59,1,10234,114,114,59,1,10231,59,1,958,4,2,65,97,19182,19187,114,114,59,1,10232,114,114,59,1,10229,97,112,59,1,10236,105,115,59,1,8955,4,3,100,112,116,19210,19215,19230,111,116,59,1,10752,4,2,102,108,19221,19225,59,3,55349,56681,117,115,59,1,10753,105,109,101,59,1,10754,4,2,65,97,19242,19247,114,114,59,1,10233,114,114,59,1,10230,4,2,99,113,19258,19263,114,59,3,55349,56525,99,117,112,59,1,10758,4,2,112,116,19275,19281,108,117,115,59,1,10756,114,105,59,1,9651,101,101,59,1,8897,101,100,103,101,59,1,8896,4,8,97,99,101,102,105,111,115,117,19316,19335,19349,19357,19362,19367,19373,19379,99,4,2,117,121,19323,19332,116,101,5,253,1,59,19330,1,253,59,1,1103,4,2,105,121,19341,19346,114,99,59,1,375,59,1,1099,110,5,165,1,59,19355,1,165,114,59,3,55349,56630,99,121,59,1,1111,112,102,59,3,55349,56682,99,114,59,3,55349,56526,4,2,99,109,19385,19389,121,59,1,1102,108,5,255,1,59,19395,1,255,4,10,97,99,100,101,102,104,105,111,115,119,19419,19426,19441,19446,19462,19467,19472,19480,19486,19492,99,117,116,101,59,1,378,4,2,97,121,19432,19438,114,111,110,59,1,382,59,1,1079,111,116,59,1,380,4,2,101,116,19452,19458,116,114,102,59,1,8488,97,59,1,950,114,59,3,55349,56631,99,121,59,1,1078,103,114,97,114,114,59,1,8669,112,102,59,3,55349,56683,99,114,59,3,55349,56527,4,2,106,110,19498,19501,59,1,8205,106,59,1,8204]);

/***/ }),

/***/ "./node_modules/parse5/lib/tokenizer/preprocessor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var UNICODE = __webpack_require__("./node_modules/parse5/lib/common/unicode.js");

//Aliases
var $ = UNICODE.CODE_POINTS;

//Utils

//OPTIMIZATION: these utility functions should not be moved out of this module. V8 Crankshaft will not inline
//this functions if they will be situated in another module due to context switch.
//Always perform inlining check before modifying this functions ('node --trace-inlining').
function isSurrogatePair(cp1, cp2) {
    return cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF;
}

function getSurrogatePairCodePoint(cp1, cp2) {
    return (cp1 - 0xD800) * 0x400 + 0x2400 + cp2;
}


//Const
var DEFAULT_BUFFER_WATERLINE = 1 << 16;


//Preprocessor
//NOTE: HTML input preprocessing
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/parsing.html#preprocessing-the-input-stream)
var Preprocessor = module.exports = function () {
    this.html = null;

    this.pos = -1;
    this.lastGapPos = -1;
    this.lastCharPos = -1;

    this.gapStack = [];

    this.skipNextNewLine = false;

    this.lastChunkWritten = false;
    this.endOfChunkHit = false;
    this.bufferWaterline = DEFAULT_BUFFER_WATERLINE;
};

Preprocessor.prototype.dropParsedChunk = function () {
    if (this.pos > this.bufferWaterline) {
        this.lastCharPos -= this.pos;
        this.html = this.html.substring(this.pos);
        this.pos = 0;
        this.lastGapPos = -1;
        this.gapStack = [];
    }
};

Preprocessor.prototype._addGap = function () {
    this.gapStack.push(this.lastGapPos);
    this.lastGapPos = this.pos;
};

Preprocessor.prototype._processHighRangeCodePoint = function (cp) {
    //NOTE: try to peek a surrogate pair
    if (this.pos !== this.lastCharPos) {
        var nextCp = this.html.charCodeAt(this.pos + 1);

        if (isSurrogatePair(cp, nextCp)) {
            //NOTE: we have a surrogate pair. Peek pair character and recalculate code point.
            this.pos++;
            cp = getSurrogatePairCodePoint(cp, nextCp);

            //NOTE: add gap that should be avoided during retreat
            this._addGap();
        }
    }

    // NOTE: we've hit the end of chunk, stop processing at this point
    else if (!this.lastChunkWritten) {
        this.endOfChunkHit = true;
        return $.EOF;
    }

    return cp;
};

Preprocessor.prototype.write = function (chunk, isLastChunk) {
    if (this.html)
        this.html += chunk;

    else
        this.html = chunk;

    this.lastCharPos = this.html.length - 1;
    this.endOfChunkHit = false;
    this.lastChunkWritten = isLastChunk;
};

Preprocessor.prototype.insertHtmlAtCurrentPos = function (chunk) {
    this.html = this.html.substring(0, this.pos + 1) +
                chunk +
                this.html.substring(this.pos + 1, this.html.length);

    this.lastCharPos = this.html.length - 1;
    this.endOfChunkHit = false;
};


Preprocessor.prototype.advance = function () {
    this.pos++;

    if (this.pos > this.lastCharPos) {
        if (!this.lastChunkWritten)
            this.endOfChunkHit = true;

        return $.EOF;
    }

    var cp = this.html.charCodeAt(this.pos);

    //NOTE: any U+000A LINE FEED (LF) characters that immediately follow a U+000D CARRIAGE RETURN (CR) character
    //must be ignored.
    if (this.skipNextNewLine && cp === $.LINE_FEED) {
        this.skipNextNewLine = false;
        this._addGap();
        return this.advance();
    }

    //NOTE: all U+000D CARRIAGE RETURN (CR) characters must be converted to U+000A LINE FEED (LF) characters
    if (cp === $.CARRIAGE_RETURN) {
        this.skipNextNewLine = true;
        return $.LINE_FEED;
    }

    this.skipNextNewLine = false;

    //OPTIMIZATION: first perform check if the code point in the allowed range that covers most common
    //HTML input (e.g. ASCII codes) to avoid performance-cost operations for high-range code points.
    return cp >= 0xD800 ? this._processHighRangeCodePoint(cp) : cp;
};

Preprocessor.prototype.retreat = function () {
    if (this.pos === this.lastGapPos) {
        this.lastGapPos = this.gapStack.pop();
        this.pos--;
    }

    this.pos--;
};



/***/ }),

/***/ "./node_modules/parse5/lib/tree_adapters/default.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DOCUMENT_MODE = __webpack_require__("./node_modules/parse5/lib/common/html.js").DOCUMENT_MODE;

//Node construction
exports.createDocument = function () {
    return {
        nodeName: '#document',
        mode: DOCUMENT_MODE.NO_QUIRKS,
        childNodes: []
    };
};

exports.createDocumentFragment = function () {
    return {
        nodeName: '#document-fragment',
        childNodes: []
    };
};

exports.createElement = function (tagName, namespaceURI, attrs) {
    return {
        nodeName: tagName,
        tagName: tagName,
        attrs: attrs,
        namespaceURI: namespaceURI,
        childNodes: [],
        parentNode: null
    };
};

exports.createCommentNode = function (data) {
    return {
        nodeName: '#comment',
        data: data,
        parentNode: null
    };
};

var createTextNode = function (value) {
    return {
        nodeName: '#text',
        value: value,
        parentNode: null
    };
};


//Tree mutation
var appendChild = exports.appendChild = function (parentNode, newNode) {
    parentNode.childNodes.push(newNode);
    newNode.parentNode = parentNode;
};

var insertBefore = exports.insertBefore = function (parentNode, newNode, referenceNode) {
    var insertionIdx = parentNode.childNodes.indexOf(referenceNode);

    parentNode.childNodes.splice(insertionIdx, 0, newNode);
    newNode.parentNode = parentNode;
};

exports.setTemplateContent = function (templateElement, contentElement) {
    templateElement.content = contentElement;
};

exports.getTemplateContent = function (templateElement) {
    return templateElement.content;
};

exports.setDocumentType = function (document, name, publicId, systemId) {
    var doctypeNode = null;

    for (var i = 0; i < document.childNodes.length; i++) {
        if (document.childNodes[i].nodeName === '#documentType') {
            doctypeNode = document.childNodes[i];
            break;
        }
    }

    if (doctypeNode) {
        doctypeNode.name = name;
        doctypeNode.publicId = publicId;
        doctypeNode.systemId = systemId;
    }

    else {
        appendChild(document, {
            nodeName: '#documentType',
            name: name,
            publicId: publicId,
            systemId: systemId
        });
    }
};

exports.setDocumentMode = function (document, mode) {
    document.mode = mode;
};

exports.getDocumentMode = function (document) {
    return document.mode;
};

exports.detachNode = function (node) {
    if (node.parentNode) {
        var idx = node.parentNode.childNodes.indexOf(node);

        node.parentNode.childNodes.splice(idx, 1);
        node.parentNode = null;
    }
};

exports.insertText = function (parentNode, text) {
    if (parentNode.childNodes.length) {
        var prevNode = parentNode.childNodes[parentNode.childNodes.length - 1];

        if (prevNode.nodeName === '#text') {
            prevNode.value += text;
            return;
        }
    }

    appendChild(parentNode, createTextNode(text));
};

exports.insertTextBefore = function (parentNode, text, referenceNode) {
    var prevNode = parentNode.childNodes[parentNode.childNodes.indexOf(referenceNode) - 1];

    if (prevNode && prevNode.nodeName === '#text')
        prevNode.value += text;
    else
        insertBefore(parentNode, createTextNode(text), referenceNode);
};

exports.adoptAttributes = function (recipient, attrs) {
    var recipientAttrsMap = [];

    for (var i = 0; i < recipient.attrs.length; i++)
        recipientAttrsMap.push(recipient.attrs[i].name);

    for (var j = 0; j < attrs.length; j++) {
        if (recipientAttrsMap.indexOf(attrs[j].name) === -1)
            recipient.attrs.push(attrs[j]);
    }
};


//Tree traversing
exports.getFirstChild = function (node) {
    return node.childNodes[0];
};

exports.getChildNodes = function (node) {
    return node.childNodes;
};

exports.getParentNode = function (node) {
    return node.parentNode;
};

exports.getAttrList = function (element) {
    return element.attrs;
};

//Node data
exports.getTagName = function (element) {
    return element.tagName;
};

exports.getNamespaceURI = function (element) {
    return element.namespaceURI;
};

exports.getTextNodeContent = function (textNode) {
    return textNode.value;
};

exports.getCommentNodeContent = function (commentNode) {
    return commentNode.data;
};

exports.getDocumentTypeNodeName = function (doctypeNode) {
    return doctypeNode.name;
};

exports.getDocumentTypeNodePublicId = function (doctypeNode) {
    return doctypeNode.publicId;
};

exports.getDocumentTypeNodeSystemId = function (doctypeNode) {
    return doctypeNode.systemId;
};

//Node types
exports.isTextNode = function (node) {
    return node.nodeName === '#text';
};

exports.isCommentNode = function (node) {
    return node.nodeName === '#comment';
};

exports.isDocumentTypeNode = function (node) {
    return node.nodeName === '#documentType';
};

exports.isElementNode = function (node) {
    return !!node.tagName;
};


/***/ }),

/***/ "./node_modules/parse5/lib/tree_adapters/htmlparser2.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var doctype = __webpack_require__("./node_modules/parse5/lib/common/doctype.js"),
    DOCUMENT_MODE = __webpack_require__("./node_modules/parse5/lib/common/html.js").DOCUMENT_MODE;


//Conversion tables for DOM Level1 structure emulation
var nodeTypes = {
    element: 1,
    text: 3,
    cdata: 4,
    comment: 8
};

var nodePropertyShorthands = {
    tagName: 'name',
    childNodes: 'children',
    parentNode: 'parent',
    previousSibling: 'prev',
    nextSibling: 'next',
    nodeValue: 'data'
};

//Node
var Node = function (props) {
    for (var key in props) {
        if (props.hasOwnProperty(key))
            this[key] = props[key];
    }
};

Node.prototype = {
    get firstChild() {
        var children = this.children;

        return children && children[0] || null;
    },

    get lastChild() {
        var children = this.children;

        return children && children[children.length - 1] || null;
    },

    get nodeType() {
        return nodeTypes[this.type] || nodeTypes.element;
    }
};

Object.keys(nodePropertyShorthands).forEach(function (key) {
    var shorthand = nodePropertyShorthands[key];

    Object.defineProperty(Node.prototype, key, {
        get: function () {
            return this[shorthand] || null;
        },
        set: function (val) {
            this[shorthand] = val;
            return val;
        }
    });
});


//Node construction
exports.createDocument = function () {
    return new Node({
        type: 'root',
        name: 'root',
        parent: null,
        prev: null,
        next: null,
        children: [],
        'x-mode': DOCUMENT_MODE.NO_QUIRKS
    });
};

exports.createDocumentFragment = function () {
    return new Node({
        type: 'root',
        name: 'root',
        parent: null,
        prev: null,
        next: null,
        children: []
    });
};

exports.createElement = function (tagName, namespaceURI, attrs) {
    var attribs = Object.create(null),
        attribsNamespace = Object.create(null),
        attribsPrefix = Object.create(null);

    for (var i = 0; i < attrs.length; i++) {
        var attrName = attrs[i].name;

        attribs[attrName] = attrs[i].value;
        attribsNamespace[attrName] = attrs[i].namespace;
        attribsPrefix[attrName] = attrs[i].prefix;
    }

    return new Node({
        type: tagName === 'script' || tagName === 'style' ? tagName : 'tag',
        name: tagName,
        namespace: namespaceURI,
        attribs: attribs,
        'x-attribsNamespace': attribsNamespace,
        'x-attribsPrefix': attribsPrefix,
        children: [],
        parent: null,
        prev: null,
        next: null
    });
};

exports.createCommentNode = function (data) {
    return new Node({
        type: 'comment',
        data: data,
        parent: null,
        prev: null,
        next: null
    });
};

var createTextNode = function (value) {
    return new Node({
        type: 'text',
        data: value,
        parent: null,
        prev: null,
        next: null
    });
};


//Tree mutation
var appendChild = exports.appendChild = function (parentNode, newNode) {
    var prev = parentNode.children[parentNode.children.length - 1];

    if (prev) {
        prev.next = newNode;
        newNode.prev = prev;
    }

    parentNode.children.push(newNode);
    newNode.parent = parentNode;
};

var insertBefore = exports.insertBefore = function (parentNode, newNode, referenceNode) {
    var insertionIdx = parentNode.children.indexOf(referenceNode),
        prev = referenceNode.prev;

    if (prev) {
        prev.next = newNode;
        newNode.prev = prev;
    }

    referenceNode.prev = newNode;
    newNode.next = referenceNode;

    parentNode.children.splice(insertionIdx, 0, newNode);
    newNode.parent = parentNode;
};

exports.setTemplateContent = function (templateElement, contentElement) {
    appendChild(templateElement, contentElement);
};

exports.getTemplateContent = function (templateElement) {
    return templateElement.children[0];
};

exports.setDocumentType = function (document, name, publicId, systemId) {
    var data = doctype.serializeContent(name, publicId, systemId),
        doctypeNode = null;

    for (var i = 0; i < document.children.length; i++) {
        if (document.children[i].type === 'directive' && document.children[i].name === '!doctype') {
            doctypeNode = document.children[i];
            break;
        }
    }

    if (doctypeNode) {
        doctypeNode.data = data;
        doctypeNode['x-name'] = name;
        doctypeNode['x-publicId'] = publicId;
        doctypeNode['x-systemId'] = systemId;
    }

    else {
        appendChild(document, new Node({
            type: 'directive',
            name: '!doctype',
            data: data,
            'x-name': name,
            'x-publicId': publicId,
            'x-systemId': systemId
        }));
    }

};

exports.setDocumentMode = function (document, mode) {
    document['x-mode'] = mode;
};

exports.getDocumentMode = function (document) {
    return document['x-mode'];
};

exports.detachNode = function (node) {
    if (node.parent) {
        var idx = node.parent.children.indexOf(node),
            prev = node.prev,
            next = node.next;

        node.prev = null;
        node.next = null;

        if (prev)
            prev.next = next;

        if (next)
            next.prev = prev;

        node.parent.children.splice(idx, 1);
        node.parent = null;
    }
};

exports.insertText = function (parentNode, text) {
    var lastChild = parentNode.children[parentNode.children.length - 1];

    if (lastChild && lastChild.type === 'text')
        lastChild.data += text;
    else
        appendChild(parentNode, createTextNode(text));
};

exports.insertTextBefore = function (parentNode, text, referenceNode) {
    var prevNode = parentNode.children[parentNode.children.indexOf(referenceNode) - 1];

    if (prevNode && prevNode.type === 'text')
        prevNode.data += text;
    else
        insertBefore(parentNode, createTextNode(text), referenceNode);
};

exports.adoptAttributes = function (recipient, attrs) {
    for (var i = 0; i < attrs.length; i++) {
        var attrName = attrs[i].name;

        if (typeof recipient.attribs[attrName] === 'undefined') {
            recipient.attribs[attrName] = attrs[i].value;
            recipient['x-attribsNamespace'][attrName] = attrs[i].namespace;
            recipient['x-attribsPrefix'][attrName] = attrs[i].prefix;
        }
    }
};


//Tree traversing
exports.getFirstChild = function (node) {
    return node.children[0];
};

exports.getChildNodes = function (node) {
    return node.children;
};

exports.getParentNode = function (node) {
    return node.parent;
};

exports.getAttrList = function (element) {
    var attrList = [];

    for (var name in element.attribs) {
        attrList.push({
            name: name,
            value: element.attribs[name],
            namespace: element['x-attribsNamespace'][name],
            prefix: element['x-attribsPrefix'][name]
        });
    }

    return attrList;
};


//Node data
exports.getTagName = function (element) {
    return element.name;
};

exports.getNamespaceURI = function (element) {
    return element.namespace;
};

exports.getTextNodeContent = function (textNode) {
    return textNode.data;
};

exports.getCommentNodeContent = function (commentNode) {
    return commentNode.data;
};

exports.getDocumentTypeNodeName = function (doctypeNode) {
    return doctypeNode['x-name'];
};

exports.getDocumentTypeNodePublicId = function (doctypeNode) {
    return doctypeNode['x-publicId'];
};

exports.getDocumentTypeNodeSystemId = function (doctypeNode) {
    return doctypeNode['x-systemId'];
};


//Node types
exports.isTextNode = function (node) {
    return node.type === 'text';
};

exports.isCommentNode = function (node) {
    return node.type === 'comment';
};

exports.isDocumentTypeNode = function (node) {
    return node.type === 'directive' && node.name === '!doctype';
};

exports.isElementNode = function (node) {
    return !!node.attribs;
};


/***/ }),

/***/ "./node_modules/parse5/lib/utils/merge_options.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function mergeOptions(defaults, options) {
    options = options || Object.create(null);

    return [defaults, options].reduce(function (merged, optObj) {
        Object.keys(optObj).forEach(function (key) {
            merged[key] = optObj[key];
        });

        return merged;
    }, Object.create(null));
};


/***/ }),

/***/ "./node_modules/parse5/lib/utils/mixin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Mixin = module.exports = function (host) {
    var originalMethods = {},
        overriddenMethods = this._getOverriddenMethods(this, originalMethods);

    Object.keys(overriddenMethods).forEach(function (key) {
        if (typeof overriddenMethods[key] === 'function') {
            originalMethods[key] = host[key];
            host[key] = overriddenMethods[key];
        }
    });
};

Mixin.prototype._getOverriddenMethods = function () {
    throw new Error('Not implemented');
};



/***/ }),

/***/ "./node_modules/process-nextick-args/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/prop-types-extra/lib/elementType.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIs = __webpack_require__("./node_modules/react-is/index.js");

var _createChainableTypeChecker = __webpack_require__("./node_modules/prop-types-extra/lib/utils/createChainableTypeChecker.js");

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
  }

  if (!(0, _reactIs.isValidElementType)(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/prop-types-extra/lib/utils/createChainableTypeChecker.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-async-script/lib/esm/async-script-loader.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeAsyncScript;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__("./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = _objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function (props, ref) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(AsyncScriptLoader, _extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
    };
    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(ForwardedComponent, WrappedComponent);
  };
}

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/src/base.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_objectWithoutProperties__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectWithoutProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



var Base = function Base(name) {
  var Atom = function Atom(_ref) {
    var refCb = _ref.refCb,
        others = Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_objectWithoutProperties__["a" /* default */])(_ref, ["refCb"]);

    if (refCb) {
      others.ref = refCb;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(name, others);
  };

  return Atom;
};

/* harmony default export */ __webpack_exports__["a"] = (Base);

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_atoms_a__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/a.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_0__ui_atoms_a__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_atoms_article__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/article.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Article", function() { return __WEBPACK_IMPORTED_MODULE_1__ui_atoms_article__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_atoms_button__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/button.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return __WEBPACK_IMPORTED_MODULE_2__ui_atoms_button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_atoms_circle__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/circle.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Circle", function() { return __WEBPACK_IMPORTED_MODULE_3__ui_atoms_circle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_atoms_div__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/div.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Div", function() { return __WEBPACK_IMPORTED_MODULE_4__ui_atoms_div__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_atoms_dl__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/dl.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Dl", function() { return __WEBPACK_IMPORTED_MODULE_5__ui_atoms_dl__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_atoms_footer__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/footer.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Footer", function() { return __WEBPACK_IMPORTED_MODULE_6__ui_atoms_footer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_atoms_form__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/form.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return __WEBPACK_IMPORTED_MODULE_7__ui_atoms_form__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_atoms_g__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/g.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_8__ui_atoms_g__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_atoms_h1__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/h1.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H1", function() { return __WEBPACK_IMPORTED_MODULE_9__ui_atoms_h1__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_atoms_h2__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/h2.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H2", function() { return __WEBPACK_IMPORTED_MODULE_10__ui_atoms_h2__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_atoms_h3__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/h3.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H3", function() { return __WEBPACK_IMPORTED_MODULE_11__ui_atoms_h3__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_atoms_h4__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/h4.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H4", function() { return __WEBPACK_IMPORTED_MODULE_12__ui_atoms_h4__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_atoms_h5__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/h5.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H5", function() { return __WEBPACK_IMPORTED_MODULE_13__ui_atoms_h5__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ui_atoms_h6__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/h6.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H6", function() { return __WEBPACK_IMPORTED_MODULE_14__ui_atoms_h6__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ui_atoms_header__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/header.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Header", function() { return __WEBPACK_IMPORTED_MODULE_15__ui_atoms_header__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ui_atoms_i__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/i.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_16__ui_atoms_i__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ui_atoms_iframe__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/iframe.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Iframe", function() { return __WEBPACK_IMPORTED_MODULE_17__ui_atoms_iframe__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ui_atoms_img__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/img.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Img", function() { return __WEBPACK_IMPORTED_MODULE_18__ui_atoms_img__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ui_atoms_input__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/input.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Input", function() { return __WEBPACK_IMPORTED_MODULE_19__ui_atoms_input__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ui_atoms_label__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/label.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Label", function() { return __WEBPACK_IMPORTED_MODULE_20__ui_atoms_label__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ui_atoms_li__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/li.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Li", function() { return __WEBPACK_IMPORTED_MODULE_21__ui_atoms_li__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ui_atoms_line__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/line.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Line", function() { return __WEBPACK_IMPORTED_MODULE_22__ui_atoms_line__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ui_atoms_main__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/main.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Main", function() { return __WEBPACK_IMPORTED_MODULE_23__ui_atoms_main__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ui_atoms_nav__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/nav.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Nav", function() { return __WEBPACK_IMPORTED_MODULE_24__ui_atoms_nav__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ui_atoms_ol__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/ol.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ol", function() { return __WEBPACK_IMPORTED_MODULE_25__ui_atoms_ol__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ui_atoms_p__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/p.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_26__ui_atoms_p__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ui_atoms_path__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/path.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Path", function() { return __WEBPACK_IMPORTED_MODULE_27__ui_atoms_path__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ui_atoms_polygon__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/polygon.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Polygon", function() { return __WEBPACK_IMPORTED_MODULE_28__ui_atoms_polygon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ui_atoms_rect__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/rect.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Rect", function() { return __WEBPACK_IMPORTED_MODULE_29__ui_atoms_rect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ui_atoms_section__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/section.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Section", function() { return __WEBPACK_IMPORTED_MODULE_30__ui_atoms_section__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ui_atoms_select__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/select.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Select", function() { return __WEBPACK_IMPORTED_MODULE_31__ui_atoms_select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ui_atoms_source__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/source.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Source", function() { return __WEBPACK_IMPORTED_MODULE_32__ui_atoms_source__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__ui_atoms_span__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/span.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Span", function() { return __WEBPACK_IMPORTED_MODULE_33__ui_atoms_span__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ui_atoms_style__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/style.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Style", function() { return __WEBPACK_IMPORTED_MODULE_34__ui_atoms_style__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ui_atoms_svg__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/svg.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Svg", function() { return __WEBPACK_IMPORTED_MODULE_35__ui_atoms_svg__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ui_atoms_table__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/table.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return __WEBPACK_IMPORTED_MODULE_36__ui_atoms_table__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ui_atoms_td__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/td.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Td", function() { return __WEBPACK_IMPORTED_MODULE_37__ui_atoms_td__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ui_atoms_text__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/text.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Text", function() { return __WEBPACK_IMPORTED_MODULE_38__ui_atoms_text__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__ui_atoms_textarea__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/textarea.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Textarea", function() { return __WEBPACK_IMPORTED_MODULE_39__ui_atoms_textarea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__ui_atoms_th__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/th.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Th", function() { return __WEBPACK_IMPORTED_MODULE_40__ui_atoms_th__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__ui_atoms_tr__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/tr.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tr", function() { return __WEBPACK_IMPORTED_MODULE_41__ui_atoms_tr__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__ui_atoms_tspan__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/tspan.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tspan", function() { return __WEBPACK_IMPORTED_MODULE_42__ui_atoms_tspan__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__ui_atoms_ul__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/ul.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ul", function() { return __WEBPACK_IMPORTED_MODULE_43__ui_atoms_ul__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__ui_atoms_video__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/ui/atoms/video.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Video", function() { return __WEBPACK_IMPORTED_MODULE_44__ui_atoms_video__["a"]; });














































/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/a.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('a'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/article.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('article'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/button.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('button'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/circle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('circle'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/div.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('div'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/dl.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('dl'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/footer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('footer'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/form.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('form'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/g.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('g'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/h1.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('h1'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/h2.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('h2'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/h3.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('h3'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/h4.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('h4'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/h5.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('h5'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/h6.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('h6'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/header.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('header'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/i.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('i'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/iframe.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('iframe'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/img.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('img'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/input.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('input'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/label.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('label'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/li.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('li'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/line.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('line'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/main.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('main'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/nav.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('nav'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/ol.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('ol'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/p.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('p'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/path.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('path'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/polygon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('polygon'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/rect.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('rect'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/section.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('section'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('select'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/source.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('source'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/span.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('span'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/style.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('style'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/svg.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('svg'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/table.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('table'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/td.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('td'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/text.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('text'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/textarea.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('textarea'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/th.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('th'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/tr.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('tr'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/tspan.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('tspan'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/ul.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('ul'));

/***/ }),

/***/ "./node_modules/react-atomic-atom/build/es/ui/atoms/video.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_base__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/base.js");

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__src_base__["a" /* default */])('video'));

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/src/build.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var build = function build(component) {
  return function (props, child) {
    return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(component) ? __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]).apply(null, child ? [component, props, child] : [component, props]);
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (build);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/src/config/styles/rwd.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export min */
/* unused harmony export max */
var min = {
  sm: '@media (min-width: 35.5em)',
  md: '@media (min-width: 48em)',
  lg: '@media (min-width: 64em)',
  xl: '@media (min-width: 80em)'
};
var max = {
  sm: '@media (max-width: 35.5em)',
  md: '@media (max-width: 48em)',
  lg: '@media (max-width: 64em)',
  xl: '@media (max-width: 80em)'
};


/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_molecules_Button__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Button.js");
/* unused harmony reexport Button */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_molecules_Card__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Card.js");
/* unused harmony reexport Card */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_molecules_Content__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Content.js");
/* unused harmony reexport Content */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_molecules_Circular__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Circular.js");
/* unused harmony reexport Circular */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_molecules_Description__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Description.js");
/* unused harmony reexport Description */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_molecules_Divider__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Divider.js");
/* unused harmony reexport Divider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_molecules_DividingHeader__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/DividingHeader.js");
/* unused harmony reexport DividingHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_molecules_Dimmer__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Dimmer.js");
/* unused harmony reexport Dimmer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_molecules_Form__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Form.js");
/* unused harmony reexport Form */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_molecules_Field__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Field.js");
/* unused harmony reexport Field */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_molecules_Header__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Header.js");
/* unused harmony reexport Header */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_molecules_Icon__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Icon.js");
/* unused harmony reexport Icon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_molecules_Item__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Item.js");
/* unused harmony reexport Item */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_molecules_Image__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Image.js");
/* unused harmony reexport Image */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ui_molecules_InputBox__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/InputBox.js");
/* unused harmony reexport InputBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ui_molecules_List__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/List.js");
/* unused harmony reexport List */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ui_molecules_Label__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Label.js");
/* unused harmony reexport Label */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ui_molecules_Menu__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Menu.js");
/* unused harmony reexport Menu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ui_molecules_Message__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Message.js");
/* unused harmony reexport Message */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ui_molecules_Meta__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Meta.js");
/* unused harmony reexport Meta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ui_molecules_Progress__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Progress.js");
/* unused harmony reexport Progress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ui_molecules_Rail__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Rail.js");
/* unused harmony reexport Rail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ui_molecules_Ribbon__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Ribbon.js");
/* unused harmony reexport Ribbon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ui_molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_23__ui_molecules_SemanticUI__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ui_molecules_Segment__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Segment.js");
/* unused harmony reexport Segment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ui_molecules_Title__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Title.js");
/* unused harmony reexport Title */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ui_molecules_Unsafe__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Unsafe.js");
/* unused harmony reexport Unsafe */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_class_lib__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_27_class_lib__, "mixClass")) __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_27_class_lib__["mixClass"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__build__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/build.js");
/* unused harmony reexport build */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__lib_styles_injectStyle__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/lib/styles/injectStyle.js");
/* unused harmony reexport injectStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__lib_styles_lazyInject__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/lib/styles/lazyInject.js");
/* unused harmony reexport lazyInject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__lib_styles_index__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/lib/styles/index.js");
/* unused harmony reexport reactStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__lib_styles_mergeStyleConfig__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/lib/styles/mergeStyleConfig.js");
/* unused harmony reexport mergeStyleConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__needCss__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/needCss.js");
/* unused harmony reexport needCss */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__config_styles_rwd__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/config/styles/rwd.js");
/* unused harmony reexport min */
/* unused harmony reexport max */
// ui


























 // libs


 //styles





 // config



/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/src/lib/styles/applyStyles.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isArray = Array.isArray;
var keys = Object.keys;

var applyClassName = function applyClassName(props, order, oStyle) {
  if (!props.className) {
    props.className = '';
  }

  var styleId = oStyle.styleId;
  props.className += ' ' + styleId;

  for (var j = 1; j <= order; j++) {
    props.className += ' ' + styleId + j;
  }

  return order;
};

var applyInlineStyle = function applyInlineStyle(props, order, oStyle) {
  if (isArray(oStyle.selector)) {
    return order;
  }

  if (!props.style) {
    props.style = {};
  }

  oStyle.style.forEach(function (one) {
    return keys(one).forEach(function (key) {
      return props.style[key] = one[key];
    });
  });
  return order;
};

var applyStyle = function applyStyle(props, order) {
  return function (oStyle) {
    if (!oStyle) {
      return order;
    }

    if (!oStyle.isCompiled) {
      console.error('Not a style object', oStyle);
      console.trace();
      return order;
    }

    return oStyle.isCompiled() && order < 10 ? applyClassName(props, order, oStyle) : applyInlineStyle(props, order, oStyle);
  };
};

var applyStyles = function applyStyles(props, styles, order) {
  if (isNaN(order)) {
    order = 0;
  }

  if (!isArray(styles)) {
    styles = [styles];
  }

  var apply = applyStyle(props, order);
  styles.forEach(function (one) {
    return apply(one);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (applyStyles);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/src/lib/styles/bindStyles.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__applyStyles__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/lib/styles/applyStyles.js");

/**
 *  props.className
 *  props.style
 *  props.styles
 *  props.styleOrder
 */

var bindStyles = function bindStyles(_ref) {
  var className = _ref.className,
      style = _ref.style,
      styles = _ref.styles,
      styleOrder = _ref.styleOrder;
  var newStyleProps = {
    className: className,
    style: style
  };
  Object(__WEBPACK_IMPORTED_MODULE_0__applyStyles__["a" /* default */])(newStyleProps, styles, styleOrder);

  if (!newStyleProps.className) {
    delete newStyleProps.className;
  }

  if (!newStyleProps.style) {
    delete newStyleProps.style;
  }

  return newStyleProps;
};

/* harmony default export */ __webpack_exports__["a"] = (bindStyles);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/src/lib/styles/cssNumberToUnit.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cssUnitLessNumber__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/lib/styles/cssUnitLessNumber.js");


var cssUnitToNumber = function cssUnitToNumber(key, value) {
  if (__WEBPACK_IMPORTED_MODULE_0__cssUnitLessNumber__["a" /* isUnitlessNumber */][key]) {
    return value;
  }

  if (value && value.map) {
    value.map(function (v) {
      if ('number' === typeof v) {
        v += 'px';
      }

      return v;
    });
  } else {
    if ('number' === typeof value) {
      value += 'px';
    }
  }

  return value;
};

/* harmony default export */ __webpack_exports__["a"] = (cssUnitToNumber);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/src/lib/styles/cssUnitLessNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isUnitlessNumber; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * CSS properties which accept numbers but are not in units of "px".
 */
var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridArea: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};
/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */

function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}
/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */


var prefixes = ['Webkit', 'ms', 'Moz', 'O']; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.

Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/src/lib/styles/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ucfirst__ = __webpack_require__("./node_modules/ucfirst/ucfirst.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ucfirst___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ucfirst__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/lib/styles/style.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/lib/styles/store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cssNumberToUnit__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/lib/styles/cssNumberToUnit.js");




var isArray = Array.isArray;
var keys = Object.keys;
var Browser = {
  webkit: 'Webkit',
  ms: 'ms',
  moz: 'Moz'
};

var genStyleId = function genStyleId() {
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].counter += 1;
  return 'c' + __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].counter + '_';
};

var createStyle = function createStyle(css, selector, styleId) {
  if (!css) {
    return;
  }

  if ('undefined' === typeof styleId) {
    styleId = genStyleId();
  } else if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].registry[styleId]) {
    return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].registry[styleId];
  }

  if (!isArray(css)) {
    css = [css];
  }

  var styles = [];
  css.forEach(function (one, i) {
    styles[i] = {};
    keys(one).forEach(function (key) {
      if (isArray(one[key]) && 1 === one[key].length) {
        var ucFirstKey = __WEBPACK_IMPORTED_MODULE_0_ucfirst___default()(key);
        styles[i][Browser.webkit + ucFirstKey] = styles[i][Browser.ms + ucFirstKey] = styles[i][Browser.moz + ucFirstKey] = styles[i][key] = Object(__WEBPACK_IMPORTED_MODULE_3__cssNumberToUnit__["a" /* default */])(key, one[key][0]);
      } else {
        styles[i][key] = Object(__WEBPACK_IMPORTED_MODULE_3__cssNumberToUnit__["a" /* default */])(key, one[key]);
      }
    });
  });
  var styleDecl = new __WEBPACK_IMPORTED_MODULE_1__style__["a" /* default */](styles, selector, styleId);
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].newStyles.push(styleDecl);
  return styleDecl;
};

/* harmony default export */ __webpack_exports__["a"] = (createStyle); // reactStyle('', '', '')

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/src/lib/styles/injectStyle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reInjectStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_objectSpread__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectSpread.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_win_doc__ = __webpack_require__("./node_modules/win-doc/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_js__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/lib/styles/store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stylesToCSS__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/lib/styles/stylesToCSS.js");





var reInjectStyle = function reInjectStyle() {
  __WEBPACK_IMPORTED_MODULE_2__store_js__["a" /* default */].newStyles = Object.values(__WEBPACK_IMPORTED_MODULE_2__store_js__["a" /* default */].registry);
  injectStyle();
};

var appendCss = function appendCss(css) {
  var oDoc = Object(__WEBPACK_IMPORTED_MODULE_1_win_doc__["a" /* doc */])();
  var tag = oDoc.createElement('style');
  tag.innerHTML = css;
  oDoc.getElementsByTagName('head')[0].appendChild(tag);
};

var injectStyle = function injectStyle() {
  if (!__WEBPACK_IMPORTED_MODULE_2__store_js__["a" /* default */].newStyles.length) {
    // We are in Node or Styles are already injected
    return null;
  }

  var compiled = Object(__WEBPACK_IMPORTED_MODULE_3__stylesToCSS__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__store_js__["a" /* default */].newStyles);
  __WEBPACK_IMPORTED_MODULE_2__store_js__["a" /* default */].newStyles = [];
  __WEBPACK_IMPORTED_MODULE_2__store_js__["a" /* default */].registry = Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_objectSpread__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_2__store_js__["a" /* default */].registry, compiled.styleIds);

  if (compiled.css) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1_win_doc__["a" /* doc */])().URL) {
      appendCss(compiled.css);
    } else {
      console.log(compiled.css);
    }
  }
};


/* harmony default export */ __webpack_exports__["a"] = (injectStyle);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/src/lib/styles/lazyInject.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/lib/styles/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__injectStyle__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/lib/styles/injectStyle.js");




var isArray = Array.isArray;
var keys = Object.keys;

var lazyInject = function lazyInject(injects, configs) {
  if (!injects) {
    injects = {};
    keys(configs).forEach(function (key) {
      var item = configs[key];

      if (!isArray(item)) {
        item = [item];
      }

      injects[key] = __WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */].apply(null, item);
    });
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__injectStyle__["a" /* default */])();
  return injects;
};

/* unused harmony default export */ var _unused_webpack_default_export = (lazyInject);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/src/lib/styles/mergeStyleConfig.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_objectSpread__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectSpread.js");

var keys = Object.keys;

var mergeStyleConfig = function mergeStyleConfig(styles, defaultStyles, injectStyles) {
  if (defaultStyles) {
    keys(defaultStyles).forEach(function (key) {
      return styles[key] = !styles[key] ? defaultStyles[key] : Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_objectSpread__["a" /* default */])({}, defaultStyles[key], styles[key]);
    });
  }

  if (injectStyles) {
    keys(styles).forEach(function (key) {
      if (injectStyles[key]) {
        injectStyles[key][0] = Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_objectSpread__["a" /* default */])({}, injectStyles[key][0], styles[key]);
      }
    });
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (mergeStyleConfig);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/src/lib/styles/store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_win_doc__ = __webpack_require__("./node_modules/win-doc/build/es/src/index.js");

var stylesStore;
var oWin = Object(__WEBPACK_IMPORTED_MODULE_0_win_doc__["b" /* win */])();
var g = oWin ? oWin : global;

if (g.reactStylesStore) {
  stylesStore = g.reactStylesStore;
} else {
  stylesStore = g.reactStylesStore = {
    registry: [],
    newStyles: [],
    mods: [],
    counter: 0
  };
}

/* harmony default export */ __webpack_exports__["a"] = (stylesStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/react-scripts/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/src/lib/styles/style.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/lib/styles/store.js");
/*jslint browser: true*/




function Style(style, selector, styleId) {
  this.style = style;
  this.selector = selector;
  this.styleId = styleId;
}

Style.prototype.isCompiled = function () {
  var registry = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].registry;
  return registry && registry[this.styleId];
};

/* harmony default export */ __webpack_exports__["a"] = (Style);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/src/lib/styles/stylesToCSS.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__ = __webpack_require__("./node_modules/hyphenate-style-name/index.js");


 // Follows syntax at https://developer.mozilla.org/en-US/docs/Web/CSS/content,
// including multiple space separated values.

var unquotedContentValueRegex = /^(normal|none|(\b(url\([^)]*\)|chapter_counter|attr\([^)]*\)|(no-)?(open|close)-quote|inherit)((\b\s*)|$|\s+))+)$/;
var isArray = Array.isArray;
var keys = Object.keys;
var browsers = ['webkit', 'moz'];

var buildRule = function buildRule(key, value) {
  if (null === value) {
    return '';
  }

  if (key === 'content' && !unquotedContentValueRegex.test(value)) {
    value = "'" + value.replace(/'/g, "\\'") + "'";
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__["a" /* default */])(key) + ': ' + value + ';';
};

var buildRules = function buildRules(result, rules, selector) {
  if (!rules.length) {
    return result;
  }

  var mycss = '';
  var parentSelector = '';

  if (isArray(selector)) {
    parentSelector = selector[0].trim();
    selector.shift();
  } else {
    selector = [selector];
  }

  rules.forEach(function (rule, i) {
    mycss += selector[i] + ' {\n';
    keys(rule).forEach(function (styleKey) {
      if (rule[styleKey] && rule[styleKey].forEach) {
        rule[styleKey].forEach(function (item) {
          return mycss += buildRule(styleKey, item);
        });
      } else {
        mycss += buildRule(styleKey, rule[styleKey]);
      }
    });
    mycss += '}\n\n';
  });

  if (parentSelector) {
    var keyframesString = '@keyframes';

    if (0 === parentSelector.indexOf(keyframesString)) {
      browsers.forEach(function (browser) {
        result.css += parentSelector.replace(keyframesString, '@-' + browser + '-keyframes') + ' {\n' + mycss + '}\n';
      });
    }

    result.css += parentSelector + ' {\n' + mycss + '}\n';
  } else {
    result.css += mycss;
  }

  return result;
};

var replicateSelector = function replicateSelector(s) {
  s = '.' + s;
  var a = [s];

  for (var i = 1; i < 10; i++) {
    a[i] = a[i - 1] + s + i;
  }

  return a.join(',');
};

var buildStyle = function buildStyle(result, oStyle) {
  var styleId = oStyle.styleId;

  if (!styleId || result.styleIds[styleId]) {
    return;
  }

  var selector = oStyle.selector;

  if (selector) {
    if (isArray(selector) && !selector[1]) {
      selector[1] = replicateSelector(styleId);
    }
  } else {
    selector = replicateSelector(styleId);
  }

  result.styleIds[styleId] = oStyle; //for check already inject

  buildRules(result, oStyle.style, selector);
};

var stylesToCSS = function stylesToCSS(styles) {
  if (!isArray(styles)) {
    styles = [styles];
  }

  var result = {
    css: '',
    styleIds: {}
  };
  styles.forEach(function (style) {
    buildStyle(result, style);
  });
  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (stylesToCSS);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/src/needCss.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_styles_store__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/lib/styles/store.js");


var needCss = function needCss(mod) {
  return __WEBPACK_IMPORTED_MODULE_0__lib_styles_store__["a" /* default */].mods[mod] = 1;
};

/* unused harmony default export */ var _unused_webpack_default_export = (needCss);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Button.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectSpread__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectSpread.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_objectWithoutProperties__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectWithoutProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__molecules_Icon__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Icon.js");








var Button = function Button(props) {
  var className = props.className,
      children = props.children,
      icon = props.icon,
      style = props.style,
      others = Object(__WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_objectWithoutProperties__["a" /* default */])(props, ["className", "children", "icon", "style"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_4_class_lib__["mixClass"])(className, 'button');
  var thisIcon;
  var buttonWithIconStyle;

  if (icon) {
    thisIcon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__molecules_Icon__["a" /* default */], {
      style: Styles.icon
    }, icon);
    buttonWithIconStyle = Styles.buttonWithIcon;
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({
    atom: "button"
  }, others, {
    className: classes,
    style: Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectSpread__["a" /* default */])({}, buttonWithIconStyle, style)
  }), thisIcon, children);
};

Button.defaultProps = {
  type: 'button'
};
/* harmony default export */ __webpack_exports__["a"] = (Button);
var Styles = {
  icon: {
    width: 25,
    height: 25,
    left: 20,
    top: 7,
    fill: '#fff',
    position: 'absolute'
  },
  buttonWithIcon: {
    position: 'relative',
    paddingLeft: 44
  }
};

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Card.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");





var Card = function Card(props) {
  var classes = Object(__WEBPACK_IMPORTED_MODULE_2_class_lib__["mixClass"])(props.className, 'card');
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({}, props, {
    className: classes
  }));
};

/* unused harmony default export */ var _unused_webpack_default_export = (Card);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Circular.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");





var Circular = function Circular(props) {
  var classes = Object(__WEBPACK_IMPORTED_MODULE_2_class_lib__["mixClass"])(props.className, 'circular');
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({}, props, {
    className: classes
  }));
};

/* unused harmony default export */ var _unused_webpack_default_export = (Circular);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Content.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectSpread__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectSpread.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_objectWithoutProperties__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectWithoutProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");







var Content = function Content(_ref) {
  var className = _ref.className,
      style = _ref.style,
      props = Object(__WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_objectWithoutProperties__["a" /* default */])(_ref, ["className", "style"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_4_class_lib__["mixClass"])(className, 'content');
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({
    ui: false
  }, props, {
    className: classes,
    style: Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectSpread__["a" /* default */])({}, style, {
      boxSizing: 'inherit'
    })
  }));
};

/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Description.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectWithoutProperties__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectWithoutProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");



/* jshint esnext: true */




var Description = function Description(props) {
  var children = props.children,
      className = props.className,
      lineAtom = props.lineAtom,
      others = Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectWithoutProperties__["a" /* default */])(props, ["children", "className", "lineAtom"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_3_class_lib__["mixClass"])(className, 'description');
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({}, others, {
    ui: false,
    className: classes
  }), children && children.map ? children.map(function (v, k) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__molecules_SemanticUI__["a" /* default */], {
      atom: lineAtom,
      key: k
    }, v);
  }) : children);
};

/* unused harmony default export */ var _unused_webpack_default_export = (Description);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Dimmer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectSpread__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectSpread.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_objectWithoutProperties__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectWithoutProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__molecules_Content__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");




/* jshint esnext: true */





var Dimmer = function Dimmer(props) {
  var className = props.className,
      show = props.show,
      children = props.children,
      center = props.center,
      content = props.content,
      contentStyle = props.contentStyle,
      isModal = props.isModal,
      others = Object(__WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_objectWithoutProperties__["a" /* default */])(props, ["className", "show", "children", "center", "content", "contentStyle", "isModal"]);

  if (!show) {
    return null;
  }

  var classes = Object(__WEBPACK_IMPORTED_MODULE_4_class_lib__["mixClass"])(className, 'transition visible active', {
    dimmer: !isModal,
    modal: isModal
  });
  var child;

  if (center && content) {
    child = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__molecules_Content__["a" /* default */], {
      style: Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectSpread__["a" /* default */])({
        boxSizing: 'inherit'
      }, contentStyle)
    }, children);
  } else {
    child = children;
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({}, others, {
    className: classes
  }), child);
};

Dimmer.defaultProps = {
  show: false,
  isModal: false,
  center: true,
  content: true // same with center attriube, just let user not confuse 

};
/* unused harmony default export */ var _unused_webpack_default_export = (Dimmer);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Divider.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");





var Divider = function Divider(props) {
  var classes = Object(__WEBPACK_IMPORTED_MODULE_2_class_lib__["mixClass"])(props.className, 'divider');
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({}, props, {
    className: classes
  }));
};

/* unused harmony default export */ var _unused_webpack_default_export = (Divider);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/DividingHeader.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");





var DividingHeader = function DividingHeader(props) {
  var classes = Object(__WEBPACK_IMPORTED_MODULE_2_class_lib__["mixClass"])(props.className, 'dividing header');
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({}, props, {
    className: classes
  }));
};

/* unused harmony default export */ var _unused_webpack_default_export = (DividingHeader);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Field.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_objectSpread__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectSpread.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectWithoutProperties__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectWithoutProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_get_object_value__ = __webpack_require__("./node_modules/get-object-value/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");



/* jshint esnext: true */





var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__molecules_SemanticUI__["a" /* default */], null);

var Field = function Field(props) {
  var className = props.className,
      fieldClassName = props.fieldClassName,
      fieldStyle = props.fieldStyle,
      fieldStyles = props.fieldStyles,
      children = props.children,
      inline = props.inline,
      type = props.type,
      inputComponent = props.inputComponent,
      inputWrapper = props.inputWrapper,
      inputWrapperAttr = props.inputWrapperAttr,
      label = props.label,
      labelStyle = props.labelStyle,
      labelStyles = props.labelStyles,
      style = props.style,
      styles = props.styles,
      styleOrder = props.styleOrder,
      required = props.required,
      others = Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectWithoutProperties__["a" /* default */])(props, ["className", "fieldClassName", "fieldStyle", "fieldStyles", "children", "inline", "type", "inputComponent", "inputWrapper", "inputWrapperAttr", "label", "labelStyle", "labelStyles", "style", "styles", "styleOrder", "required"]);

  var isGroup = !(props.atom || inputComponent);
  var classes = Object(__WEBPACK_IMPORTED_MODULE_3_class_lib__["mixClass"])(fieldClassName, {
    required: !!required,
    field: !isGroup,
    fields: isGroup,
    inline: !!inline
  });
  var oLabel = null;

  if (label) {
    var thisLabelStyle = Object(__WEBPACK_IMPORTED_MODULE_4_get_object_value__["a" /* default */])(labelStyle, null, {});

    if (props.id) {
      thisLabelStyle.cursor = 'pointer';
    }

    oLabel = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__molecules_SemanticUI__["a" /* default */], {
      atom: "label",
      key: "label",
      htmlFor: props.id,
      style: thisLabelStyle,
      styles: labelStyles,
      styleOrder: styleOrder
    }, label);
  }

  var input = null;
  var thisFieldStyles = fieldStyles;
  var thisFieldStyle = fieldStyle;
  var thisChildren = children;

  if (isGroup) {
    if (!thisFieldStyles) {
      thisFieldStyles = styles;
    }

    if (!thisFieldStyle) {
      thisFieldStyle = style;
    }
  } else {
    var isSelect = 'select' === props.atom;
    input = inputComponent ? inputComponent : _ref;
    var inputProps = Object(__WEBPACK_IMPORTED_MODULE_4_get_object_value__["a" /* default */])(input, ['props'], {}); // set inputChildren 

    var inputChildren = inputProps.children || null;

    if (isSelect) {
      thisChildren = null;
      inputChildren = children;
    }

    var inputClasses = Object(__WEBPACK_IMPORTED_MODULE_3_class_lib__["mixClass"])(className, inputProps.className, {
      dropdown: isSelect
    });
    input = Object(__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"])(input, Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_objectSpread__["a" /* default */])({}, others, {
      style: Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_objectSpread__["a" /* default */])({
        boxSizing: 'inherit'
      }, Object(__WEBPACK_IMPORTED_MODULE_4_get_object_value__["a" /* default */])(input, ['props', 'style']), style),
      key: 'input',
      className: inputClasses,
      styles: styles,
      styleOrder: styleOrder,
      required: required,
      type: type
    }), inputChildren);
  }

  var inputs;

  if ('checkbox' === type || 'radio' === type) {
    inputs = [input, oLabel];
  } else {
    inputs = [oLabel, input];
  }

  if (inputWrapper) {
    inputs = Object(__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"])(inputWrapper, inputWrapperAttr, inputs);
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__molecules_SemanticUI__["a" /* default */], {
    className: classes,
    style: thisFieldStyle,
    styles: thisFieldStyles,
    styleOrder: styleOrder
  }, inputs, thisChildren);
};

/* unused harmony default export */ var _unused_webpack_default_export = (Field);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Form.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectWithoutProperties__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectWithoutProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");



/* jshint esnext: true */




var Form = function Form(props) {
  var messageType = props.messageType,
      className = props.className,
      others = Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectWithoutProperties__["a" /* default */])(props, ["messageType", "className"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_3_class_lib__["mixClass"])(className, messageType, 'form');
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({
    atom: "form"
  }, others, {
    className: classes
  }));
};

/* unused harmony default export */ var _unused_webpack_default_export = (Form);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Header.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");





var Header = function Header(props) {
  var classes = Object(__WEBPACK_IMPORTED_MODULE_2_class_lib__["mixClass"])(props.className, 'header');
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({}, props, {
    className: classes
  }));
};

/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Icon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectSpread__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectSpread.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_objectWithoutProperties__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectWithoutProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");







var Icon = function Icon(props) {
  var className = props.className,
      style = props.style,
      others = Object(__WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_objectWithoutProperties__["a" /* default */])(props, ["className", "style"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_4_class_lib__["mixClass"])(className, 'icon');
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({
    atom: "i",
    ui: false
  }, others, {
    className: className,
    style: Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectSpread__["a" /* default */])({
      display: 'inline-block'
    }, style)
  }));
};

/* harmony default export */ __webpack_exports__["a"] = (Icon);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Image.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");





var Image = function Image(props) {
  var alt = props.alt,
      title = props.title,
      ui = props.ui;
  var classes = Object(__WEBPACK_IMPORTED_MODULE_2_class_lib__["mixClass"])(props.className, {
    image: ui
  });
  var thisAlt = alt;

  if (!thisAlt) {
    thisAlt = title;
  }

  if (props.atom && 'img' !== props.atom) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({}, props, {
      className: classes
    }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__["a" /* default */], {
      atom: "img",
      src: props.src,
      alt: thisAlt
    }), props.children);
  } else {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({
      atom: "img"
    }, props, {
      alt: thisAlt,
      className: classes
    }));
  }
};

Image.defaultProps = {
  ui: true
};
/* unused harmony default export */ var _unused_webpack_default_export = (Image);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/InputBox.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectWithoutProperties__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectWithoutProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__molecules_Button__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__molecules_Label__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Label.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__molecules_Icon__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Icon.js");



/* jshint esnext: true */







var InputBox = function InputBox(props) {
  var icon = props.icon,
      button = props.button,
      buttonProps = props.buttonProps,
      className = props.className,
      children = props.children,
      messageType = props.messageType,
      leftLabel = props.leftLabel,
      leftLabelProps = props.leftLabelProps,
      rightLabel = props.rightLabel,
      rightLabelProps = props.rightLabelProps,
      style = props.style,
      transparent = props.transparent,
      inputStyle = props.inputStyle,
      others = Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectWithoutProperties__["a" /* default */])(props, ["icon", "button", "buttonProps", "className", "children", "messageType", "leftLabel", "leftLabelProps", "rightLabel", "rightLabelProps", "style", "transparent", "inputStyle"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_3_class_lib__["mixClass"])(className, messageType, 'input', {
    labeled: leftLabel || rightLabel,
    right: rightLabel,
    action: button && !icon,
    icon: icon,
    transparent: transparent
  });
  var thisLeftLabel;

  if (leftLabel) {
    thisLeftLabel = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__molecules_Label__["a" /* default */], leftLabelProps, leftLabel);
  }

  var thisRightLabel;

  if (rightLabel) {
    thisRightLabel = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__molecules_Label__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({
      style: Styles.rightLabel,
      className: "basic"
    }, rightLabelProps), rightLabel);
  }

  var thisButton = null;

  if (button) {
    thisButton = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__molecules_Button__["a" /* default */], buttonProps, button);
  }

  if (icon) {
    thisButton = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__molecules_Icon__["a" /* default */], {
      style: Styles.icon
    }, icon);
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__molecules_SemanticUI__["a" /* default */], {
    className: classes,
    style: style
  }, thisLeftLabel, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({
    atom: "input"
  }, others, {
    style: inputStyle,
    ui: false
  })), thisRightLabel, children, thisButton);
};

InputBox.defaultProps = {
  button: 'Submit'
};
/* unused harmony default export */ var _unused_webpack_default_export = (InputBox);
var Styles = {
  rightLabel: {
    borderRadius: 0
  },
  icon: {
    width: '1.1em',
    position: 'absolute',
    top: 0,
    right: 0,
    opacity: .5
  }
};

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Item.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");


/* jshint esnext: true */




var Item = function Item(props) {
  var classes = Object(__WEBPACK_IMPORTED_MODULE_2_class_lib__["mixClass"])(props.className, 'item');
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({}, props, {
    className: classes
  }));
};

/* unused harmony default export */ var _unused_webpack_default_export = (Item);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Label.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");





var Label = function Label(props) {
  var classes = Object(__WEBPACK_IMPORTED_MODULE_2_class_lib__["mixClass"])(props.className, 'label');
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({}, props, {
    className: classes
  }));
};

/* harmony default export */ __webpack_exports__["a"] = (Label);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/List.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectWithoutProperties__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectWithoutProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");






var renderChildren = function renderChildren(children, atom) {
  return __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child) {
    if (!child) {
      return null;
    }

    if ('ul' === atom || 'ol' === atom) {
      child = Object(__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"])(child, {
        atom: 'li'
      });
    }

    return child;
  });
};

var List = function List(props) {
  var type = props.type,
      className = props.className,
      children = props.children,
      others = Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectWithoutProperties__["a" /* default */])(props, ["type", "className", "children"]);

  var typeClass = 'list';

  if (type) {
    typeClass = type;
  }

  var classes = Object(__WEBPACK_IMPORTED_MODULE_3_class_lib__["mixClass"])(className, typeClass);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({}, others, {
    className: classes
  }), renderChildren(children, props.atom));
};

/* unused harmony default export */ var _unused_webpack_default_export = (List);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Menu.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");





var Menu = function Menu(props) {
  var classes = Object(__WEBPACK_IMPORTED_MODULE_2_class_lib__["mixClass"])(props.className, 'menu');
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({}, props, {
    className: classes
  }));
};

/* unused harmony default export */ var _unused_webpack_default_export = (Menu);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Message.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectWithoutProperties__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectWithoutProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__molecules_Header__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Header.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");







var Message = function Message(props) {
  var header = props.header,
      className = props.className,
      children = props.children,
      messageType = props.messageType,
      reset = Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectWithoutProperties__["a" /* default */])(props, ["header", "className", "children", "messageType"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_3_class_lib__["mixClass"])(className, {
    info: messageType === 'info',
    error: messageType === 'error',
    success: messageType === 'success',
    warning: messageType === 'warning'
  }, 'message');
  var thisHeader;

  if (header) {
    thisHeader = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__molecules_Header__["a" /* default */], null, header);
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({}, reset, {
    className: classes
  }), thisHeader, children);
};

/* unused harmony default export */ var _unused_webpack_default_export = (Message);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Meta.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");





var Meta = function Meta(props) {
  var classes = Object(__WEBPACK_IMPORTED_MODULE_2_class_lib__["mixClass"])(props.className, 'meta');
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({}, props, {
    ui: false,
    className: classes
  }));
};

/* unused harmony default export */ var _unused_webpack_default_export = (Meta);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Progress.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectSpread__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectSpread.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_objectWithoutProperties__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectWithoutProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_lib_styles_index__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/lib/styles/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");








var Progress = function Progress(props) {
  var barProps = props.barProps,
      className = props.className,
      percent = props.percent,
      style = props.style,
      styles = props.styles,
      others = Object(__WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_objectWithoutProperties__["a" /* default */])(props, ["barProps", "className", "percent", "style", "styles"]);

  var _ref = barProps || {},
      barStyle = _ref.style,
      barStyles = _ref.styles,
      otherBarProps = Object(__WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_objectWithoutProperties__["a" /* default */])(_ref, ["style", "styles"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5_class_lib__["mixClass"])(className, 'progress');
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({}, others, {
    className: classes,
    styles: [Object(__WEBPACK_IMPORTED_MODULE_4__src_lib_styles_index__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectSpread__["a" /* default */])({
      fontSize: 0
    }, style), null, false), styles]
  }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({
    className: "bar"
  }, otherBarProps, {
    styles: [Object(__WEBPACK_IMPORTED_MODULE_4__src_lib_styles_index__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectSpread__["a" /* default */])({
      width: percent + '%'
    }, barStyle), null, false), barStyles]
  })));
};

/* unused harmony default export */ var _unused_webpack_default_export = (Progress);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Rail.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectWithoutProperties__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectWithoutProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");



/* jshint esnext: true */




var Rail = function Rail(props) {
  var attached = props.attached,
      left = props.left,
      others = Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectWithoutProperties__["a" /* default */])(props, ["attached", "left"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_3_class_lib__["mixClass"])(props.className, 'rail', {
    left: left,
    attached: attached
  });
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({}, others, {
    className: classes
  }));
};

Rail.defaultProps = {
  attached: true,
  left: true
};
/* unused harmony default export */ var _unused_webpack_default_export = (Rail);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Ribbon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__molecules_Label__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/Label.js");





var Ribbon = function Ribbon(props) {
  var classes = Object(__WEBPACK_IMPORTED_MODULE_2_class_lib__["mixClass"])(props.className, 'ribbon');
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__molecules_Label__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({}, props, {
    clssName: classes
  }));
};

/* unused harmony default export */ var _unused_webpack_default_export = (Ribbon);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Segment.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");





var Segment = function Segment(props) {
  var classes = Object(__WEBPACK_IMPORTED_MODULE_2_class_lib__["mixClass"])(props.className, 'segment');
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({}, props, {
    className: classes
  }));
};

/* unused harmony default export */ var _unused_webpack_default_export = (Segment);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_objectWithoutProperties__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectWithoutProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_atomic_atom__ = __webpack_require__("./node_modules/react-atomic-atom/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_get_object_value__ = __webpack_require__("./node_modules/get-object-value/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ucfirst__ = __webpack_require__("./node_modules/ucfirst/ucfirst.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ucfirst___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ucfirst__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_lib_styles_injectStyle__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/lib/styles/injectStyle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_lib_styles_bindStyles__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/src/lib/styles/bindStyles.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_class_lib__);


/* jshint esnext: true */







var keys = Object.keys;

var getChildren = function getChildren(render, children) {
  if (!render) {
    return null;
  }
  /**
   * Hack for https://fb.me/react-warning-keys
   * Each child in an array or iterator should have a unique "key"
   */


  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.map(children, function (c) {
    return c;
  });
};

var SemanticUI = function SemanticUI(_ref) {
  var atom = _ref.atom,
      children = _ref.children,
      renderChildren = _ref.renderChildren,
      styles = _ref.styles,
      styleOrder = _ref.styleOrder,
      ui = _ref.ui,
      others = Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_objectWithoutProperties__["a" /* default */])(_ref, ["atom", "children", "renderChildren", "styles", "styleOrder", "ui"]);

  var component;

  switch (atom) {
    case 'null':
      return null;

    case 'input':
      component = __WEBPACK_IMPORTED_MODULE_2_react_atomic_atom__["Input"];
      renderChildren = false;
      break;

    case 'img':
      component = __WEBPACK_IMPORTED_MODULE_2_react_atomic_atom__["Img"];
      renderChildren = false;
      break;

    case 'path':
      component = __WEBPACK_IMPORTED_MODULE_2_react_atomic_atom__["Path"];
      renderChildren = false;
      ui = false;
      break;

    default:
      component = Object(__WEBPACK_IMPORTED_MODULE_3_get_object_value__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_react_atomic_atom__, [__WEBPACK_IMPORTED_MODULE_4_ucfirst___default()(atom || '')], function () {
        return __WEBPACK_IMPORTED_MODULE_2_react_atomic_atom__["Div"];
      });
      break;
  }

  var className = others.className,
      style = others.style; // bindStyles need after inject

  var bindProps = {};

  if (styles) {
    // Need avoid props pass by ref !!important!!
    Object(__WEBPACK_IMPORTED_MODULE_5__src_lib_styles_injectStyle__["a" /* default */])();
    bindProps = Object(__WEBPACK_IMPORTED_MODULE_6__src_lib_styles_bindStyles__["a" /* default */])({
      className: className,
      style: style,
      styles: styles,
      styleOrder: styleOrder
    });
  }

  keys(bindProps).forEach(function (key) {
    return others[key] = bindProps[key];
  });

  if (ui) {
    // others.className maybe effect by bindProps, so use it here.
    others.className = Object(__WEBPACK_IMPORTED_MODULE_7_class_lib__["mixClass"])(others.className, 'ui');
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(component, others, getChildren(renderChildren, children));
};

SemanticUI.defaultProps = {
  ui: true,
  renderChildren: true
};
/* harmony default export */ __webpack_exports__["a"] = (SemanticUI);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Title.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");





var Title = function Title(props) {
  var classes = Object(__WEBPACK_IMPORTED_MODULE_2_class_lib__["mixClass"])(props.className, 'title');
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({}, props, {
    className: classes
  }));
};

/* unused harmony default export */ var _unused_webpack_default_export = (Title);

/***/ }),

/***/ "./node_modules/react-atomic-molecule/build/es/ui/molecules/Unsafe.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectWithoutProperties__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectWithoutProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_class_lib__ = __webpack_require__("./node_modules/class-lib/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_class_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_class_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__molecules_SemanticUI__ = __webpack_require__("./node_modules/react-atomic-molecule/build/es/ui/molecules/SemanticUI.js");






var Unsafe = function Unsafe(_ref) {
  var className = _ref.className,
      children = _ref.children,
      others = Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_objectWithoutProperties__["a" /* default */])(_ref, ["className", "children"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__molecules_SemanticUI__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_extends__["a" /* default */])({}, others, {
    className: Object(__WEBPACK_IMPORTED_MODULE_3_class_lib__["mixClass"])('us-html', className),
    dangerouslySetInnerHTML: {
      __html: 'function' === typeof children ? children() : children
    }
  }));
};

/* unused harmony default export */ var _unused_webpack_default_export = (Unsafe);

/***/ }),

/***/ "./node_modules/react-bootstrap/lib/Collapse.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/interopRequireDefault.js");

var _interopRequireWildcard = __webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard.js");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/extends.js"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/objectWithoutPropertiesLoose.js"));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/inheritsLoose.js"));

var _parseInt2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/core-js/parse-int.js"));

var _classnames = _interopRequireDefault(__webpack_require__("./node_modules/classnames/index.js"));

var _style = _interopRequireDefault(__webpack_require__("./node_modules/dom-helpers/style/index.js"));

var _react = _interopRequireDefault(__webpack_require__("./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__("./node_modules/prop-types/index.js"));

var _Transition = _interopRequireWildcard(__webpack_require__("./node_modules/react-transition-group/Transition.js"));

var _capitalize = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/lib/utils/capitalize.js"));

var _createChainedFunction = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/lib/utils/createChainedFunction.js"));

var _collapseStyles;

var MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
}; // reading a dimension prop will cause the browser to recalculate,
// which will let our animations work

function triggerBrowserReflow(node) {
  node.offsetHeight; // eslint-disable-line no-unused-expressions
}

function getDimensionValue(dimension, elem) {
  var value = elem["offset" + (0, _capitalize.default)(dimension)];
  var margins = MARGINS[dimension];
  return value + (0, _parseInt2.default)((0, _style.default)(elem, margins[0]), 10) + (0, _parseInt2.default)((0, _style.default)(elem, margins[1]), 10);
}

var collapseStyles = (_collapseStyles = {}, _collapseStyles[_Transition.EXITED] = 'collapse', _collapseStyles[_Transition.EXITING] = 'collapsing', _collapseStyles[_Transition.ENTERING] = 'collapsing', _collapseStyles[_Transition.ENTERED] = 'collapse in', _collapseStyles);
var propTypes = {
  /**
   * Show the component; triggers the expand or collapse animation
   */
  in: _propTypes.default.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: _propTypes.default.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is collapsed
   */
  unmountOnExit: _propTypes.default.bool,

  /**
   * Run the expand animation when the component mounts, if it is initially
   * shown
   */
  appear: _propTypes.default.bool,

  /**
   * Duration of the collapse animation in milliseconds, to ensure that
   * finishing callbacks are fired even if the original browser transition end
   * events are canceled
   */
  timeout: _propTypes.default.number,

  /**
   * Callback fired before the component expands
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired after the component starts to expand
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired after the component has expanded
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired before the component collapses
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: _propTypes.default.func,

  /**
   * Callback fired after the component has collapsed
   */
  onExited: _propTypes.default.func,

  /**
   * The dimension used when collapsing, or a function that returns the
   * dimension
   *
   * _Note: Bootstrap only partially supports 'width'!
   * You will need to supply your own CSS animation for the `.width` CSS class._
   */
  dimension: _propTypes.default.oneOfType([_propTypes.default.oneOf(['height', 'width']), _propTypes.default.func]),

  /**
   * Function that returns the height or width of the animating DOM node
   *
   * Allows for providing some custom logic for how much the Collapse component
   * should animate in its specified dimension. Called with the current
   * dimension prop value and the DOM node.
   */
  getDimensionValue: _propTypes.default.func,

  /**
   * ARIA role of collapsible element
   */
  role: _propTypes.default.string
};
var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  dimension: 'height',
  getDimensionValue: getDimensionValue
};

var Collapse =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Collapse, _React$Component);

  function Collapse() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleEnter = function (elem) {
      elem.style[_this.getDimension()] = '0';
    };

    _this.handleEntering = function (elem) {
      var dimension = _this.getDimension();

      elem.style[dimension] = _this._getScrollDimensionValue(elem, dimension);
    };

    _this.handleEntered = function (elem) {
      elem.style[_this.getDimension()] = null;
    };

    _this.handleExit = function (elem) {
      var dimension = _this.getDimension();

      elem.style[dimension] = _this.props.getDimensionValue(dimension, elem) + "px";
      triggerBrowserReflow(elem);
    };

    _this.handleExiting = function (elem) {
      elem.style[_this.getDimension()] = '0';
    };

    return _this;
  }

  var _proto = Collapse.prototype;

  _proto.getDimension = function getDimension() {
    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
  }; // for testing


  _proto._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
    return elem["scroll" + (0, _capitalize.default)(dimension)] + "px";
  };
  /* -- Expanding -- */


  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        onEnter = _this$props.onEnter,
        onEntering = _this$props.onEntering,
        onEntered = _this$props.onEntered,
        onExit = _this$props.onExit,
        onExiting = _this$props.onExiting,
        className = _this$props.className,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["onEnter", "onEntering", "onEntered", "onExit", "onExiting", "className", "children"]);
    delete props.dimension;
    delete props.getDimensionValue;
    var handleEnter = (0, _createChainedFunction.default)(this.handleEnter, onEnter);
    var handleEntering = (0, _createChainedFunction.default)(this.handleEntering, onEntering);
    var handleEntered = (0, _createChainedFunction.default)(this.handleEntered, onEntered);
    var handleExit = (0, _createChainedFunction.default)(this.handleExit, onExit);
    var handleExiting = (0, _createChainedFunction.default)(this.handleExiting, onExiting);
    return _react.default.createElement(_Transition.default, (0, _extends2.default)({}, props, {
      "aria-expanded": props.role ? props.in : null,
      onEnter: handleEnter,
      onEntering: handleEntering,
      onEntered: handleEntered,
      onExit: handleExit,
      onExiting: handleExiting
    }), function (state, innerProps) {
      return _react.default.cloneElement(children, (0, _extends2.default)({}, innerProps, {
        className: (0, _classnames.default)(className, children.props.className, collapseStyles[state], _this2.getDimension() === 'width' && 'width')
      }));
    });
  };

  return Collapse;
}(_react.default.Component);

Collapse.propTypes = propTypes;
Collapse.defaultProps = defaultProps;
var _default = Collapse;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/react-bootstrap/lib/Panel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/core-js/object/assign.js"));

var _values = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/core-js/object/values.js"));

var _extends2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/extends.js"));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/inheritsLoose.js"));

var _classnames = _interopRequireDefault(__webpack_require__("./node_modules/classnames/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__("./node_modules/prop-types/index.js"));

var _react = _interopRequireDefault(__webpack_require__("./node_modules/react/index.js"));

var _uncontrollable = _interopRequireDefault(__webpack_require__("./node_modules/uncontrollable/index.js"));

var _warning = _interopRequireDefault(__webpack_require__("./node_modules/warning/browser.js"));

var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");

var _StyleConfig = __webpack_require__("./node_modules/react-bootstrap/lib/utils/StyleConfig.js");

var _PanelBody = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/lib/PanelBody.js"));

var _PanelHeading = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/lib/PanelHeading.js"));

var _PanelTitle = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/lib/PanelTitle.js"));

var _PanelFooter = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/lib/PanelFooter.js"));

var _PanelToggle = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/lib/PanelToggle.js"));

var _PanelCollapse = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/lib/PanelCollapse.js"));

var has = Object.prototype.hasOwnProperty;

var defaultGetId = function defaultGetId(id, type) {
  return id ? id + "--" + type : null;
};

var propTypes = {
  /**
   * Controls the collapsed/expanded state ofthe Panel. Requires
   * a `Panel.Collapse` or `<Panel.Body collapsible>` child component
   * in order to actually animate out or in.
   *
   * @controllable onToggle
   */
  expanded: _propTypes.default.bool,

  /**
   * A callback fired when the collapse state changes.
   *
   * @controllable expanded
   */
  onToggle: _propTypes.default.func,
  eventKey: _propTypes.default.any,

  /**
   * An HTML `id` attribute uniquely identifying the Panel component.
   */
  id: _propTypes.default.string
};
var contextTypes = {
  $bs_panelGroup: _propTypes.default.shape({
    getId: _propTypes.default.func,
    activeKey: _propTypes.default.any,
    onToggle: _propTypes.default.func
  })
};
var childContextTypes = {
  $bs_panel: _propTypes.default.shape({
    headingId: _propTypes.default.string,
    bodyId: _propTypes.default.string,
    bsClass: _propTypes.default.string,
    onToggle: _propTypes.default.func,
    expanded: _propTypes.default.bool
  })
};

var Panel =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Panel, _React$Component);

  function Panel() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleToggle = function (e) {
      var panelGroup = _this.context.$bs_panelGroup;
      var expanded = !_this.getExpanded();

      if (panelGroup && panelGroup.onToggle) {
        panelGroup.onToggle(_this.props.eventKey, expanded, e);
      } else {
        _this.props.onToggle(expanded, e);
      }
    };

    return _this;
  }

  var _proto = Panel.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        eventKey = _this$props.eventKey,
        id = _this$props.id;
    var idKey = eventKey == null ? id : eventKey;
    var ids;

    if (idKey !== null) {
      var panelGroup = this.context.$bs_panelGroup;
      var getId = panelGroup && panelGroup.getId || defaultGetId;
      ids = {
        headingId: getId(idKey, 'heading'),
        bodyId: getId(idKey, 'body')
      };
    }

    return {
      $bs_panel: (0, _extends2.default)({}, ids, {
        bsClass: this.props.bsClass,
        expanded: this.getExpanded(),
        onToggle: this.handleToggle
      })
    };
  };

  _proto.getExpanded = function getExpanded() {
    var panelGroup = this.context.$bs_panelGroup;

    if (panelGroup && has.call(panelGroup, 'activeKey')) {
       false ? (0, _warning.default)(this.props.expanded == null, 'Specifying `<Panel>` `expanded` in the context of an accordion ' + '`<PanelGroup>` is not supported. Set `activeKey` on the ' + '`<PanelGroup>` instead.') : void 0;
      return panelGroup.activeKey === this.props.eventKey;
    }

    return !!this.props.expanded;
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        className = _this$props2.className,
        children = _this$props2.children;

    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(this.props, ['onToggle', 'eventKey', 'expanded']),
        bsProps = _splitBsPropsAndOmit[0],
        props = _splitBsPropsAndOmit[1];

    return _react.default.createElement("div", (0, _extends2.default)({}, props, {
      className: (0, _classnames.default)(className, (0, _bootstrapUtils.getClassSet)(bsProps))
    }), children);
  };

  return Panel;
}(_react.default.Component);

Panel.propTypes = propTypes;
Panel.contextTypes = contextTypes;
Panel.childContextTypes = childContextTypes;
var UncontrolledPanel = (0, _uncontrollable.default)((0, _bootstrapUtils.bsClass)('panel', (0, _bootstrapUtils.bsStyles)((0, _values.default)(_StyleConfig.State).concat([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Panel)), {
  expanded: 'onToggle'
});
(0, _assign.default)(UncontrolledPanel, {
  Heading: _PanelHeading.default,
  Title: _PanelTitle.default,
  Body: _PanelBody.default,
  Footer: _PanelFooter.default,
  Toggle: _PanelToggle.default,
  Collapse: _PanelCollapse.default
});
var _default = UncontrolledPanel;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/react-bootstrap/lib/PanelBody.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/extends.js"));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/inheritsLoose.js"));

var _propTypes = _interopRequireDefault(__webpack_require__("./node_modules/prop-types/index.js"));

var _react = _interopRequireDefault(__webpack_require__("./node_modules/react/index.js"));

var _classnames = _interopRequireDefault(__webpack_require__("./node_modules/classnames/index.js"));

var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");

var _PanelCollapse = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/lib/PanelCollapse.js"));

var propTypes = {
  /**
   * A convenience prop that renders a Collapse component around the Body for
   * situations when the parent Panel only contains a single Panel.Body child.
   *
   * renders:
   * ```jsx
   * <Panel.Collapse>
   *  <Panel.Body />
   * </Panel.Collapse>
   * ```
   */
  collapsible: _propTypes.default.bool.isRequired
};
var defaultProps = {
  collapsible: false
};
var contextTypes = {
  $bs_panel: _propTypes.default.shape({
    bsClass: _propTypes.default.string
  })
};

var PanelBody =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(PanelBody, _React$Component);

  function PanelBody() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelBody.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        collapsible = _this$props.collapsible;

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(this.props, ['collapsible']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    var body = _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'body'))
    }), children);

    if (collapsible) {
      body = _react.default.createElement(_PanelCollapse.default, null, body);
    }

    return body;
  };

  return PanelBody;
}(_react.default.Component);

PanelBody.propTypes = propTypes;
PanelBody.defaultProps = defaultProps;
PanelBody.contextTypes = contextTypes;

var _default = (0, _bootstrapUtils.bsClass)('panel', PanelBody);

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/react-bootstrap/lib/PanelCollapse.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/extends.js"));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/inheritsLoose.js"));

var _propTypes = _interopRequireDefault(__webpack_require__("./node_modules/prop-types/index.js"));

var _react = _interopRequireDefault(__webpack_require__("./node_modules/react/index.js"));

var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");

var _Collapse = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/lib/Collapse.js"));

var propTypes = {
  /**
   * Callback fired before the component expands
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired after the component starts to expand
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired after the component has expanded
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired before the component collapses
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: _propTypes.default.func,

  /**
   * Callback fired after the component has collapsed
   */
  onExited: _propTypes.default.func
};
var contextTypes = {
  $bs_panel: _propTypes.default.shape({
    headingId: _propTypes.default.string,
    bodyId: _propTypes.default.string,
    bsClass: _propTypes.default.string,
    expanded: _propTypes.default.bool
  })
};

var PanelCollapse =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(PanelCollapse, _React$Component);

  function PanelCollapse() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelCollapse.prototype;

  _proto.render = function render() {
    var children = this.props.children;

    var _ref = this.context.$bs_panel || {},
        headingId = _ref.headingId,
        bodyId = _ref.bodyId,
        _bsClass = _ref.bsClass,
        expanded = _ref.expanded;

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(this.props),
        bsProps = _splitBsProps[0],
        props = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (headingId && bodyId) {
      props.id = bodyId;
      props.role = props.role || 'tabpanel';
      props['aria-labelledby'] = headingId;
    }

    return _react.default.createElement(_Collapse.default, (0, _extends2.default)({
      in: expanded
    }, props), _react.default.createElement("div", {
      className: (0, _bootstrapUtils.prefix)(bsProps, 'collapse')
    }, children));
  };

  return PanelCollapse;
}(_react.default.Component);

PanelCollapse.propTypes = propTypes;
PanelCollapse.contextTypes = contextTypes;

var _default = (0, _bootstrapUtils.bsClass)('panel', PanelCollapse);

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/react-bootstrap/lib/PanelFooter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/extends.js"));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/inheritsLoose.js"));

var _propTypes = _interopRequireDefault(__webpack_require__("./node_modules/prop-types/index.js"));

var _react = _interopRequireDefault(__webpack_require__("./node_modules/react/index.js"));

var _classnames = _interopRequireDefault(__webpack_require__("./node_modules/classnames/index.js"));

var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");

var contextTypes = {
  $bs_panel: _propTypes.default.shape({
    bsClass: _propTypes.default.string
  })
};

var PanelFooter =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(PanelFooter, _React$Component);

  function PanelFooter() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelFooter.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className;

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(this.props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;
    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'footer'))
    }), children);
  };

  return PanelFooter;
}(_react.default.Component);

PanelFooter.contextTypes = contextTypes;

var _default = (0, _bootstrapUtils.bsClass)('panel', PanelFooter);

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/react-bootstrap/lib/PanelGroup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard.js");

var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.default = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/objectWithoutPropertiesLoose.js"));

var _extends2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/extends.js"));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/inheritsLoose.js"));

var _classnames = _interopRequireDefault(__webpack_require__("./node_modules/classnames/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__("./node_modules/prop-types/index.js"));

var _react = _interopRequireWildcard(__webpack_require__("./node_modules/react/index.js"));

var _uncontrollable = _interopRequireDefault(__webpack_require__("./node_modules/uncontrollable/index.js"));

var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");

var _ValidComponentChildren = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/lib/utils/ValidComponentChildren.js"));

var _PropTypes = __webpack_require__("./node_modules/react-bootstrap/lib/utils/PropTypes.js");

var propTypes = {
  accordion: _propTypes.default.bool,

  /**
   * When `accordion` is enabled, `activeKey` controls the which child `Panel` is expanded. `activeKey` should
   * match a child Panel `eventKey` prop exactly.
   *
   * @controllable onSelect
   */
  activeKey: _propTypes.default.any,

  /**
   * A callback fired when a child Panel collapse state changes. It's called with the next expanded `activeKey`
   *
   * @controllable activeKey
   */
  onSelect: _propTypes.default.func,

  /**
   * An HTML role attribute
   */
  role: _propTypes.default.string,

  /**
   * A function that takes an eventKey and type and returns a
   * unique id for each Panel heading and Panel Collapse. The function _must_ be a pure function,
   * meaning it should always return the _same_ id for the same set of inputs. The default
   * value requires that an `id` to be set for the PanelGroup.
   *
   * The `type` argument will either be `"body"` or `"heading"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: _propTypes.default.func,

  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: (0, _PropTypes.generatedId)('PanelGroup')
};
var defaultProps = {
  accordion: false
};
var childContextTypes = {
  $bs_panelGroup: _propTypes.default.shape({
    getId: _propTypes.default.func,
    headerRole: _propTypes.default.string,
    panelRole: _propTypes.default.string,
    activeKey: _propTypes.default.any,
    onToggle: _propTypes.default.func
  })
};

var PanelGroup =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(PanelGroup, _React$Component);

  function PanelGroup() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleSelect = function (key, expanded, e) {
      if (expanded) {
        _this.props.onSelect(key, e);
      } else if (_this.props.activeKey === key) {
        _this.props.onSelect(null, e);
      }
    };

    return _this;
  }

  var _proto = PanelGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        activeKey = _this$props.activeKey,
        accordion = _this$props.accordion,
        generateChildId = _this$props.generateChildId,
        id = _this$props.id;
    var getId = null;

    if (accordion) {
      getId = generateChildId || function (key, type) {
        return id ? id + "-" + type + "-" + key : null;
      };
    }

    return {
      $bs_panelGroup: (0, _extends2.default)({
        getId: getId,
        headerRole: 'tab',
        panelRole: 'tabpanel'
      }, accordion && {
        activeKey: activeKey,
        onToggle: this.handleSelect
      })
    };
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        accordion = _this$props2.accordion,
        className = _this$props2.className,
        children = _this$props2.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["accordion", "className", "children"]);

    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['onSelect', 'activeKey']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (accordion) {
      elementProps.role = elementProps.role || 'tablist';
    }

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }), _ValidComponentChildren.default.map(children, function (child) {
      return (0, _react.cloneElement)(child, {
        bsStyle: child.props.bsStyle || bsProps.bsStyle
      });
    }));
  };

  return PanelGroup;
}(_react.default.Component);

PanelGroup.propTypes = propTypes;
PanelGroup.defaultProps = defaultProps;
PanelGroup.childContextTypes = childContextTypes;

var _default = (0, _uncontrollable.default)((0, _bootstrapUtils.bsClass)('panel-group', PanelGroup), {
  activeKey: 'onSelect'
});

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/react-bootstrap/lib/PanelHeading.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/extends.js"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/objectWithoutPropertiesLoose.js"));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/inheritsLoose.js"));

var _propTypes = _interopRequireDefault(__webpack_require__("./node_modules/prop-types/index.js"));

var _react = _interopRequireDefault(__webpack_require__("./node_modules/react/index.js"));

var _classnames = _interopRequireDefault(__webpack_require__("./node_modules/classnames/index.js"));

var _elementType = _interopRequireDefault(__webpack_require__("./node_modules/react-prop-types/lib/elementType.js"));

var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");

var propTypes = {
  componentClass: _elementType.default
};
var defaultProps = {
  componentClass: 'div'
};
var contextTypes = {
  $bs_panel: _propTypes.default.shape({
    headingId: _propTypes.default.string,
    bsClass: _propTypes.default.string
  })
};

var PanelHeading =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(PanelHeading, _React$Component);

  function PanelHeading() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelHeading.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        Component = _this$props.componentClass,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["children", "className", "componentClass"]);

    var _ref = this.context.$bs_panel || {},
        headingId = _ref.headingId,
        _bsClass = _ref.bsClass;

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (headingId) {
      elementProps.role = elementProps.role || 'tab';
      elementProps.id = headingId;
    }

    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'heading'))
    }), children);
  };

  return PanelHeading;
}(_react.default.Component);

PanelHeading.propTypes = propTypes;
PanelHeading.defaultProps = defaultProps;
PanelHeading.contextTypes = contextTypes;

var _default = (0, _bootstrapUtils.bsClass)('panel', PanelHeading);

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/react-bootstrap/lib/PanelTitle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/extends.js"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/objectWithoutPropertiesLoose.js"));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/inheritsLoose.js"));

var _classnames = _interopRequireDefault(__webpack_require__("./node_modules/classnames/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__("./node_modules/prop-types/index.js"));

var _react = _interopRequireDefault(__webpack_require__("./node_modules/react/index.js"));

var _elementType = _interopRequireDefault(__webpack_require__("./node_modules/react-prop-types/lib/elementType.js"));

var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");

var _PanelToggle = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/lib/PanelToggle.js"));

var propTypes = {
  componentClass: _elementType.default,

  /**
   * A convenience prop that renders the Panel.Title as a panel collapse toggle component
   * for the common use-case.
   */
  toggle: _propTypes.default.bool
};
var contextTypes = {
  $bs_panel: _propTypes.default.shape({
    bsClass: _propTypes.default.string
  })
};
var defaultProps = {
  componentClass: 'div'
};

var PanelTitle =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(PanelTitle, _React$Component);

  function PanelTitle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelTitle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        toggle = _this$props.toggle,
        Component = _this$props.componentClass,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["children", "className", "toggle", "componentClass"]);

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (toggle) {
      children = _react.default.createElement(_PanelToggle.default, null, children);
    }

    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'title'))
    }), children);
  };

  return PanelTitle;
}(_react.default.Component);

PanelTitle.propTypes = propTypes;
PanelTitle.defaultProps = defaultProps;
PanelTitle.contextTypes = contextTypes;

var _default = (0, _bootstrapUtils.bsClass)('panel', PanelTitle);

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/react-bootstrap/lib/PanelToggle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.default = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/objectWithoutPropertiesLoose.js"));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/inheritsLoose.js"));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/assertThisInitialized.js"));

var _propTypes = _interopRequireDefault(__webpack_require__("./node_modules/prop-types/index.js"));

var _react = _interopRequireDefault(__webpack_require__("./node_modules/react/index.js"));

var _classnames = _interopRequireDefault(__webpack_require__("./node_modules/classnames/index.js"));

var _elementType = _interopRequireDefault(__webpack_require__("./node_modules/react-prop-types/lib/elementType.js"));

var _SafeAnchor = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/lib/SafeAnchor.js"));

var _createChainedFunction = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/lib/utils/createChainedFunction.js"));

var propTypes = {
  /**
   * only here to satisfy linting, just the html onClick handler.
   *
   * @private
   */
  onClick: _propTypes.default.func,

  /**
   * You can use a custom element for this component
   */
  componentClass: _elementType.default
};
var defaultProps = {
  componentClass: _SafeAnchor.default
};
var contextTypes = {
  $bs_panel: _propTypes.default.shape({
    bodyId: _propTypes.default.string,
    onToggle: _propTypes.default.func,
    expanded: _propTypes.default.bool
  })
};

var PanelToggle =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(PanelToggle, _React$Component);

  function PanelToggle() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.handleToggle = _this.handleToggle.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  var _proto = PanelToggle.prototype;

  _proto.handleToggle = function handleToggle(event) {
    var _ref = this.context.$bs_panel || {},
        onToggle = _ref.onToggle;

    if (onToggle) {
      onToggle(event);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        onClick = _this$props.onClick,
        className = _this$props.className,
        componentClass = _this$props.componentClass,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["onClick", "className", "componentClass"]);

    var _ref2 = this.context.$bs_panel || {},
        expanded = _ref2.expanded,
        bodyId = _ref2.bodyId;

    var Component = componentClass;
    props.onClick = (0, _createChainedFunction.default)(onClick, this.handleToggle);
    props['aria-expanded'] = expanded;
    props.className = (0, _classnames.default)(className, !expanded && 'collapsed');

    if (bodyId) {
      props['aria-controls'] = bodyId;
    }

    return _react.default.createElement(Component, props);
  };

  return PanelToggle;
}(_react.default.Component);

PanelToggle.propTypes = propTypes;
PanelToggle.defaultProps = defaultProps;
PanelToggle.contextTypes = contextTypes;
var _default = PanelToggle;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/react-bootstrap/lib/SafeAnchor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/extends.js"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/objectWithoutPropertiesLoose.js"));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/inheritsLoose.js"));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/assertThisInitialized.js"));

var _react = _interopRequireDefault(__webpack_require__("./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__("./node_modules/prop-types/index.js"));

var _elementType = _interopRequireDefault(__webpack_require__("./node_modules/prop-types-extra/lib/elementType.js"));

var _createChainedFunction = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/lib/utils/createChainedFunction.js"));

var propTypes = {
  href: _propTypes.default.string,
  onClick: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  role: _propTypes.default.string,
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * this is sort of silly but needed for Button
   */
  componentClass: _elementType.default
};
var defaultProps = {
  componentClass: 'a'
};

function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
 */


var SafeAnchor =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(SafeAnchor, _React$Component);

  function SafeAnchor(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  var _proto = SafeAnchor.prototype;

  _proto.handleClick = function handleClick(event) {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        href = _this$props.href,
        onClick = _this$props.onClick;

    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  _proto.handleKeyDown = function handleKeyDown(event) {
    if (event.key === ' ') {
      event.preventDefault();
      this.handleClick(event);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        Component = _this$props2.componentClass,
        disabled = _this$props2.disabled,
        onKeyDown = _this$props2.onKeyDown,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["componentClass", "disabled", "onKeyDown"]);

    if (isTrivialHref(props.href)) {
      props.role = props.role || 'button'; // we want to make sure there is a href attribute on the node
      // otherwise, the cursor incorrectly styled (except with role='button')

      props.href = props.href || '#';
    }

    if (disabled) {
      props.tabIndex = -1;
      props.style = (0, _extends2.default)({
        pointerEvents: 'none'
      }, props.style);
    }

    return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
      onClick: this.handleClick,
      onKeyDown: (0, _createChainedFunction.default)(this.handleKeyDown, onKeyDown)
    }));
  };

  return SafeAnchor;
}(_react.default.Component);

SafeAnchor.propTypes = propTypes;
SafeAnchor.defaultProps = defaultProps;
var _default = SafeAnchor;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/react-bootstrap/lib/utils/PropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.generatedId = generatedId;
exports.requiredRoles = requiredRoles;
exports.exclusiveRoles = exclusiveRoles;

var _propTypes = _interopRequireDefault(__webpack_require__("./node_modules/prop-types/index.js"));

var _createChainableTypeChecker = _interopRequireDefault(__webpack_require__("./node_modules/prop-types-extra/lib/utils/createChainableTypeChecker.js"));

var _ValidComponentChildren = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/lib/utils/ValidComponentChildren.js"));

var idPropType = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]);

function generatedId(name) {
  return function (props) {
    var error = null;

    if (!props.generateChildId) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      error = idPropType.apply(void 0, [props].concat(args));

      if (!error && !props.id) {
        error = new Error("In order to properly initialize the " + name + " in a way that is accessible to assistive technologies " + ("(such as screen readers) an `id` or a `generateChildId` prop to " + name + " is required"));
      }
    }

    return error;
  };
}

function requiredRoles() {
  for (var _len2 = arguments.length, roles = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    roles[_key2] = arguments[_key2];
  }

  return (0, _createChainableTypeChecker.default)(function (props, propName, component) {
    var missing;
    roles.every(function (role) {
      if (!_ValidComponentChildren.default.some(props.children, function (child) {
        return child.props.bsRole === role;
      })) {
        missing = role;
        return false;
      }

      return true;
    });

    if (missing) {
      return new Error("(children) " + component + " - Missing a required child with bsRole: " + (missing + ". " + component + " must have at least one child of each of ") + ("the following bsRoles: " + roles.join(', ')));
    }

    return null;
  });
}

function exclusiveRoles() {
  for (var _len3 = arguments.length, roles = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    roles[_key3] = arguments[_key3];
  }

  return (0, _createChainableTypeChecker.default)(function (props, propName, component) {
    var duplicate;
    roles.every(function (role) {
      var childrenWithRole = _ValidComponentChildren.default.filter(props.children, function (child) {
        return child.props.bsRole === role;
      });

      if (childrenWithRole.length > 1) {
        duplicate = role;
        return false;
      }

      return true;
    });

    if (duplicate) {
      return new Error("(children) " + component + " - Duplicate children detected of bsRole: " + (duplicate + ". Only one child each allowed with the following ") + ("bsRoles: " + roles.join(', ')));
    }

    return null;
  });
}

/***/ }),

/***/ "./node_modules/react-bootstrap/lib/utils/StyleConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Style = exports.State = exports.DEVICE_SIZES = exports.SIZE_MAP = exports.Size = void 0;
var Size = {
  LARGE: 'large',
  SMALL: 'small',
  XSMALL: 'xsmall'
};
exports.Size = Size;
var SIZE_MAP = {
  large: 'lg',
  medium: 'md',
  small: 'sm',
  xsmall: 'xs',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xs: 'xs'
};
exports.SIZE_MAP = SIZE_MAP;
var DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
exports.DEVICE_SIZES = DEVICE_SIZES;
var State = {
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info'
};
exports.State = State;
var Style = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  LINK: 'link',
  INVERSE: 'inverse'
};
exports.Style = Style;

/***/ }),

/***/ "./node_modules/react-bootstrap/lib/utils/ValidComponentChildren.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__("./node_modules/react/index.js"));

// TODO: This module should be ElementChildren, and should use named exports.

/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid components".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @return {object} Object containing the ordered map of results.
 */
function map(children, func, context) {
  var index = 0;
  return _react.default.Children.map(children, function (child) {
    if (!_react.default.isValidElement(child)) {
      return child;
    }

    return func.call(context, child, index++);
  });
}
/**
 * Iterates through children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for context.
 */


function forEach(children, func, context) {
  var index = 0;

  _react.default.Children.forEach(children, function (child) {
    if (!_react.default.isValidElement(child)) {
      return;
    }

    func.call(context, child, index++);
  });
}
/**
 * Count the number of "valid components" in the Children container.
 *
 * @param {?*} children Children tree container.
 * @returns {number}
 */


function count(children) {
  var result = 0;

  _react.default.Children.forEach(children, function (child) {
    if (!_react.default.isValidElement(child)) {
      return;
    }

    ++result;
  });

  return result;
}
/**
 * Finds children that are typically specified as `props.children`,
 * but only iterates over children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @returns {array} of children that meet the func return statement
 */


function filter(children, func, context) {
  var index = 0;
  var result = [];

  _react.default.Children.forEach(children, function (child) {
    if (!_react.default.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result.push(child);
    }
  });

  return result;
}

function find(children, func, context) {
  var index = 0;
  var result;

  _react.default.Children.forEach(children, function (child) {
    if (result) {
      return;
    }

    if (!_react.default.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = child;
    }
  });

  return result;
}

function every(children, func, context) {
  var index = 0;
  var result = true;

  _react.default.Children.forEach(children, function (child) {
    if (!result) {
      return;
    }

    if (!_react.default.isValidElement(child)) {
      return;
    }

    if (!func.call(context, child, index++)) {
      result = false;
    }
  });

  return result;
}

function some(children, func, context) {
  var index = 0;
  var result = false;

  _react.default.Children.forEach(children, function (child) {
    if (result) {
      return;
    }

    if (!_react.default.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = true;
    }
  });

  return result;
}

function toArray(children) {
  var result = [];

  _react.default.Children.forEach(children, function (child) {
    if (!_react.default.isValidElement(child)) {
      return;
    }

    result.push(child);
  });

  return result;
}

var _default = {
  map: map,
  forEach: forEach,
  count: count,
  find: find,
  filter: filter,
  every: every,
  some: some,
  toArray: toArray
};
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.prefix = prefix;
exports.getClassSet = getClassSet;
exports.splitBsProps = splitBsProps;
exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
exports.addStyle = addStyle;
exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = void 0;

var _entries = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/core-js/object/entries.js"));

var _extends2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime-corejs2/helpers/extends.js"));

var _invariant = _interopRequireDefault(__webpack_require__("./node_modules/invariant/browser.js"));

var _propTypes = _interopRequireDefault(__webpack_require__("./node_modules/prop-types/index.js"));

var _StyleConfig = __webpack_require__("./node_modules/react-bootstrap/lib/utils/StyleConfig.js");

// TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.
function curry(fn) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var last = args[args.length - 1];

    if (typeof last === 'function') {
      return fn.apply(void 0, args);
    }

    return function (Component) {
      return fn.apply(void 0, args.concat([Component]));
    };
  };
}

function prefix(props, variant) {
  var bsClass = (props.bsClass || '').trim();
  !(bsClass != null) ?  false ? (0, _invariant.default)(false, 'A `bsClass` prop is required for this component') : invariant(false) : void 0;
  return bsClass + (variant ? "-" + variant : '');
}

var bsClass = curry(function (defaultClass, Component) {
  var propTypes = Component.propTypes || (Component.propTypes = {});
  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
  propTypes.bsClass = _propTypes.default.string;
  defaultProps.bsClass = defaultClass;
  return Component;
});
exports.bsClass = bsClass;
var bsStyles = curry(function (styles, defaultStyle, Component) {
  if (typeof defaultStyle !== 'string') {
    Component = defaultStyle;
    defaultStyle = undefined;
  }

  var existing = Component.STYLES || [];
  var propTypes = Component.propTypes || {};
  styles.forEach(function (style) {
    if (existing.indexOf(style) === -1) {
      existing.push(style);
    }
  });

  var propType = _propTypes.default.oneOf(existing); // expose the values on the propType function for documentation


  Component.STYLES = existing;
  propType._values = existing;
  Component.propTypes = (0, _extends2.default)({}, propTypes, {
    bsStyle: propType
  });

  if (defaultStyle !== undefined) {
    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
    defaultProps.bsStyle = defaultStyle;
  }

  return Component;
});
exports.bsStyles = bsStyles;
var bsSizes = curry(function (sizes, defaultSize, Component) {
  if (typeof defaultSize !== 'string') {
    Component = defaultSize;
    defaultSize = undefined;
  }

  var existing = Component.SIZES || [];
  var propTypes = Component.propTypes || {};
  sizes.forEach(function (size) {
    if (existing.indexOf(size) === -1) {
      existing.push(size);
    }
  });
  var values = [];
  existing.forEach(function (size) {
    var mappedSize = _StyleConfig.SIZE_MAP[size];

    if (mappedSize && mappedSize !== size) {
      values.push(mappedSize);
    }

    values.push(size);
  });

  var propType = _propTypes.default.oneOf(values);

  propType._values = values; // expose the values on the propType function for documentation

  Component.SIZES = existing;
  Component.propTypes = (0, _extends2.default)({}, propTypes, {
    bsSize: propType
  });

  if (defaultSize !== undefined) {
    if (!Component.defaultProps) {
      Component.defaultProps = {};
    }

    Component.defaultProps.bsSize = defaultSize;
  }

  return Component;
});
exports.bsSizes = bsSizes;

function getClassSet(props) {
  var _classes;

  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);

  if (props.bsSize) {
    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
    classes[prefix(props, bsSize)] = true;
  }

  if (props.bsStyle) {
    classes[prefix(props, props.bsStyle)] = true;
  }

  return classes;
}

function getBsProps(props) {
  return {
    bsClass: props.bsClass,
    bsSize: props.bsSize,
    bsStyle: props.bsStyle,
    bsRole: props.bsRole
  };
}

function isBsProp(propName) {
  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
}

function splitBsProps(props) {
  var elementProps = {};
  (0, _entries.default)(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (!isBsProp(propName)) {
      elementProps[propName] = propValue;
    }
  });
  return [getBsProps(props), elementProps];
}

function splitBsPropsAndOmit(props, omittedPropNames) {
  var isOmittedProp = {};
  omittedPropNames.forEach(function (propName) {
    isOmittedProp[propName] = true;
  });
  var elementProps = {};
  (0, _entries.default)(props).forEach(function (_ref2) {
    var propName = _ref2[0],
        propValue = _ref2[1];

    if (!isBsProp(propName) && !isOmittedProp[propName]) {
      elementProps[propName] = propValue;
    }
  });
  return [getBsProps(props), elementProps];
}
/**
 * Add a style variant to a Component. Mutates the propTypes of the component
 * in order to validate the new variant.
 */


function addStyle(Component) {
  for (var _len2 = arguments.length, styleVariant = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    styleVariant[_key2 - 1] = arguments[_key2];
  }

  bsStyles(styleVariant, Component);
}

var _curry = curry;
exports._curry = _curry;

/***/ }),

/***/ "./node_modules/react-bootstrap/lib/utils/capitalize.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = capitalize;

function capitalize(string) {
  return "" + string.charAt(0).toUpperCase() + string.slice(1);
}

module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/react-bootstrap/lib/utils/createChainedFunction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) {
      return f;
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      f.apply(this, args);
    };
  }, null);
}

var _default = createChainedFunction;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/react-device-detect/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UAParser = __webpack_require__(6);

var UA = exports.UA = new UAParser();

var browser = exports.browser = UA.getBrowser();
var cpu = exports.cpu = UA.getCPU();
var device = exports.device = UA.getDevice();
var engine = exports.engine = UA.getEngine();
var os = exports.os = UA.getOS();
var ua = exports.ua = UA.getUA();
var setUA = exports.setUA = function setUA(uaStr) {
  return UA.setUA(uaStr);
};

var mockUserAgent = exports.mockUserAgent = function mockUserAgent(userAgent) {
  window.navigator.__defineGetter__("userAgent", function () {
    return userAgent;
  });
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deviceType = exports.isYandex = exports.isEdge = exports.getUA = exports.engineVersion = exports.engineName = exports.mobileModel = exports.mobileVendor = exports.browserName = exports.browserVersion = exports.fullBrowserVersion = exports.osName = exports.osVersion = exports.isIE = exports.isOpera = exports.isSafari = exports.isFirefox = exports.isChrome = exports.isIOS = exports.isWinPhone = exports.isAndroid = exports.isBrowser = exports.isTablet = exports.isMobileOnly = exports.isMobile = exports.isChromium = exports.isMobileSafari = exports.isWearable = exports.isConsole = exports.isSmartTV = undefined;

var _getUaData = __webpack_require__(0);

var _types = __webpack_require__(2);

var CHROME = _types.BROWSER_TYPES.CHROME,
    CHROMIUM = _types.BROWSER_TYPES.CHROMIUM,
    IE = _types.BROWSER_TYPES.IE,
    INTERNET_EXPLORER = _types.BROWSER_TYPES.INTERNET_EXPLORER,
    OPERA = _types.BROWSER_TYPES.OPERA,
    FIREFOX = _types.BROWSER_TYPES.FIREFOX,
    SAFARI = _types.BROWSER_TYPES.SAFARI,
    MOBILE_SAFARI = _types.BROWSER_TYPES.MOBILE_SAFARI,
    EDGE = _types.BROWSER_TYPES.EDGE,
    YANDEX = _types.BROWSER_TYPES.YANDEX;
var MOBILE = _types.DEVICE_TYPES.MOBILE,
    TABLET = _types.DEVICE_TYPES.TABLET,
    SMART_TV = _types.DEVICE_TYPES.SMART_TV,
    BROWSER = _types.DEVICE_TYPES.BROWSER,
    WEARABLE = _types.DEVICE_TYPES.WEARABLE,
    CONSOLE = _types.DEVICE_TYPES.CONSOLE;
var ANDROID = _types.OS_TYPES.ANDROID,
    WINDOWS_PHONE = _types.OS_TYPES.WINDOWS_PHONE,
    IOS = _types.OS_TYPES.IOS;


var isMobileType = function isMobileType() {
  return _getUaData.device.type === MOBILE;
};
var isTabletType = function isTabletType() {
  return _getUaData.device.type === TABLET;
};

var isMobileAndTabletType = function isMobileAndTabletType() {
  switch (_getUaData.device.type) {
    case MOBILE:
    case TABLET:
      return true;
    default:
      return false;
  }
};

var isSmartTVType = function isSmartTVType() {
  return _getUaData.device.type === SMART_TV;
};
var isBrowserType = function isBrowserType() {
  return _getUaData.device.type === BROWSER;
};
var isWearableType = function isWearableType() {
  return _getUaData.device.type === WEARABLE;
};
var isConsoleType = function isConsoleType() {
  return _getUaData.device.type === CONSOLE;
};
var isAndroidType = function isAndroidType() {
  return _getUaData.os.name === ANDROID;
};
var isWinPhoneType = function isWinPhoneType() {
  return _getUaData.os.name === WINDOWS_PHONE;
};
var isIOSType = function isIOSType() {
  return _getUaData.os.name === IOS;
};
var isChromeType = function isChromeType() {
  return _getUaData.browser.name === CHROME;
};
var isFirefoxType = function isFirefoxType() {
  return _getUaData.browser.name === FIREFOX;
};
var isChromiumType = function isChromiumType() {
  return _getUaData.browser.name === CHROMIUM;
};
var isEdgeType = function isEdgeType() {
  return _getUaData.browser.name === EDGE;
};
var isYandexType = function isYandexType() {
  return _getUaData.browser.name === YANDEX;
};
var isSafariType = function isSafariType() {
  return _getUaData.browser.name === SAFARI || _getUaData.browser.name === MOBILE_SAFARI;
};
var isMobileSafariType = function isMobileSafariType() {
  return _getUaData.browser.name === MOBILE_SAFARI;
};
var isOperaType = function isOperaType() {
  return _getUaData.browser.name === OPERA;
};
var isIEType = function isIEType() {
  return _getUaData.browser.name === INTERNET_EXPLORER || _getUaData.browser.name === IE;
};

var getBrowserFullVersion = function getBrowserFullVersion() {
  return _getUaData.browser.version;
};
var getBrowserVersion = function getBrowserVersion() {
  return _getUaData.browser.major;
};
var getOsVersion = function getOsVersion() {
  return _getUaData.os.version ? _getUaData.os.version : "none";
};
var getOsName = function getOsName() {
  return _getUaData.os.name ? _getUaData.os.name : "none";
};
var getBrowserName = function getBrowserName() {
  return _getUaData.browser.name;
};
var getMobileVendor = function getMobileVendor() {
  return _getUaData.device.vendor ? _getUaData.device.vendor : "none";
};
var getMobileModel = function getMobileModel() {
  return _getUaData.device.model ? _getUaData.device.model : "none";
};
var getEngineName = function getEngineName() {
  return _getUaData.engine.name;
};
var getEngineVersion = function getEngineVersion() {
  return _getUaData.engine.version;
};
var getUseragent = function getUseragent() {
  return _getUaData.ua;
};
var getDeviceType = function getDeviceType() {
  return _getUaData.device.type;
};

var isSmartTV = exports.isSmartTV = isSmartTVType();
var isConsole = exports.isConsole = isConsoleType();
var isWearable = exports.isWearable = isWearableType();
var isMobileSafari = exports.isMobileSafari = isMobileSafariType();
var isChromium = exports.isChromium = isChromiumType();
var isMobile = exports.isMobile = isMobileAndTabletType();
var isMobileOnly = exports.isMobileOnly = isMobileType();
var isTablet = exports.isTablet = isTabletType();
var isBrowser = exports.isBrowser = isBrowserType();
var isAndroid = exports.isAndroid = isAndroidType();
var isWinPhone = exports.isWinPhone = isWinPhoneType();
var isIOS = exports.isIOS = isIOSType();
var isChrome = exports.isChrome = isChromeType();
var isFirefox = exports.isFirefox = isFirefoxType();
var isSafari = exports.isSafari = isSafariType();
var isOpera = exports.isOpera = isOperaType();
var isIE = exports.isIE = isIEType();
var osVersion = exports.osVersion = getOsVersion();
var osName = exports.osName = getOsName();
var fullBrowserVersion = exports.fullBrowserVersion = getBrowserFullVersion();
var browserVersion = exports.browserVersion = getBrowserVersion();
var browserName = exports.browserName = getBrowserName();
var mobileVendor = exports.mobileVendor = getMobileVendor();
var mobileModel = exports.mobileModel = getMobileModel();
var engineName = exports.engineName = getEngineName();
var engineVersion = exports.engineVersion = getEngineVersion();
var getUA = exports.getUA = getUseragent();
var isEdge = exports.isEdge = isEdgeType();
var isYandex = exports.isYandex = isYandexType();
var deviceType = exports.deviceType = getDeviceType();

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wearPayload = exports.consolePayload = exports.stvPayload = exports.mobilePayload = exports.broPayload = exports.getCurrentBrowser = exports.checkType = exports.OS_TYPES = exports.BROWSER_TYPES = exports.DEVICE_TYPES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _getUaData = __webpack_require__(0);

var DEVICE_TYPES = exports.DEVICE_TYPES = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  SMART_TV: 'smarttv',
  CONSOLE: 'console',
  WEARABLE: 'wearable',
  BROWSER: undefined
};

var BROWSER_TYPES = exports.BROWSER_TYPES = {
  CHROME: 'Chrome',
  FIREFOX: "Firefox",
  OPERA: "Opera",
  YANDEX: "Yandex",
  SAFARI: "Safari",
  INTERNET_EXPLORER: "Internet Explorer",
  EDGE: "Edge",
  CHROMIUM: "Chromium",
  IE: 'IE',
  MOBILE_SAFARI: "Mobile Safari"
};

var OS_TYPES = exports.OS_TYPES = {
  IOS: 'iOS',
  ANDROID: "Android",
  WINDOWS_PHONE: "Windows Phone"
};

var initialData = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};

var checkType = exports.checkType = function checkType(type) {
  switch (type) {
    case DEVICE_TYPES.MOBILE:
      return { isMobile: true };
    case DEVICE_TYPES.TABLET:
      return { isTablet: true };
    case DEVICE_TYPES.SMART_TV:
      return { isSmartTV: true };
    case DEVICE_TYPES.CONSOLE:
      return { isConsole: true };
    case DEVICE_TYPES.WEARABLE:
      return { isWearable: true };
    case DEVICE_TYPES.BROWSER:
      return { isBrowser: true };
    default:
      return initialData;
  }
};

var getCurrentBrowser = exports.getCurrentBrowser = function getCurrentBrowser(name) {
  switch (name) {
    case BROWSER_TYPES.CHROME:
    case BROWSER_TYPES.FIREFOX:
    case BROWSER_TYPES.OPERA:
    case BROWSER_TYPES.YANDEX:
    case BROWSER_TYPES.SAFARI:
    case BROWSER_TYPES.IE:
    case BROWSER_TYPES.EDGE:
    case BROWSER_TYPES.CHROMIUM:
      return true;
    default:
      return false;
  }
};

var broPayload = exports.broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: browser.major,
    browserFullVersion: browser.version,
    browserName: browser.name,
    engineName: engine.name || false,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

var mobilePayload = exports.mobilePayload = function mobilePayload(type, device, os, ua) {
  return _extends({}, type, {
    vendor: device.vendor || "none",
    model: device.model || "none",
    os: os.name || "none",
    osVersion: os.version || "none",
    ua: ua || "none"
  });
};

var stvPayload = exports.stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: engine.name || false,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

var consolePayload = exports.consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: engine.name || false,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

var wearPayload = exports.wearPayload = function wearPayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: engine.name || false,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deviceDetect = undefined;

var _views = __webpack_require__(4);

Object.keys(_views).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _views[key];
    }
  });
});

var _selectors = __webpack_require__(1);

Object.keys(_selectors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _selectors[key];
    }
  });
});

var _detect = __webpack_require__(7);

var _detect2 = _interopRequireDefault(_detect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.deviceDetect = _detect2.default;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomView = exports.WearableView = exports.ConsoleView = exports.SmartTVView = exports.MobileOnlyView = exports.WinPhoneView = exports.TabletView = exports.MobileView = exports.IOSView = exports.IEView = exports.BrowserView = exports.AndroidView = undefined;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _selectors = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AndroidView = exports.AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      viewClassName = _ref.viewClassName,
      style = _ref.style;

  return _selectors.isAndroid ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var BrowserView = exports.BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      viewClassName = _ref2.viewClassName,
      style = _ref2.style;

  return _selectors.isBrowser ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var IEView = exports.IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      viewClassName = _ref3.viewClassName,
      style = _ref3.style;

  return _selectors.isIE ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var IOSView = exports.IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      viewClassName = _ref4.viewClassName,
      style = _ref4.style;

  return _selectors.isIOS ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var MobileView = exports.MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      viewClassName = _ref5.viewClassName,
      style = _ref5.style;

  return _selectors.isMobile ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var TabletView = exports.TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      viewClassName = _ref6.viewClassName,
      style = _ref6.style;

  return _selectors.isTablet ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var WinPhoneView = exports.WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      viewClassName = _ref7.viewClassName,
      style = _ref7.style;

  return _selectors.isWinPhone ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var MobileOnlyView = exports.MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style;

  return _selectors.isMobileOnly ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var SmartTVView = exports.SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      viewClassName = _ref9.viewClassName,
      style = _ref9.style;

  return _selectors.isSmartTV ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var ConsoleView = exports.ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      viewClassName = _ref10.viewClassName,
      style = _ref10.style;

  return _selectors.isConsole ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var WearableView = exports.WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      viewClassName = _ref11.viewClassName,
      style = _ref11.style;

  return _selectors.isWearable ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var CustomView = exports.CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition;

  return condition ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __webpack_require__("./node_modules/react/index.js");

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * UAParser.js v0.7.20
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2019 Faisal Salman <f@faisalman.com>
 * Licensed under MIT License
 */
(function(window,undefined){"use strict";var LIBVERSION="0.7.20",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded";var util={extend:function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i])}else{mergedRegexes[i]=regexes[i]}}return mergedRegexes},has:function(str1,str2){if(typeof str1==="string"){return str2.toLowerCase().indexOf(str1.toLowerCase())!==-1}else{return false}},lowerize:function(str){return str.toLowerCase()},major:function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,"").split(".")[0]:undefined},trim:function(str){return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}};var mapper={rgx:function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length==2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length==3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length==4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},str:function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(util.has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(util.has(map[i],str)){return i===UNKNOWN?undefined:i}}return str}};var maps={browser:{oldsafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{amazon:{model:{"Fire Phone":["SD","KF"]}},sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}};var regexes={browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[NAME,VERSION],[/(opios)[\/\s]+([\w\.]+)/i],[[NAME,"Opera Mini"],VERSION],[/\s(opr)\/([\w\.]+)/i],[[NAME,"Opera"],VERSION],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,/(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]*)/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i],[NAME,VERSION],[/(konqueror)\/([\w\.]+)/i],[[NAME,"Konqueror"],VERSION],[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],[[NAME,"IE"],VERSION],[/(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i],[[NAME,"Edge"],VERSION],[/(yabrowser)\/([\w\.]+)/i],[[NAME,"Yandex"],VERSION],[/(puffin)\/([\w\.]+)/i],[[NAME,"Puffin"],VERSION],[/(focus)\/([\w\.]+)/i],[[NAME,"Firefox Focus"],VERSION],[/(opt)\/([\w\.]+)/i],[[NAME,"Opera Touch"],VERSION],[/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],[[NAME,"UCBrowser"],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(windowswechat qbcore)\/([\w\.]+)/i],[[NAME,"WeChat(Win) Desktop"],VERSION],[/(micromessenger)\/([\w\.]+)/i],[[NAME,"WeChat"],VERSION],[/(brave)\/([\w\.]+)/i],[[NAME,"Brave"],VERSION],[/(qqbrowserlite)\/([\w\.]+)/i],[NAME,VERSION],[/(QQ)\/([\d\.]+)/i],[NAME,VERSION],[/m?(qqbrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(BIDUBrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(2345Explorer)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(MetaSr)[\/\s]?([\w\.]+)/i],[NAME],[/(LBBROWSER)/i],[NAME],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI Browser"]],[/;fbav\/([\w\.]+);/i],[VERSION,[NAME,"Facebook"]],[/safari\s(line)\/([\w\.]+)/i,/android.+(line)\/([\w\.]+)\/iab/i],[NAME,VERSION],[/headlesschrome(?:\/([\w\.]+)|\s)/i],[VERSION,[NAME,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 WebView"],VERSION],[/((?:oculus|samsung)browser)\/([\w\.]+)/i],[[NAME,/(.+(?:g|us))(.+)/,"$1 $2"],VERSION],[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],[VERSION,[NAME,"Android Browser"]],[/(sailfishbrowser)\/([\w\.]+)/i],[[NAME,"Sailfish Browser"],VERSION],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/(dolfin)\/([\w\.]+)/i],[[NAME,"Dolphin"],VERSION],[/((?:android.+)crmo|crios)\/([\w\.]+)/i],[[NAME,"Chrome"],VERSION],[/(coast)\/([\w\.]+)/i],[[NAME,"Opera Coast"],VERSION],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,"Firefox"]],[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],[VERSION,NAME],[/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[[NAME,"GSA"],VERSION],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,mapper.str,maps.browser.oldsafari.version]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape)\/([\w\.-]+)/i],[[NAME,"Netscape"],VERSION],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]*)/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,util.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/windows\s(ce|mobile);\sppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[[ARCHITECTURE,/ower/,"",util.lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],[[ARCHITECTURE,util.lowerize]]],device:[[/\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/applecoremedia\/[\w\.]+ \((ipad)/],[MODEL,[VENDOR,"Apple"],[TYPE,TABLET]],[/(apple\s{0,1}tv)/i],[[MODEL,"Apple TV"],[VENDOR,"Apple"]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad)/i,/(hp).+(tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(kf[A-z]+)\sbuild\/.+silk\//i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i],[[MODEL,mapper.str,maps.device.amazon.model],[VENDOR,"Amazon"],[TYPE,MOBILE]],[/android.+aft([bms])\sbuild/i],[MODEL,[VENDOR,"Amazon"],[TYPE,SMARTTV]],[/\((ip[honed|\s\w*]+);.+(apple)/i],[MODEL,VENDOR,[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);/i],[MODEL,[VENDOR,"Apple"],[TYPE,MOBILE]],[/(blackberry)[\s-]?(\w+)/i,/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/\(bb10;\s(\w+)/i],[MODEL,[VENDOR,"BlackBerry"],[TYPE,MOBILE]],[/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i],[MODEL,[VENDOR,"Asus"],[TYPE,TABLET]],[/(sony)\s(tablet\s[ps])\sbuild\//i,/(sony)?(?:sgp.+)\sbuild\//i],[[VENDOR,"Sony"],[MODEL,"Xperia Tablet"],[TYPE,TABLET]],[/android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,"Sony"],[TYPE,MOBILE]],[/\s(ouya)\s/i,/(nintendo)\s([wids3u]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/android.+;\s(shield)\sbuild/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation\s[34portablevi]+)/i],[MODEL,[VENDOR,"Sony"],[TYPE,CONSOLE]],[/(sprint\s(\w+))/i],[[VENDOR,mapper.str,maps.device.sprint.vendor],[MODEL,mapper.str,maps.device.sprint.model],[TYPE,MOBILE]],[/(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i,/(zte)-(\w*)/i,/(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/(nexus\s9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/d\/huawei([\w\s-]+)[;\)]/i,/(nexus\s6p)/i],[MODEL,[VENDOR,"Huawei"],[TYPE,MOBILE]],[/(microsoft);\s(lumia[\s\w]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/[\s\(;](xbox(?:\sone)?)[\s\);]/i],[MODEL,[VENDOR,"Microsoft"],[TYPE,CONSOLE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,"Microsoft"],[TYPE,MOBILE]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,/mot[\s-]?(\w*)/i,/(XT\d{3,4}) build\//i,/(nexus\s6)/i],[MODEL,[VENDOR,"Motorola"],[TYPE,MOBILE]],[/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[MODEL,[VENDOR,"Motorola"],[TYPE,TABLET]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[VENDOR,util.trim],[MODEL,util.trim],[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,"Samsung"],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,/((SM-T\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,TABLET]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV],MODEL],[/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,/(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,/sec-((sgh\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,MOBILE]],[/sie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/(maemo|nokia).*(n900|lumia\s\d+)/i,/(nokia)[\s_-]?([\w-]*)/i],[[VENDOR,"Nokia"],MODEL,[TYPE,MOBILE]],[/android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/android.+([vl]k\-?\d{3})\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,TABLET]],[/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],[[VENDOR,"LG"],MODEL,[TYPE,TABLET]],[/(lg) netcast\.tv/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/(nexus\s[45])/i,/lg[e;\s\/-]+(\w*)/i,/android.+lg(\-?[\d\w]+)\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,MOBILE]],[/(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+(ideatab[a-z0-9\-\s]+)/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(lenovo)[_\s-]?([\w-]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/linux;.+((jolla));/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/((pebble))app\/[\d\.]+\s/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/crkey/i],[[MODEL,"Chromecast"],[VENDOR,"Google"]],[/android.+;\s(glass)\s\d/i],[MODEL,[VENDOR,"Google"],[TYPE,WEARABLE]],[/android.+;\s(pixel c)[\s)]/i],[MODEL,[VENDOR,"Google"],[TYPE,TABLET]],[/android.+;\s(pixel( [23])?( xl)?)[\s)]/i],[MODEL,[VENDOR,"Google"],[TYPE,MOBILE]],[/android.+;\s(\w+)\s+build\/hm\1/i,/android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,/android.+(mi[\s\-_]*(?:a\d|one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,/android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,MOBILE]],[/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,TABLET]],[/android.+;\s(m[1-5]\snote)\sbuild/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/(mz)-([\w-]{2,})/i],[[VENDOR,"Meizu"],MODEL,[TYPE,MOBILE]],[/android.+a000(1)\s+build/i,/android.+oneplus\s(a\d{4})\s+build/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i],[[VENDOR,"Barnes & Noble"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/android.+;\s(k88)\sbuild/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/android.+[;\/]\s*(zur\d{3})\s+build/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/(android).+[;\/]\s+([YR]\d{2})\s+build/i,/android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/android.+;\s(PH-1)\s/i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*TU_(1491)\s+build/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/android.+(KS(.+))\s+build/i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/\s(tablet|tab)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[TYPE,util.lowerize],VENDOR,MODEL],[/[\s\/\(](smart-?tv)[;\)]/i],[[TYPE,SMARTTV]],[/(android[\w\.\s\-]{0,9});.+build/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[VERSION,[NAME,"EdgeHTML"]],[/webkit\/537\.36.+chrome\/(?!27)/i],[[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9}).+(gecko)/i],[VERSION,NAME]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[NAME,VERSION],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[NAME,[VERSION,mapper.str,maps.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,mapper.str,maps.os.windows.version]],[/\((bb)(10);/i],[[NAME,"BlackBerry"],VERSION],[/(blackberry)\w*\/?([\w\.]*)/i,/(tizen)[\/\s]([\w\.]+)/i,/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i],[NAME,VERSION],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i],[[NAME,"Symbian"],VERSION],[/\((series40);/i],[NAME],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[NAME,"Firefox OS"],VERSION],[/(nintendo|playstation)\s([wids34portablevu]+)/i,/(mint)[\/\s\(]?(\w*)/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,/(hurd|linux)\s?([\w\.]*)/i,/(gnu)\s?([\w\.]*)/i],[NAME,VERSION],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(sunos)\s?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i],[NAME,VERSION],[/(haiku)\s(\w+)/i],[NAME,VERSION],[/cfnetwork\/.+darwin/i,/ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac\sos\sx)\s?([\w\s\.]*)/i,/(macintosh|mac(?=_powerpc)\s)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]*)/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,/(unix)\s?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(uastring,extensions){if(typeof uastring==="object"){extensions=uastring;uastring=undefined}if(!(this instanceof UAParser)){return new UAParser(uastring,extensions).getResult()}var ua=uastring||(window&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var rgxmap=extensions?util.extend(regexes,extensions):regexes;this.getBrowser=function(){var browser={name:undefined,version:undefined};mapper.rgx.call(browser,ua,rgxmap.browser);browser.major=util.major(browser.version);return browser};this.getCPU=function(){var cpu={architecture:undefined};mapper.rgx.call(cpu,ua,rgxmap.cpu);return cpu};this.getDevice=function(){var device={vendor:undefined,model:undefined,type:undefined};mapper.rgx.call(device,ua,rgxmap.device);return device};this.getEngine=function(){var engine={name:undefined,version:undefined};mapper.rgx.call(engine,ua,rgxmap.engine);return engine};this.getOS=function(){var os={name:undefined,version:undefined};mapper.rgx.call(os,ua,rgxmap.os);return os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return ua};this.setUA=function(uastring){ua=uastring;return this};return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER={NAME:NAME,MAJOR:MAJOR,VERSION:VERSION};UAParser.CPU={ARCHITECTURE:ARCHITECTURE};UAParser.DEVICE={MODEL:MODEL,VENDOR:VENDOR,TYPE:TYPE,CONSOLE:CONSOLE,MOBILE:MOBILE,SMARTTV:SMARTTV,TABLET:TABLET,WEARABLE:WEARABLE,EMBEDDED:EMBEDDED};UAParser.ENGINE={NAME:NAME,VERSION:VERSION};UAParser.OS={NAME:NAME,VERSION:VERSION};if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if(true){!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return UAParser}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(window){window.UAParser=UAParser}}var $=window&&(window.jQuery||window.Zepto);if(typeof $!==UNDEF_TYPE&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(uastring){parser.setUA(uastring);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getUaData = __webpack_require__(0);

var _types = __webpack_require__(2);

var create = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var type = create.checkType(_getUaData.device.type);

exports.default = function () {
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable;

  if (isBrowser) {
    return create.broPayload(isBrowser, _getUaData.browser, _getUaData.engine, _getUaData.os, _getUaData.ua);
  }

  if (isSmartTV) {
    return create.stvPayload(isSmartTV, _getUaData.engine, _getUaData.os, _getUaData.ua);
  }

  if (isConsole) {
    return create.consolePayload(isConsole, _getUaData.engine, _getUaData.os, _getUaData.ua);
  }

  if (isMobile) {
    return create.mobilePayload(type, _getUaData.device, _getUaData.os, _getUaData.ua);
  }

  if (isTablet) {
    return create.mobilePayload(type, _getUaData.device, _getUaData.os, _getUaData.ua);
  }

  if (isWearable) {
    return create.wearPayload(isWearable, _getUaData.engine, _getUaData.os, _getUaData.ua);
  }
};

/***/ })
/******/ ]);

/***/ }),

/***/ "./node_modules/react-dom-core/lib/DOMProperty.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom-core/lib/reactProdInvariant.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),

/***/ "./node_modules/react-dom-core/lib/HTMLDOMPropertyConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__("./node_modules/react-dom-core/lib/DOMProperty.js");

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    controlsList: 0,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),

/***/ "./node_modules/react-dom-core/lib/SVGDOMPropertyConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),

/***/ "./node_modules/react-dom-core/lib/reactProdInvariant.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),

/***/ "./node_modules/react-google-recaptcha/lib/esm/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__recaptcha_wrapper__ = __webpack_require__("./node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__recaptcha__ = __webpack_require__("./node_modules/react-google-recaptcha/lib/esm/recaptcha.js");
/* unused harmony reexport ReCAPTCHA */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__recaptcha_wrapper__["a" /* default */]);


/***/ }),

/***/ "./node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__recaptcha__ = __webpack_require__("./node_modules/react-google-recaptcha/lib/esm/recaptcha.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_async_script__ = __webpack_require__("./node_modules/react-async-script/lib/esm/async-script-loader.js");


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_async_script__["a" /* default */])(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(__WEBPACK_IMPORTED_MODULE_0__recaptcha__["a" /* default */]));

/***/ }),

/***/ "./node_modules/react-google-recaptcha/lib/esm/recaptcha.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReCAPTCHA; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  grecaptcha: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["dark", "light"]),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["image", "audio"]),
  tabindex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onExpired: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onErrored: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["compact", "normal", "invisible"]),
  stoken: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  badge: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};

/***/ }),

/***/ "./node_modules/react-gtm-module/dist/Snippets.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _warn = __webpack_require__("./node_modules/react-gtm-module/dist/utils/warn.js");

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://developers.google.com/tag-manager/quickstart

var Snippets = {
  tags: function tags(_ref) {
    var id = _ref.id,
        events = _ref.events,
        dataLayer = _ref.dataLayer,
        dataLayerName = _ref.dataLayerName,
        preview = _ref.preview,
        auth = _ref.auth;

    var gtm_auth = '&gtm_auth=' + auth;
    var gtm_preview = '&gtm_preview=' + preview;

    if (!id) (0, _warn2.default)('GTM Id is required');

    var iframe = '\n      <iframe src="https://www.googletagmanager.com/ns.html?id=' + id + gtm_auth + gtm_preview + '&gtm_cookies_win=x"\n        height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>';

    var script = '\n      (function(w,d,s,l,i){w[l]=w[l]||[];\n        w[l].push({\'gtm.start\': new Date().getTime(),event:\'gtm.js\', ' + JSON.stringify(events).slice(1, -1) + '});\n        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';\n        j.async=true;j.src=\'https://www.googletagmanager.com/gtm.js?id=\'+i+dl+\'' + gtm_auth + gtm_preview + '&gtm_cookies_win=x\';\n        f.parentNode.insertBefore(j,f);\n      })(window,document,\'script\',\'' + dataLayerName + '\',\'' + id + '\');';

    var dataLayerVar = this.dataLayer(dataLayer, dataLayerName);

    return {
      iframe: iframe,
      script: script,
      dataLayerVar: dataLayerVar
    };
  },
  dataLayer: function dataLayer(_dataLayer, dataLayerName) {
    return '\n      window.' + dataLayerName + ' = window.' + dataLayerName + ' || [];\n      window.' + dataLayerName + '.push(' + JSON.stringify(_dataLayer) + ')';
  }
};

module.exports = Snippets;

/***/ }),

/***/ "./node_modules/react-gtm-module/dist/TagManager.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Snippets = __webpack_require__("./node_modules/react-gtm-module/dist/Snippets.js");

var _Snippets2 = _interopRequireDefault(_Snippets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TagManager = {
  dataScript: function dataScript(dataLayer) {
    var script = document.createElement('script');
    script.innerHTML = dataLayer;
    return script;
  },
  gtm: function gtm(args) {
    var snippets = _Snippets2.default.tags(args);

    var noScript = function noScript() {
      var noscript = document.createElement('noscript');
      noscript.innerHTML = snippets.iframe;
      return noscript;
    };

    var script = function script() {
      var script = document.createElement('script');
      script.innerHTML = snippets.script;
      return script;
    };

    var dataScript = this.dataScript(snippets.dataLayerVar);

    return {
      noScript: noScript,
      script: script,
      dataScript: dataScript
    };
  },
  initialize: function initialize(_ref) {
    var gtmId = _ref.gtmId,
        _ref$events = _ref.events,
        events = _ref$events === undefined ? {} : _ref$events,
        dataLayer = _ref.dataLayer,
        _ref$dataLayerName = _ref.dataLayerName,
        dataLayerName = _ref$dataLayerName === undefined ? 'dataLayer' : _ref$dataLayerName,
        _ref$auth = _ref.auth,
        auth = _ref$auth === undefined ? '' : _ref$auth,
        _ref$preview = _ref.preview,
        preview = _ref$preview === undefined ? '' : _ref$preview;

    var gtm = this.gtm({
      id: gtmId,
      events: events,
      dataLayer: dataLayer || undefined,
      dataLayerName: dataLayerName,
      auth: auth,
      preview: preview
    });
    if (dataLayer) document.head.appendChild(gtm.dataScript);
    document.head.insertBefore(gtm.script(), document.head.childNodes[0]);
    document.body.insertBefore(gtm.noScript(), document.body.childNodes[0]);
  },
  dataLayer: function dataLayer(_ref2) {
    var _dataLayer = _ref2.dataLayer,
        _ref2$dataLayerName = _ref2.dataLayerName,
        dataLayerName = _ref2$dataLayerName === undefined ? 'dataLayer' : _ref2$dataLayerName;

    window[dataLayerName].push(_dataLayer);
  }
};

module.exports = TagManager;

/***/ }),

/***/ "./node_modules/react-gtm-module/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _TagManager = __webpack_require__("./node_modules/react-gtm-module/dist/TagManager.js");

var _TagManager2 = _interopRequireDefault(_TagManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _TagManager2.default;

/***/ }),

/***/ "./node_modules/react-gtm-module/dist/utils/warn.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var warn = function warn(s) {
  console.warn('[react-gtm]', s);
};

exports.default = warn;

/***/ }),

/***/ "./node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),

/***/ "./node_modules/react-prop-types/lib/elementType.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__("./node_modules/react-prop-types/lib/utils/createChainableTypeChecker.js");

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  if (propType !== 'function' && propType !== 'string') {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ }),

/***/ "./node_modules/react-prop-types/lib/utils/createChainableTypeChecker.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

/***/ }),

/***/ "./node_modules/react-reveal/Fade.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopRequireDefault(o){return o&&o.__esModule?o:{default:o}}function _objectWithoutProperties(o,e){var r={};for(var t in o)e.indexOf(t)>=0||Object.prototype.hasOwnProperty.call(o,t)&&(r[t]=o[t]);return r}function make(o,e){var r=e.distance,t=e.left,p=e.right,a=e.up,l=e.down,i=e.top,u=e.bottom,n=e.big,s=e.mirror,d=e.opposite,_=(r?r.toString():0)+((t?1:0)|(p?2:0)|(i||l?4:0)|(u||a?8:0)|(s?16:0)|(d?32:0)|(o?64:0)|(n?128:0));if(lookup.hasOwnProperty(_))return lookup[_];var f=t||p||a||l||i||u,y=void 0,b=void 0;if(f){if(!s!=!(o&&d)){var v=[p,t,u,i,l,a];t=v[0],p=v[1],i=v[2],u=v[3],a=v[4],l=v[5]}var c=r||(n?"2000px":"100%");y=t?"-"+c:p?c:"0",b=l||i?"-"+c:a||u?c:"0"}return lookup[_]=(0,_globals.animation)((o?"to":"from")+" {opacity: 0;"+(f?" transform: translate3d("+y+", "+b+", 0);":"")+"}\n     "+(o?"from":"to")+" {opacity: 1;transform: none;} "),lookup[_]}function Fade(){var o=arguments.length>0&&void 0!==arguments[0]?arguments[0]:_globals.defaults,e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],r=o.children,t=(o.out,o.forever),p=o.timeout,a=o.duration,l=void 0===a?_globals.defaults.duration:a,i=o.delay,u=void 0===i?_globals.defaults.delay:i,n=o.count,s=void 0===n?_globals.defaults.count:n,d=_objectWithoutProperties(o,["children","out","forever","timeout","duration","delay","count"]),_={make:make,duration:void 0===p?l:p,delay:u,forever:t,count:s,style:{animationFillMode:"both"},reverse:d.left};return e?(0,_wrap2.default)(d,_,_,r):_}Object.defineProperty(exports,"__esModule",{value:!0});var _propTypes=__webpack_require__("./node_modules/prop-types/index.js"),_globals=__webpack_require__("./node_modules/react-reveal/globals.js"),_wrap=__webpack_require__("./node_modules/react-reveal/wrap.js"),_wrap2=_interopRequireDefault(_wrap),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,top:_propTypes.bool,bottom:_propTypes.bool,big:_propTypes.bool,mirror:_propTypes.bool,opposite:_propTypes.bool,duration:_propTypes.number,timeout:_propTypes.number,distance:_propTypes.string,delay:_propTypes.number,count:_propTypes.number,forever:_propTypes.bool},lookup={};Fade.propTypes=propTypes,exports.default=Fade,module.exports=exports.default;

/***/ }),

/***/ "./node_modules/react-reveal/RevealBase.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function _defineProperty(e,t,i){return t in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e}function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(exports,"__esModule",{value:!0});var _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},_slicedToArray=function(){function e(e,t){var i=[],s=!0,o=!1,n=void 0;try{for(var r,a=e[Symbol.iterator]();!(s=(r=a.next()).done)&&(i.push(r.value),!t||i.length!==t);s=!0);}catch(e){o=!0,n=e}finally{try{!s&&a.return&&a.return()}finally{if(o)throw n}}return i}return function(t,i){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,i);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var i=arguments[t];for(var s in i)Object.prototype.hasOwnProperty.call(i,s)&&(e[s]=i[s])}return e},_createClass=function(){function e(e,t){for(var i=0;i<t.length;i++){var s=t[i];s.enumerable=s.enumerable||!1,s.configurable=!0,"value"in s&&(s.writable=!0),Object.defineProperty(e,s.key,s)}}return function(t,i,s){return i&&e(t.prototype,i),s&&e(t,s),t}}(),_react=__webpack_require__("./node_modules/react/index.js"),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__("./node_modules/prop-types/index.js"),_globals=__webpack_require__("./node_modules/react-reveal/globals.js"),inOut=(0,_propTypes.shape)({make:_propTypes.func,duration:_propTypes.number.isRequired,delay:_propTypes.number.isRequired,forever:_propTypes.bool,count:_propTypes.number.isRequired,style:_propTypes.object.isRequired,reverse:_propTypes.bool}),propTypes={collapse:_propTypes.bool,collapseEl:_propTypes.element,cascade:_propTypes.bool,wait:_propTypes.number,force:_propTypes.bool,disabled:_propTypes.bool,appear:_propTypes.bool,enter:_propTypes.bool,exit:_propTypes.bool,fraction:_propTypes.number,refProp:_propTypes.string,innerRef:_propTypes.func,onReveal:_propTypes.func,unmountOnExit:_propTypes.bool,mountOnEnter:_propTypes.bool,inEffect:inOut.isRequired,outEffect:(0,_propTypes.oneOfType)([inOut,(0,_propTypes.oneOf)([!1])]).isRequired,ssrReveal:_propTypes.bool,collapseOnly:_propTypes.bool,ssrFadeout:_propTypes.bool},defaultProps={fraction:.2,refProp:"ref"},contextTypes={transitionGroup:_propTypes.object},RevealBase=function(e){function t(e,i){_classCallCheck(this,t);var s=_possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e,i));return s.isOn=void 0===e.when||!!e.when,s.state={collapse:e.collapse?t.getInitialCollapseStyle(e):void 0,style:{opacity:s.isOn&&!e.ssrReveal||!e.outEffect?void 0:0}},s.savedChild=!1,s.isShown=!1,_globals.observerMode?s.handleObserve=s.handleObserve.bind(s):(s.revealHandler=s.makeHandler(s.reveal),s.resizeHandler=s.makeHandler(s.resize)),s.saveRef=s.saveRef.bind(s),s}return _inherits(t,e),_createClass(t,[{key:"saveRef",value:function(e){this.childRef&&this.childRef(e),this.props.innerRef&&this.props.innerRef(e),this.el!==e&&(this.el=e&&"offsetHeight"in e?e:void 0,this.observe(this.props,!0))}},{key:"invisible",value:function(){this&&this.el&&(this.savedChild=!1,this.isShown||(this.setState({hasExited:!0,collapse:this.props.collapse?_extends({},this.state.collapse,{visibility:"hidden"}):null,style:{opacity:0}}),!_globals.observerMode&&this.props.collapse&&window.document.dispatchEvent(_globals.collapseend)))}},{key:"animationEnd",value:function(e,t,i){var s=this,o=i.forever,n=i.count,r=i.delay,a=i.duration;if(!o){var l=function(){s&&s.el&&(s.animationEndTimeout=void 0,e.call(s))};this.animationEndTimeout=window.setTimeout(l,r+(a+(t?a:0)*n))}}},{key:"getDimensionValue",value:function(){return this.el.offsetHeight+parseInt(window.getComputedStyle(this.el,null).getPropertyValue("margin-top"),10)+parseInt(window.getComputedStyle(this.el,null).getPropertyValue("margin-bottom"),10)}},{key:"collapse",value:function(e,t,i){var s=i.duration+(t.cascade?i.duration:0),o=this.isOn?this.getDimensionValue():0,n=void 0,r=void 0;if(t.collapseOnly)n=i.duration/3,r=i.delay;else{var a=s>>2,l=a>>1;n=a,r=i.delay+(this.isOn?0:s-a-l),e.style.animationDuration=s-a+(this.isOn?l:-l)+"ms",e.style.animationDelay=i.delay+(this.isOn?a-l:0)+"ms"}return e.collapse={height:o,transition:"height "+n+"ms ease "+r+"ms",overflow:t.collapseOnly?"hidden":void 0},e}},{key:"animate",value:function(e){if(this&&this.el&&(this.unlisten(),this.isShown!==this.isOn)){this.isShown=this.isOn;var t=!this.isOn&&e.outEffect,i=e[t?"outEffect":"inEffect"],s="style"in i&&i.style.animationName||void 0,o=void 0;e.collapseOnly?o={hasAppeared:!0,hasExited:!1,style:{opacity:1}}:((e.outEffect||this.isOn)&&i.make&&(s=i.make),o={hasAppeared:!0,hasExited:!1,collapse:void 0,style:_extends({},i.style,{animationDuration:i.duration+"ms",animationDelay:i.delay+"ms",animationIterationCount:i.forever?"infinite":i.count,opacity:1,animationName:s}),className:i.className}),this.setState(e.collapse?this.collapse(o,e,i):o),t?(this.savedChild=_react2.default.cloneElement(this.getChild()),this.animationEnd(this.invisible,e.cascade,i)):this.savedChild=!1,this.onReveal(e)}}},{key:"onReveal",value:function(e){e.onReveal&&this.isOn&&(this.onRevealTimeout&&(this.onRevealTimeout=window.clearTimeout(this.onRevealTimeout)),e.wait?this.onRevealTimeout=window.setTimeout(e.onReveal,e.wait):e.onReveal())}},{key:"componentWillUnmount",value:function(){this.unlisten(),_globals.ssr&&(0,_globals.disableSsr)()}},{key:"handleObserve",value:function(e,t){_slicedToArray(e,1)[0].intersectionRatio>0&&(t.disconnect(),this.observer=null,this.reveal(this.props,!0))}},{key:"observe",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(this.el&&_globals.observerMode){if(this.observer){if(!t)return;this.observer.disconnect()}else if(t)return;this.observer=new IntersectionObserver(this.handleObserve,{threshold:e.fraction}),this.observer.observe(this.el)}}},{key:"reveal",value:function(e){var t=this,i=arguments.length>1&&void 0!==arguments[1]&&arguments[1];_globals.globalHide||(0,_globals.hideAll)(),this&&this.el&&(e||(e=this.props),_globals.ssr&&(0,_globals.disableSsr)(),this.isOn&&this.isShown&&void 0!==e.spy?(this.isShown=!1,this.setState({style:{}}),window.setTimeout(function(){return t.reveal(e)},200)):i||this.inViewport(e)||e.force?this.animate(e):_globals.observerMode?this.observe(e):this.listen())}},{key:"componentDidMount",value:function(){var e=this;if(this.el&&!this.props.disabled){this.props.collapseOnly||("make"in this.props.inEffect&&this.props.inEffect.make(!1,this.props),void 0!==this.props.when&&this.props.outEffect&&"make"in this.props.outEffect&&this.props.outEffect.make(!0,this.props));var i=this.context.transitionGroup,s=i&&!i.isMounting?!("enter"in this.props&&!1===this.props.enter):this.props.appear;return this.isOn&&((void 0!==this.props.when||void 0!==this.props.spy)&&!s||_globals.ssr&&!_globals.fadeOutEnabled&&!this.props.ssrFadeout&&this.props.outEffect&&!this.props.ssrReveal&&t.getTop(this.el)<window.pageYOffset+window.innerHeight)?(this.isShown=!0,this.setState({hasAppeared:!0,collapse:this.props.collapse?{height:this.getDimensionValue()}:this.state.collapse,style:{opacity:1}}),void this.onReveal(this.props)):_globals.ssr&&(_globals.fadeOutEnabled||this.props.ssrFadeout)&&this.props.outEffect&&t.getTop(this.el)<window.pageYOffset+window.innerHeight?(this.setState({style:{opacity:0,transition:"opacity 1000ms 1000ms"}}),void window.setTimeout(function(){return e.reveal(e.props,!0)},2e3)):void(this.isOn&&(this.props.force?this.animate(this.props):this.reveal(this.props)))}}},{key:"cascade",value:function(e){var t=this,i=void 0;i="string"==typeof e?e.split("").map(function(e,t){return _react2.default.createElement("span",{key:t,style:{display:"inline-block",whiteSpace:"pre"}},e)}):_react2.default.Children.toArray(e);var s=this.props[this.isOn||!this.props.outEffect?"inEffect":"outEffect"],o=s.duration,n=s.reverse,r=i.length,a=2*o;this.props.collapse&&(a=parseInt(this.state.style.animationDuration,10),o=a/2);var l=n?r:0;return i=i.map(function(e){return"object"===(void 0===e?"undefined":_typeof(e))&&e?_react2.default.cloneElement(e,{style:_extends({},e.props.style,t.state.style,{animationDuration:Math.round((0,_globals.cascade)(n?l--:l++,0,r,o,a))+"ms"})}):e})}},{key:"componentWillReceiveProps",value:function(e){if(void 0!==e.when&&(this.isOn=!!e.when),e.fraction!==this.props.fraction&&this.observe(e,!0),!this.isOn&&e.onExited&&"exit"in e&&!1===e.exit)return void e.onExited();e.disabled||(e.collapse&&!this.props.collapse&&(this.setState({style:{},collapse:t.getInitialCollapseStyle(e)}),this.isShown=!1),e.when===this.props.when&&e.spy===this.props.spy||this.reveal(e),this.onRevealTimeout&&!this.isOn&&(this.onRevealTimeout=window.clearTimeout(this.onRevealTimeout)))}},{key:"getChild",value:function(){if(this.savedChild&&!this.props.disabled)return this.savedChild;if("object"===_typeof(this.props.children)){var e=_react2.default.Children.only(this.props.children);return"type"in e&&"string"==typeof e.type||"ref"!==this.props.refProp?e:_react2.default.createElement("div",null,e)}return _react2.default.createElement("div",null,this.props.children)}},{key:"render",value:function(){var e=void 0;e=this.state.hasAppeared?!this.props.unmountOnExit||!this.state.hasExited||this.isOn:!this.props.mountOnEnter||this.isOn;var t=this.getChild();"function"==typeof t.ref&&(this.childRef=t.ref);var i=!1,s=t.props,o=s.style,n=s.className,r=s.children,a=this.props.disabled?n:(this.props.outEffect?_globals.namespace:"")+(this.state.className?" "+this.state.className:"")+(n?" "+n:"")||void 0,l=void 0;"function"==typeof this.state.style.animationName&&(this.state.style.animationName=this.state.style.animationName(!this.isOn,this.props)),this.props.cascade&&!this.props.disabled&&r&&this.state.style.animationName?(i=this.cascade(r),l=_extends({},o,{opacity:1})):l=this.props.disabled?o:_extends({},o,this.state.style);var p=_extends({},this.props.props,_defineProperty({className:a,style:l},this.props.refProp,this.saveRef)),h=_react2.default.cloneElement(t,p,e?i||r:void 0);return void 0!==this.props.collapse?this.props.collapseEl?_react2.default.cloneElement(this.props.collapseEl,{style:_extends({},this.props.collapseEl.style,this.props.disabled?void 0:this.state.collapse),children:h}):_react2.default.createElement("div",{style:this.props.disabled?void 0:this.state.collapse,children:h}):h}},{key:"makeHandler",value:function(e){var t=this,i=function(){e.call(t,t.props),t.ticking=!1};return function(){t.ticking||((0,_globals.raf)(i),t.ticking=!0)}}},{key:"inViewport",value:function(e){if(!this.el||window.document.hidden)return!1;var i=this.el.offsetHeight,s=window.pageYOffset-t.getTop(this.el),o=Math.min(i,window.innerHeight)*(_globals.globalHide?e.fraction:0);return s>o-window.innerHeight&&s<i-o}},{key:"resize",value:function(e){this&&this.el&&this.isOn&&this.inViewport(e)&&(this.unlisten(),this.isShown=this.isOn,this.setState({hasExited:!this.isOn,hasAppeared:!0,collapse:void 0,style:{opacity:this.isOn||!e.outEffect?1:0}}),this.onReveal(e))}},{key:"listen",value:function(){_globals.observerMode||this.isListener||(this.isListener=!0,window.addEventListener("scroll",this.revealHandler,{passive:!0}),window.addEventListener("orientationchange",this.revealHandler,{passive:!0}),window.document.addEventListener("visibilitychange",this.revealHandler,{passive:!0}),window.document.addEventListener("collapseend",this.revealHandler,{passive:!0}),window.addEventListener("resize",this.resizeHandler,{passive:!0}))}},{key:"unlisten",value:function(){!_globals.observerMode&&this.isListener&&(window.removeEventListener("scroll",this.revealHandler,{passive:!0}),window.removeEventListener("orientationchange",this.revealHandler,{passive:!0}),window.document.removeEventListener("visibilitychange",this.revealHandler,{passive:!0}),window.document.removeEventListener("collapseend",this.revealHandler,{passive:!0}),window.removeEventListener("resize",this.resizeHandler,{passive:!0}),this.isListener=!1),this.onRevealTimeout&&(this.onRevealTimeout=window.clearTimeout(this.onRevealTimeout)),this.animationEndTimeout&&(this.animationEndTimeout=window.clearTimeout(this.animationEndTimeout))}}],[{key:"getInitialCollapseStyle",value:function(e){return{height:0,visibility:e.when?void 0:"hidden"}}},{key:"getTop",value:function(e){for(;void 0===e.offsetTop;)e=e.parentNode;for(var t=e.offsetTop;e.offsetParent;t+=e.offsetTop)e=e.offsetParent;return t}}]),t}(_react2.default.Component);RevealBase.propTypes=propTypes,RevealBase.defaultProps=defaultProps,RevealBase.contextTypes=contextTypes,RevealBase.displayName="RevealBase",exports.default=RevealBase,module.exports=exports.default;

/***/ }),

/***/ "./node_modules/react-reveal/globals.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function insertRule(e){try{return sheet.insertRule(e,sheet.cssRules.length)}catch(e){console.warn("react-reveal - animation failed")}}function cascade(e,n,t,o,r){var s=Math.log(o),i=Math.log(r),a=(i-s)/(t-n);return Math.exp(s+a*(e-n))}function animation(e){if(!sheet)return"";var n="@keyframes "+(name+counter)+"{"+e+"}",t=effectMap[e];return t?""+name+t:(sheet.insertRule(n,sheet.cssRules.length),effectMap[e]=counter,""+name+counter++)}function hideAll(){globalHide||(exports.globalHide=globalHide=!0,window.removeEventListener("scroll",hideAll,!0),insertRule("."+namespace+" { opacity: 0; }"),window.removeEventListener("orientationchange",hideAll,!0),window.document.removeEventListener("visibilitychange",hideAll))}function config(e){var n=e.ssrFadeout;exports.fadeOutEnabled=fadeOutEnabled=n}Object.defineProperty(exports,"__esModule",{value:!0}),exports.insertRule=insertRule,exports.cascade=cascade,exports.animation=animation,exports.hideAll=hideAll,exports.default=config;var namespace=exports.namespace="react-reveal",defaults=exports.defaults={duration:1e3,delay:0,count:1},ssr=exports.ssr=!0,observerMode=exports.observerMode=!1,raf=exports.raf=function(e){return window.setTimeout(e,66)},disableSsr=exports.disableSsr=function(){return exports.ssr=ssr=!1},fadeOutEnabled=exports.fadeOutEnabled=!1,ssrFadeout=exports.ssrFadeout=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];return exports.fadeOutEnabled=fadeOutEnabled=e},globalHide=exports.globalHide=!1,ie10=exports.ie10=!1,collapseend=exports.collapseend=void 0,counter=1,effectMap={},sheet=!1,name=namespace+"-"+Math.floor(1e15*Math.random())+"-";if("undefined"!=typeof window&&"nodejs"!==window.name&&window.document&&"undefined"!=typeof navigator){exports.observerMode=observerMode="IntersectionObserver"in window&&"IntersectionObserverEntry"in window&&"intersectionRatio"in window.IntersectionObserverEntry.prototype&&/\{\s*\[native code\]\s*\}/.test(""+IntersectionObserver),exports.raf=raf=window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||raf,exports.ssr=ssr=window.document.querySelectorAll("div[data-reactroot]").length>0,-1!==navigator.appVersion.indexOf("MSIE 10")&&(exports.ie10=ie10=!0),ssr&&"performance"in window&&"timing"in window.performance&&"domContentLoadedEventEnd"in window.performance.timing&&window.performance.timing.domLoading&&Date.now()-window.performance.timing.domLoading<300&&(exports.ssr=ssr=!1),ssr&&window.setTimeout(disableSsr,1500),observerMode||(exports.collapseend=collapseend=document.createEvent("Event"),collapseend.initEvent("collapseend",!0,!0));var element=document.createElement("style");document.head.appendChild(element),element.sheet&&element.sheet.cssRules&&element.sheet.insertRule&&(sheet=element.sheet,window.addEventListener("scroll",hideAll,!0),window.addEventListener("orientationchange",hideAll,!0),window.document.addEventListener("visibilitychange",hideAll))}

/***/ }),

/***/ "./node_modules/react-reveal/wrap.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function wrap(e,t,a,r){return"in"in e&&(e.when=e.in),_react2.default.Children.count(r)<2?_react2.default.createElement(_RevealBase2.default,_extends({},e,{inEffect:t,outEffect:a,children:r})):(r=_react2.default.Children.map(r,function(r){return _react2.default.createElement(_RevealBase2.default,_extends({},e,{inEffect:t,outEffect:a,children:r}))}),"Fragment"in _react2.default?_react2.default.createElement(_react2.default.Fragment,null,r):_react2.default.createElement("span",null,r))}Object.defineProperty(exports,"__esModule",{value:!0});var _extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var a=arguments[t];for(var r in a)Object.prototype.hasOwnProperty.call(a,r)&&(e[r]=a[r])}return e};exports.default=wrap;var _react=__webpack_require__("./node_modules/react/index.js"),_react2=_interopRequireDefault(_react),_RevealBase=__webpack_require__("./node_modules/react-reveal/RevealBase.js"),_RevealBase2=_interopRequireDefault(_RevealBase);module.exports=exports.default;

/***/ }),

/***/ "./node_modules/react-router-last-location/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__("./node_modules/react/index.js"), __webpack_require__("./node_modules/react-router-dom/es/index.js"), __webpack_require__("./node_modules/prop-types/index.js"), __webpack_require__("./node_modules/history/esm/history.js"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-router-dom", "prop-types", "history"], factory);
	else if(typeof exports === 'object')
		exports["ReactRouterLastLocation"] = factory(require("react"), require("react-router-dom"), require("prop-types"), require("history"));
	else
		root["ReactRouterLastLocation"] = factory(root["react"], root["react-router-dom"], root["prop-types"], root["history"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__6__, __WEBPACK_EXTERNAL_MODULE__10__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(6);
var react_router_dom_1 = __webpack_require__(1);
var LastLocationContext_1 = __webpack_require__(3);
var prevent_1 = __webpack_require__(7);
var lastLocation = null;
var updateLastLocation = function (_a) {
    var location = _a.location, nextLocation = _a.nextLocation, watchOnlyPathname = _a.watchOnlyPathname;
    if (location === null) {
        return;
    }
    if (nextLocation === location) {
        return;
    }
    if (watchOnlyPathname && location.pathname === nextLocation.pathname) {
        return;
    }
    if (prevent_1.shouldPrevent(nextLocation) && !prevent_1.hasBeenPrevented(nextLocation)) {
        prevent_1.prevent(nextLocation);
        return;
    }
    lastLocation = __assign({}, location);
};
var LastLocationProvider = /** @class */ (function (_super) {
    __extends(LastLocationProvider, _super);
    function LastLocationProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentLocation: null,
        };
        return _this;
    }
    LastLocationProvider.getDerivedStateFromProps = function (props, state) {
        updateLastLocation({
            location: state.currentLocation,
            nextLocation: props.location,
            watchOnlyPathname: props.watchOnlyPathname,
        });
        return {
            currentLocation: props.location,
        };
    };
    LastLocationProvider.prototype.render = function () {
        var children = this.props.children;
        return (React.createElement(LastLocationContext_1.default.Provider, { value: lastLocation }, children));
    };
    LastLocationProvider.propTypes = {
        watchOnlyPathname: PropTypes.bool,
        children: PropTypes.node.isRequired,
    };
    LastLocationProvider.defaultProps = {
        watchOnlyPathname: false,
    };
    return LastLocationProvider;
}(React.Component));
exports.getLastLocation = function () { return lastLocation; };
exports.setLastLocation = function (nextLastLocation) {
    lastLocation = nextLastLocation;
};
exports.default = react_router_dom_1.withRouter(LastLocationProvider);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __webpack_require__(0);
var LastLocationContext = react_1.createContext(null);
exports.default = LastLocationContext;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var withLastLocation_1 = __webpack_require__(5);
exports.withLastLocation = withLastLocation_1.default;
var LastLocationProvider_1 = __webpack_require__(2);
exports.LastLocationProvider = LastLocationProvider_1.default;
var useLastLocation_1 = __webpack_require__(8);
exports.useLastLocation = useLastLocation_1.default;
var RedirectWithoutLastLocation_1 = __webpack_require__(9);
exports.RedirectWithoutLastLocation = RedirectWithoutLastLocation_1.default;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(1);
var LastLocationProvider_1 = __webpack_require__(2);
function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
var withLastLocation = function (WrappedComponent) {
    var WithLastLocation = function (props) { return (React.createElement(WrappedComponent, __assign({ lastLocation: LastLocationProvider_1.getLastLocation() }, props))); };
    WithLastLocation.displayName = "WithLastLocation(" + getDisplayName(WrappedComponent) + ")";
    return react_router_dom_1.withRouter(WithLastLocation);
};
exports.default = withLastLocation;


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__6__;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * I could only check `key` here but according to:
 * @see https://reacttraining.com/react-router/web/api/location
 * `key` property is not available when HashHistory is used.
 */
var props = ['key', 'pathname', 'search', 'hash'];
var isEqual = function (a, b) { return props.every(function (prop) { return a[prop] === b[prop]; }); };
var prevented = [];
exports.prevent = function (location) {
    var state = location.state, rest = __rest(location, ["state"]);
    prevented.push(rest);
};
exports.hasBeenPrevented = function (location) {
    return prevented.some(function (preventedLocation) { return isEqual(location, preventedLocation); });
};
exports.shouldPrevent = function (location) {
    return Boolean(location.state && location.state.preventLastLocation);
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __webpack_require__(0);
var LastLocationContext_1 = __webpack_require__(3);
function useLastLocation() {
    return react_1.useContext(LastLocationContext_1.default);
}
exports.default = useLastLocation;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(1);
var history_1 = __webpack_require__(10);
var RedirectWithoutLastLocation = function (_a) {
    var to = _a.to, rest = __rest(_a, ["to"]);
    var finalTo;
    if (typeof to === 'string') {
        finalTo = history_1.createLocation(to, { preventLastLocation: true });
    }
    else {
        finalTo = __assign({}, to, { state: __assign({ preventLastLocation: true }, to.state) });
    }
    return React.createElement(react_router_dom_1.Redirect, __assign({}, rest, { to: finalTo }));
};
exports.default = RedirectWithoutLastLocation;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ })
/******/ ]);
});

/***/ }),

/***/ "./node_modules/react-share/es/EmailIcon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__("./node_modules/react-share/es/utils/iconFactory.js");


var EmailIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('email', {
  icon: 'M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z',
  mask: 'M41.1,25H22.9l9.1,7.1L41.1,25z M44,26.6l-12,9.3l-12-9.3V39h24V26.6z M0,0v64h64V0H0z M47,42H17V22h30V42z',
  color: '#7f7f7f'
});

/* unused harmony default export */ var _unused_webpack_default_export = (EmailIcon);

/***/ }),

/***/ "./node_modules/react-share/es/EmailShareButton.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__ = __webpack_require__("./node_modules/react-share/es/utils/createShareButton.js");





function emailLink(url, _ref) {
  var subject = _ref.subject,
      body = _ref.body;

  return 'mailto:' + Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({ subject: subject, body: body || url });
}

var EmailShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__["a" /* default */])('email', emailLink, function (props) {
  return {
    subject: props.subject,
    body: props.body
  };
}, {
  subject: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  body: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  openWindow: false,
  onClick: function onClick(link) {
    window.location.href = link;
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (EmailShareButton);

/***/ }),

/***/ "./node_modules/react-share/es/FacebookIcon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__("./node_modules/react-share/es/utils/iconFactory.js");


var FacebookIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('facebook', {
  icon: 'M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z',
  mask: 'M0,0v64h64V0H0z M39.6,22l-2.8,0c-2.2,0-2.6,1.1-2.6,2.6V28h5.3l-0.7,5.3h-4.6V47h-5.5V33.3H24V28h4.6V24 c0-4.6,2.8-7,6.9-7c2,0,3.6,0.1,4.1,0.2V22z',
  color: '#3b5998'
});

/* harmony default export */ __webpack_exports__["a"] = (FacebookIcon);

/***/ }),

/***/ "./node_modules/react-share/es/FacebookShareButton.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__("./node_modules/assert/assert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__("./node_modules/react-share/es/utils/createShareButton.js");







function facebookLink(url, _ref) {
  var quote = _ref.quote,
      hashtag = _ref.hashtag;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'facebook.url');

  return 'https://www.facebook.com/sharer/sharer.php' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    u: url,
    quote: quote,
    hashtag: hashtag
  });
}

var FacebookShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('facebook', facebookLink, function (props) {
  /* eslint-disable no-console */
  if (props.picture) {
    console.warn('FacebookShareButton warning: picture is a deprecated prop.');
  }

  if (props.title) {
    console.warn('FacebookShareButton warning: title is a deprecated prop. Use "quote" instead.');
  }

  if (props.description) {
    console.warn('FacebookShareButton warning: description is a deprecated prop.\n      Use "quote" instead.');
  }
  /* eslint-enable no-console */

  return {
    quote: props.quote,
    hashtag: props.hashtag
  };
}, {
  quote: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  hashtag: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

/* harmony default export */ __webpack_exports__["a"] = (FacebookShareButton);

/***/ }),

/***/ "./node_modules/react-share/es/FacebookShareCount.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__("./node_modules/jsonp/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shareCountFactory__ = __webpack_require__("./node_modules/react-share/es/utils/shareCountFactory.js");




function getFacebookShareCount(shareUrl, callback) {
  var endpoint = 'https://graph.facebook.com/?id=' + shareUrl;

  __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(endpoint, function (err, data) {
    callback(!err && data && data.share && data.share.share_count ? data.share.share_count : undefined);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_shareCountFactory__["a" /* default */])(getFacebookShareCount));

/***/ }),

/***/ "./node_modules/react-share/es/GooglePlusIcon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__("./node_modules/react-share/es/utils/iconFactory.js");


var GooglePlusIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('google', {
  icon: 'M25.3,30.1v3.8h6.3c-0.3,1.6-1.9,4.8-6.3,4.8c-3.8,0-6.9-3.1-6.9-7s3.1-7,6.9-7c2.2,0,3.6,0.9,4.4,1.7l3-2.9c-1.9-1.8-4.4-2.9-7.4-2.9c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1c6.4,0,10.7-4.5,10.7-10.9c0-0.7-0.1-1.3-0.2-1.8H25.3L25.3,30.1z M49.8,28.9h-3.2v-3.2h-3.2v3.2h-3.2v3.2h3.2v3.2h3.2v-3.2h3.2',
  mask: 'M0,0v64h64V0H0z M31.3,19.1c0.3,0.3,0.6,0.7,0.9,1.2c0.3,0.4,0.5,0.9,0.7,1.5c0.2,0.6,0.3,1.3,0.3,2.1 c0,1.4-0.3,2.6-0.9,3.4c-0.3,0.4-0.6,0.8-0.9,1.2c-0.4,0.4-0.8,0.7-1.2,1.1c-0.2,0.2-0.5,0.5-0.7,0.8c-0.2,0.3-0.4,0.7-0.4,1.1 c0,0.4,0.1,0.8,0.4,1c0.2,0.3,0.4,0.5,0.6,0.7l1.4,1.1c0.8,0.7,1.6,1.5,2.2,2.3c0.6,0.8,0.9,2,0.9,3.3c0,1.9-0.9,3.7-2.6,5.2 c-1.8,1.6-4.3,2.4-7.7,2.4c-2.8,0-4.9-0.6-6.3-1.8c-1.4-1.1-2.1-2.4-2.1-3.9c0-0.7,0.2-1.6,0.7-2.5c0.4-0.9,1.2-1.7,2.4-2.4 c1.3-0.7,2.7-1.2,4.1-1.5c1.4-0.2,2.6-0.3,3.5-0.4c-0.3-0.4-0.5-0.8-0.8-1.2c-0.3-0.4-0.4-0.9-0.4-1.5c0-0.4,0-0.6,0.2-0.9 c0.1-0.2,0.2-0.5,0.2-0.7c-0.5,0.1-0.9,0.1-1.3,0.1c-2.1,0-3.8-0.7-4.9-2c-1.2-1.2-1.8-2.7-1.8-4.3c0-2,0.8-3.8,2.5-5.4 c1.1-0.9,2.3-1.6,3.5-1.8c1.2-0.2,2.3-0.4,3.4-0.4h8L33,18.4h-2.5C30.7,18.6,31,18.8,31.3,19.1z M48,32h-4.3v4.2h-2.5V32H37v-2.5 h4.2v-4.3h2.5v4.3H48V32z M27.1,19.1c-0.6-0.5-1.4-0.7-2.2-0.7c-1.1,0-2,0.5-2.7,1.3c-0.6,0.9-0.9,1.9-0.9,3c0,1.5,0.4,3,1.3,4.5 c0.4,0.7,0.9,1.4,1.6,1.9c0.6,0.5,1.4,0.8,2.2,0.8c1.1,0,1.9-0.4,2.6-1.1c0.3-0.5,0.6-1,0.7-1.6c0.1-0.5,0.1-1,0.1-1.4 c0-1.6-0.4-3.2-1.2-4.8C28.2,20.2,27.7,19.5,27.1,19.1z M26.9,36.2c-0.2,0-0.7,0-1.6,0.1c-0.8,0.1-1.7,0.3-2.5,0.6 c-0.2,0.1-0.5,0.2-0.9,0.4c-0.4,0.2-0.7,0.4-1.1,0.7c-0.4,0.3-0.7,0.7-0.9,1.2c-0.3,0.5-0.4,1.1-0.4,1.8c0,1.4,0.6,2.6,1.9,3.5 c1.2,0.9,2.9,1.4,5,1.4c1.9,0,3.3-0.4,4.3-1.3c1-0.8,1.5-1.8,1.5-3.1c0-1-0.3-1.9-1-2.7c-0.7-0.7-1.8-1.6-3.3-2.6 C27.5,36.2,27.2,36.2,26.9,36.2z',
  color: '#dd4b39'
});

/* unused harmony default export */ var _unused_webpack_default_export = (GooglePlusIcon);

/***/ }),

/***/ "./node_modules/react-share/es/GooglePlusShareButton.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assert__ = __webpack_require__("./node_modules/assert/assert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__ = __webpack_require__("./node_modules/react-share/es/utils/createShareButton.js");





function googlePlusLink(url) {
  __WEBPACK_IMPORTED_MODULE_0_assert___default()(url, 'googlePlus.url');

  return 'https://plus.google.com/share' + Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({ url: url });
}

var GooglePlusShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__["a" /* default */])('googlePlus', googlePlusLink, undefined, undefined, {
  windowWidth: 550,
  windowHeight: 400
});

/* unused harmony default export */ var _unused_webpack_default_export = (GooglePlusShareButton);

/***/ }),

/***/ "./node_modules/react-share/es/GooglePlusShareCount.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("./node_modules/babel-runtime/core-js/json/stringify.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ieDetection__ = __webpack_require__("./node_modules/react-share/es/utils/ieDetection.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__("./node_modules/react-share/es/utils/shareCountFactory.js");




function getGooglePlusShareCount(shareUrl, callback) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_ieDetection__["a" /* default */])(11)) {
    /* eslint-disable no-console */
    console.error('Google plus share count is not supported in <=IE10!');
    /* eslint-enable no-console */
    return;
  }

  var xhr = new XMLHttpRequest();

  xhr.open('POST', 'https://clients6.google.com/rpc');
  xhr.setRequestHeader('Accept', 'application/json');
  xhr.setRequestHeader('Content-type', 'application/json;charset=UTF-8');

  xhr.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    method: 'pos.plusones.get',
    id: 'p',
    params: {
      nolog: true,
      id: shareUrl,
      source: 'widget',
      userId: '@viewer',
      groupId: '@self'
    },
    jsonrpc: '2.0',
    key: 'p',
    apiVersion: 'v1'
  }));

  xhr.onload = function onSuccessdata() {
    var data = JSON.parse(this.responseText);
    callback(data ? data.result.metadata.globalCounts.count : undefined);
  };

  xhr.onerror = function onErrordata() {};
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getGooglePlusShareCount));

/***/ }),

/***/ "./node_modules/react-share/es/LineIcon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__("./node_modules/react-share/es/utils/iconFactory.js");


var LineIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('line', {
  icon: 'M52.62 30.138c0 3.693-1.432 7.019-4.42 10.296h.001c-4.326 4.979-14 11.044-16.201 11.972-2.2.927-1.876-.591-1.786-1.112l.294-1.765c.069-.527.142-1.343-.066-1.865-.232-.574-1.146-.872-1.817-1.016-9.909-1.31-17.245-8.238-17.245-16.51 0-9.226 9.251-16.733 20.62-16.733 11.37 0 20.62 7.507 20.62 16.733zM27.81 25.68h-1.446a.402.402 0 0 0-.402.401v8.985c0 .221.18.4.402.4h1.446a.401.401 0 0 0 .402-.4v-8.985a.402.402 0 0 0-.402-.401zm9.956 0H36.32a.402.402 0 0 0-.402.401v5.338L31.8 25.858a.39.39 0 0 0-.031-.04l-.002-.003-.024-.025-.008-.007a.313.313 0 0 0-.032-.026.255.255 0 0 1-.021-.014l-.012-.007-.021-.012-.013-.006-.023-.01-.013-.005-.024-.008-.014-.003-.023-.005-.017-.002-.021-.003-.021-.002h-1.46a.402.402 0 0 0-.402.401v8.985c0 .221.18.4.402.4h1.446a.401.401 0 0 0 .402-.4v-5.337l4.123 5.568c.028.04.063.072.101.099l.004.003a.236.236 0 0 0 .025.015l.012.006.019.01a.154.154 0 0 1 .019.008l.012.004.028.01.005.001a.442.442 0 0 0 .104.013h1.446a.4.4 0 0 0 .401-.4v-8.985a.402.402 0 0 0-.401-.401zm-13.442 7.537h-3.93v-7.136a.401.401 0 0 0-.401-.401h-1.447a.4.4 0 0 0-.401.401v8.984a.392.392 0 0 0 .123.29c.072.068.17.111.278.111h5.778a.4.4 0 0 0 .401-.401v-1.447a.401.401 0 0 0-.401-.401zm21.429-5.287c.222 0 .401-.18.401-.402v-1.446a.401.401 0 0 0-.401-.402h-5.778a.398.398 0 0 0-.279.113l-.005.004-.006.008a.397.397 0 0 0-.111.276v8.984c0 .108.043.206.112.278l.005.006a.401.401 0 0 0 .284.117h5.778a.4.4 0 0 0 .401-.401v-1.447a.401.401 0 0 0-.401-.401h-3.93v-1.519h3.93c.222 0 .401-.18.401-.402V29.85a.401.401 0 0 0-.401-.402h-3.93V27.93h3.93z',
  mask: '',
  color: '#00b800'
});

/* unused harmony default export */ var _unused_webpack_default_export = (LineIcon);

/***/ }),

/***/ "./node_modules/react-share/es/LineShareButton.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__("./node_modules/assert/assert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__ = __webpack_require__("./node_modules/react-share/es/utils/createShareButton.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");







function lineLink(url, _ref) {
  var title = _ref.title;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'line.url');

  return 'https://social-plugins.line.me/lineit/share' + Object(__WEBPACK_IMPORTED_MODULE_3__utils_objectToGetParams__["a" /* default */])({
    url: url,
    text: title
  });
}

var LineShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__["a" /* default */])('line', lineLink, function (props) {
  return {
    title: props.title
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 500,
  windowHeight: 500
});

/* unused harmony default export */ var _unused_webpack_default_export = (LineShareButton);

/***/ }),

/***/ "./node_modules/react-share/es/LinkedinIcon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__("./node_modules/react-share/es/utils/iconFactory.js");


var LinkedinIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('linkedin', {
  icon: 'M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z',
  mask: 'M0,0v64h64V0H0z M25.8,44h-5.4V26.6h5.4V44z M23.1,24.3c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1 c1.7,0,3.1,1.4,3.1,3.1C26.2,22.9,24.8,24.3,23.1,24.3z M46,44h-5.4v-8.4c0-2,0-4.6-2.8-4.6c-2.8,0-3.2,2.2-3.2,4.5V44h-5.4V26.6 h5.2V29h0.1c0.7-1.4,2.5-2.8,5.1-2.8c5.5,0,6.5,3.6,6.5,8.3V44z',
  color: '#007fb1'
});

/* harmony default export */ __webpack_exports__["a"] = (LinkedinIcon);

/***/ }),

/***/ "./node_modules/react-share/es/LinkedinShareButton.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__("./node_modules/assert/assert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__("./node_modules/react-share/es/utils/createShareButton.js");







function linkedinLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'linkedin.url');

  return 'https://linkedin.com/shareArticle' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    summary: description
  });
}

var LinkedinShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('linkedin', linkedinLink, function (props) {
  return {
    title: props.title,
    description: props.description
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 750,
  windowHeight: 600
});

/* harmony default export */ __webpack_exports__["a"] = (LinkedinShareButton);

/***/ }),

/***/ "./node_modules/react-share/es/LinkedinShareCount.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__("./node_modules/jsonp/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__("./node_modules/react-share/es/utils/shareCountFactory.js");





function getLinkedinShareCount(shareUrl, callback) {
  var url = 'https://www.linkedin.com/countserv/count/share';

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url + Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    url: shareUrl,
    format: 'jsonp'
  }), function (err, data) {
    callback(data ? data.count : undefined);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getLinkedinShareCount));

/***/ }),

/***/ "./node_modules/react-share/es/LivejournalIcon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__("./node_modules/react-share/es/utils/iconFactory.js");


var LivejournalIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('livejournal', {
  icon: 'M18.3407821,28.1764706 L21.9441341,31.789916 L33.0055865,42.882353 C33.0055865,42.882353 33.0893855,42.9663866 33.0893855,42.9663866 L46.6648046,47 C46.6648046,47 46.6648046,47 46.7486034,47 C46.8324022,47 46.8324022,47 46.9162012,46.9159664 C47,46.8319327 47,46.8319327 47,46.7478991 L42.9776536,33.1344537 C42.9776536,33.1344537 42.9776536,33.1344537 42.8938548,33.0504202 L31.1620111,21.3697479 L31.1620111,21.3697479 L28.1452514,18.2605042 C27.3072626,17.4201681 26.5530726,17 25.7150838,17 C24.2905028,17 23.0335195,18.3445378 21.5251397,19.8571429 C21.273743,20.1092437 20.9385475,20.4453781 20.6871508,20.697479 C20.3519553,21.0336134 20.1005586,21.2857143 19.849162,21.5378151 C18.3407821,22.9663866 17.0837989,24.2268908 17,25.7394958 C17.0837989,26.4957983 17.5027933,27.3361345 18.3407821,28.1764706 Z M39.9012319,39.6134454 C39.7336341,39.4453781 39.4822374,37.6806724 40.2364275,36.8403362 C40.9906174,36.0840337 41.6610084,36 42.1638017,36 C42.3313995,36 42.4989973,36 42.5827961,36 L44.8453659,43.5630253 L43.5883828,44.8235295 L36.0464833,42.5546218 C35.9626843,42.2184874 35.8788855,41.2100841 36.8844722,40.2016807 C37.2196676,39.8655463 37.8900587,39.6134454 38.5604498,39.6134454 C39.147042,39.6134454 39.5660364,39.7815126 39.5660364,39.7815126 C39.6498353,39.8655463 39.8174331,39.8655463 39.8174331,39.7815126 C39.9850307,39.7815126 39.9850307,39.697479 39.9012319,39.6134454 Z',
  mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
  color: '#21A5D8'
});

/* unused harmony default export */ var _unused_webpack_default_export = (LivejournalIcon);

/***/ }),

/***/ "./node_modules/react-share/es/LivejournalShareButton.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__("./node_modules/assert/assert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__("./node_modules/react-share/es/utils/createShareButton.js");







function livejournalLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'livejournal.url');

  return 'https://www.livejournal.com/update.bml' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    subject: title,
    event: description
  });
}

var LivejournalShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('livejournal', livejournalLink, function (props) {
  return {
    title: props.title,
    description: props.description
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (LivejournalShareButton);

/***/ }),

/***/ "./node_modules/react-share/es/MailruIcon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__("./node_modules/react-share/es/utils/iconFactory.js");


var MailruIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('mailru', {
  icon: 'M39.7107745,17 C41.6619755,17 43.3204965,18.732852 43.3204965,21.0072202 C43.3204965,23.2815885 41.7595357,25.0144404 39.7107745,25.0144404 C37.7595732,25.0144404 36.1010522,23.2815885 36.1010522,21.0072202 C36.1010522,18.732852 37.7595732,17 39.7107745,17 Z M24.3938451,17 C26.3450463,17 28.0035672,18.732852 28.0035672,21.0072202 C28.0035672,23.2815885 26.4426063,25.0144404 24.3938451,25.0144404 C22.4426439,25.0144404 20.7841229,23.2815885 20.7841229,21.0072202 C20.7841229,18.732852 22.4426439,17 24.3938451,17 Z M51.9057817,43.4259928 C51.7106617,44.0758123 51.4179815,44.6173285 50.9301812,44.9422383 C50.637501,45.1588448 50.2472607,45.267148 49.8570205,45.267148 C49.07654,45.267148 48.3936197,44.833935 48.0033795,44.0758123 L46.2472985,40.7184115 L45.759498,41.2599278 C42.5400162,44.9422383 37.466893,47 32.0035297,47 C26.5401664,47 21.5646034,44.9422383 18.2475614,41.2599278 L17.7597611,40.7184115 L16.00368,44.0758123 C15.6134398,44.833935 14.9305194,45.267148 14.1500389,45.267148 C13.7597986,45.267148 13.3695584,45.1588448 13.0768782,44.9422383 C12.0037176,44.2924187 11.7110374,42.7761733 12.2963978,41.5848375 L16.7841605,33.0288807 C17.1744007,32.270758 17.8573211,31.8375453 18.6378016,31.8375453 C19.0280418,31.8375453 19.4182821,31.9458485 19.7109623,32.1624548 C20.7841229,32.8122743 21.0768031,34.3285197 20.4914427,35.5198555 L20.1012025,36.2779783 L20.2963226,36.602888 C22.4426439,39.9602888 27.0279667,42.234657 31.9059697,42.234657 C36.7839727,42.234657 41.3692955,40.068592 43.5156167,36.602888 L43.7107367,36.2779783 L43.3204965,35.6281587 C43.0278165,35.0866425 42.9302562,34.436823 43.1253765,33.7870035 C43.3204965,33.137184 43.6131767,32.5956678 44.100977,32.270758 C44.3936572,32.0541515 44.7838975,31.9458485 45.1741377,31.9458485 C45.9546182,31.9458485 46.6375385,32.3790613 47.0277787,33.137184 L51.5155415,41.6931408 C52.003342,42.234657 52.100902,42.8844765 51.9057817,43.4259928 Z',
  mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
  color: '#168DE2'
});

/* unused harmony default export */ var _unused_webpack_default_export = (MailruIcon);

/***/ }),

/***/ "./node_modules/react-share/es/MailruShareButton.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__("./node_modules/assert/assert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__("./node_modules/react-share/es/utils/createShareButton.js");







function mailruLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description,
      image = _ref.image;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'mailru.url');

  return 'https://connect.mail.ru/share' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    description: description,
    imageurl: image
  });
}

var MailruShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('mailru', mailruLink, function (props) {
  return {
    title: props.title,
    description: props.description,
    image: props.image
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (MailruShareButton);

/***/ }),

/***/ "./node_modules/react-share/es/OKIcon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__("./node_modules/react-share/es/utils/iconFactory.js");


var OKIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('ok', {
  icon: 'M39,30c-1,0-3,2-7,2s-6-2-7-2c-1.1,0-2,0.9-2,2c0,1,0.6,1.5,1,1.7c1.2,0.7,5,2.3,5,2.3l-4.3,5.4   c0,0-0.8,0.9-0.8,1.6c0,1.1,0.9,2,2,2c1,0,1.5-0.7,1.5-0.7S32,39,32,39c0,0,4.5,5.3,4.5,5.3S37,45,38,45c1.1,0,2-0.9,2-2   c0-0.6-0.8-1.6-0.8-1.6L35,36c0,0,3.8-1.6,5-2.3c0.4-0.3,1-0.7,1-1.7C41,30.9,40.1,30,39,30z M32,15c-3.9,0-7,3.1-7,7s3.1,7,7,7c3.9,0,7-3.1,7-7S35.9,15,32,15z M32,25.5   c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5C35.5,23.9,33.9,22.5,35,22.5z ',
  mask: 'M45,1H5C2.8,1,1,2.8,1,5v40c0,2.2,1.8,4,4,4h40c2.2,0,4-1.8,4-4V5C49,2.8,47.2,1,45,1z',
  color: '#f2720c'
});

/* unused harmony default export */ var _unused_webpack_default_export = (OKIcon);

/***/ }),

/***/ "./node_modules/react-share/es/OKShareButton.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__("./node_modules/assert/assert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__("./node_modules/react-share/es/utils/createShareButton.js");







function okLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description,
      image = _ref.image;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'ok.url');

  return 'https://connect.ok.ru/offer' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    description: description,
    imageUrl: image
  });
}

var OKShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('ok', okLink, function (props) {
  return {
    title: props.title,
    description: props.description,
    image: props.image
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (OKShareButton);

/***/ }),

/***/ "./node_modules/react-share/es/OKShareCount.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__("./node_modules/jsonp/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__("./node_modules/react-share/es/utils/shareCountFactory.js");





function getOKShareCount(shareUrl, callback) {
  if (!window.OK) {
    window.OK = {
      Share: {
        count: function count(index, _count) {
          return window.OK.callbacks[index](_count);
        }
      },
      callbacks: []
    };
  }

  var url = 'https://connect.ok.ru/dk';
  var index = window.OK.callbacks.length;

  window.ODKL = {
    updateCount: function updateCount(a, b) {
      window.OK.callbacks[index](b);
    }
  };
  window.OK.callbacks.push(callback);

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url + (0, __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    'st.cmd': 'extLike',
    uid: 'odklcnt0',
    ref: shareUrl
  }));
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getOKShareCount));

/***/ }),

/***/ "./node_modules/react-share/es/PinterestIcon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__("./node_modules/react-share/es/utils/iconFactory.js");


var PinterestIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('pinterest', {
  icon: 'M32,16c-8.8,0-16,7.2-16,16c0,6.6,3.9,12.2,9.6,14.7c0-1.1,0-2.5,0.3-3.7 c0.3-1.3,2.1-8.7,2.1-8.7s-0.5-1-0.5-2.5c0-2.4,1.4-4.1,3.1-4.1c1.5,0,2.2,1.1,2.2,2.4c0,1.5-0.9,3.7-1.4,5.7 c-0.4,1.7,0.9,3.1,2.5,3.1c3,0,5.1-3.9,5.1-8.5c0-3.5-2.4-6.1-6.7-6.1c-4.9,0-7.9,3.6-7.9,7.7c0,1.4,0.4,2.4,1.1,3.1 c0.3,0.3,0.3,0.5,0.2,0.9c-0.1,0.3-0.3,1-0.3,1.3c-0.1,0.4-0.4,0.6-0.8,0.4c-2.2-0.9-3.3-3.4-3.3-6.1c0-4.5,3.8-10,11.4-10 c6.1,0,10.1,4.4,10.1,9.2c0,6.3-3.5,11-8.6,11c-1.7,0-3.4-0.9-3.9-2c0,0-0.9,3.7-1.1,4.4c-0.3,1.2-1,2.5-1.6,3.4 c1.4,0.4,3,0.7,4.5,0.7c8.8,0,16-7.2,16-16C48,23.2,40.8,16,32,16z',
  mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
  color: '#cb2128'
});

/* unused harmony default export */ var _unused_webpack_default_export = (PinterestIcon);

/***/ }),

/***/ "./node_modules/react-share/es/PinterestShareButton.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__("./node_modules/assert/assert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__("./node_modules/react-share/es/utils/createShareButton.js");







function pinterestLink(url, _ref) {
  var media = _ref.media,
      description = _ref.description;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'pinterest.url');
  __WEBPACK_IMPORTED_MODULE_1_assert___default()(media, 'pinterest.media');

  return 'https://pinterest.com/pin/create/button/' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    media: media,
    description: description
  });
}

var PinterestShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('pinterest', pinterestLink, function (props) {
  return {
    media: props.media,
    description: props.description
  };
}, {
  media: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 1000,
  windowHeight: 730
});

/* unused harmony default export */ var _unused_webpack_default_export = (PinterestShareButton);

/***/ }),

/***/ "./node_modules/react-share/es/PinterestShareCount.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__("./node_modules/jsonp/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__("./node_modules/react-share/es/utils/shareCountFactory.js");





function getPinterestShareCount(shareUrl, callback) {
  var url = 'https://api.pinterest.com/v1/urls/count.json';

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url + Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    url: shareUrl
  }), function (err, data) {
    callback(data ? data.count : undefined);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getPinterestShareCount));

/***/ }),

/***/ "./node_modules/react-share/es/RedditIcon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__("./node_modules/react-share/es/utils/iconFactory.js");


var RedditIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('reddit', {
  icon: 'm 52.8165,31.942362 c 0,-2.4803 -2.0264,-4.4965 -4.5169,-4.4965 -1.2155,0 -2.3171,0.4862 -3.128,1.2682 -3.077,-2.0247 -7.2403,-3.3133 -11.8507,-3.4782 l 2.5211,-7.9373 6.8272,1.5997 -0.0102,0.0986 c 0,2.0281 1.6575,3.6771 3.6958,3.6771 2.0366,0 3.6924,-1.649 3.6924,-3.6771 0,-2.0281 -1.6575,-3.6788 -3.6924,-3.6788 -1.564,0 -2.8968,0.9758 -3.4357,2.3443 l -7.3593,-1.7255 c -0.3213,-0.0782 -0.6477,0.1071 -0.748,0.4233 L 32,25.212062 c -4.8246,0.0578 -9.1953,1.3566 -12.41,3.4425 -0.8058,-0.7446 -1.8751,-1.2104 -3.0583,-1.2104 -2.4905,0 -4.5152,2.0179 -4.5152,4.4982 0,1.649 0.9061,3.0787 2.2389,3.8607 -0.0884,0.4794 -0.1462,0.9639 -0.1462,1.4569 0,6.6487 8.1736,12.0581 18.2223,12.0581 10.0487,0 18.224,-5.4094 18.224,-12.0581 0,-0.4658 -0.0493,-0.9248 -0.1275,-1.377 1.4144,-0.7599 2.3885,-2.2304 2.3885,-3.9406 z m -29.2808,3.0872 c 0,-1.4756 1.207,-2.6775 2.6894,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 -1.4824,0 -2.6894,-1.2002 -2.6894,-2.6758 z m 15.4037,7.9373 c -1.3549,1.3481 -3.4816,2.0043 -6.5008,2.0043 l -0.0221,-0.0051 -0.0221,0.0051 c -3.0209,0 -5.1476,-0.6562 -6.5008,-2.0043 -0.2465,-0.2448 -0.2465,-0.6443 0,-0.8891 0.2465,-0.2465 0.6477,-0.2465 0.8942,0 1.105,1.0999 2.9393,1.6337 5.6066,1.6337 l 0.0221,0.0051 0.0221,-0.0051 c 2.6673,0 4.5016,-0.5355 5.6066,-1.6354 0.2465,-0.2465 0.6477,-0.2448 0.8942,0 0.2465,0.2465 0.2465,0.6443 0,0.8908 z m -0.3213,-5.2615 c -1.4824,0 -2.6877,-1.2002 -2.6877,-2.6758 0,-1.4756 1.2053,-2.6775 2.6877,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 z',
  color: '#5f99cf'
});

/* unused harmony default export */ var _unused_webpack_default_export = (RedditIcon);

/***/ }),

/***/ "./node_modules/react-share/es/RedditShareButton.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__("./node_modules/assert/assert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__("./node_modules/react-share/es/utils/createShareButton.js");







function redditLink(url, _ref) {
  var title = _ref.title;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'reddit.url');

  return 'https://www.reddit.com/submit' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title
  });
}

var RedditShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('reddit', redditLink, function (props) {
  return {
    title: props.title
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (RedditShareButton);

/***/ }),

/***/ "./node_modules/react-share/es/RedditShareCount.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__("./node_modules/jsonp/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shareCountFactory__ = __webpack_require__("./node_modules/react-share/es/utils/shareCountFactory.js");




function getRedditShareCount(shareUrl, callback) {
  var endpoint = 'https://www.reddit.com/api/info.json?limit=1&url=' + shareUrl;

  __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(endpoint, { param: 'jsonp' }, function (err, response) {
    callback(!err && response && response.data && response.data.children.length > 0 && response.data.children[0].data.score ? response.data.children[0].data.score : undefined);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_shareCountFactory__["a" /* default */])(getRedditShareCount));

/***/ }),

/***/ "./node_modules/react-share/es/TelegramIcon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__("./node_modules/react-share/es/utils/iconFactory.js");


var TelegramIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('telegram', {
  icon: 'm45.90873,15.44335c-0.6901,-0.0281 -1.37668,0.14048 -1.96142,0.41265c-0.84989,0.32661 -8.63939,3.33986 -16.5237,6.39174c-3.9685,1.53296 -7.93349,3.06593 -10.98537,4.24067c-3.05012,1.1765 -5.34694,2.05098 -5.4681,2.09312c-0.80775,0.28096 -1.89996,0.63566 -2.82712,1.72788c-0.23354,0.27218 -0.46884,0.62161 -0.58825,1.10275c-0.11941,0.48114 -0.06673,1.09222 0.16682,1.5716c0.46533,0.96052 1.25376,1.35737 2.18443,1.71383c3.09051,0.99037 6.28638,1.93508 8.93263,2.8236c0.97632,3.44171 1.91401,6.89571 2.84116,10.34268c0.30554,0.69185 0.97105,0.94823 1.65764,0.95525l-0.00351,0.03512c0,0 0.53908,0.05268 1.06412,-0.07375c0.52679,-0.12292 1.18879,-0.42846 1.79109,-0.99212c0.662,-0.62161 2.45836,-2.38812 3.47683,-3.38552l7.6736,5.66477l0.06146,0.03512c0,0 0.84989,0.59703 2.09312,0.68132c0.62161,0.04214 1.4399,-0.07726 2.14229,-0.59176c0.70766,-0.51626 1.1765,-1.34683 1.396,-2.29506c0.65673,-2.86224 5.00979,-23.57745 5.75257,-27.00686l-0.02107,0.08077c0.51977,-1.93157 0.32837,-3.70159 -0.87096,-4.74991c-0.60054,-0.52152 -1.2924,-0.7498 -1.98425,-0.77965l0,0.00176zm-0.2072,3.29069c0.04741,0.0439 0.0439,0.0439 0.00351,0.04741c-0.01229,-0.00351 0.14048,0.2072 -0.15804,1.32576l-0.01229,0.04214l-0.00878,0.03863c-0.75858,3.50668 -5.15554,24.40802 -5.74203,26.96472c-0.08077,0.34417 -0.11414,0.31959 -0.09482,0.29852c-0.1756,-0.02634 -0.50045,-0.16506 -0.52679,-0.1756l-13.13468,-9.70175c4.4988,-4.33199 9.09945,-8.25307 13.744,-12.43229c0.8218,-0.41265 0.68483,-1.68573 -0.29852,-1.70681c-1.04305,0.24584 -1.92279,0.99564 -2.8798,1.47502c-5.49971,3.2626 -11.11882,6.13186 -16.55882,9.49279c-2.792,-0.97105 -5.57873,-1.77704 -8.15298,-2.57601c2.2336,-0.89555 4.00889,-1.55579 5.75608,-2.23009c3.05188,-1.1765 7.01687,-2.7042 10.98537,-4.24067c7.94051,-3.06944 15.92667,-6.16346 16.62028,-6.43037l0.05619,-0.02283l0.05268,-0.02283c0.19316,-0.0878 0.30378,-0.09658 0.35471,-0.10009c0,0 -0.01756,-0.05795 -0.00351,-0.04566l-0.00176,0zm-20.91715,22.0638l2.16687,1.60145c-0.93418,0.91311 -1.81743,1.77353 -2.45485,2.38812l0.28798,-3.98957',
  mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
  color: '#37aee2'
});

/* unused harmony default export */ var _unused_webpack_default_export = (TelegramIcon);

/***/ }),

/***/ "./node_modules/react-share/es/TelegramShareButton.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__("./node_modules/assert/assert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__("./node_modules/react-share/es/utils/createShareButton.js");







function telegramLink(url, _ref) {
  var title = _ref.title;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'telegram.url');

  return 'https://telegram.me/share/' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    text: title
  });
}

var TelegramShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('telegram', telegramLink, function (props) {
  return {
    title: props.title,
    via: props.via
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  via: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

/* unused harmony default export */ var _unused_webpack_default_export = (TelegramShareButton);

/***/ }),

/***/ "./node_modules/react-share/es/TumblrIcon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__("./node_modules/react-share/es/utils/iconFactory.js");


var TumblrIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('tumblr', {
  icon: 'M39.2,41c-0.6,0.3-1.6,0.5-2.4,0.5c-2.4,0.1-2.9-1.7-2.9-3v-9.3h6v-4.5h-6V17c0,0-4.3,0-4.4,0 c-0.1,0-0.2,0.1-0.2,0.2c-0.3,2.3-1.4,6.4-5.9,8.1v3.9h3V39c0,3.4,2.5,8.1,9,8c2.2,0,4.7-1,5.2-1.8L39.2,41z',
  mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
  color: '#2c4762'
});

/* unused harmony default export */ var _unused_webpack_default_export = (TumblrIcon);

/***/ }),

/***/ "./node_modules/react-share/es/TumblrShareButton.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__("./node_modules/assert/assert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__("./node_modules/react-share/es/utils/createShareButton.js");







function tumblrLink(url, _ref) {
  var title = _ref.title,
      caption = _ref.caption,
      tags = _ref.tags,
      posttype = _ref.posttype;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'tumblr.url');

  return 'https://www.tumblr.com/widgets/share/tool' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    canonicalUrl: url,
    title: title,
    caption: caption,
    tags: tags,
    posttype: posttype
  });
}

var TumblrShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('tumblr', tumblrLink, function (props) {
  return {
    title: props.title,
    tags: props.tags.join(','),
    caption: props.caption,
    posttype: props.posttype
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  caption: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  posttype: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  tags: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string)
}, {
  tags: [],
  posttype: 'link',
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (TumblrShareButton);

/***/ }),

/***/ "./node_modules/react-share/es/TumblrShareCount.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__("./node_modules/jsonp/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__("./node_modules/react-share/es/utils/shareCountFactory.js");





function getTumblrShareCount(shareUrl, callback) {
  var endpoint = 'https://api.tumblr.com/v2/share/stats';

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(endpoint + Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    url: shareUrl
  }), function (err, data) {
    callback(data ? data.note_count : undefined);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getTumblrShareCount));

/***/ }),

/***/ "./node_modules/react-share/es/TwitterIcon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__("./node_modules/react-share/es/utils/iconFactory.js");


var TwitterIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('twitter', {
  icon: 'M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z',
  mask: 'M0,0v64h64V0H0z M44.7,25.5c0,0.3,0,0.6,0,0.8C44.7,35,38.1,45,26.1,45c-3.7,0-7.2-1.1-10.1-2.9 c0.5,0.1,1,0.1,1.6,0.1c3.1,0,5.9-1,8.2-2.8c-2.9-0.1-5.3-2-6.1-4.6c0.4,0.1,0.8,0.1,1.2,0.1c0.6,0,1.2-0.1,1.7-0.2 c-3-0.6-5.3-3.3-5.3-6.4c0,0,0-0.1,0-0.1c0.9,0.5,1.9,0.8,3,0.8c-1.8-1.2-2.9-3.2-2.9-5.5c0-1.2,0.3-2.3,0.9-3.3 c3.2,4,8.1,6.6,13.5,6.9c-0.1-0.5-0.2-1-0.2-1.5c0-3.6,2.9-6.6,6.6-6.6c1.9,0,3.6,0.8,4.8,2.1c1.5-0.3,2.9-0.8,4.2-1.6 c-0.5,1.5-1.5,2.8-2.9,3.6c1.3-0.2,2.6-0.5,3.8-1C47.1,23.4,46,24.5,44.7,25.5z',
  color: '#00aced'
});

/* harmony default export */ __webpack_exports__["a"] = (TwitterIcon);

/***/ }),

/***/ "./node_modules/react-share/es/TwitterShareButton.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__("./node_modules/assert/assert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__("./node_modules/react-share/es/utils/createShareButton.js");







function twitterLink(url, _ref) {
  var title = _ref.title,
      via = _ref.via,
      _ref$hashtags = _ref.hashtags,
      hashtags = _ref$hashtags === undefined ? [] : _ref$hashtags;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'twitter.url');
  __WEBPACK_IMPORTED_MODULE_1_assert___default()(Array.isArray(hashtags), 'twitter.hashtags is not an array');

  return 'https://twitter.com/share' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    text: title,
    via: via,
    hashtags: hashtags.join(',')
  });
}

var TwitterShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('twitter', twitterLink, function (props) {
  return {
    hashtags: props.hashtags,
    title: props.title,
    via: props.via
  };
}, {
  hashtags: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string),
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  via: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

/* harmony default export */ __webpack_exports__["a"] = (TwitterShareButton);

/***/ }),

/***/ "./node_modules/react-share/es/VKIcon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__("./node_modules/react-share/es/utils/iconFactory.js");


var VKIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('vk', {
  icon: 'M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
  mask: 'M0,0v64h64V0H0z M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
  color: '#45668e'
});

/* unused harmony default export */ var _unused_webpack_default_export = (VKIcon);

/***/ }),

/***/ "./node_modules/react-share/es/VKShareButton.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__("./node_modules/assert/assert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__("./node_modules/react-share/es/utils/createShareButton.js");







function vkLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description,
      image = _ref.image;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'vk.url');

  return 'https://vk.com/share.php' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    description: description,
    image: image
  });
}

var VKShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('vk', vkLink, function (props) {
  return {
    title: props.title,
    description: props.description,
    image: props.image
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (VKShareButton);

/***/ }),

/***/ "./node_modules/react-share/es/VKShareCount.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__("./node_modules/jsonp/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__("./node_modules/react-share/es/utils/shareCountFactory.js");





function getVKShareCount(shareUrl, callback) {
  if (!window.VK) {
    window.VK = {
      Share: {
        count: function count(index, _count) {
          return window.VK.callbacks[index](_count);
        }
      },
      callbacks: []
    };
  }

  var url = 'https://vk.com/share.php';
  var index = window.VK.callbacks.length;

  window.VK.callbacks.push(callback);

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url + Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    act: 'count',
    index: index,
    url: shareUrl
  }));
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getVKShareCount));

/***/ }),

/***/ "./node_modules/react-share/es/ViberIcon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__("./node_modules/react-share/es/utils/iconFactory.js");


var ViberIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('viber', {
  icon: 'm31.0,12.3c9.0,0.2 16.4,6.2 18.0,15.2c0.2,1.5 0.3,3.0 0.4,4.6a1.0,1.0 0 0 1 -0.8,1.2l-0.1,0a1.1,1.1 0 0 1 -1.0,-1.2l0,0c-0.0,-1.2 -0.1,-2.5 -0.3,-3.8a16.1,16.1 0 0 0 -13.0,-13.5c-1.0,-0.1 -2.0,-0.2 -3.0,-0.3c-0.6,-0.0 -1.4,-0.1 -1.6,-0.8a1.1,1.1 0 0 1 0.9,-1.2l0.6,0l0.0,-0.0zm10.6,39.2a19.9,19.9 0 0 1 -2.1,-0.6c-6.9,-2.9 -13.2,-6.6 -18.3,-12.2a47.5,47.5 0 0 1 -7.0,-10.7c-0.8,-1.8 -1.6,-3.7 -2.4,-5.6c-0.6,-1.7 0.3,-3.4 1.4,-4.7a11.3,11.3 0 0 1 3.7,-2.8a2.4,2.4 0 0 1 3.0,0.7a39.0,39.0 0 0 1 4.7,6.5a3.1,3.1 0 0 1 -0.8,4.2c-0.3,0.2 -0.6,0.5 -1.0,0.8a3.3,3.3 0 0 0 -0.7,0.7a2.1,2.1 0 0 0 -0.1,1.9c1.7,4.9 4.7,8.7 9.7,10.8a5.0,5.0 0 0 0 2.5,0.6c1.5,-0.1 2.0,-1.8 3.1,-2.7a2.9,2.9 0 0 1 3.5,-0.1c1.1,0.7 2.2,1.4 3.3,2.2a37.8,37.8 0 0 1 3.1,2.4a2.4,2.4 0 0 1 0.7,3.0a10.4,10.4 0 0 1 -4.4,4.8a10.8,10.8 0 0 1 -1.9,0.6c-0.7,-0.2 0.6,-0.2 0,0l0.0,0l0,-0.0zm3.1,-21.4a4.2,4.2 0 0 1 -0.0,0.6a1.0,1.0 0 0 1 -1.9,0.1a2.7,2.7 0 0 1 -0.1,-0.8a10.9,10.9 0 0 0 -1.4,-5.5a10.2,10.2 0 0 0 -4.2,-4.0a12.3,12.3 0 0 0 -3.4,-1.0c-0.5,-0.0 -1.0,-0.1 -1.5,-0.2a0.9,0.9 0 0 1 -0.9,-1.0l0,-0.1a0.9,0.9 0 0 1 0.9,-0.9l0.1,0a14.1,14.1 0 0 1 5.9,1.5a11.9,11.9 0 0 1 6.5,9.3c0,0.1 0.0,0.3 0.0,0.5c0,0.4 0.0,0.9 0.0,1.5l0,0l0.0,0.0zm-5.6,-0.2a1.1,1.1 0 0 1 -1.2,-0.9l0,-0.1a11.3,11.3 0 0 0 -0.2,-1.4a4.0,4.0 0 0 0 -1.5,-2.3a3.9,3.9 0 0 0 -1.2,-0.5c-0.5,-0.1 -1.1,-0.1 -1.6,-0.2a1.0,1.0 0 0 1 -0.8,-1.1l0,0l0,0a1.0,1.0 0 0 1 1.1,-0.8c3.4,0.2 6.0,2.0 6.3,6.2a2.8,2.8 0 0 1 0,0.8a0.8,0.8 0 0 1 -0.8,0.7l0,0l0.0,-0.0z',
  mask: '',
  color: '#7C529E'
});

/* unused harmony default export */ var _unused_webpack_default_export = (ViberIcon);

/***/ }),

/***/ "./node_modules/react-share/es/ViberShareButton.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__("./node_modules/assert/assert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__("./node_modules/react-share/es/utils/createShareButton.js");







function viberLink(url, _ref) {
  var title = _ref.title;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'viber.url');
  return 'viber://forward' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    text: (title || '') + ' ' + url
  });
}

var ViberShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('viber', viberLink, function (props) {
  return {
    title: props.title
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (ViberShareButton);

/***/ }),

/***/ "./node_modules/react-share/es/WeiboShareButton.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__("./node_modules/assert/assert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__("./node_modules/react-share/es/utils/createShareButton.js");







function weiboLink(url, _ref) {
  var title = _ref.title,
      image = _ref.image;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'weibo.url');
  __WEBPACK_IMPORTED_MODULE_1_assert___default()(image, 'weibo.image');

  return 'http://service.weibo.com/share/share.php?' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    pic: image
  });
}

var WeiboShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('weibo', weiboLink, function (props) {
  return {
    title: props.title,
    image: props.image
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

/* unused harmony default export */ var _unused_webpack_default_export = (WeiboShareButton);

/***/ }),

/***/ "./node_modules/react-share/es/WhatsappIcon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__("./node_modules/react-share/es/utils/iconFactory.js");


var WhatsappIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('whatsapp', {
  icon: 'm42.32286,33.93287c-0.5178,-0.2589 -3.04726,-1.49644 -3.52105,-1.66732c-0.4712,-0.17346 -0.81554,-0.2589 -1.15987,0.2589c-0.34175,0.51004 -1.33075,1.66474 -1.63108,2.00648c-0.30032,0.33658 -0.60064,0.36247 -1.11327,0.12945c-0.5178,-0.2589 -2.17994,-0.80259 -4.14759,-2.56312c-1.53269,-1.37217 -2.56312,-3.05503 -2.86603,-3.57283c-0.30033,-0.5178 -0.03366,-0.80259 0.22524,-1.06149c0.23301,-0.23301 0.5178,-0.59547 0.7767,-0.90616c0.25372,-0.31068 0.33657,-0.5178 0.51262,-0.85437c0.17088,-0.36246 0.08544,-0.64725 -0.04402,-0.90615c-0.12945,-0.2589 -1.15987,-2.79613 -1.58964,-3.80584c-0.41424,-1.00971 -0.84142,-0.88027 -1.15987,-0.88027c-0.29773,-0.02588 -0.64208,-0.02588 -0.98382,-0.02588c-0.34693,0 -0.90616,0.12945 -1.37736,0.62136c-0.4712,0.5178 -1.80194,1.76053 -1.80194,4.27186c0,2.51134 1.84596,4.945 2.10227,5.30747c0.2589,0.33657 3.63497,5.51458 8.80262,7.74113c1.23237,0.5178 2.1903,0.82848 2.94111,1.08738c1.23237,0.38836 2.35599,0.33657 3.24402,0.20712c0.99159,-0.15534 3.04985,-1.24272 3.47963,-2.45956c0.44013,-1.21683 0.44013,-2.22654 0.31068,-2.45955c-0.12945,-0.23301 -0.46601,-0.36247 -0.98382,-0.59548m-9.40068,12.84407l-0.02589,0c-3.05503,0 -6.08417,-0.82849 -8.72495,-2.38189l-0.62136,-0.37023l-6.47252,1.68286l1.73463,-6.29129l-0.41424,-0.64725c-1.70875,-2.71846 -2.6149,-5.85116 -2.6149,-9.07706c0,-9.39809 7.68934,-17.06155 17.15993,-17.06155c4.58253,0 8.88029,1.78642 12.11655,5.02268c3.23625,3.21036 5.02267,7.50812 5.02267,12.06476c-0.0078,9.3981 -7.69712,17.06155 -17.14699,17.06155m14.58906,-31.58846c-3.93529,-3.80584 -9.1133,-5.95471 -14.62789,-5.95471c-11.36055,0 -20.60848,9.2065 -20.61625,20.52564c0,3.61684 0.94757,7.14565 2.75211,10.26282l-2.92557,10.63564l10.93337,-2.85309c3.0136,1.63108 6.4052,2.4958 9.85634,2.49839l0.01037,0c11.36574,0 20.61884,-9.2091 20.62403,-20.53082c0,-5.48093 -2.14111,-10.64081 -6.03239,-14.51915',
  mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
  color: '#2cb742'
});

/* unused harmony default export */ var _unused_webpack_default_export = (WhatsappIcon);

/***/ }),

/***/ "./node_modules/react-share/es/WhatsappShareButton.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__("./node_modules/assert/assert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__("./node_modules/react-share/es/utils/createShareButton.js");







function whatsappLink(url, _ref) {
  var title = _ref.title,
      separator = _ref.separator;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'whatsapp.url');
  return 'https://api.whatsapp.com/send' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    text: title ? title + separator + url : url
  });
}

var WhatsappShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('whatsapp', whatsappLink, function (props) {
  return {
    title: props.title,
    separator: props.separator
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  separator: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  separator: ' ',
  windowWidth: 550,
  windowHeight: 400
});

/* unused harmony default export */ var _unused_webpack_default_export = (WhatsappShareButton);

/***/ }),

/***/ "./node_modules/react-share/es/WorkplaceIcon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__("./node_modules/react-share/es/utils/iconFactory.js");


var WorkplaceIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('workplace', {
  icon: 'M34.019,10.292c0.21,0.017,0.423,0.034,0.636,0.049 c3.657,0.262,6.976,1.464,9.929,3.635c3.331,2.448,5.635,5.65,6.914,9.584c0.699,2.152,0.983,4.365,0.885,6.623 c-0.136,3.171-1.008,6.13-2.619,8.867c-0.442,0.75-0.908,1.492-1.495,2.141c-0.588,0.651-1.29,1.141-2.146,1.383 c-1.496,0.426-3.247-0.283-3.961-1.642c-0.26-0.494-0.442-1.028-0.654-1.548c-1.156-2.838-2.311-5.679-3.465-8.519 c-0.017-0.042-0.037-0.082-0.065-0.145c-0.101,0.245-0.192,0.472-0.284,0.698c-1.237,3.051-2.475,6.103-3.711,9.155 c-0.466,1.153-1.351,1.815-2.538,2.045c-1.391,0.267-2.577-0.154-3.496-1.247c-0.174-0.209-0.31-0.464-0.415-0.717 c-2.128-5.22-4.248-10.442-6.37-15.665c-0.012-0.029-0.021-0.059-0.036-0.104c0.054-0.003,0.103-0.006,0.15-0.006 c1.498-0.001,2.997,0,4.495-0.004c0.12-0.001,0.176,0.03,0.222,0.146c1.557,3.846,3.117,7.691,4.679,11.536 c0.018,0.046,0.039,0.091,0.067,0.159c0.273-0.673,0.536-1.32,0.797-1.968c1.064-2.627,2.137-5.25,3.19-7.883 c0.482-1.208,1.376-1.917,2.621-2.135c1.454-0.255,2.644,0.257,3.522,1.449c0.133,0.18,0.229,0.393,0.313,0.603 c1.425,3.495,2.848,6.991,4.269,10.488c0.02,0.047,0.04,0.093,0.073,0.172c0.196-0.327,0.385-0.625,0.559-0.935 c0.783-1.397,1.323-2.886,1.614-4.461c0.242-1.312,0.304-2.634,0.187-3.962c-0.242-2.721-1.16-5.192-2.792-7.38 c-2.193-2.939-5.086-4.824-8.673-5.625c-1.553-0.346-3.124-0.405-4.705-0.257c-3.162,0.298-6.036,1.366-8.585,3.258 c-3.414,2.534-5.638,5.871-6.623,10.016c-0.417,1.76-0.546,3.547-0.384,5.348c0.417,4.601,2.359,8.444,5.804,11.517 c2.325,2.073,5.037,3.393,8.094,3.989c1.617,0.317,3.247,0.395,4.889,0.242c1-0.094,1.982-0.268,2.952-0.529 c0.04-0.01,0.081-0.018,0.128-0.028c0,1.526,0,3.047,0,4.586c-0.402,0.074-0.805,0.154-1.21,0.221 c-0.861,0.14-1.728,0.231-2.601,0.258c-0.035,0.002-0.071,0.013-0.108,0.021c-0.493,0-0.983,0-1.476,0 c-0.049-0.007-0.1-0.018-0.149-0.022c-0.315-0.019-0.629-0.033-0.945-0.058c-1.362-0.105-2.702-0.346-4.017-0.716 c-3.254-0.914-6.145-2.495-8.66-4.752c-2.195-1.971-3.926-4.29-5.176-6.963c-1.152-2.466-1.822-5.057-1.993-7.774 c-0.014-0.226-0.033-0.451-0.05-0.676c0-0.502,0-1.003,0-1.504c0.008-0.049,0.02-0.099,0.022-0.148 c0.036-1.025,0.152-2.043,0.338-3.052c0.481-2.616,1.409-5.066,2.8-7.331c2.226-3.625,5.25-6.386,9.074-8.254 c2.536-1.24,5.217-1.947,8.037-2.126c0.23-0.015,0.461-0.034,0.691-0.051C33.052,10.292,33.535,10.292,34.019,10.292z',
  color: '#3b3d4a'
});

/* unused harmony default export */ var _unused_webpack_default_export = (WorkplaceIcon);

/***/ }),

/***/ "./node_modules/react-share/es/WorkplaceShareButton.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__("./node_modules/assert/assert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__("./node_modules/react-share/es/utils/objectToGetParams.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__("./node_modules/react-share/es/utils/createShareButton.js");







function workplaceLink(url, _ref) {
  var quote = _ref.quote,
      hashtag = _ref.hashtag;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'workplace.url');

  return 'https://work.facebook.com/sharer.php' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    u: url,
    quote: quote,
    hashtag: hashtag
  });
}

var WorkplaceShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('workplace', workplaceLink, function (props) {
  return {
    quote: props.quote,
    hashtag: props.hashtag
  };
}, {
  quote: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  hashtag: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

/* unused harmony default export */ var _unused_webpack_default_export = (WorkplaceShareButton);

/***/ }),

/***/ "./node_modules/react-share/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FacebookShareCount__ = __webpack_require__("./node_modules/react-share/es/FacebookShareCount.js");
/* unused harmony reexport FacebookShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GooglePlusShareCount__ = __webpack_require__("./node_modules/react-share/es/GooglePlusShareCount.js");
/* unused harmony reexport GooglePlusShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LinkedinShareCount__ = __webpack_require__("./node_modules/react-share/es/LinkedinShareCount.js");
/* unused harmony reexport LinkedinShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PinterestShareCount__ = __webpack_require__("./node_modules/react-share/es/PinterestShareCount.js");
/* unused harmony reexport PinterestShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VKShareCount__ = __webpack_require__("./node_modules/react-share/es/VKShareCount.js");
/* unused harmony reexport VKShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OKShareCount__ = __webpack_require__("./node_modules/react-share/es/OKShareCount.js");
/* unused harmony reexport OKShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RedditShareCount__ = __webpack_require__("./node_modules/react-share/es/RedditShareCount.js");
/* unused harmony reexport RedditShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TumblrShareCount__ = __webpack_require__("./node_modules/react-share/es/TumblrShareCount.js");
/* unused harmony reexport TumblrShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FacebookShareButton__ = __webpack_require__("./node_modules/react-share/es/FacebookShareButton.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__FacebookShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GooglePlusShareButton__ = __webpack_require__("./node_modules/react-share/es/GooglePlusShareButton.js");
/* unused harmony reexport GooglePlusShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LinkedinShareButton__ = __webpack_require__("./node_modules/react-share/es/LinkedinShareButton.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_10__LinkedinShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TwitterShareButton__ = __webpack_require__("./node_modules/react-share/es/TwitterShareButton.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_11__TwitterShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PinterestShareButton__ = __webpack_require__("./node_modules/react-share/es/PinterestShareButton.js");
/* unused harmony reexport PinterestShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__VKShareButton__ = __webpack_require__("./node_modules/react-share/es/VKShareButton.js");
/* unused harmony reexport VKShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__OKShareButton__ = __webpack_require__("./node_modules/react-share/es/OKShareButton.js");
/* unused harmony reexport OKShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TelegramShareButton__ = __webpack_require__("./node_modules/react-share/es/TelegramShareButton.js");
/* unused harmony reexport TelegramShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__WhatsappShareButton__ = __webpack_require__("./node_modules/react-share/es/WhatsappShareButton.js");
/* unused harmony reexport WhatsappShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__RedditShareButton__ = __webpack_require__("./node_modules/react-share/es/RedditShareButton.js");
/* unused harmony reexport RedditShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__EmailShareButton__ = __webpack_require__("./node_modules/react-share/es/EmailShareButton.js");
/* unused harmony reexport EmailShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__TumblrShareButton__ = __webpack_require__("./node_modules/react-share/es/TumblrShareButton.js");
/* unused harmony reexport TumblrShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__LivejournalShareButton__ = __webpack_require__("./node_modules/react-share/es/LivejournalShareButton.js");
/* unused harmony reexport LivejournalShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__MailruShareButton__ = __webpack_require__("./node_modules/react-share/es/MailruShareButton.js");
/* unused harmony reexport MailruShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ViberShareButton__ = __webpack_require__("./node_modules/react-share/es/ViberShareButton.js");
/* unused harmony reexport ViberShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__WorkplaceShareButton__ = __webpack_require__("./node_modules/react-share/es/WorkplaceShareButton.js");
/* unused harmony reexport WorkplaceShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__LineShareButton__ = __webpack_require__("./node_modules/react-share/es/LineShareButton.js");
/* unused harmony reexport LineShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__WeiboShareButton__ = __webpack_require__("./node_modules/react-share/es/WeiboShareButton.js");
/* unused harmony reexport WeiboShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__FacebookIcon__ = __webpack_require__("./node_modules/react-share/es/FacebookIcon.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_26__FacebookIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__TwitterIcon__ = __webpack_require__("./node_modules/react-share/es/TwitterIcon.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_27__TwitterIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__GooglePlusIcon__ = __webpack_require__("./node_modules/react-share/es/GooglePlusIcon.js");
/* unused harmony reexport GooglePlusIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__LinkedinIcon__ = __webpack_require__("./node_modules/react-share/es/LinkedinIcon.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_29__LinkedinIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__PinterestIcon__ = __webpack_require__("./node_modules/react-share/es/PinterestIcon.js");
/* unused harmony reexport PinterestIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__VKIcon__ = __webpack_require__("./node_modules/react-share/es/VKIcon.js");
/* unused harmony reexport VKIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__OKIcon__ = __webpack_require__("./node_modules/react-share/es/OKIcon.js");
/* unused harmony reexport OKIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__TelegramIcon__ = __webpack_require__("./node_modules/react-share/es/TelegramIcon.js");
/* unused harmony reexport TelegramIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__WhatsappIcon__ = __webpack_require__("./node_modules/react-share/es/WhatsappIcon.js");
/* unused harmony reexport WhatsappIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__RedditIcon__ = __webpack_require__("./node_modules/react-share/es/RedditIcon.js");
/* unused harmony reexport RedditIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__TumblrIcon__ = __webpack_require__("./node_modules/react-share/es/TumblrIcon.js");
/* unused harmony reexport TumblrIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__MailruIcon__ = __webpack_require__("./node_modules/react-share/es/MailruIcon.js");
/* unused harmony reexport MailruIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__EmailIcon__ = __webpack_require__("./node_modules/react-share/es/EmailIcon.js");
/* unused harmony reexport EmailIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__LivejournalIcon__ = __webpack_require__("./node_modules/react-share/es/LivejournalIcon.js");
/* unused harmony reexport LivejournalIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__ViberIcon__ = __webpack_require__("./node_modules/react-share/es/ViberIcon.js");
/* unused harmony reexport ViberIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__WorkplaceIcon__ = __webpack_require__("./node_modules/react-share/es/WorkplaceIcon.js");
/* unused harmony reexport WorkplaceIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__LineIcon__ = __webpack_require__("./node_modules/react-share/es/LineIcon.js");
/* unused harmony reexport LineIcon */














































/***/ }),

/***/ "./node_modules/react-share/es/utils/createShareButton.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof__ = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ieDetection__ = __webpack_require__("./node_modules/react-share/es/utils/ieDetection.js");














var isPromise = function isPromise(obj) {
  return !!obj && ((typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(obj)) === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
};

function windowOpen(url, _ref, onShareWindowClose) {
  var name = _ref.name,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 400 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 550 : _ref$width;

  /* eslint-disable no-mixed-operators */
  var left = window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2;
  var top = window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2;
  /* eslint-enable no-mixed-operators */

  var config = {
    height: height,
    width: width,
    left: left,
    top: top,
    location: 'no',
    toolbar: 'no',
    status: 'no',
    directories: 'no',
    menubar: 'no',
    scrollbars: 'yes',
    resizable: 'no',
    centerscreen: 'yes',
    chrome: 'yes'
  };

  var shareDialog = window.open(url, Object(__WEBPACK_IMPORTED_MODULE_11__ieDetection__["a" /* default */])(10) ? '' : name, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(config).map(function (key) {
    return key + '=' + config[key];
  }).join(', '));

  if (onShareWindowClose) {
    var interval = window.setInterval(function () {
      try {
        if (shareDialog === null || shareDialog.closed) {
          window.clearInterval(interval);
          onShareWindowClose(shareDialog);
        }
      } catch (e) {
        /* eslint-disable no-console */
        console.error(e);
        /* eslint-enable no-console */
      }
    }, 1000);
  }

  return shareDialog;
}

var ShareButton = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ShareButton, _PureComponent);

  function ShareButton() {
    var _ref2;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ShareButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref2 = ShareButton.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ShareButton)).call.apply(_ref2, [this].concat(args))), _this), _this.onClick = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          openWindow = _this$props.openWindow,
          beforeOnClick = _this$props.beforeOnClick;


      if (disabled) {
        return;
      }

      e.preventDefault();

      var link = _this.link();

      var clickHandler = openWindow ? function () {
        return _this.openWindow(link);
      } : function () {
        return onClick(link);
      };

      if (beforeOnClick) {
        var returnVal = beforeOnClick();

        if (isPromise(returnVal)) {
          returnVal.then(clickHandler);
        } else {
          clickHandler();
        }
      } else {
        clickHandler();
      }
    }, _this.onKeyPress = function (e) {
      if (e.key === 'Enter' || e.key === 13 || e.key === ' ' || e.key === 32) {
        _this.onClick(e);
      }
    }, _this.openWindow = function (link) {
      var _this$props2 = _this.props,
          onShareWindowClose = _this$props2.onShareWindowClose,
          windowWidth = _this$props2.windowWidth,
          windowHeight = _this$props2.windowHeight;


      var windowOptions = {
        height: windowHeight,
        width: windowWidth
      };

      windowOpen(link, windowOptions, onShareWindowClose);
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ShareButton, [{
    key: 'link',
    value: function link() {
      var _props = this.props,
          url = _props.url,
          opts = _props.opts,
          networkLink = _props.networkLink;

      return networkLink(url, opts);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          additionalProps = _props2.additionalProps,
          children = _props2.children,
          className = _props2.className,
          disabled = _props2.disabled,
          disabledStyle = _props2.disabledStyle,
          name = _props2.name,
          network = _props2.network,
          role = _props2.role,
          style = _props2.style,
          tabIndex = _props2.tabIndex;


      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()('SocialMediaShareButton', 'SocialMediaShareButton--' + network, {
        'SocialMediaShareButton--disabled': !!disabled,
        disabled: !!disabled
      }, className);

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        'div',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          name: name
        }, additionalProps, {
          role: role,
          tabIndex: tabIndex,
          onClick: this.onClick,
          onKeyPress: this.onKeyPress,
          className: classes,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, disabled ? disabledStyle : {}) }),
        children
      );
    }
  }]);

  return ShareButton;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

ShareButton.propTypes = {
  additionalProps: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  disabledStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
  name: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
  network: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
  networkLink: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  opts: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
  openWindow: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  url: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
  role: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
  windowWidth: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  windowHeight: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  beforeOnClick: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  onShareWindowClose: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  tabIndex: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number])
};
ShareButton.defaultProps = {
  disabledStyle: {
    opacity: 0.6
  },
  openWindow: true,
  role: 'button',
  tabIndex: '0'
};


function createShareButton(network, link) {
  var optsMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return {};
  };
  var propTypes = arguments[3];
  var defaultProps = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  var CreatedButton = function CreatedButton(props) {
    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ShareButton, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      network: network,
      networkLink: link,
      opts: optsMap(props) }));
  };

  CreatedButton.propTypes = propTypes;
  CreatedButton.defaultProps = defaultProps;

  return CreatedButton;
}

/* harmony default export */ __webpack_exports__["a"] = (createShareButton);

/***/ }),

/***/ "./node_modules/react-share/es/utils/iconFactory.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = iconFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



function iconFactory(network, iconConfig) {
  var Icon = function Icon(props) {
    var className = props.className,
        iconBgStyle = props.iconBgStyle,
        logoFillColor = props.logoFillColor,
        round = props.round,
        size = props.size;


    var baseStyle = {
      width: size,
      height: size
    };

    var classes = 'social-icon social-icon--' + network + ' ' + className;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: baseStyle },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        {
          viewBox: '0 0 64 64',
          width: size,
          height: size,
          className: classes },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          !round ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', {
            width: '64',
            height: '64',
            fill: iconConfig.color,
            style: iconBgStyle }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', {
            cx: '32',
            cy: '32',
            r: '31',
            fill: iconConfig.color,
            style: iconBgStyle })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: iconConfig.icon, fill: logoFillColor })
        )
      )
    );
  };

  Icon.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    iconBgStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    logoFillColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    round: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  };

  Icon.defaultProps = {
    className: '',
    iconBgStyle: {},
    logoFillColor: 'white',
    size: 64
  };

  return Icon;
}

/***/ }),

/***/ "./node_modules/react-share/es/utils/ieDetection.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isInternetExplorerBefore;
/*
 * This detection method identifies Internet Explorers up until version 11.
 *
 * Reference: https://msdn.microsoft.com/en-us/library/ms537503(v=vs.85).aspx
 */
function isInternetExplorerBefore(version) {
  var iematch = /MSIE ([0-9]+)/g.exec(window.navigator.userAgent);

  return iematch ? +iematch[1] < version : false;
}

/***/ }),

/***/ "./node_modules/react-share/es/utils/objectToGetParams.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = objectToGetParams;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/* eslint-disable prefer-template */
function objectToGetParams(object) {
  return '?' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(object).filter(function (key) {
    return !!object[key];
  }).map(function (key) {
    return key + '=' + encodeURIComponent(object[key]);
  }).join('&');
}
/* eslint-enable prefer-template */

/***/ }),

/***/ "./node_modules/react-share/es/utils/shareCountFactory.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shareCountFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);










var SocialMediaShareCount = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SocialMediaShareCount, _Component);

  function SocialMediaShareCount(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SocialMediaShareCount);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SocialMediaShareCount.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SocialMediaShareCount)).call(this, props));

    _this._isMounted = false;
    _this.state = { count: 0 };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SocialMediaShareCount, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
      this.updateCount(this.props.url);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.url !== this.props.url) {
        this.updateCount(nextProps.url);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: 'updateCount',
    value: function updateCount(url) {
      var _this2 = this;

      if (this.props.getCount) {
        this.setState({
          isLoading: true
        });

        this.props.getCount(url, function (count) {
          if (_this2._isMounted) {
            _this2.setState({
              count: count,
              isLoading: false
            });
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          count = _state.count,
          isLoading = _state.isLoading;
      var _props = this.props,
          children = _props.children,
          className = _props.className;


      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('SocialMediaShareCount', className) },
        !isLoading && children(count || 0)
      );
    }
  }]);

  return SocialMediaShareCount;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

SocialMediaShareCount.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  getCount: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  url: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired
};

SocialMediaShareCount.defaultProps = {
  children: function children(shareCount) {
    return shareCount;
  }
};

function shareCountFactory(getCount) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SocialMediaShareCount, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ getCount: getCount }, props));
  };
}

/***/ }),

/***/ "./node_modules/react-slick/lib/arrows.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NextArrow = exports.PrevArrow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__("./node_modules/react-slick/lib/utils/innerSliderUtils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  PrevArrow.prototype.render = function render() {
    var prevClasses = { "slick-arrow": true, "slick-prev": true };
    var prevHandler = this.clickHandler.bind(this, { message: "previous" });

    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
      prevClasses["slick-disabled"] = true;
      prevHandler = null;
    }

    var prevArrowProps = {
      key: "0",
      "data-role": "none",
      className: (0, _classnames2.default)(prevClasses),
      style: { display: "block" },
      onClick: prevHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var prevArrow = void 0;

    if (this.props.prevArrow) {
      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
    } else {
      prevArrow = _react2.default.createElement(
        "button",
        _extends({ key: "0", type: "button" }, prevArrowProps),
        " ",
        "Previous"
      );
    }

    return prevArrow;
  };

  return PrevArrow;
}(_react2.default.PureComponent);

var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
  }

  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  NextArrow.prototype.render = function render() {
    var nextClasses = { "slick-arrow": true, "slick-next": true };
    var nextHandler = this.clickHandler.bind(this, { message: "next" });

    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
      nextClasses["slick-disabled"] = true;
      nextHandler = null;
    }

    var nextArrowProps = {
      key: "1",
      "data-role": "none",
      className: (0, _classnames2.default)(nextClasses),
      style: { display: "block" },
      onClick: nextHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var nextArrow = void 0;

    if (this.props.nextArrow) {
      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
    } else {
      nextArrow = _react2.default.createElement(
        "button",
        _extends({ key: "1", type: "button" }, nextArrowProps),
        " ",
        "Next"
      );
    }

    return nextArrow;
  };

  return NextArrow;
}(_react2.default.PureComponent);

/***/ }),

/***/ "./node_modules/react-slick/lib/default-props.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return _react2.default.createElement(
      "ul",
      { style: { display: "block" } },
      dots
    );
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return _react2.default.createElement(
      "button",
      null,
      i + 1
    );
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};

exports.default = defaultProps;

/***/ }),

/***/ "./node_modules/react-slick/lib/dots.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Dots = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = exports.Dots = function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Dots.prototype.clickHandler = function clickHandler(options, e) {
    // In Autoplay the focus stays on clicked button even after transition
    // to next slide. That only goes away by click somewhere outside
    e.preventDefault();
    this.props.clickHandler(options);
  };

  Dots.prototype.render = function render() {
    var _this2 = this;

    var dotCount = getDotCount({
      slideCount: this.props.slideCount,
      slidesToScroll: this.props.slidesToScroll,
      slidesToShow: this.props.slidesToShow,
      infinite: this.props.infinite
    });

    // Apply join & split to Array to pre-fill it for IE8
    //
    // Credit: http://stackoverflow.com/a/13735425/1849458
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
      var leftBound = i * _this2.props.slidesToScroll;
      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
      var className = (0, _classnames2.default)({
        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
      });

      var dotOptions = {
        message: "dots",
        index: i,
        slidesToScroll: _this2.props.slidesToScroll,
        currentSlide: _this2.props.currentSlide
      };

      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
      return _react2.default.createElement(
        "li",
        { key: i, className: className },
        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
      );
    });

    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
      className: this.props.dotsClass
    }, mouseEvents));
  };

  return Dots;
}(_react2.default.PureComponent);

/***/ }),

/***/ "./node_modules/react-slick/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _slider = __webpack_require__("./node_modules/react-slick/lib/slider.js");

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _slider2.default;

/***/ }),

/***/ "./node_modules/react-slick/lib/initial-state.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false, // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
  trackStyle: {},
  trackWidth: 0
};

exports.default = initialState;

/***/ }),

/***/ "./node_modules/react-slick/lib/inner-slider.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InnerSlider = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _initialState = __webpack_require__("./node_modules/react-slick/lib/initial-state.js");

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = __webpack_require__("./node_modules/lodash.debounce/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__("./node_modules/react-slick/lib/utils/innerSliderUtils.js");

var _track = __webpack_require__("./node_modules/react-slick/lib/track.js");

var _dots = __webpack_require__("./node_modules/react-slick/lib/dots.js");

var _arrows = __webpack_require__("./node_modules/react-slick/lib/arrows.js");

var _resizeObserverPolyfill = __webpack_require__("./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js");

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InnerSlider = exports.InnerSlider = function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    _classCallCheck(this, InnerSlider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.listRefHandler = function (ref) {
      return _this.list = ref;
    };

    _this.trackRefHandler = function (ref) {
      return _this.track = ref;
    };

    _this.adaptHeight = function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    };

    _this.componentWillMount = function () {
      _this.ssrInit();
      _this.props.onInit && _this.props.onInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    };

    _this.componentDidMount = function () {
      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
      _this.updateState(spec, true, function () {
        _this.adaptHeight();
        _this.props.autoplay && _this.autoPlay("update");
      });
      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }
      _this.ro = new _resizeObserverPolyfill2.default(function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });
      _this.ro.observe(_this.list);
      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });
      // To support server-side rendering
      if (!window) {
        return;
      }
      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    };

    _this.componentWillUnmount = function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }
      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }
      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });
        _this.callbackTimers = [];
      }
      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
    };

    _this.componentWillReceiveProps = function (nextProps) {
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, _this.state);
      var setTrackStyle = false;
      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var key = _ref;

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }
        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }
        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }
        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    };

    _this.componentDidUpdate = function () {
      _this.checkImagesLoad();
      _this.props.onReInit && _this.props.onReInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }
      _this.adaptHeight();
    };

    _this.onWindowResized = function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash2.default)(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);
      _this.debouncedResize();
    };

    _this.resizeWindow = function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!_reactDom2.default.findDOMNode(_this.track)) return;
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, _this.state);
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      });
      // animating state should be cleared while resizing, otherwise autoplay stops working
      _this.setState({
        animating: false
      });
      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    };

    _this.updateState = function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _extends({}, spec, { left: targetLeft });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }
      _this.setState(updatedState, callback);
    };

    _this.ssrInit = function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });
        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }
        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }
        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }
        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };
        if (_this.props.centerMode) {
          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
        }
        _this.setState({
          trackStyle: _trackStyle
        });
        return;
      }
      var childrenCount = _react2.default.Children.count(_this.props.children);
      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }
      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    };

    _this.checkImagesLoad = function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };
        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;
          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }
        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();
              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;
            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    };

    _this.progressiveLazyLoad = function () {
      var slidesToLoad = [];
      var spec = _extends({}, _this.props, _this.state);
      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }
      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }
      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });
        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    };

    _this.slideHandler = function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange;
      // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
        index: index
      }, _this.props, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({ animating: animating });
            }, 10));
            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    };

    _this.changeSlide = function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _extends({}, _this.props, _this.state);
      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;
      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    };

    _this.clickHandler = function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }
      _this.clickable = true;
    };

    _this.keyHandler = function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({ message: dir });
    };

    _this.selectHandler = function (options) {
      _this.changeSlide(options);
    };

    _this.disableBodyScroll = function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };
      window.ontouchmove = preventDefault;
    };

    _this.enableBodyScroll = function () {
      window.ontouchmove = null;
    };

    _this.swipeStart = function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }
      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    };

    _this.swipeMove = function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      if (state["swiping"]) {
        _this.clickable = false;
      }
      _this.setState(state);
    };

    _this.swipeEnd = function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];
      _this.setState(state);
      if (triggerSlideHandler === undefined) return;
      _this.slideHandler(triggerSlideHandler);
      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    };

    _this.slickPrev = function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "previous" });
      }, 0));
    };

    _this.slickNext = function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "next" });
      }, 0));
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      slide = Number(slide);
      if (isNaN(slide)) return "";
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    };

    _this.play = function () {
      var nextIndex;
      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    };

    _this.autoPlay = function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      var autoplaying = _this.state.autoplaying;
      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }
      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
      _this.setState({ autoplaying: "playing" });
    };

    _this.pause = function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }
      var autoplaying = _this.state.autoplaying;
      if (pauseType === "paused") {
        _this.setState({ autoplaying: "paused" });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({ autoplaying: "focused" });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({ autoplaying: "hovered" });
        }
      }
    };

    _this.onDotsOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onDotsLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onTrackOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onTrackLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onSlideFocus = function () {
      return _this.props.autoplay && _this.pause("focused");
    };

    _this.onSlideBlur = function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    };

    _this.render = function () {
      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });
      var spec = _extends({}, _this.props, _this.state);
      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;

      trackProps = _extends({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });

      var dots;
      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;

        dotProps = _extends({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = _react2.default.createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };

      var innerSliderProps = {
        className: className,
        dir: "ltr"
      };

      if (_this.props.unslick) {
        listProps = { className: "slick-list" };
        innerSliderProps = { className: className };
      }
      return _react2.default.createElement(
        "div",
        innerSliderProps,
        !_this.props.unslick ? prevArrow : "",
        _react2.default.createElement(
          "div",
          _extends({ ref: _this.listRefHandler }, listProps),
          _react2.default.createElement(
            _track.Track,
            _extends({ ref: _this.trackRefHandler }, trackProps),
            _this.props.children
          )
        ),
        !_this.props.unslick ? nextArrow : "",
        !_this.props.unslick ? dots : ""
      );
    };

    _this.list = null;
    _this.track = null;
    _this.state = _extends({}, _initialState2.default, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react2.default.Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react2.default.Component);

/***/ }),

/***/ "./node_modules/react-slick/lib/slider.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _innerSlider = __webpack_require__("./node_modules/react-slick/lib/inner-slider.js");

var _json2mq = __webpack_require__("./node_modules/json2mq/index.js");

var _json2mq2 = _interopRequireDefault(_json2mq);

var _defaultProps = __webpack_require__("./node_modules/react-slick/lib/default-props.js");

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _innerSliderUtils = __webpack_require__("./node_modules/react-slick/lib/utils/innerSliderUtils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__("./node_modules/enquire.js/src/index.js");

var Slider = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.innerSliderRefHandler = function (ref) {
      return _this.innerSlider = ref;
    };

    _this.slickPrev = function () {
      return _this.innerSlider.slickPrev();
    };

    _this.slickNext = function () {
      return _this.innerSlider.slickNext();
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    };

    _this.slickPause = function () {
      return _this.innerSlider.pause("paused");
    };

    _this.slickPlay = function () {
      return _this.innerSlider.autoPlay("play");
    };

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  Slider.prototype.media = function media(query, handler) {
    // javascript handler for  css media query
    enquire.register(query, handler);
    this._responsiveMediaHandlers.push({ query: query, handler: handler });
  };

  // handles responsive breakpoints


  Slider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // performance monitoring
    //if (process.env.NODE_ENV !== 'production') {
    //const { whyDidYouUpdate } = require('why-did-you-update')
    //whyDidYouUpdate(React)
    //}
    if (this.props.responsive) {
      var breakpoints = this.props.responsive.map(function (breakpt) {
        return breakpt.breakpoint;
      });
      // sort them in increasing order of their numerical value
      breakpoints.sort(function (x, y) {
        return x - y;
      });

      breakpoints.forEach(function (breakpoint, index) {
        // media query for each breakpoint
        var bQuery = void 0;
        if (index === 0) {
          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
        } else {
          bQuery = (0, _json2mq2.default)({
            minWidth: breakpoints[index - 1] + 1,
            maxWidth: breakpoint
          });
        }
        // when not using server side rendering
        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
          _this2.setState({ breakpoint: breakpoint });
        });
      });

      // Register media query for full screen. Need to support resize from small to large
      // convert javascript object to media query string
      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });

      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
        _this2.setState({ breakpoint: null });
      });
    }
  };

  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
    this._responsiveMediaHandlers.forEach(function (obj) {
      enquire.unregister(obj.query, obj.handler);
    });
  };

  Slider.prototype.render = function render() {
    var _this3 = this;

    var settings;
    var newProps;
    if (this.state.breakpoint) {
      newProps = this.props.responsive.filter(function (resp) {
        return resp.breakpoint === _this3.state.breakpoint;
      });
      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
    } else {
      settings = _extends({}, _defaultProps2.default, this.props);
    }

    // force scrolling by one if centerMode is on
    if (settings.centerMode) {
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
      }
      settings.slidesToScroll = 1;
    }
    // force showing one slide and scrolling by one if the fade mode is on
    if (settings.fade) {
      if (settings.slidesToShow > 1 && "production" !== "production") {
        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
      }
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
      }
      settings.slidesToShow = 1;
      settings.slidesToScroll = 1;
    }

    // makes sure that children is an array, even when there is only 1 child
    var children = _react2.default.Children.toArray(this.props.children);

    // Children may contain false or null, so we should filter them
    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
    children = children.filter(function (child) {
      if (typeof child === "string") {
        return !!child.trim();
      }
      return !!child;
    });

    // rows and slidesPerRow logic is handled here
    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
      settings.variableWidth = false;
    }
    var newChildren = [];
    var currentWidth = null;
    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
      var newSlide = [];
      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
        var row = [];
        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
          if (settings.variableWidth && children[k].props.style) {
            currentWidth = children[k].props.style.width;
          }
          if (k >= children.length) break;
          row.push(_react2.default.cloneElement(children[k], {
            key: 100 * i + 10 * j + k,
            tabIndex: -1,
            style: {
              width: 100 / settings.slidesPerRow + "%",
              display: "inline-block"
            }
          }));
        }
        newSlide.push(_react2.default.createElement(
          "div",
          { key: 10 * i + j },
          row
        ));
      }
      if (settings.variableWidth) {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i, style: { width: currentWidth } },
          newSlide
        ));
      } else {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i },
          newSlide
        ));
      }
    }

    if (settings === "unslick") {
      var className = "regular slider " + (this.props.className || "");
      return _react2.default.createElement(
        "div",
        { className: className },
        newChildren
      );
    } else if (newChildren.length <= settings.slidesToShow) {
      settings.unslick = true;
    }
    return _react2.default.createElement(
      _innerSlider.InnerSlider,
      _extends({ ref: this.innerSliderRefHandler }, settings),
      newChildren
    );
  };

  return Slider;
}(_react2.default.Component);

exports.default = Slider;

/***/ }),

/***/ "./node_modules/react-slick/lib/track.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Track = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__("./node_modules/react-slick/lib/utils/innerSliderUtils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }
  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL
  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";
    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var childrenCount = _react2.default.Children.count(spec.children);
  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react2.default.Children.forEach(spec.children, function (elem, index) {
    var child = void 0;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    // in case of lazyLoad, whether or not we want to fetch the slide
    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react2.default.createElement("div", null);
    }
    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
    // push a cloned element of the desired slide
    slides.push(_react2.default.cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames2.default)(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);
        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    }));

    // if slide needs to be precloned or postcloned
    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;
      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;
        if (key >= startIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        preCloneSlides.push(_react2.default.cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;
        if (key < endIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        postCloneSlides.push(_react2.default.cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = exports.Track = function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Track.prototype.render = function render() {
    var slides = renderSlides(this.props);
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    return _react2.default.createElement(
      "div",
      _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents),
      slides
    );
  };

  return Track;
}(_react2.default.PureComponent);

/***/ }),

/***/ "./node_modules/react-slick/lib/utils/innerSliderUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }
  return onDemandSlides;
};

// return list of slides that need to be present
var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }
  return requiredSlides;
};

// startIndex that needs to be present
var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};
var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};
var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};

// get width of an element
var getWidth = exports.getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};
var getHeight = exports.getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};
var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }
  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
};

// whether or not we can go next
var canGoNext = exports.canGoNext = function canGoNext(spec) {
  var canGo = true;
  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }
  return canGo;
};

// given an object and a list of keys, return new object with given keys
var extractObject = exports.extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
};

// get initialized state
var initializedState = exports.initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react2.default.Children.count(spec.children);
  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
  var slideWidth = void 0;
  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }
    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }
  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }
  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
  lazyLoadedList.concat(slidesToLoad);

  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

var slideHandler = exports.slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;

  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide = void 0,
      animationLeft = void 0,
      finalLeft = void 0;
  var state = {},
      nextState = {};
  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};
    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }
    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }
    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = { animating: false };
  } else {
    finalSlide = animationSlide;
    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }
    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }
    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        swipeLeft: null
      };
    }
  }
  return { state: state, nextState: nextState };
};

var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;

  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;
    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;
    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;
    if (targetSlide === options.currentSlide) {
      return null;
    }
    if (infinite) {
      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
    if (targetSlide === options.currentSlide) {
      return null;
    }
  }
  return targetSlide;
};
var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;

  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft = void 0,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return { scrolling: true };
  }
  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;

  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;
  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;
      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }
  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }
  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }
  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }
  state = _extends({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
  });
  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }
  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }
  return state;
};
var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }
  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
  // reset the state of touch related state variables.
  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };
  if (scrolling) {
    return state;
  }
  if (!touchObject.swipeLength) {
    return state;
  }
  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();
    if (onSwipe) {
      onSwipe(swipeDirection);
    }
    var slideCount = void 0,
        newSlide = void 0;
    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;
      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;
      default:
        slideCount = currentSlide;
    }
    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
  }
  return state;
};
var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];
  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }
  return indexes;
};
var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;
  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }
      prevNavigable = navigables[n];
    }
  }
  return index;
};
var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
  if (spec.swipeToSlide) {
    var swipedSlide = void 0;
    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }
    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth = void 0,
      trackHeight = void 0;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }
  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _extends({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }
  if (spec.fade) style = { opacity: 1 };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight;

  // Fallback for IE8
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};
var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style;
};
var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);

  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;


  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;
  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    }
    // shift current slide to center of the frame
    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }
    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }
  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = _reactDom2.default.findDOMNode(trackRef);
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;
      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }
      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

var getPreClones = exports.getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  if (spec.variableWidth) {
    return spec.slideCount;
  }
  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

var getPostClones = exports.getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  return spec.slideCount;
};

var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};
var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }
    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }
    return "left";
  }
};

var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }
  if (rtl) {
    return 0;
  }
  return slidesToShow - 1;
};

var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }
  if (rtl) {
    return slidesToShow - 1;
  }
  return 0;
};

var canUseDOM = exports.canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

/***/ }),

/***/ "./node_modules/react-transition-group/Transition.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__("./node_modules/prop-types/index.js"));

var _react = _interopRequireDefault(__webpack_require__("./node_modules/react/index.js"));

var _reactDom = _interopRequireDefault(__webpack_require__("./node_modules/react-dom/index.js"));

var _reactLifecyclesCompat = __webpack_require__("./node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js");

var _PropTypes = __webpack_require__("./node_modules/react-transition-group/utils/PropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),

/***/ "./node_modules/react-transition-group/utils/PropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__("./node_modules/prop-types/index.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),

/***/ "./node_modules/react-visibility-sensor/lib/is-visible-with-offset.js":
/***/ (function(module, exports) {

// Tell whether the rect is visible, given an offset
//
// return: boolean
module.exports = function (offset, rect, containmentRect) {
  var offsetDir = offset.direction;
  var offsetVal = offset.value;

  // Rules for checking different kind of offsets. In example if the element is
  // 90px below viewport and offsetTop is 100, it is considered visible.
  switch (offsetDir) {
  case 'top':
    return ((containmentRect.top + offsetVal) < rect.top) &&
      (containmentRect.bottom > rect.bottom) &&
      (containmentRect.left < rect.left) &&
      (containmentRect.right > rect.right);

  case 'left':
    return ((containmentRect.left + offsetVal) < rect.left) &&
      (containmentRect.bottom > rect.bottom) &&
      (containmentRect.top < rect.top) &&
      (containmentRect.right > rect.right);

  case 'bottom':
    return ((containmentRect.bottom - offsetVal) > rect.bottom) &&
      (containmentRect.left < rect.left) &&
      (containmentRect.right > rect.right) &&
      (containmentRect.top < rect.top);

  case 'right':
    return ((containmentRect.right - offsetVal) > rect.right) &&
      (containmentRect.left < rect.left) &&
      (containmentRect.top < rect.top) &&
      (containmentRect.bottom > rect.bottom);
  }
}


/***/ }),

/***/ "./node_modules/react-visibility-sensor/visibility-sensor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__("./node_modules/react/index.js");
var ReactDOM = __webpack_require__("./node_modules/react-dom/index.js");
var PropTypes = __webpack_require__("./node_modules/prop-types/index.js");
var createReactClass = __webpack_require__("./node_modules/create-react-class/index.js");
var isVisibleWithOffset = __webpack_require__("./node_modules/react-visibility-sensor/lib/is-visible-with-offset.js")

var containmentPropType = PropTypes.any;

if (typeof window !== 'undefined') {
  containmentPropType = PropTypes.instanceOf(window.Element);
}

function throttle (callback, limit) {
    var wait = false;
    return function () {
        if (!wait) {
            wait = true;
            setTimeout(function () {
                callback();
                wait = false;
            }, limit);
        }
    }
}

function debounce(func, wait) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      func.apply(context, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

function normalizeRect (rect) {
  if (rect.width === undefined) {
    rect.width = rect.right - rect.left;
  }

  if (rect.height === undefined) {
    rect.height = rect.bottom - rect.top;
  }

  return rect;
}

module.exports = createReactClass({
  displayName: 'VisibilitySensor',

  propTypes: {
    onChange: PropTypes.func,
    active: PropTypes.bool,
    partialVisibility: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
    ]),
    delayedCall: PropTypes.bool,
    offset: PropTypes.oneOfType([
      PropTypes.shape({
        top: PropTypes.number,
        left: PropTypes.number,
        bottom: PropTypes.number,
        right: PropTypes.number
      }),
      // deprecated offset property
      PropTypes.shape({
        direction: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
        value: PropTypes.number
      })
    ]),
    scrollCheck: PropTypes.bool,
    scrollDelay: PropTypes.number,
    scrollThrottle: PropTypes.number,
    resizeCheck: PropTypes.bool,
    resizeDelay: PropTypes.number,
    resizeThrottle: PropTypes.number,
    intervalCheck: PropTypes.bool,
    intervalDelay: PropTypes.number,
    containment: containmentPropType,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.func,
    ]),
    minTopValue: PropTypes.number,
  },

  getDefaultProps: function () {
    return {
      active: true,
      partialVisibility: false,
      minTopValue: 0,
      scrollCheck: false,
      scrollDelay: 250,
      scrollThrottle: -1,
      resizeCheck: false,
      resizeDelay: 250,
      resizeThrottle: -1,
      intervalCheck: true,
      intervalDelay: 100,
      delayedCall: false,
      offset: {},
      containment: null,
      children: React.createElement('span')
    };
  },

  getInitialState: function () {
    return {
      isVisible: null,
      visibilityRect: {}
    };
  },

  componentDidMount: function () {
    this.node = ReactDOM.findDOMNode(this);
    if (this.props.active) {
      this.startWatching();
    }
  },

  componentWillUnmount: function () {
    this.stopWatching();
  },

  componentWillReceiveProps: function (nextProps) {
    if (nextProps.active && !this.props.active) {
      this.setState(this.getInitialState());
      this.startWatching();
    } else if (!nextProps.active) {
      this.stopWatching();
    }
  },

  componentDidUpdate: function (prevProps) {
    this.node = ReactDOM.findDOMNode(this);
  },

  getContainer: function () {
    return this.props.containment || window;
  },

  addEventListener: function (target, event, delay, throttle) {
    if (!this.debounceCheck) {
      this.debounceCheck = {};
    }

    var timeout;
    var func;

    var later = function () {
      timeout = null;
      this.check();
    }.bind(this);

    if (throttle > -1) {
      func = function () {
        if (!timeout) {
          timeout = setTimeout(later, throttle || 0);
        }
      };
    } else {
      func = function () {
        clearTimeout(timeout);
        timeout = setTimeout(later, delay || 0);
      };
    }

    var info = {
      target: target,
      fn: func,
      getLastTimeout: function () {
        return timeout;
      },
    };

    target.addEventListener(event, info.fn);
    this.debounceCheck[event] = info;
  },

  startWatching: function () {
    if (this.debounceCheck || this.interval) { return; }

    if (this.props.intervalCheck) {
      this.interval = setInterval(this.check, this.props.intervalDelay);
    }

    if (this.props.scrollCheck) {
      this.addEventListener(
        this.getContainer(),
        'scroll',
        this.props.scrollDelay,
        this.props.scrollThrottle
      );
    }

    if (this.props.resizeCheck) {
      this.addEventListener(
        window,
        'resize',
        this.props.resizeDelay,
        this.props.resizeThrottle
      );
    }

    // if dont need delayed call, check on load ( before the first interval fires )
    !this.props.delayedCall && this.check();
  },

  stopWatching: function () {
    if (this.debounceCheck) {
      // clean up event listeners and their debounce callers
      for (var debounceEvent in this.debounceCheck) {
        if (this.debounceCheck.hasOwnProperty(debounceEvent)) {
          var debounceInfo = this.debounceCheck[debounceEvent];

          clearTimeout(debounceInfo.getLastTimeout());
          debounceInfo.target.removeEventListener(
            debounceEvent, debounceInfo.fn
          );

          this.debounceCheck[debounceEvent] = null;
        }
      }
    }
    this.debounceCheck = null;

    if (this.interval) { this.interval = clearInterval(this.interval); }
  },

  roundRectDown: function (rect) {
    return {
      top: Math.floor(rect.top),
      left: Math.floor(rect.left),
      bottom: Math.floor(rect.bottom),
      right: Math.floor(rect.right),
    };
  },

  /**
   * Check if the element is within the visible viewport
   */
  check: function () {
    var el = this.node;
    var rect;
    var containmentRect;
    // if the component has rendered to null, dont update visibility
    if (!el) {
      return this.state;
    }

    rect = normalizeRect(this.roundRectDown(el.getBoundingClientRect()));

    if (this.props.containment) {
      var containmentDOMRect = this.props.containment.getBoundingClientRect();
      containmentRect = {
        top: containmentDOMRect.top,
        left: containmentDOMRect.left,
        bottom: containmentDOMRect.bottom,
        right: containmentDOMRect.right,
      }
    } else {
      containmentRect = {
        top: 0,
        left: 0,
        bottom: window.innerHeight || document.documentElement.clientHeight,
        right: window.innerWidth || document.documentElement.clientWidth
      };
    }

    // Check if visibility is wanted via offset?
    var offset = this.props.offset || {};
    var hasValidOffset = typeof offset === 'object';
    if (hasValidOffset) {
      containmentRect.top += offset.top || 0;
      containmentRect.left += offset.left || 0;
      containmentRect.bottom -= offset.bottom || 0;
      containmentRect.right -= offset.right || 0;
    }

    var visibilityRect = {
      top: rect.top >= containmentRect.top,
      left: rect.left >= containmentRect.left,
      bottom: rect.bottom <= containmentRect.bottom,
      right: rect.right <= containmentRect.right
    };

    var hasSize = rect.height > 0 && rect.width > 0;

    var isVisible = (
      hasSize &&
      visibilityRect.top &&
      visibilityRect.left &&
      visibilityRect.bottom &&
      visibilityRect.right
    );

    // check for partial visibility
    if (hasSize && this.props.partialVisibility) {
      var partialVisible =
          rect.top <= containmentRect.bottom && rect.bottom >= containmentRect.top &&
          rect.left <= containmentRect.right && rect.right >= containmentRect.left;

      // account for partial visibility on a single edge
      if (typeof this.props.partialVisibility === 'string') {
        partialVisible = visibilityRect[this.props.partialVisibility]
      }

      // if we have minimum top visibility set by props, lets check, if it meets the passed value
      // so if for instance element is at least 200px in viewport, then show it.
      isVisible = this.props.minTopValue
        ? partialVisible && rect.top <= (containmentRect.bottom - this.props.minTopValue)
        : partialVisible
    }

    // Deprecated options for calculating offset.
    if (typeof offset.direction === 'string' &&
        typeof offset.value === 'number') {
      console.warn('[notice] offset.direction and offset.value have been deprecated. They still work for now, but will be removed in next major version. Please upgrade to the new syntax: { %s: %d }', offset.direction, offset.value)

      isVisible = isVisibleWithOffset(offset, rect, containmentRect);
    }

    var state = this.state;
    // notify the parent when the value changes
    if (this.state.isVisible !== isVisible) {
      state = {
        isVisible: isVisible,
        visibilityRect: visibilityRect
      };
      this.setState(state);
      if (this.props.onChange) this.props.onChange(isVisible, visibilityRect);
    }

    return state;
  },

  render: function () {
    if (this.props.children instanceof Function) {
      return this.props.children({
        isVisible: this.state.isVisible,
        visibilityRect: this.state.visibilityRect,
      });
    }
    return React.Children.only(this.props.children);
  }
});


/***/ }),

/***/ "./node_modules/readable-stream/duplex-browser.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/readable-stream/lib/_stream_duplex.js");


/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_duplex.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__("./node_modules/process-nextick-args/index.js");
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__("./node_modules/core-util-is/lib/util.js");
util.inherits = __webpack_require__("./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

var Readable = __webpack_require__("./node_modules/readable-stream/lib/_stream_readable.js");
var Writable = __webpack_require__("./node_modules/readable-stream/lib/_stream_writable.js");

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_passthrough.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__("./node_modules/readable-stream/lib/_stream_transform.js");

/*<replacement>*/
var util = __webpack_require__("./node_modules/core-util-is/lib/util.js");
util.inherits = __webpack_require__("./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_readable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__("./node_modules/process-nextick-args/index.js");
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__("./node_modules/isarray/index.js");
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__("./node_modules/events/events.js").EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("./node_modules/readable-stream/lib/internal/streams/stream-browser.js");
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__("./node_modules/readable-stream/node_modules/safe-buffer/index.js").Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__("./node_modules/core-util-is/lib/util.js");
util.inherits = __webpack_require__("./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__("ignored C:\\agent\\_work\\4\\s\\node_modules\\readable-stream\\lib util");
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__("./node_modules/readable-stream/lib/internal/streams/BufferList.js");
var destroyImpl = __webpack_require__("./node_modules/readable-stream/lib/internal/streams/destroy.js");
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__("./node_modules/readable-stream/lib/_stream_duplex.js");

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__("./node_modules/string_decoder/lib/string_decoder.js").StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__("./node_modules/readable-stream/lib/_stream_duplex.js");

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__("./node_modules/string_decoder/lib/string_decoder.js").StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/react-scripts/node_modules/webpack/buildin/global.js"), __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_transform.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__("./node_modules/readable-stream/lib/_stream_duplex.js");

/*<replacement>*/
var util = __webpack_require__("./node_modules/core-util-is/lib/util.js");
util.inherits = __webpack_require__("./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_writable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__("./node_modules/process-nextick-args/index.js");
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__("./node_modules/core-util-is/lib/util.js");
util.inherits = __webpack_require__("./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__("./node_modules/util-deprecate/browser.js")
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("./node_modules/readable-stream/lib/internal/streams/stream-browser.js");
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__("./node_modules/readable-stream/node_modules/safe-buffer/index.js").Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__("./node_modules/readable-stream/lib/internal/streams/destroy.js");

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__("./node_modules/readable-stream/lib/_stream_duplex.js");

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__("./node_modules/readable-stream/lib/_stream_duplex.js");

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js"), __webpack_require__("./node_modules/timers-browserify/main.js").setImmediate, __webpack_require__("./node_modules/react-scripts/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/readable-stream/lib/internal/streams/BufferList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__("./node_modules/readable-stream/node_modules/safe-buffer/index.js").Buffer;
var util = __webpack_require__("ignored C:\\agent\\_work\\4\\s\\node_modules\\readable-stream\\lib\\internal\\streams util");

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),

/***/ "./node_modules/readable-stream/lib/internal/streams/destroy.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__("./node_modules/process-nextick-args/index.js");
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),

/***/ "./node_modules/readable-stream/lib/internal/streams/stream-browser.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/events/events.js").EventEmitter;


/***/ }),

/***/ "./node_modules/readable-stream/node_modules/safe-buffer/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__("./node_modules/buffer/index.js")
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ "./node_modules/readable-stream/passthrough.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/readable-stream/readable-browser.js").PassThrough


/***/ }),

/***/ "./node_modules/readable-stream/readable-browser.js":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/readable-stream/lib/_stream_readable.js");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__("./node_modules/readable-stream/lib/_stream_writable.js");
exports.Duplex = __webpack_require__("./node_modules/readable-stream/lib/_stream_duplex.js");
exports.Transform = __webpack_require__("./node_modules/readable-stream/lib/_stream_transform.js");
exports.PassThrough = __webpack_require__("./node_modules/readable-stream/lib/_stream_passthrough.js");


/***/ }),

/***/ "./node_modules/readable-stream/transform.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/readable-stream/readable-browser.js").Transform


/***/ }),

/***/ "./node_modules/readable-stream/writable-browser.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/readable-stream/lib/_stream_writable.js");


/***/ }),

/***/ "./node_modules/reflect-metadata/Reflect.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var Reflect;
(function (Reflect) {
    // Metadata Proposal
    // https://rbuckton.github.io/reflect-metadata/
    (function (factory) {
        var root = typeof global === "object" ? global :
            typeof self === "object" ? self :
                typeof this === "object" ? this :
                    Function("return this;")();
        var exporter = makeExporter(Reflect);
        if (typeof root.Reflect === "undefined") {
            root.Reflect = Reflect;
        }
        else {
            exporter = makeExporter(root.Reflect, exporter);
        }
        factory(exporter);
        function makeExporter(target, previous) {
            return function (key, value) {
                if (typeof target[key] !== "function") {
                    Object.defineProperty(target, key, { configurable: true, writable: true, value: value });
                }
                if (previous)
                    previous(key, value);
            };
        }
    })(function (exporter) {
        var hasOwn = Object.prototype.hasOwnProperty;
        // feature test for Symbol support
        var supportsSymbol = typeof Symbol === "function";
        var toPrimitiveSymbol = supportsSymbol && typeof Symbol.toPrimitive !== "undefined" ? Symbol.toPrimitive : "@@toPrimitive";
        var iteratorSymbol = supportsSymbol && typeof Symbol.iterator !== "undefined" ? Symbol.iterator : "@@iterator";
        var supportsCreate = typeof Object.create === "function"; // feature test for Object.create support
        var supportsProto = { __proto__: [] } instanceof Array; // feature test for __proto__ support
        var downLevel = !supportsCreate && !supportsProto;
        var HashMap = {
            // create an object in dictionary mode (a.k.a. "slow" mode in v8)
            create: supportsCreate
                ? function () { return MakeDictionary(Object.create(null)); }
                : supportsProto
                    ? function () { return MakeDictionary({ __proto__: null }); }
                    : function () { return MakeDictionary({}); },
            has: downLevel
                ? function (map, key) { return hasOwn.call(map, key); }
                : function (map, key) { return key in map; },
            get: downLevel
                ? function (map, key) { return hasOwn.call(map, key) ? map[key] : undefined; }
                : function (map, key) { return map[key]; },
        };
        // Load global or shim versions of Map, Set, and WeakMap
        var functionPrototype = Object.getPrototypeOf(Function);
        var usePolyfill = typeof process === "object" && Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_CONTACT_FORM_MAIL_TO":"https://prod-11.westeurope.logic.azure.com:443/workflows/469daeb9e0814284944a6823e010e5a8/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=LDw4OCmhrzknYryf6NZR0l3HUvOO4sOrJ4KrLNKgQF4","REACT_APP_CONTACT_FORM_SUPPORT_MAIL_TO":"https://prod-16.westeurope.logic.azure.com:443/workflows/07509f2760d64838bdf665f7d4c46e93/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=RU0-XCUoC4Qpr8vUzhRzGqBG6tSvXSkO9nkxjqaxCPI","REACT_APP_DEBUG":"false","REACT_APP_GEOLOCATION_API":"https://ipinfo.io/json?token=ea4d0cf5569d7d","REACT_APP_NEWSLETTER":"https://zonifero-new-www-dev-linux-fap.azurewebsites.net/api/getResponse","REACT_APP_PIPEDRIVE":"https://thg-d-www-pipedrive-fap.azurewebsites.net/api/postnote?code=Ils3YzEnC4e_eucIqh-bmAFyZfiILKHctzHGfhApQ46-AzFun4AhSA%3D%3D","REACT_APP_PROXY_BASE_URL":"https://tender-cms-api.azurewebsites.net","REACT_APP_RECAPTCHA_SECRET_KEY":"6Ld2rL0kAAAAAMu9_rMrS0HMhPpbzlO9L11OpDSS","REACT_APP_RECAPTCHA_SITE_KEY":"6Ld2rL0kAAAAAPMldKss1yYJmpWfSil0UPlBBlqh","REACT_APP_SEARCH_CONSOLE_CODE":"vLvp2xQcuyTV0NJMTAfXrgRLTIvTQg3LC-PmKOg7rHo","REACT_APP_SECURITY_APP":"https://swh-p-spambotprot-fap.azurewebsites.net/api/SpamBotProtection","REACT_APP_TAG_MANAGER_ID":"GTM-KB24WRL"}) && Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_CONTACT_FORM_MAIL_TO":"https://prod-11.westeurope.logic.azure.com:443/workflows/469daeb9e0814284944a6823e010e5a8/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=LDw4OCmhrzknYryf6NZR0l3HUvOO4sOrJ4KrLNKgQF4","REACT_APP_CONTACT_FORM_SUPPORT_MAIL_TO":"https://prod-16.westeurope.logic.azure.com:443/workflows/07509f2760d64838bdf665f7d4c46e93/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=RU0-XCUoC4Qpr8vUzhRzGqBG6tSvXSkO9nkxjqaxCPI","REACT_APP_DEBUG":"false","REACT_APP_GEOLOCATION_API":"https://ipinfo.io/json?token=ea4d0cf5569d7d","REACT_APP_NEWSLETTER":"https://zonifero-new-www-dev-linux-fap.azurewebsites.net/api/getResponse","REACT_APP_PIPEDRIVE":"https://thg-d-www-pipedrive-fap.azurewebsites.net/api/postnote?code=Ils3YzEnC4e_eucIqh-bmAFyZfiILKHctzHGfhApQ46-AzFun4AhSA%3D%3D","REACT_APP_PROXY_BASE_URL":"https://tender-cms-api.azurewebsites.net","REACT_APP_RECAPTCHA_SECRET_KEY":"6Ld2rL0kAAAAAMu9_rMrS0HMhPpbzlO9L11OpDSS","REACT_APP_RECAPTCHA_SITE_KEY":"6Ld2rL0kAAAAAPMldKss1yYJmpWfSil0UPlBBlqh","REACT_APP_SEARCH_CONSOLE_CODE":"vLvp2xQcuyTV0NJMTAfXrgRLTIvTQg3LC-PmKOg7rHo","REACT_APP_SECURITY_APP":"https://swh-p-spambotprot-fap.azurewebsites.net/api/SpamBotProtection","REACT_APP_TAG_MANAGER_ID":"GTM-KB24WRL"})["REFLECT_METADATA_USE_MAP_POLYFILL"] === "true";
        var _Map = !usePolyfill && typeof Map === "function" && typeof Map.prototype.entries === "function" ? Map : CreateMapPolyfill();
        var _Set = !usePolyfill && typeof Set === "function" && typeof Set.prototype.entries === "function" ? Set : CreateSetPolyfill();
        var _WeakMap = !usePolyfill && typeof WeakMap === "function" ? WeakMap : CreateWeakMapPolyfill();
        // [[Metadata]] internal slot
        // https://rbuckton.github.io/reflect-metadata/#ordinary-object-internal-methods-and-internal-slots
        var Metadata = new _WeakMap();
        /**
         * Applies a set of decorators to a property of a target object.
         * @param decorators An array of decorators.
         * @param target The target object.
         * @param propertyKey (Optional) The property key to decorate.
         * @param attributes (Optional) The property descriptor for the target key.
         * @remarks Decorators are applied in reverse order.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Example = Reflect.decorate(decoratorsArray, Example);
         *
         *     // property (on constructor)
         *     Reflect.decorate(decoratorsArray, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.decorate(decoratorsArray, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Object.defineProperty(Example, "staticMethod",
         *         Reflect.decorate(decoratorsArray, Example, "staticMethod",
         *             Object.getOwnPropertyDescriptor(Example, "staticMethod")));
         *
         *     // method (on prototype)
         *     Object.defineProperty(Example.prototype, "method",
         *         Reflect.decorate(decoratorsArray, Example.prototype, "method",
         *             Object.getOwnPropertyDescriptor(Example.prototype, "method")));
         *
         */
        function decorate(decorators, target, propertyKey, attributes) {
            if (!IsUndefined(propertyKey)) {
                if (!IsArray(decorators))
                    throw new TypeError();
                if (!IsObject(target))
                    throw new TypeError();
                if (!IsObject(attributes) && !IsUndefined(attributes) && !IsNull(attributes))
                    throw new TypeError();
                if (IsNull(attributes))
                    attributes = undefined;
                propertyKey = ToPropertyKey(propertyKey);
                return DecorateProperty(decorators, target, propertyKey, attributes);
            }
            else {
                if (!IsArray(decorators))
                    throw new TypeError();
                if (!IsConstructor(target))
                    throw new TypeError();
                return DecorateConstructor(decorators, target);
            }
        }
        exporter("decorate", decorate);
        // 4.1.2 Reflect.metadata(metadataKey, metadataValue)
        // https://rbuckton.github.io/reflect-metadata/#reflect.metadata
        /**
         * A default metadata decorator factory that can be used on a class, class member, or parameter.
         * @param metadataKey The key for the metadata entry.
         * @param metadataValue The value for the metadata entry.
         * @returns A decorator function.
         * @remarks
         * If `metadataKey` is already defined for the target and target key, the
         * metadataValue for that key will be overwritten.
         * @example
         *
         *     // constructor
         *     @Reflect.metadata(key, value)
         *     class Example {
         *     }
         *
         *     // property (on constructor, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticProperty;
         *     }
         *
         *     // property (on prototype, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         property;
         *     }
         *
         *     // method (on constructor)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticMethod() { }
         *     }
         *
         *     // method (on prototype)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         method() { }
         *     }
         *
         */
        function metadata(metadataKey, metadataValue) {
            function decorator(target, propertyKey) {
                if (!IsObject(target))
                    throw new TypeError();
                if (!IsUndefined(propertyKey) && !IsPropertyKey(propertyKey))
                    throw new TypeError();
                OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
            }
            return decorator;
        }
        exporter("metadata", metadata);
        /**
         * Define a unique metadata entry on the target.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param metadataValue A value that contains attached metadata.
         * @param target The target object on which to define metadata.
         * @param propertyKey (Optional) The property key for the target.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Reflect.defineMetadata("custom:annotation", options, Example);
         *
         *     // property (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticMethod");
         *
         *     // method (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "method");
         *
         *     // decorator factory as metadata-producing annotation.
         *     function MyAnnotation(options): Decorator {
         *         return (target, key?) => Reflect.defineMetadata("custom:annotation", options, target, key);
         *     }
         *
         */
        function defineMetadata(metadataKey, metadataValue, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
        }
        exporter("defineMetadata", defineMetadata);
        /**
         * Gets a value indicating whether the target object or its prototype chain has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object or its prototype chain; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function hasMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasMetadata", hasMetadata);
        /**
         * Gets a value indicating whether the target object has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function hasOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasOwnMetadata", hasOwnMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object or its prototype chain.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function getMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetMetadata(metadataKey, target, propertyKey);
        }
        exporter("getMetadata", getMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function getOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("getOwnMetadata", getOwnMetadata);
        /**
         * Gets the metadata keys defined on the target object or its prototype chain.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "method");
         *
         */
        function getMetadataKeys(target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryMetadataKeys(target, propertyKey);
        }
        exporter("getMetadataKeys", getMetadataKeys);
        /**
         * Gets the unique metadata keys defined on the target object.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "method");
         *
         */
        function getOwnMetadataKeys(target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryOwnMetadataKeys(target, propertyKey);
        }
        exporter("getOwnMetadataKeys", getOwnMetadataKeys);
        /**
         * Deletes the metadata entry from the target object with the provided key.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata entry was found and deleted; otherwise, false.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.deleteMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function deleteMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            var metadataMap = GetOrCreateMetadataMap(target, propertyKey, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return false;
            if (!metadataMap.delete(metadataKey))
                return false;
            if (metadataMap.size > 0)
                return true;
            var targetMetadata = Metadata.get(target);
            targetMetadata.delete(propertyKey);
            if (targetMetadata.size > 0)
                return true;
            Metadata.delete(target);
            return true;
        }
        exporter("deleteMetadata", deleteMetadata);
        function DecorateConstructor(decorators, target) {
            for (var i = decorators.length - 1; i >= 0; --i) {
                var decorator = decorators[i];
                var decorated = decorator(target);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsConstructor(decorated))
                        throw new TypeError();
                    target = decorated;
                }
            }
            return target;
        }
        function DecorateProperty(decorators, target, propertyKey, descriptor) {
            for (var i = decorators.length - 1; i >= 0; --i) {
                var decorator = decorators[i];
                var decorated = decorator(target, propertyKey, descriptor);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsObject(decorated))
                        throw new TypeError();
                    descriptor = decorated;
                }
            }
            return descriptor;
        }
        function GetOrCreateMetadataMap(O, P, Create) {
            var targetMetadata = Metadata.get(O);
            if (IsUndefined(targetMetadata)) {
                if (!Create)
                    return undefined;
                targetMetadata = new _Map();
                Metadata.set(O, targetMetadata);
            }
            var metadataMap = targetMetadata.get(P);
            if (IsUndefined(metadataMap)) {
                if (!Create)
                    return undefined;
                metadataMap = new _Map();
                targetMetadata.set(P, metadataMap);
            }
            return metadataMap;
        }
        // 3.1.1.1 OrdinaryHasMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasmetadata
        function OrdinaryHasMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn)
                return true;
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent))
                return OrdinaryHasMetadata(MetadataKey, parent, P);
            return false;
        }
        // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
        function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return false;
            return ToBoolean(metadataMap.has(MetadataKey));
        }
        // 3.1.3.1 OrdinaryGetMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetmetadata
        function OrdinaryGetMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn)
                return OrdinaryGetOwnMetadata(MetadataKey, O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent))
                return OrdinaryGetMetadata(MetadataKey, parent, P);
            return undefined;
        }
        // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
        function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return undefined;
            return metadataMap.get(MetadataKey);
        }
        // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
        function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ true);
            metadataMap.set(MetadataKey, MetadataValue);
        }
        // 3.1.6.1 OrdinaryMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarymetadatakeys
        function OrdinaryMetadataKeys(O, P) {
            var ownKeys = OrdinaryOwnMetadataKeys(O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (parent === null)
                return ownKeys;
            var parentKeys = OrdinaryMetadataKeys(parent, P);
            if (parentKeys.length <= 0)
                return ownKeys;
            if (ownKeys.length <= 0)
                return parentKeys;
            var set = new _Set();
            var keys = [];
            for (var _i = 0, ownKeys_1 = ownKeys; _i < ownKeys_1.length; _i++) {
                var key = ownKeys_1[_i];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            for (var _a = 0, parentKeys_1 = parentKeys; _a < parentKeys_1.length; _a++) {
                var key = parentKeys_1[_a];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            return keys;
        }
        // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
        function OrdinaryOwnMetadataKeys(O, P) {
            var keys = [];
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return keys;
            var keysObj = metadataMap.keys();
            var iterator = GetIterator(keysObj);
            var k = 0;
            while (true) {
                var next = IteratorStep(iterator);
                if (!next) {
                    keys.length = k;
                    return keys;
                }
                var nextValue = IteratorValue(next);
                try {
                    keys[k] = nextValue;
                }
                catch (e) {
                    try {
                        IteratorClose(iterator);
                    }
                    finally {
                        throw e;
                    }
                }
                k++;
            }
        }
        // 6 ECMAScript Data Typ0es and Values
        // https://tc39.github.io/ecma262/#sec-ecmascript-data-types-and-values
        function Type(x) {
            if (x === null)
                return 1 /* Null */;
            switch (typeof x) {
                case "undefined": return 0 /* Undefined */;
                case "boolean": return 2 /* Boolean */;
                case "string": return 3 /* String */;
                case "symbol": return 4 /* Symbol */;
                case "number": return 5 /* Number */;
                case "object": return x === null ? 1 /* Null */ : 6 /* Object */;
                default: return 6 /* Object */;
            }
        }
        // 6.1.1 The Undefined Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-undefined-type
        function IsUndefined(x) {
            return x === undefined;
        }
        // 6.1.2 The Null Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-null-type
        function IsNull(x) {
            return x === null;
        }
        // 6.1.5 The Symbol Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-symbol-type
        function IsSymbol(x) {
            return typeof x === "symbol";
        }
        // 6.1.7 The Object Type
        // https://tc39.github.io/ecma262/#sec-object-type
        function IsObject(x) {
            return typeof x === "object" ? x !== null : typeof x === "function";
        }
        // 7.1 Type Conversion
        // https://tc39.github.io/ecma262/#sec-type-conversion
        // 7.1.1 ToPrimitive(input [, PreferredType])
        // https://tc39.github.io/ecma262/#sec-toprimitive
        function ToPrimitive(input, PreferredType) {
            switch (Type(input)) {
                case 0 /* Undefined */: return input;
                case 1 /* Null */: return input;
                case 2 /* Boolean */: return input;
                case 3 /* String */: return input;
                case 4 /* Symbol */: return input;
                case 5 /* Number */: return input;
            }
            var hint = PreferredType === 3 /* String */ ? "string" : PreferredType === 5 /* Number */ ? "number" : "default";
            var exoticToPrim = GetMethod(input, toPrimitiveSymbol);
            if (exoticToPrim !== undefined) {
                var result = exoticToPrim.call(input, hint);
                if (IsObject(result))
                    throw new TypeError();
                return result;
            }
            return OrdinaryToPrimitive(input, hint === "default" ? "number" : hint);
        }
        // 7.1.1.1 OrdinaryToPrimitive(O, hint)
        // https://tc39.github.io/ecma262/#sec-ordinarytoprimitive
        function OrdinaryToPrimitive(O, hint) {
            if (hint === "string") {
                var toString_1 = O.toString;
                if (IsCallable(toString_1)) {
                    var result = toString_1.call(O);
                    if (!IsObject(result))
                        return result;
                }
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result))
                        return result;
                }
            }
            else {
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result))
                        return result;
                }
                var toString_2 = O.toString;
                if (IsCallable(toString_2)) {
                    var result = toString_2.call(O);
                    if (!IsObject(result))
                        return result;
                }
            }
            throw new TypeError();
        }
        // 7.1.2 ToBoolean(argument)
        // https://tc39.github.io/ecma262/2016/#sec-toboolean
        function ToBoolean(argument) {
            return !!argument;
        }
        // 7.1.12 ToString(argument)
        // https://tc39.github.io/ecma262/#sec-tostring
        function ToString(argument) {
            return "" + argument;
        }
        // 7.1.14 ToPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-topropertykey
        function ToPropertyKey(argument) {
            var key = ToPrimitive(argument, 3 /* String */);
            if (IsSymbol(key))
                return key;
            return ToString(key);
        }
        // 7.2 Testing and Comparison Operations
        // https://tc39.github.io/ecma262/#sec-testing-and-comparison-operations
        // 7.2.2 IsArray(argument)
        // https://tc39.github.io/ecma262/#sec-isarray
        function IsArray(argument) {
            return Array.isArray
                ? Array.isArray(argument)
                : argument instanceof Object
                    ? argument instanceof Array
                    : Object.prototype.toString.call(argument) === "[object Array]";
        }
        // 7.2.3 IsCallable(argument)
        // https://tc39.github.io/ecma262/#sec-iscallable
        function IsCallable(argument) {
            // NOTE: This is an approximation as we cannot check for [[Call]] internal method.
            return typeof argument === "function";
        }
        // 7.2.4 IsConstructor(argument)
        // https://tc39.github.io/ecma262/#sec-isconstructor
        function IsConstructor(argument) {
            // NOTE: This is an approximation as we cannot check for [[Construct]] internal method.
            return typeof argument === "function";
        }
        // 7.2.7 IsPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-ispropertykey
        function IsPropertyKey(argument) {
            switch (Type(argument)) {
                case 3 /* String */: return true;
                case 4 /* Symbol */: return true;
                default: return false;
            }
        }
        // 7.3 Operations on Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-objects
        // 7.3.9 GetMethod(V, P)
        // https://tc39.github.io/ecma262/#sec-getmethod
        function GetMethod(V, P) {
            var func = V[P];
            if (func === undefined || func === null)
                return undefined;
            if (!IsCallable(func))
                throw new TypeError();
            return func;
        }
        // 7.4 Operations on Iterator Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-iterator-objects
        function GetIterator(obj) {
            var method = GetMethod(obj, iteratorSymbol);
            if (!IsCallable(method))
                throw new TypeError(); // from Call
            var iterator = method.call(obj);
            if (!IsObject(iterator))
                throw new TypeError();
            return iterator;
        }
        // 7.4.4 IteratorValue(iterResult)
        // https://tc39.github.io/ecma262/2016/#sec-iteratorvalue
        function IteratorValue(iterResult) {
            return iterResult.value;
        }
        // 7.4.5 IteratorStep(iterator)
        // https://tc39.github.io/ecma262/#sec-iteratorstep
        function IteratorStep(iterator) {
            var result = iterator.next();
            return result.done ? false : result;
        }
        // 7.4.6 IteratorClose(iterator, completion)
        // https://tc39.github.io/ecma262/#sec-iteratorclose
        function IteratorClose(iterator) {
            var f = iterator["return"];
            if (f)
                f.call(iterator);
        }
        // 9.1 Ordinary Object Internal Methods and Internal Slots
        // https://tc39.github.io/ecma262/#sec-ordinary-object-internal-methods-and-internal-slots
        // 9.1.1.1 OrdinaryGetPrototypeOf(O)
        // https://tc39.github.io/ecma262/#sec-ordinarygetprototypeof
        function OrdinaryGetPrototypeOf(O) {
            var proto = Object.getPrototypeOf(O);
            if (typeof O !== "function" || O === functionPrototype)
                return proto;
            // TypeScript doesn't set __proto__ in ES5, as it's non-standard.
            // Try to determine the superclass constructor. Compatible implementations
            // must either set __proto__ on a subclass constructor to the superclass constructor,
            // or ensure each class has a valid `constructor` property on its prototype that
            // points back to the constructor.
            // If this is not the same as Function.[[Prototype]], then this is definately inherited.
            // This is the case when in ES6 or when using __proto__ in a compatible browser.
            if (proto !== functionPrototype)
                return proto;
            // If the super prototype is Object.prototype, null, or undefined, then we cannot determine the heritage.
            var prototype = O.prototype;
            var prototypeProto = prototype && Object.getPrototypeOf(prototype);
            if (prototypeProto == null || prototypeProto === Object.prototype)
                return proto;
            // If the constructor was not a function, then we cannot determine the heritage.
            var constructor = prototypeProto.constructor;
            if (typeof constructor !== "function")
                return proto;
            // If we have some kind of self-reference, then we cannot determine the heritage.
            if (constructor === O)
                return proto;
            // we have a pretty good guess at the heritage.
            return constructor;
        }
        // naive Map shim
        function CreateMapPolyfill() {
            var cacheSentinel = {};
            var arraySentinel = [];
            var MapIterator = (function () {
                function MapIterator(keys, values, selector) {
                    this._index = 0;
                    this._keys = keys;
                    this._values = values;
                    this._selector = selector;
                }
                MapIterator.prototype["@@iterator"] = function () { return this; };
                MapIterator.prototype[iteratorSymbol] = function () { return this; };
                MapIterator.prototype.next = function () {
                    var index = this._index;
                    if (index >= 0 && index < this._keys.length) {
                        var result = this._selector(this._keys[index], this._values[index]);
                        if (index + 1 >= this._keys.length) {
                            this._index = -1;
                            this._keys = arraySentinel;
                            this._values = arraySentinel;
                        }
                        else {
                            this._index++;
                        }
                        return { value: result, done: false };
                    }
                    return { value: undefined, done: true };
                };
                MapIterator.prototype.throw = function (error) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    throw error;
                };
                MapIterator.prototype.return = function (value) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    return { value: value, done: true };
                };
                return MapIterator;
            }());
            return (function () {
                function Map() {
                    this._keys = [];
                    this._values = [];
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                }
                Object.defineProperty(Map.prototype, "size", {
                    get: function () { return this._keys.length; },
                    enumerable: true,
                    configurable: true
                });
                Map.prototype.has = function (key) { return this._find(key, /*insert*/ false) >= 0; };
                Map.prototype.get = function (key) {
                    var index = this._find(key, /*insert*/ false);
                    return index >= 0 ? this._values[index] : undefined;
                };
                Map.prototype.set = function (key, value) {
                    var index = this._find(key, /*insert*/ true);
                    this._values[index] = value;
                    return this;
                };
                Map.prototype.delete = function (key) {
                    var index = this._find(key, /*insert*/ false);
                    if (index >= 0) {
                        var size = this._keys.length;
                        for (var i = index + 1; i < size; i++) {
                            this._keys[i - 1] = this._keys[i];
                            this._values[i - 1] = this._values[i];
                        }
                        this._keys.length--;
                        this._values.length--;
                        if (key === this._cacheKey) {
                            this._cacheKey = cacheSentinel;
                            this._cacheIndex = -2;
                        }
                        return true;
                    }
                    return false;
                };
                Map.prototype.clear = function () {
                    this._keys.length = 0;
                    this._values.length = 0;
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                };
                Map.prototype.keys = function () { return new MapIterator(this._keys, this._values, getKey); };
                Map.prototype.values = function () { return new MapIterator(this._keys, this._values, getValue); };
                Map.prototype.entries = function () { return new MapIterator(this._keys, this._values, getEntry); };
                Map.prototype["@@iterator"] = function () { return this.entries(); };
                Map.prototype[iteratorSymbol] = function () { return this.entries(); };
                Map.prototype._find = function (key, insert) {
                    if (this._cacheKey !== key) {
                        this._cacheIndex = this._keys.indexOf(this._cacheKey = key);
                    }
                    if (this._cacheIndex < 0 && insert) {
                        this._cacheIndex = this._keys.length;
                        this._keys.push(key);
                        this._values.push(undefined);
                    }
                    return this._cacheIndex;
                };
                return Map;
            }());
            function getKey(key, _) {
                return key;
            }
            function getValue(_, value) {
                return value;
            }
            function getEntry(key, value) {
                return [key, value];
            }
        }
        // naive Set shim
        function CreateSetPolyfill() {
            return (function () {
                function Set() {
                    this._map = new _Map();
                }
                Object.defineProperty(Set.prototype, "size", {
                    get: function () { return this._map.size; },
                    enumerable: true,
                    configurable: true
                });
                Set.prototype.has = function (value) { return this._map.has(value); };
                Set.prototype.add = function (value) { return this._map.set(value, value), this; };
                Set.prototype.delete = function (value) { return this._map.delete(value); };
                Set.prototype.clear = function () { this._map.clear(); };
                Set.prototype.keys = function () { return this._map.keys(); };
                Set.prototype.values = function () { return this._map.values(); };
                Set.prototype.entries = function () { return this._map.entries(); };
                Set.prototype["@@iterator"] = function () { return this.keys(); };
                Set.prototype[iteratorSymbol] = function () { return this.keys(); };
                return Set;
            }());
        }
        // naive WeakMap shim
        function CreateWeakMapPolyfill() {
            var UUID_SIZE = 16;
            var keys = HashMap.create();
            var rootKey = CreateUniqueKey();
            return (function () {
                function WeakMap() {
                    this._key = CreateUniqueKey();
                }
                WeakMap.prototype.has = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.has(table, this._key) : false;
                };
                WeakMap.prototype.get = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.get(table, this._key) : undefined;
                };
                WeakMap.prototype.set = function (target, value) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ true);
                    table[this._key] = value;
                    return this;
                };
                WeakMap.prototype.delete = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? delete table[this._key] : false;
                };
                WeakMap.prototype.clear = function () {
                    // NOTE: not a real clear, just makes the previous data unreachable
                    this._key = CreateUniqueKey();
                };
                return WeakMap;
            }());
            function CreateUniqueKey() {
                var key;
                do
                    key = "@@WeakMap@@" + CreateUUID();
                while (HashMap.has(keys, key));
                keys[key] = true;
                return key;
            }
            function GetOrCreateWeakMapTable(target, create) {
                if (!hasOwn.call(target, rootKey)) {
                    if (!create)
                        return undefined;
                    Object.defineProperty(target, rootKey, { value: HashMap.create() });
                }
                return target[rootKey];
            }
            function FillRandomBytes(buffer, size) {
                for (var i = 0; i < size; ++i)
                    buffer[i] = Math.random() * 0xff | 0;
                return buffer;
            }
            function GenRandomBytes(size) {
                if (typeof Uint8Array === "function") {
                    if (typeof crypto !== "undefined")
                        return crypto.getRandomValues(new Uint8Array(size));
                    if (typeof msCrypto !== "undefined")
                        return msCrypto.getRandomValues(new Uint8Array(size));
                    return FillRandomBytes(new Uint8Array(size), size);
                }
                return FillRandomBytes(new Array(size), size);
            }
            function CreateUUID() {
                var data = GenRandomBytes(UUID_SIZE);
                // mark as random - RFC 4122 § 4.4
                data[6] = data[6] & 0x4f | 0x40;
                data[8] = data[8] & 0xbf | 0x80;
                var result = "";
                for (var offset = 0; offset < UUID_SIZE; ++offset) {
                    var byte = data[offset];
                    if (offset === 4 || offset === 6 || offset === 8)
                        result += "-";
                    if (byte < 16)
                        result += "0";
                    result += byte.toString(16).toLowerCase();
                }
                return result;
            }
        }
        // uses a heuristic used by v8 and chakra to force an object into dictionary mode.
        function MakeDictionary(obj) {
            obj.__ = undefined;
            delete obj.__;
            return obj;
        }
    });
})(Reflect || (Reflect = {}));
//# sourceMappingURL=Reflect.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js"), __webpack_require__("./node_modules/react-scripts/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/reshow-constant/build/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UNDEFINED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FUNCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OBJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT; });
/* unused harmony export STRING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SYMBOL; });
/* unused harmony export SCRIPT */
var UNDEFINED = 'undefined';
var FUNCTION = 'function';
var OBJECT = 'object';
var DEFAULT = 'default';
var STRING = 'string';
var SYMBOL = 'symbol';
var SCRIPT = 'script';

/***/ }),

/***/ "./node_modules/reshow-flux-base/build/es/Dispatcher.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_classCallCheck__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_defineProperty__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/defineProperty.js");



var Dispatcher = function Dispatcher() {
  var _this = this;

  Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_classCallCheck__["a" /* default */])(this, Dispatcher);

  Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_defineProperty__["a" /* default */])(this, "cbs", []);

  Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_defineProperty__["a" /* default */])(this, "register", function (cb) {
    return _this.cbs.push(cb);
  });

  Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_defineProperty__["a" /* default */])(this, "dispatch", function (payload, params) {
    if (!payload) {
      payload = {};
    }

    if ('string' === typeof payload) {
      payload = {
        type: payload,
        params: params
      };

      if (!params) {
        delete payload.params;
      }
    }

    _this.cbs.forEach(function (c) {
      return c(payload);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Dispatcher);

/***/ }),

/***/ "./node_modules/reshow-flux-base/build/es/Store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_classCallCheck__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_createClass__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/createClass.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_defineProperty__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/defineProperty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mitt__ = __webpack_require__("./node_modules/reshow-flux-base/build/es/mitt.js");




var CHANGE = 'chg';

var Store =
/*#__PURE__*/
function () {
  Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_createClass__["a" /* default */])(Store, [{
    key: "reduce",
    value: function reduce() {
      console.error('Not override reduce().');
    }
  }, {
    key: "getInitialState",
    value: function getInitialState() {
      console.error('Not override getInitialState().');
    }
  }, {
    key: "equals",
    value: function equals(one, two) {
      return one === two;
    }
  }]);

  function Store(dispatcher) {
    var _this = this;

    Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_classCallCheck__["a" /* default */])(this, Store);

    Object(__WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_defineProperty__["a" /* default */])(this, "getState", function () {
      return _this._state;
    });

    Object(__WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_defineProperty__["a" /* default */])(this, "__invokeOnDispatch", function (action) {
      var startingState = _this._state;

      var endingState = _this.reduce(startingState, action);

      if (endingState === undefined) {
        console.error('reduce() return undefined.');
      }

      if (!_this.equals(startingState, endingState)) {
        _this._state = endingState;

        _this.emit(CHANGE);
      }

      var next = _this.nextEmits.slice(0);

      _this.nextEmits = [];
      next.forEach(function (emit) {
        return _this.emit(emit);
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_defineProperty__["a" /* default */])(this, "emit", function (e) {
      return _this.mitt.emit(e);
    });

    Object(__WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_defineProperty__["a" /* default */])(this, "addListener", function (listener, e) {
      return _this.mitt.on(e, listener);
    });

    Object(__WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_defineProperty__["a" /* default */])(this, "removeListener", function (listener, e) {
      return _this.mitt.off(e, listener);
    });

    dispatcher.register(this.__invokeOnDispatch);
    this._state = this.reset();
  }

  Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_createClass__["a" /* default */])(Store, [{
    key: "reset",
    value: function reset() {
      this.mitt = new __WEBPACK_IMPORTED_MODULE_3__mitt__["a" /* default */]();
      this.nextEmits = [];
      return this.getInitialState();
    }
    /* Following not extendable */

  }]);

  return Store;
}();

/* harmony default export */ __webpack_exports__["b"] = (Store);


/***/ }),

/***/ "./node_modules/reshow-flux-base/build/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Store__ = __webpack_require__("./node_modules/reshow-flux-base/build/es/Store.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Store__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Store__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dispatcher__ = __webpack_require__("./node_modules/reshow-flux-base/build/es/Dispatcher.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Dispatcher__["a"]; });



/***/ }),

/***/ "./node_modules/reshow-flux-base/build/es/mitt.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var type = function type(all) {
  return function (t) {
    return all[t] || (all[t] = []);
  };
};

var mitt = function mitt() {
  var all = type({});
  return {
    on: function on(t, handler) {
      return all(t).push(handler);
    },
    off: function off(t, handler) {
      return all(t).splice(all(t).indexOf(handler) >>> 0, 1);
    },
    emit: function emit(t, state) {
      for (var a = all(t).slice(), i = 0, j = a.length; i < j; i++) {
        a[i](state);
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (mitt);

/***/ }),

/***/ "./node_modules/reshow-flux/build/es/ReduceStore.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_classCallCheck__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_createClass__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/createClass.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_possibleConstructorReturn__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/possibleConstructorReturn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reshow_runtime_es_helpers_getPrototypeOf__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/getPrototypeOf.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reshow_runtime_es_helpers_inherits__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/inherits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reshow_runtime_es_helpers_assertThisInitialized__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/assertThisInitialized.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reshow_runtime_es_helpers_defineProperty__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/defineProperty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable__ = __webpack_require__("./node_modules/immutable/dist/immutable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_reshow_flux_base__ = __webpack_require__("./node_modules/reshow-flux-base/build/es/index.js");










var ReduceStore =
/*#__PURE__*/
function (_Store) {
  Object(__WEBPACK_IMPORTED_MODULE_4_reshow_runtime_es_helpers_inherits__["a" /* default */])(ReduceStore, _Store);

  function ReduceStore() {
    var _getPrototypeOf2;

    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_classCallCheck__["a" /* default */])(this, ReduceStore);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Object(__WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf2 = Object(__WEBPACK_IMPORTED_MODULE_3_reshow_runtime_es_helpers_getPrototypeOf__["a" /* default */])(ReduceStore)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Object(__WEBPACK_IMPORTED_MODULE_6_reshow_runtime_es_helpers_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5_reshow_runtime_es_helpers_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5_reshow_runtime_es_helpers_assertThisInitialized__["a" /* default */])(_this)), "getMap", function (k, state) {
      if (!state) {
        state = _this.getState();
      }

      var v = state.get(k);

      if (v && v.toJS) {
        v = v.toJS();
      }

      if (!v) {
        v = {};
      }

      return v;
    });

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_createClass__["a" /* default */])(ReduceStore, [{
    key: "getInitialState",
    value: function getInitialState() {
      return Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["Map"])();
    }
    /* Following not extendable */

  }]);

  return ReduceStore;
}(__WEBPACK_IMPORTED_MODULE_8_reshow_flux_base__["c" /* Store */]);

/* harmony default export */ __webpack_exports__["a"] = (ReduceStore);

/***/ }),

/***/ "./node_modules/reshow-flux/build/es/connect.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_objectSpread__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/objectSpread.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_classCallCheck__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_createClass__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/createClass.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reshow_runtime_es_helpers_possibleConstructorReturn__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/possibleConstructorReturn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reshow_runtime_es_helpers_inherits__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/inherits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reshow_runtime_es_helpers_getPrototypeOf__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/getPrototypeOf.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reshow_runtime_es_helpers_get__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reshow_runtime_es_helpers_assertThisInitialized__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/assertThisInitialized.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_reshow_runtime_es_helpers_defineProperty__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/defineProperty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_array_dedup__ = __webpack_require__("./node_modules/array.dedup/build/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_array_dedup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_array_dedup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_reshow_flux_base__ = __webpack_require__("./node_modules/reshow-flux-base/build/es/index.js");











var DEFAULT_OPTIONS = {
  withProps: false
};
var keys = Object.keys;

var connect = function connect(Base, options) {
  var thisOptions = DEFAULT_OPTIONS;

  if (options) {
    keys(options).forEach(function (key) {
      return thisOptions[key] = options[key];
    });
  }

  var getProps = function getProps(props) {
    return thisOptions.withProps ? props : undefined;
  };

  var getState = function getState(self, prevState, maybeProps) {
    return self.calculateState(prevState, getProps(maybeProps));
  };

  var getStores = function getStores(self, maybeProps) {
    return self.getStores(getProps(maybeProps));
  };

  var ConnectedClass =
  /*#__PURE__*/
  function (_Base) {
    Object(__WEBPACK_IMPORTED_MODULE_4_reshow_runtime_es_helpers_inherits__["a" /* default */])(ConnectedClass, _Base);

    function ConnectedClass(props) {
      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_classCallCheck__["a" /* default */])(this, ConnectedClass);

      _this = Object(__WEBPACK_IMPORTED_MODULE_3_reshow_runtime_es_helpers_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_5_reshow_runtime_es_helpers_getPrototypeOf__["a" /* default */])(ConnectedClass).call(this, props));

      Object(__WEBPACK_IMPORTED_MODULE_8_reshow_runtime_es_helpers_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7_reshow_runtime_es_helpers_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7_reshow_runtime_es_helpers_assertThisInitialized__["a" /* default */])(_this)), "__stores", []);

      Object(__WEBPACK_IMPORTED_MODULE_8_reshow_runtime_es_helpers_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7_reshow_runtime_es_helpers_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7_reshow_runtime_es_helpers_assertThisInitialized__["a" /* default */])(_this)), "__handleChange", function () {
        if (!_this.__stores) {
          // avoid race condition
          return;
        }

        var con = _this.constructor;

        _this.setState(function (prevState, currentProps) {
          return getState(con, prevState, currentProps);
        });
      });

      Object(__WEBPACK_IMPORTED_MODULE_8_reshow_runtime_es_helpers_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7_reshow_runtime_es_helpers_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7_reshow_runtime_es_helpers_assertThisInitialized__["a" /* default */])(_this)), "__setStores", function (stores) {
        if (_this.__stores) {
          _this.__resetStores();
        }

        stores = __WEBPACK_IMPORTED_MODULE_9_array_dedup___default()(stores);
        stores.forEach(function (store) {
          return store.addListener(_this.__handleChange, __WEBPACK_IMPORTED_MODULE_10_reshow_flux_base__["a" /* CHANGE */]);
        });
        _this.__stores = stores;
      });

      Object(__WEBPACK_IMPORTED_MODULE_8_reshow_runtime_es_helpers_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7_reshow_runtime_es_helpers_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7_reshow_runtime_es_helpers_assertThisInitialized__["a" /* default */])(_this)), "__resetStores", function () {
        if (!_this.__stores) {
          return;
        }

        _this.__stores.forEach(function (store) {
          return store.removeListener(_this.__handleChange, __WEBPACK_IMPORTED_MODULE_10_reshow_flux_base__["a" /* CHANGE */]);
        });

        _this.__stores = null;
      });

      var _con = _this.constructor;

      if (!_con.calculateState) {
        _con.calculateState = Object(__WEBPACK_IMPORTED_MODULE_6_reshow_runtime_es_helpers_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5_reshow_runtime_es_helpers_getPrototypeOf__["a" /* default */])(ConnectedClass.prototype), "calculateState", Object(__WEBPACK_IMPORTED_MODULE_7_reshow_runtime_es_helpers_assertThisInitialized__["a" /* default */])(_this));
        _con.getStores = Object(__WEBPACK_IMPORTED_MODULE_6_reshow_runtime_es_helpers_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5_reshow_runtime_es_helpers_getPrototypeOf__["a" /* default */])(ConnectedClass.prototype), "getStores", Object(__WEBPACK_IMPORTED_MODULE_7_reshow_runtime_es_helpers_assertThisInitialized__["a" /* default */])(_this));
      }

      if (props.withConstructor) {
        _this.__setStores(getStores(_con, props));
      }

      if (!_this.state) {
        _this.state = {};
      }

      if (!thisOptions.withProps) {
        var calculatedState = getState(_con, undefined, props);

        if (calculatedState) {
          keys(calculatedState).forEach(function (key) {
            return _this.state[key] = calculatedState[key];
          });
        }
      }

      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_createClass__["a" /* default */])(ConnectedClass, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (Object(__WEBPACK_IMPORTED_MODULE_6_reshow_runtime_es_helpers_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5_reshow_runtime_es_helpers_getPrototypeOf__["a" /* default */])(ConnectedClass.prototype), "componentDidMount", this)) {
          Object(__WEBPACK_IMPORTED_MODULE_6_reshow_runtime_es_helpers_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5_reshow_runtime_es_helpers_getPrototypeOf__["a" /* default */])(ConnectedClass.prototype), "componentDidMount", this).call(this);
        }

        if (this.props && !this.props.withConstructor) {
          this.__setStores(getStores(this.constructor, this.props));
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        if (Object(__WEBPACK_IMPORTED_MODULE_6_reshow_runtime_es_helpers_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5_reshow_runtime_es_helpers_getPrototypeOf__["a" /* default */])(ConnectedClass.prototype), "componentDidUpdate", this)) {
          Object(__WEBPACK_IMPORTED_MODULE_6_reshow_runtime_es_helpers_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5_reshow_runtime_es_helpers_getPrototypeOf__["a" /* default */])(ConnectedClass.prototype), "componentDidUpdate", this).call(this, prevProps, prevState);
        }

        if (thisOptions.withProps) {
          this.__setStores(getStores(this.constructor, this.props));
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (Object(__WEBPACK_IMPORTED_MODULE_6_reshow_runtime_es_helpers_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5_reshow_runtime_es_helpers_getPrototypeOf__["a" /* default */])(ConnectedClass.prototype), "componentWillUnmount", this)) {
          Object(__WEBPACK_IMPORTED_MODULE_6_reshow_runtime_es_helpers_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5_reshow_runtime_es_helpers_getPrototypeOf__["a" /* default */])(ConnectedClass.prototype), "componentWillUnmount", this).call(this);
        }

        this.__resetStores();
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(nextProps, prevState) {
        var thisStates = null;

        if (Object(__WEBPACK_IMPORTED_MODULE_6_reshow_runtime_es_helpers_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5_reshow_runtime_es_helpers_getPrototypeOf__["a" /* default */])(ConnectedClass), "getDerivedStateFromProps", this)) {
          thisStates = Object(__WEBPACK_IMPORTED_MODULE_6_reshow_runtime_es_helpers_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5_reshow_runtime_es_helpers_getPrototypeOf__["a" /* default */])(ConnectedClass), "getDerivedStateFromProps", this).call(this, nextProps, prevState);
        }

        if (thisOptions.withProps) {
          var calState = getState(ConnectedClass, Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_objectSpread__["a" /* default */])({}, prevState, thisStates), nextProps);
          thisStates = Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_objectSpread__["a" /* default */])({}, thisStates, calState);
        }

        return thisStates;
      }
    }]);

    return ConnectedClass;
  }(Base);

  var componentName = Base.displayName || Base.name;
  ConnectedClass.displayName = 'FluxConnected(' + componentName + ')';
  return ConnectedClass;
};

/* harmony default export */ __webpack_exports__["a"] = (connect);

/***/ }),

/***/ "./node_modules/reshow-flux/build/es/connectFunctional.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_classCallCheck__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_createClass__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/createClass.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_possibleConstructorReturn__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/possibleConstructorReturn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reshow_runtime_es_helpers_getPrototypeOf__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/getPrototypeOf.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reshow_runtime_es_helpers_inherits__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/inherits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__connect__ = __webpack_require__("./node_modules/reshow-flux/build/es/connect.js");








var connectFunctional = function connectFunctional(viewFn, _getStores, _calculateState, options) {
  var FunctionalConnected =
  /*#__PURE__*/
  function (_PureComponent) {
    Object(__WEBPACK_IMPORTED_MODULE_4_reshow_runtime_es_helpers_inherits__["a" /* default */])(FunctionalConnected, _PureComponent);

    function FunctionalConnected() {
      Object(__WEBPACK_IMPORTED_MODULE_0_reshow_runtime_es_helpers_classCallCheck__["a" /* default */])(this, FunctionalConnected);

      return Object(__WEBPACK_IMPORTED_MODULE_2_reshow_runtime_es_helpers_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_3_reshow_runtime_es_helpers_getPrototypeOf__["a" /* default */])(FunctionalConnected).apply(this, arguments));
    }

    Object(__WEBPACK_IMPORTED_MODULE_1_reshow_runtime_es_helpers_createClass__["a" /* default */])(FunctionalConnected, [{
      key: "render",
      value: function render() {
        return viewFn(this.state);
      }
    }], [{
      key: "getStores",
      value: function getStores(props) {
        return _getStores(props);
      }
    }, {
      key: "calculateState",
      value: function calculateState(prevState, props) {
        return _calculateState(prevState, props);
      }
    }]);

    return FunctionalConnected;
  }(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

  var viewFnName = viewFn.displayName || viewFn.name || 'FunctionalConnected';
  FunctionalConnected.displayName = viewFnName;
  return Object(__WEBPACK_IMPORTED_MODULE_6__connect__["a" /* default */])(FunctionalConnected, options);
};

/* unused harmony default export */ var _unused_webpack_default_export = (connectFunctional);

/***/ }),

/***/ "./node_modules/reshow-flux/build/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__connect__ = __webpack_require__("./node_modules/reshow-flux/build/es/connect.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__connect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__connectFunctional__ = __webpack_require__("./node_modules/reshow-flux/build/es/connectFunctional.js");
/* unused harmony reexport connectFunctional */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReduceStore__ = __webpack_require__("./node_modules/reshow-flux/build/es/ReduceStore.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__ReduceStore__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reshow_flux_base__ = __webpack_require__("./node_modules/reshow-flux-base/build/es/index.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3_reshow_flux_base__["b"]; });





/***/ }),

/***/ "./node_modules/reshow-runtime/es/helpers/assertThisInitialized.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__refError__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/refError.js");

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw Object(__WEBPACK_IMPORTED_MODULE_0__refError__["a" /* default */])();
  }

  return self;
}

/***/ }),

/***/ "./node_modules/reshow-runtime/es/helpers/classCallCheck.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

/* harmony default export */ __webpack_exports__["a"] = (classCallCheck);

/***/ }),

/***/ "./node_modules/reshow-runtime/es/helpers/createClass.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var defineProperties = function defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
};

var createClass = function createClass(Constructor, protoProps, staticProps) {
  if (protoProps) defineProperties(Constructor.prototype, protoProps);
  if (staticProps) defineProperties(Constructor, staticProps);
  return Constructor;
};

/* harmony default export */ __webpack_exports__["a"] = (createClass);

/***/ }),

/***/ "./node_modules/reshow-runtime/es/helpers/defineProperty.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _defineProperty = function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/* harmony default export */ __webpack_exports__["a"] = (_defineProperty);

/***/ }),

/***/ "./node_modules/reshow-runtime/es/helpers/extends.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/* harmony default export */ __webpack_exports__["a"] = (_extends);

/***/ }),

/***/ "./node_modules/reshow-runtime/es/helpers/get.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var get = function get(object, property, receiver) {
  if (object === null) {
    object = Function.prototype;
  }

  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ('value' in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (get);

/***/ }),

/***/ "./node_modules/reshow-runtime/es/helpers/getPrototypeOf.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "./node_modules/reshow-runtime/es/helpers/getTypeOf.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = '|number|string|boolean|object|function|undefined|';
/**
 * Do not use this.
 * The class name not reliable after code compress.
 */

var toBase = function toBase(type, name) {
  if (-1 === types.indexOf('|' + type + '|')) {
    if (!name) {
      name = type;
    }

    return name;
  } else {
    return type;
  }
};

var getTypeOf = function getTypeOf(val, name) {
  var type;

  try {
    type = Object.getPrototypeOf(val).constructor.name.toLowerCase();
    return toBase(type, name);
  } catch (ex) {
    type = Object.prototype.toString.call(val).replace(/^\[object\s(.*)\]$/, '$1').toLowerCase();
    return toBase(type, name);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getTypeOf);

/***/ }),

/***/ "./node_modules/reshow-runtime/es/helpers/inherits.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/setPrototypeOf.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_constant__ = __webpack_require__("./node_modules/reshow-constant/build/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getTypeOf__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/getTypeOf.js");



function _inherits(subClass, superClass) {
  if (Object(__WEBPACK_IMPORTED_MODULE_2__getTypeOf__["a" /* default */])(superClass) !== __WEBPACK_IMPORTED_MODULE_1_reshow_constant__["b" /* FUNCTION */] && superClass !== null) {
    throw new TypeError('Super must be null or a function');
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__["a" /* default */])(subClass, superClass);
}

/***/ }),

/***/ "./node_modules/reshow-runtime/es/helpers/objectSpread.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/defineProperty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getTypeOf__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/getTypeOf.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reshow_constant__ = __webpack_require__("./node_modules/reshow-constant/build/es/index.js");



function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (Object(__WEBPACK_IMPORTED_MODULE_1__getTypeOf__["a" /* default */])(Object.getOwnPropertySymbols) === __WEBPACK_IMPORTED_MODULE_2_reshow_constant__["b" /* FUNCTION */]) {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty__["a" /* default */])(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ "./node_modules/reshow-runtime/es/helpers/objectWithoutProperties.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/* harmony default export */ __webpack_exports__["a"] = (objectWithoutProperties);

/***/ }),

/***/ "./node_modules/reshow-runtime/es/helpers/possibleConstructorReturn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reshow_constant__ = __webpack_require__("./node_modules/reshow-constant/build/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getTypeOf__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/getTypeOf.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__refError__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/refError.js");



function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw Object(__WEBPACK_IMPORTED_MODULE_2__refError__["a" /* default */])();
  }

  var isObject = __WEBPACK_IMPORTED_MODULE_0_reshow_constant__["c" /* OBJECT */] === Object(__WEBPACK_IMPORTED_MODULE_1__getTypeOf__["a" /* default */])(call);
  return call && (isObject || Object(__WEBPACK_IMPORTED_MODULE_1__getTypeOf__["a" /* default */])(call) === __WEBPACK_IMPORTED_MODULE_0_reshow_constant__["b" /* FUNCTION */]) ? call : self;
}

/***/ }),

/***/ "./node_modules/reshow-runtime/es/helpers/refError.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var refError = function refError() {
  return new ReferenceError("this hasn't been initialised - super() hasn't been called");
};

/* harmony default export */ __webpack_exports__["a"] = (refError);

/***/ }),

/***/ "./node_modules/reshow-runtime/es/helpers/setPrototypeOf.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ "./node_modules/reshow-runtime/es/helpers/typeof.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTypeOf__ = __webpack_require__("./node_modules/reshow-runtime/es/helpers/getTypeOf.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reshow_constant__ = __webpack_require__("./node_modules/reshow-constant/build/es/index.js");



var _typeof = function _typeof(o) {
  return __WEBPACK_IMPORTED_MODULE_1_reshow_constant__["d" /* SYMBOL */] === Object(__WEBPACK_IMPORTED_MODULE_0__getTypeOf__["a" /* default */])(o) ? __WEBPACK_IMPORTED_MODULE_1_reshow_constant__["d" /* SYMBOL */] : Object(__WEBPACK_IMPORTED_MODULE_0__getTypeOf__["a" /* default */])(o, __WEBPACK_IMPORTED_MODULE_1_reshow_constant__["c" /* OBJECT */]);
};

/* harmony default export */ __webpack_exports__["a"] = (_typeof);

/***/ }),

/***/ "./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/react-scripts/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/rxjs/_esm5/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Observable", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_Observable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_observable_ConnectableObservable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/ConnectableObservable.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ConnectableObservable", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_observable_ConnectableObservable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_operators_groupBy__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/groupBy.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GroupedObservable", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_operators_groupBy__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_symbol_observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/symbol/observable.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "observable", function() { return __WEBPACK_IMPORTED_MODULE_3__internal_symbol_observable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_Subject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Subject", function() { return __WEBPACK_IMPORTED_MODULE_4__internal_Subject__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_BehaviorSubject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/BehaviorSubject.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BehaviorSubject", function() { return __WEBPACK_IMPORTED_MODULE_5__internal_BehaviorSubject__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_ReplaySubject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/ReplaySubject.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ReplaySubject", function() { return __WEBPACK_IMPORTED_MODULE_6__internal_ReplaySubject__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__internal_AsyncSubject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/AsyncSubject.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncSubject", function() { return __WEBPACK_IMPORTED_MODULE_7__internal_AsyncSubject__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__internal_scheduler_asap__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/asap.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "asapScheduler", function() { return __WEBPACK_IMPORTED_MODULE_8__internal_scheduler_asap__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__internal_scheduler_async__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "asyncScheduler", function() { return __WEBPACK_IMPORTED_MODULE_9__internal_scheduler_async__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__internal_scheduler_queue__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/queue.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "queueScheduler", function() { return __WEBPACK_IMPORTED_MODULE_10__internal_scheduler_queue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__internal_scheduler_animationFrame__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/animationFrame.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "animationFrameScheduler", function() { return __WEBPACK_IMPORTED_MODULE_11__internal_scheduler_animationFrame__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__internal_scheduler_VirtualTimeScheduler__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/VirtualTimeScheduler.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VirtualTimeScheduler", function() { return __WEBPACK_IMPORTED_MODULE_12__internal_scheduler_VirtualTimeScheduler__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VirtualAction", function() { return __WEBPACK_IMPORTED_MODULE_12__internal_scheduler_VirtualTimeScheduler__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__internal_Scheduler__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Scheduler.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scheduler", function() { return __WEBPACK_IMPORTED_MODULE_13__internal_Scheduler__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__internal_Subscription__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscription.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Subscription", function() { return __WEBPACK_IMPORTED_MODULE_14__internal_Subscription__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__internal_Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Subscriber", function() { return __WEBPACK_IMPORTED_MODULE_15__internal_Subscriber__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__internal_Notification__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Notification.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Notification", function() { return __WEBPACK_IMPORTED_MODULE_16__internal_Notification__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NotificationKind", function() { return __WEBPACK_IMPORTED_MODULE_16__internal_Notification__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__internal_util_pipe__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/pipe.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pipe", function() { return __WEBPACK_IMPORTED_MODULE_17__internal_util_pipe__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__internal_util_noop__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/noop.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return __WEBPACK_IMPORTED_MODULE_18__internal_util_noop__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__internal_util_identity__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/identity.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "identity", function() { return __WEBPACK_IMPORTED_MODULE_19__internal_util_identity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__internal_util_isObservable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isObservable.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isObservable", function() { return __WEBPACK_IMPORTED_MODULE_20__internal_util_isObservable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__internal_util_ArgumentOutOfRangeError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/ArgumentOutOfRangeError.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ArgumentOutOfRangeError", function() { return __WEBPACK_IMPORTED_MODULE_21__internal_util_ArgumentOutOfRangeError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__internal_util_EmptyError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/EmptyError.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EmptyError", function() { return __WEBPACK_IMPORTED_MODULE_22__internal_util_EmptyError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__internal_util_ObjectUnsubscribedError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/ObjectUnsubscribedError.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ObjectUnsubscribedError", function() { return __WEBPACK_IMPORTED_MODULE_23__internal_util_ObjectUnsubscribedError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__internal_util_UnsubscriptionError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/UnsubscriptionError.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UnsubscriptionError", function() { return __WEBPACK_IMPORTED_MODULE_24__internal_util_UnsubscriptionError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__internal_util_TimeoutError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/TimeoutError.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TimeoutError", function() { return __WEBPACK_IMPORTED_MODULE_25__internal_util_TimeoutError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__internal_observable_bindCallback__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/bindCallback.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindCallback", function() { return __WEBPACK_IMPORTED_MODULE_26__internal_observable_bindCallback__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__internal_observable_bindNodeCallback__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/bindNodeCallback.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindNodeCallback", function() { return __WEBPACK_IMPORTED_MODULE_27__internal_observable_bindNodeCallback__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__internal_observable_combineLatest__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/combineLatest.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineLatest", function() { return __WEBPACK_IMPORTED_MODULE_28__internal_observable_combineLatest__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__internal_observable_concat__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/concat.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "concat", function() { return __WEBPACK_IMPORTED_MODULE_29__internal_observable_concat__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__internal_observable_defer__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/defer.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defer", function() { return __WEBPACK_IMPORTED_MODULE_30__internal_observable_defer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__internal_observable_empty__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/empty.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "empty", function() { return __WEBPACK_IMPORTED_MODULE_31__internal_observable_empty__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__internal_observable_forkJoin__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/forkJoin.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "forkJoin", function() { return __WEBPACK_IMPORTED_MODULE_32__internal_observable_forkJoin__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__internal_observable_from__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/from.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "from", function() { return __WEBPACK_IMPORTED_MODULE_33__internal_observable_from__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__internal_observable_fromEvent__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/fromEvent.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fromEvent", function() { return __WEBPACK_IMPORTED_MODULE_34__internal_observable_fromEvent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__internal_observable_fromEventPattern__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/fromEventPattern.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fromEventPattern", function() { return __WEBPACK_IMPORTED_MODULE_35__internal_observable_fromEventPattern__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__internal_observable_generate__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/generate.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "generate", function() { return __WEBPACK_IMPORTED_MODULE_36__internal_observable_generate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__internal_observable_iif__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/iif.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "iif", function() { return __WEBPACK_IMPORTED_MODULE_37__internal_observable_iif__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__internal_observable_interval__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/interval.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interval", function() { return __WEBPACK_IMPORTED_MODULE_38__internal_observable_interval__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__internal_observable_merge__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/merge.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return __WEBPACK_IMPORTED_MODULE_39__internal_observable_merge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__internal_observable_never__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/never.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "never", function() { return __WEBPACK_IMPORTED_MODULE_40__internal_observable_never__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__internal_observable_of__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/of.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "of", function() { return __WEBPACK_IMPORTED_MODULE_41__internal_observable_of__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__internal_observable_onErrorResumeNext__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/onErrorResumeNext.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "onErrorResumeNext", function() { return __WEBPACK_IMPORTED_MODULE_42__internal_observable_onErrorResumeNext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__internal_observable_pairs__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/pairs.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pairs", function() { return __WEBPACK_IMPORTED_MODULE_43__internal_observable_pairs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__internal_observable_partition__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/partition.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "partition", function() { return __WEBPACK_IMPORTED_MODULE_44__internal_observable_partition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__internal_observable_race__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/race.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "race", function() { return __WEBPACK_IMPORTED_MODULE_45__internal_observable_race__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__internal_observable_range__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/range.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "range", function() { return __WEBPACK_IMPORTED_MODULE_46__internal_observable_range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__internal_observable_throwError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/throwError.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "throwError", function() { return __WEBPACK_IMPORTED_MODULE_47__internal_observable_throwError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__internal_observable_timer__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/timer.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timer", function() { return __WEBPACK_IMPORTED_MODULE_48__internal_observable_timer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__internal_observable_using__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/using.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "using", function() { return __WEBPACK_IMPORTED_MODULE_49__internal_observable_using__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__internal_observable_zip__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/zip.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return __WEBPACK_IMPORTED_MODULE_50__internal_observable_zip__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__internal_scheduled_scheduled__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduled/scheduled.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scheduled", function() { return __WEBPACK_IMPORTED_MODULE_51__internal_scheduled_scheduled__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EMPTY", function() { return __WEBPACK_IMPORTED_MODULE_31__internal_observable_empty__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NEVER", function() { return __WEBPACK_IMPORTED_MODULE_40__internal_observable_never__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__internal_config__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/config.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "config", function() { return __WEBPACK_IMPORTED_MODULE_52__internal_config__["a"]; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */























































//# sourceMappingURL=index.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/AsyncSubject.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsyncSubject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscription__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscription.js");
/** PURE_IMPORTS_START tslib,_Subject,_Subscription PURE_IMPORTS_END */



var AsyncSubject = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AsyncSubject, _super);
    function AsyncSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.value = null;
        _this.hasNext = false;
        _this.hasCompleted = false;
        return _this;
    }
    AsyncSubject.prototype._subscribe = function (subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return __WEBPACK_IMPORTED_MODULE_2__Subscription__["a" /* Subscription */].EMPTY;
        }
        else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return __WEBPACK_IMPORTED_MODULE_2__Subscription__["a" /* Subscription */].EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function (value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function (error) {
        if (!this.hasCompleted) {
            _super.prototype.error.call(this, error);
        }
    };
    AsyncSubject.prototype.complete = function () {
        this.hasCompleted = true;
        if (this.hasNext) {
            _super.prototype.next.call(this, this.value);
        }
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}(__WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]));

//# sourceMappingURL=AsyncSubject.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/BehaviorSubject.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BehaviorSubject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ObjectUnsubscribedError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/ObjectUnsubscribedError.js");
/** PURE_IMPORTS_START tslib,_Subject,_util_ObjectUnsubscribedError PURE_IMPORTS_END */



var BehaviorSubject = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function () {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function (subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) {
            subscriber.next(this._value);
        }
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function () {
        if (this.hasError) {
            throw this.thrownError;
        }
        else if (this.closed) {
            throw new __WEBPACK_IMPORTED_MODULE_2__util_ObjectUnsubscribedError__["a" /* ObjectUnsubscribedError */]();
        }
        else {
            return this._value;
        }
    };
    BehaviorSubject.prototype.next = function (value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}(__WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]));

//# sourceMappingURL=BehaviorSubject.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/InnerSubscriber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InnerSubscriber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


var InnerSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        _this.index = 0;
        return _this;
    }
    InnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));

//# sourceMappingURL=InnerSubscriber.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/Notification.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NotificationKind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Notification; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_empty__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/empty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__observable_of__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/of.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__observable_throwError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/throwError.js");
/** PURE_IMPORTS_START _observable_empty,_observable_of,_observable_throwError PURE_IMPORTS_END */



var NotificationKind;
/*@__PURE__*/ (function (NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})(NotificationKind || (NotificationKind = {}));
var Notification = /*@__PURE__*/ (function () {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    Notification.prototype.observe = function (observer) {
        switch (this.kind) {
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    Notification.prototype.do = function (next, error, complete) {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    Notification.prototype.accept = function (nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
            return this.observe(nextOrObserver);
        }
        else {
            return this.do(nextOrObserver, error, complete);
        }
    };
    Notification.prototype.toObservable = function () {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return Object(__WEBPACK_IMPORTED_MODULE_1__observable_of__["a" /* of */])(this.value);
            case 'E':
                return Object(__WEBPACK_IMPORTED_MODULE_2__observable_throwError__["a" /* throwError */])(this.error);
            case 'C':
                return Object(__WEBPACK_IMPORTED_MODULE_0__observable_empty__["b" /* empty */])();
        }
        throw new Error('unexpected notification kind value');
    };
    Notification.createNext = function (value) {
        if (typeof value !== 'undefined') {
            return new Notification('N', value);
        }
        return Notification.undefinedValueNotification;
    };
    Notification.createError = function (err) {
        return new Notification('E', undefined, err);
    };
    Notification.createComplete = function () {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}());

//# sourceMappingURL=Notification.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/Observable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Observable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_canReportError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/canReportError.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_toSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/toSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/symbol/observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_pipe__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/pipe.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/config.js");
/** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */





var Observable = /*@__PURE__*/ (function () {
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = Object(__WEBPACK_IMPORTED_MODULE_1__util_toSubscriber__["a" /* toSubscriber */])(observerOrNext, error, complete);
        if (operator) {
            sink.add(operator.call(sink, this.source));
        }
        else {
            sink.add(this.source || (__WEBPACK_IMPORTED_MODULE_4__config__["a" /* config */].useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable) ?
                this._subscribe(sink) :
                this._trySubscribe(sink));
        }
        if (__WEBPACK_IMPORTED_MODULE_4__config__["a" /* config */].useDeprecatedSynchronousErrorHandling) {
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) {
                    throw sink.syncErrorValue;
                }
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            if (__WEBPACK_IMPORTED_MODULE_4__config__["a" /* config */].useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_0__util_canReportError__["a" /* canReportError */])(sink)) {
                sink.error(err);
            }
            else {
                console.warn(err);
            }
        }
    };
    Observable.prototype.forEach = function (next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var subscription;
            subscription = _this.subscribe(function (value) {
                try {
                    next(value);
                }
                catch (err) {
                    reject(err);
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
    };
    Observable.prototype[__WEBPACK_IMPORTED_MODULE_2__symbol_observable__["a" /* observable */]] = function () {
        return this;
    };
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i] = arguments[_i];
        }
        if (operations.length === 0) {
            return this;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_3__util_pipe__["b" /* pipeFromArray */])(operations)(this);
    };
    Observable.prototype.toPromise = function (promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());

function getPromiseCtor(promiseCtor) {
    if (!promiseCtor) {
        promiseCtor = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* config */].Promise || Promise;
    }
    if (!promiseCtor) {
        throw new Error('no Promise impl found');
    }
    return promiseCtor;
}
//# sourceMappingURL=Observable.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/Observer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return empty; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_hostReportError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/hostReportError.js");
/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */


var empty = {
    closed: true,
    next: function (value) { },
    error: function (err) {
        if (__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].useDeprecatedSynchronousErrorHandling) {
            throw err;
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_1__util_hostReportError__["a" /* hostReportError */])(err);
        }
    },
    complete: function () { }
};
//# sourceMappingURL=Observer.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/OuterSubscriber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OuterSubscriber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


var OuterSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](OuterSubscriber, _super);
    function OuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));

//# sourceMappingURL=OuterSubscriber.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/ReplaySubject.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReplaySubject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler_queue__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/queue.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscription__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscription.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__operators_observeOn__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/observeOn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_ObjectUnsubscribedError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/ObjectUnsubscribedError.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubjectSubscription__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/SubjectSubscription.js");
/** PURE_IMPORTS_START tslib,_Subject,_scheduler_queue,_Subscription,_operators_observeOn,_util_ObjectUnsubscribedError,_SubjectSubscription PURE_IMPORTS_END */







var ReplaySubject = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) {
            bufferSize = Number.POSITIVE_INFINITY;
        }
        if (windowTime === void 0) {
            windowTime = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this) || this;
        _this.scheduler = scheduler;
        _this._events = [];
        _this._infiniteTimeWindow = false;
        _this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        _this._windowTime = windowTime < 1 ? 1 : windowTime;
        if (windowTime === Number.POSITIVE_INFINITY) {
            _this._infiniteTimeWindow = true;
            _this.next = _this.nextInfiniteTimeWindow;
        }
        else {
            _this.next = _this.nextTimeWindow;
        }
        return _this;
    }
    ReplaySubject.prototype.nextInfiniteTimeWindow = function (value) {
        var _events = this._events;
        _events.push(value);
        if (_events.length > this._bufferSize) {
            _events.shift();
        }
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype.nextTimeWindow = function (value) {
        this._events.push(new ReplayEvent(this._getNow(), value));
        this._trimBufferThenGetEvents();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function (subscriber) {
        var _infiniteTimeWindow = this._infiniteTimeWindow;
        var _events = _infiniteTimeWindow ? this._events : this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var len = _events.length;
        var subscription;
        if (this.closed) {
            throw new __WEBPACK_IMPORTED_MODULE_5__util_ObjectUnsubscribedError__["a" /* ObjectUnsubscribedError */]();
        }
        else if (this.isStopped || this.hasError) {
            subscription = __WEBPACK_IMPORTED_MODULE_3__Subscription__["a" /* Subscription */].EMPTY;
        }
        else {
            this.observers.push(subscriber);
            subscription = new __WEBPACK_IMPORTED_MODULE_6__SubjectSubscription__["a" /* SubjectSubscription */](this, subscriber);
        }
        if (scheduler) {
            subscriber.add(subscriber = new __WEBPACK_IMPORTED_MODULE_4__operators_observeOn__["a" /* ObserveOnSubscriber */](subscriber, scheduler));
        }
        if (_infiniteTimeWindow) {
            for (var i = 0; i < len && !subscriber.closed; i++) {
                subscriber.next(_events[i]);
            }
        }
        else {
            for (var i = 0; i < len && !subscriber.closed; i++) {
                subscriber.next(_events[i].value);
            }
        }
        if (this.hasError) {
            subscriber.error(this.thrownError);
        }
        else if (this.isStopped) {
            subscriber.complete();
        }
        return subscription;
    };
    ReplaySubject.prototype._getNow = function () {
        return (this.scheduler || __WEBPACK_IMPORTED_MODULE_2__scheduler_queue__["a" /* queue */]).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function () {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        while (spliceCount < eventsCount) {
            if ((now - _events[spliceCount].time) < _windowTime) {
                break;
            }
            spliceCount++;
        }
        if (eventsCount > _bufferSize) {
            spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        }
        if (spliceCount > 0) {
            _events.splice(0, spliceCount);
        }
        return _events;
    };
    return ReplaySubject;
}(__WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]));

var ReplayEvent = /*@__PURE__*/ (function () {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}());
//# sourceMappingURL=ReplaySubject.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/Scheduler.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scheduler; });
var Scheduler = /*@__PURE__*/ (function () {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) {
            now = Scheduler.now;
        }
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    Scheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) {
            delay = 0;
        }
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = function () { return Date.now(); };
    return Scheduler;
}());

//# sourceMappingURL=Scheduler.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/Subject.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SubjectSubscriber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subject; });
/* unused harmony export AnonymousSubject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscription__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscription.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ObjectUnsubscribedError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/ObjectUnsubscribedError.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SubjectSubscription__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/SubjectSubscription.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_symbol_rxSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/symbol/rxSubscriber.js");
/** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */







var SubjectSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        return _this;
    }
    return SubjectSubscriber;
}(__WEBPACK_IMPORTED_MODULE_2__Subscriber__["a" /* Subscriber */]));

var Subject = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.observers = [];
        _this.closed = false;
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype[__WEBPACK_IMPORTED_MODULE_6__internal_symbol_rxSubscriber__["a" /* rxSubscriber */]] = function () {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function (operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function (value) {
        if (this.closed) {
            throw new __WEBPACK_IMPORTED_MODULE_4__util_ObjectUnsubscribedError__["a" /* ObjectUnsubscribedError */]();
        }
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].next(value);
            }
        }
    };
    Subject.prototype.error = function (err) {
        if (this.closed) {
            throw new __WEBPACK_IMPORTED_MODULE_4__util_ObjectUnsubscribedError__["a" /* ObjectUnsubscribedError */]();
        }
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].error(err);
        }
        this.observers.length = 0;
    };
    Subject.prototype.complete = function () {
        if (this.closed) {
            throw new __WEBPACK_IMPORTED_MODULE_4__util_ObjectUnsubscribedError__["a" /* ObjectUnsubscribedError */]();
        }
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].complete();
        }
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function () {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function (subscriber) {
        if (this.closed) {
            throw new __WEBPACK_IMPORTED_MODULE_4__util_ObjectUnsubscribedError__["a" /* ObjectUnsubscribedError */]();
        }
        else {
            return _super.prototype._trySubscribe.call(this, subscriber);
        }
    };
    Subject.prototype._subscribe = function (subscriber) {
        if (this.closed) {
            throw new __WEBPACK_IMPORTED_MODULE_4__util_ObjectUnsubscribedError__["a" /* ObjectUnsubscribedError */]();
        }
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return __WEBPACK_IMPORTED_MODULE_3__Subscription__["a" /* Subscription */].EMPTY;
        }
        else if (this.isStopped) {
            subscriber.complete();
            return __WEBPACK_IMPORTED_MODULE_3__Subscription__["a" /* Subscription */].EMPTY;
        }
        else {
            this.observers.push(subscriber);
            return new __WEBPACK_IMPORTED_MODULE_5__SubjectSubscription__["a" /* SubjectSubscription */](this, subscriber);
        }
    };
    Subject.prototype.asObservable = function () {
        var observable = new __WEBPACK_IMPORTED_MODULE_1__Observable__["a" /* Observable */]();
        observable.source = this;
        return observable;
    };
    Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}(__WEBPACK_IMPORTED_MODULE_1__Observable__["a" /* Observable */]));

var AnonymousSubject = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function (value) {
        var destination = this.destination;
        if (destination && destination.next) {
            destination.next(value);
        }
    };
    AnonymousSubject.prototype.error = function (err) {
        var destination = this.destination;
        if (destination && destination.error) {
            this.destination.error(err);
        }
    };
    AnonymousSubject.prototype.complete = function () {
        var destination = this.destination;
        if (destination && destination.complete) {
            this.destination.complete();
        }
    };
    AnonymousSubject.prototype._subscribe = function (subscriber) {
        var source = this.source;
        if (source) {
            return this.source.subscribe(subscriber);
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_3__Subscription__["a" /* Subscription */].EMPTY;
        }
    };
    return AnonymousSubject;
}(Subject));

//# sourceMappingURL=Subject.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/SubjectSubscription.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SubjectSubscription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscription.js");
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */


var SubjectSubscription = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        var _this = _super.call(this) || this;
        _this.subject = subject;
        _this.subscriber = subscriber;
        _this.closed = false;
        return _this;
    }
    SubjectSubscription.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
            return;
        }
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) {
            observers.splice(subscriberIndex, 1);
        }
    };
    return SubjectSubscription;
}(__WEBPACK_IMPORTED_MODULE_1__Subscription__["a" /* Subscription */]));

//# sourceMappingURL=SubjectSubscription.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/Subscriber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscriber; });
/* unused harmony export SafeSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isFunction__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isFunction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Observer__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscription__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscription.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_symbol_rxSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/symbol/rxSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_hostReportError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/hostReportError.js");
/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */







var Subscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Subscriber, _super);
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.syncErrorValue = null;
        _this.syncErrorThrown = false;
        _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch (arguments.length) {
            case 0:
                _this.destination = __WEBPACK_IMPORTED_MODULE_2__Observer__["a" /* empty */];
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = __WEBPACK_IMPORTED_MODULE_2__Observer__["a" /* empty */];
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    if (destinationOrNext instanceof Subscriber) {
                        _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                        _this.destination = destinationOrNext;
                        destinationOrNext.add(_this);
                    }
                    else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new SafeSubscriber(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.prototype[__WEBPACK_IMPORTED_MODULE_4__internal_symbol_rxSubscriber__["a" /* rxSubscriber */]] = function () { return this; };
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function () {
        var _parentOrParents = this._parentOrParents;
        this._parentOrParents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parentOrParents = _parentOrParents;
        return this;
    };
    return Subscriber;
}(__WEBPACK_IMPORTED_MODULE_3__Subscription__["a" /* Subscription */]));

var SafeSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isFunction__["a" /* isFunction */])(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== __WEBPACK_IMPORTED_MODULE_2__Observer__["a" /* empty */]) {
                context = Object.create(observerOrNext);
                if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isFunction__["a" /* isFunction */])(context.unsubscribe)) {
                    _this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = _this.unsubscribe.bind(_this);
            }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            var useDeprecatedSynchronousErrorHandling = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].useDeprecatedSynchronousErrorHandling;
            if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) {
                    throw err;
                }
                Object(__WEBPACK_IMPORTED_MODULE_6__util_hostReportError__["a" /* hostReportError */])(err);
            }
            else {
                if (useDeprecatedSynchronousErrorHandling) {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                }
                else {
                    Object(__WEBPACK_IMPORTED_MODULE_6__util_hostReportError__["a" /* hostReportError */])(err);
                }
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function () { return _this._complete.call(_this._context); };
                if (!__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            if (__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].useDeprecatedSynchronousErrorHandling) {
                throw err;
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_6__util_hostReportError__["a" /* hostReportError */])(err);
            }
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        if (!__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].useDeprecatedSynchronousErrorHandling) {
            throw new Error('bad call');
        }
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            if (__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_6__util_hostReportError__["a" /* hostReportError */])(err);
                return true;
            }
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function () {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber));

//# sourceMappingURL=Subscriber.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/Subscription.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_isArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isObject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isFunction__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isFunction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_UnsubscriptionError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/UnsubscriptionError.js");
/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */




var Subscription = /*@__PURE__*/ (function () {
    function Subscription(unsubscribe) {
        this.closed = false;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._unsubscribe = unsubscribe;
        }
    }
    Subscription.prototype.unsubscribe = function () {
        var errors;
        if (this.closed) {
            return;
        }
        var _a = this, _parentOrParents = _a._parentOrParents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (_parentOrParents instanceof Subscription) {
            _parentOrParents.remove(this);
        }
        else if (_parentOrParents !== null) {
            for (var index = 0; index < _parentOrParents.length; ++index) {
                var parent_1 = _parentOrParents[index];
                parent_1.remove(this);
            }
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_2__util_isFunction__["a" /* isFunction */])(_unsubscribe)) {
            try {
                _unsubscribe.call(this);
            }
            catch (e) {
                errors = e instanceof __WEBPACK_IMPORTED_MODULE_3__util_UnsubscriptionError__["a" /* UnsubscriptionError */] ? flattenUnsubscriptionErrors(e.errors) : [e];
            }
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util_isArray__["a" /* isArray */])(_subscriptions)) {
            var index = -1;
            var len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isObject__["a" /* isObject */])(sub)) {
                    try {
                        sub.unsubscribe();
                    }
                    catch (e) {
                        errors = errors || [];
                        if (e instanceof __WEBPACK_IMPORTED_MODULE_3__util_UnsubscriptionError__["a" /* UnsubscriptionError */]) {
                            errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
                        }
                        else {
                            errors.push(e);
                        }
                    }
                }
            }
        }
        if (errors) {
            throw new __WEBPACK_IMPORTED_MODULE_3__util_UnsubscriptionError__["a" /* UnsubscriptionError */](errors);
        }
    };
    Subscription.prototype.add = function (teardown) {
        var subscription = teardown;
        if (!teardown) {
            return Subscription.EMPTY;
        }
        switch (typeof teardown) {
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== 'function') {
                    return subscription;
                }
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                }
                else if (!(subscription instanceof Subscription)) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [tmp];
                }
                break;
            default: {
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
            }
        }
        var _parentOrParents = subscription._parentOrParents;
        if (_parentOrParents === null) {
            subscription._parentOrParents = this;
        }
        else if (_parentOrParents instanceof Subscription) {
            if (_parentOrParents === this) {
                return subscription;
            }
            subscription._parentOrParents = [_parentOrParents, this];
        }
        else if (_parentOrParents.indexOf(this) === -1) {
            _parentOrParents.push(this);
        }
        else {
            return subscription;
        }
        var subscriptions = this._subscriptions;
        if (subscriptions === null) {
            this._subscriptions = [subscription];
        }
        else {
            subscriptions.push(subscription);
        }
        return subscription;
    };
    Subscription.prototype.remove = function (subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());

function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function (errs, err) { return errs.concat((err instanceof __WEBPACK_IMPORTED_MODULE_3__util_UnsubscriptionError__["a" /* UnsubscriptionError */]) ? err.errors : err); }, []);
}
//# sourceMappingURL=Subscription.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var _enable_super_gross_mode_that_will_cause_bad_things = false;
var config = {
    Promise: undefined,
    set useDeprecatedSynchronousErrorHandling(value) {
        if (value) {
            var error = /*@__PURE__*/ new Error();
            /*@__PURE__*/ console.warn('DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n' + error.stack);
        }
        else if (_enable_super_gross_mode_that_will_cause_bad_things) {
            /*@__PURE__*/ console.log('RxJS: Back to a better error behavior. Thank you. <3');
        }
        _enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling() {
        return _enable_super_gross_mode_that_will_cause_bad_things;
    },
};
//# sourceMappingURL=config.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/ConnectableObservable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConnectableObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return connectableObservableDescriptor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Subscription__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscription.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__operators_refCount__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/refCount.js");
/** PURE_IMPORTS_START tslib,_Subject,_Observable,_Subscriber,_Subscription,_operators_refCount PURE_IMPORTS_END */






var ConnectableObservable = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._refCount = 0;
        _this._isComplete = false;
        return _this;
    }
    ConnectableObservable.prototype._subscribe = function (subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function () {
        var subject = this._subject;
        if (!subject || subject.isStopped) {
            this._subject = this.subjectFactory();
        }
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function () {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new __WEBPACK_IMPORTED_MODULE_4__Subscription__["a" /* Subscription */]();
            connection.add(this.source
                .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = __WEBPACK_IMPORTED_MODULE_4__Subscription__["a" /* Subscription */].EMPTY;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_5__operators_refCount__["a" /* refCount */])()(this);
    };
    return ConnectableObservable;
}(__WEBPACK_IMPORTED_MODULE_2__Observable__["a" /* Observable */]));

var connectableProto = ConnectableObservable.prototype;
var connectableObservableDescriptor = {
    operator: { value: null },
    _refCount: { value: 0, writable: true },
    _subject: { value: null, writable: true },
    _connection: { value: null, writable: true },
    _subscribe: { value: connectableProto._subscribe },
    _isComplete: { value: connectableProto._isComplete, writable: true },
    getSubject: { value: connectableProto.getSubject },
    connect: { value: connectableProto.connect },
    refCount: { value: connectableProto.refCount }
};
var ConnectableSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    ConnectableSubscriber.prototype._error = function (err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function () {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    ConnectableSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) {
                connection.unsubscribe();
            }
        }
    };
    return ConnectableSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subject__["b" /* SubjectSubscriber */]));
var RefCountOperator = /*@__PURE__*/ (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=ConnectableObservable.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/SubscribeOnObservable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SubscribeOnObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler_asap__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/asap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_isNumeric__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isNumeric.js");
/** PURE_IMPORTS_START tslib,_Observable,_scheduler_asap,_util_isNumeric PURE_IMPORTS_END */




var SubscribeOnObservable = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SubscribeOnObservable, _super);
    function SubscribeOnObservable(source, delayTime, scheduler) {
        if (delayTime === void 0) {
            delayTime = 0;
        }
        if (scheduler === void 0) {
            scheduler = __WEBPACK_IMPORTED_MODULE_2__scheduler_asap__["a" /* asap */];
        }
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.delayTime = delayTime;
        _this.scheduler = scheduler;
        if (!Object(__WEBPACK_IMPORTED_MODULE_3__util_isNumeric__["a" /* isNumeric */])(delayTime) || delayTime < 0) {
            _this.delayTime = 0;
        }
        if (!scheduler || typeof scheduler.schedule !== 'function') {
            _this.scheduler = __WEBPACK_IMPORTED_MODULE_2__scheduler_asap__["a" /* asap */];
        }
        return _this;
    }
    SubscribeOnObservable.create = function (source, delay, scheduler) {
        if (delay === void 0) {
            delay = 0;
        }
        if (scheduler === void 0) {
            scheduler = __WEBPACK_IMPORTED_MODULE_2__scheduler_asap__["a" /* asap */];
        }
        return new SubscribeOnObservable(source, delay, scheduler);
    };
    SubscribeOnObservable.dispatch = function (arg) {
        var source = arg.source, subscriber = arg.subscriber;
        return this.add(source.subscribe(subscriber));
    };
    SubscribeOnObservable.prototype._subscribe = function (subscriber) {
        var delay = this.delayTime;
        var source = this.source;
        var scheduler = this.scheduler;
        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
            source: source, subscriber: subscriber
        });
    };
    return SubscribeOnObservable;
}(__WEBPACK_IMPORTED_MODULE_1__Observable__["a" /* Observable */]));

//# sourceMappingURL=SubscribeOnObservable.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/bindCallback.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindCallback;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncSubject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/AsyncSubject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operators_map__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_canReportError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/canReportError.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_isArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_isScheduler__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isScheduler.js");
/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_canReportError,_util_isArray,_util_isScheduler PURE_IMPORTS_END */






function bindCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if (Object(__WEBPACK_IMPORTED_MODULE_5__util_isScheduler__["a" /* isScheduler */])(resultSelector)) {
            scheduler = resultSelector;
        }
        else {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return bindCallback(callbackFunc, scheduler).apply(void 0, args).pipe(Object(__WEBPACK_IMPORTED_MODULE_2__operators_map__["a" /* map */])(function (args) { return Object(__WEBPACK_IMPORTED_MODULE_4__util_isArray__["a" /* isArray */])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
            };
        }
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var context = this;
        var subject;
        var params = {
            context: context,
            subject: subject,
            callbackFunc: callbackFunc,
            scheduler: scheduler,
        };
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
            if (!scheduler) {
                if (!subject) {
                    subject = new __WEBPACK_IMPORTED_MODULE_1__AsyncSubject__["a" /* AsyncSubject */]();
                    var handler = function () {
                        var innerArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            innerArgs[_i] = arguments[_i];
                        }
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([handler]));
                    }
                    catch (err) {
                        if (Object(__WEBPACK_IMPORTED_MODULE_3__util_canReportError__["a" /* canReportError */])(subject)) {
                            subject.error(err);
                        }
                        else {
                            console.warn(err);
                        }
                    }
                }
                return subject.subscribe(subscriber);
            }
            else {
                var state = {
                    args: args, subscriber: subscriber, params: params,
                };
                return scheduler.schedule(dispatch, 0, state);
            }
        });
    };
}
function dispatch(state) {
    var _this = this;
    var self = this;
    var args = state.args, subscriber = state.subscriber, params = state.params;
    var callbackFunc = params.callbackFunc, context = params.context, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new __WEBPACK_IMPORTED_MODULE_1__AsyncSubject__["a" /* AsyncSubject */]();
        var handler = function () {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i] = arguments[_i];
            }
            var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
            _this.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
        };
        try {
            callbackFunc.apply(context, args.concat([handler]));
        }
        catch (err) {
            subject.error(err);
        }
    }
    this.add(subject.subscribe(subscriber));
}
function dispatchNext(state) {
    var value = state.value, subject = state.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(state) {
    var err = state.err, subject = state.subject;
    subject.error(err);
}
//# sourceMappingURL=bindCallback.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/bindNodeCallback.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindNodeCallback;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncSubject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/AsyncSubject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operators_map__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_canReportError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/canReportError.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_isScheduler__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isScheduler.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_isArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isArray.js");
/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_canReportError,_util_isScheduler,_util_isArray PURE_IMPORTS_END */






function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if (Object(__WEBPACK_IMPORTED_MODULE_4__util_isScheduler__["a" /* isScheduler */])(resultSelector)) {
            scheduler = resultSelector;
        }
        else {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return bindNodeCallback(callbackFunc, scheduler).apply(void 0, args).pipe(Object(__WEBPACK_IMPORTED_MODULE_2__operators_map__["a" /* map */])(function (args) { return Object(__WEBPACK_IMPORTED_MODULE_5__util_isArray__["a" /* isArray */])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
            };
        }
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var params = {
            subject: undefined,
            args: args,
            callbackFunc: callbackFunc,
            scheduler: scheduler,
            context: this,
        };
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
            var context = params.context;
            var subject = params.subject;
            if (!scheduler) {
                if (!subject) {
                    subject = params.subject = new __WEBPACK_IMPORTED_MODULE_1__AsyncSubject__["a" /* AsyncSubject */]();
                    var handler = function () {
                        var innerArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            innerArgs[_i] = arguments[_i];
                        }
                        var err = innerArgs.shift();
                        if (err) {
                            subject.error(err);
                            return;
                        }
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([handler]));
                    }
                    catch (err) {
                        if (Object(__WEBPACK_IMPORTED_MODULE_3__util_canReportError__["a" /* canReportError */])(subject)) {
                            subject.error(err);
                        }
                        else {
                            console.warn(err);
                        }
                    }
                }
                return subject.subscribe(subscriber);
            }
            else {
                return scheduler.schedule(dispatch, 0, { params: params, subscriber: subscriber, context: context });
            }
        });
    };
}
function dispatch(state) {
    var _this = this;
    var params = state.params, subscriber = state.subscriber, context = state.context;
    var callbackFunc = params.callbackFunc, args = params.args, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new __WEBPACK_IMPORTED_MODULE_1__AsyncSubject__["a" /* AsyncSubject */]();
        var handler = function () {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i] = arguments[_i];
            }
            var err = innerArgs.shift();
            if (err) {
                _this.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
            }
            else {
                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                _this.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
            }
        };
        try {
            callbackFunc.apply(context, args.concat([handler]));
        }
        catch (err) {
            this.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
        }
    }
    this.add(subject.subscribe(subscriber));
}
function dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}
//# sourceMappingURL=bindNodeCallback.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/combineLatest.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = combineLatest;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CombineLatestOperator; });
/* unused harmony export CombineLatestSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isScheduler__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isScheduler.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fromArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/fromArray.js");
/** PURE_IMPORTS_START tslib,_util_isScheduler,_util_isArray,_OuterSubscriber,_util_subscribeToResult,_fromArray PURE_IMPORTS_END */






var NONE = {};
function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var resultSelector = null;
    var scheduler = null;
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isScheduler__["a" /* isScheduler */])(observables[observables.length - 1])) {
        scheduler = observables.pop();
    }
    if (typeof observables[observables.length - 1] === 'function') {
        resultSelector = observables.pop();
    }
    if (observables.length === 1 && Object(__WEBPACK_IMPORTED_MODULE_2__util_isArray__["a" /* isArray */])(observables[0])) {
        observables = observables[0];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_5__fromArray__["a" /* fromArray */])(observables, scheduler).lift(new CombineLatestOperator(resultSelector));
}
var CombineLatestOperator = /*@__PURE__*/ (function () {
    function CombineLatestOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    CombineLatestOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CombineLatestSubscriber(subscriber, this.resultSelector));
    };
    return CombineLatestOperator;
}());

var CombineLatestSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, resultSelector) {
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.active = 0;
        _this.values = [];
        _this.observables = [];
        return _this;
    }
    CombineLatestSubscriber.prototype._next = function (observable) {
        this.values.push(NONE);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            this.active = len;
            this.toRespond = len;
            for (var i = 0; i < len; i++) {
                var observable = observables[i];
                this.add(Object(__WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__["a" /* subscribeToResult */])(this, observable, observable, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
        if ((this.active -= 1) === 0) {
            this.destination.complete();
        }
    };
    CombineLatestSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond
            ? 0
            : oldVal === NONE ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.resultSelector) {
                this._tryResultSelector(values);
            }
            else {
                this.destination.next(values.slice());
            }
        }
    };
    CombineLatestSubscriber.prototype._tryResultSelector = function (values) {
        var result;
        try {
            result = this.resultSelector.apply(this, values);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__["a" /* OuterSubscriber */]));

//# sourceMappingURL=combineLatest.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/concat.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = concat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__of__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/of.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__operators_concatAll__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/concatAll.js");
/** PURE_IMPORTS_START _of,_operators_concatAll PURE_IMPORTS_END */


function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_1__operators_concatAll__["a" /* concatAll */])()(__WEBPACK_IMPORTED_MODULE_0__of__["a" /* of */].apply(void 0, observables));
}
//# sourceMappingURL=concat.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/defer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__from__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/from.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__empty__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/empty.js");
/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */



function defer(observableFactory) {
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var input;
        try {
            input = observableFactory();
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = input ? Object(__WEBPACK_IMPORTED_MODULE_1__from__["a" /* from */])(input) : Object(__WEBPACK_IMPORTED_MODULE_2__empty__["b" /* empty */])();
        return source.subscribe(subscriber);
    });
}
//# sourceMappingURL=defer.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/empty.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EMPTY; });
/* harmony export (immutable) */ __webpack_exports__["b"] = empty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

var EMPTY = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) { return subscriber.complete(); });
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) { return scheduler.schedule(function () { return subscriber.complete(); }); });
}
//# sourceMappingURL=empty.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/forkJoin.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = forkJoin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operators_map__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_isObject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__from__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/from.js");
/** PURE_IMPORTS_START _Observable,_util_isArray,_operators_map,_util_isObject,_from PURE_IMPORTS_END */





function forkJoin() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    if (sources.length === 1) {
        var first_1 = sources[0];
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isArray__["a" /* isArray */])(first_1)) {
            return forkJoinInternal(first_1, null);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_3__util_isObject__["a" /* isObject */])(first_1) && Object.getPrototypeOf(first_1) === Object.prototype) {
            var keys = Object.keys(first_1);
            return forkJoinInternal(keys.map(function (key) { return first_1[key]; }), keys);
        }
    }
    if (typeof sources[sources.length - 1] === 'function') {
        var resultSelector_1 = sources.pop();
        sources = (sources.length === 1 && Object(__WEBPACK_IMPORTED_MODULE_1__util_isArray__["a" /* isArray */])(sources[0])) ? sources[0] : sources;
        return forkJoinInternal(sources, null).pipe(Object(__WEBPACK_IMPORTED_MODULE_2__operators_map__["a" /* map */])(function (args) { return resultSelector_1.apply(void 0, args); }));
    }
    return forkJoinInternal(sources, null);
}
function forkJoinInternal(sources, keys) {
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var len = sources.length;
        if (len === 0) {
            subscriber.complete();
            return;
        }
        var values = new Array(len);
        var completed = 0;
        var emitted = 0;
        var _loop_1 = function (i) {
            var source = Object(__WEBPACK_IMPORTED_MODULE_4__from__["a" /* from */])(sources[i]);
            var hasValue = false;
            subscriber.add(source.subscribe({
                next: function (value) {
                    if (!hasValue) {
                        hasValue = true;
                        emitted++;
                    }
                    values[i] = value;
                },
                error: function (err) { return subscriber.error(err); },
                complete: function () {
                    completed++;
                    if (completed === len || !hasValue) {
                        if (emitted === len) {
                            subscriber.next(keys ?
                                keys.reduce(function (result, key, i) { return (result[key] = values[i], result); }, {}) :
                                values);
                        }
                        subscriber.complete();
                    }
                }
            }));
        };
        for (var i = 0; i < len; i++) {
            _loop_1(i);
        }
    });
}
//# sourceMappingURL=forkJoin.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/from.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = from;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_subscribeTo__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeTo.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduled_scheduled__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduled/scheduled.js");
/** PURE_IMPORTS_START _Observable,_util_subscribeTo,_scheduled_scheduled PURE_IMPORTS_END */



function from(input, scheduler) {
    if (!scheduler) {
        if (input instanceof __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */]) {
            return input;
        }
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](Object(__WEBPACK_IMPORTED_MODULE_1__util_subscribeTo__["a" /* subscribeTo */])(input));
    }
    else {
        return Object(__WEBPACK_IMPORTED_MODULE_2__scheduled_scheduled__["a" /* scheduled */])(input, scheduler);
    }
}
//# sourceMappingURL=from.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/fromArray.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_subscribeToArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduled_scheduleArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduled/scheduleArray.js");
/** PURE_IMPORTS_START _Observable,_util_subscribeToArray,_scheduled_scheduleArray PURE_IMPORTS_END */



function fromArray(input, scheduler) {
    if (!scheduler) {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](Object(__WEBPACK_IMPORTED_MODULE_1__util_subscribeToArray__["a" /* subscribeToArray */])(input));
    }
    else {
        return Object(__WEBPACK_IMPORTED_MODULE_2__scheduled_scheduleArray__["a" /* scheduleArray */])(input, scheduler);
    }
}
//# sourceMappingURL=fromArray.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/fromEvent.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isFunction__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isFunction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__operators_map__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/map.js");
/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */




var toString = Object.prototype.toString;
function fromEvent(target, eventName, options, resultSelector) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__util_isFunction__["a" /* isFunction */])(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) {
        return fromEvent(target, eventName, options).pipe(Object(__WEBPACK_IMPORTED_MODULE_3__operators_map__["a" /* map */])(function (args) { return Object(__WEBPACK_IMPORTED_MODULE_1__util_isArray__["a" /* isArray */])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        function handler(e) {
            if (arguments.length > 1) {
                subscriber.next(Array.prototype.slice.call(arguments));
            }
            else {
                subscriber.next(e);
            }
        }
        setupSubscription(target, eventName, handler, subscriber, options);
    });
}
function setupSubscription(sourceObj, eventName, handler, subscriber, options) {
    var unsubscribe;
    if (isEventTarget(sourceObj)) {
        var source_1 = sourceObj;
        sourceObj.addEventListener(eventName, handler, options);
        unsubscribe = function () { return source_1.removeEventListener(eventName, handler, options); };
    }
    else if (isJQueryStyleEventEmitter(sourceObj)) {
        var source_2 = sourceObj;
        sourceObj.on(eventName, handler);
        unsubscribe = function () { return source_2.off(eventName, handler); };
    }
    else if (isNodeStyleEventEmitter(sourceObj)) {
        var source_3 = sourceObj;
        sourceObj.addListener(eventName, handler);
        unsubscribe = function () { return source_3.removeListener(eventName, handler); };
    }
    else if (sourceObj && sourceObj.length) {
        for (var i = 0, len = sourceObj.length; i < len; i++) {
            setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
        }
    }
    else {
        throw new TypeError('Invalid event target');
    }
    subscriber.add(unsubscribe);
}
function isNodeStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
}
function isJQueryStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
}
function isEventTarget(sourceObj) {
    return sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
}
//# sourceMappingURL=fromEvent.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/fromEventPattern.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromEventPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isFunction__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isFunction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__operators_map__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/map.js");
/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */




function fromEventPattern(addHandler, removeHandler, resultSelector) {
    if (resultSelector) {
        return fromEventPattern(addHandler, removeHandler).pipe(Object(__WEBPACK_IMPORTED_MODULE_3__operators_map__["a" /* map */])(function (args) { return Object(__WEBPACK_IMPORTED_MODULE_1__util_isArray__["a" /* isArray */])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var handler = function () {
            var e = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                e[_i] = arguments[_i];
            }
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue;
        try {
            retValue = addHandler(handler);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__util_isFunction__["a" /* isFunction */])(removeHandler)) {
            return undefined;
        }
        return function () { return removeHandler(handler, retValue); };
    });
}
//# sourceMappingURL=fromEventPattern.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/generate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_identity__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/identity.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isScheduler__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isScheduler.js");
/** PURE_IMPORTS_START _Observable,_util_identity,_util_isScheduler PURE_IMPORTS_END */



function generate(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
    var resultSelector;
    var initialState;
    if (arguments.length == 1) {
        var options = initialStateOrOptions;
        initialState = options.initialState;
        condition = options.condition;
        iterate = options.iterate;
        resultSelector = options.resultSelector || __WEBPACK_IMPORTED_MODULE_1__util_identity__["a" /* identity */];
        scheduler = options.scheduler;
    }
    else if (resultSelectorOrObservable === undefined || Object(__WEBPACK_IMPORTED_MODULE_2__util_isScheduler__["a" /* isScheduler */])(resultSelectorOrObservable)) {
        initialState = initialStateOrOptions;
        resultSelector = __WEBPACK_IMPORTED_MODULE_1__util_identity__["a" /* identity */];
        scheduler = resultSelectorOrObservable;
    }
    else {
        initialState = initialStateOrOptions;
        resultSelector = resultSelectorOrObservable;
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var state = initialState;
        if (scheduler) {
            return scheduler.schedule(dispatch, 0, {
                subscriber: subscriber,
                iterate: iterate,
                condition: condition,
                resultSelector: resultSelector,
                state: state
            });
        }
        do {
            if (condition) {
                var conditionResult = void 0;
                try {
                    conditionResult = condition(state);
                }
                catch (err) {
                    subscriber.error(err);
                    return undefined;
                }
                if (!conditionResult) {
                    subscriber.complete();
                    break;
                }
            }
            var value = void 0;
            try {
                value = resultSelector(state);
            }
            catch (err) {
                subscriber.error(err);
                return undefined;
            }
            subscriber.next(value);
            if (subscriber.closed) {
                break;
            }
            try {
                state = iterate(state);
            }
            catch (err) {
                subscriber.error(err);
                return undefined;
            }
        } while (true);
        return undefined;
    });
}
function dispatch(state) {
    var subscriber = state.subscriber, condition = state.condition;
    if (subscriber.closed) {
        return undefined;
    }
    if (state.needIterate) {
        try {
            state.state = state.iterate(state.state);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
    }
    else {
        state.needIterate = true;
    }
    if (condition) {
        var conditionResult = void 0;
        try {
            conditionResult = condition(state.state);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!conditionResult) {
            subscriber.complete();
            return undefined;
        }
        if (subscriber.closed) {
            return undefined;
        }
    }
    var value;
    try {
        value = state.resultSelector(state.state);
    }
    catch (err) {
        subscriber.error(err);
        return undefined;
    }
    if (subscriber.closed) {
        return undefined;
    }
    subscriber.next(value);
    if (subscriber.closed) {
        return undefined;
    }
    return this.schedule(state);
}
//# sourceMappingURL=generate.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/iif.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = iif;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defer__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/defer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__empty__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/empty.js");
/** PURE_IMPORTS_START _defer,_empty PURE_IMPORTS_END */


function iif(condition, trueResult, falseResult) {
    if (trueResult === void 0) {
        trueResult = __WEBPACK_IMPORTED_MODULE_1__empty__["a" /* EMPTY */];
    }
    if (falseResult === void 0) {
        falseResult = __WEBPACK_IMPORTED_MODULE_1__empty__["a" /* EMPTY */];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__defer__["a" /* defer */])(function () { return condition() ? trueResult : falseResult; });
}
//# sourceMappingURL=iif.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/interval.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = interval;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler_async__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isNumeric__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isNumeric.js");
/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric PURE_IMPORTS_END */



function interval(period, scheduler) {
    if (period === void 0) {
        period = 0;
    }
    if (scheduler === void 0) {
        scheduler = __WEBPACK_IMPORTED_MODULE_1__scheduler_async__["a" /* async */];
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__util_isNumeric__["a" /* isNumeric */])(period) || period < 0) {
        period = 0;
    }
    if (!scheduler || typeof scheduler.schedule !== 'function') {
        scheduler = __WEBPACK_IMPORTED_MODULE_1__scheduler_async__["a" /* async */];
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        subscriber.add(scheduler.schedule(dispatch, period, { subscriber: subscriber, counter: 0, period: period }));
        return subscriber;
    });
}
function dispatch(state) {
    var subscriber = state.subscriber, counter = state.counter, period = state.period;
    subscriber.next(counter);
    this.schedule({ subscriber: subscriber, counter: counter + 1, period: period }, period);
}
//# sourceMappingURL=interval.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/merge.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = merge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isScheduler__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isScheduler.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operators_mergeAll__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/mergeAll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fromArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/fromArray.js");
/** PURE_IMPORTS_START _Observable,_util_isScheduler,_operators_mergeAll,_fromArray PURE_IMPORTS_END */




function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isScheduler__["a" /* isScheduler */])(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
            concurrent = observables.pop();
        }
    }
    else if (typeof last === 'number') {
        concurrent = observables.pop();
    }
    if (scheduler === null && observables.length === 1 && observables[0] instanceof __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */]) {
        return observables[0];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__operators_mergeAll__["a" /* mergeAll */])(concurrent)(Object(__WEBPACK_IMPORTED_MODULE_3__fromArray__["a" /* fromArray */])(observables, scheduler));
}
//# sourceMappingURL=merge.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/never.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NEVER; });
/* harmony export (immutable) */ __webpack_exports__["b"] = never;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_noop__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/noop.js");
/** PURE_IMPORTS_START _Observable,_util_noop PURE_IMPORTS_END */


var NEVER = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](__WEBPACK_IMPORTED_MODULE_1__util_noop__["a" /* noop */]);
function never() {
    return NEVER;
}
//# sourceMappingURL=never.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/of.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = of;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_isScheduler__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isScheduler.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fromArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/fromArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduled_scheduleArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduled/scheduleArray.js");
/** PURE_IMPORTS_START _util_isScheduler,_fromArray,_scheduled_scheduleArray PURE_IMPORTS_END */



function of() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = args[args.length - 1];
    if (Object(__WEBPACK_IMPORTED_MODULE_0__util_isScheduler__["a" /* isScheduler */])(scheduler)) {
        args.pop();
        return Object(__WEBPACK_IMPORTED_MODULE_2__scheduled_scheduleArray__["a" /* scheduleArray */])(args, scheduler);
    }
    else {
        return Object(__WEBPACK_IMPORTED_MODULE_1__fromArray__["a" /* fromArray */])(args);
    }
}
//# sourceMappingURL=of.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/onErrorResumeNext.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = onErrorResumeNext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__from__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/from.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__empty__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/empty.js");
/** PURE_IMPORTS_START _Observable,_from,_util_isArray,_empty PURE_IMPORTS_END */




function onErrorResumeNext() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    if (sources.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_3__empty__["a" /* EMPTY */];
    }
    var first = sources[0], remainder = sources.slice(1);
    if (sources.length === 1 && Object(__WEBPACK_IMPORTED_MODULE_2__util_isArray__["a" /* isArray */])(first)) {
        return onErrorResumeNext.apply(void 0, first);
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var subNext = function () { return subscriber.add(onErrorResumeNext.apply(void 0, remainder).subscribe(subscriber)); };
        return Object(__WEBPACK_IMPORTED_MODULE_1__from__["a" /* from */])(first).subscribe({
            next: function (value) { subscriber.next(value); },
            error: subNext,
            complete: subNext,
        });
    });
}
//# sourceMappingURL=onErrorResumeNext.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/pairs.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pairs;
/* unused harmony export dispatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscription.js");
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */


function pairs(obj, scheduler) {
    if (!scheduler) {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
            var keys = Object.keys(obj);
            for (var i = 0; i < keys.length && !subscriber.closed; i++) {
                var key = keys[i];
                if (obj.hasOwnProperty(key)) {
                    subscriber.next([key, obj[key]]);
                }
            }
            subscriber.complete();
        });
    }
    else {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
            var keys = Object.keys(obj);
            var subscription = new __WEBPACK_IMPORTED_MODULE_1__Subscription__["a" /* Subscription */]();
            subscription.add(scheduler.schedule(dispatch, 0, { keys: keys, index: 0, subscriber: subscriber, subscription: subscription, obj: obj }));
            return subscription;
        });
    }
}
function dispatch(state) {
    var keys = state.keys, index = state.index, subscriber = state.subscriber, subscription = state.subscription, obj = state.obj;
    if (!subscriber.closed) {
        if (index < keys.length) {
            var key = keys[index];
            subscriber.next([key, obj[key]]);
            subscription.add(this.schedule({ keys: keys, index: index + 1, subscriber: subscriber, subscription: subscription, obj: obj }));
        }
        else {
            subscriber.complete();
        }
    }
}
//# sourceMappingURL=pairs.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/partition.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = partition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_not__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/not.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_subscribeTo__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeTo.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operators_filter__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/filter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/** PURE_IMPORTS_START _util_not,_util_subscribeTo,_operators_filter,_Observable PURE_IMPORTS_END */




function partition(source, predicate, thisArg) {
    return [
        Object(__WEBPACK_IMPORTED_MODULE_2__operators_filter__["a" /* filter */])(predicate, thisArg)(new __WEBPACK_IMPORTED_MODULE_3__Observable__["a" /* Observable */](Object(__WEBPACK_IMPORTED_MODULE_1__util_subscribeTo__["a" /* subscribeTo */])(source))),
        Object(__WEBPACK_IMPORTED_MODULE_2__operators_filter__["a" /* filter */])(Object(__WEBPACK_IMPORTED_MODULE_0__util_not__["a" /* not */])(predicate, thisArg))(new __WEBPACK_IMPORTED_MODULE_3__Observable__["a" /* Observable */](Object(__WEBPACK_IMPORTED_MODULE_1__util_subscribeTo__["a" /* subscribeTo */])(source)))
    ];
}
//# sourceMappingURL=partition.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/race.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = race;
/* unused harmony export RaceOperator */
/* unused harmony export RaceSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fromArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/fromArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_util_isArray,_fromArray,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */





function race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    if (observables.length === 1) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isArray__["a" /* isArray */])(observables[0])) {
            observables = observables[0];
        }
        else {
            return observables[0];
        }
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__fromArray__["a" /* fromArray */])(observables, undefined).lift(new RaceOperator());
}
var RaceOperator = /*@__PURE__*/ (function () {
    function RaceOperator() {
    }
    RaceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RaceSubscriber(subscriber));
    };
    return RaceOperator;
}());

var RaceSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasFirst = false;
        _this.observables = [];
        _this.subscriptions = [];
        return _this;
    }
    RaceSubscriber.prototype._next = function (observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            for (var i = 0; i < len && !this.hasFirst; i++) {
                var observable = observables[i];
                var subscription = Object(__WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__["a" /* subscribeToResult */])(this, observable, observable, i);
                if (this.subscriptions) {
                    this.subscriptions.push(subscription);
                }
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for (var i = 0; i < this.subscriptions.length; i++) {
                if (i !== outerIndex) {
                    var subscription = this.subscriptions[i];
                    subscription.unsubscribe();
                    this.remove(subscription);
                }
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__["a" /* OuterSubscriber */]));

//# sourceMappingURL=race.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/range.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = range;
/* unused harmony export dispatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

function range(start, count, scheduler) {
    if (start === void 0) {
        start = 0;
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        if (count === undefined) {
            count = start;
            start = 0;
        }
        var index = 0;
        var current = start;
        if (scheduler) {
            return scheduler.schedule(dispatch, 0, {
                index: index, count: count, start: start, subscriber: subscriber
            });
        }
        else {
            do {
                if (index++ >= count) {
                    subscriber.complete();
                    break;
                }
                subscriber.next(current++);
                if (subscriber.closed) {
                    break;
                }
            } while (true);
        }
        return undefined;
    });
}
function dispatch(state) {
    var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
    if (index >= count) {
        subscriber.complete();
        return;
    }
    subscriber.next(start);
    if (subscriber.closed) {
        return;
    }
    state.index = index + 1;
    state.start = start + 1;
    this.schedule(state);
}
//# sourceMappingURL=range.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/throwError.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throwError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

function throwError(error, scheduler) {
    if (!scheduler) {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) { return subscriber.error(error); });
    }
    else {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) { return scheduler.schedule(dispatch, 0, { error: error, subscriber: subscriber }); });
    }
}
function dispatch(_a) {
    var error = _a.error, subscriber = _a.subscriber;
    subscriber.error(error);
}
//# sourceMappingURL=throwError.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/timer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = timer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler_async__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isNumeric__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isNumeric.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_isScheduler__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isScheduler.js");
/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */




function timer(dueTime, periodOrScheduler, scheduler) {
    if (dueTime === void 0) {
        dueTime = 0;
    }
    var period = -1;
    if (Object(__WEBPACK_IMPORTED_MODULE_2__util_isNumeric__["a" /* isNumeric */])(periodOrScheduler)) {
        period = Number(periodOrScheduler) < 1 && 1 || Number(periodOrScheduler);
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_3__util_isScheduler__["a" /* isScheduler */])(periodOrScheduler)) {
        scheduler = periodOrScheduler;
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_3__util_isScheduler__["a" /* isScheduler */])(scheduler)) {
        scheduler = __WEBPACK_IMPORTED_MODULE_1__scheduler_async__["a" /* async */];
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var due = Object(__WEBPACK_IMPORTED_MODULE_2__util_isNumeric__["a" /* isNumeric */])(dueTime)
            ? dueTime
            : (+dueTime - scheduler.now());
        return scheduler.schedule(dispatch, due, {
            index: 0, period: period, subscriber: subscriber
        });
    });
}
function dispatch(state) {
    var index = state.index, period = state.period, subscriber = state.subscriber;
    subscriber.next(index);
    if (subscriber.closed) {
        return;
    }
    else if (period === -1) {
        return subscriber.complete();
    }
    state.index = index + 1;
    this.schedule(state, period);
}
//# sourceMappingURL=timer.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/using.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = using;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__from__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/from.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__empty__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/empty.js");
/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */



function using(resourceFactory, observableFactory) {
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var resource;
        try {
            resource = resourceFactory();
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var result;
        try {
            result = observableFactory(resource);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = result ? Object(__WEBPACK_IMPORTED_MODULE_1__from__["a" /* from */])(result) : __WEBPACK_IMPORTED_MODULE_2__empty__["a" /* EMPTY */];
        var subscription = source.subscribe(subscriber);
        return function () {
            subscription.unsubscribe();
            if (resource) {
                resource.unsubscribe();
            }
        };
    });
}
//# sourceMappingURL=using.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/zip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = zip;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ZipOperator; });
/* unused harmony export ZipSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fromArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/fromArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_symbol_iterator__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/symbol/iterator.js");
/** PURE_IMPORTS_START tslib,_fromArray,_util_isArray,_Subscriber,_OuterSubscriber,_util_subscribeToResult,_.._internal_symbol_iterator PURE_IMPORTS_END */







function zip() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var resultSelector = observables[observables.length - 1];
    if (typeof resultSelector === 'function') {
        observables.pop();
    }
    return Object(__WEBPACK_IMPORTED_MODULE_1__fromArray__["a" /* fromArray */])(observables, undefined).lift(new ZipOperator(resultSelector));
}
var ZipOperator = /*@__PURE__*/ (function () {
    function ZipOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    ZipOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ZipSubscriber(subscriber, this.resultSelector));
    };
    return ZipOperator;
}());

var ZipSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ZipSubscriber, _super);
    function ZipSubscriber(destination, resultSelector, values) {
        if (values === void 0) {
            values = Object.create(null);
        }
        var _this = _super.call(this, destination) || this;
        _this.iterators = [];
        _this.active = 0;
        _this.resultSelector = (typeof resultSelector === 'function') ? resultSelector : null;
        _this.values = values;
        return _this;
    }
    ZipSubscriber.prototype._next = function (value) {
        var iterators = this.iterators;
        if (Object(__WEBPACK_IMPORTED_MODULE_2__util_isArray__["a" /* isArray */])(value)) {
            iterators.push(new StaticArrayIterator(value));
        }
        else if (typeof value[__WEBPACK_IMPORTED_MODULE_6__internal_symbol_iterator__["a" /* iterator */]] === 'function') {
            iterators.push(new StaticIterator(value[__WEBPACK_IMPORTED_MODULE_6__internal_symbol_iterator__["a" /* iterator */]]()));
        }
        else {
            iterators.push(new ZipBufferIterator(this.destination, this, value));
        }
    };
    ZipSubscriber.prototype._complete = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        this.unsubscribe();
        if (len === 0) {
            this.destination.complete();
            return;
        }
        this.active = len;
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (iterator.stillUnsubscribed) {
                var destination = this.destination;
                destination.add(iterator.subscribe(iterator, i));
            }
            else {
                this.active--;
            }
        }
    };
    ZipSubscriber.prototype.notifyInactive = function () {
        this.active--;
        if (this.active === 0) {
            this.destination.complete();
        }
    };
    ZipSubscriber.prototype.checkIterators = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) {
                return;
            }
        }
        var shouldComplete = false;
        var args = [];
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            var result = iterator.next();
            if (iterator.hasCompleted()) {
                shouldComplete = true;
            }
            if (result.done) {
                destination.complete();
                return;
            }
            args.push(result.value);
        }
        if (this.resultSelector) {
            this._tryresultSelector(args);
        }
        else {
            destination.next(args);
        }
        if (shouldComplete) {
            destination.complete();
        }
    };
    ZipSubscriber.prototype._tryresultSelector = function (args) {
        var result;
        try {
            result = this.resultSelector.apply(this, args);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return ZipSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__Subscriber__["a" /* Subscriber */]));

var StaticIterator = /*@__PURE__*/ (function () {
    function StaticIterator(iterator) {
        this.iterator = iterator;
        this.nextResult = iterator.next();
    }
    StaticIterator.prototype.hasValue = function () {
        return true;
    };
    StaticIterator.prototype.next = function () {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
    };
    StaticIterator.prototype.hasCompleted = function () {
        var nextResult = this.nextResult;
        return nextResult && nextResult.done;
    };
    return StaticIterator;
}());
var StaticArrayIterator = /*@__PURE__*/ (function () {
    function StaticArrayIterator(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
    }
    StaticArrayIterator.prototype[__WEBPACK_IMPORTED_MODULE_6__internal_symbol_iterator__["a" /* iterator */]] = function () {
        return this;
    };
    StaticArrayIterator.prototype.next = function (value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? { value: array[i], done: false } : { value: null, done: true };
    };
    StaticArrayIterator.prototype.hasValue = function () {
        return this.array.length > this.index;
    };
    StaticArrayIterator.prototype.hasCompleted = function () {
        return this.array.length === this.index;
    };
    return StaticArrayIterator;
}());
var ZipBufferIterator = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ZipBufferIterator, _super);
    function ZipBufferIterator(destination, parent, observable) {
        var _this = _super.call(this, destination) || this;
        _this.parent = parent;
        _this.observable = observable;
        _this.stillUnsubscribed = true;
        _this.buffer = [];
        _this.isComplete = false;
        return _this;
    }
    ZipBufferIterator.prototype[__WEBPACK_IMPORTED_MODULE_6__internal_symbol_iterator__["a" /* iterator */]] = function () {
        return this;
    };
    ZipBufferIterator.prototype.next = function () {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) {
            return { value: null, done: true };
        }
        else {
            return { value: buffer.shift(), done: false };
        }
    };
    ZipBufferIterator.prototype.hasValue = function () {
        return this.buffer.length > 0;
    };
    ZipBufferIterator.prototype.hasCompleted = function () {
        return this.buffer.length === 0 && this.isComplete;
    };
    ZipBufferIterator.prototype.notifyComplete = function () {
        if (this.buffer.length > 0) {
            this.isComplete = true;
            this.parent.notifyInactive();
        }
        else {
            this.destination.complete();
        }
    };
    ZipBufferIterator.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
    };
    ZipBufferIterator.prototype.subscribe = function (value, index) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_subscribeToResult__["a" /* subscribeToResult */])(this, this.observable, this, index);
    };
    return ZipBufferIterator;
}(__WEBPACK_IMPORTED_MODULE_4__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=zip.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/audit.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = audit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function audit(durationSelector) {
    return function auditOperatorFunction(source) {
        return source.lift(new AuditOperator(durationSelector));
    };
}
var AuditOperator = /*@__PURE__*/ (function () {
    function AuditOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    AuditOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new AuditSubscriber(subscriber, this.durationSelector));
    };
    return AuditOperator;
}());
var AuditSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AuditSubscriber, _super);
    function AuditSubscriber(destination, durationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.durationSelector = durationSelector;
        _this.hasValue = false;
        return _this;
    }
    AuditSubscriber.prototype._next = function (value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            var duration = void 0;
            try {
                var durationSelector = this.durationSelector;
                duration = durationSelector(value);
            }
            catch (err) {
                return this.destination.error(err);
            }
            var innerSubscription = Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(this, duration);
            if (!innerSubscription || innerSubscription.closed) {
                this.clearThrottle();
            }
            else {
                this.add(this.throttled = innerSubscription);
            }
        }
    };
    AuditSubscriber.prototype.clearThrottle = function () {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = null;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    AuditSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
        this.clearThrottle();
    };
    AuditSubscriber.prototype.notifyComplete = function () {
        this.clearThrottle();
    };
    return AuditSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=audit.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/auditTime.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = auditTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scheduler_async__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audit__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/audit.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__observable_timer__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/timer.js");
/** PURE_IMPORTS_START _scheduler_async,_audit,_observable_timer PURE_IMPORTS_END */



function auditTime(duration, scheduler) {
    if (scheduler === void 0) {
        scheduler = __WEBPACK_IMPORTED_MODULE_0__scheduler_async__["a" /* async */];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_1__audit__["a" /* audit */])(function () { return Object(__WEBPACK_IMPORTED_MODULE_2__observable_timer__["a" /* timer */])(duration, scheduler); });
}
//# sourceMappingURL=auditTime.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/buffer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buffer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function buffer(closingNotifier) {
    return function bufferOperatorFunction(source) {
        return source.lift(new BufferOperator(closingNotifier));
    };
}
var BufferOperator = /*@__PURE__*/ (function () {
    function BufferOperator(closingNotifier) {
        this.closingNotifier = closingNotifier;
    }
    BufferOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
    };
    return BufferOperator;
}());
var BufferSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](BufferSubscriber, _super);
    function BufferSubscriber(destination, closingNotifier) {
        var _this = _super.call(this, destination) || this;
        _this.buffer = [];
        _this.add(Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(_this, closingNotifier));
        return _this;
    }
    BufferSubscriber.prototype._next = function (value) {
        this.buffer.push(value);
    };
    BufferSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var buffer = this.buffer;
        this.buffer = [];
        this.destination.next(buffer);
    };
    return BufferSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=buffer.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/bufferCount.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bufferCount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) {
        startBufferEvery = null;
    }
    return function bufferCountOperatorFunction(source) {
        return source.lift(new BufferCountOperator(bufferSize, startBufferEvery));
    };
}
var BufferCountOperator = /*@__PURE__*/ (function () {
    function BufferCountOperator(bufferSize, startBufferEvery) {
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        if (!startBufferEvery || bufferSize === startBufferEvery) {
            this.subscriberClass = BufferCountSubscriber;
        }
        else {
            this.subscriberClass = BufferSkipCountSubscriber;
        }
    }
    BufferCountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
    };
    return BufferCountOperator;
}());
var BufferCountSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](BufferCountSubscriber, _super);
    function BufferCountSubscriber(destination, bufferSize) {
        var _this = _super.call(this, destination) || this;
        _this.bufferSize = bufferSize;
        _this.buffer = [];
        return _this;
    }
    BufferCountSubscriber.prototype._next = function (value) {
        var buffer = this.buffer;
        buffer.push(value);
        if (buffer.length == this.bufferSize) {
            this.destination.next(buffer);
            this.buffer = [];
        }
    };
    BufferCountSubscriber.prototype._complete = function () {
        var buffer = this.buffer;
        if (buffer.length > 0) {
            this.destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    return BufferCountSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
var BufferSkipCountSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](BufferSkipCountSubscriber, _super);
    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
        var _this = _super.call(this, destination) || this;
        _this.bufferSize = bufferSize;
        _this.startBufferEvery = startBufferEvery;
        _this.buffers = [];
        _this.count = 0;
        return _this;
    }
    BufferSkipCountSubscriber.prototype._next = function (value) {
        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
        this.count++;
        if (count % startBufferEvery === 0) {
            buffers.push([]);
        }
        for (var i = buffers.length; i--;) {
            var buffer = buffers[i];
            buffer.push(value);
            if (buffer.length === bufferSize) {
                buffers.splice(i, 1);
                this.destination.next(buffer);
            }
        }
    };
    BufferSkipCountSubscriber.prototype._complete = function () {
        var _a = this, buffers = _a.buffers, destination = _a.destination;
        while (buffers.length > 0) {
            var buffer = buffers.shift();
            if (buffer.length > 0) {
                destination.next(buffer);
            }
        }
        _super.prototype._complete.call(this);
    };
    return BufferSkipCountSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=bufferCount.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/bufferTime.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bufferTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler_async__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_isScheduler__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isScheduler.js");
/** PURE_IMPORTS_START tslib,_scheduler_async,_Subscriber,_util_isScheduler PURE_IMPORTS_END */




function bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = __WEBPACK_IMPORTED_MODULE_1__scheduler_async__["a" /* async */];
    if (Object(__WEBPACK_IMPORTED_MODULE_3__util_isScheduler__["a" /* isScheduler */])(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) {
        bufferCreationInterval = arguments[1];
    }
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) {
        maxBufferSize = arguments[2];
    }
    return function bufferTimeOperatorFunction(source) {
        return source.lift(new BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
    };
}
var BufferTimeOperator = /*@__PURE__*/ (function () {
    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
    }
    BufferTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
    };
    return BufferTimeOperator;
}());
var Context = /*@__PURE__*/ (function () {
    function Context() {
        this.buffer = [];
    }
    return Context;
}());
var BufferTimeSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](BufferTimeSubscriber, _super);
    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.bufferTimeSpan = bufferTimeSpan;
        _this.bufferCreationInterval = bufferCreationInterval;
        _this.maxBufferSize = maxBufferSize;
        _this.scheduler = scheduler;
        _this.contexts = [];
        var context = _this.openContext();
        _this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
        if (_this.timespanOnly) {
            var timeSpanOnlyState = { subscriber: _this, context: context, bufferTimeSpan: bufferTimeSpan };
            _this.add(context.closeAction = scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
        else {
            var closeState = { subscriber: _this, context: context };
            var creationState = { bufferTimeSpan: bufferTimeSpan, bufferCreationInterval: bufferCreationInterval, subscriber: _this, scheduler: scheduler };
            _this.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, closeState));
            _this.add(scheduler.schedule(dispatchBufferCreation, bufferCreationInterval, creationState));
        }
        return _this;
    }
    BufferTimeSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        var len = contexts.length;
        var filledBufferContext;
        for (var i = 0; i < len; i++) {
            var context_1 = contexts[i];
            var buffer = context_1.buffer;
            buffer.push(value);
            if (buffer.length == this.maxBufferSize) {
                filledBufferContext = context_1;
            }
        }
        if (filledBufferContext) {
            this.onBufferFull(filledBufferContext);
        }
    };
    BufferTimeSubscriber.prototype._error = function (err) {
        this.contexts.length = 0;
        _super.prototype._error.call(this, err);
    };
    BufferTimeSubscriber.prototype._complete = function () {
        var _a = this, contexts = _a.contexts, destination = _a.destination;
        while (contexts.length > 0) {
            var context_2 = contexts.shift();
            destination.next(context_2.buffer);
        }
        _super.prototype._complete.call(this);
    };
    BufferTimeSubscriber.prototype._unsubscribe = function () {
        this.contexts = null;
    };
    BufferTimeSubscriber.prototype.onBufferFull = function (context) {
        this.closeContext(context);
        var closeAction = context.closeAction;
        closeAction.unsubscribe();
        this.remove(closeAction);
        if (!this.closed && this.timespanOnly) {
            context = this.openContext();
            var bufferTimeSpan = this.bufferTimeSpan;
            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
            this.add(context.closeAction = this.scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
    };
    BufferTimeSubscriber.prototype.openContext = function () {
        var context = new Context();
        this.contexts.push(context);
        return context;
    };
    BufferTimeSubscriber.prototype.closeContext = function (context) {
        this.destination.next(context.buffer);
        var contexts = this.contexts;
        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
        if (spliceIndex >= 0) {
            contexts.splice(contexts.indexOf(context), 1);
        }
    };
    return BufferTimeSubscriber;
}(__WEBPACK_IMPORTED_MODULE_2__Subscriber__["a" /* Subscriber */]));
function dispatchBufferTimeSpanOnly(state) {
    var subscriber = state.subscriber;
    var prevContext = state.context;
    if (prevContext) {
        subscriber.closeContext(prevContext);
    }
    if (!subscriber.closed) {
        state.context = subscriber.openContext();
        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
    }
}
function dispatchBufferCreation(state) {
    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
    var context = subscriber.openContext();
    var action = this;
    if (!subscriber.closed) {
        subscriber.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, { subscriber: subscriber, context: context }));
        action.schedule(state, bufferCreationInterval);
    }
}
function dispatchBufferClose(arg) {
    var subscriber = arg.subscriber, context = arg.context;
    subscriber.closeContext(context);
}
//# sourceMappingURL=bufferTime.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/bufferToggle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bufferToggle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscription.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/** PURE_IMPORTS_START tslib,_Subscription,_util_subscribeToResult,_OuterSubscriber PURE_IMPORTS_END */




function bufferToggle(openings, closingSelector) {
    return function bufferToggleOperatorFunction(source) {
        return source.lift(new BufferToggleOperator(openings, closingSelector));
    };
}
var BufferToggleOperator = /*@__PURE__*/ (function () {
    function BufferToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    BufferToggleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return BufferToggleOperator;
}());
var BufferToggleSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](BufferToggleSubscriber, _super);
    function BufferToggleSubscriber(destination, openings, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.openings = openings;
        _this.closingSelector = closingSelector;
        _this.contexts = [];
        _this.add(Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(_this, openings));
        return _this;
    }
    BufferToggleSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        var len = contexts.length;
        for (var i = 0; i < len; i++) {
            contexts[i].buffer.push(value);
        }
    };
    BufferToggleSubscriber.prototype._error = function (err) {
        var contexts = this.contexts;
        while (contexts.length > 0) {
            var context_1 = contexts.shift();
            context_1.subscription.unsubscribe();
            context_1.buffer = null;
            context_1.subscription = null;
        }
        this.contexts = null;
        _super.prototype._error.call(this, err);
    };
    BufferToggleSubscriber.prototype._complete = function () {
        var contexts = this.contexts;
        while (contexts.length > 0) {
            var context_2 = contexts.shift();
            this.destination.next(context_2.buffer);
            context_2.subscription.unsubscribe();
            context_2.buffer = null;
            context_2.subscription = null;
        }
        this.contexts = null;
        _super.prototype._complete.call(this);
    };
    BufferToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
    };
    BufferToggleSubscriber.prototype.notifyComplete = function (innerSub) {
        this.closeBuffer(innerSub.context);
    };
    BufferToggleSubscriber.prototype.openBuffer = function (value) {
        try {
            var closingSelector = this.closingSelector;
            var closingNotifier = closingSelector.call(this, value);
            if (closingNotifier) {
                this.trySubscribe(closingNotifier);
            }
        }
        catch (err) {
            this._error(err);
        }
    };
    BufferToggleSubscriber.prototype.closeBuffer = function (context) {
        var contexts = this.contexts;
        if (contexts && context) {
            var buffer = context.buffer, subscription = context.subscription;
            this.destination.next(buffer);
            contexts.splice(contexts.indexOf(context), 1);
            this.remove(subscription);
            subscription.unsubscribe();
        }
    };
    BufferToggleSubscriber.prototype.trySubscribe = function (closingNotifier) {
        var contexts = this.contexts;
        var buffer = [];
        var subscription = new __WEBPACK_IMPORTED_MODULE_1__Subscription__["a" /* Subscription */]();
        var context = { buffer: buffer, subscription: subscription };
        contexts.push(context);
        var innerSubscription = Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(this, closingNotifier, context);
        if (!innerSubscription || innerSubscription.closed) {
            this.closeBuffer(context);
        }
        else {
            innerSubscription.context = context;
            this.add(innerSubscription);
            subscription.add(innerSubscription);
        }
    };
    return BufferToggleSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=bufferToggle.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/bufferWhen.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bufferWhen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscription.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_Subscription,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */




function bufferWhen(closingSelector) {
    return function (source) {
        return source.lift(new BufferWhenOperator(closingSelector));
    };
}
var BufferWhenOperator = /*@__PURE__*/ (function () {
    function BufferWhenOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    BufferWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferWhenSubscriber(subscriber, this.closingSelector));
    };
    return BufferWhenOperator;
}());
var BufferWhenSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](BufferWhenSubscriber, _super);
    function BufferWhenSubscriber(destination, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.closingSelector = closingSelector;
        _this.subscribing = false;
        _this.openBuffer();
        return _this;
    }
    BufferWhenSubscriber.prototype._next = function (value) {
        this.buffer.push(value);
    };
    BufferWhenSubscriber.prototype._complete = function () {
        var buffer = this.buffer;
        if (buffer) {
            this.destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    BufferWhenSubscriber.prototype._unsubscribe = function () {
        this.buffer = null;
        this.subscribing = false;
    };
    BufferWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openBuffer();
    };
    BufferWhenSubscriber.prototype.notifyComplete = function () {
        if (this.subscribing) {
            this.complete();
        }
        else {
            this.openBuffer();
        }
    };
    BufferWhenSubscriber.prototype.openBuffer = function () {
        var closingSubscription = this.closingSubscription;
        if (closingSubscription) {
            this.remove(closingSubscription);
            closingSubscription.unsubscribe();
        }
        var buffer = this.buffer;
        if (this.buffer) {
            this.destination.next(buffer);
        }
        this.buffer = [];
        var closingNotifier;
        try {
            var closingSelector = this.closingSelector;
            closingNotifier = closingSelector();
        }
        catch (err) {
            return this.error(err);
        }
        closingSubscription = new __WEBPACK_IMPORTED_MODULE_1__Subscription__["a" /* Subscription */]();
        this.closingSubscription = closingSubscription;
        this.add(closingSubscription);
        this.subscribing = true;
        closingSubscription.add(Object(__WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__["a" /* subscribeToResult */])(this, closingNotifier));
        this.subscribing = false;
    };
    return BufferWhenSubscriber;
}(__WEBPACK_IMPORTED_MODULE_2__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=bufferWhen.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/catchError.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = catchError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InnerSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/InnerSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_InnerSubscriber,_util_subscribeToResult PURE_IMPORTS_END */




function catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new CatchOperator(selector);
        var caught = source.lift(operator);
        return (operator.caught = caught);
    };
}
var CatchOperator = /*@__PURE__*/ (function () {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}());
var CatchSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        var _this = _super.call(this, destination) || this;
        _this.selector = selector;
        _this.caught = caught;
        return _this;
    }
    CatchSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            }
            catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            var innerSubscriber = new __WEBPACK_IMPORTED_MODULE_2__InnerSubscriber__["a" /* InnerSubscriber */](this, undefined, undefined);
            this.add(innerSubscriber);
            Object(__WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__["a" /* subscribeToResult */])(this, result, undefined, undefined, innerSubscriber);
        }
    };
    return CatchSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=catchError.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/combineAll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_combineLatest__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/combineLatest.js");
/** PURE_IMPORTS_START _observable_combineLatest PURE_IMPORTS_END */

function combineAll(project) {
    return function (source) { return source.lift(new __WEBPACK_IMPORTED_MODULE_0__observable_combineLatest__["a" /* CombineLatestOperator */](project)); };
}
//# sourceMappingURL=combineAll.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/combineLatest.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineLatest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_isArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__observable_combineLatest__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/combineLatest.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__observable_from__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/from.js");
/** PURE_IMPORTS_START _util_isArray,_observable_combineLatest,_observable_from PURE_IMPORTS_END */



var none = {};
function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var project = null;
    if (typeof observables[observables.length - 1] === 'function') {
        project = observables.pop();
    }
    if (observables.length === 1 && Object(__WEBPACK_IMPORTED_MODULE_0__util_isArray__["a" /* isArray */])(observables[0])) {
        observables = observables[0].slice();
    }
    return function (source) { return source.lift.call(Object(__WEBPACK_IMPORTED_MODULE_2__observable_from__["a" /* from */])([source].concat(observables)), new __WEBPACK_IMPORTED_MODULE_1__observable_combineLatest__["a" /* CombineLatestOperator */](project)); };
}
//# sourceMappingURL=combineLatest.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/concat.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = concat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_concat__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/concat.js");
/** PURE_IMPORTS_START _observable_concat PURE_IMPORTS_END */

function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return function (source) { return source.lift.call(__WEBPACK_IMPORTED_MODULE_0__observable_concat__["a" /* concat */].apply(void 0, [source].concat(observables))); };
}
//# sourceMappingURL=concat.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/concatAll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = concatAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mergeAll__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/mergeAll.js");
/** PURE_IMPORTS_START _mergeAll PURE_IMPORTS_END */

function concatAll() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__mergeAll__["a" /* mergeAll */])(1);
}
//# sourceMappingURL=concatAll.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/concatMap.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = concatMap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mergeMap__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/mergeMap.js");
/** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */

function concatMap(project, resultSelector) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__mergeMap__["a" /* mergeMap */])(project, resultSelector, 1);
}
//# sourceMappingURL=concatMap.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/concatMapTo.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = concatMapTo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__concatMap__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/concatMap.js");
/** PURE_IMPORTS_START _concatMap PURE_IMPORTS_END */

function concatMapTo(innerObservable, resultSelector) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__concatMap__["a" /* concatMap */])(function () { return innerObservable; }, resultSelector);
}
//# sourceMappingURL=concatMapTo.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/count.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = count;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function count(predicate) {
    return function (source) { return source.lift(new CountOperator(predicate, source)); };
}
var CountOperator = /*@__PURE__*/ (function () {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}());
var CountSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.count = 0;
        _this.index = 0;
        return _this;
    }
    CountSubscriber.prototype._next = function (value) {
        if (this.predicate) {
            this._tryPredicate(value);
        }
        else {
            this.count++;
        }
    };
    CountSubscriber.prototype._tryPredicate = function (value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.count++;
        }
    };
    CountSubscriber.prototype._complete = function () {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=count.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/debounce.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function debounce(durationSelector) {
    return function (source) { return source.lift(new DebounceOperator(durationSelector)); };
}
var DebounceOperator = /*@__PURE__*/ (function () {
    function DebounceOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    DebounceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DebounceSubscriber(subscriber, this.durationSelector));
    };
    return DebounceOperator;
}());
var DebounceSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](DebounceSubscriber, _super);
    function DebounceSubscriber(destination, durationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.durationSelector = durationSelector;
        _this.hasValue = false;
        _this.durationSubscription = null;
        return _this;
    }
    DebounceSubscriber.prototype._next = function (value) {
        try {
            var result = this.durationSelector.call(this, value);
            if (result) {
                this._tryNext(value, result);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    DebounceSubscriber.prototype._complete = function () {
        this.emitValue();
        this.destination.complete();
    };
    DebounceSubscriber.prototype._tryNext = function (value, duration) {
        var subscription = this.durationSubscription;
        this.value = value;
        this.hasValue = true;
        if (subscription) {
            subscription.unsubscribe();
            this.remove(subscription);
        }
        subscription = Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(this, duration);
        if (subscription && !subscription.closed) {
            this.add(this.durationSubscription = subscription);
        }
    };
    DebounceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    DebounceSubscriber.prototype.notifyComplete = function () {
        this.emitValue();
    };
    DebounceSubscriber.prototype.emitValue = function () {
        if (this.hasValue) {
            var value = this.value;
            var subscription = this.durationSubscription;
            if (subscription) {
                this.durationSubscription = null;
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.value = null;
            this.hasValue = false;
            _super.prototype._next.call(this, value);
        }
    };
    return DebounceSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=debounce.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/debounceTime.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounceTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler_async__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */



function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) {
        scheduler = __WEBPACK_IMPORTED_MODULE_2__scheduler_async__["a" /* async */];
    }
    return function (source) { return source.lift(new DebounceTimeOperator(dueTime, scheduler)); };
}
var DebounceTimeOperator = /*@__PURE__*/ (function () {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}());
var DebounceTimeSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.dueTime = dueTime;
        _this.scheduler = scheduler;
        _this.debouncedSubscription = null;
        _this.lastValue = null;
        _this.hasValue = false;
        return _this;
    }
    DebounceTimeSubscriber.prototype._next = function (value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function () {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function () {
        this.clearDebounce();
        if (this.hasValue) {
            var lastValue = this.lastValue;
            this.lastValue = null;
            this.hasValue = false;
            this.destination.next(lastValue);
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function () {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
function dispatchNext(subscriber) {
    subscriber.debouncedNext();
}
//# sourceMappingURL=debounceTime.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/defaultIfEmpty.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultIfEmpty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) {
        defaultValue = null;
    }
    return function (source) { return source.lift(new DefaultIfEmptyOperator(defaultValue)); };
}
var DefaultIfEmptyOperator = /*@__PURE__*/ (function () {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}());
var DefaultIfEmptySubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        var _this = _super.call(this, destination) || this;
        _this.defaultValue = defaultValue;
        _this.isEmpty = true;
        return _this;
    }
    DefaultIfEmptySubscriber.prototype._next = function (value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function () {
        if (this.isEmpty) {
            this.destination.next(this.defaultValue);
        }
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=defaultIfEmpty.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/delay.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = delay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler_async__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isDate__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isDate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Notification__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Notification.js");
/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_Subscriber,_Notification PURE_IMPORTS_END */





function delay(delay, scheduler) {
    if (scheduler === void 0) {
        scheduler = __WEBPACK_IMPORTED_MODULE_1__scheduler_async__["a" /* async */];
    }
    var absoluteDelay = Object(__WEBPACK_IMPORTED_MODULE_2__util_isDate__["a" /* isDate */])(delay);
    var delayFor = absoluteDelay ? (+delay - scheduler.now()) : Math.abs(delay);
    return function (source) { return source.lift(new DelayOperator(delayFor, scheduler)); };
}
var DelayOperator = /*@__PURE__*/ (function () {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}());
var DelaySubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.delay = delay;
        _this.scheduler = scheduler;
        _this.queue = [];
        _this.active = false;
        _this.errored = false;
        return _this;
    }
    DelaySubscriber.dispatch = function (state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while (queue.length > 0 && (queue[0].time - scheduler.now()) <= 0) {
            queue.shift().notification.observe(destination);
        }
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        }
        else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function (scheduler) {
        this.active = true;
        var destination = this.destination;
        destination.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this, destination: this.destination, scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function (notification) {
        if (this.errored === true) {
            return;
        }
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) {
            this._schedule(scheduler);
        }
    };
    DelaySubscriber.prototype._next = function (value) {
        this.scheduleNotification(__WEBPACK_IMPORTED_MODULE_4__Notification__["a" /* Notification */].createNext(value));
    };
    DelaySubscriber.prototype._error = function (err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
        this.unsubscribe();
    };
    DelaySubscriber.prototype._complete = function () {
        this.scheduleNotification(__WEBPACK_IMPORTED_MODULE_4__Notification__["a" /* Notification */].createComplete());
        this.unsubscribe();
    };
    return DelaySubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__Subscriber__["a" /* Subscriber */]));
var DelayMessage = /*@__PURE__*/ (function () {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}());
//# sourceMappingURL=delay.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/delayWhen.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = delayWhen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */





function delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) {
        return function (source) {
            return new SubscriptionDelayObservable(source, subscriptionDelay)
                .lift(new DelayWhenOperator(delayDurationSelector));
        };
    }
    return function (source) { return source.lift(new DelayWhenOperator(delayDurationSelector)); };
}
var DelayWhenOperator = /*@__PURE__*/ (function () {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}());
var DelayWhenSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.delayDurationSelector = delayDurationSelector;
        _this.completed = false;
        _this.delayNotifierSubscriptions = [];
        _this.index = 0;
        return _this;
    }
    DelayWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function (innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) {
            this.destination.next(value);
        }
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function (value) {
        var index = this.index++;
        try {
            var delayNotifier = this.delayDurationSelector(value, index);
            if (delayNotifier) {
                this.tryDelay(delayNotifier, value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function () {
        this.completed = true;
        this.tryComplete();
        this.unsubscribe();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function (subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        if (subscriptionIdx !== -1) {
            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
        }
        return subscription.outerValue;
    };
    DelayWhenSubscriber.prototype.tryDelay = function (delayNotifier, value) {
        var notifierSubscription = Object(__WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__["a" /* subscribeToResult */])(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            var destination = this.destination;
            destination.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
    };
    DelayWhenSubscriber.prototype.tryComplete = function () {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) {
            this.destination.complete();
        }
    };
    return DelayWhenSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__["a" /* OuterSubscriber */]));
var SubscriptionDelayObservable = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(source, subscriptionDelay) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subscriptionDelay = subscriptionDelay;
        return _this;
    }
    SubscriptionDelayObservable.prototype._subscribe = function (subscriber) {
        this.subscriptionDelay.subscribe(new SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}(__WEBPACK_IMPORTED_MODULE_2__Observable__["a" /* Observable */]));
var SubscriptionDelaySubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.source = source;
        _this.sourceSubscribed = false;
        return _this;
    }
    SubscriptionDelaySubscriber.prototype._next = function (unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function (err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function () {
        this.unsubscribe();
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function () {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=delayWhen.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/dematerialize.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dematerialize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function dematerialize() {
    return function dematerializeOperatorFunction(source) {
        return source.lift(new DeMaterializeOperator());
    };
}
var DeMaterializeOperator = /*@__PURE__*/ (function () {
    function DeMaterializeOperator() {
    }
    DeMaterializeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DeMaterializeSubscriber(subscriber));
    };
    return DeMaterializeOperator;
}());
var DeMaterializeSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](DeMaterializeSubscriber, _super);
    function DeMaterializeSubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    DeMaterializeSubscriber.prototype._next = function (value) {
        value.observe(this.destination);
    };
    return DeMaterializeSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=dematerialize.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/distinct.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = distinct;
/* unused harmony export DistinctSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function distinct(keySelector, flushes) {
    return function (source) { return source.lift(new DistinctOperator(keySelector, flushes)); };
}
var DistinctOperator = /*@__PURE__*/ (function () {
    function DistinctOperator(keySelector, flushes) {
        this.keySelector = keySelector;
        this.flushes = flushes;
    }
    DistinctOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DistinctSubscriber(subscriber, this.keySelector, this.flushes));
    };
    return DistinctOperator;
}());
var DistinctSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](DistinctSubscriber, _super);
    function DistinctSubscriber(destination, keySelector, flushes) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.values = new Set();
        if (flushes) {
            _this.add(Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(_this, flushes));
        }
        return _this;
    }
    DistinctSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values.clear();
    };
    DistinctSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    DistinctSubscriber.prototype._next = function (value) {
        if (this.keySelector) {
            this._useKeySelector(value);
        }
        else {
            this._finalizeNext(value, value);
        }
    };
    DistinctSubscriber.prototype._useKeySelector = function (value) {
        var key;
        var destination = this.destination;
        try {
            key = this.keySelector(value);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        this._finalizeNext(key, value);
    };
    DistinctSubscriber.prototype._finalizeNext = function (key, value) {
        var values = this.values;
        if (!values.has(key)) {
            values.add(key);
            this.destination.next(value);
        }
    };
    return DistinctSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));

//# sourceMappingURL=distinct.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/distinctUntilChanged.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = distinctUntilChanged;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function distinctUntilChanged(compare, keySelector) {
    return function (source) { return source.lift(new DistinctUntilChangedOperator(compare, keySelector)); };
}
var DistinctUntilChangedOperator = /*@__PURE__*/ (function () {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}());
var DistinctUntilChangedSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.hasKey = false;
        if (typeof compare === 'function') {
            _this.compare = compare;
        }
        return _this;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function (x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function (value) {
        var key;
        try {
            var keySelector = this.keySelector;
            key = keySelector ? keySelector(value) : value;
        }
        catch (err) {
            return this.destination.error(err);
        }
        var result = false;
        if (this.hasKey) {
            try {
                var compare = this.compare;
                result = compare(this.key, key);
            }
            catch (err) {
                return this.destination.error(err);
            }
        }
        else {
            this.hasKey = true;
        }
        if (!result) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=distinctUntilChanged.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/distinctUntilKeyChanged.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = distinctUntilKeyChanged;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__distinctUntilChanged__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/distinctUntilChanged.js");
/** PURE_IMPORTS_START _distinctUntilChanged PURE_IMPORTS_END */

function distinctUntilKeyChanged(key, compare) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__distinctUntilChanged__["a" /* distinctUntilChanged */])(function (x, y) { return compare ? compare(x[key], y[key]) : x[key] === y[key]; });
}
//# sourceMappingURL=distinctUntilKeyChanged.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/elementAt.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = elementAt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_ArgumentOutOfRangeError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/ArgumentOutOfRangeError.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filter__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/filter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__throwIfEmpty__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/throwIfEmpty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultIfEmpty__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/defaultIfEmpty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__take__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/take.js");
/** PURE_IMPORTS_START _util_ArgumentOutOfRangeError,_filter,_throwIfEmpty,_defaultIfEmpty,_take PURE_IMPORTS_END */





function elementAt(index, defaultValue) {
    if (index < 0) {
        throw new __WEBPACK_IMPORTED_MODULE_0__util_ArgumentOutOfRangeError__["a" /* ArgumentOutOfRangeError */]();
    }
    var hasDefaultValue = arguments.length >= 2;
    return function (source) {
        return source.pipe(Object(__WEBPACK_IMPORTED_MODULE_1__filter__["a" /* filter */])(function (v, i) { return i === index; }), Object(__WEBPACK_IMPORTED_MODULE_4__take__["a" /* take */])(1), hasDefaultValue
            ? Object(__WEBPACK_IMPORTED_MODULE_3__defaultIfEmpty__["a" /* defaultIfEmpty */])(defaultValue)
            : Object(__WEBPACK_IMPORTED_MODULE_2__throwIfEmpty__["a" /* throwIfEmpty */])(function () { return new __WEBPACK_IMPORTED_MODULE_0__util_ArgumentOutOfRangeError__["a" /* ArgumentOutOfRangeError */](); }));
    };
}
//# sourceMappingURL=elementAt.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/endWith.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = endWith;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_concat__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/concat.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__observable_of__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/of.js");
/** PURE_IMPORTS_START _observable_concat,_observable_of PURE_IMPORTS_END */


function endWith() {
    var array = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        array[_i] = arguments[_i];
    }
    return function (source) { return Object(__WEBPACK_IMPORTED_MODULE_0__observable_concat__["a" /* concat */])(source, __WEBPACK_IMPORTED_MODULE_1__observable_of__["a" /* of */].apply(void 0, array)); };
}
//# sourceMappingURL=endWith.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/every.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = every;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function every(predicate, thisArg) {
    return function (source) { return source.lift(new EveryOperator(predicate, thisArg, source)); };
}
var EveryOperator = /*@__PURE__*/ (function () {
    function EveryOperator(predicate, thisArg, source) {
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
    }
    EveryOperator.prototype.call = function (observer, source) {
        return source.subscribe(new EverySubscriber(observer, this.predicate, this.thisArg, this.source));
    };
    return EveryOperator;
}());
var EverySubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EverySubscriber, _super);
    function EverySubscriber(destination, predicate, thisArg, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.source = source;
        _this.index = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    EverySubscriber.prototype.notifyComplete = function (everyValueMatch) {
        this.destination.next(everyValueMatch);
        this.destination.complete();
    };
    EverySubscriber.prototype._next = function (value) {
        var result = false;
        try {
            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (!result) {
            this.notifyComplete(false);
        }
    };
    EverySubscriber.prototype._complete = function () {
        this.notifyComplete(true);
    };
    return EverySubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=every.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/exhaust.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = exhaust;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function exhaust() {
    return function (source) { return source.lift(new SwitchFirstOperator()); };
}
var SwitchFirstOperator = /*@__PURE__*/ (function () {
    function SwitchFirstOperator() {
    }
    SwitchFirstOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchFirstSubscriber(subscriber));
    };
    return SwitchFirstOperator;
}());
var SwitchFirstSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SwitchFirstSubscriber, _super);
    function SwitchFirstSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasCompleted = false;
        _this.hasSubscription = false;
        return _this;
    }
    SwitchFirstSubscriber.prototype._next = function (value) {
        if (!this.hasSubscription) {
            this.hasSubscription = true;
            this.add(Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(this, value));
        }
    };
    SwitchFirstSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (!this.hasSubscription) {
            this.destination.complete();
        }
    };
    SwitchFirstSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) {
            this.destination.complete();
        }
    };
    return SwitchFirstSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=exhaust.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/exhaustMap.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = exhaustMap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InnerSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/InnerSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__map__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__observable_from__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/from.js");
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_InnerSubscriber,_util_subscribeToResult,_map,_observable_from PURE_IMPORTS_END */






function exhaustMap(project, resultSelector) {
    if (resultSelector) {
        return function (source) { return source.pipe(exhaustMap(function (a, i) { return Object(__WEBPACK_IMPORTED_MODULE_5__observable_from__["a" /* from */])(project(a, i)).pipe(Object(__WEBPACK_IMPORTED_MODULE_4__map__["a" /* map */])(function (b, ii) { return resultSelector(a, b, i, ii); })); })); };
    }
    return function (source) {
        return source.lift(new ExhaustMapOperator(project));
    };
}
var ExhaustMapOperator = /*@__PURE__*/ (function () {
    function ExhaustMapOperator(project) {
        this.project = project;
    }
    ExhaustMapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ExhaustMapSubscriber(subscriber, this.project));
    };
    return ExhaustMapOperator;
}());
var ExhaustMapSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ExhaustMapSubscriber, _super);
    function ExhaustMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.hasSubscription = false;
        _this.hasCompleted = false;
        _this.index = 0;
        return _this;
    }
    ExhaustMapSubscriber.prototype._next = function (value) {
        if (!this.hasSubscription) {
            this.tryNext(value);
        }
    };
    ExhaustMapSubscriber.prototype.tryNext = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.hasSubscription = true;
        this._innerSub(result, value, index);
    };
    ExhaustMapSubscriber.prototype._innerSub = function (result, value, index) {
        var innerSubscriber = new __WEBPACK_IMPORTED_MODULE_2__InnerSubscriber__["a" /* InnerSubscriber */](this, undefined, undefined);
        var destination = this.destination;
        destination.add(innerSubscriber);
        Object(__WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__["a" /* subscribeToResult */])(this, result, value, index, innerSubscriber);
    };
    ExhaustMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (!this.hasSubscription) {
            this.destination.complete();
        }
        this.unsubscribe();
    };
    ExhaustMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    ExhaustMapSubscriber.prototype.notifyError = function (err) {
        this.destination.error(err);
    };
    ExhaustMapSubscriber.prototype.notifyComplete = function (innerSub) {
        var destination = this.destination;
        destination.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) {
            this.destination.complete();
        }
    };
    return ExhaustMapSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=exhaustMap.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/expand.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = expand;
/* unused harmony export ExpandOperator */
/* unused harmony export ExpandSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function expand(project, concurrent, scheduler) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    if (scheduler === void 0) {
        scheduler = undefined;
    }
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return function (source) { return source.lift(new ExpandOperator(project, concurrent, scheduler)); };
}
var ExpandOperator = /*@__PURE__*/ (function () {
    function ExpandOperator(project, concurrent, scheduler) {
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
    }
    ExpandOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
    };
    return ExpandOperator;
}());

var ExpandSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ExpandSubscriber, _super);
    function ExpandSubscriber(destination, project, concurrent, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.scheduler = scheduler;
        _this.index = 0;
        _this.active = 0;
        _this.hasCompleted = false;
        if (concurrent < Number.POSITIVE_INFINITY) {
            _this.buffer = [];
        }
        return _this;
    }
    ExpandSubscriber.dispatch = function (arg) {
        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
        subscriber.subscribeToProjection(result, value, index);
    };
    ExpandSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        if (destination.closed) {
            this._complete();
            return;
        }
        var index = this.index++;
        if (this.active < this.concurrent) {
            destination.next(value);
            try {
                var project = this.project;
                var result = project(value, index);
                if (!this.scheduler) {
                    this.subscribeToProjection(result, value, index);
                }
                else {
                    var state = { subscriber: this, result: result, value: value, index: index };
                    var destination_1 = this.destination;
                    destination_1.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
                }
            }
            catch (e) {
                destination.error(e);
            }
        }
        else {
            this.buffer.push(value);
        }
    };
    ExpandSubscriber.prototype.subscribeToProjection = function (result, value, index) {
        this.active++;
        var destination = this.destination;
        destination.add(Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(this, result, value, index));
    };
    ExpandSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.hasCompleted && this.active === 0) {
            this.destination.complete();
        }
        this.unsubscribe();
    };
    ExpandSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._next(innerValue);
    };
    ExpandSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        var destination = this.destination;
        destination.remove(innerSub);
        this.active--;
        if (buffer && buffer.length > 0) {
            this._next(buffer.shift());
        }
        if (this.hasCompleted && this.active === 0) {
            this.destination.complete();
        }
    };
    return ExpandSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));

//# sourceMappingURL=expand.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/filter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = filter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new FilterOperator(predicate, thisArg));
    };
}
var FilterOperator = /*@__PURE__*/ (function () {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}());
var FilterSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.count = 0;
        return _this;
    }
    FilterSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.destination.next(value);
        }
    };
    return FilterSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=filter.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/finalize.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = finalize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscription__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscription.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_Subscription PURE_IMPORTS_END */



function finalize(callback) {
    return function (source) { return source.lift(new FinallyOperator(callback)); };
}
var FinallyOperator = /*@__PURE__*/ (function () {
    function FinallyOperator(callback) {
        this.callback = callback;
    }
    FinallyOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new FinallySubscriber(subscriber, this.callback));
    };
    return FinallyOperator;
}());
var FinallySubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](FinallySubscriber, _super);
    function FinallySubscriber(destination, callback) {
        var _this = _super.call(this, destination) || this;
        _this.add(new __WEBPACK_IMPORTED_MODULE_2__Subscription__["a" /* Subscription */](callback));
        return _this;
    }
    return FinallySubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=finalize.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/find.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = find;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FindValueOperator; });
/* unused harmony export FindValueSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function find(predicate, thisArg) {
    if (typeof predicate !== 'function') {
        throw new TypeError('predicate is not a function');
    }
    return function (source) { return source.lift(new FindValueOperator(predicate, source, false, thisArg)); };
}
var FindValueOperator = /*@__PURE__*/ (function () {
    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
    }
    FindValueOperator.prototype.call = function (observer, source) {
        return source.subscribe(new FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
    };
    return FindValueOperator;
}());

var FindValueSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](FindValueSubscriber, _super);
    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.yieldIndex = yieldIndex;
        _this.thisArg = thisArg;
        _this.index = 0;
        return _this;
    }
    FindValueSubscriber.prototype.notifyComplete = function (value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
        this.unsubscribe();
    };
    FindValueSubscriber.prototype._next = function (value) {
        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
        var index = this.index++;
        try {
            var result = predicate.call(thisArg || this, value, index, this.source);
            if (result) {
                this.notifyComplete(this.yieldIndex ? index : value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    FindValueSubscriber.prototype._complete = function () {
        this.notifyComplete(this.yieldIndex ? -1 : undefined);
    };
    return FindValueSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));

//# sourceMappingURL=find.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/findIndex.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findIndex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__operators_find__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/find.js");
/** PURE_IMPORTS_START _operators_find PURE_IMPORTS_END */

function findIndex(predicate, thisArg) {
    return function (source) { return source.lift(new __WEBPACK_IMPORTED_MODULE_0__operators_find__["a" /* FindValueOperator */](predicate, source, true, thisArg)); };
}
//# sourceMappingURL=findIndex.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/first.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = first;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_EmptyError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/EmptyError.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filter__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/filter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__take__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/take.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultIfEmpty__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/defaultIfEmpty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__throwIfEmpty__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/throwIfEmpty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_identity__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/identity.js");
/** PURE_IMPORTS_START _util_EmptyError,_filter,_take,_defaultIfEmpty,_throwIfEmpty,_util_identity PURE_IMPORTS_END */






function first(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function (source) { return source.pipe(predicate ? Object(__WEBPACK_IMPORTED_MODULE_1__filter__["a" /* filter */])(function (v, i) { return predicate(v, i, source); }) : __WEBPACK_IMPORTED_MODULE_5__util_identity__["a" /* identity */], Object(__WEBPACK_IMPORTED_MODULE_2__take__["a" /* take */])(1), hasDefaultValue ? Object(__WEBPACK_IMPORTED_MODULE_3__defaultIfEmpty__["a" /* defaultIfEmpty */])(defaultValue) : Object(__WEBPACK_IMPORTED_MODULE_4__throwIfEmpty__["a" /* throwIfEmpty */])(function () { return new __WEBPACK_IMPORTED_MODULE_0__util_EmptyError__["a" /* EmptyError */](); })); };
}
//# sourceMappingURL=first.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/groupBy.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = groupBy;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupedObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscription__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscription.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Subject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subject.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_Subscription,_Observable,_Subject PURE_IMPORTS_END */





function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return function (source) {
        return source.lift(new GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
    };
}
var GroupByOperator = /*@__PURE__*/ (function () {
    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
    }
    GroupByOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
    };
    return GroupByOperator;
}());
var GroupBySubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](GroupBySubscriber, _super);
    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.elementSelector = elementSelector;
        _this.durationSelector = durationSelector;
        _this.subjectSelector = subjectSelector;
        _this.groups = null;
        _this.attemptedToUnsubscribe = false;
        _this.count = 0;
        return _this;
    }
    GroupBySubscriber.prototype._next = function (value) {
        var key;
        try {
            key = this.keySelector(value);
        }
        catch (err) {
            this.error(err);
            return;
        }
        this._group(value, key);
    };
    GroupBySubscriber.prototype._group = function (value, key) {
        var groups = this.groups;
        if (!groups) {
            groups = this.groups = new Map();
        }
        var group = groups.get(key);
        var element;
        if (this.elementSelector) {
            try {
                element = this.elementSelector(value);
            }
            catch (err) {
                this.error(err);
            }
        }
        else {
            element = value;
        }
        if (!group) {
            group = (this.subjectSelector ? this.subjectSelector() : new __WEBPACK_IMPORTED_MODULE_4__Subject__["a" /* Subject */]());
            groups.set(key, group);
            var groupedObservable = new GroupedObservable(key, group, this);
            this.destination.next(groupedObservable);
            if (this.durationSelector) {
                var duration = void 0;
                try {
                    duration = this.durationSelector(new GroupedObservable(key, group));
                }
                catch (err) {
                    this.error(err);
                    return;
                }
                this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
            }
        }
        if (!group.closed) {
            group.next(element);
        }
    };
    GroupBySubscriber.prototype._error = function (err) {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function (group, key) {
                group.error(err);
            });
            groups.clear();
        }
        this.destination.error(err);
    };
    GroupBySubscriber.prototype._complete = function () {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function (group, key) {
                group.complete();
            });
            groups.clear();
        }
        this.destination.complete();
    };
    GroupBySubscriber.prototype.removeGroup = function (key) {
        this.groups.delete(key);
    };
    GroupBySubscriber.prototype.unsubscribe = function () {
        if (!this.closed) {
            this.attemptedToUnsubscribe = true;
            if (this.count === 0) {
                _super.prototype.unsubscribe.call(this);
            }
        }
    };
    return GroupBySubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
var GroupDurationSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](GroupDurationSubscriber, _super);
    function GroupDurationSubscriber(key, group, parent) {
        var _this = _super.call(this, group) || this;
        _this.key = key;
        _this.group = group;
        _this.parent = parent;
        return _this;
    }
    GroupDurationSubscriber.prototype._next = function (value) {
        this.complete();
    };
    GroupDurationSubscriber.prototype._unsubscribe = function () {
        var _a = this, parent = _a.parent, key = _a.key;
        this.key = this.parent = null;
        if (parent) {
            parent.removeGroup(key);
        }
    };
    return GroupDurationSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
var GroupedObservable = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](GroupedObservable, _super);
    function GroupedObservable(key, groupSubject, refCountSubscription) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.groupSubject = groupSubject;
        _this.refCountSubscription = refCountSubscription;
        return _this;
    }
    GroupedObservable.prototype._subscribe = function (subscriber) {
        var subscription = new __WEBPACK_IMPORTED_MODULE_2__Subscription__["a" /* Subscription */]();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) {
            subscription.add(new InnerRefCountSubscription(refCountSubscription));
        }
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
    };
    return GroupedObservable;
}(__WEBPACK_IMPORTED_MODULE_3__Observable__["a" /* Observable */]));

var InnerRefCountSubscription = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](InnerRefCountSubscription, _super);
    function InnerRefCountSubscription(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        parent.count++;
        return _this;
    }
    InnerRefCountSubscription.prototype.unsubscribe = function () {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
            _super.prototype.unsubscribe.call(this);
            parent.count -= 1;
            if (parent.count === 0 && parent.attemptedToUnsubscribe) {
                parent.unsubscribe();
            }
        }
    };
    return InnerRefCountSubscription;
}(__WEBPACK_IMPORTED_MODULE_2__Subscription__["a" /* Subscription */]));
//# sourceMappingURL=groupBy.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/ignoreElements.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ignoreElements;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function ignoreElements() {
    return function ignoreElementsOperatorFunction(source) {
        return source.lift(new IgnoreElementsOperator());
    };
}
var IgnoreElementsOperator = /*@__PURE__*/ (function () {
    function IgnoreElementsOperator() {
    }
    IgnoreElementsOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new IgnoreElementsSubscriber(subscriber));
    };
    return IgnoreElementsOperator;
}());
var IgnoreElementsSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](IgnoreElementsSubscriber, _super);
    function IgnoreElementsSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IgnoreElementsSubscriber.prototype._next = function (unused) {
    };
    return IgnoreElementsSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=ignoreElements.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/isEmpty.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isEmpty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function isEmpty() {
    return function (source) { return source.lift(new IsEmptyOperator()); };
}
var IsEmptyOperator = /*@__PURE__*/ (function () {
    function IsEmptyOperator() {
    }
    IsEmptyOperator.prototype.call = function (observer, source) {
        return source.subscribe(new IsEmptySubscriber(observer));
    };
    return IsEmptyOperator;
}());
var IsEmptySubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](IsEmptySubscriber, _super);
    function IsEmptySubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    IsEmptySubscriber.prototype.notifyComplete = function (isEmpty) {
        var destination = this.destination;
        destination.next(isEmpty);
        destination.complete();
    };
    IsEmptySubscriber.prototype._next = function (value) {
        this.notifyComplete(false);
    };
    IsEmptySubscriber.prototype._complete = function () {
        this.notifyComplete(true);
    };
    return IsEmptySubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=isEmpty.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/last.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = last;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_EmptyError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/EmptyError.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filter__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/filter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__takeLast__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/takeLast.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__throwIfEmpty__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/throwIfEmpty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultIfEmpty__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/defaultIfEmpty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_identity__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/identity.js");
/** PURE_IMPORTS_START _util_EmptyError,_filter,_takeLast,_throwIfEmpty,_defaultIfEmpty,_util_identity PURE_IMPORTS_END */






function last(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function (source) { return source.pipe(predicate ? Object(__WEBPACK_IMPORTED_MODULE_1__filter__["a" /* filter */])(function (v, i) { return predicate(v, i, source); }) : __WEBPACK_IMPORTED_MODULE_5__util_identity__["a" /* identity */], Object(__WEBPACK_IMPORTED_MODULE_2__takeLast__["a" /* takeLast */])(1), hasDefaultValue ? Object(__WEBPACK_IMPORTED_MODULE_4__defaultIfEmpty__["a" /* defaultIfEmpty */])(defaultValue) : Object(__WEBPACK_IMPORTED_MODULE_3__throwIfEmpty__["a" /* throwIfEmpty */])(function () { return new __WEBPACK_IMPORTED_MODULE_0__util_EmptyError__["a" /* EmptyError */](); })); };
}
//# sourceMappingURL=last.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/map.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = map;
/* unused harmony export MapOperator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== 'function') {
            throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        }
        return source.lift(new MapOperator(project, thisArg));
    };
}
var MapOperator = /*@__PURE__*/ (function () {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}());

var MapSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.count = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    MapSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=map.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/mapTo.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapTo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function mapTo(value) {
    return function (source) { return source.lift(new MapToOperator(value)); };
}
var MapToOperator = /*@__PURE__*/ (function () {
    function MapToOperator(value) {
        this.value = value;
    }
    MapToOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapToSubscriber(subscriber, this.value));
    };
    return MapToOperator;
}());
var MapToSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MapToSubscriber, _super);
    function MapToSubscriber(destination, value) {
        var _this = _super.call(this, destination) || this;
        _this.value = value;
        return _this;
    }
    MapToSubscriber.prototype._next = function (x) {
        this.destination.next(this.value);
    };
    return MapToSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=mapTo.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/materialize.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = materialize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Notification__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Notification.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */



function materialize() {
    return function materializeOperatorFunction(source) {
        return source.lift(new MaterializeOperator());
    };
}
var MaterializeOperator = /*@__PURE__*/ (function () {
    function MaterializeOperator() {
    }
    MaterializeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MaterializeSubscriber(subscriber));
    };
    return MaterializeOperator;
}());
var MaterializeSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MaterializeSubscriber, _super);
    function MaterializeSubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    MaterializeSubscriber.prototype._next = function (value) {
        this.destination.next(__WEBPACK_IMPORTED_MODULE_2__Notification__["a" /* Notification */].createNext(value));
    };
    MaterializeSubscriber.prototype._error = function (err) {
        var destination = this.destination;
        destination.next(__WEBPACK_IMPORTED_MODULE_2__Notification__["a" /* Notification */].createError(err));
        destination.complete();
    };
    MaterializeSubscriber.prototype._complete = function () {
        var destination = this.destination;
        destination.next(__WEBPACK_IMPORTED_MODULE_2__Notification__["a" /* Notification */].createComplete());
        destination.complete();
    };
    return MaterializeSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=materialize.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/max.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = max;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reduce__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/reduce.js");
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */

function max(comparer) {
    var max = (typeof comparer === 'function')
        ? function (x, y) { return comparer(x, y) > 0 ? x : y; }
        : function (x, y) { return x > y ? x : y; };
    return Object(__WEBPACK_IMPORTED_MODULE_0__reduce__["a" /* reduce */])(max);
}
//# sourceMappingURL=max.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/merge.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = merge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_merge__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/merge.js");
/** PURE_IMPORTS_START _observable_merge PURE_IMPORTS_END */

function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return function (source) { return source.lift.call(__WEBPACK_IMPORTED_MODULE_0__observable_merge__["a" /* merge */].apply(void 0, [source].concat(observables))); };
}
//# sourceMappingURL=merge.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/mergeAll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mergeMap__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/mergeMap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_identity__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/identity.js");
/** PURE_IMPORTS_START _mergeMap,_util_identity PURE_IMPORTS_END */


function mergeAll(concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__mergeMap__["a" /* mergeMap */])(__WEBPACK_IMPORTED_MODULE_1__util_identity__["a" /* identity */], concurrent);
}
//# sourceMappingURL=mergeAll.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/mergeMap.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeMap;
/* unused harmony export MergeMapOperator */
/* unused harmony export MergeMapSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InnerSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/InnerSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__map__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__observable_from__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/from.js");
/** PURE_IMPORTS_START tslib,_util_subscribeToResult,_OuterSubscriber,_InnerSubscriber,_map,_observable_from PURE_IMPORTS_END */






function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    if (typeof resultSelector === 'function') {
        return function (source) { return source.pipe(mergeMap(function (a, i) { return Object(__WEBPACK_IMPORTED_MODULE_5__observable_from__["a" /* from */])(project(a, i)).pipe(Object(__WEBPACK_IMPORTED_MODULE_4__map__["a" /* map */])(function (b, ii) { return resultSelector(a, b, i, ii); })); }, concurrent)); };
    }
    else if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return function (source) { return source.lift(new MergeMapOperator(project, concurrent)); };
}
var MergeMapOperator = /*@__PURE__*/ (function () {
    function MergeMapOperator(project, concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        this.project = project;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
    };
    return MergeMapOperator;
}());

var MergeMapSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeMapSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            this._tryNext(value);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeMapSubscriber.prototype._tryNext = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result, value, index);
    };
    MergeMapSubscriber.prototype._innerSub = function (ish, value, index) {
        var innerSubscriber = new __WEBPACK_IMPORTED_MODULE_3__InnerSubscriber__["a" /* InnerSubscriber */](this, undefined, undefined);
        var destination = this.destination;
        destination.add(innerSubscriber);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_subscribeToResult__["a" /* subscribeToResult */])(this, ish, value, index, innerSubscriber);
    };
    MergeMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
        this.unsubscribe();
    };
    MergeMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeMapSubscriber;
}(__WEBPACK_IMPORTED_MODULE_2__OuterSubscriber__["a" /* OuterSubscriber */]));

//# sourceMappingURL=mergeMap.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/mergeMapTo.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeMapTo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mergeMap__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/mergeMap.js");
/** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */

function mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    if (typeof resultSelector === 'function') {
        return Object(__WEBPACK_IMPORTED_MODULE_0__mergeMap__["a" /* mergeMap */])(function () { return innerObservable; }, resultSelector, concurrent);
    }
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__mergeMap__["a" /* mergeMap */])(function () { return innerObservable; }, concurrent);
}
//# sourceMappingURL=mergeMapTo.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/mergeScan.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeScan;
/* unused harmony export MergeScanOperator */
/* unused harmony export MergeScanSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InnerSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/InnerSubscriber.js");
/** PURE_IMPORTS_START tslib,_util_subscribeToResult,_OuterSubscriber,_InnerSubscriber PURE_IMPORTS_END */




function mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    return function (source) { return source.lift(new MergeScanOperator(accumulator, seed, concurrent)); };
}
var MergeScanOperator = /*@__PURE__*/ (function () {
    function MergeScanOperator(accumulator, seed, concurrent) {
        this.accumulator = accumulator;
        this.seed = seed;
        this.concurrent = concurrent;
    }
    MergeScanOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
    };
    return MergeScanOperator;
}());

var MergeScanSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MergeScanSubscriber, _super);
    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
        var _this = _super.call(this, destination) || this;
        _this.accumulator = accumulator;
        _this.acc = acc;
        _this.concurrent = concurrent;
        _this.hasValue = false;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeScanSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            var index = this.index++;
            var destination = this.destination;
            var ish = void 0;
            try {
                var accumulator = this.accumulator;
                ish = accumulator(this.acc, value, index);
            }
            catch (e) {
                return destination.error(e);
            }
            this.active++;
            this._innerSub(ish, value, index);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeScanSubscriber.prototype._innerSub = function (ish, value, index) {
        var innerSubscriber = new __WEBPACK_IMPORTED_MODULE_3__InnerSubscriber__["a" /* InnerSubscriber */](this, undefined, undefined);
        var destination = this.destination;
        destination.add(innerSubscriber);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_subscribeToResult__["a" /* subscribeToResult */])(this, ish, value, index, innerSubscriber);
    };
    MergeScanSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            if (this.hasValue === false) {
                this.destination.next(this.acc);
            }
            this.destination.complete();
        }
        this.unsubscribe();
    };
    MergeScanSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var destination = this.destination;
        this.acc = innerValue;
        this.hasValue = true;
        destination.next(innerValue);
    };
    MergeScanSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        var destination = this.destination;
        destination.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            if (this.hasValue === false) {
                this.destination.next(this.acc);
            }
            this.destination.complete();
        }
    };
    return MergeScanSubscriber;
}(__WEBPACK_IMPORTED_MODULE_2__OuterSubscriber__["a" /* OuterSubscriber */]));

//# sourceMappingURL=mergeScan.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/min.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = min;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reduce__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/reduce.js");
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */

function min(comparer) {
    var min = (typeof comparer === 'function')
        ? function (x, y) { return comparer(x, y) < 0 ? x : y; }
        : function (x, y) { return x < y ? x : y; };
    return Object(__WEBPACK_IMPORTED_MODULE_0__reduce__["a" /* reduce */])(min);
}
//# sourceMappingURL=min.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/multicast.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = multicast;
/* unused harmony export MulticastOperator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_ConnectableObservable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/ConnectableObservable.js");
/** PURE_IMPORTS_START _observable_ConnectableObservable PURE_IMPORTS_END */

function multicast(subjectOrSubjectFactory, selector) {
    return function multicastOperatorFunction(source) {
        var subjectFactory;
        if (typeof subjectOrSubjectFactory === 'function') {
            subjectFactory = subjectOrSubjectFactory;
        }
        else {
            subjectFactory = function subjectFactory() {
                return subjectOrSubjectFactory;
            };
        }
        if (typeof selector === 'function') {
            return source.lift(new MulticastOperator(subjectFactory, selector));
        }
        var connectable = Object.create(source, __WEBPACK_IMPORTED_MODULE_0__observable_ConnectableObservable__["b" /* connectableObservableDescriptor */]);
        connectable.source = source;
        connectable.subjectFactory = subjectFactory;
        return connectable;
    };
}
var MulticastOperator = /*@__PURE__*/ (function () {
    function MulticastOperator(subjectFactory, selector) {
        this.subjectFactory = subjectFactory;
        this.selector = selector;
    }
    MulticastOperator.prototype.call = function (subscriber, source) {
        var selector = this.selector;
        var subject = this.subjectFactory();
        var subscription = selector(subject).subscribe(subscriber);
        subscription.add(source.subscribe(subject));
        return subscription;
    };
    return MulticastOperator;
}());

//# sourceMappingURL=multicast.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/observeOn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = observeOn;
/* unused harmony export ObserveOnOperator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObserveOnSubscriber; });
/* unused harmony export ObserveOnMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Notification__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Notification.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */



function observeOn(scheduler, delay) {
    if (delay === void 0) {
        delay = 0;
    }
    return function observeOnOperatorFunction(source) {
        return source.lift(new ObserveOnOperator(scheduler, delay));
    };
}
var ObserveOnOperator = /*@__PURE__*/ (function () {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}());

var ObserveOnSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        var _this = _super.call(this, destination) || this;
        _this.scheduler = scheduler;
        _this.delay = delay;
        return _this;
    }
    ObserveOnSubscriber.dispatch = function (arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
        var destination = this.destination;
        destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function (value) {
        this.scheduleMessage(__WEBPACK_IMPORTED_MODULE_2__Notification__["a" /* Notification */].createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function (err) {
        this.scheduleMessage(__WEBPACK_IMPORTED_MODULE_2__Notification__["a" /* Notification */].createError(err));
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype._complete = function () {
        this.scheduleMessage(__WEBPACK_IMPORTED_MODULE_2__Notification__["a" /* Notification */].createComplete());
        this.unsubscribe();
    };
    return ObserveOnSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));

var ObserveOnMessage = /*@__PURE__*/ (function () {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}());

//# sourceMappingURL=observeOn.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/onErrorResumeNext.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = onErrorResumeNext;
/* unused harmony export onErrorResumeNextStatic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__observable_from__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/from.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InnerSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/InnerSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_observable_from,_util_isArray,_OuterSubscriber,_InnerSubscriber,_util_subscribeToResult PURE_IMPORTS_END */






function onErrorResumeNext() {
    var nextSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nextSources[_i] = arguments[_i];
    }
    if (nextSources.length === 1 && Object(__WEBPACK_IMPORTED_MODULE_2__util_isArray__["a" /* isArray */])(nextSources[0])) {
        nextSources = nextSources[0];
    }
    return function (source) { return source.lift(new OnErrorResumeNextOperator(nextSources)); };
}
function onErrorResumeNextStatic() {
    var nextSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nextSources[_i] = arguments[_i];
    }
    var source = null;
    if (nextSources.length === 1 && Object(__WEBPACK_IMPORTED_MODULE_2__util_isArray__["a" /* isArray */])(nextSources[0])) {
        nextSources = nextSources[0];
    }
    source = nextSources.shift();
    return Object(__WEBPACK_IMPORTED_MODULE_1__observable_from__["a" /* from */])(source, null).lift(new OnErrorResumeNextOperator(nextSources));
}
var OnErrorResumeNextOperator = /*@__PURE__*/ (function () {
    function OnErrorResumeNextOperator(nextSources) {
        this.nextSources = nextSources;
    }
    OnErrorResumeNextOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new OnErrorResumeNextSubscriber(subscriber, this.nextSources));
    };
    return OnErrorResumeNextOperator;
}());
var OnErrorResumeNextSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](OnErrorResumeNextSubscriber, _super);
    function OnErrorResumeNextSubscriber(destination, nextSources) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.nextSources = nextSources;
        return _this;
    }
    OnErrorResumeNextSubscriber.prototype.notifyError = function (error, innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.notifyComplete = function (innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._error = function (err) {
        this.subscribeToNextSource();
        this.unsubscribe();
    };
    OnErrorResumeNextSubscriber.prototype._complete = function () {
        this.subscribeToNextSource();
        this.unsubscribe();
    };
    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function () {
        var next = this.nextSources.shift();
        if (!!next) {
            var innerSubscriber = new __WEBPACK_IMPORTED_MODULE_4__InnerSubscriber__["a" /* InnerSubscriber */](this, undefined, undefined);
            var destination = this.destination;
            destination.add(innerSubscriber);
            Object(__WEBPACK_IMPORTED_MODULE_5__util_subscribeToResult__["a" /* subscribeToResult */])(this, next, undefined, undefined, innerSubscriber);
        }
        else {
            this.destination.complete();
        }
    };
    return OnErrorResumeNextSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=onErrorResumeNext.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/pairwise.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pairwise;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function pairwise() {
    return function (source) { return source.lift(new PairwiseOperator()); };
}
var PairwiseOperator = /*@__PURE__*/ (function () {
    function PairwiseOperator() {
    }
    PairwiseOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new PairwiseSubscriber(subscriber));
    };
    return PairwiseOperator;
}());
var PairwiseSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](PairwiseSubscriber, _super);
    function PairwiseSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasPrev = false;
        return _this;
    }
    PairwiseSubscriber.prototype._next = function (value) {
        var pair;
        if (this.hasPrev) {
            pair = [this.prev, value];
        }
        else {
            this.hasPrev = true;
        }
        this.prev = value;
        if (pair) {
            this.destination.next(pair);
        }
    };
    return PairwiseSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=pairwise.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/partition.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = partition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_not__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/not.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filter__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/filter.js");
/** PURE_IMPORTS_START _util_not,_filter PURE_IMPORTS_END */


function partition(predicate, thisArg) {
    return function (source) {
        return [
            Object(__WEBPACK_IMPORTED_MODULE_1__filter__["a" /* filter */])(predicate, thisArg)(source),
            Object(__WEBPACK_IMPORTED_MODULE_1__filter__["a" /* filter */])(Object(__WEBPACK_IMPORTED_MODULE_0__util_not__["a" /* not */])(predicate, thisArg))(source)
        ];
    };
}
//# sourceMappingURL=partition.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/pluck.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pluck;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/map.js");
/** PURE_IMPORTS_START _map PURE_IMPORTS_END */

function pluck() {
    var properties = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        properties[_i] = arguments[_i];
    }
    var length = properties.length;
    if (length === 0) {
        throw new Error('list of properties cannot be empty.');
    }
    return function (source) { return Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* map */])(plucker(properties, length))(source); };
}
function plucker(props, length) {
    var mapper = function (x) {
        var currentProp = x;
        for (var i = 0; i < length; i++) {
            var p = currentProp[props[i]];
            if (typeof p !== 'undefined') {
                currentProp = p;
            }
            else {
                return undefined;
            }
        }
        return currentProp;
    };
    return mapper;
}
//# sourceMappingURL=pluck.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/publish.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = publish;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Subject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__multicast__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/multicast.js");
/** PURE_IMPORTS_START _Subject,_multicast PURE_IMPORTS_END */


function publish(selector) {
    return selector ?
        Object(__WEBPACK_IMPORTED_MODULE_1__multicast__["a" /* multicast */])(function () { return new __WEBPACK_IMPORTED_MODULE_0__Subject__["a" /* Subject */](); }, selector) :
        Object(__WEBPACK_IMPORTED_MODULE_1__multicast__["a" /* multicast */])(new __WEBPACK_IMPORTED_MODULE_0__Subject__["a" /* Subject */]());
}
//# sourceMappingURL=publish.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/publishBehavior.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = publishBehavior;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BehaviorSubject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/BehaviorSubject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__multicast__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/multicast.js");
/** PURE_IMPORTS_START _BehaviorSubject,_multicast PURE_IMPORTS_END */


function publishBehavior(value) {
    return function (source) { return Object(__WEBPACK_IMPORTED_MODULE_1__multicast__["a" /* multicast */])(new __WEBPACK_IMPORTED_MODULE_0__BehaviorSubject__["a" /* BehaviorSubject */](value))(source); };
}
//# sourceMappingURL=publishBehavior.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/publishLast.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = publishLast;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncSubject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/AsyncSubject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__multicast__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/multicast.js");
/** PURE_IMPORTS_START _AsyncSubject,_multicast PURE_IMPORTS_END */


function publishLast() {
    return function (source) { return Object(__WEBPACK_IMPORTED_MODULE_1__multicast__["a" /* multicast */])(new __WEBPACK_IMPORTED_MODULE_0__AsyncSubject__["a" /* AsyncSubject */]())(source); };
}
//# sourceMappingURL=publishLast.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/publishReplay.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = publishReplay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReplaySubject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/ReplaySubject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__multicast__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/multicast.js");
/** PURE_IMPORTS_START _ReplaySubject,_multicast PURE_IMPORTS_END */


function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') {
        scheduler = selectorOrScheduler;
    }
    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
    var subject = new __WEBPACK_IMPORTED_MODULE_0__ReplaySubject__["a" /* ReplaySubject */](bufferSize, windowTime, scheduler);
    return function (source) { return Object(__WEBPACK_IMPORTED_MODULE_1__multicast__["a" /* multicast */])(function () { return subject; }, selector)(source); };
}
//# sourceMappingURL=publishReplay.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/race.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = race;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_isArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__observable_race__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/race.js");
/** PURE_IMPORTS_START _util_isArray,_observable_race PURE_IMPORTS_END */


function race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return function raceOperatorFunction(source) {
        if (observables.length === 1 && Object(__WEBPACK_IMPORTED_MODULE_0__util_isArray__["a" /* isArray */])(observables[0])) {
            observables = observables[0];
        }
        return source.lift.call(__WEBPACK_IMPORTED_MODULE_1__observable_race__["a" /* race */].apply(void 0, [source].concat(observables)));
    };
}
//# sourceMappingURL=race.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/reduce.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reduce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scan__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/scan.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__takeLast__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/takeLast.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultIfEmpty__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/defaultIfEmpty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_pipe__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/pipe.js");
/** PURE_IMPORTS_START _scan,_takeLast,_defaultIfEmpty,_util_pipe PURE_IMPORTS_END */




function reduce(accumulator, seed) {
    if (arguments.length >= 2) {
        return function reduceOperatorFunctionWithSeed(source) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__util_pipe__["a" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_0__scan__["a" /* scan */])(accumulator, seed), Object(__WEBPACK_IMPORTED_MODULE_1__takeLast__["a" /* takeLast */])(1), Object(__WEBPACK_IMPORTED_MODULE_2__defaultIfEmpty__["a" /* defaultIfEmpty */])(seed))(source);
        };
    }
    return function reduceOperatorFunction(source) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__util_pipe__["a" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_0__scan__["a" /* scan */])(function (acc, value, index) { return accumulator(acc, value, index + 1); }), Object(__WEBPACK_IMPORTED_MODULE_1__takeLast__["a" /* takeLast */])(1))(source);
    };
}
//# sourceMappingURL=reduce.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/refCount.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = refCount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new RefCountOperator(source));
    };
}
var RefCountOperator = /*@__PURE__*/ (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=refCount.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/repeat.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = repeat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__observable_empty__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/empty.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_observable_empty PURE_IMPORTS_END */



function repeat(count) {
    if (count === void 0) {
        count = -1;
    }
    return function (source) {
        if (count === 0) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__observable_empty__["b" /* empty */])();
        }
        else if (count < 0) {
            return source.lift(new RepeatOperator(-1, source));
        }
        else {
            return source.lift(new RepeatOperator(count - 1, source));
        }
    };
}
var RepeatOperator = /*@__PURE__*/ (function () {
    function RepeatOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RepeatOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RepeatSubscriber(subscriber, this.count, this.source));
    };
    return RepeatOperator;
}());
var RepeatSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](RepeatSubscriber, _super);
    function RepeatSubscriber(destination, count, source) {
        var _this = _super.call(this, destination) || this;
        _this.count = count;
        _this.source = source;
        return _this;
    }
    RepeatSubscriber.prototype.complete = function () {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) {
                return _super.prototype.complete.call(this);
            }
            else if (count > -1) {
                this.count = count - 1;
            }
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RepeatSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=repeat.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/repeatWhen.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = repeatWhen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_Subject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */




function repeatWhen(notifier) {
    return function (source) { return source.lift(new RepeatWhenOperator(notifier)); };
}
var RepeatWhenOperator = /*@__PURE__*/ (function () {
    function RepeatWhenOperator(notifier) {
        this.notifier = notifier;
    }
    RepeatWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RepeatWhenSubscriber(subscriber, this.notifier, source));
    };
    return RepeatWhenOperator;
}());
var RepeatWhenSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](RepeatWhenSubscriber, _super);
    function RepeatWhenSubscriber(destination, notifier, source) {
        var _this = _super.call(this, destination) || this;
        _this.notifier = notifier;
        _this.source = source;
        _this.sourceIsBeingSubscribedTo = true;
        return _this;
    }
    RepeatWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.sourceIsBeingSubscribedTo = true;
        this.source.subscribe(this);
    };
    RepeatWhenSubscriber.prototype.notifyComplete = function (innerSub) {
        if (this.sourceIsBeingSubscribedTo === false) {
            return _super.prototype.complete.call(this);
        }
    };
    RepeatWhenSubscriber.prototype.complete = function () {
        this.sourceIsBeingSubscribedTo = false;
        if (!this.isStopped) {
            if (!this.retries) {
                this.subscribeToRetries();
            }
            if (!this.retriesSubscription || this.retriesSubscription.closed) {
                return _super.prototype.complete.call(this);
            }
            this._unsubscribeAndRecycle();
            this.notifications.next();
        }
    };
    RepeatWhenSubscriber.prototype._unsubscribe = function () {
        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
        if (notifications) {
            notifications.unsubscribe();
            this.notifications = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function () {
        var _unsubscribe = this._unsubscribe;
        this._unsubscribe = null;
        _super.prototype._unsubscribeAndRecycle.call(this);
        this._unsubscribe = _unsubscribe;
        return this;
    };
    RepeatWhenSubscriber.prototype.subscribeToRetries = function () {
        this.notifications = new __WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]();
        var retries;
        try {
            var notifier = this.notifier;
            retries = notifier(this.notifications);
        }
        catch (e) {
            return _super.prototype.complete.call(this);
        }
        this.retries = retries;
        this.retriesSubscription = Object(__WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__["a" /* subscribeToResult */])(this, retries);
    };
    return RepeatWhenSubscriber;
}(__WEBPACK_IMPORTED_MODULE_2__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=repeatWhen.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/retry.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = retry;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function retry(count) {
    if (count === void 0) {
        count = -1;
    }
    return function (source) { return source.lift(new RetryOperator(count, source)); };
}
var RetryOperator = /*@__PURE__*/ (function () {
    function RetryOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RetryOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RetrySubscriber(subscriber, this.count, this.source));
    };
    return RetryOperator;
}());
var RetrySubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](RetrySubscriber, _super);
    function RetrySubscriber(destination, count, source) {
        var _this = _super.call(this, destination) || this;
        _this.count = count;
        _this.source = source;
        return _this;
    }
    RetrySubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) {
                return _super.prototype.error.call(this, err);
            }
            else if (count > -1) {
                this.count = count - 1;
            }
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RetrySubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=retry.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/retryWhen.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = retryWhen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_Subject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */




function retryWhen(notifier) {
    return function (source) { return source.lift(new RetryWhenOperator(notifier, source)); };
}
var RetryWhenOperator = /*@__PURE__*/ (function () {
    function RetryWhenOperator(notifier, source) {
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RetryWhenSubscriber(subscriber, this.notifier, this.source));
    };
    return RetryWhenOperator;
}());
var RetryWhenSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](RetryWhenSubscriber, _super);
    function RetryWhenSubscriber(destination, notifier, source) {
        var _this = _super.call(this, destination) || this;
        _this.notifier = notifier;
        _this.source = source;
        return _this;
    }
    RetryWhenSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var errors = this.errors;
            var retries = this.retries;
            var retriesSubscription = this.retriesSubscription;
            if (!retries) {
                errors = new __WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]();
                try {
                    var notifier = this.notifier;
                    retries = notifier(errors);
                }
                catch (e) {
                    return _super.prototype.error.call(this, e);
                }
                retriesSubscription = Object(__WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__["a" /* subscribeToResult */])(this, retries);
            }
            else {
                this.errors = null;
                this.retriesSubscription = null;
            }
            this._unsubscribeAndRecycle();
            this.errors = errors;
            this.retries = retries;
            this.retriesSubscription = retriesSubscription;
            errors.next(err);
        }
    };
    RetryWhenSubscriber.prototype._unsubscribe = function () {
        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
        if (errors) {
            errors.unsubscribe();
            this.errors = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    RetryWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _unsubscribe = this._unsubscribe;
        this._unsubscribe = null;
        this._unsubscribeAndRecycle();
        this._unsubscribe = _unsubscribe;
        this.source.subscribe(this);
    };
    return RetryWhenSubscriber;
}(__WEBPACK_IMPORTED_MODULE_2__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=retryWhen.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/sample.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sample;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function sample(notifier) {
    return function (source) { return source.lift(new SampleOperator(notifier)); };
}
var SampleOperator = /*@__PURE__*/ (function () {
    function SampleOperator(notifier) {
        this.notifier = notifier;
    }
    SampleOperator.prototype.call = function (subscriber, source) {
        var sampleSubscriber = new SampleSubscriber(subscriber);
        var subscription = source.subscribe(sampleSubscriber);
        subscription.add(Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(sampleSubscriber, this.notifier));
        return subscription;
    };
    return SampleOperator;
}());
var SampleSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SampleSubscriber, _super);
    function SampleSubscriber() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasValue = false;
        return _this;
    }
    SampleSubscriber.prototype._next = function (value) {
        this.value = value;
        this.hasValue = true;
    };
    SampleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    SampleSubscriber.prototype.notifyComplete = function () {
        this.emitValue();
    };
    SampleSubscriber.prototype.emitValue = function () {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.value);
        }
    };
    return SampleSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=sample.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/sampleTime.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sampleTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler_async__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */



function sampleTime(period, scheduler) {
    if (scheduler === void 0) {
        scheduler = __WEBPACK_IMPORTED_MODULE_2__scheduler_async__["a" /* async */];
    }
    return function (source) { return source.lift(new SampleTimeOperator(period, scheduler)); };
}
var SampleTimeOperator = /*@__PURE__*/ (function () {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}());
var SampleTimeSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.period = period;
        _this.scheduler = scheduler;
        _this.hasValue = false;
        _this.add(scheduler.schedule(dispatchNotification, period, { subscriber: _this, period: period }));
        return _this;
    }
    SampleTimeSubscriber.prototype._next = function (value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function () {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
function dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
}
//# sourceMappingURL=sampleTime.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/scan.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scan;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function scan(accumulator, seed) {
    var hasSeed = false;
    if (arguments.length >= 2) {
        hasSeed = true;
    }
    return function scanOperatorFunction(source) {
        return source.lift(new ScanOperator(accumulator, seed, hasSeed));
    };
}
var ScanOperator = /*@__PURE__*/ (function () {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) {
            hasSeed = false;
        }
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}());
var ScanSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        var _this = _super.call(this, destination) || this;
        _this.accumulator = accumulator;
        _this._seed = _seed;
        _this.hasSeed = hasSeed;
        _this.index = 0;
        return _this;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function () {
            return this._seed;
        },
        set: function (value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function (value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        }
        else {
            return this._tryNext(value);
        }
    };
    ScanSubscriber.prototype._tryNext = function (value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        }
        catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=scan.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/sequenceEqual.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sequenceEqual;
/* unused harmony export SequenceEqualOperator */
/* unused harmony export SequenceEqualSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function sequenceEqual(compareTo, comparator) {
    return function (source) { return source.lift(new SequenceEqualOperator(compareTo, comparator)); };
}
var SequenceEqualOperator = /*@__PURE__*/ (function () {
    function SequenceEqualOperator(compareTo, comparator) {
        this.compareTo = compareTo;
        this.comparator = comparator;
    }
    SequenceEqualOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SequenceEqualSubscriber(subscriber, this.compareTo, this.comparator));
    };
    return SequenceEqualOperator;
}());

var SequenceEqualSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SequenceEqualSubscriber, _super);
    function SequenceEqualSubscriber(destination, compareTo, comparator) {
        var _this = _super.call(this, destination) || this;
        _this.compareTo = compareTo;
        _this.comparator = comparator;
        _this._a = [];
        _this._b = [];
        _this._oneComplete = false;
        _this.destination.add(compareTo.subscribe(new SequenceEqualCompareToSubscriber(destination, _this)));
        return _this;
    }
    SequenceEqualSubscriber.prototype._next = function (value) {
        if (this._oneComplete && this._b.length === 0) {
            this.emit(false);
        }
        else {
            this._a.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype._complete = function () {
        if (this._oneComplete) {
            this.emit(this._a.length === 0 && this._b.length === 0);
        }
        else {
            this._oneComplete = true;
        }
        this.unsubscribe();
    };
    SequenceEqualSubscriber.prototype.checkValues = function () {
        var _c = this, _a = _c._a, _b = _c._b, comparator = _c.comparator;
        while (_a.length > 0 && _b.length > 0) {
            var a = _a.shift();
            var b = _b.shift();
            var areEqual = false;
            try {
                areEqual = comparator ? comparator(a, b) : a === b;
            }
            catch (e) {
                this.destination.error(e);
            }
            if (!areEqual) {
                this.emit(false);
            }
        }
    };
    SequenceEqualSubscriber.prototype.emit = function (value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    SequenceEqualSubscriber.prototype.nextB = function (value) {
        if (this._oneComplete && this._a.length === 0) {
            this.emit(false);
        }
        else {
            this._b.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype.completeB = function () {
        if (this._oneComplete) {
            this.emit(this._a.length === 0 && this._b.length === 0);
        }
        else {
            this._oneComplete = true;
        }
    };
    return SequenceEqualSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));

var SequenceEqualCompareToSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SequenceEqualCompareToSubscriber, _super);
    function SequenceEqualCompareToSubscriber(destination, parent) {
        var _this = _super.call(this, destination) || this;
        _this.parent = parent;
        return _this;
    }
    SequenceEqualCompareToSubscriber.prototype._next = function (value) {
        this.parent.nextB(value);
    };
    SequenceEqualCompareToSubscriber.prototype._error = function (err) {
        this.parent.error(err);
        this.unsubscribe();
    };
    SequenceEqualCompareToSubscriber.prototype._complete = function () {
        this.parent.completeB();
        this.unsubscribe();
    };
    return SequenceEqualCompareToSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=sequenceEqual.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/share.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = share;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__multicast__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/multicast.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__refCount__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/refCount.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subject.js");
/** PURE_IMPORTS_START _multicast,_refCount,_Subject PURE_IMPORTS_END */



function shareSubjectFactory() {
    return new __WEBPACK_IMPORTED_MODULE_2__Subject__["a" /* Subject */]();
}
function share() {
    return function (source) { return Object(__WEBPACK_IMPORTED_MODULE_1__refCount__["a" /* refCount */])()(Object(__WEBPACK_IMPORTED_MODULE_0__multicast__["a" /* multicast */])(shareSubjectFactory)(source)); };
}
//# sourceMappingURL=share.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/shareReplay.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shareReplay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReplaySubject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/ReplaySubject.js");
/** PURE_IMPORTS_START _ReplaySubject PURE_IMPORTS_END */

function shareReplay(configOrBufferSize, windowTime, scheduler) {
    var config;
    if (configOrBufferSize && typeof configOrBufferSize === 'object') {
        config = configOrBufferSize;
    }
    else {
        config = {
            bufferSize: configOrBufferSize,
            windowTime: windowTime,
            refCount: false,
            scheduler: scheduler
        };
    }
    return function (source) { return source.lift(shareReplayOperator(config)); };
}
function shareReplayOperator(_a) {
    var _b = _a.bufferSize, bufferSize = _b === void 0 ? Number.POSITIVE_INFINITY : _b, _c = _a.windowTime, windowTime = _c === void 0 ? Number.POSITIVE_INFINITY : _c, useRefCount = _a.refCount, scheduler = _a.scheduler;
    var subject;
    var refCount = 0;
    var subscription;
    var hasError = false;
    var isComplete = false;
    return function shareReplayOperation(source) {
        refCount++;
        if (!subject || hasError) {
            hasError = false;
            subject = new __WEBPACK_IMPORTED_MODULE_0__ReplaySubject__["a" /* ReplaySubject */](bufferSize, windowTime, scheduler);
            subscription = source.subscribe({
                next: function (value) { subject.next(value); },
                error: function (err) {
                    hasError = true;
                    subject.error(err);
                },
                complete: function () {
                    isComplete = true;
                    subject.complete();
                },
            });
        }
        var innerSub = subject.subscribe(this);
        this.add(function () {
            refCount--;
            innerSub.unsubscribe();
            if (subscription && !isComplete && useRefCount && refCount === 0) {
                subscription.unsubscribe();
                subscription = undefined;
                subject = undefined;
            }
        });
    };
}
//# sourceMappingURL=shareReplay.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/single.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = single;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_EmptyError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/EmptyError.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_util_EmptyError PURE_IMPORTS_END */



function single(predicate) {
    return function (source) { return source.lift(new SingleOperator(predicate, source)); };
}
var SingleOperator = /*@__PURE__*/ (function () {
    function SingleOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    SingleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SingleSubscriber(subscriber, this.predicate, this.source));
    };
    return SingleOperator;
}());
var SingleSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SingleSubscriber, _super);
    function SingleSubscriber(destination, predicate, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.seenValue = false;
        _this.index = 0;
        return _this;
    }
    SingleSubscriber.prototype.applySingleValue = function (value) {
        if (this.seenValue) {
            this.destination.error('Sequence contains more than one element');
        }
        else {
            this.seenValue = true;
            this.singleValue = value;
        }
    };
    SingleSubscriber.prototype._next = function (value) {
        var index = this.index++;
        if (this.predicate) {
            this.tryNext(value, index);
        }
        else {
            this.applySingleValue(value);
        }
    };
    SingleSubscriber.prototype.tryNext = function (value, index) {
        try {
            if (this.predicate(value, index, this.source)) {
                this.applySingleValue(value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    SingleSubscriber.prototype._complete = function () {
        var destination = this.destination;
        if (this.index > 0) {
            destination.next(this.seenValue ? this.singleValue : undefined);
            destination.complete();
        }
        else {
            destination.error(new __WEBPACK_IMPORTED_MODULE_2__util_EmptyError__["a" /* EmptyError */]);
        }
    };
    return SingleSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=single.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/skip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = skip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function skip(count) {
    return function (source) { return source.lift(new SkipOperator(count)); };
}
var SkipOperator = /*@__PURE__*/ (function () {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}());
var SkipSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.count = 0;
        return _this;
    }
    SkipSubscriber.prototype._next = function (x) {
        if (++this.count > this.total) {
            this.destination.next(x);
        }
    };
    return SkipSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=skip.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/skipLast.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = skipLast;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ArgumentOutOfRangeError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/ArgumentOutOfRangeError.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError PURE_IMPORTS_END */



function skipLast(count) {
    return function (source) { return source.lift(new SkipLastOperator(count)); };
}
var SkipLastOperator = /*@__PURE__*/ (function () {
    function SkipLastOperator(_skipCount) {
        this._skipCount = _skipCount;
        if (this._skipCount < 0) {
            throw new __WEBPACK_IMPORTED_MODULE_2__util_ArgumentOutOfRangeError__["a" /* ArgumentOutOfRangeError */];
        }
    }
    SkipLastOperator.prototype.call = function (subscriber, source) {
        if (this._skipCount === 0) {
            return source.subscribe(new __WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */](subscriber));
        }
        else {
            return source.subscribe(new SkipLastSubscriber(subscriber, this._skipCount));
        }
    };
    return SkipLastOperator;
}());
var SkipLastSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SkipLastSubscriber, _super);
    function SkipLastSubscriber(destination, _skipCount) {
        var _this = _super.call(this, destination) || this;
        _this._skipCount = _skipCount;
        _this._count = 0;
        _this._ring = new Array(_skipCount);
        return _this;
    }
    SkipLastSubscriber.prototype._next = function (value) {
        var skipCount = this._skipCount;
        var count = this._count++;
        if (count < skipCount) {
            this._ring[count] = value;
        }
        else {
            var currentIndex = count % skipCount;
            var ring = this._ring;
            var oldValue = ring[currentIndex];
            ring[currentIndex] = value;
            this.destination.next(oldValue);
        }
    };
    return SkipLastSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=skipLast.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/skipUntil.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = skipUntil;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InnerSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/InnerSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_InnerSubscriber,_util_subscribeToResult PURE_IMPORTS_END */




function skipUntil(notifier) {
    return function (source) { return source.lift(new SkipUntilOperator(notifier)); };
}
var SkipUntilOperator = /*@__PURE__*/ (function () {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function (destination, source) {
        return source.subscribe(new SkipUntilSubscriber(destination, this.notifier));
    };
    return SkipUntilOperator;
}());
var SkipUntilSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        var _this = _super.call(this, destination) || this;
        _this.hasValue = false;
        var innerSubscriber = new __WEBPACK_IMPORTED_MODULE_2__InnerSubscriber__["a" /* InnerSubscriber */](_this, undefined, undefined);
        _this.add(innerSubscriber);
        _this.innerSubscription = innerSubscriber;
        Object(__WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__["a" /* subscribeToResult */])(_this, notifier, undefined, undefined, innerSubscriber);
        return _this;
    }
    SkipUntilSubscriber.prototype._next = function (value) {
        if (this.hasValue) {
            _super.prototype._next.call(this, value);
        }
    };
    SkipUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.hasValue = true;
        if (this.innerSubscription) {
            this.innerSubscription.unsubscribe();
        }
    };
    SkipUntilSubscriber.prototype.notifyComplete = function () {
    };
    return SkipUntilSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=skipUntil.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/skipWhile.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = skipWhile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function skipWhile(predicate) {
    return function (source) { return source.lift(new SkipWhileOperator(predicate)); };
}
var SkipWhileOperator = /*@__PURE__*/ (function () {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}());
var SkipWhileSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.skipping = true;
        _this.index = 0;
        return _this;
    }
    SkipWhileSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        if (this.skipping) {
            this.tryCallPredicate(value);
        }
        if (!this.skipping) {
            destination.next(value);
        }
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function (value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=skipWhile.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/startWith.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startWith;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_concat__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/concat.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isScheduler__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isScheduler.js");
/** PURE_IMPORTS_START _observable_concat,_util_isScheduler PURE_IMPORTS_END */


function startWith() {
    var array = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        array[_i] = arguments[_i];
    }
    var scheduler = array[array.length - 1];
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isScheduler__["a" /* isScheduler */])(scheduler)) {
        array.pop();
        return function (source) { return Object(__WEBPACK_IMPORTED_MODULE_0__observable_concat__["a" /* concat */])(array, source, scheduler); };
    }
    else {
        return function (source) { return Object(__WEBPACK_IMPORTED_MODULE_0__observable_concat__["a" /* concat */])(array, source); };
    }
}
//# sourceMappingURL=startWith.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/subscribeOn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subscribeOn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_SubscribeOnObservable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/SubscribeOnObservable.js");
/** PURE_IMPORTS_START _observable_SubscribeOnObservable PURE_IMPORTS_END */

function subscribeOn(scheduler, delay) {
    if (delay === void 0) {
        delay = 0;
    }
    return function subscribeOnOperatorFunction(source) {
        return source.lift(new SubscribeOnOperator(scheduler, delay));
    };
}
var SubscribeOnOperator = /*@__PURE__*/ (function () {
    function SubscribeOnOperator(scheduler, delay) {
        this.scheduler = scheduler;
        this.delay = delay;
    }
    SubscribeOnOperator.prototype.call = function (subscriber, source) {
        return new __WEBPACK_IMPORTED_MODULE_0__observable_SubscribeOnObservable__["a" /* SubscribeOnObservable */](source, this.delay, this.scheduler).subscribe(subscriber);
    };
    return SubscribeOnOperator;
}());
//# sourceMappingURL=subscribeOn.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/switchAll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = switchAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__switchMap__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/switchMap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_identity__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/identity.js");
/** PURE_IMPORTS_START _switchMap,_util_identity PURE_IMPORTS_END */


function switchAll() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__switchMap__["a" /* switchMap */])(__WEBPACK_IMPORTED_MODULE_1__util_identity__["a" /* identity */]);
}
//# sourceMappingURL=switchAll.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/switchMap.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = switchMap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InnerSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/InnerSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__map__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__observable_from__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/from.js");
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_InnerSubscriber,_util_subscribeToResult,_map,_observable_from PURE_IMPORTS_END */






function switchMap(project, resultSelector) {
    if (typeof resultSelector === 'function') {
        return function (source) { return source.pipe(switchMap(function (a, i) { return Object(__WEBPACK_IMPORTED_MODULE_5__observable_from__["a" /* from */])(project(a, i)).pipe(Object(__WEBPACK_IMPORTED_MODULE_4__map__["a" /* map */])(function (b, ii) { return resultSelector(a, b, i, ii); })); })); };
    }
    return function (source) { return source.lift(new SwitchMapOperator(project)); };
}
var SwitchMapOperator = /*@__PURE__*/ (function () {
    function SwitchMapOperator(project) {
        this.project = project;
    }
    SwitchMapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchMapSubscriber(subscriber, this.project));
    };
    return SwitchMapOperator;
}());
var SwitchMapSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.index = 0;
        return _this;
    }
    SwitchMapSubscriber.prototype._next = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function (result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) {
            innerSubscription.unsubscribe();
        }
        var innerSubscriber = new __WEBPACK_IMPORTED_MODULE_2__InnerSubscriber__["a" /* InnerSubscriber */](this, undefined, undefined);
        var destination = this.destination;
        destination.add(innerSubscriber);
        this.innerSubscription = Object(__WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__["a" /* subscribeToResult */])(this, result, value, index, innerSubscriber);
    };
    SwitchMapSubscriber.prototype._complete = function () {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) {
            _super.prototype._complete.call(this);
        }
        this.unsubscribe();
    };
    SwitchMapSubscriber.prototype._unsubscribe = function () {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function (innerSub) {
        var destination = this.destination;
        destination.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) {
            _super.prototype._complete.call(this);
        }
    };
    SwitchMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    return SwitchMapSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=switchMap.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/switchMapTo.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = switchMapTo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__switchMap__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/switchMap.js");
/** PURE_IMPORTS_START _switchMap PURE_IMPORTS_END */

function switchMapTo(innerObservable, resultSelector) {
    return resultSelector ? Object(__WEBPACK_IMPORTED_MODULE_0__switchMap__["a" /* switchMap */])(function () { return innerObservable; }, resultSelector) : Object(__WEBPACK_IMPORTED_MODULE_0__switchMap__["a" /* switchMap */])(function () { return innerObservable; });
}
//# sourceMappingURL=switchMapTo.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/take.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = take;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ArgumentOutOfRangeError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/ArgumentOutOfRangeError.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__observable_empty__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/empty.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */




function take(count) {
    return function (source) {
        if (count === 0) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__observable_empty__["b" /* empty */])();
        }
        else {
            return source.lift(new TakeOperator(count));
        }
    };
}
var TakeOperator = /*@__PURE__*/ (function () {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) {
            throw new __WEBPACK_IMPORTED_MODULE_2__util_ArgumentOutOfRangeError__["a" /* ArgumentOutOfRangeError */];
        }
    }
    TakeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}());
var TakeSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.count = 0;
        return _this;
    }
    TakeSubscriber.prototype._next = function (value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=take.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/takeLast.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLast;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ArgumentOutOfRangeError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/ArgumentOutOfRangeError.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__observable_empty__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/empty.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */




function takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__observable_empty__["b" /* empty */])();
        }
        else {
            return source.lift(new TakeLastOperator(count));
        }
    };
}
var TakeLastOperator = /*@__PURE__*/ (function () {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) {
            throw new __WEBPACK_IMPORTED_MODULE_2__util_ArgumentOutOfRangeError__["a" /* ArgumentOutOfRangeError */];
        }
    }
    TakeLastOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}());
var TakeLastSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.ring = new Array();
        _this.count = 0;
        return _this;
    }
    TakeLastSubscriber.prototype._next = function (value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) {
            ring.push(value);
        }
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function () {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for (var i = 0; i < total; i++) {
                var idx = (count++) % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=takeLast.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/takeUntil.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeUntil;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function takeUntil(notifier) {
    return function (source) { return source.lift(new TakeUntilOperator(notifier)); };
}
var TakeUntilOperator = /*@__PURE__*/ (function () {
    function TakeUntilOperator(notifier) {
        this.notifier = notifier;
    }
    TakeUntilOperator.prototype.call = function (subscriber, source) {
        var takeUntilSubscriber = new TakeUntilSubscriber(subscriber);
        var notifierSubscription = Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(takeUntilSubscriber, this.notifier);
        if (notifierSubscription && !takeUntilSubscriber.seenValue) {
            takeUntilSubscriber.add(notifierSubscription);
            return source.subscribe(takeUntilSubscriber);
        }
        return takeUntilSubscriber;
    };
    return TakeUntilOperator;
}());
var TakeUntilSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](TakeUntilSubscriber, _super);
    function TakeUntilSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.seenValue = false;
        return _this;
    }
    TakeUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.seenValue = true;
        this.complete();
    };
    TakeUntilSubscriber.prototype.notifyComplete = function () {
    };
    return TakeUntilSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=takeUntil.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/takeWhile.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeWhile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function takeWhile(predicate, inclusive) {
    if (inclusive === void 0) {
        inclusive = false;
    }
    return function (source) {
        return source.lift(new TakeWhileOperator(predicate, inclusive));
    };
}
var TakeWhileOperator = /*@__PURE__*/ (function () {
    function TakeWhileOperator(predicate, inclusive) {
        this.predicate = predicate;
        this.inclusive = inclusive;
    }
    TakeWhileOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeWhileSubscriber(subscriber, this.predicate, this.inclusive));
    };
    return TakeWhileOperator;
}());
var TakeWhileSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](TakeWhileSubscriber, _super);
    function TakeWhileSubscriber(destination, predicate, inclusive) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.inclusive = inclusive;
        _this.index = 0;
        return _this;
    }
    TakeWhileSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        var result;
        try {
            result = this.predicate(value, this.index++);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        this.nextOrComplete(value, result);
    };
    TakeWhileSubscriber.prototype.nextOrComplete = function (value, predicateResult) {
        var destination = this.destination;
        if (Boolean(predicateResult)) {
            destination.next(value);
        }
        else {
            if (this.inclusive) {
                destination.next(value);
            }
            destination.complete();
        }
    };
    return TakeWhileSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=takeWhile.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/tap.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_noop__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/noop.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_isFunction__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isFunction.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_util_noop,_util_isFunction PURE_IMPORTS_END */




function tap(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new DoOperator(nextOrObserver, error, complete));
    };
}
var DoOperator = /*@__PURE__*/ (function () {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TapSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}());
var TapSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](TapSubscriber, _super);
    function TapSubscriber(destination, observerOrNext, error, complete) {
        var _this = _super.call(this, destination) || this;
        _this._tapNext = __WEBPACK_IMPORTED_MODULE_2__util_noop__["a" /* noop */];
        _this._tapError = __WEBPACK_IMPORTED_MODULE_2__util_noop__["a" /* noop */];
        _this._tapComplete = __WEBPACK_IMPORTED_MODULE_2__util_noop__["a" /* noop */];
        _this._tapError = error || __WEBPACK_IMPORTED_MODULE_2__util_noop__["a" /* noop */];
        _this._tapComplete = complete || __WEBPACK_IMPORTED_MODULE_2__util_noop__["a" /* noop */];
        if (Object(__WEBPACK_IMPORTED_MODULE_3__util_isFunction__["a" /* isFunction */])(observerOrNext)) {
            _this._context = _this;
            _this._tapNext = observerOrNext;
        }
        else if (observerOrNext) {
            _this._context = observerOrNext;
            _this._tapNext = observerOrNext.next || __WEBPACK_IMPORTED_MODULE_2__util_noop__["a" /* noop */];
            _this._tapError = observerOrNext.error || __WEBPACK_IMPORTED_MODULE_2__util_noop__["a" /* noop */];
            _this._tapComplete = observerOrNext.complete || __WEBPACK_IMPORTED_MODULE_2__util_noop__["a" /* noop */];
        }
        return _this;
    }
    TapSubscriber.prototype._next = function (value) {
        try {
            this._tapNext.call(this._context, value);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(value);
    };
    TapSubscriber.prototype._error = function (err) {
        try {
            this._tapError.call(this._context, err);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.error(err);
    };
    TapSubscriber.prototype._complete = function () {
        try {
            this._tapComplete.call(this._context);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        return this.destination.complete();
    };
    return TapSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=tap.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/throttle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultThrottleConfig; });
/* harmony export (immutable) */ __webpack_exports__["b"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



var defaultThrottleConfig = {
    leading: true,
    trailing: false
};
function throttle(durationSelector, config) {
    if (config === void 0) {
        config = defaultThrottleConfig;
    }
    return function (source) { return source.lift(new ThrottleOperator(durationSelector, config.leading, config.trailing)); };
}
var ThrottleOperator = /*@__PURE__*/ (function () {
    function ThrottleOperator(durationSelector, leading, trailing) {
        this.durationSelector = durationSelector;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
    };
    return ThrottleOperator;
}());
var ThrottleSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ThrottleSubscriber, _super);
    function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.durationSelector = durationSelector;
        _this._leading = _leading;
        _this._trailing = _trailing;
        _this._hasValue = false;
        return _this;
    }
    ThrottleSubscriber.prototype._next = function (value) {
        this._hasValue = true;
        this._sendValue = value;
        if (!this._throttled) {
            if (this._leading) {
                this.send();
            }
            else {
                this.throttle(value);
            }
        }
    };
    ThrottleSubscriber.prototype.send = function () {
        var _a = this, _hasValue = _a._hasValue, _sendValue = _a._sendValue;
        if (_hasValue) {
            this.destination.next(_sendValue);
            this.throttle(_sendValue);
        }
        this._hasValue = false;
        this._sendValue = null;
    };
    ThrottleSubscriber.prototype.throttle = function (value) {
        var duration = this.tryDurationSelector(value);
        if (!!duration) {
            this.add(this._throttled = Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(this, duration));
        }
    };
    ThrottleSubscriber.prototype.tryDurationSelector = function (value) {
        try {
            return this.durationSelector(value);
        }
        catch (err) {
            this.destination.error(err);
            return null;
        }
    };
    ThrottleSubscriber.prototype.throttlingDone = function () {
        var _a = this, _throttled = _a._throttled, _trailing = _a._trailing;
        if (_throttled) {
            _throttled.unsubscribe();
        }
        this._throttled = null;
        if (_trailing) {
            this.send();
        }
    };
    ThrottleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.throttlingDone();
    };
    ThrottleSubscriber.prototype.notifyComplete = function () {
        this.throttlingDone();
    };
    return ThrottleSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=throttle.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/throttleTime.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttleTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler_async__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__throttle__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/throttle.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async,_throttle PURE_IMPORTS_END */




function throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) {
        scheduler = __WEBPACK_IMPORTED_MODULE_2__scheduler_async__["a" /* async */];
    }
    if (config === void 0) {
        config = __WEBPACK_IMPORTED_MODULE_3__throttle__["a" /* defaultThrottleConfig */];
    }
    return function (source) { return source.lift(new ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing)); };
}
var ThrottleTimeOperator = /*@__PURE__*/ (function () {
    function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
    };
    return ThrottleTimeOperator;
}());
var ThrottleTimeSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ThrottleTimeSubscriber, _super);
    function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
        var _this = _super.call(this, destination) || this;
        _this.duration = duration;
        _this.scheduler = scheduler;
        _this.leading = leading;
        _this.trailing = trailing;
        _this._hasTrailingValue = false;
        _this._trailingValue = null;
        return _this;
    }
    ThrottleTimeSubscriber.prototype._next = function (value) {
        if (this.throttled) {
            if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        }
        else {
            this.add(this.throttled = this.scheduler.schedule(dispatchNext, this.duration, { subscriber: this }));
            if (this.leading) {
                this.destination.next(value);
            }
            else if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        }
    };
    ThrottleTimeSubscriber.prototype._complete = function () {
        if (this._hasTrailingValue) {
            this.destination.next(this._trailingValue);
            this.destination.complete();
        }
        else {
            this.destination.complete();
        }
    };
    ThrottleTimeSubscriber.prototype.clearThrottle = function () {
        var throttled = this.throttled;
        if (throttled) {
            if (this.trailing && this._hasTrailingValue) {
                this.destination.next(this._trailingValue);
                this._trailingValue = null;
                this._hasTrailingValue = false;
            }
            throttled.unsubscribe();
            this.remove(throttled);
            this.throttled = null;
        }
    };
    return ThrottleTimeSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
function dispatchNext(arg) {
    var subscriber = arg.subscriber;
    subscriber.clearThrottle();
}
//# sourceMappingURL=throttleTime.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/throwIfEmpty.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throwIfEmpty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_EmptyError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/EmptyError.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_util_EmptyError,_Subscriber PURE_IMPORTS_END */



function throwIfEmpty(errorFactory) {
    if (errorFactory === void 0) {
        errorFactory = defaultErrorFactory;
    }
    return function (source) {
        return source.lift(new ThrowIfEmptyOperator(errorFactory));
    };
}
var ThrowIfEmptyOperator = /*@__PURE__*/ (function () {
    function ThrowIfEmptyOperator(errorFactory) {
        this.errorFactory = errorFactory;
    }
    ThrowIfEmptyOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ThrowIfEmptySubscriber(subscriber, this.errorFactory));
    };
    return ThrowIfEmptyOperator;
}());
var ThrowIfEmptySubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ThrowIfEmptySubscriber, _super);
    function ThrowIfEmptySubscriber(destination, errorFactory) {
        var _this = _super.call(this, destination) || this;
        _this.errorFactory = errorFactory;
        _this.hasValue = false;
        return _this;
    }
    ThrowIfEmptySubscriber.prototype._next = function (value) {
        this.hasValue = true;
        this.destination.next(value);
    };
    ThrowIfEmptySubscriber.prototype._complete = function () {
        if (!this.hasValue) {
            var err = void 0;
            try {
                err = this.errorFactory();
            }
            catch (e) {
                err = e;
            }
            this.destination.error(err);
        }
        else {
            return this.destination.complete();
        }
    };
    return ThrowIfEmptySubscriber;
}(__WEBPACK_IMPORTED_MODULE_2__Subscriber__["a" /* Subscriber */]));
function defaultErrorFactory() {
    return new __WEBPACK_IMPORTED_MODULE_1__util_EmptyError__["a" /* EmptyError */]();
}
//# sourceMappingURL=throwIfEmpty.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/timeInterval.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = timeInterval;
/* unused harmony export TimeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scheduler_async__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scan__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/scan.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__observable_defer__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/defer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__map__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/map.js");
/** PURE_IMPORTS_START _scheduler_async,_scan,_observable_defer,_map PURE_IMPORTS_END */




function timeInterval(scheduler) {
    if (scheduler === void 0) {
        scheduler = __WEBPACK_IMPORTED_MODULE_0__scheduler_async__["a" /* async */];
    }
    return function (source) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__observable_defer__["a" /* defer */])(function () {
            return source.pipe(Object(__WEBPACK_IMPORTED_MODULE_1__scan__["a" /* scan */])(function (_a, value) {
                var current = _a.current;
                return ({ value: value, current: scheduler.now(), last: current });
            }, { current: scheduler.now(), value: undefined, last: undefined }), Object(__WEBPACK_IMPORTED_MODULE_3__map__["a" /* map */])(function (_a) {
                var current = _a.current, last = _a.last, value = _a.value;
                return new TimeInterval(value, current - last);
            }));
        });
    };
}
var TimeInterval = /*@__PURE__*/ (function () {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}());

//# sourceMappingURL=timeInterval.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/timeout.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = timeout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scheduler_async__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_TimeoutError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/TimeoutError.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timeoutWith__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/timeoutWith.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__observable_throwError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/throwError.js");
/** PURE_IMPORTS_START _scheduler_async,_util_TimeoutError,_timeoutWith,_observable_throwError PURE_IMPORTS_END */




function timeout(due, scheduler) {
    if (scheduler === void 0) {
        scheduler = __WEBPACK_IMPORTED_MODULE_0__scheduler_async__["a" /* async */];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__timeoutWith__["a" /* timeoutWith */])(due, Object(__WEBPACK_IMPORTED_MODULE_3__observable_throwError__["a" /* throwError */])(new __WEBPACK_IMPORTED_MODULE_1__util_TimeoutError__["a" /* TimeoutError */]()), scheduler);
}
//# sourceMappingURL=timeout.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/timeoutWith.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = timeoutWith;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler_async__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isDate__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isDate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */





function timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) {
        scheduler = __WEBPACK_IMPORTED_MODULE_1__scheduler_async__["a" /* async */];
    }
    return function (source) {
        var absoluteTimeout = Object(__WEBPACK_IMPORTED_MODULE_2__util_isDate__["a" /* isDate */])(due);
        var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
        return source.lift(new TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
    };
}
var TimeoutWithOperator = /*@__PURE__*/ (function () {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}());
var TimeoutWithSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.absoluteTimeout = absoluteTimeout;
        _this.waitFor = waitFor;
        _this.withObservable = withObservable;
        _this.scheduler = scheduler;
        _this.action = null;
        _this.scheduleTimeout();
        return _this;
    }
    TimeoutWithSubscriber.dispatchTimeout = function (subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add(Object(__WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__["a" /* subscribeToResult */])(subscriber, withObservable));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function () {
        var action = this.action;
        if (action) {
            this.action = action.schedule(this, this.waitFor);
        }
        else {
            this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
        }
    };
    TimeoutWithSubscriber.prototype._next = function (value) {
        if (!this.absoluteTimeout) {
            this.scheduleTimeout();
        }
        _super.prototype._next.call(this, value);
    };
    TimeoutWithSubscriber.prototype._unsubscribe = function () {
        this.action = null;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=timeoutWith.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/timestamp.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = timestamp;
/* unused harmony export Timestamp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scheduler_async__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__map__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/map.js");
/** PURE_IMPORTS_START _scheduler_async,_map PURE_IMPORTS_END */


function timestamp(scheduler) {
    if (scheduler === void 0) {
        scheduler = __WEBPACK_IMPORTED_MODULE_0__scheduler_async__["a" /* async */];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_1__map__["a" /* map */])(function (value) { return new Timestamp(value, scheduler.now()); });
}
var Timestamp = /*@__PURE__*/ (function () {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}());

//# sourceMappingURL=timestamp.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/toArray.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reduce__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/reduce.js");
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */

function toArrayReducer(arr, item, index) {
    if (index === 0) {
        return [item];
    }
    arr.push(item);
    return arr;
}
function toArray() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__reduce__["a" /* reduce */])(toArrayReducer, []);
}
//# sourceMappingURL=toArray.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/window.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = window;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_Subject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */




function window(windowBoundaries) {
    return function windowOperatorFunction(source) {
        return source.lift(new WindowOperator(windowBoundaries));
    };
}
var WindowOperator = /*@__PURE__*/ (function () {
    function WindowOperator(windowBoundaries) {
        this.windowBoundaries = windowBoundaries;
    }
    WindowOperator.prototype.call = function (subscriber, source) {
        var windowSubscriber = new WindowSubscriber(subscriber);
        var sourceSubscription = source.subscribe(windowSubscriber);
        if (!sourceSubscription.closed) {
            windowSubscriber.add(Object(__WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__["a" /* subscribeToResult */])(windowSubscriber, this.windowBoundaries));
        }
        return sourceSubscription;
    };
    return WindowOperator;
}());
var WindowSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WindowSubscriber, _super);
    function WindowSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.window = new __WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]();
        destination.next(_this.window);
        return _this;
    }
    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow();
    };
    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
        this._complete();
    };
    WindowSubscriber.prototype._next = function (value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function (err) {
        this.window.error(err);
        this.destination.error(err);
    };
    WindowSubscriber.prototype._complete = function () {
        this.window.complete();
        this.destination.complete();
    };
    WindowSubscriber.prototype._unsubscribe = function () {
        this.window = null;
    };
    WindowSubscriber.prototype.openWindow = function () {
        var prevWindow = this.window;
        if (prevWindow) {
            prevWindow.complete();
        }
        var destination = this.destination;
        var newWindow = this.window = new __WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]();
        destination.next(newWindow);
    };
    return WindowSubscriber;
}(__WEBPACK_IMPORTED_MODULE_2__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=window.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/windowCount.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = windowCount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subject.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_Subject PURE_IMPORTS_END */



function windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) {
        startWindowEvery = 0;
    }
    return function windowCountOperatorFunction(source) {
        return source.lift(new WindowCountOperator(windowSize, startWindowEvery));
    };
}
var WindowCountOperator = /*@__PURE__*/ (function () {
    function WindowCountOperator(windowSize, startWindowEvery) {
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
    }
    WindowCountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
    };
    return WindowCountOperator;
}());
var WindowCountSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WindowCountSubscriber, _super);
    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.windowSize = windowSize;
        _this.startWindowEvery = startWindowEvery;
        _this.windows = [new __WEBPACK_IMPORTED_MODULE_2__Subject__["a" /* Subject */]()];
        _this.count = 0;
        destination.next(_this.windows[0]);
        return _this;
    }
    WindowCountSubscriber.prototype._next = function (value) {
        var startWindowEvery = (this.startWindowEvery > 0) ? this.startWindowEvery : this.windowSize;
        var destination = this.destination;
        var windowSize = this.windowSize;
        var windows = this.windows;
        var len = windows.length;
        for (var i = 0; i < len && !this.closed; i++) {
            windows[i].next(value);
        }
        var c = this.count - windowSize + 1;
        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) {
            windows.shift().complete();
        }
        if (++this.count % startWindowEvery === 0 && !this.closed) {
            var window_1 = new __WEBPACK_IMPORTED_MODULE_2__Subject__["a" /* Subject */]();
            windows.push(window_1);
            destination.next(window_1);
        }
    };
    WindowCountSubscriber.prototype._error = function (err) {
        var windows = this.windows;
        if (windows) {
            while (windows.length > 0 && !this.closed) {
                windows.shift().error(err);
            }
        }
        this.destination.error(err);
    };
    WindowCountSubscriber.prototype._complete = function () {
        var windows = this.windows;
        if (windows) {
            while (windows.length > 0 && !this.closed) {
                windows.shift().complete();
            }
        }
        this.destination.complete();
    };
    WindowCountSubscriber.prototype._unsubscribe = function () {
        this.count = 0;
        this.windows = null;
    };
    return WindowCountSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=windowCount.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/windowTime.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = windowTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler_async__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_isNumeric__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isNumeric.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_isScheduler__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isScheduler.js");
/** PURE_IMPORTS_START tslib,_Subject,_scheduler_async,_Subscriber,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */






function windowTime(windowTimeSpan) {
    var scheduler = __WEBPACK_IMPORTED_MODULE_2__scheduler_async__["a" /* async */];
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if (Object(__WEBPACK_IMPORTED_MODULE_5__util_isScheduler__["a" /* isScheduler */])(arguments[3])) {
        scheduler = arguments[3];
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_5__util_isScheduler__["a" /* isScheduler */])(arguments[2])) {
        scheduler = arguments[2];
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_4__util_isNumeric__["a" /* isNumeric */])(arguments[2])) {
        maxWindowSize = arguments[2];
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_5__util_isScheduler__["a" /* isScheduler */])(arguments[1])) {
        scheduler = arguments[1];
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_4__util_isNumeric__["a" /* isNumeric */])(arguments[1])) {
        windowCreationInterval = arguments[1];
    }
    return function windowTimeOperatorFunction(source) {
        return source.lift(new WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
    };
}
var WindowTimeOperator = /*@__PURE__*/ (function () {
    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
    }
    WindowTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
    };
    return WindowTimeOperator;
}());
var CountedSubject = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CountedSubject, _super);
    function CountedSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._numberOfNextedValues = 0;
        return _this;
    }
    CountedSubject.prototype.next = function (value) {
        this._numberOfNextedValues++;
        _super.prototype.next.call(this, value);
    };
    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
        get: function () {
            return this._numberOfNextedValues;
        },
        enumerable: true,
        configurable: true
    });
    return CountedSubject;
}(__WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]));
var WindowTimeSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WindowTimeSubscriber, _super);
    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.windowTimeSpan = windowTimeSpan;
        _this.windowCreationInterval = windowCreationInterval;
        _this.maxWindowSize = maxWindowSize;
        _this.scheduler = scheduler;
        _this.windows = [];
        var window = _this.openWindow();
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            var closeState = { subscriber: _this, window: window, context: null };
            var creationState = { windowTimeSpan: windowTimeSpan, windowCreationInterval: windowCreationInterval, subscriber: _this, scheduler: scheduler };
            _this.add(scheduler.schedule(dispatchWindowClose, windowTimeSpan, closeState));
            _this.add(scheduler.schedule(dispatchWindowCreation, windowCreationInterval, creationState));
        }
        else {
            var timeSpanOnlyState = { subscriber: _this, window: window, windowTimeSpan: windowTimeSpan };
            _this.add(scheduler.schedule(dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
        }
        return _this;
    }
    WindowTimeSubscriber.prototype._next = function (value) {
        var windows = this.windows;
        var len = windows.length;
        for (var i = 0; i < len; i++) {
            var window_1 = windows[i];
            if (!window_1.closed) {
                window_1.next(value);
                if (window_1.numberOfNextedValues >= this.maxWindowSize) {
                    this.closeWindow(window_1);
                }
            }
        }
    };
    WindowTimeSubscriber.prototype._error = function (err) {
        var windows = this.windows;
        while (windows.length > 0) {
            windows.shift().error(err);
        }
        this.destination.error(err);
    };
    WindowTimeSubscriber.prototype._complete = function () {
        var windows = this.windows;
        while (windows.length > 0) {
            var window_2 = windows.shift();
            if (!window_2.closed) {
                window_2.complete();
            }
        }
        this.destination.complete();
    };
    WindowTimeSubscriber.prototype.openWindow = function () {
        var window = new CountedSubject();
        this.windows.push(window);
        var destination = this.destination;
        destination.next(window);
        return window;
    };
    WindowTimeSubscriber.prototype.closeWindow = function (window) {
        window.complete();
        var windows = this.windows;
        windows.splice(windows.indexOf(window), 1);
    };
    return WindowTimeSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__Subscriber__["a" /* Subscriber */]));
function dispatchWindowTimeSpanOnly(state) {
    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
    if (window) {
        subscriber.closeWindow(window);
    }
    state.window = subscriber.openWindow();
    this.schedule(state, windowTimeSpan);
}
function dispatchWindowCreation(state) {
    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
    var window = subscriber.openWindow();
    var action = this;
    var context = { action: action, subscription: null };
    var timeSpanState = { subscriber: subscriber, window: window, context: context };
    context.subscription = scheduler.schedule(dispatchWindowClose, windowTimeSpan, timeSpanState);
    action.add(context.subscription);
    action.schedule(state, windowCreationInterval);
}
function dispatchWindowClose(state) {
    var subscriber = state.subscriber, window = state.window, context = state.context;
    if (context && context.action && context.subscription) {
        context.action.remove(context.subscription);
    }
    subscriber.closeWindow(window);
}
//# sourceMappingURL=windowTime.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/windowToggle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = windowToggle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscription__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscription.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_Subject,_Subscription,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */





function windowToggle(openings, closingSelector) {
    return function (source) { return source.lift(new WindowToggleOperator(openings, closingSelector)); };
}
var WindowToggleOperator = /*@__PURE__*/ (function () {
    function WindowToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    WindowToggleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return WindowToggleOperator;
}());
var WindowToggleSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WindowToggleSubscriber, _super);
    function WindowToggleSubscriber(destination, openings, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.openings = openings;
        _this.closingSelector = closingSelector;
        _this.contexts = [];
        _this.add(_this.openSubscription = Object(__WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__["a" /* subscribeToResult */])(_this, openings, openings));
        return _this;
    }
    WindowToggleSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        if (contexts) {
            var len = contexts.length;
            for (var i = 0; i < len; i++) {
                contexts[i].window.next(value);
            }
        }
    };
    WindowToggleSubscriber.prototype._error = function (err) {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context_1 = contexts[index];
                context_1.window.error(err);
                context_1.subscription.unsubscribe();
            }
        }
        _super.prototype._error.call(this, err);
    };
    WindowToggleSubscriber.prototype._complete = function () {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context_2 = contexts[index];
                context_2.window.complete();
                context_2.subscription.unsubscribe();
            }
        }
        _super.prototype._complete.call(this);
    };
    WindowToggleSubscriber.prototype._unsubscribe = function () {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context_3 = contexts[index];
                context_3.window.unsubscribe();
                context_3.subscription.unsubscribe();
            }
        }
    };
    WindowToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (outerValue === this.openings) {
            var closingNotifier = void 0;
            try {
                var closingSelector = this.closingSelector;
                closingNotifier = closingSelector(innerValue);
            }
            catch (e) {
                return this.error(e);
            }
            var window_1 = new __WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]();
            var subscription = new __WEBPACK_IMPORTED_MODULE_2__Subscription__["a" /* Subscription */]();
            var context_4 = { window: window_1, subscription: subscription };
            this.contexts.push(context_4);
            var innerSubscription = Object(__WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__["a" /* subscribeToResult */])(this, closingNotifier, context_4);
            if (innerSubscription.closed) {
                this.closeWindow(this.contexts.length - 1);
            }
            else {
                innerSubscription.context = context_4;
                subscription.add(innerSubscription);
            }
            this.destination.next(window_1);
        }
        else {
            this.closeWindow(this.contexts.indexOf(outerValue));
        }
    };
    WindowToggleSubscriber.prototype.notifyError = function (err) {
        this.error(err);
    };
    WindowToggleSubscriber.prototype.notifyComplete = function (inner) {
        if (inner !== this.openSubscription) {
            this.closeWindow(this.contexts.indexOf(inner.context));
        }
    };
    WindowToggleSubscriber.prototype.closeWindow = function (index) {
        if (index === -1) {
            return;
        }
        var contexts = this.contexts;
        var context = contexts[index];
        var window = context.window, subscription = context.subscription;
        contexts.splice(index, 1);
        window.complete();
        subscription.unsubscribe();
    };
    return WindowToggleSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=windowToggle.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/windowWhen.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = windowWhen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_Subject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */




function windowWhen(closingSelector) {
    return function windowWhenOperatorFunction(source) {
        return source.lift(new WindowOperator(closingSelector));
    };
}
var WindowOperator = /*@__PURE__*/ (function () {
    function WindowOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    WindowOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowSubscriber(subscriber, this.closingSelector));
    };
    return WindowOperator;
}());
var WindowSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WindowSubscriber, _super);
    function WindowSubscriber(destination, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.closingSelector = closingSelector;
        _this.openWindow();
        return _this;
    }
    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype._next = function (value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function (err) {
        this.window.error(err);
        this.destination.error(err);
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype._complete = function () {
        this.window.complete();
        this.destination.complete();
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype.unsubscribeClosingNotification = function () {
        if (this.closingNotification) {
            this.closingNotification.unsubscribe();
        }
    };
    WindowSubscriber.prototype.openWindow = function (innerSub) {
        if (innerSub === void 0) {
            innerSub = null;
        }
        if (innerSub) {
            this.remove(innerSub);
            innerSub.unsubscribe();
        }
        var prevWindow = this.window;
        if (prevWindow) {
            prevWindow.complete();
        }
        var window = this.window = new __WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]();
        this.destination.next(window);
        var closingNotifier;
        try {
            var closingSelector = this.closingSelector;
            closingNotifier = closingSelector();
        }
        catch (e) {
            this.destination.error(e);
            this.window.error(e);
            return;
        }
        this.add(this.closingNotification = Object(__WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__["a" /* subscribeToResult */])(this, closingNotifier));
    };
    return WindowSubscriber;
}(__WEBPACK_IMPORTED_MODULE_2__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=windowWhen.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/withLatestFrom.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withLatestFrom;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function withLatestFrom() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return function (source) {
        var project;
        if (typeof args[args.length - 1] === 'function') {
            project = args.pop();
        }
        var observables = args;
        return source.lift(new WithLatestFromOperator(observables, project));
    };
}
var WithLatestFromOperator = /*@__PURE__*/ (function () {
    function WithLatestFromOperator(observables, project) {
        this.observables = observables;
        this.project = project;
    }
    WithLatestFromOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WithLatestFromSubscriber(subscriber, this.observables, this.project));
    };
    return WithLatestFromOperator;
}());
var WithLatestFromSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WithLatestFromSubscriber, _super);
    function WithLatestFromSubscriber(destination, observables, project) {
        var _this = _super.call(this, destination) || this;
        _this.observables = observables;
        _this.project = project;
        _this.toRespond = [];
        var len = observables.length;
        _this.values = new Array(len);
        for (var i = 0; i < len; i++) {
            _this.toRespond.push(i);
        }
        for (var i = 0; i < len; i++) {
            var observable = observables[i];
            _this.add(Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(_this, observable, observable, i));
        }
        return _this;
    }
    WithLatestFromSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        var toRespond = this.toRespond;
        if (toRespond.length > 0) {
            var found = toRespond.indexOf(outerIndex);
            if (found !== -1) {
                toRespond.splice(found, 1);
            }
        }
    };
    WithLatestFromSubscriber.prototype.notifyComplete = function () {
    };
    WithLatestFromSubscriber.prototype._next = function (value) {
        if (this.toRespond.length === 0) {
            var args = [value].concat(this.values);
            if (this.project) {
                this._tryProject(args);
            }
            else {
                this.destination.next(args);
            }
        }
    };
    WithLatestFromSubscriber.prototype._tryProject = function (args) {
        var result;
        try {
            result = this.project.apply(this, args);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return WithLatestFromSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=withLatestFrom.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/zip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = zip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_zip__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/zip.js");
/** PURE_IMPORTS_START _observable_zip PURE_IMPORTS_END */

function zip() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return function zipOperatorFunction(source) {
        return source.lift.call(__WEBPACK_IMPORTED_MODULE_0__observable_zip__["b" /* zip */].apply(void 0, [source].concat(observables)));
    };
}
//# sourceMappingURL=zip.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/zipAll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = zipAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_zip__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/observable/zip.js");
/** PURE_IMPORTS_START _observable_zip PURE_IMPORTS_END */

function zipAll(project) {
    return function (source) { return source.lift(new __WEBPACK_IMPORTED_MODULE_0__observable_zip__["a" /* ZipOperator */](project)); };
}
//# sourceMappingURL=zipAll.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduled/scheduleArray.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scheduleArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscription.js");
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */


function scheduleArray(input, scheduler) {
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var sub = new __WEBPACK_IMPORTED_MODULE_1__Subscription__["a" /* Subscription */]();
        var i = 0;
        sub.add(scheduler.schedule(function () {
            if (i === input.length) {
                subscriber.complete();
                return;
            }
            subscriber.next(input[i++]);
            if (!subscriber.closed) {
                sub.add(this.schedule());
            }
        }));
        return sub;
    });
}
//# sourceMappingURL=scheduleArray.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduled/scheduleIterable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scheduleIterable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscription.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_iterator__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/symbol/iterator.js");
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator PURE_IMPORTS_END */



function scheduleIterable(input, scheduler) {
    if (!input) {
        throw new Error('Iterable cannot be null');
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var sub = new __WEBPACK_IMPORTED_MODULE_1__Subscription__["a" /* Subscription */]();
        var iterator;
        sub.add(function () {
            if (iterator && typeof iterator.return === 'function') {
                iterator.return();
            }
        });
        sub.add(scheduler.schedule(function () {
            iterator = input[__WEBPACK_IMPORTED_MODULE_2__symbol_iterator__["a" /* iterator */]]();
            sub.add(scheduler.schedule(function () {
                if (subscriber.closed) {
                    return;
                }
                var value;
                var done;
                try {
                    var result = iterator.next();
                    value = result.value;
                    done = result.done;
                }
                catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) {
                    subscriber.complete();
                }
                else {
                    subscriber.next(value);
                    this.schedule();
                }
            }));
        }));
        return sub;
    });
}
//# sourceMappingURL=scheduleIterable.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduled/scheduleObservable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scheduleObservable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscription.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/symbol/observable.js");
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable PURE_IMPORTS_END */



function scheduleObservable(input, scheduler) {
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var sub = new __WEBPACK_IMPORTED_MODULE_1__Subscription__["a" /* Subscription */]();
        sub.add(scheduler.schedule(function () {
            var observable = input[__WEBPACK_IMPORTED_MODULE_2__symbol_observable__["a" /* observable */]]();
            sub.add(observable.subscribe({
                next: function (value) { sub.add(scheduler.schedule(function () { return subscriber.next(value); })); },
                error: function (err) { sub.add(scheduler.schedule(function () { return subscriber.error(err); })); },
                complete: function () { sub.add(scheduler.schedule(function () { return subscriber.complete(); })); },
            }));
        }));
        return sub;
    });
}
//# sourceMappingURL=scheduleObservable.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduled/schedulePromise.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = schedulePromise;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscription.js");
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */


function schedulePromise(input, scheduler) {
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var sub = new __WEBPACK_IMPORTED_MODULE_1__Subscription__["a" /* Subscription */]();
        sub.add(scheduler.schedule(function () {
            return input.then(function (value) {
                sub.add(scheduler.schedule(function () {
                    subscriber.next(value);
                    sub.add(scheduler.schedule(function () { return subscriber.complete(); }));
                }));
            }, function (err) {
                sub.add(scheduler.schedule(function () { return subscriber.error(err); }));
            });
        }));
        return sub;
    });
}
//# sourceMappingURL=schedulePromise.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduled/scheduled.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scheduled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scheduleObservable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduled/scheduleObservable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schedulePromise__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduled/schedulePromise.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduleArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduled/scheduleArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scheduleIterable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduled/scheduleIterable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_isInteropObservable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isInteropObservable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_isPromise__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isPromise.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_isArrayLike__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isArrayLike.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_isIterable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isIterable.js");
/** PURE_IMPORTS_START _scheduleObservable,_schedulePromise,_scheduleArray,_scheduleIterable,_util_isInteropObservable,_util_isPromise,_util_isArrayLike,_util_isIterable PURE_IMPORTS_END */








function scheduled(input, scheduler) {
    if (input != null) {
        if (Object(__WEBPACK_IMPORTED_MODULE_4__util_isInteropObservable__["a" /* isInteropObservable */])(input)) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__scheduleObservable__["a" /* scheduleObservable */])(input, scheduler);
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_5__util_isPromise__["a" /* isPromise */])(input)) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__schedulePromise__["a" /* schedulePromise */])(input, scheduler);
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_6__util_isArrayLike__["a" /* isArrayLike */])(input)) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__scheduleArray__["a" /* scheduleArray */])(input, scheduler);
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_7__util_isIterable__["a" /* isIterable */])(input) || typeof input === 'string') {
            return Object(__WEBPACK_IMPORTED_MODULE_3__scheduleIterable__["a" /* scheduleIterable */])(input, scheduler);
        }
    }
    throw new TypeError((input !== null && typeof input || input) + ' is not observable');
}
//# sourceMappingURL=scheduled.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/Action.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Action; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscription.js");
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */


var Action = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        return this;
    };
    return Action;
}(__WEBPACK_IMPORTED_MODULE_1__Subscription__["a" /* Subscription */]));

//# sourceMappingURL=Action.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/AnimationFrameAction.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimationFrameAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncAction__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/AsyncAction.js");
/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */


var AnimationFrameAction = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = requestAnimationFrame(function () { return scheduler.flush(null); }));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        if (scheduler.actions.length === 0) {
            cancelAnimationFrame(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AnimationFrameAction;
}(__WEBPACK_IMPORTED_MODULE_1__AsyncAction__["a" /* AsyncAction */]));

//# sourceMappingURL=AnimationFrameAction.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/AnimationFrameScheduler.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimationFrameScheduler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/AsyncScheduler.js");
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */


var AnimationFrameScheduler = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationFrameScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AnimationFrameScheduler;
}(__WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__["a" /* AsyncScheduler */]));

//# sourceMappingURL=AnimationFrameScheduler.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/AsapAction.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsapAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Immediate__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/Immediate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AsyncAction__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/AsyncAction.js");
/** PURE_IMPORTS_START tslib,_util_Immediate,_AsyncAction PURE_IMPORTS_END */



var AsapAction = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = __WEBPACK_IMPORTED_MODULE_1__util_Immediate__["a" /* Immediate */].setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        if (scheduler.actions.length === 0) {
            __WEBPACK_IMPORTED_MODULE_1__util_Immediate__["a" /* Immediate */].clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AsapAction;
}(__WEBPACK_IMPORTED_MODULE_2__AsyncAction__["a" /* AsyncAction */]));

//# sourceMappingURL=AsapAction.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/AsapScheduler.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsapScheduler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/AsyncScheduler.js");
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */


var AsapScheduler = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsapScheduler;
}(__WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__["a" /* AsyncScheduler */]));

//# sourceMappingURL=AsapScheduler.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/AsyncAction.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsyncAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Action__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/Action.js");
/** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */


var AsyncAction = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (this.closed) {
            return this;
        }
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        this.pending = true;
        this.delay = delay;
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        return setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay !== null && this.delay === delay && this.pending === false) {
            return id;
        }
        clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function (state, delay) {
        if (this.closed) {
            return new Error('executing a cancelled action');
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
            return error;
        }
        else if (this.pending === false && this.id != null) {
            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
    };
    AsyncAction.prototype._execute = function (state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        }
        catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype._unsubscribe = function () {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) {
            actions.splice(index, 1);
        }
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, null);
        }
        this.delay = null;
    };
    return AsyncAction;
}(__WEBPACK_IMPORTED_MODULE_1__Action__["a" /* Action */]));

//# sourceMappingURL=AsyncAction.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/AsyncScheduler.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsyncScheduler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Scheduler__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Scheduler.js");
/** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */


var AsyncScheduler = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) {
            now = __WEBPACK_IMPORTED_MODULE_1__Scheduler__["a" /* Scheduler */].now;
        }
        var _this = _super.call(this, SchedulerAction, function () {
            if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) {
                return AsyncScheduler.delegate.now();
            }
            else {
                return now();
            }
        }) || this;
        _this.actions = [];
        _this.active = false;
        _this.scheduled = undefined;
        return _this;
    }
    AsyncScheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) {
            delay = 0;
        }
        if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) {
            return AsyncScheduler.delegate.schedule(work, delay, state);
        }
        else {
            return _super.prototype.schedule.call(this, work, delay, state);
        }
    };
    AsyncScheduler.prototype.flush = function (action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (action = actions.shift());
        this.active = false;
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsyncScheduler;
}(__WEBPACK_IMPORTED_MODULE_1__Scheduler__["a" /* Scheduler */]));

//# sourceMappingURL=AsyncScheduler.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/QueueAction.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueueAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncAction__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/AsyncAction.js");
/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */


var QueueAction = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay > 0) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function (state, delay) {
        return (delay > 0 || this.closed) ?
            _super.prototype.execute.call(this, state, delay) :
            this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        return scheduler.flush(this);
    };
    return QueueAction;
}(__WEBPACK_IMPORTED_MODULE_1__AsyncAction__["a" /* AsyncAction */]));

//# sourceMappingURL=QueueAction.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/QueueScheduler.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueueScheduler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/AsyncScheduler.js");
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */


var QueueScheduler = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}(__WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__["a" /* AsyncScheduler */]));

//# sourceMappingURL=QueueScheduler.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/VirtualTimeScheduler.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VirtualTimeScheduler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VirtualAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncAction__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/AsyncAction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AsyncScheduler__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/AsyncScheduler.js");
/** PURE_IMPORTS_START tslib,_AsyncAction,_AsyncScheduler PURE_IMPORTS_END */



var VirtualTimeScheduler = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
        if (SchedulerAction === void 0) {
            SchedulerAction = VirtualAction;
        }
        if (maxFrames === void 0) {
            maxFrames = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this, SchedulerAction, function () { return _this.frame; }) || this;
        _this.maxFrames = maxFrames;
        _this.frame = 0;
        _this.index = -1;
        return _this;
    }
    VirtualTimeScheduler.prototype.flush = function () {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error, action;
        while ((action = actions[0]) && action.delay <= maxFrames) {
            actions.shift();
            this.frame = action.delay;
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        }
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}(__WEBPACK_IMPORTED_MODULE_2__AsyncScheduler__["a" /* AsyncScheduler */]));

var VirtualAction = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) {
            index = scheduler.index += 1;
        }
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.index = index;
        _this.active = true;
        _this.index = scheduler.index = index;
        return _this;
    }
    VirtualAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (!this.id) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.active = false;
        var action = new VirtualAction(this.scheduler, this.work);
        this.add(action);
        return action.schedule(state, delay);
    };
    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return true;
    };
    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        return undefined;
    };
    VirtualAction.prototype._execute = function (state, delay) {
        if (this.active === true) {
            return _super.prototype._execute.call(this, state, delay);
        }
    };
    VirtualAction.sortActions = function (a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) {
                return 0;
            }
            else if (a.index > b.index) {
                return 1;
            }
            else {
                return -1;
            }
        }
        else if (a.delay > b.delay) {
            return 1;
        }
        else {
            return -1;
        }
    };
    return VirtualAction;
}(__WEBPACK_IMPORTED_MODULE_1__AsyncAction__["a" /* AsyncAction */]));

//# sourceMappingURL=VirtualTimeScheduler.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/animationFrame.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return animationFrame; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimationFrameAction__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/AnimationFrameAction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnimationFrameScheduler__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/AnimationFrameScheduler.js");
/** PURE_IMPORTS_START _AnimationFrameAction,_AnimationFrameScheduler PURE_IMPORTS_END */


var animationFrame = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__AnimationFrameScheduler__["a" /* AnimationFrameScheduler */](__WEBPACK_IMPORTED_MODULE_0__AnimationFrameAction__["a" /* AnimationFrameAction */]);
//# sourceMappingURL=animationFrame.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/asap.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsapAction__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/AsapAction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsapScheduler__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/AsapScheduler.js");
/** PURE_IMPORTS_START _AsapAction,_AsapScheduler PURE_IMPORTS_END */


var asap = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__AsapScheduler__["a" /* AsapScheduler */](__WEBPACK_IMPORTED_MODULE_0__AsapAction__["a" /* AsapAction */]);
//# sourceMappingURL=asap.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/async.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return async; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncAction__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/AsyncAction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/AsyncScheduler.js");
/** PURE_IMPORTS_START _AsyncAction,_AsyncScheduler PURE_IMPORTS_END */


var async = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__["a" /* AsyncScheduler */](__WEBPACK_IMPORTED_MODULE_0__AsyncAction__["a" /* AsyncAction */]);
//# sourceMappingURL=async.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/queue.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return queue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QueueAction__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/QueueAction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__QueueScheduler__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/scheduler/QueueScheduler.js");
/** PURE_IMPORTS_START _QueueAction,_QueueScheduler PURE_IMPORTS_END */


var queue = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__QueueScheduler__["a" /* QueueScheduler */](__WEBPACK_IMPORTED_MODULE_0__QueueAction__["a" /* QueueAction */]);
//# sourceMappingURL=queue.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/symbol/iterator.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getSymbolIterator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return iterator; });
/* unused harmony export $$iterator */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) {
        return '@@iterator';
    }
    return Symbol.iterator;
}
var iterator = /*@__PURE__*/ getSymbolIterator();
var $$iterator = iterator;
//# sourceMappingURL=iterator.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/symbol/observable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return observable; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var observable = typeof Symbol === 'function' && Symbol.observable || '@@observable';
//# sourceMappingURL=observable.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/symbol/rxSubscriber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rxSubscriber; });
/* unused harmony export $$rxSubscriber */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var rxSubscriber = typeof Symbol === 'function'
    ? /*@__PURE__*/ Symbol('rxSubscriber')
    : '@@rxSubscriber_' + /*@__PURE__*/ Math.random();
var $$rxSubscriber = rxSubscriber;
//# sourceMappingURL=rxSubscriber.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/ArgumentOutOfRangeError.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArgumentOutOfRangeError; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function ArgumentOutOfRangeErrorImpl() {
    Error.call(this);
    this.message = 'argument out of range';
    this.name = 'ArgumentOutOfRangeError';
    return this;
}
ArgumentOutOfRangeErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
var ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl;
//# sourceMappingURL=ArgumentOutOfRangeError.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/EmptyError.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmptyError; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function EmptyErrorImpl() {
    Error.call(this);
    this.message = 'no elements in sequence';
    this.name = 'EmptyError';
    return this;
}
EmptyErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
var EmptyError = EmptyErrorImpl;
//# sourceMappingURL=EmptyError.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/Immediate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Immediate; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var nextHandle = 1;
var tasksByHandle = {};
function runIfPresent(handle) {
    var cb = tasksByHandle[handle];
    if (cb) {
        cb();
    }
}
var Immediate = {
    setImmediate: function (cb) {
        var handle = nextHandle++;
        tasksByHandle[handle] = cb;
        Promise.resolve().then(function () { return runIfPresent(handle); });
        return handle;
    },
    clearImmediate: function (handle) {
        delete tasksByHandle[handle];
    },
};
//# sourceMappingURL=Immediate.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/ObjectUnsubscribedError.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObjectUnsubscribedError; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function ObjectUnsubscribedErrorImpl() {
    Error.call(this);
    this.message = 'object unsubscribed';
    this.name = 'ObjectUnsubscribedError';
    return this;
}
ObjectUnsubscribedErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
var ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl;
//# sourceMappingURL=ObjectUnsubscribedError.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/TimeoutError.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimeoutError; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function TimeoutErrorImpl() {
    Error.call(this);
    this.message = 'Timeout has occurred';
    this.name = 'TimeoutError';
    return this;
}
TimeoutErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
var TimeoutError = TimeoutErrorImpl;
//# sourceMappingURL=TimeoutError.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/UnsubscriptionError.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UnsubscriptionError; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function UnsubscriptionErrorImpl(errors) {
    Error.call(this);
    this.message = errors ?
        errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ') : '';
    this.name = 'UnsubscriptionError';
    this.errors = errors;
    return this;
}
UnsubscriptionErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
var UnsubscriptionError = UnsubscriptionErrorImpl;
//# sourceMappingURL=UnsubscriptionError.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/canReportError.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = canReportError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */

function canReportError(observer) {
    while (observer) {
        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
        if (closed_1 || isStopped) {
            return false;
        }
        else if (destination && destination instanceof __WEBPACK_IMPORTED_MODULE_0__Subscriber__["a" /* Subscriber */]) {
            observer = destination;
        }
        else {
            observer = null;
        }
    }
    return true;
}
//# sourceMappingURL=canReportError.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/hostReportError.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hostReportError;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function hostReportError(err) {
    setTimeout(function () { throw err; }, 0);
}
//# sourceMappingURL=hostReportError.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/identity.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function identity(x) {
    return x;
}
//# sourceMappingURL=identity.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/isArray.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isArray; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArray.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/isArrayLike.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isArrayLike; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });
//# sourceMappingURL=isArrayLike.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/isDate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isDate;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
//# sourceMappingURL=isDate.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/isFunction.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isFunction;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isFunction(x) {
    return typeof x === 'function';
}
//# sourceMappingURL=isFunction.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/isInteropObservable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isInteropObservable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__symbol_observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/symbol/observable.js");
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */

function isInteropObservable(input) {
    return input && typeof input[__WEBPACK_IMPORTED_MODULE_0__symbol_observable__["a" /* observable */]] === 'function';
}
//# sourceMappingURL=isInteropObservable.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/isIterable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isIterable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__symbol_iterator__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/symbol/iterator.js");
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */

function isIterable(input) {
    return input && typeof input[__WEBPACK_IMPORTED_MODULE_0__symbol_iterator__["a" /* iterator */]] === 'function';
}
//# sourceMappingURL=isIterable.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/isNumeric.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isNumeric;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isArray.js");
/** PURE_IMPORTS_START _isArray PURE_IMPORTS_END */

function isNumeric(val) {
    return !Object(__WEBPACK_IMPORTED_MODULE_0__isArray__["a" /* isArray */])(val) && (val - parseFloat(val) + 1) >= 0;
}
//# sourceMappingURL=isNumeric.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/isObject.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isObject;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isObject(x) {
    return x !== null && typeof x === 'object';
}
//# sourceMappingURL=isObject.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/isObservable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isObservable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

function isObservable(obj) {
    return !!obj && (obj instanceof __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */] || (typeof obj.lift === 'function' && typeof obj.subscribe === 'function'));
}
//# sourceMappingURL=isObservable.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/isPromise.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isPromise(value) {
    return !!value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
//# sourceMappingURL=isPromise.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/isScheduler.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isScheduler;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
//# sourceMappingURL=isScheduler.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/noop.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noop;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function noop() { }
//# sourceMappingURL=noop.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/not.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = not;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function not(pred, thisArg) {
    function notPred() {
        return !(notPred.pred.apply(notPred.thisArg, arguments));
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
//# sourceMappingURL=not.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/pipe.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pipe;
/* harmony export (immutable) */ __webpack_exports__["b"] = pipeFromArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/noop.js");
/** PURE_IMPORTS_START _noop PURE_IMPORTS_END */

function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return pipeFromArray(fns);
}
function pipeFromArray(fns) {
    if (!fns) {
        return __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* noop */];
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}
//# sourceMappingURL=pipe.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/subscribeTo.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subscribeTo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__subscribeToArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subscribeToPromise__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToPromise.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__subscribeToIterable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToIterable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__subscribeToObservable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeToObservable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArrayLike__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isArrayLike.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isPromise__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isPromise.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isObject__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/isObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__symbol_iterator__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/symbol/iterator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__symbol_observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/symbol/observable.js");
/** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */









var subscribeTo = function (result) {
    if (!!result && typeof result[__WEBPACK_IMPORTED_MODULE_8__symbol_observable__["a" /* observable */]] === 'function') {
        return Object(__WEBPACK_IMPORTED_MODULE_3__subscribeToObservable__["a" /* subscribeToObservable */])(result);
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_4__isArrayLike__["a" /* isArrayLike */])(result)) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__subscribeToArray__["a" /* subscribeToArray */])(result);
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_5__isPromise__["a" /* isPromise */])(result)) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__subscribeToPromise__["a" /* subscribeToPromise */])(result);
    }
    else if (!!result && typeof result[__WEBPACK_IMPORTED_MODULE_7__symbol_iterator__["a" /* iterator */]] === 'function') {
        return Object(__WEBPACK_IMPORTED_MODULE_2__subscribeToIterable__["a" /* subscribeToIterable */])(result);
    }
    else {
        var value = Object(__WEBPACK_IMPORTED_MODULE_6__isObject__["a" /* isObject */])(result) ? 'an invalid object' : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected."
            + ' You can provide an Observable, Promise, Array, or Iterable.';
        throw new TypeError(msg);
    }
};
//# sourceMappingURL=subscribeTo.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/subscribeToArray.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subscribeToArray; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var subscribeToArray = function (array) {
    return function (subscriber) {
        for (var i = 0, len = array.length; i < len && !subscriber.closed; i++) {
            subscriber.next(array[i]);
        }
        subscriber.complete();
    };
};
//# sourceMappingURL=subscribeToArray.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/subscribeToIterable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subscribeToIterable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__symbol_iterator__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/symbol/iterator.js");
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */

var subscribeToIterable = function (iterable) {
    return function (subscriber) {
        var iterator = iterable[__WEBPACK_IMPORTED_MODULE_0__symbol_iterator__["a" /* iterator */]]();
        do {
            var item = iterator.next();
            if (item.done) {
                subscriber.complete();
                break;
            }
            subscriber.next(item.value);
            if (subscriber.closed) {
                break;
            }
        } while (true);
        if (typeof iterator.return === 'function') {
            subscriber.add(function () {
                if (iterator.return) {
                    iterator.return();
                }
            });
        }
        return subscriber;
    };
};
//# sourceMappingURL=subscribeToIterable.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/subscribeToObservable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subscribeToObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__symbol_observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/symbol/observable.js");
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */

var subscribeToObservable = function (obj) {
    return function (subscriber) {
        var obs = obj[__WEBPACK_IMPORTED_MODULE_0__symbol_observable__["a" /* observable */]]();
        if (typeof obs.subscribe !== 'function') {
            throw new TypeError('Provided object does not correctly implement Symbol.observable');
        }
        else {
            return obs.subscribe(subscriber);
        }
    };
};
//# sourceMappingURL=subscribeToObservable.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/subscribeToPromise.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subscribeToPromise; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hostReportError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/hostReportError.js");
/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */

var subscribeToPromise = function (promise) {
    return function (subscriber) {
        promise.then(function (value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function (err) { return subscriber.error(err); })
            .then(null, __WEBPACK_IMPORTED_MODULE_0__hostReportError__["a" /* hostReportError */]);
        return subscriber;
    };
};
//# sourceMappingURL=subscribeToPromise.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subscribeToResult;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InnerSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/InnerSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subscribeTo__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/util/subscribeTo.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Observable__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observable.js");
/** PURE_IMPORTS_START _InnerSubscriber,_subscribeTo,_Observable PURE_IMPORTS_END */



function subscribeToResult(outerSubscriber, result, outerValue, outerIndex, destination) {
    if (destination === void 0) {
        destination = new __WEBPACK_IMPORTED_MODULE_0__InnerSubscriber__["a" /* InnerSubscriber */](outerSubscriber, outerValue, outerIndex);
    }
    if (destination.closed) {
        return undefined;
    }
    if (result instanceof __WEBPACK_IMPORTED_MODULE_2__Observable__["a" /* Observable */]) {
        return result.subscribe(destination);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_1__subscribeTo__["a" /* subscribeTo */])(result)(destination);
}
//# sourceMappingURL=subscribeToResult.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/toSubscriber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Subscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__symbol_rxSubscriber__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/symbol/rxSubscriber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Observer__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/Observer.js");
/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */



function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof __WEBPACK_IMPORTED_MODULE_0__Subscriber__["a" /* Subscriber */]) {
            return nextOrObserver;
        }
        if (nextOrObserver[__WEBPACK_IMPORTED_MODULE_1__symbol_rxSubscriber__["a" /* rxSubscriber */]]) {
            return nextOrObserver[__WEBPACK_IMPORTED_MODULE_1__symbol_rxSubscriber__["a" /* rxSubscriber */]]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new __WEBPACK_IMPORTED_MODULE_0__Subscriber__["a" /* Subscriber */](__WEBPACK_IMPORTED_MODULE_2__Observer__["a" /* empty */]);
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Subscriber__["a" /* Subscriber */](nextOrObserver, error, complete);
}
//# sourceMappingURL=toSubscriber.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/operators/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_operators_audit__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/audit.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "audit", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_operators_audit__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_operators_auditTime__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/auditTime.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "auditTime", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_operators_auditTime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_operators_buffer__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/buffer.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "buffer", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_operators_buffer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_operators_bufferCount__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/bufferCount.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bufferCount", function() { return __WEBPACK_IMPORTED_MODULE_3__internal_operators_bufferCount__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_operators_bufferTime__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/bufferTime.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bufferTime", function() { return __WEBPACK_IMPORTED_MODULE_4__internal_operators_bufferTime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_operators_bufferToggle__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/bufferToggle.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bufferToggle", function() { return __WEBPACK_IMPORTED_MODULE_5__internal_operators_bufferToggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_operators_bufferWhen__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/bufferWhen.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bufferWhen", function() { return __WEBPACK_IMPORTED_MODULE_6__internal_operators_bufferWhen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__internal_operators_catchError__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/catchError.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "catchError", function() { return __WEBPACK_IMPORTED_MODULE_7__internal_operators_catchError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__internal_operators_combineAll__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/combineAll.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineAll", function() { return __WEBPACK_IMPORTED_MODULE_8__internal_operators_combineAll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__internal_operators_combineLatest__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/combineLatest.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineLatest", function() { return __WEBPACK_IMPORTED_MODULE_9__internal_operators_combineLatest__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__internal_operators_concat__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/concat.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "concat", function() { return __WEBPACK_IMPORTED_MODULE_10__internal_operators_concat__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__internal_operators_concatAll__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/concatAll.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "concatAll", function() { return __WEBPACK_IMPORTED_MODULE_11__internal_operators_concatAll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__internal_operators_concatMap__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/concatMap.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "concatMap", function() { return __WEBPACK_IMPORTED_MODULE_12__internal_operators_concatMap__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__internal_operators_concatMapTo__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/concatMapTo.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "concatMapTo", function() { return __WEBPACK_IMPORTED_MODULE_13__internal_operators_concatMapTo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__internal_operators_count__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/count.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "count", function() { return __WEBPACK_IMPORTED_MODULE_14__internal_operators_count__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__internal_operators_debounce__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/debounce.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "debounce", function() { return __WEBPACK_IMPORTED_MODULE_15__internal_operators_debounce__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__internal_operators_debounceTime__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/debounceTime.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "debounceTime", function() { return __WEBPACK_IMPORTED_MODULE_16__internal_operators_debounceTime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__internal_operators_defaultIfEmpty__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/defaultIfEmpty.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultIfEmpty", function() { return __WEBPACK_IMPORTED_MODULE_17__internal_operators_defaultIfEmpty__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__internal_operators_delay__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/delay.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return __WEBPACK_IMPORTED_MODULE_18__internal_operators_delay__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__internal_operators_delayWhen__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/delayWhen.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "delayWhen", function() { return __WEBPACK_IMPORTED_MODULE_19__internal_operators_delayWhen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__internal_operators_dematerialize__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/dematerialize.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "dematerialize", function() { return __WEBPACK_IMPORTED_MODULE_20__internal_operators_dematerialize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__internal_operators_distinct__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/distinct.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "distinct", function() { return __WEBPACK_IMPORTED_MODULE_21__internal_operators_distinct__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__internal_operators_distinctUntilChanged__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/distinctUntilChanged.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "distinctUntilChanged", function() { return __WEBPACK_IMPORTED_MODULE_22__internal_operators_distinctUntilChanged__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__internal_operators_distinctUntilKeyChanged__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/distinctUntilKeyChanged.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "distinctUntilKeyChanged", function() { return __WEBPACK_IMPORTED_MODULE_23__internal_operators_distinctUntilKeyChanged__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__internal_operators_elementAt__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/elementAt.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "elementAt", function() { return __WEBPACK_IMPORTED_MODULE_24__internal_operators_elementAt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__internal_operators_endWith__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/endWith.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "endWith", function() { return __WEBPACK_IMPORTED_MODULE_25__internal_operators_endWith__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__internal_operators_every__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/every.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "every", function() { return __WEBPACK_IMPORTED_MODULE_26__internal_operators_every__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__internal_operators_exhaust__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/exhaust.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "exhaust", function() { return __WEBPACK_IMPORTED_MODULE_27__internal_operators_exhaust__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__internal_operators_exhaustMap__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/exhaustMap.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "exhaustMap", function() { return __WEBPACK_IMPORTED_MODULE_28__internal_operators_exhaustMap__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__internal_operators_expand__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/expand.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "expand", function() { return __WEBPACK_IMPORTED_MODULE_29__internal_operators_expand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__internal_operators_filter__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/filter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "filter", function() { return __WEBPACK_IMPORTED_MODULE_30__internal_operators_filter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__internal_operators_finalize__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/finalize.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "finalize", function() { return __WEBPACK_IMPORTED_MODULE_31__internal_operators_finalize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__internal_operators_find__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/find.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "find", function() { return __WEBPACK_IMPORTED_MODULE_32__internal_operators_find__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__internal_operators_findIndex__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/findIndex.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findIndex", function() { return __WEBPACK_IMPORTED_MODULE_33__internal_operators_findIndex__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__internal_operators_first__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/first.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "first", function() { return __WEBPACK_IMPORTED_MODULE_34__internal_operators_first__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__internal_operators_groupBy__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/groupBy.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "groupBy", function() { return __WEBPACK_IMPORTED_MODULE_35__internal_operators_groupBy__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__internal_operators_ignoreElements__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/ignoreElements.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ignoreElements", function() { return __WEBPACK_IMPORTED_MODULE_36__internal_operators_ignoreElements__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__internal_operators_isEmpty__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/isEmpty.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function() { return __WEBPACK_IMPORTED_MODULE_37__internal_operators_isEmpty__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__internal_operators_last__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/last.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "last", function() { return __WEBPACK_IMPORTED_MODULE_38__internal_operators_last__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__internal_operators_map__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/map.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "map", function() { return __WEBPACK_IMPORTED_MODULE_39__internal_operators_map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__internal_operators_mapTo__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/mapTo.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mapTo", function() { return __WEBPACK_IMPORTED_MODULE_40__internal_operators_mapTo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__internal_operators_materialize__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/materialize.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "materialize", function() { return __WEBPACK_IMPORTED_MODULE_41__internal_operators_materialize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__internal_operators_max__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/max.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "max", function() { return __WEBPACK_IMPORTED_MODULE_42__internal_operators_max__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__internal_operators_merge__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/merge.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return __WEBPACK_IMPORTED_MODULE_43__internal_operators_merge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__internal_operators_mergeAll__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/mergeAll.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mergeAll", function() { return __WEBPACK_IMPORTED_MODULE_44__internal_operators_mergeAll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__internal_operators_mergeMap__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/mergeMap.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mergeMap", function() { return __WEBPACK_IMPORTED_MODULE_45__internal_operators_mergeMap__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "flatMap", function() { return __WEBPACK_IMPORTED_MODULE_45__internal_operators_mergeMap__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__internal_operators_mergeMapTo__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/mergeMapTo.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mergeMapTo", function() { return __WEBPACK_IMPORTED_MODULE_46__internal_operators_mergeMapTo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__internal_operators_mergeScan__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/mergeScan.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mergeScan", function() { return __WEBPACK_IMPORTED_MODULE_47__internal_operators_mergeScan__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__internal_operators_min__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/min.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "min", function() { return __WEBPACK_IMPORTED_MODULE_48__internal_operators_min__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__internal_operators_multicast__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/multicast.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "multicast", function() { return __WEBPACK_IMPORTED_MODULE_49__internal_operators_multicast__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__internal_operators_observeOn__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/observeOn.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "observeOn", function() { return __WEBPACK_IMPORTED_MODULE_50__internal_operators_observeOn__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__internal_operators_onErrorResumeNext__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/onErrorResumeNext.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "onErrorResumeNext", function() { return __WEBPACK_IMPORTED_MODULE_51__internal_operators_onErrorResumeNext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__internal_operators_pairwise__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/pairwise.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pairwise", function() { return __WEBPACK_IMPORTED_MODULE_52__internal_operators_pairwise__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__internal_operators_partition__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/partition.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "partition", function() { return __WEBPACK_IMPORTED_MODULE_53__internal_operators_partition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__internal_operators_pluck__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/pluck.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pluck", function() { return __WEBPACK_IMPORTED_MODULE_54__internal_operators_pluck__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__internal_operators_publish__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/publish.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "publish", function() { return __WEBPACK_IMPORTED_MODULE_55__internal_operators_publish__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__internal_operators_publishBehavior__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/publishBehavior.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "publishBehavior", function() { return __WEBPACK_IMPORTED_MODULE_56__internal_operators_publishBehavior__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__internal_operators_publishLast__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/publishLast.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "publishLast", function() { return __WEBPACK_IMPORTED_MODULE_57__internal_operators_publishLast__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__internal_operators_publishReplay__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/publishReplay.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "publishReplay", function() { return __WEBPACK_IMPORTED_MODULE_58__internal_operators_publishReplay__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__internal_operators_race__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/race.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "race", function() { return __WEBPACK_IMPORTED_MODULE_59__internal_operators_race__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__internal_operators_reduce__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/reduce.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reduce", function() { return __WEBPACK_IMPORTED_MODULE_60__internal_operators_reduce__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__internal_operators_repeat__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/repeat.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "repeat", function() { return __WEBPACK_IMPORTED_MODULE_61__internal_operators_repeat__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__internal_operators_repeatWhen__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/repeatWhen.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "repeatWhen", function() { return __WEBPACK_IMPORTED_MODULE_62__internal_operators_repeatWhen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__internal_operators_retry__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/retry.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "retry", function() { return __WEBPACK_IMPORTED_MODULE_63__internal_operators_retry__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__internal_operators_retryWhen__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/retryWhen.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "retryWhen", function() { return __WEBPACK_IMPORTED_MODULE_64__internal_operators_retryWhen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__internal_operators_refCount__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/refCount.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "refCount", function() { return __WEBPACK_IMPORTED_MODULE_65__internal_operators_refCount__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__internal_operators_sample__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/sample.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sample", function() { return __WEBPACK_IMPORTED_MODULE_66__internal_operators_sample__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__internal_operators_sampleTime__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/sampleTime.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sampleTime", function() { return __WEBPACK_IMPORTED_MODULE_67__internal_operators_sampleTime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__internal_operators_scan__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/scan.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scan", function() { return __WEBPACK_IMPORTED_MODULE_68__internal_operators_scan__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__internal_operators_sequenceEqual__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/sequenceEqual.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sequenceEqual", function() { return __WEBPACK_IMPORTED_MODULE_69__internal_operators_sequenceEqual__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__internal_operators_share__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/share.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "share", function() { return __WEBPACK_IMPORTED_MODULE_70__internal_operators_share__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__internal_operators_shareReplay__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/shareReplay.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "shareReplay", function() { return __WEBPACK_IMPORTED_MODULE_71__internal_operators_shareReplay__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__internal_operators_single__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/single.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "single", function() { return __WEBPACK_IMPORTED_MODULE_72__internal_operators_single__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__internal_operators_skip__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/skip.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "skip", function() { return __WEBPACK_IMPORTED_MODULE_73__internal_operators_skip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__internal_operators_skipLast__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/skipLast.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "skipLast", function() { return __WEBPACK_IMPORTED_MODULE_74__internal_operators_skipLast__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__internal_operators_skipUntil__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/skipUntil.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "skipUntil", function() { return __WEBPACK_IMPORTED_MODULE_75__internal_operators_skipUntil__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__internal_operators_skipWhile__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/skipWhile.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "skipWhile", function() { return __WEBPACK_IMPORTED_MODULE_76__internal_operators_skipWhile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__internal_operators_startWith__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/startWith.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "startWith", function() { return __WEBPACK_IMPORTED_MODULE_77__internal_operators_startWith__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__internal_operators_subscribeOn__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/subscribeOn.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "subscribeOn", function() { return __WEBPACK_IMPORTED_MODULE_78__internal_operators_subscribeOn__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__internal_operators_switchAll__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/switchAll.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "switchAll", function() { return __WEBPACK_IMPORTED_MODULE_79__internal_operators_switchAll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__internal_operators_switchMap__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/switchMap.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "switchMap", function() { return __WEBPACK_IMPORTED_MODULE_80__internal_operators_switchMap__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__internal_operators_switchMapTo__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/switchMapTo.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "switchMapTo", function() { return __WEBPACK_IMPORTED_MODULE_81__internal_operators_switchMapTo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__internal_operators_take__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/take.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "take", function() { return __WEBPACK_IMPORTED_MODULE_82__internal_operators_take__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__internal_operators_takeLast__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/takeLast.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeLast", function() { return __WEBPACK_IMPORTED_MODULE_83__internal_operators_takeLast__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__internal_operators_takeUntil__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/takeUntil.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeUntil", function() { return __WEBPACK_IMPORTED_MODULE_84__internal_operators_takeUntil__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__internal_operators_takeWhile__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/takeWhile.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeWhile", function() { return __WEBPACK_IMPORTED_MODULE_85__internal_operators_takeWhile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__internal_operators_tap__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/tap.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tap", function() { return __WEBPACK_IMPORTED_MODULE_86__internal_operators_tap__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__internal_operators_throttle__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/throttle.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_87__internal_operators_throttle__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__internal_operators_throttleTime__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/throttleTime.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "throttleTime", function() { return __WEBPACK_IMPORTED_MODULE_88__internal_operators_throttleTime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__internal_operators_throwIfEmpty__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/throwIfEmpty.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "throwIfEmpty", function() { return __WEBPACK_IMPORTED_MODULE_89__internal_operators_throwIfEmpty__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__internal_operators_timeInterval__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/timeInterval.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timeInterval", function() { return __WEBPACK_IMPORTED_MODULE_90__internal_operators_timeInterval__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__internal_operators_timeout__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/timeout.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timeout", function() { return __WEBPACK_IMPORTED_MODULE_91__internal_operators_timeout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__internal_operators_timeoutWith__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/timeoutWith.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timeoutWith", function() { return __WEBPACK_IMPORTED_MODULE_92__internal_operators_timeoutWith__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__internal_operators_timestamp__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/timestamp.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timestamp", function() { return __WEBPACK_IMPORTED_MODULE_93__internal_operators_timestamp__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__internal_operators_toArray__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/toArray.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "toArray", function() { return __WEBPACK_IMPORTED_MODULE_94__internal_operators_toArray__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__internal_operators_window__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/window.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "window", function() { return __WEBPACK_IMPORTED_MODULE_95__internal_operators_window__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__internal_operators_windowCount__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/windowCount.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "windowCount", function() { return __WEBPACK_IMPORTED_MODULE_96__internal_operators_windowCount__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__internal_operators_windowTime__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/windowTime.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "windowTime", function() { return __WEBPACK_IMPORTED_MODULE_97__internal_operators_windowTime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__internal_operators_windowToggle__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/windowToggle.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "windowToggle", function() { return __WEBPACK_IMPORTED_MODULE_98__internal_operators_windowToggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__internal_operators_windowWhen__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/windowWhen.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "windowWhen", function() { return __WEBPACK_IMPORTED_MODULE_99__internal_operators_windowWhen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__internal_operators_withLatestFrom__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/withLatestFrom.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withLatestFrom", function() { return __WEBPACK_IMPORTED_MODULE_100__internal_operators_withLatestFrom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__internal_operators_zip__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/zip.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return __WEBPACK_IMPORTED_MODULE_101__internal_operators_zip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__internal_operators_zipAll__ = __webpack_require__("./node_modules/rxjs/_esm5/internal/operators/zipAll.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "zipAll", function() { return __WEBPACK_IMPORTED_MODULE_102__internal_operators_zipAll__["a"]; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */








































































































//# sourceMappingURL=index.js.map


/***/ }),

/***/ "./node_modules/setimmediate/setImmediate.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/react-scripts/node_modules/webpack/buildin/global.js"), __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/slick-carousel/slick/slick-theme.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/slick-carousel/slick/slick.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/smooth-scroll-to/build/es/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_get_scroll_info__ = __webpack_require__("./node_modules/get-scroll-info/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_easing_lib_easeInOutCubic__ = __webpack_require__("./node_modules/easing-lib/easeInOutCubic.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_easing_lib_easeInOutCubic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_easing_lib_easeInOutCubic__);


var isRunning = false;

var _call = function _call(func, scrollNode) {
  return function () {
    if ('function' !== typeof func) {
      return;
    }

    func(scrollNode);
  };
};
/**
 *  !!Important!! any logic change need take care isRunning
 */


var smoothScrollTo = function smoothScrollTo(to, duration, el, callback) {
  var scrollNode = Object(__WEBPACK_IMPORTED_MODULE_0_get_scroll_info__["b" /* getScrollNode */])(el);

  var cb = _call(callback, scrollNode);

  if (isRunning) {
    isRunning = false;
    setTimeout(function () {
      scrollNode.scrollTop = to;
      cb();
    });
    return false;
  }

  if (!duration) {
    duration = 900;
  }

  var from = scrollNode.scrollTop;
  var go = to - from;

  if (!go) {
    isRunning = false;
    cb();
    return;
  }

  var beginTimeStamp;

  var scrollTo = function scrollTo(timeStamp) {
    beginTimeStamp = beginTimeStamp || timeStamp;
    var elapsedTime = timeStamp - beginTimeStamp;
    var progress = __WEBPACK_IMPORTED_MODULE_1_easing_lib_easeInOutCubic___default()(elapsedTime, from, go, duration);
    scrollNode.scrollTop = progress;

    if (elapsedTime < duration && go && isRunning) {
      requestAnimationFrame(scrollTo);
    } else {
      isRunning = false;
      cb();
    }
  };

  isRunning = true;
  requestAnimationFrame(scrollTo);
};

/* harmony default export */ __webpack_exports__["a"] = (smoothScrollTo);

/***/ }),

/***/ "./node_modules/stream-browserify/index.js":
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__("./node_modules/events/events.js").EventEmitter;
var inherits = __webpack_require__("./node_modules/inherits/inherits_browser.js");

inherits(Stream, EE);
Stream.Readable = __webpack_require__("./node_modules/readable-stream/readable-browser.js");
Stream.Writable = __webpack_require__("./node_modules/readable-stream/writable-browser.js");
Stream.Duplex = __webpack_require__("./node_modules/readable-stream/duplex-browser.js");
Stream.Transform = __webpack_require__("./node_modules/readable-stream/transform.js");
Stream.PassThrough = __webpack_require__("./node_modules/readable-stream/passthrough.js");

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),

/***/ "./node_modules/string-convert/camel2hyphen.js":
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),

/***/ "./node_modules/string_decoder/lib/string_decoder.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__("./node_modules/string_decoder/node_modules/safe-buffer/index.js").Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ "./node_modules/string_decoder/node_modules/safe-buffer/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__("./node_modules/buffer/index.js")
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ "./node_modules/style-to-object/index.js":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("./node_modules/css/lib/parse/index.js");

/**
 * Parses inline style.
 *
 * Example: 'color:red' => { color: 'red' }
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */
module.exports = function parseInlineStyle(style, iterator) {
  if (!style || typeof style !== 'string') return null;

  // make sure to wrap declarations in placeholder
  var declarations = parse('p{' + style + '}').stylesheet.rules[0].declarations;
  var declaration, property, value;

  var output = null;
  var hasIterator = typeof iterator === 'function';

  for (var i = 0, len = declarations.length; i < len; i++) {
    declaration = declarations[i];
    property = declaration.property;
    value = declaration.value;

    if (hasIterator) {
      iterator(property, value, declaration);
    } else if (value) {
      output || (output = {});
      output[property] = value;
    }
  }

  return output;
};


/***/ }),

/***/ "./node_modules/styled-normalize/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.normalize = void 0;

var _styledComponents = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");

var normalize = (0, _styledComponents.css)(["html{line-height:1.15;-webkit-text-size-adjust:100%;}body{margin:0;}main{display:block;}h1{font-size:2em;margin:0.67em 0;}hr{box-sizing:content-box;height:0;overflow:visible;}pre{font-family:monospace,monospace;font-size:1em;}a{background-color:transparent;}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted;}b,strong{font-weight:bolder;}code,kbd,samp{font-family:monospace,monospace;font-size:1em;}small{font-size:80%;}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline;}sub{bottom:-0.25em;}sup{top:-0.5em;}img{border-style:none;}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0;}button,input{overflow:visible;}button,select{text-transform:none;}button,[type=\"button\"],[type=\"reset\"],[type=\"submit\"]{-webkit-appearance:button;}button::-moz-focus-inner,[type=\"button\"]::-moz-focus-inner,[type=\"reset\"]::-moz-focus-inner,[type=\"submit\"]::-moz-focus-inner{border-style:none;padding:0;}button:-moz-focusring,[type=\"button\"]:-moz-focusring,[type=\"reset\"]:-moz-focusring,[type=\"submit\"]:-moz-focusring{outline:1px dotted ButtonText;}fieldset{padding:0.35em 0.75em 0.625em;}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal;}progress{vertical-align:baseline;}textarea{overflow:auto;}[type=\"checkbox\"],[type=\"radio\"]{box-sizing:border-box;padding:0;}[type=\"number\"]::-webkit-inner-spin-button,[type=\"number\"]::-webkit-outer-spin-button{height:auto;}[type=\"search\"]{-webkit-appearance:textfield;outline-offset:-2px;}[type=\"search\"]::-webkit-search-decoration{-webkit-appearance:none;}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit;}details{display:block;}summary{display:list-item;}template{display:none;}[hidden]{display:none;}"]);
exports.normalize = normalize;
var _default = normalize;
exports.default = _default;

/***/ }),

/***/ "./node_modules/styled-props/lib/bind.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledProps = __webpack_require__("./node_modules/styled-props/lib/styledProps.js");

var _styledProps2 = _interopRequireDefault(_styledProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bind = function bind(map) {
  return Object.keys(map).reduce(function (memo, key) {
    // eslint-disable-next-line no-param-reassign
    memo[key] = (0, _styledProps2.default)(map[key], key);
    return memo;
  }, {});
};

exports.default = bind;

/***/ }),

/***/ "./node_modules/styled-props/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindStyles = exports.bind = undefined;

var _styledProps = __webpack_require__("./node_modules/styled-props/lib/styledProps.js");

var _styledProps2 = _interopRequireDefault(_styledProps);

var _bind = __webpack_require__("./node_modules/styled-props/lib/bind.js");

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.bind = _bind2.default;
exports.bindStyles = _bind2.default;
exports.default = _styledProps2.default;

/***/ }),

/***/ "./node_modules/styled-props/lib/styledProps.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var styledProps = function styledProps(map, fallback) {
  return function (props) {
    var keysFromProps = Object.keys(map).filter(function (key) {
      return !!props[key];
    });
    if (keysFromProps.length > 1) {
      if (false) {
        // eslint-disable-next-line no-console
        console.error('[styledProps] Multiple props provided: ' + keysFromProps.join(', ') + '.');
      }
    }
    var keyFromProps = keysFromProps[0];
    if (map[keyFromProps] !== undefined) {
      return map[keyFromProps];
    }
    if (fallback) {
      if (props[fallback] && map[props[fallback]] !== undefined) {
        return map[props[fallback]];
      }
      if (false) {
        // eslint-disable-next-line no-console
        console.error('[styledProps] Unknown fallback prop provided: ' + fallback + '.');
      }
    }
    return undefined;
  };
};

exports.default = styledProps;

/***/ }),

/***/ "./node_modules/supports-webp/dist/supports-webp.common-js.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! npm.im/supports-webp 1.0.7 */


var canvas = typeof document === 'object' ? document.createElement('canvas') : {};
canvas.width = canvas.height = 1;
var index = canvas.toDataURL ? canvas.toDataURL('image/webp').indexOf('image/webp') === 5 : false;

module.exports = index;


/***/ }),

/***/ "./node_modules/timers-browserify/main.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__("./node_modules/setimmediate/setImmediate.js");
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/react-scripts/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/ucfirst/ucfirst.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(s) {
  return s.substr(0, 1).toUpperCase() + s.substring(1);
};



/***/ }),

/***/ "./node_modules/uncontrollable/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = uncontrollable;

var _react = _interopRequireDefault(__webpack_require__("./node_modules/react/index.js"));

var _invariant = _interopRequireDefault(__webpack_require__("./node_modules/invariant/browser.js"));

var Utils = _interopRequireWildcard(__webpack_require__("./node_modules/uncontrollable/utils.js"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function uncontrollable(Component, controlledValues, methods) {
  if (methods === void 0) {
    methods = [];
  }

  var displayName = Component.displayName || Component.name || 'Component';
  var isCompositeComponent = Utils.isReactComponent(Component);
  var controlledProps = Object.keys(controlledValues);
  var PROPS_TO_OMIT = controlledProps.map(Utils.defaultKey);
  !(isCompositeComponent || !methods.length) ?  false ? (0, _invariant.default)(false, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', ')) : invariant(false) : void 0;

  var UncontrolledComponent =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(UncontrolledComponent, _React$Component);

    function UncontrolledComponent() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _this.handlers = Object.create(null);
      controlledProps.forEach(function (propName) {
        var handlerName = controlledValues[propName];

        var handleChange = function handleChange(value) {
          if (_this.props[handlerName]) {
            var _this$props;

            _this._notifying = true;

            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            (_this$props = _this.props)[handlerName].apply(_this$props, [value].concat(args));

            _this._notifying = false;
          }

          _this._values[propName] = value;
          if (!_this.unmounted) _this.forceUpdate();
        };

        _this.handlers[handlerName] = handleChange;
      });
      if (isCompositeComponent) _this.attachRef = function (ref) {
        _this.inner = ref;
      };
      return _this;
    }

    var _proto = UncontrolledComponent.prototype;

    _proto.shouldComponentUpdate = function shouldComponentUpdate() {
      //let the forceUpdate trigger the update
      return !this._notifying;
    };

    _proto.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var props = this.props;
      this._values = Object.create(null);
      controlledProps.forEach(function (key) {
        _this2._values[key] = props[Utils.defaultKey(key)];
      });
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      var props = this.props;
      controlledProps.forEach(function (key) {
        /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */
        if (!Utils.isProp(nextProps, key) && Utils.isProp(props, key)) {
          _this3._values[key] = nextProps[Utils.defaultKey(key)];
        }
      });
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.unmounted = true;
    };

    _proto.getControlledInstance = function getControlledInstance() {
      return this.inner;
    };

    _proto.render = function render() {
      var _this4 = this;

      var props = _extends({}, this.props);

      PROPS_TO_OMIT.forEach(function (prop) {
        delete props[prop];
      });
      var newProps = {};
      controlledProps.forEach(function (propName) {
        var propValue = _this4.props[propName];
        newProps[propName] = propValue !== undefined ? propValue : _this4._values[propName];
      });
      return _react.default.createElement(Component, _extends({}, props, newProps, this.handlers, {
        ref: this.attachRef
      }));
    };

    return UncontrolledComponent;
  }(_react.default.Component);

  UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
  UncontrolledComponent.propTypes = Utils.uncontrolledPropTypes(controlledValues, displayName);
  methods.forEach(function (method) {
    UncontrolledComponent.prototype[method] = function $proxiedMethod() {
      var _inner;

      return (_inner = this.inner)[method].apply(_inner, arguments);
    };
  });
  UncontrolledComponent.ControlledComponent = Component;
  /**
   * useful when wrapping a Component and you want to control
   * everything
   */

  UncontrolledComponent.deferControlTo = function (newComponent, additions, nextMethods) {
    if (additions === void 0) {
      additions = {};
    }

    return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
  };

  return UncontrolledComponent;
}

module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/uncontrollable/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.uncontrolledPropTypes = uncontrolledPropTypes;
exports.isProp = isProp;
exports.defaultKey = defaultKey;
exports.isReactComponent = isReactComponent;

var _invariant = _interopRequireDefault(__webpack_require__("./node_modules/invariant/browser.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {};

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, displayName) {
  var propTypes = {};
  Object.keys(controlledValues).forEach(function (prop) {
    // add default propTypes for folks that use runtime checks
    propTypes[defaultKey(prop)] = noop;

    if (false) {
      var handler = controlledValues[prop];
      !(typeof handler === 'string' && handler.trim().length) ? process.env.NODE_ENV !== "production" ? (0, _invariant.default)(false, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop) : invariant(false) : void 0;
      propTypes[prop] = readOnlyPropType(handler, displayName);
    }
  });
  return propTypes;
}

function isProp(props, prop) {
  return props[prop] !== undefined;
}

function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */


function isReactComponent(component) {
  return !!(component && component.prototype && component.prototype.isReactComponent);
}

/***/ }),

/***/ "./node_modules/universal-cookie/es6/Cookies.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookie__ = __webpack_require__("./node_modules/universal-cookie/node_modules/cookie/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("./node_modules/universal-cookie/es6/utils.js");


// We can't please Rollup and TypeScript at the same time
// Only way to make both of them work
var objectAssign = __webpack_require__("./node_modules/object-assign/index.js");
var Cookies = /** @class */ (function () {
    function Cookies(cookies) {
        this.changeListeners = [];
        this.TESTING_ONETWO = 2;
        this.cookies = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* parseCookies */])(cookies);
        this.HAS_DOCUMENT_COOKIE = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* hasDocumentCookie */])();
    }
    Cookies.prototype._updateBrowserValues = function () {
        if (!this.HAS_DOCUMENT_COOKIE) {
            return;
        }
        this.cookies = __WEBPACK_IMPORTED_MODULE_0_cookie__["parse"](document.cookie);
    };
    Cookies.prototype._emitChange = function (params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    };
    Cookies.prototype.get = function (name, options) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues();
        return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* readCookie */])(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function (options) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues();
        var result = {};
        for (var name_1 in this.cookies) {
            result[name_1] = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* readCookie */])(this.cookies[name_1], options);
        }
        return result;
    };
    Cookies.prototype.set = function (name, value, options) {
        var _a;
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.cookies = objectAssign({}, this.cookies, (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = __WEBPACK_IMPORTED_MODULE_0_cookie__["serialize"](name, value, options);
        }
        this._emitChange({ name: name, value: value, options: options });
    };
    Cookies.prototype.remove = function (name, options) {
        var finalOptions = (options = objectAssign({}, options, {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        }));
        this.cookies = objectAssign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = __WEBPACK_IMPORTED_MODULE_0_cookie__["serialize"](name, '', finalOptions);
        }
        this._emitChange({ name: name, value: undefined, options: options });
    };
    Cookies.prototype.addChangeListener = function (callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function (callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
    };
    return Cookies;
}());
/* harmony default export */ __webpack_exports__["a"] = (Cookies);


/***/ }),

/***/ "./node_modules/universal-cookie/es6/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Cookies__ = __webpack_require__("./node_modules/universal-cookie/es6/Cookies.js");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Cookies__["a" /* default */]);


/***/ }),

/***/ "./node_modules/universal-cookie/es6/utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasDocumentCookie;
/* unused harmony export cleanCookies */
/* harmony export (immutable) */ __webpack_exports__["b"] = parseCookies;
/* unused harmony export isParsingCookie */
/* harmony export (immutable) */ __webpack_exports__["c"] = readCookie;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookie__ = __webpack_require__("./node_modules/universal-cookie/node_modules/cookie/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cookie__);

function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function cleanCookies() {
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c
            .replace(/^ +/, '')
            .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function parseCookies(cookies) {
    if (typeof cookies === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_cookie__["parse"](cookies);
    }
    else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    }
    else {
        return {};
    }
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === 'undefined') {
        // We guess if the cookie start with { or [, it has been serialized
        doNotParse =
            !value || (value[0] !== '{' && value[0] !== '[' && value[0] !== '"');
    }
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) { options = {}; }
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) {
        try {
            return JSON.parse(cleanValue);
        }
        catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}


/***/ }),

/***/ "./node_modules/universal-cookie/node_modules/cookie/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ "./node_modules/util-deprecate/browser.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/react-scripts/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/util/node_modules/inherits/inherits_browser.js":
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),

/***/ "./node_modules/util/support/isBufferBrowser.js":
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),

/***/ "./node_modules/util/util.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_CONTACT_FORM_MAIL_TO":"https://prod-11.westeurope.logic.azure.com:443/workflows/469daeb9e0814284944a6823e010e5a8/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=LDw4OCmhrzknYryf6NZR0l3HUvOO4sOrJ4KrLNKgQF4","REACT_APP_CONTACT_FORM_SUPPORT_MAIL_TO":"https://prod-16.westeurope.logic.azure.com:443/workflows/07509f2760d64838bdf665f7d4c46e93/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=RU0-XCUoC4Qpr8vUzhRzGqBG6tSvXSkO9nkxjqaxCPI","REACT_APP_DEBUG":"false","REACT_APP_GEOLOCATION_API":"https://ipinfo.io/json?token=ea4d0cf5569d7d","REACT_APP_NEWSLETTER":"https://zonifero-new-www-dev-linux-fap.azurewebsites.net/api/getResponse","REACT_APP_PIPEDRIVE":"https://thg-d-www-pipedrive-fap.azurewebsites.net/api/postnote?code=Ils3YzEnC4e_eucIqh-bmAFyZfiILKHctzHGfhApQ46-AzFun4AhSA%3D%3D","REACT_APP_PROXY_BASE_URL":"https://tender-cms-api.azurewebsites.net","REACT_APP_RECAPTCHA_SECRET_KEY":"6Ld2rL0kAAAAAMu9_rMrS0HMhPpbzlO9L11OpDSS","REACT_APP_RECAPTCHA_SITE_KEY":"6Ld2rL0kAAAAAPMldKss1yYJmpWfSil0UPlBBlqh","REACT_APP_SEARCH_CONSOLE_CODE":"vLvp2xQcuyTV0NJMTAfXrgRLTIvTQg3LC-PmKOg7rHo","REACT_APP_SECURITY_APP":"https://swh-p-spambotprot-fap.azurewebsites.net/api/SpamBotProtection","REACT_APP_TAG_MANAGER_ID":"GTM-KB24WRL"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__("./node_modules/util/support/isBufferBrowser.js");

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__("./node_modules/util/node_modules/inherits/inherits_browser.js");

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/warning/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),

/***/ "./node_modules/win-doc/build/es/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return doc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return win; });
/**
 * !!Important!! do not use reshow-constant here
 * Bable will transpile it to double undefined
 */
var doc = function doc(w) {
  w = w || win();
  return 'undefined' !== typeof w.document ? w.document : {
    __null: true
  };
};

var win = function win() {
  return 'undefined' !== typeof window ? window : {
    __null: true
  };
};



/***/ }),

/***/ "./node_modules/window-or-global/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
module.exports = (typeof self === 'object' && self.self === self && self) ||
  (typeof global === 'object' && global.global === global && global) ||
  this

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/react-scripts/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./src/App.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_last_location__ = __webpack_require__("./node_modules/react-router-last-location/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_last_location___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_router_last_location__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_blocks_Layout__ = __webpack_require__("./src/blocks/Layout/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_BlogArticle__ = __webpack_require__("./src/pages/BlogArticle/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_consts_anchor__ = __webpack_require__("./src/common/consts/anchor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_consts_anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_common_consts_anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_Product__ = __webpack_require__("./src/pages/Product/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_ForInvestors__ = __webpack_require__("./src/pages/ForInvestors/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_Blog__ = __webpack_require__("./src/pages/Blog/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_Regulations__ = __webpack_require__("./src/pages/Regulations/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_PrivacyPolicy__ = __webpack_require__("./src/pages/PrivacyPolicy/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pages_PageNotFound__ = __webpack_require__("./src/pages/PageNotFound/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_ContactForm__ = __webpack_require__("./src/pages/ContactForm/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_NewsletterThankYouPage__ = __webpack_require__("./src/pages/NewsletterThankYouPage/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_methods_language__ = __webpack_require__("./src/common/methods/language.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__stores_App_store__ = __webpack_require__("./src/stores/App.store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_services_Inbound_service__ = __webpack_require__("./src/services/Inbound.service.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["inject"])('appStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"])(_class=(_temp=_class2=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));Object(__WEBPACK_IMPORTED_MODULE_18_services_Inbound_service__["a" /* default */])();_this.state={anchor:Object(__WEBPACK_IMPORTED_MODULE_16__common_methods_language__["c" /* prepareAnchors */])(props.appStore.currentLanguage,__WEBPACK_IMPORTED_MODULE_6_common_consts_anchor___default.a)};return _this;}_createClass(App,[{key:'render',value:function render(){var appStore=this.props.appStore;var anchor=this.state.anchor;appStore.setUrlHistory();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_last_location__["LastLocationProvider"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_blocks_Layout__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Switch"],null,appStore.currentLanguage==="pl"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"],{exact:true,path:anchor.FOR_INVESTORS,component:__WEBPACK_IMPORTED_MODULE_8_pages_ForInvestors__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"],{path:anchor.CONTACT_FORM,component:__WEBPACK_IMPORTED_MODULE_13_pages_ContactForm__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"],{path:anchor.THANK_YOU,component:__WEBPACK_IMPORTED_MODULE_14_pages_NewsletterThankYouPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"],{path:anchor.SUBSCRIPTION_CONFIRMED,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_pages_NewsletterThankYouPage__["a" /* default */],Object.assign({confirmed:true},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"],{exact:true,path:anchor.REGULATIONS,component:__WEBPACK_IMPORTED_MODULE_10_pages_Regulations__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"],{exact:true,path:anchor.PRIVACY_POLICY,component:__WEBPACK_IMPORTED_MODULE_11_pages_PrivacyPolicy__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"],{exact:true,path:Object(__WEBPACK_IMPORTED_MODULE_16__common_methods_language__["d" /* rootPathJoin */])(anchor.BLOG,'/:category/:slug'),component:__WEBPACK_IMPORTED_MODULE_5_pages_BlogArticle__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"],{exact:true,path:Object(__WEBPACK_IMPORTED_MODULE_16__common_methods_language__["d" /* rootPathJoin */])(anchor.BLOG,'/:category?'),component:__WEBPACK_IMPORTED_MODULE_9_pages_Blog__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"],{exact:true,path:Object(__WEBPACK_IMPORTED_MODULE_16__common_methods_language__["d" /* rootPathJoin */])(anchor.HOME,'/:slug?'),component:__WEBPACK_IMPORTED_MODULE_7_pages_Product__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"],{component:__WEBPACK_IMPORTED_MODULE_12_pages_PageNotFound__["a" /* default */]}))));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class2.propTypes={appStore:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_17__stores_App_store__["a" /* AppStore */]).isRequired},_temp))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),

/***/ "./src/RootApp.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flowRight__ = __webpack_require__("./node_modules/lodash/flowRight.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("./src/App.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__history__ = __webpack_require__("./src/history.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__stores_App_store__ = __webpack_require__("./src/stores/App.store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_Language_service__ = __webpack_require__("./src/services/Language.service.js");
var ProptechLandingPage=Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["withRouter"])(Object(__WEBPACK_IMPORTED_MODULE_0_react__["lazy"])(function(){return __webpack_require__.e/* import() */("index").then(__webpack_require__.bind(null, "./src/landings/proptech/index.jsx"));}));var RootApp=function RootApp(_ref){var currentLanguage=_ref.appStore.currentLanguage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Router"],{history:__WEBPACK_IMPORTED_MODULE_5__history__["a" /* default */],key:currentLanguage},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"],{fallback:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Loading')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Switch"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"],{path:'/'+currentLanguage+'/',component:__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"],{render:function render(_ref2){var location=_ref2.location;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"],{to:{pathname:__WEBPACK_IMPORTED_MODULE_8__services_Language_service__["a" /* default */].createLink(currentLanguage,location.pathname),search:location.search,state:location.state}});}}))));};RootApp.propTypes={appStore:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_7__stores_App_store__["a" /* AppStore */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_lodash_flowRight___default()(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["inject"])('appStore'),__WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"])(RootApp));

/***/ }),

/***/ "./src/animations/Animations.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return KEY_FRAMES; });
/* unused harmony export dropAnimation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return screenChangeAnimation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return delayedOpacityAnimation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hideToRightAnimation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hideToLeftAnimation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return showToRightAnimation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return showToLeftAnimation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return scrollToElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return scrollTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FADE_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return parallaxImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return parallaxImageTranslateY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return scaleImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animejs__ = __webpack_require__("./node_modules/animejs/anime.min.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_window_or_global__ = __webpack_require__("./node_modules/window-or-global/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var KEY_FRAMES={FADE_IN:Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["keyframes"])(['from{opacity:0;}to{opacity:1;}'])};var dropAnimation=function dropAnimation(targets){__WEBPACK_IMPORTED_MODULE_0_animejs___default()({targets:targets,duration:1500,opacity:1,translateY:[-700,0]});};var screenChangeAnimation=function screenChangeAnimation(targets){__WEBPACK_IMPORTED_MODULE_0_animejs___default()({targets:targets,delay:200,easing:'easeOutSine',translateX:[260,0],opacity:[0,1],duration:250});};var delayedOpacityAnimation=function delayedOpacityAnimation(targets){var _delay=arguments.length>1&&arguments[1]!==undefined?arguments[1]:200;var isCompletedCallback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:function(){};__WEBPACK_IMPORTED_MODULE_0_animejs___default()({targets:targets,easing:'linear',opacity:[0,1],delay:function delay(el,index){return index*_delay;},duration:_delay,complete:isCompletedCallback});};var hideToRightAnimation=function hideToRightAnimation(targets){__WEBPACK_IMPORTED_MODULE_0_animejs___default()({targets:targets,easing:'easeOutSine',opacity:[1,0],translateX:[0,1000],duration:350});};var hideToLeftAnimation=function hideToLeftAnimation(targets){__WEBPACK_IMPORTED_MODULE_0_animejs___default()({targets:targets,easing:'easeOutSine',opacity:[1,0],translateX:[0,-1000],duration:350});};var showToRightAnimation=function showToRightAnimation(targets){__WEBPACK_IMPORTED_MODULE_0_animejs___default()({targets:targets,easing:'easeOutSine',opacity:[0,1],delay:25,translateX:[-1000,0],duration:350});};var showToLeftAnimation=function showToLeftAnimation(targets){__WEBPACK_IMPORTED_MODULE_0_animejs___default()({targets:targets,easing:'easeOutSine',opacity:[0,1],delay:25,translateX:[1000,0],duration:350});};var scrollToElement=function scrollToElement(target,delayInMilliseconds){var behavior=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'smooth';setTimeout(function(){target.scrollIntoView({behavior:behavior,block:'start'});},delayInMilliseconds);};var scrollTo=function scrollTo(top,left){__WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.scroll({top:top,left:left,behavior:'smooth'});};var FADE_VALUES={BOX:{LIGHT:'10px',SMALL:'50px',LARGE:'100px'},TEXT:{SMALL:'1em',LARGE:'2em'},DELAY:{SMALL:200,LARGE:1000}};var parallaxImage=function parallaxImage(reference,topMaxValue,topMinValue,animationSpeed){var imageParams=reference.getBoundingClientRect();var top=topMinValue;top+=(imageParams.top-__WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.innerHeight)/animationSpeed*-1;reference.style.top=top+'px';if(top<topMinValue){reference.style.top=topMinValue+'px';}else if(top>topMaxValue){reference.style.top=topMaxValue+'px';}};var parallaxImageTranslateY=function parallaxImageTranslateY(reference,topMaxValue,topMinValue,animationSpeed){var imageParams=reference.getBoundingClientRect();var top=topMinValue;top+=(imageParams.top-__WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.innerHeight)/animationSpeed*-1;reference.style.transform='translateY('+top+'px)';if(top<topMinValue){reference.style.transform='translateY('+topMinValue+'px)';}else if(top>topMaxValue){reference.style.transform='translateY('+topMaxValue+'px)';}};var scaleImage=function scaleImage(reference,scaleMax,scaleMin){var imageParams=reference.getBoundingClientRect();var scale=scaleMin;scale+=(imageParams.top-__WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.innerHeight)/5000*-1;reference.style.transform='scale('+scale+')';if(scale>scaleMax){reference.style.transform='scale('+scaleMax+')';}else if(scale<scaleMin){reference.style.transform='scale('+scaleMin+')';}};

/***/ }),

/***/ "./src/blocks/Arrow/Arrow.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var Arrow=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({displayName:'Arrow',componentId:'sc-1yq8d6a-0'})(['width:',';height:',';display:',';border:solid black;border-width:0 2px 2px 0;transform:rotate(45deg);margin-right:',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),function(props){return props.isActive?'none':'block';},__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.base'));/* harmony default export */ __webpack_exports__["a"] = (Arrow);

/***/ }),

/***/ "./src/blocks/Background/Background.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n      padding-top: 0;\n    '],['\n      padding-top: 0;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* Disable ESlint rule for this file *//* eslint react/destructuring-assignment: "off" */var Background=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'Background',componentId:'mv0vjj-0'})(['width:100%;background-color:',';overflow:hidden;padding-top:',';',''],function(props){return props.color;},__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.base'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].desktop(_templateObject));/* harmony default export */ __webpack_exports__["a"] = (Background);

/***/ }),

/***/ "./src/blocks/BurgerIcon/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_consts_navigation__ = __webpack_require__("./src/common/consts/navigation.js");
var BurgerIconWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].a.withConfig({displayName:'BurgerIcon__BurgerIconWrapper',componentId:'rewj8u-0'})(['position:relative;display:flex;width:16px;height:16px;cursor:pointer;justify-content:center;padding-bottom:calc(',' * 2);'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.xs'));var BurgerIconElement=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({displayName:'BurgerIcon__BurgerIconElement',componentId:'rewj8u-1'})(['&,&:after,&:before{cursor:pointer;border-radius:1px;height:2px;width:16px;background-color:',';position:absolute;display:block;content:\'\';transition:all ',' ',';top:6px;}&:before{top:6px;}&:after{top:',';}',''],function(_ref){var color=_ref.color;return color||__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('text');},__WEBPACK_IMPORTED_MODULE_4_common_consts_navigation__["c" /* MOBILE_NAV_TRANSITION_SPEED */],__WEBPACK_IMPORTED_MODULE_4_common_consts_navigation__["b" /* MOBILE_NAV_TRANSITION_FUNCTION */],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.xs'),function(_ref2){var active=_ref2.active;return active?'\n    & {\n      margin-top: '+__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.xs')+';\n      background-color: transparent;\n    }\n    &, &:after, &:before {\n      top: 0;\n      width: 18px;\n      height: 2px;\n    }\n    &:before {\n      transform: rotate(45deg);\n    }\n    &:after {\n      transform: rotate(-45deg);\n    }\n  ':'';});var BurgerIcon=function BurgerIcon(_ref3){var active=_ref3.active,color=_ref3.color;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(BurgerIconWrapper,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(BurgerIconElement,{active:active,color:color}));};BurgerIcon.propTypes={active:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};BurgerIcon.defaultProps={active:false,color:''};/* harmony default export */ __webpack_exports__["a"] = (BurgerIcon);

/***/ }),

/***/ "./src/blocks/Carousel/Carousel.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slick__ = __webpack_require__("./node_modules/react-slick/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_slick_carousel_slick_slick_css__ = __webpack_require__("./node_modules/slick-carousel/slick/slick.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_slick_carousel_slick_slick_theme_css__ = __webpack_require__("./node_modules/slick-carousel/slick/slick-theme.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_slick_carousel_slick_slick_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_slick_carousel_slick_slick_theme_css__);
var _templateObject=_taggedTemplateLiteral(['\n    ','\n      ','\n  '],['\n    ','\n      ','\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    ',';\n    ','\n  '],['\n    ',';\n    ','\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/forbid-prop-types,no-unused-expressions */var StyledSlider=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_react_slick___default.a).withConfig({displayName:'Carousel__StyledSlider',componentId:'w9n1ru-0'})(['width:100%;margin:',';',' ',' ',' ',' ',''],function(_ref){var blogArticle=_ref.blogArticle;return blogArticle?__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('metrics.l')+' auto':'';},function(_ref2){var noMarginBottom=_ref2.noMarginBottom;return noMarginBottom?'.slick-list { margin-bottom: 0; }':'';},function(_ref3){var cursorDefault=_ref3.cursorDefault;return cursorDefault?'cursor: default':'';},function(_ref4){var selectable=_ref4.selectable;return selectable?'\n     user-select: text;\n     & .slick-slide {\n        user-select: text;\n      }\n  ':'';},__WEBPACK_IMPORTED_MODULE_4_designsystem_index__["c" /* media */].tablet(_templateObject,function(_ref5){var threeColumnCarousel=_ref5.threeColumnCarousel;return!threeColumnCarousel?'\n      cursor: move;\n      cursor: grab;\n    ':'';},function(_ref6){var cursorDefault=_ref6.cursorDefault;return cursorDefault?'cursor: default':'';}),__WEBPACK_IMPORTED_MODULE_4_designsystem_index__["c" /* media */].desktop(_templateObject2,function(_ref7){var threeColumnCarousel=_ref7.threeColumnCarousel;return threeColumnCarousel?'\n      & .slick-slide {\n        margin-right: 7.3%;\n        user-select: text;\n      }\n    ':'';},function(_ref8){var cursorDefault=_ref8.cursorDefault;return cursorDefault?'cursor: default':'';}));var defaultSettings={infinite:true,speed:500,slidesToScroll:1};var Carousel=function Carousel(props){var settings=props.settings,children=props.children,threeColumnCarousel=props.threeColumnCarousel,blogArticle=props.blogArticle,cursorDefault=props.cursorDefault,_innerRef=props.innerRef,selectable=props.selectable,noMarginBottom=props.noMarginBottom;var sliderSettings=Object.assign(defaultSettings,settings);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledSlider,Object.assign({},sliderSettings,{selectable:selectable,innerRef:function innerRef(slider){return _innerRef&&_innerRef(slider);},cursorDefault:cursorDefault,threeColumnCarousel:threeColumnCarousel,blogArticle:blogArticle,noMarginBottom:noMarginBottom}),children);};Carousel.propTypes={settings:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,threeColumnCarousel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,blogArticle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,cursorDefault:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,selectable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,noMarginBottom:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,innerRef:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};Carousel.defaultProps={threeColumnCarousel:false,blogArticle:false,cursorDefault:false,selectable:false,noMarginBottom:false,innerRef:null};/* harmony default export */ __webpack_exports__["a"] = (Carousel);

/***/ }),

/***/ "./src/blocks/CloseButton/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    top: ',';\n    right: ',';\n  '],['\n    top: ',';\n    right: ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ButtonContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div.withConfig({displayName:'CloseButton__ButtonContainer',componentId:'sc-1l7sg5q-0'})(['width:',';height:',';position:fixed;top:',';right:',';display:flex;align-items:center;',' &:focus{outline:none;}'],__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_3_designsystem_index__["c" /* media */].tablet(_templateObject,__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('metrics.l')));var Button=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span.withConfig({displayName:'CloseButton__Button',componentId:'sc-1l7sg5q-1'})(['cursor:pointer;&::before,&::after{content:\'\';position:absolute;height:2px;width:calc(',' / 2);top:50%;right:0;background:',';}&::before{transform:rotate(45deg);}&::after{transform:rotate(-45deg);}'],__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('metrics.base'),__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].brand('regular'));var Text=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span.withConfig({displayName:'CloseButton__Text',componentId:'sc-1l7sg5q-2'})(['font-size:',';line-height:',';font-family:',';font-weight:',';cursor:pointer;position:absolute;top:-3px;right:0;opacity:0;transition:all .3s;',';'],__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].fs('m'),__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('type.lineHeight.s'),__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('type.fontWeight.extended'),function(_ref){var active=_ref.active;return active&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(['right:',';opacity:1;'],__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('metrics.base'));});var CloseButton=function CloseButton(_ref2){var onClick=_ref2.onClick,onMouseEnter=_ref2.onMouseEnter,onMouseLeave=_ref2.onMouseLeave,text=_ref2.text,isShown=_ref2.isShown;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonContainer,{onClick:onClick,onKeyPress:onClick,role:'button',tabIndex:-1,onMouseEnter:onMouseEnter,onMouseLeave:onMouseLeave},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,{active:isShown},text));};CloseButton.propTypes={onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onMouseEnter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onMouseLeave:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isShown:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};CloseButton.defaultProps={onMouseEnter:function onMouseEnter(){},onMouseLeave:function onMouseLeave(){},text:'',isShown:false};/* harmony default export */ __webpack_exports__["a"] = (CloseButton);

/***/ }),

/***/ "./src/blocks/CloseIcon/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var CloseIcon=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].a.withConfig({displayName:'CloseIcon',componentId:'sc-8m7x2t-0'})(['position:absolute;right:32px;top:32px;width:32px;height:32px;opacity:0.9;transition:opacity .3s;cursor:pointer;&:hover{opacity:1;}&:before,&:after{position:absolute;left:15px;content:\' \';height:',';width:',';background-color:',';}&:before{transform:rotate(45deg);}&:after{transform:rotate(-45deg);}'],function(_ref){var height=_ref.height;return height||'33px';},function(_ref2){var width=_ref2.width;return width||'2px';},function(_ref3){var color=_ref3.color;return color||__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('text');});/* harmony default export */ __webpack_exports__["a"] = (CloseIcon);

/***/ }),

/***/ "./src/blocks/Container/Container.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_consts_containerWidth__ = __webpack_require__("./src/common/consts/containerWidth.js");
var Container=function Container(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_hedron__["Page"],Object.assign({},props,{width:__WEBPACK_IMPORTED_MODULE_2_common_consts_containerWidth__["a" /* default */]+'px'}));};/* harmony default export */ __webpack_exports__["a"] = (Container);

/***/ }),

/***/ "./src/blocks/CookiesModal/CookiesModal.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CookiesModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_responsive__ = __webpack_require__("./src/common/responsive.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_universal_cookie__ = __webpack_require__("./node_modules/universal-cookie/es6/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_decorators_bind__ = __webpack_require__("./node_modules/lodash-decorators/bind.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_decorators_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_decorators_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_consts_cookies__ = __webpack_require__("./src/common/consts/cookies.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_elements_Paragraph__ = __webpack_require__("./src/elements/Paragraph.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2;var _templateObject=_taggedTemplateLiteral(['\n        right: ','\n        width: 500px;\n        height: auto;\n        bottom: 250px;\n    '],['\n        right: ','\n        width: 500px;\n        height: auto;\n        bottom: 250px;\n    ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var CookiesModalBox=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div.withConfig({displayName:'CookiesModal__CookiesModalBox',componentId:'sc-143eype-0'})(['width:100%;padding:',';background-color:',';position:fixed;z-index:1000;bottom:0;',';'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_4_common_responsive__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.l')));var CloseIcon=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].a.withConfig({displayName:'CookiesModal__CloseIcon',componentId:'sc-143eype-1'})(['display:block;position:absolute;width:25px;height:25px;top:15px;right:',';cursor:pointer;&:before,&:after{display:block;content:\'\';position:absolute;right:12px;height:25px;width:1px;background-color:',';}&:before{transform:rotate(45deg);}&:after{transform:rotate(-45deg);}'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('background'));var WhiteParagraph=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8_elements_Paragraph__["a" /* default */]).withConfig({displayName:'CookiesModal__WhiteParagraph',componentId:'sc-143eype-2'})(['color:',';font-size:',';line-height:21px;'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('background'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].fs('s'));var CookiesModal=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('coreStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(_class=(_class2=function(_Component){_inherits(CookiesModal,_Component);function CookiesModal(props){_classCallCheck(this,CookiesModal);var _this=_possibleConstructorReturn(this,(CookiesModal.__proto__||Object.getPrototypeOf(CookiesModal)).call(this,props));_this.state={hasCookie:false};_this.cookieProvider=new __WEBPACK_IMPORTED_MODULE_5_universal_cookie__["a" /* default */]();return _this;}_createClass(CookiesModal,[{key:'componentDidMount',value:function componentDidMount(){this.setState({hasCookie:this.cookieProvider.get(__WEBPACK_IMPORTED_MODULE_7_common_consts_cookies__["a" /* default */])});}},{key:'setCookie',value:function setCookie(){this.cookieProvider.set(__WEBPACK_IMPORTED_MODULE_7_common_consts_cookies__["a" /* default */],true);this.setState({hasCookie:true});}},{key:'render',value:function render(){var translations=this.props.coreStore.translations;var hasCookie=this.state.hasCookie;return hasCookie?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CookiesModalBox,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WhiteParagraph,null,translations.COOKIES_AGREEMENT),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseIcon,{onClick:this.setCookie}));}}]);return CookiesModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),(_applyDecoratedDescriptor(_class2.prototype,'setCookie',[__WEBPACK_IMPORTED_MODULE_6_lodash_decorators_bind___default.a],Object.getOwnPropertyDescriptor(_class2.prototype,'setCookie'),_class2.prototype)),_class2))||_class)||_class);

/***/ }),

/***/ "./src/blocks/DebugComponents/DebugBar/DebugBarWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var DebugBarWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'DebugBarWrapper',componentId:'sc-161nq6j-0'})(['position:fixed;display:flex;bottom:0;right:0;width:auto;z-index:1000;']);/* harmony default export */ __webpack_exports__["a"] = (DebugBarWrapper);

/***/ }),

/***/ "./src/blocks/DebugComponents/DebugBar/DebugButton.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_elements_Button__ = __webpack_require__("./src/elements/Button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n  position: relative;\n  margin: 0;\n  box-shadow: 0 0 1px 0 rgba(0, 0, 0, .2);\n  border: none;\n  color: ',';\n  transition-duration: 0.2s;\n  outline: none;\n  background-color: ',';\n  width: 133px;\n  height: auto;\n  white-space: nowrap;\n  padding: ',' ',';\n  \n  font-weight: ',';\n  \n  &:hover, &:focus {\n    background-color: ',';\n  }\n  \n  &:active {\n    background-color: ',';\n  }\n'],['\n  position: relative;\n  margin: 0;\n  box-shadow: 0 0 1px 0 rgba(0, 0, 0, .2);\n  border: none;\n  color: ',';\n  transition-duration: 0.2s;\n  outline: none;\n  background-color: ',';\n  width: 133px;\n  height: auto;\n  white-space: nowrap;\n  padding: ',' ',';\n  \n  font-weight: ',';\n  \n  &:hover, &:focus {\n    background-color: ',';\n  }\n  \n  &:active {\n    background-color: ',';\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var DebugButton=__WEBPACK_IMPORTED_MODULE_0_elements_Button__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.bold'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('background'));/* harmony default export */ __webpack_exports__["a"] = (DebugButton);

/***/ }),

/***/ "./src/blocks/DebugComponents/DebugBar/DebugOption/DebugOptionGroupLabel.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var DebugOptionGroupLabel=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].label.withConfig({displayName:'DebugOptionGroupLabel',componentId:'yasl4k-0'})(['font-family:',';font-weight:',';padding-right:',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.regular'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'));/* harmony default export */ __webpack_exports__["a"] = (DebugOptionGroupLabel);

/***/ }),

/***/ "./src/blocks/DebugComponents/DebugBar/DebugOption/DebugOptionInput.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var DebugOptionInput=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].input.withConfig({displayName:'DebugOptionInput',componentId:'sc-9z17tc-0'})(['cursor:pointer;margin-left:',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'));/* harmony default export */ __webpack_exports__["a"] = (DebugOptionInput);

/***/ }),

/***/ "./src/blocks/DebugComponents/DebugBar/DebugOption/DebugOptionLabel.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var DebugOptionLabel=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].label.withConfig({displayName:'DebugOptionLabel',componentId:'sc-1cc6ye4-0'})(['cursor:pointer;font-family:',';font-weight:',';padding-right:',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.bold'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'));/* harmony default export */ __webpack_exports__["a"] = (DebugOptionLabel);

/***/ }),

/***/ "./src/blocks/DebugComponents/DebugBar/DebugOption/DebugOptionWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var DebugOptionWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'DebugOptionWrapper',componentId:'sc-1n8gly8-0'})(['height:100%;padding:',' 0 ',' ',';background-color:',';border-left:2px solid ',';flex-grow:1;'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('background'));/* harmony default export */ __webpack_exports__["a"] = (DebugOptionWrapper);

/***/ }),

/***/ "./src/blocks/DebugComponents/DebugBar/DebugOption/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DebugOptionWrapper__ = __webpack_require__("./src/blocks/DebugComponents/DebugBar/DebugOption/DebugOptionWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DebugOptionLabel__ = __webpack_require__("./src/blocks/DebugComponents/DebugBar/DebugOption/DebugOptionLabel.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DebugOptionInput__ = __webpack_require__("./src/blocks/DebugComponents/DebugBar/DebugOption/DebugOptionInput.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DebugOptionGroupLabel__ = __webpack_require__("./src/blocks/DebugComponents/DebugBar/DebugOption/DebugOptionGroupLabel.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}var DebugOption=(_class=function(_Component){_inherits(DebugOption,_Component);function DebugOption(){_classCallCheck(this,DebugOption);return _possibleConstructorReturn(this,(DebugOption.__proto__||Object.getPrototypeOf(DebugOption)).apply(this,arguments));}_createClass(DebugOption,[{key:'handleOptionChange',value:function handleOptionChange(event){var _props=this.props,optionName=_props.optionName,onValueChange=_props.onValueChange;onValueChange({name:optionName,value:event.target.value});}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,optionName=_props2.optionName,values=_props2.values,checked=_props2.checked;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DebugOptionWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DebugOptionGroupLabel__["a" /* default */],null,optionName+':'),values.map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DebugOptionLabel__["a" /* default */],{key:value},value,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DebugOptionInput__["a" /* default */],{type:'radio',checked:value===checked,onChange:_this2.handleOptionChange,value:value,name:optionName}));}));}}]);return DebugOption;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),(_applyDecoratedDescriptor(_class.prototype,'handleOptionChange',[__WEBPACK_IMPORTED_MODULE_2_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class.prototype,'handleOptionChange'),_class.prototype)),_class);DebugOption.propTypes={optionName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,values:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,onValueChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,checked:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};DebugOption.defaultProps={checked:''};/* harmony default export */ __webpack_exports__["a"] = (DebugOption);

/***/ }),

/***/ "./src/blocks/DebugComponents/DebugBar/DebugOptions.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var DebugOptions=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'DebugOptions',componentId:'sc-1wjbpld-0'})(['position:relative;display:flex;box-shadow:0 0 1px 0 rgba(0,0,0,.2);top:',';width:',';height:',';flex-wrap:wrap;align-items:center;transition:top 0.15s;'],function(_ref){var hidden=_ref.hidden;return hidden?'100vh':'0';},function(_ref2){var hidden=_ref2.hidden;return hidden?'0':'auto';},function(_ref3){var hidden=_ref3.hidden;return hidden?'0':'auto';});/* harmony default export */ __webpack_exports__["a"] = (DebugOptions);

/***/ }),

/***/ "./src/blocks/DebugComponents/DebugBar/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_window_or_global__ = __webpack_require__("./node_modules/window-or-global/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_DebugOptions_service__ = __webpack_require__("./src/services/DebugOptions.service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DebugBarWrapper__ = __webpack_require__("./src/blocks/DebugComponents/DebugBar/DebugBarWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DebugButton__ = __webpack_require__("./src/blocks/DebugComponents/DebugBar/DebugButton.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DebugOptions__ = __webpack_require__("./src/blocks/DebugComponents/DebugBar/DebugOptions.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DebugOption__ = __webpack_require__("./src/blocks/DebugComponents/DebugBar/DebugOption/index.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}/* eslint-disable react/no-array-index-key */var DebugBar=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"])(_class=(_class2=function(_Component){_inherits(DebugBar,_Component);function DebugBar(props){_classCallCheck(this,DebugBar);var _this=_possibleConstructorReturn(this,(DebugBar.__proto__||Object.getPrototypeOf(DebugBar)).call(this,props));_this.state={hidden:true};_this.debugOptionsRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(DebugBar,[{key:'onDebugButtonClick',value:function onDebugButtonClick(){var hidden=this.state.hidden;this.setState({hidden:!hidden});}},{key:'setDebugOption',value:function setDebugOption(option,forcePageReload){__WEBPACK_IMPORTED_MODULE_4_services_DebugOptions_service__["a" /* default */].setDebugOptionValueByName(option.name,option.value);this.forceUpdate();if(forcePageReload){__WEBPACK_IMPORTED_MODULE_3_window_or_global___default.a.location.reload();}}},{key:'render',value:function render(){var _this2=this;var hidden=this.state.hidden;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DebugBarWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DebugOptions__["a" /* default */],{innerRef:this.debugOptionsRef,hidden:hidden},__WEBPACK_IMPORTED_MODULE_4_services_DebugOptions_service__["a" /* default */].getDebugOptionsModel().map(function(option){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__DebugOption__["a" /* default */],{key:option.name,optionName:option.name,values:option.values,checked:__WEBPACK_IMPORTED_MODULE_4_services_DebugOptions_service__["a" /* default */].getOptionValueByName(option.name),onValueChange:function onValueChange(optionData){return _this2.setDebugOption(optionData,option.reloadOnChange);}});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DebugButton__["a" /* default */],{onClick:this.onDebugButtonClick},hidden?'Show debug':'Hide debug'));}}]);return DebugBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),(_applyDecoratedDescriptor(_class2.prototype,'onDebugButtonClick',[__WEBPACK_IMPORTED_MODULE_1_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'onDebugButtonClick'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'setDebugOption',[__WEBPACK_IMPORTED_MODULE_1_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'setDebugOption'),_class2.prototype)),_class2))||_class;/* harmony default export */ __webpack_exports__["a"] = (DebugBar);

/***/ }),

/***/ "./src/blocks/DebugComponents/DebugGridHelper/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_DebugOptions_service__ = __webpack_require__("./src/services/DebugOptions.service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_consts_debugOptionConsts__ = __webpack_require__("./src/common/consts/debugOptionConsts.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_decorators__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}/* eslint-disable react/no-array-index-key */var DebugGridHelper=Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["observer"])(_class=(_class2=function(_Component){_inherits(DebugGridHelper,_Component);function DebugGridHelper(){_classCallCheck(this,DebugGridHelper);return _possibleConstructorReturn(this,(DebugGridHelper.__proto__||Object.getPrototypeOf(DebugGridHelper)).apply(this,arguments));}_createClass(DebugGridHelper,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_3_services_DebugOptions_service__["a" /* default */].subscribe(this.onDebugOptionsChange);}},{key:'componentWillUnmount',value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_3_services_DebugOptions_service__["a" /* default */].unsubscribe(this.onDebugOptionsChange);}},{key:'onDebugOptionsChange',value:function onDebugOptionsChange(){this.forceUpdate();}},{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_services_DebugOptions_service__["a" /* default */].getOptionValueByName(__WEBPACK_IMPORTED_MODULE_4_common_consts_debugOptionConsts__["b" /* DEBUG_OPTION_GRID */])===__WEBPACK_IMPORTED_MODULE_4_common_consts_debugOptionConsts__["d" /* DEBUG_VALUE_GRID_OFF */]){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'fixed',top:0,left:0,pointerEvents:'none',width:'100vw',zIndex:9999}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_blocks_Container_Container__["a" /* default */],{debug:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_hedron__["Row"],{style:{height:'100vh'}},[].concat(_toConsumableArray(Array(12))).map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_hedron__["Column"],{key:index,xs:1});}))));}}]);return DebugGridHelper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),(_applyDecoratedDescriptor(_class2.prototype,'onDebugOptionsChange',[__WEBPACK_IMPORTED_MODULE_6_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'onDebugOptionsChange'),_class2.prototype)),_class2))||_class;/* harmony default export */ __webpack_exports__["a"] = (DebugGridHelper);

/***/ }),

/***/ "./src/blocks/DebugComponents/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_DebugOptions_service__ = __webpack_require__("./src/services/DebugOptions.service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DebugBar__ = __webpack_require__("./src/blocks/DebugComponents/DebugBar/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DebugGridHelper__ = __webpack_require__("./src/blocks/DebugComponents/DebugGridHelper/index.jsx");
var DebugComponents=function DebugComponents(){if(!__WEBPACK_IMPORTED_MODULE_1_services_DebugOptions_service__["a" /* default */].isDebug()){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DebugBar__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DebugGridHelper__["a" /* default */],null));};/* harmony default export */ __webpack_exports__["a"] = (DebugComponents);

/***/ }),

/***/ "./src/blocks/FiltersList/NativeValueListBox/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ValueListBoxWrapper */
/* unused harmony export ValueListBoxSelect */
/* unused harmony export ValueListBoxOption */
/* unused harmony export ValueListBoxDefaultOption */
/* unused harmony export ValueListBoxArrow */
/* unused harmony export ValueListBoxItemCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blocks_Arrow_Arrow__ = __webpack_require__("./src/blocks/Arrow/Arrow.js");
var _templateObject=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  pointer-events: none;\n  margin: ',' calc(',' / 6);\n  border: 1px solid ',';\n  border-left: none;\n  border-top: none;\n  width: calc(',' * 2/3);\n  height: calc(',' * 2/3);\n'],['\n  position: absolute;\n  top: 0;\n  right: 0;\n  pointer-events: none;\n  margin: ',' calc(',' / 6);\n  border: 1px solid ',';\n  border-left: none;\n  border-top: none;\n  width: calc(',' * 2/3);\n  height: calc(',' * 2/3);\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types *//* eslint-disable react/no-array-index-key */var ValueListBoxWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({displayName:'NativeValueListBox__ValueListBoxWrapper',componentId:'sc-9w5emt-0'})(['position:relative;max-width:',';font-size:',';font-family:',';font-weight:',';'],function(_ref){var maxWidth=_ref.maxWidth;return maxWidth||'100%';},__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["a" /* default */].fontSize('base'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["a" /* default */].get('type.fontWeight.bold'));var ValueListBoxSelect=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].select.withConfig({displayName:'NativeValueListBox__ValueListBoxSelect',componentId:'sc-9w5emt-1'})(['font-size:',';font-family:',';font-weight:',';width:100%;padding:calc(',' / 2) 0;border:none;background-color:',';border-bottom:2px solid ',';outline:none;appearance:none;&::-ms-expand{display:none;}'],__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["a" /* default */].fontSize('base'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["a" /* default */].get('type.fontWeight.bold'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["a" /* default */].brand('background'));var ValueListBoxOption=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].option.withConfig({displayName:'NativeValueListBox__ValueListBoxOption',componentId:'sc-9w5emt-2'})(['padding:calc(',' / 2);appearance:none;'],__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["a" /* default */].get('metrics.xs'));var ValueListBoxDefaultOption=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({displayName:'NativeValueListBox__ValueListBoxDefaultOption',componentId:'sc-9w5emt-3'})(['pointer-events:none;position:absolute;left:0;top:0;background-color:',';font-size:',';font-family:',';font-weight:',';width:100%;padding:calc(',' / 2) 0;'],__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["a" /* default */].fontSize('base'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["a" /* default */].get('type.fontWeight.bold'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["a" /* default */].get('metrics.xs'));var ValueListBoxArrow=__WEBPACK_IMPORTED_MODULE_3_blocks_Arrow_Arrow__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["a" /* default */].brand('product'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["a" /* default */].get('metrics.xs'));var ValueListBoxItemCount=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span.withConfig({displayName:'NativeValueListBox__ValueListBoxItemCount',componentId:'sc-9w5emt-4'})(['color:',';margin-left:calc(',' * 2/3);'],__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["a" /* default */].brand('product'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["a" /* default */].get('metrics.xs'));var NativeValueListBox=function NativeValueListBox(props){var categories=props.categories,activeFilter=props.activeFilter,maxWidth=props.maxWidth,onSelect=props.onSelect;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ValueListBoxWrapper,{maxWidth:maxWidth},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ValueListBoxDefaultOption,null,activeFilter.name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ValueListBoxItemCount,null,'('+activeFilter.count+')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ValueListBoxSelect,{onChange:function onChange(e){return onSelect(e.target.value);},value:activeFilter.value},categories.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ValueListBoxOption,{value:item.value,key:i},item.name,' ('+item.count+')');})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ValueListBoxArrow,null));};/* harmony default export */ __webpack_exports__["a"] = (NativeValueListBox);

/***/ }),

/***/ "./src/blocks/FiltersList/ValueListBox/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ValueListBoxWrapper */
/* unused harmony export ValueListBoxSelect */
/* unused harmony export ValueListBoxOptionsWrapper */
/* unused harmony export ValueListBoxOption */
/* unused harmony export ValueListBoxArrow */
/* unused harmony export ValueListBoxCloseIcon */
/* unused harmony export ValueListBoxItemCount */
/* unused harmony export ValueListBoxOptionFooter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ValueListBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_decorators_bind__ = __webpack_require__("./node_modules/lodash-decorators/bind.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_decorators_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_decorators_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_blocks_Arrow_Arrow__ = __webpack_require__("./src/blocks/Arrow/Arrow.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blocks_CloseIcon__ = __webpack_require__("./src/blocks/CloseIcon/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_animations_Animations__ = __webpack_require__("./src/animations/Animations.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2;var _templateObject=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  pointer-events: none;\n  margin: ',' calc(',' / 6);\n  border: 1px solid ',';\n  border-left: none;\n  border-top: none;\n  width: calc(',' * 2/3);\n  height: calc(',' * 2/3);\n  animation: ',' 0.1s linear;\n'],['\n  position: absolute;\n  top: 0;\n  right: 0;\n  pointer-events: none;\n  margin: ',' calc(',' / 6);\n  border: 1px solid ',';\n  border-left: none;\n  border-top: none;\n  width: calc(',' * 2/3);\n  height: calc(',' * 2/3);\n  animation: ',' 0.1s linear;\n']),_templateObject2=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 1px;\n  right: 0;\n  margin: ',' 0;\n  \n  &:before, &:after {\n    background-color: ',';\n    height: 16px;\n    width: 1px;\n    left: 26px;\n  }\n  animation: ',' 0.1s linear;\n'],['\n  position: absolute;\n  top: 1px;\n  right: 0;\n  margin: ',' 0;\n  \n  &:before, &:after {\n    background-color: ',';\n    height: 16px;\n    width: 1px;\n    left: 26px;\n  }\n  animation: ',' 0.1s linear;\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var ValueListBoxWrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div.withConfig({displayName:'ValueListBox__ValueListBoxWrapper',componentId:'sc-1uwn94p-0'})(['position:relative;max-width:',';font-size:',';font-family:',';font-weight:',';background-color:',';'],function(_ref){var maxWidth=_ref.maxWidth;return maxWidth||'100%';},__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].fontSize('base'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('type.fontWeight.bold'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('white'));var ValueListBoxSelect=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div.withConfig({displayName:'ValueListBox__ValueListBoxSelect',componentId:'sc-1uwn94p-1'})(['font-size:',';font-family:',';font-weight:',';width:100%;padding:calc(',' / 2) 0;border:none;background-color:',';border-bottom:1px solid ',';user-select:none;transition:0.2s;cursor:pointer;',''],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].fontSize('base'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('type.fontWeight.bold'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('background'),function(_ref2){var optionsVisible=_ref2.optionsVisible;return optionsVisible?'border-bottom: 1px solid transparent;':'';});var ValueListBoxOptionsWrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div.withConfig({displayName:'ValueListBox__ValueListBoxOptionsWrapper',componentId:'sc-1uwn94p-2'})(['',';background-color:',';position:absolute;width:100%;overflow-y:auto;border-radius:2px;transition-duration:0.2s;'],function(_ref3){var visible=_ref3.visible;return visible?'opacity: 1; height: auto':'opacity: 0; height: 0';},__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('white'));var ValueListBoxOption=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div.withConfig({displayName:'ValueListBox__ValueListBoxOption',componentId:'sc-1uwn94p-3'})(['position:relative;padding:calc(',' / 1.5) 0;font-weight:',';user-select:none;transition:0.2s;background-color:',';&:hover{background-color:',';}'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('type.fontWeight.bold'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('background'));var ValueListBoxArrow=__WEBPACK_IMPORTED_MODULE_4_blocks_Arrow_Arrow__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('product'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_7_animations_Animations__["b" /* KEY_FRAMES */].FADE_IN);var ValueListBoxCloseIcon=__WEBPACK_IMPORTED_MODULE_5_blocks_CloseIcon__["a" /* default */].extend(_templateObject2,__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('product'),__WEBPACK_IMPORTED_MODULE_7_animations_Animations__["b" /* KEY_FRAMES */].FADE_IN);var ValueListBoxItemCount=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span.withConfig({displayName:'ValueListBox__ValueListBoxItemCount',componentId:'sc-1uwn94p-4'})(['color:',';margin-left:calc(',' * 2/3);'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('product'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.xs'));var ValueListBoxOptionFooter=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].hr.withConfig({displayName:'ValueListBox__ValueListBoxOptionFooter',componentId:'sc-1uwn94p-5'})(['position:relative;margin:',' 0;border:none;border-bottom:1px solid ',';'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('background'));var ValueListBox=(_dec=Object(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["inject"])('windowStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["observer"])(_class=(_class2=function(_Component){_inherits(ValueListBox,_Component);function ValueListBox(props){_classCallCheck(this,ValueListBox);var _this=_possibleConstructorReturn(this,(ValueListBox.__proto__||Object.getPrototypeOf(ValueListBox)).call(this,props));var _this$props=_this.props,activeFilter=_this$props.activeFilter,categories=_this$props.categories;_this.state={value:activeFilter,options:categories,filteredOptions:categories.filter(function(option){return option.name!==activeFilter.name;}),dropDown:false};_this.valueListBoxRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(ValueListBox,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var windowStore=this.props.windowStore;this.disposeReaction=windowStore.onClickedAnywhere(function(event){var dropDown=_this2.state.dropDown;if(_this2.valueListBoxRef.current.contains(event.target)||dropDown){_this2.toggleMenu();}});}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.disposeReaction();}},{key:'setValue',value:function setValue(newValue){var options=this.state.options;var onSelect=this.props.onSelect;this.setState({value:newValue,filteredOptions:options.filter(function(option){return option!==newValue;})});onSelect(newValue.value);}},{key:'toggleMenu',value:function toggleMenu(){var dropDown=this.state.dropDown;this.setState({dropDown:!dropDown});}},{key:'render',value:function render(){var _this3=this;var maxWidth=this.props.maxWidth;var _state=this.state,value=_state.value,filteredOptions=_state.filteredOptions,dropDown=_state.dropDown;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ValueListBoxWrapper,{maxWidth:maxWidth,innerRef:this.valueListBoxRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ValueListBoxSelect,{optionsVisible:dropDown},value.name,value.count!=null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ValueListBoxItemCount,null,' ('+value.count+')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ValueListBoxOptionsWrapper,{visible:dropDown},filteredOptions.map(function(option,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ValueListBoxOption,{value:option.value,key:option.id||i,onClick:function onClick(){return _this3.setValue(option);}},option.name,option.count!=null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ValueListBoxItemCount,null,' ('+option.count+')'));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ValueListBoxOptionFooter,null)),dropDown?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ValueListBoxCloseIcon,null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ValueListBoxArrow,null));}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(newProps){var activeFilter=newProps.activeFilter,categories=newProps.categories;return{value:activeFilter,options:categories,filteredOptions:categories.filter(function(option){return option.name!==activeFilter.name;})};}}]);return ValueListBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),(_applyDecoratedDescriptor(_class2.prototype,'setValue',[__WEBPACK_IMPORTED_MODULE_1_lodash_decorators_bind___default.a],Object.getOwnPropertyDescriptor(_class2.prototype,'setValue'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'toggleMenu',[__WEBPACK_IMPORTED_MODULE_1_lodash_decorators_bind___default.a],Object.getOwnPropertyDescriptor(_class2.prototype,'toggleMenu'),_class2.prototype)),_class2))||_class)||_class);

/***/ }),

/***/ "./src/blocks/FiltersList/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FiltersList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValueListBox__ = __webpack_require__("./src/blocks/FiltersList/ValueListBox/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NativeValueListBox__ = __webpack_require__("./src/blocks/FiltersList/NativeValueListBox/index.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable react/prop-types */var FiltersList=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('windowStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(_class=function(_Component){_inherits(FiltersList,_Component);function FiltersList(){_classCallCheck(this,FiltersList);return _possibleConstructorReturn(this,(FiltersList.__proto__||Object.getPrototypeOf(FiltersList)).apply(this,arguments));}_createClass(FiltersList,[{key:'render',value:function render(){var windowStore=this.props.windowStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,windowStore.isOnMobile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__NativeValueListBox__["a" /* default */],this.props):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ValueListBox__["a" /* default */],this.props));}}]);return FiltersList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (FiltersList);

/***/ }),

/***/ "./src/blocks/FlexColumn/FlexColumn.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_hedron__);
/* Disable ESlint rule for this file *//* eslint react/destructuring-assignment: "off" */var FlexColumn=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_hedron__["Column"]).withConfig({displayName:'FlexColumn',componentId:'drr5ad-0'})(['display:flex;justify-content:',';align-items:',';'],function(props){return props.justify;},function(props){return props.align;});/* harmony default export */ __webpack_exports__["a"] = (FlexColumn);

/***/ }),

/***/ "./src/blocks/Footer/Header.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_elements_Header5__ = __webpack_require__("./src/elements/Header5.js");
var _templateObject=_taggedTemplateLiteral(['\n  color: ',';\n'],['\n  color: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Header=__WEBPACK_IMPORTED_MODULE_1_elements_Header5__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_0_designsystem__["a" /* default */].brand('white'));/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),

/***/ "./src/blocks/Footer/SocialLink.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_elements_Paragraph__ = __webpack_require__("./src/elements/Paragraph.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    color: ',';\n    display: flex;\n    align-items: center;\n  '],['\n    color: ',';\n    display: flex;\n    align-items: center;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SocialLink=function SocialLink(props){var image=props.image,children=props.children,custom=props.custom;var Social=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span.withConfig({displayName:'SocialLink__Social',componentId:'lyk1az-0'})(['display:inline-block;background-image:url(',');height:20px;width:20px;background-repeat:no-repeat;margin-right:10px;',''],image,custom);var ParagraphWhite=__WEBPACK_IMPORTED_MODULE_1_elements_Paragraph__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].brand('white'));SocialLink.propTypes={image:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,children:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,custom:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ParagraphWhite,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Social,null),children);};/* harmony default export */ __webpack_exports__["a"] = (SocialLink);

/***/ }),

/***/ "./src/blocks/Footer/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blocks_Background_Background__ = __webpack_require__("./src/blocks/Background/Background.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_consts_hrefs__ = __webpack_require__("./src/common/consts/hrefs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_elements_Paragraph__ = __webpack_require__("./src/elements/Paragraph.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_images_fb_svg__ = __webpack_require__("./src/common/images/fb.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_images_fb_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_common_images_fb_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_common_images_lin_svg__ = __webpack_require__("./src/common/images/lin.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_common_images_lin_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_common_images_lin_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_common_images_zoni_white_png__ = __webpack_require__("./src/common/images/zoni_white.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_common_images_zoni_white_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_common_images_zoni_white_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_common_images_EX_logo_svg__ = __webpack_require__("./src/common/images/EX_logo.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_common_images_EX_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_common_images_EX_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_common_consts_anchor__ = __webpack_require__("./src/common/consts/anchor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_common_consts_anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_common_consts_anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SocialLink__ = __webpack_require__("./src/blocks/Footer/SocialLink.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Header__ = __webpack_require__("./src/blocks/Footer/Header.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_blocks_StyledLink__ = __webpack_require__("./src/blocks/StyledLink/index.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _templateObject=_taggedTemplateLiteral(['\n  color: ',';\n  display: flex;\n  align-items: center;\n  ','\n'],['\n  color: ',';\n  display: flex;\n  align-items: center;\n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n  justify-content: flex-end;\n'],['\n  justify-content: flex-end;\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var ParagraphWhite=__WEBPACK_IMPORTED_MODULE_6_elements_Paragraph__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('white'),function(_ref){var marginZero=_ref.marginZero;return marginZero?'margin: 0;':'';});var ParagraphWhiteRight=ParagraphWhite.extend(_templateObject2);var ZoniWhite=__WEBPACK_IMPORTED_MODULE_12_styled_components__["default"].div.withConfig({displayName:'Footer__ZoniWhite',componentId:'yg7b1v-0'})(['display:inline-block;background-image:url(',');background-size:100%;height:29px;width:',';margin-bottom:50px;margin-top:',';'],__WEBPACK_IMPORTED_MODULE_9_common_images_zoni_white_png___default.a,__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.xxl'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.s'));var EXLogo=__WEBPACK_IMPORTED_MODULE_12_styled_components__["default"].span.withConfig({displayName:'Footer__EXLogo',componentId:'yg7b1v-1'})(['display:inline-block;background-image:url(',');background-repeat:no-repeat;height:16px;width:39px;margin-left:15px;'],__WEBPACK_IMPORTED_MODULE_10_common_images_EX_logo_svg___default.a);var borderTop={borderTop:'1px solid rgba(255, 255, 255, .3)'};var StyledLink=__WEBPACK_IMPORTED_MODULE_12_styled_components__["default"].a.withConfig({displayName:'Footer__StyledLink',componentId:'yg7b1v-2'})(['color:',';text-decoration:none;'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('white'));var StyledBackground=Object(__WEBPACK_IMPORTED_MODULE_12_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_blocks_Background_Background__["a" /* default */]).withConfig({displayName:'Footer__StyledBackground',componentId:'yg7b1v-3'})(['margin-top:',';'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.xxl'));var Footer=(_dec=Object(__WEBPACK_IMPORTED_MODULE_13_mobx_react__["inject"])('coreStore','appStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_13_mobx_react__["observer"])(_class=function(_Component){_inherits(Footer,_Component);function Footer(){_classCallCheck(this,Footer);return _possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).apply(this,arguments));}_createClass(Footer,[{key:'render',value:function render(){var currentLanguage=this.props.appStore.currentLanguage;var _props$coreStore=this.props.coreStore,_props$coreStore$tran=_props$coreStore.translations,FOOTER_ADDRESS_UPPER_LINE=_props$coreStore$tran.FOOTER_ADDRESS_UPPER_LINE,FOOTER_ADDRESS_BOTTOM_LINE=_props$coreStore$tran.FOOTER_ADDRESS_BOTTOM_LINE,FOOTER_SOCIAL_MEDIA=_props$coreStore$tran.FOOTER_SOCIAL_MEDIA,FOOTER_PRODUCTS=_props$coreStore$tran.FOOTER_PRODUCTS,FOOTER_ABOUT=_props$coreStore$tran.FOOTER_ABOUT,FOOTER_COMPANY=_props$coreStore$tran.FOOTER_COMPANY,FOOTER_PRIVACY_POLICY_LINK=_props$coreStore$tran.FOOTER_PRIVACY_POLICY_LINK,FOOTER_REGULATIONS_LINK=_props$coreStore$tran.FOOTER_REGULATIONS_LINK,_props$coreStore$cont=_props$coreStore.content,footerProducts=_props$coreStore$cont.footerProducts,footerBlogArticleLink=_props$coreStore$cont.footerBlogArticleLink,isLoaded=_props$coreStore.isLoaded;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledBackground,{color:__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('product')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_blocks_Container_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_hedron__["Row"],{divisions:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_hedron__["Column"],{sm:6,md:4,lg:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ZoniWhite,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ParagraphWhite,{marginZero:true,dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_14_common_methods_string__["g" /* safeHtmlWithBr */])(FOOTER_ADDRESS_UPPER_LINE)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ParagraphWhite,{marginZero:true,dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_14_common_methods_string__["g" /* safeHtmlWithBr */])(FOOTER_ADDRESS_BOTTOM_LINE)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ParagraphWhite,{marginZero:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledLink,{href:'mailto: hello@zonifero.com'},'hello@zonifero.com'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_hedron__["Column"],{sm:6,md:4,lg:2,lgShift:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Header__["a" /* default */],{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_14_common_methods_string__["g" /* safeHtmlWithBr */])(FOOTER_PRODUCTS)}}),isLoaded&&footerProducts.map(function(link){if(link.url){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledLink,{key:link.system.id,href:link.url},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ParagraphWhite,{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_14_common_methods_string__["g" /* safeHtmlWithBr */])(link.description)}}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_blocks_StyledLink__["b" /* default */],{key:link.system.id,to:link.slug},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ParagraphWhite,{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_14_common_methods_string__["g" /* safeHtmlWithBr */])(link.description)}}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_hedron__["Column"],{sm:6,md:4,lg:2,lgShift:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Header__["a" /* default */],{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_14_common_methods_string__["g" /* safeHtmlWithBr */])(FOOTER_ABOUT)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_blocks_StyledLink__["a" /* StyledBlogLink */],{to:__WEBPACK_IMPORTED_MODULE_11_common_consts_anchor___default.a.BLOG[currentLanguage]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ParagraphWhite,null,'Blog')),FOOTER_PRIVACY_POLICY_LINK&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledLink,{href:__WEBPACK_IMPORTED_MODULE_11_common_consts_anchor___default.a.PRIVACY_POLICY[currentLanguage],rel:'nofollow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ParagraphWhite,null,FOOTER_PRIVACY_POLICY_LINK)),FOOTER_REGULATIONS_LINK&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_blocks_StyledLink__["b" /* default */],{to:__WEBPACK_IMPORTED_MODULE_11_common_consts_anchor___default.a.REGULATIONS[currentLanguage]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ParagraphWhite,null,FOOTER_REGULATIONS_LINK)),isLoaded&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_blocks_StyledLink__["b" /* default */],{to:footerBlogArticleLink},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ParagraphWhite,{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_14_common_methods_string__["g" /* safeHtmlWithBr */])(FOOTER_COMPANY)}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_hedron__["Column"],{sm:6,md:4,lg:2,lgShift:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Header__["a" /* default */],{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_14_common_methods_string__["g" /* safeHtmlWithBr */])(FOOTER_SOCIAL_MEDIA)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledLink,{href:__WEBPACK_IMPORTED_MODULE_4_common_consts_hrefs__["a" /* default */].FACEBOOK,rel:'nofollow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__SocialLink__["a" /* default */],{custom:'background-position: 0 -1px;',image:__WEBPACK_IMPORTED_MODULE_7_common_images_fb_svg___default.a},'Facebook')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledLink,{href:__WEBPACK_IMPORTED_MODULE_4_common_consts_hrefs__["a" /* default */].LINKED_IN,rel:'nofollow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__SocialLink__["a" /* default */],{custom:'background-position: 0 -2px;',image:__WEBPACK_IMPORTED_MODULE_8_common_images_lin_svg___default.a},'LinkedIn')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_hedron__["Row"],{style:borderTop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_hedron__["Column"],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ParagraphWhiteRight,null,'Manufactured at',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledLink,{href:__WEBPACK_IMPORTED_MODULE_4_common_consts_hrefs__["a" /* default */].EXTRAHUT},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EXLogo,null)))))));}}]);return Footer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),

/***/ "./src/blocks/Form/CustomButton.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_elements_Button__ = __webpack_require__("./src/elements/Button.js");
var _templateObject=_taggedTemplateLiteral(['\n  margin-left: ',';\n  margin-right: ',';\n   ',';\n'],['\n  margin-left: ',';\n  margin-right: ',';\n   ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n      margin-left: ',';\n  '],['\n      margin-left: ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/destructuring-assignment */var CustomButton=__WEBPACK_IMPORTED_MODULE_1_elements_Button__["a" /* default */].extend(_templateObject,function(props){return props.centered?'auto':'inherit';},function(props){return props.centered?'auto':'inherit';},__WEBPACK_IMPORTED_MODULE_0_designsystem_index__["c" /* media */].desktop(_templateObject2,function(props){return props.centered?'auto':'inherit';}));/* harmony default export */ __webpack_exports__["a"] = (CustomButton);

/***/ }),

/***/ "./src/blocks/Form/CustomCheckbox.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_desc,_value,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}var CheckboxWrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div.withConfig({displayName:'CustomCheckbox__CheckboxWrapper',componentId:'sc-1e6g0vo-0'})(['margin-top:',';'],function(_ref){var marginTop=_ref.marginTop;return marginTop;});var StyledLabel=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].label.withConfig({displayName:'CustomCheckbox__StyledLabel',componentId:'sc-1e6g0vo-1'})(['display:flex;position:relative;cursor:pointer;']);var CheckboxInput=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].input.withConfig({displayName:'CustomCheckbox__CheckboxInput',componentId:'sc-1e6g0vo-2'})(['display:block;transform:scale(2);margin-right:',';position:absolute;z-index:-1;left:15px;top:10px;opacity:0;'],__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('metrics.value'));var Checkmark=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].span.withConfig({displayName:'CustomCheckbox__Checkmark',componentId:'sc-1e6g0vo-3'})(['position:absolute;top:0;left:0;height:25px;width:25px;&:before{content:\'\';position:absolute;display:block;bottom:0;height:2px;width:100%;background-image:radial-gradient(',' 2px,',' 2px);background-size:5px 10px;opacity:0.55;}&:after{content:\'\';position:absolute;display:',';left:9px;top:0;width:8px;height:17px;border:solid blue;border-width:0 1px 1px 0;transform:rotate(45deg);}'],__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].brand('white'),function(_ref2){var checked=_ref2.checked;return checked?'block':'none';});var CheckboxText=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].span.withConfig({displayName:'CustomCheckbox__CheckboxText',componentId:'sc-1e6g0vo-4'})(['display:block;font-family:',';color:',';font-size:',';font-weight:',';opacity:0.8;margin-left:40px;& > p{margin:0;& > a{color:',';text-decoration:none;&:hover{color:',';}}}'],__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].fs('s'),__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('type.fontWeight.light'),__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].brand('productHover'));var CustomCheckbox=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2_lodash_decorators__["Bind"])(),(_class=function(_Component){_inherits(CustomCheckbox,_Component);function CustomCheckbox(){var _ref3;var _temp,_this,_ret;_classCallCheck(this,CustomCheckbox);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref3=CustomCheckbox.__proto__||Object.getPrototypeOf(CustomCheckbox)).call.apply(_ref3,[this].concat(args))),_this),_this.state={checked:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CustomCheckbox,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var resetValue=this.props.resetValue;if(prevProps.resetValue!==resetValue){this.setState({checked:false});}}},{key:'handleInputChange',value:function handleInputChange(event){var target=event.target;var name=target.name;var getValue=this.props.getValue;this.setState({checked:target.checked});getValue({inputName:name,value:target.checked});}},{key:'render',value:function render(){var checked=this.state.checked;var _props=this.props,name=_props.name,checkboxText=_props.checkboxText,required=_props.required,marginTop=_props.marginTop;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CheckboxWrapper,{marginTop:marginTop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledLabel,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CheckboxInput,{type:'checkbox',required:required,name:name,checked:checked,onChange:this.handleInputChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Checkmark,{checked:checked}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CheckboxText,{dangerouslySetInnerHTML:{__html:checkboxText}})));}}]);return CustomCheckbox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),(_applyDecoratedDescriptor(_class.prototype,'handleInputChange',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'handleInputChange'),_class.prototype)),_class));/* harmony default export */ __webpack_exports__["a"] = (CustomCheckbox);CustomCheckbox.propTypes={name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,checkboxText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,getValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,required:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,resetValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,marginTop:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};CustomCheckbox.defaultProps={required:false,resetValue:false,getValue:function getValue(){},marginTop:'0'};

/***/ }),

/***/ "./src/blocks/Form/CustomField.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var CustomField=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'CustomField',componentId:'sc-9nrl1r-0'})(['display:flex;flex-flow:column-reverse;position:relative;width:100%;margin:',' 0 1em 0;'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'));/* harmony default export */ __webpack_exports__["a"] = (CustomField);

/***/ }),

/***/ "./src/blocks/Form/CustomForm.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var CustomForm=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].form.withConfig({displayName:'CustomForm',componentId:'x84td6-0'})(['display:flex;flex-flow:row wrap;justify-content:space-between;width:100%;background:white;']);/* harmony default export */ __webpack_exports__["a"] = (CustomForm);

/***/ }),

/***/ "./src/blocks/Form/CustomFormElement.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_consts_form__ = __webpack_require__("./src/common/consts/form.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OkIcon__ = __webpack_require__("./src/blocks/Form/OkIcon.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NotIcon__ = __webpack_require__("./src/blocks/Form/NotIcon.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CustomField__ = __webpack_require__("./src/blocks/Form/CustomField.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CustomInput__ = __webpack_require__("./src/blocks/Form/CustomInput.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CustomLabel__ = __webpack_require__("./src/blocks/Form/CustomLabel.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UnderlineDots__ = __webpack_require__("./src/blocks/Form/UnderlineDots.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RequiredIndicator__ = __webpack_require__("./src/blocks/Form/RequiredIndicator.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CustomTextArea__ = __webpack_require__("./src/blocks/Form/CustomTextArea.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}/* eslint-disable react/no-did-update-set-state */var CustomFormElement=(_class=function(_Component){_inherits(CustomFormElement,_Component);function CustomFormElement(props){_classCallCheck(this,CustomFormElement);var _this=_possibleConstructorReturn(this,(CustomFormElement.__proto__||Object.getPrototypeOf(CustomFormElement)).call(this,props));_this.validateOnInput=props.validateOnInput;_this.state={pristine:true,correct:true,touched:false,empty:true,value:'',textAreaRows:1};_this.inputRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.customFieldRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.underlineDotsRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(CustomFormElement,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var resetValue=this.props.resetValue;if(prevProps.resetValue!==resetValue){this.setState({pristine:true,correct:true,touched:false,empty:true,value:''});}}},{key:'onInput',value:function onInput(inputEvent){var onInput=this.props.onInput;this.setState({pristine:false,empty:inputEvent.target.value===''});if(this.validateOnInput){this.setValidationState();}this.setState({value:inputEvent.target.value});onInput(inputEvent.target.value);}},{key:'onBlur',value:function onBlur(blurEvent){var target=blurEvent.target;var value=target.value;this.setState({touched:true});if(!this.validateOnInput){this.setValidationState();}var _props=this.props,name=_props.name,getValue=_props.getValue;getValue({inputName:name,value:value});}},{key:'setValidationState',value:function setValidationState(){this.setState({correct:this.inputRef.current.checkValidity()});}},{key:'autoSize',value:function autoSize(){var _this2=this;var el=this.inputRef.current;setTimeout(function(){el.style.cssText='height: auto; padding: 0';el.style.cssText='height:'+el.scrollHeight+'px';_this2.setState({textAreaRows:Math.floor(el.scrollHeight/__WEBPACK_IMPORTED_MODULE_3_common_consts_form__["a" /* default */].DESKTOP_TEXT_AREA_LINE_HEIGHT)});},0);}},{key:'generateUnderlineDots',value:function generateUnderlineDots(){var _this3=this;var textAreaRows=this.state.textAreaRows;return[].concat(_toConsumableArray(Array(textAreaRows).keys())).map(function(rowNumber){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__UnderlineDots__["a" /* default */],{key:rowNumber,innerRef:_this3.underlineDotsRef,offset:rowNumber!==0?rowNumber*__WEBPACK_IMPORTED_MODULE_3_common_consts_form__["a" /* default */].DESKTOP_TEXT_AREA_LINE_HEIGHT:null});});}},{key:'render',value:function render(){var _state=this.state,pristine=_state.pristine,touched=_state.touched,correct=_state.correct,empty=_state.empty,value=_state.value;var _props2=this.props,type=_props2.type,name=_props2.name,labelName=_props2.labelName,required=_props2.required,minlength=_props2.minlength,maxlength=_props2.maxlength,pattern=_props2.pattern,title=_props2.title;var doValidate=!pristine&&this.validateOnInput||touched&&!this.validateOnInput;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CustomField__["a" /* default */],{innerRef:this.customFieldRef},type==='textarea'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__CustomTextArea__["a" /* default */],{innerRef:this.inputRef,type:type,name:name,required:required,minlength:minlength,maxlength:maxlength,pattern:pattern,title:title,onChange:this.onInput,onBlur:this.onBlur,isEmpty:empty,value:value,onKeyDown:this.autoSize}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CustomInput__["a" /* default */],{innerRef:this.inputRef,type:type,name:name,required:required,minlength:minlength,maxlength:maxlength,pattern:pattern,title:title,onChange:this.onInput,onBlur:this.onBlur,isEmpty:empty,value:value}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CustomLabel__["a" /* default */],{htmlFor:name},labelName,required?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__RequiredIndicator__["a" /* default */],null):''),type==='textarea'?this.generateUnderlineDots():__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__UnderlineDots__["a" /* default */],{innerRef:this.underlineDotsRef}),doValidate&&(correct?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__OkIcon__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__NotIcon__["a" /* default */],null)));}}]);return CustomFormElement;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),(_applyDecoratedDescriptor(_class.prototype,'onInput',[__WEBPACK_IMPORTED_MODULE_2_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class.prototype,'onInput'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onBlur',[__WEBPACK_IMPORTED_MODULE_2_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class.prototype,'onBlur'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setValidationState',[__WEBPACK_IMPORTED_MODULE_2_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class.prototype,'setValidationState'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'autoSize',[__WEBPACK_IMPORTED_MODULE_2_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class.prototype,'autoSize'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'generateUnderlineDots',[__WEBPACK_IMPORTED_MODULE_2_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class.prototype,'generateUnderlineDots'),_class.prototype)),_class);CustomFormElement.propTypes={name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,labelName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,required:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,validateOnInput:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,minlength:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,maxlength:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,pattern:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,getValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,resetValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onInput:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};CustomFormElement.defaultProps={type:'',labelName:'',required:false,validateOnInput:false,minlength:null,maxlength:null,pattern:null,title:null,resetValue:false,onInput:function onInput(){}};/* harmony default export */ __webpack_exports__["a"] = (CustomFormElement);

/***/ }),

/***/ "./src/blocks/Form/CustomInput.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* eslint-disable react/destructuring-assignment */var CustomInput=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].input.withConfig({displayName:'CustomInput',componentId:'sc-18vb99y-0'})(['font-size:',';color:',';font-family:',';font-weight:',';z-index:2;transition:all 0.3s;touch-action:manipulation;background:transparent;border:0;position:relative;&:focus{outline:0;}&:focus::-webkit-input-placeholder{opacity:0;}& + label{',';',';',';',';}&:after{content:\'\';width:100%;height:',';top:0;left:0;background:red;position:absolute;}'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('l'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.regular'),function(props){return!props.isEmpty?'top: -30px':'';},function(props){return!props.isEmpty?'font-size: '+__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('s'):'';},function(props){return!props.isEmpty?'font-weight: '+__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.light'):'';},function(props){return!props.isEmpty?'opacity: 0.8':'';},__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'));/* harmony default export */ __webpack_exports__["a"] = (CustomInput);

/***/ }),

/***/ "./src/blocks/Form/CustomLabel.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var CustomLabel=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].label.withConfig({displayName:'CustomLabel',componentId:'zgzpm5-0'})(['font-size:',';color:',';font-family:',';font-weight:',';transition:all 0.2s;touch-action:manipulation;position:absolute;top:1px;left:0;opacity:0.65;'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('l'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.regular'));/* harmony default export */ __webpack_exports__["a"] = (CustomLabel);

/***/ }),

/***/ "./src/blocks/Form/CustomTextArea.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_consts_form__ = __webpack_require__("./src/common/consts/form.js");
/* eslint-disable react/destructuring-assignment */var CustomTextArea=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].textarea.withConfig({displayName:'CustomTextArea',componentId:'zu0pvr-0'})(['font-size:',';color:',';font-family:',';font-weight:',';z-index:2;transition:all 0.3s;touch-action:manipulation;background:transparent;border:0;position:relative;resize:none;height:','px;line-height:','px;overflow:hidden;&:focus{outline:0;}&:focus::-webkit-input-placeholder{opacity:0;}& + label{',';',';',';',';}&:after{content:\'\';width:100%;height:',';top:0;left:0;background:red;position:absolute;}'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('l'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.regular'),__WEBPACK_IMPORTED_MODULE_2_common_consts_form__["a" /* default */].DESKTOP_TEXT_AREA_LINE_HEIGHT,__WEBPACK_IMPORTED_MODULE_2_common_consts_form__["a" /* default */].DESKTOP_TEXT_AREA_LINE_HEIGHT,function(props){return!props.isEmpty?'top: -30px':'';},function(props){return!props.isEmpty?'font-size: '+__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('s'):'';},function(props){return!props.isEmpty?'font-weight: '+__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.light'):'';},function(props){return!props.isEmpty?'opacity: 0.8':'';},__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'));/* harmony default export */ __webpack_exports__["a"] = (CustomTextArea);

/***/ }),

/***/ "./src/blocks/Form/NotIcon.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var NotIcon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].svg.withConfig({displayName:'NotIcon',componentId:'sc-12du8ms-0'})(['width:',';height:',';position:absolute;bottom:0;right:0;transform:scaleX(1.1) translateY(-50%);stroke:red;fill:none;z-index:10;'],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.s'));var CustomNotIcon=function CustomNotIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NotIcon,{viewBox:'0 0 20 20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline',{points:'2,2 18,18'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline',{points:'2,18 18,2'}));};/* harmony default export */ __webpack_exports__["a"] = (CustomNotIcon);

/***/ }),

/***/ "./src/blocks/Form/OkIcon.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var OkIcon=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].svg.withConfig({displayName:'OkIcon',componentId:'sc-150c3l-0'})(['width:',';height:',';position:absolute;bottom:0;right:0;transform:scaleX(1.1) translateY(-50%);stroke:',';scaleX:1.5;fill:none;z-index:10;'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('product'));var CustomOkIcon=function CustomOkIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OkIcon,{viewBox:'0 0 20 20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline',{points:'1,12 7,18 18,5'}));};/* harmony default export */ __webpack_exports__["a"] = (CustomOkIcon);

/***/ }),

/***/ "./src/blocks/Form/RequiredIndicator.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var RequiredIndicator=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({displayName:'RequiredIndicator',componentId:'vbpz5b-0'})(['&:after{display:inline-block;margin-left:3px;color:',';content:\'*\';}'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('product'));/* harmony default export */ __webpack_exports__["a"] = (RequiredIndicator);

/***/ }),

/***/ "./src/blocks/Form/SubmitButton.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_consts_form__ = __webpack_require__("./src/common/consts/form.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CustomButton__ = __webpack_require__("./src/blocks/Form/CustomButton.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_dec2,_class,_desc,_value,_class2,_descriptor;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}/* eslint-disable react/prop-types */var isDisabled=function isDisabled(buttonState){return!!buttonState;};var SubmitButton=(_dec=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["inject"])('coreStore'),_dec2=Object(__WEBPACK_IMPORTED_MODULE_4_lodash_decorators__["Bind"])(),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"])(_class=(_class2=function(_Component){_inherits(SubmitButton,_Component);function SubmitButton(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SubmitButton);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SubmitButton.__proto__||Object.getPrototypeOf(SubmitButton)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'getButtonMessage',_descriptor,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SubmitButton,[{key:'render',value:function render(){var _props=this.props,centered=_props.centered,buttonState=_props.buttonState;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CustomButton__["a" /* default */],{centered:centered,disabled:isDisabled(buttonState),type:'submit'},this.getButtonMessage(buttonState));}}]);return SubmitButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'getButtonMessage',[_dec2],{enumerable:true,initializer:function initializer(){var _this2=this;return function(buttonState){var translations=_this2.props.coreStore.translations;switch(buttonState){case __WEBPACK_IMPORTED_MODULE_2_common_consts_form__["a" /* default */].BUTTON_STATE.SUCCESS:return translations.FORM_BUTTON_SUCCESS_MESSAGE;case __WEBPACK_IMPORTED_MODULE_2_common_consts_form__["a" /* default */].BUTTON_STATE.ERROR:return translations.FORM_BUTTON_ERROR_MESSAGE;case __WEBPACK_IMPORTED_MODULE_2_common_consts_form__["a" /* default */].BUTTON_STATE.LOADING:return translations.FORM_BUTTON_LOADING_MESSAGE;default:return translations.FORM_BUTTON_DEFAULT_MESSAGE;}};}})),_class2))||_class)||_class);SubmitButton.propTypes={centered:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,buttonState:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};SubmitButton.defaultProps={centered:false,buttonState:''};/* harmony default export */ __webpack_exports__["a"] = (SubmitButton);

/***/ }),

/***/ "./src/blocks/Form/UnderlineDots.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var UnderlineDots=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'UnderlineDots',componentId:'u4b801-0'})(['width:100%;position:absolute;height:2px;bottom:-3px;left:0;background-image:radial-gradient(',' 2px,',' 2px);background-size:5px 10px;opacity:0.55;z-index:10;',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white'),function(_ref){var offset=_ref.offset;return offset?'top: '+offset+'px;':'';});/* harmony default export */ __webpack_exports__["a"] = (UnderlineDots);

/***/ }),

/***/ "./src/blocks/HTMLModifableBackground/HTMLModifiableBackground.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* Disable ESlint rule for this file *//* eslint react/destructuring-assignment: "off" */var HTMLModifiableBackground=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'HTMLModifiableBackground',componentId:'sc-1g44izf-0'})(['width:100%;position:relative;background-color:',';overflow:',';',''],function(_ref){var color=_ref.color;return color||__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white');},function(_ref2){var overflow=_ref2.overflow;return overflow||'hidden';},function(_ref3){var htmlModifiers=_ref3.htmlModifiers;if(htmlModifiers){var css='';htmlModifiers.forEach(function(htmlModifier){css+=htmlModifier.property+':'+htmlModifier.value+';';});return css;}return'';});/* harmony default export */ __webpack_exports__["a"] = (HTMLModifiableBackground);

/***/ }),

/***/ "./src/blocks/ImgModal/ImgModal.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImgModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable react/prop-types */var ImgModalBox=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({displayName:'ImgModal__ImgModalBox',componentId:'l1tiqo-0'})(['width:100%;height:100%;background-color:rgba(0,0,0,0.7);;position:fixed;z-index:1000;display:flex;align-items:center;justify-content:center;top:0;left:0;']);var CloseIcon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].a.withConfig({displayName:'ImgModal__CloseIcon',componentId:'l1tiqo-1'})(['display:block;position:absolute;width:25px;height:25px;top:15px;right:15px;cursor:pointer;&:before,&:after{display:block;content:\'\';position:absolute;right:12px;height:25px;width:2px;background-color:',';};&:before{transform:rotate(45deg);};&:after{transform:rotate(-45deg);}'],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('background'));var ImageWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].img.withConfig({displayName:'ImgModal__ImageWrapper',componentId:'l1tiqo-2'})(['display:block;max-width:100%;max-height:100%;cursor:pointer;']);var ImgModal=function(_Component){_inherits(ImgModal,_Component);function ImgModal(props){_classCallCheck(this,ImgModal);var _this=_possibleConstructorReturn(this,(ImgModal.__proto__||Object.getPrototypeOf(ImgModal)).call(this,props));_this.closeModal=function(){_this.props.closeModal();};return _this;}_createClass(ImgModal,[{key:'render',value:function render(){var _props=this.props,image=_props.image,alt=_props.alt;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImgModalBox,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImageWrapper,{className:'Image',src:image,alt:alt,onClick:this.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseIcon,{onClick:this.closeModal}));}}]);return ImgModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),

/***/ "./src/blocks/InjectMetaTags/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stores_App_store__ = __webpack_require__("./src/stores/App.store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stores_GlobalMetaTags_store__ = __webpack_require__("./src/stores/GlobalMetaTags.store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_flowRight__ = __webpack_require__("./node_modules/lodash/flowRight.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_Language_service__ = __webpack_require__("./src/services/Language.service.js");
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var InjectMetaTags=function InjectMetaTags(props){var title=props.title,description=props.description,ogImage=props.ogImage,ogType=props.ogType,metaKeywords=props.metaKeywords,noIndex=props.noIndex,pathname=props.pathname,currentLanguage=props.appStore.currentLanguage,metaTags=props.globalMetaTagsStore.metaTags;var _document$location=document.location,origin=_document$location.origin,pathnameLocation=_document$location.pathname;var createHrefLangs=function createHrefLangs(currentAnchorObject){if(!currentAnchorObject){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('link',{key:currentLanguage,rel:'alternate',hrefLang:currentLanguage,href:''+origin+pathnameLocation})];}return Object.keys(currentAnchorObject).map(function(language){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('link',{key:language,rel:'alternate',hrefLang:language,href:origin+'/'+language+currentAnchorObject[language]});});};var renderHreflangs=function renderHreflangs(){var params=__WEBPACK_IMPORTED_MODULE_7__services_Language_service__["a" /* default */].getParamsFromPathname(pathname);var currentAnchorObject=__WEBPACK_IMPORTED_MODULE_7__services_Language_service__["a" /* default */].getAnchorFromPathname('/'+params.slug);var currentDefaultPath=currentAnchorObject&&currentAnchorObject.en;var defaultHreflang=currentDefaultPath&&''+document.location.origin+currentDefaultPath;return[].concat(_toConsumableArray(createHrefLangs(currentAnchorObject)),[defaultHreflang&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('link',{key:'default',rel:'alternate',hrefLang:'x-default',href:defaultHreflang})]);};var renderGlobalMetaTags=function renderGlobalMetaTags(){return metaTags?metaTags.metaTags.map(function(_ref){var system=_ref.system,name=_ref.name,content=_ref.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{key:system.id,name:name,content:content});}):null;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_helmet__["Helmet"],{defaultTitle:'Zonifero',titleTemplate:'%s - Zonifero'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('html',{lang:currentLanguage}),title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,title),description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'description',content:description}),noIndex&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'robots',content:noIndex}),title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{property:'og:title',content:title}),ogType&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{property:'og:type',content:ogType}),ogImage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{property:'og:image',content:ogImage}),metaKeywords&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{property:'keywords',content:metaKeywords}),description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{property:'og:description',content:description}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'twitter:card',content:'summary'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('link',{rel:'canonical',href:''+origin+pathnameLocation}),renderHreflangs(),renderGlobalMetaTags());};InjectMetaTags.propTypes={title:__WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].string,description:__WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].string,ogImage:__WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].string,ogType:__WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].string,metaKeywords:__WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].string,noIndex:__WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].string,pathname:__WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].string,appStore:__WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].instanceOf(__WEBPACK_IMPORTED_MODULE_3_stores_App_store__["a" /* AppStore */]).isRequired,globalMetaTagsStore:__WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].instanceOf(__WEBPACK_IMPORTED_MODULE_4_stores_GlobalMetaTags_store__["a" /* default */]).isRequired};InjectMetaTags.defaultProps={title:'',description:'',ogImage:'',ogType:'',metaKeywords:'',noIndex:'',pathname:''};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6_lodash_flowRight___default()(Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["inject"])('appStore','globalMetaTagsStore'),__WEBPACK_IMPORTED_MODULE_5_mobx_react__["observer"])(InjectMetaTags));

/***/ }),

/***/ "./src/blocks/Layout/LayoutWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayoutWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable react/prop-types */var Wrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div.withConfig({displayName:'LayoutWrapper__Wrapper',componentId:'sc-1gdndh4-0'})(['min-height:100vh;display:flex;flex-direction:column;justify-content:space-between;']);var LayoutWrapper=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(_class=function(_Component){_inherits(LayoutWrapper,_Component);function LayoutWrapper(){_classCallCheck(this,LayoutWrapper);return _possibleConstructorReturn(this,(LayoutWrapper.__proto__||Object.getPrototypeOf(LayoutWrapper)).apply(this,arguments));}_createClass(LayoutWrapper,[{key:'render',value:function render(){var children=this.props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,null,children);}}]);return LayoutWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;

/***/ }),

/***/ "./src/blocks/Layout/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blocks_Footer__ = __webpack_require__("./src/blocks/Footer/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blocks_DebugComponents__ = __webpack_require__("./src/blocks/DebugComponents/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_blocks_NavigationAwarePageContent__ = __webpack_require__("./src/blocks/NavigationAwarePageContent/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blocks_CookiesModal_CookiesModal__ = __webpack_require__("./src/blocks/CookiesModal/CookiesModal.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_Core_store__ = __webpack_require__("./src/stores/Core.store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LayoutWrapper__ = __webpack_require__("./src/blocks/Layout/LayoutWrapper.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable react/prop-types */var Layout=function(_Component){_inherits(Layout,_Component);function Layout(props){_classCallCheck(this,Layout);var _this=_possibleConstructorReturn(this,(Layout.__proto__||Object.getPrototypeOf(Layout)).call(this,props));_this.coreStore=new __WEBPACK_IMPORTED_MODULE_6_stores_Core_store__["a" /* default */]();return _this;}_createClass(Layout,[{key:'render',value:function render(){var children=this.props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["Provider"],{navigationStore:this.coreStore.navigationStore,windowStore:this.coreStore.windowStore,productsStore:this.coreStore.productsStore,calculatorStore:this.coreStore.calculatorStore,blogStore:this.coreStore.blogStore,forInvestorsStore:this.coreStore.forInvestorsStore,globalMetaTagsStore:this.coreStore.globalMetaTagsStore,coreStore:this.coreStore},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__LayoutWrapper__["a" /* default */],null,children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_blocks_NavigationAwarePageContent__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_blocks_Footer__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_blocks_CookiesModal_CookiesModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_blocks_DebugComponents__["a" /* default */],null)));}}]);return Layout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Layout);

/***/ }),

/***/ "./src/blocks/Navigation/Buttons/ButtonsSection.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    position: fixed;\n    top:0;\n    bottom:initial;\n    width: auto;\n  '],['\n    position: fixed;\n    top:0;\n    bottom:initial;\n    width: auto;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ButtonsSection=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'ButtonsSection',componentId:'sc-1xl577e-0'})(['display:inline-flex;position:relative;align-items:right;top:0;right:0;z-index:1000;width:100%;',''],__WEBPACK_IMPORTED_MODULE_1_designsystem_index__["c" /* media */].desktop(_templateObject));/* harmony default export */ __webpack_exports__["a"] = (ButtonsSection);

/***/ }),

/***/ "./src/blocks/Navigation/Buttons/TagAGetTheApp.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_LanguageLink__ = __webpack_require__("./src/elements/LanguageLink.jsx");
var _templateObject=_taggedTemplateLiteral(['\n    height: ',';\n  '],['\n    height: ',';\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    width: 200px;'],['\n    width: 200px;']);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var TagContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'TagAGetTheApp__TagContainer',componentId:'sc-1gbunqe-0'})(['position:relative;width:50%;height:',';display:inline-block;',' ',''],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_3_designsystem_index__["c" /* media */].tablet(_templateObject,__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('navSection.navHeight')),__WEBPACK_IMPORTED_MODULE_3_designsystem_index__["c" /* media */].desktop(_templateObject2));var TagContainerLink=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_4__elements_LanguageLink__["a" /* default */]).withConfig({displayName:'TagAGetTheApp__TagContainerLink',componentId:'sc-1gbunqe-1'})(['position:relative;width:50%;height:',';display:inline-block;text-decoration:none;',' ',''],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_3_designsystem_index__["c" /* media */].tablet(_templateObject,__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('navSection.navHeight')),__WEBPACK_IMPORTED_MODULE_3_designsystem_index__["c" /* media */].desktop(_templateObject2));var TagFlexContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].a.withConfig({displayName:'TagAGetTheApp__TagFlexContainer',componentId:'sc-1gbunqe-2'})(['width:100%;height:100%;display:flex;align-items:center;justify-content:center;text-decoration:none;color:',';cursor:pointer;font-size:',';font-family:',';font-weight:',';background-color:',';'],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('colors.brand.white'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('base'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontWeight.light'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('colors.brand.product'));var renderContent=function renderContent(children){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TagFlexContainer,null,children);};var TagAGetTheApp=function TagAGetTheApp(_ref){var to=_ref.to,onClick=_ref.onClick,children=_ref.children,reset=_objectWithoutProperties(_ref,['to','onClick','children']);return to?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TagContainerLink,Object.assign({to:to,onClick:onClick},reset),renderContent(children)):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TagContainer,Object.assign({onClick:onClick},reset),renderContent(children));};/* harmony default export */ __webpack_exports__["a"] = (TagAGetTheApp);

/***/ }),

/***/ "./src/blocks/Navigation/Buttons/TagASignIn.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n      height: ',';\n    '],['\n      height: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n      width: initial;\n      justify-content: center;\n      height: ',';\n    '],['\n      width: initial;\n      justify-content: center;\n      height: ',';\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        padding: ',';\n    '],['\n        padding: ',';\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var TagContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].a.withConfig({displayName:'TagASignIn__TagContainer',componentId:'sc-1dommab-0'})(['font-size:',';font-family:',';font-weight:',';background-color:',';color:',';border:none;cursor:pointer;display:flex;align-items:center;text-decoration:none;white-space:nowrap;width:50%;justify-content:center;height:',';',' ',''],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('base'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontWeight.bold'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('colors.brand.white'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('colors.brand.text'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_4_designsystem_index__["c" /* media */].tablet(_templateObject,__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('navSection.navHeight')),__WEBPACK_IMPORTED_MODULE_4_designsystem_index__["c" /* media */].desktop(_templateObject2,__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('navSection.navHeight')));var Tag=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'TagASignIn__Tag',componentId:'sc-1dommab-1'})(['margin:0;',''],__WEBPACK_IMPORTED_MODULE_4_designsystem_index__["c" /* media */].desktop(_templateObject3,__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.s')));var TagASignIn=function TagASignIn(props){var href=props.href,text=props.text;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TagContainer,{href:href},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tag,null,text));};TagASignIn.propTypes={href:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,text:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};TagASignIn.defaultProps={href:'',text:''};/* harmony default export */ __webpack_exports__["a"] = (TagASignIn);

/***/ }),

/***/ "./src/blocks/Navigation/Buttons/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_window_or_global__ = __webpack_require__("./node_modules/window-or-global/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_consts_hrefs__ = __webpack_require__("./src/common/consts/hrefs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_consts_navigation__ = __webpack_require__("./src/common/consts/navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_consts_anchor__ = __webpack_require__("./src/common/consts/anchor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_consts_anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_common_consts_anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ButtonsSection__ = __webpack_require__("./src/blocks/Navigation/Buttons/ButtonsSection.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TagASignIn__ = __webpack_require__("./src/blocks/Navigation/Buttons/TagASignIn.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TagAGetTheApp__ = __webpack_require__("./src/blocks/Navigation/Buttons/TagAGetTheApp.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}/* eslint-disable react/prop-types *//* eslint-disable class-methods-use-this */var Buttons=(_dec=Object(__WEBPACK_IMPORTED_MODULE_7_mobx_react__["inject"])('windowStore','coreStore','productsStore','navigationStore','appStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_7_mobx_react__["observer"])(_class=(_class2=function(_Component){_inherits(Buttons,_Component);function Buttons(props){_classCallCheck(this,Buttons);var _this=_possibleConstructorReturn(this,(Buttons.__proto__||Object.getPrototypeOf(Buttons)).call(this,props));_this.buttonsSectionRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(Buttons,[{key:'componentDidMount',value:function componentDidMount(){this.setButtonsSectionWidth();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.setButtonsSectionWidth();}},{key:'setButtonsSectionWidth',value:function setButtonsSectionWidth(){var navigationStore=this.props.navigationStore;if(this.buttonsSectionRef&&this.buttonsSectionRef.current){var buttonsSectionWidth=this.buttonsSectionRef.current.getBoundingClientRect().width;navigationStore.setButtonsSectionWidth(buttonsSectionWidth);}}},{key:'scrollToForm',value:function scrollToForm(formRef){var isOnMobile=this.props.windowStore.isOnMobile;if(isOnMobile){setTimeout(function(){return formRef.scrollIntoView({block:'start'});},1000);}else{var offsetTop=formRef.getBoundingClientRect().top+__WEBPACK_IMPORTED_MODULE_2_window_or_global___default.a.scrollY;__WEBPACK_IMPORTED_MODULE_2_window_or_global___default.a.scroll({top:offsetTop-__WEBPACK_IMPORTED_MODULE_4_common_consts_navigation__["d" /* NAV_HEIGHT */],behavior:'smooth'});}}},{key:'render',value:function render(){var _props=this.props,onItemClick=_props.onItemClick,isOnTablet=_props.windowStore.isOnTablet,translations=_props.coreStore.translations,currentLanguage=_props.appStore.currentLanguage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ButtonsSection__["a" /* default */],{innerRef:this.buttonsSectionRef,onClick:function onClick(){return onItemClick();}},isOnTablet&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TagASignIn__["a" /* default */],{text:translations.NAVIGATION_SIGN_IN,href:__WEBPACK_IMPORTED_MODULE_3_common_consts_hrefs__["a" /* default */].SIGN_IN}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__TagAGetTheApp__["a" /* default */],{to:__WEBPACK_IMPORTED_MODULE_5_common_consts_anchor___default.a.CONTACT_FORM[currentLanguage]},translations.NAVIGATION_GET_THE_APP));}}]);return Buttons;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),(_applyDecoratedDescriptor(_class2.prototype,'setButtonsSectionWidth',[__WEBPACK_IMPORTED_MODULE_8_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'setButtonsSectionWidth'),_class2.prototype)),_class2))||_class)||_class);Buttons.propTypes={onItemClick:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func};Buttons.defaultProps={onItemClick:function onItemClick(){}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["withRouter"])(Buttons));

/***/ }),

/***/ "./src/blocks/Navigation/DesktopNavigation/DesktopMenuItem.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DesktopNavButton__ = __webpack_require__("./src/blocks/Navigation/DesktopNavigation/DesktopNavButton.jsx");
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/* eslint-disable react/forbid-prop-types */var DesktopMenuItem=function DesktopMenuItem(props){var targetInfo=props.targetInfo,reset=_objectWithoutProperties(props,['targetInfo']);var active=null;if(targetInfo.active){active=true;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DesktopNavButton__["a" /* default */],Object.assign({active:active},reset));};DesktopMenuItem.propTypes={targetInfo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,style:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};DesktopMenuItem.defaultProps={targetInfo:{},style:{}};/* harmony default export */ __webpack_exports__["a"] = (DesktopMenuItem);

/***/ }),

/***/ "./src/blocks/Navigation/DesktopNavigation/DesktopNavButton.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var DesktopNavButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].a.withConfig({displayName:'DesktopNavButton',componentId:'biu2td-0'})(['cursor:pointer;font-size:',';font-family:',';color:',';padding:0 ',';font-weight:',';&:after{content:\'\';display:block;top:calc(',' + ',' / 2);width:',';height:4px;position:absolute;background-color:',';transition-duration:0.25s;}'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('base'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),function(_ref){var active=_ref.active;return active?__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.bold'):__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.regular');},__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),function(_ref2){var active=_ref2.active;return active?__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.base'):0;},__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('secondary'));/* harmony default export */ __webpack_exports__["a"] = (DesktopNavButton);

/***/ }),

/***/ "./src/blocks/Navigation/DesktopNavigation/DesktopNavContainer.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n      ','\n    '],['\n      ','\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var DesktopNavContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'DesktopNavContainer',componentId:'sc-160ou4d-0'})(['position:fixed;width:100%;background-color:',';z-index:101;transition-duration:.3s;',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].desktop(_templateObject,function(_ref){var scrollDirection=_ref.scrollDirection;return'\n        top: '+(scrollDirection==='bottom'?'0':__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('navSection.navHeight'))+';\n        z-index: '+(scrollDirection==='bottom'?'101':'99')+';\n        height: '+__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('navSection.navHeight')+';\n      ';}));/* harmony default export */ __webpack_exports__["a"] = (DesktopNavContainer);

/***/ }),

/***/ "./src/blocks/Navigation/DesktopNavigation/DesktopNavTitle.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var DesktopNavTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].h1.withConfig({displayName:'DesktopNavTitle',componentId:'sc-12ukv1k-0'})(['font-size:',';font-family:',';color:',';padding:0 ',';font-weight:',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('base'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('regular'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.bold'));/* harmony default export */ __webpack_exports__["a"] = (DesktopNavTitle);

/***/ }),

/***/ "./src/blocks/Navigation/DesktopNavigation/DesktopNavigationBar.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_consts_containerWidth__ = __webpack_require__("./src/common/consts/containerWidth.js");
var _templateObject=_taggedTemplateLiteral(['\n    position: absolute;\n    margin-left: calc((100vw - ','px - 15px) / 2);\n    padding-left: 0;'],['\n    position: absolute;\n    margin-left: calc((100vw - ','px - 15px) / 2);\n    padding-left: 0;']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var DesktopNavigationBar=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'DesktopNavigationBar',componentId:'adng0d-0'})(['         height:100%;display:inline-flex;align-items:center;padding-left:calc(',' + ',');',''],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.xxl'),__WEBPACK_IMPORTED_MODULE_1_designsystem_index__["c" /* media */].largeDesktop(_templateObject,__WEBPACK_IMPORTED_MODULE_3_common_consts_containerWidth__["a" /* default */]));/* harmony default export */ __webpack_exports__["a"] = (DesktopNavigationBar);

/***/ }),

/***/ "./src/blocks/Navigation/DesktopNavigation/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainNavigation__ = __webpack_require__("./src/blocks/Navigation/MainNavigation/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DesktopNavContainer__ = __webpack_require__("./src/blocks/Navigation/DesktopNavigation/DesktopNavContainer.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DesktopNavigationBar__ = __webpack_require__("./src/blocks/Navigation/DesktopNavigation/DesktopNavigationBar.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MenuButtons__ = __webpack_require__("./src/blocks/Navigation/MenuButtons.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DesktopNavTitle__ = __webpack_require__("./src/blocks/Navigation/DesktopNavigation/DesktopNavTitle.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable react/prop-types,react/forbid-prop-types,react/require-default-props */var DesktopNavigation=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["inject"])('productsStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"])(_class=function(_Component){_inherits(DesktopNavigation,_Component);function DesktopNavigation(){_classCallCheck(this,DesktopNavigation);return _possibleConstructorReturn(this,(DesktopNavigation.__proto__||Object.getPrototypeOf(DesktopNavigation)).apply(this,arguments));}_createClass(DesktopNavigation,[{key:'render',value:function render(){var _props=this.props,windowStore=_props.windowStore,parsedStructure=_props.parsedStructure,productsStore=_props.productsStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__MainNavigation__["a" /* default */],null),Array.isArray(parsedStructure)&&parsedStructure.length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DesktopNavContainer__["a" /* default */],{scrollDirection:windowStore.scrollDirection},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DesktopNavigationBar__["a" /* default */],{scrollRefId:'nav-parent'},productsStore.currentProduct.name?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DesktopNavTitle__["a" /* default */],null,productsStore.currentProduct.name+':'):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__MenuButtons__["a" /* default */],{parsedStructure:parsedStructure}))):null);}}]);return DesktopNavigation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);DesktopNavigation.propTypes={windowStore:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,parsedStructure:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};DesktopNavigation.defaultProps={parsedStructure:[]};/* harmony default export */ __webpack_exports__["a"] = (DesktopNavigation);

/***/ }),

/***/ "./src/blocks/Navigation/Languages/Language.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    padding: 0;\n    margin: calc(',' + 2px) ',' ',' 0;\n    position: relative;\n  '],['\n    padding: 0;\n    margin: calc(',' + 2px) ',' ',' 0;\n    position: relative;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Language=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].a.withConfig({displayName:'Language',componentId:'sc-1qfkt1i-0'})(['color:',';cursor:pointer;font-size:',';font-family:',';font-weight:',';text-decoration:none;padding:',' ',' ',' 0;user-select:none;',' ',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.regular'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),function(_ref){var active=_ref.active;return active?'font-weight: '+__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.bold')+';':'';},__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs')));/* harmony default export */ __webpack_exports__["a"] = (Language);

/***/ }),

/***/ "./src/blocks/Navigation/Languages/LanguageArrow.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_blocks_Arrow_Arrow__ = __webpack_require__("./src/blocks/Arrow/Arrow.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n  display: inline-block;\n  width: calc(',' * 2/3);\n  height: calc(',' * 2/3);\n  border-bottom-width: 1px;\n  border-right-width: 1px;\n  margin-left: 10px;\n  margin-bottom: 4px;\n  user-select: none;\n'],['\n  display: inline-block;\n  width: calc(',' * 2/3);\n  height: calc(',' * 2/3);\n  border-bottom-width: 1px;\n  border-right-width: 1px;\n  margin-left: 10px;\n  margin-bottom: 4px;\n  user-select: none;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LanguageArrow=__WEBPACK_IMPORTED_MODULE_0_blocks_Arrow_Arrow__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'));/* harmony default export */ __webpack_exports__["a"] = (LanguageArrow);

/***/ }),

/***/ "./src/blocks/Navigation/Languages/LanguageFullWidthBar.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    display: block;\n    position: absolute;\n    width: 200vw;\n    left: -100vw;\n    top: 0;\n    height: ',';\n    background-color: ',';\n    transition-duration: 0.1s;\n    pointer-events: ',';    \n  '],['\n    display: block;\n    position: absolute;\n    width: 200vw;\n    left: -100vw;\n    top: 0;\n    height: ',';\n    background-color: ',';\n    transition-duration: 0.1s;\n    pointer-events: ',';    \n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LanguageFullWidthBar=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'LanguageFullWidthBar',componentId:'uv6mu4-0'})(['display:none;',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('navSection.navHeight'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white'),function(_ref){var visible=_ref.visible;return visible?'auto':'none';}));/* harmony default export */ __webpack_exports__["a"] = (LanguageFullWidthBar);

/***/ }),

/***/ "./src/blocks/Navigation/Languages/LanguageImage.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var LanguageImage=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].img.withConfig({displayName:'LanguageImage',componentId:'f8g7do-0'})(['display:inline-block;user-select:none;']);/* harmony default export */ __webpack_exports__["a"] = (LanguageImage);

/***/ }),

/***/ "./src/blocks/Navigation/Languages/LanguagesButton.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_images_globe_png__ = __webpack_require__("./src/common/images/globe.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_images_globe_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_images_globe_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LanguageImage__ = __webpack_require__("./src/blocks/Navigation/Languages/LanguageImage.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LanguageArrow__ = __webpack_require__("./src/blocks/Navigation/Languages/LanguageArrow.jsx");
var LanguagesButtonWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].a.withConfig({displayName:'LanguagesButton__LanguagesButtonWrapper',componentId:'qdq7u8-0'})(['position:relative;display:block;padding-top:calc(',' / 2);background-color:',';height:',';cursor:pointer;transition-duration:0.2s;opacity:',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('navSection.navHeight'),function(_ref){var hidden=_ref.hidden;return hidden?'0':'1';});var LanguagesButton=function LanguagesButton(_ref2){var _onClick=_ref2.onClick,hidden=_ref2.hidden;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(LanguagesButtonWrapper,{hidden:hidden,onClick:function onClick(event){return _onClick(event);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__LanguageImage__["a" /* default */],{src:__WEBPACK_IMPORTED_MODULE_4_common_images_globe_png___default.a}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__LanguageArrow__["a" /* default */],null));};LanguagesButton.propTypes={onClick:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,hidden:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};LanguagesButton.defaultProps={onClick:function onClick(){},hidden:false};/* harmony default export */ __webpack_exports__["a"] = (LanguagesButton);

/***/ }),

/***/ "./src/blocks/Navigation/Languages/LanguagesDropdownWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    display: block;\n    line-height: ',';\n    margin-left: calc(',' * 2);\n  '],['\n    display: block;\n    line-height: ',';\n    margin-left: calc(',' * 2);\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LanguagesDropdownWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'LanguagesDropdownWrapper',componentId:'ebj3it-0'})(['',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('navSection.navHeight'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs')));/* harmony default export */ __webpack_exports__["a"] = (LanguagesDropdownWrapper);

/***/ }),

/***/ "./src/blocks/Navigation/Languages/LanguagesWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    position: absolute;\n    top: ',';\n    display: block;\n    transition-duration: 0.1s;\n    opacity: ',';\n    pointer-events: ',';\n  '],['\n    position: absolute;\n    top: ',';\n    display: block;\n    transition-duration: 0.1s;\n    opacity: ',';\n    pointer-events: ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LanguagesWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'LanguagesWrapper',componentId:'x1kmw-0'})(['display:flex;',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('navSection.navHeight'),function(_ref){var visible=_ref.visible;return visible?'1':'0';},function(_ref2){var visible=_ref2.visible;return visible?'inherit':'none';}));/* harmony default export */ __webpack_exports__["a"] = (LanguagesWrapper);

/***/ }),

/***/ "./src/blocks/Navigation/Languages/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_consts_languages__ = __webpack_require__("./src/common/consts/languages.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_Language_service__ = __webpack_require__("./src/services/Language.service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Language__ = __webpack_require__("./src/blocks/Navigation/Languages/Language.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LanguagesWrapper__ = __webpack_require__("./src/blocks/Navigation/Languages/LanguagesWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LanguagesDropdownWrapper__ = __webpack_require__("./src/blocks/Navigation/Languages/LanguagesDropdownWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LanguagesButton__ = __webpack_require__("./src/blocks/Navigation/Languages/LanguagesButton.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LanguageFullWidthBar__ = __webpack_require__("./src/blocks/Navigation/Languages/LanguageFullWidthBar.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}/* eslint-disable react/prop-types,react/no-find-dom-node */var Languages=(_dec=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["inject"])('windowStore','appStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["observer"])(_class=Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["withRouter"])(_class=(_class2=function(_Component){_inherits(Languages,_Component);function Languages(){_classCallCheck(this,Languages);var _this=_possibleConstructorReturn(this,(Languages.__proto__||Object.getPrototypeOf(Languages)).call(this));_this.state={opened:false};_this.dropDownButtonRef=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();return _this;}_createClass(Languages,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var windowStore=this.props.windowStore;this.clickReactionDispose=windowStore.onClickedAnywhere(function(_ref){var target=_ref.target;var opened=_this2.state.opened;if(!_this2.dropDownButtonRef.current.contains(target)&&opened){_this2.toggleDropDown();}});this.scrollReactionDispose=windowStore.reactToScroll(function(){var opened=_this2.state.opened;if(opened){_this2.setState({opened:false});}});}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.clickReactionDispose();this.scrollReactionDispose();}},{key:'toggleDropDown',value:function toggleDropDown(){var opened=this.state.opened;this.setState({opened:!opened});}},{key:'changeLanguage',value:function changeLanguage(e,language,pathname){e.preventDefault();var history=this.props.history;var path=__WEBPACK_IMPORTED_MODULE_3_services_Language_service__["a" /* default */].createLink(language,pathname);history.push(path);}},{key:'render',value:function render(){var _this3=this;var _props=this.props,isOnTablet=_props.windowStore.isOnTablet,_props$appStore=_props.appStore,currentLanguage=_props$appStore.currentLanguage,currentUrl=_props$appStore.currentUrl,pathname=_props.location.pathname;var opened=this.state.opened;var isLangButtonVisible=!currentUrl.includes('/blog/');var isFrenchAvailable=!currentUrl.includes('/blog');var filteredLanguages=isFrenchAvailable?__WEBPACK_IMPORTED_MODULE_0_common_consts_languages__["c" /* LANGUAGES */]:__WEBPACK_IMPORTED_MODULE_0_common_consts_languages__["a" /* BLOG_LANGUAGES */];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__LanguagesDropdownWrapper__["a" /* default */],{innerRef:this.dropDownButtonRef},!isOnTablet&&isLangButtonVisible&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__LanguagesButton__["a" /* default */],{onClick:function onClick(){return _this3.toggleDropDown();}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__LanguagesWrapper__["a" /* default */],{visible:opened},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LanguageFullWidthBar__["a" /* default */],{visible:opened}),Object.values(filteredLanguages).map(function(language){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Language__["a" /* default */],{key:language.value,active:currentLanguage===language.value,onClick:function onClick(e){return _this3.changeLanguage(e,language.value,pathname);},href:__WEBPACK_IMPORTED_MODULE_3_services_Language_service__["a" /* default */].createLink(language.value,pathname)},language.name);})));}}]);return Languages;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),(_applyDecoratedDescriptor(_class2.prototype,'toggleDropDown',[__WEBPACK_IMPORTED_MODULE_5_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'toggleDropDown'),_class2.prototype)),_class2))||_class)||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (Languages);

/***/ }),

/***/ "./src/blocks/Navigation/Logo/LogoImage.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    ','\n  '],['\n    ','\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LogoImage=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].img.withConfig({displayName:'LogoImage',componentId:'xs8bfa-0'})(['position:relative;width:',';margin-left:',';margin-top:auto;margin-bottom:auto;',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xxl'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].tablet(_templateObject,function(_ref){var big=_ref.big;return big?'width: calc('+__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.l')+' * 3);':'';}));/* harmony default export */ __webpack_exports__["a"] = (LogoImage);

/***/ }),

/***/ "./src/blocks/Navigation/Logo/LogoWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var LogoWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'LogoWrapper',componentId:'sc-1dw6gye-0'})(['',' ',' ',';display:flex;align-items:center;top:0;height:',';padding:',' 0;',''],function(_ref){var fixed=_ref.fixed;return fixed?'\n    position: fixed;\n    z-index: 1000;':'position: relative;';},function(_ref2){var absolute=_ref2.absolute;return absolute?'position: absolute; z-index: 500;':'';},function(_ref3){var backgroundColor=_ref3.backgroundColor;return backgroundColor?'background-color: '+backgroundColor:'';},__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('navSection.navHeight'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),function(_ref4){var alignSelf=_ref4.alignSelf;return alignSelf?'align-self: '+alignSelf+';':'';});/* harmony default export */ __webpack_exports__["a"] = (LogoWrapper);

/***/ }),

/***/ "./src/blocks/Navigation/Logo/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_images_zonifero_logo_black_svg__ = __webpack_require__("./src/common/images/zonifero_logo_black.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_images_zonifero_logo_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_images_zonifero_logo_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_consts_anchor__ = __webpack_require__("./src/common/consts/anchor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_consts_anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_consts_anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_animations_Animations__ = __webpack_require__("./src/animations/Animations.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LogoWrapper__ = __webpack_require__("./src/blocks/Navigation/Logo/LogoWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LogoImage__ = __webpack_require__("./src/blocks/Navigation/Logo/LogoImage.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_LanguageLink__ = __webpack_require__("./src/elements/LanguageLink.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable react/prop-types */var Logo=(_dec=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["inject"])('navigationStore','windowStore','appStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["observer"])(_class=function(_Component){_inherits(Logo,_Component);function Logo(){_classCallCheck(this,Logo);return _possibleConstructorReturn(this,(Logo.__proto__||Object.getPrototypeOf(Logo)).apply(this,arguments));}_createClass(Logo,[{key:'render',value:function render(){var _props=this.props,fixed=_props.fixed,absolute=_props.absolute,backgroundColor=_props.backgroundColor,alignSelf=_props.alignSelf,big=_props.big,navigationStore=_props.navigationStore,windowStore=_props.windowStore,currentLanguage=_props.appStore.currentLanguage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__LogoWrapper__["a" /* default */],{fixed:fixed,absolute:absolute,backgroundColor:backgroundColor,alignSelf:alignSelf},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_LanguageLink__["a" /* default */],{to:__WEBPACK_IMPORTED_MODULE_3_common_consts_anchor___default.a.HOME[currentLanguage],onClick:function onClick(){navigationStore.closeMobileNav();Object(__WEBPACK_IMPORTED_MODULE_5_animations_Animations__["j" /* scrollTo */])(0,0);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__LogoImage__["a" /* default */],{big:big,src:windowStore.adjustImageSize(__WEBPACK_IMPORTED_MODULE_1_common_images_zonifero_logo_black_svg___default.a)})));}}]);return Logo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);Logo.propTypes={fixed:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,absolute:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,backgroundColor:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,alignSelf:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,big:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};Logo.defaultProps={fixed:false,absolute:false,backgroundColor:'',alignSelf:'',big:false};/* harmony default export */ __webpack_exports__["a"] = (Logo);

/***/ }),

/***/ "./src/blocks/Navigation/MainNavigation/MainNavigationBar.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n      position: fixed;\n      flex-direction: row;\n      align-items: center;\n      height: ',';\n      padding-right: ',';\n      padding-left: ',';\n      top: 0;\n      z-index: 100;\n    '],['\n      position: fixed;\n      flex-direction: row;\n      align-items: center;\n      height: ',';\n      padding-right: ',';\n      padding-left: ',';\n      top: 0;\n      z-index: 100;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var MainNavigationBar=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'MainNavigationBar',componentId:'sc-16dmv38-0'})(['  position:relative;display:flex;justify-content:flex-end;background-color:',';width:100%;flex-direction:column;',''],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_1_designsystem_index__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('navSection.navHeight'),function(_ref){var paddingRight=_ref.paddingRight;return paddingRight;},function(_ref2){var paddingLeft=_ref2.paddingLeft;return paddingLeft;}));/* harmony default export */ __webpack_exports__["a"] = (MainNavigationBar);

/***/ }),

/***/ "./src/blocks/Navigation/MainNavigation/StyledBlogLink.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
var _templateObject=_taggedTemplateLiteral(['\n      padding: calc(',' / 2) calc(',' * 2);\n  '],['\n      padding: calc(',' / 2) calc(',' * 2);\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledBlogLink=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["NavLink"]).withConfig({displayName:'StyledBlogLink',componentId:'d4f3ch-0'})(['position:relative;display:block;color:',';font-size:',';font-family:',';font-weight:',';text-decoration:none;padding:',' 0 ',' 0;&.active{font-weight:',';}',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.regular'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.bold'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs')));/* harmony default export */ __webpack_exports__["a"] = (StyledBlogLink);

/***/ }),

/***/ "./src/blocks/Navigation/MainNavigation/StyledExternalLink.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n      padding: calc(',' / 2) calc(',' * 2);\n  '],['\n      padding: calc(',' / 2) calc(',' * 2);\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledLink=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].a.withConfig({displayName:'StyledExternalLink__StyledLink',componentId:'sc-1qg3s0d-0'})(['position:relative;display:block;color:',';font-size:',';font-family:',';font-weight:',';text-decoration:none;padding:',' 0 ',' 0;',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),function(props){return __WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.'+(props.bold?'bold':'regular'));},__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs')));/* harmony default export */ __webpack_exports__["a"] = (StyledLink);

/***/ }),

/***/ "./src/blocks/Navigation/MainNavigation/StyledLink.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_LanguageLink__ = __webpack_require__("./src/elements/LanguageLink.jsx");
var _templateObject=_taggedTemplateLiteral(['\n      padding: calc(',' / 2) calc(',' * 2);\n  '],['\n      padding: calc(',' / 2) calc(',' * 2);\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledLink=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3__elements_LanguageLink__["a" /* default */]).withConfig({displayName:'StyledLink',componentId:'sc-18fw721-0'})(['position:relative;display:block;color:',';font-size:',';font-family:',';font-weight:',';text-decoration:none;padding:',' 0 ',' 0;&.active{font-weight:',';}',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.regular'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.bold'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs')));/* harmony default export */ __webpack_exports__["a"] = (StyledLink);

/***/ }),

/***/ "./src/blocks/Navigation/MainNavigation/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_consts_anchor__ = __webpack_require__("./src/common/consts/anchor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_consts_anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_consts_anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_consts_hrefs__ = __webpack_require__("./src/common/consts/hrefs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_consts_languages__ = __webpack_require__("./src/common/consts/languages.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Logo_index__ = __webpack_require__("./src/blocks/Navigation/Logo/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MainNavigationBar__ = __webpack_require__("./src/blocks/Navigation/MainNavigation/MainNavigationBar.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Buttons_index__ = __webpack_require__("./src/blocks/Navigation/Buttons/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__StyledLink__ = __webpack_require__("./src/blocks/Navigation/MainNavigation/StyledLink.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StyledBlogLink__ = __webpack_require__("./src/blocks/Navigation/MainNavigation/StyledBlogLink.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Languages__ = __webpack_require__("./src/blocks/Navigation/Languages/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__StyledExternalLink__ = __webpack_require__("./src/blocks/Navigation/MainNavigation/StyledExternalLink.jsx");
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable react/no-array-index-key,react/prop-types */var MainNavigation=(_dec=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["inject"])('coreStore','navigationStore','windowStore','appStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"])(_class=function(_Component){_inherits(MainNavigation,_Component);function MainNavigation(){_classCallCheck(this,MainNavigation);return _possibleConstructorReturn(this,(MainNavigation.__proto__||Object.getPrototypeOf(MainNavigation)).apply(this,arguments));}_createClass(MainNavigation,[{key:'render',value:function render(){var _props=this.props,renderLogo=_props.renderLogo,renderButtons=_props.renderButtons,paddingRight=_props.paddingRight,paddingLeft=_props.paddingLeft,itemClick=_props.itemClick,translations=_props.coreStore.translations,buttonsSectionWidth=_props.navigationStore.buttonsSectionWidth,isOnTablet=_props.windowStore.isOnTablet,currentLanguage=_props.appStore.currentLanguage;var paddingLeftWithLogo=paddingLeft;var paddingRightWithButtons=paddingRight;if(renderLogo){paddingLeftWithLogo='calc('+paddingLeft+' + 200px)';}if(renderButtons){paddingRightWithButtons='calc('+paddingRight+' + '+(24+buttonsSectionWidth)+'px)';}var blogLanguagesArray=Object.entries(__WEBPACK_IMPORTED_MODULE_6_common_consts_languages__["a" /* BLOG_LANGUAGES */]).map(function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];return value.value;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,renderLogo?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Logo_index__["a" /* default */],{fixed:true}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__MainNavigationBar__["a" /* default */],{paddingLeft:paddingLeftWithLogo,paddingRight:paddingRightWithButtons},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__StyledLink__["a" /* default */],{to:__WEBPACK_IMPORTED_MODULE_2_common_consts_anchor___default.a.HOME[currentLanguage],onClick:function onClick(){return itemClick();},exact:true},translations.NAVIGATION_ZONIFERO_PRODUCTS),blogLanguagesArray.includes(currentLanguage)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__StyledBlogLink__["a" /* default */],{to:__WEBPACK_IMPORTED_MODULE_2_common_consts_anchor___default.a.BLOG[currentLanguage],onClick:function onClick(){return itemClick();}},translations.NAVIGATION_BLOG),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__StyledLink__["a" /* default */],{to:__WEBPACK_IMPORTED_MODULE_2_common_consts_anchor___default.a.FAQ[currentLanguage],onClick:function onClick(){return itemClick();}},translations.NAVIGATION_FAQ),currentLanguage==='pl'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__StyledLink__["a" /* default */],{to:__WEBPACK_IMPORTED_MODULE_2_common_consts_anchor___default.a.FOR_INVESTORS[currentLanguage],onClick:function onClick(){return itemClick();}},'Dla inwestor\xF3w'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledExternalLink__["a" /* default */],{href:currentLanguage==='pl'?'https://zonifero.com/pl/support':'https://lp.zonifero.com/workplaces-handbook'},translations.NAVIGATION_PROPTECH),currentLanguage==='pl'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__StyledLink__["a" /* default */],{to:__WEBPACK_IMPORTED_MODULE_2_common_consts_anchor___default.a.WORK[currentLanguage],onClick:function onClick(){return itemClick();}},translations.NAVIGATION_WORK),!isOnTablet&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Languages__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledExternalLink__["a" /* default */],{href:__WEBPACK_IMPORTED_MODULE_5_common_consts_hrefs__["a" /* default */].SIGN_IN,onClick:function onClick(){return itemClick();},bold:true},translations.NAVIGATION_SIGN_IN))),renderButtons?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Buttons_index__["a" /* default */],null):'');}}]);return MainNavigation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);MainNavigation.propTypes={itemClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,renderLogo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,renderButtons:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,paddingRight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,paddingLeft:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};MainNavigation.defaultProps={itemClick:function itemClick(){},renderLogo:true,renderButtons:true,paddingRight:'0px',paddingLeft:'0px'};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["withRouter"])(MainNavigation));

/***/ }),

/***/ "./src/blocks/Navigation/MenuButtons.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_organism_react_scroll_nav__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_consts_navigation__ = __webpack_require__("./src/common/consts/navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DesktopNavigation_DesktopMenuItem__ = __webpack_require__("./src/blocks/Navigation/DesktopNavigation/DesktopMenuItem.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_LanguageLink__ = __webpack_require__("./src/elements/LanguageLink.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _templateObject=_taggedTemplateLiteral(['\n    padding: 0 ',';\n  \n    &:after {\n      content: \'\';\n      display: block;\n      top: calc(',' + ',' / 2);\n      width: ',';\n      height: 4px;\n      position: absolute;\n      background-color: ',';\n      transition-duration: 0.25s;\n    }\n  '],['\n    padding: 0 ',';\n  \n    &:after {\n      content: \'\';\n      display: block;\n      top: calc(',' + ',' / 2);\n      width: ',';\n      height: 4px;\n      position: absolute;\n      background-color: ',';\n      transition-duration: 0.25s;\n    }\n  ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var MenuLink=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_7__elements_LanguageLink__["a" /* default */]).withConfig({displayName:'MenuButtons__MenuLink',componentId:'f1yh3k-0'})(['cursor:pointer;display:flex;font-size:',';font-family:',';color:',';font-weight:',';text-decoration:none;padding:',' 0 ',' 0;',''],__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].fontSize('base'),__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('type.fontFamily.text'),function(_ref){var highlighted=_ref.highlighted;return highlighted?__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].brand('product'):__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].brand('text');},function(_ref2){var active=_ref2.active;return active?__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('type.fontWeight.bold'):__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('type.fontWeight.regular');},__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_5_designsystem__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('metrics.s'),function(_ref3){var active=_ref3.active;return active?__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('metrics.base'):0;},__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].brand('secondary')));var MenuButtons=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["inject"])('windowStore','navigationStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"])(_class=function(_Component){_inherits(MenuButtons,_Component);function MenuButtons(){_classCallCheck(this,MenuButtons);return _possibleConstructorReturn(this,(MenuButtons.__proto__||Object.getPrototypeOf(MenuButtons)).apply(this,arguments));}_createClass(MenuButtons,[{key:'render',value:function render(){var _props=this.props,parsedStructure=_props.parsedStructure,buttonComponent=_props.buttonComponent,windowStore=_props.windowStore,navigationStore=_props.navigationStore;return parsedStructure.map(function(section,sectionIndex){return section.urlSlug?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuLink,{to:section.urlSlug,highlighted:section.highlighted||false,key:'navScroll-'+(sectionIndex+1),onClick:function onClick(){return navigationStore.closeMobileNav();}},section.sectionName):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_organism_react_scroll_nav__["c" /* SmoothScrollLink */],{key:'navScroll-'+(sectionIndex+1),scrollRefId:'nav-parent',container:buttonComponent||__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DesktopNavigation_DesktopMenuItem__["a" /* default */],null),targetId:'scroll-'+(sectionIndex+1),scrollMargin:windowStore.isOnTablet?0:__WEBPACK_IMPORTED_MODULE_3_common_consts_navigation__["d" /* NAV_HEIGHT */]},section.sectionName);});}}]);return MenuButtons;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (MenuButtons);

/***/ }),

/***/ "./src/blocks/Navigation/MobileNavigation/BurgerWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var BurgerWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'BurgerWrapper',componentId:'vt2l8w-0'})(['position:fixed;top:calc(',' + 2px);right:',';z-index:1000;cursor:pointer;'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'));/* harmony default export */ __webpack_exports__["a"] = (BurgerWrapper);

/***/ }),

/***/ "./src/blocks/Navigation/MobileNavigation/MobileMenuItem.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MobileNavButton__ = __webpack_require__("./src/blocks/Navigation/MobileNavigation/MobileNavButton.jsx");
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/* eslint-disable react/forbid-prop-types */var MobileMenuItem=function MobileMenuItem(props){var targetInfo=props.targetInfo,itemClick=props.itemClick,reset=_objectWithoutProperties(props,['targetInfo','itemClick']);var active=null;if(targetInfo.active){active=true;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__MobileNavButton__["a" /* default */],Object.assign({onMouseDown:function onMouseDown(){return setTimeout(function(){return itemClick(targetInfo);},500);},active:active},reset));};MobileMenuItem.propTypes={targetInfo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,style:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,itemClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};MobileMenuItem.defaultProps={targetInfo:{},style:{},itemClick:function itemClick(){}};/* harmony default export */ __webpack_exports__["a"] = (MobileMenuItem);

/***/ }),

/***/ "./src/blocks/Navigation/MobileNavigation/MobileNavButton.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n      padding: 0 ',';\n  '],['\n      padding: 0 ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var MobileNavButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].a.withConfig({displayName:'MobileNavButton',componentId:'sc-10ywffo-0'})(['cursor:pointer;display:flex;font-size:',';font-family:',';color:',';font-weight:',';padding:',' 0 ',' 0;',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('base'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('regular'),function(_ref){var active=_ref.active;return active?__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.bold'):__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.regular');},__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s')));/* harmony default export */ __webpack_exports__["a"] = (MobileNavButton);

/***/ }),

/***/ "./src/blocks/Navigation/MobileNavigation/MobileNavContainer.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_consts_navigation__ = __webpack_require__("./src/common/consts/navigation.js");
var MobileNavContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].nav.withConfig({displayName:'MobileNavContainer',componentId:'sc-13f8r4p-0'})(['background-color:',';position:fixed;width:100%;display:flex;flex-direction:column;justify-content:space-between;align-items:center;z-index:999;overflow:auto;height:',';top:',';transition:top ',' ',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_2_common_consts_navigation__["a" /* MOBILE_NAV_HEIGHT */],function(_ref){var hidden=_ref.hidden;return hidden?'-115vh':'0';},__WEBPACK_IMPORTED_MODULE_2_common_consts_navigation__["c" /* MOBILE_NAV_TRANSITION_SPEED */],__WEBPACK_IMPORTED_MODULE_2_common_consts_navigation__["b" /* MOBILE_NAV_TRANSITION_FUNCTION */]);/* harmony default export */ __webpack_exports__["a"] = (MobileNavContainer);

/***/ }),

/***/ "./src/blocks/Navigation/MobileNavigation/MobileNavSection.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_consts_navigation__ = __webpack_require__("./src/common/consts/navigation.js");
var _templateObject=_taggedTemplateLiteral(['\n    display: ',';\n    vertical-align: top;\n    padding: 0 calc(',' * 2) ',' calc(',' * 2);\n  '],['\n    display: ',';\n    vertical-align: top;\n    padding: 0 calc(',' * 2) ',' calc(',' * 2);\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    padding: ',' ',';\n  '],['\n    padding: ',' ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var MobileNavSection=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'MobileNavSection',componentId:'sc-4trg9h-0'})(['position:relative;display:block;transition-duration:',';padding:',' 0;',' ',''],__WEBPACK_IMPORTED_MODULE_3_common_consts_navigation__["c" /* MOBILE_NAV_TRANSITION_SPEED */],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].mobile(_templateObject,function(_ref){var isPortraitOrientation=_ref.isPortraitOrientation;return isPortraitOrientation?'block':'inline-block';},__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs')),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].tablet(_templateObject2,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.l')));/* harmony default export */ __webpack_exports__["a"] = (MobileNavSection);

/***/ }),

/***/ "./src/blocks/Navigation/MobileNavigation/MobileNavSections.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    align-self: ',';\n    margin-left: ',';\n  '],['\n    align-self: ',';\n    margin-left: ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var MobileNavSections=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'MobileNavSections',componentId:'sc-1tnqjr4-0'})(['display:block;padding-top:',';padding-bottom:',';margin-top:auto;margin-bottom:auto;',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.base'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].mobile(_templateObject,function(_ref){var list=_ref.list;return list?'flex-start':'center';},function(_ref2){var list=_ref2.list;return list?'100px':'0px';}));/* harmony default export */ __webpack_exports__["a"] = (MobileNavSections);

/***/ }),

/***/ "./src/blocks/Navigation/MobileNavigation/MobileNavTitle.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var MobileNavTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].h1.withConfig({displayName:'MobileNavTitle',componentId:'pg9xjg-0'})(['font-size:',';font-family:',';color:',';padding:0;font-weight:',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('base'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('regular'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.bold'));/* harmony default export */ __webpack_exports__["a"] = (MobileNavTitle);

/***/ }),

/***/ "./src/blocks/Navigation/MobileNavigation/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blocks_BurgerIcon__ = __webpack_require__("./src/blocks/BurgerIcon/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_blocks_Navigation_Logo__ = __webpack_require__("./src/blocks/Navigation/Logo/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blocks_Navigation_MenuButtons__ = __webpack_require__("./src/blocks/Navigation/MenuButtons.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_blocks_Navigation_Buttons__ = __webpack_require__("./src/blocks/Navigation/Buttons/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_blocks_Navigation_MainNavigation__ = __webpack_require__("./src/blocks/Navigation/MainNavigation/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobx__ = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_common_consts_navigation__ = __webpack_require__("./src/common/consts/navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__BurgerWrapper__ = __webpack_require__("./src/blocks/Navigation/MobileNavigation/BurgerWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__MobileNavContainer__ = __webpack_require__("./src/blocks/Navigation/MobileNavigation/MobileNavContainer.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__MobileNavSections__ = __webpack_require__("./src/blocks/Navigation/MobileNavigation/MobileNavSections.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__MobileNavSection__ = __webpack_require__("./src/blocks/Navigation/MobileNavigation/MobileNavSection.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__MobileMenuItem__ = __webpack_require__("./src/blocks/Navigation/MobileNavigation/MobileMenuItem.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__MobileNavTitle__ = __webpack_require__("./src/blocks/Navigation/MobileNavigation/MobileNavTitle.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Languages__ = __webpack_require__("./src/blocks/Navigation/Languages/index.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}/* eslint-disable react/forbid-prop-types,react/require-default-props,react/prop-types */var MobileNavigation=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('productsStore','windowStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(_class=(_class2=function(_Component){_inherits(MobileNavigation,_Component);function MobileNavigation(props){_classCallCheck(this,MobileNavigation);var _this=_possibleConstructorReturn(this,(MobileNavigation.__proto__||Object.getPrototypeOf(MobileNavigation)).call(this,props));_this.mobileNavRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(MobileNavigation,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var navigationStore=this.props.navigationStore;this.onMenuToggle();this.disposeMenuHideReaction=Object(__WEBPACK_IMPORTED_MODULE_10_mobx__["reaction"])(function(){return navigationStore.isMobileNavOpen;},function(){return _this2.onMenuToggle();});}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.disposeMenuHideReaction();}},{key:'onMenuToggle',value:function onMenuToggle(){var _this3=this;var navigationStore=this.props.navigationStore;if(this.mobileNavRef.current&&!navigationStore.isMobileNavOpen){this.hideTimeout=setTimeout(function(){if(_this3.mobileNavRef.current){_this3.mobileNavRef.current.style.opacity='0';}clearTimeout(_this3.hideTimeout);},Object(__WEBPACK_IMPORTED_MODULE_12_common_methods_string__["d" /* getNumbers */])(__WEBPACK_IMPORTED_MODULE_11_common_consts_navigation__["c" /* MOBILE_NAV_TRANSITION_SPEED */]));}else{clearTimeout(this.hideTimeout);this.mobileNavRef.current.style.opacity='1';}}},{key:'toggleMenu',value:function toggleMenu(){var navigationStore=this.props.navigationStore;if(navigationStore.isMobileNavOpen){navigationStore.closeMobileNav();}else{navigationStore.openMobileNav();}}},{key:'render',value:function render(){var _props=this.props,navigationStore=_props.navigationStore,parsedStructure=_props.parsedStructure,productsStore=_props.productsStore,windowStore=_props.windowStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__BurgerWrapper__["a" /* default */],{onClick:this.toggleMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_blocks_BurgerIcon__["a" /* default */],{active:navigationStore.isMobileNavOpen,color:__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('product')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__MobileNavContainer__["a" /* default */],{innerRef:this.mobileNavRef,hidden:!navigationStore.isMobileNavOpen,scrollRefId:'nav-parent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_blocks_Navigation_Logo__["a" /* default */],{alignSelf:'flex-start'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__MobileNavSections__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileNavSection__["a" /* default */],{isPortraitOrientation:windowStore.isPortraitOrientation},productsStore.currentProduct&&productsStore.currentProduct.name?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__MobileNavTitle__["a" /* default */],null,productsStore.currentProduct.name+':'):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_blocks_Navigation_MenuButtons__["a" /* default */],{parsedStructure:parsedStructure,buttonComponent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__MobileMenuItem__["a" /* default */],{itemClick:function itemClick(){return navigationStore.closeMobileNav();}})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileNavSection__["a" /* default */],{isPortraitOrientation:windowStore.isPortraitOrientation},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_blocks_Navigation_MainNavigation__["a" /* default */],{itemClick:function itemClick(){return navigationStore.closeMobileNav();},renderLogo:false,renderButtons:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileNavSection__["a" /* default */],{isPortraitOrientation:windowStore.isPortraitOrientation},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Languages__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_blocks_Navigation_Buttons__["a" /* default */],{onItemClick:function onItemClick(){return navigationStore.closeMobileNav();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_blocks_Navigation_Logo__["a" /* default */],{absolute:true}));}}]);return MobileNavigation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),(_applyDecoratedDescriptor(_class2.prototype,'onMenuToggle',[__WEBPACK_IMPORTED_MODULE_2_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'onMenuToggle'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'toggleMenu',[__WEBPACK_IMPORTED_MODULE_2_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'toggleMenu'),_class2.prototype)),_class2))||_class)||_class);MobileNavigation.propTypes={navigationStore:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,parsedStructure:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array};MobileNavigation.defaultProps={parsedStructure:[]};/* harmony default export */ __webpack_exports__["a"] = (MobileNavigation);

/***/ }),

/***/ "./src/blocks/Navigation/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_organism_react_scroll_nav__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores_Products_store__ = __webpack_require__("./src/stores/Products.store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DesktopNavigation__ = __webpack_require__("./src/blocks/Navigation/DesktopNavigation/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MobileNavigation__ = __webpack_require__("./src/blocks/Navigation/MobileNavigation/index.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable react/forbid-prop-types,react/require-default-props */Object(__WEBPACK_IMPORTED_MODULE_1_organism_react_scroll_nav__["d" /* scrollDispatch */])({scrollMargin:0,scrollDelay:0});var Navigation=(_dec=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["inject"])('windowStore','navigationStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"])(_class=function(_Component){_inherits(Navigation,_Component);function Navigation(props){_classCallCheck(this,Navigation);var _this=_possibleConstructorReturn(this,(Navigation.__proto__||Object.getPrototypeOf(Navigation)).call(this,props));_this.content=__WEBPACK_IMPORTED_MODULE_2_stores_Products_store__["a" /* default */].content;return _this;}_createClass(Navigation,[{key:'render',value:function render(){var _props=this.props,windowStore=_props.windowStore,parsedStructure=_props.parsedStructure,navigationStore=_props.navigationStore,isSupportProducts=_props.isSupportProducts;if(isSupportProducts&&!parsedStructure.some(function(item){return item.id==='report-problem-link';})){parsedStructure.push({id:'report-problem-link',highlighted:true,models:[],sectionName:'Zg\u0142o\u015B problem',//encoding problem
urlSlug:'https://zonifero.atlassian.net/servicedesk/customer/topic/7f3d783b-22fe-44db-a877-b73ed22d7cb3'});}return windowStore.isOnTablet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__MobileNavigation__["a" /* default */],{navigationStore:navigationStore,parsedStructure:parsedStructure}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DesktopNavigation__["a" /* default */],{windowStore:windowStore,parsedStructure:parsedStructure});}}]);return Navigation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);Navigation.propTypes={windowStore:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,navigationStore:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,parsedStructure:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,isSupportProducts:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool};Navigation.defaultProps={parsedStructure:[],isSupportProducts:false};/* harmony default export */ __webpack_exports__["a"] = (Navigation);

/***/ }),

/***/ "./src/blocks/NavigationAwarePageContent/ContentWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_consts_navigation__ = __webpack_require__("./src/common/consts/navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    top: 0;\n  '],['\n    top: 0;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ContentWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'ContentWrapper',componentId:'sc-1tmv09a-0'})(['position:relative;top:0;transition:top ',' ',';',';',';'],__WEBPACK_IMPORTED_MODULE_1_common_consts_navigation__["c" /* MOBILE_NAV_TRANSITION_SPEED */],__WEBPACK_IMPORTED_MODULE_1_common_consts_navigation__["b" /* MOBILE_NAV_TRANSITION_FUNCTION */],function(_ref){var mobileNavOpened=_ref.mobileNavOpened;return mobileNavOpened?'\n    top: '+__WEBPACK_IMPORTED_MODULE_1_common_consts_navigation__["a" /* MOBILE_NAV_HEIGHT */]+';\n  ':0;},__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].desktop(_templateObject));/* harmony default export */ __webpack_exports__["a"] = (ContentWrapper);

/***/ }),

/***/ "./src/blocks/NavigationAwarePageContent/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContentWrapper__ = __webpack_require__("./src/blocks/NavigationAwarePageContent/ContentWrapper.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable react/prop-types */var NavigationAwarePageContent=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('navigationStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(_class=function(_Component){_inherits(NavigationAwarePageContent,_Component);function NavigationAwarePageContent(){_classCallCheck(this,NavigationAwarePageContent);return _possibleConstructorReturn(this,(NavigationAwarePageContent.__proto__||Object.getPrototypeOf(NavigationAwarePageContent)).apply(this,arguments));}_createClass(NavigationAwarePageContent,[{key:'render',value:function render(){var _props=this.props,navigationStore=_props.navigationStore,children=_props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ContentWrapper__["a" /* default */],{mobileNavOpened:navigationStore.isMobileNavOpen},children);}}]);return NavigationAwarePageContent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (NavigationAwarePageContent);

/***/ }),

/***/ "./src/blocks/PageContent/StyledScrollSpy.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_organism_react_scroll_nav__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_consts_navigation__ = __webpack_require__("./src/common/consts/navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    ','\n  '],['\n    ','\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledScrollSpy=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_organism_react_scroll_nav__["b" /* ScrollSpy */]).withConfig({displayName:'StyledScrollSpy',componentId:'sc-1149ldb-0'})(['position:relative;top:0;transition:top ',' ',';',';',''],__WEBPACK_IMPORTED_MODULE_2_common_consts_navigation__["c" /* MOBILE_NAV_TRANSITION_SPEED */],__WEBPACK_IMPORTED_MODULE_2_common_consts_navigation__["b" /* MOBILE_NAV_TRANSITION_FUNCTION */],function(_ref){var mobileopen=_ref.mobileopen;return mobileopen==='open'?'\n    top: '+__WEBPACK_IMPORTED_MODULE_2_common_consts_navigation__["a" /* MOBILE_NAV_HEIGHT */]+';\n  ':'';},__WEBPACK_IMPORTED_MODULE_3_designsystem_index__["c" /* media */].desktop(_templateObject,function(_ref2){var top=_ref2.top;return top==='top'?'margin-top: '+__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('navSection.navHeight'):'';}));/* harmony default export */ __webpack_exports__["a"] = (StyledScrollSpy);

/***/ }),

/***/ "./src/blocks/PageContent/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_window_or_global__ = __webpack_require__("./node_modules/window-or-global/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_animations_Animations__ = __webpack_require__("./src/animations/Animations.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_organism_react_scroll_nav__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx__ = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_consts_navigation__ = __webpack_require__("./src/common/consts/navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Product_ProductsSectionParser__ = __webpack_require__("./src/pages/Product/ProductsSectionParser.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StyledScrollSpy__ = __webpack_require__("./src/blocks/PageContent/StyledScrollSpy.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2;var _templateObject=_taggedTemplateLiteral(['\n    position: relative;\n    top: ','px;\n  '],['\n    position: relative;\n    top: ','px;\n  ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint react/prop-types: "off" */var ScrollToElement=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div.withConfig({displayName:'PageContent__ScrollToElement',componentId:'sc-59p9fm-0'})(['',''],__WEBPACK_IMPORTED_MODULE_9_designsystem__["c" /* media */].desktop(_templateObject,-__WEBPACK_IMPORTED_MODULE_7_common_consts_navigation__["d" /* NAV_HEIGHT */]));var PageContent=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('navigationStore','windowStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(_class=(_class2=function(_Component){_inherits(PageContent,_Component);function PageContent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PageContent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PageContent.__proto__||Object.getPrototypeOf(PageContent)).call.apply(_ref,[this].concat(args))),_this),_this.navigators={},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PageContent,[{key:'componentDidMount',value:function componentDidMount(){var windowStore=this.props.windowStore;this.resetHashNavigators();this.disposeScrollYReaction=Object(__WEBPACK_IMPORTED_MODULE_5_mobx__["reaction"])(function(){return windowStore.scrollY;},this.onScrollY,{delay:200});}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.resetHashNavigators();}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(this.hashTimeout);this.disposeScrollYReaction();}},{key:'onScrollY',value:function onScrollY(){var _this2=this;clearTimeout(this.hashTimeout);this.hashTimeout=setTimeout(function(){Object.keys(_this2.navigators).forEach(function(scrollHash){if(_this2.navigators[scrollHash].scrollReceiver&&_this2.navigators[scrollHash].scrollReceiver.current&&_this2.navigators[scrollHash].scrollReceiver.current.state.active){__WEBPACK_IMPORTED_MODULE_2_window_or_global___default.a.location.hash=scrollHash;}});},200);}},{key:'resetHashNavigators',value:function resetHashNavigators(){var scrollHash=__WEBPACK_IMPORTED_MODULE_2_window_or_global___default.a.location.hash.replace('#','').toLowerCase();if(this.navigators[scrollHash]&&this.navigators[scrollHash].scrollToElement.current){Object(__WEBPACK_IMPORTED_MODULE_3_animations_Animations__["k" /* scrollToElement */])(this.navigators[scrollHash].scrollToElement.current,100,'auto');}}},{key:'render',value:function render(){var _this3=this;var _props=this.props,parsedStructure=_props.parsedStructure,navigationStore=_props.navigationStore,windowStore=_props.windowStore;var contactForm=parsedStructure.find(function(x){return x.models.some(function(z){return z.system.id==='bdf9ea8b-e4fc-4160-8a8c-5c2ad966401c';});});if(contactForm){contactForm.models=contactForm.models.filter(function(x){return x.system.id!=='bdf9ea8b-e4fc-4160-8a8c-5c2ad966401c';});}this.navigators={};parsedStructure.forEach(function(section){if(section.sectionName){_this3.navigators[section.sectionName.toLowerCase()]={};_this3.navigators[section.sectionName.toLowerCase()].scrollToElement=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this3.navigators[section.sectionName.toLowerCase()].scrollReceiver=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();}});return parsedStructure.map(function(section,sectionIndex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:sectionIndex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_organism_react_scroll_nav__["a" /* ScrollReceiver */],{scrollMargin:windowStore.isOnTablet?0:__WEBPACK_IMPORTED_MODULE_7_common_consts_navigation__["d" /* NAV_HEIGHT */],targetId:'scroll-'+(sectionIndex+1),ref:section.sectionName&&_this3.navigators[section.sectionName.toLowerCase()].scrollReceiver}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__StyledScrollSpy__["a" /* default */],{top:sectionIndex===0?'top':'',mobileopen:windowStore.isOnTablet&&navigationStore.isMobileNavOpen?'open':'',key:'navContent-'+(sectionIndex+1),id:'scroll-'+(sectionIndex+1)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollToElement,{innerRef:section.sectionName&&_this3.navigators[section.sectionName.toLowerCase()].scrollToElement}),section.models.map(function(model){return Object(__WEBPACK_IMPORTED_MODULE_10__pages_Product_ProductsSectionParser__["a" /* default */])(model);})));});}}]);return PageContent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),(_applyDecoratedDescriptor(_class2.prototype,'onScrollY',[__WEBPACK_IMPORTED_MODULE_6_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'onScrollY'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'resetHashNavigators',[__WEBPACK_IMPORTED_MODULE_6_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'resetHashNavigators'),_class2.prototype)),_class2))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (PageContent);

/***/ }),

/***/ "./src/blocks/PanelGroup/StyledPanelBody.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_lib_Panel__ = __webpack_require__("./node_modules/react-bootstrap/lib/Panel.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_lib_Panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_lib_Panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['flex-direction: row'],['flex-direction: row']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledPanelBody=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_lib_Panel___default.a.Body).withConfig({displayName:'StyledPanelBody',componentId:'sc-1bm4ivh-0'})(['margin-bottom:',';color:',';font-size:',';font-family:',';font-weight:',';line-height:',';display:flex;flex-direction:column;',''],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('base'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontWeight.light'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.lineHeight.s'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["c" /* media */].desktop(_templateObject));/* harmony default export */ __webpack_exports__["a"] = (StyledPanelBody);

/***/ }),

/***/ "./src/blocks/PanelGroup/StyledPanelTitle.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_lib_Panel__ = __webpack_require__("./node_modules/react-bootstrap/lib/Panel.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_lib_Panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_lib_Panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var StyledPanelTitle=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_lib_Panel___default.a.Title).withConfig({displayName:'StyledPanelTitle',componentId:'p2qlz-0'})(['margin-bottom:',';& a{font-size:',';color:',';font-family:',';font-weight:',';text-decoration:none;}'],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('base'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontFamily.headline'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontWeight.bold'));/* harmony default export */ __webpack_exports__["a"] = (StyledPanelTitle);

/***/ }),

/***/ "./src/blocks/PanelGroup/accordionStyles.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/blocks/PanelGroup/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Panel__ = __webpack_require__("./node_modules/react-bootstrap/lib/Panel.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_lib_PanelGroup__ = __webpack_require__("./node_modules/react-bootstrap/lib/PanelGroup.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_lib_PanelGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_lib_PanelGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StyledPanelBody__ = __webpack_require__("./src/blocks/PanelGroup/StyledPanelBody.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StyledPanelTitle__ = __webpack_require__("./src/blocks/PanelGroup/StyledPanelTitle.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__accordionStyles_css__ = __webpack_require__("./src/blocks/PanelGroup/accordionStyles.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__accordionStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__accordionStyles_css__);
var _templateObject=_taggedTemplateLiteral(['\n        padding: 0 ',';\n    '],['\n        padding: 0 ',';\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var PanelGroup=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_lib_PanelGroup___default.a).withConfig({displayName:'PanelGroup',componentId:'sc-1eadlml-0'})(['width:100%;',';'],__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s')));PanelGroup.Panel=__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Panel___default.a;PanelGroup.Heading=__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Panel___default.a.Heading;PanelGroup.Title=__WEBPACK_IMPORTED_MODULE_6__StyledPanelTitle__["a" /* default */];PanelGroup.Body=__WEBPACK_IMPORTED_MODULE_5__StyledPanelBody__["a" /* default */];/* harmony default export */ __webpack_exports__["a"] = (PanelGroup);

/***/ }),

/***/ "./src/blocks/Parser/Parser.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styleFactory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HTMLParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html_react_parser__ = __webpack_require__("./node_modules/html-react-parser/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html_react_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_html_react_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_consts_kentico__ = __webpack_require__("./src/common/consts/kentico.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__ = __webpack_require__("./src/common/consts/domNodes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_elements_Header2__ = __webpack_require__("./src/elements/Header2.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_elements_Header3__ = __webpack_require__("./src/elements/Header3.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_elements_Header4__ = __webpack_require__("./src/elements/Header4.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_elements_Header5__ = __webpack_require__("./src/elements/Header5.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_elements_Paragraph__ = __webpack_require__("./src/elements/Paragraph.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_elements_BlogArticleBoldText__ = __webpack_require__("./src/elements/BlogArticleBoldText.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_elements_Image__ = __webpack_require__("./src/elements/Image.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_models_HtmlModifier_model__ = __webpack_require__("./src/models/HtmlModifier.model.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_kentico_blocks_DividedBlogSection__ = __webpack_require__("./src/kentico-blocks/DividedBlogSection/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_kentico_blocks_BlogImageSlider__ = __webpack_require__("./src/kentico-blocks/BlogImageSlider/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_kentico_blocks_ImageLink__ = __webpack_require__("./src/kentico-blocks/ImageLink/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_window_or_global__ = __webpack_require__("./node_modules/window-or-global/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_elements_UnorderedList__ = __webpack_require__("./src/elements/UnorderedList.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_elements_OrderedList__ = __webpack_require__("./src/elements/OrderedList.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_elements_LI__ = __webpack_require__("./src/elements/LI.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_elements_BlogArticleLink__ = __webpack_require__("./src/elements/BlogArticleLink.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable no-empty,no-console */var BoldText=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__["a" /* default */].STRONG).withConfig({displayName:'Parser__BoldText',componentId:'sc-1gmn4vs-0'})(['font-weight:bold;']);var ItalicText=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__["a" /* default */].I).withConfig({displayName:'Parser__ItalicText',componentId:'sc-1gmn4vs-1'})(['']);/* Disable ESlint rules for this file *//* eslint react/jsx-one-expression-per-line: "off" *//* eslint react/require-default-props: "off" *//* eslint react/forbid-prop-types: "off" *//* eslint react/no-array-index-key: "off" */var styleFactory=function styleFactory(htmlModifiers){var inlineStyles={};if(htmlModifiers){htmlModifiers.forEach(function(htmlModifier){switch(htmlModifier.property){case __WEBPACK_IMPORTED_MODULE_5_common_consts_kentico__["b" /* KENTICO_HTML_MODIFIERS */].BACKGROUND_COLOR:inlineStyles.backgroundColor=htmlModifier.value;break;case __WEBPACK_IMPORTED_MODULE_5_common_consts_kentico__["b" /* KENTICO_HTML_MODIFIERS */].COLOR:inlineStyles.color=htmlModifier.value;break;case __WEBPACK_IMPORTED_MODULE_5_common_consts_kentico__["b" /* KENTICO_HTML_MODIFIERS */].PADDING_TOP:inlineStyles.paddingTop=htmlModifier.value;break;case __WEBPACK_IMPORTED_MODULE_5_common_consts_kentico__["b" /* KENTICO_HTML_MODIFIERS */].PADDING_RIGHT:inlineStyles.paddingRight=htmlModifier.value;break;case __WEBPACK_IMPORTED_MODULE_5_common_consts_kentico__["b" /* KENTICO_HTML_MODIFIERS */].PADDING_BOTTOM:inlineStyles.paddingBottom=htmlModifier.value;break;case __WEBPACK_IMPORTED_MODULE_5_common_consts_kentico__["b" /* KENTICO_HTML_MODIFIERS */].PADDING_LEFT:inlineStyles.paddingLeft=htmlModifier.value;break;case __WEBPACK_IMPORTED_MODULE_5_common_consts_kentico__["b" /* KENTICO_HTML_MODIFIERS */].MARGIN_TOP:inlineStyles.marginTop=htmlModifier.value;break;case __WEBPACK_IMPORTED_MODULE_5_common_consts_kentico__["b" /* KENTICO_HTML_MODIFIERS */].MARGIN_RIGHT:inlineStyles.marginRight=htmlModifier.value;break;case __WEBPACK_IMPORTED_MODULE_5_common_consts_kentico__["b" /* KENTICO_HTML_MODIFIERS */].MARGIN_BOTTOM:inlineStyles.marginBottom=htmlModifier.value;break;case __WEBPACK_IMPORTED_MODULE_5_common_consts_kentico__["b" /* KENTICO_HTML_MODIFIERS */].MARGIN_LEFT:inlineStyles.marginLeft=htmlModifier.value;break;default:}});}return inlineStyles;};var HTMLParser=(_dec=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["inject"])('windowStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["observer"])(_class=(_temp=_class2=function(_Component){_inherits(HTMLParser,_Component);function HTMLParser(props){_classCallCheck(this,HTMLParser);var _this=_possibleConstructorReturn(this,(HTMLParser.__proto__||Object.getPrototypeOf(HTMLParser)).call(this,props));_this.windowStore=_this.props.windowStore;_this.parseHeader=function(domNode){if(domNode.name==='h2'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_elements_Header2__["a" /* default */],null,domNode.children[0].data);}if(domNode.name==='h3'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_elements_Header3__["a" /* default */],null,domNode.children[0].data);}if(domNode.name==='h4'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_elements_Header4__["a" /* default */],null,domNode.children[0].data);}if(domNode.name==='h5'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_elements_Header5__["a" /* default */],null,domNode.children[0].data);}return null;};_this.parseList=function(domNode){if(domNode.name===__WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__["a" /* default */].UL){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_elements_UnorderedList__["a" /* default */],null,domNode.children&&domNode.children.map(_this.parseFunction));}if(domNode.name===__WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__["a" /* default */].OL){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_elements_OrderedList__["a" /* default */],null,domNode.children&&domNode.children.map(_this.parseFunction));}return null;};_this.parseFunction=function(domNode){var header=_this.parseHeader(domNode);if(header){return header;}var list=_this.parseList(domNode);if(list){return list;}if(domNode.name===__WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__["a" /* default */].LI){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_elements_LI__["a" /* default */],null,domNode.children&&domNode.children.map(_this.parseFunction));}if(domNode.name===__WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__["a" /* default */].A){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_elements_BlogArticleLink__["a" /* default */],domNode.attribs,domNode.children&&domNode.children.map(_this.parseFunction));}if(domNode.name===__WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__["a" /* default */].EM){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItalicText,null,domNode.children&&domNode.children.map(_this.parseFunction));}if(domNode.name===__WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__["a" /* default */].STRONG){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_elements_BlogArticleBoldText__["a" /* default */],null,domNode.children&&domNode.children.map(_this.parseFunction));}if(domNode.name===__WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__["a" /* default */].DIV){if(!domNode.children.length)return null;var model=domNode.children[0].attribs;if(model.constructor===__WEBPACK_IMPORTED_MODULE_5_common_consts_kentico__["c" /* KENTICO_TYPES */].HEADER){try{_this.modifiedStyles=styleFactory(JSON.parse(__WEBPACK_IMPORTED_MODULE_18_window_or_global___default.a.atob(model.htmlmodifiers)));}catch(err){_this.modifiedStyles={};console.error('error when parsing html modifiers string to JSON by Parser: ',err);}switch(model.size){case __WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__["a" /* default */].H2:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_elements_Header2__["a" /* default */],{style:_this.modifiedStyles,dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_19_common_methods_string__["g" /* safeHtmlWithBr */])(model.text)}});case __WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__["a" /* default */].H3:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_elements_Header3__["a" /* default */],{style:_this.modifiedStyles,dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_19_common_methods_string__["g" /* safeHtmlWithBr */])(model.text)}});case __WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__["a" /* default */].H4:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_elements_Header4__["a" /* default */],{style:_this.modifiedStyles,dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_19_common_methods_string__["g" /* safeHtmlWithBr */])(model.text)}});case __WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__["a" /* default */].H5:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_elements_Header5__["a" /* default */],{style:_this.modifiedStyles,dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_19_common_methods_string__["g" /* safeHtmlWithBr */])(model.text)}});default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:_this.modifiedStyles},' ',' ');}}else if(model.constructor===__WEBPACK_IMPORTED_MODULE_5_common_consts_kentico__["c" /* KENTICO_TYPES */].DIVIDED_BLOG_SECTION){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_kentico_blocks_DividedBlogSection__["a" /* default */],{data:model});}else if(model.constructor===__WEBPACK_IMPORTED_MODULE_5_common_consts_kentico__["c" /* KENTICO_TYPES */].BLOG_IMAGE_SLIDER){var slides=JSON.parse(model.slides);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_kentico_blocks_BlogImageSlider__["a" /* default */],{slides:slides});}}if(domNode.name===__WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__["a" /* default */].P){if(_this.cameFromBlogArticle){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_elements_Paragraph__["a" /* default */],{blogArticle:true},domNode.children.map(function(paragraphChild,index){if(paragraphChild.name===__WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__["a" /* default */].STRONG){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_elements_BlogArticleBoldText__["a" /* default */],{key:index,dangerouslySetInnerHTML:{__html:paragraphChild.children[0].data}});}if(paragraphChild.name===__WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__["a" /* default */].EM){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItalicText,{key:index,dangerouslySetInnerHTML:{__html:paragraphChild.children[0].data}});}if(paragraphChild.name===__WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__["a" /* default */].A){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_elements_BlogArticleLink__["a" /* default */],paragraphChild.attribs,paragraphChild&&paragraphChild.children.map(_this.parseFunction));}return paragraphChild.data;}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_elements_Paragraph__["a" /* default */],null,domNode.children.map(function(paragraphChild,index){if(paragraphChild.name===__WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__["a" /* default */].STRONG){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BoldText,{key:index,dangerouslySetInnerHTML:{__html:paragraphChild.children[0].data}});}if(paragraphChild.name===__WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__["a" /* default */].EM){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItalicText,{key:index,dangerouslySetInnerHTML:{__html:paragraphChild.children[0].data}});}return paragraphChild.data;}));}if(domNode.name===__WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__["a" /* default */].IMG){var _model=domNode.attribs;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_elements_Image__["a" /* default */],{src:_this.windowStore.adjustImageSize(_model.src),alt:_model.alt});}if(domNode.name===__WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__["a" /* default */].FIGURE&&domNode.children.length>0&&domNode.children[0].name===__WEBPACK_IMPORTED_MODULE_6_common_consts_domNodes__["a" /* default */].IMG){var _model2=domNode.children[0].attribs;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_elements_Image__["a" /* default */],{src:_this.windowStore.adjustImageSize(_model2.src),alt:_model2.alt,style:_this.modifiedStyles});}return domNode.data;};_this.parserOptions={replace:_this.parseFunction};var htmlModifiers=props.htmlModifiers,blogArticle=props.blogArticle;_this.modifiedStyles=styleFactory(htmlModifiers);_this.cameFromBlogArticle=blogArticle;return _this;}_createClass(HTMLParser,[{key:'render',value:function render(){var htmlBody=this.props.htmlBody;return htmlBody?__WEBPACK_IMPORTED_MODULE_2_html_react_parser___default()(htmlBody.resolveHtml(),this.parserOptions):null;}}]);return HTMLParser;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class2.propTypes={htmlBody:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,htmlModifiers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_14_models_HtmlModifier_model__["a" /* default */])),blogArticle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool},_temp))||_class)||_class);

/***/ }),

/***/ "./src/blocks/PrivacyPolicy/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrivacyPolicy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable react/prop-types */var StyledContainer=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_blocks_Container_Container__["a" /* default */]).withConfig({displayName:'PrivacyPolicy__StyledContainer',componentId:'ft2izr-0'})(['margin-top:125px;padding:0 20px;']);var PrivacyPolicy=(_dec=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["inject"])("coreStore"),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"])(_class=function(_Component){_inherits(PrivacyPolicy,_Component);function PrivacyPolicy(){_classCallCheck(this,PrivacyPolicy);return _possibleConstructorReturn(this,(PrivacyPolicy.__proto__||Object.getPrototypeOf(PrivacyPolicy)).apply(this,arguments));}_createClass(PrivacyPolicy,[{key:'render',value:function render(){var translations=this.props.coreStore.translations;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledContainer,{dangerouslySetInnerHTML:{__html:translations.PRIVACY_POLICY}});}}]);return PrivacyPolicy;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);

/***/ }),

/***/ "./src/blocks/Regulations/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Regulations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable react/prop-types */var StyledContainer=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_blocks_Container_Container__["a" /* default */]).withConfig({displayName:'Regulations__StyledContainer',componentId:'x6kya7-0'})(['margin-top:125px;padding:0 20px;']);var Regulations=(_dec=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["inject"])("coreStore"),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["observer"])(_class=function(_Component){_inherits(Regulations,_Component);function Regulations(){_classCallCheck(this,Regulations);return _possibleConstructorReturn(this,(Regulations.__proto__||Object.getPrototypeOf(Regulations)).apply(this,arguments));}_createClass(Regulations,[{key:'render',value:function render(){var _props=this.props,translations=_props.coreStore.translations,isAppRegulations=_props.isAppRegulations;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledContainer,{dangerouslySetInnerHTML:{__html:isAppRegulations?translations.APPLICATION_REGULATIONS:translations.REGULATIONS}});}}]);return Regulations;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);Regulations.propTypes={isAppRegulations:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};Regulations.defaultProps={isAppRegulations:false};

/***/ }),

/***/ "./src/blocks/ScrollDiv/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var ScrollDiv=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'ScrollDiv',componentId:'sc-1cvixoz-0'})(['position:relative;height:0;top:',';pointer-events:none;'],function(_ref){var offset=_ref.offset;return offset||'0';});/* harmony default export */ __webpack_exports__["a"] = (ScrollDiv);

/***/ }),

/***/ "./src/blocks/ShareMechanism/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShareMechanism; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_window_or_global__ = __webpack_require__("./node_modules/window-or-global/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_images_shareIcon_png__ = __webpack_require__("./src/common/images/shareIcon.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_images_shareIcon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_common_images_shareIcon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_elements_Header5__ = __webpack_require__("./src/elements/Header5.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_share__ = __webpack_require__("./node_modules/react-share/es/index.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _templateObject=_taggedTemplateLiteral(['\n    zoom: 1;\n  '],['\n    zoom: 1;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n      position:relative;\n      height:55px;\n      width:120px;\n      border:2px solid ',';\n      border-radius:',';\n      overflow:hidden;\n      background-color:',';\n      transition:height 0.4s, background-color 0.4s, border 0.4s;\n      transition-delay: 0.12s;\n      margin-top:',';\n\n      &:hover{\n          height:200px;\n          border:2px solid ',';\n          background-color:',';\n      };\n  '],['\n      position:relative;\n      height:55px;\n      width:120px;\n      border:2px solid ',';\n      border-radius:',';\n      overflow:hidden;\n      background-color:',';\n      transition:height 0.4s, background-color 0.4s, border 0.4s;\n      transition-delay: 0.12s;\n      margin-top:',';\n\n      &:hover{\n          height:200px;\n          border:2px solid ',';\n          background-color:',';\n      };\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    flex-direction: column;\n    margin-top: 0;\n  '],['\n    flex-direction: column;\n    margin-top: 0;\n  ']),_templateObject4=_taggedTemplateLiteral(['\n      margin: 8px ',' 8px 0;\n    '],['\n      margin: 8px ',' 8px 0;\n    ']),_templateObject5=_taggedTemplateLiteral(['  \n      margin: 5px auto;\n    '],['  \n      margin: 5px auto;\n    ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var ShareBox=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({displayName:'ShareMechanism__ShareBox',componentId:'swe37s-0'})(['zoom:0.85;',' ',';'],__WEBPACK_IMPORTED_MODULE_3_designsystem_index__["c" /* media */].mobile(_templateObject),__WEBPACK_IMPORTED_MODULE_3_designsystem_index__["c" /* media */].desktop(_templateObject2,__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.base'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('darkBackground'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('darkBackground'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('white')));var ShareIcon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({displayName:'ShareMechanism__ShareIcon',componentId:'swe37s-1'})(['background-image:url(',');height:35px;width:35px;background-repeat:no-repeat;margin:',' auto ',';'],__WEBPACK_IMPORTED_MODULE_6_common_images_shareIcon_png___default.a,__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.s'));var SharesList=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({displayName:'ShareMechanism__SharesList',componentId:'swe37s-2'})(['display:flex;flex-wrap:wrap;margin-top:',';',';'],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_3_designsystem_index__["c" /* media */].desktop(_templateObject3));var socialShareButton=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(['outline:none;display:flex;border-radius:5px;overflow:hidden;height:26px;width:100px;margin:8px ',' 8px 0;opacity:0.95;justify-content:',';&:hover{opacity:1;}',' ',';'],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.xs'),function(_ref){var isPolishLanguage=_ref.isPolishLanguage;return isPolishLanguage?'flex-start':'center';},__WEBPACK_IMPORTED_MODULE_3_designsystem_index__["c" /* media */].mobile(_templateObject4,__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.s')),__WEBPACK_IMPORTED_MODULE_3_designsystem_index__["c" /* media */].desktop(_templateObject5));var FacebookShare=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8_react_share__["b" /* FacebookShareButton */]).withConfig({displayName:'ShareMechanism__FacebookShare',componentId:'swe37s-3'})(['',';background-color:',';'],socialShareButton,function(_ref2){var color=_ref2.color;return color;});var TwitterShare=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8_react_share__["f" /* TwitterShareButton */]).withConfig({displayName:'ShareMechanism__TwitterShare',componentId:'swe37s-4'})(['',';background-color:',';'],socialShareButton,function(_ref3){var color=_ref3.color;return color;});var LinkedinShare=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8_react_share__["d" /* LinkedinShareButton */]).withConfig({displayName:'ShareMechanism__LinkedinShare',componentId:'swe37s-5'})(['',';background-color:',';margin-right:0;'],socialShareButton,function(_ref4){var color=_ref4.color;return color;});var ShareText=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_7_elements_Header5__["a" /* default */]).withConfig({displayName:'ShareMechanism__ShareText',componentId:'swe37s-6'})(['font-size:',';color:',';margin:0;padding-top:1px;padding-right:',';'],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('s'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('white'),function(_ref5){var isPolishLanguage=_ref5.isPolishLanguage;return isPolishLanguage?'6px':'10px';});var ShareMechanism=(_dec=Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["inject"])('windowStore','coreStore','appStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["observer"])(_class=function(_Component){_inherits(ShareMechanism,_Component);function ShareMechanism(){_classCallCheck(this,ShareMechanism);return _possibleConstructorReturn(this,(ShareMechanism.__proto__||Object.getPrototypeOf(ShareMechanism)).apply(this,arguments));}_createClass(ShareMechanism,[{key:'render',value:function render(){var url=__WEBPACK_IMPORTED_MODULE_4_window_or_global___default.a.location.href;var _props=this.props,windowStore=_props.windowStore,translations=_props.coreStore.translations,isPolishLanguage=_props.appStore.isPolishLanguage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShareBox,null,!windowStore.isOnTablet&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShareIcon,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SharesList,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FacebookShare,{url:url,color:__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].color('social','fb'),isPolishLanguage:isPolishLanguage},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_share__["a" /* FacebookIcon */],{size:28,round:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShareText,{isPolishLanguage:isPolishLanguage,bold:true},translations.BLOG_SHARE)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TwitterShare,{url:url,color:__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].color('social','tw'),isPolishLanguage:isPolishLanguage},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_share__["e" /* TwitterIcon */],{size:28,round:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShareText,{isPolishLanguage:isPolishLanguage,bold:true},'Tweet')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LinkedinShare,{url:url,color:__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].color('social','link'),isPolishLanguage:isPolishLanguage},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_share__["c" /* LinkedinIcon */],{size:28,round:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShareText,{isPolishLanguage:isPolishLanguage,bold:true},translations.BLOG_SHARE))));}}]);return ShareMechanism;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);

/***/ }),

/***/ "./src/blocks/SliderButtons/ArrowLeft.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blocks_Arrow_Arrow__ = __webpack_require__("./src/blocks/Arrow/Arrow.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var _templateObject=_taggedTemplateLiteral(['\n  position: absolute;\n  right: -16px;\n  transition: right 0.25s;\n  transform: rotate(135deg);\n  margin-right: 29px;\n  \n  animation: ',';\n  \n  ',';  \n'],['\n  position: absolute;\n  right: -16px;\n  transition: right 0.25s;\n  transform: rotate(135deg);\n  margin-right: 29px;\n  \n  animation: ',';\n  \n  ',';  \n']),_templateObject2=_taggedTemplateLiteral(['\n    right: -2px;\n    transform: rotate(135deg);\n  '],['\n    right: -2px;\n    transform: rotate(135deg);\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var activeAnimation=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["keyframes"])(['0%{transform:scale(0.95) translateX(3px) rotate(135deg);}50%{transform:scale(1.05) translateX(-2px) rotate(135deg);}100%{transform:scale(0.95) translateX(3px) rotate(135deg);}']);var ArrowLeft=__WEBPACK_IMPORTED_MODULE_1_blocks_Arrow_Arrow__["a" /* default */].extend(_templateObject,function(_ref){var animate=_ref.animate;return animate?activeAnimation+' 1.75s ease-in-out infinite':'none';},__WEBPACK_IMPORTED_MODULE_0_designsystem_index__["c" /* media */].desktop(_templateObject2));/* harmony default export */ __webpack_exports__["a"] = (ArrowLeft);

/***/ }),

/***/ "./src/blocks/SliderButtons/ArrowRight.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blocks_Arrow_Arrow__ = __webpack_require__("./src/blocks/Arrow/Arrow.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var _templateObject=_taggedTemplateLiteral(['\n  position: absolute;\n\n  transition: left 0.25s;\n  transform: rotate(-45deg);\n  left: 12px;\n  margin-left: 0;\n  animation: ',';\n  \n  ',';\n'],['\n  position: absolute;\n\n  transition: left 0.25s;\n  transform: rotate(-45deg);\n  left: 12px;\n  margin-left: 0;\n  animation: ',';\n  \n  ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n    left: -2px;\n    transform: rotate(-45deg);\n    margin-left: 28px;\n  '],['\n    left: -2px;\n    transform: rotate(-45deg);\n    margin-left: 28px;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var activeAnimation=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["keyframes"])(['0%{transform:scale(0.95) translateX(-3px) rotate(-45deg);}50%{transform:scale(1.05) translateX(2px) rotate(-45deg);}100%{transform:scale(0.95) translateX(-3px) rotate(-45deg);}']);var ArrowRight=__WEBPACK_IMPORTED_MODULE_1_blocks_Arrow_Arrow__["a" /* default */].extend(_templateObject,function(_ref){var animate=_ref.animate;return animate?activeAnimation+' 1.75s ease-in-out infinite':'none';},__WEBPACK_IMPORTED_MODULE_0_designsystem_index__["c" /* media */].desktop(_templateObject2));/* harmony default export */ __webpack_exports__["a"] = (ArrowRight);

/***/ }),

/***/ "./src/blocks/SliderButtons/Button.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_elements_Button__ = __webpack_require__("./src/elements/Button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ArrowLeft__ = __webpack_require__("./src/blocks/SliderButtons/ArrowLeft.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ArrowRight__ = __webpack_require__("./src/blocks/SliderButtons/ArrowRight.jsx");
var _templateObject=_taggedTemplateLiteral(['\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  width: ',';\n  height: ',';\n  margin: 0;\n  padding: 0;\n  background-color: ',';\n  outline: none;\n  \n  ',';\n  \n  &:hover, &:focus {\n    background-color: ',';\n    filter: brightness(95%);\n  }\n  \n  &:hover, &:focus ',' {\n    transition-duration: 0.15s;\n  }\n  \n  &:hover, &:focus ',' {\n    transition-duration: 0.15s;\n  }\n  \n  &:active {\n    background-color: ',';\n  }\n'],['\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  width: ',';\n  height: ',';\n  margin: 0;\n  padding: 0;\n  background-color: ',';\n  outline: none;\n  \n  ',';\n  \n  &:hover, &:focus {\n    background-color: ',';\n    filter: brightness(95%);\n  }\n  \n  &:hover, &:focus ',' {\n    transition-duration: 0.15s;\n  }\n  \n  &:hover, &:focus ',' {\n    transition-duration: 0.15s;\n  }\n  \n  &:active {\n    background-color: ',';\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n    width: 70px;\n    height: 70px;\n  '],['\n    width: 70px;\n    height: 70px;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Button=__WEBPACK_IMPORTED_MODULE_0_elements_Button__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].desktop(_templateObject2),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_3__ArrowLeft__["a" /* default */],__WEBPACK_IMPORTED_MODULE_4__ArrowRight__["a" /* default */],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white'));/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),

/***/ "./src/blocks/SliderButtons/SliderButton.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__("./src/blocks/SliderButtons/Button.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ArrowLeft__ = __webpack_require__("./src/blocks/SliderButtons/ArrowLeft.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ArrowRight__ = __webpack_require__("./src/blocks/SliderButtons/ArrowRight.jsx");
var SliderButton=function SliderButton(props){var onClick=props.onClick,animateArrow=props.animateArrow,right=props.right;return right?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Button__["a" /* default */],{onClick:onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ArrowRight__["a" /* default */],{animate:animateArrow})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Button__["a" /* default */],{onClick:onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ArrowLeft__["a" /* default */],{animate:animateArrow}));};SliderButton.propTypes={onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,animateArrow:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,right:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};SliderButton.defaultProps={animateArrow:false,right:false};/* harmony default export */ __webpack_exports__["a"] = (SliderButton);

/***/ }),

/***/ "./src/blocks/SplashScreen/SplashScreenLogo.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var SplashScreenLogo=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].img.withConfig({displayName:'SplashScreenLogo',componentId:'g16gaf-0'})(['margin-top:-',';margin-left:-',';max-height:calc(2 * ',');'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.l'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xxl'));/* harmony default export */ __webpack_exports__["a"] = (SplashScreenLogo);

/***/ }),

/***/ "./src/blocks/SplashScreen/SplashScreenPageWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var SplashScreenPageWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'SplashScreenPageWrapper',componentId:'sc-19vsxwk-0'})(['width:100vw;height:100vh;position:fixed;top:0;left:0;z-index:9999;display:flex;justify-content:center;align-items:center;background-color:',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white'));/* harmony default export */ __webpack_exports__["a"] = (SplashScreenPageWrapper);

/***/ }),

/***/ "./src/blocks/SplashScreen/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_images_loader_gif__ = __webpack_require__("./src/common/images/loader.gif");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_images_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_images_loader_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SplashScreenPageWrapper__ = __webpack_require__("./src/blocks/SplashScreen/SplashScreenPageWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SplashScreenLogo__ = __webpack_require__("./src/blocks/SplashScreen/SplashScreenLogo.jsx");
var SplashScreen=function SplashScreen(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SplashScreenPageWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SplashScreenLogo__["a" /* default */],{src:__WEBPACK_IMPORTED_MODULE_1_common_images_loader_gif___default.a}));};/* harmony default export */ __webpack_exports__["a"] = (SplashScreen);

/***/ }),

/***/ "./src/blocks/StyledLink/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledBlogLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_LanguageLink__ = __webpack_require__("./src/elements/LanguageLink.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
var StyledLink=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2__elements_LanguageLink__["a" /* default */]).withConfig({displayName:'StyledLink',componentId:'sc-1irpndz-0'})(['text-decoration:none;&:focus,&:hover,&:visited,&:link,&:active{text-decoration:none;}']);var StyledBlogLink=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["NavLink"]).withConfig({displayName:'StyledLink__StyledBlogLink',componentId:'sc-1irpndz-1'})(['text-decoration:none;&:focus,&:hover,&:visited,&:link,&:active{text-decoration:none;}']);/* harmony default export */ __webpack_exports__["b"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledLink,props);});

/***/ }),

/***/ "./src/common/consts/anchor.js":
/***/ (function(module, exports) {

var ANCHOR={HOME:{pl:'/',en:'/',fr:'/'},BLOG:{pl:'/blog',en:'/blog',fr:'/blog'},PRIVACY_POLICY:{pl:'https://tenderhut.com/dane-osobowe',en:'https://tenderhut.com/en/personal-data',fr:'https://tenderhut.com/en/personal-data'},REGULATIONS:{pl:'/regulamin-strony',en:'/terms-of-use',fr:'/conditions-dutilisation'},APPLICATION_REGULATIONS:{pl:'/regulamin-aplikacji',en:'/app-terms-of-use',fr:'/conditions-dutilisation-de-lapplication'},CONTACT_FORM:{pl:'/contact',en:'/contact',fr:'/contact'},LOBBYPASSPORT:{pl:'/lobbypassport',en:'/lobbypassport',fr:'/lobbypassport'},WORKSPACE:{pl:'/workplace',en:'/workplace',fr:'/workplace'},TV:{pl:'/tv',en:'/tv',fr:'/tv'},SERVICES:{pl:'/services',en:'/services',fr:'/services'},FAQ:{pl:'/faq',en:'/faq',fr:'/faq'},FOR_INVESTORS:{pl:'/for-investors',en:'/for-investors',fr:'/for-investors'},THANK_YOU:{pl:'/thank-you',en:'/thank-you',fr:'/thank-you'},SUBSCRIPTION_CONFIRMED:{pl:'/subscription-confirmed',en:'/subscription-confirmed',fr:'/subscription-confirmed'},WORK:{pl:'/praca',en:'/praca',fr:'/praca'}};module.exports=ANCHOR;

/***/ }),

/***/ "./src/common/consts/blog.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BLOG_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_BLOG_FILTER; });
var BLOG_SETTINGS={LISTING:{DEFAULT_LIMIT:6,LOAD_ARTICLES_COUNT:3},ARTICLE:{DEFAULT_LIMIT:3,LOAD_ARTICLES_COUNT:3},ARTICLE_CHARS_LIMIT:150,ARTICLE_SEO_DESCRIPTION_LIMIT:200};// todo - lang service !!
var DEFAULT_BLOG_FILTER={name:'all articles',value:''};

/***/ }),

/***/ "./src/common/consts/calculator.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var CALCULATOR={desktopHeight:1000};/* harmony default export */ __webpack_exports__["a"] = (CALCULATOR);

/***/ }),

/***/ "./src/common/consts/containerWidth.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var containerWidth=1366;/* harmony default export */ __webpack_exports__["a"] = (containerWidth);

/***/ }),

/***/ "./src/common/consts/cookies.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var COOKIE_KEY='cookieAgrement';/* harmony default export */ __webpack_exports__["a"] = (COOKIE_KEY);

/***/ }),

/***/ "./src/common/consts/debugOptionConsts.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEBUG_OPTION_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DEBUG_VALUE_MODE_PREVIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DEBUG_VALUE_MODE_PUBLISHED; });
/* unused harmony export DEBUG_OPTION_LANGUAGE */
/* unused harmony export DEBUG_VALUE_LANGUAGE_ENGLISH */
/* unused harmony export DEBUG_VALUE_LANGUAGE_POLISH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEBUG_OPTION_GRID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DEBUG_VALUE_GRID_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DEBUG_VALUE_GRID_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEBUG_CONFIG_SESSION_STORAGE_KEY; });
var DEBUG_OPTION_MODE='Mode';var DEBUG_VALUE_MODE_PREVIEW='Preview';var DEBUG_VALUE_MODE_PUBLISHED='Published';var DEBUG_OPTION_LANGUAGE='Language';var DEBUG_VALUE_LANGUAGE_ENGLISH='en';var DEBUG_VALUE_LANGUAGE_POLISH='pl';var DEBUG_OPTION_GRID='Grid';var DEBUG_VALUE_GRID_OFF='OFF';var DEBUG_VALUE_GRID_ON='ON';var DEBUG_CONFIG_SESSION_STORAGE_KEY='zonifero_debug_config';

/***/ }),

/***/ "./src/common/consts/dividedSectionOrder.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var DIVIDED_SECTION_ORDER={CITE_IMAGE:'cite : image',IMAGE_CITE:'image : cite'};/* harmony default export */ __webpack_exports__["a"] = (DIVIDED_SECTION_ORDER);

/***/ }),

/***/ "./src/common/consts/domNodes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var DOM_NODES={DIV:'div',P:'p',STRONG:'strong',EM:'em',I:'i',UL:'ul',OL:'ol',LI:'li',H2:'H2',H3:'H3',H4:'H4',H5:'H5',FIGURE:'figure',IMG:'img',A:'a'};/* harmony default export */ __webpack_exports__["a"] = (DOM_NODES);

/***/ }),

/***/ "./src/common/consts/form.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var FORM={DESKTOP_TEXT_AREA_LINE_HEIGHT:38,SUCCESS_MESSAGE_TIMEOUT:2000,BUTTON_STATE:{SUCCESS:'success',ERROR:'error',LOADING:'loading'}};/* harmony default export */ __webpack_exports__["a"] = (FORM);

/***/ }),

/***/ "./src/common/consts/hrefs.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var HREFS={SIGN_IN:'https://portal.zonifero.com/',LINKED_IN:'https://www.linkedin.com/company/zonifero/',FACEBOOK:'https://www.facebook.com/zonifero/',EXTRAHUT:'https://www.extrahut.com/'};/* harmony default export */ __webpack_exports__["a"] = (HREFS);

/***/ }),

/***/ "./src/common/consts/kentico.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PROJECT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PREVIEW_API_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return KENTICO_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KENTICO_CONSTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return KENTICO_HTML_MODIFIERS; });
var PROJECT_ID='b17309a6-c1a6-4783-8b34-1e273f6881cc';var PREVIEW_API_KEY=Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_CONTACT_FORM_MAIL_TO":"https://prod-11.westeurope.logic.azure.com:443/workflows/469daeb9e0814284944a6823e010e5a8/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=LDw4OCmhrzknYryf6NZR0l3HUvOO4sOrJ4KrLNKgQF4","REACT_APP_CONTACT_FORM_SUPPORT_MAIL_TO":"https://prod-16.westeurope.logic.azure.com:443/workflows/07509f2760d64838bdf665f7d4c46e93/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=RU0-XCUoC4Qpr8vUzhRzGqBG6tSvXSkO9nkxjqaxCPI","REACT_APP_DEBUG":"false","REACT_APP_GEOLOCATION_API":"https://ipinfo.io/json?token=ea4d0cf5569d7d","REACT_APP_NEWSLETTER":"https://zonifero-new-www-dev-linux-fap.azurewebsites.net/api/getResponse","REACT_APP_PIPEDRIVE":"https://thg-d-www-pipedrive-fap.azurewebsites.net/api/postnote?code=Ils3YzEnC4e_eucIqh-bmAFyZfiILKHctzHGfhApQ46-AzFun4AhSA%3D%3D","REACT_APP_PROXY_BASE_URL":"https://tender-cms-api.azurewebsites.net","REACT_APP_RECAPTCHA_SECRET_KEY":"6Ld2rL0kAAAAAMu9_rMrS0HMhPpbzlO9L11OpDSS","REACT_APP_RECAPTCHA_SITE_KEY":"6Ld2rL0kAAAAAPMldKss1yYJmpWfSil0UPlBBlqh","REACT_APP_SEARCH_CONSOLE_CODE":"vLvp2xQcuyTV0NJMTAfXrgRLTIvTQg3LC-PmKOg7rHo","REACT_APP_SECURITY_APP":"https://swh-p-spambotprot-fap.azurewebsites.net/api/SpamBotProtection","REACT_APP_TAG_MANAGER_ID":"GTM-KB24WRL"}).REACT_APP_PREVIEW_API_KEY;var KENTICO_TYPES={PRODUCT:'product',THREE_COLUMN_GRID:'n3_columns_grid',TWO_COLUMN_GRID:'n2_columns_grid',HEADER:'header',ACCORDION:'accordion',ACCORDION_ITEM:'accordion_item',ARTICLE_SLIDE:'article_slide',ARTICLE_SLIDER:'article_slider',DOWNLOAD_BAR:'download_bar',BANNER:'banner',CARD_SLIDER:'card_slider',CARD_SLIDE:'card_slide',IMAGE_SLIDER:'image_slider',IMAGE_SLIDE:'image_slide',SIMPLE_ACCORDION:'simple_accordion',SIMPLE_ACCORDION_ITEM:'simple_accordion_item',FILE_LINK:'file_link',IMAGED_SECTION:'imaged_section',NAVIGATOR:'navigator',CONTACT_FORM:'contact_form',CONTACT_FORM_SUPPORT:'contact_form_support',HERO_IMAGE:'hero_image',CALL_US:'call_us',CONTACT_PERSON:'contact_person',ContactLink:'contact_link',HORIZONTALLY_NAVIGABLE_CONTENT:'horizontally_navigable_content',CONTENT_WITH_HEADER:'content_with_header',SEO:'seo',SHARE_LINK:'share_link',COLUMN:'column',HTML_MODIFIER:'html_modifier',TRANSLATIONS:'translations',CORE:'core',BLOG_ARTICLE:'blog_article',BLOG_AUTHOR:'blog_author',NEWSLETTER:'newsletter',LINK_BANNER:'link_banner',DIVIDED_BLOG_SECTION:'divided_blog_section',BLOG_IMAGE_SLIDER:'blog_image_slider',BLOG_IMAGE_SLIDE:'blog_image_slide',LINK_TO_PRODUCT:'link_to_product',PRODUCT_SLIDER:'product_slider',PRODUCT_SLIDE:'product_slide',CROPPED_ASSET:'cropped_asset',CALCULATOR:'calculator',CALCULATOR_VALUE:'calculator_value',BLOG_CATEGORY_TRANSLATION:'blog_category_translation',IMAGE_LINK:'image_link',TITLE_AND_SUBTITLE:'title_and_subtitle',FAQ_ACCORDION:'faq_accordion',FAQ_ACCORDION_ITEM:'faq_accordion_item',FOR_INVESTORS:'forinvestors',FOR_INVESTORS_SECTION:'for_investors_section',// FOR_INVESTORS_ITEM: 'for_investors_item',
GLOBAL_META_TAGS:'global_meta_tags',GLOBAL_META_TAG:'global_meta_tag_element',NEWSLETTER_THANK_YOU_PAGE:'newsletter_thank_you_page'};var KENTICO_CONSTS={MARKET_GOOGLE_PLAY_CODENAME:'google_play',MARKET_APP_STORE_CODENAME:'app_store'};var KENTICO_HTML_MODIFIERS={COLOR:'color',MARGIN_TOP:'margin-top',MARGIN_LEFT:'margin-left',MARGIN_BOTTOM:'margin-bottom',MARGIN_RIGHT:'margin-right',BACKGROUND_COLOR:'background-color',PADDING_TOP:'padding-top',PADDING_LEFT:'padding-left',PADDING_RIGHT:'padding-right',PADDING_BOTTOM:'padding-bottom'};

/***/ }),

/***/ "./src/common/consts/languages.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LANGUAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BLOG_LANGUAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LANGUAGE_STORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_LANGUAGE; });
var LANGUAGES={EN:{name:'EN',value:'en'},PL:{name:'PL',value:'pl'},FR:{name:'FR',value:'fr'}/*
  SE: {
    name: 'SE',
    value: 'se',
  },
  DE: {
    name: 'DE',
    value: 'de',
  },
  RU: {
    name: 'RU',
    value: 'ru',
  },
  */};var BLOG_LANGUAGES={EN:{name:'EN',value:'en'},PL:{name:'PL',value:'pl'}};var LANGUAGE_STORAGE_KEY='zonifero-language';var DEFAULT_LANGUAGE=LANGUAGES.EN.value;

/***/ }),

/***/ "./src/common/consts/navigation.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NAV_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MOBILE_NAV_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MOBILE_NAV_TRANSITION_SPEED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MOBILE_NAV_TRANSITION_FUNCTION; });
var NAV_HEIGHT=70;var MOBILE_NAV_HEIGHT='100vh';var MOBILE_NAV_TRANSITION_SPEED='400ms';var MOBILE_NAV_TRANSITION_FUNCTION='ease-in-out';

/***/ }),

/***/ "./src/common/consts/navigationItem.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return navigationItemID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isNavItem; });
var navigationItemID='navigationItem';var isNavItem='true';

/***/ }),

/***/ "./src/common/consts/person-image.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return smallImageWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mediumImageWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bigImageWidth; });
var smallImageWidth='130px';var mediumImageWidth='160px';var bigImageWidth='180px';

/***/ }),

/***/ "./src/common/consts/scroll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SCROLL={MOBILE_TOP_OFFSET:30,DESKTOP_TOP_OFFSET:150,SIMPLE_ACCORDION_TOP_OFFSET:200};/* harmony default export */ __webpack_exports__["a"] = (SCROLL);

/***/ }),

/***/ "./src/common/consts/window.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var WINDOW={TOP:'top',BOTTOM:'bottom'};/* harmony default export */ __webpack_exports__["a"] = (WINDOW);

/***/ }),

/***/ "./src/common/fonts/poppins-v5-latin-ext-700.woff":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/poppins-v5-latin-ext-700.1271e83e.woff";

/***/ }),

/***/ "./src/common/fonts/poppins-v5-latin-ext-700.woff2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/poppins-v5-latin-ext-700.1ad68bab.woff2";

/***/ }),

/***/ "./src/common/fonts/poppins-v5-latin-ext-regular.woff":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/poppins-v5-latin-ext-regular.25700972.woff";

/***/ }),

/***/ "./src/common/fonts/poppins-v5-latin-ext-regular.woff2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/poppins-v5-latin-ext-regular.6fc407b7.woff2";

/***/ }),

/***/ "./src/common/fonts/roboto-v18-latin-ext_latin-300.woff":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/roboto-v18-latin-ext_latin-300.d687dd23.woff";

/***/ }),

/***/ "./src/common/fonts/roboto-v18-latin-ext_latin-300.woff2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/roboto-v18-latin-ext_latin-300.3cb9e8d5.woff2";

/***/ }),

/***/ "./src/common/fonts/roboto-v18-latin-ext_latin-regular.woff":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/roboto-v18-latin-ext_latin-regular.1fb51f52.woff";

/***/ }),

/***/ "./src/common/fonts/roboto-v18-latin-ext_latin-regular.woff2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/roboto-v18-latin-ext_latin-regular.e5d046dd.woff2";

/***/ }),

/***/ "./src/common/global-styles.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_normalize__ = __webpack_require__("./node_modules/styled-normalize/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_normalize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_styled_normalize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fonts_poppins_v5_latin_ext_regular_woff__ = __webpack_require__("./src/common/fonts/poppins-v5-latin-ext-regular.woff");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fonts_poppins_v5_latin_ext_regular_woff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fonts_poppins_v5_latin_ext_regular_woff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fonts_poppins_v5_latin_ext_regular_woff2__ = __webpack_require__("./src/common/fonts/poppins-v5-latin-ext-regular.woff2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fonts_poppins_v5_latin_ext_regular_woff2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fonts_poppins_v5_latin_ext_regular_woff2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fonts_poppins_v5_latin_ext_700_woff__ = __webpack_require__("./src/common/fonts/poppins-v5-latin-ext-700.woff");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fonts_poppins_v5_latin_ext_700_woff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__fonts_poppins_v5_latin_ext_700_woff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fonts_poppins_v5_latin_ext_700_woff2__ = __webpack_require__("./src/common/fonts/poppins-v5-latin-ext-700.woff2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fonts_poppins_v5_latin_ext_700_woff2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fonts_poppins_v5_latin_ext_700_woff2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fonts_roboto_v18_latin_ext_latin_regular_woff__ = __webpack_require__("./src/common/fonts/roboto-v18-latin-ext_latin-regular.woff");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fonts_roboto_v18_latin_ext_latin_regular_woff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__fonts_roboto_v18_latin_ext_latin_regular_woff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fonts_roboto_v18_latin_ext_latin_regular_woff2__ = __webpack_require__("./src/common/fonts/roboto-v18-latin-ext_latin-regular.woff2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fonts_roboto_v18_latin_ext_latin_regular_woff2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__fonts_roboto_v18_latin_ext_latin_regular_woff2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fonts_roboto_v18_latin_ext_latin_300_woff__ = __webpack_require__("./src/common/fonts/roboto-v18-latin-ext_latin-300.woff");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fonts_roboto_v18_latin_ext_latin_300_woff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__fonts_roboto_v18_latin_ext_latin_300_woff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fonts_roboto_v18_latin_ext_latin_300_woff2__ = __webpack_require__("./src/common/fonts/roboto-v18-latin-ext_latin-300.woff2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fonts_roboto_v18_latin_ext_latin_300_woff2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__fonts_roboto_v18_latin_ext_latin_300_woff2__);
var _templateObject=_taggedTemplateLiteral(['\n','\n\n/* poppins-regular - latin-ext */\n@font-face {\n  font-family: \'Poppins\';\n  font-style: normal;\n  font-weight: 400;\n  src: url(\'','\') format(\'woff2\'), /* Chrome 26+, Opera 23+, Firefox 39+ */\n       url(\'','\') format(\'woff\'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */\n       local(\'Poppins Regular\'), local(\'Poppins-Regular\'),\n}\n/* poppins-700 - latin-ext */\n@font-face {\n  font-family: \'Poppins\';\n  font-style: normal;\n  font-weight: 700;\n  src: url(\'','\') format(\'woff2\'), /* Chrome 26+, Opera 23+, Firefox 39+ */\n       url(\'','\') format(\'woff\'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */\n       local(\'Poppins Bold\'), local(\'Poppins-Bold\'),\n}\n/* roboto-300 - latin-ext */\n@font-face {\n  font-family: \'Roboto\';\n  font-style: normal;\n  font-weight: 300;\n  src: url(\'','\') format(\'woff2\'), /* Chrome 26+, Opera 23+, Firefox 39+ */\n       url(\'','\') format(\'woff\'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */\n       local(\'Roboto Light\'), local(\'Roboto-Light\'),\n}\n/* roboto-regular - latin-ext */\n@font-face {\n  font-family: \'Roboto\';\n  font-style: normal;\n  font-weight: 400;\n  src: url(\'','\') format(\'woff2\'), /* Chrome 26+, Opera 23+, Firefox 39+ */\n       url(\'','\') format(\'woff\'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */\n       local(\'Roboto\'), local(\'Roboto-Regular\'),\n}\n\n* {\n  box-sizing: border-box;\n}\n\n.slick-slider .slick-dots li button::before {\n    font-size: 8px;\n    color: ',';\n    opacity: 0.7;\n}\n\n.slick-slider .slick-list {\n  margin-bottom: 25px;\n}\n\n.slick-slider .slick-dots li.slick-active button::before {\n    color: ',';\n    opacity: 1;\n}\n\n.slick-slider .slick-list .slick-track {\n  display: flex;\n}\n\n.slick-track div {\n  outline: none;\n}\n'],['\n','\n\n/* poppins-regular - latin-ext */\n@font-face {\n  font-family: \'Poppins\';\n  font-style: normal;\n  font-weight: 400;\n  src: url(\'','\') format(\'woff2\'), /* Chrome 26+, Opera 23+, Firefox 39+ */\n       url(\'','\') format(\'woff\'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */\n       local(\'Poppins Regular\'), local(\'Poppins-Regular\'),\n}\n/* poppins-700 - latin-ext */\n@font-face {\n  font-family: \'Poppins\';\n  font-style: normal;\n  font-weight: 700;\n  src: url(\'','\') format(\'woff2\'), /* Chrome 26+, Opera 23+, Firefox 39+ */\n       url(\'','\') format(\'woff\'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */\n       local(\'Poppins Bold\'), local(\'Poppins-Bold\'),\n}\n/* roboto-300 - latin-ext */\n@font-face {\n  font-family: \'Roboto\';\n  font-style: normal;\n  font-weight: 300;\n  src: url(\'','\') format(\'woff2\'), /* Chrome 26+, Opera 23+, Firefox 39+ */\n       url(\'','\') format(\'woff\'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */\n       local(\'Roboto Light\'), local(\'Roboto-Light\'),\n}\n/* roboto-regular - latin-ext */\n@font-face {\n  font-family: \'Roboto\';\n  font-style: normal;\n  font-weight: 400;\n  src: url(\'','\') format(\'woff2\'), /* Chrome 26+, Opera 23+, Firefox 39+ */\n       url(\'','\') format(\'woff\'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */\n       local(\'Roboto\'), local(\'Roboto-Regular\'),\n}\n\n* {\n  box-sizing: border-box;\n}\n\n.slick-slider .slick-dots li button::before {\n    font-size: 8px;\n    color: ',';\n    opacity: 0.7;\n}\n\n.slick-slider .slick-list {\n  margin-bottom: 25px;\n}\n\n.slick-slider .slick-dots li.slick-active button::before {\n    color: ',';\n    opacity: 1;\n}\n\n.slick-slider .slick-list .slick-track {\n  display: flex;\n}\n\n.slick-track div {\n  outline: none;\n}\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// adding fonts
/* Disable ESlint rules for this file *//* eslint-disable */Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["injectGlobal"])(_templateObject,__WEBPACK_IMPORTED_MODULE_1_styled_normalize___default.a,__WEBPACK_IMPORTED_MODULE_4__fonts_poppins_v5_latin_ext_regular_woff2___default.a,__WEBPACK_IMPORTED_MODULE_3__fonts_poppins_v5_latin_ext_regular_woff___default.a,__WEBPACK_IMPORTED_MODULE_6__fonts_poppins_v5_latin_ext_700_woff2___default.a,__WEBPACK_IMPORTED_MODULE_5__fonts_poppins_v5_latin_ext_700_woff___default.a,__WEBPACK_IMPORTED_MODULE_10__fonts_roboto_v18_latin_ext_latin_300_woff2___default.a,__WEBPACK_IMPORTED_MODULE_9__fonts_roboto_v18_latin_ext_latin_300_woff___default.a,__WEBPACK_IMPORTED_MODULE_8__fonts_roboto_v18_latin_ext_latin_regular_woff2___default.a,__WEBPACK_IMPORTED_MODULE_7__fonts_roboto_v18_latin_ext_latin_regular_woff___default.a,__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('product'));

/***/ }),

/***/ "./src/common/images/EX_logo.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/EX_logo.058d6769.svg";

/***/ }),

/***/ "./src/common/images/app-store-badge.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "./src/common/images/fb.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fb.8b09d7bd.svg";

/***/ }),

/***/ "./src/common/images/globe.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAACOElEQVQ4jXXUTYiVVRgH8N99uwRJ0WWiRSCcUwdaBNGNSQZqmZvsQwp3BZKJ1L4gKFfZJmjR1GoSnWULqQZctFBqEehgV8ZwIdGBcyhUckhdSLSZaXHPlder/Xfn+TrP838+BuaQQuywF/uwiG0M8SD+xsdYy7Vs9f26uSCLOIdX8BWewir+xTKONN25Zns3UoivpRAvpBDHPdljKcTzKcQdc7bjFOKvKcT9d2TUon+C3bmWjZ7PX7iK31KIH86EzeZdLM8yGzZOVrA/13KtvZ9pn5zPtexJIe5qjn0cwGdYSSHuGjZiN3ItGynEgG9xCQ+gSyFexPM4k0J8Di/gcezEITyBvZ1pd462Xz7HR7mWN3Mtb+DLRv57uIyvcQtn8Wrr3FHsG5q2eL0FejrX8kOPi9M9gm/hINawmWvZbqp1HO+wnWvZatz8L3Itf+I0LuDlnnwL292c4JcU4qkU4vcpxA/uEe8wruD3eUWHQS+bt/A23sfrKcQne6V1+AaruZZLc/LBEBMs4Uyr+49mcARf4KXm87DpWNwewoYlTDqcwDv3KOMiHuq9d+Mf073r4yBOdKZdeLa/Gg0jbLbs7seneDHXstkra4wx1gZNsIhjpityrWf4I342Hci1XMtyT/coTuFArmVyH1y/eePKwmh0GasLo9HZ6zdvXIWF0egkHsGxXMvJuUy+w+Fcy08w6NfSMlvBhunErs/uTuvOUuNkjEO5lsnM945APYf5wzaznZg2567D9h+G3suTjreQlgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "./src/common/images/google-play-badge.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "./src/common/images/lin.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lin.678ea4c2.svg";

/***/ }),

/***/ "./src/common/images/linkIcon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/linkIcon.04504ed0.svg";

/***/ }),

/***/ "./src/common/images/loader.gif":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/loader.5c5ee73e.gif";

/***/ }),

/***/ "./src/common/images/phone.png":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/phone.9b15e985.png";

/***/ }),

/***/ "./src/common/images/shareIcon.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiCRMMIhf1n7CqAAAB50lEQVRIx5XUP0hWYRTH8Y+WWZmvRWKEU1IQJoVTJEQkTSZRECVCNpWLVGsEjREOCv2bDByKpgqqqaGgbGmTKIXsvySZg2b059W30+Dt5ua954HLOQd+33vP73nuQ56o1uuFWUN6lOVSgg0+iHQ9sDwv4KEw5aJ9bikJp/LJNwrhaFL1C2P5APuFacuSqkUoqaQ8M+AzamxJqm34rpT9/Wv0C+GuejR5I9zOLu8wnrr/yyshzGjIJm7yWAhfnXDctwQzamcWcUGfOaHkqnVJp02PPSqXFpc5ZkIIzzRn+9gKjQpJvsOQECZ0ZTu0tW76JfzxVKvL5oU5fSlwiajxXgilRWf9kW3Zt+ma8EW3ggOGhdCRXQyfhLNJvlcIm/PIVwuhMXV/RmjLKi7HD+M4lHRaFfAi3wiXhCmn1TripVC0Ox+g2tgi/xfWvXSoTLHWdbNCeKzdHSHMG1CfB1KuQXWSt3gmhB8uqMk3zv84aFQIU85YkfTqHNZhfVbEct3JD/VOp5UGEn9K7luVFVLlfHILLDxfG0mu9Yrsw9S5oiiEc6DVT6ErnyO9wpO0GhRuLDifNQooptUkqvIBhrE12dIa7Xibb4QNJoXnOrV7Ivy2KR+AZtPpQS86mVcO2/Ub8dGgXf9afwFUlMIP/QkJOAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wOS0xOVQxMjozNDoyMyswMjowMPM6ZqIAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTgtMDktMTlUMTI6MzQ6MjMrMDI6MDCCZ94eAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "./src/common/images/zoni_white.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "./src/common/images/zonifero_logo_black.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zonifero_logo_black.ef52f150.svg";

/***/ }),

/***/ "./src/common/methods/blogMethods.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export extractTextFromTags */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return limitArticleChars; });
/* unused harmony export limitArticleCharsWithoutWordCut */
/* unused harmony export addNewMetaTagsToExistingMetaTagsString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateMetaTagsFromBlogArticle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_models_SEO_model__ = __webpack_require__("./src/models/SEO.model.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_consts_blog__ = __webpack_require__("./src/common/consts/blog.js");
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/* eslint-disable no-param-reassign */var extractTextFromTags=function extractTextFromTags(textWithTags){return textWithTags.replace(/(<([^>]+)>)/ig,'');};var limitArticleChars=function limitArticleChars(article,limit){return'\n  '+extractTextFromTags(article).slice(0,limit)+'...\n';};var limitArticleCharsWithoutWordCut=function limitArticleCharsWithoutWordCut(article,limit){var articleText=extractTextFromTags(article);var indexOfLastSpace=articleText.slice(0,limit).lastIndexOf(' ');return articleText.slice(0,indexOfLastSpace);};var addNewMetaTagsToExistingMetaTagsString=function addNewMetaTagsToExistingMetaTagsString(currentMetaTags,newMetaTags){var metaTagsArray=currentMetaTags.replace(/\s/g,'').split(',').filter(function(tag){return tag!=='';});var newMetaTagsArray=newMetaTags.replace(/\s/g,'').split(',').filter(function(tag){return tag!=='';});metaTagsArray.push.apply(metaTagsArray,_toConsumableArray(newMetaTagsArray));return Array.from(new Set(metaTagsArray)).join(', ');};var generateMetaTagsFromBlogArticle=function generateMetaTagsFromBlogArticle(blogArticle){var SEO=blogArticle.SEO||new __WEBPACK_IMPORTED_MODULE_0_models_SEO_model__["a" /* default */]();if(!SEO.title){SEO.title=blogArticle.title;}if(!SEO.description){SEO.description=limitArticleCharsWithoutWordCut(blogArticle.content.value,__WEBPACK_IMPORTED_MODULE_1_common_consts_blog__["a" /* BLOG_SETTINGS */].ARTICLE_SEO_DESCRIPTION_LIMIT);}if(!SEO.ogImage){SEO.ogImage=blogArticle.listingImage;}if(!SEO.ogType){SEO.ogType='article';}if(SEO.metaKeywords){SEO.metaKeywords=addNewMetaTagsToExistingMetaTagsString(SEO.metaKeywords,blogArticle.metaKeywords);}else{SEO.metaKeywords=blogArticle.metaKeywords;}return SEO;};

/***/ }),

/***/ "./src/common/methods/enlargeFont.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var enlargeFont=function enlargeFont(fontSize){var trimmedSize=fontSize.slice(0,-3);return trimmedSize*__WEBPACK_IMPORTED_MODULE_0_designsystem__["a" /* default */].get('metrics.textEnlarge')+'rem';};/* harmony default export */ __webpack_exports__["a"] = (enlargeFont);

/***/ }),

/***/ "./src/common/methods/formatFileSize.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__("./node_modules/lodash/isNil.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
var formatFileSize=function formatFileSize(bytes,decimalPoint){if(bytes===0||__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(bytes))return'0 Bytes';var k=1024;var dp=decimalPoint||2;var sizes=['Bytes','KB','MB'];var i=Math.floor(Math.log(bytes)/Math.log(k));return parseFloat((bytes/Math.pow(k,i)).toFixed(dp))+' '+sizes[i];};/* harmony default export */ __webpack_exports__["a"] = (formatFileSize);

/***/ }),

/***/ "./src/common/methods/language.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pathJoin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return rootPathJoin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return languagePathJoin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return normalizePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return prepareAnchors; });
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var pathJoin=function pathJoin(){for(var _len=arguments.length,paths=Array(_len),_key=0;_key<_len;_key++){paths[_key]=arguments[_key];}return paths.map(function(p){return(p||'').replace(/^[/]*(.*[^/])?.*$/,'$1');}).filter(function(i){return i;}).join('/');};var rootPathJoin=function rootPathJoin(){return'/'+pathJoin.apply(undefined,arguments);};var languagePathJoin=function languagePathJoin(language){for(var _len2=arguments.length,paths=Array(_len2>1?_len2-1:0),_key2=1;_key2<_len2;_key2++){paths[_key2-1]=arguments[_key2];}return'/'+language+'/'+pathJoin.apply(undefined,paths);};var normalizePath=function normalizePath(language,to){return(typeof to==='undefined'?'undefined':_typeof(to))==='object'?Object.assign({},to,{pathname:languagePathJoin(language,to.pathname)}):languagePathJoin(language,to||'');};var prepareAnchors=function prepareAnchors(language,anchors){return Object.keys(anchors).reduce(function(result,key){return Object.assign({},result,_defineProperty({},key,languagePathJoin(language,anchors[key][language])));},{});};

/***/ }),

/***/ "./src/common/methods/string.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return slashesToDashes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return underscoresToDashes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dashesToUnderscores; });
/* unused harmony export tagsToReplace */
/* unused harmony export replaceTag */
/* unused harmony export safeTagsReplace */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return safeHtmlWithBr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NBSPAfterSingleLetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getNumbers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return croppedImageUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return removeTags; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery_commonjs_lib__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery_commonjs_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery_commonjs_lib__);
var slashesToDashes=function slashesToDashes(text){return text.replace(/\/+/g,'_');};var underscoresToDashes=function underscoresToDashes(text){return text.replace(/_+/g,'-');};var dashesToUnderscores=function dashesToUnderscores(text){return text.replace(/-+/g,'_');};var tagsToReplace={'&':'&amp;','<':'&lt;','>':'&gt;'};var replaceTag=function replaceTag(tag){return tagsToReplace[tag]||tag;};var safeTagsReplace=function safeTagsReplace(str){return str.replace(/[&<>]/g,replaceTag);};var safeHtmlWithBr=function safeHtmlWithBr(text){if(text){var escapedHTML=safeTagsReplace(text);return escapedHTML.replace(/(&lt;br&gt;|&lt;\/br&gt;)/g,'<br>');}return'';};var NBSPAfterSingleLetters=function NBSPAfterSingleLetters(text){return text.replace(/( [A-Za-z]) /g,'$1&#xA0;');};var isVideo=function isVideo(fileName){var ext=(fileName.match(/\.([^.]*?)(?=\?|#|$)/)||[])[1];return!!ext.match(/3gp|avi|mov|mp4|m4v|m4a|mp3|mkv|ogv|ogm|ogg|oga|webm|wav/);};var getNumbers=function getNumbers(str){if(typeof str==='string'){return str.replace(/\D/g,'');}return str;};var croppedImageUrl=function croppedImageUrl(url,width,height){var quality=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;var imageUrlBuilder=new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery_commonjs_lib__["ImageUrlBuilder"](url);if(width||height||quality){imageUrlBuilder.withDpr(2).withFitMode(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery_commonjs_lib__["ImageFitModeEnum"].Crop);if(width){imageUrlBuilder.withWidth(getNumbers(width));}if(height){imageUrlBuilder.withHeight(getNumbers(height));}if(quality){imageUrlBuilder.withQuality(quality);}}return imageUrlBuilder.getUrl();};var removeTags=function removeTags(text){return text?text.replace(/(<([^>]+)>)/ig,''):text;};

/***/ }),

/***/ "./src/common/responsive.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isOnMobile; });
/* unused harmony export isOnTablet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return media; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mobileBreakpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return desktopBreakpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return tabletBreakpoint; });
/* unused harmony export largeDesktopBreakpoint */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return wideDesktopBreakpoint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__humblebee_styled_components_breakpoint__ = __webpack_require__("./node_modules/@humblebee/styled-components-breakpoint/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__humblebee_styled_components_breakpoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__humblebee_styled_components_breakpoint__);
// Devices breakpoints
var mobileBreakpoint=500;var tabletBreakpoint=768;var desktopBreakpoint=1100;var largeDesktopBreakpoint=1650;var xLargeDesktopBreakpoint=1400;var wideDesktopBreakpoint=1980;var media=__WEBPACK_IMPORTED_MODULE_0__humblebee_styled_components_breakpoint___default()({mobile:mobileBreakpoint,tablet:tabletBreakpoint,desktop:desktopBreakpoint,largeDesktop:largeDesktopBreakpoint,xLargeDesktop:xLargeDesktopBreakpoint});/* How to use media queries:

${media.desktop`
  flex-direction:row;
`};

*/// Check if device width is less than desktop breakpoint
var isOnMobile=function isOnMobile(){var query=global.window.matchMedia('(max-width: '+(desktopBreakpoint-1)+'px)');return query.matches;};var isOnTablet=function isOnTablet(){var query=global.window.matchMedia('(max-width: '+(tabletBreakpoint-1)+'px)');return query.matches;};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/react-scripts/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./src/designsystem/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return myDesignSystem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_design_system_utils__ = __webpack_require__("./node_modules/design-system-utils/build/es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_consts_containerWidth__ = __webpack_require__("./src/common/consts/containerWidth.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_responsive__ = __webpack_require__("./src/common/responsive.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_consts_navigation__ = __webpack_require__("./src/common/consts/navigation.js");
/* unused harmony reexport containerWidth */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2_common_responsive__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2_common_responsive__["b"]; });
var myDesignSystem={type:{// this should be set as a px value if you have `options.fontSizeUnit` set
// to 'rem' or 'em' so that the lib can convert the values properly
baseFontSize:'16px',// Used with `ds.fontSize(value)` / `ds.fs(value)`
sizes:{xs:'11px',s:'13px',base:'17px',m:'19px',l:'30px',xl:'50px',xxl:'70px',blogArticleParagraph:'22px'},// use with ds.get('type.fontFamily.value')
fontFamily:{headline:'Poppins',text:'Roboto'},// use with ds.get('type.fontWeight.value')
fontWeight:{light:300,regular:400,extended:500,bold:700},// use with ds.get('type.lineHeight.value')
lineHeight:{xs:'13px',s:'25px',base:'26px',l:'40px',xl:'60px',xxl:'80px'}},// Color palette
// Each object needs to have the same shape
// Each color object needs a `base` value to be the default
// Have as many color objects as you like
colors:{// Used with `ds.brand('social', 'colorName')`
colorPalette:{social:{fb:'#3B5998',tw:'#00ACED',link:'#007FB1'}},// Used with `ds.brand('colorName)`
brand:{product:'#3146FF',productHover:'#2e40f0',productActive:'#2d3fe1',text:'#000000',background:'#f7f7f7',darkBackground:'#ECEFF3',darkPurple:'#6450d6',secondary:'#01ffcb',white:'#ffffff',regular:'#000000'}},// used with `ds.get('metrics.value)`
metrics:{xs:'12px',s:'20px',base:'30px',m:'40px',l:'60px',xl:'90px',xxl:'120px',textEnlarge:1.1},// few elements in navigation section uses same
// height to be match in element.
navSection:{navHeight:__WEBPACK_IMPORTED_MODULE_3_common_consts_navigation__["d" /* NAV_HEIGHT */]+'px'}};/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_design_system_utils__["a" /* default */](myDesignSystem,{fontSizeUnit:'rem'}));

/***/ }),

/***/ "./src/elements/BlogArticleBoldText.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    line-height: ',';\n  '],['\n    line-height: ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var BlogArticleBoldText=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({displayName:'BlogArticleBoldText',componentId:'sc-1tax6ad-0'})(['font-weight:',';font-family:',';font-size:',';line-height:',';',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.regular'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('blogArticleParagraph'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.base'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].tablet(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.l')));/* harmony default export */ __webpack_exports__["a"] = (BlogArticleBoldText);

/***/ }),

/***/ "./src/elements/BlogArticleLink.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var BlogArticleLink=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].a.withConfig({displayName:'BlogArticleLink',componentId:'gleyed-0'})(['text-decoration:none;&:focus,&:hover,&:visited,&:link,&:active{text-decoration:none;}']);/* harmony default export */ __webpack_exports__["a"] = (BlogArticleLink);

/***/ }),

/***/ "./src/elements/Button.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n        margin-left: 0;\n    '],['\n        margin-left: 0;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Button=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].button.withConfig({displayName:'Button',componentId:'sc-1xyo68n-0'})(['font-size:',';font-family:',';font-weight:',';background-color:',';color:',';width:200px;height:65px;border:none;cursor:pointer;display:block;margin:',' auto;transition:background-color,.1s,ease-in-out;outline:none;&:hover,&:focus{background-color:',';}&:active{background-color:',';}',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('base'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.light'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('colors.brand.product'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('colors.brand.background'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('colors.brand.productHover'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('colors.brand.productActive'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].desktop(_templateObject));/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),

/***/ "./src/elements/DescriptionText.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var DescriptionText=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].h3.withConfig({displayName:'DescriptionText',componentId:'sc-1i82nng-0'})(['color:',';font-size:',';font-family:',';font-weight:',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('l'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.regular'));/* harmony default export */ __webpack_exports__["a"] = (DescriptionText);

/***/ }),

/***/ "./src/elements/Header1.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_props__ = __webpack_require__("./node_modules/styled-props/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_styled_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var Header1=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].h1.withConfig({displayName:'Header1',componentId:'sc-2xhc25-0'})(['color:',';font-size:',';font-family:',';font-weight:',';line-height:',';'],__WEBPACK_IMPORTED_MODULE_1_styled_props___default()({primary:__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('product'),secondary:__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('text')}),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('xxl'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontFamily.headline'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontWeight.bold'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.lineHeight.xxl'));/* harmony default export */ __webpack_exports__["a"] = (Header1);

/***/ }),

/***/ "./src/elements/Header2.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n      font-size: ',';\n      line-height: ',';\n    '],['\n      font-size: ',';\n      line-height: ',';\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Header2=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].h2.withConfig({displayName:'Header2',componentId:'sc-1gobyi2-0'})(['color:',';font-family:',';font-weight:',';line-height:',';font-size:',';',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.headline'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.bold'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.l'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('l'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].tablet(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('xl'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.xl')));/* harmony default export */ __webpack_exports__["a"] = (Header2);

/***/ }),

/***/ "./src/elements/Header3.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var Header3=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].h3.withConfig({displayName:'Header3',componentId:'sc-1aurikz-0'})(['color:',';font-size:',';font-family:',';font-weight:',';line-height:',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('l'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.headline'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.bold'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.l'));/* harmony default export */ __webpack_exports__["a"] = (Header3);

/***/ }),

/***/ "./src/elements/Header4.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var Header4=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].h4.withConfig({displayName:'Header4',componentId:'sc-1s8wm73-0'})(['color:',';font-size:',';font-family:',';font-weight:',';line-height:',';margin:36px 0 24px;'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('m'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.headline'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.bold'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.base'));/* harmony default export */ __webpack_exports__["a"] = (Header4);

/***/ }),

/***/ "./src/elements/Header5.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var Header5=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].h5.withConfig({displayName:'Header5',componentId:'sc-1vrjdkf-0'})(['color:',';font-size:',';font-family:',';font-weight:',';line-height:',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('base'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),function(_ref){var bold=_ref.bold;return bold?__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.bold'):__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.regular');},__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.base'));/* harmony default export */ __webpack_exports__["a"] = (Header5);

/***/ }),

/***/ "./src/elements/Image.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var Image=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].img.withConfig({displayName:'Image',componentId:'djo27q-0'})(['margin:0;padding:0;max-width:100%;max-height:100%;']);/* harmony default export */ __webpack_exports__["a"] = (Image);

/***/ }),

/***/ "./src/elements/LI.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var LI=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].li.withConfig({displayName:'LI',componentId:'sc-1hbkdr3-0'})(['color:',';position:relative;font-family:',';font-weight:',';font-size:',';line-height:',';margin:10px 0;'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.light'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('blogArticleParagraph'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.s'));/* harmony default export */ __webpack_exports__["a"] = (LI);

/***/ }),

/***/ "./src/elements/LanguageLink.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores_App_store__ = __webpack_require__("./src/stores/App.store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_methods_language__ = __webpack_require__("./src/common/methods/language.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_flowRight__ = __webpack_require__("./node_modules/lodash/flowRight.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_flowRight__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var urlRegex=/^https?:\/\/[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/;var LanguageLink=function LanguageLink(_ref){var to=_ref.to,currentLanguage=_ref.appStore.currentLanguage,rest=_objectWithoutProperties(_ref,['to','appStore']);var isExternal=typeof to==="string"&&urlRegex.test(to);if(isExternal){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',Object.assign({href:to,target:'_blank',rel:'noopener noreferrer'},rest));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["NavLink"],Object.assign({to:Object(__WEBPACK_IMPORTED_MODULE_5__common_methods_language__["b" /* normalizePath */])(currentLanguage,to)},rest));};LanguageLink.propTypes={to:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object]).isRequired,appStore:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4__stores_App_store__["a" /* AppStore */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6_lodash_flowRight___default()(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["inject"])('appStore'),__WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"])(LanguageLink));

/***/ }),

/***/ "./src/elements/ListItem.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_methods_enlargeFont__ = __webpack_require__("./src/common/methods/enlargeFont.js");
/* eslint react/destructuring-assignment: "off" *//* eslint no-confusing-arrow: "off" */var ListItem=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({displayName:'ListItem',componentId:'n4ps3s-0'})(['font-size:',';transition:font-size 0.5s;font-family:',';font-weight:',';line-height:',';&:hover{color:',';}'],function(props){return props.isActive?Object(__WEBPACK_IMPORTED_MODULE_2_common_methods_enlargeFont__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('m')):__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('m');},__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.Poppins'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.bold'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('product'));/* harmony default export */ __webpack_exports__["a"] = (ListItem);

/***/ }),

/***/ "./src/elements/OrderedList.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var OrderedList=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].ol.withConfig({displayName:'OrderedList',componentId:'sc-159z5fq-0'})(['line-height:',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.s'));/* harmony default export */ __webpack_exports__["a"] = (OrderedList);

/***/ }),

/***/ "./src/elements/Paragraph.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    font-size: ',';\n    line-height: ',';\n  '],['\n    font-size: ',';\n    line-height: ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Paragraph=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].p.withConfig({displayName:'Paragraph',componentId:'sc-1s76ydm-0'})(['color:',';font-family:',';font-weight:',';font-size:',';line-height:',';',' & strong{font-weight:',';}'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.light'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('base'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].tablet(_templateObject,function(_ref){var blogArticle=_ref.blogArticle;return blogArticle?__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('blogArticleParagraph'):__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('base');},function(_ref2){var blogArticle=_ref2.blogArticle;return blogArticle?__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.l'):__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.s');}),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.bold'));/* harmony default export */ __webpack_exports__["a"] = (Paragraph);

/***/ }),

/***/ "./src/elements/UnorderedList.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var UnorderedList=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].ul.withConfig({displayName:'UnorderedList',componentId:'sc-1bk7m7l-0'})(['line-height:',';list-style:none;padding-left:30px;li{&:before{content:\'\';position:absolute;top:0;left:0;transform:translateY(8px);width:7px;height:7px;background:',';margin-left:-20px;border-radius:50%;}}'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('darkPurple'));/* harmony default export */ __webpack_exports__["a"] = (UnorderedList);

/***/ }),

/***/ "./src/history.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history__ = __webpack_require__("./node_modules/history/esm/history.js");
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_history__["createBrowserHistory"])());

/***/ }),

/***/ "./src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("./node_modules/react-dom/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_gtm_module__ = __webpack_require__("./node_modules/react-gtm-module/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_gtm_module___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_gtm_module__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_global_styles__ = __webpack_require__("./src/common/global-styles.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RootApp__ = __webpack_require__("./src/RootApp.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stores_App_store__ = __webpack_require__("./src/stores/App.store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__registerServiceWorker__ = __webpack_require__("./src/registerServiceWorker.js");
/* Disable ESlint rules for this file *//* eslint react/jsx-filename-extension: "off" */var hasGoogleTagManagerID=!!"GTM-KB24WRL";var tagManagerArgs={gtmId:"GTM-KB24WRL"};if(hasGoogleTagManagerID){__WEBPACK_IMPORTED_MODULE_2_react_gtm_module___default.a.initialize(tagManagerArgs);}__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["Provider"],{appStore:__WEBPACK_IMPORTED_MODULE_6__stores_App_store__["b" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__RootApp__["a" /* default */],null)),global.document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_7__registerServiceWorker__["a" /* unregister */])();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/react-scripts/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./src/kentico-blocks/Accordion/PanelGroup/Arrow.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* Disable ESlint rules for this file *//* eslint no-confusing-arrow: "off" *//* eslint react/destructuring-assignment: "off" */var Arrow=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({displayName:'Arrow',componentId:'sc-1m3a8q2-0'})(['width:8px;height:8px;display:',';border:solid black;border-width:0 1px 1px 0;transform:rotate(45deg);margin-right:',';position:relative;top:9px;'],function(props){return props.isActive?'none':'block';},__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.base'));/* harmony default export */ __webpack_exports__["a"] = (Arrow);

/***/ }),

/***/ "./src/kentico-blocks/Accordion/PanelGroup/StyledPanelBody/Image.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var Image=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].img.withConfig({displayName:'Image',componentId:'sc-1u86gad-0'})(['width:100%;max-width:400px;height:100%;margin:17px 0;']);/* harmony default export */ __webpack_exports__["a"] = (Image);

/***/ }),

/***/ "./src/kentico-blocks/Accordion/PanelGroup/StyledPanelBody/Paragraph.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_elements_Paragraph__ = __webpack_require__("./src/elements/Paragraph.js");
var _templateObject=_taggedTemplateLiteral(['\ndisplay: ',';\n    & p{\n        margin: 0 6px 0 0;\n    }\n'],['\ndisplay: ',';\n    & p{\n        margin: 0 6px 0 0;\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint react/destructuring-assignment: "off" *//* eslint no-confusing-arrow: "off" */var StyledParagraph=__WEBPACK_IMPORTED_MODULE_0_elements_Paragraph__["a" /* default */].extend(_templateObject,function(props){return props.isEmpty?'none':'block';});/* harmony default export */ __webpack_exports__["a"] = (StyledParagraph);

/***/ }),

/***/ "./src/kentico-blocks/Accordion/PanelGroup/StyledPanelBody/Video.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var Video=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'Video',componentId:'vcz69d-0'})(['position:relative;height:236px;margin:17px 0;& iframe{position:absolute;top:0;left:0;width:100%;height:100%;}']);/* harmony default export */ __webpack_exports__["a"] = (Video);

/***/ }),

/***/ "./src/kentico-blocks/Accordion/PanelGroup/StyledPanelBody/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blocks_PanelGroup_index__ = __webpack_require__("./src/blocks/PanelGroup/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Paragraph__ = __webpack_require__("./src/kentico-blocks/Accordion/PanelGroup/StyledPanelBody/Paragraph.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Image__ = __webpack_require__("./src/kentico-blocks/Accordion/PanelGroup/StyledPanelBody/Image.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Video__ = __webpack_require__("./src/kentico-blocks/Accordion/PanelGroup/StyledPanelBody/Video.jsx");
/* eslint react/destructuring-assignment: "off" */var StyledPanelBody=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_blocks_PanelGroup_index__["a" /* default */].Body).withConfig({displayName:'StyledPanelBody',componentId:'j0mxms-0'})(['border-bottom:',';'],function(props){return props['data-isspread']?'1px solid '+__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('background'):'none';});StyledPanelBody.Paragraph=__WEBPACK_IMPORTED_MODULE_3__Paragraph__["a" /* default */];StyledPanelBody.Image=__WEBPACK_IMPORTED_MODULE_4__Image__["a" /* default */];StyledPanelBody.Video=__WEBPACK_IMPORTED_MODULE_5__Video__["a" /* default */];/* harmony default export */ __webpack_exports__["a"] = (StyledPanelBody);

/***/ }),

/***/ "./src/kentico-blocks/Accordion/PanelGroup/StyledPanelHeading.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blocks_PanelGroup_index__ = __webpack_require__("./src/blocks/PanelGroup/index.jsx");
/* eslint react/destructuring-assignment: "off" */var StyledPanelHeading=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_blocks_PanelGroup_index__["a" /* default */].Heading).withConfig({displayName:'StyledPanelHeading',componentId:'hwcgsb-0'})(['display:flex;justify-content:space-between;padding:',' 0;border-bottom:',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),function(props){return props['data-isactive']?'none':'1px solid '+__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('background');});/* harmony default export */ __webpack_exports__["a"] = (StyledPanelHeading);

/***/ }),

/***/ "./src/kentico-blocks/Accordion/PanelGroup/StyledPanelTitle.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blocks_PanelGroup_index__ = __webpack_require__("./src/blocks/PanelGroup/index.jsx");
/* Disable ESlint rules for this file *//* eslint no-confusing-arrow: "off" *//* eslint react/destructuring-assignment: "off" */var StyledPanelTitle=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_blocks_PanelGroup_index__["a" /* default */].Title).withConfig({displayName:'StyledPanelTitle',componentId:'xdyoiz-0'})(['margin-bottom:0;width:100%;position:relative;& a{color:',';font-size:90px;display:block;width:100%;height:100%;}'],function(props){return props.isActive?__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('product'):__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('text');});/* harmony default export */ __webpack_exports__["a"] = (StyledPanelTitle);

/***/ }),

/***/ "./src/kentico-blocks/Accordion/PanelGroup/TitleText.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_elements_ListItem__ = __webpack_require__("./src/elements/ListItem.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    display:flex;\n    justify-content:space-between;\n    font-size: ','\n'],['\n    display:flex;\n    justify-content:space-between;\n    font-size: ','\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* Disable ESlint rules for this file *//* eslint no-confusing-arrow: "off" *//* eslint react/destructuring-assignment: "off" */var TitleText=__WEBPACK_IMPORTED_MODULE_0_elements_ListItem__["a" /* default */].extend(_templateObject,function(props){return props.isActive?__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('l'):__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('m');});/* harmony default export */ __webpack_exports__["a"] = (TitleText);

/***/ }),

/***/ "./src/kentico-blocks/Accordion/PanelGroup/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_blocks_PanelGroup_index__ = __webpack_require__("./src/blocks/PanelGroup/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StyledPanelHeading__ = __webpack_require__("./src/kentico-blocks/Accordion/PanelGroup/StyledPanelHeading.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StyledPanelBody__ = __webpack_require__("./src/kentico-blocks/Accordion/PanelGroup/StyledPanelBody/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StyledPanelTitle__ = __webpack_require__("./src/kentico-blocks/Accordion/PanelGroup/StyledPanelTitle.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TitleText__ = __webpack_require__("./src/kentico-blocks/Accordion/PanelGroup/TitleText.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Arrow__ = __webpack_require__("./src/kentico-blocks/Accordion/PanelGroup/Arrow.jsx");
var PanelGroup=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_0_blocks_PanelGroup_index__["a" /* default */]).withConfig({displayName:'PanelGroup',componentId:'wsoghv-0'})(['']);PanelGroup.Panel=__WEBPACK_IMPORTED_MODULE_0_blocks_PanelGroup_index__["a" /* default */].Panel;PanelGroup.Heading=__WEBPACK_IMPORTED_MODULE_2__StyledPanelHeading__["a" /* default */];PanelGroup.Title=__WEBPACK_IMPORTED_MODULE_4__StyledPanelTitle__["a" /* default */];PanelGroup.TitleText=__WEBPACK_IMPORTED_MODULE_5__TitleText__["a" /* default */];PanelGroup.Body=__WEBPACK_IMPORTED_MODULE_3__StyledPanelBody__["a" /* default */];PanelGroup.Arrow=__WEBPACK_IMPORTED_MODULE_6__Arrow__["a" /* default */];/* harmony default export */ __webpack_exports__["a"] = (PanelGroup);

/***/ }),

/***/ "./src/kentico-blocks/Accordion/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx__ = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blocks_FlexColumn_FlexColumn__ = __webpack_require__("./src/blocks/FlexColumn/FlexColumn.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_common_consts_scroll__ = __webpack_require__("./src/common/consts/scroll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_animations_Animations__ = __webpack_require__("./src/animations/Animations.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_blocks_ScrollDiv__ = __webpack_require__("./src/blocks/ScrollDiv/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_blocks_HTMLModifableBackground_HTMLModifiableBackground__ = __webpack_require__("./src/blocks/HTMLModifableBackground/HTMLModifiableBackground.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PanelGroup__ = __webpack_require__("./src/kentico-blocks/Accordion/PanelGroup/index.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;var _templateObject=_taggedTemplateLiteral(['\n    margin: ',' auto;\n  '],['\n    margin: ',' auto;\n  ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var Accordion=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div.withConfig({displayName:'Accordion',componentId:'sc-4i208x-0'})(['margin:',' auto;padding:',';padding-top:0;width:100%;',';'],__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_5_designsystem__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('metrics.xl')));var SimpleText=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span.withConfig({displayName:'Accordion__SimpleText',componentId:'sc-4i208x-1'})(['']);var AccordionBlock=(_dec=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["inject"])('windowStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["observer"])(_class=(_temp=_class2=function(_Component){_inherits(AccordionBlock,_Component);function AccordionBlock(props){_classCallCheck(this,AccordionBlock);var _this=_possibleConstructorReturn(this,(AccordionBlock.__proto__||Object.getPrototypeOf(AccordionBlock)).call(this,props));_this.activeKey=__WEBPACK_IMPORTED_MODULE_3_mobx__["observable"].box(0);var accordionItems=_this.props.data.accordionItems;_this.scrollDivRefs=accordionItems.map(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();});return _this;}_createClass(AccordionBlock,[{key:'scrollToHeader',value:function scrollToHeader(elementRefIndex){if(elementRefIndex>0){var scrollDivRef=this.scrollDivRefs[elementRefIndex-1].current;Object(__WEBPACK_IMPORTED_MODULE_11_animations_Animations__["k" /* scrollToElement */])(scrollDivRef,300);}else{Object(__WEBPACK_IMPORTED_MODULE_11_animations_Animations__["k" /* scrollToElement */])(this.scrollDivRefs[0].current,0);}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,_props$data=_props.data,accordionItems=_props$data.accordionItems,htmlModifiers=_props$data.htmlModifiers,windowStore=_props.windowStore,isOnTablet=_props.windowStore.isOnTablet;var isAccordionSpread=!!this.activeKey.get()||this.activeKey.get()===0;var scrollDivOffset=isOnTablet?'-'+__WEBPACK_IMPORTED_MODULE_10_common_consts_scroll__["a" /* default */].MOBILE_TOP_OFFSET+'px':'-'+__WEBPACK_IMPORTED_MODULE_10_common_consts_scroll__["a" /* default */].DESKTOP_TOP_OFFSET+'px';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_blocks_HTMLModifableBackground_HTMLModifiableBackground__["a" /* default */],{htmlModifiers:htmlModifiers,color:__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].brand('white')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_blocks_Container_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Accordion,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PanelGroup__["a" /* default */],{accordion:true,defaultActiveKey:0,activeKey:this.activeKey.get(),onSelect:function onSelect(activeKey){return _this2.activeKey.set(activeKey);},id:'FAQ.LeftPanel'},accordionItems.map(function(question,index){var isActive=_this2.activeKey.get()===index;var isSmallParagraphEmpty=question.smallText==='<p><br></p>';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PanelGroup__["a" /* default */].Panel,{eventKey:index,key:question.system.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PanelGroup__["a" /* default */].Heading,{'data-isactive':isActive},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PanelGroup__["a" /* default */].Title,{toggle:true,onClick:function onClick(){return _this2.scrollToHeader(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_blocks_ScrollDiv__["a" /* default */],{offset:scrollDivOffset,innerRef:_this2.scrollDivRefs[index]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PanelGroup__["a" /* default */].TitleText,{isActive:isActive},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SimpleText,{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_14_common_methods_string__["g" /* safeHtmlWithBr */])(question.title)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PanelGroup__["a" /* default */].Arrow,{isActive:isActive})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PanelGroup__["a" /* default */].Body,{'data-isspread':isAccordionSpread,collapsible:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_hedron__["Row"],{alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_hedron__["Column"],{lg:4,fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PanelGroup__["a" /* default */].Body.Paragraph,{dangerouslySetInnerHTML:{__html:question.text}})),!isOnTablet&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_blocks_FlexColumn_FlexColumn__["a" /* default */],{lg:3,lgShift:1,align:'flex-end',fluid:true},question.image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PanelGroup__["a" /* default */].Body.Image,{src:windowStore.adjustImageSize(question.image)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_hedron__["Column"],{lg:2,lgShift:1,fluid:true},question.smallText&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PanelGroup__["a" /* default */].Body.Paragraph,{isEmpty:isSmallParagraphEmpty,dangerouslySetInnerHTML:{__html:question.smallText}})),isOnTablet&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_blocks_FlexColumn_FlexColumn__["a" /* default */],{lg:3,lgShift:1,align:'flex-end',fluid:true},question.image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PanelGroup__["a" /* default */].Body.Image,{src:windowStore.adjustImageSize(question.image)})))));})))));}}]);return AccordionBlock;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class2.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_8_models__["a" /* Accordion */]).isRequired},_temp))||_class)||_class);

/***/ }),

/***/ "./src/kentico-blocks/ArticleSlider/ArticleSlide/ArticleImage.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var ArticleImage=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].img.withConfig({displayName:'ArticleImage',componentId:'clgi61-0'})(['height:214px;width:100%;object-fit:cover;']);/* harmony default export */ __webpack_exports__["a"] = (ArticleImage);

/***/ }),

/***/ "./src/kentico-blocks/ArticleSlider/ArticleSlide/StyledLink.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    margin-bottom: ',';\n  '],['\n    margin-bottom: ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledLink=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].a.withConfig({displayName:'StyledLink',componentId:'sc-1af7run-0'})(['text-decoration:none;&:focus,&:hover,&:visited,&:link,&:active{text-decoration:none;outline:none;}',';'],__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs')));/* harmony default export */ __webpack_exports__["a"] = (StyledLink);

/***/ }),

/***/ "./src/kentico-blocks/ArticleSlider/ArticleSlide/Title.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_elements_Header4__ = __webpack_require__("./src/elements/Header4.js");
var _templateObject=_taggedTemplateLiteral(['\n  ',';\n'],['\n  ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n    margin-bottom: ',';\n    color: #2A2A2A;\n  '],['\n    margin-bottom: ',';\n    color: #2A2A2A;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ArticleTitle=__WEBPACK_IMPORTED_MODULE_2_elements_Header4__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem_index__["c" /* media */].desktop(_templateObject2,__WEBPACK_IMPORTED_MODULE_0_designsystem__["a" /* default */].get('metrics.xs')));/* harmony default export */ __webpack_exports__["a"] = (ArticleTitle);

/***/ }),

/***/ "./src/kentico-blocks/ArticleSlider/ArticleSlide/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArticleSlide; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_reveal_Fade__ = __webpack_require__("./node_modules/react-reveal/Fade.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_reveal_Fade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_reveal_Fade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_animations_Animations__ = __webpack_require__("./src/animations/Animations.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ArticleImage__ = __webpack_require__("./src/kentico-blocks/ArticleSlider/ArticleSlide/ArticleImage.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StyledLink__ = __webpack_require__("./src/kentico-blocks/ArticleSlider/ArticleSlide/StyledLink.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Title__ = __webpack_require__("./src/kentico-blocks/ArticleSlider/ArticleSlide/Title.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable react/prop-types */var ArticleSlide=(_dec=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["inject"])("windowStore"),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"])(_class=function(_Component){_inherits(ArticleSlide,_Component);function ArticleSlide(){_classCallCheck(this,ArticleSlide);return _possibleConstructorReturn(this,(ArticleSlide.__proto__||Object.getPrototypeOf(ArticleSlide)).apply(this,arguments));}_createClass(ArticleSlide,[{key:'render',value:function render(){var _props=this.props,_props$article=_props.article,image=_props$article.image,title=_props$article.title,url=_props$article.url,index=_props.index,windowStore=_props.windowStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_reveal_Fade___default.a,{bottom:true,distance:''+__WEBPACK_IMPORTED_MODULE_5_animations_Animations__["a" /* FADE_VALUES */].BOX.LARGE,delay:windowStore.isOnMobile?__WEBPACK_IMPORTED_MODULE_5_animations_Animations__["a" /* FADE_VALUES */].DELAY.SMALL:__WEBPACK_IMPORTED_MODULE_5_animations_Animations__["a" /* FADE_VALUES */].DELAY.SMALL*index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StyledLink__["a" /* default */],{href:url,rel:'nofollow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ArticleImage__["a" /* default */],{src:windowStore.adjustImageSize(image)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Title__["a" /* default */],null,title)));}}]);return ArticleSlide;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);ArticleSlide.propTypes={article:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_models__["c" /* ArticleSlide */]).isRequired,index:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired};

/***/ }),

/***/ "./src/kentico-blocks/ArticleSlider/Header.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_elements_Header5__ = __webpack_require__("./src/elements/Header5.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n  margin: 0 0 ',';\n  \n    ','\n'],['\n  margin: 0 0 ',';\n  \n    ','\n']),_templateObject2=_taggedTemplateLiteral(['\n    margin: 0 0 ',';\n  '],['\n    margin: 0 0 ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Header=__WEBPACK_IMPORTED_MODULE_0_elements_Header5__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].tablet(_templateObject2,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.l')));/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),

/***/ "./src/kentico-blocks/ArticleSlider/LeftButtonWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    top: 255px;\n '],['\n    top: 255px;\n ']),_templateObject2=_taggedTemplateLiteral(['\n    top: 240px;\n  '],['\n    top: 240px;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LeftButtonWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'LeftButtonWrapper',componentId:'ld2r5k-0'})(['position:absolute;top:215px;z-index:25;padding-left:20px;',';',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem_index__["c" /* media */].tablet(_templateObject),__WEBPACK_IMPORTED_MODULE_1_designsystem_index__["c" /* media */].desktop(_templateObject2));/* harmony default export */ __webpack_exports__["a"] = (LeftButtonWrapper);

/***/ }),

/***/ "./src/kentico-blocks/ArticleSlider/RightButtonWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    top: 255px;\n '],['\n    top: 255px;\n ']),_templateObject2=_taggedTemplateLiteral(['\n    top: 240px;\n  '],['\n    top: 240px;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var RightButtonWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'RightButtonWrapper',componentId:'ebffdb-0'})(['position:absolute;top:215px;right:0;z-index:25;padding-right:20px;',';',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem_index__["c" /* media */].tablet(_templateObject),__WEBPACK_IMPORTED_MODULE_1_designsystem_index__["c" /* media */].desktop(_templateObject2));/* harmony default export */ __webpack_exports__["a"] = (RightButtonWrapper);

/***/ }),

/***/ "./src/kentico-blocks/ArticleSlider/SliderWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n   padding: ',' 0;\n  '],['\n   padding: ',' 0;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SliderWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'SliderWrapper',componentId:'y36wje-0'})(['position:relative;padding:',' 0 0;& .slick-slider{overflow:hidden;& .slick-list{margin:0 -60px;& .slick-slide{margin:0 60px;}}}',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].tablet(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.l')));/* harmony default export */ __webpack_exports__["a"] = (SliderWrapper);

/***/ }),

/***/ "./src/kentico-blocks/ArticleSlider/carouselSettings.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_responsive__ = __webpack_require__("./src/common/responsive.js");
var carouselSettings={swipe:true,slidesToShow:3,dots:false,arrows:false,slidesToScroll:1,centerPadding:'0',initialSlide:1,centerMode:true,infinite:true,responsive:[{breakpoint:__WEBPACK_IMPORTED_MODULE_0_common_responsive__["a" /* desktopBreakpoint */],settings:{slidesToShow:2}},{breakpoint:__WEBPACK_IMPORTED_MODULE_0_common_responsive__["e" /* tabletBreakpoint */],settings:{slidesToShow:1}}]};/* harmony default export */ __webpack_exports__["a"] = (carouselSettings);

/***/ }),

/***/ "./src/kentico-blocks/ArticleSlider/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArticleSlider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blocks_HTMLModifableBackground_HTMLModifiableBackground__ = __webpack_require__("./src/blocks/HTMLModifableBackground/HTMLModifiableBackground.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blocks_Carousel_Carousel__ = __webpack_require__("./src/blocks/Carousel/Carousel.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_blocks_SliderButtons_SliderButton__ = __webpack_require__("./src/blocks/SliderButtons/SliderButton.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__carouselSettings__ = __webpack_require__("./src/kentico-blocks/ArticleSlider/carouselSettings.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Header__ = __webpack_require__("./src/kentico-blocks/ArticleSlider/Header.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SliderWrapper__ = __webpack_require__("./src/kentico-blocks/ArticleSlider/SliderWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ArticleSlide__ = __webpack_require__("./src/kentico-blocks/ArticleSlider/ArticleSlide/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__LeftButtonWrapper__ = __webpack_require__("./src/kentico-blocks/ArticleSlider/LeftButtonWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RightButtonWrapper__ = __webpack_require__("./src/kentico-blocks/ArticleSlider/RightButtonWrapper.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}var ArticleSlider=(_class=function(_Component){_inherits(ArticleSlider,_Component);function ArticleSlider(){_classCallCheck(this,ArticleSlider);return _possibleConstructorReturn(this,(ArticleSlider.__proto__||Object.getPrototypeOf(ArticleSlider)).apply(this,arguments));}_createClass(ArticleSlider,[{key:'slickNext',value:function slickNext(){if(this.sliderRef){this.sliderRef.slickNext();}}},{key:'slickPrev',value:function slickPrev(){if(this.sliderRef){this.sliderRef.slickPrev();}}},{key:'render',value:function render(){var _this2=this;var _props$data=this.props.data,header=_props$data.header,articleSlides=_props$data.articleSlides,htmlModifiers=_props$data.htmlModifiers;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_blocks_HTMLModifableBackground_HTMLModifiableBackground__["a" /* default */],{htmlModifiers:htmlModifiers},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_blocks_Container_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__SliderWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_hedron__["Column"],{lg:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Header__["a" /* default */],null,header),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_blocks_Carousel_Carousel__["a" /* default */],{settings:__WEBPACK_IMPORTED_MODULE_9__carouselSettings__["a" /* default */],innerRef:function innerRef(ref){_this2.sliderRef=ref;}},articleSlides.map(function(slide,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ArticleSlide__["a" /* default */],{article:slide,key:slide.system.id,index:index});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__LeftButtonWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_blocks_SliderButtons_SliderButton__["a" /* default */],{animateArrow:true,onClick:this.slickPrev})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__RightButtonWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_blocks_SliderButtons_SliderButton__["a" /* default */],{animateArrow:true,right:true,onClick:this.slickNext})))));}}]);return ArticleSlider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),(_applyDecoratedDescriptor(_class.prototype,'slickNext',[__WEBPACK_IMPORTED_MODULE_3_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class.prototype,'slickNext'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'slickPrev',[__WEBPACK_IMPORTED_MODULE_3_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class.prototype,'slickPrev'),_class.prototype)),_class);ArticleSlider.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_models__["d" /* ArticleSlider */]).isRequired};

/***/ }),

/***/ "./src/kentico-blocks/Banner/Header.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_elements_Header2__ = __webpack_require__("./src/elements/Header2.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    margin: 0;\n    margin-bottom: ',';\n'],['\n    margin: 0;\n    margin-bottom: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Header=__WEBPACK_IMPORTED_MODULE_0_elements_Header2__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'));/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),

/***/ "./src/kentico-blocks/Banner/Image.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n        width: 80%;\n    '],['\n        width: 80%;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Image=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].img.withConfig({displayName:'Image',componentId:'sc-1o6usb7-0'})(['width:100%;display:block;margin:0 auto;position:relative;',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject));/* harmony default export */ __webpack_exports__["a"] = (Image);

/***/ }),

/***/ "./src/kentico-blocks/Banner/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BannerBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx__ = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_decorators_bind__ = __webpack_require__("./node_modules/lodash-decorators/bind.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_decorators_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_decorators_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_decorators_debounce__ = __webpack_require__("./node_modules/lodash-decorators/debounce.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_decorators_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_decorators_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_reveal_Fade__ = __webpack_require__("./node_modules/react-reveal/Fade.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_reveal_Fade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_reveal_Fade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_elements_Button__ = __webpack_require__("./src/elements/Button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_animations_Animations__ = __webpack_require__("./src/animations/Animations.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_elements_Paragraph__ = __webpack_require__("./src/elements/Paragraph.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_blocks_HTMLModifableBackground_HTMLModifiableBackground__ = __webpack_require__("./src/blocks/HTMLModifableBackground/HTMLModifiableBackground.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_organism_react_scroll_nav__ = __webpack_require__("./node_modules/organism-react-scroll-nav/build/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Image__ = __webpack_require__("./src/kentico-blocks/Banner/Image.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Header__ = __webpack_require__("./src/kentico-blocks/Banner/Header.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_dec2,_dec3,_dec4,_class,_desc,_value,_class2,_class3,_temp;var _templateObject=_taggedTemplateLiteral(['\n        padding: calc(',' * 7) 0;\n    '],['\n        padding: calc(',' * 7) 0;\n    ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types,no-param-reassign */var TagAScroll=__WEBPACK_IMPORTED_MODULE_10_styled_components__["default"].a.withConfig({displayName:'Banner__TagAScroll',componentId:'sc-1drv177-0'})(['text-decoration:none;']);var Banner=__WEBPACK_IMPORTED_MODULE_10_styled_components__["default"].div.withConfig({displayName:'Banner',componentId:'sc-1drv177-1'})(['',';'],__WEBPACK_IMPORTED_MODULE_8_designsystem_index__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_11_designsystem__["a" /* default */].get('metrics.base')));var BannerBlock=(_dec=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["inject"])('productsStore','windowStore'),_dec2=__WEBPACK_IMPORTED_MODULE_4_lodash_decorators_bind___default()(),_dec3=__WEBPACK_IMPORTED_MODULE_4_lodash_decorators_bind___default()(),_dec4=__WEBPACK_IMPORTED_MODULE_5_lodash_decorators_debounce___default()(200),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"])(_class=(_class2=(_temp=_class3=function(_Component){_inherits(BannerBlock,_Component);function BannerBlock(props){_classCallCheck(this,BannerBlock);var _this=_possibleConstructorReturn(this,(BannerBlock.__proto__||Object.getPrototypeOf(BannerBlock)).call(this,props));_this.isMobile=__WEBPACK_IMPORTED_MODULE_2_mobx__["observable"].box(Object(__WEBPACK_IMPORTED_MODULE_8_designsystem_index__["b" /* isOnMobile */])());_this.elementRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(BannerBlock,[{key:'componentDidMount',value:function componentDidMount(){var windowStore=this.props.windowStore;this.disposeOnScroll=windowStore.reactToScroll(this.onScroll);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.disposeOnScroll();}},{key:'onScroll',value:function onScroll(){Object(__WEBPACK_IMPORTED_MODULE_14_animations_Animations__["f" /* parallaxImage */])(this.elementRef.current,55,-55,10);}},{key:'updateDimensions',value:function updateDimensions(){this.isMobile.set(Object(__WEBPACK_IMPORTED_MODULE_8_designsystem_index__["b" /* isOnMobile */])());}},{key:'renderScrollButton',value:function renderScrollButton(buttonText,buttonLink){if(buttonLink){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TagAScroll,{href:buttonLink},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_elements_Button__["a" /* default */],null,buttonText));}var productsStore=this.props.productsStore;var navElementsLength=productsStore.parsedStructure.length;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_organism_react_scroll_nav__["c" /* SmoothScrollLink */],{container:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TagAScroll,{href:'#scroll-'+navElementsLength},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_elements_Button__["a" /* default */],null,buttonText)),targetId:'scroll-'+navElementsLength,scrollMargin:70});}},{key:'render',value:function render(){var _props=this.props,_props$data=_props.data,header=_props$data.header,text=_props$data.text,buttonText=_props$data.buttonText,image=_props$data.image,htmlModifiers=_props$data.htmlModifiers,buttonLink=_props$data.buttonLink,windowStore=_props.windowStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_blocks_HTMLModifableBackground_HTMLModifiableBackground__["a" /* default */],{htmlModifiers:htmlModifiers,color:__WEBPACK_IMPORTED_MODULE_11_designsystem__["a" /* default */].brand('background')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_blocks_Container_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Banner,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_hedron__["Row"],{alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_hedron__["Column"],{lg:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_reveal_Fade___default.a,{bottom:true,distance:''+__WEBPACK_IMPORTED_MODULE_14_animations_Animations__["a" /* FADE_VALUES */].BOX.SMALL,delay:__WEBPACK_IMPORTED_MODULE_14_animations_Animations__["a" /* FADE_VALUES */].DELAY.SMALL},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Header__["a" /* default */],{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_18_common_methods_string__["g" /* safeHtmlWithBr */])(header)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_elements_Paragraph__["a" /* default */],{dangerouslySetInnerHTML:{__html:text}}),!this.isMobile.get()?this.renderScrollButton(buttonText,buttonLink):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_hedron__["Column"],{lg:7,lgShift:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_reveal_Fade___default.a,{bottom:true,distance:''+__WEBPACK_IMPORTED_MODULE_14_animations_Animations__["a" /* FADE_VALUES */].BOX.SMALL,delay:__WEBPACK_IMPORTED_MODULE_14_animations_Animations__["a" /* FADE_VALUES */].DELAY.SMALL},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Image__["a" /* default */],{src:windowStore.adjustImageSize(image),innerRef:this.elementRef}),this.isMobile.get()?this.renderScrollButton(buttonText,buttonLink):''))))));}}]);return BannerBlock;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class3.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9_models__["e" /* Banner */]).isRequired},_temp),(_applyDecoratedDescriptor(_class2.prototype,'onScroll',[_dec2],Object.getOwnPropertyDescriptor(_class2.prototype,'onScroll'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'updateDimensions',[_dec3,_dec4],Object.getOwnPropertyDescriptor(_class2.prototype,'updateDimensions'),_class2.prototype)),_class2))||_class)||_class);

/***/ }),

/***/ "./src/kentico-blocks/BlogImageSlider/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlogImageSlider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_slick__ = __webpack_require__("./node_modules/react-slick/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_blocks_Carousel_Carousel__ = __webpack_require__("./src/blocks/Carousel/Carousel.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_reveal_Fade__ = __webpack_require__("./node_modules/react-reveal/Fade.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_reveal_Fade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_reveal_Fade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_animations_Animations__ = __webpack_require__("./src/animations/Animations.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sliderStyles_css__ = __webpack_require__("./src/kentico-blocks/BlogImageSlider/sliderStyles.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sliderStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__sliderStyles_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable react/prop-types *//* Disable ESlint rule for this file *//* eslint-disable jsx-a11y/click-events-have-key-events *//* eslint-disable jsx-a11y/no-noninteractive-element-interactions *//* eslint-disable no-return-assign *//* eslint react/no-array-index-key: "off" */var CustomArrow=function CustomArrow(props){var styles=props.styles,onClick=props.onClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles,onClick:onClick,role:'navigation'});};var wrapperDivStyles={width:'120%',margin:__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.l')+' 0',marginLeft:'-15%',overflow:'hidden'};var Image=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].img.withConfig({displayName:'BlogImageSlider__Image',componentId:'sx0uej-0'})(['width:100%;margin:0 auto;outline:none;']);var BlogImageSlider=(_dec=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["inject"])('windowStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["observer"])(_class=(_temp=_class2=function(_Component){_inherits(BlogImageSlider,_Component);function BlogImageSlider(props){_classCallCheck(this,BlogImageSlider);var _this=_possibleConstructorReturn(this,(BlogImageSlider.__proto__||Object.getPrototypeOf(BlogImageSlider)).call(this,props));_this.state={nav1:null,nav2:null};return _this;}_createClass(BlogImageSlider,[{key:'componentDidMount',value:function componentDidMount(){this.setState({nav1:this.slider1,nav2:this.slider2});}},{key:'render',value:function render(){var _this2=this;var _props=this.props,slides=_props.slides,windowStore=_props.windowStore;var _state=this.state,nav1=_state.nav1,nav2=_state.nav2;return windowStore.isOnTablet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_blocks_Carousel_Carousel__["a" /* default */],{blogArticle:true,settings:BlogImageSlider.mobileCarouselSettings},slides.map(function(slide,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Image,{key:index,src:windowStore.adjustImageSize(slide)});})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:wrapperDivStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_reveal_Fade___default.a,{bottom:true,distance:''+__WEBPACK_IMPORTED_MODULE_8_animations_Animations__["a" /* FADE_VALUES */].BOX.LIGHT,delay:__WEBPACK_IMPORTED_MODULE_8_animations_Animations__["a" /* FADE_VALUES */].DELAY.SMALL},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_slick___default.a,{asNavFor:nav2,ref:function ref(slider){return _this2.slider1=slider;},prevArrow:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomArrow,{styles:'arrow prevArrow'}),nextArrow:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomArrow,{styles:'arrow nextArrow'}),className:'mainSlider'},slides.map(function(slide,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Image,{key:index,src:windowStore.adjustImageSize(slide)});})),slides.length>1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_slick___default.a,{asNavFor:nav1,ref:function ref(slider){return _this2.slider2=slider;},slidesToShow:slides.length<4?slides.length:4,swipeToSlide:true,focusOnSelect:true,centerMode:true,className:'assistantSlider'},slides.map(function(slide,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Image,{key:index,src:windowStore.adjustImageSize(slide)});}))));}}]);return BlogImageSlider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class2.mobileCarouselSettings={swipe:true,slidesToShow:1,dots:true,infinite:true,arrows:false,slidesToScroll:1},_temp))||_class)||_class);BlogImageSlider.propTypes={slides:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired};CustomArrow.propTypes={onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,styles:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};CustomArrow.defaultProps={onClick:function onClick(){}};

/***/ }),

/***/ "./src/kentico-blocks/BlogImageSlider/sliderStyles.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/kentico-blocks/Calculator/CalculatorDetailsItem/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalculatorDetailsItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _templateObject=_taggedTemplateLiteral(['\n    padding: ',';\n    padding-top: 0;\n    padding-bottom: ',';\n  '],['\n    padding: ',';\n    padding-top: 0;\n    padding-bottom: ',';\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    font-size: ',';\n  '],['\n    font-size: ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    width: ',';\n  '],['\n    width: ',';\n  ']),_templateObject4=_taggedTemplateLiteral(['\n    font-weight: ',';\n    \n    ','\n'],['\n    font-weight: ',';\n    \n    ','\n']),_templateObject5=_taggedTemplateLiteral(['\n    font-size: calc(',' * ',');\n    ',';\n  '],['\n    font-size: calc(',' * ',');\n    ',';\n  ']),_templateObject6=_taggedTemplateLiteral(['\n    right: 0%;\n    bottom: ',';\n  '],['\n    right: 0%;\n    bottom: ',';\n  ']),_templateObject7=_taggedTemplateLiteral(['\n    right: 7%;\n    font-size: ',';\n    bottom: calc(',' * 0.8);\n    font-weight: ',';\n\n    ','\n\n    ','\n\n    ','\n  '],['\n    right: 7%;\n    font-size: ',';\n    bottom: calc(',' * 0.8);\n    font-weight: ',';\n\n    ','\n\n    ','\n\n    ','\n  ']),_templateObject8=_taggedTemplateLiteral(['\n    opacity: 0.2;\n  '],['\n    opacity: 0.2;\n  ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var labelWidth='68%';var fontScale=0.85;// scale fonts for mobile details view - without this param, values wont fit
var Container=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_hedron__["Column"]).withConfig({displayName:'CalculatorDetailsItem__Container',componentId:'xgkaiw-0'})(['position:relative;display:flex;flex-direction:column;justify-content:flex-end;padding:',';padding-left:',';',' ',' ',''],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.s'),function(_ref){var alignRight=_ref.alignRight;return alignRight?'align-items: flex-end;':'';},function(_ref2){var smallPadding=_ref2.smallPadding;return smallPadding?'padding: '+__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.xs')+';':'';},__WEBPACK_IMPORTED_MODULE_2_designsystem__["c" /* media */].mobile(_templateObject,__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.xs')));var Label=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].p.withConfig({displayName:'CalculatorDetailsItem__Label',componentId:'xgkaiw-1'})(['position:relative;font-family:',';font-size:',';line-height:',';color:',';z-index:1;font-weight:',';',' ',' width:100%;',' ',' ',''],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('xs'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.lineHeight.xs'),function(_ref3){var white=_ref3.white;return white?__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('background'):__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('product');},function(_ref4){var labelBold=_ref4.labelBold;return labelBold?__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontWeight.regular'):__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontWeight.light');},function(_ref5){var center=_ref5.center;return center?'\n    text-align: center;\n  ':'';},function(_ref6){var alignRight=_ref6.alignRight;return alignRight?'text-align: end;':'';},__WEBPACK_IMPORTED_MODULE_2_designsystem__["c" /* media */].mobile(_templateObject2,__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('s')),__WEBPACK_IMPORTED_MODULE_2_designsystem__["c" /* media */].tablet(_templateObject3,function(_ref7){var labelWide=_ref7.labelWide;return labelWide?'100%':labelWidth;}),__WEBPACK_IMPORTED_MODULE_2_designsystem__["c" /* media */].desktop(_templateObject4,function(_ref8){var labelBold=_ref8.labelBold;return labelBold?__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontWeight.bold'):__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontWeight.light');},function(_ref9){var center=_ref9.center;return center?'\n      top: -12%;\n    ':'';}));var Value=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].p.withConfig({displayName:'CalculatorDetailsItem__Value',componentId:'xgkaiw-2'})(['font-family:',';font-size:calc(',' * ',');z-index:1;margin:0;color:',';font-weight:',';',' ',';'],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('m'),fontScale,function(_ref10){var white=_ref10.white;return white?__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('background'):__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('product');},function(_ref11){var valueBold=_ref11.valueBold;return valueBold?__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontWeight.bold'):__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontWeight.regular');},function(_ref12){var center=_ref12.center;return center?'text-align: center':'';},__WEBPACK_IMPORTED_MODULE_2_designsystem__["c" /* media */].tablet(_templateObject5,__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('l'),fontScale,function(_ref13){var center=_ref13.center;return center?'\n      width: '+labelWidth+';\n    ':'';}));var Unit=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].span.withConfig({displayName:'CalculatorDetailsItem__Unit',componentId:'xgkaiw-3'})(['color:',';font-weight:',';font-size:',';',''],function(_ref14){var white=_ref14.white;return white?__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('background'):__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('product');},__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontWeight.regular'),function(_ref15){var bigUnit=_ref15.bigUnit;return bigUnit?'calc('+__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('m')+' * '+fontScale+')':'calc('+__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('base')+' * '+fontScale+')';},__WEBPACK_IMPORTED_MODULE_2_designsystem__["c" /* media */].tablet(_templateObject2,function(_ref16){var bigUnit=_ref16.bigUnit;return bigUnit?'calc('+__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('l')+' * '+fontScale+')':__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('m');}));var Sign=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].span.withConfig({displayName:'CalculatorDetailsItem__Sign',componentId:'xgkaiw-4'})(['position:absolute;font-family:',';font-size:',';color:',';z-index:1;right:-10%;bottom:calc(',' + 3px);font-weight:',';',' ',' ',''],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('s'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontWeight.light'),function(_ref17){var bigSign=_ref17.bigSign;return bigSign?'\n    bottom: '+__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.xs')+';\n    font-size: '+__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('m')+';\n    transform: translate(-'+__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.m')+', 0);\n  ':'';},__WEBPACK_IMPORTED_MODULE_2_designsystem__["c" /* media */].mobile(_templateObject6,__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.xs')),__WEBPACK_IMPORTED_MODULE_2_designsystem__["c" /* media */].tablet(_templateObject7,__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('m'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontWeight.bold'),function(_ref18){var bigSign=_ref18.bigSign;return bigSign?'\n      font-size: '+__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('l')+';\n      transform: translate(0, 20%);\n    ':'';},function(_ref19){var signLeft=_ref19.signLeft;return signLeft?'\n      right: 115%;\n    ':'';},function(_ref20){var signBottom=_ref20.signBottom;return signBottom?'\n      right: 85%;\n      bottom: -'+__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.base')+';\n    ':'';}));var Icon=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].img.withConfig({displayName:'CalculatorDetailsItem__Icon',componentId:'xgkaiw-5'})(['position:absolute;top:',';left:',';width:',';',''],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.xl'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["c" /* media */].desktop(_templateObject8));var WhiteBackground=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].div.withConfig({displayName:'CalculatorDetailsItem__WhiteBackground',componentId:'xgkaiw-6'})(['position:absolute;width:75%;height:120%;left:0;top:-10%;background-color:',';'],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('background'));var power=function power(unit){return unit==='m2'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'m',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,'2')):unit;};var CalculatorDetailsItem=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('windowStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(_class=function(_Component){_inherits(CalculatorDetailsItem,_Component);function CalculatorDetailsItem(){_classCallCheck(this,CalculatorDetailsItem);return _possibleConstructorReturn(this,(CalculatorDetailsItem.__proto__||Object.getPrototypeOf(CalculatorDetailsItem)).apply(this,arguments));}_createClass(CalculatorDetailsItem,[{key:'render',value:function render(){var _props=this.props,windowStore=_props.windowStore,icon=_props.icon,label=_props.label,labelBold=_props.labelBold,labelWide=_props.labelWide,alignRight=_props.alignRight,value=_props.value,valueBold=_props.valueBold,unit=_props.unit,bigUnit=_props.bigUnit,sign=_props.sign,signLeft=_props.signLeft,signBottom=_props.signBottom,bigSign=_props.bigSign,calculatorValue=_props.calculatorValue,white=_props.white,center=_props.center,mobileWidth2x=_props.mobileWidth2x,smallPadding=_props.smallPadding;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{xs:mobileWidth2x?6:3,lg:2,alignRight:alignRight,smallPadding:smallPadding},white&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WhiteBackground,null),windowStore.isOnDesktop&&icon&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{src:icon,alt:label||calculatorValue.label}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label,{white:!white,labelBold:labelBold,center:center,labelWide:labelWide,alignRight:alignRight},label||calculatorValue.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Value,{valueBold:valueBold,white:!white,center:center},value!==null?value.toLocaleString()||value:calculatorValue.value.toLocaleString()||calculatorValue.value,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Unit,{bigUnit:bigUnit,white:!white},' ',power(unit||calculatorValue.unit))),sign&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Sign,{signBottom:signBottom,signLeft:signLeft,bigSign:bigSign},sign));}}]);return CalculatorDetailsItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);CalculatorDetailsItem.defaultProps={calculatorValue:{label:'',value:'',unit:''},icon:'',label:'',labelBold:false,labelWide:false,value:null,valueBold:false,unit:'',bigUnit:false,sign:'',bigSign:false,signLeft:false,signBottom:false,alignRight:false,white:false,center:false,smallPadding:false,mobileWidth2x:false};

/***/ }),

/***/ "./src/kentico-blocks/Calculator/CalculatorDetailsView/CostOfZoniferoGrid/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_kentico_blocks_Calculator_CalculatorDetailsItem__ = __webpack_require__("./src/kentico-blocks/Calculator/CalculatorDetailsItem/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_styled__ = __webpack_require__("./src/kentico-blocks/Calculator/styled.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_kentico_blocks_Calculator_FullWidthCalculatorDetailsItem__ = __webpack_require__("./src/kentico-blocks/Calculator/FullWidthCalculatorDetailsItem/index.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable react/prop-types */var CostOfZoniferoGrid=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('calculatorStore','windowStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(_class=function(_Component){_inherits(CostOfZoniferoGrid,_Component);function CostOfZoniferoGrid(){_classCallCheck(this,CostOfZoniferoGrid);return _possibleConstructorReturn(this,(CostOfZoniferoGrid.__proto__||Object.getPrototypeOf(CostOfZoniferoGrid)).apply(this,arguments));}_createClass(CostOfZoniferoGrid,[{key:'render',value:function render(){var _props=this.props,windowStore=_props.windowStore,calculatorStore=_props.calculatorStore,_props$data=_props.data,currency=_props$data.currency,sideInfoOptimisationPeriod=_props$data.sideInfoOptimisationPeriod,estimatedCostOfSensorInstallationPerDesk=_props$data.estimatedCostOfSensorInstallationPerDesk,costOfScreenHardwarePerRoom=_props$data.costOfScreenHardwarePerRoom,subscriptionFeePerEmployeeIn5Years=_props$data.subscriptionFeePerEmployeeIn5Years,numberOfDesksLabel=_props$data.numberOfDesksLabel,numberOfConferenceRoomsLabel=_props$data.numberOfConferenceRoomsLabel,hardwareImplementationCostLabel=_props$data.hardwareImplementationCostLabel,costOfZoniferoIn5YearsPerspectiveLabel=_props$data.costOfZoniferoIn5YearsPerspectiveLabel,totalOptimisationPerMonthLabel=_props$data.totalOptimisationPerMonthLabel,yourReturnOfInvestmentTimeLabel=_props$data.yourReturnOfInvestmentTimeLabel,numberOfEmployeesLabel=_props$data.numberOfEmployeesLabel;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_styled__["f" /* PaddedTopRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{calculatorValue:estimatedCostOfSensorInstallationPerDesk,unit:currency,sign:'x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{label:numberOfDesksLabel,value:calculatorStore.numberOfDesks.get(),sign:'+'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{label:numberOfConferenceRoomsLabel,value:calculatorStore.numberOfConferenceRooms.get(),sign:'x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{calculatorValue:costOfScreenHardwarePerRoom,unit:currency,sign:windowStore.isOnDesktop?'=':''}),windowStore.isOnDesktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{label:hardwareImplementationCostLabel,value:calculatorStore.hardwareImplementationCost,unit:currency,valueBold:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_kentico_blocks_Calculator_FullWidthCalculatorDetailsItem__["a" /* default */],{label:hardwareImplementationCostLabel,value:calculatorStore.hardwareImplementationCost,unit:currency,sign:'=',valueBold:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_styled__["e" /* PaddedBottomRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{calculatorValue:subscriptionFeePerEmployeeIn5Years,unit:currency,sign:'x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{label:numberOfEmployeesLabel,value:calculatorStore.numberOfEmployees.get(),sign:'+'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{label:hardwareImplementationCostLabel,value:calculatorStore.hardwareImplementationCost,unit:currency,sign:windowStore.isOnDesktop?'=':'',mobileWidth2x:true}),windowStore.isOnDesktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{label:costOfZoniferoIn5YearsPerspectiveLabel,value:calculatorStore.costOfZoniferoIn5Years,unit:currency,labelBold:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_kentico_blocks_Calculator_FullWidthCalculatorDetailsItem__["a" /* default */],{label:costOfZoniferoIn5YearsPerspectiveLabel,labelBold:true,value:calculatorStore.costOfZoniferoIn5Years,unit:currency,sign:'=',valueBold:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_styled__["f" /* PaddedTopRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{label:costOfZoniferoIn5YearsPerspectiveLabel,value:calculatorStore.costOfZoniferoIn5Years,unit:currency,sign:'/',bigSign:true,bigUnit:true,labelBold:true,mobileWidth2x:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{label:totalOptimisationPerMonthLabel,value:calculatorStore.totalOptimisationPerMonth,unit:currency,sign:windowStore.isOnDesktop?'=':'',bigUnit:true,labelBold:true,mobileWidth2x:true}),windowStore.isOnDesktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{label:yourReturnOfInvestmentTimeLabel,value:calculatorStore.yourReturnOfInvestmentTime,unit:sideInfoOptimisationPeriod,valueBold:true,labelBold:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_kentico_blocks_Calculator_FullWidthCalculatorDetailsItem__["a" /* default */],{label:yourReturnOfInvestmentTimeLabel,value:calculatorStore.yourReturnOfInvestmentTime,unit:sideInfoOptimisationPeriod,sign:'=',valueBold:true})));}}]);return CostOfZoniferoGrid;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (CostOfZoniferoGrid);

/***/ }),

/***/ "./src/kentico-blocks/Calculator/CalculatorDetailsView/TotalOptimisationGrid/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_CalculatorDetailsItem__ = __webpack_require__("./src/kentico-blocks/Calculator/CalculatorDetailsItem/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_kentico_blocks_Calculator_styled__ = __webpack_require__("./src/kentico-blocks/Calculator/styled.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kentico_blocks_Calculator_FullWidthCalculatorDetailsItem__ = __webpack_require__("./src/kentico-blocks/Calculator/FullWidthCalculatorDetailsItem/index.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable react/prop-types */var TotalOptimisationGrid=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('calculatorStore','windowStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(_class=function(_Component){_inherits(TotalOptimisationGrid,_Component);function TotalOptimisationGrid(){_classCallCheck(this,TotalOptimisationGrid);return _possibleConstructorReturn(this,(TotalOptimisationGrid.__proto__||Object.getPrototypeOf(TotalOptimisationGrid)).apply(this,arguments));}_createClass(TotalOptimisationGrid,[{key:'render',value:function render(){var _props=this.props,windowStore=_props.windowStore,calculatorStore=_props.calculatorStore,_props$data=_props.data,currency=_props$data.currency,conferenceRoomsDetailsViewIcon=_props$data.conferenceRoomsDetailsViewIcon,employeesDetailsViewIcon=_props$data.employeesDetailsViewIcon,desksMainDetailsIcon=_props$data.desksMainDetailsIcon,parkingSpotsDetailsViewIcon=_props$data.parkingSpotsDetailsViewIcon,averageSizeOfConferenceRoom=_props$data.averageSizeOfConferenceRoom,averageWorkingHoursPerMonth=_props$data.averageWorkingHoursPerMonth,estimatedAreaOfOneDesk=_props$data.estimatedAreaOfOneDesk,numberOfConferenceRoomsLabel=_props$data.numberOfConferenceRoomsLabel,monthlyM2RentPriceLabel=_props$data.monthlyM2RentPriceLabel,numberOfEmployeesLabel=_props$data.numberOfEmployeesLabel,averageEmployeeSalaryPerHourLabel=_props$data.averageEmployeeSalaryPerHourLabel,totalOptimisationPerMonthLabel=_props$data.totalOptimisationPerMonthLabel,numberOfDesksLabel=_props$data.numberOfDesksLabel,numberOfParkingSpotsLabel=_props$data.numberOfParkingSpotsLabel,pricePerParkingSpotLabel=_props$data.pricePerParkingSpotLabel,optimisationRatesHeading=_props$data.optimisationRatesHeading,roomsOptimisationLabel=_props$data.roomsOptimisationLabel,workOptimisationLabel=_props$data.workOptimisationLabel,desksOptimisationLabel=_props$data.desksOptimisationLabel,parkingOptimisationLabel=_props$data.parkingOptimisationLabel;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_kentico_blocks_Calculator_styled__["f" /* PaddedTopRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{icon:conferenceRoomsDetailsViewIcon,calculatorValue:averageSizeOfConferenceRoom,sign:'x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{label:numberOfConferenceRoomsLabel,value:calculatorStore.numberOfConferenceRooms.get(),sign:'x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{label:monthlyM2RentPriceLabel,value:calculatorStore.monthlyM2RentPrice.get(),unit:currency,sign:'x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{label:optimisationRatesHeading,value:calculatorStore.conferenceRoomOptimisationRate*100,unit:'%',sign:windowStore.isOnDesktop?'=':'',white:windowStore.isOnDesktop,center:true,labelBold:true,smallPadding:true}),windowStore.isOnDesktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{value:calculatorStore.roomOptimisation,unit:currency,sign:'+',signBottom:true,valueBold:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_kentico_blocks_Calculator_FullWidthCalculatorDetailsItem__["a" /* default */],{value:calculatorStore.roomOptimisation,unit:currency,label:roomsOptimisationLabel,valueBold:true,sign:'='})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_hedron__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{icon:employeesDetailsViewIcon,calculatorValue:averageWorkingHoursPerMonth,sign:'x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{label:numberOfEmployeesLabel,value:calculatorStore.numberOfEmployees.get(),sign:'x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{label:averageEmployeeSalaryPerHourLabel,value:calculatorStore.averageEmployeeSalaryPerH.get(),unit:currency,sign:'x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{value:calculatorStore.workingHoursOptimisationRate*100,unit:'%',sign:windowStore.isOnDesktop?'=':'',white:windowStore.isOnDesktop,center:true}),windowStore.isOnDesktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{value:calculatorStore.employeeOptimisation,unit:currency,sign:'+',signBottom:true,valueBold:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_kentico_blocks_Calculator_FullWidthCalculatorDetailsItem__["a" /* default */],{value:calculatorStore.employeeOptimisation,unit:currency,label:workOptimisationLabel,valueBold:true,sign:'='})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_hedron__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{icon:desksMainDetailsIcon,calculatorValue:estimatedAreaOfOneDesk,sign:'x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{label:numberOfDesksLabel,value:calculatorStore.numberOfDesks.get(),sign:'x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{label:monthlyM2RentPriceLabel,value:calculatorStore.monthlyM2RentPrice.get(),unit:currency,sign:'x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{value:calculatorStore.desksOptimisationRate*100,unit:'%',sign:windowStore.isOnDesktop?'=':'',white:windowStore.isOnDesktop,center:true}),windowStore.isOnDesktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{value:calculatorStore.desksOptimisation,unit:currency,sign:'+',signBottom:true,valueBold:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{label:totalOptimisationPerMonthLabel,labelBold:true,labelWide:true,value:calculatorStore.totalOptimisationPerMonth,unit:currency,sign:'=',signLeft:true,bigUnit:true,valueBold:true,alignRight:true})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_kentico_blocks_Calculator_FullWidthCalculatorDetailsItem__["a" /* default */],{value:calculatorStore.desksOptimisation,unit:currency,label:desksOptimisationLabel,valueBold:true,sign:'='})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_kentico_blocks_Calculator_styled__["e" /* PaddedBottomRow */],null,windowStore.isOnDesktop&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{icon:parkingSpotsDetailsViewIcon}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{label:numberOfParkingSpotsLabel,value:calculatorStore.numberOfParkingSpots.get(),sign:'x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{label:pricePerParkingSpotLabel,value:calculatorStore.pricePerParkingSpot.get(),unit:currency,sign:'x',mobileWidth2x:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{value:calculatorStore.parkingOptimisationRate*100,unit:'%',sign:windowStore.isOnDesktop?'=':'',white:windowStore.isOnDesktop,center:true}),windowStore.isOnDesktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_Calculator_CalculatorDetailsItem__["a" /* default */],{value:calculatorStore.parkingOptimisation,unit:currency,valueBold:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_kentico_blocks_Calculator_FullWidthCalculatorDetailsItem__["a" /* default */],{value:calculatorStore.parkingOptimisation,unit:currency,label:parkingOptimisationLabel,valueBold:true,sign:'='})),!windowStore.isOnDesktop&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_kentico_blocks_Calculator_styled__["e" /* PaddedBottomRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_kentico_blocks_Calculator_FullWidthCalculatorDetailsItem__["a" /* default */],{value:calculatorStore.totalOptimisationPerMonth,valueBold:true,unit:currency,bigUnit:true,label:totalOptimisationPerMonthLabel,labelBold:true,center:true})));}}]);return TotalOptimisationGrid;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (TotalOptimisationGrid);

/***/ }),

/***/ "./src/kentico-blocks/Calculator/CalculatorDetailsView/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalculatorDetailsView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kentico_blocks_Calculator_styled__ = __webpack_require__("./src/kentico-blocks/Calculator/styled.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_kentico_blocks_Calculator_CalculatorDetailsView_TotalOptimisationGrid__ = __webpack_require__("./src/kentico-blocks/Calculator/CalculatorDetailsView/TotalOptimisationGrid/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_kentico_blocks_Calculator_CalculatorDetailsView_CostOfZoniferoGrid__ = __webpack_require__("./src/kentico-blocks/Calculator/CalculatorDetailsView/CostOfZoniferoGrid/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable react/prop-types */var BlueBackground=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div.withConfig({displayName:'CalculatorDetailsView__BlueBackground',componentId:'y1kevn-0'})(['position:absolute;background-color:',';top:0;left:0;width:100vw;height:130%;'],__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].brand('product'));var FlexRightColumn=Object(__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_hedron__["Column"]).withConfig({displayName:'CalculatorDetailsView__FlexRightColumn',componentId:'y1kevn-1'})(['display:flex;justify-content:flex-end;padding-top:',';'],__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].get('metrics.xs'));var WhiteLeftArrow=Object(__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_5_kentico_blocks_Calculator_styled__["j" /* WhiteArrow */]).withConfig({displayName:'CalculatorDetailsView__WhiteLeftArrow',componentId:'y1kevn-2'})(['transform:translate(3px,-3px) rotate(135deg);margin-left:0;']);var CalculatorDetailsView=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["inject"])('calculatorStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"])(_class=(_temp=_class2=function(_Component){_inherits(CalculatorDetailsView,_Component);function CalculatorDetailsView(props){_classCallCheck(this,CalculatorDetailsView);var _this=_possibleConstructorReturn(this,(CalculatorDetailsView.__proto__||Object.getPrototypeOf(CalculatorDetailsView)).call(this,props));_this.elementRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(CalculatorDetailsView,[{key:'render',value:function render(){var _props=this.props,onClickPrev=_props.onClickPrev,_innerRef=_props.innerRef,data=_props.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_kentico_blocks_Calculator_styled__["b" /* CalculatorContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BlueBackground,{innerRef:function innerRef(ref){return _innerRef(ref);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_kentico_blocks_Calculator_styled__["f" /* PaddedTopRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_hedron__["Column"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_kentico_blocks_Calculator_styled__["a" /* ButtonTextWhite */],{big:true,onClick:onClickPrev},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WhiteLeftArrow,null),data.returnToMainViewLinkText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_kentico_blocks_Calculator_styled__["l" /* WhiteHorizontalLine */],{noMarginBottom:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_kentico_blocks_Calculator_CalculatorDetailsView_TotalOptimisationGrid__["a" /* default */],{data:data}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_kentico_blocks_Calculator_CalculatorDetailsView_CostOfZoniferoGrid__["a" /* default */],{data:data}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_kentico_blocks_Calculator_styled__["e" /* PaddedBottomRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FlexRightColumn,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_kentico_blocks_Calculator_styled__["a" /* ButtonTextWhite */],{big:true,onClick:onClickPrev},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WhiteLeftArrow,null),data.returnToMainViewLinkText))));}}]);return CalculatorDetailsView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class2.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_models__["k" /* Calculator */]).isRequired,innerRef:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func},_class2.defaultProps={innerRef:function innerRef(){}},_temp))||_class)||_class);

/***/ }),

/***/ "./src/kentico-blocks/Calculator/CalculatorInputRow/CalculatorInput/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx__ = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2;var _templateObject=_taggedTemplateLiteral(['\n    font-size: ',';\n  '],['\n    font-size: ',';\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    width: 100%;\n  '],['\n    width: 100%;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    font-size: ',';\n    max-width: ',';\n  '],['\n    font-size: ',';\n    max-width: ',';\n  ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var Currency=__WEBPACK_IMPORTED_MODULE_5_styled_components__["default"].span.withConfig({displayName:'CalculatorInput__Currency',componentId:'sc-1r6bfqx-0'})(['font-size:',';font-family:',';color:gray;',''],__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].fs('base'),__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_4_designsystem__["c" /* media */].tablet(_templateObject,__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].fs('m')));var Label=__WEBPACK_IMPORTED_MODULE_5_styled_components__["default"].label.withConfig({displayName:'CalculatorInput__Label',componentId:'sc-1r6bfqx-1'})(['font-size:',';font-family:',';text-align:',';width:120px;',''],__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].fs('s'),__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('type.fontFamily.text'),function(_ref){var labelRight=_ref.labelRight;return labelRight?'end':'start';},__WEBPACK_IMPORTED_MODULE_4_designsystem__["c" /* media */].mobile(_templateObject2));var InputGroup=__WEBPACK_IMPORTED_MODULE_5_styled_components__["default"].div.withConfig({displayName:'CalculatorInput__InputGroup',componentId:'sc-1r6bfqx-2'})(['display:flex;align-items:center;padding-top:',';justify-content:',';'],__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('metrics.s'),function(_ref2){var toRight=_ref2.toRight;return toRight?'flex-end':'flex-start';});var Button=__WEBPACK_IMPORTED_MODULE_5_styled_components__["default"].button.withConfig({displayName:'CalculatorInput__Button',componentId:'sc-1r6bfqx-3'})(['width:16px;height:16px;border:none;background-color:#fff;outline:none;padding:0;margin:0 ',';cursor:pointer;font-size:',';font-weight:bold;line-height:0;user-select:none;&:hover{opacity:0.7;}'],__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].fs('l'));var InputField=__WEBPACK_IMPORTED_MODULE_5_styled_components__["default"].input.withConfig({displayName:'CalculatorInput__InputField',componentId:'sc-1r6bfqx-4'})(['border:none;text-align:center;font-size:',';max-width:',';margin:0;&:focus{outline:none;}&::-webkit-outer-spin-button,&::-webkit-inner-spin-button{-webkit-appearance:none;}',''],__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].fs('m'),__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('metrics.l'),__WEBPACK_IMPORTED_MODULE_4_designsystem__["c" /* media */].tablet(_templateObject3,__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].fs('l'),__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('metrics.xl')));var CalculatorInput=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"])(_class=(_class2=function(_Component){_inherits(CalculatorInput,_Component);function CalculatorInput(){_classCallCheck(this,CalculatorInput);return _possibleConstructorReturn(this,(CalculatorInput.__proto__||Object.getPrototypeOf(CalculatorInput)).apply(this,arguments));}_createClass(CalculatorInput,[{key:'onInput',value:function onInput(e){var _props=this.props,valueObservableBox=_props.valueObservableBox,noNegative=_props.noNegative;if(!noNegative||noNegative&&e.target.value>=0){valueObservableBox.set(parseInt(e.target.value,10)||0);}}},{key:'decrease',value:function decrease(){var _props2=this.props,valueObservableBox=_props2.valueObservableBox,noNegative=_props2.noNegative;try{var value=parseInt(valueObservableBox.get(),10);if(noNegative&&value<=0){return;}valueObservableBox.set(value-1);}catch(e){console.error('wrong value in input: ',e);}}},{key:'increase',value:function increase(){var valueObservableBox=this.props.valueObservableBox;try{valueObservableBox.set(parseInt(valueObservableBox.get(),10)+1);}catch(e){console.error('wrong value in input: ',e);}}},{key:'render',value:function render(){var _props3=this.props,valueObservableBox=_props3.valueObservableBox,hasButtons=_props3.hasButtons,label=_props3.label,labelRight=_props3.labelRight,currency=_props3.currency;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label,{labelRight:labelRight},label,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputGroup,{toRight:currency},hasButtons&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{type:'button',onClick:this.decrease},'−'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputField,{type:'number',onInput:this.onInput,value:valueObservableBox.get()}),currency&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Currency,null,currency),hasButtons&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{type:'button',onClick:this.increase},'+')));}}]);return CalculatorInput;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),(_applyDecoratedDescriptor(_class2.prototype,'onInput',[__WEBPACK_IMPORTED_MODULE_1_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'onInput'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'decrease',[__WEBPACK_IMPORTED_MODULE_1_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'decrease'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'increase',[__WEBPACK_IMPORTED_MODULE_1_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'increase'),_class2.prototype)),_class2))||_class;CalculatorInput.defaultProps={hasButtons:false,label:'',labelRight:false,currency:'',noNegative:false,valueObservableBox:__WEBPACK_IMPORTED_MODULE_3_mobx__["observable"].box(0)};/* harmony default export */ __webpack_exports__["a"] = (CalculatorInput);

/***/ }),

/***/ "./src/kentico-blocks/Calculator/CalculatorInputRow/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalculatorInputRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kentico_blocks_Calculator_CalculatorInputRow_CalculatorInput__ = __webpack_require__("./src/kentico-blocks/Calculator/CalculatorInputRow/CalculatorInput/index.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _templateObject=_taggedTemplateLiteral(['\n     opacity: 1;\n     transform: none;\n  '],['\n     opacity: 1;\n     transform: none;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    ','\n  '],['\n    ','\n  ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var Icon=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].img.withConfig({displayName:'CalculatorInputRow__Icon',componentId:'ftix2t-0'})(['position:absolute;opacity:0.35;transform:translateX(calc(50vw - 75%));width:',';margin-top:',';',''],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.xl'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["c" /* media */].tablet(_templateObject));var NoPaddingColumn=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_hedron__["Column"]).withConfig({displayName:'CalculatorInputRow__NoPaddingColumn',componentId:'ftix2t-1'})(['padding-left:0;padding-right:0;']);var InputsContainer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].div.withConfig({displayName:'CalculatorInputRow__InputsContainer',componentId:'ftix2t-2'})(['display:flex;align-items:center;justify-content:space-between;border-bottom:3px solid gray;padding-bottom:',';',' ',''],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.xs'),function(_ref){var short=_ref.short;return short?'width: 135px;':'';},__WEBPACK_IMPORTED_MODULE_2_designsystem__["c" /* media */].tablet(_templateObject2,function(_ref2){var short=_ref2.short;return short?'width: 165px;':'';}));var CalculatorInputRow=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(_class=function(_Component){_inherits(CalculatorInputRow,_Component);function CalculatorInputRow(){_classCallCheck(this,CalculatorInputRow);return _possibleConstructorReturn(this,(CalculatorInputRow.__proto__||Object.getPrototypeOf(CalculatorInputRow)).apply(this,arguments));}_createClass(CalculatorInputRow,[{key:'render',value:function render(){var _props=this.props,firstInputLabel=_props.firstInputLabel,secondInputLabel=_props.secondInputLabel,firstValueObservableBox=_props.firstValueObservableBox,secondValueObservableBox=_props.secondValueObservableBox,icon=_props.icon,currency=_props.currency;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_hedron__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NoPaddingColumn,{md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{src:icon,alt:firstInputLabel})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NoPaddingColumn,{md:9,lg:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputsContainer,{short:!secondValueObservableBox&&!secondInputLabel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_kentico_blocks_Calculator_CalculatorInputRow_CalculatorInput__["a" /* default */],{label:firstInputLabel,valueObservableBox:firstValueObservableBox,hasButtons:true,noNegative:true}),secondInputLabel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_kentico_blocks_Calculator_CalculatorInputRow_CalculatorInput__["a" /* default */],{label:secondInputLabel,labelRight:true,valueObservableBox:secondValueObservableBox,currency:currency,noNegative:true}))));}}]);return CalculatorInputRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;

/***/ }),

/***/ "./src/kentico-blocks/Calculator/CalculatorMainView/MobileOptimisationModal/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_kentico_blocks_Calculator_styled__ = __webpack_require__("./src/kentico-blocks/Calculator/styled.jsx");
var _templateObject=_taggedTemplateLiteral(['\n    margin-left: ',';\n  '],['\n    margin-left: ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var StyledRow=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_hedron__["Row"]).withConfig({displayName:'MobileOptimisationModal__StyledRow',componentId:'sc-1c7qnu4-0'})(['position:fixed;bottom:0;left:0;width:100vw;z-index:10;transform:',';transition-duration:0.4s;'],function(_ref){var show=_ref.show;return show?'translateY(0)':'translateY(100%)';});var StyledColumn=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_hedron__["Column"]).withConfig({displayName:'MobileOptimisationModal__StyledColumn',componentId:'sc-1c7qnu4-1'})(['display:flex;flex-direction:column;justify-content:center;align-items:center;background-color:',';padding:0;'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('product'));var Value=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p.withConfig({displayName:'MobileOptimisationModal__Value',componentId:'sc-1c7qnu4-2'})(['font-family:',';line-height:',';font-size:',';font-weight:',';color:',';text-align:center;margin-bottom:0;'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('type.fontFamily.headline'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('type.lineHeight.s'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].fs('l'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('type.fontWeight.bold'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('white'));var Unit=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span.withConfig({displayName:'MobileOptimisationModal__Unit',componentId:'sc-1c7qnu4-3'})(['font-family:',';line-height:',';font-size:',';font-weight:',';color:',';'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('type.fontFamily.headline'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('type.lineHeight.s'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].fs('s'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('type.fontWeight.bold'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('white'));var ValueDescription=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p.withConfig({displayName:'MobileOptimisationModal__ValueDescription',componentId:'sc-1c7qnu4-4'})(['font-family:',';line-height:',';font-size:',';font-weight:',';color:',';text-align:center;margin-top:0;'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('type.lineHeight.s'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].fs('s'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('type.fontWeight.light'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('white'));var ArrowLink=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button.withConfig({displayName:'MobileOptimisationModal__ArrowLink',componentId:'sc-1c7qnu4-5'})(['font-family:',';line-height:',';font-size:',';font-weight:',';color:',';text-align:center;background:none;outline:none;cursor:pointer;border:none;transition-duration:0.2s;margin-top:0;margin-bottom:',';margin-left:',';',' &:hover{opacity:0.7;}'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('type.lineHeight.s'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].fs('base'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('type.fontWeight.light'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["c" /* media */].mobile(_templateObject,__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.s')));var MobileOptimisationModal=function MobileOptimisationModal(_ref2){var onClick=_ref2.onClick,value=_ref2.value,currency=_ref2.currency,period=_ref2.period,description=_ref2.description,linkText=_ref2.linkText,show=_ref2.show;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledRow,{show:show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledColumn,{xsShift:3,xs:9,smShift:6,sm:6,mdShift:8,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Value,null,value,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Unit,null,' '+currency+' / '+period)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ValueDescription,null,'- '+description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArrowLink,{onClick:onClick},linkText,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_kentico_blocks_Calculator_styled__["j" /* WhiteArrow */],null))));};/* harmony default export */ __webpack_exports__["a"] = (MobileOptimisationModal);

/***/ }),

/***/ "./src/kentico-blocks/Calculator/CalculatorMainView/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalculatorMainView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_kentico_blocks_Calculator_CalculatorInputRow__ = __webpack_require__("./src/kentico-blocks/Calculator/CalculatorInputRow/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_kentico_blocks_Calculator_styled__ = __webpack_require__("./src/kentico-blocks/Calculator/styled.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;var _templateObject=_taggedTemplateLiteral(['\n    margin-top: 0;\n    color: ',';\n    text-align: start;\n    padding-left: 8%;\n    padding-top: ',';\n    padding-bottom: ',';\n  '],['\n    margin-top: 0;\n    color: ',';\n    text-align: start;\n    padding-left: 8%;\n    padding-top: ',';\n    padding-bottom: ',';\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    height: 100%;\n  '],['\n    height: 100%;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    margin-top: ',';\n  '],['\n    margin-top: ',';\n  ']),_templateObject4=_taggedTemplateLiteral(['\n    padding-top: ',';\n    padding-bottom: 0;\n  '],['\n    padding-top: ',';\n    padding-bottom: 0;\n  ']),_templateObject5=_taggedTemplateLiteral(['\n    margin-top: 0;\n  '],['\n    margin-top: 0;\n  ']),_templateObject6=_taggedTemplateLiteral(['\n    margin-top: 0;\n '],['\n    margin-top: 0;\n ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var SideInfo=Object(__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_hedron__["Column"]).withConfig({displayName:'CalculatorMainView__SideInfo',componentId:'sc-1u8tatk-0'})(['position:relative;height:100%;background-color:',';margin-top:',';padding-top:',';padding-bottom:',';',';'],__WEBPACK_IMPORTED_MODULE_6_designsystem__["a" /* default */].get('colors.brand.product'),__WEBPACK_IMPORTED_MODULE_6_designsystem__["a" /* default */].get('metrics.l'),__WEBPACK_IMPORTED_MODULE_6_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_6_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_6_designsystem__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_6_designsystem__["a" /* default */].get('colors.brand.white'),__WEBPACK_IMPORTED_MODULE_6_designsystem__["a" /* default */].get('metrics.xxl'),__WEBPACK_IMPORTED_MODULE_6_designsystem__["a" /* default */].get('metrics.xxl')));var SideInfoBackground=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div.withConfig({displayName:'CalculatorMainView__SideInfoBackground',componentId:'sc-1u8tatk-1'})(['display:block;position:absolute;background-color:',';width:100vw;height:140%;left:0;top:0;',''],__WEBPACK_IMPORTED_MODULE_6_designsystem__["a" /* default */].get('colors.brand.product'),__WEBPACK_IMPORTED_MODULE_6_designsystem__["c" /* media */].desktop(_templateObject2));var SideInfoContent=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].aside.withConfig({displayName:'CalculatorMainView__SideInfoContent',componentId:'sc-1u8tatk-2'})(['position:relative;display:flex;flex-direction:column;justify-content:flex-start;height:100%;margin-top:0;',''],__WEBPACK_IMPORTED_MODULE_6_designsystem__["c" /* media */].desktop(_templateObject3,__WEBPACK_IMPORTED_MODULE_6_designsystem__["a" /* default */].get('metrics.xxl')));var InputColumn=Object(__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_hedron__["Column"]).withConfig({displayName:'CalculatorMainView__InputColumn',componentId:'sc-1u8tatk-3'})(['position:relative;display:flex;flex-direction:column;justify-content:flex-start;height:100%;margin-top:',';',''],__WEBPACK_IMPORTED_MODULE_6_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_6_designsystem__["c" /* media */].desktop(_templateObject3,__WEBPACK_IMPORTED_MODULE_6_designsystem__["a" /* default */].get('metrics.xl')));var MiddleText=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div.withConfig({displayName:'CalculatorMainView__MiddleText',componentId:'sc-1u8tatk-4'})(['padding-top:0;padding-bottom:',';',''],__WEBPACK_IMPORTED_MODULE_6_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_6_designsystem__["c" /* media */].desktop(_templateObject4,__WEBPACK_IMPORTED_MODULE_6_designsystem__["a" /* default */].get('metrics.s')));var StyledRow=Object(__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_hedron__["Row"]).withConfig({displayName:'CalculatorMainView__StyledRow',componentId:'sc-1u8tatk-5'})(['margin-top:',';height:100%;',' ',''],__WEBPACK_IMPORTED_MODULE_6_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_6_designsystem__["c" /* media */].tablet(_templateObject3,__WEBPACK_IMPORTED_MODULE_6_designsystem__["a" /* default */].get('metrics.l')),__WEBPACK_IMPORTED_MODULE_6_designsystem__["c" /* media */].desktop(_templateObject5));var AsideWhiteText=Object(__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_hedron__["Column"]).withConfig({displayName:'CalculatorMainView__AsideWhiteText',componentId:'sc-1u8tatk-6'})(['color:',';font-family:',';line-height:',';font-size:',';font-weight:',';text-align:start;margin-bottom:0;margin-top:',';padding-left:0;padding-right:0;',''],__WEBPACK_IMPORTED_MODULE_6_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_6_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_6_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_6_designsystem__["a" /* default */].fs('s'),__WEBPACK_IMPORTED_MODULE_6_designsystem__["a" /* default */].get('type.fontWeight.light'),__WEBPACK_IMPORTED_MODULE_6_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_6_designsystem__["c" /* media */].mobile(_templateObject6));var WhiteRightArrow=Object(__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8_kentico_blocks_Calculator_styled__["j" /* WhiteArrow */]).withConfig({displayName:'CalculatorMainView__WhiteRightArrow',componentId:'sc-1u8tatk-7'})(['transform:translate(2px,2px) rotate(-45deg);']);var CalculatorMainView=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["inject"])('calculatorStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"])(_class=(_temp=_class2=function(_Component){_inherits(CalculatorMainView,_Component);function CalculatorMainView(){_classCallCheck(this,CalculatorMainView);return _possibleConstructorReturn(this,(CalculatorMainView.__proto__||Object.getPrototypeOf(CalculatorMainView)).apply(this,arguments));}_createClass(CalculatorMainView,[{key:'render',value:function render(){var _props=this.props,onClickNext=_props.onClickNext,calculatorStore=_props.calculatorStore,sideInfoRef=_props.sideInfoRef,_props$data=_props.data,currency=_props$data.currency,mainHeading=_props$data.mainHeading,detailsViewLinkText=_props$data.detailsViewLinkText,sideInfoImplementationText=_props$data.sideInfoImplementationText,sideInfoOptimisationFrequency=_props$data.sideInfoOptimisationFrequency,sideInfoOptimisationPeriod=_props$data.sideInfoOptimisationPeriod,sideInfoReimburseText=_props$data.sideInfoReimburseText,sideInfoText=_props$data.sideInfoText,conferenceRoomsMainViewIcon=_props$data.conferenceRoomsMainViewIcon,employeesMainViewIcon=_props$data.employeesMainViewIcon,desksMainViewIcon=_props$data.desksMainViewIcon,parkingSpotsMainViewIcon=_props$data.parkingSpotsMainViewIcon,numberOfConferenceRoomsLabel=_props$data.numberOfConferenceRoomsLabel,monthlyM2RentPriceLabel=_props$data.monthlyM2RentPriceLabel,numberOfEmployeesLabel=_props$data.numberOfEmployeesLabel,averageEmployeeSalaryPerHourLabel=_props$data.averageEmployeeSalaryPerHourLabel,numberOfDesksLabel=_props$data.numberOfDesksLabel,numberOfParkingSpotsLabel=_props$data.numberOfParkingSpotsLabel,pricePerParkingSpotLabel=_props$data.pricePerParkingSpotLabel,asideNote=_props$data.asideNote;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_kentico_blocks_Calculator_styled__["b" /* CalculatorContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledRow,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputColumn,{lg:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_kentico_blocks_Calculator_styled__["d" /* Heading */],null,mainHeading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_kentico_blocks_Calculator_CalculatorInputRow__["a" /* default */],{icon:conferenceRoomsMainViewIcon,firstInputLabel:numberOfConferenceRoomsLabel,secondInputLabel:monthlyM2RentPriceLabel,firstValueObservableBox:calculatorStore.numberOfConferenceRooms,secondValueObservableBox:calculatorStore.monthlyM2RentPrice,currency:currency}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_kentico_blocks_Calculator_CalculatorInputRow__["a" /* default */],{icon:employeesMainViewIcon,firstInputLabel:numberOfEmployeesLabel,secondInputLabel:averageEmployeeSalaryPerHourLabel,firstValueObservableBox:calculatorStore.numberOfEmployees,secondValueObservableBox:calculatorStore.averageEmployeeSalaryPerH,currency:currency}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_kentico_blocks_Calculator_CalculatorInputRow__["a" /* default */],{icon:desksMainViewIcon,firstInputLabel:numberOfDesksLabel,firstValueObservableBox:calculatorStore.numberOfDesks,currency:currency}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_kentico_blocks_Calculator_CalculatorInputRow__["a" /* default */],{icon:parkingSpotsMainViewIcon,firstInputLabel:numberOfParkingSpotsLabel,secondInputLabel:pricePerParkingSpotLabel,firstValueObservableBox:calculatorStore.numberOfParkingSpots,secondValueObservableBox:calculatorStore.pricePerParkingSpot,currency:currency})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SideInfo,{lg:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SideInfoBackground,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SideInfoContent,{innerRef:function innerRef(ref){sideInfoRef(ref);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_kentico_blocks_Calculator_styled__["k" /* WhiteHeadline */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_kentico_blocks_Calculator_styled__["i" /* Price */],null,calculatorStore.totalOptimisationPerMonth.toLocaleString()),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_kentico_blocks_Calculator_styled__["c" /* Currency */],null,currency+' / '+sideInfoOptimisationFrequency)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_kentico_blocks_Calculator_styled__["g" /* ParagraphWhite */],{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_4_common_methods_string__["g" /* safeHtmlWithBr */])(sideInfoText)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MiddleText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_kentico_blocks_Calculator_styled__["h" /* ParagraphWhiteBig */],null,sideInfoImplementationText+'\n                    '+calculatorStore.costOfZoniferoIn5Years.toLocaleString()+'\n                    '+currency+'\n                    '+sideInfoReimburseText+' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_kentico_blocks_Calculator_styled__["i" /* Price */],null,calculatorStore.yourReturnOfInvestmentTime+' '+sideInfoOptimisationPeriod))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_kentico_blocks_Calculator_styled__["l" /* WhiteHorizontalLine */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_kentico_blocks_Calculator_styled__["a" /* ButtonTextWhite */],{mobileToRight:true,onClick:onClickNext},detailsViewLinkText,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WhiteRightArrow,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_kentico_blocks_Calculator_styled__["l" /* WhiteHorizontalLine */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AsideWhiteText,{md:6,lg:12,dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_4_common_methods_string__["a" /* NBSPAfterSingleLetters */])(Object(__WEBPACK_IMPORTED_MODULE_4_common_methods_string__["g" /* safeHtmlWithBr */])(asideNote))}}))))));}}]);return CalculatorMainView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class2.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_5_models__["k" /* Calculator */]).isRequired,sideInfoRef:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func},_temp))||_class)||_class);CalculatorMainView.defaultProps={sideInfoRef:function sideInfoRef(){return null;}};

/***/ }),

/***/ "./src/kentico-blocks/Calculator/FullWidthCalculatorDetailsItem/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FullWidthCalculatorDetailsItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable react/prop-types */var labelWidth='68%';var Container=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_hedron__["Column"]).withConfig({displayName:'FullWidthCalculatorDetailsItem__Container',componentId:'sc-1gdovx0-0'})(['position:relative;display:flex;align-items:flex-start;padding-top:',';padding-bottom:',';',''],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.xs'),function(_ref){var center=_ref.center;return center?'\n    flex-direction: column;\n    align-items: center;\n  ':'';});var Label=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].p.withConfig({displayName:'FullWidthCalculatorDetailsItem__Label',componentId:'sc-1gdovx0-1'})(['position:relative;font-family:',';font-size:',';line-height:',';color:',';width:',';margin-top:',';margin-bottom:calc(',' / 2);margin-left:',';font-weight:',';',''],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('base'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('m'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('background'),function(_ref2){var labelWide=_ref2.labelWide;return labelWide?'100%':labelWidth;},__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.xs'),function(_ref3){var labelBold=_ref3.labelBold;return labelBold?__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontWeight.regular'):__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontWeight.light');},function(_ref4){var center=_ref4.center;return center?'\n    width: 100%;\n    text-align: center;\n    top: -12%;\n  ':'';});var Value=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].p.withConfig({displayName:'FullWidthCalculatorDetailsItem__Value',componentId:'sc-1gdovx0-2'})(['font-family:',';font-size:',';color:',';white-space:nowrap;font-weight:',';margin:0;',';'],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('l'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('background'),function(_ref5){var valueBold=_ref5.valueBold;return valueBold?__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontWeight.regular'):__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontWeight.light');},function(_ref6){var center=_ref6.center;return center?'\n    text-align: center;\n    width: '+labelWidth+';\n  ':'';});var Unit=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].span.withConfig({displayName:'FullWidthCalculatorDetailsItem__Unit',componentId:'sc-1gdovx0-3'})(['font-size:',';color:',';font-weight:',';'],function(_ref7){var bigUnit=_ref7.bigUnit;return bigUnit?__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('l'):__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('m');},__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('background'),function(_ref8){var unitBold=_ref8.unitBold;return unitBold?__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontWeight.bold'):__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontWeight.regular');});var Sign=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].span.withConfig({displayName:'FullWidthCalculatorDetailsItem__Sign',componentId:'sc-1gdovx0-4'})(['font-family:',';font-size:',';font-weight:',';color:',';margin-right:',';margin-top:calc(',' / 2);'],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs('m'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('type.fontWeight.bold'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.xs'));var FullWidthCalculatorDetailsItem=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(_class=function(_Component){_inherits(FullWidthCalculatorDetailsItem,_Component);function FullWidthCalculatorDetailsItem(){_classCallCheck(this,FullWidthCalculatorDetailsItem);return _possibleConstructorReturn(this,(FullWidthCalculatorDetailsItem.__proto__||Object.getPrototypeOf(FullWidthCalculatorDetailsItem)).apply(this,arguments));}_createClass(FullWidthCalculatorDetailsItem,[{key:'render',value:function render(){var _props=this.props,label=_props.label,labelBold=_props.labelBold,value=_props.value,valueBold=_props.valueBold,unit=_props.unit,bigUnit=_props.bigUnit,unitBold=_props.unitBold,sign=_props.sign,center=_props.center;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{center:center},sign&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Sign,null,sign),center&&label&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label,{labelBold:labelBold,center:true},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Value,{valueBold:valueBold},value.toLocaleString()||value,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Unit,{bigUnit:bigUnit,unitBold:unitBold},' '+unit)),!center&&label&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label,{labelBold:labelBold},'- '+label));}}]);return FullWidthCalculatorDetailsItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;FullWidthCalculatorDetailsItem.defaultProps={sign:'',bigUnit:false,unitBold:false,labelBold:false,valueBold:false,center:false};

/***/ }),

/***/ "./src/kentico-blocks/Calculator/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Calculator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kentico_blocks_Calculator_CalculatorMainView__ = __webpack_require__("./src/kentico-blocks/Calculator/CalculatorMainView/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_kentico_blocks_Calculator_CalculatorDetailsView__ = __webpack_require__("./src/kentico-blocks/Calculator/CalculatorDetailsView/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blocks_Carousel_Carousel__ = __webpack_require__("./src/blocks/Carousel/Carousel.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_kentico_blocks_Calculator_CalculatorMainView_MobileOptimisationModal__ = __webpack_require__("./src/kentico-blocks/Calculator/CalculatorMainView/MobileOptimisationModal/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx__ = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_window_or_global__ = __webpack_require__("./node_modules/window-or-global/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_window_or_global__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_dec2,_class,_desc,_value,_class2,_descriptor,_descriptor2,_class3,_temp2;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}/* eslint-disable react/prop-types */var Calculator=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["inject"])('windowStore','calculatorStore'),_dec2=Object(__WEBPACK_IMPORTED_MODULE_4_lodash_decorators__["Debounce"])(200),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(Calculator,_Component);function Calculator(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Calculator);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Calculator.__proto__||Object.getPrototypeOf(Calculator)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'inViewport',_descriptor,_this),_initDefineProp(_this,'isMainView',_descriptor2,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Calculator,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,calculatorStore=_props.calculatorStore,data=_props.data;calculatorStore.setCalcData(data);__WEBPACK_IMPORTED_MODULE_10_window_or_global___default.a.addEventListener('scroll',this.checkIfInViewport);__WEBPACK_IMPORTED_MODULE_10_window_or_global___default.a.addEventListener('resize',this.checkIfInViewport);}},{key:'componentWillUnmount',value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_10_window_or_global___default.a.removeEventListener('scroll',this.checkIfInViewport);__WEBPACK_IMPORTED_MODULE_10_window_or_global___default.a.removeEventListener('resize',this.checkIfInViewport);}},{key:'onModalClick',value:function onModalClick(){if(this.sideInfoRef){this.sideInfoRef.scrollIntoView({behavior:'smooth',block:'end'});}}},{key:'checkIfInViewport',value:function checkIfInViewport(){if(this.calculatorDetailsRef&&this.sideInfoRef){var containerRect=this.calculatorDetailsRef.getBoundingClientRect();this.inViewport=containerRect.y<__WEBPACK_IMPORTED_MODULE_10_window_or_global___default.a.innerHeight/3&&containerRect.y>-(containerRect.height*0.47)+__WEBPACK_IMPORTED_MODULE_10_window_or_global___default.a.innerHeight;}}},{key:'slickNext',value:function slickNext(){var _this2=this;var windowStore=this.props.windowStore;if(this.sliderRef){this.sliderRef.slickNext();this.isMainView=false;setTimeout(function(){if(_this2.calculatorDetailsRef&&!windowStore.isOnDesktop){_this2.calculatorDetailsRef.scrollIntoView({behavior:'smooth'});}},150);}}},{key:'slickPrev',value:function slickPrev(){if(this.sliderRef){this.sliderRef.slickPrev();this.isMainView=true;}}},{key:'render',value:function render(){var _this3=this;var _props2=this.props,windowStore=_props2.windowStore,calculatorStore=_props2.calculatorStore,data=_props2.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,!windowStore.isOnDesktop&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_kentico_blocks_Calculator_CalculatorMainView_MobileOptimisationModal__["a" /* default */],{value:calculatorStore.totalOptimisationPerMonth,currency:data.currency,period:data.sideInfoOptimisationFrequency,description:data.valueOfOptimisationText,linkText:data.linkToMoreDataText,show:this.inViewport&&this.isMainView,onClick:this.onModalClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_blocks_Carousel_Carousel__["a" /* default */],{innerRef:function innerRef(ref){_this3.sliderRef=ref;},cursorDefault:true,settings:Calculator.carouselSettings,selectable:true,noMarginBottom:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_kentico_blocks_Calculator_CalculatorMainView__["a" /* default */],{data:data,sideInfoRef:function sideInfoRef(ref){_this3.sideInfoRef=ref;},onClickNext:this.slickNext}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_kentico_blocks_Calculator_CalculatorDetailsView__["a" /* default */],{data:data,onClickPrev:this.slickPrev,innerRef:function innerRef(ref){_this3.calculatorDetailsRef=ref;}})));}}]);return Calculator;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class3.carouselSettings={swipe:false,slidesToShow:1,dots:false,infinite:false,arrows:false,slidesToScroll:1},_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'inViewport',[__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'isMainView',[__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return true;}}),_applyDecoratedDescriptor(_class2.prototype,'onModalClick',[__WEBPACK_IMPORTED_MODULE_4_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'onModalClick'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'checkIfInViewport',[_dec2,__WEBPACK_IMPORTED_MODULE_4_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'checkIfInViewport'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'slickNext',[__WEBPACK_IMPORTED_MODULE_4_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'slickNext'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'slickPrev',[__WEBPACK_IMPORTED_MODULE_4_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'slickPrev'),_class2.prototype)),_class2))||_class)||_class);Calculator.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_models__["k" /* Calculator */]).isRequired};

/***/ }),

/***/ "./src/kentico-blocks/Calculator/styled.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ParagraphWhite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonTextWhite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CalculatorContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ParagraphWhiteBig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return WhiteHeadline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return WhiteArrow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Price; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Currency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PaddedTopRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PaddedBottomRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return WhiteHorizontalLine; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_consts_calculator__ = __webpack_require__("./src/common/consts/calculator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blocks_Arrow_Arrow__ = __webpack_require__("./src/blocks/Arrow/Arrow.js");
var _templateObject=_taggedTemplateLiteral(['\n    margin: 0;\n    line-height: ',';\n  '],['\n    margin: 0;\n    line-height: ',';\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    text-align: start;\n  '],['\n    text-align: start;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n      height: ','px;\n  '],['\n      height: ','px;\n  ']),_templateObject4=_taggedTemplateLiteral(['\n      margin-bottom: ',';\n  '],['\n      margin-bottom: ',';\n  ']),_templateObject5=_taggedTemplateLiteral(['\n    font-size: ',';\n    line-height: ',';\n  '],['\n    font-size: ',';\n    line-height: ',';\n  ']),_templateObject6=_taggedTemplateLiteral(['\n    padding-top: ',';\n  '],['\n    padding-top: ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Heading=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].h2.withConfig({displayName:'styled__Heading',componentId:'vwwu97-0'})(['font-size:',';font-family:',';padding-top:',';padding-bottom:',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('l'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'));var ParagraphWhite=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].p.withConfig({displayName:'styled__ParagraphWhite',componentId:'vwwu97-1'})(['color:',';font-family:',';line-height:',';font-size:',';font-weight:',';margin:',' 0;',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.base'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('base'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.light'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.base')));var ButtonTextWhite=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].button.withConfig({displayName:'styled__ButtonTextWhite',componentId:'vwwu97-2'})(['position:relative;color:',';font-family:',';font-size:',';font-weight:',';cursor:pointer;z-index:2;background:none;padding:0;border:none;outline:none;transition-duration:0.2s;white-space:nowrap;&:hover{opacity:0.7;}',' ',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),function(_ref){var big=_ref.big;return big?__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('l'):__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('m');},__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.light'),function(_ref2){var mobileToRight=_ref2.mobileToRight;return mobileToRight?'\n    text-align: end;\n  ':'';},__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject2));var CalculatorContainer=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_blocks_Container_Container__["a" /* default */]).withConfig({displayName:'styled__CalculatorContainer',componentId:'vwwu97-3'})(['position:relative;',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject3,__WEBPACK_IMPORTED_MODULE_4_common_consts_calculator__["a" /* default */].desktopHeight));var ParagraphWhiteBig=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].p.withConfig({displayName:'styled__ParagraphWhiteBig',componentId:'vwwu97-4'})(['color:',';font-size:',';line-height:',';font-family:',';font-weight:',';margin-top:',';margin-bottom:0;',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('l'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.l'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.light'),function(_ref3){var marginTop=_ref3.marginTop;return marginTop?marginTop+'px':0;},__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject4,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s')));var WhiteHeadline=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].p.withConfig({displayName:'styled__WhiteHeadline',componentId:'vwwu97-5'})(['font-family:',';font-weight:',';color:',';margin-top:',';margin-bottom:',';font-size:',';line-height:',';',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.headline'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.regular'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('xl'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.l'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].tablet(_templateObject5,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('xxl'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.xl')));var WhiteArrow=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_5_blocks_Arrow_Arrow__["a" /* default */]).withConfig({displayName:'styled__WhiteArrow',componentId:'vwwu97-6'})(['position:relative;display:inline-block;margin-left:',';border-color:',';width:10px;height:10px;top:-2px;'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white'));var Price=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({displayName:'styled__Price',componentId:'vwwu97-7'})(['font-weight:',';white-space:nowrap;'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.bold'));var Currency=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({displayName:'styled__Currency',componentId:'vwwu97-8'})(['font-size:',';font-weight:',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('base'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.bold'));var PaddedTopRow=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_hedron__["Row"]).withConfig({displayName:'styled__PaddedTopRow',componentId:'vwwu97-9'})(['',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].tablet(_templateObject6,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s')));var PaddedBottomRow=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_hedron__["Row"]).withConfig({displayName:'styled__PaddedBottomRow',componentId:'vwwu97-10'})(['padding-bottom:',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'));var WhiteHorizontalLine=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].hr.withConfig({displayName:'styled__WhiteHorizontalLine',componentId:'vwwu97-11'})(['border:none;border-top:1px solid ',';width:100%;height:0;opacity:0.1;margin:',' 0;',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),function(_ref4){var noMarginBottom=_ref4.noMarginBottom;return noMarginBottom?'margin-bottom: 0;':'';});

/***/ }),

/***/ "./src/kentico-blocks/CallUs/ContactPerson/ContactData.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_elements_Paragraph__ = __webpack_require__("./src/elements/Paragraph.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n  font-weight: ',';\n  text-decoration: ',';\n  margin-bottom: 0;\n  margin-top: calc(',' / 3);\n  font-size: ',';\n  \n  ','\n'],['\n  font-weight: ',';\n  text-decoration: ',';\n  margin-bottom: 0;\n  margin-top: calc(',' / 3);\n  font-size: ',';\n  \n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n     font-size: ',';\n  '],['\n     font-size: ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ContactData=__WEBPACK_IMPORTED_MODULE_0_elements_Paragraph__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.regular'),function(_ref){var underline=_ref.underline;return underline?'underline':'none';},__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].tablet(_templateObject2,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('base')));/* harmony default export */ __webpack_exports__["a"] = (ContactData);

/***/ }),

/***/ "./src/kentico-blocks/CallUs/ContactPerson/ContactDataWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var ContactDataWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'ContactDataWrapper',componentId:'phy8od-0'})(['justify-self:flex-end;word-wrap:break-word;']);/* harmony default export */ __webpack_exports__["a"] = (ContactDataWrapper);

/***/ }),

/***/ "./src/kentico-blocks/CallUs/ContactPerson/ContactLink/LinkWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n      font-size: ',';\n      zoom: 1;\n  '],['\n      font-size: ',';\n      zoom: 1;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LinkWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].a.withConfig({displayName:'LinkWrapper',componentId:'sc-2t8aqd-0'})(['display:inline-block;background-color:',';font-family:',';color:',';font-weight:',';text-decoration:none;border-radius:',';padding:calc(',' / 2) ',';margin:calc(',' / 2) calc(',' / 2) 0 0;zoom:0.7;transition-duration:0.2s;',' &:hover{background-color:',';}'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('background'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.regular'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].tablet(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('base')),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('darkBackground'));/* harmony default export */ __webpack_exports__["a"] = (LinkWrapper);

/***/ }),

/***/ "./src/kentico-blocks/CallUs/ContactPerson/ContactLink/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LinkWrapper__ = __webpack_require__("./src/kentico-blocks/CallUs/ContactPerson/ContactLink/LinkWrapper.jsx");
var ContactLink=function ContactLink(props){var _props$data=props.data,name=_props$data.name,url=_props$data.url;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__LinkWrapper__["a" /* default */],{href:url,dangerouslySetInnerHTML:{__html:name},rel:'nofollow'});};ContactLink.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_models__["O" /* Link */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (ContactLink);

/***/ }),

/***/ "./src/kentico-blocks/CallUs/ContactPerson/ContactPersonWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var ContactPersonWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'ContactPersonWrapper',componentId:'sc-1plrp04-0'})(['display:block;margin:0;']);/* harmony default export */ __webpack_exports__["a"] = (ContactPersonWrapper);

/***/ }),

/***/ "./src/kentico-blocks/CallUs/ContactPerson/ImageColumn.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_consts_person_image__ = __webpack_require__("./src/common/consts/person-image.js");
var _templateObject=_taggedTemplateLiteral(['\n    display: inline-block;\n  '],['\n    display: inline-block;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    width: ',';\n    display: inline-block;\n  '],['\n    width: ',';\n    display: inline-block;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    width: ',';\n    margin-right: ',';\n  '],['\n    width: ',';\n    margin-right: ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ImageColumn=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'ImageColumn',componentId:'sc-1juyddu-0'})(['display:block;flex-direction:column;margin-right:',';width:',';',';',';',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_2_common_consts_person_image__["c" /* smallImageWidth */],__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].mobile(_templateObject),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].tablet(_templateObject2,__WEBPACK_IMPORTED_MODULE_2_common_consts_person_image__["b" /* mediumImageWidth */]),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject3,__WEBPACK_IMPORTED_MODULE_2_common_consts_person_image__["a" /* bigImageWidth */],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.l')));/* harmony default export */ __webpack_exports__["a"] = (ImageColumn);

/***/ }),

/***/ "./src/kentico-blocks/CallUs/ContactPerson/LinksWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var LinksWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'LinksWrapper',componentId:'sc-1ali2j1-0'})(['padding-top:',';display:flex;flex-wrap:wrap;'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'));/* harmony default export */ __webpack_exports__["a"] = (LinksWrapper);

/***/ }),

/***/ "./src/kentico-blocks/CallUs/ContactPerson/PersonDescription.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_elements_DescriptionText__ = __webpack_require__("./src/elements/DescriptionText.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n  font-size: ',';\n  line-height: calc(',' / 1.1);\n  font-weight: ',';\n  margin-top: calc(',' / 3);\n  margin-bottom: ',';\n  \n  ','\n'],['\n  font-size: ',';\n  line-height: calc(',' / 1.1);\n  font-weight: ',';\n  margin-top: calc(',' / 3);\n  margin-bottom: ',';\n  \n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n    font-size: ',';\n    line-height: ',';\n  '],['\n    font-size: ',';\n    line-height: ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var PersonDescription=__WEBPACK_IMPORTED_MODULE_0_elements_DescriptionText__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.regular'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject2,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('base'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.s')));/* harmony default export */ __webpack_exports__["a"] = (PersonDescription);

/***/ }),

/***/ "./src/kentico-blocks/CallUs/ContactPerson/PersonImage.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_consts_person_image__ = __webpack_require__("./src/common/consts/person-image.js");
var _templateObject=_taggedTemplateLiteral(['\n    height: ',';\n    width: ',';\n  '],['\n    height: ',';\n    width: ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var PersonImage=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].img.withConfig({displayName:'PersonImage',componentId:'qd08eq-0'})(['object-fit:cover;height:',';width:',';',' ',';'],__WEBPACK_IMPORTED_MODULE_2_common_consts_person_image__["c" /* smallImageWidth */],__WEBPACK_IMPORTED_MODULE_2_common_consts_person_image__["c" /* smallImageWidth */],__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].tablet(_templateObject,__WEBPACK_IMPORTED_MODULE_2_common_consts_person_image__["b" /* mediumImageWidth */],__WEBPACK_IMPORTED_MODULE_2_common_consts_person_image__["b" /* mediumImageWidth */]),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_2_common_consts_person_image__["a" /* bigImageWidth */],__WEBPACK_IMPORTED_MODULE_2_common_consts_person_image__["a" /* bigImageWidth */]));/* harmony default export */ __webpack_exports__["a"] = (PersonImage);

/***/ }),

/***/ "./src/kentico-blocks/CallUs/ContactPerson/PersonName.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_elements_Header3__ = __webpack_require__("./src/elements/Header3.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n  overflow: visible;\n  margin-top: 0;\n  margin-bottom: ',';\n  font-size: ',';\n  line-height: ',';\n    \n  ','\n  \n   ','\n'],['\n  overflow: visible;\n  margin-top: 0;\n  margin-bottom: ',';\n  font-size: ',';\n  line-height: ',';\n    \n  ','\n  \n   ','\n']),_templateObject2=_taggedTemplateLiteral(['\n    font-size: ',';\n    line-height: ',';\n  '],['\n    font-size: ',';\n    line-height: ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var PersonName=__WEBPACK_IMPORTED_MODULE_0_elements_Header3__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('m'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].tablet(_templateObject2,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('m'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.s')),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject2,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fs('l'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.l')));/* harmony default export */ __webpack_exports__["a"] = (PersonName);

/***/ }),

/***/ "./src/kentico-blocks/CallUs/ContactPerson/TextColumn.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_consts_person_image__ = __webpack_require__("./src/common/consts/person-image.js");
var _templateObject=_taggedTemplateLiteral(['\n    display: inline-block;\n    width: calc(100% - ',' - ',');\n    margin-top: 0;\n  '],['\n    display: inline-block;\n    width: calc(100% - ',' - ',');\n    margin-top: 0;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    width: calc(100% - ',' - ',');\n  '],['\n    width: calc(100% - ',' - ',');\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var TextColumn=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'TextColumn',componentId:'sc-1tidrsn-0'})(['display:block;flex-direction:column;vertical-align:top;width:100%;margin-top:20px;',';',';',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].mobile(_templateObject,__WEBPACK_IMPORTED_MODULE_2_common_consts_person_image__["c" /* smallImageWidth */],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s')),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].tablet(_templateObject2,__WEBPACK_IMPORTED_MODULE_2_common_consts_person_image__["b" /* mediumImageWidth */],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s')),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject2,__WEBPACK_IMPORTED_MODULE_2_common_consts_person_image__["a" /* bigImageWidth */],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.l')));/* harmony default export */ __webpack_exports__["a"] = (TextColumn);

/***/ }),

/***/ "./src/kentico-blocks/CallUs/ContactPerson/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContactPerson; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_reveal_Fade__ = __webpack_require__("./node_modules/react-reveal/Fade.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_reveal_Fade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_reveal_Fade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_animations_Animations__ = __webpack_require__("./src/animations/Animations.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ContactPersonWrapper__ = __webpack_require__("./src/kentico-blocks/CallUs/ContactPerson/ContactPersonWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ContactLink__ = __webpack_require__("./src/kentico-blocks/CallUs/ContactPerson/ContactLink/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LinksWrapper__ = __webpack_require__("./src/kentico-blocks/CallUs/ContactPerson/LinksWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ImageColumn__ = __webpack_require__("./src/kentico-blocks/CallUs/ContactPerson/ImageColumn.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PersonImage__ = __webpack_require__("./src/kentico-blocks/CallUs/ContactPerson/PersonImage.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PersonName__ = __webpack_require__("./src/kentico-blocks/CallUs/ContactPerson/PersonName.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PersonDescription__ = __webpack_require__("./src/kentico-blocks/CallUs/ContactPerson/PersonDescription.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ContactDataWrapper__ = __webpack_require__("./src/kentico-blocks/CallUs/ContactPerson/ContactDataWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ContactData__ = __webpack_require__("./src/kentico-blocks/CallUs/ContactPerson/ContactData.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__TextColumn__ = __webpack_require__("./src/kentico-blocks/CallUs/ContactPerson/TextColumn.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable react/prop-types */var Link=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].a.withConfig({displayName:'ContactPerson__Link',componentId:'sc-1c8d49b-0'})(['color:',';text-decoration:none;font-size:',';'],__WEBPACK_IMPORTED_MODULE_7_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_7_designsystem__["a" /* default */].fs('m'));var ContactPerson=(_dec=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["inject"])('windowStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["observer"])(_class=function(_Component){_inherits(ContactPerson,_Component);function ContactPerson(){_classCallCheck(this,ContactPerson);return _possibleConstructorReturn(this,(ContactPerson.__proto__||Object.getPrototypeOf(ContactPerson)).apply(this,arguments));}_createClass(ContactPerson,[{key:'renderLinks',value:function renderLinks(){var links=this.props.data.links;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__LinksWrapper__["a" /* default */],null,links.map(function(link){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ContactLink__["a" /* default */],{data:link,key:link.id});}));}},{key:'render',value:function render(){var _props=this.props,_props$data=_props.data,email=_props$data.email,phone=_props$data.phone,photo=_props$data.photo,description=_props$data.description,name=_props$data.name,index=_props.index,windowStore=_props.windowStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_reveal_Fade___default.a,{bottom:true,distance:''+__WEBPACK_IMPORTED_MODULE_5_animations_Animations__["a" /* FADE_VALUES */].BOX.SMALL,delay:index*__WEBPACK_IMPORTED_MODULE_5_animations_Animations__["a" /* FADE_VALUES */].DELAY.SMALL},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ContactPersonWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ImageColumn__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__PersonImage__["a" /* default */],{src:windowStore.adjustImageSize(photo)}),!windowStore.isOnMobile?this.renderLinks():null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__TextColumn__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__PersonName__["a" /* default */],{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_8_common_methods_string__["g" /* safeHtmlWithBr */])(name)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PersonDescription__["a" /* default */],{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_8_common_methods_string__["g" /* safeHtmlWithBr */])(description)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ContactDataWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ContactData__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Link,{href:'tel: '+phone.match(/\+|\d/g).join(''),dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_8_common_methods_string__["g" /* safeHtmlWithBr */])(phone)}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ContactData__["a" /* default */],{underline:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Link,{href:'mailto: '+email,dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_8_common_methods_string__["g" /* safeHtmlWithBr */])(email)}}))),windowStore.isOnMobile&&this.renderLinks())));}}]);return ContactPerson;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);ContactPerson.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_models__["s" /* ContactPerson */]).isRequired,index:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired};

/***/ }),

/***/ "./src/kentico-blocks/CallUs/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blocks_HTMLModifableBackground_HTMLModifiableBackground__ = __webpack_require__("./src/blocks/HTMLModifableBackground/HTMLModifiableBackground.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ContactPerson__ = __webpack_require__("./src/kentico-blocks/CallUs/ContactPerson/index.jsx");
/* eslint-disable react/no-array-index-key */var CallUs=function CallUs(props){var _props$data=props.data,people=_props$data.people,htmlModifiers=_props$data.htmlModifiers;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_blocks_HTMLModifableBackground_HTMLModifiableBackground__["a" /* default */],{htmlModifiers:htmlModifiers,color:__WEBPACK_IMPORTED_MODULE_6_designsystem__["a" /* default */].brand('white')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_blocks_Container_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hedron__["Row"],{style:{paddingBottom:'70px'}},people.map(function(person,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hedron__["Column"],{md:6,key:person.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ContactPerson__["a" /* default */],{data:person,index:index}));}))));};CallUs.propTypes={data:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_models__["m" /* CallUs */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (CallUs);

/***/ }),

/***/ "./src/kentico-blocks/CardSlider/CardWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n        width:125%;\n        position: absolute;\n        top: ',';\n        transform: scale(1);\n        transition: transform 0.5s ease;\n        transform-origin: 0 50%;\n        & > div .slick-list{\n            overflow: visible;\n            & .slick-track{\n                margin-left:0;\n            }\n        }\n        &:hover{\n            transform: scale(0.98, 1);\n            transform-origin: 0 50%;\n            transition: transform 0.5s ease;\n            cursor:pointer;\n        }\n    '],['\n        width:125%;\n        position: absolute;\n        top: ',';\n        transform: scale(1);\n        transition: transform 0.5s ease;\n        transform-origin: 0 50%;\n        & > div .slick-list{\n            overflow: visible;\n            & .slick-track{\n                margin-left:0;\n            }\n        }\n        &:hover{\n            transform: scale(0.98, 1);\n            transform-origin: 0 50%;\n            transition: transform 0.5s ease;\n            cursor:pointer;\n        }\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var CardWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'CardWrapper',componentId:'k6t3ps-0'})(['     display:flex;flex-flow:row;width:100%;',';'],__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.l')));/* harmony default export */ __webpack_exports__["a"] = (CardWrapper);

/***/ }),

/***/ "./src/kentico-blocks/CardSlider/FeatureCard/Icon.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n        width: 100%;\n    '],['\n        width: 100%;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].img.withConfig({displayName:'Icon',componentId:'wajnjw-0'})(['width:80%;margin:0 auto;max-width:350px;',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem_index__["c" /* media */].desktop(_templateObject));/* harmony default export */ __webpack_exports__["a"] = (Icon);

/***/ }),

/***/ "./src/kentico-blocks/CardSlider/FeatureCard/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FeatureCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_reveal_Fade__ = __webpack_require__("./node_modules/react-reveal/Fade.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_reveal_Fade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_reveal_Fade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_animations_Animations__ = __webpack_require__("./src/animations/Animations.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_elements_Header4__ = __webpack_require__("./src/elements/Header4.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_elements_Paragraph__ = __webpack_require__("./src/elements/Paragraph.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Icon__ = __webpack_require__("./src/kentico-blocks/CardSlider/FeatureCard/Icon.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _templateObject=_taggedTemplateLiteral(['\n      min-width: 320px;\n      width: 95%;\n      min-height:500px;\n    '],['\n      min-width: 320px;\n      width: 95%;\n      min-height:500px;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n      min-height:510px;\n      padding: ',' ',';\n      padding-top: ',';\n    '],['\n      min-height:510px;\n      padding: ',' ',';\n      padding-top: ',';\n    ']),_templateObject3=_taggedTemplateLiteral(['\n  margin-bottom: 0;\n  ','\n'],['\n  margin-bottom: 0;\n  ','\n']),_templateObject4=_taggedTemplateLiteral(['\n    margin-bottom: ',';\n  '],['\n    margin-bottom: ',';\n  ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var FeatureCardBox=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div.withConfig({displayName:'FeatureCard__FeatureCardBox',componentId:'ml8a6d-0'})(['display:flex;width:100%;min-height:490px;justify-content:flex-start;flex-flow:column nowrap;padding:',' ',';background:',';margin-right:',';',' ',';'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.base'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_7_designsystem_index__["c" /* media */].tablet(_templateObject),__WEBPACK_IMPORTED_MODULE_7_designsystem_index__["c" /* media */].desktop(_templateObject2,__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.base'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.l'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.m')));FeatureCardBox.Icon=__WEBPACK_IMPORTED_MODULE_12__Icon__["a" /* default */];var StyledHeader=__WEBPACK_IMPORTED_MODULE_9_elements_Header4__["a" /* default */].extend(_templateObject3,__WEBPACK_IMPORTED_MODULE_7_designsystem_index__["c" /* media */].desktop(_templateObject4,__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.xs')));var FeatureCard=(_dec=Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["inject"])('windowStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["observer"])(_class=function(_Component){_inherits(FeatureCard,_Component);function FeatureCard(){_classCallCheck(this,FeatureCard);return _possibleConstructorReturn(this,(FeatureCard.__proto__||Object.getPrototypeOf(FeatureCard)).apply(this,arguments));}_createClass(FeatureCard,[{key:'render',value:function render(){var _props=this.props,_props$featureCard=_props.featureCard,logo=_props$featureCard.logo,title=_props$featureCard.title,description=_props$featureCard.description,index=_props.index,windowStore=_props.windowStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_reveal_Fade___default.a,{bottom:true,distance:''+__WEBPACK_IMPORTED_MODULE_8_animations_Animations__["a" /* FADE_VALUES */].BOX.LARGE,delay:windowStore.isOnMobile?__WEBPACK_IMPORTED_MODULE_8_animations_Animations__["a" /* FADE_VALUES */].DELAY.SMALL:__WEBPACK_IMPORTED_MODULE_8_animations_Animations__["a" /* FADE_VALUES */].DELAY.SMALL*index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FeatureCardBox,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FeatureCardBox.Icon,{src:windowStore.adjustImageSize(logo)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledHeader,{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_11_common_methods_string__["g" /* safeHtmlWithBr */])(title)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_elements_Paragraph__["a" /* default */],{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_11_common_methods_string__["g" /* safeHtmlWithBr */])(description)}})));}}]);return FeatureCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);FeatureCard.propTypes={featureCard:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_6_models__["n" /* CardSlide */]).isRequired,index:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired};

/***/ }),

/***/ "./src/kentico-blocks/CardSlider/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardSliderBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_responsive__ = __webpack_require__("./src/common/responsive.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blocks_Carousel_Carousel__ = __webpack_require__("./src/blocks/Carousel/Carousel.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_elements_Header4__ = __webpack_require__("./src/elements/Header4.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_blocks_HTMLModifableBackground_HTMLModifiableBackground__ = __webpack_require__("./src/blocks/HTMLModifableBackground/HTMLModifiableBackground.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FeatureCard__ = __webpack_require__("./src/kentico-blocks/CardSlider/FeatureCard/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CardWrapper__ = __webpack_require__("./src/kentico-blocks/CardSlider/CardWrapper.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CardSlider=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div.withConfig({displayName:'CardSlider',componentId:'sc-3l5c75-0'})(['width:100%;margin:0 auto;position:relative;height:750px;padding:0;']);var CardSliderBlock=(_temp=_class=function(_Component){_inherits(CardSliderBlock,_Component);function CardSliderBlock(){_classCallCheck(this,CardSliderBlock);return _possibleConstructorReturn(this,(CardSliderBlock.__proto__||Object.getPrototypeOf(CardSliderBlock)).apply(this,arguments));}_createClass(CardSliderBlock,[{key:'render',value:function render(){var _props$data=this.props.data,slides=_props$data.slides,header=_props$data.header,htmlModifiers=_props$data.htmlModifiers;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_blocks_HTMLModifableBackground_HTMLModifiableBackground__["a" /* default */],{htmlModifiers:htmlModifiers,color:__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('background')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_blocks_Container_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_hedron__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_hedron__["Column"],{lg:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CardSlider,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_elements_Header4__["a" /* default */],{bold:true,dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_11_common_methods_string__["g" /* safeHtmlWithBr */])(header)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__CardWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_blocks_Carousel_Carousel__["a" /* default */],{settings:CardSliderBlock.carouselSettings},slides.map(function(slide,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__FeatureCard__["a" /* default */],{featureCard:slide,key:slide.system.id,index:index});}))))))));}}]);return CardSliderBlock;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.carouselSettings={swipe:true,slidesToShow:4.856,dots:false,infinite:false,arrows:false,slidesToScroll:1,responsive:[{breakpoint:1366,settings:{slidesToShow:3.89,slidesToScroll:1,dots:true,infinite:false,arrows:false}},{breakpoint:__WEBPACK_IMPORTED_MODULE_4_common_responsive__["a" /* desktopBreakpoint */],settings:{slidesToShow:2.12,slidesToScroll:1,infinite:false,arrows:false}},{breakpoint:__WEBPACK_IMPORTED_MODULE_4_common_responsive__["e" /* tabletBreakpoint */],settings:{slidesToShow:1,slidesToScroll:1,dots:true,infinite:false,arrows:false}}]},_class.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_5_models__["o" /* CardSlider */]).isRequired},_temp);

/***/ }),

/***/ "./src/kentico-blocks/ContactForm/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_google_recaptcha__ = __webpack_require__("./node_modules/react-google-recaptcha/lib/esm/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_blocks_Form_CustomForm__ = __webpack_require__("./src/blocks/Form/CustomForm.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_blocks_Form_CustomFormElement__ = __webpack_require__("./src/blocks/Form/CustomFormElement.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_blocks_Form_SubmitButton__ = __webpack_require__("./src/blocks/Form/SubmitButton.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_Mailing_service__ = __webpack_require__("./src/services/Mailing.service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_common_consts_form__ = __webpack_require__("./src/common/consts/form.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_blocks_HTMLModifableBackground_HTMLModifiableBackground__ = __webpack_require__("./src/blocks/HTMLModifableBackground/HTMLModifiableBackground.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}/* eslint-disable react/prop-types */// restore below when privacy policy agreement is required
// import CustomCheckbox from 'blocks/Form/CustomCheckbox';
// restore below when privacy policy agreement is required
// import { removeTags } from 'common/methods/string';
// restore below when privacy policy agreement is required
// import styled from 'styled-components';
// restore below when privacy policy agreement is required
// const CheckboxContainer = styled.div`
//   transition: all 0.35s ease-out;
//   transform-origin: 50% 75%;
//   position: relative;
//
//   ${({ visible }) => (visible
//     ? 'transform: scaleY(1); margin-top: 0; opacity: 1;'
//     : `transform: scaleY(0.33); margin-top: -${ds.get('metrics.xxl')}; opacity: 0;`)};
// `;
// cancel below when privacy policy agreement is required
var ContactForm=(_dec=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["inject"])('appStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["observer"])(_class=(_class2=function(_Component){_inherits(ContactForm,_Component);function ContactForm(props){_classCallCheck(this,ContactForm);var _this=_possibleConstructorReturn(this,(ContactForm.__proto__||Object.getPrototypeOf(ContactForm)).call(this,props));_this.captchaRef=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();_this.state={formData:{body:'',email:'',firstName:'',lastName:'',phone:'',dataProcessingCheckbox:false,dataSendingCheckbox:false},buttonState:'',resetValue:false,country:'PL',clientIP:'',showReCAPTCHA:false,isReCAPTCHAError:false// restore below when privacy policy agreement is required
// isRodoVisible: false,
};_this.checkReCAPTCHA();return _this;}_createClass(ContactForm,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;fetch("https://ipinfo.io/json?token=ea4d0cf5569d7d").then(function(response){return response.json();}).then(function(jsonResponse){return _this2.setState({clientIP:jsonResponse.ip},function(){return _this2.checkReCAPTCHA();});});}},{key:'checkReCAPTCHA',value:function checkReCAPTCHA(){var _this3=this;__WEBPACK_IMPORTED_MODULE_12_services_Mailing_service__["a" /* default */].spamBotDetected(this.state.clientIP,"check").then(function(res){return _this3.setState({showReCAPTCHA:res});});}},{key:'submitForm',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(submitEvent){var _this4=this;var _props$appStore,referrer,currentUrl,previousUrl,_state$formData,firstName,lastName,phone,email,body,token,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:submitEvent.preventDefault();_props$appStore=this.props.appStore,referrer=_props$appStore.referrer,currentUrl=_props$appStore.currentUrl,previousUrl=_props$appStore.previousUrl;_state$formData=this.state.formData,firstName=_state$formData.firstName,lastName=_state$formData.lastName,phone=_state$formData.phone,email=_state$formData.email,body=_state$formData.body;_context.prev=3;if(!this.state.showReCAPTCHA){_context.next=12;break;}token=this.captchaRef.current.getValue();if(token){_context.next=9;break;}this.setState({isReCAPTCHAError:true});return _context.abrupt('return');case 9:__WEBPACK_IMPORTED_MODULE_12_services_Mailing_service__["a" /* default */].spamBotDetected(this.state.clientIP,"submit",token).then(function(res){return _this4.setState({showReCAPTCHA:res});});_context.next=13;break;case 12:__WEBPACK_IMPORTED_MODULE_12_services_Mailing_service__["a" /* default */].spamBotDetected(this.state.clientIP,"submit").then(function(res){return _this4.setState({showReCAPTCHA:res});});case 13:this.setState({buttonState:__WEBPACK_IMPORTED_MODULE_13_common_consts_form__["a" /* default */].BUTTON_STATE.LOADING});fetch("https://ipinfo.io/json?token=ea4d0cf5569d7d").then(function(response){return response.json();}).then(function(jsonResponse){return _this4.setState({country:jsonResponse.country});});data={firstName:firstName,lastName:lastName,phone:phone,email:email,body:body,source:referrer,url:currentUrl,referrer:previousUrl,country:this.state.country};_context.next=18;return __WEBPACK_IMPORTED_MODULE_12_services_Mailing_service__["a" /* default */].sendContactForm(data);case 18:_context.next=20;return __WEBPACK_IMPORTED_MODULE_12_services_Mailing_service__["a" /* default */].sendPipedrive(data);case 20:if(!_context.sent){_context.next=26;break;}this.setState({buttonState:__WEBPACK_IMPORTED_MODULE_13_common_consts_form__["a" /* default */].BUTTON_STATE.SUCCESS});setTimeout(function(){_this4.resetState();},__WEBPACK_IMPORTED_MODULE_13_common_consts_form__["a" /* default */].SUCCESS_MESSAGE_TIMEOUT);this.setState({resetValue:false});_context.next=27;break;case 26:throw new Error();case 27:_context.next=32;break;case 29:_context.prev=29;_context.t0=_context['catch'](3);this.setState({buttonState:__WEBPACK_IMPORTED_MODULE_13_common_consts_form__["a" /* default */].BUTTON_STATE.ERROR});case 32:case'end':return _context.stop();}}},_callee,this,[[3,29]]);}));function submitForm(_x){return _ref.apply(this,arguments);}return submitForm;}()},{key:'resetState',value:function resetState(){this.setState({formData:{body:'',email:'',firstName:'',lastName:'',phone:'',dataProcessingCheckbox:false,dataSendingCheckbox:false},buttonState:'',resetValue:true});}},{key:'updateInputValue',value:function updateInputValue(input){var inputName=input.inputName;var formData=this.state.formData;formData[inputName]=input.value;this.setState({formData:formData});}// restore below when privacy policy agreement is required
// @Bind
// showRodoCheckboxes() {
//   this.setState({
//     isRodoVisible: true,
//   });
// }
},{key:'render',value:function render(){var _props$data=this.props.data,emailLabel=_props$data.emailLabel,firstNameLabel=_props$data.firstNameLabel,lastNameLabel=_props$data.lastNameLabel,phoneLabel=_props$data.phoneLabel,messageLabel=_props$data.messageLabel,reCaptchaErrorMessage=_props$data.reCaptchaErrorMessage,htmlModifiers=_props$data.htmlModifiers;// cancel below when privacy policy agreement is required
var _state=this.state,buttonState=_state.buttonState,resetValue=_state.resetValue;// restore below when privacy policy agreement is required
// const { buttonState, resetValue, isRodoVisible } = this.state;
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_blocks_HTMLModifableBackground_HTMLModifiableBackground__["a" /* default */],{htmlModifiers:htmlModifiers,color:__WEBPACK_IMPORTED_MODULE_14_designsystem__["a" /* default */].brand('white')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_blocks_Form_CustomForm__["a" /* default */],{onSubmit:this.submitForm,className:'GA-form-contact'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_blocks_Container_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_hedron__["Row"],{divisions:11},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_hedron__["Column"],{lg:5},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_blocks_Form_CustomFormElement__["a" /* default */],{type:'text',name:'firstName',required:true,labelName:firstNameLabel,validateOnInput:true,getValue:this.updateInputValue,resetValue:resetValue// restore below when privacy policy agreement is required
// onInput={this.showRodoCheckboxes}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_hedron__["Column"],{lg:5,lgShift:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_blocks_Form_CustomFormElement__["a" /* default */],{type:'text',name:'lastName',required:true,labelName:lastNameLabel,validateOnInput:true,getValue:this.updateInputValue,resetValue:resetValue// restore below when privacy policy agreement is required
// onInput={this.showRodoCheckboxes}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_hedron__["Row"],{divisions:11},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_hedron__["Column"],{lg:5},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_blocks_Form_CustomFormElement__["a" /* default */],{type:'tel',name:'phone',required:true,pattern:'^[0-9-+\\s()]*$',labelName:phoneLabel,validateOnInput:true,getValue:this.updateInputValue,resetValue:resetValue// restore below when privacy policy agreement is required
// onInput={this.showRodoCheckboxes}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_hedron__["Column"],{lg:5,lgShift:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_blocks_Form_CustomFormElement__["a" /* default */],{type:'email',name:'email',required:true,labelName:emailLabel,validateOnInput:true,getValue:this.updateInputValue,resetValue:resetValue// restore below when privacy policy agreement is required
// onInput={this.showRodoCheckboxes}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_hedron__["Row"],{divisions:11},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_hedron__["Column"],{lg:11},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_blocks_Form_CustomFormElement__["a" /* default */],{type:'textarea',name:'body',labelName:messageLabel,required:true,validateOnInput:true,getValue:this.updateInputValue,resetValue:resetValue// restore below when privacy policy agreement is required
// onInput={this.showRodoCheckboxes}
}))),this.state.showReCAPTCHA&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_hedron__["Row"],{divisions:11},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_hedron__["Column"],{lg:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_google_recaptcha__["a" /* default */],{sitekey:"6Ld2rL0kAAAAAPMldKss1yYJmpWfSil0UPlBBlqh",ref:this.captchaRef}),this.state.isReCAPTCHAError&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:{"color":"red"}},reCaptchaErrorMessage))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_hedron__["Row"],{divisions:11},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_hedron__["Column"],{lg:11},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_blocks_Form_SubmitButton__["a" /* default */],{centered:true,buttonState:buttonState}))))));}}]);return ContactForm;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),(_applyDecoratedDescriptor(_class2.prototype,'submitForm',[__WEBPACK_IMPORTED_MODULE_11_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'submitForm'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'updateInputValue',[__WEBPACK_IMPORTED_MODULE_11_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'updateInputValue'),_class2.prototype)),_class2))||_class)||_class);ContactForm.propTypes={data:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_7_models__["q" /* ContactForm */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (ContactForm);

/***/ }),

/***/ "./src/kentico-blocks/ContactFormSupport/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blocks_Form_CustomCheckbox__ = __webpack_require__("./src/blocks/Form/CustomCheckbox.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_blocks_Form_CustomForm__ = __webpack_require__("./src/blocks/Form/CustomForm.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_blocks_Form_CustomFormElement__ = __webpack_require__("./src/blocks/Form/CustomFormElement.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_blocks_Form_SubmitButton__ = __webpack_require__("./src/blocks/Form/SubmitButton.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_Mailing_service__ = __webpack_require__("./src/services/Mailing.service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_common_consts_form__ = __webpack_require__("./src/common/consts/form.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_blocks_HTMLModifableBackground_HTMLModifiableBackground__ = __webpack_require__("./src/blocks/HTMLModifableBackground/HTMLModifiableBackground.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}/* eslint-disable react/prop-types */// if privacy policy agreement is requred see commit:
// https://softwarehut.visualstudio.com/DefaultCollection/Zonifero.WWW/_git/Zonifero.WWW/commit/52b0ba021a24d6bc2ea1910d4d60af104f948a46?refName=refs%2Fheads%2Ffeature%2F76983-add-contact-form-support
// and add commented out lines
var ContactFormSupport=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["inject"])('appStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"])(_class=(_class2=function(_Component){_inherits(ContactFormSupport,_Component);function ContactFormSupport(props){_classCallCheck(this,ContactFormSupport);var _this=_possibleConstructorReturn(this,(ContactFormSupport.__proto__||Object.getPrototypeOf(ContactFormSupport)).call(this,props));_this.state={formData:{system:[],body:'',email:'',firstName:'',lastName:'',phone:'',company:'',osVersion:'',dataProcessingCheckbox:false,dataSendingCheckbox:false},buttonState:'',resetValue:false};return _this;}_createClass(ContactFormSupport,[{key:'submitForm',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(submitEvent){var _this2=this;var _props$appStore,referrer,currentUrl,previousUrl,_state$formData,firstName,lastName,phone,email,body,company,osVersion,system,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:submitEvent.preventDefault();_props$appStore=this.props.appStore,referrer=_props$appStore.referrer,currentUrl=_props$appStore.currentUrl,previousUrl=_props$appStore.previousUrl;_state$formData=this.state.formData,firstName=_state$formData.firstName,lastName=_state$formData.lastName,phone=_state$formData.phone,email=_state$formData.email,body=_state$formData.body,company=_state$formData.company,osVersion=_state$formData.osVersion,system=_state$formData.system;_context.prev=3;this.setState({buttonState:__WEBPACK_IMPORTED_MODULE_13_common_consts_form__["a" /* default */].BUTTON_STATE.LOADING});fetch("https://ipinfo.io/json?token=ea4d0cf5569d7d").then(function(response){return response.json();}).then(function(jsonResponse){return _this2.setState({country:jsonResponse.country});});data={firstName:firstName,lastName:lastName,phone:phone,email:email,body:body,company:company,system:system,osVersion:osVersion,source:referrer,url:currentUrl,referrer:previousUrl};_context.next=9;return __WEBPACK_IMPORTED_MODULE_12_services_Mailing_service__["a" /* default */].sendContactSupportForm(data);case 9:this.setState({buttonState:__WEBPACK_IMPORTED_MODULE_13_common_consts_form__["a" /* default */].BUTTON_STATE.SUCCESS});setTimeout(function(){_this2.resetState();},__WEBPACK_IMPORTED_MODULE_13_common_consts_form__["a" /* default */].SUCCESS_MESSAGE_TIMEOUT);this.setState({resetValue:false});_context.next=17;break;case 14:_context.prev=14;_context.t0=_context['catch'](3);this.setState({buttonState:__WEBPACK_IMPORTED_MODULE_13_common_consts_form__["a" /* default */].BUTTON_STATE.ERROR});case 17:case'end':return _context.stop();}}},_callee,this,[[3,14]]);}));function submitForm(_x){return _ref.apply(this,arguments);}return submitForm;}()},{key:'resetState',value:function resetState(){this.setState({formData:{system:[],body:'',company:'',osVersion:'',email:'',firstName:'',lastName:'',phone:'',dataProcessingCheckbox:false,dataSendingCheckbox:false},buttonState:'',resetValue:true});}},{key:'updateInputValue',value:function updateInputValue(input){var inputName=input.inputName;var formData=this.state.formData;formData[inputName]=input.value;this.setState({formData:formData});}},{key:'updateGroupInputValue',value:function updateGroupInputValue(input){var inputName=input.inputName,value=input.value;var formData=this.state.formData;if(!formData.system.includes(inputName)&&value){formData.system.push(inputName);}if(formData.system.includes(inputName)&&!value){formData.system=formData.system.filter(function(item){return item!==inputName;});}this.setState({formData:formData});}},{key:'render',value:function render(){var _this3=this;var _props$data=this.props.data,clientSystem=_props$data.clientSystem,company=_props$data.company,osVersion=_props$data.osVersion,emailLabel=_props$data.emailLabel,firstNameLabel=_props$data.firstNameLabel,lastNameLabel=_props$data.lastNameLabel,phoneLabel=_props$data.phoneLabel,messageLabel=_props$data.messageLabel,htmlModifiers=_props$data.htmlModifiers;var _state=this.state,buttonState=_state.buttonState,resetValue=_state.resetValue;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_blocks_HTMLModifableBackground_HTMLModifiableBackground__["a" /* default */],{htmlModifiers:htmlModifiers,color:__WEBPACK_IMPORTED_MODULE_14_designsystem__["a" /* default */].brand('white')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_blocks_Form_CustomForm__["a" /* default */],{onSubmit:this.submitForm,className:'GA-form-contact'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_blocks_Container_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hedron__["Row"],{divisions:11},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hedron__["Column"],{lg:5},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_blocks_Form_CustomFormElement__["a" /* default */],{type:'text',name:'firstName',required:true,labelName:firstNameLabel,validateOnInput:true,getValue:this.updateInputValue,resetValue:resetValue})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hedron__["Column"],{lg:5,lgShift:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_blocks_Form_CustomFormElement__["a" /* default */],{type:'text',name:'lastName',required:true,labelName:lastNameLabel,validateOnInput:true,getValue:this.updateInputValue,resetValue:resetValue}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hedron__["Row"],{divisions:11},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hedron__["Column"],{lg:5},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_blocks_Form_CustomFormElement__["a" /* default */],{type:'tel',name:'phone',pattern:'^[0-9-+\\s()]*$',labelName:phoneLabel,validateOnInput:true,getValue:this.updateInputValue,resetValue:resetValue})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hedron__["Column"],{lg:5,lgShift:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_blocks_Form_CustomFormElement__["a" /* default */],{type:'email',name:'email',required:true,labelName:emailLabel,validateOnInput:true,getValue:this.updateInputValue,resetValue:resetValue}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hedron__["Row"],{divisions:11},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hedron__["Column"],{lg:5},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_blocks_Form_CustomFormElement__["a" /* default */],{type:'text',name:'company',required:true,labelName:company,validateOnInput:true,getValue:this.updateInputValue,resetValue:resetValue})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hedron__["Column"],{lg:5,lgShift:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_blocks_Form_CustomFormElement__["a" /* default */],{type:'text',name:'osVersion',required:true,labelName:osVersion,validateOnInput:true,getValue:this.updateInputValue,resetValue:resetValue}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hedron__["Row"],{divisions:11},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hedron__["Column"],{lg:11},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_blocks_Form_CustomFormElement__["a" /* default */],{type:'textarea',name:'body',labelName:messageLabel,required:true,validateOnInput:true,getValue:this.updateInputValue,resetValue:resetValue}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hedron__["Row"],{divisions:15},clientSystem.map(function(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hedron__["Column"],{key:item.name,lg:4,lgShift:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_blocks_Form_CustomCheckbox__["a" /* default */],{name:item.name,checkboxText:item.name,getValue:_this3.updateGroupInputValue,resetValue:resetValue}));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hedron__["Row"],{divisions:11},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hedron__["Column"],{lg:11},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_blocks_Form_SubmitButton__["a" /* default */],{centered:true,buttonState:buttonState}))))));}}]);return ContactFormSupport;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),(_applyDecoratedDescriptor(_class2.prototype,'submitForm',[__WEBPACK_IMPORTED_MODULE_11_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'submitForm'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'updateInputValue',[__WEBPACK_IMPORTED_MODULE_11_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'updateInputValue'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'updateGroupInputValue',[__WEBPACK_IMPORTED_MODULE_11_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'updateGroupInputValue'),_class2.prototype)),_class2))||_class)||_class);ContactFormSupport.propTypes={data:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_5_models__["r" /* ContactFormSupport */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (ContactFormSupport);

/***/ }),

/***/ "./src/kentico-blocks/CroppedAsset/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    margin-top: calc(',' * 2);\n    margin-bottom: ',';\n  '],['\n    margin-top: calc(',' * 2);\n    margin-bottom: ',';\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    margin-top: calc(',' * 2);\n    margin-bottom: calc(',' * 2);\n  '],['\n    margin-top: calc(',' * 2);\n    margin-bottom: calc(',' * 2);\n  ']),_templateObject3=_taggedTemplateLiteral(['\n      font-size: ',';\n    '],['\n      font-size: ',';\n    ']),_templateObject4=_taggedTemplateLiteral(['\n    display: flex;\n    margin: auto;\n    \n    .iframe-wrapper {\n      flex: 1 0 50%;\n    }\n\n    iframe {\n      left: 0;\n      width: 100%;\n      height: 50%;\n      transform: translateY(50%);\n    }\n  '],['\n    display: flex;\n    margin: auto;\n    \n    .iframe-wrapper {\n      flex: 1 0 50%;\n    }\n\n    iframe {\n      left: 0;\n      width: 100%;\n      height: 50%;\n      transform: translateY(50%);\n    }\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var CropContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({displayName:'CroppedAsset__CropContainer',componentId:'a6ebnb-0'})(['position:',';top:0;left:0;overflow:hidden;',''],function(_ref){var absolute=_ref.absolute;return absolute?'absolute':'relative';},function(_ref2){var _ref2$params=_ref2.params,width=_ref2$params.width,height=_ref2$params.height,marginLeft=_ref2$params.marginLeft,marginTop=_ref2$params.marginTop;return'\n    width: '+width+';\n\t\theight: '+height+';\n\t\tmargin-left: '+marginLeft+';\n\t\tmargin-top: '+marginTop+';';});var Header=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({displayName:'CroppedAsset__Header',componentId:'a6ebnb-1'})(['flex:0 1 auto;font-family:',';margin-top:calc(',');margin-bottom:',';margin-left:20px;margin-right:20px;display:flex;flex-direction:column;justify-content:center;',' ',' .title{font-weight:',';font-size:',';color:',';','}.subtitle{font-weight:',';font-size:',';margin-top:',' ','}'],__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('type.fontFamily.headline'),__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('metrics.xl'),__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_5_designsystem__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('metrics.xl'),__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('metrics.xl')),__WEBPACK_IMPORTED_MODULE_5_designsystem__["c" /* media */].xLargeDesktop(_templateObject2,__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('metrics.xl'),__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('metrics.xl')),__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('type.fontWeight.bold'),__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].fs('xl'),__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].brand('product'),__WEBPACK_IMPORTED_MODULE_5_designsystem__["c" /* media */].desktop(_templateObject3,__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].fs('xxl')),__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('type.fontWeight.extended'),__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].fs('m'),__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('metrics.base'),__WEBPACK_IMPORTED_MODULE_5_designsystem__["c" /* media */].desktop(_templateObject3,__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].fs('l')));var YouTubeContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({displayName:'CroppedAsset__YouTubeContainer',componentId:'a6ebnb-2'})(['max-width:100%;margin:0 auto;width:1366px;.iframe-wrapper{position:relative;padding-bottom:56.25%;height:0;}iframe{position:absolute;top:0;left:20px;width:calc(100% - 40px);height:100%;}',''],__WEBPACK_IMPORTED_MODULE_5_designsystem__["c" /* media */].xLargeDesktop(_templateObject4));var CroppedImage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].img.withConfig({displayName:'CroppedAsset__CroppedImage',componentId:'a6ebnb-3'})(['']);var CroppedVideo=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].video.withConfig({displayName:'CroppedAsset__CroppedVideo',componentId:'a6ebnb-4'})(['object-fit:cover;',''],function(_ref3){var _ref3$params=_ref3.params,width=_ref3$params.width,height=_ref3$params.height;return'\n    width: '+width+';\n    height: '+height+';\n  ';});var EmbedYouTube=function EmbedYouTube(_ref4){var data=_ref4.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(YouTubeContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header,null,data.title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},data.title),data.subtitle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subtitle'},data.subtitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'iframe-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{title:'youTubeSrc',src:data.youTubeSrc,frameborder:'0',allow:'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',allowfullscreen:true})));};var CroppedAsset=function CroppedAsset(_ref5){var data=_ref5.data,absolute=_ref5.absolute;if(data.youTubeSrc){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EmbedYouTube,{data:data});}return Object(__WEBPACK_IMPORTED_MODULE_4_common_methods_string__["e" /* isVideo */])(data.asset)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CropContainer,{params:data,absolute:absolute},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CroppedVideo,{src:data.asset,params:data,muted:true,loop:true,autoPlay:true})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CropContainer,{params:data,absolute:absolute},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CroppedImage,{src:''+Object(__WEBPACK_IMPORTED_MODULE_4_common_methods_string__["b" /* croppedImageUrl */])(data.asset,data.width,data.height)}));};CroppedAsset.propTypes={data:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_models__["v" /* CroppedAsset */]).isRequired,absolute:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};CroppedAsset.defaultProps={absolute:false};/* harmony default export */ __webpack_exports__["a"] = (CroppedAsset);

/***/ }),

/***/ "./src/kentico-blocks/DividedBlogSection/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DivicedBlogSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_consts_dividedSectionOrder__ = __webpack_require__("./src/common/consts/dividedSectionOrder.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_responsive__ = __webpack_require__("./src/common/responsive.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_reveal_Fade__ = __webpack_require__("./node_modules/react-reveal/Fade.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_reveal_Fade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_reveal_Fade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_animations_Animations__ = __webpack_require__("./src/animations/Animations.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_elements_Image__ = __webpack_require__("./src/elements/Image.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_elements_BlogArticleBoldText__ = __webpack_require__("./src/elements/BlogArticleBoldText.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _templateObject=_taggedTemplateLiteral(['\n      display:flex;\n      flex-direction:row;\n      width:100%;\n      width:160%;\n      margin:',' auto;\n      margin-left:',';\n    '],['\n      display:flex;\n      flex-direction:row;\n      width:100%;\n      width:160%;\n      margin:',' auto;\n      margin-left:',';\n    ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var SectionWrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div.withConfig({displayName:'DividedBlogSection__SectionWrapper',componentId:'sc-13zvrj7-0'})(['margin:',' auto;',';'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.base'),__WEBPACK_IMPORTED_MODULE_6_common_responsive__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.l'),function(_ref){var order=_ref.order;return order?'-36%':'-15%';}));var StyledColumn=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_hedron__["Column"]).withConfig({displayName:'DividedBlogSection__StyledColumn',componentId:'sc-13zvrj7-1'})(['order:',';'],function(_ref2){var order=_ref2.order;return order?'0':'1';});var DivicedBlogSection=(_dec=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["inject"])('windowStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["observer"])(_class=function(_Component){_inherits(DivicedBlogSection,_Component);function DivicedBlogSection(){_classCallCheck(this,DivicedBlogSection);return _possibleConstructorReturn(this,(DivicedBlogSection.__proto__||Object.getPrototypeOf(DivicedBlogSection)).apply(this,arguments));}_createClass(DivicedBlogSection,[{key:'render',value:function render(){var _props=this.props,_props$data=_props.data,cite=_props$data.cite,image=_props$data.image,order=_props$data.order,windowStore=_props.windowStore;var imageFirst=order===__WEBPACK_IMPORTED_MODULE_5_common_consts_dividedSectionOrder__["a" /* default */].IMAGE_CITE;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SectionWrapper,{order:imageFirst?1:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledColumn,{lg:6,lgShift:!imageFirst?1:0,order:imageFirst?1:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_reveal_Fade___default.a,{left:true,distance:''+__WEBPACK_IMPORTED_MODULE_8_animations_Animations__["a" /* FADE_VALUES */].BOX.SMALL,delay:__WEBPACK_IMPORTED_MODULE_8_animations_Animations__["a" /* FADE_VALUES */].DELAY.SMALL},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_elements_Image__["a" /* default */],{src:windowStore.adjustImageSize(image)}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_hedron__["Column"],{lg:4,lgShift:imageFirst?1:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_reveal_Fade___default.a,{right:true,distance:''+__WEBPACK_IMPORTED_MODULE_8_animations_Animations__["a" /* FADE_VALUES */].BOX.SMALL,delay:__WEBPACK_IMPORTED_MODULE_8_animations_Animations__["a" /* FADE_VALUES */].DELAY.SMALL},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_elements_BlogArticleBoldText__["a" /* default */],{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_11_common_methods_string__["g" /* safeHtmlWithBr */])(cite)}}))));}}]);return DivicedBlogSection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);

/***/ }),

/***/ "./src/kentico-blocks/DownloadBar/BorderedDescription.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_elements_Paragraph__ = __webpack_require__("./src/elements/Paragraph.js");
var _templateObject=_taggedTemplateLiteral(['\n  border-left: none;\n  border-right: 1px solid ','; \n  \n  ','\n'],['\n  border-left: none;\n  border-right: 1px solid ','; \n  \n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n    border-left: 1px solid ','; \n  '],['\n    border-left: 1px solid ','; \n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var BorderedDescription=__WEBPACK_IMPORTED_MODULE_1_elements_Paragraph__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_0_designsystem__["a" /* default */].brand('text'),__WEBPACK_IMPORTED_MODULE_0_designsystem__["c" /* media */].desktop(_templateObject2,__WEBPACK_IMPORTED_MODULE_0_designsystem__["a" /* default */].brand('text')));/* harmony default export */ __webpack_exports__["a"] = (BorderedDescription);

/***/ }),

/***/ "./src/kentico-blocks/DownloadBar/DownloadButton.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_responsive__ = __webpack_require__("./src/common/responsive.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_elements_Button__ = __webpack_require__("./src/elements/Button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
var _templateObject=_taggedTemplateLiteral(['\n  margin: 0;\n  width: inherit;\n  ',';\n'],['\n  margin: 0;\n  width: inherit;\n  ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n    width: 100%;\n  '],['\n    width: 100%;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var DownloadButton=__WEBPACK_IMPORTED_MODULE_2_elements_Button__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_0_common_responsive__["c" /* media */].desktop(_templateObject2));var DownloadAHref=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].a.withConfig({displayName:'DownloadButton__DownloadAHref',componentId:'qaqaxj-0'})(['cursor:pointer;text-decoration:inherit;']);var DownloadButtonElement=function DownloadButtonElement(props){var file=props.file,fileName=props.fileName,buttonText=props.buttonText;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(DownloadAHref,{href:file,download:fileName,target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(DownloadButton,null,buttonText));};DownloadButtonElement.propTypes={file:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,fileName:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,buttonText:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (DownloadButtonElement);

/***/ }),

/***/ "./src/kentico-blocks/DownloadBar/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_responsive__ = __webpack_require__("./src/common/responsive.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_methods_formatFileSize__ = __webpack_require__("./src/common/methods/formatFileSize.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_elements_Header4__ = __webpack_require__("./src/elements/Header4.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_elements_Paragraph__ = __webpack_require__("./src/elements/Paragraph.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_blocks_HTMLModifableBackground_HTMLModifiableBackground__ = __webpack_require__("./src/blocks/HTMLModifableBackground/HTMLModifiableBackground.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__BorderedDescription__ = __webpack_require__("./src/kentico-blocks/DownloadBar/BorderedDescription.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DownloadButton__ = __webpack_require__("./src/kentico-blocks/DownloadBar/DownloadButton.jsx");
var _templateObject=_taggedTemplateLiteral(['\n    max-width: 100%;\n    height: 120px;\n  '],['\n    max-width: 100%;\n    height: 120px;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var DownloadBar=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div.withConfig({displayName:'DownloadBar',componentId:'sc-1vw6gms-0'})(['max-width:400px;margin:0 auto;text-align:center;',''],__WEBPACK_IMPORTED_MODULE_6_common_responsive__["c" /* media */].desktop(_templateObject));var DownloadBarBlock=function DownloadBarBlock(props){var _props$data=props.data,leftText=_props$data.leftText,_props$data$fileLink=_props$data.fileLink,fileName=_props$data$fileLink.fileName,fileType=_props$data$fileLink.fileType,fileSize=_props$data$fileLink.fileSize,fileUrl=_props$data$fileLink.fileUrl,buttonText=_props$data.buttonText,htmlModifiers=_props$data.htmlModifiers;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_blocks_HTMLModifableBackground_HTMLModifiableBackground__["a" /* default */],{htmlModifiers:htmlModifiers,color:__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].brand('background')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_blocks_Container_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_hedron__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_hedron__["Column"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DownloadBar,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_hedron__["Row"],{alignItems:'center',justifyContent:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_hedron__["Column"],{lg:2,fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_elements_Header4__["a" /* default */],{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_12_common_methods_string__["g" /* safeHtmlWithBr */])(leftText)}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_hedron__["Column"],{lg:5,fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_elements_Paragraph__["a" /* default */],{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_12_common_methods_string__["g" /* safeHtmlWithBr */])(fileName)}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_hedron__["Column"],{lg:1,xs:6,fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__BorderedDescription__["a" /* default */],null,fileType.toUpperCase().slice(12))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_hedron__["Column"],{lg:1,xs:6,fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_elements_Paragraph__["a" /* default */],null,Object(__WEBPACK_IMPORTED_MODULE_7_common_methods_formatFileSize__["a" /* default */])(fileSize))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_hedron__["Column"],{lg:2,lgShift:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__DownloadButton__["a" /* default */],{buttonText:buttonText,file:fileUrl,fileName:fileName}))))))));};DownloadBarBlock.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_models__["x" /* DownloadBar */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (DownloadBarBlock);

/***/ }),

/***/ "./src/kentico-blocks/FAQAccordion/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FAQAccordion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx__ = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_blocks_ScrollDiv__ = __webpack_require__("./src/blocks/ScrollDiv/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_kentico_blocks_Accordion_PanelGroup__ = __webpack_require__("./src/kentico-blocks/Accordion/PanelGroup/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_elements_Header3__ = __webpack_require__("./src/elements/Header3.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_common_consts_scroll__ = __webpack_require__("./src/common/consts/scroll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_animations_Animations__ = __webpack_require__("./src/animations/Animations.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_blocks_ImgModal_ImgModal__ = __webpack_require__("./src/blocks/ImgModal/ImgModal.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;var _templateObject=_taggedTemplateLiteral(["\n    padding: 0 "," ",";\n  "],["\n    padding: 0 "," ",";\n  "]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var Accordion=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div.withConfig({displayName:"FAQAccordion__Accordion",componentId:"vlg4q2-0"})(["padding:",";padding-top:0;width:100%;",";.panel-collapse a{font-weight:400;color:",";text-decoration:none;}"],__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get("metrics.s"),__WEBPACK_IMPORTED_MODULE_5_designsystem__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get("metrics.l"),__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get("metrics.m")),__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get("colors.brand.product"));var FAQAccordion=(_dec=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["inject"])("windowStore"),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["observer"])(_class=(_temp=_class2=function(_Component){_inherits(FAQAccordion,_Component);function FAQAccordion(props){_classCallCheck(this,FAQAccordion);var _this=_possibleConstructorReturn(this,(FAQAccordion.__proto__||Object.getPrototypeOf(FAQAccordion)).call(this,props));_this.activeKey=__WEBPACK_IMPORTED_MODULE_3_mobx__["observable"].box(null);var accordionItems=_this.props.data.accordionItems;_this.scrollDivRefs=accordionItems.map(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();});_this.state={showImgModal:false};_this.handleOpenModal=_this.handleOpenModal.bind(_this);_this.handleCloseModal=_this.handleCloseModal.bind(_this);return _this;}_createClass(FAQAccordion,[{key:"scrollToHeader",value:function scrollToHeader(elementRefIndex){if(elementRefIndex>0){var scrollDivRef=this.scrollDivRefs[elementRefIndex-1].current;Object(__WEBPACK_IMPORTED_MODULE_12_animations_Animations__["k" /* scrollToElement */])(scrollDivRef,300);}else{Object(__WEBPACK_IMPORTED_MODULE_12_animations_Animations__["k" /* scrollToElement */])(this.scrollDivRefs[0].current,0);}}},{key:"handleOpenModal",value:function handleOpenModal(){this.setState({showImgModal:true});}},{key:"handleCloseModal",value:function handleCloseModal(){this.setState({showImgModal:false});}},{key:"render",value:function render(){var _this2=this;var _props=this.props,_props$data=_props.data,title=_props$data.title,accordionItems=_props$data.accordionItems,id=_props$data.id,isOnTablet=_props.windowStore.isOnTablet;var isAccordionSpread=!!this.activeKey.get()||this.activeKey.get()===0;var scrollDivOffset=isOnTablet?"-"+__WEBPACK_IMPORTED_MODULE_11_common_consts_scroll__["a" /* default */].MOBILE_TOP_OFFSET+"px":"-"+__WEBPACK_IMPORTED_MODULE_11_common_consts_scroll__["a" /* default */].DESKTOP_TOP_OFFSET+"px";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_blocks_Container_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Accordion,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_elements_Header3__["a" /* default */],null,title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_kentico_blocks_Accordion_PanelGroup__["a" /* default */],{accordion:true,defaultActiveKey:0,activeKey:this.activeKey.get(),onSelect:function onSelect(activeKey){return _this2.activeKey.set(activeKey);},id:"FAQ.PanelGroup-"+id},accordionItems.map(function(accordionItem,index){var text=accordionItem.text,title=accordionItem.title,id=accordionItem.id,videoLink=accordionItem.videoLink,image=accordionItem.image;var isActive=_this2.activeKey.get()===index;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_kentico_blocks_Accordion_PanelGroup__["a" /* default */].Panel,{eventKey:index,key:id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_kentico_blocks_Accordion_PanelGroup__["a" /* default */].Heading,{"data-isactive":isActive},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_kentico_blocks_Accordion_PanelGroup__["a" /* default */].Title,{toggle:true,onClick:function onClick(){return _this2.scrollToHeader(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_blocks_ScrollDiv__["a" /* default */],{offset:scrollDivOffset,innerRef:_this2.scrollDivRefs[index]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_kentico_blocks_Accordion_PanelGroup__["a" /* default */].TitleText,{isActive:isActive},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_kentico_blocks_Accordion_PanelGroup__["a" /* default */].Arrow,{isActive:isActive})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_kentico_blocks_Accordion_PanelGroup__["a" /* default */].Body,{"data-isspread":isAccordionSpread,collapsible:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_kentico_blocks_Accordion_PanelGroup__["a" /* default */].Body.Paragraph,{dangerouslySetInnerHTML:{__html:text}}),videoLink&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_kentico_blocks_Accordion_PanelGroup__["a" /* default */].Body.Video,{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe",{src:videoLink,title:"YouTube video player",frameBorder:"0",allow:"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",allowFullScreen:true})),image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_kentico_blocks_Accordion_PanelGroup__["a" /* default */].Body.Image,{src:image,alt:title,onClick:_this2.handleOpenModal,style:{cursor:'pointer'}}),_this2.state.showImgModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_blocks_ImgModal_ImgModal__["a" /* default */],{closeModal:_this2.handleCloseModal,image:image,alt:title}))));}))));}}]);return FAQAccordion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class2.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_6_models__["y" /* FAQAccordion */]).isRequired},_temp))||_class)||_class);

/***/ }),

/***/ "./src/kentico-blocks/HeroImage/ImageBlock/DesksImage.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_responsive__ = __webpack_require__("./src/common/responsive.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Image__ = __webpack_require__("./src/kentico-blocks/HeroImage/ImageBlock/Image.jsx");
var _templateObject=_taggedTemplateLiteral(['\n  width: 110%;\n  left: -5%;\n  top: 10%;\n  \n  ','\n  \n  ','\n'],['\n  width: 110%;\n  left: -5%;\n  top: 10%;\n  \n  ','\n  \n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n    max-width: 90%;\n    top: 0;\n    left: 5%;\n  '],['\n    max-width: 90%;\n    top: 0;\n    left: 5%;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    top: 15%;\n    max-width: 670px;\n    left: 0;\n  '],['\n    top: 15%;\n    max-width: 670px;\n    left: 0;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var DesksImage=__WEBPACK_IMPORTED_MODULE_1__Image__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_0_common_responsive__["c" /* media */].tablet(_templateObject2),__WEBPACK_IMPORTED_MODULE_0_common_responsive__["c" /* media */].desktop(_templateObject3));/* harmony default export */ __webpack_exports__["a"] = (DesksImage);

/***/ }),

/***/ "./src/kentico-blocks/HeroImage/ImageBlock/HandImage.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Image__ = __webpack_require__("./src/kentico-blocks/HeroImage/ImageBlock/Image.jsx");
var _templateObject=_taggedTemplateLiteral(['\n  position: absolute;\n'],['\n  position: absolute;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var HandImage=__WEBPACK_IMPORTED_MODULE_0__Image__["a" /* default */].extend(_templateObject);/* harmony default export */ __webpack_exports__["a"] = (HandImage);

/***/ }),

/***/ "./src/kentico-blocks/HeroImage/ImageBlock/Image.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var Image=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].img.withConfig({displayName:'Image',componentId:'o6rsiv-0'})(['position:absolute;width:100%;']);/* harmony default export */ __webpack_exports__["a"] = (Image);

/***/ }),

/***/ "./src/kentico-blocks/HeroImage/ImageBlock/ImageWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_responsive__ = __webpack_require__("./src/common/responsive.js");
var _templateObject=_taggedTemplateLiteral(['\n    min-height: 360px;\n  '],['\n    min-height: 360px;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    min-height: 100%;\n  '],['\n    min-height: 100%;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ImageWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'ImageWrapper',componentId:'sc-18h0wzd-0'})(['display:flex;justify-content:center;position:relative;overflow:hidden;min-height:300px;flex-basis:50%;',' ',''],__WEBPACK_IMPORTED_MODULE_1_common_responsive__["c" /* media */].tablet(_templateObject),__WEBPACK_IMPORTED_MODULE_1_common_responsive__["c" /* media */].desktop(_templateObject2));/* harmony default export */ __webpack_exports__["a"] = (ImageWrapper);

/***/ }),

/***/ "./src/kentico-blocks/HeroImage/ImageBlock/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_kentico_blocks_CroppedAsset__ = __webpack_require__("./src/kentico-blocks/CroppedAsset/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_window_or_global__ = __webpack_require__("./node_modules/window-or-global/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DesksImage__ = __webpack_require__("./src/kentico-blocks/HeroImage/ImageBlock/DesksImage.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ImageWrapper__ = __webpack_require__("./src/kentico-blocks/HeroImage/ImageBlock/ImageWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__HandImage__ = __webpack_require__("./src/kentico-blocks/HeroImage/ImageBlock/HandImage.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2;var _templateObject=_taggedTemplateLiteral(['\n    max-width: 360px;\n  '],['\n    max-width: 360px;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    margin-top: ','\n    max-width: 540px;\n    top: 5%;\n  '],['\n    margin-top: ','\n    max-width: 540px;\n    top: 5%;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    transform: translateY(-50px) scale(0.62);\n  '],['\n    transform: translateY(-50px) scale(0.62);\n  ']),_templateObject4=_taggedTemplateLiteral(['\n    transform: scale(1);\n    top: -','\n    left: -10px;\n  '],['\n    transform: scale(1);\n    top: -','\n    left: -10px;\n  ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var FloatingComponents=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].div.withConfig({displayName:'ImageBlock__FloatingComponents',componentId:'sc-1cc3g8h-0'})(['position:relative;transition:transform 0.55s ease-in-out;width:100%;max-width:300px;left:',';',' ',''],__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_8_designsystem__["c" /* media */].tablet(_templateObject),__WEBPACK_IMPORTED_MODULE_8_designsystem__["c" /* media */].desktop(_templateObject2,__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].get('metrics.xl')));var CroppedAssets=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].div.withConfig({displayName:'ImageBlock__CroppedAssets',componentId:'sc-1cc3g8h-1'})(['position:absolute;top:0;transform:translateY(-35px) scale(0.51);',' ',''],__WEBPACK_IMPORTED_MODULE_8_designsystem__["c" /* media */].tablet(_templateObject3),__WEBPACK_IMPORTED_MODULE_8_designsystem__["c" /* media */].desktop(_templateObject4,__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].get('metrics.xl')));var ImageBlock=(_dec=Object(__WEBPACK_IMPORTED_MODULE_7_mobx_react__["inject"])('windowStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_7_mobx_react__["observer"])(_class=(_class2=function(_Component){_inherits(ImageBlock,_Component);function ImageBlock(props){_classCallCheck(this,ImageBlock);var _this=_possibleConstructorReturn(this,(ImageBlock.__proto__||Object.getPrototypeOf(ImageBlock)).call(this,props));_this.floatingComponentsRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(ImageBlock,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_5_window_or_global___default.a.addEventListener('scroll',this.setScrollY);}},{key:'componentWillUnmount',value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_5_window_or_global___default.a.removeEventListener('scroll',this.setScrollY);}},{key:'setScrollY',value:function setScrollY(){this.floatingComponentsRef.current.style.transform='translateY('+__WEBPACK_IMPORTED_MODULE_5_window_or_global___default.a.scrollY+'px)';}},{key:'render',value:function render(){var _props=this.props,backgroundDesks=_props.backgroundDesks,backgroundHand=_props.backgroundHand,floatingElements=_props.floatingElements,windowStore=_props.windowStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ImageWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__DesksImage__["a" /* default */],{src:windowStore.adjustImageSize(backgroundDesks)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FloatingComponents,{innerRef:this.floatingComponentsRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__HandImage__["a" /* default */],{src:windowStore.adjustImageSize(backgroundHand)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CroppedAssets,null,floatingElements.map(function(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_CroppedAsset__["a" /* default */],{data:element,absolute:true,key:element.id});}))));}}]);return ImageBlock;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),(_applyDecoratedDescriptor(_class2.prototype,'setScrollY',[__WEBPACK_IMPORTED_MODULE_6_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'setScrollY'),_class2.prototype)),_class2))||_class)||_class);ImageBlock.propTypes={backgroundDesks:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,backgroundHand:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,floatingElements:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_models__["v" /* CroppedAsset */]))};ImageBlock.defaultProps={floatingElements:[]};/* harmony default export */ __webpack_exports__["a"] = (ImageBlock);

/***/ }),

/***/ "./src/kentico-blocks/HeroImage/TextBlock/BlackButton.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    max-height: 70px;\n    padding-right: ',';\n  '],['\n    max-height: 70px;\n    padding-right: ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var BlackButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].a.withConfig({displayName:'BlackButton',componentId:'wu9xpp-0'})(['display:block;padding-right:',';max-height:',';&:hover{cursor:pointer;}',''],function(_ref){var rightPad=_ref.rightPad;return rightPad?__WEBPACK_IMPORTED_MODULE_0_designsystem__["a" /* default */].get('metrics.xs'):'0';},__WEBPACK_IMPORTED_MODULE_0_designsystem__["a" /* default */].get('metrics.l'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].tablet(_templateObject,function(_ref2){var rightPad=_ref2.rightPad;return rightPad?__WEBPACK_IMPORTED_MODULE_0_designsystem__["a" /* default */].get('metrics.s'):'0';}));/* harmony default export */ __webpack_exports__["a"] = (BlackButton);

/***/ }),

/***/ "./src/kentico-blocks/HeroImage/TextBlock/ButtonsWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    padding-bottom: ',';\n  '],['\n    padding-bottom: ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ButtonsWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'ButtonsWrapper',componentId:'bmn87z-0'})(['display:flex;flex-flow:row nowrap;padding-bottom:',';padding-left:',';padding-right:',';',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xl'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xxl')));/* harmony default export */ __webpack_exports__["a"] = (ButtonsWrapper);

/***/ }),

/***/ "./src/kentico-blocks/HeroImage/TextBlock/Description.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_elements_DescriptionText__ = __webpack_require__("./src/elements/DescriptionText.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n  margin: 0;\n  padding: ',' ',';\n  font-size: ',';\n  line-height: ',';\n  font-weight: ',';\n  \n  ','\n'],['\n  margin: 0;\n  padding: ',' ',';\n  font-size: ',';\n  line-height: ',';\n  font-weight: ',';\n  \n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n    width: 100%;\n    padding: ',' ',';\n    font-size: ',';\n    line-height: ',';\n  '],['\n    width: 100%;\n    padding: ',' ',';\n    font-size: ',';\n    line-height: ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Description=__WEBPACK_IMPORTED_MODULE_0_elements_DescriptionText__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('m'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.base'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.regular'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].tablet(_templateObject2,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('l'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.l')));/* harmony default export */ __webpack_exports__["a"] = (Description);

/***/ }),

/***/ "./src/kentico-blocks/HeroImage/TextBlock/Headline.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_elements_Header1__ = __webpack_require__("./src/elements/Header1.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n  padding: 0 ',';\n  font-size: ',';\n  line-height: 1.15;\n  margin-top: ',';\n  \n  ','\n  \n  ','\n'],['\n  padding: 0 ',';\n  font-size: ',';\n  line-height: 1.15;\n  margin-top: ',';\n  \n  ','\n  \n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n    padding: 0 ',';\n    font-size: ',';\n    margin: ',' 0 ',' 0;\n  '],['\n    padding: 0 ',';\n    font-size: ',';\n    margin: ',' 0 ',' 0;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    font-size: ',';\n    margin: 160px 0 0 0;\n  '],['\n    font-size: ',';\n    margin: 160px 0 0 0;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Headline=__WEBPACK_IMPORTED_MODULE_0_elements_Header1__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('l'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.l'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].tablet(_templateObject2,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('xl'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xl'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s')),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].desktop(_templateObject3,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('xxl')));/* harmony default export */ __webpack_exports__["a"] = (Headline);

/***/ }),

/***/ "./src/kentico-blocks/HeroImage/TextBlock/LinkImage.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var LinkImage=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].img.withConfig({displayName:'LinkImage',componentId:'sc-1bb3fhp-0'})(['width:100%;height:auto;']);/* harmony default export */ __webpack_exports__["a"] = (LinkImage);

/***/ }),

/***/ "./src/kentico-blocks/HeroImage/TextBlock/TextWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n      flex-basis: 50%;\n      min-height: 714px;\n  '],['\n      flex-basis: 50%;\n      min-height: 714px;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var TextWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'TextWrapper',componentId:'ra8oqf-0'})(['display:flex;flex-direction:column;flex-basis:100%;',''],__WEBPACK_IMPORTED_MODULE_1_designsystem_index__["c" /* media */].desktop(_templateObject));/* harmony default export */ __webpack_exports__["a"] = (TextWrapper);

/***/ }),

/***/ "./src/kentico-blocks/HeroImage/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_responsive__ = __webpack_require__("./src/common/responsive.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_window_or_global__ = __webpack_require__("./node_modules/window-or-global/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobx__ = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_reveal_Fade__ = __webpack_require__("./node_modules/react-reveal/Fade.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_reveal_Fade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_reveal_Fade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_animations_Animations__ = __webpack_require__("./src/animations/Animations.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_common_images_google_play_badge_png__ = __webpack_require__("./src/common/images/google-play-badge.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_common_images_google_play_badge_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_common_images_google_play_badge_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_common_images_app_store_badge_png__ = __webpack_require__("./src/common/images/app-store-badge.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_common_images_app_store_badge_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_common_images_app_store_badge_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_blocks_HTMLModifableBackground_HTMLModifiableBackground__ = __webpack_require__("./src/blocks/HTMLModifableBackground/HTMLModifiableBackground.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__TextBlock_Headline__ = __webpack_require__("./src/kentico-blocks/HeroImage/TextBlock/Headline.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__TextBlock_Description__ = __webpack_require__("./src/kentico-blocks/HeroImage/TextBlock/Description.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__TextBlock_ButtonsWrapper__ = __webpack_require__("./src/kentico-blocks/HeroImage/TextBlock/ButtonsWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__TextBlock_TextWrapper__ = __webpack_require__("./src/kentico-blocks/HeroImage/TextBlock/TextWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ImageBlock__ = __webpack_require__("./src/kentico-blocks/HeroImage/ImageBlock/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__TextBlock_LinkImage__ = __webpack_require__("./src/kentico-blocks/HeroImage/TextBlock/LinkImage.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__TextBlock_BlackButton__ = __webpack_require__("./src/kentico-blocks/HeroImage/TextBlock/BlackButton.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_dec2,_class,_desc,_value,_class2,_class3,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}/* eslint-disable react/jsx-one-expression-per-line,react/prop-types */var FlexContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div.withConfig({displayName:'HeroImage__FlexContainer',componentId:'do8bfa-0'})(['display:flex;']);var HeroImage=(_dec=Object(__WEBPACK_IMPORTED_MODULE_8_mobx_react__["inject"])('productsStore'),_dec2=Object(__WEBPACK_IMPORTED_MODULE_9_lodash_decorators__["Debounce"])(200),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_8_mobx_react__["observer"])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(HeroImage,_Component);function HeroImage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HeroImage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HeroImage.__proto__||Object.getPrototypeOf(HeroImage)).call.apply(_ref,[this].concat(args))),_this),_this.isMobile=__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"].box(Object(__WEBPACK_IMPORTED_MODULE_4_common_responsive__["b" /* isOnMobile */])()),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(HeroImage,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_5_window_or_global___default.a.addEventListener('resize',this.updateDimensions);}},{key:'componentWillUnmount',value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_5_window_or_global___default.a.removeEventListener('resize',this.updateDimensions);}},{key:'updateDimensions',value:function updateDimensions(){this.isMobile.set(Object(__WEBPACK_IMPORTED_MODULE_4_common_responsive__["b" /* isOnMobile */])());}},{key:'render',value:function render(){var _props$data=this.props.data,header=_props$data.header,description=_props$data.description,backgroundHand=_props$data.backgroundHand,backgroundDesks=_props$data.backgroundDesks,htmlModifiers=_props$data.htmlModifiers,floatingElements=_props$data.floatingElements;var _props$productsStore$=this.props.productsStore.currentProduct,appStoreShareLink=_props$productsStore$.appStoreShareLink,googlePlayShareLink=_props$productsStore$.googlePlayShareLink;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_blocks_HTMLModifableBackground_HTMLModifiableBackground__["a" /* default */],{htmlModifiers:htmlModifiers,color:__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('background')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_blocks_Container_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FlexContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__TextBlock_TextWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_reveal_Fade___default.a,{distance:''+__WEBPACK_IMPORTED_MODULE_12_animations_Animations__["a" /* FADE_VALUES */].TEXT.SMALL,delay:__WEBPACK_IMPORTED_MODULE_12_animations_Animations__["a" /* FADE_VALUES */].DELAY.SMALL,bottom:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__TextBlock_Headline__["a" /* default */],{primary:true,dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_16_common_methods_string__["g" /* safeHtmlWithBr */])(header)}}),this.isMobile.get()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ImageBlock__["a" /* default */],{backgroundHand:backgroundHand,backgroundDesks:backgroundDesks,floatingElements:floatingElements}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__TextBlock_Description__["a" /* default */],{dangerouslySetInnerHTML:{__html:description}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__TextBlock_ButtonsWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__TextBlock_BlackButton__["a" /* default */],{href:googlePlayShareLink,rightPad:true,rel:'nofollow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__TextBlock_LinkImage__["a" /* default */],{src:__WEBPACK_IMPORTED_MODULE_13_common_images_google_play_badge_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__TextBlock_BlackButton__["a" /* default */],{href:appStoreShareLink,rel:'nofollow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__TextBlock_LinkImage__["a" /* default */],{src:__WEBPACK_IMPORTED_MODULE_14_common_images_app_store_badge_png___default.a}))))),!this.isMobile.get()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ImageBlock__["a" /* default */],{backgroundHand:backgroundHand,backgroundDesks:backgroundDesks,floatingElements:floatingElements}):'')));}}]);return HeroImage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class3.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_6_models__["H" /* HeroImage */]).isRequired},_temp2),(_applyDecoratedDescriptor(_class2.prototype,'updateDimensions',[__WEBPACK_IMPORTED_MODULE_9_lodash_decorators__["Bind"],_dec2],Object.getOwnPropertyDescriptor(_class2.prototype,'updateDimensions'),_class2.prototype)),_class2))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (HeroImage);

/***/ }),

/***/ "./src/kentico-blocks/HorizontallyNavigableContent/NavButton.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var NavButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].a.withConfig({displayName:'NavButton',componentId:'sc-4evb99-0'})(['cursor:pointer;font-size:',';font-family:',';line-height:',';margin:',';font-weight:',';&:after{content:\'\';display:block;width:',';height:4px;margin-top:4px;background-color:',';transition-duration:0.25s;}'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('base'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontFamily.headline'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.base'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.base'),function(_ref){var active=_ref.active;return active?__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.bold'):__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.regular');},function(_ref2){var active=_ref2.active;return active?__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.base'):0;},__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('secondary'));/* harmony default export */ __webpack_exports__["a"] = (NavButton);

/***/ }),

/***/ "./src/kentico-blocks/HorizontallyNavigableContent/NavContainer.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var NavContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'NavContainer',componentId:'g55t7l-0'})(['display:flex;justify-content:center;']);/* harmony default export */ __webpack_exports__["a"] = (NavContainer);

/***/ }),

/***/ "./src/kentico-blocks/HorizontallyNavigableContent/NavContent.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var NavContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'NavContent',componentId:'nlkl8r-0'})(['position:',';overflow:hidden;'],function(_ref){var absolute=_ref.absolute;return absolute?'absolute':'relative';});/* harmony default export */ __webpack_exports__["a"] = (NavContent);

/***/ }),

/***/ "./src/kentico-blocks/HorizontallyNavigableContent/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_Product_ProductsSectionParser__ = __webpack_require__("./src/pages/Product/ProductsSectionParser.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_animations_Animations__ = __webpack_require__("./src/animations/Animations.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_blocks_HTMLModifableBackground_HTMLModifiableBackground__ = __webpack_require__("./src/blocks/HTMLModifableBackground/HTMLModifiableBackground.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_common_consts_navigationItem__ = __webpack_require__("./src/common/consts/navigationItem.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NavButton__ = __webpack_require__("./src/kentico-blocks/HorizontallyNavigableContent/NavButton.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__NavContainer__ = __webpack_require__("./src/kentico-blocks/HorizontallyNavigableContent/NavContainer.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__NavContent__ = __webpack_require__("./src/kentico-blocks/HorizontallyNavigableContent/NavContent.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}var StyledContainer=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_7_blocks_Container_Container__["a" /* default */]).withConfig({displayName:'HorizontallyNavigableContent__StyledContainer',componentId:'sc-1qos50j-0'})(['padding-bottom:',';'],__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('metrics.xxl'));var HorizontallyNavigableContent=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(_class=(_class2=function(_Component){_inherits(HorizontallyNavigableContent,_Component);function HorizontallyNavigableContent(props){_classCallCheck(this,HorizontallyNavigableContent);var _this=_possibleConstructorReturn(this,(HorizontallyNavigableContent.__proto__||Object.getPrototypeOf(HorizontallyNavigableContent)).call(this,props));_this.state={currentComponentIndex:0,previousComponentIndex:0};_this.previousContentRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.currentContentRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(HorizontallyNavigableContent,[{key:'getComponentIndexById',value:function getComponentIndexById(id){var contentItems=this.props.data.contentItems;return contentItems.indexOf(contentItems.find(function(item){return item.id===id;}));}},{key:'navButtonClick',value:function navButtonClick(buttonId){var buttonIndex=this.getComponentIndexById(buttonId);var currentComponentIndex=this.state.currentComponentIndex;if(buttonIndex===currentComponentIndex){return;}this.setState({previousComponentIndex:currentComponentIndex,currentComponentIndex:buttonIndex});if(currentComponentIndex<buttonIndex){Object(__WEBPACK_IMPORTED_MODULE_10_animations_Animations__["d" /* hideToLeftAnimation */])(this.previousContentRef.current);Object(__WEBPACK_IMPORTED_MODULE_10_animations_Animations__["l" /* showToLeftAnimation */])(this.currentContentRef.current);}else{Object(__WEBPACK_IMPORTED_MODULE_10_animations_Animations__["e" /* hideToRightAnimation */])(this.previousContentRef.current);Object(__WEBPACK_IMPORTED_MODULE_10_animations_Animations__["m" /* showToRightAnimation */])(this.currentContentRef.current);}}},{key:'render',value:function render(){var _this2=this;var _props$data=this.props.data,contentItems=_props$data.contentItems,navigationItem=_props$data.navigationItem,htmlModifiers=_props$data.htmlModifiers;var _state=this.state,currentComponentIndex=_state.currentComponentIndex,previousComponentIndex=_state.previousComponentIndex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_blocks_HTMLModifableBackground_HTMLModifiableBackground__["a" /* default */],{htmlModifiers:htmlModifiers,color:__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].brand('white'),id:navigationItem&&__WEBPACK_IMPORTED_MODULE_13_common_consts_navigationItem__["a" /* isNavItem */]===navigationItem.toLowerCase()?__WEBPACK_IMPORTED_MODULE_13_common_consts_navigationItem__["b" /* navigationItemID */]:null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_hedron__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_hedron__["Column"],{lg:11},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__NavContainer__["a" /* default */],null,contentItems&&contentItems.map(function(navItem){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__NavButton__["a" /* default */],{active:_this2.getComponentIndexById(navItem.id)===currentComponentIndex,onClick:function onClick(){return _this2.navButtonClick(navItem.id);},key:navItem.id,dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_12_common_methods_string__["g" /* safeHtmlWithBr */])(navItem.header)}});})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__NavContent__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__NavContent__["a" /* default */],{absolute:true,innerRef:this.previousContentRef},previousComponentIndex!==currentComponentIndex?contentItems[previousComponentIndex].contentItems.map(function(contentItem){return Object(__WEBPACK_IMPORTED_MODULE_8_pages_Product_ProductsSectionParser__["a" /* default */])(contentItem);}):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__NavContent__["a" /* default */],{innerRef:this.currentContentRef},contentItems&&contentItems[currentComponentIndex].contentItems.map(function(contentItem){return Object(__WEBPACK_IMPORTED_MODULE_8_pages_Product_ProductsSectionParser__["a" /* default */])(contentItem);})))));}}]);return HorizontallyNavigableContent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),(_applyDecoratedDescriptor(_class2.prototype,'navButtonClick',[__WEBPACK_IMPORTED_MODULE_3_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'navButtonClick'),_class2.prototype)),_class2))||_class;HorizontallyNavigableContent.propTypes={data:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_6_models__["I" /* HorizontallyNavigableContent */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (HorizontallyNavigableContent);

/***/ }),

/***/ "./src/kentico-blocks/ImageLink/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_elements_Paragraph__ = __webpack_require__("./src/elements/Paragraph.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_elements_Image__ = __webpack_require__("./src/elements/Image.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable react/prop-types */var ImageLink=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('windowStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(_class=function(_Component){_inherits(ImageLink,_Component);function ImageLink(){_classCallCheck(this,ImageLink);return _possibleConstructorReturn(this,(ImageLink.__proto__||Object.getPrototypeOf(ImageLink)).apply(this,arguments));}_createClass(ImageLink,[{key:'render',value:function render(){var _props=this.props,_props$data=_props.data,alt=_props$data.alt,description=_props$data.description,url=_props$data.url,image=_props$data.image,nofollow=_props$data.nofollow,blank=_props$data.blank,windowStore=_props.windowStore;var imageUrl=typeof image==='string'?windowStore.adjustImageSize(image):windowStore.adjustImageSize(image.url);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:url,rel:!nofollow?null:nofollow,target:!blank?null:blank},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_elements_Image__["a" /* default */],{src:imageUrl,alt:alt||image.description})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_elements_Paragraph__["a" /* default */],null,description));}}]);return ImageLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);

/***/ }),

/***/ "./src/kentico-blocks/ImageSlider/Background.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var Background=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'Background',componentId:'sc-18vewl2-0'})(['position:relative;background-color:',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('background'));/* harmony default export */ __webpack_exports__["a"] = (Background);

/***/ }),

/***/ "./src/kentico-blocks/ImageSlider/ButtonWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    top: 545px;\n  '],['\n    top: 545px;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ButtonWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'ButtonWrapper',componentId:'dy7qry-0'})(['position:absolute;display:flex;justify-content:space-between;width:100%;top:410px;z-index:25;',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem_index__["c" /* media */].desktop(_templateObject));/* harmony default export */ __webpack_exports__["a"] = (ButtonWrapper);

/***/ }),

/***/ "./src/kentico-blocks/ImageSlider/Header.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_elements_Header4__ = __webpack_require__("./src/elements/Header4.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n  margin: 0;\n  padding: ',';\n'],['\n  margin: 0;\n  padding: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Header=__WEBPACK_IMPORTED_MODULE_0_elements_Header4__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'));/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),

/***/ "./src/kentico-blocks/ImageSlider/ImageSlide/AbsoluteWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    height: 515px;\n  '],['\n    height: 515px;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var AbsoluteWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'AbsoluteWrapper',componentId:'sc-1dzw5b7-0'})(['position:absolute;width:100%;z-index:0;overflow:hidden;height:365px;',''],__WEBPACK_IMPORTED_MODULE_1_designsystem_index__["c" /* media */].desktop(_templateObject));/* harmony default export */ __webpack_exports__["a"] = (AbsoluteWrapper);

/***/ }),

/***/ "./src/kentico-blocks/ImageSlider/ImageSlide/Background.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var Background=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'Background',componentId:'sc-1hnxe5r-0'})(['background-color:',';min-height:280px;'],__WEBPACK_IMPORTED_MODULE_1_designsystem_index__["a" /* default */].brand('product'));/* harmony default export */ __webpack_exports__["a"] = (Background);

/***/ }),

/***/ "./src/kentico-blocks/ImageSlider/ImageSlide/BackgroundImage.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    height: 600px;\n  '],['\n    height: 600px;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var BackgroundImage=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].img.withConfig({displayName:'BackgroundImage',componentId:'sc-1ovd0r-0'})(['position:relative;display:block;height:490px;width:100%;object-fit:cover;',''],__WEBPACK_IMPORTED_MODULE_1_designsystem_index__["c" /* media */].desktop(_templateObject));/* harmony default export */ __webpack_exports__["a"] = (BackgroundImage);

/***/ }),

/***/ "./src/kentico-blocks/ImageSlider/ImageSlide/CurrentImageWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    height: 515px;\n  '],['\n    height: 515px;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var CurrentImageWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'CurrentImageWrapper',componentId:'sc-1c4cqyx-0'})(['width:100%;position:relative;overflow:hidden;height:365px;',''],__WEBPACK_IMPORTED_MODULE_1_designsystem_index__["c" /* media */].desktop(_templateObject));/* harmony default export */ __webpack_exports__["a"] = (CurrentImageWrapper);

/***/ }),

/***/ "./src/kentico-blocks/ImageSlider/ImageSlide/Description.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_elements_DescriptionText__ = __webpack_require__("./src/elements/DescriptionText.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_elements_Paragraph__ = __webpack_require__("./src/elements/Paragraph.js");
var _templateObject=_taggedTemplateLiteral(['\n  color: ',';\n  margin-top: 0;\n  \n  & > ',' {\n    color: ',';\n    font-size: ',';\n    font-weight: ',';\n    opacity: 0.9;\n    padding: 0;\n    margin: 0;\n  }\n  \n  margin-bottom: ',';\n\n  ','\n  \n  ','\n'],['\n  color: ',';\n  margin-top: 0;\n  \n  & > ',' {\n    color: ',';\n    font-size: ',';\n    font-weight: ',';\n    opacity: 0.9;\n    padding: 0;\n    margin: 0;\n  }\n  \n  margin-bottom: ',';\n\n  ','\n  \n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n    margin-top: ',';\n    margin-bottom: calc(',' - ',');\n  '],['\n    margin-top: ',';\n    margin-bottom: calc(',' - ',');\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    line-height: ',';\n    margin-top: ',';\n    \n    & > ',' {\n      font-size: ',';\n    }\n  '],['\n    line-height: ',';\n    margin-top: ',';\n    \n    & > ',' {\n      font-size: ',';\n    }\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Description=__WEBPACK_IMPORTED_MODULE_0_elements_DescriptionText__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_3_elements_Paragraph__["a" /* default */],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('base'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.light'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].tablet(_templateObject2,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xl'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xxl'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s')),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].desktop(_templateObject3,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.xl'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xxl'),__WEBPACK_IMPORTED_MODULE_3_elements_Paragraph__["a" /* default */],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('m')));/* harmony default export */ __webpack_exports__["a"] = (Description);

/***/ }),

/***/ "./src/kentico-blocks/ImageSlider/ImageSlide/ImageSlideWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var ImageSlideWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'ImageSlideWrapper',componentId:'sc-8l13ms-0'})(['width:100%;position:relative;overflow:hidden;']);/* harmony default export */ __webpack_exports__["a"] = (ImageSlideWrapper);

/***/ }),

/***/ "./src/kentico-blocks/ImageSlider/ImageSlide/PhoneAbsoluteWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var AbsoluteWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'PhoneAbsoluteWrapper__AbsoluteWrapper',componentId:'sc-91wtd2-0'})(['position:absolute;width:100%;height:100%;z-index:0;']);/* harmony default export */ __webpack_exports__["a"] = (AbsoluteWrapper);

/***/ }),

/***/ "./src/kentico-blocks/ImageSlider/ImageSlide/PhoneImage.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var PhoneImage=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].img.withConfig({displayName:'PhoneImage',componentId:'ovtumi-0'})(['width:100%;pointer-events:none;']);/* harmony default export */ __webpack_exports__["a"] = (PhoneImage);

/***/ }),

/***/ "./src/kentico-blocks/ImageSlider/ImageSlide/PhoneScenery.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    display: block;\n  '],['\n    display: block;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var PhoneScenery=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'PhoneScenery',componentId:'yrj385-0'})(['top:0;position:relative;display:flex;justify-content:center;',''],__WEBPACK_IMPORTED_MODULE_1_designsystem_index__["c" /* media */].desktop(_templateObject));/* harmony default export */ __webpack_exports__["a"] = (PhoneScenery);

/***/ }),

/***/ "./src/kentico-blocks/ImageSlider/ImageSlide/PhoneScreenImage.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* eslint-disable react/destructuring-assignment */var PhoneScreenImage=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'PhoneScreenImage',componentId:'fe5hed-0'})(['width:100%;height:100%;border-radius:1px;background-size:cover;background-repeat:no-repeat;background-position:center;background-image:url(',');box-shadow:inset 0 0 1px 1px rgba(0,0,0,0.5);'],function(props){return props.screenImage;});/* harmony default export */ __webpack_exports__["a"] = (PhoneScreenImage);

/***/ }),

/***/ "./src/kentico-blocks/ImageSlider/ImageSlide/PhoneScreenImageWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    top: 63px;\n    left: 81px;\n    width: 151px;\n    height: 265px;\n  '],['\n    top: 63px;\n    left: 81px;\n    width: 151px;\n    height: 265px;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    top: 97px;\n    left: 125px;\n    width: 230px;\n    height: 406px;\n  '],['\n    top: 97px;\n    left: 125px;\n    width: 230px;\n    height: 406px;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var PhoneScreenImageWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'PhoneScreenImageWrapper',componentId:'sc-1p9fare-0'})(['position:absolute;top:54px;left:68px;width:129px;height:225px;transform-origin:right;overflow:hidden;box-shadow:inset 0 0 1px 1px rgba(0,0,0,0.5);',' ',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem_index__["c" /* media */].tablet(_templateObject),__WEBPACK_IMPORTED_MODULE_1_designsystem_index__["c" /* media */].desktop(_templateObject2));/* harmony default export */ __webpack_exports__["a"] = (PhoneScreenImageWrapper);

/***/ }),

/***/ "./src/kentico-blocks/ImageSlider/ImageSlide/PhoneWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    margin-left: -30px;\n    margin-top: 200px;\n    width: 265px;\n  '],['\n    margin-left: -30px;\n    margin-top: 200px;\n    width: 265px;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    margin-left: auto;\n    margin-right: auto;\n    right: 42px;\n    left: -60px;\n    margin-top: 40px;\n    width: 406px;\n  '],['\n    margin-left: auto;\n    margin-right: auto;\n    right: 42px;\n    left: -60px;\n    margin-top: 40px;\n    width: 406px;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var PhoneWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'PhoneWrapper',componentId:'sc-1om51xr-0'})(['top:-1200px;position:absolute;margin-top:250px;margin-left:-20px;width:225px;transition:top 0.55s ease-in-out 0s;',';',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem_index__["c" /* media */].tablet(_templateObject),__WEBPACK_IMPORTED_MODULE_1_designsystem_index__["c" /* media */].desktop(_templateObject2));/* harmony default export */ __webpack_exports__["a"] = (PhoneWrapper);

/***/ }),

/***/ "./src/kentico-blocks/ImageSlider/ImageSlide/Title.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_elements_Header1__ = __webpack_require__("./src/elements/Header1.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n  font-size: ',';\n  line-height: ',';\n  margin-top: ',';\n  margin-bottom: ',';\n  color: ',';\n  \n  ',';\n'],['\n  font-size: ',';\n  line-height: ',';\n  margin-top: ',';\n  margin-bottom: ',';\n  color: ',';\n  \n  ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n    align-self: top;\n    font-size: ',';\n    margin-bottom: ',';\n    line-height: ',';\n  '],['\n    align-self: top;\n    font-size: ',';\n    margin-bottom: ',';\n    line-height: ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Title=__WEBPACK_IMPORTED_MODULE_0_elements_Header1__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('l'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.l'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.l'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.sm'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].tablet(_templateObject2,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('xl'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.l'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.xl')));/* harmony default export */ __webpack_exports__["a"] = (Title);

/***/ }),

/***/ "./src/kentico-blocks/ImageSlider/ImageSlide/TitleWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    margin-bottom: calc(',' - ',');\n  '],['\n    margin-bottom: calc(',' - ',');\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var TitleWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'TitleWrapper',componentId:'dpk09z-0'})(['display:flex;align-items:center;height:100%;margin-bottom:',';',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].tablet(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xxl'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s')));/* harmony default export */ __webpack_exports__["a"] = (TitleWrapper);

/***/ }),

/***/ "./src/kentico-blocks/ImageSlider/ImageSlide/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blocks_Parser_Parser__ = __webpack_require__("./src/blocks/Parser/Parser.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_images_phone_png__ = __webpack_require__("./src/common/images/phone.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_images_phone_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_images_phone_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_models_index__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_animations_Animations__ = __webpack_require__("./src/animations/Animations.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx__ = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_reveal_Fade__ = __webpack_require__("./node_modules/react-reveal/Fade.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_reveal_Fade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_reveal_Fade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ImageSlideWrapper__ = __webpack_require__("./src/kentico-blocks/ImageSlider/ImageSlide/ImageSlideWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Background__ = __webpack_require__("./src/kentico-blocks/ImageSlider/ImageSlide/Background.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Title__ = __webpack_require__("./src/kentico-blocks/ImageSlider/ImageSlide/Title.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Description__ = __webpack_require__("./src/kentico-blocks/ImageSlider/ImageSlide/Description.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__PhoneImage__ = __webpack_require__("./src/kentico-blocks/ImageSlider/ImageSlide/PhoneImage.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__BackgroundImage__ = __webpack_require__("./src/kentico-blocks/ImageSlider/ImageSlide/BackgroundImage.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__PhoneWrapper__ = __webpack_require__("./src/kentico-blocks/ImageSlider/ImageSlide/PhoneWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__CurrentImageWrapper__ = __webpack_require__("./src/kentico-blocks/ImageSlider/ImageSlide/CurrentImageWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PhoneScreenImage__ = __webpack_require__("./src/kentico-blocks/ImageSlider/ImageSlide/PhoneScreenImage.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__AbsoluteWrapper__ = __webpack_require__("./src/kentico-blocks/ImageSlider/ImageSlide/AbsoluteWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__PhoneAbsoluteWrapper__ = __webpack_require__("./src/kentico-blocks/ImageSlider/ImageSlide/PhoneAbsoluteWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__PhoneScreenImageWrapper__ = __webpack_require__("./src/kentico-blocks/ImageSlider/ImageSlide/PhoneScreenImageWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__PhoneScenery__ = __webpack_require__("./src/kentico-blocks/ImageSlider/ImageSlide/PhoneScenery.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__TitleWrapper__ = __webpack_require__("./src/kentico-blocks/ImageSlider/ImageSlide/TitleWrapper.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}/* eslint-disable react/destructuring-assignment,react/prop-types */var PhoneContainer=Object(__WEBPACK_IMPORTED_MODULE_12_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_blocks_Container_Container__["a" /* default */]).withConfig({displayName:'ImageSlide__PhoneContainer',componentId:'sc-2uaxbv-0'})(['transition-duration:0.7s;transform:',';transition-timing-function:ease-in-out;'],function(_ref){var visible=_ref.visible;return visible?'translateY(0)':'translateY(-100vh)';});var ImageSlide=(_dec=Object(__WEBPACK_IMPORTED_MODULE_10_mobx_react__["inject"])("windowStore"),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_10_mobx_react__["observer"])(_class=(_class2=function(_Component){_inherits(ImageSlide,_Component);function ImageSlide(props){_classCallCheck(this,ImageSlide);var _this=_possibleConstructorReturn(this,(ImageSlide.__proto__||Object.getPrototypeOf(ImageSlide)).call(this,props));_this.state={currentImageSlideData:props.data,previousImageSlideData:props.data};_this.phoneWrapperRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.phoneScreenRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.backgroundImageRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.absoluteBackgroundImageRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.titleRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.descriptionRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(ImageSlide,[{key:'componentDidMount',value:function componentDidMount(){var windowStore=this.props.windowStore;this.disposeOnScroll=windowStore.reactToScroll(this.setScrollY);this.addReactionToSlideChange();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.disposeOnScroll();this.disposeReactionToSlideChange();}},{key:'setScrollY',value:function setScrollY(){var backgroundScrollTop=-this.backgroundImageRef.current.getBoundingClientRect().top;if(backgroundScrollTop<-450){this.phoneWrapperRef.current.style.top=backgroundScrollTop-160+'px';}else if(backgroundScrollTop<-1200){this.phoneWrapperRef.current.style.top=500+'px';}else{this.phoneWrapperRef.current.style.top=-515+'px';}Object(__WEBPACK_IMPORTED_MODULE_6_animations_Animations__["g" /* parallaxImageTranslateY */])(this.backgroundImageRef.current,150,-150,8);Object(__WEBPACK_IMPORTED_MODULE_6_animations_Animations__["g" /* parallaxImageTranslateY */])(this.absoluteBackgroundImageRef.current,150,-150,8);}},{key:'addReactionToSlideChange',value:function addReactionToSlideChange(){var _this2=this;this.disposeReactionToSlideChange=Object(__WEBPACK_IMPORTED_MODULE_9_mobx__["reaction"])(function(){return _this2.props.currentImageIndex;},function(){return _this2.animateOnChange();});}},{key:'animateOnChange',value:function animateOnChange(){var setCanChangeSlide=this.props.setCanChangeSlide;setCanChangeSlide(false);Object(__WEBPACK_IMPORTED_MODULE_6_animations_Animations__["i" /* screenChangeAnimation */])(this.phoneScreenRef.current);Object(__WEBPACK_IMPORTED_MODULE_6_animations_Animations__["c" /* delayedOpacityAnimation */])([this.backgroundImageRef.current,this.titleRef.current,this.descriptionRef.current],250,function(){setCanChangeSlide(true);});}},{key:'render',value:function render(){var _state=this.state,currentImageSlideData=_state.currentImageSlideData,previousImageSlideData=_state.previousImageSlideData;var windowStore=this.props.windowStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ImageSlideWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__AbsoluteWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__BackgroundImage__["a" /* default */],{src:windowStore.adjustImageSize(previousImageSlideData.background),innerRef:this.absoluteBackgroundImageRef})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__CurrentImageWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__BackgroundImage__["a" /* default */],{innerRef:this.backgroundImageRef,src:windowStore.adjustImageSize(currentImageSlideData.background)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PhoneContainer,{visible:!!currentImageSlideData.image},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_hedron__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_hedron__["Column"],{xs:12,lgShift:6,lg:6,style:{padding:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__PhoneScenery__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__PhoneWrapper__["a" /* default */],{innerRef:this.phoneWrapperRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__PhoneImage__["a" /* default */],{src:__WEBPACK_IMPORTED_MODULE_4_common_images_phone_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__PhoneScreenImageWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__PhoneAbsoluteWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__PhoneScreenImage__["a" /* default */],{screenImage:windowStore.adjustImageSize(previousImageSlideData.image)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__PhoneScreenImage__["a" /* default */],{innerRef:this.phoneScreenRef,screenImage:windowStore.adjustImageSize(currentImageSlideData.image)}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Background__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_blocks_Container_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_hedron__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_hedron__["Column"],{style:{paddingTop:0,paddingBottom:0},md:6,lg:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__TitleWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_reveal_Fade___default.a,{distance:''+__WEBPACK_IMPORTED_MODULE_6_animations_Animations__["a" /* FADE_VALUES */].TEXT.SMALL,bottom:true,delay:__WEBPACK_IMPORTED_MODULE_6_animations_Animations__["a" /* FADE_VALUES */].DELAY.SMALL*2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Title__["a" /* default */],{innerRef:this.titleRef,dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_13_common_methods_string__["g" /* safeHtmlWithBr */])(currentImageSlideData.header)}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_hedron__["Column"],{mdShift:1,md:5,style:{paddingTop:0,paddingBottom:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Description__["a" /* default */],{innerRef:this.descriptionRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_blocks_Parser_Parser__["a" /* default */],{htmlBody:currentImageSlideData.text})))))));}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(nextProps,lastState){return{currentImageSlideData:nextProps.data,previousImageSlideData:lastState.currentImageSlideData};}}]);return ImageSlide;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),(_applyDecoratedDescriptor(_class2.prototype,'setScrollY',[__WEBPACK_IMPORTED_MODULE_7_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'setScrollY'),_class2.prototype)),_class2))||_class)||_class);ImageSlide.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_5_models_index__["L" /* ImageSlide */]).isRequired,setCanChangeSlide:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,currentImageIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ImageSlide);

/***/ }),

/***/ "./src/kentico-blocks/ImageSlider/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_visibility_sensor__ = __webpack_require__("./node_modules/react-visibility-sensor/visibility-sensor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_visibility_sensor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_visibility_sensor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx__ = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_blocks_HTMLModifableBackground_HTMLModifiableBackground__ = __webpack_require__("./src/blocks/HTMLModifableBackground/HTMLModifiableBackground.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_blocks_SliderButtons_Button__ = __webpack_require__("./src/blocks/SliderButtons/Button.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_blocks_SliderButtons_ArrowLeft__ = __webpack_require__("./src/blocks/SliderButtons/ArrowLeft.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_blocks_SliderButtons_ArrowRight__ = __webpack_require__("./src/blocks/SliderButtons/ArrowRight.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ButtonWrapper__ = __webpack_require__("./src/kentico-blocks/ImageSlider/ButtonWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Header__ = __webpack_require__("./src/kentico-blocks/ImageSlider/Header.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Background__ = __webpack_require__("./src/kentico-blocks/ImageSlider/Background.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ImageSlide__ = __webpack_require__("./src/kentico-blocks/ImageSlider/ImageSlide/index.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_descriptor2;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var ImageSlider=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"])(_class=(_class2=function(_Component){_inherits(ImageSlider,_Component);function ImageSlider(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ImageSlider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ImageSlider.__proto__||Object.getPrototypeOf(ImageSlider)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'currentImageIndex',_descriptor,_this),_initDefineProp(_this,'hasBeenSeen',_descriptor2,_this),_this.canChangeSlide=true,_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ImageSlider,[{key:'componentDidMount',value:function componentDidMount(){var imageSlides=this.props.data.imageSlides;this.currentImageIndex=imageSlides.length-1;}},{key:'onSliderInViewport',value:function onSliderInViewport(isInViewport){var _this2=this;if(isInViewport&&!this.hasBeenSeen){setTimeout(function(){// this.nextImage(); // Todo: TEMPORARILY DISABLED FUNCTIONALITY
_this2.hasBeenSeen=true;},300);}}},{key:'setCanChangeSlide',value:function setCanChangeSlide(canChangeSlide){this.canChangeSlide=canChangeSlide;}},{key:'nextImage',value:function nextImage(){if(!this.canChangeSlide){return;}var imageSlides=this.props.data.imageSlides;if(imageSlides.length>this.currentImageIndex+1){this.currentImageIndex=this.currentImageIndex+1;}else{this.currentImageIndex=0;}}},{key:'previousImage',value:function previousImage(){if(!this.canChangeSlide){return;}var imageSlides=this.props.data.imageSlides;if(this.currentImageIndex-1<0){this.currentImageIndex=imageSlides.length-1;}else{this.currentImageIndex=this.currentImageIndex-1;}}},{key:'render',value:function render(){var _props$data=this.props.data,header=_props$data.header,imageSlides=_props$data.imageSlides,htmlModifiers=_props$data.htmlModifiers;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_blocks_HTMLModifableBackground_HTMLModifiableBackground__["a" /* default */],{htmlModifiers:htmlModifiers,color:__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].brand('white')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Background__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_blocks_Container_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Header__["a" /* default */],{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_9_common_methods_string__["g" /* safeHtmlWithBr */])(header)}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ImageSlide__["a" /* default */],{currentImageIndex:this.currentImageIndex,data:imageSlides[this.currentImageIndex],setCanChangeSlide:this.setCanChangeSlide}),imageSlides.length>1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ButtonWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_blocks_SliderButtons_Button__["a" /* default */],{onClick:this.previousImage},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_visibility_sensor___default.a,{onChange:this.onSliderInViewport},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_blocks_SliderButtons_ArrowLeft__["a" /* default */],{animate:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_blocks_SliderButtons_Button__["a" /* default */],{onClick:this.nextImage},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_blocks_SliderButtons_ArrowRight__["a" /* default */],{animate:true}))));}}]);return ImageSlider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'currentImageIndex',[__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'hasBeenSeen',[__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class2.prototype,'onSliderInViewport',[__WEBPACK_IMPORTED_MODULE_5_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'onSliderInViewport'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'setCanChangeSlide',[__WEBPACK_IMPORTED_MODULE_5_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'setCanChangeSlide'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'nextImage',[__WEBPACK_IMPORTED_MODULE_5_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'nextImage'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'previousImage',[__WEBPACK_IMPORTED_MODULE_5_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'previousImage'),_class2.prototype)),_class2))||_class;ImageSlider.propTypes={data:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_6_models__["M" /* ImageSlider */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (ImageSlider);

/***/ }),

/***/ "./src/kentico-blocks/ImagedSection/Image.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_responsive__ = __webpack_require__("./src/common/responsive.js");
var _templateObject=_taggedTemplateLiteral(['\n    max-height: 260px;\n  '],['\n    max-height: 260px;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n  max-height: 500px;\n  '],['\n  max-height: 500px;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Image=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].img.withConfig({displayName:'Image',componentId:'qukgx6-0'})(['max-height:260px;transform:scale(0.8);position:relative;',';',';'],__WEBPACK_IMPORTED_MODULE_1_common_responsive__["c" /* media */].mobile(_templateObject),__WEBPACK_IMPORTED_MODULE_1_common_responsive__["c" /* media */].tablet(_templateObject2));/* harmony default export */ __webpack_exports__["a"] = (Image);

/***/ }),

/***/ "./src/kentico-blocks/ImagedSection/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImagedSectionBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_reveal_Fade__ = __webpack_require__("./node_modules/react-reveal/Fade.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_reveal_Fade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_reveal_Fade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_animations_Animations__ = __webpack_require__("./src/animations/Animations.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_blocks_Parser_Parser__ = __webpack_require__("./src/blocks/Parser/Parser.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_elements_Header2__ = __webpack_require__("./src/elements/Header2.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_elements_Paragraph__ = __webpack_require__("./src/elements/Paragraph.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_elements_DescriptionText__ = __webpack_require__("./src/elements/DescriptionText.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_blocks_HTMLModifableBackground_HTMLModifiableBackground__ = __webpack_require__("./src/blocks/HTMLModifableBackground/HTMLModifiableBackground.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Image__ = __webpack_require__("./src/kentico-blocks/ImagedSection/Image.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_class3,_temp;var _templateObject=_taggedTemplateLiteral(['\n      padding: ',' 0;\n      padding-bottom: 0;\n    '],['\n      padding: ',' 0;\n      padding-bottom: 0;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n  & > ',' {\n    font-size: ',';\n    line-height: ',';\n    font-weight: ',';\n    font-family: Roboto;\n\n    ','\n  }\n'],['\n  & > ',' {\n    font-size: ',';\n    line-height: ',';\n    font-weight: ',';\n    font-family: Roboto;\n\n    ','\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n      font-size: ',';\n      line-height: ',';\n    '],['\n      font-size: ',';\n      line-height: ',';\n    ']),_templateObject4=_taggedTemplateLiteral(['\n    font-size: ',';\n    line-height: ',';\n    \n    ','\n'],['\n    font-size: ',';\n    line-height: ',';\n    \n    ','\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var ImagedSection=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div.withConfig({displayName:'ImagedSection',componentId:'sc-133p96j-0'})(['',';'],__WEBPACK_IMPORTED_MODULE_6_designsystem_index__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_9_designsystem__["a" /* default */].get('metrics.l')));var Description=__WEBPACK_IMPORTED_MODULE_15_elements_DescriptionText__["a" /* default */].extend(_templateObject2,__WEBPACK_IMPORTED_MODULE_14_elements_Paragraph__["a" /* default */],__WEBPACK_IMPORTED_MODULE_9_designsystem__["a" /* default */].fs('m'),__WEBPACK_IMPORTED_MODULE_9_designsystem__["a" /* default */].get('type.lineHeight.m'),__WEBPACK_IMPORTED_MODULE_9_designsystem__["a" /* default */].get('type.fontWeight.regular'),__WEBPACK_IMPORTED_MODULE_6_designsystem_index__["c" /* media */].tablet(_templateObject3,__WEBPACK_IMPORTED_MODULE_9_designsystem__["a" /* default */].fs('l'),__WEBPACK_IMPORTED_MODULE_9_designsystem__["a" /* default */].get('type.lineHeight.l')));var ImagedSectionHeader=__WEBPACK_IMPORTED_MODULE_13_elements_Header2__["a" /* default */].extend(_templateObject4,__WEBPACK_IMPORTED_MODULE_9_designsystem__["a" /* default */].fs('l'),__WEBPACK_IMPORTED_MODULE_9_designsystem__["a" /* default */].get('type.lineHeight.l'),__WEBPACK_IMPORTED_MODULE_6_designsystem_index__["c" /* media */].tablet(_templateObject3,__WEBPACK_IMPORTED_MODULE_9_designsystem__["a" /* default */].fs('xl'),__WEBPACK_IMPORTED_MODULE_9_designsystem__["a" /* default */].get('type.lineHeight.xl')));var backgroundStyles={overflow:'hidden'};var leftColumnStyles={alignSelf:'flex-end'};var rightColumnStyles={paddingRight:0};ImagedSection.Image=__WEBPACK_IMPORTED_MODULE_18__Image__["a" /* default */];var ImagedSectionBlock=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["inject"])("windowStore"),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"])(_class=(_class2=(_temp=_class3=function(_Component){_inherits(ImagedSectionBlock,_Component);function ImagedSectionBlock(props){_classCallCheck(this,ImagedSectionBlock);var _this=_possibleConstructorReturn(this,(ImagedSectionBlock.__proto__||Object.getPrototypeOf(ImagedSectionBlock)).call(this,props));_this.elementRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(ImagedSectionBlock,[{key:'componentDidMount',value:function componentDidMount(){var windowStore=this.props.windowStore;this.disposeOnScroll=windowStore.reactToScroll(this.onScroll);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.disposeOnScroll();}},{key:'onScroll',value:function onScroll(){Object(__WEBPACK_IMPORTED_MODULE_10_animations_Animations__["h" /* scaleImage */])(this.elementRef.current,1.1,0.8);Object(__WEBPACK_IMPORTED_MODULE_10_animations_Animations__["f" /* parallaxImage */])(this.elementRef.current,100,-100,10);}},{key:'render',value:function render(){var _props=this.props,_props$data=_props.data,header=_props$data.header,text=_props$data.text,image=_props$data.image,htmlModifiers=_props$data.htmlModifiers,windowStore=_props.windowStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_blocks_HTMLModifableBackground_HTMLModifiableBackground__["a" /* default */],{htmlModifiers:htmlModifiers,color:__WEBPACK_IMPORTED_MODULE_9_designsystem__["a" /* default */].brand('white'),style:backgroundStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_blocks_Container_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImagedSection,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hedron__["Row"],{alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hedron__["Column"],{lg:7,style:leftColumnStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_reveal_Fade___default.a,{distance:''+__WEBPACK_IMPORTED_MODULE_10_animations_Animations__["a" /* FADE_VALUES */].TEXT.SMALL,delay:__WEBPACK_IMPORTED_MODULE_10_animations_Animations__["a" /* FADE_VALUES */].DELAY.SMALL,bottom:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImagedSectionHeader,{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_17_common_methods_string__["g" /* safeHtmlWithBr */])(header.text)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Description,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_blocks_Parser_Parser__["a" /* default */],{htmlBody:text})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hedron__["Column"],{lg:5,style:rightColumnStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImagedSection.Image,{src:windowStore.adjustImageSize(image),innerRef:this.elementRef}))))));}}]);return ImagedSectionBlock;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class3.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_models__["N" /* ImagedSection */]).isRequired},_temp),(_applyDecoratedDescriptor(_class2.prototype,'onScroll',[__WEBPACK_IMPORTED_MODULE_12_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'onScroll'),_class2.prototype)),_class2))||_class)||_class);

/***/ }),

/***/ "./src/kentico-blocks/LinkBanner/BackgroundImage.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    position: relative;\n    width: initial;\n    min-width: initial;\n    object-fit: cover;\n  '],['\n    position: relative;\n    width: initial;\n    min-width: initial;\n    object-fit: cover;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var BackgroundImage=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].img.withConfig({displayName:'BackgroundImage',componentId:'sc-1iwq4cc-0'})(['position:absolute;width:100%;min-width:400px;object-fit:contain;',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject));/* harmony default export */ __webpack_exports__["a"] = (BackgroundImage);

/***/ }),

/***/ "./src/kentico-blocks/LinkBanner/Description.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_elements_DescriptionText__ = __webpack_require__("./src/elements/DescriptionText.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n  margin: 0;\n  padding: ',' ',';\n  font-size: ',';\n  line-height: ',';\n  font-weight: ',';\n  \n  ','\n'],['\n  margin: 0;\n  padding: ',' ',';\n  font-size: ',';\n  line-height: ',';\n  font-weight: ',';\n  \n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n    width: 100%;\n    padding: ',' ',';\n    font-size: ',';\n    line-height: ',';\n  '],['\n    width: 100%;\n    padding: ',' ',';\n    font-size: ',';\n    line-height: ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Description=__WEBPACK_IMPORTED_MODULE_0_elements_DescriptionText__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('m'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.base'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.fontWeight.regular'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].tablet(_templateObject2,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('l'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('type.lineHeight.l')));/* harmony default export */ __webpack_exports__["a"] = (Description);

/***/ }),

/***/ "./src/kentico-blocks/LinkBanner/DesktopImagesWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    min-height: 500px;\n  '],['\n    min-height: 500px;\n  ']),_templateObject2=_taggedTemplateLiteral([' \n    position: relative;\n  '],[' \n    position: relative;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var DesktopImagesWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'DesktopImagesWrapper',componentId:'efr18f-0'})(['width:100%;min-height:400px;',' ',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].tablet(_templateObject),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject2));/* harmony default export */ __webpack_exports__["a"] = (DesktopImagesWrapper);

/***/ }),

/***/ "./src/kentico-blocks/LinkBanner/Header.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_elements_Header2__ = __webpack_require__("./src/elements/Header2.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n  padding: 0 ',';\n  font-size: ',';    \n  color: ',';\n  margin-bottom: 0;\n  margin-top: ',';\n  \n  ','\n\n  ','\n'],['\n  padding: 0 ',';\n  font-size: ',';    \n  color: ',';\n  margin-bottom: 0;\n  margin-top: ',';\n  \n  ','\n\n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n    font-size: ',';\n    margin-top: ',';\n  '],['\n    font-size: ',';\n    margin-top: ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    font-size: ',';\n    line-height: 1.15;\n    margin-top: calc(',' + ',')\n  '],['\n    font-size: ',';\n    line-height: 1.15;\n    margin-top: calc(',' + ',')\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Header=__WEBPACK_IMPORTED_MODULE_0_elements_Header2__["a" /* default */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('l'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('product'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.l'),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].tablet(_templateObject2,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('xl'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.l')),__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].desktop(_templateObject3,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].fontSize('xxl'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xxl'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s')));/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),

/***/ "./src/kentico-blocks/LinkBanner/Image.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    max-height: 450px;\n  '],['\n    max-height: 450px;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    max-height: 600px;\n    top: ',';\n  '],['\n    max-height: 600px;\n    top: ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    left: ',';\n    max-height: 727px;\n    position: absolute;\n  '],['\n    left: ',';\n    max-height: 727px;\n    position: absolute;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Image=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].img.withConfig({displayName:'Image',componentId:'gpaz7u-0'})(['position:relative;object-fit:contain;max-height:300px;z-index:1;margin-left:auto;margin-right:auto;top:',';',' ',' ',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].mobile(_templateObject),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].tablet(_templateObject2,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.l')),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject3,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.base')));/* harmony default export */ __webpack_exports__["a"] = (Image);

/***/ }),

/***/ "./src/kentico-blocks/LinkBanner/MobileImagesWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    min-height: 450px;\n  '],['\n    min-height: 450px;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    min-height: 600px;\n  '],['\n    min-height: 600px;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var MobileImagesWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'MobileImagesWrapper',componentId:'bmbkb7-0'})(['position:relative;display:flex;justify-content:flex-start;overflow:hidden;min-height:360px;padding:',';',' ',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].mobile(_templateObject),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].tablet(_templateObject2));/* harmony default export */ __webpack_exports__["a"] = (MobileImagesWrapper);

/***/ }),

/***/ "./src/kentico-blocks/LinkBanner/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkBannerBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_blocks_StyledLink__ = __webpack_require__("./src/blocks/StyledLink/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_reveal_Fade__ = __webpack_require__("./node_modules/react-reveal/Fade.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_reveal_Fade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_reveal_Fade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_animations_Animations__ = __webpack_require__("./src/animations/Animations.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_blocks_HTMLModifableBackground_HTMLModifiableBackground__ = __webpack_require__("./src/blocks/HTMLModifableBackground/HTMLModifiableBackground.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_elements_Button__ = __webpack_require__("./src/elements/Button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Description__ = __webpack_require__("./src/kentico-blocks/LinkBanner/Description.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Image__ = __webpack_require__("./src/kentico-blocks/LinkBanner/Image.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Header__ = __webpack_require__("./src/kentico-blocks/LinkBanner/Header.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__BackgroundImage__ = __webpack_require__("./src/kentico-blocks/LinkBanner/BackgroundImage.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__MobileImagesWrapper__ = __webpack_require__("./src/kentico-blocks/LinkBanner/MobileImagesWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__DesktopImagesWrapper__ = __webpack_require__("./src/kentico-blocks/LinkBanner/DesktopImagesWrapper.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_class3,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}/* eslint-disable react/prop-types */var StyledContainer=Object(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_5_blocks_Container_Container__["a" /* default */]).withConfig({displayName:'LinkBanner__StyledContainer',componentId:'sc-1rxctp-0'})(['margin-top:',';margin-bottom:0;'],__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].get('metrics.base'));var StyledColumn=Object(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_4_hedron__["Column"]).withConfig({displayName:'LinkBanner__StyledColumn',componentId:'sc-1rxctp-1'})(['padding:0;display:flex;justify-content:space-between;align-self:start;']);var StyledRow=Object(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_4_hedron__["Row"]).withConfig({displayName:'LinkBanner__StyledRow',componentId:'sc-1rxctp-2'})(['align-items:center;']);var LinkButton=Object(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_13_elements_Button__["a" /* default */]).withConfig({displayName:'LinkBanner__LinkButton',componentId:'sc-1rxctp-3'})(['margin-left:',';margin-top:15px;'],__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].get('metrics.s'));var TextWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div.withConfig({displayName:'LinkBanner__TextWrapper',componentId:'sc-1rxctp-4'})(['width:100%;']);var HideContentContainer=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div.withConfig({displayName:'LinkBanner__HideContentContainer',componentId:'sc-1rxctp-5'})(['overflow:hidden;']);var LinkBannerBlock=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["inject"])('windowStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"])(_class=(_class2=(_temp=_class3=function(_Component){_inherits(LinkBannerBlock,_Component);function LinkBannerBlock(props){_classCallCheck(this,LinkBannerBlock);var _this=_possibleConstructorReturn(this,(LinkBannerBlock.__proto__||Object.getPrototypeOf(LinkBannerBlock)).call(this,props));_this.elementRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(LinkBannerBlock,[{key:'componentDidMount',value:function componentDidMount(){var windowStore=this.props.windowStore;this.disposeOnScroll=windowStore.reactToScroll(this.onScroll);this.onScroll();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.disposeOnScroll();}},{key:'onScroll',value:function onScroll(){if(this.elementRef.current){Object(__WEBPACK_IMPORTED_MODULE_10_animations_Animations__["h" /* scaleImage */])(this.elementRef.current,1.1,0.9);Object(__WEBPACK_IMPORTED_MODULE_10_animations_Animations__["f" /* parallaxImage */])(this.elementRef.current,150,0,10);}}},{key:'render',value:function render(){var _props=this.props,_props$data=_props.data,htmlModifiers=_props$data.htmlModifiers,description=_props$data.description,header=_props$data.header,image=_props$data.image,backgroundImage=_props$data.backgroundImage,slug=_props$data.slug,linkText=_props$data.linkText,mobileBackgroundImage=_props$data.mobileBackgroundImage,windowStore=_props.windowStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_blocks_HTMLModifableBackground_HTMLModifiableBackground__["a" /* default */],{htmlModifiers:htmlModifiers,color:__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].brand('background')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HideContentContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledRow,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledColumn,{lg:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_reveal_Fade___default.a,{distance:''+__WEBPACK_IMPORTED_MODULE_10_animations_Animations__["a" /* FADE_VALUES */].TEXT.SMALL,delay:__WEBPACK_IMPORTED_MODULE_10_animations_Animations__["a" /* FADE_VALUES */].DELAY.SMALL,bottom:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TextWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Header__["a" /* default */],{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_14_common_methods_string__["g" /* safeHtmlWithBr */])(header)}}),windowStore.isOnTablet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__MobileImagesWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__BackgroundImage__["a" /* default */],{src:windowStore.adjustImageSize(mobileBackgroundImage||backgroundImage)}),image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Image__["a" /* default */],{innerRef:this.elementRef,src:windowStore.adjustImageSize(image)})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Description__["a" /* default */],{dangerouslySetInnerHTML:{__html:description}}),slug&&linkText&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_blocks_StyledLink__["b" /* default */],{to:slug},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LinkButton,{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_14_common_methods_string__["g" /* safeHtmlWithBr */])(linkText)}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledColumn,{lg:6},windowStore.isOnTablet?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__DesktopImagesWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Image__["a" /* default */],{innerRef:this.elementRef,src:windowStore.adjustImageSize(image)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__BackgroundImage__["a" /* default */],{src:windowStore.adjustImageSize(backgroundImage)})))))));}}]);return LinkBannerBlock;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class3.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_models__["P" /* LinkBanner */]).isRequired},_temp),(_applyDecoratedDescriptor(_class2.prototype,'onScroll',[__WEBPACK_IMPORTED_MODULE_11_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'onScroll'),_class2.prototype)),_class2))||_class)||_class);

/***/ }),

/***/ "./src/kentico-blocks/Newsletter/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Newsletter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_consts_anchor__ = __webpack_require__("./src/common/consts/anchor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_consts_anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_consts_anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_Mailing_service__ = __webpack_require__("./src/services/Mailing.service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_blocks_Form_CustomForm__ = __webpack_require__("./src/blocks/Form/CustomForm.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_blocks_Form_CustomFormElement__ = __webpack_require__("./src/blocks/Form/CustomFormElement.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_blocks_Form_SubmitButton__ = __webpack_require__("./src/blocks/Form/SubmitButton.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_elements_Header2__ = __webpack_require__("./src/elements/Header2.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_elements_Paragraph__ = __webpack_require__("./src/elements/Paragraph.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_blocks_Form_CustomCheckbox__ = __webpack_require__("./src/blocks/Form/CustomCheckbox.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_common_consts_form__ = __webpack_require__("./src/common/consts/form.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_blocks_HTMLModifableBackground_HTMLModifiableBackground__ = __webpack_require__("./src/blocks/HTMLModifableBackground/HTMLModifiableBackground.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_dec2,_dec3,_class,_desc,_value,_class2;var _templateObject=_taggedTemplateLiteral(['\n    margin-top:',';\n'],['\n    margin-top:',';\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var CheckboxContainer=__WEBPACK_IMPORTED_MODULE_5_styled_components__["default"].div.withConfig({displayName:'Newsletter__CheckboxContainer',componentId:'sc-1salzcq-0'})(['transition:all 0.35s ease-out;transform-origin:50% 75%;position:relative;',''],function(_ref){var visible=_ref.visible;return visible?'transform: scaleY(1); margin-top: 0; opacity: 1;':'transform: scaleY(0.33); margin-top: -'+__WEBPACK_IMPORTED_MODULE_7_designsystem__["a" /* default */].get('metrics.xxl')+'; opacity: 0;';});var StyledCustomForm=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_11_blocks_Form_CustomForm__["a" /* default */]).withConfig({displayName:'Newsletter__StyledCustomForm',componentId:'sc-1salzcq-1'})(['position:relative;justify-content:flex-end;',';'],__WEBPACK_IMPORTED_MODULE_7_designsystem__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_7_designsystem__["a" /* default */].get('metrics.l')));var StyledRow=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8_hedron__["Row"]).withConfig({displayName:'Newsletter__StyledRow',componentId:'sc-1salzcq-2'})(['margin:',';margin-top:',';'],function(_ref2){var margin=_ref2.margin;return margin?'0 '+__WEBPACK_IMPORTED_MODULE_7_designsystem__["a" /* default */].get('metrics.s'):'';},__WEBPACK_IMPORTED_MODULE_7_designsystem__["a" /* default */].get('metrics.xl'));var Newsletter=(_dec=Object(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["inject"])('windowStore','coreStore','appStore'),_dec2=Object(__WEBPACK_IMPORTED_MODULE_17_lodash_decorators__["Bind"])(),_dec3=Object(__WEBPACK_IMPORTED_MODULE_17_lodash_decorators__["Bind"])(),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["observer"])(_class=Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["withRouter"])(_class=(_class2=function(_Component){_inherits(Newsletter,_Component);function Newsletter(props){_classCallCheck(this,Newsletter);var _this=_possibleConstructorReturn(this,(Newsletter.__proto__||Object.getPrototypeOf(Newsletter)).call(this,props));_this.state={formData:{email:'',dataProcessingCheckbox:false,dataSendingCheckbox:false},resetValue:false,buttonState:'',isRodoVisible:false};return _this;}_createClass(Newsletter,[{key:'updateInputValue',value:function updateInputValue(input){var inputName=input.inputName,value=input.value;var formData=this.state.formData;formData[inputName]=value;this.setState(formData);}},{key:'submitForm',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _this2=this;var email,_props,currentLanguage,history,resultCode,errData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();email=this.state.formData.email;_props=this.props,currentLanguage=_props.appStore.currentLanguage,history=_props.history;this.setState({buttonState:__WEBPACK_IMPORTED_MODULE_18_common_consts_form__["a" /* default */].BUTTON_STATE.LOADING});resultCode=void 0;_context.prev=5;_context.next=8;return __WEBPACK_IMPORTED_MODULE_10_services_Mailing_service__["a" /* default */].sendNewsletter({email:email});case 8:resultCode=200;this.setState({buttonState:__WEBPACK_IMPORTED_MODULE_18_common_consts_form__["a" /* default */].BUTTON_STATE.SUCCESS});setTimeout(function(){_this2.resetState();},__WEBPACK_IMPORTED_MODULE_18_common_consts_form__["a" /* default */].SUCCESS_MESSAGE_TIMEOUT);this.setState({resetValue:false});_context.next=27;break;case 14:_context.prev=14;_context.t0=_context['catch'](5);this.setState({buttonState:__WEBPACK_IMPORTED_MODULE_18_common_consts_form__["a" /* default */].BUTTON_STATE.ERROR});_context.prev=17;_context.next=20;return _context.t0.json();case 20:errData=_context.sent;resultCode=errData.code;_context.next=27;break;case 24:_context.prev=24;_context.t1=_context['catch'](17);resultCode=_context.t0.status;case 27:_context.prev=27;history.push({pathname:''+__WEBPACK_IMPORTED_MODULE_3_common_consts_anchor___default.a.THANK_YOU[currentLanguage],state:{code:resultCode}});return _context.finish(27);case 30:case'end':return _context.stop();}}},_callee,this,[[5,14,27,30],[17,24]]);}));function submitForm(_x){return _ref3.apply(this,arguments);}return submitForm;}()},{key:'showRodoCheckboxes',value:function showRodoCheckboxes(){this.setState({isRodoVisible:true});}},{key:'resetState',value:function resetState(){this.setState({formData:{email:'',dataProcessingCheckbox:false,dataSendingCheckbox:false},buttonState:'',resetValue:true});}},{key:'render',value:function render(){var _props2=this.props,_props2$content=_props2.content,description=_props2$content.description,title=_props2$content.title,label=_props2$content.label,htmlModifiers=_props2$content.htmlModifiers,windowStore=_props2.windowStore,translations=_props2.coreStore.translations,margin=_props2.margin;var _state=this.state,resetValue=_state.resetValue,buttonState=_state.buttonState,isRodoVisible=_state.isRodoVisible;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_blocks_HTMLModifableBackground_HTMLModifiableBackground__["a" /* default */],{htmlModifiers:htmlModifiers,color:__WEBPACK_IMPORTED_MODULE_7_designsystem__["a" /* default */].brand('white'),overflow:'visible'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledRow,{margin:margin?1:0,divisions:11},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_hedron__["Column"],{fluid:!windowStore.isOnTablet,lg:5},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_elements_Header2__["a" /* default */],{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_20_common_methods_string__["g" /* safeHtmlWithBr */])(title)}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_elements_Paragraph__["a" /* default */],{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_20_common_methods_string__["g" /* safeHtmlWithBr */])(description)}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_hedron__["Column"],{fluid:!windowStore.isOnTablet,lg:5,lgShift:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledCustomForm,{onSubmit:this.submitForm},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_blocks_Form_CustomFormElement__["a" /* default */],{type:'email',name:'email',required:true,labelName:label,validateOnInput:true,getValue:this.updateInputValue,onInput:this.showRodoCheckboxes,resetValue:resetValue}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CheckboxContainer,{visible:isRodoVisible},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_blocks_Form_CustomCheckbox__["a" /* default */],{marginTop:__WEBPACK_IMPORTED_MODULE_7_designsystem__["a" /* default */].get('metrics.s'),type:'checkbox',name:'dataProcessingCheckbox',checkboxText:translations.FORM_CHECKBOX_DATA_PROCESSING_LABEL,required:true,resetValue:resetValue,getValue:this.updateInputValue}),Object(__WEBPACK_IMPORTED_MODULE_20_common_methods_string__["f" /* removeTags */])(translations.FORM_CHECKBOX_DATA_SENDING_LABEL)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_blocks_Form_CustomCheckbox__["a" /* default */],{marginTop:__WEBPACK_IMPORTED_MODULE_7_designsystem__["a" /* default */].get('metrics.s'),type:'checkbox',name:'dataSendingCheckbox',checkboxText:translations.FORM_CHECKBOX_DATA_SENDING_LABEL,required:true,resetValue:resetValue,getValue:this.updateInputValue})),!windowStore.isOnTablet&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_hedron__["Column"],{lg:3,lgShift:1}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_blocks_Form_SubmitButton__["a" /* default */],{centered:windowStore.isOnTablet,buttonState:buttonState})))));}}]);return Newsletter;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),(_applyDecoratedDescriptor(_class2.prototype,'updateInputValue',[_dec2],Object.getOwnPropertyDescriptor(_class2.prototype,'updateInputValue'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'submitForm',[_dec3],Object.getOwnPropertyDescriptor(_class2.prototype,'submitForm'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'showRodoCheckboxes',[__WEBPACK_IMPORTED_MODULE_17_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'showRodoCheckboxes'),_class2.prototype)),_class2))||_class)||_class)||_class);Newsletter.propTypes={content:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9_models__["R" /* Newsletter */]).isRequired,margin:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool};Newsletter.defaultProps={margin:true};

/***/ }),

/***/ "./src/kentico-blocks/ProductSlider/ProductSlide/BottomImage.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var BottomImage=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].img.withConfig({displayName:'BottomImage',componentId:'ia6gfb-0'})(['max-height:285px;position:absolute;left:0;bottom:-50px;max-width:100%;transition:bottom 0.2s ease-in-out 0.1s;']);/* harmony default export */ __webpack_exports__["a"] = (BottomImage);

/***/ }),

/***/ "./src/kentico-blocks/ProductSlider/ProductSlide/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductSlide; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_reveal_Fade__ = __webpack_require__("./node_modules/react-reveal/Fade.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_reveal_Fade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_reveal_Fade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_animations_Animations__ = __webpack_require__("./src/animations/Animations.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_blocks_Parser_Parser__ = __webpack_require__("./src/blocks/Parser/Parser.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_blocks_StyledLink__ = __webpack_require__("./src/blocks/StyledLink/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__BottomImage__ = __webpack_require__("./src/kentico-blocks/ProductSlider/ProductSlide/BottomImage.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _templateObject=_taggedTemplateLiteral(['\n    height: 550px;\n  '],['\n    height: 550px;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    width: 95%;\n    max-width: 431px;\n  '],['\n    width: 95%;\n    max-width: 431px;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    margin-right: ',';\n  '],['\n    margin-right: ',';\n  ']),_templateObject4=_taggedTemplateLiteral(['\n    margin-right: 0;\n  '],['\n    margin-right: 0;\n  ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var ProductCardBox=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div.withConfig({displayName:'ProductSlide__ProductCardBox',componentId:'sc-1x9i2ud-0'})(['display:block;position:relative;width:100%;height:520px;background-color:',';overflow:hidden;',' ',''],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('background'),__WEBPACK_IMPORTED_MODULE_7_designsystem_index__["c" /* media */].tablet(_templateObject),__WEBPACK_IMPORTED_MODULE_7_designsystem_index__["c" /* media */].desktop(_templateObject2));var StyledLinkForImage=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_10_blocks_StyledLink__["b" /* default */]).withConfig({displayName:'ProductSlide__StyledLinkForImage',componentId:'sc-1x9i2ud-1'})(['display:block;margin:',' ',';&:hover + * > ',',&:hover > ','{bottom:0;}'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.l'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.l'),__WEBPACK_IMPORTED_MODULE_11__BottomImage__["a" /* default */],__WEBPACK_IMPORTED_MODULE_11__BottomImage__["a" /* default */]);var MarginBox=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div.withConfig({displayName:'ProductSlide__MarginBox',componentId:'sc-1x9i2ud-2'})(['',' ',''],__WEBPACK_IMPORTED_MODULE_7_designsystem_index__["c" /* media */].tablet(_templateObject3,__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.s')),__WEBPACK_IMPORTED_MODULE_7_designsystem_index__["c" /* media */].desktop(_templateObject4));ProductCardBox.BottomImage=__WEBPACK_IMPORTED_MODULE_11__BottomImage__["a" /* default */];var ProductSlide=(_dec=Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["inject"])('windowStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["observer"])(_class=function(_Component){_inherits(ProductSlide,_Component);function ProductSlide(){_classCallCheck(this,ProductSlide);return _possibleConstructorReturn(this,(ProductSlide.__proto__||Object.getPrototypeOf(ProductSlide)).apply(this,arguments));}_createClass(ProductSlide,[{key:'render',value:function render(){var _props=this.props,_props$featureCard=_props.featureCard,content=_props$featureCard.content,bottomImage=_props$featureCard.bottomImage,slug=_props$featureCard.slug,index=_props.index,windowStore=_props.windowStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_reveal_Fade___default.a,{bottom:true,distance:''+__WEBPACK_IMPORTED_MODULE_8_animations_Animations__["a" /* FADE_VALUES */].BOX.LARGE,delay:windowStore.isOnMobile?__WEBPACK_IMPORTED_MODULE_8_animations_Animations__["a" /* FADE_VALUES */].DELAY.SMALL:__WEBPACK_IMPORTED_MODULE_8_animations_Animations__["a" /* FADE_VALUES */].DELAY.SMALL*index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MarginBox,{index:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductCardBox,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledLinkForImage,{to:slug},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_blocks_Parser_Parser__["a" /* default */],{htmlBody:content})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledLinkForImage,{to:slug,onClick:function onClick(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__BottomImage__["a" /* default */],{src:windowStore.adjustImageSize(bottomImage)})))));}}]);return ProductSlide;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);ProductSlide.propTypes={featureCard:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_6_models__["U" /* ProductSlide */]).isRequired,index:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired};

/***/ }),

/***/ "./src/kentico-blocks/ProductSlider/SlideWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n        width:125%;\n        transform: scale(1);\n        transition: transform 0.5s ease;\n        transform-origin: 0 50%;\n        & > div .slick-list{\n            overflow: visible;\n            & .slick-track{\n                margin-left:0;\n            }\n        }\n        &:hover{\n            transform: scale(0.99, 1);\n            transform-origin: 0 50%;\n            transition: transform 0.5s ease;\n            cursor:pointer;\n        }\n    '],['\n        width:125%;\n        transform: scale(1);\n        transition: transform 0.5s ease;\n        transform-origin: 0 50%;\n        & > div .slick-list{\n            overflow: visible;\n            & .slick-track{\n                margin-left:0;\n            }\n        }\n        &:hover{\n            transform: scale(0.99, 1);\n            transform-origin: 0 50%;\n            transition: transform 0.5s ease;\n            cursor:pointer;\n        }\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SlideWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'SlideWrapper',componentId:'sc-1b7gygu-0'})(['     display:flex;flex-flow:row;width:100%;',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject));/* harmony default export */ __webpack_exports__["a"] = (SlideWrapper);

/***/ }),

/***/ "./src/kentico-blocks/ProductSlider/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductSliderBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_responsive__ = __webpack_require__("./src/common/responsive.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blocks_Carousel_Carousel__ = __webpack_require__("./src/blocks/Carousel/Carousel.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_elements_Header4__ = __webpack_require__("./src/elements/Header4.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_blocks_HTMLModifableBackground_HTMLModifiableBackground__ = __webpack_require__("./src/blocks/HTMLModifableBackground/HTMLModifiableBackground.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SlideWrapper__ = __webpack_require__("./src/kentico-blocks/ProductSlider/SlideWrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ProductSlide__ = __webpack_require__("./src/kentico-blocks/ProductSlider/ProductSlide/index.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductSlider=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div.withConfig({displayName:'ProductSlider',componentId:'sc-1ue5gzx-0'})(['width:100%;margin:0 auto;position:relative;height:750px;padding:0;']);var ProductSliderBlock=(_temp=_class=function(_Component){_inherits(ProductSliderBlock,_Component);function ProductSliderBlock(){_classCallCheck(this,ProductSliderBlock);return _possibleConstructorReturn(this,(ProductSliderBlock.__proto__||Object.getPrototypeOf(ProductSliderBlock)).apply(this,arguments));}_createClass(ProductSliderBlock,[{key:'render',value:function render(){var _props$data=this.props.data,productSlides=_props$data.productSlides,header=_props$data.header,htmlModifiers=_props$data.htmlModifiers;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_blocks_HTMLModifableBackground_HTMLModifiableBackground__["a" /* default */],{htmlModifiers:htmlModifiers,color:__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('white')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_blocks_Container_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_hedron__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_hedron__["Column"],{lg:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductSlider,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_elements_Header4__["a" /* default */],{bold:true,dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_11_common_methods_string__["g" /* safeHtmlWithBr */])(header)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__SlideWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_blocks_Carousel_Carousel__["a" /* default */],{settings:ProductSliderBlock.carouselSettings},productSlides.map(function(slide,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProductSlide__["a" /* default */],{featureCard:slide,key:slide.system.id,index:index});}))))))));}}]);return ProductSliderBlock;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.carouselSettings={swipe:true,slidesToShow:3.65,dots:false,infinite:false,arrows:false,slidesToScroll:1,responsive:[{breakpoint:__WEBPACK_IMPORTED_MODULE_4_common_responsive__["a" /* desktopBreakpoint */],settings:{slidesToShow:1.99,slidesToScroll:1,infinite:false,arrows:false}},{breakpoint:__WEBPACK_IMPORTED_MODULE_4_common_responsive__["e" /* tabletBreakpoint */],settings:{slidesToShow:1,slidesToScroll:1,dots:true,infinite:false,arrows:false}}]},_class.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_5_models__["V" /* ProductSlider */]).isRequired},_temp);

/***/ }),

/***/ "./src/kentico-blocks/SimpleAccordion/PanelGroup/StyledPanelBody.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blocks_PanelGroup_index__ = __webpack_require__("./src/blocks/PanelGroup/index.jsx");
var StyledPanelBody=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_blocks_PanelGroup_index__["a" /* default */].Body).withConfig({displayName:'StyledPanelBody',componentId:'sc-1rnzuba-0'})(['width:100%;& p{margin:0;}']);/* harmony default export */ __webpack_exports__["a"] = (StyledPanelBody);

/***/ }),

/***/ "./src/kentico-blocks/SimpleAccordion/PanelGroup/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blocks_PanelGroup_index__ = __webpack_require__("./src/blocks/PanelGroup/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StyledPanelBody__ = __webpack_require__("./src/kentico-blocks/SimpleAccordion/PanelGroup/StyledPanelBody.jsx");
var PanelGroup=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_blocks_PanelGroup_index__["a" /* default */]).withConfig({displayName:'PanelGroup',componentId:'sc-1hhlgfc-0'})(['']);PanelGroup.Body=__WEBPACK_IMPORTED_MODULE_2__StyledPanelBody__["a" /* default */];/* harmony default export */ __webpack_exports__["a"] = (PanelGroup);

/***/ }),

/***/ "./src/kentico-blocks/SimpleAccordion/QuestionsWrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var QuestionsWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'QuestionsWrapper',componentId:'sc-1i3feju-0'})(['box-sizing:border-box;outline:none;']);/* harmony default export */ __webpack_exports__["a"] = (QuestionsWrapper);

/***/ }),

/***/ "./src/kentico-blocks/SimpleAccordion/Title.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_elements_Header2__ = __webpack_require__("./src/elements/Header2.js");
var _templateObject=_taggedTemplateLiteral(['\n    margin-top: 0;\n'],['\n    margin-top: 0;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Title=__WEBPACK_IMPORTED_MODULE_0_elements_Header2__["a" /* default */].extend(_templateObject);/* harmony default export */ __webpack_exports__["a"] = (Title);

/***/ }),

/***/ "./src/kentico-blocks/SimpleAccordion/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SimpleAccordionBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_chunk__ = __webpack_require__("./node_modules/lodash/chunk.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_chunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_chunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx__ = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_animations_Animations__ = __webpack_require__("./src/animations/Animations.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_reveal_Fade__ = __webpack_require__("./node_modules/react-reveal/Fade.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_reveal_Fade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_reveal_Fade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_blocks_ScrollDiv__ = __webpack_require__("./src/blocks/ScrollDiv/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_common_consts_scroll__ = __webpack_require__("./src/common/consts/scroll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_blocks_HTMLModifableBackground_HTMLModifiableBackground__ = __webpack_require__("./src/blocks/HTMLModifableBackground/HTMLModifiableBackground.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__PanelGroup_index__ = __webpack_require__("./src/kentico-blocks/SimpleAccordion/PanelGroup/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Title__ = __webpack_require__("./src/kentico-blocks/SimpleAccordion/Title.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__QuestionsWrapper__ = __webpack_require__("./src/kentico-blocks/SimpleAccordion/QuestionsWrapper.jsx");
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_class3,_temp;var _templateObject=_taggedTemplateLiteral(['\n    flex-direction: row;\n    min-height: 300px;\n    margin: ',' auto;\n    '],['\n    flex-direction: row;\n    min-height: 300px;\n    margin: ',' auto;\n    ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var SimpleAccordion=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div.withConfig({displayName:'SimpleAccordion',componentId:'sc-1k33gco-0'})(['display:flex;flex-direction:column;margin:',' auto;padding-bottom:',';width:100%;',';'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_12_designsystem_index__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.xl')));var SimpleText=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span.withConfig({displayName:'SimpleAccordion__SimpleText',componentId:'sc-1k33gco-1'})(['']);var SimpleAccordionBlock=(_dec=Object(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["inject"])('windowStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["observer"])(_class=(_class2=(_temp=_class3=function(_Component){_inherits(SimpleAccordionBlock,_Component);function SimpleAccordionBlock(props){_classCallCheck(this,SimpleAccordionBlock);var _this=_possibleConstructorReturn(this,(SimpleAccordionBlock.__proto__||Object.getPrototypeOf(SimpleAccordionBlock)).call(this,props));_this.activeKey=__WEBPACK_IMPORTED_MODULE_5_mobx__["observable"].box(0);var simpleAccordionItems=_this.props.data.simpleAccordionItems;_this.scrollRefs=simpleAccordionItems.map(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();});return _this;}_createClass(SimpleAccordionBlock,[{key:'scrollTo',value:function scrollTo(scrollRef){var windowStore=this.props.windowStore;if(windowStore.isOnTablet){Object(__WEBPACK_IMPORTED_MODULE_7_animations_Animations__["k" /* scrollToElement */])(scrollRef.current,200);}}},{key:'render',value:function render(){var _this2=this;var data=this.props.data;var questions=data.simpleAccordionItems;var _chunk=__WEBPACK_IMPORTED_MODULE_4_lodash_chunk___default()(questions,Math.ceil(questions.length/2)),_chunk2=_slicedToArray(_chunk,2),LeftColData=_chunk2[0],RightColData=_chunk2[1];var scrollOffset='-'+__WEBPACK_IMPORTED_MODULE_15_common_consts_scroll__["a" /* default */].SIMPLE_ACCORDION_TOP_OFFSET+'px';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_blocks_HTMLModifableBackground_HTMLModifiableBackground__["a" /* default */],{htmlModifiers:data.htmlModifiers,color:__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].brand('white')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_blocks_Container_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SimpleAccordion,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_hedron__["Column"],{lg:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_reveal_Fade___default.a,{bottom:true,distance:''+__WEBPACK_IMPORTED_MODULE_7_animations_Animations__["a" /* FADE_VALUES */].BOX.SMALL,delay:__WEBPACK_IMPORTED_MODULE_7_animations_Animations__["a" /* FADE_VALUES */].DELAY.SMALL},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Title__["a" /* default */],{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_17_common_methods_string__["g" /* safeHtmlWithBr */])(data.header)}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_hedron__["Column"],{lg:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__QuestionsWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_reveal_Fade___default.a,{bottom:true,cascade:true,distance:''+__WEBPACK_IMPORTED_MODULE_7_animations_Animations__["a" /* FADE_VALUES */].BOX.SMALL,delay:__WEBPACK_IMPORTED_MODULE_7_animations_Animations__["a" /* FADE_VALUES */].DELAY.SMALL},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_hedron__["Row"],{alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_hedron__["Column"],{fluid:true,lg:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__PanelGroup_index__["a" /* default */],{accordion:true,defaultActiveKey:0,activeKey:this.activeKey.get(),onSelect:function onSelect(activeKey){return _this2.activeKey.set(activeKey);},id:'FAQ.LeftPanel'},LeftColData.map(function(question,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__PanelGroup_index__["a" /* default */].Panel,{eventKey:index,key:question.system.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__PanelGroup_index__["a" /* default */].Heading,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_blocks_ScrollDiv__["a" /* default */],{offset:scrollOffset,innerRef:_this2.scrollRefs[index]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__PanelGroup_index__["a" /* default */].Title,{toggle:true,onClick:function onClick(){return _this2.scrollTo(_this2.scrollRefs[index]);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SimpleText,{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_17_common_methods_string__["g" /* safeHtmlWithBr */])(question.title)}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__PanelGroup_index__["a" /* default */].Body,{collapsible:true,dangerouslySetInnerHTML:{__html:question.text}}));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_hedron__["Column"],{fluid:true,lg:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__PanelGroup_index__["a" /* default */],{accordion:true,activeKey:this.activeKey.get(),onSelect:function onSelect(activeKey){return _this2.activeKey.set(activeKey);},id:'FAQ.RightPanel'},RightColData.map(function(question,index){var rightColIndex=index+LeftColData.length+1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__PanelGroup_index__["a" /* default */].Panel,{eventKey:rightColIndex,key:rightColIndex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__PanelGroup_index__["a" /* default */].Heading,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_blocks_ScrollDiv__["a" /* default */],{offset:scrollOffset,innerRef:_this2.scrollRefs[LeftColData.length+index]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__PanelGroup_index__["a" /* default */].Title,{toggle:true,onClick:function onClick(){return _this2.scrollTo(_this2.scrollRefs[LeftColData.length+index]);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SimpleText,{dangerouslySetInnerHTML:{__html:question.title}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__PanelGroup_index__["a" /* default */].Body,{collapsible:true,dangerouslySetInnerHTML:{__html:question.text}}));}))))))))));}}]);return SimpleAccordionBlock;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class3.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_10_models__["Y" /* SimpleAccordion */]).isRequired},_temp),(_applyDecoratedDescriptor(_class2.prototype,'scrollTo',[__WEBPACK_IMPORTED_MODULE_13_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'scrollTo'),_class2.prototype)),_class2))||_class)||_class);

/***/ }),

/***/ "./src/kentico-blocks/ThreeColumnGrid/ColumnBox.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem_index__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n        padding-right: ',';\n        padding-left: 0;\n    '],['\n        padding-right: ',';\n        padding-left: 0;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ColumnBox=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'ColumnBox',componentId:'sc-9cuqdr-0'})(['box-sizing:border-box;padding:0;outline:none;& *{margin-left:0;}',';'],__WEBPACK_IMPORTED_MODULE_2_designsystem_index__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.l')));/* harmony default export */ __webpack_exports__["a"] = (ColumnBox);

/***/ }),

/***/ "./src/kentico-blocks/ThreeColumnGrid/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThreeColumnGridBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_responsive__ = __webpack_require__("./src/common/responsive.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_consts_kentico__ = __webpack_require__("./src/common/consts/kentico.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_blocks_Carousel_Carousel__ = __webpack_require__("./src/blocks/Carousel/Carousel.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_blocks_Parser_Parser__ = __webpack_require__("./src/blocks/Parser/Parser.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_blocks_HTMLModifableBackground_HTMLModifiableBackground__ = __webpack_require__("./src/blocks/HTMLModifableBackground/HTMLModifiableBackground.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_kentico_blocks_ImageLink__ = __webpack_require__("./src/kentico-blocks/ImageLink/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ColumnBox__ = __webpack_require__("./src/kentico-blocks/ThreeColumnGrid/ColumnBox.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ThreeColumnGrid=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div.withConfig({displayName:'ThreeColumnGrid',componentId:'sc-179lrf9-0'})(['display:flex;padding:0 0 ',' 0;'],__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('metrics.xl'));ThreeColumnGrid.ColumnBox=__WEBPACK_IMPORTED_MODULE_13__ColumnBox__["a" /* default */];var ThreeColumnGridBlock=(_temp=_class=function(_Component){_inherits(ThreeColumnGridBlock,_Component);function ThreeColumnGridBlock(){_classCallCheck(this,ThreeColumnGridBlock);return _possibleConstructorReturn(this,(ThreeColumnGridBlock.__proto__||Object.getPrototypeOf(ThreeColumnGridBlock)).apply(this,arguments));}_createClass(ThreeColumnGridBlock,[{key:'render',value:function render(){var _props$data=this.props.data,columns=_props$data.columns,htmlModifiers=_props$data.htmlModifiers;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_blocks_HTMLModifableBackground_HTMLModifiableBackground__["a" /* default */],{color:__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].brand('background'),htmlModifiers:htmlModifiers},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_blocks_Container_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ThreeColumnGrid,null,columns&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_blocks_Carousel_Carousel__["a" /* default */],{settings:ThreeColumnGridBlock.carouselSettings,threeColumnCarousel:true},columns.map(function(el){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_hedron__["Column"],{key:el.system.id},el.system.type===__WEBPACK_IMPORTED_MODULE_6_common_consts_kentico__["c" /* KENTICO_TYPES */].IMAGE_LINK?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_kentico_blocks_ImageLink__["a" /* default */],{data:el}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_blocks_Parser_Parser__["a" /* default */],{htmlModifiers:el.htmlModifiers,htmlBody:el.content}));})))));}}]);return ThreeColumnGridBlock;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.carouselSettings={swipe:true,slidesToShow:3,slidesToScroll:1,dots:false,responsive:[{breakpoint:__WEBPACK_IMPORTED_MODULE_5_common_responsive__["a" /* desktopBreakpoint */],settings:{slidesToShow:1,dots:true,infinite:false,arrows:false}}]},_class.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_7_models__["_0" /* ThreeColumnGrid */]).isRequired},_temp);

/***/ }),

/***/ "./src/kentico-blocks/TitleAndSubtitle/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_elements_Header1__ = __webpack_require__("./src/elements/Header1.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_elements_DescriptionText__ = __webpack_require__("./src/elements/DescriptionText.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n    margin: "," auto ",";\n  "],["\n    margin: "," auto ",";\n  "]),_templateObject2=_taggedTemplateLiteral(["\n      font-size: ",";\n      line-height: ",";\n    "],["\n      font-size: ",";\n      line-height: ",";\n    "]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var StyledContainer=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_blocks_Container_Container__["a" /* default */]).withConfig({displayName:"TitleAndSubtitle__StyledContainer",componentId:"xaj0xw-0"})(["margin:"," auto 0;padding:",";",";"],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get("metrics.xl"),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get("metrics.s"),__WEBPACK_IMPORTED_MODULE_2_designsystem__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get("metrics.xxl"),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get("metrics.l")));var StyledHeader=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_4_elements_Header1__["a" /* default */]).withConfig({displayName:"TitleAndSubtitle__StyledHeader",componentId:"xaj0xw-1"})(["font-size:",";line-height:",";text-align:center;",""],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs("l"),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get("type.lineHeight.l"),__WEBPACK_IMPORTED_MODULE_2_designsystem__["c" /* media */].tablet(_templateObject2,__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs("xl"),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get("type.lineHeight.xl")));var Description=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_5_elements_DescriptionText__["a" /* default */]).withConfig({displayName:"TitleAndSubtitle__Description",componentId:"xaj0xw-2"})(["font-size:",";line-height:",";text-align:center;",""],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs("m"),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get("type.lineHeight.m"),__WEBPACK_IMPORTED_MODULE_2_designsystem__["c" /* media */].tablet(_templateObject2,__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].fs("l"),__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get("type.lineHeight.l")));var TitleAndSubtitle=function(_Component){_inherits(TitleAndSubtitle,_Component);function TitleAndSubtitle(){_classCallCheck(this,TitleAndSubtitle);return _possibleConstructorReturn(this,(TitleAndSubtitle.__proto__||Object.getPrototypeOf(TitleAndSubtitle)).apply(this,arguments));}_createClass(TitleAndSubtitle,[{key:"render",value:function render(){var _props$data=this.props.data,title=_props$data.title,subtitle=_props$data.subtitle;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledHeader,null,title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Description,null,subtitle));}}]);return TitleAndSubtitle;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TitleAndSubtitle);

/***/ }),

/***/ "./src/kentico-blocks/TwoColumnGrid/Column.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_reveal_Fade__ = __webpack_require__("./node_modules/react-reveal/Fade.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_reveal_Fade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_reveal_Fade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_animations_Animations__ = __webpack_require__("./src/animations/Animations.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_blocks_Parser_Parser__ = __webpack_require__("./src/blocks/Parser/Parser.jsx");
var ColumnBlock=function ColumnBlock(_ref){var data=_ref.data,lgShift=_ref.lgShift,id=_ref.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hedron__["Column"],{lg:5,lgShift:lgShift},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_reveal_Fade___default.a,{bottom:true,distance:''+__WEBPACK_IMPORTED_MODULE_3_animations_Animations__["a" /* FADE_VALUES */].TEXT.LARGE,delay:__WEBPACK_IMPORTED_MODULE_3_animations_Animations__["a" /* FADE_VALUES */].DELAY.SMALL*id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_blocks_Parser_Parser__["a" /* default */],{htmlModifiers:data.htmlModifiers,htmlBody:data.content})));};ColumnBlock.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_5_models__["p" /* Column */]).isRequired,lgShift:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};ColumnBlock.defaultProps={lgShift:0,id:0};/* harmony default export */ __webpack_exports__["a"] = (ColumnBlock);

/***/ }),

/***/ "./src/kentico-blocks/TwoColumnGrid/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_kentico_blocks_TwoColumnGrid_Column__ = __webpack_require__("./src/kentico-blocks/TwoColumnGrid/Column.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_blocks_HTMLModifableBackground_HTMLModifiableBackground__ = __webpack_require__("./src/blocks/HTMLModifableBackground/HTMLModifiableBackground.jsx");
var TwoColumnGrid=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div.withConfig({displayName:'TwoColumnGrid',componentId:'sc-83v9cp-0'})(['display:flex;padding:',' 0;'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.base'));var TwoColumnGridBlock=function TwoColumnGridBlock(_ref){var _ref$data=_ref.data,columns=_ref$data.columns,htmlModifiers=_ref$data.htmlModifiers;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_blocks_HTMLModifableBackground_HTMLModifiableBackground__["a" /* default */],{htmlModifiers:htmlModifiers},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_blocks_Container_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TwoColumnGrid,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hedron__["Row"],{alignItems:'flex-start'},columns.map(function(column,index){return column?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_kentico_blocks_TwoColumnGrid_Column__["a" /* default */],{data:column,key:column.id,id:index,lgShift:index%2}):'';})))));};TwoColumnGridBlock.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_5_models__["_3" /* TwoColumnGrid */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (TwoColumnGridBlock);

/***/ }),

/***/ "./src/kentico-blocks/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeroImage__ = __webpack_require__("./src/kentico-blocks/HeroImage/index.jsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__HeroImage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ThreeColumnGrid__ = __webpack_require__("./src/kentico-blocks/ThreeColumnGrid/index.jsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_1__ThreeColumnGrid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Banner__ = __webpack_require__("./src/kentico-blocks/Banner/index.jsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Banner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SimpleAccordion__ = __webpack_require__("./src/kentico-blocks/SimpleAccordion/index.jsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_3__SimpleAccordion__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Accordion__ = __webpack_require__("./src/kentico-blocks/Accordion/index.jsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__Accordion__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CardSlider__ = __webpack_require__("./src/kentico-blocks/CardSlider/index.jsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__CardSlider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ProductSlider__ = __webpack_require__("./src/kentico-blocks/ProductSlider/index.jsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_6__ProductSlider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DownloadBar__ = __webpack_require__("./src/kentico-blocks/DownloadBar/index.jsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_7__DownloadBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TwoColumnGrid__ = __webpack_require__("./src/kentico-blocks/TwoColumnGrid/index.jsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_8__TwoColumnGrid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ImagedSection__ = __webpack_require__("./src/kentico-blocks/ImagedSection/index.jsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_9__ImagedSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ContactForm__ = __webpack_require__("./src/kentico-blocks/ContactForm/index.jsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_10__ContactForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ContactFormSupport__ = __webpack_require__("./src/kentico-blocks/ContactFormSupport/index.jsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_11__ContactFormSupport__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ImageSlider__ = __webpack_require__("./src/kentico-blocks/ImageSlider/index.jsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_12__ImageSlider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CallUs__ = __webpack_require__("./src/kentico-blocks/CallUs/index.jsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_13__CallUs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__HorizontallyNavigableContent__ = __webpack_require__("./src/kentico-blocks/HorizontallyNavigableContent/index.jsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_14__HorizontallyNavigableContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__LinkBanner__ = __webpack_require__("./src/kentico-blocks/LinkBanner/index.jsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_15__LinkBanner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Calculator__ = __webpack_require__("./src/kentico-blocks/Calculator/index.jsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_16__Calculator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ArticleSlider__ = __webpack_require__("./src/kentico-blocks/ArticleSlider/index.jsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_17__ArticleSlider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__FAQAccordion__ = __webpack_require__("./src/kentico-blocks/FAQAccordion/index.jsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_18__FAQAccordion__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__TitleAndSubtitle__ = __webpack_require__("./src/kentico-blocks/TitleAndSubtitle/index.jsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_19__TitleAndSubtitle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CroppedAsset__ = __webpack_require__("./src/kentico-blocks/CroppedAsset/index.jsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_20__CroppedAsset__["a"]; });


/***/ }),

/***/ "./src/models/Accordion.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Accordion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Accordion=function(_ContentItem){_inherits(Accordion,_ContentItem);function Accordion(){_classCallCheck(this,Accordion);return _possibleConstructorReturn(this,(Accordion.__proto__||Object.getPrototypeOf(Accordion)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(Accordion,[{key:'header',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_header.value','');}},{key:'accordionItems',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_accordion_items',[]);}},{key:'htmlModifiers',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_html_modifiers',[]);}}]);return Accordion;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/AccordionItem.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AccordionItem=function(_ContentItem){_inherits(AccordionItem,_ContentItem);function AccordionItem(){_classCallCheck(this,AccordionItem);return _possibleConstructorReturn(this,(AccordionItem.__proto__||Object.getPrototypeOf(AccordionItem)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(AccordionItem,[{key:'title',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_title.value','');}},{key:'text',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_text.value','');}},{key:'image',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_image.value[0].url','');}},{key:'smallText',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_small_text.value','');}}]);return AccordionItem;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/ArticleSlide.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArticleSlide; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ArticleSlide=function(_ContentItem){_inherits(ArticleSlide,_ContentItem);function ArticleSlide(){_classCallCheck(this,ArticleSlide);return _possibleConstructorReturn(this,(ArticleSlide.__proto__||Object.getPrototypeOf(ArticleSlide)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(ArticleSlide,[{key:'image',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_image.value[0].url','');}},{key:'title',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_title.value','');}},{key:'url',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_url.value','');}},{key:'id',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'system.id','');}}]);return ArticleSlide;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/ArticleSlider.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArticleSlider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ArticleSlider=function(_ContentItem){_inherits(ArticleSlider,_ContentItem);function ArticleSlider(){_classCallCheck(this,ArticleSlider);return _possibleConstructorReturn(this,(ArticleSlider.__proto__||Object.getPrototypeOf(ArticleSlider)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(ArticleSlider,[{key:'header',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_header.value','');}},{key:'articleSlides',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_article_slides',[]);}},{key:'htmlModifiers',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_html_modifiers',[]);}},{key:'id',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'system.id','');}}]);return ArticleSlider;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/Banner.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Banner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Banner=function(_ContentItem){_inherits(Banner,_ContentItem);function Banner(){_classCallCheck(this,Banner);return _possibleConstructorReturn(this,(Banner.__proto__||Object.getPrototypeOf(Banner)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(Banner,[{key:'header',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_header.value','');}},{key:'image',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_image.value[0].url','');}},{key:'text',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_text.value','');}},{key:'buttonText',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_button_text.value','');}},{key:'buttonLink',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_button_link.value','');}},{key:'htmlModifiers',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_html_modifiers',[]);}}]);return Banner;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/BlogArticle.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlogArticle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BlogArticle=function(_ContentItem){_inherits(BlogArticle,_ContentItem);function BlogArticle(){_classCallCheck(this,BlogArticle);return _possibleConstructorReturn(this,(BlogArticle.__proto__||Object.getPrototypeOf(BlogArticle)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(BlogArticle,[{key:'id',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'system.id','');}},{key:'categories',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_categories__blog_category.taxonomyTerms',[]);}},{key:'mainCategory',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_main_category__blog_category.taxonomyTerms[0]',[]);}},{key:'relatedProducts',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_related_products',[]);}},{key:'title',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_title.value','');}},{key:'slug',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_slug.value','');}},{key:'publicationDate',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_publication_date.value','');}},{key:'content',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_content',{});}},{key:'fullWidthListingImage',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_listing___full_width_image.value[0].url','');}},{key:'listingImage',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_listing___image.value[0].url','');}},{key:'articleAuthor',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_article_author[0]',{});}},{key:'linkToProduct',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_link_to_product[0]',{});}},{key:'SEO',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_seo[0].model',{});}},{key:'metaKeywords',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_meta_keywords.value','');}}]);return BlogArticle;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/BlogAuthor.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlogAuthor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BlogAuthor=function(_ContentItem){_inherits(BlogAuthor,_ContentItem);function BlogAuthor(){_classCallCheck(this,BlogAuthor);return _possibleConstructorReturn(this,(BlogAuthor.__proto__||Object.getPrototypeOf(BlogAuthor)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(BlogAuthor,[{key:'id',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'system.id','');}},{key:'codename',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'system.codename','');}},{key:'name',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_name.value','');}},{key:'position',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_position.value','');}},{key:'description',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_description.value','');}},{key:'image',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_image.value[0].url','');}}]);return BlogAuthor;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/BlogCategoryTranslation.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlogCategoryTranslation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BlogCategoryTranslation=function(_ContentItem){_inherits(BlogCategoryTranslation,_ContentItem);function BlogCategoryTranslation(){_classCallCheck(this,BlogCategoryTranslation);return _possibleConstructorReturn(this,(BlogCategoryTranslation.__proto__||Object.getPrototypeOf(BlogCategoryTranslation)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(BlogCategoryTranslation,[{key:'category',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_translation.value','');}},{key:'codeName',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_blog_category.taxonomyTerms[0].codename','');}}]);return BlogCategoryTranslation;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/BlogImageSlide.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlogImageSlide; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BlogImageSlide=function(_ContentItem){_inherits(BlogImageSlide,_ContentItem);function BlogImageSlide(){_classCallCheck(this,BlogImageSlide);return _possibleConstructorReturn(this,(BlogImageSlide.__proto__||Object.getPrototypeOf(BlogImageSlide)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(BlogImageSlide,[{key:'type',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'system.type','');}},{key:'imageSlide',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_image_slide.value[0].url','');}}]);return BlogImageSlide;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/BlogImageSlider.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlogImageSlider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BlogImageSlider=function(_ContentItem){_inherits(BlogImageSlider,_ContentItem);function BlogImageSlider(){_classCallCheck(this,BlogImageSlider);return _possibleConstructorReturn(this,(BlogImageSlider.__proto__||Object.getPrototypeOf(BlogImageSlider)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;},richTextResolver:function richTextResolver(item){return'<object slides='+JSON.stringify(item.imageSlides.map(function(image){return image.imageSlide;}))+'\n                                  constructor="'+item.type+'"/>';}}));}_createClass(BlogImageSlider,[{key:'type',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'system.type','');}},{key:'imageSlides',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_image_slides',[]);}}]);return BlogImageSlider;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/Calculator.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Calculator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Calculator=function(_ContentItem){_inherits(Calculator,_ContentItem);function Calculator(){_classCallCheck(this,Calculator);return _possibleConstructorReturn(this,(Calculator.__proto__||Object.getPrototypeOf(Calculator)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(Calculator,[{key:'currency',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_currency.value','');}// MOBILE SMALL MODAL
},{key:'valueOfOptimisationText',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_value_of_optimisation_text.value','');}},{key:'linkToMoreDataText',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_link_to_more_data_text.value','');}// MAIN VIEW:
},{key:'mainHeading',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_main_heading.value','');}},{key:'detailsViewLinkText',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_details_view_link_text.value','');}},{key:'returnToMainViewLinkText',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_return_to_main_view_link_text.value','');}// ICONS MAIN VIEW:
},{key:'conferenceRoomsMainViewIcon',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_conference_rooms_main_view_icon.value[0].url','');}},{key:'employeesMainViewIcon',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_employees_main_view_icon.value[0].url','');}},{key:'desksMainViewIcon',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_desks_main_view_icon.value[0].url','');}},{key:'parkingSpotsMainViewIcon',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_parking_spots_main_view_icon.value[0].url','');}// LABELS AND INPUTS IN MAIN VIEW:
},{key:'numberOfConferenceRoomsLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_number_of_conference_rooms_label.value','');}},{key:'numberOfConferenceRoomsDefaultValue',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_number_of_conference_rooms_default_value.value',0);}},{key:'monthlyM2RentPriceLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_monthly_m2_rent_price_label.value','');}},{key:'monthlyM2RentPriceDefaultValue',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_monthly_m2_rent_price_default_value.value',0);}},{key:'numberOfEmployeesLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_number_of_employees_label.value','');}},{key:'numberOfEmployeesDefaultValue',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_number_of_employees_default_value.value',0);}},{key:'averageEmployeeSalaryPerHourLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_average_employee_salary_per_hour_label.value','');}},{key:'averageEmployeeSalaryPerHourDefaultValue',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_average_employee_salary_per_hour_default_value.value',0);}},{key:'numberOfDesksLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_number_of_desks_label.value','');}},{key:'numberOfDesksDefaultValue',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_number_of_desks_default_value.value',0);}},{key:'numberOfParkingSpotsLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_number_of_parking_spots_label.value','');}},{key:'numberOfParkingSpotsDefaultValue',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_number_of_parking_spots_default_value.value',0);}},{key:'pricePerParkingSpotLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_price_per_parking_spot_label.value','');}},{key:'pricePerParkingSpotDefaultValue',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_price_per_parking_spot_default_value.value',0);}// Side info texts:
},{key:'sideInfoOptimisationFrequency',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_side_info_optimisation_frequency.value','');}},{key:'sideInfoOptimisationPeriod',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_side_info_optimisation_period.value','');}},{key:'sideInfoText',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_side_info_text_3b26206.value','');}},{key:'sideInfoImplementationText',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_side_info_implementation_text.value','');}},{key:'sideInfoReimburseText',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_side_info_reimburse_text.value','');}},{key:'asideNote',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_aside_note.value','');}// ICONS DISPLAYED IN DETAILS VIEW:
},{key:'conferenceRoomsDetailsViewIcon',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_conference_rooms_details_view_icon.value[0].url','');}},{key:'employeesDetailsViewIcon',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_employees_details_view_icon.value[0].url','');}},{key:'desksMainDetailsIcon',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_desks_details_view_icon.value[0].url','');}},{key:'parkingSpotsDetailsViewIcon',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_parking_spots_details_view_icon.value[0].url','');}// OPTIMISATION RATES REQUIRED FOR CALCULATIONS (DETAILS VIEW):
},{key:'optimisationRatesHeading',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_optimisation_rates_heading.value','');}},{key:'conferenceRoomOptimisationRate',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_conference_room_optimisation_rate.value','');}},{key:'workingHoursOptimisationRate',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_working_hours_optimisation_rate.value','');}},{key:'desksOptimisationRate',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_desks_optimisation_rate.value','');}},{key:'parkingOptimisationRate',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_parking_optimisation_rate.value','');}// Constant values required for calculations (displayed in details view):
},{key:'averageSizeOfConferenceRoom',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_average_size_of_conference_room[0]',{});}},{key:'averageWorkingHoursPerMonth',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_average_working_hours_per_month[0]',{});}},{key:'estimatedAreaOfOneDesk',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_estimated_area_of_one_desk[0]',{});}},{key:'estimatedCostOfSensorInstallationPerDesk',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_estimated_cost_of_sensor_installation_per_desk[0]',{});}},{key:'costOfScreenHardwarePerRoom',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_cost_of_screen_hardware_per_room[0]',{});}},{key:'subscriptionFeePerEmployeeIn5Years',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_subscription_fee_per_employee_in_5_years[0]',{});}// Labels for calculated values in details view:
},{key:'hardwareImplementationCostLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_hardware_implementation_cost_label.value','');}},{key:'costOfZoniferoIn5YearsPerspectiveLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_cost_of_zonifero_in_5_years_perspective_label.value','');}},{key:'totalOptimisationPerMonthLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_total_optimisation_per_month_label.value','');}},{key:'yourReturnOfInvestmentTimeLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_your_return_of_investment_time_label.value','');}},{key:'roomsOptimisationLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_rooms_optimisation_label.value','');}},{key:'workOptimisationLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_work_optimisation_label.value','');}},{key:'desksOptimisationLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_desks_optimisation_label.value','');}},{key:'parkingOptimisationLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_parking_optimisation_label.value','');}}]);return Calculator;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/CalculatorValue.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalculatorValue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CalculatorValue=function(_ContentItem){_inherits(CalculatorValue,_ContentItem);function CalculatorValue(){_classCallCheck(this,CalculatorValue);return _possibleConstructorReturn(this,(CalculatorValue.__proto__||Object.getPrototypeOf(CalculatorValue)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(CalculatorValue,[{key:'label',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_label.value','');}},{key:'value',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_value.value','');}},{key:'unit',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_unit.value','');}}]);return CalculatorValue;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/CallUs.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CallUs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CallUs=function(_ContentItem){_inherits(CallUs,_ContentItem);function CallUs(){_classCallCheck(this,CallUs);return _possibleConstructorReturn(this,(CallUs.__proto__||Object.getPrototypeOf(CallUs)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(CallUs,[{key:'people',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_people',[]);}},{key:'htmlModifiers',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_html_modifiers',[]);}}]);return CallUs;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/CardSlide.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardSlide; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CardSlide=function(_ContentItem){_inherits(CardSlide,_ContentItem);function CardSlide(){_classCallCheck(this,CardSlide);return _possibleConstructorReturn(this,(CardSlide.__proto__||Object.getPrototypeOf(CardSlide)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(CardSlide,[{key:'title',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_title.value','');}},{key:'description',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_description.value','');}},{key:'logo',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_logo.value[0].url','');}}]);return CardSlide;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/CardSlider.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardSlider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CardSlider=function(_ContentItem){_inherits(CardSlider,_ContentItem);function CardSlider(){_classCallCheck(this,CardSlider);return _possibleConstructorReturn(this,(CardSlider.__proto__||Object.getPrototypeOf(CardSlider)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(CardSlider,[{key:'header',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_header.value','');}},{key:'slides',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_slides',[]);}},{key:'htmlModifiers',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_html_modifiers',[]);}}]);return CardSlider;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/Column.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Column; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Column=function(_ContentItem){_inherits(Column,_ContentItem);function Column(){_classCallCheck(this,Column);return _possibleConstructorReturn(this,(Column.__proto__||Object.getPrototypeOf(Column)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(Column,[{key:'content',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_content',{});}},{key:'htmlModifiers',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_html_modifiers',[]);}},{key:'id',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'system.id','');}}]);return Column;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/ContactForm.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContactForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContactForm=function(_ContentItem){_inherits(ContactForm,_ContentItem);function ContactForm(){_classCallCheck(this,ContactForm);return _possibleConstructorReturn(this,(ContactForm.__proto__||Object.getPrototypeOf(ContactForm)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(ContactForm,[{key:'email',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_email.value','');}},{key:'emailLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_email_label.value','');}},{key:'submitButtonText',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_submit_button_text.value','');}},{key:'messageLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_message_label.value','');}},{key:'firstNameLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_first_name_label.value','');}},{key:'lastNameLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_last_name_label.value','');}},{key:'phoneLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_phone_label.value','');}},{key:'reCaptchaErrorMessage',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_recaptcha_error_message.value','');}},{key:'htmlModifiers',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_html_modifiers',[]);}}]);return ContactForm;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/ContactFormSupport.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContactFormSupport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContactFormSupport=function(_ContentItem){_inherits(ContactFormSupport,_ContentItem);function ContactFormSupport(){_classCallCheck(this,ContactFormSupport);return _possibleConstructorReturn(this,(ContactFormSupport.__proto__||Object.getPrototypeOf(ContactFormSupport)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(ContactFormSupport,[{key:'osVersion',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_os_version.value','');}},{key:'company',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_company.value','');}},{key:'email',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_email.value','');}},{key:'emailLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_email_label.value','');}},{key:'submitButtonText',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_submit_button_text.value','');}},{key:'messageLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_message_label.value','');}},{key:'firstNameLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_first_name_label.value','');}},{key:'lastNameLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_last_name_label.value','');}},{key:'phoneLabel',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_phone_label.value','');}},{key:'clientSystem',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_client_system.value','');}},{key:'reCaptchaErrorMessage',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_recaptcha_error_message.value','');}},{key:'htmlModifiers',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_html_modifiers',[]);}}]);return ContactFormSupport;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/ContactLink.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContactLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContactLink=function(_ContentItem){_inherits(ContactLink,_ContentItem);function ContactLink(){_classCallCheck(this,ContactLink);return _possibleConstructorReturn(this,(ContactLink.__proto__||Object.getPrototypeOf(ContactLink)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(ContactLink,[{key:'name',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_name.value','');}},{key:'url',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_url.value','');}},{key:'id',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'system.id','');}}]);return ContactLink;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/ContactPerson.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContactPerson; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContactPerson=function(_ContentItem){_inherits(ContactPerson,_ContentItem);function ContactPerson(){_classCallCheck(this,ContactPerson);return _possibleConstructorReturn(this,(ContactPerson.__proto__||Object.getPrototypeOf(ContactPerson)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(ContactPerson,[{key:'email',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_email.value','');}},{key:'phone',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_phone.value','');}},{key:'photo',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_photo.value[0].url','');}},{key:'description',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_description.value','');}},{key:'name',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_name.value','');}},{key:'links',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_links',[]);}},{key:'id',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'system.id','');}}]);return ContactPerson;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/ContentWithHeader.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContentWithHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentWithHeader=function(_ContentItem){_inherits(ContentWithHeader,_ContentItem);function ContentWithHeader(){_classCallCheck(this,ContentWithHeader);return _possibleConstructorReturn(this,(ContentWithHeader.__proto__||Object.getPrototypeOf(ContentWithHeader)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(ContentWithHeader,[{key:'header',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_header.text','');}},{key:'contentItems',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_content_items',[]);}},{key:'id',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'system.id','');}}]);return ContentWithHeader;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/Core.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Core; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Core=function(_ContentItem){_inherits(Core,_ContentItem);function Core(){_classCallCheck(this,Core);return _possibleConstructorReturn(this,(Core.__proto__||Object.getPrototypeOf(Core)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(Core,[{key:'mainProductPage',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_main_product_page[0]',{});}},{key:'translations',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_translations[0]',{});}},{key:'newsletter',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_newsletter[0]',{});}},{key:'blogSEO',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_blog_seo[0].model',{});}},{key:'termsOfUseSEO',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_terms_of_use_seo[0].model',{});}},{key:'privacyPolicySEO',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_privacy_policy_seo[0].model',{});}},{key:'contactSEO',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_contact_seo[0].model',{});}},{key:'appRegulationsSEO',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_app_regulations_seo[0].model',{});}},{key:'footerProducts',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_footer___products',[]);}},{key:'footerBlogArticleLink',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_footer___blog_article_link.value','');}},{key:'blogContactComponent',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_blog_contact_component[0]',{});}},{key:'blogNewsletterThankYouPage',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_blog_newsletter_thank_you_page[0]',{});}}]);return Core;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/CroppedAsset.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CroppedAsset; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CroppedAsset=function(_ContentItem){_inherits(CroppedAsset,_ContentItem);function CroppedAsset(){_classCallCheck(this,CroppedAsset);return _possibleConstructorReturn(this,(CroppedAsset.__proto__||Object.getPrototypeOf(CroppedAsset)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(CroppedAsset,[{key:'marginLeft',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_margin_left.value','0px');}},{key:'marginTop',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_margin_top.value','0px');}},{key:'width',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_width.value','auto');}},{key:'height',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_height.value','auto');}},{key:'videoAsBanner',get:function get(){return!!__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_video_as_banner.value[0]');}},{key:'youTubeSrc',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_iframe_src_youtube.value','');}},{key:'subtitle',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_subtitle.value','');}},{key:'title',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_title.value','');}},{key:'asset',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_asset.value[0].url','');}},{key:'id',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'system.id','');}}]);return CroppedAsset;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/DividedBlogSection.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DividedBlogSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DividedBlogSection=function(_ContentItem){_inherits(DividedBlogSection,_ContentItem);function DividedBlogSection(){_classCallCheck(this,DividedBlogSection);return _possibleConstructorReturn(this,(DividedBlogSection.__proto__||Object.getPrototypeOf(DividedBlogSection)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;},richTextResolver:function richTextResolver(item){return'<object cite="'+item.cite+'" \n                                         image="'+item.image+'"\n                                         order="'+item.order+'" \n                                         constructor="'+item.type+'"/>';}}));}_createClass(DividedBlogSection,[{key:'type',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'system.type','');}},{key:'cite',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_cite.value','');}},{key:'order',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_order.value[0].name','');}},{key:'image',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_image.value[0].url','');}}]);return DividedBlogSection;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/DownloadBar.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DownloadBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DownloadBar=function(_ContentItem){_inherits(DownloadBar,_ContentItem);function DownloadBar(){_classCallCheck(this,DownloadBar);return _possibleConstructorReturn(this,(DownloadBar.__proto__||Object.getPrototypeOf(DownloadBar)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(DownloadBar,[{key:'leftText',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_left_text.value','');}},{key:'buttonText',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_button_text.value','');}},{key:'fileLink',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_file_link[0]',[]);}},{key:'htmlModifiers',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_html_modifiers',[]);}}]);return DownloadBar;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/FAQAccordion.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Accordion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Accordion=function(_ContentItem){_inherits(Accordion,_ContentItem);function Accordion(){_classCallCheck(this,Accordion);return _possibleConstructorReturn(this,(Accordion.__proto__||Object.getPrototypeOf(Accordion)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(Accordion,[{key:'title',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_title.text','');}},{key:'accordionItems',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_accordion_items',[]);}},{key:'id',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'system.id','');}}]);return Accordion;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/FAQAccordionItem.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AccordionItem=function(_ContentItem){_inherits(AccordionItem,_ContentItem);function AccordionItem(){_classCallCheck(this,AccordionItem);return _possibleConstructorReturn(this,(AccordionItem.__proto__||Object.getPrototypeOf(AccordionItem)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(AccordionItem,[{key:'title',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_title.text','');}},{key:'text',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_text.value','');}},{key:'id',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'system.id','');}},{key:'videoLink',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_video_link.value','');}},{key:'image',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_image.value[0].url','');}}]);return AccordionItem;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/File.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return File; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var File=function(_ContentItem){_inherits(File,_ContentItem);function File(){_classCallCheck(this,File);return _possibleConstructorReturn(this,(File.__proto__||Object.getPrototypeOf(File)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(File,[{key:'fileUrl',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_file.value[0].url','');}},{key:'fileName',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_file.value[0].name','');}},{key:'fileDescription',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_file.value[0].description','');}},{key:'fileSize',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_file.value[0].size','');}},{key:'fileType',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_file.value[0].type','');}}]);return File;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/ForInvestors.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ForInvestorsItems; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ForInvestorsItems=function(_ContentItem){_inherits(ForInvestorsItems,_ContentItem);function ForInvestorsItems(){_classCallCheck(this,ForInvestorsItems);return _possibleConstructorReturn(this,(ForInvestorsItems.__proto__||Object.getPrototypeOf(ForInvestorsItems)).call(this,{opertyResolver:function opertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(ForInvestorsItems,[{key:'sectionHeader',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'header.value','');}},{key:'sectionDescription',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'description.value','');}},{key:'sectionsData',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'for_investors_sections','');}}]);return ForInvestorsItems;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/ForInvestorsLinkedItem.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ForInvestorsLinkedItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ForInvestorsLinkedItem=function(_ContentItem){_inherits(ForInvestorsLinkedItem,_ContentItem);function ForInvestorsLinkedItem(){_classCallCheck(this,ForInvestorsLinkedItem);return _possibleConstructorReturn(this,(ForInvestorsLinkedItem.__proto__||Object.getPrototypeOf(ForInvestorsLinkedItem)).call(this,{opertyResolver:function opertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(ForInvestorsLinkedItem,[{key:'type',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'file_type.value[0].codename','');}},{key:'description',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'description.value','');}},{key:'date',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'date.value','');}},{key:'url',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'linked_asset.value[0].url','');}}]);return ForInvestorsLinkedItem;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/ForInvestorsSection.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ForInvestorsSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ForInvestorsSection=function(_ContentItem){_inherits(ForInvestorsSection,_ContentItem);function ForInvestorsSection(){_classCallCheck(this,ForInvestorsSection);return _possibleConstructorReturn(this,(ForInvestorsSection.__proto__||Object.getPrototypeOf(ForInvestorsSection)).call(this,{opertyResolver:function opertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(ForInvestorsSection,[{key:'sectionName',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'name.value','');}},{key:'linkedFiles',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'linked_files','');}}]);return ForInvestorsSection;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/GlobalMetaTag.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalMetaTag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_kentico_cloud_delivery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GlobalMetaTag=function(_ContentItem){_inherits(GlobalMetaTag,_ContentItem);function GlobalMetaTag(){_classCallCheck(this,GlobalMetaTag);return _possibleConstructorReturn(this,(GlobalMetaTag.__proto__||Object.getPrototypeOf(GlobalMetaTag)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(GlobalMetaTag,[{key:'name',get:function get(){return __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this,'_name.value','');}},{key:'content',get:function get(){return __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this,'_content.value','');}}]);return GlobalMetaTag;}(__WEBPACK_IMPORTED_MODULE_1_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/GlobalMetaTags.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalMetaTags; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_kentico_cloud_delivery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GlobalMetaTags=function(_ContentItem){_inherits(GlobalMetaTags,_ContentItem);function GlobalMetaTags(){_classCallCheck(this,GlobalMetaTags);return _possibleConstructorReturn(this,(GlobalMetaTags.__proto__||Object.getPrototypeOf(GlobalMetaTags)).apply(this,arguments));}_createClass(GlobalMetaTags,[{key:'metaTags',get:function get(){return __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this,'tags',[]);}}]);return GlobalMetaTags;}(__WEBPACK_IMPORTED_MODULE_1_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/Header.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Header; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_window_or_global__ = __webpack_require__("./node_modules/window-or-global/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_window_or_global__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header=function(_ContentItem){_inherits(Header,_ContentItem);function Header(){_classCallCheck(this,Header);return _possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;},richTextResolver:function richTextResolver(item){return'<object text="'+item.text+'" \n                                         size="'+item.size+'" \n                                         color="'+item.color+'"\n                                         htmlModifiers="'+item.htmlModifiers+'"\n                                         constructor="'+item.type+'"/>';}}));}_createClass(Header,[{key:'type',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'system.type','');}},{key:'text',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_text.value','');}},{key:'size',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_size.value[0].name','');}},{key:'color',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_color.value[0].name','');}},{key:'htmlModifiers',get:function get(){var modifiers=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_html_modifiers',[]).map(function(modifier){return{property:modifier.property,value:modifier.value};});var modifiersBaseEncoded=__WEBPACK_IMPORTED_MODULE_2_window_or_global___default.a.btoa(JSON.stringify(modifiers));return modifiersBaseEncoded;}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/HeroImage.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeroImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HeroImage=function(_ContentItem){_inherits(HeroImage,_ContentItem);function HeroImage(){_classCallCheck(this,HeroImage);return _possibleConstructorReturn(this,(HeroImage.__proto__||Object.getPrototypeOf(HeroImage)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(HeroImage,[{key:'header',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_header.value','');}},{key:'description',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_description.value','');}},{key:'backgroundDesks',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_background_desks.value[0].url','');}},{key:'backgroundHand',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_background_hand.value[0].url','');}},{key:'htmlModifiers',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_html_modifiers',[]);}},{key:'floatingElements',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_floating_elements',[]);}}]);return HeroImage;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/HorizontallyNavigableContent.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HorizontallyNavigableContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HorizontallyNavigableContent=function(_ContentItem){_inherits(HorizontallyNavigableContent,_ContentItem);function HorizontallyNavigableContent(){_classCallCheck(this,HorizontallyNavigableContent);return _possibleConstructorReturn(this,(HorizontallyNavigableContent.__proto__||Object.getPrototypeOf(HorizontallyNavigableContent)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(HorizontallyNavigableContent,[{key:'contentItems',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_content_items',[]);}},{key:'navigationItem',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_navigation_item.value[0].name','');}},{key:'htmlModifiers',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_html_modifiers',[]);}}]);return HorizontallyNavigableContent;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/HtmlModifier.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HtmlModifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HtmlModifier=function(_ContentItem){_inherits(HtmlModifier,_ContentItem);function HtmlModifier(){_classCallCheck(this,HtmlModifier);return _possibleConstructorReturn(this,(HtmlModifier.__proto__||Object.getPrototypeOf(HtmlModifier)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(HtmlModifier,[{key:'property',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_property.options[0].name','');}},{key:'value',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_value.value','');}}]);return HtmlModifier;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/ImageLink.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_kentico_cloud_delivery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ImageLink=function(_ContentItem){_inherits(ImageLink,_ContentItem);function ImageLink(){_classCallCheck(this,ImageLink);return _possibleConstructorReturn(this,(ImageLink.__proto__||Object.getPrototypeOf(ImageLink)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;},richTextResolver:function richTextResolver(item){return'<a href=\''+item.url+'\' target=\''+item.blank+'\' rel=\''+item.nofollow+'\'>\n                                    <img src=\''+item.image.url+'\' alt=\''+item.image.description+'\' />\n                                  </a>';}}));}_createClass(ImageLink,[{key:'type',get:function get(){return __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this,'system.type','');}},{key:'url',get:function get(){return __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this,'_url.value','');}},{key:'nofollow',get:function get(){return __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this,'_rel_nofollow.value[0].name','');}},{key:'blank',get:function get(){return __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this,'_target_blank.value[0].name','');}},{key:'image',get:function get(){return __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this,'_image.value[0]','');}},{key:'description',get:function get(){return __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this,'_description.value','');}},{key:'id',get:function get(){return __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this,'system.id','');}}]);return ImageLink;}(__WEBPACK_IMPORTED_MODULE_1_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/ImageSlide.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageSlide; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ImageSlide=function(_ContentItem){_inherits(ImageSlide,_ContentItem);function ImageSlide(){_classCallCheck(this,ImageSlide);return _possibleConstructorReturn(this,(ImageSlide.__proto__||Object.getPrototypeOf(ImageSlide)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(ImageSlide,[{key:'header',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_header.value','');}},{key:'background',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_background.value[0].url','');}},{key:'image',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_image.value[0].url','');}},{key:'text',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_text','');}}]);return ImageSlide;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/ImageSlider.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageSlider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ImageSlider=function(_ContentItem){_inherits(ImageSlider,_ContentItem);function ImageSlider(){_classCallCheck(this,ImageSlider);return _possibleConstructorReturn(this,(ImageSlider.__proto__||Object.getPrototypeOf(ImageSlider)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(ImageSlider,[{key:'header',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_header.value','');}},{key:'imageSlides',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_image_slides',[]);}},{key:'htmlModifiers',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_html_modifiers',[]);}}]);return ImageSlider;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/ImagedSection.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImagedSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ImagedSection=function(_ContentItem){_inherits(ImagedSection,_ContentItem);function ImagedSection(){_classCallCheck(this,ImagedSection);return _possibleConstructorReturn(this,(ImagedSection.__proto__||Object.getPrototypeOf(ImagedSection)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(ImagedSection,[{key:'header',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_header','');}},{key:'image',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_image.value[0].url','');}},{key:'text',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_text','');}},{key:'htmlModifiers',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_html_modifiers',[]);}}]);return ImagedSection;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/LinkBanner.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Blog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Blog=function(_ContentItem){_inherits(Blog,_ContentItem);function Blog(){_classCallCheck(this,Blog);return _possibleConstructorReturn(this,(Blog.__proto__||Object.getPrototypeOf(Blog)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(Blog,[{key:'description',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_description.value','');}},{key:'header',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_header.value','');}},{key:'htmlModifiers',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_html_modifiers',[]);}},{key:'mobileBackgroundImage',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_mobile_background_image.value[0].url','');}},{key:'backgroundImage',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_background_image.value[0].url','');}},{key:'image',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_image.value[0].url','');}},{key:'linkText',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_link_text.value','');}},{key:'slug',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_product_slugs.taxonomyTerms[0].name','/');}}]);return Blog;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/LinkToProduct.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkToProduct; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LinkToProduct=function(_ContentItem){_inherits(LinkToProduct,_ContentItem);function LinkToProduct(){_classCallCheck(this,LinkToProduct);return _possibleConstructorReturn(this,(LinkToProduct.__proto__||Object.getPrototypeOf(LinkToProduct)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(LinkToProduct,[{key:'description',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_description.value','');}},{key:'slug',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_product_slugs.taxonomyTerms[0].name','/');}},{key:'url',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_url.value','');}}]);return LinkToProduct;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/Newsletter.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Newsletter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Newsletter=function(_ContentItem){_inherits(Newsletter,_ContentItem);function Newsletter(){_classCallCheck(this,Newsletter);return _possibleConstructorReturn(this,(Newsletter.__proto__||Object.getPrototypeOf(Newsletter)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(Newsletter,[{key:'title',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_title.value','');}},{key:'description',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_description.value','');}},{key:'buttonText',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_button_text.value','');}},{key:'label',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_label.value','');}},{key:'htmlModifiers',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_html_modifiers',[]);}}]);return Newsletter;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/NewsletterThankYouPage.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewsletterThankYouPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewsletterThankYouPage=function(_ContentItem){_inherits(NewsletterThankYouPage,_ContentItem);function NewsletterThankYouPage(){_classCallCheck(this,NewsletterThankYouPage);return _possibleConstructorReturn(this,(NewsletterThankYouPage.__proto__||Object.getPrototypeOf(NewsletterThankYouPage)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(NewsletterThankYouPage,[{key:'closeButtonText',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_close_button_text.value','');}},{key:'backButtonText',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_back_button_text.value','');}},{key:'successTitle',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_success_title.value','');}},{key:'successLine1',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_success_line1.value','');}},{key:'successLine2',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_success_line2.value','');}},{key:'warningTitle',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_warning_title.value','');}},{key:'warningLine1',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_warning_line1.value','');}},{key:'warningLine2',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_warning_line2.value','');}},{key:'errorTitle',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_error_title.value','');}},{key:'errorLine1',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_error_line1.value','');}},{key:'errorLine2',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_error_line2.value','');}},{key:'confirmedTitle',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_confirmed_title.value','');}},{key:'confirmedLine1',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_confirmed_line1.value','');}},{key:'confirmedLine2',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_confirmed_line2.value','');}}]);return NewsletterThankYouPage;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/Product.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Product; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__ = __webpack_require__("./src/common/consts/kentico.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Product=function(_ContentItem){_inherits(Product,_ContentItem);function Product(){_classCallCheck(this,Product);return _possibleConstructorReturn(this,(Product.__proto__||Object.getPrototypeOf(Product)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(Product,[{key:'name',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_name.value','');}},{key:'slug',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_product_slugs.taxonomyTerms[0].name','/');}},{key:'structure',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_structure',[]);}},{key:'shareLinks',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_share_links',[]);}},{key:'googlePlayShareLink',get:function get(){var link=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_share_links',[]).find(function(shareLink){return shareLink.marketCodeName===__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["a" /* KENTICO_CONSTS */].MARKET_GOOGLE_PLAY_CODENAME;});return link?link.link:'';}},{key:'appStoreShareLink',get:function get(){var link=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_share_links',[]).find(function(shareLink){return shareLink.marketCodeName===__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["a" /* KENTICO_CONSTS */].MARKET_APP_STORE_CODENAME;});return link?link.link:'';}},{key:'SEO',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_product___seo[0].model',[]);}}]);return Product;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/ProductSlide.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductSlide; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductSlide=function(_ContentItem){_inherits(ProductSlide,_ContentItem);function ProductSlide(){_classCallCheck(this,ProductSlide);return _possibleConstructorReturn(this,(ProductSlide.__proto__||Object.getPrototypeOf(ProductSlide)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(ProductSlide,[{key:'content',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_content',{});}},{key:'bottomImage',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_bottom_image.value[0].url','');}},{key:'slug',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_product_slugs.taxonomyTerms[0].name','/');}}]);return ProductSlide;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/ProductSlider.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductSlider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductSlider=function(_ContentItem){_inherits(ProductSlider,_ContentItem);function ProductSlider(){_classCallCheck(this,ProductSlider);return _possibleConstructorReturn(this,(ProductSlider.__proto__||Object.getPrototypeOf(ProductSlider)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(ProductSlider,[{key:'header',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_header.value','');}},{key:'productSlides',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_product_slides',[]);}},{key:'htmlModifiers',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_html_modifiers',[]);}}]);return ProductSlider;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/SEO.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SEO; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SEO=function(_ContentItem){_inherits(SEO,_ContentItem);function SEO(){_classCallCheck(this,SEO);return _possibleConstructorReturn(this,(SEO.__proto__||Object.getPrototypeOf(SEO)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(SEO,[{key:'title',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_meta_tags__meta_title.value');}},{key:'description',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_meta_tags__meta_description.value');}},{key:'ogImage',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_meta_tags__meta_image.value[0].url');}},{key:'ogType',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_meta_tags__meta_type.value[0].name');}},{key:'noIndex',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_meta_tags__meta_noindex.value');}},{key:'metaKeywords',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_meta_tags__meta_keywords.value','');}},{key:'model',get:function get(){return{title:this.title,description:this.description,ogImage:this.ogImage,ogType:this.ogType,noIndex:this.noIndex,metaKeywords:this.metaKeywords};}}]);return SEO;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/ShareLink.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShareLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShareLink=function(_ContentItem){_inherits(ShareLink,_ContentItem);function ShareLink(){_classCallCheck(this,ShareLink);return _possibleConstructorReturn(this,(ShareLink.__proto__||Object.getPrototypeOf(ShareLink)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(ShareLink,[{key:'marketName',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_market.value[0].name','');}},{key:'marketCodeName',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_market.value[0].codename','');}},{key:'link',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_link.value','');}},{key:'id',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'system.id','');}}]);return ShareLink;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/SimpleAccordion.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SimpleAccordion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SimpleAccordion=function(_ContentItem){_inherits(SimpleAccordion,_ContentItem);function SimpleAccordion(){_classCallCheck(this,SimpleAccordion);return _possibleConstructorReturn(this,(SimpleAccordion.__proto__||Object.getPrototypeOf(SimpleAccordion)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(SimpleAccordion,[{key:'header',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_header.value','');}},{key:'simpleAccordionItems',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_simple_accordion_items',[]);}},{key:'htmlModifiers',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_html_modifiers',[]);}}]);return SimpleAccordion;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/SimpleAccordionItem.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SimpleAccordionItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SimpleAccordionItem=function(_ContentItem){_inherits(SimpleAccordionItem,_ContentItem);function SimpleAccordionItem(){_classCallCheck(this,SimpleAccordionItem);return _possibleConstructorReturn(this,(SimpleAccordionItem.__proto__||Object.getPrototypeOf(SimpleAccordionItem)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(SimpleAccordionItem,[{key:'title',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_title.value','');}},{key:'text',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_text.value','');}}]);return SimpleAccordionItem;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/ThreeColumnGrid.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThreeColumnGrid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ThreeColumnGrid=function(_ContentItem){_inherits(ThreeColumnGrid,_ContentItem);function ThreeColumnGrid(){_classCallCheck(this,ThreeColumnGrid);return _possibleConstructorReturn(this,(ThreeColumnGrid.__proto__||Object.getPrototypeOf(ThreeColumnGrid)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(ThreeColumnGrid,[{key:'columns',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_columns',[]);}},{key:'htmlModifiers',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_html_modifiers',[]);}}]);return ThreeColumnGrid;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/TitleAndSubtitle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FAQ; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FAQ=function(_ContentItem){_inherits(FAQ,_ContentItem);function FAQ(){_classCallCheck(this,FAQ);return _possibleConstructorReturn(this,(FAQ.__proto__||Object.getPrototypeOf(FAQ)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(FAQ,[{key:'title',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_title.text','');}},{key:'subtitle',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_subtitle.text','');}}]);return FAQ;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/Translations.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Translations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Translations=function(_ContentItem){_inherits(Translations,_ContentItem);function Translations(){_classCallCheck(this,Translations);return _possibleConstructorReturn(this,(Translations.__proto__||Object.getPrototypeOf(Translations)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(Translations,[{key:'blogCategoryTranslations',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_blog_category_translations',[]);}},{key:'NAVIGATION_GET_THE_APP',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_navigation_get_the_app.value','');}},{key:'NAVIGATION_SIGN_IN',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_navigation_sign_in.value','');}},{key:'NAVIGATION_ZONIFERO_PRODUCTS',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_navigation_zonifero_products.value','');}},{key:'NAVIGATION_PROPTECH',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_navigation_proptech.value','');}},{key:'NAVIGATION_STORE',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_navigation_store.value','');}},{key:'NAVIGATION_BLOG',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_navigation_blog.value','');}},{key:'NAVIGATION_FAQ',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_navigation_faq.value','');}},{key:'NAVIGATION_WORK',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_navigation_work.value','');}},{key:'BLOG_ABOUT_THE_AUTHOR',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_blog_about_the_author.value','');}},{key:'BLOG_BLOG_AUTHORS',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_blog_blog_authors.value','');}},{key:'BLOG_OTHER_ARTICLES',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_blog_other_articles.value','');}},{key:'BLOG_MORE_ARTICLES',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_blog_more_articles.value','');}},{key:'BLOG_BY',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_blog_by.value','');}},{key:'BLOG_SHARE',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_blog_share.value','');}},{key:'BLOG_DEFAULT_FILTER',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_blog_default_filter.value','');}},{key:'BLOG_HEADER',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_blog_header.value','');}},{key:'FOOTER_ADDRESS_UPPER_LINE',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_footer_address_upper_line.value','');}},{key:'FOOTER_ADDRESS_BOTTOM_LINE',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_footer_address_bottom_line.value','');}},{key:'FOOTER_SOCIAL_MEDIA',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_footer_social_media.value','');}},{key:'FOOTER_PRODUCTS',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_footer_products.value','');}},{key:'FOOTER_ABOUT',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_footer_about.value','');}},{key:'FOOTER_COMPANY',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_footer_company.value','');}},{key:'FORM_CHECKBOX_DATA_PROCESSING_LABEL',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_form_checkbox_data_processing_label.value','');}},{key:'FORM_CHECKBOX_DATA_SENDING_LABEL',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_form_checkbox_data_sending_label.value','');}},{key:'FORM_BUTTON_SUCCESS_MESSAGE',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_form_button_success_message.value','');}},{key:'FORM_BUTTON_ERROR_MESSAGE',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_form_button_error_message.value','');}},{key:'FORM_BUTTON_LOADING_MESSAGE',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_form_button_loading_message.value','');}},{key:'FORM_BUTTON_DEFAULT_MESSAGE',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_form_button_default_message.value','');}},{key:'COOKIES_AGREEMENT',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_cookies_agreement.value','');}},{key:'PRIVACY_POLICY',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_privacy_policy.value','');}},{key:'REGULATIONS',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_regulations.value','');}},{key:'APPLICATION_REGULATIONS',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_application_regulations.value','');}},{key:'FOOTER_PRIVACY_POLICY_LINK',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_footer_privacy_policy_link.value','');}},{key:'FOOTER_REGULATIONS_LINK',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_footer_regulations_link.value','');}},{key:'FOOTER_APPLICATION_REGULATIONS_LINK',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_footer_application_regulations_link.value','');}},{key:'PAGE_NOT_FOUND_TEXT',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_page_not_found_text.value','');}},{key:'LANGUAGE_CHANGE_WARNING',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_language_change_warning.value','');}},{key:'LANGUAGE_CHANGE_WARNING_ACCEPT_BUTTON',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_language_change_warning_accept_button.value','');}},{key:'LANGUAGE_CHANGE_WARNING_CANCEL_BUTTON',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_language_change_warning_cancel_button.value','');}}]);return Translations;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/TwoColumnGrid.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TwoColumnGrid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TwoColumnGrid=function(_ContentItem){_inherits(TwoColumnGrid,_ContentItem);function TwoColumnGrid(){_classCallCheck(this,TwoColumnGrid);return _possibleConstructorReturn(this,(TwoColumnGrid.__proto__||Object.getPrototypeOf(TwoColumnGrid)).call(this,{propertyResolver:function propertyResolver(fieldName){return'_'+fieldName;}}));}_createClass(TwoColumnGrid,[{key:'columns',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_columns',[]);}},{key:'htmlModifiers',get:function get(){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this,'_html_modifiers',[]);}}]);return TwoColumnGrid;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["ContentItem"]);

/***/ }),

/***/ "./src/models/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Column_model__ = __webpack_require__("./src/models/Column.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_0__Column_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header_model__ = __webpack_require__("./src/models/Header.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_1__Header_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Product_model__ = __webpack_require__("./src/models/Product.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_2__Product_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HeroImage_model__ = __webpack_require__("./src/models/HeroImage.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_3__HeroImage_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThreeColumnGrid_model__ = __webpack_require__("./src/models/ThreeColumnGrid.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_4__ThreeColumnGrid_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Accordion_model__ = __webpack_require__("./src/models/Accordion.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__Accordion_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccordionItem_model__ = __webpack_require__("./src/models/AccordionItem.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__AccordionItem_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Banner_model__ = __webpack_require__("./src/models/Banner.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__Banner_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SimpleAccordion_model__ = __webpack_require__("./src/models/SimpleAccordion.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_8__SimpleAccordion_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SimpleAccordionItem_model__ = __webpack_require__("./src/models/SimpleAccordionItem.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_9__SimpleAccordionItem_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CardSlider_model__ = __webpack_require__("./src/models/CardSlider.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_10__CardSlider_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CardSlide_model__ = __webpack_require__("./src/models/CardSlide.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_11__CardSlide_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DownloadBar_model__ = __webpack_require__("./src/models/DownloadBar.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_12__DownloadBar_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__File_model__ = __webpack_require__("./src/models/File.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_13__File_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TwoColumnGrid_model__ = __webpack_require__("./src/models/TwoColumnGrid.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_14__TwoColumnGrid_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ImagedSection_model__ = __webpack_require__("./src/models/ImagedSection.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_15__ImagedSection_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ContactForm_model__ = __webpack_require__("./src/models/ContactForm.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_16__ContactForm_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ContactFormSupport_model__ = __webpack_require__("./src/models/ContactFormSupport.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_17__ContactFormSupport_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ImageSlide_model__ = __webpack_require__("./src/models/ImageSlide.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_18__ImageSlide_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ImageSlider_model__ = __webpack_require__("./src/models/ImageSlider.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_19__ImageSlider_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CallUs_model__ = __webpack_require__("./src/models/CallUs.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_20__CallUs_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ContactPerson_model__ = __webpack_require__("./src/models/ContactPerson.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_21__ContactPerson_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ContactLink_model__ = __webpack_require__("./src/models/ContactLink.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_22__ContactLink_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__HorizontallyNavigableContent_model__ = __webpack_require__("./src/models/HorizontallyNavigableContent.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_23__HorizontallyNavigableContent_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ContentWithHeader_model__ = __webpack_require__("./src/models/ContentWithHeader.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_24__ContentWithHeader_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__SEO_model__ = __webpack_require__("./src/models/SEO.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_25__SEO_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ShareLink_model__ = __webpack_require__("./src/models/ShareLink.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_26__ShareLink_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__HtmlModifier_model__ = __webpack_require__("./src/models/HtmlModifier.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_27__HtmlModifier_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Translations_model__ = __webpack_require__("./src/models/Translations.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_28__Translations_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Core_model__ = __webpack_require__("./src/models/Core.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_29__Core_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__BlogArticle_model__ = __webpack_require__("./src/models/BlogArticle.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_30__BlogArticle_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__BlogAuthor_model__ = __webpack_require__("./src/models/BlogAuthor.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_31__BlogAuthor_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Newsletter_model__ = __webpack_require__("./src/models/Newsletter.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_32__Newsletter_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__LinkBanner_model__ = __webpack_require__("./src/models/LinkBanner.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_33__LinkBanner_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__DividedBlogSection_model__ = __webpack_require__("./src/models/DividedBlogSection.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_34__DividedBlogSection_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__BlogImageSlider_model__ = __webpack_require__("./src/models/BlogImageSlider.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_35__BlogImageSlider_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__BlogImageSlide_model__ = __webpack_require__("./src/models/BlogImageSlide.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_36__BlogImageSlide_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__LinkToProduct_model__ = __webpack_require__("./src/models/LinkToProduct.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_37__LinkToProduct_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ProductSlide_model__ = __webpack_require__("./src/models/ProductSlide.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_38__ProductSlide_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__ProductSlider_model__ = __webpack_require__("./src/models/ProductSlider.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_39__ProductSlider_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__CroppedAsset_model__ = __webpack_require__("./src/models/CroppedAsset.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_40__CroppedAsset_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Calculator_model__ = __webpack_require__("./src/models/Calculator.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_41__Calculator_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__CalculatorValue_model__ = __webpack_require__("./src/models/CalculatorValue.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_42__CalculatorValue_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__BlogCategoryTranslation_model__ = __webpack_require__("./src/models/BlogCategoryTranslation.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_43__BlogCategoryTranslation_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__ArticleSlide_model__ = __webpack_require__("./src/models/ArticleSlide.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_44__ArticleSlide_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__ArticleSlider_model__ = __webpack_require__("./src/models/ArticleSlider.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_45__ArticleSlider_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__ImageLink_model__ = __webpack_require__("./src/models/ImageLink.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_46__ImageLink_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__TitleAndSubtitle__ = __webpack_require__("./src/models/TitleAndSubtitle.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_47__TitleAndSubtitle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__FAQAccordion_model__ = __webpack_require__("./src/models/FAQAccordion.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_48__FAQAccordion_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__FAQAccordionItem_model__ = __webpack_require__("./src/models/FAQAccordionItem.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_49__FAQAccordionItem_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__ForInvestors_model__ = __webpack_require__("./src/models/ForInvestors.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_50__ForInvestors_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__ForInvestorsSection_model__ = __webpack_require__("./src/models/ForInvestorsSection.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_51__ForInvestorsSection_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__ForInvestorsLinkedItem_model__ = __webpack_require__("./src/models/ForInvestorsLinkedItem.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_52__ForInvestorsLinkedItem_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__GlobalMetaTags_model__ = __webpack_require__("./src/models/GlobalMetaTags.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_53__GlobalMetaTags_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__GlobalMetaTag_model__ = __webpack_require__("./src/models/GlobalMetaTag.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_54__GlobalMetaTag_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__NewsletterThankYouPage_model__ = __webpack_require__("./src/models/NewsletterThankYouPage.model.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_55__NewsletterThankYouPage_model__["a"]; });


/***/ }),

/***/ "./src/pages/Blog/BlogArticleBox/Icon.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var Icon=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'Icon',componentId:'sc-1ojid9s-0'})(['background-image:',';width:100%;margin:0 auto;background-size:cover;background-position:center center;padding-bottom:66%;'],function(_ref){var url=_ref.url;return'url('+url+')';});/* harmony default export */ __webpack_exports__["a"] = (Icon);

/***/ }),

/***/ "./src/pages/Blog/BlogArticleBox/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_consts_anchor__ = __webpack_require__("./src/common/consts/anchor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_consts_anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_common_consts_anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blocks_StyledLink__ = __webpack_require__("./src/blocks/StyledLink/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_elements_Header4__ = __webpack_require__("./src/elements/Header4.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icon__ = __webpack_require__("./src/pages/Blog/BlogArticleBox/Icon.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_dec2,_class,_desc,_value,_class2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}var Wrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div.withConfig({displayName:'BlogArticleBox__Wrapper',componentId:'sc-122f0lq-0'})(['margin:',' 0;opacity:',';transition-duration:0.3s;'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.s'),function(_ref){var fadeInArticle=_ref.fadeInArticle;return fadeInArticle?1:0;});var Title=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_9_elements_Header4__["a" /* default */]).withConfig({displayName:'BlogArticleBox__Title',componentId:'sc-122f0lq-1'})(['margin-top:',';'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.s'));var ImageMemory=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].img.withConfig({displayName:'BlogArticleBox__ImageMemory',componentId:'sc-122f0lq-2'})(['display:none;']);var BlogArticleBox=(_dec=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["inject"])('windowStore','appStore'),_dec2=Object(__WEBPACK_IMPORTED_MODULE_10_lodash_decorators__["Bind"])(),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["observer"])(_class=(_class2=function(_Component){_inherits(BlogArticleBox,_Component);function BlogArticleBox(props){_classCallCheck(this,BlogArticleBox);var _this=_possibleConstructorReturn(this,(BlogArticleBox.__proto__||Object.getPrototypeOf(BlogArticleBox)).call(this,props));_this.state={imageIsLoaded:false};return _this;}_createClass(BlogArticleBox,[{key:'setImageIsLoaded',value:function setImageIsLoaded(){this.setState({imageIsLoaded:true});}},{key:'render',value:function render(){var _props=this.props,_props$article=_props.article,listingImage=_props$article.listingImage,title=_props$article.title,slug=_props$article.slug,codename=_props$article.mainCategory.codename,windowStore=_props.windowStore,currentLanguage=_props.appStore.currentLanguage;var imageIsLoaded=this.state.imageIsLoaded;var articleCategory=Object(__WEBPACK_IMPORTED_MODULE_8_common_methods_string__["i" /* underscoresToDashes */])(codename);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,{fadeInArticle:imageIsLoaded},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_blocks_StyledLink__["b" /* default */],{to:{pathname:__WEBPACK_IMPORTED_MODULE_6_common_consts_anchor___default.a.BLOG[currentLanguage]+'/'+articleCategory+'/'+slug,state:{slug:slug}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImageMemory,{src:windowStore.adjustImageSize(listingImage),onLoad:this.setImageIsLoaded}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Icon__["a" /* default */],{url:windowStore.adjustImageSize(listingImage)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,null,title)));}}]);return BlogArticleBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),(_applyDecoratedDescriptor(_class2.prototype,'setImageIsLoaded',[_dec2],Object.getOwnPropertyDescriptor(_class2.prototype,'setImageIsLoaded'),_class2.prototype)),_class2))||_class)||_class);BlogArticleBox.propTypes={article:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_5_models__["f" /* BlogArticle */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (BlogArticleBox);

/***/ }),

/***/ "./src/pages/Blog/LatestArticle/FullWidthImage.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_responsive__ = __webpack_require__("./src/common/responsive.js");
var _templateObject=_taggedTemplateLiteral(['\n    height: 600px;\n  '],['\n    height: 600px;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var FullWidthImage=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'FullWidthImage',componentId:'sc-100i8q8-0'})(['width:100%;background-image:url(',');background-size:cover;background-position:center center;position:absolute;right:0;',';'],function(_ref){var url=_ref.url;return url;},__WEBPACK_IMPORTED_MODULE_1_common_responsive__["c" /* media */].desktop(_templateObject));/* harmony default export */ __webpack_exports__["a"] = (FullWidthImage);

/***/ }),

/***/ "./src/pages/Blog/LatestArticle/MobileImage.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_responsive__ = __webpack_require__("./src/common/responsive.js");
var _templateObject=_taggedTemplateLiteral(['\n    height:350px;\n  '],['\n    height:350px;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var MobileImage=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].img.withConfig({displayName:'MobileImage',componentId:'sc-9rp93e-0'})(['object-fit:cover;height:200px;width:100%;',';'],__WEBPACK_IMPORTED_MODULE_1_common_responsive__["c" /* media */].tablet(_templateObject));/* harmony default export */ __webpack_exports__["a"] = (MobileImage);

/***/ }),

/***/ "./src/pages/Blog/LatestArticle/Wrapper.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _templateObject=_taggedTemplateLiteral(['\n    width: 500px;\n    height: 700px;\n    position: absolute;\n    top:-200px;\n    right: 100px;\n    padding: ',';\n    z-index:1;\n  '],['\n    width: 500px;\n    height: 700px;\n    position: absolute;\n    top:-200px;\n    right: 100px;\n    padding: ',';\n    z-index:1;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'Wrapper',componentId:'sc-48dg4r-0'})(['padding:',' 0;background-color:',';',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].brand('white'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.l')));/* harmony default export */ __webpack_exports__["a"] = (Wrapper);

/***/ }),

/***/ "./src/pages/Blog/LatestArticle/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_blocks_FiltersList__ = __webpack_require__("./src/blocks/FiltersList/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_consts_anchor__ = __webpack_require__("./src/common/consts/anchor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_consts_anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_common_consts_anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_elements_Paragraph__ = __webpack_require__("./src/elements/Paragraph.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_common_methods_blogMethods__ = __webpack_require__("./src/common/methods/blogMethods.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_elements_Header3__ = __webpack_require__("./src/elements/Header3.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_reveal_Fade__ = __webpack_require__("./node_modules/react-reveal/Fade.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_reveal_Fade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_reveal_Fade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_animations_Animations__ = __webpack_require__("./src/animations/Animations.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_common_consts_blog__ = __webpack_require__("./src/common/consts/blog.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__FullWidthImage__ = __webpack_require__("./src/pages/Blog/LatestArticle/FullWidthImage.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__MobileImage__ = __webpack_require__("./src/pages/Blog/LatestArticle/MobileImage.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Wrapper__ = __webpack_require__("./src/pages/Blog/LatestArticle/Wrapper.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_blocks_StyledLink__ = __webpack_require__("./src/blocks/StyledLink/index.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2;var _templateObject=_taggedTemplateLiteral(['\n    height: 500px;\n  '],['\n    height: 500px;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    padding-left: initial;\n    margin-top: ',';\n  '],['\n    padding-left: initial;\n    margin-top: ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    padding-left: initial;\n  '],['\n    padding-left: initial;\n  ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var LatestArticleWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'LatestArticle__LatestArticleWrapper',componentId:'sc-41co18-0'})(['margin-bottom:',';position:relative;'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.l'));var RelativeContainer=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_blocks_Container_Container__["a" /* default */]).withConfig({displayName:'LatestArticle__RelativeContainer',componentId:'sc-41co18-1'})(['position:relative;height:100%;']);var RelativeImageBox=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'LatestArticle__RelativeImageBox',componentId:'sc-41co18-2'})(['position:relative;overflow:hidden;',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject));var StyledHeader3=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_12_elements_Header3__["a" /* default */]).withConfig({displayName:'LatestArticle__StyledHeader3',componentId:'sc-41co18-3'})(['margin-top:',';padding:0 ',';',';'],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject2,__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.xxl')));var StyledParagraph=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_9_elements_Paragraph__["a" /* default */]).withConfig({displayName:'LatestArticle__StyledParagraph',componentId:'sc-41co18-4'})(['padding:0 ',';',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject3));var FiltersListWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'LatestArticle__FiltersListWrapper',componentId:'sc-41co18-5'})(['padding:0 ',';',''],__WEBPACK_IMPORTED_MODULE_1_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_1_designsystem__["c" /* media */].desktop(_templateObject3));var LatestArticleWithFilter=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'LatestArticle__LatestArticleWithFilter',componentId:'sc-41co18-6'})(['']);var LatestArticle=(_dec=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["inject"])('coreStore','blogStore','windowStore','appStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"])(_class=(_class2=function(_Component){_inherits(LatestArticle,_Component);function LatestArticle(props){_classCallCheck(this,LatestArticle);var _this=_possibleConstructorReturn(this,(LatestArticle.__proto__||Object.getPrototypeOf(LatestArticle)).call(this,props));_this.fullWidthImageRef=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createRef();return _this;}_createClass(LatestArticle,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var windowStore=this.props.windowStore;this.disposeOnScroll=windowStore.reactToScroll(this.onScroll,{fireImmediately:true});setTimeout(function(){_this2.onScroll();},0);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.disposeOnScroll();}},{key:'onScroll',value:function onScroll(){var isOnMobile=this.props.windowStore.isOnMobile;if(!isOnMobile&&this.fullWidthImageRef.current){Object(__WEBPACK_IMPORTED_MODULE_14_animations_Animations__["f" /* parallaxImage */])(this.fullWidthImageRef.current,200,-150,6);}}},{key:'render',value:function render(){var _props=this.props,backgroundImage=_props.backgroundImage,_props$article=_props.article,title=_props$article.title,content=_props$article.content,slug=_props$article.slug,articleAuthor=_props$article.articleAuthor,codename=_props$article.mainCategory.codename,onSelect=_props.onSelect,coreStore=_props.coreStore,blogStore=_props.blogStore,_props$windowStore=_props.windowStore,isOnTablet=_props$windowStore.isOnTablet,isOnMobile=_props$windowStore.isOnMobile,currentLanguage=_props.appStore.currentLanguage;var articleCategory=Object(__WEBPACK_IMPORTED_MODULE_8_common_methods_string__["i" /* underscoresToDashes */])(codename);return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(LatestArticleWrapper,null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(RelativeContainer,null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Wrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_reveal_Fade___default.a,{bottom:true,distance:''+__WEBPACK_IMPORTED_MODULE_14_animations_Animations__["a" /* FADE_VALUES */].BOX.LIGHT},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(LatestArticleWithFilter,null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(FiltersListWrapper,null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_blocks_FiltersList__["a" /* default */],{categories:blogStore.categoriesToRender,onSelect:onSelect,activeFilter:blogStore.blogState.activeCategory})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_blocks_StyledLink__["b" /* default */],{to:__WEBPACK_IMPORTED_MODULE_7_common_consts_anchor___default.a.BLOG[currentLanguage]+'/'+articleCategory+'/'+slug},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(StyledHeader3,null,title),isOnTablet&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__MobileImage__["a" /* default */],{src:backgroundImage}),blogStore.isLoaded&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(StyledParagraph,{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_10_common_methods_blogMethods__["b" /* limitArticleChars */])(content.value,__WEBPACK_IMPORTED_MODULE_16_common_consts_blog__["a" /* BLOG_SETTINGS */].ARTICLE_CHARS_LIMIT)}}),articleAuthor&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(StyledParagraph,null,coreStore.translations.BLOG_BY+' ',articleAuthor.name)))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(RelativeImageBox,null,!isOnMobile&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__FullWidthImage__["a" /* default */],{url:backgroundImage,innerRef:this.fullWidthImageRef})));}}]);return LatestArticle;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]),(_applyDecoratedDescriptor(_class2.prototype,'onScroll',[__WEBPACK_IMPORTED_MODULE_15_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'onScroll'),_class2.prototype)),_class2))||_class)||_class);LatestArticle.propTypes={article:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_11_models__["f" /* BlogArticle */]).isRequired,onSelect:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (LatestArticle);

/***/ }),

/***/ "./src/pages/Blog/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Blog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_decorators_bind__ = __webpack_require__("./node_modules/lodash-decorators/bind.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_decorators_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_decorators_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_window_or_global__ = __webpack_require__("./node_modules/window-or-global/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_visibility_sensor__ = __webpack_require__("./node_modules/react-visibility-sensor/visibility-sensor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_visibility_sensor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_visibility_sensor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_reveal_Fade__ = __webpack_require__("./node_modules/react-reveal/Fade.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_reveal_Fade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_reveal_Fade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_animations_Animations__ = __webpack_require__("./src/animations/Animations.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_common_responsive__ = __webpack_require__("./src/common/responsive.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_common_consts_anchor__ = __webpack_require__("./src/common/consts/anchor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_common_consts_anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_common_consts_anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_blocks_Navigation__ = __webpack_require__("./src/blocks/Navigation/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_blocks_SplashScreen__ = __webpack_require__("./src/blocks/SplashScreen/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_blocks_InjectMetaTags__ = __webpack_require__("./src/blocks/InjectMetaTags/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_blocks_NavigationAwarePageContent__ = __webpack_require__("./src/blocks/NavigationAwarePageContent/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_elements_Header1__ = __webpack_require__("./src/elements/Header1.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_kentico_blocks_Newsletter__ = __webpack_require__("./src/kentico-blocks/Newsletter/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_pages_PageNotFound__ = __webpack_require__("./src/pages/PageNotFound/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__BlogArticleBox__ = __webpack_require__("./src/pages/Blog/BlogArticleBox/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__LatestArticle__ = __webpack_require__("./src/pages/Blog/LatestArticle/index.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_dec2,_class,_desc,_value,_class2;var _templateObject=_taggedTemplateLiteral(['\n    margin: 200px auto ',';\n  '],['\n    margin: 200px auto ',';\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    font-size: ',';\n  '],['\n    font-size: ',';\n  ']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var StyledContainer=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_14_blocks_Container_Container__["a" /* default */]).withConfig({displayName:'Blog__StyledContainer',componentId:'ao0d1r-0'})(['margin:',' auto 0;',';'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.xl'),__WEBPACK_IMPORTED_MODULE_11_common_responsive__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.xl')));var StyledHeader=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_19_elements_Header1__["a" /* default */]).withConfig({displayName:'Blog__StyledHeader',componentId:'ao0d1r-1'})(['margin-bottom:0;margin-left:',';font-size:',';',';'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].fs('xl'),__WEBPACK_IMPORTED_MODULE_11_common_responsive__["c" /* media */].tablet(_templateObject2,__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].fs('xxl')));var Blog=(_dec=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["inject"])('coreStore','blogStore','windowStore','appStore'),_dec2=__WEBPACK_IMPORTED_MODULE_5_lodash_decorators_bind___default()(),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["observer"])(_class=(_class2=function(_Component){_inherits(Blog,_Component);function Blog(props){_classCallCheck(this,Blog);var _this=_possibleConstructorReturn(this,(Blog.__proto__||Object.getPrototypeOf(Blog)).call(this,props));_this.articlesListRef=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();_this.visibilitySensorSettings={partialVisibility:'bottom',offset:{bottom:300}};_this.isInitialCategorySet=false;_this.state={articleAuthor:null};return _this;}_createClass(Blog,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var blogStore,_props,history,location,category,categoryCodename,articleAuthor;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:blogStore=this.props.blogStore;__WEBPACK_IMPORTED_MODULE_6_window_or_global___default.a.scrollTo(0,0);_context.next=4;return blogStore.initialContentFetch();case 4:_props=this.props,history=_props.history,location=_props.location,category=_props.match.params.category;categoryCodename=category?Object(__WEBPACK_IMPORTED_MODULE_13_common_methods_string__["c" /* dashesToUnderscores */])(category):'';if(!location.state){_context.next=11;break;}if(!(location.state.author&&history.action==='PUSH')){_context.next=11;break;}this.setState({articleAuthor:location.state.author});blogStore.setBlogFilter(categoryCodename,true);return _context.abrupt('return');case 11:articleAuthor=blogStore.blogAuthors.find(function(author){return author.value===categoryCodename;});this.setState({articleAuthor:articleAuthor});case 13:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState,snapshot){var _props2=this.props,blogStore=_props2.blogStore,category=_props2.match.params.category;var categoryCodename=category?Object(__WEBPACK_IMPORTED_MODULE_13_common_methods_string__["c" /* dashesToUnderscores */])(category):'';if(!this.isInitialCategorySet&&blogStore.categoriesToRender.length>1&&blogStore.blogAuthors.length>1){var articleAuthor=blogStore.blogAuthors.find(function(author){return author.value===categoryCodename;});this.setState({articleAuthor:articleAuthor});blogStore.setBlogFilter(categoryCodename,!!articleAuthor);this.isInitialCategorySet=true;}}},{key:'onCategoryChange',value:function onCategoryChange(activeCategory){var _props3=this.props,blogStore=_props3.blogStore,isOnTablet=_props3.windowStore.isOnTablet,currentLanguage=_props3.appStore.currentLanguage,history=_props3.history;var articleAuthor=this.state.articleAuthor;blogStore.setBlogFilter(activeCategory,!!articleAuthor);history.push(__WEBPACK_IMPORTED_MODULE_12_common_consts_anchor___default.a.BLOG[currentLanguage]+'/'+Object(__WEBPACK_IMPORTED_MODULE_13_common_methods_string__["i" /* underscoresToDashes */])(activeCategory));var offset=isOnTablet?0:150;if(this.articlesListRef&&this.articlesListRef.current){Object(__WEBPACK_IMPORTED_MODULE_10_animations_Animations__["j" /* scrollTo */])(this.articlesListRef.current.node.offsetTop-offset);}}},{key:'render',value:function render(){var _props4=this.props,blogStore=_props4.blogStore,_props4$coreStore=_props4.coreStore,isLoaded=_props4$coreStore.isLoaded,translations=_props4$coreStore.translations,_props4$coreStore$con=_props4$coreStore.content,newsletter=_props4$coreStore$con.newsletter,blogSEO=_props4$coreStore$con.blogSEO,windowStore=_props4$coreStore.windowStore;var articleAuthor=this.state.articleAuthor;var allArticlesLoaded=blogStore.blogState.loadedArticlesCount>=blogStore.articlesDetails.length;var CoreStoreLoaded=isLoaded;if(!blogStore.isLoaded||!CoreStoreLoaded){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_blocks_SplashScreen__["a" /* default */],null);}if(!blogStore.loadArticles){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_pages_PageNotFound__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_blocks_InjectMetaTags__["a" /* default */],blogSEO),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_blocks_Navigation__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_blocks_NavigationAwarePageContent__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_reveal_Fade___default.a,{left:true,distance:''+__WEBPACK_IMPORTED_MODULE_10_animations_Animations__["a" /* FADE_VALUES */].BOX.LIGHT},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledHeader,null,articleAuthor?articleAuthor.name:translations.BLOG_HEADER))),blogStore.isLoaded&&blogStore.latestArticle&&!articleAuthor&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__LatestArticle__["a" /* default */],{backgroundImage:windowStore.adjustImageSize(blogStore.latestArticle.fullWidthListingImage),article:blogStore.latestArticle,onSelect:this.onCategoryChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_blocks_Container_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_visibility_sensor___default.a,Object.assign({},this.visibilitySensorSettings,{ref:this.articlesListRef,active:!allArticlesLoaded,onChange:function onChange(isBottom){return blogStore.setArticlesLimitInListingView(isBottom);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_hedron__["Row"],{divisions:11},blogStore.loadArticles.map(function(article,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_hedron__["Column"],{lg:3,lgShift:index%3?1:0,key:article.system.id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_reveal_Fade___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__BlogArticleBox__["a" /* default */],{article:article})));}))),CoreStoreLoaded&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_reveal_Fade___default.a,{bottom:true,distance:''+__WEBPACK_IMPORTED_MODULE_10_animations_Animations__["a" /* FADE_VALUES */].BOX.LIGHT,delay:__WEBPACK_IMPORTED_MODULE_10_animations_Animations__["a" /* FADE_VALUES */].DELAY.SMALL},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_kentico_blocks_Newsletter__["a" /* default */],{margin:!windowStore.isOnTablet,content:newsletter})))));}}]);return Blog;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),(_applyDecoratedDescriptor(_class2.prototype,'onCategoryChange',[_dec2],Object.getOwnPropertyDescriptor(_class2.prototype,'onCategoryChange'),_class2.prototype)),_class2))||_class)||_class);

/***/ }),

/***/ "./src/pages/BlogArticle/ArticleCategory.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_elements_Header4__ = __webpack_require__("./src/elements/Header4.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_images_linkIcon_svg__ = __webpack_require__("./src/common/images/linkIcon.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_images_linkIcon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_common_images_linkIcon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_blocks_StyledLink__ = __webpack_require__("./src/blocks/StyledLink/index.jsx");
var _templateObject=_taggedTemplateLiteral(['\n    margin: 0 ',';\n  '],['\n    margin: 0 ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LinkIcon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span.withConfig({displayName:'ArticleCategory__LinkIcon',componentId:'sc-1vz331i-0'})(['display:inline-block;background-image:url(',');height:15px;width:15px;background-repeat:no-repeat;margin-right:',';'],__WEBPACK_IMPORTED_MODULE_5_common_images_linkIcon_svg___default.a,__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.s'));var StyledLink=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_6_blocks_StyledLink__["b" /* default */]).withConfig({displayName:'ArticleCategory__StyledLink',componentId:'sc-1vz331i-1'})(['display:flex;align-items:center;margin:',' 0;',''],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.base'),__WEBPACK_IMPORTED_MODULE_2_designsystem__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].get('metrics.s')));var StyledHeader4=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_elements_Header4__["a" /* default */]).withConfig({displayName:'ArticleCategory__StyledHeader4',componentId:'sc-1vz331i-2'})(['margin:0;color:',';'],__WEBPACK_IMPORTED_MODULE_2_designsystem__["a" /* default */].brand('product'));var ArticleCategory=function ArticleCategory(_ref){var slug=_ref.slug,description=_ref.description,onClick=_ref.onClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledLink,{to:slug,onClick:onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LinkIcon,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledHeader4,null,description)));};ArticleCategory.propTypes={slug:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,description:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,onClick:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func};ArticleCategory.defaultProps={onClick:function onClick(){return null;}};/* harmony default export */ __webpack_exports__["a"] = (ArticleCategory);

/***/ }),

/***/ "./src/pages/BlogArticle/BlogAuthor/Image.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
var Image=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({displayName:'Image',componentId:'sc-1tnk7p9-0'})(['background-image:',';width:100%;margin:0 auto;background-size:cover;background-position:center center;padding-bottom:100%;'],function(_ref){var url=_ref.url;return'url('+url+')';});/* harmony default export */ __webpack_exports__["a"] = (Image);

/***/ }),

/***/ "./src/pages/BlogArticle/BlogAuthor/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlogAuthorBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_common_consts_anchor__ = __webpack_require__("./src/common/consts/anchor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_common_consts_anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_common_consts_anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_decorators_bind__ = __webpack_require__("./node_modules/lodash-decorators/bind.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_decorators_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_decorators_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_common_responsive__ = __webpack_require__("./src/common/responsive.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_elements_Header4__ = __webpack_require__("./src/elements/Header4.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_elements_Paragraph__ = __webpack_require__("./src/elements/Paragraph.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Image__ = __webpack_require__("./src/pages/BlogArticle/BlogAuthor/Image.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_dec2,_class,_desc,_value,_class2;var _templateObject=_taggedTemplateLiteral(['\n      display:flex;\n      margin-bottom:0;\n    '],['\n      display:flex;\n      margin-bottom:0;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n    margin: 0;\n  '],['\n    margin: 0;\n  ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var Wrapper=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].div.withConfig({displayName:'BlogAuthor__Wrapper',componentId:'sc-1vhlsrl-0'})(['cursor:pointer;margin-bottom:',' ',';'],__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_11_common_responsive__["c" /* media */].tablet(_templateObject));var StyledHeader=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_12_elements_Header4__["a" /* default */]).withConfig({displayName:'BlogAuthor__StyledHeader',componentId:'sc-1vhlsrl-1'})(['margin:',' 0;',';'],__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('metrics.xs'),__WEBPACK_IMPORTED_MODULE_11_common_responsive__["c" /* media */].desktop(_templateObject2));var StyledParagraph=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_13_elements_Paragraph__["a" /* default */]).withConfig({displayName:'BlogAuthor__StyledParagraph',componentId:'sc-1vhlsrl-2'})(['margin-top:0;']);var StyledColumn=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_6_hedron__["Column"]).withConfig({displayName:'BlogAuthor__StyledColumn',componentId:'sc-1vhlsrl-3'})(['margin-right:',';'],__WEBPACK_IMPORTED_MODULE_5_designsystem__["a" /* default */].get('metrics.xl'));var BlogAuthorBox=(_dec=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["inject"])('blogStore','windowStore','appStore'),_dec2=__WEBPACK_IMPORTED_MODULE_10_lodash_decorators_bind___default()(),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"])(_class=Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["withRouter"])(_class=(_class2=function(_Component){_inherits(BlogAuthorBox,_Component);function BlogAuthorBox(){_classCallCheck(this,BlogAuthorBox);return _possibleConstructorReturn(this,(BlogAuthorBox.__proto__||Object.getPrototypeOf(BlogAuthorBox)).apply(this,arguments));}_createClass(BlogAuthorBox,[{key:'filterByAuthor',value:function filterByAuthor(author){var _props=this.props,history=_props.history,codename=_props.author.codename,currentLanguage=_props.appStore.currentLanguage;history.push({pathname:__WEBPACK_IMPORTED_MODULE_8_common_consts_anchor___default.a.BLOG[currentLanguage]+'/'+Object(__WEBPACK_IMPORTED_MODULE_9_common_methods_string__["i" /* underscoresToDashes */])(codename),state:{cameFromArticle:true,author:author}});}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,blogStore=_props2.blogStore,_props2$author=_props2.author,name=_props2$author.name,position=_props2$author.position,description=_props2$author.description,image=_props2$author.image,system=_props2$author.system,windowStore=_props2.windowStore;var author=blogStore.blogAuthors.find(function(filterAuthor){return filterAuthor.system.codename===system.codename;});var authorToFilter={name:author.name,value:author.value,count:author.count};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,{onClick:function onClick(){return _this2.filterByAuthor(authorToFilter);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_hedron__["Column"],{fluid:true,md:4,lg:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Image__["a" /* default */],{url:windowStore.adjustImageSize(image)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledColumn,{fluid:true,md:7,lg:8,mdShift:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledHeader,null,name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledParagraph,null,position),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_elements_Paragraph__["a" /* default */],null,description)));}}]);return BlogAuthorBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),(_applyDecoratedDescriptor(_class2.prototype,'filterByAuthor',[_dec2],Object.getOwnPropertyDescriptor(_class2.prototype,'filterByAuthor'),_class2.prototype)),_class2))||_class)||_class)||_class);BlogAuthorBox.propTypes={author:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_7_models__["g" /* BlogAuthor */]).isRequired};

/***/ }),

/***/ "./src/pages/BlogArticle/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlogArticle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_window_or_global__ = __webpack_require__("./node_modules/window-or-global/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blocks_Parser_Parser__ = __webpack_require__("./src/blocks/Parser/Parser.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("./node_modules/moment/moment.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_common_responsive__ = __webpack_require__("./src/common/responsive.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_reveal_Fade__ = __webpack_require__("./node_modules/react-reveal/Fade.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_reveal_Fade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_reveal_Fade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_animations_Animations__ = __webpack_require__("./src/animations/Animations.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_elements_Paragraph__ = __webpack_require__("./src/elements/Paragraph.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_elements_Header1__ = __webpack_require__("./src/elements/Header1.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_elements_Header5__ = __webpack_require__("./src/elements/Header5.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_blocks_Navigation__ = __webpack_require__("./src/blocks/Navigation/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_blocks_ShareMechanism__ = __webpack_require__("./src/blocks/ShareMechanism/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_kentico_blocks_Newsletter__ = __webpack_require__("./src/kentico-blocks/Newsletter/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_blocks_InjectMetaTags__ = __webpack_require__("./src/blocks/InjectMetaTags/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_blocks_SplashScreen__ = __webpack_require__("./src/blocks/SplashScreen/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_pages_BlogArticle_ArticleCategory__ = __webpack_require__("./src/pages/BlogArticle/ArticleCategory.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_pages_PageNotFound__ = __webpack_require__("./src/pages/PageNotFound/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_common_methods_blogMethods__ = __webpack_require__("./src/common/methods/blogMethods.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_blocks_NavigationAwarePageContent__ = __webpack_require__("./src/blocks/NavigationAwarePageContent/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_common_consts_anchor__ = __webpack_require__("./src/common/consts/anchor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_common_consts_anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_common_consts_anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__BlogAuthor__ = __webpack_require__("./src/pages/BlogArticle/BlogAuthor/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Blog_BlogArticleBox__ = __webpack_require__("./src/pages/Blog/BlogArticleBox/index.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _templateObject=_taggedTemplateLiteral(['\n    padding-right:',';\n    overflow: hidden;\n  '],['\n    padding-right:',';\n    overflow: hidden;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n  padding: 0 ',';\n  font-size: ',';\n  line-height: ',';\n  \n  ','\n  \n  ',';\n'],['\n  padding: 0 ',';\n  font-size: ',';\n  line-height: ',';\n  \n  ','\n  \n  ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n    font-size: ',';\n    line-height: ',';\n  '],['\n    font-size: ',';\n    line-height: ',';\n  ']),_templateObject4=_taggedTemplateLiteral(['\n    font-size: ',';\n    line-height: ',';\n'],['\n    font-size: ',';\n    line-height: ',';\n']),_templateObject5=_taggedTemplateLiteral(['\n    margin: ',' 0 ',';\n  '],['\n    margin: ',' 0 ',';\n  ']),_templateObject6=_taggedTemplateLiteral(['\n    margin-top:',';\n  '],['\n    margin-top:',';\n  ']),_templateObject7=_taggedTemplateLiteral(['\n    margin-top: 250px;\n  '],['\n    margin-top: 250px;\n  ']),_templateObject8=_taggedTemplateLiteral(['\n    padding: ',';\n  '],['\n    padding: ',';\n  ']),_templateObject9=_taggedTemplateLiteral(['\n    margin-top:0;\n  '],['\n    margin-top:0;\n  ']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/no-did-update-set-state,no-param-reassign *//* eslint-disable react/prop-types */var StyledContainer=Object(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_11_blocks_Container_Container__["a" /* default */]).withConfig({displayName:'BlogArticle__StyledContainer',componentId:'sc-1sdgazp-0'})(['',';'],__WEBPACK_IMPORTED_MODULE_9_common_responsive__["c" /* media */].desktop(_templateObject,__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].get('metrics.xxl')));var StyledTitle=__WEBPACK_IMPORTED_MODULE_15_elements_Header1__["a" /* default */].extend(_templateObject2,__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].fontSize('l'),__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].get('type.lineHeight.l'),__WEBPACK_IMPORTED_MODULE_9_common_responsive__["c" /* media */].tablet(_templateObject3,__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].fontSize('xl'),__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].get('type.lineHeight.xl')),__WEBPACK_IMPORTED_MODULE_9_common_responsive__["c" /* media */].desktop(_templateObject4,__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].fontSize('xxl'),__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].get('type.lineHeight.xxl')));var StyledHeader5=Object(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_16_elements_Header5__["a" /* default */]).withConfig({displayName:'BlogArticle__StyledHeader5',componentId:'sc-1sdgazp-1'})(['margin:',' 0 ',';margin-left:',';',';'],__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].get('metrics.base'),function(_ref){var alignLeft=_ref.alignLeft;return alignLeft?__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].get('metrics.s'):'';},__WEBPACK_IMPORTED_MODULE_9_common_responsive__["c" /* media */].desktop(_templateObject5,__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].get('metrics.xxl'),__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].get('metrics.l')));var StyledParagraph=Object(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_14_elements_Paragraph__["a" /* default */]).withConfig({displayName:'BlogArticle__StyledParagraph',componentId:'sc-1sdgazp-2'})(['margin:0;',';'],__WEBPACK_IMPORTED_MODULE_9_common_responsive__["c" /* media */].desktop(_templateObject6,__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].get('metrics.base')));var MarginContainer=Object(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_11_blocks_Container_Container__["a" /* default */]).withConfig({displayName:'BlogArticle__MarginContainer',componentId:'sc-1sdgazp-3'})(['margin-top:',';',''],__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].get('metrics.xxl'),__WEBPACK_IMPORTED_MODULE_9_common_responsive__["c" /* media */].desktop(_templateObject7));var PaddingContainer=Object(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_11_blocks_Container_Container__["a" /* default */]).withConfig({displayName:'BlogArticle__PaddingContainer',componentId:'sc-1sdgazp-4'})(['',';'],__WEBPACK_IMPORTED_MODULE_9_common_responsive__["c" /* media */].desktop(_templateObject8,__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].get('metrics.s')));var StyledColumn=Object(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_hedron__["Column"]).withConfig({displayName:'BlogArticle__StyledColumn',componentId:'sc-1sdgazp-5'})(['margin-top:-',';',';'],__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].get('metrics.base'),__WEBPACK_IMPORTED_MODULE_9_common_responsive__["c" /* media */].desktop(_templateObject9));var LoadArticles=Object(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_14_elements_Paragraph__["a" /* default */]).withConfig({displayName:'BlogArticle__LoadArticles',componentId:'sc-1sdgazp-6'})(['margin:',' auto;width:100px;cursor:pointer;text-decoration:underline;'],__WEBPACK_IMPORTED_MODULE_8_designsystem__["a" /* default */].get('metrics.base'));var publicationDateFormat='DD.MM/YYYY';var BlogArticle=(_dec=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["inject"])('coreStore','windowStore','blogStore','appStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"])(_class=function(_Component){_inherits(BlogArticle,_Component);function BlogArticle(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,BlogArticle);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=BlogArticle.__proto__||Object.getPrototypeOf(BlogArticle)).call.apply(_ref2,[this].concat(args))),_this),_this.state={blogArticle:null,isArticleFound:true},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BlogArticle,[{key:'componentDidMount',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var blogStore,_props$match$params,slug,category,blogArticle;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:blogStore=this.props.blogStore;__WEBPACK_IMPORTED_MODULE_4_window_or_global___default.a.scrollTo(0,0);_context.next=4;return blogStore.initialContentFetch();case 4:_props$match$params=this.props.match.params,slug=_props$match$params.slug,category=_props$match$params.category;_context.next=7;return blogStore.getArticleBySlug(slug);case 7:blogArticle=_context.sent;if(!blogArticle||category!==Object(__WEBPACK_IMPORTED_MODULE_10_common_methods_string__["i" /* underscoresToDashes */])(blogArticle.mainCategory.codename)){this.setState({isArticleFound:false});}else{this.setState({blogArticle:blogArticle});}case 9:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref3.apply(this,arguments);}return componentDidMount;}()},{key:'componentDidUpdate',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(props){var blogStore,state,blogArticle,incomingSlug,newBlogArticle;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:blogStore=props.blogStore,state=props.history.location.state;blogArticle=this.state.blogArticle;if(!(blogArticle&&blogArticle.slug&&state)){_context2.next=11;break;}incomingSlug=state.slug;if(!(blogArticle.slug!==incomingSlug)){_context2.next=11;break;}_context2.next=7;return blogStore.getArticleBySlug(incomingSlug);case 7:newBlogArticle=_context2.sent;this.setState({blogArticle:newBlogArticle});blogStore.resetArticlesCountinArticleView();__WEBPACK_IMPORTED_MODULE_4_window_or_global___default.a.scrollTo(0,0);case 11:case'end':return _context2.stop();}}},_callee2,this);}));function componentDidUpdate(_x){return _ref4.apply(this,arguments);}return componentDidUpdate;}()},{key:'componentWillUnmount',value:function componentWillUnmount(){var blogStore=this.props.blogStore;blogStore.resetArticlesCountinArticleView();}},{key:'render',value:function render(){var _state=this.state,blogArticle=_state.blogArticle,isArticleFound=_state.isArticleFound;if(!isArticleFound){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_pages_PageNotFound__["a" /* default */],null);}if(!blogArticle){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_blocks_SplashScreen__["a" /* default */],null);}var _state$blogArticle=this.state.blogArticle,id=_state$blogArticle.id,title=_state$blogArticle.title,mainCategory=_state$blogArticle.mainCategory,content=_state$blogArticle.content,articleAuthor=_state$blogArticle.articleAuthor,publicationDate=_state$blogArticle.publicationDate,slug=_state$blogArticle.linkToProduct.slug;var _props=this.props,blogStore=_props.blogStore,_props$coreStore=_props.coreStore,isLoaded=_props$coreStore.isLoaded,translations=_props$coreStore.translations,newsletter=_props$coreStore.content.newsletter,windowStore=_props$coreStore.windowStore,currentLanguage=_props.appStore.currentLanguage;var metaTags=Object(__WEBPACK_IMPORTED_MODULE_24_common_methods_blogMethods__["a" /* generateMetaTagsFromBlogArticle */])(blogArticle);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_blocks_InjectMetaTags__["a" /* default */],metaTags),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_blocks_Navigation__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_blocks_NavigationAwarePageContent__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(MarginContainer,null,slug&&!windowStore.isOnTablet&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_pages_BlogArticle_ArticleCategory__["a" /* default */],{slug:__WEBPACK_IMPORTED_MODULE_26_common_consts_anchor___default.a.BLOG[currentLanguage]+'/'+Object(__WEBPACK_IMPORTED_MODULE_10_common_methods_string__["i" /* underscoresToDashes */])(mainCategory.codename),description:blogStore.translateBlogCategory(mainCategory.codename),onClick:function onClick(){return blogStore.setBlogFilter(mainCategory.codename);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_reveal_Fade___default.a,{bottom:true,distance:''+__WEBPACK_IMPORTED_MODULE_13_animations_Animations__["a" /* FADE_VALUES */].BOX.LIGHT},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledTitle,null,title))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_hedron__["Row"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_hedron__["Column"],{lg:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledParagraph,null,__WEBPACK_IMPORTED_MODULE_6_moment___default()(publicationDate).format(publicationDateFormat)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_blocks_ShareMechanism__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledColumn,{lg:9,lgShift:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_blocks_Parser_Parser__["a" /* default */],{blogArticle:true,htmlBody:content}),slug&&windowStore.isOnTablet&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_pages_BlogArticle_ArticleCategory__["a" /* default */],{slug:__WEBPACK_IMPORTED_MODULE_26_common_consts_anchor___default.a.BLOG[currentLanguage],description:blogStore.translateBlogCategory(mainCategory.codename),onClick:function onClick(){return blogStore.setBlogFilter(mainCategory.codename);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledHeader5,{bold:true},translations.BLOG_ABOUT_THE_AUTHOR),articleAuthor&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__BlogAuthor__["a" /* default */],{author:articleAuthor})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PaddingContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledHeader5,{alignLeft:true,bold:true},translations.BLOG_OTHER_ARTICLES),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_hedron__["Row"],{divisions:11},blogStore.getArticlesDetailsForArticleView(id).map(function(article,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_hedron__["Column"],{lg:3,lgShift:index%3?1:0,fluid:!windowStore.isOnTablet,key:article.system.id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__Blog_BlogArticleBox__["a" /* default */],{article:article}));})),!blogStore.allArticlesInArticleViewLoaded&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadArticles,{onClick:blogStore.loadMoreArticlesinArticleView},translations.BLOG_MORE_ARTICLES),isLoaded&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_kentico_blocks_Newsletter__["a" /* default */],{margin:false,content:newsletter}))));}}]);return BlogArticle;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class)||_class);

/***/ }),

/***/ "./src/pages/ContactForm/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_kentico_blocks_HorizontallyNavigableContent__ = __webpack_require__("./src/kentico-blocks/HorizontallyNavigableContent/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_window_or_global__ = __webpack_require__("./node_modules/window-or-global/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blocks_Navigation_Buttons_TagAGetTheApp__ = __webpack_require__("./src/blocks/Navigation/Buttons/TagAGetTheApp.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_last_location__ = __webpack_require__("./node_modules/react-router-last-location/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_last_location___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_router_last_location__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_common_consts_anchor__ = __webpack_require__("./src/common/consts/anchor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_common_consts_anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_common_consts_anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_blocks_SplashScreen__ = __webpack_require__("./src/blocks/SplashScreen/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_blocks_Navigation_Logo__ = __webpack_require__("./src/blocks/Navigation/Logo/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_blocks_CloseIcon__ = __webpack_require__("./src/blocks/CloseIcon/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_blocks_InjectMetaTags__ = __webpack_require__("./src/blocks/InjectMetaTags/index.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2;var _templateObject=_taggedTemplateLiteral(['\n    margin: ',' ',';\n  '],['\n    margin: ',' ',';\n  ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var NavContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div.withConfig({displayName:'ContactForm__NavContainer',componentId:'yjdl53-0'})(['display:flex;justify-content:space-between;',''],__WEBPACK_IMPORTED_MODULE_4_designsystem__["c" /* media */].tablet(_templateObject,__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('metrics.l')));var StyledCloseIcon=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_13_blocks_CloseIcon__["a" /* default */]).withConfig({displayName:'ContactForm__StyledCloseIcon',componentId:'yjdl53-1'})(['position:relative;display:inline-block;top:7px;right:0;width:',';'],__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].get('metrics.xs'));var ContactFormPage=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('coreStore','appStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(_class=(_class2=function(_Component){_inherits(ContactFormPage,_Component);function ContactFormPage(){_classCallCheck(this,ContactFormPage);return _possibleConstructorReturn(this,(ContactFormPage.__proto__||Object.getPrototypeOf(ContactFormPage)).apply(this,arguments));}_createClass(ContactFormPage,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_5_window_or_global___default.a.scrollTo(0,0);}},{key:'goBack',value:function goBack(){var _props=this.props,history=_props.history,lastLocation=_props.lastLocation,currentLanguage=_props.appStore.currentLanguage;if(lastLocation){history.goBack();}else{// if user came from web (outside), on contact form close go to the main page:
history.push(__WEBPACK_IMPORTED_MODULE_10_common_consts_anchor___default.a.HOME[currentLanguage]);}}},{key:'render',value:function render(){var _props$coreStore=this.props.coreStore,initialCoreDataFetchDone=_props$coreStore.initialCoreDataFetchDone,translations=_props$coreStore.translations,blogContactComponent=_props$coreStore.blogContactComponent,contactSEO=_props$coreStore.content.contactSEO;if(!initialCoreDataFetchDone){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_blocks_SplashScreen__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_blocks_InjectMetaTags__["a" /* default */],contactSEO),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_blocks_Navigation_Logo__["a" /* default */],{big:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_blocks_Navigation_Buttons_TagAGetTheApp__["a" /* default */],{onClick:this.goBack},translations.NAVIGATION_GET_THE_APP,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledCloseIcon,{color:__WEBPACK_IMPORTED_MODULE_4_designsystem__["a" /* default */].brand('background'),height:'18px',width:'1px'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_kentico_blocks_HorizontallyNavigableContent__["a" /* default */],{data:blogContactComponent}));}}]);return ContactFormPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),(_applyDecoratedDescriptor(_class2.prototype,'goBack',[__WEBPACK_IMPORTED_MODULE_8_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'goBack'),_class2.prototype)),_class2))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["withRouter"])(Object(__WEBPACK_IMPORTED_MODULE_9_react_router_last_location__["withLastLocation"])(ContactFormPage)));

/***/ }),

/***/ "./src/pages/ForInvestors/ForInvestorsItem/ForInvestorsItem.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ForInvestorsItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_pdf_icon_png__ = __webpack_require__("./src/pages/ForInvestors/assets/pdf-icon.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_pdf_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_pdf_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_xls_icon_png__ = __webpack_require__("./src/pages/ForInvestors/assets/xls-icon.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_xls_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_xls_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__consts_index__ = __webpack_require__("./src/pages/ForInvestors/consts/index.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Date=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({displayName:'ForInvestorsItem__Date',componentId:'ue2g09-0'})(['color:grey;font-size:14px;font-family:\'Roboto\',sans-serif;']);var ItemsWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({displayName:'ForInvestorsItem__ItemsWrapper',componentId:'ue2g09-1'})(['display:flex;align-items:flex-start;width:100%;justify-content:space-between;flex-wrap:wrap;']);var InformationWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({displayName:'ForInvestorsItem__InformationWrapper',componentId:'ue2g09-2'})(['display:flex;align-items:flex-start;flex-wrap:wrap;max-width:80%;']);var ContentWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({displayName:'ForInvestorsItem__ContentWrapper',componentId:'ue2g09-3'})(['display:flex;flex-direction:column;align-items:flex-start;margin-left:10px;height:70px;justify-content:space-evenly;']);var SectionDescription=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span.withConfig({displayName:'ForInvestorsItem__SectionDescription',componentId:'ue2g09-4'})(['font-family:',';font-weight:700;text-align:left;margin-bottom:10px;'],__WEBPACK_IMPORTED_MODULE_4__consts_index__["b" /* headersFont */]);var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button.withConfig({displayName:'ForInvestorsItem__Button',componentId:'ue2g09-5'})(['font-family:',';font-weight:300;text-align:center;display:inline-block;background-color:#3046ff;padding:15px 30px;color:white;border:none;outline:none;font-size:17px;margin:20px 0;cursor:pointer;'],__WEBPACK_IMPORTED_MODULE_4__consts_index__["a" /* defaultFont */]);var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].img.withConfig({displayName:'ForInvestorsItem__Icon',componentId:'ue2g09-6'})(['height:65px;padding:10px;']);var ForInvestorsItem=function(_Component){_inherits(ForInvestorsItem,_Component);function ForInvestorsItem(){_classCallCheck(this,ForInvestorsItem);return _possibleConstructorReturn(this,(ForInvestorsItem.__proto__||Object.getPrototypeOf(ForInvestorsItem)).apply(this,arguments));}_createClass(ForInvestorsItem,[{key:'render',value:function render(){var _props=this.props,icon=_props.icon,description=_props.description,date=_props.date,url=_props.url;var currentDate=date.split("T")[0].split("-");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemsWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InformationWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{src:icon==="pdf"?__WEBPACK_IMPORTED_MODULE_2__assets_pdf_icon_png___default.a:__WEBPACK_IMPORTED_MODULE_3__assets_xls_icon_png___default.a,alt:'Pdf logo'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SectionDescription,null,description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Date,null,currentDate[2]+'.'+currentDate[1]+'.'+currentDate[0]))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:url,target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{type:'submit'},'Poka\u017C')));}}]);return ForInvestorsItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),

/***/ "./src/pages/ForInvestors/assets/pdf-icon.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "./src/pages/ForInvestors/assets/xls-icon.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAAG7AAABuwE67OPiAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAWJQTFRF////4uLrhLtZ4uXmwcbLhL1a4ubn4uXnhL1ahL1bhb5bhr5dh79eh79fiL9fiL9gicBgi8FjjMFljcJmjsJoj8Noj8NpkMNqkcRrksVtk8VvlMZvlcZxlsdyl8d0mMV4mch2msl4nMp6nst9oMyAoc2Bo8iMo86Epc+Gps+Ip9CJqtGMq9KOr9SUsLe9sNWVsdWWs9aZtLvAtbzBtdebttidt9ifuNmfutqiu9qjvNumwN2qwN2rwcfMxuCyyOG1yeK3ytHYytTUzNzGzeS8zuW9zuW+z9Xb0ObA0ebB0ebC0+fD1tvf1unH1unI2OrL2evN2+zP3ODj3eDj3u3S3u3T4O7V4uXn4u/Y5PDa5PHb5fHc5fHd5vLe5/Lf6PPh6fPi7vbo7/bp7/bq8Pfq8ffs8vju8/nv9Pnw9Pnx9frx9fry9/v1+Pv1+fz3+vz5+/35/P36/P37/f78///+////UwWFaAAAAAh0Uk5TABo8psDJ5upYXiAEAAAB00lEQVRYw93X90/CQBQHcLBanrhn3RsHiooK7j1Q3LPiXrhBEd//b4GqRW3vtedPfJP2JZfcJ3m53F3OZtPGLoiyQbJtjNgdsmF6WYIgMwCWIDIBhiCzAWOBAhgKJMBIoAEGAhHQF6iArkAG9AQ6oCOwgEGWwAImexkCC9gdYAgyU5g07kImZG32O5YArWAN0AgWgW/BKvAlWAY+BeuAKnAAKYEHSApcQELgAxSBE5DXeAH5/4CsHDCRxvlfgKn5ivALAJPJbKA4VfLUT41rdMxTQAL8cW+ieF580BAdVgcrQqjkwU0BPPjWBtDyil7owaA6OIMnQxMHsWlSC0G8qyq7wXXQAFGsU/6FThJQcIRH+3herAXCOJ5HXwXpFvGpBrSA7x2fVzvJy7iCuAlpADRvvSNeuGlAH8ZiOJIOAFR6Q/haSwGaX9DvxXjHDwAg9wz7CUDpFW4ALOJjtQKsS5JU6QTnwlgTQHkEuwnAEl6WKEtxjNsKkMx1UXkcMbwXwXAJAZgKtyRK9eky1NwngdN86DpU6ttyHcdmqm91SZl+Hpg8VNs5j/X2Od2LZZaWACcQ2Pn/qy2DANHcfNH00/dHBNOP7/Q47H883wVyF6KQmv8Bq6jVN1IOSxsAAAAASUVORK5CYII="

/***/ }),

/***/ "./src/pages/ForInvestors/consts/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultFont; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return headersFont; });
var defaultFont="'Roboto', sans-serif";var headersFont="'Poppins', sans-serif";

/***/ }),

/***/ "./src/pages/ForInvestors/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ForInvestors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blocks_Navigation__ = __webpack_require__("./src/blocks/Navigation/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ForInvestorsItem_ForInvestorsItem__ = __webpack_require__("./src/pages/ForInvestors/ForInvestorsItem/ForInvestorsItem.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__consts_index__ = __webpack_require__("./src/pages/ForInvestors/consts/index.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PageContainer=__WEBPACK_IMPORTED_MODULE_5_styled_components__["default"].div.withConfig({displayName:'ForInvestors__PageContainer',componentId:'sc-1v6wkap-0'})(['display:flex;align-items:center;justify-content:center;padding:20px;']);var Container=__WEBPACK_IMPORTED_MODULE_5_styled_components__["default"].div.withConfig({displayName:'ForInvestors__Container',componentId:'sc-1v6wkap-1'})(['min-height:300px;padding-top:70px;padding-bottom:40px;width:1366px;display:flex;flex-direction:column;justify-content:center;']);var Header=__WEBPACK_IMPORTED_MODULE_5_styled_components__["default"].h2.withConfig({displayName:'ForInvestors__Header',componentId:'sc-1v6wkap-2'})(['font-size:50px;text-align:center;font-family:',';font-weight:700;'],__WEBPACK_IMPORTED_MODULE_8__consts_index__["b" /* headersFont */]);var Description=__WEBPACK_IMPORTED_MODULE_5_styled_components__["default"].div.withConfig({displayName:'ForInvestors__Description',componentId:'sc-1v6wkap-3'})(['font-family:',';font-size:30px;text-align:center;'],__WEBPACK_IMPORTED_MODULE_8__consts_index__["a" /* defaultFont */]);var SectionName=__WEBPACK_IMPORTED_MODULE_5_styled_components__["default"].h3.withConfig({displayName:'ForInvestors__SectionName',componentId:'sc-1v6wkap-4'})(['font-family:',';font-weight:700;font-size:30px;'],__WEBPACK_IMPORTED_MODULE_8__consts_index__["b" /* headersFont */]);var ForInvestors=(_dec=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["inject"])('forInvestorsStore','appStore'),_dec(_class=function(_Component){_inherits(ForInvestors,_Component);function ForInvestors(){_classCallCheck(this,ForInvestors);return _possibleConstructorReturn(this,(ForInvestors.__proto__||Object.getPrototypeOf(ForInvestors)).apply(this,arguments));}_createClass(ForInvestors,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var forInvestorsStore,fetchedInvestorData,sectionHeader,sectionDescription,sectionsData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:forInvestorsStore=this.props.forInvestorsStore;root.scrollTo(0,0);_context.next=4;return forInvestorsStore.getForInvestorsData();case 4:fetchedInvestorData=this.props.forInvestorsStore.fetchedInvestorData;sectionHeader=fetchedInvestorData.sectionHeader,sectionDescription=fetchedInvestorData.sectionDescription,sectionsData=fetchedInvestorData.sectionsData;this.setState({header:sectionHeader,description:sectionDescription,sectionsData:[].concat(_toConsumableArray(sectionsData))});case 7:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var currentUrl=this.props.appStore.currentUrl;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet__["Helmet"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('link',{rel:'canonical',href:currentUrl})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_blocks_Navigation__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PageContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Container,null,this.state&&this.state.header&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Header,null,this.state.header),this.state&&this.state.description&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Description,null,this.state.description),this.state&&this.state.sectionsData&&this.state.sectionsData.map(function(_ref2){var sectionName=_ref2.sectionName,linkedFiles=_ref2.linkedFiles;return sectionName&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,sectionName&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SectionName,null,sectionName),linkedFiles&&linkedFiles.map(function(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ForInvestorsItem_ForInvestorsItem__["a" /* default */],{icon:__WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(item,'file_type.value[0].codename',''),description:__WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(item,'description.value',''),date:__WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(item,'date.value',''),url:__WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(item,'linked_asset.value[0].url','')});}));}))));}}]);return ForInvestors;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class);

/***/ }),

/***/ "./src/pages/NewsletterThankYouPage/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_designsystem__ = __webpack_require__("./src/designsystem/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_blocks_Navigation_Buttons_TagAGetTheApp__ = __webpack_require__("./src/blocks/Navigation/Buttons/TagAGetTheApp.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blocks_CloseButton__ = __webpack_require__("./src/blocks/CloseButton/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_consts_anchor__ = __webpack_require__("./src/common/consts/anchor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_consts_anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_common_consts_anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_blocks_SplashScreen__ = __webpack_require__("./src/blocks/SplashScreen/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_blocks_Navigation_Logo__ = __webpack_require__("./src/blocks/Navigation/Logo/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_blocks_Container_Container__ = __webpack_require__("./src/blocks/Container/Container.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hedron__ = __webpack_require__("./node_modules/hedron/dist/hedron.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hedron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_hedron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_elements_Header1__ = __webpack_require__("./src/elements/Header1.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_elements_DescriptionText__ = __webpack_require__("./src/elements/DescriptionText.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2;var _templateObject=_taggedTemplateLiteral(['\n      font-size: ',';\n      line-height: ',';\n    '],['\n      font-size: ',';\n      line-height: ',';\n    ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var CenteredContent=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div.withConfig({displayName:'NewsletterThankYouPage__CenteredContent',componentId:'yosr0u-0'})(['display:flex;flex-direction:column;justify-content:center;align-items:center;']);var StyledHeader=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_12_elements_Header1__["a" /* default */]).withConfig({displayName:'NewsletterThankYouPage__StyledHeader',componentId:'yosr0u-1'})(['font-size:',';line-height:',';text-align:center;',''],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].fs('l'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('type.lineHeight.l'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["c" /* media */].tablet(_templateObject,__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].fs('xl'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('type.lineHeight.xl')));var Description=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_13_elements_DescriptionText__["a" /* default */]).withConfig({displayName:'NewsletterThankYouPage__Description',componentId:'yosr0u-2'})(['font-size:',';line-height:',';text-align:center;',''],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].fs('m'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('type.lineHeight.m'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["c" /* media */].tablet(_templateObject,__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].fs('l'),__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('type.lineHeight.l')));var BackButton=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_4_blocks_Navigation_Buttons_TagAGetTheApp__["a" /* default */]).withConfig({displayName:'NewsletterThankYouPage__BackButton',componentId:'yosr0u-3'})(['width:calc(',' * 5);'],__WEBPACK_IMPORTED_MODULE_3_designsystem__["a" /* default */].get('metrics.m'));var NewsletterThankYouPage=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('coreStore','appStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(_class=(_class2=function(_Component){_inherits(NewsletterThankYouPage,_Component);function NewsletterThankYouPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NewsletterThankYouPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NewsletterThankYouPage.__proto__||Object.getPrototypeOf(NewsletterThankYouPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={isShown:false,title:'',line1:'',line2:''},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NewsletterThankYouPage,[{key:'goBack',value:function goBack(goHome){var _props=this.props,history=_props.history,currentLanguage=_props.appStore.currentLanguage;if(goHome){history.push(__WEBPACK_IMPORTED_MODULE_7_common_consts_anchor___default.a.HOME[currentLanguage]);}else{history.goBack();}}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,confirmed=_props2.confirmed,_props2$coreStore=_props2.coreStore,initialCoreDataFetchDone=_props2$coreStore.initialCoreDataFetchDone,_props2$coreStore$new=_props2$coreStore.newsletterThankYouPage,closeButtonText=_props2$coreStore$new.closeButtonText,backButtonText=_props2$coreStore$new.backButtonText;if(!initialCoreDataFetchDone){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_blocks_SplashScreen__["a" /* default */],null);}var _state=this.state,isShown=_state.isShown,title=_state.title,line1=_state.line1,line2=_state.line2;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_blocks_Container_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_hedron__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_hedron__["Column"],{sm:10,smShift:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CenteredContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_blocks_Navigation_Logo__["a" /* default */],{big:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_hedron__["Column"],{sm:1},!confirmed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_blocks_CloseButton__["a" /* default */],{onClick:function onClick(){return _this2.goBack(false);},onMouseEnter:function onMouseEnter(){return _this2.setState({isShown:true});},onMouseLeave:function onMouseLeave(){return _this2.setState({isShown:false});},isShown:isShown,text:closeButtonText}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_hedron__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_hedron__["Column"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CenteredContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledHeader,null,title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Description,null,line1,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),line2)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_hedron__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_hedron__["Column"],{lg:6,lgShift:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CenteredContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BackButton,{onClick:function onClick(){return _this2.goBack(true);}},backButtonText))))));}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(newProps){var confirmed=newProps.confirmed,location=newProps.location,history=newProps.history,currentLanguage=newProps.appStore.currentLanguage,_newProps$coreStore$n=newProps.coreStore.newsletterThankYouPage,successTitle=_newProps$coreStore$n.successTitle,successLine1=_newProps$coreStore$n.successLine1,successLine2=_newProps$coreStore$n.successLine2,warningTitle=_newProps$coreStore$n.warningTitle,warningLine1=_newProps$coreStore$n.warningLine1,warningLine2=_newProps$coreStore$n.warningLine2,errorTitle=_newProps$coreStore$n.errorTitle,errorLine1=_newProps$coreStore$n.errorLine1,errorLine2=_newProps$coreStore$n.errorLine2,confirmedTitle=_newProps$coreStore$n.confirmedTitle,confirmedLine1=_newProps$coreStore$n.confirmedLine1,confirmedLine2=_newProps$coreStore$n.confirmedLine2;if(confirmed){return{title:confirmedTitle,line1:confirmedLine1,line2:confirmedLine2};}if(!location||!location.state||!location.state.code){history.push(__WEBPACK_IMPORTED_MODULE_7_common_consts_anchor___default.a.HOME[currentLanguage]);return null;}switch(location.state.code){case 200:return{title:successTitle,line1:successLine1,line2:successLine2};case 1008:return{title:warningTitle,line1:warningLine1,line2:warningLine2};default:return{title:errorTitle,line1:errorLine1,line2:errorLine2};}}}]);return NewsletterThankYouPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),(_applyDecoratedDescriptor(_class2.prototype,'goBack',[__WEBPACK_IMPORTED_MODULE_6_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class2.prototype,'goBack'),_class2.prototype)),_class2))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (NewsletterThankYouPage);

/***/ }),

/***/ "./src/pages/PageNotFound/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blocks_SplashScreen_index__ = __webpack_require__("./src/blocks/SplashScreen/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_blocks_Navigation__ = __webpack_require__("./src/blocks/Navigation/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blocks_NavigationAwarePageContent__ = __webpack_require__("./src/blocks/NavigationAwarePageContent/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_designsystem__ = __webpack_require__("./src/designsystem/index.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _templateObject=_taggedTemplateLiteral(['\n    position: relative;\n    top: ',';\n    min-height: 400px;\n    height: 40vh;\n    flex-direction: row;\n  '],['\n    position: relative;\n    top: ',';\n    min-height: 400px;\n    height: 40vh;\n    flex-direction: row;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    font-size: ',';\n    padding-right: ',';\n  '],['\n    font-size: ',';\n    padding-right: ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    margin-top: ',';\n  '],['\n    margin-top: ',';\n  ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable react/prop-types */var PageNotFoundContainer=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div.withConfig({displayName:'PageNotFound__PageNotFoundContainer',componentId:'p6hiq2-0'})(['position:relative;top:',';min-height:520px;display:flex;align-items:center;justify-content:center;padding:',';flex-direction:column;',''],__WEBPACK_IMPORTED_MODULE_7_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_7_designsystem__["a" /* default */].get('metrics.s'),__WEBPACK_IMPORTED_MODULE_7_designsystem__["c" /* media */].tablet(_templateObject,__WEBPACK_IMPORTED_MODULE_7_designsystem__["a" /* default */].get('metrics.xxl')));var ErrorCode=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].p.withConfig({displayName:'PageNotFound__ErrorCode',componentId:'p6hiq2-1'})(['font-family:',';font-size:',';',''],__WEBPACK_IMPORTED_MODULE_7_designsystem__["a" /* default */].get('type.fontFamily.headline'),__WEBPACK_IMPORTED_MODULE_7_designsystem__["a" /* default */].fs('xxl'),__WEBPACK_IMPORTED_MODULE_7_designsystem__["c" /* media */].tablet(_templateObject2,__WEBPACK_IMPORTED_MODULE_7_designsystem__["a" /* default */].fs('xl'),__WEBPACK_IMPORTED_MODULE_7_designsystem__["a" /* default */].get('metrics.s')));var PageNotFoundText=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].p.withConfig({displayName:'PageNotFound__PageNotFoundText',componentId:'p6hiq2-2'})(['font-family:',';font-size:',';line-height:',';margin-top:-',';text-align:center;',';'],__WEBPACK_IMPORTED_MODULE_7_designsystem__["a" /* default */].get('type.fontFamily.text'),__WEBPACK_IMPORTED_MODULE_7_designsystem__["a" /* default */].fs('m'),__WEBPACK_IMPORTED_MODULE_7_designsystem__["a" /* default */].get('type.lineHeight.s'),__WEBPACK_IMPORTED_MODULE_7_designsystem__["a" /* default */].get('metrics.m'),__WEBPACK_IMPORTED_MODULE_7_designsystem__["c" /* media */].tablet(_templateObject3,__WEBPACK_IMPORTED_MODULE_7_designsystem__["a" /* default */].get('metrics.m')));var PageNotFound=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('coreStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(_class=function(_Component){_inherits(PageNotFound,_Component);function PageNotFound(){_classCallCheck(this,PageNotFound);return _possibleConstructorReturn(this,(PageNotFound.__proto__||Object.getPrototypeOf(PageNotFound)).apply(this,arguments));}_createClass(PageNotFound,[{key:'render',value:function render(){var _props$coreStore=this.props.coreStore,isLoaded=_props$coreStore.isLoaded,translations=_props$coreStore.translations;if(!isLoaded){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_blocks_SplashScreen_index__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet__["Helmet"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'prerender-status-code',content:'404'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_blocks_Navigation__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_blocks_NavigationAwarePageContent__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageNotFoundContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ErrorCode,null,' 404 '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageNotFoundText,null,translations.PAGE_NOT_FOUND_TEXT))));}}]);return PageNotFound;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (PageNotFound);

/***/ }),

/***/ "./src/pages/PrivacyPolicy/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrivacyPolicyPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_window_or_global__ = __webpack_require__("./node_modules/window-or-global/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blocks_PrivacyPolicy__ = __webpack_require__("./src/blocks/PrivacyPolicy/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blocks_Navigation__ = __webpack_require__("./src/blocks/Navigation/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_blocks_NavigationAwarePageContent__ = __webpack_require__("./src/blocks/NavigationAwarePageContent/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blocks_InjectMetaTags__ = __webpack_require__("./src/blocks/InjectMetaTags/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_Core_store__ = __webpack_require__("./src/stores/Core.store.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PrivacyPolicyPage=(_dec=Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["inject"])('coreStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["observer"])(_class=(_temp=_class2=function(_Component){_inherits(PrivacyPolicyPage,_Component);function PrivacyPolicyPage(){_classCallCheck(this,PrivacyPolicyPage);return _possibleConstructorReturn(this,(PrivacyPolicyPage.__proto__||Object.getPrototypeOf(PrivacyPolicyPage)).apply(this,arguments));}_createClass(PrivacyPolicyPage,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.scrollTo(0,0);}},{key:'render',value:function render(){var privacyPolicySEO=this.props.coreStore.content.privacyPolicySEO;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_blocks_InjectMetaTags__["a" /* default */],privacyPolicySEO),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_blocks_Navigation__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_blocks_NavigationAwarePageContent__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_blocks_PrivacyPolicy__["a" /* default */],null)));}}]);return PrivacyPolicyPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class2.propTypes={coreStore:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_8_stores_Core_store__["a" /* default */]).isRequired},_temp))||_class)||_class);

/***/ }),

/***/ "./src/pages/Product/ProductsSectionParser.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__ = __webpack_require__("./src/common/consts/kentico.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_kentico_blocks__ = __webpack_require__("./src/kentico-blocks/index.jsx");
var productsSectionParser=function productsSectionParser(model){switch(model.system.type){case __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].CROPPED_ASSET:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks__["i" /* CroppedAsset */],{data:model,key:model.system.id});case __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].THREE_COLUMN_GRID:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks__["s" /* ThreeColumnGrid */],{data:model,key:model.system.id});case __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].BANNER:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks__["c" /* Banner */],{data:model,key:model.system.id});case __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].SIMPLE_ACCORDION:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks__["r" /* SimpleAccordion */],{data:model,key:model.system.id});case __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].ACCORDION:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks__["a" /* Accordion */],{data:model,key:model.system.id});case __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].CARD_SLIDER:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks__["f" /* CardSlider */],{data:model,key:model.system.id});case __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].DOWNLOAD_BAR:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks__["j" /* DownloadBar */],{data:model,key:model.system.id});case __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].TWO_COLUMN_GRID:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks__["u" /* TwoColumnGrid */],{data:model,key:model.system.id});case __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].IMAGED_SECTION:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks__["o" /* ImagedSection */],{data:model,key:model.system.id});case __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].CONTACT_FORM:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks__["g" /* ContactForm */],{data:model,key:model.system.id});case __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].CONTACT_FORM_SUPPORT:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks__["h" /* ContactFormSupport */],{data:model,key:model.system.id});case __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].HERO_IMAGE:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks__["l" /* HeroImage */],{data:model,key:model.system.id});case __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].IMAGE_SLIDER:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks__["n" /* ImageSlider */],{data:model,key:model.system.id});case __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].CALL_US:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks__["e" /* CallUs */],{data:model,key:model.system.id});case __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].HORIZONTALLY_NAVIGABLE_CONTENT:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks__["m" /* HorizontallyNavigableContent */],{data:model,key:model.system.id});case __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].LINK_BANNER:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks__["p" /* LinkBanner */],{data:model,key:model.system.id});case __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].PRODUCT_SLIDER:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks__["q" /* ProductSlider */],{data:model,key:model.system.id});case __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].CALCULATOR:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks__["d" /* Calculator */],{data:model,key:model.system.id});case __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].ARTICLE_SLIDER:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks__["b" /* ArticleSlider */],{data:model,key:model.system.id});case __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].FAQ_ACCORDION:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks__["k" /* FAQAccordion */],{data:model,key:model.system.id});case __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].TITLE_AND_SUBTITLE:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_kentico_blocks__["t" /* TitleAndSubtitle */],{data:model,key:model.system.id});default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:model.system.id});}};/* harmony default export */ __webpack_exports__["a"] = (productsSectionParser);

/***/ }),

/***/ "./src/pages/Product/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blocks_InjectMetaTags_index__ = __webpack_require__("./src/blocks/InjectMetaTags/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blocks_SplashScreen_index__ = __webpack_require__("./src/blocks/SplashScreen/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_blocks_PageContent__ = __webpack_require__("./src/blocks/PageContent/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blocks_Navigation__ = __webpack_require__("./src/blocks/Navigation/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_window_or_global__ = __webpack_require__("./node_modules/window-or-global/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_PageNotFound__ = __webpack_require__("./src/pages/PageNotFound/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_get__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable no-return-assign,react/prop-types,react/no-unused-state */var Product=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('coreStore','productsStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(_class=function(_Component){_inherits(Product,_Component);function Product(props){_classCallCheck(this,Product);var _this=_possibleConstructorReturn(this,(Product.__proto__||Object.getPrototypeOf(Product)).call(this,props));var _this$props=_this.props,productsStore=_this$props.productsStore,slug=_this$props.match.params.slug;productsStore.setCurrentProductByUrlSlug(slug);return _this;}_createClass(Product,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var productsStore=this.props.productsStore;var prevSlug=__WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(prevProps,'match.params.slug');var slug=__WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(this.props,'match.params.slug');if(prevSlug!==slug){productsStore.setCurrentProductByUrlSlug(slug);__WEBPACK_IMPORTED_MODULE_6_window_or_global___default.a.scrollTo(0,0);}}},{key:'render',value:function render(){var _props=this.props,_props$productsStore=_props.productsStore,currentProduct=_props$productsStore.currentProduct,loadingCurrentProduct=_props$productsStore.loadingCurrentProduct,parsedStructure=_props$productsStore.parsedStructure,pathname=_props.location.pathname;if(loadingCurrentProduct){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_blocks_SplashScreen_index__["a" /* default */],null);}if(!currentProduct){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_pages_PageNotFound__["a" /* default */],null);}var isSupportProducts=(''+pathname).includes('support');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_blocks_InjectMetaTags_index__["a" /* default */],Object.assign({},currentProduct.SEO,{pathname:pathname})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_blocks_Navigation__["a" /* default */],{parsedStructure:parsedStructure,isSupportProducts:isSupportProducts}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_blocks_PageContent__["a" /* default */],{parsedStructure:parsedStructure}));}}]);return Product;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (Product);

/***/ }),

/***/ "./src/pages/Regulations/index.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppRegulations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blocks_Navigation__ = __webpack_require__("./src/blocks/Navigation/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blocks_NavigationAwarePageContent__ = __webpack_require__("./src/blocks/NavigationAwarePageContent/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_window_or_global__ = __webpack_require__("./node_modules/window-or-global/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blocks_Regulations__ = __webpack_require__("./src/blocks/Regulations/index.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react__ = __webpack_require__("./node_modules/mobx-react/index.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__stores_App_store__ = __webpack_require__("./src/stores/App.store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_blocks_InjectMetaTags__ = __webpack_require__("./src/blocks/InjectMetaTags/index.jsx");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RegulationsPage=(_dec=Object(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["inject"])('appStore','coreStore'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["observer"])(_class=function(_Component){_inherits(RegulationsPage,_Component);function RegulationsPage(){_classCallCheck(this,RegulationsPage);return _possibleConstructorReturn(this,(RegulationsPage.__proto__||Object.getPrototypeOf(RegulationsPage)).apply(this,arguments));}_createClass(RegulationsPage,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_4_window_or_global___default.a.scrollTo(0,0);}},{key:'componentDidUpdate',value:function componentDidUpdate(){__WEBPACK_IMPORTED_MODULE_4_window_or_global___default.a.scrollTo(0,0);}},{key:'render',value:function render(){var _props=this.props,isAppRegulations=_props.isAppRegulations,_props$coreStore$cont=_props.coreStore.content,termsOfUseSEO=_props$coreStore$cont.termsOfUseSEO,appRegulationsSEO=_props$coreStore$cont.appRegulationsSEO;var SEO=isAppRegulations?appRegulationsSEO:termsOfUseSEO;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_blocks_InjectMetaTags__["a" /* default */],SEO),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_blocks_Navigation__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_blocks_NavigationAwarePageContent__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_blocks_Regulations__["a" /* default */],{isAppRegulations:isAppRegulations})));}}]);return RegulationsPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);RegulationsPage.propTypes={appStore:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_7__stores_App_store__["a" /* AppStore */]).isRequired,isAppRegulations:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};RegulationsPage.defaultProps={isAppRegulations:false};var AppRegulations=function AppRegulations(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RegulationsPage,Object.assign({isAppRegulations:true},props));};/* harmony default export */ __webpack_exports__["a"] = (RegulationsPage);

/***/ }),

/***/ "./src/registerServiceWorker.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = unregister;
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
/* Disable ESlint rule for this file *//* eslint-disable*/var isLocalhost=Boolean(window.location.hostname==='localhost'// [::1] is the IPv6 localhost address.
||window.location.hostname==='[::1]'// 127.0.0.1/8 is considered localhost for IPv4.
||window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),

/***/ "./src/services/Blog.service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__ = __webpack_require__("./src/common/consts/kentico.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kenticoClient__ = __webpack_require__("./src/services/kenticoClient.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Language_service__ = __webpack_require__("./src/services/Language.service.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var BlogService=function(){function BlogService(){_classCallCheck(this,BlogService);this.client=__WEBPACK_IMPORTED_MODULE_3__kenticoClient__["a" /* default */];}_createClass(BlogService,[{key:'fetchArticlesDetails',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var query;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:query=this.client.items().type(__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].BLOG_ARTICLE).equalsFilter('system.language',__WEBPACK_IMPORTED_MODULE_4__Language_service__["a" /* default */].getLanguage()).elementsParameter(['listing___image','title','slug','related_products','article_author','name','description','image','position','categories__blog_category','main_category__blog_category']).orderParameter('elements.publication_date',__WEBPACK_IMPORTED_MODULE_1_kentico_cloud_delivery__["SortOrder"].desc);return _context.abrupt('return',query.getPromise());case 2:case'end':return _context.stop();}}},_callee,this);}));function fetchArticlesDetails(){return _ref.apply(this,arguments);}return fetchArticlesDetails;}()},{key:'fetchLatestArticle',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(fallback){var query;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:query=this.client.items().type(__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].BLOG_ARTICLE).equalsFilter('system.language',__WEBPACK_IMPORTED_MODULE_4__Language_service__["a" /* default */].getLanguage()).depthParameter(10).limitParameter(1).orderParameter('elements.publication_date',__WEBPACK_IMPORTED_MODULE_1_kentico_cloud_delivery__["SortOrder"].desc);if(!fallback){query.equalsFilter('elements.promoted__promoted[any]','yes');}return _context2.abrupt('return',query.getPromise());case 3:case'end':return _context2.stop();}}},_callee2,this);}));function fetchLatestArticle(_x){return _ref2.apply(this,arguments);}return fetchLatestArticle;}()},{key:'getArticleBySlug',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(slug){var query;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:query=this.client.items().type(__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].BLOG_ARTICLE).depthParameter(10).equalsFilter('elements.slug',slug);return _context3.abrupt('return',query.getPromise());case 2:case'end':return _context3.stop();}}},_callee3,this);}));function getArticleBySlug(_x2){return _ref3.apply(this,arguments);}return getArticleBySlug;}()}]);return BlogService;}();/* harmony default export */ __webpack_exports__["a"] = (new BlogService());

/***/ }),

/***/ "./src/services/Core.service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__ = __webpack_require__("./src/common/consts/kentico.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__kenticoClient__ = __webpack_require__("./src/services/kenticoClient.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/* eslint-disable no-console */var CoreService=function(){function CoreService(){_classCallCheck(this,CoreService);this.client=__WEBPACK_IMPORTED_MODULE_2__kenticoClient__["a" /* default */];}_createClass(CoreService,[{key:'fetchCoreData',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var coreDataItems;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return this.client.items().type(__WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].CORE).depthParameter(5).getPromise();case 3:coreDataItems=_context.sent;if(!coreDataItems.isEmpty){_context.next=6;break;}return _context.abrupt('return',null);case 6:return _context.abrupt('return',coreDataItems.lastItem);case 9:_context.prev=9;_context.t0=_context['catch'](0);console.log('Failed to fetch core data',_context.t0);return _context.abrupt('return',null);case 13:case'end':return _context.stop();}}},_callee,this,[[0,9]]);}));function fetchCoreData(){return _ref.apply(this,arguments);}return fetchCoreData;}()}]);return CoreService;}();/* harmony default export */ __webpack_exports__["a"] = (new CoreService());

/***/ }),

/***/ "./src/services/Country.service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isoCountries={AF:'Afghanistan',AX:'Aland Islands',AL:'Albania',DZ:'Algeria',AS:'American Samoa',AD:'Andorra',AO:'Angola',AI:'Anguilla',AQ:'Antarctica',AG:'Antigua And Barbuda',AR:'Argentina',AM:'Armenia',AW:'Aruba',AU:'Australia',AT:'Austria',AZ:'Azerbaijan',BS:'Bahamas',BH:'Bahrain',BD:'Bangladesh',BB:'Barbados',BY:'Belarus',BE:'Belgium',BZ:'Belize',BJ:'Benin',BM:'Bermuda',BT:'Bhutan',BO:'Bolivia',BA:'Bosnia And Herzegovina',BW:'Botswana',BV:'Bouvet Island',BR:'Brazil',IO:'British Indian Ocean Territory',BN:'Brunei Darussalam',BG:'Bulgaria',BF:'Burkina Faso',BI:'Burundi',KH:'Cambodia',CM:'Cameroon',CA:'Canada',CV:'Cape Verde',KY:'Cayman Islands',CF:'Central African Republic',TD:'Chad',CL:'Chile',CN:'China',CX:'Christmas Island',CC:'Cocos (Keeling) Islands',CO:'Colombia',KM:'Comoros',CG:'Congo',CD:'Congo, Democratic Republic',CK:'Cook Islands',CR:'Costa Rica',CI:'Cote D\'Ivoire',HR:'Croatia',CU:'Cuba',CY:'Cyprus',CZ:'Czech Republic',DK:'Denmark',DJ:'Djibouti',DM:'Dominica',DO:'Dominican Republic',EC:'Ecuador',EG:'Egypt',SV:'El Salvador',GQ:'Equatorial Guinea',ER:'Eritrea',EE:'Estonia',ET:'Ethiopia',FK:'Falkland Islands (Malvinas)',FO:'Faroe Islands',FJ:'Fiji',FI:'Finland',FR:'France',GF:'French Guiana',PF:'French Polynesia',TF:'French Southern Territories',GA:'Gabon',GM:'Gambia',GE:'Georgia',DE:'Germany',GH:'Ghana',GI:'Gibraltar',GR:'Greece',GL:'Greenland',GD:'Grenada',GP:'Guadeloupe',GU:'Guam',GT:'Guatemala',GG:'Guernsey',GN:'Guinea',GW:'Guinea-Bissau',GY:'Guyana',HT:'Haiti',HM:'Heard Island & Mcdonald Islands',VA:'Holy See (Vatican City State)',HN:'Honduras',HK:'Hong Kong',HU:'Hungary',IS:'Iceland',IN:'India',ID:'Indonesia',IR:'Iran, Islamic Republic Of',IQ:'Iraq',IE:'Ireland',IM:'Isle Of Man',IL:'Israel',IT:'Italy',JM:'Jamaica',JP:'Japan',JE:'Jersey',JO:'Jordan',KZ:'Kazakhstan',KE:'Kenya',KI:'Kiribati',KR:'Korea',KW:'Kuwait',KG:'Kyrgyzstan',LA:'Lao People\'s Democratic Republic',LV:'Latvia',LB:'Lebanon',LS:'Lesotho',LR:'Liberia',LY:'Libyan Arab Jamahiriya',LI:'Liechtenstein',LT:'Lithuania',LU:'Luxembourg',MO:'Macao',MK:'Macedonia',MG:'Madagascar',MW:'Malawi',MY:'Malaysia',MV:'Maldives',ML:'Mali',MT:'Malta',MH:'Marshall Islands',MQ:'Martinique',MR:'Mauritania',MU:'Mauritius',YT:'Mayotte',MX:'Mexico',FM:'Micronesia, Federated States Of',MD:'Moldova',MC:'Monaco',MN:'Mongolia',ME:'Montenegro',MS:'Montserrat',MA:'Morocco',MZ:'Mozambique',MM:'Myanmar',NA:'Namibia',NR:'Nauru',NP:'Nepal',NL:'Netherlands',AN:'Netherlands Antilles',NC:'New Caledonia',NZ:'New Zealand',NI:'Nicaragua',NE:'Niger',NG:'Nigeria',NU:'Niue',NF:'Norfolk Island',MP:'Northern Mariana Islands',NO:'Norway',OM:'Oman',PK:'Pakistan',PW:'Palau',PS:'Palestinian Territory, Occupied',PA:'Panama',PG:'Papua New Guinea',PY:'Paraguay',PE:'Peru',PH:'Philippines',PN:'Pitcairn',PL:'Poland',PT:'Portugal',PR:'Puerto Rico',QA:'Qatar',RE:'Reunion',RO:'Romania',RU:'Russian Federation',RW:'Rwanda',BL:'Saint Barthelemy',SH:'Saint Helena',KN:'Saint Kitts And Nevis',LC:'Saint Lucia',MF:'Saint Martin',PM:'Saint Pierre And Miquelon',VC:'Saint Vincent And Grenadines',WS:'Samoa',SM:'San Marino',ST:'Sao Tome And Principe',SA:'Saudi Arabia',SN:'Senegal',RS:'Serbia',SC:'Seychelles',SL:'Sierra Leone',SG:'Singapore',SK:'Slovakia',SI:'Slovenia',SB:'Solomon Islands',SO:'Somalia',ZA:'South Africa',GS:'South Georgia And Sandwich Isl.',ES:'Spain',LK:'Sri Lanka',SD:'Sudan',SR:'Suriname',SJ:'Svalbard And Jan Mayen',SZ:'Swaziland',SE:'Sweden',CH:'Switzerland',SY:'Syrian Arab Republic',TW:'Taiwan',TJ:'Tajikistan',TZ:'Tanzania',TH:'Thailand',TL:'Timor-Leste',TG:'Togo',TK:'Tokelau',TO:'Tonga',TT:'Trinidad And Tobago',TN:'Tunisia',TR:'Turkey',TM:'Turkmenistan',TC:'Turks And Caicos Islands',TV:'Tuvalu',UG:'Uganda',UA:'Ukraine',AE:'United Arab Emirates',GB:'United Kingdom',US:'United States',UM:'United States Outlying Islands',UY:'Uruguay',UZ:'Uzbekistan',VU:'Vanuatu',VE:'Venezuela',VN:'Viet Nam',VG:'Virgin Islands, British',VI:'Virgin Islands, U.S.',WF:'Wallis And Futuna',EH:'Western Sahara',YE:'Yemen',ZM:'Zambia',ZW:'Zimbabwe'};function getCountryName(countryCode){if(Object.prototype.hasOwnProperty.call(isoCountries,countryCode)){return isoCountries[countryCode];}return countryCode;}/* harmony default export */ __webpack_exports__["a"] = (getCountryName);

/***/ }),

/***/ "./src/services/DebugOptions.service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_window_or_global__ = __webpack_require__("./node_modules/window-or-global/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_consts_debugOptionConsts__ = __webpack_require__("./src/common/consts/debugOptionConsts.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/* eslint-disable no-underscore-dangle */var DebugOptionsService=(_temp=_class=function(){function DebugOptionsService(){_classCallCheck(this,DebugOptionsService);}_createClass(DebugOptionsService,null,[{key:'isDebug',// model defines which values can be used
value:function isDebug(){return "false"==='true';}},{key:'getDebugOptions',value:function getDebugOptions(){try{var options=JSON.parse(__WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_1_common_consts_debugOptionConsts__["a" /* DEBUG_CONFIG_SESSION_STORAGE_KEY */]));if(options){return options;}}catch(e){return DebugOptionsService.defaultDebugOptions;}return DebugOptionsService.defaultDebugOptions;}},{key:'getDebugOptionsModel',value:function getDebugOptionsModel(){return DebugOptionsService.optionsModel;}},{key:'subscribe',value:function subscribe(observerFunction){DebugOptionsService._subscribers.push(observerFunction);}},{key:'unsubscribe',value:function unsubscribe(observerFunction){DebugOptionsService._subscribers=DebugOptionsService._subscribers.filter(function(func){return func!==observerFunction;});}},{key:'_tellAboutChanges',value:function _tellAboutChanges(changes){DebugOptionsService._subscribers.forEach(function(observerFunction){return observerFunction(changes);});}},{key:'setDebugOptions',value:function setDebugOptions(options){__WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.sessionStorage.setItem(__WEBPACK_IMPORTED_MODULE_1_common_consts_debugOptionConsts__["a" /* DEBUG_CONFIG_SESSION_STORAGE_KEY */],JSON.stringify(options));DebugOptionsService._tellAboutChanges(options);}},{key:'setDebugOptionValueByName',value:function setDebugOptionValueByName(optionName,optionValue){var currentOptions=DebugOptionsService.getDebugOptions();if(currentOptions!=null){var checkedOptions=DebugOptionsService.getDebugOptions().map(function(currentOption){if(currentOption.name===optionName){var newOption=Object.assign({},currentOption);newOption.value=optionValue;return newOption;}return currentOption;});DebugOptionsService.setDebugOptions(checkedOptions);}}},{key:'getOptionValueByName',value:function getOptionValueByName(optionName){var debugOptions=DebugOptionsService.getDebugOptions();return debugOptions?debugOptions.find(function(option){return option.name===optionName;}).value:null;}}]);return DebugOptionsService;}(),_class._subscribers=[],_class.optionsModel=[{name:__WEBPACK_IMPORTED_MODULE_1_common_consts_debugOptionConsts__["c" /* DEBUG_OPTION_MODE */],values:[__WEBPACK_IMPORTED_MODULE_1_common_consts_debugOptionConsts__["f" /* DEBUG_VALUE_MODE_PREVIEW */],__WEBPACK_IMPORTED_MODULE_1_common_consts_debugOptionConsts__["g" /* DEBUG_VALUE_MODE_PUBLISHED */]],reloadOnChange:true},/* {
      name: DEBUG_OPTION_LANGUAGE,
      values: [DEBUG_VALUE_LANGUAGE_ENGLISH, DEBUG_VALUE_LANGUAGE_POLISH],
      reloadOnChange: true,
    }, */{name:__WEBPACK_IMPORTED_MODULE_1_common_consts_debugOptionConsts__["b" /* DEBUG_OPTION_GRID */],reloadOnChange:false,values:[__WEBPACK_IMPORTED_MODULE_1_common_consts_debugOptionConsts__["d" /* DEBUG_VALUE_GRID_OFF */],__WEBPACK_IMPORTED_MODULE_1_common_consts_debugOptionConsts__["e" /* DEBUG_VALUE_GRID_ON */]]}],_class.defaultDebugOptions=[{name:__WEBPACK_IMPORTED_MODULE_1_common_consts_debugOptionConsts__["c" /* DEBUG_OPTION_MODE */],value:__WEBPACK_IMPORTED_MODULE_1_common_consts_debugOptionConsts__["f" /* DEBUG_VALUE_MODE_PREVIEW */]},/* {
      name: DEBUG_OPTION_LANGUAGE,
      value: DEBUG_VALUE_LANGUAGE_ENGLISH,
    }, */{name:__WEBPACK_IMPORTED_MODULE_1_common_consts_debugOptionConsts__["b" /* DEBUG_OPTION_GRID */],value:__WEBPACK_IMPORTED_MODULE_1_common_consts_debugOptionConsts__["d" /* DEBUG_VALUE_GRID_OFF */]}],_temp);/* harmony default export */ __webpack_exports__["a"] = (DebugOptionsService);

/***/ }),

/***/ "./src/services/ForInvestors.service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__ = __webpack_require__("./src/common/consts/kentico.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__kenticoClient__ = __webpack_require__("./src/services/kenticoClient.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/* eslint-disable no-console */var ForInvestorsService=function(){function ForInvestorsService(){_classCallCheck(this,ForInvestorsService);this.client=__WEBPACK_IMPORTED_MODULE_2__kenticoClient__["a" /* default */];}_createClass(ForInvestorsService,[{key:'fetchInvestorsData',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var forInvestorsDataItems;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return this.client.items().type(__WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].FOR_INVESTORS).depthParameter(5).getPromise();case 3:forInvestorsDataItems=_context.sent;if(!forInvestorsDataItems.isEmpty){_context.next=6;break;}return _context.abrupt('return',null);case 6:return _context.abrupt('return',forInvestorsDataItems.lastItem);case 9:_context.prev=9;_context.t0=_context['catch'](0);console.log('Failed to fetch core data',_context.t0);return _context.abrupt('return',null);case 13:case'end':return _context.stop();}}},_callee,this,[[0,9]]);}));function fetchInvestorsData(){return _ref.apply(this,arguments);}return fetchInvestorsData;}()}]);return ForInvestorsService;}();/* harmony default export */ __webpack_exports__["a"] = (new ForInvestorsService());

/***/ }),

/***/ "./src/services/GlobalMetaTags.service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__ = __webpack_require__("./src/common/consts/kentico.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__kenticoClient__ = __webpack_require__("./src/services/kenticoClient.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var GlobalMetaTagsService=function(){function GlobalMetaTagsService(){_classCallCheck(this,GlobalMetaTagsService);}_createClass(GlobalMetaTagsService,null,[{key:'fetchMetaTagsData',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var items;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return __WEBPACK_IMPORTED_MODULE_2__kenticoClient__["a" /* default */].items().type(__WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].GLOBAL_META_TAGS).getPromise();case 2:items=_context.sent;if(!items.isEmpty){_context.next=5;break;}return _context.abrupt('return',null);case 5:return _context.abrupt('return',items.lastItem);case 6:case'end':return _context.stop();}}},_callee,this);}));function fetchMetaTagsData(){return _ref.apply(this,arguments);}return fetchMetaTagsData;}()}]);return GlobalMetaTagsService;}();/* harmony default export */ __webpack_exports__["a"] = (GlobalMetaTagsService);

/***/ }),

/***/ "./src/services/Inbound.service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_cookie__ = __webpack_require__("./node_modules/universal-cookie/es6/index.js");
var getDataFromURL=function getDataFromURL(){var cookies=new __WEBPACK_IMPORTED_MODULE_0_universal_cookie__["a" /* default */]();var inbound='';var browsers=['www.google.com','www.bing.com','www.yahoo.com','www.baidu.com','www.yandex.com','duckduckgo.com','search.aol.com','www.ask.com','www.wolframalpha.com','archive.org','www.startpage.com','www.qwant.com','search.creativecommons.org','gibiru.com','www.ecosia.org','www.dogpile.com','www.excite.com','www.goodsearch.com','www.lycos.com','metager.org'];var valueExists=function valueExists(value){return value!=null&&value!==''&&value!==undefined;};var socialMedias=['facebook','instagram','tiktok','twitter','linkedin'];var referrer='';if(valueExists(document.referrer)){referrer=new URL(document.referrer).hostname;if(!referrer.includes('zonifero')){if(browsers.find(function(domain){return referrer.includes(domain);})){inbound='Inbound - Organic';}else if(referrer.includes('clutch')){inbound='Inbound - Clutch';}else if(socialMedias.find(function(utm){return referrer.includes(utm);})){inbound='Inbound - Social Media';}else{inbound='Inbound - Referral';}cookies.set('inbound',inbound);}}else{inbound='Inbound - Direct';cookies.set('inbound',inbound);}};/* harmony default export */ __webpack_exports__["a"] = (getDataFromURL);

/***/ }),

/***/ "./src/services/KenticoStructureParser.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_consts_kentico__ = __webpack_require__("./src/common/consts/kentico.js");
var arrangeKenticoStructure=function arrangeKenticoStructure(content){if(!content){return[];}var structure=content.structure;if(!structure){return[];}return structure.reduce(function(accumulator,currentValue){if(currentValue.system.type===__WEBPACK_IMPORTED_MODULE_0_common_consts_kentico__["c" /* KENTICO_TYPES */].NAVIGATOR){accumulator[accumulator.length]={sectionName:currentValue.menu_link_name.text,urlSlug:currentValue.product_slugs&&currentValue.product_slugs.value&&currentValue.product_slugs.value.length>0?currentValue.product_slugs.value[0].name:null,models:[]};}else if(accumulator[accumulator.length-1]&&accumulator[accumulator.length-1].models){accumulator[accumulator.length-1].models.push(currentValue);}return accumulator;},[]);};/* harmony default export */ __webpack_exports__["a"] = (arrangeKenticoStructure);

/***/ }),

/***/ "./src/services/Language.service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_window_or_global__ = __webpack_require__("./node_modules/window-or-global/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_consts_languages__ = __webpack_require__("./src/common/consts/languages.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_consts_anchor__ = __webpack_require__("./src/common/consts/anchor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_consts_anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_consts_anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_methods_language__ = __webpack_require__("./src/common/methods/language.js");
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var LanguageService=(_temp=_class=function(){function LanguageService(){_classCallCheck(this,LanguageService);}_createClass(LanguageService,null,[{key:'setLanguage',value:function setLanguage(language){if(language){__WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1_common_consts_languages__["d" /* LANGUAGE_STORAGE_KEY */],language);}else{__WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_1_common_consts_languages__["d" /* LANGUAGE_STORAGE_KEY */]);}}},{key:'createLink',value:function createLink(language,pathname){var params=LanguageService.getParamsFromPathname(pathname);var anchor=LanguageService.getAnchorFromPathname('/'+params.slug);return Object(__WEBPACK_IMPORTED_MODULE_4__common_methods_language__["a" /* languagePathJoin */])(language,anchor[language],params[0]);}},{key:'getAnchorFromPathname',value:function getAnchorFromPathname(pathname){var key=Object.keys(__WEBPACK_IMPORTED_MODULE_2_common_consts_anchor___default.a).find(function(a){return Object.values(__WEBPACK_IMPORTED_MODULE_2_common_consts_anchor___default.a[a]).includes(pathname);});return __WEBPACK_IMPORTED_MODULE_2_common_consts_anchor___default.a[key]||{};}},{key:'getParamsFromPathname',value:function getParamsFromPathname(pathname){var match=Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["matchPath"])(pathname+'/',{path:'/:lang(.{2})?/:slug([^/]*)?/*'});return match&&match.params;}},{key:'getLanguageFromUrl',value:function getLanguageFromUrl(){var _root$location$pathna=__WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.location.pathname.split('/'),_root$location$pathna2=_slicedToArray(_root$location$pathna,2),lang=_root$location$pathna2[1];return lang&&lang.length===2?lang.toLowerCase():undefined;}},{key:'getLanguageFromLocalStorage',value:function getLanguageFromLocalStorage(){return __WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_1_common_consts_languages__["d" /* LANGUAGE_STORAGE_KEY */])||undefined;}},{key:'getLanguageFromNavigator',value:function getLanguageFromNavigator(){var navigator=__WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.navigator;var language=navigator.language||navigator.userLanguage||'';var _language$split=language.split(/[-_]/),_language$split2=_slicedToArray(_language$split,1),languageCode=_language$split2[0];return languageCode?languageCode.toLowerCase():undefined;}},{key:'updateLanguageLocalStorage',value:function updateLanguageLocalStorage(language){var current=LanguageService.getLanguageFromLocalStorage();if(current!==language){LanguageService.setLanguage(language!==__WEBPACK_IMPORTED_MODULE_1_common_consts_languages__["b" /* DEFAULT_LANGUAGE */]&&language);}}},{key:'hasLanguageAvailable',value:function hasLanguageAvailable(language){return Object.values(__WEBPACK_IMPORTED_MODULE_1_common_consts_languages__["c" /* LANGUAGES */]).some(function(lang){return lang.value===language;});}},{key:'getLanguage',value:function getLanguage(){var language=LanguageService.getLanguageFromLocalStorage()||LanguageService.getLanguageFromUrl()||LanguageService.getLanguageFromNavigator();return LanguageService.hasLanguageAvailable(language)?language:__WEBPACK_IMPORTED_MODULE_1_common_consts_languages__["b" /* DEFAULT_LANGUAGE */];}},{key:'getInitialLanguage',value:function getInitialLanguage(){var language=LanguageService.getLanguage();LanguageService.updateLanguageLocalStorage(language);return language;}},{key:'getLanguageByRouteLogic',value:function getLanguageByRouteLogic(pathname,prevPathname){var current=LanguageService.getParamsFromPathname(pathname);var prev=LanguageService.getParamsFromPathname(prevPathname);//  /*TEMPORARY DISABLED  */
// if (current.slug === LanguageService.BLOG_SLUG) {
//   return {
//     language: !LanguageService.BLOG_LANGUAGES.includes(current.lang)
//       ? LanguageService.BLOG_LANGUAGES[0]
//       : current.lang,
//   };
// }
// if (prev.slug === LanguageService.BLOG_SLUG) {
//   const fromLocalStorage = LanguageService.getLanguageFromLocalStorage();
//   return {
//     language:
//       current.lang !== fromLocalStorage ? fromLocalStorage : current.lang,
//   };
// }
return{language:current.lang,shouldSave:true};}}]);return LanguageService;}(),_class.BLOG_LANGUAGES=[__WEBPACK_IMPORTED_MODULE_1_common_consts_languages__["c" /* LANGUAGES */].EN.value,__WEBPACK_IMPORTED_MODULE_1_common_consts_languages__["c" /* LANGUAGES */].PL.value],_class.BLOG_SLUG='blog',_temp);/* harmony default export */ __webpack_exports__["a"] = (LanguageService);

/***/ }),

/***/ "./src/services/Mailing.service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_window_or_global__ = __webpack_require__("./node_modules/window-or-global/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("./node_modules/axios/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_universal_cookie__ = __webpack_require__("./node_modules/universal-cookie/es6/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Country_service__ = __webpack_require__("./src/services/Country.service.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/* eslint-disable class-methods-use-this */var URLContactForm="https://prod-11.westeurope.logic.azure.com:443/workflows/469daeb9e0814284944a6823e010e5a8/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=LDw4OCmhrzknYryf6NZR0l3HUvOO4sOrJ4KrLNKgQF4";var URLContactSupportForm="https://prod-16.westeurope.logic.azure.com:443/workflows/07509f2760d64838bdf665f7d4c46e93/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=RU0-XCUoC4Qpr8vUzhRzGqBG6tSvXSkO9nkxjqaxCPI";var URLNewsletter="https://zonifero-new-www-dev-linux-fap.azurewebsites.net/api/getResponse";var URLPipedrive="https://thg-d-www-pipedrive-fap.azurewebsites.net/api/postnote?code=Ils3YzEnC4e_eucIqh-bmAFyZfiILKHctzHGfhApQ46-AzFun4AhSA%3D%3D";var SecretKey="6Ld2rL0kAAAAAMu9_rMrS0HMhPpbzlO9L11OpDSS";var MailingService=function(){function MailingService(){_classCallCheck(this,MailingService);}_createClass(MailingService,[{key:'sendContactForm',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref){var firstName=_ref.firstName,lastName=_ref.lastName,phone=_ref.phone,email=_ref.email,body=_ref.body,url=_ref.url,source=_ref.source,referrer=_ref.referrer;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:return _context.abrupt('return',__WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.fetch(URLContactForm,{method:'POST',body:JSON.stringify({firstName:firstName,lastName:lastName,phone:phone,email:email,body:body,url:url,source:source,referrer:referrer}),headers:{'Content-Type':'application/json'}}).then(function(res){return res.ok?true:Promise.reject(res);}));case 1:case'end':return _context.stop();}}},_callee,this);}));function sendContactForm(_x){return _ref2.apply(this,arguments);}return sendContactForm;}()},{key:'sendNewsletter',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3){var email=_ref3.email;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:return _context2.abrupt('return',__WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.fetch(URLNewsletter,{method:'POST',body:JSON.stringify({email:email}),headers:{'Content-Type':'application/json'}}).then(function(res){return res.ok?true:Promise.reject(res);}));case 1:case'end':return _context2.stop();}}},_callee2,this);}));function sendNewsletter(_x2){return _ref4.apply(this,arguments);}return sendNewsletter;}()},{key:'sendContactSupportForm',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref5){var firstName=_ref5.firstName,lastName=_ref5.lastName,phone=_ref5.phone,email=_ref5.email,body=_ref5.body,company=_ref5.company,system=_ref5.system,osVersion=_ref5.osVersion,url=_ref5.url,source=_ref5.source,referrer=_ref5.referrer;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:return _context3.abrupt('return',__WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.fetch(URLContactSupportForm,{method:'POST',body:JSON.stringify({name:firstName+' '+lastName,phone:phone,email:email,message:body,company:company,system:system,osVersion:osVersion,url:url,source:source,referrer:referrer}),headers:{'Content-Type':'application/json'}}).then(function(res){return res.ok?true:Promise.reject(res);}));case 1:case'end':return _context3.stop();}}},_callee3,this);}));function sendContactSupportForm(_x3){return _ref6.apply(this,arguments);}return sendContactSupportForm;}()},{key:'sendPipedrive',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(data){var cookies;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.prev=0;cookies=new __WEBPACK_IMPORTED_MODULE_3_universal_cookie__["a" /* default */]();__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(URLPipedrive,{name:'jakub.skrzypek@zonifero.com',content:data,person:{name:data.firstName+' '+data.lastName,email:data.email,phone:data.phone,country:Object(__WEBPACK_IMPORTED_MODULE_4__Country_service__["a" /* default */])(data.country)},marketingAgreement:false,inbound:cookies.get('inbound')||'Inbound - Unidentified',businessUnit:'Zonifero'});return _context4.abrupt('return',true);case 6:_context4.prev=6;_context4.t0=_context4['catch'](0);return _context4.abrupt('return',false);case 9:case'end':return _context4.stop();}}},_callee4,this,[[0,6]]);}));function sendPipedrive(_x4){return _ref7.apply(this,arguments);}return sendPipedrive;}()},{key:'spamBotDetected',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(clientIP,action,token){var data,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(clientIP){_context5.next=2;break;}return _context5.abrupt('return');case 2:_context5.prev=2;data={clientIP:clientIP,action:action,captchaUrl:action==='submit'&&token?'https://www.google.com/recaptcha/api/siteverify?secret='+SecretKey+'&response='+token:''};_context5.next=6;return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://swh-p-spambotprot-fap.azurewebsites.net/api/SpamBotProtection",data);case 6:res=_context5.sent;if(!(res.status===202)){_context5.next=9;break;}return _context5.abrupt('return',true);case 9:if(!(res.status===200)){_context5.next=11;break;}return _context5.abrupt('return',false);case 11:_context5.next=16;break;case 13:_context5.prev=13;_context5.t0=_context5['catch'](2);return _context5.abrupt('return',true);case 16:case'end':return _context5.stop();}}},_callee5,this,[[2,13]]);}));function spamBotDetected(_x5,_x6,_x7){return _ref8.apply(this,arguments);}return spamBotDetected;}()}]);return MailingService;}();/* harmony default export */ __webpack_exports__["a"] = (new MailingService());

/***/ }),

/***/ "./src/services/Products.service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__ = __webpack_require__("./src/common/consts/kentico.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_methods_string__ = __webpack_require__("./src/common/methods/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kenticoClient__ = __webpack_require__("./src/services/kenticoClient.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/* eslint-disable no-console */var ProductsService=function(){function ProductsService(){_classCallCheck(this,ProductsService);this.client=__WEBPACK_IMPORTED_MODULE_3__kenticoClient__["a" /* default */];}_createClass(ProductsService,[{key:'fetchProductByUrlSlug',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(slug){var slugCodename,items;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;slugCodename=Object(__WEBPACK_IMPORTED_MODULE_2_common_methods_string__["h" /* slashesToDashes */])(slug);_context.next=4;return this.client.items().type(__WEBPACK_IMPORTED_MODULE_1_common_consts_kentico__["c" /* KENTICO_TYPES */].PRODUCT).containsFilter('elements.product_slugs',[slugCodename]).depthParameter(10).getPromise();case 4:items=_context.sent;if(!items.isEmpty){_context.next=7;break;}return _context.abrupt('return',null);case 7:return _context.abrupt('return',items.lastItem);case 10:_context.prev=10;_context.t0=_context['catch'](0);console.error('Failed to fetch product data',_context.t0);return _context.abrupt('return',null);case 14:case'end':return _context.stop();}}},_callee,this,[[0,10]]);}));function fetchProductByUrlSlug(_x){return _ref.apply(this,arguments);}return fetchProductByUrlSlug;}()}]);return ProductsService;}();/* harmony default export */ __webpack_exports__["a"] = (new ProductsService());

/***/ }),

/***/ "./src/services/kenticoClient.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_DebugOptions_service__ = __webpack_require__("./src/services/DebugOptions.service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__ = __webpack_require__("./src/common/consts/kentico.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_models__ = __webpack_require__("./src/models/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_consts_debugOptionConsts__ = __webpack_require__("./src/common/consts/debugOptionConsts.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_Language_service__ = __webpack_require__("./src/services/Language.service.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable max-len *//* Disable ESlint rule for this file *//* eslint no-console: "off" */// configure type resolvers
var typeResolvers=[new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].PRODUCT,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["T" /* Product */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].COLUMN,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["p" /* Column */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].HERO_IMAGE,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["H" /* HeroImage */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].THREE_COLUMN_GRID,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["_0" /* ThreeColumnGrid */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].HEADER,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["G" /* Header */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].ACCORDION,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["a" /* Accordion */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].ACCORDION_ITEM,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["b" /* AccordionItem */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].BANNER,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["e" /* Banner */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].SIMPLE_ACCORDION,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["Y" /* SimpleAccordion */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].SIMPLE_ACCORDION_ITEM,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["Z" /* SimpleAccordionItem */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].CARD_SLIDER,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["o" /* CardSlider */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].CARD_SLIDE,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["n" /* CardSlide */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].DOWNLOAD_BAR,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["x" /* DownloadBar */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].FILE_LINK,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["A" /* File */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].TWO_COLUMN_GRID,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["_3" /* TwoColumnGrid */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].IMAGED_SECTION,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["N" /* ImagedSection */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].CONTACT_FORM,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["q" /* ContactForm */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].CONTACT_FORM_SUPPORT,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["r" /* ContactFormSupport */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].IMAGE_SLIDE,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["L" /* ImageSlide */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].IMAGE_SLIDER,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["M" /* ImageSlider */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].CALL_US,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["m" /* CallUs */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].CONTACT_PERSON,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["s" /* ContactPerson */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].ContactLink,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["O" /* Link */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].HORIZONTALLY_NAVIGABLE_CONTENT,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["I" /* HorizontallyNavigableContent */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].CONTENT_WITH_HEADER,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["t" /* ContentWithHeader */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].SEO,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["W" /* SEO */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].SHARE_LINK,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["X" /* ShareLink */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].HTML_MODIFIER,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["J" /* HtmlModifier */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].TRANSLATIONS,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["_2" /* Translations */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].CORE,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["u" /* Core */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].BLOG_ARTICLE,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["f" /* BlogArticle */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].BLOG_AUTHOR,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["g" /* BlogAuthor */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].NEWSLETTER,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["R" /* Newsletter */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].LINK_BANNER,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["P" /* LinkBanner */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].DIVIDED_BLOG_SECTION,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["w" /* DividedBlogSection */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].BLOG_IMAGE_SLIDER,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["j" /* BlogImageSlider */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].BLOG_IMAGE_SLIDE,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["i" /* BlogImageSlide */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].LINK_TO_PRODUCT,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["Q" /* LinkToProduct */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].PRODUCT_SLIDER,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["V" /* ProductSlider */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].PRODUCT_SLIDE,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["U" /* ProductSlide */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].CROPPED_ASSET,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["v" /* CroppedAsset */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].CALCULATOR,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["k" /* Calculator */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].CALCULATOR_VALUE,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["l" /* CalculatorValue */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].BLOG_CATEGORY_TRANSLATION,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["h" /* BlogCategoryTranslation */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].ARTICLE_SLIDE,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["c" /* ArticleSlide */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].ARTICLE_SLIDER,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["d" /* ArticleSlider */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].IMAGE_LINK,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["K" /* ImageLink */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].TITLE_AND_SUBTITLE,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["_1" /* TitleAndSubtitle */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].FAQ_ACCORDION,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["y" /* FAQAccordion */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].FAQ_ACCORDION_ITEM,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["z" /* FAQAccordionItem */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].FOR_INVESTORS,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["B" /* ForInvestorsItems */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].FOR_INVESTORS_SECTION,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["D" /* ForInvestorsSection */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].FOR_INVESTORS_ITEM,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["C" /* ForInvestorsLinkedItem */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].GLOBAL_META_TAGS,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["F" /* GlobalMetaTags */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].GLOBAL_META_TAG,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["E" /* GlobalMetaTag */]();}),new __WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["TypeResolver"](__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["c" /* KENTICO_TYPES */].NEWSLETTER_THANK_YOU_PAGE,function(){return new __WEBPACK_IMPORTED_MODULE_3_models__["S" /* NewsletterThankYouPage */]();})];var isPreview=!!__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["d" /* PREVIEW_API_KEY */];if(isPreview){console.info('PREVIEW MODE IS ENABLED');}var defaultLanguage=__WEBPACK_IMPORTED_MODULE_5_services_Language_service__["a" /* default */].getLanguage();var defaultDeliveryClientOptions={projectId:__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["e" /* PROJECT_ID */],typeResolvers:[].concat(typeResolvers),enablePreviewMode:false,defaultLanguage:defaultLanguage,modularContentResolver:{modularContentWrapperTag:'div'},baseUrl:"https://tender-cms-api.azurewebsites.net",basePreviewUrl:"https://tender-cms-api.azurewebsites.net"};var debugDeliveryClientOptions=__WEBPACK_IMPORTED_MODULE_1_services_DebugOptions_service__["a" /* default */].isDebug()?{projectId:__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["e" /* PROJECT_ID */],typeResolvers:[].concat(typeResolvers),previewApiKey:__WEBPACK_IMPORTED_MODULE_2_common_consts_kentico__["d" /* PREVIEW_API_KEY */],enablePreviewMode:__WEBPACK_IMPORTED_MODULE_1_services_DebugOptions_service__["a" /* default */].getOptionValueByName(__WEBPACK_IMPORTED_MODULE_4_common_consts_debugOptionConsts__["c" /* DEBUG_OPTION_MODE */])===__WEBPACK_IMPORTED_MODULE_4_common_consts_debugOptionConsts__["f" /* DEBUG_VALUE_MODE_PREVIEW */]&&isPreview,defaultLanguage:defaultLanguage,modularContentResolver:{modularContentWrapperTag:'div'},baseUrl:"https://tender-cms-api.azurewebsites.net",basePreviewUrl:"https://tender-cms-api.azurewebsites.net"}:null;var CustomDeliveryClient=function(_DeliveryClient){_inherits(CustomDeliveryClient,_DeliveryClient);function CustomDeliveryClient(){_classCallCheck(this,CustomDeliveryClient);return _possibleConstructorReturn(this,(CustomDeliveryClient.__proto__||Object.getPrototypeOf(CustomDeliveryClient)).apply(this,arguments));}_createClass(CustomDeliveryClient,[{key:'setLanguage',value:function setLanguage(language){if(this.config){this.config.defaultLanguage=language;}}}]);return CustomDeliveryClient;}(__WEBPACK_IMPORTED_MODULE_0_kentico_cloud_delivery__["DeliveryClient"]);/* harmony default export */ __webpack_exports__["a"] = (new CustomDeliveryClient(debugDeliveryClientOptions||defaultDeliveryClientOptions));

/***/ }),

/***/ "./src/stores/App.store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_window_or_global__ = __webpack_require__("./node_modules/window-or-global/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Language_service__ = __webpack_require__("./src/services/Language.service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_kenticoClient__ = __webpack_require__("./src/services/kenticoClient.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_consts_languages__ = __webpack_require__("./src/common/consts/languages.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__history__ = __webpack_require__("./src/history.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var AppStore=(_class=function(){_createClass(AppStore,[{key:'isPolishLanguage',get:function get(){return this.currentLanguage===__WEBPACK_IMPORTED_MODULE_4__common_consts_languages__["c" /* LANGUAGES */].PL.value;}},{key:'isEnglishLanguage',get:function get(){return this.currentLanguage===__WEBPACK_IMPORTED_MODULE_4__common_consts_languages__["c" /* LANGUAGES */].EN.value;}},{key:'isFranceLanguage',get:function get(){return this.currentLanguage===__WEBPACK_IMPORTED_MODULE_4__common_consts_languages__["c" /* LANGUAGES */].FR.value;}}]);function AppStore(){_classCallCheck(this,AppStore);_initDefineProp(this,'currentLanguage',_descriptor,this);_initDefineProp(this,'previousPathname',_descriptor2,this);_initDefineProp(this,'referrer',_descriptor3,this);_initDefineProp(this,'currentUrl',_descriptor4,this);_initDefineProp(this,'previousUrl',_descriptor5,this);this.initStore();}_createClass(AppStore,[{key:'initStore',value:function initStore(){var _this=this;this.checkLanguagePath(__WEBPACK_IMPORTED_MODULE_5__history__["a" /* default */].location.pathname);__WEBPACK_IMPORTED_MODULE_5__history__["a" /* default */].listen(function(location){_this.checkLanguagePath(location.pathname);});}},{key:'setLanguage',value:function setLanguage(language){var saveInStorage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;if(__WEBPACK_IMPORTED_MODULE_2__services_Language_service__["a" /* default */].hasLanguageAvailable(language)){this.currentLanguage=language;__WEBPACK_IMPORTED_MODULE_3__services_kenticoClient__["a" /* default */].setLanguage(language);if(saveInStorage){__WEBPACK_IMPORTED_MODULE_2__services_Language_service__["a" /* default */].updateLanguageLocalStorage(language);}}}},{key:'checkLanguagePath',value:function checkLanguagePath(pathname){var lang=__WEBPACK_IMPORTED_MODULE_2__services_Language_service__["a" /* default */].getLanguageByRouteLogic(pathname,this.previousPathname);this.previousPathname=pathname;if(this.currentLanguage!==lang.language){this.setLanguage(lang.language||this.currentLanguage,lang.shouldSave);}}},{key:'setUrlHistory',value:function setUrlHistory(){var currentUrl=__WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.parent.location.href;if(this.currentUrl!==currentUrl){this.previousUrl=this.currentUrl;}this.currentUrl=currentUrl;}}]);return AppStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'currentLanguage',[__WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return __WEBPACK_IMPORTED_MODULE_2__services_Language_service__["a" /* default */].getInitialLanguage();}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'previousPathname',[__WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return __WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.location.pathname;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'referrer',[__WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return __WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.document.referrer;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'currentUrl',[__WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return __WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.location.href;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'previousUrl',[__WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]],{enumerable:true,initializer:null}),_applyDecoratedDescriptor(_class.prototype,'isPolishLanguage',[__WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'isPolishLanguage'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isEnglishLanguage',[__WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'isEnglishLanguage'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isFranceLanguage',[__WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'isFranceLanguage'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'initStore',[__WEBPACK_IMPORTED_MODULE_1_mobx__["action"]],Object.getOwnPropertyDescriptor(_class.prototype,'initStore'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setLanguage',[__WEBPACK_IMPORTED_MODULE_1_mobx__["action"]],Object.getOwnPropertyDescriptor(_class.prototype,'setLanguage'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'checkLanguagePath',[__WEBPACK_IMPORTED_MODULE_1_mobx__["action"]],Object.getOwnPropertyDescriptor(_class.prototype,'checkLanguagePath'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setUrlHistory',[__WEBPACK_IMPORTED_MODULE_1_mobx__["action"]],Object.getOwnPropertyDescriptor(_class.prototype,'setUrlHistory'),_class.prototype)),_class);/* harmony default export */ __webpack_exports__["b"] = (new AppStore());

/***/ }),

/***/ "./src/stores/Blog.store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_Blog_service__ = __webpack_require__("./src/services/Blog.service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_consts_blog__ = __webpack_require__("./src/common/consts/blog.js");
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_dec2,_desc,_value,_class;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}/* Disable ESlint rules for this file *//* eslint no-console: "off" *//* eslint class-methods-use-this: "off" */var BlogStore=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2_lodash_decorators__["Bind"])(),_dec2=Object(__WEBPACK_IMPORTED_MODULE_2_lodash_decorators__["Bind"])(),(_class=function(){function BlogStore(coreStore){_classCallCheck(this,BlogStore);this.latestArticle={};this.articlesDetails=[];this.blogState={activeCategory:this.defaultBlogFilter,loadedArticlesCount:__WEBPACK_IMPORTED_MODULE_4_common_consts_blog__["a" /* BLOG_SETTINGS */].LISTING.DEFAULT_LIMIT,loadedArticlesInArticleView:__WEBPACK_IMPORTED_MODULE_4_common_consts_blog__["a" /* BLOG_SETTINGS */].ARTICLE.DEFAULT_LIMIT};this.initialFetchDone=__WEBPACK_IMPORTED_MODULE_1_mobx__["observable"].box(false);this.coreStore=coreStore;}_createClass(BlogStore,[{key:'getArticlesDetailsForArticleView',value:function getArticlesDetailsForArticleView(activeArticleId){var uniqueArticles=this.articlesDetails.filter(function(article){return article.id!==activeArticleId;});return uniqueArticles.slice(0,this.blogState.loadedArticlesInArticleView);}},{key:'setBlogFilter',value:function setBlogFilter(codename){var isAuthor=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var activeCategory=void 0;if(!isAuthor){activeCategory=this.categoriesToRender.find(function(category){return category.value===codename;});}else{activeCategory=this.blogAuthors.find(function(author){return author.value===codename;});}this.blogState.activeCategory=activeCategory;}},{key:'setDefaultBlogFilter',value:function setDefaultBlogFilter(){this.blogState.activeCategory=this.defaultBlogFilter;}},{key:'translateBlogCategory',value:function translateBlogCategory(categoryCodeName){if(this.coreStore.translations.blogCategoryTranslations){var categoryTranslation=this.coreStore.translations.blogCategoryTranslations.find(function(translation){return translation.codeName===categoryCodeName;});return categoryTranslation?categoryTranslation.category:'';}return'';}},{key:'initialContentFetch',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this=this;var _ref2,_ref3,articlesDetails,latestArticle;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!this.isLoaded){_context.next=2;break;}return _context.abrupt('return',null);case 2:_context.prev=2;_context.next=5;return Promise.all([__WEBPACK_IMPORTED_MODULE_3_services_Blog_service__["a" /* default */].fetchArticlesDetails(),this.fetchLatestArticle()]);case 5:_ref2=_context.sent;_ref3=_slicedToArray(_ref2,2);articlesDetails=_ref3[0];latestArticle=_ref3[1];Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["runInAction"])(function(){var _articlesDetails;(_articlesDetails=_this.articlesDetails).push.apply(_articlesDetails,_toConsumableArray(articlesDetails.items));_this.latestArticle=latestArticle.firstItem;_this.initialFetchDone.set(true);_this.setDefaultBlogFilter();});return _context.abrupt('return',this.content);case 13:_context.prev=13;_context.t0=_context['catch'](2);console.error('Failed to fetch blog data',_context.t0);return _context.abrupt('return',null);case 17:case'end':return _context.stop();}}},_callee,this,[[2,13]]);}));function initialContentFetch(){return _ref.apply(this,arguments);}return initialContentFetch;}()},{key:'fetchLatestArticle',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var latestArticle,fallback;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return __WEBPACK_IMPORTED_MODULE_3_services_Blog_service__["a" /* default */].fetchLatestArticle();case 2:latestArticle=_context2.sent;if(latestArticle.items.length){_context2.next=8;break;}fallback=true;_context2.next=7;return __WEBPACK_IMPORTED_MODULE_3_services_Blog_service__["a" /* default */].fetchLatestArticle(fallback);case 7:latestArticle=_context2.sent;case 8:return _context2.abrupt('return',latestArticle);case 9:case'end':return _context2.stop();}}},_callee2,this);}));function fetchLatestArticle(){return _ref4.apply(this,arguments);}return fetchLatestArticle;}()},{key:'getArticleBySlug',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(slug){var article;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(!(this.isLoaded&&this.latestArticle.slug===slug)){_context3.next=2;break;}return _context3.abrupt('return',this.latestArticle);case 2:_context3.prev=2;_context3.next=5;return __WEBPACK_IMPORTED_MODULE_3_services_Blog_service__["a" /* default */].getArticleBySlug(slug);case 5:article=_context3.sent;return _context3.abrupt('return',article.isEmpty?null:article.items[0]);case 9:_context3.prev=9;_context3.t0=_context3['catch'](2);console.error('Failed to fetch article by slug');return _context3.abrupt('return',null);case 13:case'end':return _context3.stop();}}},_callee3,this,[[2,9]]);}));function getArticleBySlug(_x2){return _ref5.apply(this,arguments);}return getArticleBySlug;}()},{key:'setArticlesLimitInListingView',value:function setArticlesLimitInListingView(isBottom){if(isBottom&&this.isLoaded){this.blogState.loadedArticlesCount+=__WEBPACK_IMPORTED_MODULE_4_common_consts_blog__["a" /* BLOG_SETTINGS */].LISTING.LOAD_ARTICLES_COUNT;}}},{key:'resetArticlesCountinArticleView',value:function resetArticlesCountinArticleView(){this.blogState.loadedArticlesInArticleView=__WEBPACK_IMPORTED_MODULE_4_common_consts_blog__["a" /* BLOG_SETTINGS */].ARTICLE.DEFAULT_LIMIT;}},{key:'loadMoreArticlesinArticleView',value:function loadMoreArticlesinArticleView(){this.blogState.loadedArticlesInArticleView+=__WEBPACK_IMPORTED_MODULE_4_common_consts_blog__["a" /* BLOG_SETTINGS */].ARTICLE.LOAD_ARTICLES_COUNT;}},{key:'isLoaded',get:function get(){return this.initialFetchDone.get();}// articlesDetails array with removed first item (duplicate)
},{key:'listingArticles',get:function get(){return this.articlesDetails.slice(1,this.articlesDetails.length);}},{key:'allArticlesInArticleViewLoaded',get:function get(){return this.articlesDetails.length-1<=this.blogState.loadedArticlesInArticleView;}},{key:'defaultBlogFilter',get:function get(){var filter=__WEBPACK_IMPORTED_MODULE_4_common_consts_blog__["b" /* DEFAULT_BLOG_FILTER */];filter.count=this.articlesLength;return filter;}},{key:'articlesLength',get:function get(){return this.articlesDetails.length;}},{key:'categoriesToRender',get:function get(){// const uniqueProductNames = uniqBy(flattenDeep(this.productNames), 'value');
// return [DEFAULT_BLOG_FILTER, ...uniqueProductNames, ...this.blogAuthors];
return[this.defaultBlogFilter].concat(_toConsumableArray(this.categoriesUsedForArticles));}},{key:'productNames',get:function get(){return this.articlesDetails.reduce(function(products,articleDetails){var articleProducts=articleDetails.relatedProducts;var productsToReturn=[];articleProducts.forEach(function(articleProduct){var existingProduct=products.find(function(product){return product.name===articleProduct.name;});if(existingProduct){existingProduct.count+=1;}else{var newProduct=articleProduct;newProduct.count=1;newProduct.value=newProduct.system.codename;productsToReturn.push(newProduct);}});return[].concat(_toConsumableArray(products),productsToReturn);},[]);}},{key:'blogAuthors',get:function get(){return this.articlesDetails.reduce(function(authors,articleDetails){var currentAuthor=authors.find(function(author){return author.name===articleDetails.articleAuthor.name;});if(currentAuthor){currentAuthor.count+=1;return authors;}currentAuthor=articleDetails.articleAuthor;if(currentAuthor&&currentAuthor.system){currentAuthor.count=1;currentAuthor.value=currentAuthor.system.codename;return[].concat(_toConsumableArray(authors),[currentAuthor]);}return authors;},[]);}},{key:'categoriesUsedForArticles',get:function get(){var _this2=this;if(this.coreStore.translations.blogCategoryTranslations){return this.articlesDetails.reduce(function(categories,articleDetails){if(articleDetails.system.id===_this2.latestArticle.system.id){return categories;}var currentCategory=void 0;articleDetails.categories.forEach(function(articleCategory){currentCategory=categories.find(function(category){return articleCategory.codename===category.value;});if(currentCategory){currentCategory.count+=1;return categories;}currentCategory=articleCategory;if(currentCategory&&currentCategory.codename){var category={count:1,value:currentCategory.codename,name:_this2.translateBlogCategory(currentCategory.codename)};categories=[].concat(_toConsumableArray(categories),[category]);}});return categories;},[]);}return[];}},{key:'loadArticles',get:function get(){var _blogState=this.blogState,activeCategory=_blogState.activeCategory,loadedArticlesCount=_blogState.loadedArticlesCount;if(!activeCategory){return;}if(activeCategory.value===''){return this.listingArticles.slice(0,loadedArticlesCount);}// Check if filtering is by authors
var filterByAuthors=!!this.blogAuthors.filter(function(authors){return authors.value===activeCategory.value;}).length;var filteredArticles=filterByAuthors?this.filterByAuthor:this.filterByCategory;return filteredArticles.slice(0,loadedArticlesCount);}},{key:'filterByCategory',get:function get(){var _this3=this;return this.listingArticles.filter(function(article){return article.categories.some(function(category){return category.codename===_this3.blogState.activeCategory.value;});});}},{key:'filterByAuthor',get:function get(){var _this4=this;return this.listingArticles.filter(function(article){return article.articleAuthor.codename===_this4.blogState.activeCategory.value;});}},{key:'articlesCount',get:function get(){var _this5=this;return this.listingArticles.filter(function(article){return article.articleAuthor.codename===_this5.blogState.activeCategory.value;});}}]);return BlogStore;}(),(_applyDecoratedDescriptor(_class.prototype,'isLoaded',[__WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'isLoaded'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'listingArticles',[__WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'listingArticles'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getArticlesDetailsForArticleView',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'getArticlesDetailsForArticleView'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'allArticlesInArticleViewLoaded',[__WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'allArticlesInArticleViewLoaded'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setBlogFilter',[__WEBPACK_IMPORTED_MODULE_1_mobx__["action"]],Object.getOwnPropertyDescriptor(_class.prototype,'setBlogFilter'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setDefaultBlogFilter',[__WEBPACK_IMPORTED_MODULE_1_mobx__["action"]],Object.getOwnPropertyDescriptor(_class.prototype,'setDefaultBlogFilter'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'defaultBlogFilter',[__WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'defaultBlogFilter'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'translateBlogCategory',[__WEBPACK_IMPORTED_MODULE_2_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class.prototype,'translateBlogCategory'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'articlesLength',[__WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'articlesLength'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'categoriesToRender',[__WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'categoriesToRender'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'productNames',[__WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'productNames'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'blogAuthors',[__WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'blogAuthors'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'categoriesUsedForArticles',[__WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'categoriesUsedForArticles'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'loadArticles',[__WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'loadArticles'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'filterByCategory',[__WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'filterByCategory'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'filterByAuthor',[__WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'filterByAuthor'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'articlesCount',[__WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'articlesCount'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setArticlesLimitInListingView',[__WEBPACK_IMPORTED_MODULE_1_mobx__["action"]],Object.getOwnPropertyDescriptor(_class.prototype,'setArticlesLimitInListingView'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'resetArticlesCountinArticleView',[__WEBPACK_IMPORTED_MODULE_1_mobx__["action"]],Object.getOwnPropertyDescriptor(_class.prototype,'resetArticlesCountinArticleView'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'loadMoreArticlesinArticleView',[_dec2,__WEBPACK_IMPORTED_MODULE_1_mobx__["action"]],Object.getOwnPropertyDescriptor(_class.prototype,'loadMoreArticlesinArticleView'),_class.prototype)),_class));Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["decorate"])(BlogStore,{content:__WEBPACK_IMPORTED_MODULE_1_mobx__["observable"],latestArticle:__WEBPACK_IMPORTED_MODULE_1_mobx__["observable"],articlesDetails:__WEBPACK_IMPORTED_MODULE_1_mobx__["observable"],blogState:__WEBPACK_IMPORTED_MODULE_1_mobx__["observable"],initialContentFetch:__WEBPACK_IMPORTED_MODULE_1_mobx__["action"]});/* harmony default export */ __webpack_exports__["a"] = (BlogStore);

/***/ }),

/***/ "./src/stores/Calculator.store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export roundToTwo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var roundToTwo=function roundToTwo(num){return+(Math.round(num+'e+2')+'e-2');};var CalculatorStore=(_dec=__WEBPACK_IMPORTED_MODULE_0_mobx__["action"].bound,(_class=function(){function CalculatorStore(){_classCallCheck(this,CalculatorStore);this.numberOfConferenceRooms=__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"].box(15);this.numberOfEmployees=__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"].box(15);this.numberOfDesks=__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"].box(15);this.numberOfParkingSpots=__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"].box(15);this.monthlyM2RentPrice=__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"].box(100);this.averageEmployeeSalaryPerH=__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"].box(40);this.pricePerParkingSpot=__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"].box(500);_initDefineProp(this,'averageSizeOfConferenceRoom',_descriptor,this);_initDefineProp(this,'conferenceRoomOptimisationRate',_descriptor2,this);_initDefineProp(this,'averageWorkingHoursPerMonth',_descriptor3,this);_initDefineProp(this,'workingHoursOptimisationRate',_descriptor4,this);_initDefineProp(this,'estimatedAreaOfOneDesk',_descriptor5,this);_initDefineProp(this,'desksOptimisationRate',_descriptor6,this);_initDefineProp(this,'parkingOptimisationRate',_descriptor7,this);_initDefineProp(this,'estimatedCostOfSensorInstallationPerDesk',_descriptor8,this);_initDefineProp(this,'costOfScreenHardwarePerRoom',_descriptor9,this);_initDefineProp(this,'subscriptionFeePerEmployeeIn5Years',_descriptor10,this);}_createClass(CalculatorStore,[{key:'setCalcData',value:function setCalcData(calcData){this.numberOfConferenceRooms.set(calcData.numberOfConferenceRoomsDefaultValue);this.numberOfEmployees.set(calcData.numberOfEmployeesDefaultValue);this.numberOfDesks.set(calcData.numberOfDesksDefaultValue);this.numberOfParkingSpots.set(calcData.numberOfParkingSpotsDefaultValue);this.monthlyM2RentPrice.set(calcData.monthlyM2RentPriceDefaultValue);this.averageEmployeeSalaryPerH.set(calcData.averageEmployeeSalaryPerHourDefaultValue);this.pricePerParkingSpot.set(calcData.pricePerParkingSpotDefaultValue);this.averageSizeOfConferenceRoom=calcData.averageSizeOfConferenceRoom.value;this.averageWorkingHoursPerMonth=calcData.averageWorkingHoursPerMonth.value;this.estimatedAreaOfOneDesk=calcData.estimatedAreaOfOneDesk.value;this.estimatedCostOfSensorInstallationPerDesk=calcData.estimatedCostOfSensorInstallationPerDesk.value;this.costOfScreenHardwarePerRoom=calcData.costOfScreenHardwarePerRoom.value;this.subscriptionFeePerEmployeeIn5Years=calcData.subscriptionFeePerEmployeeIn5Years.value;// optimisation rates (values are percent %):
this.conferenceRoomOptimisationRate=calcData.conferenceRoomOptimisationRate/100;this.workingHoursOptimisationRate=calcData.workingHoursOptimisationRate/100;this.desksOptimisationRate=calcData.desksOptimisationRate/100;this.parkingOptimisationRate=calcData.parkingOptimisationRate/100;}},{key:'roomOptimisation',get:function get(){return roundToTwo(this.averageSizeOfConferenceRoom*this.numberOfConferenceRooms.get()*this.monthlyM2RentPrice.get()*this.conferenceRoomOptimisationRate);}},{key:'employeeOptimisation',get:function get(){return roundToTwo(this.averageWorkingHoursPerMonth*this.numberOfEmployees.get()*this.averageEmployeeSalaryPerH.get()*this.workingHoursOptimisationRate);}},{key:'desksOptimisation',get:function get(){return roundToTwo(this.estimatedAreaOfOneDesk*this.numberOfDesks.get()*this.monthlyM2RentPrice.get()*this.desksOptimisationRate);}},{key:'parkingOptimisation',get:function get(){return roundToTwo(this.numberOfParkingSpots.get()*this.pricePerParkingSpot.get()*this.parkingOptimisationRate);}},{key:'totalOptimisationPerMonth',get:function get(){return roundToTwo(this.roomOptimisation+this.employeeOptimisation+this.desksOptimisation+this.parkingOptimisation);}},{key:'hardwareImplementationCost',get:function get(){return roundToTwo(this.estimatedCostOfSensorInstallationPerDesk*this.numberOfDesks.get()+this.numberOfConferenceRooms.get()*this.costOfScreenHardwarePerRoom);}},{key:'costOfZoniferoIn5Years',get:function get(){return roundToTwo(this.subscriptionFeePerEmployeeIn5Years*this.numberOfEmployees.get()+this.hardwareImplementationCost);}},{key:'yourReturnOfInvestmentTime',get:function get(){return Math.round(this.costOfZoniferoIn5Years/this.totalOptimisationPerMonth)||0;}}]);return CalculatorStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'averageSizeOfConferenceRoom',[__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'conferenceRoomOptimisationRate',[__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'averageWorkingHoursPerMonth',[__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'workingHoursOptimisationRate',[__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'estimatedAreaOfOneDesk',[__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'desksOptimisationRate',[__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'parkingOptimisationRate',[__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'estimatedCostOfSensorInstallationPerDesk',[__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'costOfScreenHardwarePerRoom',[__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'subscriptionFeePerEmployeeIn5Years',[__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return 0;}}),_applyDecoratedDescriptor(_class.prototype,'setCalcData',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'setCalcData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'roomOptimisation',[__WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'roomOptimisation'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'employeeOptimisation',[__WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'employeeOptimisation'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'desksOptimisation',[__WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'desksOptimisation'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'parkingOptimisation',[__WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'parkingOptimisation'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'totalOptimisationPerMonth',[__WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'totalOptimisationPerMonth'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'hardwareImplementationCost',[__WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'hardwareImplementationCost'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'costOfZoniferoIn5Years',[__WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'costOfZoniferoIn5Years'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'yourReturnOfInvestmentTime',[__WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'yourReturnOfInvestmentTime'),_class.prototype)),_class));/* harmony default export */ __webpack_exports__["a"] = (CalculatorStore);

/***/ }),

/***/ "./src/stores/Core.store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_Core_service__ = __webpack_require__("./src/services/Core.service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Blog_store__ = __webpack_require__("./src/stores/Blog.store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Window_store__ = __webpack_require__("./src/stores/Window.store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Navigation_store__ = __webpack_require__("./src/stores/Navigation.store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Products_store__ = __webpack_require__("./src/stores/Products.store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Calculator_store__ = __webpack_require__("./src/stores/Calculator.store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ForInvestors_store__ = __webpack_require__("./src/stores/ForInvestors.store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GlobalMetaTags_store__ = __webpack_require__("./src/stores/GlobalMetaTags.store.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var CoreStore=(_class=function(){function CoreStore(){_classCallCheck(this,CoreStore);_initDefineProp(this,'translations',_descriptor,this);_initDefineProp(this,'content',_descriptor2,this);_initDefineProp(this,'blogContactComponent',_descriptor3,this);_initDefineProp(this,'newsletterThankYouPage',_descriptor4,this);this.initialCoreDataFetchDone=__WEBPACK_IMPORTED_MODULE_1_mobx__["observable"].box(false);this.productsStore=new __WEBPACK_IMPORTED_MODULE_6__Products_store__["a" /* default */](this);this.navigationStore=new __WEBPACK_IMPORTED_MODULE_5__Navigation_store__["a" /* default */](this);this.windowStore=new __WEBPACK_IMPORTED_MODULE_4__Window_store__["a" /* default */](this);this.calculatorStore=new __WEBPACK_IMPORTED_MODULE_7__Calculator_store__["a" /* default */](this);this.blogStore=new __WEBPACK_IMPORTED_MODULE_3__Blog_store__["a" /* default */](this);this.forInvestorsStore=new __WEBPACK_IMPORTED_MODULE_8__ForInvestors_store__["a" /* default */](this);this.globalMetaTagsStore=new __WEBPACK_IMPORTED_MODULE_9__GlobalMetaTags_store__["a" /* default */](this);this.getCoreData();}_createClass(CoreStore,[{key:'getCoreData',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this=this;var coreData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return __WEBPACK_IMPORTED_MODULE_2_services_Core_service__["a" /* default */].fetchCoreData();case 3:coreData=_context.sent;Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["runInAction"])(function(){_this.content=coreData;_this.translations=coreData.translations;_this.blogContactComponent=coreData.blogContactComponent;_this.initialCoreDataFetchDone.set(true);_this.newsletterThankYouPage=coreData.blogNewsletterThankYouPage;});_context.next=10;break;case 7:_context.prev=7;_context.t0=_context['catch'](0);console.log('error when fetching core data: ',_context.t0);case 10:case'end':return _context.stop();}}},_callee,this,[[0,7]]);}));function getCoreData(){return _ref.apply(this,arguments);}return getCoreData;}()},{key:'isLoaded',get:function get(){return this.initialCoreDataFetchDone.get();}}]);return CoreStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'translations',[__WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'content',[__WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'blogContactComponent',[__WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'newsletterThankYouPage',[__WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return{};}}),_applyDecoratedDescriptor(_class.prototype,'isLoaded',[__WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'isLoaded'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getCoreData',[__WEBPACK_IMPORTED_MODULE_1_mobx__["action"]],Object.getOwnPropertyDescriptor(_class.prototype,'getCoreData'),_class.prototype)),_class);/* harmony default export */ __webpack_exports__["a"] = (CoreStore);

/***/ }),

/***/ "./src/stores/ForInvestors.store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_ForInvestors_service__ = __webpack_require__("./src/services/ForInvestors.service.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var ForInvestorsStore=(_class=function(){function ForInvestorsStore(coreStore){_classCallCheck(this,ForInvestorsStore);_initDefineProp(this,'fetchedInvestorData',_descriptor,this);this.initialForInvestorsDataFetchDone=__WEBPACK_IMPORTED_MODULE_1_mobx__["observable"].box(false);this.coreStore=coreStore;}_createClass(ForInvestorsStore,[{key:'getForInvestorsData',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this=this;var investorsData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!this.isLoaded){_context.next=2;break;}return _context.abrupt('return',null);case 2:_context.prev=2;_context.next=5;return __WEBPACK_IMPORTED_MODULE_2_services_ForInvestors_service__["a" /* default */].fetchInvestorsData();case 5:investorsData=_context.sent;Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["runInAction"])(function(){_this.fetchedInvestorData=investorsData;});_context.next=12;break;case 9:_context.prev=9;_context.t0=_context['catch'](2);console.log('error when fetching for investors data: ',_context.t0);case 12:case'end':return _context.stop();}}},_callee,this,[[2,9]]);}));function getForInvestorsData(){return _ref.apply(this,arguments);}return getForInvestorsData;}()},{key:'isLoaded',get:function get(){return this.initialForInvestorsDataFetchDone.get();}}]);return ForInvestorsStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'fetchedInvestorData',[__WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return{};}}),_applyDecoratedDescriptor(_class.prototype,'isLoaded',[__WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'isLoaded'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getForInvestorsData',[__WEBPACK_IMPORTED_MODULE_1_mobx__["action"]],Object.getOwnPropertyDescriptor(_class.prototype,'getForInvestorsData'),_class.prototype)),_class);/* harmony default export */ __webpack_exports__["a"] = (ForInvestorsStore);

/***/ }),

/***/ "./src/stores/GlobalMetaTags.store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_GlobalMetaTags_service__ = __webpack_require__("./src/services/GlobalMetaTags.service.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var GlobalMetaTagsStore=(_class=function(){function GlobalMetaTagsStore(){_classCallCheck(this,GlobalMetaTagsStore);_initDefineProp(this,'metaTags',_descriptor,this);this.getMetaTagsData();}_createClass(GlobalMetaTagsStore,[{key:'getMetaTagsData',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return __WEBPACK_IMPORTED_MODULE_2_services_GlobalMetaTags_service__["a" /* default */].fetchMetaTagsData();case 3:this.metaTags=_context.sent;_context.next=9;break;case 6:_context.prev=6;_context.t0=_context['catch'](0);throw _context.t0;case 9:case'end':return _context.stop();}}},_callee,this,[[0,6]]);}));function getMetaTagsData(){return _ref.apply(this,arguments);}return getMetaTagsData;}()}]);return GlobalMetaTagsStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'metaTags',[__WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return null;}}),_applyDecoratedDescriptor(_class.prototype,'getMetaTagsData',[__WEBPACK_IMPORTED_MODULE_1_mobx__["action"]],Object.getOwnPropertyDescriptor(_class.prototype,'getMetaTagsData'),_class.prototype)),_class);/* harmony default export */ __webpack_exports__["a"] = (GlobalMetaTagsStore);

/***/ }),

/***/ "./src/stores/Navigation.store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var NavigationStore=(_class=function(){function NavigationStore(){_classCallCheck(this,NavigationStore);_initDefineProp(this,'isMobileNavOpen',_descriptor,this);_initDefineProp(this,'buttonsSectionWidth',_descriptor2,this);}_createClass(NavigationStore,[{key:'openMobileNav',value:function openMobileNav(){this.isMobileNavOpen=true;}},{key:'closeMobileNav',value:function closeMobileNav(){this.isMobileNavOpen=false;}},{key:'setButtonsSectionWidth',value:function setButtonsSectionWidth(buttonsSectionWidth){this.buttonsSectionWidth=buttonsSectionWidth;}},{key:'reactToMobileNavChange',value:function reactToMobileNavChange(callback){var _this=this;return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["reaction"])(function(){return _this.isMobileNavOpen;},function(data,theReaction){return callback(data,theReaction);});}}]);return NavigationStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'isMobileNavOpen',[__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'buttonsSectionWidth',[__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return 0;}}),_applyDecoratedDescriptor(_class.prototype,'setButtonsSectionWidth',[__WEBPACK_IMPORTED_MODULE_0_mobx__["action"]],Object.getOwnPropertyDescriptor(_class.prototype,'setButtonsSectionWidth'),_class.prototype)),_class);/* harmony default export */ __webpack_exports__["a"] = (NavigationStore);

/***/ }),

/***/ "./src/stores/Products.store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_Products_service__ = __webpack_require__("./src/services/Products.service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_KenticoStructureParser__ = __webpack_require__("./src/services/KenticoStructureParser.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var ProductsStore=(_class=function(){function ProductsStore(coreStore){_classCallCheck(this,ProductsStore);_initDefineProp(this,'currentProduct',_descriptor,this);_initDefineProp(this,'loadingCurrentProduct',_descriptor2,this);_initDefineProp(this,'cachedProducts',_descriptor3,this);this.coreStore=coreStore;}_createClass(ProductsStore,[{key:'setCurrentProductByUrlSlug',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(urlSlug){var slug,cachedProduct,fetchedProduct;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:slug='/'+(urlSlug||'');cachedProduct=this.cachedProducts.find(function(product){return product.slug===slug;});if(!cachedProduct){_context.next=6;break;}this.currentProduct=cachedProduct;_context.next=16;break;case 6:this.loadingCurrentProduct=true;_context.next=9;return __WEBPACK_IMPORTED_MODULE_2_services_Products_service__["a" /* default */].fetchProductByUrlSlug(slug);case 9:fetchedProduct=_context.sent;this.loadingCurrentProduct=false;if(fetchedProduct){_context.next=14;break;}this.currentProduct=null;return _context.abrupt('return');case 14:this.currentProduct=fetchedProduct;this.cachedProducts.push(fetchedProduct);case 16:case'end':return _context.stop();}}},_callee,this);}));function setCurrentProductByUrlSlug(_x){return _ref.apply(this,arguments);}return setCurrentProductByUrlSlug;}()},{key:'parsedStructure',get:function get(){return Object(__WEBPACK_IMPORTED_MODULE_3_services_KenticoStructureParser__["a" /* default */])(this.currentProduct);}}]);return ProductsStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'currentProduct',[__WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'loadingCurrentProduct',[__WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'cachedProducts',[__WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class.prototype,'parsedStructure',[__WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]],Object.getOwnPropertyDescriptor(_class.prototype,'parsedStructure'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setCurrentProductByUrlSlug',[__WEBPACK_IMPORTED_MODULE_1_mobx__["action"]],Object.getOwnPropertyDescriptor(_class.prototype,'setCurrentProductByUrlSlug'),_class.prototype)),_class);/* harmony default export */ __webpack_exports__["a"] = (ProductsStore);

/***/ }),

/***/ "./src/stores/Window.store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_device_detect__ = __webpack_require__("./node_modules/react-device-detect/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_kentico_cloud_delivery_commonjs_lib__ = __webpack_require__("./node_modules/kentico-cloud-delivery/_commonjs/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_kentico_cloud_delivery_commonjs_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_kentico_cloud_delivery_commonjs_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_decorators__ = __webpack_require__("./node_modules/lodash-decorators/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_decorators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_decorators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_consts_window__ = __webpack_require__("./src/common/consts/window.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_window_or_global__ = __webpack_require__("./node_modules/window-or-global/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__("./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_responsive__ = __webpack_require__("./src/common/responsive.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_supports_webp__ = __webpack_require__("./node_modules/supports-webp/dist/supports-webp.common-js.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_supports_webp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_supports_webp__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}/* eslint-disable class-methods-use-this */var WindowStore=(_class=function(){function WindowStore(){var _this=this;_classCallCheck(this,WindowStore);_initDefineProp(this,'isOnMobile',_descriptor,this);_initDefineProp(this,'isOnTablet',_descriptor2,this);_initDefineProp(this,'isPortraitOrientation',_descriptor3,this);_initDefineProp(this,'devicePixelRatio',_descriptor4,this);_initDefineProp(this,'scrollDirection',_descriptor5,this);_initDefineProp(this,'scrollY',_descriptor6,this);_initDefineProp(this,'windowClickEvent',_descriptor7,this);this.checkIfIsOnMobile=function(){var query=__WEBPACK_IMPORTED_MODULE_5_window_or_global___default.a.matchMedia('(max-width: '+(__WEBPACK_IMPORTED_MODULE_7_common_responsive__["e" /* tabletBreakpoint */]-1)+'px)');return query.matches;};this.checkIfIsOnTablet=function(){var query=__WEBPACK_IMPORTED_MODULE_5_window_or_global___default.a.matchMedia('(max-width: '+(__WEBPACK_IMPORTED_MODULE_7_common_responsive__["a" /* desktopBreakpoint */]-1)+'px)');return query.matches;};this.adjustImageSize=function(url){var mobilesBreakpoints=[__WEBPACK_IMPORTED_MODULE_7_common_responsive__["d" /* mobileBreakpoint */],__WEBPACK_IMPORTED_MODULE_7_common_responsive__["e" /* tabletBreakpoint */],__WEBPACK_IMPORTED_MODULE_7_common_responsive__["a" /* desktopBreakpoint */]].sort(function(a,b){return a-b;});var desktopBreakpoints=[__WEBPACK_IMPORTED_MODULE_7_common_responsive__["f" /* wideDesktopBreakpoint */]];var urlBuilder=new __WEBPACK_IMPORTED_MODULE_2_kentico_cloud_delivery_commonjs_lib__["ImageUrlBuilder"](url);if(__WEBPACK_IMPORTED_MODULE_1_react_device_detect__["isMobile"]){_this.buildURL(mobilesBreakpoints,urlBuilder);}else{_this.buildURL(desktopBreakpoints,urlBuilder);}return urlBuilder.getUrl();};this.buildURL=function(breakpoints,urlBuilder){var getBreakpoint=breakpoints.find(function(breakpoint){return __WEBPACK_IMPORTED_MODULE_5_window_or_global___default.a.innerWidth<=breakpoint;});urlBuilder.withDpr(_this.devicePixelRatio);if(getBreakpoint){urlBuilder.withWidth(getBreakpoint);}if(__WEBPACK_IMPORTED_MODULE_8_supports_webp___default.a){urlBuilder.withFormat(__WEBPACK_IMPORTED_MODULE_2_kentico_cloud_delivery_commonjs_lib__["ImageFormatEnum"].Webp).withCompression(__WEBPACK_IMPORTED_MODULE_2_kentico_cloud_delivery_commonjs_lib__["ImageCompressionEnum"].Lossy);}};this.onScroll();this.onResize();__WEBPACK_IMPORTED_MODULE_5_window_or_global___default.a.addEventListener('scroll',Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["throttle"])(this.onScroll));__WEBPACK_IMPORTED_MODULE_5_window_or_global___default.a.addEventListener('resize',Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["throttle"])(this.onResize));__WEBPACK_IMPORTED_MODULE_5_window_or_global___default.a.addEventListener('click',this.onWindowClick);}_createClass(WindowStore,[{key:'reactToScroll',value:function reactToScroll(callback){var _this2=this;var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["reaction"])(function(){return _this2.scrollY;},function(scrollY,theReaction){return callback(scrollY,theReaction);},options);}},{key:'onScroll',value:function onScroll(){if(__WEBPACK_IMPORTED_MODULE_5_window_or_global___default.a.scrollY>this.scrollY){this.scrollDirection=__WEBPACK_IMPORTED_MODULE_4_common_consts_window__["a" /* default */].BOTTOM;}else{this.scrollDirection=__WEBPACK_IMPORTED_MODULE_4_common_consts_window__["a" /* default */].TOP;}this.scrollY=__WEBPACK_IMPORTED_MODULE_5_window_or_global___default.a.scrollY;}},{key:'onResize',value:function onResize(){this.isOnMobile=this.checkIfIsOnMobile();this.isOnTablet=this.checkIfIsOnTablet();this.isPortraitOrientation=this.checkIfPortraitOrientation();this.devicePixelRatio=__WEBPACK_IMPORTED_MODULE_5_window_or_global___default.a.devicePixelRatio;}},{key:'checkIfPortraitOrientation',value:function checkIfPortraitOrientation(){return __WEBPACK_IMPORTED_MODULE_5_window_or_global___default.a.matchMedia('(orientation: portrait)').matches;}},{key:'onWindowClick',value:function onWindowClick(event){this.windowClickEvent=event;}},{key:'onClickedAnywhere',value:function onClickedAnywhere(callback){var _this3=this;return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["reaction"])(function(){return _this3.windowClickEvent;},function(data,theReaction){return callback(data,theReaction);});}},{key:'isOnDesktop',get:function get(){return!this.isOnMobile&&!this.isOnTablet;}}]);return WindowStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'isOnMobile',[__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'isOnTablet',[__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'isPortraitOrientation',[__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'devicePixelRatio',[__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'scrollDirection',[__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return __WEBPACK_IMPORTED_MODULE_4_common_consts_window__["a" /* default */].TOP;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'scrollY',[__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'windowClickEvent',[__WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]],{enumerable:true,initializer:function initializer(){return{};}}),_applyDecoratedDescriptor(_class.prototype,'onScroll',[__WEBPACK_IMPORTED_MODULE_3_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class.prototype,'onScroll'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onResize',[__WEBPACK_IMPORTED_MODULE_3_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class.prototype,'onResize'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onWindowClick',[__WEBPACK_IMPORTED_MODULE_3_lodash_decorators__["Bind"]],Object.getOwnPropertyDescriptor(_class.prototype,'onWindowClick'),_class.prototype)),_class);/* harmony default export */ __webpack_exports__["a"] = (WindowStore);

/***/ }),

/***/ "ignored C:\\agent\\_work\\4\\s\\node_modules\\readable-stream\\lib util":
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "ignored C:\\agent\\_work\\4\\s\\node_modules\\readable-stream\\lib\\internal\\streams util":
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},["./src/index.js"]);


// WEBPACK FOOTER //
// static/js/1.72fd9c52.js